(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 75102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ib": function() { return /* reexport safe */ _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__.Ib; },
/* harmony export */   "Ku": function() { return /* binding */ BuilderContent; },
/* harmony export */   "VD": function() { return /* binding */ BuilderComponent; },
/* harmony export */   "Wp": function() { return /* binding */ BuilderBlocks; },
/* harmony export */   "ZP": function() { return /* reexport safe */ _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__.fl; },
/* harmony export */   "u7": function() { return /* binding */ withChildren; }
/* harmony export */ });
/* unused harmony exports BuilderAsyncRequestsContext, BuilderBlock, BuilderBlockComponent, BuilderMetaContext, BuilderPage, BuilderStoreContext, Button, Columns, CustomCode, Dropzone, Embed, Form, FormInput, FormSelect, FormSubmitButton, Fragment, Image, Img, Label, Mutation, RawText, RenderContent, Router, Section, StateProvider, Symbol, Text, TextArea, Video, getSrcSet, noWrap, onChange, stringToFunction, updateMetadata, useIsPreviewing, withBuilder */
/* harmony import */ var _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11183);
/* harmony import */ var _emotion_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12520);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62991);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65883);
/* harmony import */ var hash_sum__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94915);
/* harmony import */ var hash_sum__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(hash_sum__WEBPACK_IMPORTED_MODULE_4__);
/* provided dependency */ var process = __webpack_require__(28584);
var version="2.0.10-9",_a;"undefined"!=typeof window&&(null===(_a=window.parent)||void 0===_a||_a.postMessage({type:"builder.isReactSdk",data:{value:!0,supportsPatchUpdates:"v4",supportsCustomBreakpoints:!0,priorVersion:version}},"*"));var extendStatics=function(e,t){return(extendStatics=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])})(e,t)};function __extends(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Class extends value "+String(t)+" is not a constructor or null");function n(){this.constructor=e}extendStatics(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}var __assign=function(){return(__assign=Object.assign||function(e){for(var t,n=1,i=arguments.length;n<i;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e}).apply(this,arguments)};function __decorate(e,t,n,i){var r,o=arguments.length,a=o<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,n):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)a=Reflect.decorate(e,t,n,i);else for(var s=e.length-1;s>=0;s--)(r=e[s])&&(a=(o<3?r(a):o>3?r(t,n,a):r(t,n))||a);return o>3&&a&&Object.defineProperty(t,n,a),a}function __metadata(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)}function __awaiter(e,t,n,i){return new(n||(n=Promise))((function(r,o){function a(e){try{l(i.next(e))}catch(e){o(e)}}function s(e){try{l(i.throw(e))}catch(e){o(e)}}function l(e){var t;e.done?r(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(a,s)}l((i=i.apply(e,t||[])).next())}))}function __generator(e,t){var n,i,r,o,a={label:0,sent:function(){if(1&r[0])throw r[1];return r[1]},trys:[],ops:[]};return o={next:s(0),throw:s(1),return:s(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function s(o){return function(s){return function(o){if(n)throw new TypeError("Generator is already executing.");for(;a;)try{if(n=1,i&&(r=2&o[0]?i.return:o[0]?i.throw||((r=i.return)&&r.call(i),0):i.next)&&!(r=r.call(i,o[1])).done)return r;switch(i=0,r&&(o=[2&o[0],r.value]),o[0]){case 0:case 1:r=o;break;case 4:return a.label++,{value:o[1],done:!1};case 5:a.label++,i=o[1],o=[0];continue;case 7:o=a.ops.pop(),a.trys.pop();continue;default:if(!(r=a.trys,(r=r.length>0&&r[r.length-1])||6!==o[0]&&2!==o[0])){a=0;continue}if(3===o[0]&&(!r||o[1]>r[0]&&o[1]<r[3])){a.label=o[1];break}if(6===o[0]&&a.label<r[1]){a.label=r[1],r=o;break}if(r&&a.label<r[2]){a.label=r[2],a.ops.push(o);break}r[2]&&a.ops.pop(),a.trys.pop();continue}o=t.call(e,a)}catch(e){o=[6,e],i=0}finally{n=r=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,s])}}}function __spreadArray(e,t,n){if(n||2===arguments.length)for(var i,r=0,o=t.length;r<o;r++)!i&&r in t||(i||(i=Array.prototype.slice.call(t,0,r)),i[r]=t[r]);return e.concat(i||Array.prototype.slice.call(t))}var fastClone=function(e){return JSON.parse(JSON.stringify(e))},sizeNames=["xsmall","small","medium","large"],sizes={xsmall:{min:0,default:0,max:0},small:{min:320,default:321,max:640},medium:{min:641,default:642,max:991},large:{min:990,default:991,max:1200},getWidthForSize:function(e){return this[e].default},getSizeForWidth:function(e){for(var t=0,n=sizeNames;t<n.length;t++){var i=n[t];if(e<=this[i].max)return i}return"large"}},getSizesForBreakpoints=function(e){var t=e.small,n=e.medium,i=__assign(__assign({},sizes),fastClone(sizes));if(!t||!n)return i;var r=Math.floor(t/2);i.small={max:t,min:r,default:r+1};var o=i.small.max+1;i.medium={max:n,min:o,default:o+1};var a=i.medium.max+1;return i.large={max:2e3,min:a,default:a+1},i},set=function(e,t,n){if(Object(e)!==e)return e;var i=Array.isArray(t)?t:t.toString().match(/[^.[\]]+/g);return i.slice(0,-1).reduce((function(e,t,n){return Object(e[t])===e[t]?e[t]:e[t]=Math.abs(Number(i[n+1]))>>0==+i[n+1]?[]:{}}),e)[i[i.length-1]]=n,e},noop=function(){return null},safeDynamicRequire;("function"==typeof(null===globalThis||void 0===globalThis?void 0:globalThis.require)||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isServer */ .Ib.isServer&&"function"=="function")&&(safeDynamicRequire=eval("require")),null!=safeDynamicRequire||(safeDynamicRequire=noop);var fnCache={},api=function(e){return _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder */ .fl};function stringToFunction(e,t,n,i){if(void 0===t&&(t=!0),!e||!e.trim())return function(){};var r=e+":"+t;if(fnCache[r])return fnCache[r];var o=t&&!(e.includes(";")||e.includes(" return ")||e.trim().startsWith("return "))||e.trim().startsWith("builder.run"),a=function(){};try{_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&(a=new Function("state","event","block","builder","Device","update","Builder","context","\n          var names = [\n            'state',\n            'event',\n            'block',\n            'builder',\n            'Device',\n            'update',\n            'Builder',\n            'context'\n          ];\n          var rootState = state;\n          if (typeof Proxy !== 'undefined') {\n            rootState = new Proxy(rootState, {\n              set: function () {\n                return false;\n              },\n              get: function (target, key) {\n                if (names.includes(key)) {\n                  return undefined;\n                }\n                return target[key];\n              }\n            });\n          }\n          /* Alias */\n          var ctx = context;\n          with (rootState) {\n            ".concat(o?"return (".concat(e,");"):e,";\n          }\n        ")))}catch(t){n&&n.push(t);var s=t&&t.message;s&&"string"==typeof s&&i&&-1===i.indexOf(s)&&i.push(s),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&console.warn("Function compile error in ".concat(e),t)}var l=function(){for(var t=[],i=0;i<arguments.length;i++)t[i]=arguments[i];try{if(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser)return a.apply(void 0,t);var r=safeDynamicRequire("vm2").VM,o=t[0],s=t[1],l=(t[2],t[3],t[4],t[5],t[6],t[7]);return new r({timeout:100,sandbox:__assign(__assign(__assign(__assign(__assign({},o),{state:o}),{context:l}),{builder:api}),{event:s})}).run(e.replace(/(^|;)return /,"$1"))}catch(t){return _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser?console.warn("Builder custom code error:",t.message||t,"in",e,t.stack||t):process.env.DEBUG&&console.debug("Builder custom code error:",t.message||t,"in",e,t.stack||t),n&&n.push(t),null}};return _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&(fnCache[r]=l),l}var isPromise=function(e){return"function"==typeof e.then},isRequestInfo=function(e){return!isPromise(e)},BuilderAsyncRequestsContext=react__WEBPACK_IMPORTED_MODULE_2__.createContext({requests:[],errors:[],logs:[]}),BuilderStoreContext=react__WEBPACK_IMPORTED_MODULE_2__.createContext({state:{},rootState:{},content:{},context:{},update:function(e){return null}}),applyPatchWithMinimalMutationChain=function(e,t,n){if(void 0===n&&(n=!1),Object(e)!==e)return e;var i=t.path,r=t.op,o=t.value,a=i.split(/\//);""===a[0]&&a.shift();for(var s=n?e:__assign({},e),l=s,u=0;u<a.length;u++){var d=u===a.length-1,c=a[u];if(d){if("replace"===r)l[c]=o;else if("add"===r){var p=Number(c);Array.isArray(l)?"-"===c?l.push(o):l.splice(p,0,o):l[c]=o}else if("remove"===r){p=Number(c);Array.isArray(l)?l.splice(p,1):delete l[c]}}else{var f=a[u+1],m=Object(l[c])===l[c]?l[c]:String(Number(f))===f?[]:{};l=l[c]=Array.isArray(m)?__spreadArray([],m,!0):__assign({},m)}}return s},htmlEscape=function(e){return e.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;")},blockToHtmlString=function(e){var t;return"<".concat(htmlEscape(e.tagName||"div"),' \n    class="builder-block ').concat(e.id," ").concat(e.class||"",'"\n    builder-id="').concat(e.id,'"\n  ').concat(Object.keys(e.properties||{}).map((function(t){return"".concat(htmlEscape(t),'="').concat(htmlEscape(e.properties[t]),'"')})).join(" "),"\n  >").concat("Text"===(null===(t=null==e?void 0:e.component)||void 0===t?void 0:t.name)?e.component.options.text:e.children?e.children.map((function(e){return blockToHtmlString(e)})).join(""):"","</").concat(e.tagName||"div",">").replace(/\s+/g," ")},Link=function(e){return react__WEBPACK_IMPORTED_MODULE_2__.createElement(BuilderStoreContext.Consumer,null,(function(t){return t.renderLink?t.renderLink(e):react__WEBPACK_IMPORTED_MODULE_2__.createElement("a",__assign({},e))}))},camelCaseToKebabCase=function(e){return e?e.replace(/([A-Z])/g,(function(e){return"-".concat(e[0].toLowerCase())})):""},kebabCaseToCamelCase=function(e){return void 0===e&&(e=""),e.replace(/-([a-z])/g,(function(e){return e[1].toUpperCase()}))},Device={desktop:0,tablet:1,mobile:2},voidElements=new Set(["area","base","br","col","embed","hr","img","input","link","meta","param","source","track","wbr","textarea"]),last=function(e){return e[e.length-1]};function omit$1(e,t){for(var n=Object.assign({},e),i=0,r=t;i<r.length;i++){delete n[r[i]]}return n}var cssCase=function(e){if(!e)return e;var t=camelCaseToKebabCase(e);return e[0]===e[0].toUpperCase()&&(t="-"+t),t};function capitalize(e){if(e)return e[0].toUpperCase()+e.slice(1)}var BuilderBlock$1=function(_super){function BuilderBlock(){var _this=null!==_super&&_super.apply(this,arguments)||this;return _this.state={hasError:!1,updates:0},_this.privateState={state:{},rootState:{},context:{},update:function(){}},_this.onWindowMessage=function(event){var message=event.data;if(message)switch(message.type){case"builder.selectionChange":var data=message.data;if(!data)break;var selection=data.selection,id=_this.block&&_this.block.id;id&&Array.isArray(selection)&&selection.indexOf(id)>-1&&setTimeout((function(){window.$block=_this,window.$blocks||(window.$blocks=[]),window.$blocks.push(_this)}));break;case"builder.patchUpdates":var data=message.data;if(!data||!data.data)break;var patches=data.data[_this.block.id];if(!patches)return;location.href.includes("builder.debug=true")&&eval("debugger");for(var _i=0,patches_1=patches;_i<patches_1.length;_i++){var patch=patches_1[_i];applyPatchWithMinimalMutationChain(_this.props.block,patch,!0)}_this.setState({updates:_this.state.updates+1})}},_this}return __extends(BuilderBlock,_super),Object.defineProperty(BuilderBlock.prototype,"store",{get:function(){return this.privateState},enumerable:!1,configurable:!0}),BuilderBlock.getDerivedStateFromError=function(e){return{hasError:!0}},BuilderBlock.prototype.componentDidCatch=function(e,t){console.error("Builder block error:",e,t)},BuilderBlock.prototype.stringToFunction=function(e,t){return void 0===t&&(t=!0),stringToFunction(e,t,this._errors,this._logs)},Object.defineProperty(BuilderBlock.prototype,"block",{get:function(){return this.props.block},enumerable:!1,configurable:!0}),Object.defineProperty(BuilderBlock.prototype,"emotionCss",{get:function(){var e,t,n,i,r,o=this.block;if(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isServer */ .Ib.isServer){var a=o.animations&&o.animations[0];if(a&&"hover"!==a.trigger){var s=a&&a.steps&&a.steps[0],l=s&&s.styles;l&&(r=l)}}var u=sizeNames.slice().reverse(),d=this.block,c={};if(d.responsiveStyles)for(var p=0,f=u;p<f.length;p++){var m=f[p];if("large"===m)this.props.emailMode||(c["&.builder-block"]=Object.assign({},d.responsiveStyles[m],r));else{var h=getSizesForBreakpoints((null===(t=null===(e=this.privateState.context.builderContent)||void 0===e?void 0:e.meta)||void 0===t?void 0:t.breakpoints)||{});c["@media only screen and (max-width: ".concat(h[m].max,"px)")]={"&.builder-block":d.responsiveStyles[m]}}}var g=o.animations&&o.animations.find((function(e){return"hover"===e.trigger}));return g&&(c[":hover"]=(null===(i=null===(n=g.steps)||void 0===n?void 0:n[1])||void 0===i?void 0:i.styles)||{},c.transition="all ".concat(g.duration,"s ").concat(camelCaseToKebabCase(g.easing)),g.delay&&(c.transitionDelay=g.delay+"s")),c},enumerable:!1,configurable:!0}),BuilderBlock.prototype.eval=function(e){return this.stringToFunction(e)(this.privateState.state,void 0,this.block,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder */ .fl,Device,this.privateState.update,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder */ .Ib,this.privateState.context)},BuilderBlock.prototype.componentWillUnmount=function(){_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&removeEventListener("message",this.onWindowMessage)},BuilderBlock.prototype.componentDidMount=function(){var e,t=this,n=this.block,i=n&&n.animations;if(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&addEventListener("message",this.onWindowMessage),i){var r={animations:fastClone(i)};if(n.bindings)for(var o in n.bindings)if((null===(e=o.trim)||void 0===e?void 0:e.call(o))&&o.startsWith("animations.")){var a=this.stringToFunction(n.bindings[o]);void 0!==a&&set(r,o,a(this.privateState.state,null,n,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder */ .fl,null,null,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder */ .Ib,this.privateState.context))}_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.animator.bindAnimations */ .Ib.animator.bindAnimations(r.animations.filter((function(e){return"hover"!==e.trigger})).map((function(e){return __assign(__assign({},e),{elementId:t.block.id})})))}},BuilderBlock.prototype.getElement=function(e,t){var n,i,r,o,a,s=this;void 0===e&&(e=0),void 0===t&&(t=this.privateState.state);var l=this.props;l.child,l.fieldName;var u,d=this.block,c=(d.tagName||"div").toLowerCase();if("template"===c){var p=d.children?d.children.map((function(e){return blockToHtmlString(e)})).join(" "):"";return console.debug("template html",p),(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("template",__assign({},d.properties,{dangerouslySetInnerHTML:{__html:p}}))}var f=d.component&&(d.component.name||d.component.component),m=null;d.component&&!d.component.class&&(d.component&&d.component.tag?u=d.component.tag:(m=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.components.find */ .Ib.components.find((function(e){return e.name===f}))||null)&&m.class?u=m.class:m&&m.tag?u=m.tag:(null==f?void 0:f.startsWith("Builder:"))?console.warn("Missing @builder.io/widgets installation, please install and import @builder.io/widgets to use ".concat(f.split(":")[1]," in your content, more info here: https://github.com/BuilderIO/builder/tree/main/packages/widgets")):f&&console.warn("Missing registration for ".concat(f,", have you included the registration in your bundle?")));var h=__assign(__assign({},d.properties),{style:{}});if(h=__assign(__assign({},h.properties),h),d.component&&(h.component=fastClone(d.component)),d.bindings)for(var g in d.bindings)if(null===(i=g.trim)||void 0===i?void 0:i.call(g)){var v=this.stringToFunction(d.bindings[g]);set(h,g,v(t,null,d,api(),Device,null,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder */ .Ib,this.privateState.context))}if(h.hide)return null;if(delete h.hide,("show"in h||d.bindings&&d.bindings.show)&&!h.show)return null;if(delete h.show,d.actions){var b=function(e){if(!(null===(r=e.trim)||void 0===r?void 0:r.call(e)))return"continue";var n=d.actions[e];h["on"+capitalize(e)]=function(e){var i=t;return"undefined"!=typeof Proxy&&(i=new Proxy(t,{set:function(e,t,n){return e[t]=n,s.privateState.rootState[t]=n,!0}})),s.stringToFunction(n,!1)(i,e,s.block,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder */ .fl,Device,s.privateState.update,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder */ .Ib,s.privateState.context)}};for(var g in d.actions)b(g)}var y=(h.component||h.options)&&__assign(__assign({},h.options),h.component.options||h.component.data),_=voidElements.has(c),x=m&&(m.fragment||m.noWrap),B=(null===(o=h.attr)||void 0===o?void 0:o.style)||("string"==typeof h.style?h.style:"")||"";if("string"==typeof B){"object"!=typeof h.style&&(h.style={});for(var S=0,k=B.split(";");S<k.length;S++){var w=k[S].split(":");if(!w.length)return;g=w[0],v=w[1];w.length>2&&(v=w.slice(1).join(":")),h.style[kebabCaseToCamelCase(g)]=v}}var C=__assign(__assign(__assign({},omit$1(h,["class","component","attr"])),((n={})["string"!=typeof c||c.includes("-")?"class":"className"]="builder-block ".concat(this.id).concat(d.class?" ".concat(d.class):"").concat(!d.component||["Image","Video","Banner"].indexOf(f)>-1?"":" builder-has-component")+(h.class?" "+h.class:"")+(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&(null===(a=this.privateState.state._spacer)||void 0===a?void 0:a.parent)===d.id?" builder-spacer-parent":""),n.key=this.id+e,n["builder-id"]=this.id,n)),0!==e&&{"builder-index":e});_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&(C["builder-inline-styles"]=h.attr&&h.attr.style?Object.keys(h.style).reduce((function(e,t){return(e?"".concat(e,";"):"")+"".concat(cssCase(t),":").concat(h.style[t],";")}),""):""),(C.properties&&C.properties.href||C.href)&&"div"===c&&(c="a"),"a"===c&&(c=Link);var R=d.children||C.children||[];return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment,null,(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .ClassNames */ .ms,null,(function(e){var t=e.css;if(e.cx,!s.props.emailMode){var n=" "+t(s.emotionCss);C.class&&(C.class+=n),C.className&&(C.className+=n)}return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderAsyncRequestsContext.Consumer,null,(function(e){return s._asyncRequests=e&&e.requests,s._errors=e&&e.errors,s._logs=e&&e.logs,_?(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(c,__assign({},C)):u&&(x||s.props.emailMode)?(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(u,__assign({},y,{attributes:C,builderBlock:d,builderState:s.privateState})):(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(c,__assign({},C),u&&(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(u,__assign({builderState:s.privateState,builderBlock:d},y)),d.text||h.text?h.text:!u&&R&&Array.isArray(R)&&R.length?R.map((function(e,t){return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderBlock,{key:(s.id||"")+t,block:e,index:t,size:s.props.size,fieldName:s.props.fieldName,child:s.props.child,emailMode:s.props.emailMode})})):null)}))})))},Object.defineProperty(BuilderBlock.prototype,"id",{get:function(){var e=this.block;return e.id.startsWith("builder")?e.id:"builder-"+e.id},enumerable:!1,configurable:!0}),BuilderBlock.prototype.contents=function(e){var t=this,n=this.block;if(this.privateState=e,n.repeat&&n.repeat.collection){var i=n.repeat.collection,r=last((i||"").trim().split("(")[0].trim().split(".")),o=n.repeat.itemName||(r?r+"Item":"item"),a=this.stringToFunction(i)(e.state,null,n,api(),Device,null,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder */ .Ib,this.privateState.context);return Array.isArray(a)?a.map((function(n,i){var r,a=__assign(__assign({},e.state),((r={$index:i,$item:n})[o]=n,r["$".concat(o,"Index")]=i,r));return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderStoreContext.Provider,{key:i,value:__assign(__assign({},e),{state:a})},t.getElement(i,a))})):null}return this.getElement()},BuilderBlock.prototype.render=function(){var e=this;return this.state.hasError?(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span",{css:{display:"inline-block",padding:5,color:"#999",fontSize:11,fontStyle:"italic"}},"Builder block error :( Check console for details"):(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderStoreContext.Consumer,null,(function(t){return e.contents(t)}))},BuilderBlock}(react__WEBPACK_IMPORTED_MODULE_2__.Component),BuilderBlocks=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.onClickEmptyBlocks=function(){var e;_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isIframe */ .Ib.isIframe&&t.noBlocks&&(null===(e=window.parent)||void 0===e||e.postMessage({type:"builder.clickEmptyBlocks",data:{parentElementId:t.parentId,dataPath:t.path}},"*"))},t.onHoverEmptyBlocks=function(){var e;_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&t.noBlocks&&(null===(e=window.parent)||void 0===e||e.postMessage({type:"builder.hoverEmptyBlocks",data:{parentElementId:t.parentId,dataPath:t.path}},"*"))},t}return __extends(t,e),Object.defineProperty(t.prototype,"isRoot",{get:function(){return!this.props.child},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"noBlocks",{get:function(){var e=this.props.blocks;return!(e&&e.length)},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"path",{get:function(){var e=this.props.dataPath||"";return e.trim()&&(e.startsWith("this.")?e=e.replace("this.",""):e.startsWith("component.options.")||(e="component.options."+e)),e},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"parentId",{get:function(){return this.props.parentElementId?this.props.parentElementId:this.props.parent&&this.props.parent.id},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this,t=this.props.blocks,n=this.props.emailMode?"span":"div";return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(n,__assign({className:"builder-blocks"+(this.noBlocks?" no-blocks":"")+(this.props.child?" builder-blocks-child":"")+(this.props.className?" "+this.props.className:""),"builder-type":"blocks","builder-path":_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isIframe */ .Ib.isIframe?this.path:void 0,"builder-parent-id":this.parentId,css:__assign(__assign({},!this.props.emailMode&&{display:"flex",flexDirection:"column",alignItems:"stretch"}),this.props.style),onClick:function(){e.noBlocks&&e.onClickEmptyBlocks()}},_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&{onMouseEnter:function(){return e.onHoverEmptyBlocks()}}),t&&Array.isArray(t)&&t.map((function(t,n){return t&&"@builder.io/sdk:Element"===t["@type"]?(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderBlock$1,{key:t.id,block:t,index:n,fieldName:e.props.fieldName,child:e.props.child,emailMode:e.props.emailMode}):t}))||t)},t.renderInto=function(e,n,i){if(void 0===n&&(n={}),e){var r=null;return"string"==typeof e?r=document.querySelector(e):e instanceof Element&&(r=e),react_dom__WEBPACK_IMPORTED_MODULE_3__.render((0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderStoreContext.Provider,{value:i},(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(t,__assign({},n))),r)}},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),NoWrap=function(e){return e.children};function getData(e){if(void 0!==(null==e?void 0:e.data)){var t=e.data,n=t.blocks,i=t.blocksString,r=Array.isArray(n)||"string"==typeof i,o=__assign(__assign({},e.data),r&&{blocks:n||JSON.parse(i)});return delete o.blocksString,o}}var variantsScript=function(e,t){return"\n(function() {\n  if (window.builderNoTrack || !navigator.cookieEnabled) {\n    return;\n  }\n\n  var variants = ".concat(e,';\n  function removeVariants() {\n    variants.forEach(function (template) {\n      document.querySelector(\'template[data-template-variant-id="\' + template.id + \'"]\').remove();\n    });\n  }\n\n  if (typeof document.createElement("template").content === \'undefined\') {\n    removeVariants();\n    return ;\n  }\n\n  function setCookie(name,value,days) {\n    var expires = "";\n    if (days) {\n        var date = new Date();\n        date.setTime(date.getTime() + (days*24*60*60*1000));\n        expires = "; expires=" + date.toUTCString();\n    }\n    document.cookie = name + "=" + (value || "")  + expires + "; path=/" + "; Secure; SameSite=None";\n  }\n\n  function getCookie(name) {\n    var nameEQ = name + "=";\n    var ca = document.cookie.split(\';\');\n    for(var i=0;i < ca.length;i++) {\n        var c = ca[i];\n        while (c.charAt(0)==\' \') c = c.substring(1,c.length);\n        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);\n    }\n    return null;\n  }\n  var cookieName = \'builder.tests.').concat(t,"';\n  var variantInCookie = getCookie(cookieName);\n  var availableIDs = variants.map(function(vr) { return vr.id }).concat('").concat(t,"');\n  var variantId;\n  if (availableIDs.indexOf(variantInCookie) > -1) {\n    variantId = variantInCookie;\n  }\n  if (!variantId) {\n    var n = 0;\n    var random = Math.random();\n    for (var i = 0; i < variants.length; i++) {\n      var variant = variants[i];\n      var testRatio = variant.testRatio;\n      n += testRatio;\n      if (random < n) {\n        setCookie(cookieName, variant.id);\n        variantId = variant.id;\n        break;\n      }\n    }\n    if (!variantId) {\n      variantId = \"").concat(t,'";\n      setCookie(cookieName, "').concat(t,'");\n    }\n  }\n  if (variantId && variantId !== "').concat(t,"\") {\n    var winningTemplate = document.querySelector('template[data-template-variant-id=\"' + variantId + '\"]');\n    if (winningTemplate) {\n      var parentNode = winningTemplate.parentNode;\n      var newParent = parentNode.cloneNode(false);\n      newParent.appendChild(winningTemplate.content.firstChild);\n      parentNode.parentNode.replaceChild(newParent, parentNode);\n    }\n  } else if (variants.length > 0) {\n    removeVariants();\n  }\n})()").replace(/\s+/g," ")},VariantsProvider=function(e){var t=e.initialContent,n=e.children;if(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&!_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.canTrack */ .fl.canTrack)return n([t]);if(!Boolean(Object.keys((null==t?void 0:t.variations)||{}).length))return n([t]);var i=Object.keys(t.variations).map((function(e){return __assign(__assign({id:e},t.variations[e]),{data:getData(t.variations[e])})})),r=__spreadArray(__spreadArray([],i,!0),[t],!1);if(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isServer */ .Ib.isServer){var o=JSON.stringify(Object.keys(t.variations||{}).map((function(e){return{id:e,testRatio:t.variations[e].testRatio}})));return react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment,null,n(r,(function(){return react__WEBPACK_IMPORTED_MODULE_2__.createElement("script",{dangerouslySetInnerHTML:{__html:variantsScript(o,t.id)}})})))}var a="builder.tests.".concat(t.id),s=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.getCookie */ .fl.getCookie(a);if(!s&&_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser)for(var l=0,u=Math.random(),d=0;d<i.length;d++){var c=i[d];if(u<(l+=c.testRatio)){_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.setCookie */ .fl.setCookie(a,c.id),s=c.id;break}}return s||(s=t.id,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.setCookie */ .fl.setCookie(a,s)),n([r.find((function(e){return e.id===s}))])},BuilderContent=function(_super){function BuilderContent(){var _this=null!==_super&&_super.apply(this,arguments)||this;return _this.ref=null,_this.state={loading:!_this.props.content,data:getContentWithInfo(_this.props.content),updates:1},_this.onWindowMessage=function(event){var _a,_b,message=event.data;if(message)switch(message.type){case"builder.patchUpdates":if(null===(_a=_this.props.options)||void 0===_a?void 0:_a.noEditorUpdates)return;var data=message.data;if(!data||!data.data)break;var patches=data.data[null===(_b=_this.state.data)||void 0===_b?void 0:_b.id];if(!patches||!patches.length)return;location.href.includes("builder.debug=true")&&eval("debugger");for(var newData=_this.state.data,_i=0,patches_1=patches;_i<patches_1.length;_i++){var patch=patches_1[_i];newData=applyPatchWithMinimalMutationChain(newData,patch,!1)}_this.setState({updates:_this.state.updates+1,data:newData}),_this.props.contentLoaded&&_this.props.contentLoaded(newData.data,newData)}},_this.subscriptions=new _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Subscription */ .w0,_this.firstLoad=!0,_this.clicked=!1,_this.trackedImpression=!1,_this.intersectionObserver=null,_this.onClick=function(e){var t=e.nativeEvent,n=_this.data;n&&(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.autoTrack */ .fl.autoTrack&&_this.builder.trackInteraction(n.id,_this.renderedVariantId,_this.clicked,t,{content:n}),_this.clicked||(_this.clicked=!0))},_this}return __extends(BuilderContent,_super),Object.defineProperty(BuilderContent.prototype,"builder",{get:function(){return this.props.builder||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder */ .fl},enumerable:!1,configurable:!0}),Object.defineProperty(BuilderContent.prototype,"name",{get:function(){var e=this.props;return"model"in e?e.model:e.modelName},enumerable:!1,configurable:!0}),Object.defineProperty(BuilderContent.prototype,"renderedVariantId",{get:function(){var e,t,n=this.props.isStatic?this.builder.getCookie("builder.tests.".concat(null===(e=this.data)||void 0===e?void 0:e.id)):null===(t=this.data)||void 0===t?void 0:t.variationId;if(null!==n)return n},enumerable:!1,configurable:!0}),Object.defineProperty(BuilderContent.prototype,"options",{get:function(){var e,t,n=__assign({},this.props.options||{});return n.key||!(null===(e=this.props.content)||void 0===e?void 0:e.id)||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isPreviewing */ .Ib.isPreviewing||(n.key=this.props.content.id),!this.props.content||(null===(t=n.initialContent)||void 0===t?void 0:t.length)||!this.props.inline&&_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isPreviewing */ .Ib.isPreviewing||(n.initialContent=[this.props.content]),n},enumerable:!1,configurable:!0}),Object.defineProperty(BuilderContent.prototype,"data",{get:function(){var e=(this.props.inline||!_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser||this.firstLoad)&&this.options.initialContent&&this.options.initialContent[0]||this.state.data;return getContentWithInfo(e)},enumerable:!1,configurable:!0}),BuilderContent.prototype.componentDidMount=function(){var e,t;if(!this.props.inline||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isPreviewing */ .Ib.isPreviewing)this.subscribeToContent();else if(this.props.inline&&(null===(t=null===(e=this.options)||void 0===e?void 0:e.initialContent)||void 0===t?void 0:t.length)){var n=this.options.initialContent[0];(null==n?void 0:n.id)&&this.builder.trackImpression(n.id,this.renderedVariantId,void 0,{content:n})}_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&addEventListener("message",this.onWindowMessage)},BuilderContent.prototype.subscribeToContent=function(){var e=this;"_inline"!==this.name&&this.subscriptions.add(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.queueGetContent */ .fl.queueGetContent(this.name,this.options).subscribe((function(t){var n=t&&t[0];e.setState({data:n,loading:!1});var i=(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.editingModel */ .fl.editingModel||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.previewingModel */ .fl.previewingModel)===e.name;if(!e.props.inline&&e.props.content&&e.firstLoad&&i&&(e.firstLoad=!1,e.subscriptions.unsubscribe(),e.subscribeToContent()),n&&e.firstLoad&&(e.firstLoad=!1,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.autoTrack */ .fl.autoTrack&&!_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing)){var r=!1;if("function"==typeof IntersectionObserver&&e.ref)try{(e.intersectionObserver=new IntersectionObserver((function(t,i){t.forEach((function(t){t.intersectionRatio>0&&!e.trackedImpression&&(e.builder.trackImpression(n.id,e.renderedVariantId,void 0,{content:e.data}),e.data,e.trackedImpression=!0,e.ref&&i.unobserve(e.ref))}))}))).observe(e.ref),r=!0}catch(e){console.warn("Could not bind intersection observer")}r||(e.trackedImpression=!0,e.builder.trackImpression(n.id,e.renderedVariantId,void 0,{content:n}))}e.props.contentLoaded&&e.props.contentLoaded(n&&n.data,n)}),(function(t){e.props.contentError&&(e.props.contentError(t),e.setState({loading:!1}))})))},BuilderContent.prototype.componentWillUnmount=function(){_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&removeEventListener("message",this.onWindowMessage),this.subscriptions.unsubscribe(),this.intersectionObserver&&this.ref&&this.intersectionObserver.unobserve(this.ref)},BuilderContent.prototype.render=function(){var e=this;if(this.props.dataOnly)return null;var t=this.state.loading,n=this.data,i=this.props.dataOnly?NoWrap:"div";return react__WEBPACK_IMPORTED_MODULE_2__.createElement(VariantsProvider,{initialContent:n},(function(r,o){return react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment,null,r.map((function(a,s){var l=s===r.length-1?react__WEBPACK_IMPORTED_MODULE_2__.Fragment:"template";return react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment,{key:String((null==a?void 0:a.id)+s)},"template"!==l&&(null==o?void 0:o()),react__WEBPACK_IMPORTED_MODULE_2__.createElement(l,__assign({key:String((null==a?void 0:a.id)+s)},"template"===l&&{"data-template-variant-id":null==a?void 0:a.id}),react__WEBPACK_IMPORTED_MODULE_2__.createElement(i,__assign({},0===s&&!e.props.dataOnly&&{ref:function(t){return e.ref=t}},{className:"builder-content",onClick:e.onClick,"builder-content-id":null==a?void 0:a.id,"builder-model":e.name}),e.props.children(null==a?void 0:a.data,!e.props.inline&&t,n))))})))}))},BuilderContent}(react__WEBPACK_IMPORTED_MODULE_2__.Component),getContentWithInfo=function(e){var t;if(e){var n=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.getCookie */ .fl.getCookie("builder.tests.".concat(e.id)),i=n===e.id?e:null===(t=e.variations)||void 0===t?void 0:t[n],r=(null==i?void 0:i.name)||((null==i?void 0:i.id)===e.id?"Default variation":"");return __assign(__assign({},e),{variationId:n,testVariationId:n,testVariationName:r})}return null};function unwrapExports(e){return e&&e.__esModule&&Object.prototype.hasOwnProperty.call(e,"default")?e.default:e}function createCommonjsModule(e,t){return e(t={exports:{}},t.exports),t.exports}var onChange_1=createCommonjsModule((function(e,t){Object.defineProperty(t,"__esModule",{value:!0});var n=Symbol("target"),i=Symbol("unsubscribe"),r=function(e,t){return t&&t.toString&&(e&&(e+="."),e+=t.toString()),e},o=function(e){return Array.isArray(e)?e.slice():Object.assign({},e)},a=function(e,t,a){if("undefined"==typeof Proxy)return e;void 0===a&&(a={});var s,l,u=Symbol("ProxyTarget"),d=!1,c=!1,p=!1,f=a.equals||Object.is,m=new WeakMap,h=new WeakMap,g=new WeakMap,v=function(e,n,i,a){if(!p)if(d){if(d&&l&&void 0!==i&&void 0!==a&&"length"!==n){var u=l;e!==s&&function(e,t){for(var n;e;)-1===(n=e.indexOf("."))&&(n=e.length),t(e.slice(0,n)),e=e.slice(n+1)}(e=e.replace(s,"").slice(1),(function(e){u[e]=o(u[e]),u=u[e]})),u[n]=i}c=!0}else t(r(e,n),a,i)},b=function(e,t){var n=m?m.get(e):void 0;n&&n.delete(t)},y=function(e,t){if(p)return e;h.set(e,t);var n=g.get(e);return void 0===n&&(n=new Proxy(e,x),g.set(e,n)),n},_=function(e){return p||!0===a.ignoreSymbols&&"symbol"==typeof e},x={get:function(e,t,o){if(t===u||t===n)return e;if(t===i&&""===h.get(e))return function(e){return p=!0,m=null,h=null,g=null,e}(e);var s=Reflect.get(e,t,o);if(function(e){return null===e||"object"!=typeof e&&"function"!=typeof e}(s)||function(e){return e instanceof RegExp||e instanceof Number}(s)||"constructor"===t||!0===a.isShallow)return s;var l=function(e,t){var n=m?m.get(e):void 0;if(n)return n;n=new Map,m.set(e,n);var i=n.get(t);return i||(i=Reflect.getOwnPropertyDescriptor(e,t),n.set(t,i)),i}(e,t);if(l&&!l.configurable){if(l.set&&!l.get)return;if(!1===l.writable)return s}return y(s,r(h.get(e),t))},set:function(e,t,n,i){n&&void 0!==n[u]&&(n=n[u]);var r=_(t),o=r?null:Reflect.get(e,t,i),a=Reflect.set(e[u]||e,t,n);return r||f(o,n)||v(h.get(e),t,o,n),a},defineProperty:function(e,t,n){var i=Reflect.defineProperty(e,t,n);return _(t)||(b(e,t),v(h.get(e),t,void 0,n.value)),i},deleteProperty:function(e,t){if(!Reflect.has(e,t))return!0;var n=_(t),i=n?null:Reflect.get(e,t),r=Reflect.deleteProperty(e,t);return n||(b(e,t),v(h.get(e),t,i)),r},apply:function(e,t,n){var i=t instanceof Date;if(i&&(t=t[u]),!d){d=!0,i&&(l=t.valueOf()),(Array.isArray(t)||"[object Object]"===toString.call(t))&&(l=o(t[u])),s=(s=h.get(e)).slice(0,Math.max(s.lastIndexOf("."),0));var r=Reflect.apply(e,t,n);return d=!1,(c||i&&!f(l,t.valueOf()))&&(v(s,"",l,t[u]||t),l=null,c=!1),r}return Reflect.apply(e,t,n)}},B=y(e,"");return t=t.bind(B),B};a.target=function(e){return e[n]||e},a.unsubscribe=function(e){return e[i]||e},e.exports=a,t.default=a})),onChange=unwrapExports(onChange_1),nextTick=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.nextTick */ .Ib.nextTick;function debounceNextTick(e,t,n){return void 0===t&&"function"==typeof e?debounceNextTickImpl(e):{configurable:!0,enumerable:n.enumerable,get:function(){return Object.defineProperty(this,t,{configurable:!0,enumerable:n.enumerable,value:debounceNextTickImpl(n.value)}),this[t]}}}function debounceNextTickImpl(e){var t=null,n=null;return function(){var e=t;if(t=[].slice.call(arguments),n=this,null!==e)return;nextTick(i)};function i(){e.apply(n,t),t=null,n=null}}function throttle(e,t,n){var i,r,o;void 0===n&&(n={});var a=null,s=0,l=function(){s=!1===n.leading?0:Date.now(),a=null,o=e.apply(i,r),a||(i=r=null)};return function(){var u=Date.now();s||!1!==n.leading||(s=u);var d=t-(u-s);return i=this,r=arguments,d<=0||d>t?(a&&(clearTimeout(a),a=null),s=u,o=e.apply(i,r),a||(i=r=null)):a||!1===n.trailing||(a=setTimeout(l,d)),o}}var BuilderMetaContext=react__WEBPACK_IMPORTED_MODULE_2__.createContext({emailMode:!1,ampMode:!1,isServer:!1}),tryEval=function(e,t,n){void 0===t&&(t={});var i=e;if("string"==typeof i&&i.trim()){var r=!(i.includes(";")||i.includes(" return ")),o=function(){};try{_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&(o=new Function("state","var rootState = state;\n        if (typeof Proxy !== 'undefined') {\n          rootState = new Proxy(rootState, {\n            set: function () {\n              return false;\n            },\n            get: function (target, key) {\n              if (key === 'state') {\n                return state;\n              }\n              return target[key]\n            }\n          });\n        }\n        with (rootState) {\n          ".concat(r?"return (".concat(e,");"):e,";\n        }")))}catch(e){_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&console.warn("Could not compile javascript",e)}try{return _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser?o(t||{}):new(0,safeDynamicRequire("vm2").VM)({sandbox:__assign(__assign({},t),{state:t})}).run(i.replace(/(^|;)return /,"$1"))}catch(t){n&&n.push(t),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser?console.warn("Builder custom code error:",t.message,"in",e,t.stack):process.env.DEBUG&&console.debug("Builder custom code error:",t.message,"in",e,t.stack)}}};function toError(e){return e instanceof Error?e:new Error(String(e))}function pick(e){for(var t=[],n=1;n<arguments.length;n++)t[n-1]=arguments[n];var i={};return t.forEach((function(t){i[t]=e[t]})),i}function omit(e){for(var t=[],n=1;n<arguments.length;n++)t[n-1]=arguments[n];var i=__assign({},e);return t.forEach((function(e){delete i[e]})),i}var wrapComponent=function(e){return function(t){var n,i=t.builderTag||"div",r=["children"].concat((null===(n=e.inputs)||void 0===n?void 0:n.map((function(e){return e.name})))||[]),o=omit.apply(void 0,__spreadArray(__spreadArray([t],r,!1),["attributes"],!1)),a=t;return e.noWrap?react__WEBPACK_IMPORTED_MODULE_2__.createElement(e.class,__assign({attributes:o},a)):react__WEBPACK_IMPORTED_MODULE_2__.createElement(i,__assign({},o),react__WEBPACK_IMPORTED_MODULE_2__.createElement(e.class,__assign({},a)))}},size$1=function(e){return Object.keys(e).length};function debounce(e,t,n){var i;return void 0===n&&(n=!1),function(){var r=this,o=arguments;clearTimeout(i),i=setTimeout((function(){i=null,n||e.apply(r,o)}),t),n&&!i&&e.apply(r,o)}}var fontsLoaded=new Set,fetch$1;globalThis.fetch&&(fetch$1=globalThis.fetch),null!=fetch$1||(fetch$1=__webpack_require__(1053));var sizeMap={desktop:"large",tablet:"medium",mobile:"small"},fetchCache={};function searchToObject$1(e){var t=(e.search||"").substring(1).split("&"),n={};for(var i in t)if(t[i]&&"string"==typeof t[i]){var r=t[i].split("=");n[decodeURIComponent(r[0])]=decodeURIComponent(r[1])}return n}var BuilderComponent=function(e){function t(t){var n,i=this;(i=e.call(this,t)||this).subscriptions=new _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Subscription */ .w0,i.onStateChange=new _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .BehaviorSubject */ .Xe(null),i.asServer=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isServer */ .Ib.isServer,i.contentRef=null,i.styleRef=null,i.rootState=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isServer */ .Ib.isServer?{}:onChange({},(function(){return i.updateState()})),i.lastJsCode="",i.lastHttpRequests={},i.httpSubscriptionPerKey={},i.firstLoad=!0,i.ref=null,i.messageListener=function(e){var t=e.data;switch(t.type){case"builder.updateSpacer":var n=t.data;i.rootState._spacer,i.updateState((function(e){e._spacer=n}));break;case"builder.resetState":var r=t.data,o=r.state;if(r.model===i.name){for(var a in i.rootState)"function"!=typeof i.rootState[a]&&delete i.rootState[a];Object.assign(i.rootState,o),i.setState(__assign(__assign({},i.state),{state:i.rootState,updates:(i.state&&i.state.updates||0)+1}))}break;case"builder.resetSymbolState":var s=t.data.state,l=(o=s.state,s.model,s.id);if(i.props.builderBlock&&i.props.builderBlock===l){for(var a in i.rootState)delete i.rootState[a];Object.assign(i.rootState,o),i.setState(__assign(__assign({},i.state),{state:i.rootState,updates:(i.state&&i.state.updates||0)+1}))}}},i.resizeFn=function(){var e=i.deviceSizeState;e!==i.state.state.deviceSize&&i.setState(__assign(__assign({},i.state),{updates:(i.state&&i.state.updates||0)+1,state:Object.assign(i.rootState,__assign(__assign({},i.state.state),{deviceSize:e}))}))},i.resizeListener=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing?throttle(i.resizeFn,200):debounce(i.resizeFn,400),i.mounted=!1,i.updateState=function(e){var t=i.rootState;e&&e(t),i.mounted?i.setState({update:i.updateState,state:t,updates:(i.state&&i.state.updates||0)+1}):i.state=__assign(__assign({},i.state),{update:i.updateState,state:t,updates:(i.state&&i.state.updates||0)+1}),i.notifyStateChange()},i.onContentLoaded=function(e,t){if("page"===i.name&&_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&e){var n=e.title,r=e.pageTitle,o=e.description,a=e.pageDescription;if((n||r)&&(document.title=n||r),o||a){var s=document.querySelector('meta[name="description"]');s||((s=document.createElement("meta")).setAttribute("name","description"),document.head.appendChild(s)),s.setAttribute("content",o||a)}}if(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&i.notifyStateChange(),i.props.contentLoaded&&i.props.contentLoaded(e,t),e&&e.inputs&&Array.isArray(e.inputs)&&e.inputs.length&&(e.state||(e.state={}),e.inputs.forEach((function(t){t&&t.name&&void 0!==t.defaultValue&&void 0===e.state[t.name]&&(e.state[t.name]=t.defaultValue)}))),e&&e.state){var l=__assign(__assign({},i.state),{updates:(i.state&&i.state.updates||0)+1,state:Object.assign(i.rootState,__assign(__assign(__assign(__assign({},i.state.state),{location:i.locationState,deviceSize:i.deviceSizeState,device:i.device}),e.state),i.externalState))});i.mounted?i.setState(l):i.state=l}if(e&&e.jsCode&&_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&!i.options.codegen){var u=!1;if(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&(i.lastJsCode===e.jsCode?u=!0:i.lastJsCode=e.jsCode),!u){var d=i.state.state;try{new Function("data","ref","state","update","element","Builder","builder","context",e.jsCode)(e,i,d,i.state.update,i.ref,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder */ .Ib,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder */ .fl,i.state.context)}catch(t){var c=toError(t);_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser?console.warn("Builder custom code error:",c.message,"in",e.jsCode,c.stack):process.env.DEBUG&&console.debug("Builder custom code error:",c.message,"in",e.jsCode,c.stack)}}}if(e&&e.httpRequests&&!i.props.noAsync&&!(u=!1)){var p=function(t){var n=e.httpRequests[t];if(n&&(!i.data[t]||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing))if(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser){var r=i.evalExpression(n);if(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&i.lastHttpRequests[t]===r)return"continue";i.lastHttpRequests[t]=r;var o=n.match(/builder\.io\/api\/v2\/([^\/\?]+)/i);o&&o[1],i.handleRequest(t,r);var a=i.httpSubscriptionPerKey[t];a&&a.unsubscribe();var s=i.httpSubscriptionPerKey[t]=i.onStateChange.subscribe((function(){var e=i.evalExpression(n);e!==r&&(i.handleRequest(t,e),i.lastHttpRequests[t]=e)}));i.subscriptions.add(s)}else i.handleRequest(t,i.evalExpression(n))};for(var f in e.httpRequests)p(f)}};var r=i.inlinedContent;if(r&&r.content&&(r=r.content),i.sizes=getSizesForBreakpoints((null===(n=null==r?void 0:r.meta)||void 0===n?void 0:n.breakpoints)||{}),i.state={context:__assign(__assign({},t.context),{apiKey:_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.apiKey */ .fl.apiKey||i.props.apiKey}),state:Object.assign(i.rootState,__assign(__assign(__assign(__assign({},i.inlinedContent&&i.inlinedContent.data&&i.inlinedContent.data.state),{isBrowser:_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser,isServer:!_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser,_hydrate:t.hydrate,location:i.locationState,deviceSize:i.deviceSizeState,device:i.device}),i.getHtmlData()),t.data)),updates:0,key:0,update:i.updateState},_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser){var o=i.props.apiKey;if(o&&o!==i.builder.apiKey&&(i.builder.apiKey=o),i.inlinedContent){var a=i.inlinedContent.content||i.inlinedContent;i.onContentLoaded(null==a?void 0:a.data,getContentWithInfo(a))}}return i}return __extends(t,e),Object.defineProperty(t.prototype,"options",{get:function(){return __assign(__assign({},t.defaults),this.props)},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"name",{get:function(){return this.props.model||this.props.modelName||this.props.name},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"element",{get:function(){return this.ref},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"inlinedContent",{get:function(){if(!this.isPreviewing||this.props.inlineContent)return this.props.content},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"builder",{get:function(){return this.props.builder||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder */ .fl},enumerable:!1,configurable:!0}),t.prototype.getHtmlData=function(){var e=this.inlinedContent&&this.inlinedContent.id||this.props.entry,t=e&&_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&document.querySelector('script[data-builder-json="'.concat(e,'"],script[data-builder-state="').concat(e,'"]'));if(t)try{return JSON.parse(t.innerText)}catch(e){console.warn("Could not parse Builder.io HTML data transfer",e,t.innerText)}return{}},Object.defineProperty(t.prototype,"device",{get:function(){return this.builder.getUserAttributes().device||"desktop"},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"locationState",{get:function(){return __assign(__assign({},pick(this.location,"pathname","hostname","search","host")),{path:this.location.pathname&&this.location.pathname.split("/").slice(1)||"",query:searchToObject$1(this.location)})},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"deviceSizeState",{get:function(){return _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser?this.sizes.getSizeForWidth(window.innerWidth):sizeMap[this.device]||"large"},enumerable:!1,configurable:!0}),t.renderInto=function(e,n,i,r){if(void 0===n&&(n={}),void 0===i&&(i=!0),void 0===r&&(r=!1),console.debug("BuilderPage.renderInto",e,n,i,this),e){var o=null;if("string"==typeof e?o=document.querySelector(e):e instanceof Element&&(o=e),o){var a=o.classList.contains("builder-hydrated");if(!a||r){o.classList.add("builder-hydrated");var s=i&&o.innerHTML.includes("builder-block");if(!o.classList.contains("builder-component")){var l=o.querySelector(".builder-api-styles")||(o.previousElementSibling&&o.previousElementSibling.matches(".builder-api-styles")?o.previousElementSibling:null),u="";if(l)l.innerHTML.replace(/\/\*start:([^\*]+?)\*\/([\s\S]*?)\/\*end:([^\*]+?)\*\//g,(function(e,t,n){var i=null;try{i=document.querySelector('[data-emotion-css="'.concat(t,'"]'))}catch(e){console.warn(e)}return i?i.innerHTML=n:_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing||(u+=e),e})),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.nextTick */ .Ib.nextTick((function(){l.innerHTML=u}));var d=o.querySelector(".builder-component");d?o=d:s=!1}location.search.includes("builder.debug=true")&&console.debug("hydrate",s,o);var c=o;if(!a){var p=document.createElement("div");o.insertAdjacentElement("beforebegin",p),p.appendChild(o),c=p}if((_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&location.search.includes("builder.preview="))&&(s=!1),s&&o){var f=react_dom__WEBPACK_IMPORTED_MODULE_3__.render(react__WEBPACK_IMPORTED_MODULE_2__.createElement(t,__assign({},n)),c,c.builderRootRef);return c.builderRootRef=f,f}var m=react_dom__WEBPACK_IMPORTED_MODULE_3__.render(react__WEBPACK_IMPORTED_MODULE_2__.createElement(t,__assign({},n)),c,c.builderRootRef);return c.builderRootRef=m,m}console.debug("Tried to hydrate multiple times")}}},t.prototype.componentDidMount=function(){var e,t=this;this.mounted=!0,this.asServer&&(this.asServer=!1,this.updateState((function(e){e.isBrowser=!0,e.isServer=!1}))),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isIframe */ .Ib.isIframe&&(null===(e=window.parent)||void 0===e||e.postMessage({type:"builder.sdkInjected",data:{modelName:this.name}},"*")),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&(window.addEventListener("resize",this.resizeListener),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&window.addEventListener("message",this.messageListener),(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isPreviewing */ .Ib.isPreviewing)&&_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.nextTick */ .Ib.nextTick((function(){t.firstLoad=!1,t.reload()})),setTimeout((function(){window.dispatchEvent(new CustomEvent("builder:component:load",{detail:{ref:t}}))})))},Object.defineProperty(t.prototype,"isPreviewing",{get:function(){return(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isServer */ .Ib.isServer||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isPreviewing */ .Ib.isPreviewing&&!this.firstLoad)&&_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.previewingModel */ .fl.previewingModel===this.name},enumerable:!1,configurable:!0}),t.prototype.notifyStateChange=function(){if(!_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isServer */ .Ib.isServer&&this&&this.state){var e=this.state.state;this.props.onStateChange&&this.props.onStateChange(e),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&window.dispatchEvent(new CustomEvent("builder:component:stateChange",{detail:{state:e,ref:this}})),this.onStateChange.next(e)}},t.prototype.processStateFromApi=function(e){return e},Object.defineProperty(t.prototype,"location",{get:function(){return this.props.location||(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser?location:{})},enumerable:!1,configurable:!0}),t.prototype.getCssFromFont=function(e,t){var n=e.family+(e.kind&&!e.kind.includes("#")?", "+e.kind:""),i=n.split(",")[0],r=e.fileUrl?e.fileUrl:e.files&&e.files.regular,o="";if(r&&n&&i&&(o+='\n@font-face {\n  font-family: "'.concat(n,'";\n  src: local("').concat(i,"\"), url('").concat(r,"') format('woff2');\n  font-display: fallback;\n  font-weight: 400;\n}\n        ").trim()),e.files)for(var a in e.files){if(String(Number(a))===a){var s=e.files[a];s&&s!==r&&(o+='\n@font-face {\n  font-family: "'.concat(n,"\";\n  src: url('").concat(s,"') format('woff2');\n  font-display: fallback;\n  font-weight: ").concat(a,";\n}\n          ").trim())}}return o},t.prototype.componentWillUnmount=function(){this.unsubscribe(),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&(window.removeEventListener("resize",this.resizeListener),window.removeEventListener("message",this.messageListener))},t.prototype.getFontCss=function(e){var t=this;return this.builder.allowCustomFonts&&(null==e?void 0:e.customFonts)&&e.customFonts.length&&e.customFonts.map((function(n){return t.getCssFromFont(n,e)})).join(" ")||""},t.prototype.ensureFontsLoaded=function(e){if(this.builder.allowCustomFonts&&(null==e?void 0:e.customFonts)&&Array.isArray(e.customFonts))for(var t=0,n=e.customFonts;t<n.length;t++){var i=n[t],r=i.fileUrl?i.fileUrl:i.files&&i.files.regular;if(!fontsLoaded.has(r)){var o=this.getCssFromFont(i,e);if(fontsLoaded.add(r),!o)continue;var a=document.createElement("style");a.className="builder-custom-font",a.setAttribute("data-builder-custom-font",r),a.innerHTML=o,document.head.appendChild(a)}}},t.prototype.getCss=function(e){var t,n=null===(t=this.useContent)||void 0===t?void 0:t.id,i=(null==e?void 0:e.cssCode)||"";return n&&(i=i.replace(/&/g,".builder-component-".concat(n))),i+this.getFontCss(e)},Object.defineProperty(t.prototype,"data",{get:function(){var e,t=__assign(__assign(__assign({},this.inlinedContent&&(null===(e=this.inlinedContent.data)||void 0===e?void 0:e.state)),this.externalState),this.state.state);return Object.assign(this.rootState,t),t},enumerable:!1,configurable:!0}),t.prototype.componentDidUpdate=function(e){var t=this;this.props.data&&e.data!==this.props.data&&this.state.update((function(e){Object.assign(e,t.externalState)})),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&this.inlinedContent&&e.content!==this.inlinedContent&&this.onContentLoaded(this.inlinedContent.data,this.inlinedContent)},t.prototype.checkStyles=function(e){if(this.styleRef){var t=this.getCss(e);this.styleRef.innerHTML!==t&&(this.styleRef.innerHTML=t)}},t.prototype.reload=function(){this.setState({key:this.state.key+1})},Object.defineProperty(t.prototype,"content",{get:function(){var e=this.inlinedContent;return e&&e.content&&(e=__assign(__assign({},e),{data:e.content})),e},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"externalState",{get:function(){return __assign(__assign({},this.props.data),this.props.locale?{locale:this.props.locale}:{})},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"useContent",{get:function(){return this.content||this.state.context.builderContent},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e,t=this,n=this.content,i=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&this.externalState&&size$1(this.externalState)&&hash_sum__WEBPACK_IMPORTED_MODULE_4___default()(this.externalState),r=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing?this.name:this.props.entry;r&&!_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&i&&i.length<300&&(r+=":"+i);var o=this.props.dataOnly?react__WEBPACK_IMPORTED_MODULE_2__.Fragment:"div",a=null===(e=this.useContent)||void 0===e?void 0:e.id;return react__WEBPACK_IMPORTED_MODULE_2__.createElement(o,{onClick:function(e){!_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing||t.props.isChild||t.props.stopClickPropagationWhenEditing||e.stopPropagation()},className:"builder-component ".concat(a?"builder-component-".concat(a):""),"data-name":this.name,"data-source":"Rendered by Builder.io",key:this.state.key,ref:function(e){return t.ref=e}},react__WEBPACK_IMPORTED_MODULE_2__.createElement(BuilderMetaContext.Consumer,null,(function(e){return react__WEBPACK_IMPORTED_MODULE_2__.createElement(BuilderMetaContext.Provider,{value:"boolean"==typeof t.props.ampMode?__assign(__assign({},e),{ampMode:t.props.ampMode}):e},react__WEBPACK_IMPORTED_MODULE_2__.createElement(BuilderAsyncRequestsContext.Consumer,null,(function(e){var i;return t._asyncRequests=e&&e.requests,t._errors=e&&e.errors,t._logs=e&&e.logs,react__WEBPACK_IMPORTED_MODULE_2__.createElement(BuilderContent,{isStatic:t.props.isStatic||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isStatic */ .Ib.isStatic,key:(null===(i=t.inlinedContent)||void 0===i?void 0:i.id)||("content"in t.props&&!t.isPreviewing?"null-content-prop":"no-content-prop"),builder:t.builder,ref:function(e){return t.contentRef=e},contentLoaded:function(e,n){return t.onContentLoaded(e,n)},options:__assign(__assign(__assign(__assign(__assign(__assign({key:r,entry:t.props.entry},n&&{initialContent:[n]}),!n&&"content"in t.props&&!t.isPreviewing&&{initialContent:[]}),t.props.url&&{url:t.props.url}),t.props.options),t.props.locale?{locale:t.props.locale}:{}),t.options.codegen&&{format:"react"}),inline:t.props.inlineContent||!t.isPreviewing&&"content"in t.props,contentError:t.props.contentError,modelName:t.name||"page"},(function(e,n,i){var r;if(t.props.dataOnly)return null;i&&i.id&&(t.state.context.builderContent=i),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.nextTick */ .Ib.nextTick((function(){t.checkStyles(e)}));var o=t.options.codegen;if(o&&!t.Component&&(null==e?void 0:e.blocksJs)){var a=Array.from(new Set(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.components.map */ .Ib.components.map((function(e){return e.name})))),s=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.components.slice */ .Ib.components.slice().reverse(),l=a.map((function(e){return s.find((function(t){return t.class&&t.name===e}))})),u=a.map((function(e){return(e||"").replace(/[^\w]+/gi,"")})),d=l.map((function(e){return wrapComponent(e)}));t.Component=(new(Function.bind.apply(Function,__spreadArray(__spreadArray([void 0,"jsx","_css","Builder","builder","React","useBuilderState"],u,!1),[e.blocksJs],!1)))).apply(void 0,__spreadArray([_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder */ .Ib,_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder */ .fl,react__WEBPACK_IMPORTED_MODULE_2__,function(e){var t=react__WEBPACK_IMPORTED_MODULE_2__.useState(0)[1];return react__WEBPACK_IMPORTED_MODULE_2__.useState((function(){return onChange(e,(function(){t((function(e){return e+1}))}))}))[0]}],d,!1))}return e?react__WEBPACK_IMPORTED_MODULE_2__.createElement("div",{"data-builder-component":t.name,"data-builder-content-id":i.id,"data-builder-variation-id":i.testVariationId||i.variationId||i.id},!o&&t.getCss(e)&&react__WEBPACK_IMPORTED_MODULE_2__.createElement("style",{ref:function(e){return t.styleRef=e},className:"builder-custom-styles",dangerouslySetInnerHTML:{__html:t.getCss(e)}}),react__WEBPACK_IMPORTED_MODULE_2__.createElement(BuilderStoreContext.Provider,{value:__assign(__assign({},t.state),{rootState:t.rootState,state:t.data,content:i,renderLink:t.props.renderLink})},o&&t.Component?react__WEBPACK_IMPORTED_MODULE_2__.createElement(t.Component,{data:t.data,context:t.state.context}):react__WEBPACK_IMPORTED_MODULE_2__.createElement(BuilderBlocks,{key:String(!!(null===(r=null==e?void 0:e.blocks)||void 0===r?void 0:r.length)),emailMode:t.props.emailMode,fieldName:"blocks",blocks:e.blocks}))):n?react__WEBPACK_IMPORTED_MODULE_2__.createElement("div",{"data-builder-component":t.name,className:"builder-loading"},t.props.children):react__WEBPACK_IMPORTED_MODULE_2__.createElement("div",{"data-builder-component":t.name,className:"builder-no-content"})}))})))})))},t.prototype.evalExpression=function(e){var t=this,n=this.data;return String(e).replace(/{{([^}]+)}}/g,(function(e,i){return tryEval(i,n,t._errors)}))},t.prototype.handleRequest=function(e,t){return __awaiter(this,void 0,void 0,(function(){var n,i,r,o,a=this;return __generator(this,(function(s){return _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isIframe */ .Ib.isIframe&&fetchCache[t]?(this.updateState((function(n){n[e]=fetchCache[t]})),[2,fetchCache[t]]):(n=function(){return __awaiter(a,void 0,void 0,(function(){var n,i,r,o;return __generator(this,(function(a){switch(a.label){case 0:n=Date.now(),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser||console.time("Fetch "+t),a.label=1;case 1:return a.trys.push([1,4,5,6]),[4,fetch$1(t)];case 2:return[4,a.sent().json()];case 3:return i=a.sent(),[3,6];case 4:return r=a.sent(),o=toError(r),this._errors&&this._errors.push(o),this._logs&&this._logs.push("Fetch to ".concat(t," errored in ").concat(Date.now()-n,"ms")),[2];case 5:return _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser||(console.timeEnd("Fetch "+t),this._logs&&this._logs.push("Fetched ".concat(t," in ").concat(Date.now()-n,"ms"))),[7];case 6:return i&&(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isIframe */ .Ib.isIframe&&(fetchCache[t]=i),this.updateState((function(t){t[e]=i}))),[2,i]}}))}))},(i=this._asyncRequests&&this._asyncRequests.find((function(e){return isRequestInfo(e)&&e.url===t})))?((r=i.promise).then((function(t){t&&a.updateState((function(n){n[e]=t}))})),[2,r]):(o=n(),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.nextTick */ .Ib.nextTick((function(){a._asyncRequests&&a._asyncRequests.push(o)})),[2,o]))}))}))},t.prototype.unsubscribe=function(){this.subscriptions&&(this.subscriptions.unsubscribe(),this.subscriptions=new _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Subscription */ .w0)},t.prototype.handleBuilderRequest=function(e,t){var n=this,i=tryEval(t,this.data,this._errors);this.subscriptions&&this.unsubscribe(),i&&this.subscriptions.add(this.builder.queueGetContent(i.model,i).subscribe((function(t){t&&n.updateState((function(n){n[e]=t}))})))},t.defaults={codegen:Boolean(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&location.href.includes("builder.codegen=true"))},__decorate([debounceNextTick,__metadata("design:type",Function),__metadata("design:paramtypes",[]),__metadata("design:returntype",void 0)],t.prototype,"notifyStateChange",null),t}(react__WEBPACK_IMPORTED_MODULE_2__.Component);function BuilderBlock(e){return e.type="react",_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.Component */ .Ib.Component(e)}function updateMetadata(e,t){var n=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.components.find */ .Ib.components.find((function(t){return"string"==typeof e?t.name===e:t.class===t}))||null,i=t(n);n&&i?_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.registerComponent */ .Ib.registerComponent(i.class||n.class,i):n&&!i||!n&&i&&_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.registerComponent */ .Ib.registerComponent(i.class,i)}function withBuilder(e,t){return BuilderBlock(t)(e),e}var withChildren=function(e){var t=react__WEBPACK_IMPORTED_MODULE_2__.forwardRef((function(t,n){var i=t.children||t.builderBlock&&t.builderBlock.children&&t.builderBlock.children.map((function(e){return react__WEBPACK_IMPORTED_MODULE_2__.createElement(BuilderBlock$1,{key:e.id,block:e})}));return react__WEBPACK_IMPORTED_MODULE_2__.createElement(e,__assign({},t,{ref:n}),i)}));return t.builderOptions={canHaveChildren:!0},t},noWrap=function(e){var t=react__WEBPACK_IMPORTED_MODULE_2__.forwardRef((function(t,n){var i=__assign(__assign({},t),t.attributes);return react__WEBPACK_IMPORTED_MODULE_2__.createElement(e,__assign({},i,{ref:n}))}));return t.builderOptions={noWrap:!0},t},iconUrl="https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-text_fields-24px%20(1).svg?alt=media&token=12177b73-0ee3-42ca-98c6-0dd003de1929",TextComponent=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.textRef=null,t}return __extends(t,e),t.prototype.componentDidUpdate=function(e){this.allowTextEdit&&(!this.textRef||"true"===this.textRef.contentEditable&&this.textRef===document.activeElement||this.props.text!==e.text&&(this.textRef.innerHTML=this.props.text))},t.prototype.componentDidMount=function(){this.textRef&&(this.textRef.innerHTML=this.props.text)},t.prototype.evalExpression=function(e,t){return String(e).replace(/{{([^}]+)}}/g,(function(e,n){return tryEval(n,t)}))},Object.defineProperty(t.prototype,"allowTextEdit",{get:function(){return _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&location.search.includes("builder.allowTextEdit=true")&&!(this.props.builderBlock&&this.props.builderBlock.bindings&&(this.props.builderBlock.bindings["component.options.text"]||this.props.builderBlock.bindings["options.text"]||this.props.builderBlock.bindings.text))},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this,t=this.allowTextEdit,n={outline:"none","& p:first-of-type, & .builder-paragraph:first-of-type":{margin:0},"& > p, & .builder-paragraph":{color:"inherit",lineHeight:"inherit",letterSpacing:"inherit",fontWeight:"inherit",fontSize:"inherit",textAlign:"inherit",fontFamily:"inherit"}};return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderStoreContext.Consumer,null,(function(i){var r;return(null===(r=i.content.meta)||void 0===r?void 0:r.rtlMode)&&(n.direction="rtl"),(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment,null,(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span",__assign({ref:function(t){e.textRef=t},contentEditable:t||void 0,onInput:function(n){var i;t&&(null===(i=window.parent)||void 0===i||i.postMessage({type:"builder.textEdited",data:{id:e.props.builderBlock&&e.props.builderBlock.id,value:n.currentTarget.innerHTML}},"*"))},onKeyDown:function(n){t&&e.textRef&&27===n.which&&document.activeElement===e.textRef&&e.textRef.blur()},onFocus:function(n){var i;t&&(null===(i=window.parent)||void 0===i||i.postMessage({type:"builder.textFocused",data:{id:e.props.builderBlock&&e.props.builderBlock.id}},"*"))},onBlur:function(n){var i;t&&(null===(i=window.parent)||void 0===i||i.postMessage({type:"builder.textBlurred",data:{id:e.props.builderBlock&&e.props.builderBlock.id}},"*"))},css:n,className:"builder-text"},!t&&{dangerouslySetInnerHTML:{__html:e.evalExpression(e.props.text||e.props.content||"",i.state)}})))}))},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),Text=withBuilder(TextComponent,{name:"Text",static:!0,image:iconUrl,inputs:[{name:"text",type:"html",required:!0,autoFocus:!0,bubble:!0,defaultValue:"Enter some text..."}],defaultStyles:{lineHeight:"normal",height:"auto",textAlign:"center"}});function Slot(e){var t=e.name,n=(0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(BuilderStoreContext),i=!n.context.symbolId;return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div",__assign({css:{pointerEvents:"auto"}},i&&{"builder-slot":t}),(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderBlocks,{child:!0,parentElementId:n.context.symbolId,dataPath:"symbol.data.".concat(t),blocks:n.state[t]||[]}))}_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.registerComponent */ .Ib.registerComponent(Slot,{name:"Slot",description:"Allow child blocks to be inserted into this content when used as a Symbol",docsLink:"https://www.builder.io/c/docs/symbols-with-blocks",image:"https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2F3aad6de36eae43b59b52c85190fdef56",inputs:[{name:"name",type:"string",required:!0,defaultValue:"children"}]});var FragmentComponent=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.render=function(){return this.props.builderBlock&&this.props.builderBlock.children&&this.props.builderBlock.children.map((function(e,t){return react__WEBPACK_IMPORTED_MODULE_2__.createElement(BuilderBlock$1,{block:e,key:e.id,index:t})}))},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),Fragment=withBuilder(FragmentComponent,{name:"Core:Fragment",canHaveChildren:!0,noWrap:!0,static:!0,hideFromInsertMenu:!0}),DEFAULT_ASPECT_RATIO$2=.7004048582995948,defaultBlocks=[{"@type":"@builder.io/sdk:Element",responsiveStyles:{large:{display:"flex",flexDirection:"column",alignItems:"stretch",flexShrink:"0",position:"relative",marginTop:"30px",textAlign:"center",lineHeight:"normal",height:"auto",minHeight:"20px",minWidth:"20px",overflow:"hidden"}},component:{name:"Image",options:{image:"https://builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d",backgroundPosition:"center",backgroundSize:"cover",aspectRatio:DEFAULT_ASPECT_RATIO$2}}},{"@type":"@builder.io/sdk:Element",responsiveStyles:{large:{display:"flex",flexDirection:"column",alignItems:"stretch",flexShrink:"0",position:"relative",marginTop:"30px",textAlign:"center",lineHeight:"normal",height:"auto"}},component:{name:"Text",options:{text:"<p>Enter some text...</p>"}}}],ColumnsComponent=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),Object.defineProperty(t.prototype,"columns",{get:function(){return this.props.columns||[]},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"gutterSize",{get:function(){return"number"==typeof this.props.space?this.props.space||0:20},enumerable:!1,configurable:!0}),t.prototype.getWidth=function(e){return this.columns[e]&&this.columns[e].width||100/this.columns.length},t.prototype.getColumnWidth=function(e){var t=this.columns,n=this.gutterSize*(t.length-1)/t.length;return"calc(".concat(this.getWidth(e),"% - ").concat(n,"px)")},t.prototype.render=function(){var e,t=this,n=this.columns,i=this.gutterSize;return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment,null,(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div",{className:"builder-columns",css:__assign({display:"flex"},"never"!==this.props.stackColumnsAt&&(e={},e["@media (max-width: ".concat("tablet"!==this.props.stackColumnsAt?639:991,"px)")]={flexDirection:this.props.reverseColumnsWhenStacked?"column-reverse":"column",alignItems:"stretch"},e))},n.map((function(e,n){var r,o,a=e.link?Link:"div";return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment,{key:n},(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(a,__assign({className:"builder-column"},e.link?{href:e.link}:null,{css:__assign((r={display:"flex",flexDirection:"column",alignItems:"stretch",lineHeight:"normal"},r["& > .builder-blocks"]={flexGrow:1},r.width=t.getColumnWidth(n),r.marginLeft=0===n?0:i,r),"never"!==t.props.stackColumnsAt&&(o={},o["@media (max-width: ".concat("tablet"!==t.props.stackColumnsAt?639:991,"px)")]={width:"100%",marginLeft:0},o))}),(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderBlocks,{key:n,child:!0,parentElementId:t.props.builderBlock&&t.props.builderBlock.id,blocks:e.blocks,dataPath:"component.options.columns.".concat(n,".blocks")})))}))))},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),Columns=withBuilder(ColumnsComponent,{name:"Columns",static:!0,inputs:[{name:"columns",type:"array",broadcast:!0,subFields:[{name:"blocks",type:"array",hideFromUI:!0,defaultValue:defaultBlocks},{name:"width",type:"number",hideFromUI:!0,helperText:"Width %, e.g. set to 50 to fill half of the space"},{name:"link",type:"url",helperText:"Optionally set a url that clicking this column will link to"}],defaultValue:[{blocks:defaultBlocks},{blocks:defaultBlocks}],onChange:function(e){function t(){n.forEach((function(e){e.delete("width")}))}var n=e.get("columns");Array.isArray(n)&&(!n.find((function(e){return e.get("width")}))||(n.find((function(e){return!e.get("width")}))||100!==n.reduce((function(e,t){return e+t.get("width")}),0))&&t())}},{name:"space",type:"number",defaultValue:20,helperText:"Size of gap between columns",advanced:!0},{name:"stackColumnsAt",type:"string",defaultValue:"tablet",helperText:"Convert horizontal columns to vertical at what device size",enum:["tablet","mobile","never"],advanced:!0},{name:"reverseColumnsWhenStacked",type:"boolean",defaultValue:!1,helperText:"When stacking columns for mobile devices, reverse the ordering",advanced:!0}]}),EmbedComponent=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.elementRef=null,t.scriptsInserted=new Set,t.scriptsRun=new Set,t}return __extends(t,e),t.prototype.componentDidUpdate=function(e){this.props.content!==e.content&&this.findAndRunScripts()},t.prototype.componentDidMount=function(){this.findAndRunScripts()},t.prototype.findAndRunScripts=function(){if(this.elementRef&&"undefined"!=typeof window)for(var e=this.elementRef.getElementsByTagName("script"),t=0;t<e.length;t++){var n=e[t];if(n.src){if(this.scriptsInserted.has(n.src))continue;this.scriptsInserted.add(n.src);var i=document.createElement("script");i.async=!0,i.src=n.src,document.head.appendChild(i)}else{if(this.scriptsRun.has(n.innerText))continue;this.scriptsRun.add(n.innerText);try{new Function(n.innerText)()}catch(e){console.warn("Builder custom code component error:",e)}}}},Object.defineProperty(t.prototype,"content",{get:function(){return _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isServer */ .Ib.isServer?(this.props.content||"").replace(/<script[\s\S]*?<\/script>/g,""):this.props.content},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return react__WEBPACK_IMPORTED_MODULE_2__.createElement("div",{ref:function(t){return e.elementRef=t},className:"builder-embed",dangerouslySetInnerHTML:{__html:this.content}})},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),Embed=withBuilder(EmbedComponent,{name:"Embed",static:!0,inputs:[{name:"url",type:"url",required:!0,defaultValue:"",helperText:"e.g. enter a youtube url, google map, etc",onChange:function(e){var t=e.get("url");if(t){e.set("content","Loading...");return fetch("https://iframe.ly/api/iframely?url=".concat(t,"&api_key=").concat("ae0e60e78201a3f2b0de4b")).then((function(e){return e.json()})).then((function(n){e.get("url")===t&&(n.html?e.set("content",n.html):e.set("content","Invalid url, please try another"))})).catch((function(t){e.set("content","There was an error embedding this URL, please try again or another URL")}))}e.delete("content")}},{name:"content",type:"html",defaultValue:'<div style="padding: 20px; text-align: center">(Choose an embed URL)<div>',hideFromUI:!0}]}),globalReplaceNodes={}||null,isShopify$1=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&"Shopify"in window;if(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&globalReplaceNodes){var customCodeQuerySelector_1=".builder-custom-code";try{var allCustomCodeElements_1=Array.from(document.querySelectorAll(customCodeQuerySelector_1)),builderTemplates=document.querySelectorAll("template[data-template-variant-id]");builderTemplates.length&&Array.from(builderTemplates).forEach((function(e){var t=e.content.querySelectorAll(customCodeQuerySelector_1);t.length&&(allCustomCodeElements_1=allCustomCodeElements_1.concat(Array.from(t)))})),allCustomCodeElements_1.forEach((function(e){var t=e.parentElement,n=t&&t.getAttribute("builder-id");n&&(globalReplaceNodes[n]=globalReplaceNodes[n]||[],globalReplaceNodes[n].push(isShopify$1?e:e.cloneNode(!0)))}))}catch(e){console.error("Builder replace nodes error:",e)}}var CustomCodeComponent=function(e){function t(t){var n,i=this;if((i=e.call(this,t)||this).elementRef=null,i.originalRef=null,i.scriptsInserted=new Set,i.scriptsRun=new Set,i.firstLoad=!0,i.replaceNodes=!1,i.state={hydrated:!1},_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser){var r=null===(n=i.props.builderBlock)||void 0===n?void 0:n.id;if(i.replaceNodes=Boolean(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&(t.replaceNodes||isShopify$1)&&r&&(null==globalReplaceNodes?void 0:globalReplaceNodes[r])),i.firstLoad&&i.props.builderBlock)if(r&&(null==globalReplaceNodes?void 0:globalReplaceNodes[r])){var o=globalReplaceNodes[r].shift()||null;i.originalRef=o,0===globalReplaceNodes[r].length&&delete globalReplaceNodes[r]}else if(i.replaceNodes){var a=document.querySelectorAll(".".concat(i.props.builderBlock.id," .builder-custom-code"));if(1===a.length){var s=a[0];i.originalRef=s,i.originalRef.remove()}}}return i}return __extends(t,e),Object.defineProperty(t.prototype,"noReactRender",{get:function(){var e;return Boolean(isShopify$1&&(null===(e=this.props.code)||void 0===e?void 0:e.match(/{[{%]/g)))},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"isHydrating",{get:function(){return!isShopify$1&&this.originalRef},enumerable:!1,configurable:!0}),t.prototype.componentDidUpdate=function(e){this.props.code!==e.code&&this.findAndRunScripts()},t.prototype.componentDidMount=function(){var e=this;this.firstLoad=!1,this.replaceNodes||(this.isHydrating?(this.setState({hydrated:!0}),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.nextTick */ .Ib.nextTick((function(){return e.findAndRunScripts()}))):this.findAndRunScripts()),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&this.replaceNodes&&this.originalRef&&this.elementRef&&this.elementRef.appendChild(this.originalRef)},t.prototype.findAndRunScripts=function(){if(this.elementRef&&"undefined"!=typeof window)for(var e=this.elementRef.getElementsByTagName("script"),t=0;t<e.length;t++){var n=e[t];if(n.src){if(this.scriptsInserted.has(n.src))continue;this.scriptsInserted.add(n.src);var i=document.createElement("script");i.async=!0,i.src=n.src,document.head.appendChild(i)}else if(!n.type||["text/javascript","application/javascript","application/ecmascript"].includes(n.type)){if(this.scriptsRun.has(n.innerText))continue;try{this.scriptsRun.add(n.innerText),new Function(n.innerText)()}catch(e){console.warn("Builder custom code component error:",e)}}}},Object.defineProperty(t.prototype,"code",{get:function(){return(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isServer */ .Ib.isServer||this.isHydrating&&this.firstLoad)&&this.props.scriptsClientOnly?(this.props.code||"").replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,""):this.props.code},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return react__WEBPACK_IMPORTED_MODULE_2__.createElement("div",__assign({ref:function(t){return e.elementRef=t},className:"builder-custom-code"},!this.replaceNodes&&!this.noReactRender&&{dangerouslySetInnerHTML:{__html:this.code}}))},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),CustomCode=withBuilder(CustomCodeComponent,{name:"Custom Code",static:!0,requiredPermissions:["editCode"],inputs:[{name:"code",type:"html",required:!0,defaultValue:"<p>Hello there, I am custom HTML code!</p>",code:!0},__assign({name:"replaceNodes",type:"boolean",helperText:"Preserve server rendered dom nodes",advanced:!0},isShopify$1&&{defaultValue:!0}),__assign({name:"scriptsClientOnly",type:"boolean",helperText:"Only print and run scripts on the client. Important when scripts influence DOM that could be replaced when client loads",advanced:!0},!isShopify$1&&{defaultValue:!0})]});function removeProtocol(e){return e.replace(/http(s)?:/,"")}function isElementInViewport(e){var t=e.getBoundingClientRect();return t.top>=0&&t.left>=0&&t.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&t.right<=(window.innerWidth||document.documentElement.clientWidth)}function getShopifyImageUrl(e,t){if(!e||!(null==e?void 0:e.match(/cdn\.shopify\.com/))||!t)return e;if("master"===t)return removeProtocol(e);var n=e.match(/(_\d+x(\d+)?)?(\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?)/i);if(n){var i=e.split(n[0]),r=n[3],o=t.match("x")?t:"".concat(t,"x");return removeProtocol("".concat(i[0],"_").concat(o).concat(r))}return null}var DEFAULT_ASPECT_RATIO$1=.7041;function updateQueryParam(e,t,n){void 0===e&&(e="");var i=new RegExp("([?&])"+t+"=.*?(&|$)","i"),r=-1!==e.indexOf("?")?"&":"?";return e.match(i)?e.replace(i,"$1"+t+"="+encodeURIComponent(n)+"$2"):e+r+t+"="+encodeURIComponent(n)}function getSrcSet(e){if(!e)return e;var t=[100,200,400,800,1200,1600,2e3];if(e.match(/builder\.io/)){var n=e,i=Number(e.split("?width=")[1]);return isNaN(i)||(n="".concat(n," ").concat(i,"w")),t.filter((function(e){return e!==i})).map((function(t){return"".concat(updateQueryParam(e,"width",t)," ").concat(t,"w")})).concat([n]).join(", ")}return e.match(/cdn\.shopify\.com/)?t.map((function(t){return[getShopifyImageUrl(e,"".concat(t,"x").concat(t)),t]})).filter((function(e){return!!e[0]})).map((function(e){var t=e[0],n=e[1];return"".concat(t," ").concat(n,"w")})).concat([e]).join(", "):e}var getSizes=function(e,t){var n,i,r,o,a,s,l,u,d="";if(e){var c=e.split(","),p=c.length;d=c.map((function(e,t){return p===t+1?e.replace(/\([\s\S]*?\)/g,"").trim():e})).join(", ")}else if(t&&t.responsiveStyles){var f=[],m=!1,h=/^\d+/;if(null===(r=null===(i=null===(n=t.responsiveStyles)||void 0===n?void 0:n.small)||void 0===i?void 0:i.width)||void 0===r?void 0:r.match(h)){m=!0;var g="".concat("(max-width: 639px)"," ").concat(t.responsiveStyles.small.width.replace("%","vw"));f.push(g)}if(null===(s=null===(a=null===(o=t.responsiveStyles)||void 0===o?void 0:o.medium)||void 0===a?void 0:a.width)||void 0===s?void 0:s.match(h)){m=!0;g="".concat("(max-width: 991px)"," ").concat(t.responsiveStyles.medium.width.replace("%","vw"));f.push(g)}if(null===(u=null===(l=t.responsiveStyles)||void 0===l?void 0:l.large)||void 0===u?void 0:u.width){var v=t.responsiveStyles.large.width.replace("%","vw");f.push(v)}else m&&f.push("100vw");f.length&&(d=f.join(", "))}return d},ImageComponent=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.state={imageLoaded:!t.useLazyLoading,load:!t.useLazyLoading},t.pictureRef=null,t.scrollListener=null,t.intersectionObserver=null,t}return __extends(t,e),Object.defineProperty(t.prototype,"useLazyLoading",{get:function(){return(!_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser||!location.search.includes("builder.lazyLoadImages=false"))&&(!(!_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser||!location.href.includes("builder.lazyLoadImages=true"))||this.props.lazy)},enumerable:!1,configurable:!0}),t.prototype.componentWillUnmount=function(){_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&(this.scrollListener&&(window.removeEventListener("scroll",this.scrollListener),this.scrollListener=null),this.intersectionObserver&&this.pictureRef&&this.intersectionObserver.unobserve(this.pictureRef))},t.prototype.componentDidMount=function(){var e=this;if(this.props.lazy&&_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser)if(this.pictureRef&&isElementInViewport(this.pictureRef))this.setState({load:!0});else if("function"==typeof IntersectionObserver&&this.pictureRef){(this.intersectionObserver=new IntersectionObserver((function(t,n){t.forEach((function(t){t.intersectionRatio>0&&(e.setState({load:!0}),e.pictureRef&&n.unobserve(e.pictureRef))}))}))).observe(this.pictureRef)}else{var t=throttle((function(n){if(e.pictureRef){var i=e.pictureRef.getBoundingClientRect(),r=window.innerHeight/2;i.top<window.innerHeight+r&&(e.setState(__assign(__assign({},e.state),{load:!0})),window.removeEventListener("scroll",t),e.scrollListener=null)}}),400,{leading:!1,trailing:!0});this.scrollListener=t,window.addEventListener("scroll",t,{capture:!0,passive:!0}),t()}},Object.defineProperty(t.prototype,"image",{get:function(){return this.props.image||this.props.src},enumerable:!1,configurable:!0}),t.prototype.getSrcSet=function(){var e=this.image;if(e&&(e.match(/builder\.io/)||e.match(/cdn\.shopify\.com/)))return getSrcSet(e)},t.prototype.render=function(){var e,t=this,n=this.props,i=n.aspectRatio,r=n.lazy,o=this.props.builderBlock&&this.props.builderBlock.children,a=this.props.srcset,s=getSizes(this.props.sizes,this.props.builderBlock),l=this.image;a&&l&&l.includes("builder.io/api/v1/image")?a.includes(l.split("?")[0])||(console.debug("Removed given srcset"),a=this.getSrcSet()):l&&!a&&(a=this.getSrcSet());var u=null===(e=this.props.builderBlock)||void 0===e?void 0:e.id.startsWith("builder-pixel-"),d=this.props.fitContent;return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderMetaContext.Consumer,null,(function(e){var n,l=e.ampMode,c=l?"amp-img":"img",p=(!r||t.state.load||l)&&(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(c,__assign({},l?{layout:"responsive",height:t.props.height||(i?Math.round(1e3*i):void 0),width:t.props.width||(i?Math.round(1e3/i):void 0)}:null,{alt:t.props.altText,key:_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&"string"==typeof t.image&&t.image.split("?")[0]||void 0,role:t.props.altText?void 0:"presentation",css:__assign(__assign({opacity:l?1:t.useLazyLoading&&!t.state.imageLoaded?0:1,transition:"opacity 0.2s ease-in-out",objectFit:t.props.backgroundSize||"cover",objectPosition:t.props.backgroundPosition||"center"},i&&!l&&{position:"absolute",height:"100%",width:"100%",left:0,top:0}),l&&(n={},n["& img"]={objectFit:t.props.backgroundSize,objectPosition:t.props.backgroundPosition},n)),loading:u?"eager":"lazy",className:"builder-image"+(t.props.className?" "+t.props.className:""),src:t.image},!l&&{onLoad:function(){return t.setState({imageLoaded:!0})}},{srcSet:a,sizes:!l&&s?s:void 0}));return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment,null,l?p:(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("picture",{ref:function(e){return t.pictureRef=e}},a&&a.match(/builder\.io/)&&!t.props.noWebp&&(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("source",{srcSet:a.replace(/\?/g,"?format=webp&"),type:"image/webp"}),p),!i||l||d&&o&&o.length?null:(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div",{className:"builder-image-sizer",css:{width:"100%",paddingTop:100*i+"%",pointerEvents:"none",fontSize:0}}," "),o&&o.length?d?o.map((function(e,t){return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderBlock$1,{key:e.id,block:e})})):(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div",{css:{display:"flex",flexDirection:"column",alignItems:"stretch",position:"absolute",top:0,left:0,width:"100%",height:"100%"}},o.map((function(e,t){return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderBlock$1,{key:e.id,block:e})}))):null)}))},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),Image=withBuilder(ImageComponent,{name:"Image",static:!0,image:"https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-insert_photo-24px.svg?alt=media&token=4e5d0ef4-f5e8-4e57-b3a9-38d63a9b9dc4",defaultStyles:{position:"relative",minHeight:"20px",minWidth:"20px",overflow:"hidden"},canHaveChildren:!0,inputs:[{name:"image",type:"file",bubble:!0,allowedFileTypes:["jpeg","jpg","png","svg"],required:!0,defaultValue:"https://cdn.builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d",onChange:function(e){e.delete("srcset"),e.delete("noWebp");var t,n,i=e.get("image"),r=e.get("aspectRatio");if(fetch(i).then((function(e){return e.blob()})).then((function(t){t.type.includes("svg")&&e.set("noWebp",!0)})),i&&(!r||.7041===r))return(t=i,void 0===n&&(n=6e4),new Promise((function(e,i){var r=document.createElement("img"),o=!1;r.onload=function(){o=!0,e(r)},r.addEventListener("error",(function(e){console.warn("Image load failed",e.error),i(e.error)})),r.src=t,setTimeout((function(){o||i(new Error("Image load timed out"))}),n)}))).then((function(t){var n,r=e.get("aspectRatio");e.get("image")!==i||r&&.7041!==r||t.width&&t.height&&(e.set("aspectRatio",(n=t.height/t.width,Math.round(1e3*n)/1e3)),e.set("height",t.height),e.set("width",t.width))}))}},{name:"backgroundSize",type:"text",defaultValue:"cover",enum:[{label:"contain",value:"contain",helperText:"The image should never get cropped"},{label:"cover",value:"cover",helperText:"The image should fill its box, cropping when needed"}]},{name:"backgroundPosition",type:"text",defaultValue:"center",enum:["center","top","left","right","bottom","top left","top right","bottom left","bottom right"]},{name:"altText",type:"string",helperText:"Text to display when the user has images off"},{name:"height",type:"number",hideFromUI:!0},{name:"width",type:"number",hideFromUI:!0},{name:"sizes",type:"string",hideFromUI:!0},{name:"srcset",type:"string",hideFromUI:!0},{name:"lazy",type:"boolean",defaultValue:!0,hideFromUI:!0},{name:"fitContent",type:"boolean",helperText:"When child blocks are provided, fit to them instead of using the image's aspect ratio",defaultValue:!0},{name:"aspectRatio",type:"number",helperText:"This is the ratio of height/width, e.g. set to 1.5 for a 300px wide and 200px tall photo. Set to 0 to not force the image to maintain it's aspect ratio",advanced:!0,defaultValue:DEFAULT_ASPECT_RATIO$1}]}),DEFAULT_ASPECT_RATIO=.7004048582995948,VideoComponent=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.video=null,t.containerRef=null,t.scrollListener=null,t.state={load:!t.lazyLoad},t}return __extends(t,e),Object.defineProperty(t.prototype,"lazyLoad",{get:function(){return!1!==this.props.lazyLoad},enumerable:!1,configurable:!0}),t.prototype.updateVideo=function(){var e=this,t=this.video;if(t){["muted","playsInline","autoPlay"].forEach((function(n){var i=n.toLowerCase();e.props[n]?t.setAttribute(i,i):t.removeAttribute(i)}))}},t.prototype.componentDidUpdate=function(){this.updateVideo()},t.prototype.componentDidMount=function(){var e=this;if(this.updateVideo(),this.lazyLoad&&_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser){var t=throttle((function(n){if(e.containerRef){var i=e.containerRef.getBoundingClientRect(),r=window.innerHeight/2;i.top<window.innerHeight+r&&(e.setState((function(e){return __assign(__assign({},e),{load:!0})})),window.removeEventListener("scroll",t),e.scrollListener=null)}}),400,{leading:!1,trailing:!0});this.scrollListener=t,window.addEventListener("scroll",t,{capture:!0,passive:!0}),t()}},t.prototype.componentWillUnmount=function(){_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&this.scrollListener&&(window.removeEventListener("scroll",this.scrollListener),this.scrollListener=null)},t.prototype.render=function(){var e=this,t=this.props,n=t.aspectRatio,i=t.children;return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div",{ref:function(t){return e.containerRef=t},css:{position:"relative"}},(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("video",{key:this.props.video||"no-src",poster:this.props.posterImage,ref:function(t){return e.video=t},autoPlay:this.props.autoPlay,muted:this.props.muted,controls:this.props.controls,loop:this.props.loop,className:"builder-video",css:__assign({width:"100%",height:"100%",objectFit:this.props.fit,objectPosition:this.props.position,zIndex:2,borderRadius:1},n?{position:"absolute"}:null)},(!this.lazyLoad||this.state.load)&&(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("source",{type:"video/mp4",src:this.props.video})),!n||this.props.fitContent&&i?null:(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div",{css:{width:"100%",paddingTop:100*n+"%",pointerEvents:"none",fontSize:0}}),i&&this.props.fitContent?(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div",{css:{display:"flex",flexDirection:"column",alignItems:"stretch"}},i):i?(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div",{css:{pointerEvents:"none",display:"flex",flexDirection:"column",alignItems:"stretch",position:"absolute",top:0,left:0,width:"100%",height:"100%"}},i):null)},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),Video=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.registerComponent */ .Ib.registerComponent(withChildren(VideoComponent),{name:"Video",canHaveChildren:!0,defaultStyles:{minHeight:"20px",minWidth:"20px"},image:"https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-videocam-24px%20(1).svg?alt=media&token=49a84e4a-b20e-4977-a650-047f986874bb",inputs:[{name:"video",type:"file",allowedFileTypes:["mp4"],bubble:!0,defaultValue:"https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/assets%2FKQlEmWDxA0coC3PK6UvkrjwkIGI2%2F28cb070609f546cdbe5efa20e931aa4b?alt=media&token=912e9551-7a7c-4dfb-86b6-3da1537d1a7f",required:!0},{name:"posterImage",type:"file",allowedFileTypes:["jpeg","png"],helperText:"Image to show before the video plays"},{name:"autoPlay",type:"boolean",defaultValue:!0},{name:"controls",type:"boolean",defaultValue:!1},{name:"muted",type:"boolean",defaultValue:!0},{name:"loop",type:"boolean",defaultValue:!0},{name:"playsInline",type:"boolean",defaultValue:!0},{name:"fit",type:"text",defaultValue:"cover",enum:["contain","cover","fill","auto"]},{name:"fitContent",type:"boolean",helperText:"When child blocks are provided, fit to them instead of using the aspect ratio",defaultValue:!0,advanced:!0},{name:"position",type:"text",defaultValue:"center",enum:["center","top","left","right","bottom","top left","top right","bottom left","bottom right"]},{name:"height",type:"number",advanced:!0},{name:"width",type:"number",advanced:!0},{name:"aspectRatio",type:"number",advanced:!0,defaultValue:DEFAULT_ASPECT_RATIO},{name:"lazyLoad",type:"boolean",helperText:'Load this video "lazily" - as in only when a user scrolls near the video. Recommended for optmized performance and bandwidth consumption',defaultValue:!0,advanced:!0}]}),size=function(e){return Object.keys(e).length},isShopify=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&"Shopify"in window,refs={};if(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser)try{Array.from(document.querySelectorAll("[builder-static-symbol]")).forEach((function(e){var t=e.getAttribute("builder-static-symbol");t&&(refs[t]=e)}))}catch(e){console.error("Builder replace nodes error:",e)}var SymbolComponent=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.ref=null,t.staticRef=null,t}return __extends(t,e),Object.defineProperty(t.prototype,"placeholder",{get:function(){return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div",{css:{padding:10}},"Symbols let you reuse dynamic elements across your content. Please choose a model and entry for this symbol.")},enumerable:!1,configurable:!0}),t.prototype.componentDidMount=function(){var e,t,n;this.useStatic&&this.staticRef&&refs[null===(e=this.props.builderBlock)||void 0===e?void 0:e.id]&&(null===(t=this.staticRef.parentNode)||void 0===t||t.replaceChild(refs[null===(n=this.props.builderBlock)||void 0===n?void 0:n.id],this.staticRef))},Object.defineProperty(t.prototype,"useStatic",{get:function(){var e;return Boolean(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isBrowser */ .Ib.isBrowser&&refs[null===(e=this.props.builderBlock)||void 0===e?void 0:e.id]&&!(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isPreviewing */ .Ib.isPreviewing))},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e,t=this;if(this.useStatic)return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div",{ref:function(e){return t.staticRef=e}});var n=this.props.symbol,i=!1;n||(i=!0);var r=this.props.dataOnly?NoWrap:this.props.builderBlock&&this.props.builderBlock.tagName||"div",o=n||{},a=o.model,s=o.entry,l=o.data,u=o.content,d=o.inline,c=(null==n?void 0:n.dynamic)||this.props.dynamic;a&&(s||c)||(null===(e=null==u?void 0:u.data)||void 0===e?void 0:e.blocksJs)||d||(i=!0);var p=c?void 0:[a,s].join(":"),f=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing?null:l&&size(l)&&hash_sum__WEBPACK_IMPORTED_MODULE_4___default()(l);p&&f&&f.length<300&&(p+=":"+f);var m=this.props.attributes||{};return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderStoreContext.Consumer,{key:(a||"no model")+":"+(s||"no entry")},(function(e){var o,d,c,f,h,g,v,b,y,_;return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(r,__assign({"data-model":a},m,{className:(m.class||m.className||"")+" builder-symbol"+((null==n?void 0:n.inline)?" builder-inline-symbol":"")+((null==n?void 0:n.dynamic)||t.props.dynamic?" builder-dynamic-symbol":"")}),i?t.placeholder:(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderComponent,__assign({},(null===(o=e.state)||void 0===o?void 0:o.locale)&&{locale:e.state.locale},{isChild:!0,ref:function(e){return t.ref=e},context:__assign(__assign({},e.context),{symbolId:null===(d=t.props.builderBlock)||void 0===d?void 0:d.id}),modelName:a,entry:s,data:__assign(__assign(__assign({},l),!!t.props.inheritState&&e.state),null===(b=null===(v=null===(g=null===(h=null===(f=null===(c=t.props.builderBlock)||void 0===c?void 0:c.component)||void 0===f?void 0:f.options)||void 0===h?void 0:h.symbol)||void 0===g?void 0:g.content)||void 0===v?void 0:v.data)||void 0===b?void 0:b.state),renderLink:e.renderLink,inlineContent:null==n?void 0:n.inline},u&&{content:u},{options:{key:p,noEditorUpdates:!0},codegen:!!(null===(y=null==u?void 0:u.data)||void 0===y?void 0:y.blocksJs),hydrate:null===(_=e.state)||void 0===_?void 0:_._hydrate,builderBlock:t.props.builderBlock,dataOnly:t.props.dataOnly}),t.props.children))}))},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),Symbol$1=withBuilder(SymbolComponent,{name:"Symbol",noWrap:!0,static:!0,inputs:[{name:"symbol",type:"uiSymbol"},{name:"dataOnly",helperText:"Make this a data symbol that doesn't display any UI",type:"boolean",defaultValue:!1,advanced:!0,hideFromUI:!0},{name:"inheritState",helperText:"Inherit the parent component state and data",type:"boolean",defaultValue:isShopify,advanced:!0},{name:"renderToLiquid",helperText:"Render this symbols contents to liquid. Turn off to fetch with javascript and use custom targeting",type:"boolean",defaultValue:isShopify,advanced:!0,hideFromUI:!0},{name:"useChildren",hideFromUI:!0,type:"boolean"}]}),ButtonComponent=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.render=function(){var e=this.props.link?Link:"span";return react__WEBPACK_IMPORTED_MODULE_2__.createElement(e,__assign({role:"button",href:this.props.link,target:this.props.openLinkInNewTab?"_blank":void 0},this.props.attributes),this.props.text)},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),Button=withBuilder(ButtonComponent,{name:"Core:Button",image:"https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F81a15681c3e74df09677dfc57a615b13",defaultStyles:{appearance:"none",paddingTop:"15px",paddingBottom:"15px",paddingLeft:"25px",paddingRight:"25px",backgroundColor:"#000000",color:"white",borderRadius:"4px",textAlign:"center",cursor:"pointer"},inputs:[{name:"text",type:"text",defaultValue:"Click me!",bubble:!0},{name:"link",type:"url",bubble:!0},{name:"openLinkInNewTab",type:"boolean",defaultValue:!1,friendlyName:"Open link in new tab"}],static:!0,noWrap:!0}),SectionComponent=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.ref=null,t.unmountCallbacks=[],t.state={inView:!1},t}return __extends(t,e),Object.defineProperty(t.prototype,"renderContents",{get:function(){return!0!==this.props.lazyLoad||this.state.inView},enumerable:!1,configurable:!0}),t.prototype.componentWillUnmount=function(){this.unmountCallbacks.forEach((function(e){return e()}))},t.prototype.componentDidMount=function(){var e=this;if(this.props.lazyLoad)if("undefined"!=typeof IntersectionObserver&&this.ref){var t=new IntersectionObserver((function(t,n){t.forEach((function(t){t.intersectionRatio>0&&(e.setState({inView:!0}),e.ref&&n.unobserve(e.ref))}))}),{rootMargin:"10px"});t.observe(this.ref),this.unmountCallbacks.push((function(){e.ref&&t.unobserve(e.ref)}))}else this.setState({inView:!0})},t.prototype.render=function(){var e=this;return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("section",{ref:function(t){return e.ref=t},css:__assign({width:"100%",alignSelf:"stretch",flexGrow:1,boxSizing:"border-box",maxWidth:this.props.maxWidth,display:"flex",flexDirection:"column",alignItems:"stretch",marginLeft:"auto",marginRight:"auto"},this.renderContents?null:this.props.lazyStyles)},this.renderContents?(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment,null,this.props.children,this.props.builderBlock&&this.props.builderBlock.children&&this.props.builderBlock.children.map((function(e,t){return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderBlock$1,{key:e.id,block:e})}))):null)},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),Section=withBuilder(SectionComponent,{name:"Core:Section",static:!0,image:"https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F682efef23ace49afac61748dd305c70a",inputs:[{name:"maxWidth",type:"number",defaultValue:1200},{name:"lazyLoad",type:"boolean",defaultValue:!1,advanced:!0,description:"Only render this section when in view"}],defaultStyles:{paddingLeft:"20px",paddingRight:"20px",paddingTop:"50px",paddingBottom:"50px",marginTop:"0px",width:"100vw",marginLeft:"calc(50% - 50vw)"},canHaveChildren:!0,defaultChildren:[{"@type":"@builder.io/sdk:Element",responsiveStyles:{large:{textAlign:"center"}},component:{name:"Text",options:{text:"<p><b>I am a section! My content keeps from getting too wide, so that it's easy to read even on big screens.</b></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur</p>"}}}]}),StateProviderComponent=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.render=function(){var e=this;return react__WEBPACK_IMPORTED_MODULE_2__.createElement(BuilderStoreContext.Consumer,null,(function(t){return react__WEBPACK_IMPORTED_MODULE_2__.createElement(BuilderStoreContext.Provider,{value:__assign(__assign({},t),{state:__assign(__assign({},t.state),e.props.state),context:__assign(__assign({},t.context),e.props.context)})},e.props.builderBlock&&e.props.builderBlock.children&&e.props.builderBlock.children.map((function(e,t){return react__WEBPACK_IMPORTED_MODULE_2__.createElement(BuilderBlock$1,{block:e,key:e.id,index:t,child:!0})})),e.props.children)}))},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),StateProvider=withBuilder(StateProviderComponent,{name:"Builder:StateProvider",canHaveChildren:!0,static:!0,noWrap:!0,hideFromInsertMenu:!0}),prefetched=new Set;function searchToObject(e){var t=(e.search||"").substring(1).split("&"),n={};for(var i in t)if(t[i]&&"string"==typeof t[i]){var r=t[i].split("=");n[decodeURIComponent(r[0])]=decodeURIComponent(r[1])}return n}var RouterComponent=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.builder=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder */ .fl,t.routed=!1,t.preloadQueue=0,t.onPopState=function(e){t.updateLocationState()},t.onMouseOverOrTouchStart=function(e){if(!(t.preloadQueue>4)&&!1!==t.props.preloadOnHover){var n=t.findHrefTarget(e);if(n){var i=n.getAttribute("href");if(i){if(!t.isRelative(i)){var r=t.convertToRelative(i);if(!r)return;i=r}if(!i.startsWith("#")&&!prefetched.has(i)){prefetched.add(i);var o=t.parseUrl(i);t.preloadQueue++;var a=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.getUserAttributes */ .fl.getUserAttributes();a.urlPath=o.pathname,a.queryString=o.search;var s=_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.get */ .fl.get(t.model,{userAttributes:a,key:t.model+":"+o.pathname+o.search}).subscribe((function(){t.preloadQueue--,s.unsubscribe()}))}}}}},t.onClick=function(e){return __awaiter(t,void 0,void 0,(function(){var t,n,i,r;return __generator(this,(function(o){if(!1===this.props.handleRouting)return[2];if(0!==e.button||e.ctrlKey||e.defaultPrevented||e.metaKey)return[2];if(!(t=this.findHrefTarget(e)))return[2];if(t.target&&"_client"!==t.target)return[2];if(!(n=t.getAttribute("href")))return[2];if(this.props.onRoute&&(i={url:n,anchorNode:t,preventDefault:function(){this.defaultPrevented=!0},defaultPrevented:!1},this.props.onRoute(i),i.defaultPrevented))return[2];if(!this.isRelative(n)){if(!(r=this.convertToRelative(n)))return[2];n=r}return n.startsWith("#")||(e.preventDefault(),this.route(n)),[2]}))}))},t.privateState=null,t}return __extends(t,e),t.prototype.route=function(e){var t;return this.routed=!0,"function"==typeof(null===(t=window.history)||void 0===t?void 0:t.pushState)?(history.pushState(null,"",e),this.updateLocationState(),!0):(location.href=e,!1)},t.prototype.updateLocationState=function(){this.privateState&&this.privateState.update((function(e){e.location=__assign(__assign({},e.location),{pathname:location.pathname,search:location.search,path:location.pathname.split("/").slice(1),query:searchToObject(location)})}))},Object.defineProperty(t.prototype,"model",{get:function(){return this.props.model||"page"},enumerable:!1,configurable:!0}),t.prototype.componentDidMount=function(){"undefined"!=typeof document&&(document.addEventListener("click",this.onClick),window.addEventListener("popstate",this.onPopState),document.addEventListener("mouseover",this.onMouseOverOrTouchStart),document.addEventListener("touchstart",this.onMouseOverOrTouchStart))},t.prototype.componentWillUnmount=function(){"undefined"!=typeof document&&(document.removeEventListener("click",this.onClick),document.removeEventListener("mouseover",this.onMouseOverOrTouchStart),window.removeEventListener("popstate",this.onPopState),document.removeEventListener("touchstart",this.onMouseOverOrTouchStart))},t.prototype.render=function(){var e=this,t=this.model;return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderStoreContext.Consumer,null,(function(n){e.privateState=n;var i=n.state&&n.state.location&&n.state.location.pathname+n.state.location.search;return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div",{className:"builder-router","data-model":t},(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("style",null,"\n                @keyframes builderLoadingSpinner {\n                  0% {\n                    transform: rotate(0deg);\n                  }\n                  100% {\n                    transform: rotate(360deg);\n                  }\n                }\n                /* TODO: overridable tag */\n                .builder-page-loading {\n                  -webkit-animation: builderLoadingSpinner 1s infinite linear;\n                  animation: builderLoadingSpinner 1s infinite linear;\n                  -webkit-transform: translateZ(0);\n                  transform: translateZ(0);\n                  border-radius: 50%;\n                  width: 36px;\n                  height: 36px;\n                  margin: 6px auto;\n                  position: relative;\n                  border: 1px solid transparent;\n                  border-left: 1px solid #808284;\n                }\n              "),(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderComponent,{key:i,data:e.props.data,content:e.routed?void 0:e.props.content,modelName:t,options:{key:_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing?void 0:e.model+":"+i}},e.props.children||(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div",{css:{display:"flex"}},(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div",{css:{margin:"40vh auto"},className:"builder-page-loading"}))))}))},t.prototype.findHrefTarget=function(e){for(var t=e.target;t;){if(t instanceof HTMLAnchorElement&&t.getAttribute("href"))return t;if(t===e.currentTarget)break;t=t.parentElement}return null},t.prototype.isRelative=function(e){return!e.match(/^(\/\/|https?:\/\/)/i)},t.prototype.parseUrl=function(e){var t=document.createElement("a");return t.href=e,t},t.prototype.convertToRelative=function(e){var t=this.parseUrl(location.href),n=this.parseUrl(e);if(t.host===n.host){var i=n.pathname+(n.search?n.search:"");return i.startsWith("#")?null:i||"/"}return null},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),Router=withBuilder(RouterComponent,{name:"Core:Router",hideFromInsertMenu:!0,inputs:[{name:"model",type:"string",defaultValue:"page",advanced:!0},{name:"handleRouting",type:"boolean",defaultValue:!0,advanced:!0},{name:"preloadOnHover",type:"boolean",defaultValue:!0,advanced:!0},{name:"onRoute",type:"function",advanced:!0}]});function Mutation(e){var t,n,i=react__WEBPACK_IMPORTED_MODULE_2__.useRef(null);useWaitForSelector(e.selector,(function(t){"afterEnd"!==e.type&&(t.innerHTML=""),t.appendChild(i.current.firstElementChild)}));var r=null===(t=e.builderBlock)||void 0===t?void 0:t.children;return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span",{style:{display:"none"},ref:i},(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderBlocks,{style:{display:"inline"},child:!0,parentElementId:null===(n=e.builderBlock)||void 0===n?void 0:n.id,dataPath:"this.children",blocks:r}))}function useWaitForSelector(e,t){react__WEBPACK_IMPORTED_MODULE_2__.useLayoutEffect((function(){try{var n=document.querySelector(e);if(n)return void t(n)}catch(e){console.warn(e)}var i=new MutationObserver((function(){try{var n=document.querySelector(e);n&&(i.disconnect(),t(n))}catch(e){console.warn(e)}}));return i.observe(document.body,{attributes:!0,subtree:!0,characterData:!0}),function(){i.disconnect()}}),[e])}_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.registerComponent */ .Ib.registerComponent(Mutation,{name:"Builder:Mutation",canHaveChildren:!0,noWrap:!0,hideFromInsertMenu:!0,inputs:[{name:"type",type:"string",defaultValue:"replace",enum:[{label:"Replace",value:"replace",helperText:"Replace the contents of this site region with content from Builder"},{label:"Append",value:"afterEnd",helperText:"Append Builder content after the chosen site region"}]},{name:"selector",type:"builder:domSelector"}]});var get=function(e,t,n){var i=String.prototype.split.call(t,/[,[\].]+?/).filter(Boolean).reduce((function(e,t){return null!=e?e[t]:e}),e);return void 0===i||i===e?n:i},MULTIPART_CONTENT_TYPE="multipart/form-data",JSON_CONTENT_TYPE="application/json",ENCODED_CONTENT_TYPE="application/x-www-form-urlencoded",FormComponent=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.ref=null,t.state={state:"unsubmitted",responseData:null,formErrorMessage:""},t}return __extends(t,e),Object.defineProperty(t.prototype,"submissionState",{get:function(){return _builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&this.props.previewState||this.state.state},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderStoreContext.Consumer,null,(function(t){return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderStoreContext.Provider,{value:__assign(__assign({},t),{state:__assign(__assign({},t.state),{formErrorMessage:e.state.formErrorMessage})})},(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("form",__assign({validate:e.props.validate,ref:function(t){return e.ref=t},action:!e.props.sendWithJs&&e.props.action,method:e.props.method,name:e.props.name,onSubmit:function(t){var n,i=e.props.sendWithJs||"email"===e.props.sendSubmissionsTo;if("zapier"===e.props.sendSubmissionsTo)t.preventDefault();else if(i){if(!e.props.action&&"email"!==e.props.sendSubmissionsTo)return void t.preventDefault();t.preventDefault();var r=t.currentTarget,o=e.props.customHeaders||{},a=void 0,s=new FormData(r),l=Array.from(t.currentTarget.querySelectorAll("input,select,textarea")).filter((function(e){return!!e.name})).map((function(e){var t,n=e.name;if(e instanceof HTMLInputElement)if("radio"===e.type){if(e.checked)return{key:n,value:t=e.name}}else if("checkbox"===e.type)t=e.checked;else if("number"===e.type||"range"===e.type){var i=e.valueAsNumber;isNaN(i)||(t=i)}else t="file"===e.type?e.files:e.value;else t=e.value;return{key:n,value:t}})),u=e.props.contentType;if("email"===e.props.sendSubmissionsTo&&(u=MULTIPART_CONTENT_TYPE),Array.from(l).forEach((function(e){var t=e.value;(t instanceof File||Array.isArray(t)&&t[0]instanceof File||t instanceof FileList)&&(u=MULTIPART_CONTENT_TYPE)})),u===MULTIPART_CONTENT_TYPE)a=s;else if(u===JSON_CONTENT_TYPE){var d={};Array.from(l).forEach((function(e){var t=e.value,n=e.key;set(d,n,t)})),a=JSON.stringify(d)}else{if(u!==ENCODED_CONTENT_TYPE)return void console.error("Unsupported content type: ",u);a=Array.from(l).map((function(e){var t=e.value,n=e.key;return encodeURIComponent(n)+"="+encodeURIComponent(t)})).join("&")}u&&u!==MULTIPART_CONTENT_TYPE&&(i&&(null===(n=e.props.action)||void 0===n?void 0:n.includes("zapier.com"))||(o["content-type"]=u));var c=new CustomEvent("presubmit",{detail:{body:a}});if(e.ref&&(e.ref.dispatchEvent(c),c.defaultPrevented))return;e.setState(__assign(__assign({},e.state),{state:"sending"}));var p="".concat("dev"===_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.env */ .fl.env?"http://localhost:5000":"https://builder.io","/api/v1/form-submit?apiKey=").concat(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .builder.apiKey */ .fl.apiKey,"&to=").concat(btoa(e.props.sendSubmissionsToEmail||""),"&name=").concat(encodeURIComponent(e.props.name||""));fetch("email"===e.props.sendSubmissionsTo?p:e.props.action,{body:a,headers:o,method:e.props.method||"post"}).then((function(t){return __awaiter(e,void 0,void 0,(function(){var e,n,i,r,o;return __generator(this,(function(a){switch(a.label){case 0:return(n=t.headers.get("content-type"))&&-1!==n.indexOf(JSON_CONTENT_TYPE)?[4,t.json()]:[3,2];case 1:return e=a.sent(),[3,4];case 2:return[4,t.text()];case 3:e=a.sent(),a.label=4;case 4:if(!t.ok&&this.props.errorMessagePath&&(i=get(e,this.props.errorMessagePath))&&("string"!=typeof i&&(i=JSON.stringify(i)),this.setState(__assign(__assign({},this.state),{formErrorMessage:i}))),this.setState(__assign(__assign({},this.state),{responseData:e,state:t.ok?"success":"error"})),t.ok){if(r=new CustomEvent("submit:success",{detail:{res:t,body:e}}),this.ref){if(this.ref.dispatchEvent(r),r.defaultPrevented)return[2];!1!==this.props.resetFormOnSubmit&&this.ref.reset()}this.props.successUrl&&(this.ref?(o=new CustomEvent("route",{detail:{url:this.props.successUrl}}),this.ref.dispatchEvent(o),o.defaultPrevented||(location.href=this.props.successUrl)):location.href=this.props.successUrl)}return[2]}}))}))}),(function(t){var n=new CustomEvent("submit:error",{detail:{error:t}});e.ref&&(e.ref.dispatchEvent(n),n.defaultPrevented)||e.setState(__assign(__assign({},e.state),{responseData:t,state:"error"}))}))}}},e.props.attributes),e.props.builderBlock&&e.props.builderBlock.children&&e.props.builderBlock.children.map((function(e,t){return (0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderBlock$1,{key:e.id,block:e})})),"error"===e.submissionState&&(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderBlocks,{dataPath:"errorMessage",blocks:e.props.errorMessage}),"sending"===e.submissionState&&(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderBlocks,{dataPath:"sendingMessage",blocks:e.props.sendingMessage}),"error"===e.submissionState&&e.state.responseData&&(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("pre",{className:"builder-form-error-text",css:{padding:10,color:"red",textAlign:"center"}},JSON.stringify(e.state.responseData,null,2)),"success"===e.submissionState&&(0,_emotion_core__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(BuilderBlocks,{dataPath:"successMessage",blocks:e.props.successMessage})))}))},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),Form=withBuilder(FormComponent,{name:"Form:Form",defaults:{responsiveStyles:{large:{marginTop:"15px",paddingBottom:"15px"}}},image:"https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Fef36d2a846134910b64b88e6d18c5ca5",inputs:[{name:"sendSubmissionsTo",type:"string",enum:[{label:"Send to email",value:"email",helperText:"Send form submissions to the email address of your choosing"},{label:"Custom",value:"custom",helperText:"Handle where the form requests go manually with a little code, e.g. to your own custom backend"}],defaultValue:"email"},{name:"sendSubmissionsToEmail",type:"string",required:!0,defaultValue:"your@email.com",showIf:'options.get("sendSubmissionsTo") === "email"'},{name:"sendWithJs",type:"boolean",helperText:"Set to false to use basic html form action",defaultValue:!0,showIf:'options.get("sendSubmissionsTo") === "custom"'},{name:"name",type:"string",defaultValue:"My form"},{name:"action",type:"string",helperText:"URL to send the form data to",showIf:'options.get("sendSubmissionsTo") === "custom"'},{name:"contentType",type:"string",defaultValue:JSON_CONTENT_TYPE,advanced:!0,enum:[JSON_CONTENT_TYPE,MULTIPART_CONTENT_TYPE,ENCODED_CONTENT_TYPE],showIf:'options.get("sendSubmissionsTo") === "custom" && options.get("sendWithJs") === true'},{name:"method",type:"string",showIf:'options.get("sendSubmissionsTo") === "custom"',defaultValue:"POST",advanced:!0},{name:"previewState",type:"string",enum:["unsubmitted","sending","success","error"],defaultValue:"unsubmitted",helperText:'Choose a state to edit, e.g. choose "success" to show what users see on success and edit the message',showIf:'options.get("sendSubmissionsTo") !== "zapier" && options.get("sendWithJs") === true'},{name:"successUrl",type:"url",helperText:"Optional URL to redirect the user to on form submission success",showIf:'options.get("sendSubmissionsTo") !== "zapier" && options.get("sendWithJs") === true'},{name:"resetFormOnSubmit",type:"boolean",showIf:function(e){return"custom"===e.get("sendSubmissionsTo")&&!0===e.get("sendWithJs")},advanced:!0},{name:"successMessage",type:"uiBlocks",hideFromUI:!0,defaultValue:[{"@type":"@builder.io/sdk:Element",responsiveStyles:{large:{marginTop:"10px"}},component:{name:"Text",options:{text:"<span>Thanks!</span>"}}}]},{name:"validate",type:"boolean",defaultValue:!0,advanced:!0},{name:"errorMessagePath",type:"text",advanced:!0,helperText:'Path to where to get the error message from in a JSON response to display to the user, e.g. "error.message" for a response like { "error": { "message": "this username is taken" }}'},{name:"errorMessage",type:"uiBlocks",hideFromUI:!0,defaultValue:[{"@type":"@builder.io/sdk:Element",responsiveStyles:{large:{marginTop:"10px"}},bindings:{"component.options.text":"state.formErrorMessage || block.component.options.text"},component:{name:"Text",options:{text:"<span>Form submission error :( Please check your answers and try again</span>"}}}]},{name:"sendingMessage",type:"uiBlocks",hideFromUI:!0,defaultValue:[{"@type":"@builder.io/sdk:Element",responsiveStyles:{large:{marginTop:"10px"}},component:{name:"Text",options:{text:"<span>Sending...</span>"}}}]},__assign(__assign({name:"customHeaders",type:"map"},{valueType:{type:"string"}}),{advanced:!0,showIf:'options.get("sendSubmissionsTo") === "custom" && options.get("sendWithJs") === true'})],noWrap:!0,canHaveChildren:!0,defaultChildren:[{"@type":"@builder.io/sdk:Element",responsiveStyles:{large:{marginTop:"10px"}},component:{name:"Text",options:{text:"<span>Enter your name</span>"}}},{"@type":"@builder.io/sdk:Element",responsiveStyles:{large:{marginTop:"10px"}},component:{name:"Form:Input",options:{name:"name",placeholder:"Jane Doe"}}},{"@type":"@builder.io/sdk:Element",responsiveStyles:{large:{marginTop:"10px"}},component:{name:"Text",options:{text:"<span>Enter your email</span>"}}},{"@type":"@builder.io/sdk:Element",responsiveStyles:{large:{marginTop:"10px"}},component:{name:"Form:Input",options:{name:"email",placeholder:"jane@doe.com"}}},{"@type":"@builder.io/sdk:Element",responsiveStyles:{large:{marginTop:"10px"}},component:{name:"Form:SubmitButton",options:{text:"Submit"}}}]}),FormInputComponent=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.render=function(){return react__WEBPACK_IMPORTED_MODULE_2__.createElement("input",__assign({key:_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&this.props.defaultValue?this.props.defaultValue:"default-key",placeholder:this.props.placeholder,type:this.props.type,name:this.props.name,value:this.props.value,defaultValue:this.props.defaultValue,required:this.props.required},this.props.attributes))},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),FormInput=withBuilder(FormInputComponent,{name:"Form:Input",image:"https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Fad6f37889d9e40bbbbc72cdb5875d6ca",inputs:[{name:"type",type:"text",enum:["text","number","email","url","checkbox","radio","range","date","datetime-local","search","tel","time","file","month","week","password","color","hidden"],defaultValue:"text"},{name:"name",type:"string",required:!0,helperText:'Every input in a form needs a unique name describing what it takes, e.g. "email"'},{name:"placeholder",type:"string",defaultValue:"Hello there",helperText:"Text to display when there is no value"},{name:"defaultValue",type:"string"},{name:"value",type:"string",advanced:!0},{name:"required",type:"boolean",helperText:"Is this input required to be filled out to submit a form",defaultValue:!1}],noWrap:!0,static:!0,defaultStyles:{paddingTop:"10px",paddingBottom:"10px",paddingLeft:"10px",paddingRight:"10px",borderRadius:"3px",borderWidth:"1px",borderStyle:"solid",borderColor:"#ccc"}}),FormSubmitButtonComponent=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.render=function(){return react__WEBPACK_IMPORTED_MODULE_2__.createElement("button",__assign({type:"submit"},this.props.attributes),this.props.text)},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),FormSubmitButton=withBuilder(FormSubmitButtonComponent,{name:"Form:SubmitButton",image:"https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Fdf2820ffed1f4349a94c40b3221f5b98",defaultStyles:{appearance:"none",paddingTop:"15px",paddingBottom:"15px",paddingLeft:"25px",paddingRight:"25px",backgroundColor:"#3898EC",color:"white",borderRadius:"4px",cursor:"pointer"},inputs:[{name:"text",type:"text",defaultValue:"Click me"}],static:!0,noWrap:!0}),LabelComponent=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.render=function(){return react__WEBPACK_IMPORTED_MODULE_2__.createElement("label",__assign({htmlFor:this.props.for},this.props.attributes),this.props.text&&react__WEBPACK_IMPORTED_MODULE_2__.createElement("span",{className:"builder-label-text",dangerouslySetInnerHTML:{__html:this.props.text}}),this.props.builderBlock&&this.props.builderBlock.children&&this.props.builderBlock.children.map((function(e){return react__WEBPACK_IMPORTED_MODULE_2__.createElement(BuilderBlock$1,{key:e.id,block:e})})))},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),Label=withBuilder(LabelComponent,{name:"Form:Label",image:"https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F9322342f04b545fb9a8091cd801dfb5b",inputs:[{name:"text",type:"html",richText:!0,defaultValue:"Label"},{name:"for",type:"text",helperText:"The name of the input this label is for",advanced:!0}],noWrap:!0,static:!0,canHaveChildren:!0}),FormSelectComponent=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.render=function(){var e=this.props.options;return react__WEBPACK_IMPORTED_MODULE_2__.createElement("select",__assign({value:this.props.value,key:_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing&&this.props.defaultValue?this.props.defaultValue:"default-key",defaultValue:this.props.defaultValue,name:this.props.name},this.props.attributes),e&&e.map((function(e){return react__WEBPACK_IMPORTED_MODULE_2__.createElement("option",{value:e.value},e.name||e.value)})))},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),FormSelect=withBuilder(FormSelectComponent,{name:"Form:Select",image:"https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F83acca093fb24aaf94dee136e9a4b045",defaultStyles:{alignSelf:"flex-start"},inputs:[{name:"options",type:"list",required:!0,subFields:[{name:"value",type:"text",required:!0},{name:"name",type:"text"}],defaultValue:[{value:"option 1"},{value:"option 2"}]},{name:"name",type:"string",required:!0,helperText:'Every select in a form needs a unique name describing what it gets, e.g. "email"'},{name:"defaultValue",type:"string"},{name:"value",type:"string",advanced:!0},{name:"required",type:"boolean",defaultValue:!1}],static:!0,noWrap:!0}),TextAreaComponent=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.render=function(){return react__WEBPACK_IMPORTED_MODULE_2__.createElement("textarea",__assign({placeholder:this.props.placeholder,name:this.props.name,value:this.props.value,defaultValue:this.props.defaultValue},this.props.attributes))},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),TextArea=withBuilder(TextAreaComponent,{name:"Form:TextArea",image:"https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Ff74a2f3de58c4c3e939204e5b6b8f6c3",inputs:[{advanced:!0,name:"value",type:"string"},{name:"name",type:"string",required:!0,helperText:'Every input in a form needs a unique name describing what it gets, e.g. "email"'},{name:"defaultValue",type:"string"},{name:"placeholder",type:"string",defaultValue:"Hello there"},{name:"required",type:"boolean",defaultValue:!1}],defaultStyles:{paddingTop:"10px",paddingBottom:"10px",paddingLeft:"10px",paddingRight:"10px",borderRadius:"3px",borderWidth:"1px",borderStyle:"solid",borderColor:"#ccc"},static:!0,noWrap:!0}),ImgComponent=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.render=function(){var e=this.props.attributes||{};return react__WEBPACK_IMPORTED_MODULE_2__.createElement("img",__assign({},this.props.attributes,{src:this.props.image||e.src}))},t}(react__WEBPACK_IMPORTED_MODULE_2__.Component),Img=withBuilder(ImgComponent,{name:"Raw:Img",hideFromInsertMenu:!0,image:"https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-insert_photo-24px.svg?alt=media&token=4e5d0ef4-f5e8-4e57-b3a9-38d63a9b9dc4",inputs:[{name:"image",bubble:!0,type:"file",allowedFileTypes:["jpeg","jpg","png","svg"],required:!0}],noWrap:!0,static:!0}),RawText=function(e){var t=e.attributes||{};return react__WEBPACK_IMPORTED_MODULE_2__.createElement("span",{className:(null==t?void 0:t.class)||(null==t?void 0:t.className),dangerouslySetInnerHTML:{__html:e.text||""}})};function useIsPreviewing(){var e=(0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(!1),t=e[0],n=e[1];return (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)((function(){(_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isEditing */ .Ib.isEditing||_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isPreviewing */ .Ib.isPreviewing)&&n(!0)}),[]),t}_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.registerComponent */ .Ib.registerComponent(RawText,{name:"Builder:RawText",hideFromInsertMenu:!0,inputs:[{name:"text",bubble:!0,type:"longText",required:!0}]}),_builder_io_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Builder.isReact */ .Ib.isReact=!0;
//# sourceMappingURL=builder-react.es5.js.map


/***/ }),

/***/ 11183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ib": function() { return /* binding */ Builder; },
/* harmony export */   "Xe": function() { return /* binding */ BehaviorSubject; },
/* harmony export */   "fl": function() { return /* binding */ builder; },
/* harmony export */   "w0": function() { return /* binding */ Subscription; }
/* harmony export */ });
/* unused harmony exports BuilderComponent, isBrowser */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56385);
/* harmony import */ var hash_sum__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94915);
/* harmony import */ var hash_sum__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(hash_sum__WEBPACK_IMPORTED_MODULE_0__);



(function () {
  if (typeof window === 'undefined' || typeof window.CustomEvent === 'function') return false;

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: null };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  window.CustomEvent = CustomEvent;
})();

var isSafari = typeof window !== 'undefined' &&
    /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);
// TODO: queue all of these in a debounceNextTick
function nextTick(fn) {
    // React native
    if (typeof setImmediate === 'function' && typeof window === 'undefined') {
        return setImmediate(fn);
    }
    // TODO: should this be setImmediate instead? Forgot if that is micro or macro task
    // TODO: detect specifically if is server
    // if (typeof process !== 'undefined' && process.nextTick) {
    //   console.log('process.nextTick?');
    //   process.nextTick(fn);
    //   return;
    // }
    // FIXME: fix the real safari issue of this randomly not working
    if (isSafari || typeof MutationObserver === 'undefined') {
        setTimeout(fn);
        return;
    }
    var called = 0;
    var observer = new MutationObserver(function () { return fn(); });
    var element = document.createTextNode('');
    observer.observe(element, {
        characterData: true,
    });
    // tslint:disable-next-line
    element.data = String((called = ++called));
}

var PROPERTY_NAME_DENY_LIST = Object.freeze(['__proto__', 'prototype', 'constructor']);
// TODO: unit tests
var QueryString = /** @class */ (function () {
    function QueryString() {
    }
    QueryString.parseDeep = function (queryString) {
        var obj = this.parse(queryString);
        return this.deepen(obj);
    };
    QueryString.stringifyDeep = function (obj) {
        var map = this.flatten(obj);
        return this.stringify(map);
    };
    QueryString.parse = function (queryString) {
        var query = {};
        var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
        for (var i = 0; i < pairs.length; i++) {
            var pair = pairs[i].split('=');
            // TODO: node support?
            try {
                query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
            }
            catch (error) {
                // Ignore malformed URI components
            }
        }
        return query;
    };
    QueryString.stringify = function (map) {
        var str = '';
        for (var key in map) {
            if (map.hasOwnProperty(key)) {
                var value = map[key];
                if (str) {
                    str += '&';
                }
                str += encodeURIComponent(key) + '=' + encodeURIComponent(value);
            }
        }
        return str;
    };
    QueryString.deepen = function (map) {
        // FIXME; Should be type Tree = Record<string, string | Tree>
        // requires a typescript upgrade.
        var output = {};
        for (var k in map) {
            var t = output;
            var parts = k.split('.');
            var key = parts.pop();
            for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
                var part = parts_1[_i];
                assertAllowedPropertyName(part);
                t = t[part] = t[part] || {};
            }
            t[key] = map[k];
        }
        return output;
    };
    QueryString.flatten = function (obj, _current, _res) {
        if (_res === void 0) { _res = {}; }
        for (var key in obj) {
            var value = obj[key];
            var newKey = _current ? _current + '.' + key : key;
            if (value && typeof value === 'object') {
                this.flatten(value, newKey, _res);
            }
            else {
                _res[newKey] = value;
            }
        }
        return _res;
    };
    return QueryString;
}());
function assertAllowedPropertyName(name) {
    if (PROPERTY_NAME_DENY_LIST.indexOf(name) >= 0)
        throw new Error("Property name \"".concat(name, "\" is not allowed"));
}

var version = "1.1.30-1";

var Subscription = /** @class */ (function () {
    function Subscription(listeners, listener) {
        this.listeners = listeners;
        this.listener = listener;
        this.unsubscribed = false;
        this.otherSubscriptions = [];
    }
    Object.defineProperty(Subscription.prototype, "closed", {
        get: function () {
            return this.unsubscribed;
        },
        enumerable: false,
        configurable: true
    });
    Subscription.prototype.add = function (subscription) {
        this.otherSubscriptions.push(subscription);
    };
    Subscription.prototype.unsubscribe = function () {
        if (this.unsubscribed) {
            return;
        }
        if (this.listener && this.listeners) {
            var index = this.listeners.indexOf(this.listener);
            if (index > -1) {
                this.listeners.splice(index, 1);
            }
        }
        this.otherSubscriptions.forEach(function (sub) { return sub.unsubscribe(); });
        this.unsubscribed = true;
    };
    return Subscription;
}());
// TODO: follow minimal basic spec: https://github.com/tc39/proposal-observable
var BehaviorSubject = /** @class */ (function () {
    function BehaviorSubject(value) {
        this.value = value;
        this.listeners = [];
        this.errorListeners = [];
    }
    BehaviorSubject.prototype.next = function (value) {
        this.value = value;
        for (var _i = 0, _a = this.listeners; _i < _a.length; _i++) {
            var listener = _a[_i];
            listener(value);
        }
    };
    // TODO: implement this as PIPE instead
    BehaviorSubject.prototype.map = function (fn) {
        var newSubject = new BehaviorSubject(fn(this.value));
        // TODO: on destroy delete these
        this.subscribe(function (val) {
            newSubject.next(fn(val));
        });
        this.catch(function (err) {
            newSubject.error(err);
        });
        return newSubject;
    };
    BehaviorSubject.prototype.catch = function (errorListener) {
        this.errorListeners.push(errorListener);
        return new Subscription(this.errorListeners, errorListener);
    };
    BehaviorSubject.prototype.error = function (error) {
        for (var _i = 0, _a = this.errorListeners; _i < _a.length; _i++) {
            var listener = _a[_i];
            listener(error);
        }
    };
    BehaviorSubject.prototype.subscribe = function (listener, errorListener) {
        this.listeners.push(listener);
        if (errorListener) {
            this.errorListeners.push(errorListener);
        }
        return new Subscription(this.listeners, listener);
    };
    BehaviorSubject.prototype.toPromise = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var subscription = _this.subscribe(function (value) {
                resolve(value);
                subscription.unsubscribe();
            }, function (err) {
                reject(err);
                subscription.unsubscribe();
            });
        });
    };
    BehaviorSubject.prototype.promise = function () {
        return this.toPromise();
    };
    return BehaviorSubject;
}());

var State = {
    Pending: 'Pending',
    Fulfilled: 'Fulfilled',
    Rejected: 'Rejected',
};
function isFunction(val) {
    return val && typeof val === 'function';
}
function isObject(val) {
    return val && typeof val === 'object';
}
var TinyPromise = /** @class */ (function () {
    function TinyPromise(executor) {
        this._state = State.Pending;
        this._handlers = [];
        this._value = null;
        executor(this._resolve.bind(this), this._reject.bind(this));
    }
    TinyPromise.prototype._resolve = function (x) {
        var _this = this;
        if (x instanceof TinyPromise) {
            x.then(this._resolve.bind(this), this._reject.bind(this));
        }
        else if (isObject(x) || isFunction(x)) {
            var called_1 = false;
            try {
                var thenable = x.then;
                if (isFunction(thenable)) {
                    thenable.call(x, function (result) {
                        if (!called_1)
                            _this._resolve(result);
                        called_1 = true;
                        return undefined;
                    }, function (error) {
                        if (!called_1)
                            _this._reject(error);
                        called_1 = true;
                        return undefined;
                    });
                }
                else {
                    this._fulfill(x);
                }
            }
            catch (ex) {
                if (!called_1) {
                    this._reject(ex);
                }
            }
        }
        else {
            this._fulfill(x);
        }
    };
    TinyPromise.prototype._fulfill = function (result) {
        var _this = this;
        this._state = State.Fulfilled;
        this._value = result;
        this._handlers.forEach(function (handler) { return _this._callHandler(handler); });
    };
    TinyPromise.prototype._reject = function (error) {
        var _this = this;
        this._state = State.Rejected;
        this._value = error;
        this._handlers.forEach(function (handler) { return _this._callHandler(handler); });
    };
    TinyPromise.prototype._isPending = function () {
        return this._state === State.Pending;
    };
    TinyPromise.prototype._isFulfilled = function () {
        return this._state === State.Fulfilled;
    };
    TinyPromise.prototype._isRejected = function () {
        return this._state === State.Rejected;
    };
    TinyPromise.prototype._addHandler = function (onFulfilled, onRejected) {
        this._handlers.push({
            onFulfilled: onFulfilled,
            onRejected: onRejected,
        });
    };
    TinyPromise.prototype._callHandler = function (handler) {
        if (this._isFulfilled() && isFunction(handler.onFulfilled)) {
            handler.onFulfilled(this._value);
        }
        else if (this._isRejected() && isFunction(handler.onRejected)) {
            handler.onRejected(this._value);
        }
    };
    TinyPromise.prototype.then = function (onFulfilled, onRejected) {
        var _this = this;
        switch (this._state) {
            case State.Pending: {
                return new TinyPromise(function (resolve, reject) {
                    _this._addHandler(function (value) {
                        nextTick(function () {
                            try {
                                if (isFunction(onFulfilled)) {
                                    resolve(onFulfilled(value));
                                }
                                else {
                                    resolve(value);
                                }
                            }
                            catch (ex) {
                                reject(ex);
                            }
                        });
                    }, function (error) {
                        nextTick(function () {
                            try {
                                if (isFunction(onRejected)) {
                                    resolve(onRejected(error));
                                }
                                else {
                                    reject(error);
                                }
                            }
                            catch (ex) {
                                reject(ex);
                            }
                        });
                    });
                });
            }
            case State.Fulfilled: {
                return new TinyPromise(function (resolve, reject) {
                    nextTick(function () {
                        try {
                            if (isFunction(onFulfilled)) {
                                resolve(onFulfilled(_this._value));
                            }
                            else {
                                resolve(_this._value);
                            }
                        }
                        catch (ex) {
                            reject(ex);
                        }
                    });
                });
            }
            case State.Rejected: {
                return new TinyPromise(function (resolve, reject) {
                    nextTick(function () {
                        try {
                            if (isFunction(onRejected)) {
                                resolve(onRejected(_this._value));
                            }
                            else {
                                reject(_this._value);
                            }
                        }
                        catch (ex) {
                            reject(ex);
                        }
                    });
                });
            }
        }
    };
    return TinyPromise;
}());
var Promise$1 = (typeof Promise !== 'undefined' ? Promise : TinyPromise);

// Webpack workaround to conditionally require certain external modules
// only on the server and not bundle them on the client
var serverOnlyRequire;
try {
    // tslint:disable-next-line:no-eval
    serverOnlyRequire = eval('require');
}
catch (err) {
    // all good
    serverOnlyRequire = (function () { return null; });
}
var serverOnlyRequire$1 = serverOnlyRequire;

function promiseResolve(value) {
    return new Promise$1(function (resolve) { return resolve(value); });
}
// Adapted from https://raw.githubusercontent.com/developit/unfetch/master/src/index.mjs
function tinyFetch(url, options) {
    if (options === void 0) { options = {}; }
    return new Promise$1(function (resolve, reject) {
        var request = new XMLHttpRequest();
        request.open(options.method || 'get', url, true);
        if (options.headers) {
            for (var i in options.headers) {
                request.setRequestHeader(i, options.headers[i]);
            }
        }
        request.withCredentials = options.credentials === 'include';
        request.onload = function () {
            resolve(response());
        };
        request.onerror = reject;
        request.send(options.body);
        function response() {
            var keys = [];
            var all = [];
            var headers = {};
            var header = undefined;
            request
                .getAllResponseHeaders()
                .replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function (_match, _key, value) {
                var key = _key;
                keys.push((key = key.toLowerCase()));
                all.push([key, value]);
                header = headers[key];
                headers[key] = header ? "".concat(header, ",").concat(value) : value;
                return '';
            });
            return {
                ok: ((request.status / 100) | 0) === 2,
                status: request.status,
                statusText: request.statusText,
                url: request.responseURL,
                clone: response,
                text: function () { return promiseResolve(request.responseText); },
                json: function () { return promiseResolve(request.responseText).then(JSON.parse); },
                blob: function () { return promiseResolve(new Blob([request.response])); },
                headers: {
                    keys: function () { return keys; },
                    entries: function () { return all; },
                    get: function (n) { return headers[n.toLowerCase()]; },
                    has: function (n) { return n.toLowerCase() in headers; },
                },
            };
        }
    });
}
var fetch;
// If fetch is defined, in the browser, via polyfill, or in a Cloudflare worker, use it.
if (globalThis.fetch) {
    fetch = globalThis.fetch;
}
// If fetch is not defined, in a Node.js environment, use node-fetch.
if (typeof window === 'undefined') {
    fetch !== null && fetch !== void 0 ? fetch : (fetch = serverOnlyRequire$1('node-fetch'));
}
// Otherwise, use tiny-fetch.
fetch !== null && fetch !== void 0 ? fetch : (fetch = tinyFetch);

function assign(target) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var to = Object(target);
    for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];
        if (nextSource != null) {
            // Skip over if undefined or null
            for (var nextKey in nextSource) {
                // Avoid bugs when hasOwnProperty is shadowed
                if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                    to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}

function throttle(func, wait, options) {
    if (options === void 0) { options = {}; }
    var context;
    var args;
    var result;
    var timeout = null;
    var previous = 0;
    var later = function () {
        previous = options.leading === false ? 0 : Date.now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout)
            context = args = null;
    };
    return function () {
        var now = Date.now();
        if (!previous && options.leading === false)
            previous = now;
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = func.apply(context, args);
            if (!timeout)
                context = args = null;
        }
        else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(later, remaining);
        }
        return result;
    };
}

var camelCaseToKebabCase = function (str) {
    return str ? str.replace(/([A-Z])/g, function (g) { return "-".concat(g[0].toLowerCase()); }) : '';
};
var Animator = /** @class */ (function () {
    function Animator() {
    }
    Animator.prototype.bindAnimations = function (animations) {
        for (var _i = 0, animations_1 = animations; _i < animations_1.length; _i++) {
            var animation = animations_1[_i];
            switch (animation.trigger) {
                case 'pageLoad':
                    this.triggerAnimation(animation);
                    break;
                case 'hover':
                    this.bindHoverAnimation(animation);
                    break;
                case 'scrollInView':
                    this.bindScrollInViewAnimation(animation);
                    break;
            }
        }
    };
    Animator.prototype.warnElementNotPresent = function (id) {
        console.warn("Cannot animate element: element with ID ".concat(id, " not found!"));
    };
    Animator.prototype.augmentAnimation = function (animation, element) {
        var stylesUsed = this.getAllStylesUsed(animation);
        var computedStyle = getComputedStyle(element);
        // const computedStyle = getComputedStyle(element);
        // // FIXME: this will break if original load is in one reponsive size then resize to another hmmm
        // Need to use transform instead of left since left can change on screen sizes
        var firstStyles = animation.steps[0].styles;
        var lastStyles = animation.steps[animation.steps.length - 1].styles;
        var bothStyles = [firstStyles, lastStyles];
        // FIXME: this won't work as expected for augmented animations - may need the editor itself to manage this
        for (var _i = 0, bothStyles_1 = bothStyles; _i < bothStyles_1.length; _i++) {
            var styles = bothStyles_1[_i];
            for (var _a = 0, stylesUsed_1 = stylesUsed; _a < stylesUsed_1.length; _a++) {
                var style = stylesUsed_1[_a];
                if (!(style in styles)) {
                    styles[style] = computedStyle[style];
                }
            }
        }
    };
    Animator.prototype.getAllStylesUsed = function (animation) {
        var properties = [];
        for (var _i = 0, _a = animation.steps; _i < _a.length; _i++) {
            var step = _a[_i];
            for (var key in step.styles) {
                if (properties.indexOf(key) === -1) {
                    properties.push(key);
                }
            }
        }
        return properties;
    };
    Animator.prototype.triggerAnimation = function (animation) {
        var _this = this;
        // TODO: do for ALL elements
        var elements = Array.prototype.slice.call(document.getElementsByClassName(animation.elementId || animation.id || ''));
        if (!elements.length) {
            this.warnElementNotPresent(animation.elementId || animation.id || '');
            return;
        }
        Array.from(elements).forEach(function (element) {
            _this.augmentAnimation(animation, element);
            // TODO: do this properly, may have other animations of different properties
            // TODO: only override the properties
            // TODO: if there is an entrance and hover animation, the transition duration will get effed
            // element.setAttribute('style', '');
            // const styledUsed = this.getAllStylesUsed(animation);
            element.style.transition = 'none';
            element.style.transitionDelay = '0';
            assign(element.style, animation.steps[0].styles);
            // TODO: queue/batch these timeouts
            // TODO: only include properties explicitly set in the animation
            // using Object.keys(styles)
            setTimeout(function () {
                element.style.transition = "all ".concat(animation.duration, "s ").concat(camelCaseToKebabCase(animation.easing));
                if (animation.delay) {
                    element.style.transitionDelay = animation.delay + 's';
                }
                assign(element.style, animation.steps[1].styles);
                // TODO: maybe remove/reset transitoin property after animation duration
                // TODO: queue timers
                setTimeout(function () {
                    // TODO: what if has other transition (reset back to what it was)
                    element.style.transition = '';
                    element.style.transitionDelay = '';
                }, (animation.delay || 0) * 1000 + animation.duration * 1000 + 100);
            });
        });
    };
    Animator.prototype.bindHoverAnimation = function (animation) {
        var _this = this;
        // TODO: is it multiple binding when editing...?
        // TODO: unbind on element remove
        // TODO: apply to ALL elements
        var elements = Array.prototype.slice.call(document.getElementsByClassName(animation.elementId || animation.id || ''));
        if (!elements.length) {
            this.warnElementNotPresent(animation.elementId || animation.id || '');
            return;
        }
        Array.from(elements).forEach(function (element) {
            _this.augmentAnimation(animation, element);
            var defaultState = animation.steps[0].styles;
            var hoverState = animation.steps[1].styles;
            function attachDefaultState() {
                assign(element.style, defaultState);
            }
            function attachHoverState() {
                assign(element.style, hoverState);
            }
            attachDefaultState();
            element.addEventListener('mouseenter', attachHoverState);
            element.addEventListener('mouseleave', attachDefaultState);
            // TODO: queue/batch these timeouts
            setTimeout(function () {
                element.style.transition = "all ".concat(animation.duration, "s ").concat(camelCaseToKebabCase(animation.easing));
                if (animation.delay) {
                    element.style.transitionDelay = animation.delay + 's';
                }
            });
        });
    };
    // TODO: unbind on element remove
    Animator.prototype.bindScrollInViewAnimation = function (animation) {
        var _this = this;
        // TODO: apply to ALL matching elements
        var elements = Array.prototype.slice.call(document.getElementsByClassName(animation.elementId || animation.id || ''));
        if (!elements.length) {
            this.warnElementNotPresent(animation.elementId || animation.id || '');
            return;
        }
        // TODO: if server side rendered and scrolled into view don't animate...
        Array.from(elements).forEach(function (element) {
            _this.augmentAnimation(animation, element);
            var triggered = false;
            var pendingAnimation = false;
            function immediateOnScroll() {
                if (!triggered && isScrolledIntoView(element)) {
                    triggered = true;
                    pendingAnimation = true;
                    setTimeout(function () {
                        assign(element.style, animation.steps[1].styles);
                        if (!animation.repeat) {
                            document.removeEventListener('scroll', onScroll);
                        }
                        setTimeout(function () {
                            pendingAnimation = false;
                            if (!animation.repeat) {
                                element.style.transition = '';
                                element.style.transitionDelay = '';
                            }
                        }, (animation.duration + (animation.delay || 0)) * 1000 + 100);
                    });
                }
                else if (animation.repeat &&
                    triggered &&
                    !pendingAnimation &&
                    !isScrolledIntoView(element)) {
                    // we want to repeat the animation every time the the element is out of view and back again
                    triggered = false;
                    assign(element.style, animation.steps[0].styles);
                }
            }
            // TODO: roll all of these in one for more efficiency of checking all the rects
            var onScroll = throttle(immediateOnScroll, 200, { leading: false });
            // TODO: fully in view or partially
            function isScrolledIntoView(elem) {
                var rect = elem.getBoundingClientRect();
                var windowHeight = window.innerHeight;
                var thresholdPercent = (animation.thresholdPercent || 0) / 100;
                var threshold = thresholdPercent * windowHeight;
                // TODO: partial in view? or what if element is larger than screen itself
                return (rect.bottom > threshold && rect.top < windowHeight - threshold // Element is peeking top or bottom
                // (rect.top > 0 && rect.bottom < window.innerHeight) || // element fits within the screen and is fully on screen (not hanging off at all)
                // (rect.top < 0 && rect.bottom > window.innerHeight) // element is larger than the screen and hangs over the top and bottom
                );
            }
            var defaultState = animation.steps[0].styles;
            function attachDefaultState() {
                assign(element.style, defaultState);
            }
            attachDefaultState();
            // TODO: queue/batch these timeouts!
            setTimeout(function () {
                element.style.transition = "all ".concat(animation.duration, "s ").concat(camelCaseToKebabCase(animation.easing));
                if (animation.delay) {
                    element.style.transitionDelay = animation.delay + 's';
                }
            });
            // TODO: one listener for everything
            document.addEventListener('scroll', onScroll, { capture: true, passive: true });
            // Do an initial check
            immediateOnScroll();
        });
    };
    return Animator;
}());

/**
 * Only gets one level up from hostname
 * wwww.example.com -> example.com
 * www.example.co.uk -> example.co.uk
 */
function getTopLevelDomain(host) {
    var parts = host.split('.');
    if (parts.length > 2) {
        return parts.slice(1).join('.');
    }
    return host;
}

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */
var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var Cookies = /** @class */ (function () {
    function Cookies(request, response) {
        this.request = request;
        this.response = response;
    }
    Cookies.prototype.get = function (name) {
        var header = this.request.headers['cookie'];
        if (!header) {
            return;
        }
        var match = header.match(getPattern(name));
        if (!match) {
            return;
        }
        var value = match[1];
        return value;
    };
    Cookies.prototype.set = function (name, value, opts) {
        var res = this.response;
        var req = this.request;
        var headers = res.getHeader('Set-Cookie') || [];
        // TODO: just make this always true
        var secure = this.secure !== undefined
            ? !!this.secure
            : req.protocol === 'https' || req.connection.encrypted;
        var cookie = new Cookie(name, value, opts);
        if (typeof headers === 'string') {
            headers = [headers];
        }
        if (!secure && opts && opts.secure) {
            throw new Error('Cannot send secure cookie over unencrypted connection');
        }
        cookie.secure = secure;
        if (opts && 'secure' in opts) {
            cookie.secure = !!opts.secure;
        }
        cookie.domain = req.headers.host && getTopLevelDomain(req.headers.host);
        pushCookie(headers, cookie);
        var setHeader = res.setHeader;
        setHeader.call(res, 'Set-Cookie', headers);
        return this;
    };
    return Cookies;
}());
var Cookie = /** @class */ (function () {
    function Cookie(name, value, attrs) {
        this.path = '/';
        this.domain = undefined;
        this.httpOnly = true;
        this.sameSite = false;
        this.secure = false;
        this.overwrite = false;
        this.name = '';
        this.value = '';
        if (!fieldContentRegExp.test(name)) {
            throw new TypeError('argument name is invalid');
        }
        if (value && !fieldContentRegExp.test(value)) {
            throw new TypeError('argument value is invalid');
        }
        if (!value) {
            this.expires = new Date(0);
        }
        this.name = name;
        this.value = value || '';
        if (attrs.expires) {
            this.expires = attrs.expires;
        }
        if (attrs.secure) {
            this.secure = attrs.secure;
        }
    }
    Cookie.prototype.toString = function () {
        return "".concat(this.name, "=").concat(this.value);
    };
    Cookie.prototype.toHeader = function () {
        var header = this.toString();
        if (this.maxAge) {
            this.expires = new Date(Date.now() + this.maxAge);
        }
        if (this.path) {
            header += "; path=".concat(this.path);
        }
        if (this.expires) {
            header += "; expires=".concat(this.expires.toUTCString());
        }
        if (this.domain) {
            header += "; domain=".concat(this.domain);
        }
        // TODO: samesite=none by default (?)
        header += "; SameSite=".concat(this.sameSite === true ? 'strict' : 'None');
        // TODO: On by default
        if (this.secure) {
            header += '; secure';
        }
        if (this.httpOnly) {
            header += '; httponly';
        }
        return header;
    };
    return Cookie;
}());
function getPattern(name) {
    return new RegExp("(?:^|;) *".concat(name.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), "=([^;]*)"));
}
function pushCookie(headers, cookie) {
    if (cookie.overwrite) {
        for (var i = headers.length - 1; i >= 0; i--) {
            if (headers[i].indexOf("".concat(cookie.name, "=")) === 0) {
                headers.splice(i, 1);
            }
        }
    }
    headers.push(cookie.toHeader());
}

function omit(obj) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    var newObject = Object.assign({}, obj);
    for (var _a = 0, values_1 = values; _a < values_1.length; _a++) {
        var key = values_1[_a];
        delete newObject[key];
    }
    return newObject;
}

/**
 * @credit https://stackoverflow.com/a/2117523
 */
function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0, v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
/**
 * Slightly cleaner and smaller UUIDs
 */
function uuid() {
    return uuidv4().replace(/-/g, '');
}

function emptyUrl() {
    return {
        query: null,
        port: null,
        auth: null,
        hash: null,
        host: null,
        hostname: null,
        href: null,
        path: null,
        pathname: null,
        protocol: null,
        search: null,
        slashes: null,
    };
}
// Replacement for `url.parse` using `URL` global object that works with relative paths.
// Assumptions: this function operates in a NodeJS environment.
function parse(url) {
    var out = emptyUrl();
    var u;
    var pathOnly = url === '' || url[0] === '/';
    if (pathOnly) {
        u = new URL(url, 'http://0.0.0.0/');
        out.href = u.href;
        out.href = out.href.slice(14); // remove 'http://0.0.0.0/'
    }
    else {
        u = new URL(url);
        out.href = u.href;
        out.port = u.port === '' ? null : u.port;
        out.hash = u.hash === '' ? null : u.hash;
        out.host = u.host;
        out.hostname = u.hostname;
        out.href = u.href;
        out.pathname = u.pathname;
        out.protocol = u.protocol;
        out.slashes = url[u.protocol.length] === '/'; // check if the mimetype is proceeded by a slash
    }
    out.search = u.search;
    out.query = u.search.slice(1); // remove '?'
    out.path = "".concat(u.pathname).concat(u.search);
    out.pathname = u.pathname;
    return out;
}

/**
 * Safe conversion to error type. Intended to be used in catch blocks where the
 *  value is not guaranteed to be an error.
 *
 *  @example
 *  try {
 *    throw new Error('Something went wrong')
 *  }
 *  catch (err: unknown) {
 *    const error: Error = toError(err)
 *  }
 */
function toError(err) {
    if (err instanceof Error)
        return err;
    return new Error(String(err));
}

function datePlusMinutes(minutes) {
    if (minutes === void 0) { minutes = 30; }
    return new Date(Date.now() + minutes * 60000);
}
var isPositiveNumber = function (thing) {
    return typeof thing === 'number' && !isNaN(thing) && thing >= 0;
};
var isReactNative = typeof navigator === 'object' && navigator.product === 'ReactNative';
var validEnvList = [
    'production',
    'qa',
    'test',
    'development',
    'dev',
    'cdn-qa',
    'cloud',
    'fast',
    'cdn2',
    'cdn-prod',
];
function getQueryParam(url, variable) {
    var query = url.split('?')[1] || '';
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) === variable) {
            return decodeURIComponent(pair[1]);
        }
    }
    return null;
}
var urlParser = {
    parse: function (url) {
        var el = document.createElement('a');
        el.href = url;
        var out = {};
        var props = [
            'username',
            'password',
            'host',
            'hostname',
            'port',
            'protocol',
            'origin',
            'pathname',
            'search',
            'hash',
        ];
        for (var _i = 0, props_1 = props; _i < props_1.length; _i++) {
            var prop = props_1[_i];
            out[prop] = el[prop];
        }
        // IE 11 pathname handling workaround
        // (IE omits preceeding '/', unlike other browsers)
        if ((out.pathname || out.pathname === '') &&
            typeof out.pathname === 'string' &&
            out.pathname.indexOf('/') !== 0) {
            out.pathname = '/' + out.pathname;
        }
        return out;
    },
};
var parse$1 = isReactNative
    ? function () { return emptyUrl(); }
    : typeof window === 'object'
        ? urlParser.parse
        : parse;
function setCookie(name$$1, value, expires) {
    try {
        var expiresString = '';
        // TODO: need to know if secure server side
        if (expires) {
            expiresString = '; expires=' + expires.toUTCString();
        }
        var secure = isBrowser ? location.protocol === 'https:' : true;
        document.cookie =
            name$$1 +
                '=' +
                (value || '') +
                expiresString +
                '; path=/' +
                "; domain=".concat(getTopLevelDomain(location.hostname)) +
                (secure ? ';secure ; SameSite=None' : '');
    }
    catch (err) {
        console.warn('Could not set cookie', err);
    }
}
function getCookie(name$$1) {
    try {
        return (decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' +
            encodeURIComponent(name$$1).replace(/[\-\.\+\*]/g, '\\$&') +
            '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null);
    }
    catch (err) {
        console.warn('Could not get cookie', err);
    }
}
function size(object) {
    return Object.keys(object).length;
}
function find(target, callback) {
    var list = target;
    // Makes sures is always has an positive integer as length.
    var length = list.length >>> 0;
    var thisArg = arguments[1];
    for (var i = 0; i < length; i++) {
        var element = list[i];
        if (callback.call(thisArg, element, i, list)) {
            return element;
        }
    }
}
var sessionStorageKey = 'builderSessionId';
var localStorageKey = 'builderVisitorId';
var isBrowser = typeof window !== 'undefined' && !isReactNative;
var isIframe = isBrowser && window.top !== window.self;
function BuilderComponent(info) {
    if (info === void 0) { info = {}; }
    return Builder.Component(info);
}
var Builder = /** @class */ (function () {
    function Builder(apiKey, request, response, forceNewInstance, authToken) {
        if (apiKey === void 0) { apiKey = null; }
        if (forceNewInstance === void 0) { forceNewInstance = false; }
        if (authToken === void 0) { authToken = null; }
        var _this = this;
        this.request = request;
        this.response = response;
        this.eventsQueue = [];
        this.throttledClearEventsQueue = throttle(function () {
            _this.processEventsQueue();
            // Extend the session cookie
            _this.setCookie(sessionStorageKey, _this.sessionId, datePlusMinutes(30));
        }, 5);
        this.env = 'production';
        this.sessionId = this.getSessionId();
        this.targetContent = true;
        this.contentPerRequest = 1;
        // TODO: make array or function
        this.allowCustomFonts = true;
        this.cookies = null;
        // TODO: api options object
        this.cachebust = false;
        this.overrideParams = '';
        this.noCache = false;
        this.preview = false;
        this.canTrack$ = new BehaviorSubject(!this.browserTrackingDisabled);
        this.apiKey$ = new BehaviorSubject(null);
        this.authToken$ = new BehaviorSubject(null);
        this.userAttributesChanged = new BehaviorSubject(null);
        this.editingMode$ = new BehaviorSubject(isIframe);
        // TODO: decorator to do this stuff with the get/set (how do with typing too? compiler?)
        this.editingModel$ = new BehaviorSubject(null);
        this.userAgent = (typeof navigator === 'object' && navigator.userAgent) || '';
        this.trackingHooks = [];
        // Set this to control the userId
        // TODO: allow changing it mid session and updating existing data to be associated
        // e.g. for when a user navigates and then logs in
        this.visitorId = this.getVisitorId();
        this.autoTrack = !Builder.isBrowser
            ? false
            : !this.isDevelopmentEnv &&
                !(Builder.isBrowser && location.search.indexOf('builder.preview=') !== -1);
        this.trackingUserAttributes = {};
        this.blockContentLoading = '';
        this.observersByKey = {};
        this.noEditorUpdates = {};
        this.overrides = {};
        this.queryOptions = {};
        this.getContentQueue = null;
        this.priorContentQueue = null;
        this.testCookiePrefix = 'builder.tests';
        this.cookieQueue = [];
        // TODO: use a window variable for this perhaps, e.g. bc webcomponents may be loading builder twice
        // with it's and react (use rollup build to fix)
        if (Builder.isBrowser && !forceNewInstance && Builder.singletonInstance) {
            return Builder.singletonInstance;
        }
        if (this.request && this.response) {
            this.setUserAgent(this.request.headers['user-agent'] || '');
            this.cookies = new Cookies(this.request, this.response);
        }
        if (apiKey) {
            this.apiKey = apiKey;
        }
        if (authToken) {
            this.authToken = authToken;
        }
        if (isBrowser) {
            this.bindMessageListeners();
            if (Builder.isEditing) {
                parent.postMessage({
                    type: 'builder.animatorOptions',
                    data: {
                        options: {
                            version: 2,
                        },
                    },
                }, '*');
            }
            // TODO: postmessage to parent the builder info for every package
            // type: 'builder.sdk', data: { name: '@builder.io/react', version: '0.1.23' }
            // (window as any).BUILDER_VERSION = Builder.VERSION;
            // Ensure always one Builder global singleton
            // TODO: some people won't want this, e.g. rakuten
            // Maybe hide this behind symbol or on document, etc
            // if ((window as any).Builder) {
            //   Builder.components = (window as any).Builder.components;
            // } else {
            //   (window as any).Builder = Builder;
            // }
        }
        if (isIframe) {
            this.messageFrameLoaded();
        }
        // TODO: on destroy clear subscription
        this.canTrack$.subscribe(function (value) {
            if (value) {
                if (typeof sessionStorage !== 'undefined') {
                    try {
                        if (!sessionStorage.getItem(sessionStorageKey)) {
                            sessionStorage.setItem(sessionStorageKey, _this.sessionId);
                        }
                    }
                    catch (err) {
                        console.debug('Session storage error', err);
                    }
                }
                if (_this.eventsQueue.length) {
                    _this.throttledClearEventsQueue();
                }
                if (_this.cookieQueue.length) {
                    _this.cookieQueue.forEach(function (item) {
                        _this.setCookie(item[0], item[1]);
                    });
                    _this.cookieQueue.length = 0;
                }
            }
        });
        if (isBrowser) {
            // TODO: defer so subclass constructor runs and injects location service
            this.setTestsFromUrl();
            // TODO: do this on every request send?
            this.getOverridesFromQueryString();
        }
    }
    Builder.register = function (type, info) {
        // TODO: all must have name and can't conflict?
        var typeList = this.registry[type];
        if (!typeList) {
            typeList = this.registry[type] = [];
        }
        typeList.push(info);
        if (Builder.isBrowser) {
            var message = {
                type: 'builder.register',
                data: {
                    type: type,
                    info: info,
                },
            };
            try {
                parent.postMessage(message, '*');
                if (parent !== window) {
                    window.postMessage(message, '*');
                }
            }
            catch (err) {
                console.debug('Could not postmessage', err);
            }
        }
        this.registryChange.next(this.registry);
    };
    Builder.registerEditor = function (info) {
        if (Builder.isBrowser) {
            window.postMessage({
                type: 'builder.registerEditor',
                data: omit(info, 'component'),
            }, '*');
            var hostname = location.hostname;
            if (!Builder.isTrustedHost(hostname)) {
                console.error('Builder.registerEditor() called in the wrong environment! You cannot load custom editors from your app, they must be loaded through the Builder.io app itself. Follow the readme here for more details: https://github.com/builderio/builder/tree/master/plugins/cloudinary or contact chat us in our Spectrum community for help: https://spectrum.chat/builder');
            }
        }
        this.editors.push(info);
    };
    Builder.registerPlugin = function (info) {
        this.plugins.push(info);
    };
    Builder.registerAction = function (action) {
        this.actions.push(action);
    };
    Builder.registerTrustedHost = function (host) {
        this.trustedHosts.push(host);
    };
    Builder.isTrustedHost = function (hostname) {
        return (this.trustedHosts.findIndex(function (trustedHost) { return trustedHost === hostname || hostname.endsWith(".".concat(trustedHost)); }) > -1);
    };
    Builder.runAction = function (action) {
        // TODO
        var actionObject = typeof action === 'string' ? find(this.actions, function (item) { return item.name === action; }) : action;
        if (!actionObject) {
            throw new Error("Action not found: ".concat(action));
        }
    };
    Builder.fields = function (name$$1, fields) {
        var _a;
        (_a = window.parent) === null || _a === void 0 ? void 0 : _a.postMessage({
            type: 'builder.fields',
            data: { name: name$$1, fields: fields },
        }, '*');
    };
    /**
     * @deprecated
     * @hidden
     *
     * Use Builder.register('editor.settings', {}) instead.
     */
    Builder.set = function (settings) {
        Builder.register('editor.settings', settings);
    };
    Builder.import = function (packageName) {
        if (!Builder.isBrowser) {
            // TODO: server side support *maybe*
            console.warn('Builder.import used on the server - this should only be used in the browser');
            return;
        }
        var System = window.System;
        if (!System) {
            console.warn('System.js not available. Please include System.js when using Builder.import');
            return;
        }
        return System.import("https://cdn.builder.io/systemjs/".concat(packageName));
    };
    Object.defineProperty(Builder, "editingPage", {
        // useCdnApi = false;
        get: function () {
            return this._editingPage;
        },
        set: function (editingPage) {
            this._editingPage = editingPage;
            if (isBrowser && isIframe) {
                if (editingPage) {
                    document.body.classList.add('builder-editing-page');
                }
                else {
                    document.body.classList.remove('builder-editing-page');
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Builder.prepareComponentSpecToSend = function (spec) {
        return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, spec), (spec.inputs && {
            inputs: spec.inputs.map(function (input) {
                var _a;
                // TODO: do for nexted fields too
                // TODO: probably just convert all functions, not just
                // TODO: put this in input hooks: { onChange: ..., showIf: ... }
                var keysToConvertFnToString = ['onChange', 'showIf'];
                for (var _i = 0, keysToConvertFnToString_1 = keysToConvertFnToString; _i < keysToConvertFnToString_1.length; _i++) {
                    var key = keysToConvertFnToString_1[_i];
                    if (input[key] && typeof input[key] === 'function') {
                        var fn = input[key];
                        input = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, input), (_a = {}, _a[key] = "return (".concat(fn.toString(), ").apply(this, arguments)"), _a));
                    }
                }
                return input;
            }),
        })), { hooks: Object.keys(spec.hooks || {}).reduce(function (memo, key) {
                var value = spec.hooks && spec.hooks[key];
                if (!value) {
                    return memo;
                }
                if (typeof value === 'string') {
                    memo[key] = value;
                }
                else {
                    memo[key] = "return (".concat(value.toString(), ").apply(this, arguments)");
                }
                return memo;
            }, {}), class: undefined });
    };
    Builder.registerBlock = function (component, options) {
        this.registerComponent(component, options);
    };
    Builder.registerComponent = function (component, options) {
        var _a;
        var spec = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ class: component }, component.builderOptions), options);
        this.addComponent(spec);
        var editable = options.models && this.singletonInstance.editingModel
            ? isBrowser && options.models.includes(this.singletonInstance.editingModel)
            : isBrowser;
        if (editable) {
            var sendSpec = this.prepareComponentSpecToSend(spec);
            (_a = window.parent) === null || _a === void 0 ? void 0 : _a.postMessage({
                type: 'builder.registerComponent',
                data: sendSpec,
            }, '*');
        }
    };
    Builder.addComponent = function (component) {
        var current = find(this.components, function (item) { return item.name === component.name; });
        if (current) {
            // FIXME: why does sometimes we get an extra post without class - probably
            // from postMessage handler wrong in some place
            if (current.class && !component.class) {
                return;
            }
            this.components.splice(this.components.indexOf(current), 1, component);
        }
        else {
            this.components.push(component);
        }
    };
    // TODO: style guide, etc off this system as well?
    Builder.component = function (info) {
        var _this = this;
        if (info === void 0) { info = {}; }
        return function (component) {
            var _a;
            var spec = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, info), { class: component });
            if (!spec.name) {
                spec.name = component.name;
            }
            _this.addComponent(spec);
            var sendSpec = _this.prepareComponentSpecToSend(spec);
            // TODO: serialize component name and inputs
            if (isBrowser) {
                (_a = window.parent) === null || _a === void 0 ? void 0 : _a.postMessage({
                    type: 'builder.registerComponent',
                    data: sendSpec,
                }, '*');
            }
            return component;
        };
    };
    Object.defineProperty(Builder, "Component", {
        get: function () {
            return this.component;
        },
        enumerable: false,
        configurable: true
    });
    Builder.prototype.processEventsQueue = function () {
        if (!this.eventsQueue.length) {
            return;
        }
        var events = this.eventsQueue;
        this.eventsQueue = [];
        var fullUserAttributes = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, Builder.overrideUserAttributes), this.trackingUserAttributes);
        for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
            var event_1 = events_1[_i];
            if (!event_1.data.metadata) {
                event_1.data.metadata = {};
            }
            if (!event_1.data.metadata.user) {
                event_1.data.metadata.user = {};
            }
            Object.assign(event_1.data.metadata.user, fullUserAttributes, event_1.data.metadata.user);
        }
        var host = this.host;
        fetch("".concat(host, "/api/v1/track"), {
            method: 'POST',
            body: JSON.stringify({ events: events }),
            headers: {
                'content-type': 'application/json',
            },
            mode: 'cors',
        }).catch(function () {
            // Not the end of the world
        });
    };
    Object.defineProperty(Builder.prototype, "browserTrackingDisabled", {
        get: function () {
            return Builder.isBrowser && Boolean(window.builderNoTrack || !navigator.cookieEnabled);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builder.prototype, "canTrack", {
        get: function () {
            return this.canTrack$.value;
        },
        set: function (canTrack) {
            if (this.canTrack !== canTrack) {
                this.canTrack$.next(canTrack);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builder.prototype, "editingMode", {
        get: function () {
            return this.editingMode$.value;
        },
        set: function (value) {
            if (value !== this.editingMode) {
                this.editingMode$.next(value);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builder.prototype, "editingModel", {
        get: function () {
            return this.editingModel$.value;
        },
        set: function (value) {
            if (value !== this.editingModel) {
                this.editingModel$.next(value);
            }
        },
        enumerable: false,
        configurable: true
    });
    Builder.prototype.findParentElement = function (target, callback, checkElement) {
        if (checkElement === void 0) { checkElement = true; }
        if (!(target instanceof HTMLElement)) {
            return null;
        }
        var parent = checkElement ? target : target.parentElement;
        do {
            if (!parent) {
                return null;
            }
            var matches = callback(parent);
            if (matches) {
                return parent;
            }
        } while ((parent = parent.parentElement));
        return null;
    };
    Builder.prototype.findBuilderParent = function (target) {
        return this.findParentElement(target, function (el) {
            var id = el.getAttribute('builder-id') || el.id;
            return Boolean(id && id.indexOf('builder-') === 0);
        });
    };
    Builder.prototype.setUserAgent = function (userAgent) {
        this.userAgent = userAgent || '';
    };
    /**
     * Set a hook to modify events being tracked from builder, such as impressions and clicks
     *
     * For example, to track the model ID of each event associated with content for querying
     * by mode, you can do
     *
     *    builder.setTrackingHook((event, context) => {
     *      if (context.content) {
     *        event.data.metadata.modelId = context.content.modelId
     *      }
     *    })
     */
    Builder.prototype.setTrackingHook = function (hook) {
        this.trackingHooks.push(hook);
    };
    Builder.prototype.track = function (eventName, properties, context) {
        if (properties === void 0) { properties = {}; }
        // TODO: queue up track requests and fire them off when canTrack set to true - otherwise may get lots of clicks with no impressions
        if (isIframe || !isBrowser || Builder.isPreviewing) {
            return;
        }
        var apiKey = this.apiKey;
        if (!apiKey) {
            console.error('Builder integration error: Looks like the Builder SDK has not been initialized properly (your API key has not been set). Make sure you are calling `builder.init("«YOUR-API-KEY»");` as early as possible in your application\'s code.');
            return;
        }
        var eventData = JSON.parse(JSON.stringify({
            type: eventName,
            data: (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, omit(properties, 'meta')), { metadata: (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ sdkVersion: Builder.VERSION, url: location.href }, properties.meta), properties.metadata), ownerId: apiKey, userAttributes: this.getUserAttributes(), sessionId: this.sessionId, visitorId: this.visitorId }),
        }));
        for (var _i = 0, _a = this.trackingHooks; _i < _a.length; _i++) {
            var hook = _a[_i];
            var returnValue = hook(eventData, context || {});
            if (returnValue) {
                eventData = returnValue;
            }
        }
        // batch events
        this.eventsQueue.push(eventData);
        if (this.canTrack) {
            this.throttledClearEventsQueue();
        }
    };
    Builder.prototype.getSessionId = function () {
        var _this = this;
        var sessionId = null;
        try {
            if (Builder.isBrowser && typeof sessionStorage !== 'undefined') {
                sessionId = this.getCookie(sessionStorageKey);
            }
        }
        catch (err) {
            console.debug('Session storage error', err);
            // It's ok
        }
        if (!sessionId) {
            sessionId = uuid();
        }
        // Give the app a second to start up and set canTrack to false if needed
        if (Builder.isBrowser) {
            setTimeout(function () {
                try {
                    if (_this.canTrack) {
                        _this.setCookie(sessionStorageKey, sessionId, datePlusMinutes(30));
                    }
                }
                catch (err) {
                    console.debug('Cookie setting error', err);
                }
            });
        }
        return sessionId;
    };
    Builder.prototype.getVisitorId = function () {
        var _this = this;
        if (this.visitorId) {
            return this.visitorId;
        }
        var visitorId = null;
        try {
            if (Builder.isBrowser && typeof localStorage !== 'undefined') {
                // TODO: cookie instead?
                visitorId = localStorage.getItem(localStorageKey);
            }
        }
        catch (err) {
            console.debug('Local storage error', err);
            // It's ok
        }
        if (!visitorId) {
            visitorId = uuid();
        }
        this.visitorId = visitorId;
        // Give the app a second to start up and set canTrack to false if needed
        if (Builder.isBrowser) {
            setTimeout(function () {
                try {
                    if (_this.canTrack && typeof localStorage !== 'undefined' && visitorId) {
                        localStorage.setItem(localStorageKey, visitorId);
                    }
                }
                catch (err) {
                    console.debug('Session storage error', err);
                }
            });
        }
        return visitorId;
    };
    Builder.prototype.trackImpression = function (contentId, variationId, properties, context) {
        if (isIframe || !isBrowser || Builder.isPreviewing) {
            return;
        }
        // TODO: use this.track method
        this.track('impression', {
            contentId: contentId,
            variationId: variationId !== contentId ? variationId : undefined,
            metadata: properties,
        }, context);
    };
    Builder.prototype.trackConversion = function (amount, contentId, variationId, customProperties, context) {
        if (isIframe || !isBrowser || Builder.isPreviewing) {
            return;
        }
        var meta = typeof contentId === 'object' ? contentId : customProperties;
        var useContentId = typeof contentId === 'string' ? contentId : undefined;
        this.track('conversion', { amount: amount, variationId: variationId, meta: meta, contentId: useContentId }, context);
    };
    Object.defineProperty(Builder.prototype, "isDevelopmentEnv", {
        // TODO: set this for QA
        get: function () {
            // Automatic determining of development environment
            return (Builder.isIframe ||
                (Builder.isBrowser && (location.hostname === 'localhost' || location.port !== '')) ||
                this.env !== 'production');
        },
        enumerable: false,
        configurable: true
    });
    Builder.prototype.trackInteraction = function (contentId, variationId, alreadyTrackedOne, event, context) {
        if (alreadyTrackedOne === void 0) { alreadyTrackedOne = false; }
        if (isIframe || !isBrowser || Builder.isPreviewing) {
            return;
        }
        var target = event && event.target;
        var targetBuilderElement = target && this.findBuilderParent(target);
        function round(num) {
            return Math.round(num * 1000) / 1000;
        }
        var metadata = {};
        if (event) {
            var clientX = event.clientX, clientY = event.clientY;
            if (target) {
                var targetRect = target.getBoundingClientRect();
                var xOffset = clientX - targetRect.left;
                var yOffset = clientY - targetRect.top;
                var xRatio = round(xOffset / targetRect.width);
                var yRatio = round(yOffset / targetRect.height);
                metadata.targetOffset = {
                    x: xRatio,
                    y: yRatio,
                };
            }
            if (targetBuilderElement) {
                var targetRect = targetBuilderElement.getBoundingClientRect();
                var xOffset = clientX - targetRect.left;
                var yOffset = clientY - targetRect.top;
                var xRatio = round(xOffset / targetRect.width);
                var yRatio = round(yOffset / targetRect.height);
                metadata.builderTargetOffset = {
                    x: xRatio,
                    y: yRatio,
                };
            }
        }
        var builderId = targetBuilderElement &&
            (targetBuilderElement.getAttribute('builder-id') || targetBuilderElement.id);
        if (builderId && targetBuilderElement) {
            metadata.builderElementIndex = [].slice
                .call(document.getElementsByClassName(builderId))
                .indexOf(targetBuilderElement);
        }
        this.track('click', {
            contentId: contentId,
            metadata: metadata,
            variationId: variationId !== contentId ? variationId : undefined,
            unique: !alreadyTrackedOne,
            targetBuilderElement: builderId || undefined,
        }, context);
    };
    Builder.prototype.component = function (info) {
        if (info === void 0) { info = {}; }
        return Builder.component(info);
    };
    Object.defineProperty(Builder.prototype, "apiKey", {
        get: function () {
            return this.apiKey$.value;
        },
        set: function (key) {
            this.apiKey$.next(key);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Builder.prototype, "authToken", {
        get: function () {
            return this.authToken$.value;
        },
        set: function (token) {
            this.authToken$.next(token);
        },
        enumerable: false,
        configurable: true
    });
    Builder.prototype.modifySearch = function (search) {
        return search.replace(/(^|&|\?)(builder_.*?)=/gi, function (_match, group1, group2) { return group1 + group2.replace(/_/g, '.') + '='; });
    };
    Builder.prototype.setTestsFromUrl = function () {
        var search = this.getLocation().search;
        var params = QueryString.parseDeep(this.modifySearch(search || '').substr(1));
        var tests = params.builder && params.builder.tests;
        if (tests && typeof tests === 'object') {
            for (var key in tests) {
                if (tests.hasOwnProperty(key)) {
                    this.setTestCookie(key, tests[key]);
                }
            }
        }
    };
    Builder.prototype.resetOverrides = function () {
        // Ugly - pass down instances per request instead using react context
        // or use builder.get('foo', { req, res }) in react...........
        Builder.overrideUserAttributes = {};
        this.cachebust = false;
        this.noCache = false;
        this.preview = false;
        this.editingModel = null;
        this.overrides = {};
        this.env = 'production';
        this.userAgent = '';
        this.request = undefined;
        this.response = undefined;
    };
    Builder.prototype.getOverridesFromQueryString = function () {
        var location = this.getLocation();
        var params = QueryString.parseDeep(this.modifySearch(location.search || '').substr(1));
        var builder = params.builder;
        if (builder) {
            var userAttributes = builder.userAttributes, overrides = builder.overrides, env = builder.env, host = builder.host, api = builder.api, cachebust = builder.cachebust, noCache = builder.noCache, preview = builder.preview, editing = builder.editing, frameEditing = builder.frameEditing, options = builder.options, overrideParams = builder.params;
            if (userAttributes) {
                this.setUserAttributes(userAttributes);
            }
            if (options) {
                // picking only locale and includeRefs
                this.queryOptions = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, (options.locale && { locale: options.locale })), (options.includeRefs && { includeRefs: options.includeRefs }));
            }
            if (overrides) {
                this.overrides = overrides;
            }
            if (validEnvList.indexOf(env || api) > -1) {
                this.env = env || api;
            }
            if (Builder.isEditing) {
                var editingModel = frameEditing || editing || preview;
                if (editingModel && editingModel !== 'true') {
                    this.editingModel = editingModel;
                }
            }
            if (cachebust) {
                this.cachebust = true;
            }
            if (noCache) {
                this.noCache = true;
            }
            if (preview) {
                this.preview = true;
            }
            if (params) {
                this.overrideParams = overrideParams;
            }
        }
    };
    Builder.prototype.messageFrameLoaded = function () {
        var _a;
        (_a = window.parent) === null || _a === void 0 ? void 0 : _a.postMessage({
            type: 'builder.loaded',
            data: {
                value: true,
            },
        }, '*');
    };
    Builder.prototype.bindMessageListeners = function () {
        var _this = this;
        if (isBrowser) {
            addEventListener('message', function (event) {
                var _a, _b, _c, _d, _e;
                var url = parse$1(event.origin);
                var isRestricted = ['builder.register', 'builder.registerComponent'].indexOf((_a = event.data) === null || _a === void 0 ? void 0 : _a.type) === -1;
                var isTrusted = url.hostname && Builder.isTrustedHost(url.hostname);
                if (isRestricted && !isTrusted) {
                    return;
                }
                var data = event.data;
                if (data) {
                    switch (data.type) {
                        case 'builder.ping': {
                            (_b = window.parent) === null || _b === void 0 ? void 0 : _b.postMessage({
                                type: 'builder.pong',
                                data: {},
                            }, '*');
                            break;
                        }
                        case 'builder.register': {
                            // TODO: possibly do this for all...
                            if (event.source === window) {
                                break;
                            }
                            var options = data.data;
                            if (!options) {
                                break;
                            }
                            var type = options.type, info = options.info;
                            // TODO: all must have name and can't conflict?
                            var typeList = Builder.registry[type];
                            if (!typeList) {
                                typeList = Builder.registry[type] = [];
                            }
                            typeList.push(info);
                            Builder.registryChange.next(Builder.registry);
                            break;
                        }
                        case 'builder.settingsChange': {
                            // TODO: possibly do this for all...
                            if (event.source === window) {
                                break;
                            }
                            var settings = data.data;
                            if (!settings) {
                                break;
                            }
                            Object.assign(Builder.settings, settings);
                            Builder.settingsChange.next(Builder.settings);
                            break;
                        }
                        case 'builder.registerEditor': {
                            // TODO: possibly do this for all...
                            if (event.source === window) {
                                break;
                            }
                            var info_1 = data.data;
                            if (!info_1) {
                                break;
                            }
                            var hasComponent_1 = !!info_1.component;
                            Builder.editors.every(function (thisInfo, index) {
                                if (info_1.name === thisInfo.name) {
                                    if (thisInfo.component && !hasComponent_1) {
                                        return false;
                                    }
                                    else {
                                        Builder.editors[index] = thisInfo;
                                    }
                                    return false;
                                }
                                return true;
                            });
                            break;
                        }
                        case 'builder.triggerAnimation': {
                            Builder.animator.triggerAnimation(data.data);
                            break;
                        }
                        case 'builder.contentUpdate':
                            var key = data.data.key || data.data.alias || data.data.entry || data.data.modelName;
                            var contentData = data.data.data; // hmmm...
                            var observer = _this.observersByKey[key];
                            if (observer && !_this.noEditorUpdates[key]) {
                                observer.next([contentData]);
                            }
                            break;
                        case 'builder.getComponents':
                            (_c = window.parent) === null || _c === void 0 ? void 0 : _c.postMessage({
                                type: 'builder.components',
                                data: Builder.components.map(function (item) { return Builder.prepareComponentSpecToSend(item); }),
                            }, '*');
                            break;
                        case 'builder.editingModel':
                            _this.editingModel = data.data.model;
                            break;
                        case 'builder.registerComponent':
                            var componentData = data.data;
                            Builder.addComponent(componentData);
                            break;
                        case 'builder.blockContentLoading':
                            if (typeof data.data.model === 'string') {
                                _this.blockContentLoading = data.data.model;
                            }
                            break;
                        case 'builder.editingMode':
                            var editingMode = data.data;
                            if (editingMode) {
                                _this.editingMode = true;
                                document.body.classList.add('builder-editing');
                            }
                            else {
                                _this.editingMode = false;
                                document.body.classList.remove('builder-editing');
                            }
                            break;
                        case 'builder.editingPageMode':
                            var editingPageMode = data.data;
                            Builder.editingPage = editingPageMode;
                            break;
                        case 'builder.overrideUserAttributes':
                            var userAttributes = data.data;
                            assign(Builder.overrideUserAttributes, userAttributes);
                            _this.flushGetContentQueue(true);
                            // TODO: refetch too
                            break;
                        case 'builder.overrideTestGroup':
                            var _f = data.data, variationId = _f.variationId, contentId = _f.contentId;
                            if (variationId && contentId) {
                                _this.setTestCookie(contentId, variationId);
                                _this.flushGetContentQueue(true);
                            }
                            break;
                        case 'builder.evaluate': {
                            var text = data.data.text;
                            var args = data.data.arguments || [];
                            var id_1 = data.data.id;
                            // tslint:disable-next-line:no-function-constructor-with-string-args
                            var fn = new Function(text);
                            var result = void 0;
                            var error = null;
                            try {
                                result = fn.apply(_this, args);
                            }
                            catch (err) {
                                error = toError(err);
                            }
                            if (error) {
                                (_d = window.parent) === null || _d === void 0 ? void 0 : _d.postMessage({
                                    type: 'builder.evaluateError',
                                    data: { id: id_1, error: error.message },
                                }, '*');
                            }
                            else {
                                if (result && typeof result.then === 'function') {
                                    result
                                        .then(function (finalResult) {
                                        var _a;
                                        (_a = window.parent) === null || _a === void 0 ? void 0 : _a.postMessage({
                                            type: 'builder.evaluateResult',
                                            data: { id: id_1, result: finalResult },
                                        }, '*');
                                    })
                                        .catch(console.error);
                                }
                                else {
                                    (_e = window.parent) === null || _e === void 0 ? void 0 : _e.postMessage({
                                        type: 'builder.evaluateResult',
                                        data: { result: result, id: id_1 },
                                    }, '*');
                                }
                            }
                            break;
                        }
                    }
                }
            });
        }
    };
    Object.defineProperty(Builder.prototype, "defaultCanTrack", {
        get: function () {
            return Boolean(Builder.isBrowser &&
                navigator.userAgent.trim() &&
                !navigator.userAgent.match(/bot|crawler|spider|robot|crawling|prerender|google|baidu|bing|msn|duckduckbot|teoma|slurp|yandex|phantom|headless|selenium|puppeteer/i) &&
                !this.browserTrackingDisabled);
        },
        enumerable: false,
        configurable: true
    });
    Builder.prototype.init = function (apiKey, canTrack, req, res, authToken) {
        if (canTrack === void 0) { canTrack = this.defaultCanTrack; }
        if (req) {
            this.request = req;
        }
        if (res) {
            this.response = res;
        }
        this.canTrack = canTrack;
        this.apiKey = apiKey;
        if (authToken) {
            this.authToken = authToken;
        }
        return this;
    };
    Object.defineProperty(Builder.prototype, "previewingModel", {
        get: function () {
            var search = this.getLocation().search;
            var params = QueryString.parse((search || '').substr(1));
            return params['builder.preview'];
        },
        enumerable: false,
        configurable: true
    });
    // TODO: allow adding location object as property and/or in constructor
    Builder.prototype.getLocation = function () {
        var _a;
        var parsedLocation = {};
        // in ssr mode
        if (this.request) {
            parsedLocation = parse$1((_a = this.request.url) !== null && _a !== void 0 ? _a : '');
        }
        else if (typeof location === 'object') {
            // in the browser
            parsedLocation = parse$1(location.href);
        }
        // IE11 bug with parsed path being empty string
        // causes issues with our user targeting
        if (parsedLocation.pathname === '') {
            parsedLocation.pathname = '/';
        }
        return parsedLocation;
    };
    Builder.prototype.getUserAttributes = function (userAgent) {
        if (userAgent === void 0) { userAgent = this.userAgent || ''; }
        var isMobile = {
            Android: function () {
                return userAgent.match(/Android/i);
            },
            BlackBerry: function () {
                return userAgent.match(/BlackBerry/i);
            },
            iOS: function () {
                return userAgent.match(/iPhone|iPod/i);
            },
            Opera: function () {
                return userAgent.match(/Opera Mini/i);
            },
            Windows: function () {
                return userAgent.match(/IEMobile/i) || userAgent.match(/WPDesktop/i);
            },
            any: function () {
                return (isMobile.Android() ||
                    isMobile.BlackBerry() ||
                    isMobile.iOS() ||
                    isMobile.Opera() ||
                    isMobile.Windows());
            },
        };
        var isTablet = userAgent.match(/Tablet|iPad/i);
        var url = this.getLocation();
        return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ urlPath: url.pathname, host: url.host || url.hostname, 
            // TODO: maybe an option to choose to target off of mobile/tablet/desktop or just mobile/desktop
            device: isTablet ? 'tablet' : isMobile.any() ? 'mobile' : 'desktop' }, Builder.overrideUserAttributes);
    };
    Builder.prototype.setUserAttributes = function (options) {
        assign(Builder.overrideUserAttributes, options);
        this.userAttributesChanged.next(options);
    };
    /**
     * Set user attributes just for tracking purposes.
     *
     * Do this so properties exist on event objects for querying insights, but
     * won't affect targeting
     *
     * Use this when you want to track properties but don't need to target off
     * of them to optimize cache efficiency
     */
    Builder.prototype.setTrackingUserAttributes = function (attributes) {
        assign(this.trackingUserAttributes, attributes);
    };
    Builder.prototype.get = function (modelName, options) {
        if (options === void 0) { options = {}; }
        var instance = this;
        if (!Builder.isBrowser) {
            instance = new Builder(options.apiKey || this.apiKey, options.req, options.res, undefined, options.authToken || this.authToken);
            instance.setUserAttributes(this.getUserAttributes());
        }
        else {
            if (options.apiKey && !this.apiKey) {
                this.apiKey = options.apiKey;
            }
            if (options.authToken && !this.authToken) {
                this.authToken = options.authToken;
            }
        }
        return instance.queueGetContent(modelName, options).map(
        /* map( */ function (matches) {
            var match = matches && matches[0];
            if (Builder.isStatic) {
                return match;
            }
            var matchData = match && match.data;
            if (!matchData) {
                return null;
            }
            if (typeof matchData.blocksString !== 'undefined') {
                matchData.blocks = JSON.parse(matchData.blocksString);
                delete matchData.blocksString;
            }
            return {
                // TODO: add ab test info here and other high level stuff
                data: matchData,
                id: match.id,
                variationId: match.testVariationId || match.variationId || null,
                testVariationId: match.testVariationId || match.variationId || null,
                testVariationName: match.testVariationName || null,
                lastUpdated: match.lastUpdated || null,
            };
        });
        // );
    };
    // TODO: entry id in options
    Builder.prototype.queueGetContent = function (modelName, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        // TODO: if query do modelName + query
        var key = options.key ||
            options.alias ||
            // TODO: SDKs only pass entry key when given to them, and never when editing...
            // options.entry ||
            // TODO: this is ugly - instead of multiple of same model with different options are sent
            // say requires key/alias. Or if not perhaps make a reliable hash of the options and use that.
            // TODO: store last user state on last request and if user attributes different now
            // give a warning that need to use keys to request new contente
            // (options &&
            //   Object.keys(options).filter(key => key !== 'model').length &&
            //   JSON.stringify({ model: modelName, ...options, initialContent: undefined })) ||
            modelName;
        var isEditingThisModel = this.editingModel === modelName;
        // TODO: include params in this key........
        var currentObservable = this.observersByKey[key];
        // if (options.query && options.query._id) {
        //   this.flushGetContentQueue([options])
        // }
        if (this.apiKey === 'DEMO' && !this.overrides[key] && !options.initialContent) {
            options.initialContent = [];
        }
        var initialContent = options.initialContent;
        // TODO: refresh option in options
        if (currentObservable && (!currentObservable.value || options.cache)) {
            // TODO: test if this ran, otherwise on 404 some observers may never be called...
            if (currentObservable.value) {
                nextTick(function () {
                    // TODO: return a new observable and only that one fires subscribers, don't refire for existing ones
                    currentObservable.next(currentObservable.value);
                });
            }
            return currentObservable;
        }
        if (isEditingThisModel) {
            if (Builder.isBrowser) {
                parent.postMessage({ type: 'builder.updateContent', data: { options: options } }, '*');
            }
        }
        if (!initialContent /* || isEditingThisModel */) {
            if (!this.getContentQueue) {
                this.getContentQueue = [];
            }
            this.getContentQueue.push((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, options), { model: modelName, key: key }));
            if (this.getContentQueue && this.getContentQueue.length >= this.contentPerRequest) {
                var queue_1 = this.getContentQueue.slice();
                this.getContentQueue = [];
                nextTick(function () {
                    _this.flushGetContentQueue(false, queue_1);
                });
            }
            else {
                nextTick(function () {
                    _this.flushGetContentQueue();
                });
            }
        }
        var observable = new BehaviorSubject(null);
        this.observersByKey[key] = observable;
        if (options.noEditorUpdates) {
            this.noEditorUpdates[key] = true;
        }
        if (initialContent) {
            nextTick(function () {
                // TODO: need to testModify this I think...?
                observable.next(initialContent);
            });
        }
        return observable;
    };
    Object.defineProperty(Builder.prototype, "host", {
        get: function () {
            switch (this.env) {
                case 'qa':
                    return 'https://qa.builder.io';
                case 'test':
                    return 'https://builder-io-test.web.app';
                case 'fast':
                    return 'https://fast.builder.io';
                case 'cloud':
                    return 'https://cloud.builder.io';
                case 'cdn2':
                    return 'https://cdn2.builder.io';
                case 'cdn-qa':
                    return 'https://cdn-qa.builder.io';
                case 'development':
                case 'dev':
                    return 'http://localhost:5000';
                case 'cdn-prod':
                    return 'https://cdn.builder.io';
                default:
                    return Builder.overrideHost || 'https://cdn.builder.io';
            }
        },
        enumerable: false,
        configurable: true
    });
    Builder.prototype.flushGetContentQueue = function (usePastQueue, useQueue) {
        var _this = this;
        if (usePastQueue === void 0) { usePastQueue = false; }
        if (!this.apiKey) {
            throw new Error("Fetching content failed, expected apiKey to be defined instead got: ".concat(this.apiKey));
        }
        if (!usePastQueue && !this.getContentQueue) {
            return;
        }
        var queue = useQueue || (usePastQueue ? this.priorContentQueue : this.getContentQueue) || [];
        // TODO: do this on every request send?
        this.getOverridesFromQueryString();
        var queryParams = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ 
            // TODO: way to force a request to be in a separate queue. or just lower queue limit to be 1 by default
            omit: queue[0].omit || 'meta.componentsUsed', apiKey: this.apiKey }, queue[0].options), this.queryOptions);
        if (queue[0].fields) {
            queryParams.fields = queue[0].fields;
        }
        if (queue[0].format) {
            queryParams.format = queue[0].format;
        }
        var pageQueryParams = typeof location !== 'undefined'
            ? QueryString.parseDeep(location.search.substr(1))
            :  false || {};
        var userAttributes = 
        // FIXME: HACK: only checks first in queue for user attributes overrides, should check all
        // TODO: merge user attributes provided here with defaults and current user attiributes (?)
        queue && queue[0].userAttributes
            ? queue[0].userAttributes
            : this.targetContent
                ? this.getUserAttributes()
                : {
                    urlPath: this.getLocation().pathname,
                };
        var fullUrlQueueItem = queue.find(function (item) { return !!item.includeUrl; });
        if (fullUrlQueueItem) {
            var location_1 = this.getLocation();
            if (location_1.origin) {
                queryParams.url = "".concat(location_1.origin).concat(location_1.pathname).concat(location_1.search);
            }
        }
        var urlQueueItem = useQueue === null || useQueue === void 0 ? void 0 : useQueue.find(function (item) { return item.url; });
        if (urlQueueItem === null || urlQueueItem === void 0 ? void 0 : urlQueueItem.url) {
            userAttributes.urlPath = urlQueueItem.url.split('?')[0];
        }
        // TODO: merge in the attribute from query string ones
        // TODO: make this an option per component/request
        queryParams.userAttributes = userAttributes;
        if (!usePastQueue && !useQueue) {
            this.priorContentQueue = queue;
            this.getContentQueue = null;
        }
        var cachebust = this.cachebust ||
            isIframe ||
            pageQueryParams.cachebust ||
            pageQueryParams['builder.cachebust'];
        if (cachebust || this.env !== 'production') {
            queryParams.cachebust = true;
        }
        if (Builder.isEditing) {
            queryParams.isEditing = true;
        }
        if (this.noCache || this.env !== 'production') {
            queryParams.noCache = true;
        }
        if (size(this.overrides)) {
            for (var key in this.overrides) {
                if (this.overrides.hasOwnProperty(key)) {
                    queryParams["overrides.".concat(key)] = this.overrides[key];
                }
            }
        }
        if (!Builder.isReact) {
            // TODO: remove me once v1 page editors converted to v2
            // queryParams.extractCss = true;
            queryParams.prerender = true;
        }
        for (var _i = 0, queue_2 = queue; _i < queue_2.length; _i++) {
            var options = queue_2[_i];
            if (options.format) {
                queryParams.format = options.format;
            }
            // TODO: remove me and make permodel
            if (options.static) {
                queryParams.static = options.static;
            }
            if (options.cachebust) {
                queryParams.cachebust = options.cachebust;
            }
            if (isPositiveNumber(options.cacheSeconds)) {
                queryParams.cacheSeconds = options.cacheSeconds;
            }
            if (isPositiveNumber(options.staleCacheSeconds)) {
                queryParams.staleCacheSeconds = options.staleCacheSeconds;
            }
            var properties = [
                'prerender',
                'extractCss',
                'limit',
                'offset',
                'query',
                'preview',
                'model',
                'entry',
                'rev',
                'static',
            ];
            for (var _a = 0, properties_1 = properties; _a < properties_1.length; _a++) {
                var key = properties_1[_a];
                var value = options[key];
                if (value !== undefined) {
                    queryParams.options = queryParams.options || {};
                    queryParams.options[options.key] = queryParams.options[options.key] || {};
                    queryParams.options[options.key][key] = JSON.stringify(value);
                }
            }
        }
        if (this.preview) {
            queryParams.preview = 'true';
        }
        var hasParams = Object.keys(queryParams).length > 0;
        // TODO: option to force dev or qa api here
        var host = this.host;
        var keyNames = queue.map(function (item) { return encodeURIComponent(item.key); }).join(',');
        if (this.overrideParams) {
            var params = omit(QueryString.parse(this.overrideParams), 'apiKey');
            assign(queryParams, params);
        }
        var queryStr = QueryString.stringifyDeep(queryParams);
        var format = queryParams.format;
        var requestOptions = { headers: {} };
        if (this.authToken) {
            requestOptions.headers = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, requestOptions.headers), { Authorization: "Bearer ".concat(this.authToken) });
        }
        var fn = format === 'solid' || format === 'react' ? 'codegen' : 'query';
        var url = "".concat(host, "/api/v1/").concat(fn, "/").concat(this.apiKey, "/").concat(keyNames) +
            (queryParams && hasParams ? "?".concat(queryStr) : '');
        var promise = fetch(url, requestOptions)
            .then(function (res) { return res.json(); })
            .then(function (result) {
            for (var _i = 0, queue_3 = queue; _i < queue_3.length; _i++) {
                var options = queue_3[_i];
                var keyName = options.key;
                if (options.model === _this.blockContentLoading && !options.noEditorUpdates) {
                    continue;
                }
                var isEditingThisModel = _this.editingModel === options.model;
                if (isEditingThisModel && Builder.isEditing) {
                    parent.postMessage({ type: 'builder.updateContent', data: { options: options } }, '*');
                    // return;
                }
                var observer = _this.observersByKey[keyName];
                if (!observer) {
                    return;
                }
                var data = result[keyName];
                var sorted = data; // sortBy(data, item => item.priority);
                if (data) {
                    var testModifiedResults = Builder.isServer
                        ? sorted
                        : _this.processResultsForTests(sorted);
                    observer.next(testModifiedResults);
                }
                else {
                    var search = _this.getLocation().search;
                    if ((search || '').includes('builder.preview=' + options.model)) {
                        var previewData = {
                            id: 'preview',
                            name: 'Preview',
                            data: {},
                        };
                        observer.next([previewData]);
                    }
                    observer.next([]);
                }
            }
        }, function (err) {
            for (var _i = 0, queue_4 = queue; _i < queue_4.length; _i++) {
                var options = queue_4[_i];
                var observer = _this.observersByKey[options.key];
                if (!observer) {
                    return;
                }
                observer.error(err);
            }
        });
        return promise;
    };
    Builder.prototype.processResultsForTests = function (results) {
        var _this = this;
        var _a;
        var mappedResults = results.map(function (item) {
            if (!item.variations) {
                return item;
            }
            var cookieValue = _this.getTestCookie(item.id);
            var cookieVariation = cookieValue === item.id ? item : item.variations[cookieValue];
            if (cookieVariation) {
                return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, item), { data: cookieVariation.data, variationId: cookieValue, testVariationId: cookieValue, testVariationName: cookieVariation.name });
            }
            if (_this.canTrack && item.variations && size(item.variations)) {
                var n = 0;
                var random = Math.random();
                for (var id in item.variations) {
                    var variation = item.variations[id];
                    var testRatio = variation.testRatio;
                    n += testRatio;
                    if (random < n) {
                        _this.setTestCookie(item.id, variation.id);
                        var variationName = variation.name || (variation.id === item.id ? 'Default variation' : '');
                        return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, item), { data: variation.data, variationId: variation.id, testVariationId: variation.id, variationName: variationName, testVariationName: variationName });
                    }
                }
                _this.setTestCookie(item.id, item.id);
            }
            return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, item), { variationId: item.id }), (item.variations &&
                size(item.variations) && {
                testVariationId: item.id,
                testVariationName: 'Default variation',
            }));
        });
        if (isIframe) {
            (_a = window.parent) === null || _a === void 0 ? void 0 : _a.postMessage({ type: 'builder.contentResults', data: { results: mappedResults } }, '*');
        }
        return mappedResults;
    };
    Builder.prototype.getTestCookie = function (contentId) {
        return this.getCookie("".concat(this.testCookiePrefix, ".").concat(contentId));
    };
    Builder.prototype.setTestCookie = function (contentId, variationId) {
        if (!this.canTrack) {
            this.cookieQueue.push([contentId, variationId]);
            return;
        }
        // 30 days from now
        var future = new Date();
        future.setDate(future.getDate() + 30);
        return this.setCookie("".concat(this.testCookiePrefix, ".").concat(contentId), variationId, future);
    };
    Builder.prototype.getCookie = function (name$$1) {
        if (this.cookies) {
            return this.cookies.get(name$$1);
        }
        return Builder.isBrowser && getCookie(name$$1);
    };
    Builder.prototype.setCookie = function (name$$1, value, expires) {
        if (this.cookies && !(Builder.isServer && Builder.isStatic)) {
            return this.cookies.set(name$$1, value, {
                expires: expires,
                secure: this.getLocation().protocol === 'https:',
            });
        }
        return Builder.isBrowser && setCookie(name$$1, value, expires);
    };
    Builder.prototype.getContent = function (modelName, options) {
        if (options === void 0) { options = {}; }
        if (!this.apiKey) {
            throw new Error("Fetching content from model ".concat(modelName, " failed, expected apiKey to be defined instead got: ").concat(this.apiKey));
        }
        return this.queueGetContent(modelName, options);
    };
    Builder.prototype.getAll = function (modelName, options) {
        if (options === void 0) { options = {}; }
        var instance = this;
        if (!Builder.isBrowser) {
            instance = new Builder(options.apiKey || this.apiKey, options.req, options.res);
            instance.setUserAttributes(this.getUserAttributes());
        }
        else {
            if (options.apiKey && !this.apiKey) {
                this.apiKey = options.apiKey;
            }
        }
        return instance
            .getContent(modelName, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ limit: 30 }, options), { key: options.key ||
                // Make the key include all options so we don't reuse cache for the same conent fetched
                // with different options
                Builder.isBrowser
                ? "".concat(modelName, ":").concat(hash_sum__WEBPACK_IMPORTED_MODULE_0___default()(omit(options, 'initialContent', 'req', 'res')))
                : undefined }))
            .promise();
    };
    /**
     * @hidden
     * @deprecated. This is buggy, and always behind by a version.
     */
    Builder.VERSION = version;
    Builder.components = [];
    /**
     * Makes it so that a/b tests generate code like {@link
     * https://www.builder.io/blog/high-performance-no-code#__next:~:text=Static%20generated%20A%2FB%20testing}
     * instead of the old way where we render only one test group at a time on the
     * server. This is the preferred/better way not and we should ultimately make it
     * the default
     */
    Builder.isStatic = true;
    Builder.animator = new Animator();
    Builder.nextTick = nextTick;
    Builder.throttle = throttle;
    Builder.editors = [];
    Builder.trustedHosts = ['builder.io', 'localhost'];
    Builder.plugins = [];
    Builder.actions = [];
    Builder.registry = {};
    Builder.registryChange = new BehaviorSubject({});
    Builder._editingPage = false;
    Builder.isIframe = isIframe;
    Builder.isBrowser = isBrowser;
    Builder.isReactNative = isReactNative;
    Builder.isServer = !isBrowser && !isReactNative;
    Builder.previewingModel = Builder.isBrowser && getQueryParam(location.href, 'builder.preview');
    Builder.settings = {};
    Builder.settingsChange = new BehaviorSubject({});
    // TODO: this is quick and dirty, do better implementation later. Also can be unreliable
    // if page 301s etc. Use a query param instead? also could have issues with redirects. Injecting var could
    // work but is async...
    Builder.isEditing = Boolean(isIframe &&
        ((document.referrer && document.referrer.match(/builder\.io|localhost:1234/)) ||
            location.search.indexOf('builder.frameEditing=') !== -1));
    Builder.isPreviewing = Boolean(isBrowser &&
        (location.search.indexOf('builder.preview=') !== -1 ||
            location.search.indexOf('builder.frameEditing=') !== -1));
    Builder.isReact = false;
    Builder.overrideUserAttributes = {};
    return Builder;
}());

var builder = new Builder(null, undefined, undefined, true);
Builder.singletonInstance = builder;


//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 69257:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.extendAsyncProps = void 0;
const traverse_1 = __importDefault(__webpack_require__(7917));
function extendAsyncProps(content, mappers) {
    return __awaiter(this, void 0, void 0, function* () {
        const promises = [];
        traverse_1.default(content).forEach(function (field) {
            const isComponentOptions = ['component.options', 'symbol.data'].includes(this.path.slice(-2).join('.'));
            if (field && isComponentOptions) {
                const keys = Object.keys(field);
                keys.forEach(key => {
                    const mapper = mappers[key];
                    if (mapper) {
                        promises.push(mapper(field).then(result => {
                            this.update(Object.assign(Object.assign({}, field), result));
                        }));
                    }
                });
            }
        });
        yield Promise.all(promises);
        return content;
    });
}
exports.extendAsyncProps = extendAsyncProps;


/***/ }),

/***/ 39000:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getAsyncProps = exports.isBuilderElement = void 0;
const traverse_1 = __importDefault(__webpack_require__(7917));
const isBuilderElement = (item) => {
    var _a;
    return Boolean(((_a = item) === null || _a === void 0 ? void 0 : _a['@type']) === '@builder.io/sdk:Element');
};
exports.isBuilderElement = isBuilderElement;
function getAsyncProps(content, mappers) {
    return __awaiter(this, void 0, void 0, function* () {
        const promises = [];
        traverse_1.default(content).forEach(item => {
            if (exports.isBuilderElement(item)) {
                if (item.component) {
                    const mapper = mappers[item.component.name];
                    if (mapper) {
                        promises.push(mapper(item.component.options, item).then(result => {
                            Object.assign(item.component.options, result);
                        }));
                    }
                }
            }
        });
        yield Promise.all(promises);
        return content;
    });
}
exports.getAsyncProps = getAsyncProps;


/***/ }),

/***/ 31258:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(39000), exports);
__exportStar(__webpack_require__(69257), exports);
__exportStar(__webpack_require__(68812), exports);
__exportStar(__webpack_require__(52270), exports);


/***/ }),

/***/ 68812:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.transformComponents = void 0;
const traverse_1 = __importDefault(__webpack_require__(7917));
const isBuilderElement = (item) => {
    var _a;
    return Boolean(((_a = item) === null || _a === void 0 ? void 0 : _a['@type']) === '@builder.io/sdk:Element');
};
function transformComponents(content, mappers) {
    return traverse_1.default(content).map(function (item) {
        var _a;
        if (isBuilderElement(item)) {
            if (item.component) {
                const mapper = mappers[item.component.name];
                if (mapper) {
                    this.update(Object.assign(Object.assign(Object.assign(Object.assign({}, item), (((_a = item.code) === null || _a === void 0 ? void 0 : _a.bindings) ? {
                        code: Object.assign(Object.assign({}, item.code), { bindings: Object.assign(Object.assign({}, item.code.bindings), Object.keys(mapper.props).reduce((acc, key) => {
                                const binding = item.code.bindings[`component.options.${mapper.props[key]}`];
                                if (binding) {
                                    return Object.assign(Object.assign({}, acc), { [key]: binding });
                                }
                                return acc;
                            }, {})) }),
                    }
                        : {})), (item.bindings
                        ? {
                            bindings: Object.assign(Object.assign({}, item.bindings), Object.keys(mapper.props).reduce((acc, key) => {
                                const binding = item.bindings[`component.options.${mapper.props[key]}`];
                                if (binding) {
                                    return Object.assign(Object.assign({}, acc), { [key]: binding });
                                }
                                return acc;
                            }, {})),
                        }
                        : {})), { component: Object.assign(Object.assign({}, item.component), { name: mapper.name, options: Object.keys(mapper.props).reduce((acc, key) => {
                                var _a;
                                return Object.assign(Object.assign({}, acc), { [key]: (_a = item.component) === null || _a === void 0 ? void 0 : _a.options[mapper.props[key]] });
                            }, {}) }) }));
                }
            }
        }
    });
}
exports.transformComponents = transformComponents;


/***/ }),

/***/ 52270:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.applyTranslation = exports.getTranslateableFields = exports.localizedType = void 0;
const traverse_1 = __importDefault(__webpack_require__(7917));
const omit_1 = __importDefault(__webpack_require__(13110));
const unescape_1 = __importDefault(__webpack_require__(16561));
exports.localizedType = '@builder.io/core:LocalizedValue';
function getTranslateableFields(content, sourceLocaleId, defaultInstructions) {
    const results = {};
    let _a = content.data, { blocks, blocksString, state } = _a, customFields = __rest(_a, ["blocks", "blocksString", "state"]);
    if (typeof blocks === 'undefined') {
        blocks = JSON.parse(blocksString);
    }
    // metadata [content's localized custom fields]
    traverse_1.default(customFields).forEach(function (el) {
        var _a;
        if (this.key && el && el['@type'] === exports.localizedType) {
            results[`metadata.${this.path.join('#')}`] = {
                instructions: ((_a = el.meta) === null || _a === void 0 ? void 0 : _a.instructions) || defaultInstructions,
                value: el[sourceLocaleId] || el.Default,
            };
        }
    });
    // blocks
    traverse_1.default(blocks).forEach(function (el) {
        var _a, _b, _c, _d;
        if (this.key && el && ((_a = el.meta) === null || _a === void 0 ? void 0 : _a.localizedTextInputs)) {
            const localizedTextInputs = el.meta.localizedTextInputs;
            if (localizedTextInputs && Array.isArray(localizedTextInputs)) {
                localizedTextInputs
                    .filter(input => { var _a, _b, _c; return ((_c = (_b = (_a = el.component) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b[input]) === null || _c === void 0 ? void 0 : _c['@type']) === exports.localizedType; })
                    .forEach(inputKey => {
                    var _a, _b, _c, _d, _e;
                    const valueToBeTranslated = ((_b = (_a = el.component.options) === null || _a === void 0 ? void 0 : _a[inputKey]) === null || _b === void 0 ? void 0 : _b[sourceLocaleId]) || ((_d = (_c = el.component.options) === null || _c === void 0 ? void 0 : _c[inputKey]) === null || _d === void 0 ? void 0 : _d.Default);
                    if (valueToBeTranslated) {
                        results[`blocks.${el.id}#${inputKey}`] = {
                            instructions: ((_e = el.meta) === null || _e === void 0 ? void 0 : _e.instructions) || defaultInstructions,
                            value: valueToBeTranslated,
                        };
                    }
                });
            }
        }
        if (el && el.id && ((_b = el.component) === null || _b === void 0 ? void 0 : _b.name) === 'Text' && !((_c = el.meta) === null || _c === void 0 ? void 0 : _c.excludeFromTranslation)) {
            results[`blocks.${el.id}#text`] = {
                value: el.component.options.text,
                instructions: ((_d = el.meta) === null || _d === void 0 ? void 0 : _d.instructions) || defaultInstructions,
            };
        }
    });
    return results;
}
exports.getTranslateableFields = getTranslateableFields;
function applyTranslation(content, translation, locale) {
    let _a = content.data, { blocks, blocksString, state } = _a, customFields = __rest(_a, ["blocks", "blocksString", "state"]);
    if (typeof blocks === 'undefined') {
        blocks = JSON.parse(blocksString);
    }
    traverse_1.default(customFields).forEach(function (el) {
        var _a;
        const path = (_a = this.path) === null || _a === void 0 ? void 0 : _a.join('#');
        if (translation[`metadata.${path}`]) {
            this.update(Object.assign(Object.assign({}, el), { [locale]: unescape_1.default(translation[`metadata.${path}`].value) }));
        }
    });
    traverse_1.default(blocks).forEach(function (el) {
        var _a, _b, _c, _d;
        if (el &&
            el.id &&
            ((_a = el.component) === null || _a === void 0 ? void 0 : _a.name) === 'Text' &&
            !((_b = el.meta) === null || _b === void 0 ? void 0 : _b.excludeFromTranslation) &&
            translation[`blocks.${el.id}#text`]) {
            this.update(Object.assign(Object.assign({}, el), { meta: Object.assign(Object.assign({}, el.meta), { translated: true }), bindings: Object.assign(Object.assign({}, el.bindings), { 'component.options.text': `state.translation['blocks.${el.id}#text'][state.locale || 'Default'] || \`${el.component.options.text}\`` }) }));
        }
        // custom components
        if (el && el.id && ((_c = el.meta) === null || _c === void 0 ? void 0 : _c.localizedTextInputs)) {
            // there's a localized input
            const keys = (_d = el.meta) === null || _d === void 0 ? void 0 : _d.localizedTextInputs;
            keys.forEach(key => {
                if (translation[`blocks.${el.id}#${key}`]) {
                    this.update(Object.assign(Object.assign({}, el), { meta: Object.assign(Object.assign({}, el.meta), { translated: true }), component: Object.assign(Object.assign({}, el.component), { options: Object.assign(Object.assign({}, el.component.options), { [key]: Object.assign(Object.assign({}, el.component.options[key]), { [locale]: unescape_1.default(translation[`blocks.${el.id}#${key}`].value) }) }) }) }));
                }
            });
        }
    });
    const translationState = Object.keys(translation).reduce((acc, key) => {
        var _a, _b;
        if (key.startsWith('blocks.')) {
            return Object.assign(Object.assign({}, acc), { [key]: Object.assign(Object.assign({ '@type': exports.localizedType }, (_b = (_a = content.data.state) === null || _a === void 0 ? void 0 : _a.translation) === null || _b === void 0 ? void 0 : _b[key]), { [locale]: unescape_1.default(translation[key].value) }) });
        }
        return acc;
    }, {});
    content.data.state = Object.assign(Object.assign({}, content.data.state), { translation: translationState });
    content.data = Object.assign(Object.assign(Object.assign({}, omit_1.default(content.data, 'blocksString')), { blocks }), customFields);
    return content;
}
exports.applyTranslation = applyTranslation;


/***/ }),

/***/ 12520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ms": function() { return /* binding */ ClassNames; },
  "iv": function() { return /* reexport */ css_browser_esm; },
  "tZ": function() { return /* binding */ jsx; }
});

// UNUSED EXPORTS: CacheProvider, Global, ThemeContext, createElement, keyframes, withEmotionCache

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(62991);
;// CONCATENATED MODULE: ./node_modules/@emotion/sheet/dist/sheet.browser.esm.js
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ./node_modules/@emotion/stylis/dist/stylis.browser.esm.js
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ var stylis_browser_esm = (stylis_min);

;// CONCATENATED MODULE: ./node_modules/@emotion/cache/dist/cache.browser.esm.js




// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new stylis_browser_esm(stylisOptions);

  if (false) {}

  var inserted = {}; // $FlowFixMe

  var container;

  {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (false) { var map; }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  }

  if (false) { var commentEnd, commentStart; }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

/* harmony default export */ var cache_browser_esm = (createCache);

;// CONCATENATED MODULE: ./node_modules/@emotion/utils/dist/utils.browser.esm.js
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};



;// CONCATENATED MODULE: ./node_modules/@emotion/hash/dist/hash.browser.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ var hash_browser_esm = (murmur2);

;// CONCATENATED MODULE: ./node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var unitless_browser_esm = (unitlessKeys);

;// CONCATENATED MODULE: ./node_modules/@emotion/memoize/dist/memoize.browser.esm.js
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var memoize_browser_esm = (memoize);

;// CONCATENATED MODULE: ./node_modules/@emotion/serialize/dist/serialize.browser.esm.js




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = memoize_browser_esm(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitless_browser_esm[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];

  if (false) {}

  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serialize_browser_esm_serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = hash_browser_esm(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};



;// CONCATENATED MODULE: ./node_modules/@emotion/core/dist/emotion-element-57a3a7a3.browser.esm.js






var emotion_element_57a3a7a3_browser_esm_hasOwnProperty = Object.prototype.hasOwnProperty;

var EmotionCacheContext = /*#__PURE__*/(0,react.createContext)( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? cache_browser_esm() : null);
var emotion_element_57a3a7a3_browser_esm_ThemeContext = /*#__PURE__*/(0,react.createContext)({});
var CacheProvider = EmotionCacheContext.Provider;

var emotion_element_57a3a7a3_browser_esm_withEmotionCache = function withEmotionCache(func) {
  var render = function render(props, ref) {
    return /*#__PURE__*/(0,react.createElement)(EmotionCacheContext.Consumer, null, function (cache) {
      return func(props, cache, ref);
    });
  }; // $FlowFixMe


  return /*#__PURE__*/(0,react.forwardRef)(render);
};

// thus we only need to replace what is a valid character for JS, but not for CSS

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {}

  var newProps = {};

  for (var key in props) {
    if (emotion_element_57a3a7a3_browser_esm_hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // TODO: check if this still works with all of those different JSX functions

  if (false) { var match, error; }

  return newProps;
};

var render = function render(cache, props, theme, ref) {
  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serialize_browser_esm_serializeStyles(registeredStyles);

  if (false) { var labelFromStack; }

  var rules = insertStyles(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (emotion_element_57a3a7a3_browser_esm_hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ( true || 0)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = /*#__PURE__*/(0,react.createElement)(type, newProps);

  return ele;
}; // eslint-disable-next-line no-undef


var Emotion = /* #__PURE__ */emotion_element_57a3a7a3_browser_esm_withEmotionCache(function (props, cache, ref) {
  if (typeof props.css === 'function') {
    return /*#__PURE__*/(0,react.createElement)(emotion_element_57a3a7a3_browser_esm_ThemeContext.Consumer, null, function (theme) {
      return render(cache, props, theme, ref);
    });
  }

  return render(cache, props, null, ref);
});

if (false) {}



;// CONCATENATED MODULE: ./node_modules/@emotion/css/dist/css.browser.esm.js


function css_browser_esm_css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serialize_browser_esm_serializeStyles(args);
}

/* harmony default export */ var css_browser_esm = (css_browser_esm_css);

;// CONCATENATED MODULE: ./node_modules/@emotion/core/dist/core.browser.esm.js











var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !emotion_element_57a3a7a3_browser_esm_hasOwnProperty.call(props, 'css')) {
    // $FlowFixMe
    return react.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return react.createElement.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false;
var Global = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache) {
  if (false) {}

  var styles = props.styles;

  if (typeof styles === 'function') {
    return /*#__PURE__*/createElement(ThemeContext.Consumer, null, function (theme) {
      var serialized = serializeStyles([styles(theme)]);
      return /*#__PURE__*/createElement(InnerGlobal, {
        serialized: serialized,
        cache: cache
      });
    });
  }

  var serialized = serializeStyles([styles]);
  return /*#__PURE__*/createElement(InnerGlobal, {
    serialized: serialized,
    cache: cache
  });
})));

// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var InnerGlobal = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InnerGlobal, _React$Component);

  function InnerGlobal(props, context, updater) {
    return _React$Component.call(this, props, context, updater) || this;
  }

  var _proto = InnerGlobal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.sheet = new StyleSheet({
      key: this.props.cache.key + "-global",
      nonce: this.props.cache.sheet.nonce,
      container: this.props.cache.sheet.container
    }); // $FlowFixMe

    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");

    if (node !== null) {
      this.sheet.tags.push(node);
    }

    if (this.props.cache.sheet.tags.length) {
      this.sheet.before = this.props.cache.sheet.tags[0];
    }

    this.insertStyles();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.serialized.name !== this.props.serialized.name) {
      this.insertStyles();
    }
  };

  _proto.insertStyles = function insertStyles$1() {
    if (this.props.serialized.next !== undefined) {
      // insert keyframes
      insertStyles(this.props.cache, this.props.serialized.next, true);
    }

    if (this.sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
      this.sheet.before = element;
      this.sheet.flush();
    }

    this.props.cache.insert("", this.props.serialized, this.sheet, false);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.sheet.flush();
  };

  _proto.render = function render() {

    return null;
  };

  return InnerGlobal;
}(react.Component);

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var ClassNames = emotion_element_57a3a7a3_browser_esm_withEmotionCache(function (props, context) {
  return /*#__PURE__*/(0,react.createElement)(emotion_element_57a3a7a3_browser_esm_ThemeContext.Consumer, null, function (theme) {
    var hasRendered = false;

    var css = function css() {
      if (hasRendered && "production" !== 'production') {}

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var serialized = serialize_browser_esm_serializeStyles(args, context.registered);

      {
        insertStyles(context, serialized, false);
      }

      return context.key + "-" + serialized.name;
    };

    var cx = function cx() {
      if (hasRendered && "production" !== 'production') {}

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return merge(context.registered, css, classnames(args));
    };

    var content = {
      css: css,
      cx: cx,
      theme: theme
    };
    var ele = props.children(content);
    hasRendered = true;

    return ele;
  });
});




/***/ }),

/***/ 14172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useGSAP; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62991);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30334);
/*!
 * @gsap/react 2.1.1
 * https://gsap.com
 *
 * Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
/* eslint-disable */



let useIsomorphicLayoutEffect = typeof window !== "undefined" ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect,
    isConfig = value => value && !Array.isArray(value) && typeof(value) === "object",
    emptyArray = [],
    defaultConfig = {},
    _gsap = gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP; // accommodates situations where different versions of GSAP may be loaded, so a user can gsap.registerPlugin(useGSAP);

const useGSAP = (callback, dependencies = emptyArray) => {
  let config = defaultConfig;
  if (isConfig(callback)) {
    config = callback;
    callback = null;
    dependencies = "dependencies" in config ? config.dependencies : emptyArray;
  } else if (isConfig(dependencies)) {
    config = dependencies;
    dependencies = "dependencies" in config ? config.dependencies : emptyArray;
  }
  (callback && typeof callback !== "function") && console.warn("First parameter must be a function or config object");
  const { scope, revertOnUpdate } = config,
        mounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false),
        context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(_gsap.context(() => { }, scope)),
        contextSafe = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)((func) => context.current.add(null, func)),
        deferCleanup = dependencies && dependencies.length && !revertOnUpdate;
  useIsomorphicLayoutEffect(() => {
    callback && context.current.add(callback, scope);
    if (!deferCleanup || !mounted.current) { // React renders bottom-up, thus there could be hooks with dependencies that run BEFORE the component mounts, thus cleanup wouldn't occur since a hook with an empty dependency Array would only run once the component mounts.
      return () => context.current.revert();
    }
  }, dependencies);
  deferCleanup && useIsomorphicLayoutEffect(() => {
      mounted.current = true;
      return () => context.current.revert();
    }, emptyArray);
  return { context: context.current, contextSafe: contextSafe.current };
};
useGSAP.register = core => { _gsap = core; };
useGSAP.headless = true; // doesn't require the window to be registered.


/***/ }),

/***/ 41806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/*! @vimeo/player v2.16.2 | (c) 2021 Vimeo | MIT License | https://github.com/vimeo/player.js */
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/**
 * @module lib/functions
 */

/**
 * Check to see this is a node environment.
 * @type {Boolean}
 */

/* global global */
var isNode = typeof __webpack_require__.g !== 'undefined' && {}.toString.call(__webpack_require__.g) === '[object global]';
/**
 * Get the name of the method for a given getter or setter.
 *
 * @param {string} prop The name of the property.
 * @param {string} type Either “get” or “set”.
 * @return {string}
 */

function getMethodName(prop, type) {
  if (prop.indexOf(type.toLowerCase()) === 0) {
    return prop;
  }

  return "".concat(type.toLowerCase()).concat(prop.substr(0, 1).toUpperCase()).concat(prop.substr(1));
}
/**
 * Check to see if the object is a DOM Element.
 *
 * @param {*} element The object to check.
 * @return {boolean}
 */

function isDomElement(element) {
  return Boolean(element && element.nodeType === 1 && 'nodeName' in element && element.ownerDocument && element.ownerDocument.defaultView);
}
/**
 * Check to see whether the value is a number.
 *
 * @see http://dl.dropboxusercontent.com/u/35146/js/tests/isNumber.html
 * @param {*} value The value to check.
 * @param {boolean} integer Check if the value is an integer.
 * @return {boolean}
 */

function isInteger(value) {
  // eslint-disable-next-line eqeqeq
  return !isNaN(parseFloat(value)) && isFinite(value) && Math.floor(value) == value;
}
/**
 * Check to see if the URL is a Vimeo url.
 *
 * @param {string} url The url string.
 * @return {boolean}
 */

function isVimeoUrl(url) {
  return /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(url);
}
/**
 * Get the Vimeo URL from an element.
 * The element must have either a data-vimeo-id or data-vimeo-url attribute.
 *
 * @param {object} oEmbedParameters The oEmbed parameters.
 * @return {string}
 */

function getVimeoUrl() {
  var oEmbedParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = oEmbedParameters.id;
  var url = oEmbedParameters.url;
  var idOrUrl = id || url;

  if (!idOrUrl) {
    throw new Error('An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.');
  }

  if (isInteger(idOrUrl)) {
    return "https://vimeo.com/".concat(idOrUrl);
  }

  if (isVimeoUrl(idOrUrl)) {
    return idOrUrl.replace('http:', 'https:');
  }

  if (id) {
    throw new TypeError("\u201C".concat(id, "\u201D is not a valid video id."));
  }

  throw new TypeError("\u201C".concat(idOrUrl, "\u201D is not a vimeo.com url."));
}

var arrayIndexOfSupport = typeof Array.prototype.indexOf !== 'undefined';
var postMessageSupport = typeof window !== 'undefined' && typeof window.postMessage !== 'undefined';

if (!isNode && (!arrayIndexOfSupport || !postMessageSupport)) {
  throw new Error('Sorry, the Vimeo Player API is not available in this browser.');
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/*!
 * weakmap-polyfill v2.0.4 - ECMAScript6 WeakMap polyfill
 * https://github.com/polygonplanet/weakmap-polyfill
 * Copyright (c) 2015-2021 polygonplanet <polygon.planet.aqua@gmail.com>
 * @license MIT
 */
(function (self) {

  if (self.WeakMap) {
    return;
  }

  var hasOwnProperty = Object.prototype.hasOwnProperty;

  var hasDefine = Object.defineProperty && function () {
    try {
      // Avoid IE8's broken Object.defineProperty
      return Object.defineProperty({}, 'x', {
        value: 1
      }).x === 1;
    } catch (e) {}
  }();

  var defineProperty = function (object, name, value) {
    if (hasDefine) {
      Object.defineProperty(object, name, {
        configurable: true,
        writable: true,
        value: value
      });
    } else {
      object[name] = value;
    }
  };

  self.WeakMap = function () {
    // ECMA-262 23.3 WeakMap Objects
    function WeakMap() {
      if (this === void 0) {
        throw new TypeError("Constructor WeakMap requires 'new'");
      }

      defineProperty(this, '_id', genId('_WeakMap')); // ECMA-262 23.3.1.1 WeakMap([iterable])

      if (arguments.length > 0) {
        // Currently, WeakMap `iterable` argument is not supported
        throw new TypeError('WeakMap iterable is not supported');
      }
    } // ECMA-262 23.3.3.2 WeakMap.prototype.delete(key)


    defineProperty(WeakMap.prototype, 'delete', function (key) {
      checkInstance(this, 'delete');

      if (!isObject(key)) {
        return false;
      }

      var entry = key[this._id];

      if (entry && entry[0] === key) {
        delete key[this._id];
        return true;
      }

      return false;
    }); // ECMA-262 23.3.3.3 WeakMap.prototype.get(key)

    defineProperty(WeakMap.prototype, 'get', function (key) {
      checkInstance(this, 'get');

      if (!isObject(key)) {
        return void 0;
      }

      var entry = key[this._id];

      if (entry && entry[0] === key) {
        return entry[1];
      }

      return void 0;
    }); // ECMA-262 23.3.3.4 WeakMap.prototype.has(key)

    defineProperty(WeakMap.prototype, 'has', function (key) {
      checkInstance(this, 'has');

      if (!isObject(key)) {
        return false;
      }

      var entry = key[this._id];

      if (entry && entry[0] === key) {
        return true;
      }

      return false;
    }); // ECMA-262 23.3.3.5 WeakMap.prototype.set(key, value)

    defineProperty(WeakMap.prototype, 'set', function (key, value) {
      checkInstance(this, 'set');

      if (!isObject(key)) {
        throw new TypeError('Invalid value used as weak map key');
      }

      var entry = key[this._id];

      if (entry && entry[0] === key) {
        entry[1] = value;
        return this;
      }

      defineProperty(key, this._id, [key, value]);
      return this;
    });

    function checkInstance(x, methodName) {
      if (!isObject(x) || !hasOwnProperty.call(x, '_id')) {
        throw new TypeError(methodName + ' method called on incompatible receiver ' + typeof x);
      }
    }

    function genId(prefix) {
      return prefix + '_' + rand() + '.' + rand();
    }

    function rand() {
      return Math.random().toString().substring(2);
    }

    defineProperty(WeakMap, '_polyfill', true);
    return WeakMap;
  }();

  function isObject(x) {
    return Object(x) === x;
  }
})(typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : commonjsGlobal);

var npo_src = createCommonjsModule(function (module) {
/*! Native Promise Only
    v0.8.1 (c) Kyle Simpson
    MIT License: http://getify.mit-license.org
*/
(function UMD(name, context, definition) {
  // special form of UMD for polyfilling across evironments
  context[name] = context[name] || definition();

  if ( module.exports) {
    module.exports = context[name];
  }
})("Promise", typeof commonjsGlobal != "undefined" ? commonjsGlobal : commonjsGlobal, function DEF() {

  var builtInProp,
      cycle,
      scheduling_queue,
      ToString = Object.prototype.toString,
      timer = typeof setImmediate != "undefined" ? function timer(fn) {
    return setImmediate(fn);
  } : setTimeout; // dammit, IE8.

  try {
    Object.defineProperty({}, "x", {});

    builtInProp = function builtInProp(obj, name, val, config) {
      return Object.defineProperty(obj, name, {
        value: val,
        writable: true,
        configurable: config !== false
      });
    };
  } catch (err) {
    builtInProp = function builtInProp(obj, name, val) {
      obj[name] = val;
      return obj;
    };
  } // Note: using a queue instead of array for efficiency


  scheduling_queue = function Queue() {
    var first, last, item;

    function Item(fn, self) {
      this.fn = fn;
      this.self = self;
      this.next = void 0;
    }

    return {
      add: function add(fn, self) {
        item = new Item(fn, self);

        if (last) {
          last.next = item;
        } else {
          first = item;
        }

        last = item;
        item = void 0;
      },
      drain: function drain() {
        var f = first;
        first = last = cycle = void 0;

        while (f) {
          f.fn.call(f.self);
          f = f.next;
        }
      }
    };
  }();

  function schedule(fn, self) {
    scheduling_queue.add(fn, self);

    if (!cycle) {
      cycle = timer(scheduling_queue.drain);
    }
  } // promise duck typing


  function isThenable(o) {
    var _then,
        o_type = typeof o;

    if (o != null && (o_type == "object" || o_type == "function")) {
      _then = o.then;
    }

    return typeof _then == "function" ? _then : false;
  }

  function notify() {
    for (var i = 0; i < this.chain.length; i++) {
      notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
    }

    this.chain.length = 0;
  } // NOTE: This is a separate function to isolate
  // the `try..catch` so that other code can be
  // optimized better


  function notifyIsolated(self, cb, chain) {
    var ret, _then;

    try {
      if (cb === false) {
        chain.reject(self.msg);
      } else {
        if (cb === true) {
          ret = self.msg;
        } else {
          ret = cb.call(void 0, self.msg);
        }

        if (ret === chain.promise) {
          chain.reject(TypeError("Promise-chain cycle"));
        } else if (_then = isThenable(ret)) {
          _then.call(ret, chain.resolve, chain.reject);
        } else {
          chain.resolve(ret);
        }
      }
    } catch (err) {
      chain.reject(err);
    }
  }

  function resolve(msg) {
    var _then,
        self = this; // already triggered?


    if (self.triggered) {
      return;
    }

    self.triggered = true; // unwrap

    if (self.def) {
      self = self.def;
    }

    try {
      if (_then = isThenable(msg)) {
        schedule(function () {
          var def_wrapper = new MakeDefWrapper(self);

          try {
            _then.call(msg, function $resolve$() {
              resolve.apply(def_wrapper, arguments);
            }, function $reject$() {
              reject.apply(def_wrapper, arguments);
            });
          } catch (err) {
            reject.call(def_wrapper, err);
          }
        });
      } else {
        self.msg = msg;
        self.state = 1;

        if (self.chain.length > 0) {
          schedule(notify, self);
        }
      }
    } catch (err) {
      reject.call(new MakeDefWrapper(self), err);
    }
  }

  function reject(msg) {
    var self = this; // already triggered?

    if (self.triggered) {
      return;
    }

    self.triggered = true; // unwrap

    if (self.def) {
      self = self.def;
    }

    self.msg = msg;
    self.state = 2;

    if (self.chain.length > 0) {
      schedule(notify, self);
    }
  }

  function iteratePromises(Constructor, arr, resolver, rejecter) {
    for (var idx = 0; idx < arr.length; idx++) {
      (function IIFE(idx) {
        Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
          resolver(idx, msg);
        }, rejecter);
      })(idx);
    }
  }

  function MakeDefWrapper(self) {
    this.def = self;
    this.triggered = false;
  }

  function MakeDef(self) {
    this.promise = self;
    this.state = 0;
    this.triggered = false;
    this.chain = [];
    this.msg = void 0;
  }

  function Promise(executor) {
    if (typeof executor != "function") {
      throw TypeError("Not a function");
    }

    if (this.__NPO__ !== 0) {
      throw TypeError("Not a promise");
    } // instance shadowing the inherited "brand"
    // to signal an already "initialized" promise


    this.__NPO__ = 1;
    var def = new MakeDef(this);

    this["then"] = function then(success, failure) {
      var o = {
        success: typeof success == "function" ? success : true,
        failure: typeof failure == "function" ? failure : false
      }; // Note: `then(..)` itself can be borrowed to be used against
      // a different promise constructor for making the chained promise,
      // by substituting a different `this` binding.

      o.promise = new this.constructor(function extractChain(resolve, reject) {
        if (typeof resolve != "function" || typeof reject != "function") {
          throw TypeError("Not a function");
        }

        o.resolve = resolve;
        o.reject = reject;
      });
      def.chain.push(o);

      if (def.state !== 0) {
        schedule(notify, def);
      }

      return o.promise;
    };

    this["catch"] = function $catch$(failure) {
      return this.then(void 0, failure);
    };

    try {
      executor.call(void 0, function publicResolve(msg) {
        resolve.call(def, msg);
      }, function publicReject(msg) {
        reject.call(def, msg);
      });
    } catch (err) {
      reject.call(def, err);
    }
  }

  var PromisePrototype = builtInProp({}, "constructor", Promise,
  /*configurable=*/
  false); // Note: Android 4 cannot use `Object.defineProperty(..)` here

  Promise.prototype = PromisePrototype; // built-in "brand" to signal an "uninitialized" promise

  builtInProp(PromisePrototype, "__NPO__", 0,
  /*configurable=*/
  false);
  builtInProp(Promise, "resolve", function Promise$resolve(msg) {
    var Constructor = this; // spec mandated checks
    // note: best "isPromise" check that's practical for now

    if (msg && typeof msg == "object" && msg.__NPO__ === 1) {
      return msg;
    }

    return new Constructor(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }

      resolve(msg);
    });
  });
  builtInProp(Promise, "reject", function Promise$reject(msg) {
    return new this(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }

      reject(msg);
    });
  });
  builtInProp(Promise, "all", function Promise$all(arr) {
    var Constructor = this; // spec mandated checks

    if (ToString.call(arr) != "[object Array]") {
      return Constructor.reject(TypeError("Not an array"));
    }

    if (arr.length === 0) {
      return Constructor.resolve([]);
    }

    return new Constructor(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }

      var len = arr.length,
          msgs = Array(len),
          count = 0;
      iteratePromises(Constructor, arr, function resolver(idx, msg) {
        msgs[idx] = msg;

        if (++count === len) {
          resolve(msgs);
        }
      }, reject);
    });
  });
  builtInProp(Promise, "race", function Promise$race(arr) {
    var Constructor = this; // spec mandated checks

    if (ToString.call(arr) != "[object Array]") {
      return Constructor.reject(TypeError("Not an array"));
    }

    return new Constructor(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }

      iteratePromises(Constructor, arr, function resolver(idx, msg) {
        resolve(msg);
      }, reject);
    });
  });
  return Promise;
});
});

/**
 * @module lib/callbacks
 */
var callbackMap = new WeakMap();
/**
 * Store a callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @param {(function(this:Player, *): void|{resolve: function, reject: function})} callback
 *        The callback to call or an object with resolve and reject functions for a promise.
 * @return {void}
 */

function storeCallback(player, name, callback) {
  var playerCallbacks = callbackMap.get(player.element) || {};

  if (!(name in playerCallbacks)) {
    playerCallbacks[name] = [];
  }

  playerCallbacks[name].push(callback);
  callbackMap.set(player.element, playerCallbacks);
}
/**
 * Get the callbacks for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @return {function[]}
 */

function getCallbacks(player, name) {
  var playerCallbacks = callbackMap.get(player.element) || {};
  return playerCallbacks[name] || [];
}
/**
 * Remove a stored callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @param {function} [callback] The specific callback to remove.
 * @return {boolean} Was this the last callback?
 */

function removeCallback(player, name, callback) {
  var playerCallbacks = callbackMap.get(player.element) || {};

  if (!playerCallbacks[name]) {
    return true;
  } // If no callback is passed, remove all callbacks for the event


  if (!callback) {
    playerCallbacks[name] = [];
    callbackMap.set(player.element, playerCallbacks);
    return true;
  }

  var index = playerCallbacks[name].indexOf(callback);

  if (index !== -1) {
    playerCallbacks[name].splice(index, 1);
  }

  callbackMap.set(player.element, playerCallbacks);
  return playerCallbacks[name] && playerCallbacks[name].length === 0;
}
/**
 * Return the first stored callback for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @return {function} The callback, or false if there were none
 */

function shiftCallbacks(player, name) {
  var playerCallbacks = getCallbacks(player, name);

  if (playerCallbacks.length < 1) {
    return false;
  }

  var callback = playerCallbacks.shift();
  removeCallback(player, name, callback);
  return callback;
}
/**
 * Move callbacks associated with an element to another element.
 *
 * @param {HTMLElement} oldElement The old element.
 * @param {HTMLElement} newElement The new element.
 * @return {void}
 */

function swapCallbacks(oldElement, newElement) {
  var playerCallbacks = callbackMap.get(oldElement);
  callbackMap.set(newElement, playerCallbacks);
  callbackMap.delete(oldElement);
}

/**
 * @module lib/embed
 */
var oEmbedParameters = ['autopause', 'autoplay', 'background', 'byline', 'color', 'controls', 'dnt', 'height', 'id', 'keyboard', 'loop', 'maxheight', 'maxwidth', 'muted', 'playsinline', 'portrait', 'responsive', 'speed', 'texttrack', 'title', 'transparent', 'url', 'width'];
/**
 * Get the 'data-vimeo'-prefixed attributes from an element as an object.
 *
 * @param {HTMLElement} element The element.
 * @param {Object} [defaults={}] The default values to use.
 * @return {Object<string, string>}
 */

function getOEmbedParameters(element) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return oEmbedParameters.reduce(function (params, param) {
    var value = element.getAttribute("data-vimeo-".concat(param));

    if (value || value === '') {
      params[param] = value === '' ? 1 : value;
    }

    return params;
  }, defaults);
}
/**
 * Create an embed from oEmbed data inside an element.
 *
 * @param {object} data The oEmbed data.
 * @param {HTMLElement} element The element to put the iframe in.
 * @return {HTMLIFrameElement} The iframe embed.
 */

function createEmbed(_ref, element) {
  var html = _ref.html;

  if (!element) {
    throw new TypeError('An element must be provided');
  }

  if (element.getAttribute('data-vimeo-initialized') !== null) {
    return element.querySelector('iframe');
  }

  var div = document.createElement('div');
  div.innerHTML = html;
  element.appendChild(div.firstChild);
  element.setAttribute('data-vimeo-initialized', 'true');
  return element.querySelector('iframe');
}
/**
 * Make an oEmbed call for the specified URL.
 *
 * @param {string} videoUrl The vimeo.com url for the video.
 * @param {Object} [params] Parameters to pass to oEmbed.
 * @param {HTMLElement} element The element.
 * @return {Promise}
 */

function getOEmbedData(videoUrl) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var element = arguments.length > 2 ? arguments[2] : undefined;
  return new Promise(function (resolve, reject) {
    if (!isVimeoUrl(videoUrl)) {
      throw new TypeError("\u201C".concat(videoUrl, "\u201D is not a vimeo.com url."));
    }

    var url = "https://vimeo.com/api/oembed.json?url=".concat(encodeURIComponent(videoUrl));

    for (var param in params) {
      if (params.hasOwnProperty(param)) {
        url += "&".concat(param, "=").concat(encodeURIComponent(params[param]));
      }
    }

    var xhr = 'XDomainRequest' in window ? new XDomainRequest() : new XMLHttpRequest();
    xhr.open('GET', url, true);

    xhr.onload = function () {
      if (xhr.status === 404) {
        reject(new Error("\u201C".concat(videoUrl, "\u201D was not found.")));
        return;
      }

      if (xhr.status === 403) {
        reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
        return;
      }

      try {
        var json = JSON.parse(xhr.responseText); // Check api response for 403 on oembed

        if (json.domain_status_code === 403) {
          // We still want to create the embed to give users visual feedback
          createEmbed(json, element);
          reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
          return;
        }

        resolve(json);
      } catch (error) {
        reject(error);
      }
    };

    xhr.onerror = function () {
      var status = xhr.status ? " (".concat(xhr.status, ")") : '';
      reject(new Error("There was an error fetching the embed code from Vimeo".concat(status, ".")));
    };

    xhr.send();
  });
}
/**
 * Initialize all embeds within a specific element
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */

function initializeEmbeds() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var elements = [].slice.call(parent.querySelectorAll('[data-vimeo-id], [data-vimeo-url]'));

  var handleError = function handleError(error) {
    if ('console' in window && console.error) {
      console.error("There was an error creating an embed: ".concat(error));
    }
  };

  elements.forEach(function (element) {
    try {
      // Skip any that have data-vimeo-defer
      if (element.getAttribute('data-vimeo-defer') !== null) {
        return;
      }

      var params = getOEmbedParameters(element);
      var url = getVimeoUrl(params);
      getOEmbedData(url, params, element).then(function (data) {
        return createEmbed(data, element);
      }).catch(handleError);
    } catch (error) {
      handleError(error);
    }
  });
}
/**
 * Resize embeds when messaged by the player.
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */

function resizeEmbeds() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  // Prevent execution if users include the player.js script multiple times.
  if (window.VimeoPlayerResizeEmbeds_) {
    return;
  }

  window.VimeoPlayerResizeEmbeds_ = true;

  var onMessage = function onMessage(event) {
    if (!isVimeoUrl(event.origin)) {
      return;
    } // 'spacechange' is fired only on embeds with cards


    if (!event.data || event.data.event !== 'spacechange') {
      return;
    }

    var iframes = parent.querySelectorAll('iframe');

    for (var i = 0; i < iframes.length; i++) {
      if (iframes[i].contentWindow !== event.source) {
        continue;
      } // Change padding-bottom of the enclosing div to accommodate
      // card carousel without distorting aspect ratio


      var space = iframes[i].parentElement;
      space.style.paddingBottom = "".concat(event.data.data[0].bottom, "px");
      break;
    }
  };

  window.addEventListener('message', onMessage);
}

/**
 * @module lib/postmessage
 */
/**
 * Parse a message received from postMessage.
 *
 * @param {*} data The data received from postMessage.
 * @return {object}
 */

function parseMessageData(data) {
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (error) {
      // If the message cannot be parsed, throw the error as a warning
      console.warn(error);
      return {};
    }
  }

  return data;
}
/**
 * Post a message to the specified target.
 *
 * @param {Player} player The player object to use.
 * @param {string} method The API method to call.
 * @param {object} params The parameters to send to the player.
 * @return {void}
 */

function postMessage(player, method, params) {
  if (!player.element.contentWindow || !player.element.contentWindow.postMessage) {
    return;
  }

  var message = {
    method: method
  };

  if (params !== undefined) {
    message.value = params;
  } // IE 8 and 9 do not support passing messages, so stringify them


  var ieVersion = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, '$1'));

  if (ieVersion >= 8 && ieVersion < 10) {
    message = JSON.stringify(message);
  }

  player.element.contentWindow.postMessage(message, player.origin);
}
/**
 * Parse the data received from a message event.
 *
 * @param {Player} player The player that received the message.
 * @param {(Object|string)} data The message data. Strings will be parsed into JSON.
 * @return {void}
 */

function processData(player, data) {
  data = parseMessageData(data);
  var callbacks = [];
  var param;

  if (data.event) {
    if (data.event === 'error') {
      var promises = getCallbacks(player, data.data.method);
      promises.forEach(function (promise) {
        var error = new Error(data.data.message);
        error.name = data.data.name;
        promise.reject(error);
        removeCallback(player, data.data.method, promise);
      });
    }

    callbacks = getCallbacks(player, "event:".concat(data.event));
    param = data.data;
  } else if (data.method) {
    var callback = shiftCallbacks(player, data.method);

    if (callback) {
      callbacks.push(callback);
      param = data.value;
    }
  }

  callbacks.forEach(function (callback) {
    try {
      if (typeof callback === 'function') {
        callback.call(player, param);
        return;
      }

      callback.resolve(param);
    } catch (e) {// empty
    }
  });
}

/* MIT License

Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
Terms */
function initializeScreenfull() {
  var fn = function () {
    var val;
    var fnMap = [['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror'], // New WebKit
    ['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror'], // Old WebKit
    ['webkitRequestFullScreen', 'webkitCancelFullScreen', 'webkitCurrentFullScreenElement', 'webkitCancelFullScreen', 'webkitfullscreenchange', 'webkitfullscreenerror'], ['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror'], ['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError']];
    var i = 0;
    var l = fnMap.length;
    var ret = {};

    for (; i < l; i++) {
      val = fnMap[i];

      if (val && val[1] in document) {
        for (i = 0; i < val.length; i++) {
          ret[fnMap[0][i]] = val[i];
        }

        return ret;
      }
    }

    return false;
  }();

  var eventNameMap = {
    fullscreenchange: fn.fullscreenchange,
    fullscreenerror: fn.fullscreenerror
  };
  var screenfull = {
    request: function request(element) {
      return new Promise(function (resolve, reject) {
        var onFullScreenEntered = function onFullScreenEntered() {
          screenfull.off('fullscreenchange', onFullScreenEntered);
          resolve();
        };

        screenfull.on('fullscreenchange', onFullScreenEntered);
        element = element || document.documentElement;
        var returnPromise = element[fn.requestFullscreen]();

        if (returnPromise instanceof Promise) {
          returnPromise.then(onFullScreenEntered).catch(reject);
        }
      });
    },
    exit: function exit() {
      return new Promise(function (resolve, reject) {
        if (!screenfull.isFullscreen) {
          resolve();
          return;
        }

        var onFullScreenExit = function onFullScreenExit() {
          screenfull.off('fullscreenchange', onFullScreenExit);
          resolve();
        };

        screenfull.on('fullscreenchange', onFullScreenExit);
        var returnPromise = document[fn.exitFullscreen]();

        if (returnPromise instanceof Promise) {
          returnPromise.then(onFullScreenExit).catch(reject);
        }
      });
    },
    on: function on(event, callback) {
      var eventName = eventNameMap[event];

      if (eventName) {
        document.addEventListener(eventName, callback);
      }
    },
    off: function off(event, callback) {
      var eventName = eventNameMap[event];

      if (eventName) {
        document.removeEventListener(eventName, callback);
      }
    }
  };
  Object.defineProperties(screenfull, {
    isFullscreen: {
      get: function get() {
        return Boolean(document[fn.fullscreenElement]);
      }
    },
    element: {
      enumerable: true,
      get: function get() {
        return document[fn.fullscreenElement];
      }
    },
    isEnabled: {
      enumerable: true,
      get: function get() {
        // Coerce to boolean in case of old WebKit
        return Boolean(document[fn.fullscreenEnabled]);
      }
    }
  });
  return screenfull;
}

var playerMap = new WeakMap();
var readyMap = new WeakMap();
var screenfull = {};

var Player = /*#__PURE__*/function () {
  /**
   * Create a Player.
   *
   * @param {(HTMLIFrameElement|HTMLElement|string|jQuery)} element A reference to the Vimeo
   *        player iframe, and id, or a jQuery object.
   * @param {object} [options] oEmbed parameters to use when creating an embed in the element.
   * @return {Player}
   */
  function Player(element) {
    var _this = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Player);

    /* global jQuery */
    if (window.jQuery && element instanceof jQuery) {
      if (element.length > 1 && window.console && console.warn) {
        console.warn('A jQuery object with multiple elements was passed, using the first element.');
      }

      element = element[0];
    } // Find an element by ID


    if (typeof document !== 'undefined' && typeof element === 'string') {
      element = document.getElementById(element);
    } // Not an element!


    if (!isDomElement(element)) {
      throw new TypeError('You must pass either a valid element or a valid id.');
    } // Already initialized an embed in this div, so grab the iframe


    if (element.nodeName !== 'IFRAME') {
      var iframe = element.querySelector('iframe');

      if (iframe) {
        element = iframe;
      }
    } // iframe url is not a Vimeo url


    if (element.nodeName === 'IFRAME' && !isVimeoUrl(element.getAttribute('src') || '')) {
      throw new Error('The player element passed isn’t a Vimeo embed.');
    } // If there is already a player object in the map, return that


    if (playerMap.has(element)) {
      return playerMap.get(element);
    }

    this._window = element.ownerDocument.defaultView;
    this.element = element;
    this.origin = '*';
    var readyPromise = new npo_src(function (resolve, reject) {
      _this._onMessage = function (event) {
        if (!isVimeoUrl(event.origin) || _this.element.contentWindow !== event.source) {
          return;
        }

        if (_this.origin === '*') {
          _this.origin = event.origin;
        }

        var data = parseMessageData(event.data);
        var isError = data && data.event === 'error';
        var isReadyError = isError && data.data && data.data.method === 'ready';

        if (isReadyError) {
          var error = new Error(data.data.message);
          error.name = data.data.name;
          reject(error);
          return;
        }

        var isReadyEvent = data && data.event === 'ready';
        var isPingResponse = data && data.method === 'ping';

        if (isReadyEvent || isPingResponse) {
          _this.element.setAttribute('data-ready', 'true');

          resolve();
          return;
        }

        processData(_this, data);
      };

      _this._window.addEventListener('message', _this._onMessage);

      if (_this.element.nodeName !== 'IFRAME') {
        var params = getOEmbedParameters(element, options);
        var url = getVimeoUrl(params);
        getOEmbedData(url, params, element).then(function (data) {
          var iframe = createEmbed(data, element); // Overwrite element with the new iframe,
          // but store reference to the original element

          _this.element = iframe;
          _this._originalElement = element;
          swapCallbacks(element, iframe);
          playerMap.set(_this.element, _this);
          return data;
        }).catch(reject);
      }
    }); // Store a copy of this Player in the map

    readyMap.set(this, readyPromise);
    playerMap.set(this.element, this); // Send a ping to the iframe so the ready promise will be resolved if
    // the player is already ready.

    if (this.element.nodeName === 'IFRAME') {
      postMessage(this, 'ping');
    }

    if (screenfull.isEnabled) {
      var exitFullscreen = function exitFullscreen() {
        return screenfull.exit();
      };

      this.fullscreenchangeHandler = function () {
        if (screenfull.isFullscreen) {
          storeCallback(_this, 'event:exitFullscreen', exitFullscreen);
        } else {
          removeCallback(_this, 'event:exitFullscreen', exitFullscreen);
        } // eslint-disable-next-line


        _this.ready().then(function () {
          postMessage(_this, 'fullscreenchange', screenfull.isFullscreen);
        });
      };

      screenfull.on('fullscreenchange', this.fullscreenchangeHandler);
    }

    return this;
  }
  /**
   * Get a promise for a method.
   *
   * @param {string} name The API method to call.
   * @param {Object} [args={}] Arguments to send via postMessage.
   * @return {Promise}
   */


  _createClass(Player, [{
    key: "callMethod",
    value: function callMethod(name) {
      var _this2 = this;

      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new npo_src(function (resolve, reject) {
        // We are storing the resolve/reject handlers to call later, so we
        // can’t return here.
        // eslint-disable-next-line promise/always-return
        return _this2.ready().then(function () {
          storeCallback(_this2, name, {
            resolve: resolve,
            reject: reject
          });
          postMessage(_this2, name, args);
        }).catch(reject);
      });
    }
    /**
     * Get a promise for the value of a player property.
     *
     * @param {string} name The property name
     * @return {Promise}
     */

  }, {
    key: "get",
    value: function get(name) {
      var _this3 = this;

      return new npo_src(function (resolve, reject) {
        name = getMethodName(name, 'get'); // We are storing the resolve/reject handlers to call later, so we
        // can’t return here.
        // eslint-disable-next-line promise/always-return

        return _this3.ready().then(function () {
          storeCallback(_this3, name, {
            resolve: resolve,
            reject: reject
          });
          postMessage(_this3, name);
        }).catch(reject);
      });
    }
    /**
     * Get a promise for setting the value of a player property.
     *
     * @param {string} name The API method to call.
     * @param {mixed} value The value to set.
     * @return {Promise}
     */

  }, {
    key: "set",
    value: function set(name, value) {
      var _this4 = this;

      return new npo_src(function (resolve, reject) {
        name = getMethodName(name, 'set');

        if (value === undefined || value === null) {
          throw new TypeError('There must be a value to set.');
        } // We are storing the resolve/reject handlers to call later, so we
        // can’t return here.
        // eslint-disable-next-line promise/always-return


        return _this4.ready().then(function () {
          storeCallback(_this4, name, {
            resolve: resolve,
            reject: reject
          });
          postMessage(_this4, name, value);
        }).catch(reject);
      });
    }
    /**
     * Add an event listener for the specified event. Will call the
     * callback with a single parameter, `data`, that contains the data for
     * that event.
     *
     * @param {string} eventName The name of the event.
     * @param {function(*)} callback The function to call when the event fires.
     * @return {void}
     */

  }, {
    key: "on",
    value: function on(eventName, callback) {
      if (!eventName) {
        throw new TypeError('You must pass an event name.');
      }

      if (!callback) {
        throw new TypeError('You must pass a callback function.');
      }

      if (typeof callback !== 'function') {
        throw new TypeError('The callback must be a function.');
      }

      var callbacks = getCallbacks(this, "event:".concat(eventName));

      if (callbacks.length === 0) {
        this.callMethod('addEventListener', eventName).catch(function () {// Ignore the error. There will be an error event fired that
          // will trigger the error callback if they are listening.
        });
      }

      storeCallback(this, "event:".concat(eventName), callback);
    }
    /**
     * Remove an event listener for the specified event. Will remove all
     * listeners for that event if a `callback` isn’t passed, or only that
     * specific callback if it is passed.
     *
     * @param {string} eventName The name of the event.
     * @param {function} [callback] The specific callback to remove.
     * @return {void}
     */

  }, {
    key: "off",
    value: function off(eventName, callback) {
      if (!eventName) {
        throw new TypeError('You must pass an event name.');
      }

      if (callback && typeof callback !== 'function') {
        throw new TypeError('The callback must be a function.');
      }

      var lastCallback = removeCallback(this, "event:".concat(eventName), callback); // If there are no callbacks left, remove the listener

      if (lastCallback) {
        this.callMethod('removeEventListener', eventName).catch(function (e) {// Ignore the error. There will be an error event fired that
          // will trigger the error callback if they are listening.
        });
      }
    }
    /**
     * A promise to load a new video.
     *
     * @promise LoadVideoPromise
     * @fulfill {number} The video with this id or url successfully loaded.
     * @reject {TypeError} The id was not a number.
     */

    /**
     * Load a new video into this embed. The promise will be resolved if
     * the video is successfully loaded, or it will be rejected if it could
     * not be loaded.
     *
     * @param {number|string|object} options The id of the video, the url of the video, or an object with embed options.
     * @return {LoadVideoPromise}
     */

  }, {
    key: "loadVideo",
    value: function loadVideo(options) {
      return this.callMethod('loadVideo', options);
    }
    /**
     * A promise to perform an action when the Player is ready.
     *
     * @todo document errors
     * @promise LoadVideoPromise
     * @fulfill {void}
     */

    /**
     * Trigger a function when the player iframe has initialized. You do not
     * need to wait for `ready` to trigger to begin adding event listeners
     * or calling other methods.
     *
     * @return {ReadyPromise}
     */

  }, {
    key: "ready",
    value: function ready() {
      var readyPromise = readyMap.get(this) || new npo_src(function (resolve, reject) {
        reject(new Error('Unknown player. Probably unloaded.'));
      });
      return npo_src.resolve(readyPromise);
    }
    /**
     * A promise to add a cue point to the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point to use for removeCuePoint.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */

    /**
     * Add a cue point to the player.
     *
     * @param {number} time The time for the cue point.
     * @param {object} [data] Arbitrary data to be returned with the cue point.
     * @return {AddCuePointPromise}
     */

  }, {
    key: "addCuePoint",
    value: function addCuePoint(time) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.callMethod('addCuePoint', {
        time: time,
        data: data
      });
    }
    /**
     * A promise to remove a cue point from the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point that was removed.
     * @reject {InvalidCuePoint} The cue point with the specified id was not
     *         found.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */

    /**
     * Remove a cue point from the video.
     *
     * @param {string} id The id of the cue point to remove.
     * @return {RemoveCuePointPromise}
     */

  }, {
    key: "removeCuePoint",
    value: function removeCuePoint(id) {
      return this.callMethod('removeCuePoint', id);
    }
    /**
     * A representation of a text track on a video.
     *
     * @typedef {Object} VimeoTextTrack
     * @property {string} language The ISO language code.
     * @property {string} kind The kind of track it is (captions or subtitles).
     * @property {string} label The human‐readable label for the track.
     */

    /**
     * A promise to enable a text track.
     *
     * @promise EnableTextTrackPromise
     * @fulfill {VimeoTextTrack} The text track that was enabled.
     * @reject {InvalidTrackLanguageError} No track was available with the
     *         specified language.
     * @reject {InvalidTrackError} No track was available with the specified
     *         language and kind.
     */

    /**
     * Enable the text track with the specified language, and optionally the
     * specified kind (captions or subtitles).
     *
     * When set via the API, the track language will not change the viewer’s
     * stored preference.
     *
     * @param {string} language The two‐letter language code.
     * @param {string} [kind] The kind of track to enable (captions or subtitles).
     * @return {EnableTextTrackPromise}
     */

  }, {
    key: "enableTextTrack",
    value: function enableTextTrack(language, kind) {
      if (!language) {
        throw new TypeError('You must pass a language.');
      }

      return this.callMethod('enableTextTrack', {
        language: language,
        kind: kind
      });
    }
    /**
     * A promise to disable the active text track.
     *
     * @promise DisableTextTrackPromise
     * @fulfill {void} The track was disabled.
     */

    /**
     * Disable the currently-active text track.
     *
     * @return {DisableTextTrackPromise}
     */

  }, {
    key: "disableTextTrack",
    value: function disableTextTrack() {
      return this.callMethod('disableTextTrack');
    }
    /**
     * A promise to pause the video.
     *
     * @promise PausePromise
     * @fulfill {void} The video was paused.
     */

    /**
     * Pause the video if it’s playing.
     *
     * @return {PausePromise}
     */

  }, {
    key: "pause",
    value: function pause() {
      return this.callMethod('pause');
    }
    /**
     * A promise to play the video.
     *
     * @promise PlayPromise
     * @fulfill {void} The video was played.
     */

    /**
     * Play the video if it’s paused. **Note:** on iOS and some other
     * mobile devices, you cannot programmatically trigger play. Once the
     * viewer has tapped on the play button in the player, however, you
     * will be able to use this function.
     *
     * @return {PlayPromise}
     */

  }, {
    key: "play",
    value: function play() {
      return this.callMethod('play');
    }
    /**
     * Request that the player enters fullscreen.
     * @return {Promise}
     */

  }, {
    key: "requestFullscreen",
    value: function requestFullscreen() {
      if (screenfull.isEnabled) {
        return screenfull.request(this.element);
      }

      return this.callMethod('requestFullscreen');
    }
    /**
     * Request that the player exits fullscreen.
     * @return {Promise}
     */

  }, {
    key: "exitFullscreen",
    value: function exitFullscreen() {
      if (screenfull.isEnabled) {
        return screenfull.exit();
      }

      return this.callMethod('exitFullscreen');
    }
    /**
     * Returns true if the player is currently fullscreen.
     * @return {Promise}
     */

  }, {
    key: "getFullscreen",
    value: function getFullscreen() {
      if (screenfull.isEnabled) {
        return npo_src.resolve(screenfull.isFullscreen);
      }

      return this.get('fullscreen');
    }
    /**
     * Request that the player enters picture-in-picture.
     * @return {Promise}
     */

  }, {
    key: "requestPictureInPicture",
    value: function requestPictureInPicture() {
      return this.callMethod('requestPictureInPicture');
    }
    /**
     * Request that the player exits picture-in-picture.
     * @return {Promise}
     */

  }, {
    key: "exitPictureInPicture",
    value: function exitPictureInPicture() {
      return this.callMethod('exitPictureInPicture');
    }
    /**
     * Returns true if the player is currently picture-in-picture.
     * @return {Promise}
     */

  }, {
    key: "getPictureInPicture",
    value: function getPictureInPicture() {
      return this.get('pictureInPicture');
    }
    /**
     * A promise to unload the video.
     *
     * @promise UnloadPromise
     * @fulfill {void} The video was unloaded.
     */

    /**
     * Return the player to its initial state.
     *
     * @return {UnloadPromise}
     */

  }, {
    key: "unload",
    value: function unload() {
      return this.callMethod('unload');
    }
    /**
     * Cleanup the player and remove it from the DOM
     *
     * It won't be usable and a new one should be constructed
     *  in order to do any operations.
     *
     * @return {Promise}
     */

  }, {
    key: "destroy",
    value: function destroy() {
      var _this5 = this;

      return new npo_src(function (resolve) {
        readyMap.delete(_this5);
        playerMap.delete(_this5.element);

        if (_this5._originalElement) {
          playerMap.delete(_this5._originalElement);

          _this5._originalElement.removeAttribute('data-vimeo-initialized');
        }

        if (_this5.element && _this5.element.nodeName === 'IFRAME' && _this5.element.parentNode) {
          // If we've added an additional wrapper div, remove that from the DOM.
          // If not, just remove the iframe element.
          if (_this5.element.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== _this5.element.parentNode) {
            _this5.element.parentNode.parentNode.removeChild(_this5.element.parentNode);
          } else {
            _this5.element.parentNode.removeChild(_this5.element);
          }
        } // If the clip is private there is a case where the element stays the
        // div element. Destroy should reset the div and remove the iframe child.


        if (_this5.element && _this5.element.nodeName === 'DIV' && _this5.element.parentNode) {
          _this5.element.removeAttribute('data-vimeo-initialized');

          var iframe = _this5.element.querySelector('iframe');

          if (iframe && iframe.parentNode) {
            // If we've added an additional wrapper div, remove that from the DOM.
            // If not, just remove the iframe element.
            if (iframe.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== iframe.parentNode) {
              iframe.parentNode.parentNode.removeChild(iframe.parentNode);
            } else {
              iframe.parentNode.removeChild(iframe);
            }
          }
        }

        _this5._window.removeEventListener('message', _this5._onMessage);

        if (screenfull.isEnabled) {
          screenfull.off('fullscreenchange', _this5.fullscreenchangeHandler);
        }

        resolve();
      });
    }
    /**
     * A promise to get the autopause behavior of the video.
     *
     * @promise GetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */

    /**
     * Get the autopause behavior for this player.
     *
     * @return {GetAutopausePromise}
     */

  }, {
    key: "getAutopause",
    value: function getAutopause() {
      return this.get('autopause');
    }
    /**
     * A promise to set the autopause behavior of the video.
     *
     * @promise SetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */

    /**
     * Enable or disable the autopause behavior of this player.
     *
     * By default, when another video is played in the same browser, this
     * player will automatically pause. Unless you have a specific reason
     * for doing so, we recommend that you leave autopause set to the
     * default (`true`).
     *
     * @param {boolean} autopause
     * @return {SetAutopausePromise}
     */

  }, {
    key: "setAutopause",
    value: function setAutopause(autopause) {
      return this.set('autopause', autopause);
    }
    /**
     * A promise to get the buffered property of the video.
     *
     * @promise GetBufferedPromise
     * @fulfill {Array} Buffered Timeranges converted to an Array.
     */

    /**
     * Get the buffered property of the video.
     *
     * @return {GetBufferedPromise}
     */

  }, {
    key: "getBuffered",
    value: function getBuffered() {
      return this.get('buffered');
    }
    /**
     * @typedef {Object} CameraProperties
     * @prop {number} props.yaw - Number between 0 and 360.
     * @prop {number} props.pitch - Number between -90 and 90.
     * @prop {number} props.roll - Number between -180 and 180.
     * @prop {number} props.fov - The field of view in degrees.
     */

    /**
     * A promise to get the camera properties of the player.
     *
     * @promise GetCameraPromise
     * @fulfill {CameraProperties} The camera properties.
     */

    /**
     * For 360° videos get the camera properties for this player.
     *
     * @return {GetCameraPromise}
     */

  }, {
    key: "getCameraProps",
    value: function getCameraProps() {
      return this.get('cameraProps');
    }
    /**
     * A promise to set the camera properties of the player.
     *
     * @promise SetCameraPromise
     * @fulfill {Object} The camera was successfully set.
     * @reject {RangeError} The range was out of bounds.
     */

    /**
     * For 360° videos set the camera properties for this player.
     *
     * @param {CameraProperties} camera The camera properties
     * @return {SetCameraPromise}
     */

  }, {
    key: "setCameraProps",
    value: function setCameraProps(camera) {
      return this.set('cameraProps', camera);
    }
    /**
     * A representation of a chapter.
     *
     * @typedef {Object} VimeoChapter
     * @property {number} startTime The start time of the chapter.
     * @property {object} title The title of the chapter.
     * @property {number} index The place in the order of Chapters. Starts at 1.
     */

    /**
     * A promise to get chapters for the video.
     *
     * @promise GetChaptersPromise
     * @fulfill {VimeoChapter[]} The chapters for the video.
     */

    /**
     * Get an array of all the chapters for the video.
     *
     * @return {GetChaptersPromise}
     */

  }, {
    key: "getChapters",
    value: function getChapters() {
      return this.get('chapters');
    }
    /**
     * A promise to get the currently active chapter.
     *
     * @promise GetCurrentChaptersPromise
     * @fulfill {VimeoChapter|undefined} The current chapter for the video.
     */

    /**
     * Get the currently active chapter for the video.
     *
     * @return {GetCurrentChaptersPromise}
     */

  }, {
    key: "getCurrentChapter",
    value: function getCurrentChapter() {
      return this.get('currentChapter');
    }
    /**
     * A promise to get the color of the player.
     *
     * @promise GetColorPromise
     * @fulfill {string} The hex color of the player.
     */

    /**
     * Get the color for this player.
     *
     * @return {GetColorPromise}
     */

  }, {
    key: "getColor",
    value: function getColor() {
      return this.get('color');
    }
    /**
     * A promise to set the color of the player.
     *
     * @promise SetColorPromise
     * @fulfill {string} The color was successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */

    /**
     * Set the color of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     *
     * @param {string} color The hex or rgb color string to set.
     * @return {SetColorPromise}
     */

  }, {
    key: "setColor",
    value: function setColor(color) {
      return this.set('color', color);
    }
    /**
     * A representation of a cue point.
     *
     * @typedef {Object} VimeoCuePoint
     * @property {number} time The time of the cue point.
     * @property {object} data The data passed when adding the cue point.
     * @property {string} id The unique id for use with removeCuePoint.
     */

    /**
     * A promise to get the cue points of a video.
     *
     * @promise GetCuePointsPromise
     * @fulfill {VimeoCuePoint[]} The cue points added to the video.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */

    /**
     * Get an array of the cue points added to the video.
     *
     * @return {GetCuePointsPromise}
     */

  }, {
    key: "getCuePoints",
    value: function getCuePoints() {
      return this.get('cuePoints');
    }
    /**
     * A promise to get the current time of the video.
     *
     * @promise GetCurrentTimePromise
     * @fulfill {number} The current time in seconds.
     */

    /**
     * Get the current playback position in seconds.
     *
     * @return {GetCurrentTimePromise}
     */

  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.get('currentTime');
    }
    /**
     * A promise to set the current time of the video.
     *
     * @promise SetCurrentTimePromise
     * @fulfill {number} The actual current time that was set.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     */

    /**
     * Set the current playback position in seconds. If the player was
     * paused, it will remain paused. Likewise, if the player was playing,
     * it will resume playing once the video has buffered.
     *
     * You can provide an accurate time and the player will attempt to seek
     * to as close to that time as possible. The exact time will be the
     * fulfilled value of the promise.
     *
     * @param {number} currentTime
     * @return {SetCurrentTimePromise}
     */

  }, {
    key: "setCurrentTime",
    value: function setCurrentTime(currentTime) {
      return this.set('currentTime', currentTime);
    }
    /**
     * A promise to get the duration of the video.
     *
     * @promise GetDurationPromise
     * @fulfill {number} The duration in seconds.
     */

    /**
     * Get the duration of the video in seconds. It will be rounded to the
     * nearest second before playback begins, and to the nearest thousandth
     * of a second after playback begins.
     *
     * @return {GetDurationPromise}
     */

  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.get('duration');
    }
    /**
     * A promise to get the ended state of the video.
     *
     * @promise GetEndedPromise
     * @fulfill {boolean} Whether or not the video has ended.
     */

    /**
     * Get the ended state of the video. The video has ended if
     * `currentTime === duration`.
     *
     * @return {GetEndedPromise}
     */

  }, {
    key: "getEnded",
    value: function getEnded() {
      return this.get('ended');
    }
    /**
     * A promise to get the loop state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the player is set to loop.
     */

    /**
     * Get the loop state of the player.
     *
     * @return {GetLoopPromise}
     */

  }, {
    key: "getLoop",
    value: function getLoop() {
      return this.get('loop');
    }
    /**
     * A promise to set the loop state of the player.
     *
     * @promise SetLoopPromise
     * @fulfill {boolean} The loop state that was set.
     */

    /**
     * Set the loop state of the player. When set to `true`, the player
     * will start over immediately once playback ends.
     *
     * @param {boolean} loop
     * @return {SetLoopPromise}
     */

  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      return this.set('loop', loop);
    }
    /**
     * A promise to set the muted state of the player.
     *
     * @promise SetMutedPromise
     * @fulfill {boolean} The muted state that was set.
     */

    /**
     * Set the muted state of the player. When set to `true`, the player
     * volume will be muted.
     *
     * @param {boolean} muted
     * @return {SetMutedPromise}
     */

  }, {
    key: "setMuted",
    value: function setMuted(muted) {
      return this.set('muted', muted);
    }
    /**
     * A promise to get the muted state of the player.
     *
     * @promise GetMutedPromise
     * @fulfill {boolean} Whether or not the player is muted.
     */

    /**
     * Get the muted state of the player.
     *
     * @return {GetMutedPromise}
     */

  }, {
    key: "getMuted",
    value: function getMuted() {
      return this.get('muted');
    }
    /**
     * A promise to get the paused state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the video is paused.
     */

    /**
     * Get the paused state of the player.
     *
     * @return {GetLoopPromise}
     */

  }, {
    key: "getPaused",
    value: function getPaused() {
      return this.get('paused');
    }
    /**
     * A promise to get the playback rate of the player.
     *
     * @promise GetPlaybackRatePromise
     * @fulfill {number} The playback rate of the player on a scale from 0.5 to 2.
     */

    /**
     * Get the playback rate of the player on a scale from `0.5` to `2`.
     *
     * @return {GetPlaybackRatePromise}
     */

  }, {
    key: "getPlaybackRate",
    value: function getPlaybackRate() {
      return this.get('playbackRate');
    }
    /**
     * A promise to set the playbackrate of the player.
     *
     * @promise SetPlaybackRatePromise
     * @fulfill {number} The playback rate was set.
     * @reject {RangeError} The playback rate was less than 0.5 or greater than 2.
     */

    /**
     * Set the playback rate of the player on a scale from `0.5` to `2`. When set
     * via the API, the playback rate will not be synchronized to other
     * players or stored as the viewer's preference.
     *
     * @param {number} playbackRate
     * @return {SetPlaybackRatePromise}
     */

  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(playbackRate) {
      return this.set('playbackRate', playbackRate);
    }
    /**
     * A promise to get the played property of the video.
     *
     * @promise GetPlayedPromise
     * @fulfill {Array} Played Timeranges converted to an Array.
     */

    /**
     * Get the played property of the video.
     *
     * @return {GetPlayedPromise}
     */

  }, {
    key: "getPlayed",
    value: function getPlayed() {
      return this.get('played');
    }
    /**
     * A promise to get the qualities available of the current video.
     *
     * @promise GetQualitiesPromise
     * @fulfill {Array} The qualities of the video.
     */

    /**
     * Get the qualities of the current video.
     *
     * @return {GetQualitiesPromise}
     */

  }, {
    key: "getQualities",
    value: function getQualities() {
      return this.get('qualities');
    }
    /**
     * A promise to get the current set quality of the video.
     *
     * @promise GetQualityPromise
     * @fulfill {string} The current set quality.
     */

    /**
     * Get the current set quality of the video.
     *
     * @return {GetQualityPromise}
     */

  }, {
    key: "getQuality",
    value: function getQuality() {
      return this.get('quality');
    }
    /**
     * A promise to set the video quality.
     *
     * @promise SetQualityPromise
     * @fulfill {number} The quality was set.
     * @reject {RangeError} The quality is not available.
     */

    /**
     * Set a video quality.
     *
     * @param {string} quality
     * @return {SetQualityPromise}
     */

  }, {
    key: "setQuality",
    value: function setQuality(quality) {
      return this.set('quality', quality);
    }
    /**
     * A promise to get the seekable property of the video.
     *
     * @promise GetSeekablePromise
     * @fulfill {Array} Seekable Timeranges converted to an Array.
     */

    /**
     * Get the seekable property of the video.
     *
     * @return {GetSeekablePromise}
     */

  }, {
    key: "getSeekable",
    value: function getSeekable() {
      return this.get('seekable');
    }
    /**
     * A promise to get the seeking property of the player.
     *
     * @promise GetSeekingPromise
     * @fulfill {boolean} Whether or not the player is currently seeking.
     */

    /**
     * Get if the player is currently seeking.
     *
     * @return {GetSeekingPromise}
     */

  }, {
    key: "getSeeking",
    value: function getSeeking() {
      return this.get('seeking');
    }
    /**
     * A promise to get the text tracks of a video.
     *
     * @promise GetTextTracksPromise
     * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
     */

    /**
     * Get an array of the text tracks that exist for the video.
     *
     * @return {GetTextTracksPromise}
     */

  }, {
    key: "getTextTracks",
    value: function getTextTracks() {
      return this.get('textTracks');
    }
    /**
     * A promise to get the embed code for the video.
     *
     * @promise GetVideoEmbedCodePromise
     * @fulfill {string} The `<iframe>` embed code for the video.
     */

    /**
     * Get the `<iframe>` embed code for the video.
     *
     * @return {GetVideoEmbedCodePromise}
     */

  }, {
    key: "getVideoEmbedCode",
    value: function getVideoEmbedCode() {
      return this.get('videoEmbedCode');
    }
    /**
     * A promise to get the id of the video.
     *
     * @promise GetVideoIdPromise
     * @fulfill {number} The id of the video.
     */

    /**
     * Get the id of the video.
     *
     * @return {GetVideoIdPromise}
     */

  }, {
    key: "getVideoId",
    value: function getVideoId() {
      return this.get('videoId');
    }
    /**
     * A promise to get the title of the video.
     *
     * @promise GetVideoTitlePromise
     * @fulfill {number} The title of the video.
     */

    /**
     * Get the title of the video.
     *
     * @return {GetVideoTitlePromise}
     */

  }, {
    key: "getVideoTitle",
    value: function getVideoTitle() {
      return this.get('videoTitle');
    }
    /**
     * A promise to get the native width of the video.
     *
     * @promise GetVideoWidthPromise
     * @fulfill {number} The native width of the video.
     */

    /**
     * Get the native width of the currently‐playing video. The width of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoWidthPromise}
     */

  }, {
    key: "getVideoWidth",
    value: function getVideoWidth() {
      return this.get('videoWidth');
    }
    /**
     * A promise to get the native height of the video.
     *
     * @promise GetVideoHeightPromise
     * @fulfill {number} The native height of the video.
     */

    /**
     * Get the native height of the currently‐playing video. The height of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoHeightPromise}
     */

  }, {
    key: "getVideoHeight",
    value: function getVideoHeight() {
      return this.get('videoHeight');
    }
    /**
     * A promise to get the vimeo.com url for the video.
     *
     * @promise GetVideoUrlPromise
     * @fulfill {number} The vimeo.com url for the video.
     * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
     */

    /**
     * Get the vimeo.com url for the video.
     *
     * @return {GetVideoUrlPromise}
     */

  }, {
    key: "getVideoUrl",
    value: function getVideoUrl() {
      return this.get('videoUrl');
    }
    /**
     * A promise to get the volume level of the player.
     *
     * @promise GetVolumePromise
     * @fulfill {number} The volume level of the player on a scale from 0 to 1.
     */

    /**
     * Get the current volume level of the player on a scale from `0` to `1`.
     *
     * Most mobile devices do not support an independent volume from the
     * system volume. In those cases, this method will always return `1`.
     *
     * @return {GetVolumePromise}
     */

  }, {
    key: "getVolume",
    value: function getVolume() {
      return this.get('volume');
    }
    /**
     * A promise to set the volume level of the player.
     *
     * @promise SetVolumePromise
     * @fulfill {number} The volume was set.
     * @reject {RangeError} The volume was less than 0 or greater than 1.
     */

    /**
     * Set the volume of the player on a scale from `0` to `1`. When set
     * via the API, the volume level will not be synchronized to other
     * players or stored as the viewer’s preference.
     *
     * Most mobile devices do not support setting the volume. An error will
     * *not* be triggered in that situation.
     *
     * @param {number} volume
     * @return {SetVolumePromise}
     */

  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      return this.set('volume', volume);
    }
  }]);

  return Player;
}(); // Setup embed only if this is not a node environment


if (!isNode) {
  screenfull = initializeScreenfull();
  initializeEmbeds();
  resizeEmbeds();
}

/* harmony default export */ __webpack_exports__["Z"] = (Player);


/***/ }),

/***/ 96441:
/***/ (function(module) {

/*! algoliasearch.umd.js | 4.14.2 | © Algolia, inc. | https://github.com/algolia/algoliasearch-client-javascript */
!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";function t(t,e,r){return e in t?Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}):t[e]=r,t}function e(t,e){var r=Object.keys(t);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(t);e&&(n=n.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),r.push.apply(r,n)}return r}function r(r){for(var n=1;n<arguments.length;n++){var a=null!=arguments[n]?arguments[n]:{};n%2?e(Object(a),!0).forEach((function(e){t(r,e,a[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(r,Object.getOwnPropertyDescriptors(a)):e(Object(a)).forEach((function(t){Object.defineProperty(r,t,Object.getOwnPropertyDescriptor(a,t))}))}return r}function n(t,e){if(null==t)return{};var r,n,a=function(t,e){if(null==t)return{};var r,n,a={},o=Object.keys(t);for(n=0;n<o.length;n++)r=o[n],e.indexOf(r)>=0||(a[r]=t[r]);return a}(t,e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(t);for(n=0;n<o.length;n++)r=o[n],e.indexOf(r)>=0||Object.prototype.propertyIsEnumerable.call(t,r)&&(a[r]=t[r])}return a}function a(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){if(!(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t)))return;var r=[],n=!0,a=!1,o=void 0;try{for(var i,u=t[Symbol.iterator]();!(n=(i=u.next()).done)&&(r.push(i.value),!e||r.length!==e);n=!0);}catch(t){a=!0,o=t}finally{try{n||null==u.return||u.return()}finally{if(a)throw o}}return r}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function o(t){return function(t){if(Array.isArray(t)){for(var e=0,r=new Array(t.length);e<t.length;e++)r[e]=t[e];return r}}(t)||function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function i(t){var e,r="algoliasearch-client-js-".concat(t.key),n=function(){return void 0===e&&(e=t.localStorage||window.localStorage),e},o=function(){return JSON.parse(n().getItem(r)||"{}")};return{get:function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{miss:function(){return Promise.resolve()}};return Promise.resolve().then((function(){var r=JSON.stringify(t),n=o()[r];return Promise.all([n||e(),void 0!==n])})).then((function(t){var e=a(t,2),n=e[0],o=e[1];return Promise.all([n,o||r.miss(n)])})).then((function(t){return a(t,1)[0]}))},set:function(t,e){return Promise.resolve().then((function(){var a=o();return a[JSON.stringify(t)]=e,n().setItem(r,JSON.stringify(a)),e}))},delete:function(t){return Promise.resolve().then((function(){var e=o();delete e[JSON.stringify(t)],n().setItem(r,JSON.stringify(e))}))},clear:function(){return Promise.resolve().then((function(){n().removeItem(r)}))}}}function u(t){var e=o(t.caches),r=e.shift();return void 0===r?{get:function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{miss:function(){return Promise.resolve()}},n=e();return n.then((function(t){return Promise.all([t,r.miss(t)])})).then((function(t){return a(t,1)[0]}))},set:function(t,e){return Promise.resolve(e)},delete:function(t){return Promise.resolve()},clear:function(){return Promise.resolve()}}:{get:function(t,n){var a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{miss:function(){return Promise.resolve()}};return r.get(t,n,a).catch((function(){return u({caches:e}).get(t,n,a)}))},set:function(t,n){return r.set(t,n).catch((function(){return u({caches:e}).set(t,n)}))},delete:function(t){return r.delete(t).catch((function(){return u({caches:e}).delete(t)}))},clear:function(){return r.clear().catch((function(){return u({caches:e}).clear()}))}}}function s(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{serializable:!0},e={};return{get:function(r,n){var a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{miss:function(){return Promise.resolve()}},o=JSON.stringify(r);if(o in e)return Promise.resolve(t.serializable?JSON.parse(e[o]):e[o]);var i=n(),u=a&&a.miss||function(){return Promise.resolve()};return i.then((function(t){return u(t)})).then((function(){return i}))},set:function(r,n){return e[JSON.stringify(r)]=t.serializable?JSON.stringify(n):n,Promise.resolve(n)},delete:function(t){return delete e[JSON.stringify(t)],Promise.resolve()},clear:function(){return e={},Promise.resolve()}}}function c(t,e,r){var n={"x-algolia-api-key":r,"x-algolia-application-id":e};return{headers:function(){return t===m.WithinHeaders?n:{}},queryParameters:function(){return t===m.WithinQueryParameters?n:{}}}}function f(t){var e=0;return t((function r(){return e++,new Promise((function(n){setTimeout((function(){n(t(r))}),Math.min(100*e,1e3))}))}))}function d(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:function(t,e){return Promise.resolve()};return Object.assign(t,{wait:function(r){return d(t.then((function(t){return Promise.all([e(t,r),t])})).then((function(t){return t[1]})))}})}function l(t){for(var e=t.length-1;e>0;e--){var r=Math.floor(Math.random()*(e+1)),n=t[e];t[e]=t[r],t[r]=n}return t}function p(t,e){return e?(Object.keys(e).forEach((function(r){t[r]=e[r](t)})),t):t}function h(t){for(var e=arguments.length,r=new Array(e>1?e-1:0),n=1;n<e;n++)r[n-1]=arguments[n];var a=0;return t.replace(/%s/g,(function(){return encodeURIComponent(r[a++])}))}var m={WithinQueryParameters:0,WithinHeaders:1};function y(t,e){var r=t||{},n=r.data||{};return Object.keys(r).forEach((function(t){-1===["timeout","headers","queryParameters","data","cacheable"].indexOf(t)&&(n[t]=r[t])})),{data:Object.entries(n).length>0?n:void 0,timeout:r.timeout||e,headers:r.headers||{},queryParameters:r.queryParameters||{},cacheable:r.cacheable}}var g={Read:1,Write:2,Any:3},v=1,b=2,P=3;function w(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:v;return r(r({},t),{},{status:e,lastUpdate:Date.now()})}function O(t){return"string"==typeof t?{protocol:"https",url:t,accept:g.Any}:{protocol:t.protocol||"https",url:t.url,accept:t.accept||g.Any}}var I="DELETE",x="GET",j="POST",D="PUT";function q(t,e){return Promise.all(e.map((function(e){return t.get(e,(function(){return Promise.resolve(w(e))}))}))).then((function(t){var r=t.filter((function(t){return function(t){return t.status===v||Date.now()-t.lastUpdate>12e4}(t)})),n=t.filter((function(t){return function(t){return t.status===P&&Date.now()-t.lastUpdate<=12e4}(t)})),a=[].concat(o(r),o(n));return{getTimeout:function(t,e){return(0===n.length&&0===t?1:n.length+3+t)*e},statelessHosts:a.length>0?a.map((function(t){return O(t)})):e}}))}function S(t,e,n,a){var i=[],u=function(t,e){if(t.method===x||void 0===t.data&&void 0===e.data)return;var n=Array.isArray(t.data)?t.data:r(r({},t.data),e.data);return JSON.stringify(n)}(n,a),s=function(t,e){var n=r(r({},t.headers),e.headers),a={};return Object.keys(n).forEach((function(t){var e=n[t];a[t.toLowerCase()]=e})),a}(t,a),c=n.method,f=n.method!==x?{}:r(r({},n.data),a.data),d=r(r(r({"x-algolia-agent":t.userAgent.value},t.queryParameters),f),a.queryParameters),l=0,p=function e(r,o){var f=r.pop();if(void 0===f)throw{name:"RetryError",message:"Unreachable hosts - your application id may be incorrect. If the error persists, contact support@algolia.com.",transporterStackTrace:R(i)};var p={data:u,headers:s,method:c,url:N(f,n.path,d),connectTimeout:o(l,t.timeouts.connect),responseTimeout:o(l,a.timeout)},h=function(t){var e={request:p,response:t,host:f,triesLeft:r.length};return i.push(e),e},m={onSuccess:function(t){return function(t){try{return JSON.parse(t.content)}catch(e){throw function(t,e){return{name:"DeserializationError",message:t,response:e}}(e.message,t)}}(t)},onRetry:function(n){var a=h(n);return n.isTimedOut&&l++,Promise.all([t.logger.info("Retryable failure",A(a)),t.hostsCache.set(f,w(f,n.isTimedOut?P:b))]).then((function(){return e(r,o)}))},onFail:function(t){throw h(t),function(t,e){var r=t.content,n=t.status,a=r;try{a=JSON.parse(r).message}catch(t){}return function(t,e,r){return{name:"ApiError",message:t,status:e,transporterStackTrace:r}}(a,n,e)}(t,R(i))}};return t.requester.send(p).then((function(t){return function(t,e){return function(t){var e=t.status;return t.isTimedOut||function(t){var e=t.isTimedOut,r=t.status;return!e&&0==~~r}(t)||2!=~~(e/100)&&4!=~~(e/100)}(t)?e.onRetry(t):2==~~(t.status/100)?e.onSuccess(t):e.onFail(t)}(t,m)}))};return q(t.hostsCache,e).then((function(t){return p(o(t.statelessHosts).reverse(),t.getTimeout)}))}function k(t){var e=t.hostsCache,r=t.logger,n=t.requester,o=t.requestsCache,i=t.responsesCache,u=t.timeouts,s=t.userAgent,c=t.hosts,f=t.queryParameters,d={hostsCache:e,logger:r,requester:n,requestsCache:o,responsesCache:i,timeouts:u,userAgent:s,headers:t.headers,queryParameters:f,hosts:c.map((function(t){return O(t)})),read:function(t,e){var r=y(e,d.timeouts.read),n=function(){return S(d,d.hosts.filter((function(t){return 0!=(t.accept&g.Read)})),t,r)};if(!0!==(void 0!==r.cacheable?r.cacheable:t.cacheable))return n();var o={request:t,mappedRequestOptions:r,transporter:{queryParameters:d.queryParameters,headers:d.headers}};return d.responsesCache.get(o,(function(){return d.requestsCache.get(o,(function(){return d.requestsCache.set(o,n()).then((function(t){return Promise.all([d.requestsCache.delete(o),t])}),(function(t){return Promise.all([d.requestsCache.delete(o),Promise.reject(t)])})).then((function(t){var e=a(t,2);e[0];return e[1]}))}))}),{miss:function(t){return d.responsesCache.set(o,t)}})},write:function(t,e){return S(d,d.hosts.filter((function(t){return 0!=(t.accept&g.Write)})),t,y(e,d.timeouts.write))}};return d}function T(t){var e={value:"Algolia for JavaScript (".concat(t,")"),add:function(t){var r="; ".concat(t.segment).concat(void 0!==t.version?" (".concat(t.version,")"):"");return-1===e.value.indexOf(r)&&(e.value="".concat(e.value).concat(r)),e}};return e}function N(t,e,r){var n=E(r),a="".concat(t.protocol,"://").concat(t.url,"/").concat("/"===e.charAt(0)?e.substr(1):e);return n.length&&(a+="?".concat(n)),a}function E(t){return Object.keys(t).map((function(e){return h("%s=%s",e,(r=t[e],"[object Object]"===Object.prototype.toString.call(r)||"[object Array]"===Object.prototype.toString.call(r)?JSON.stringify(t[e]):t[e]));var r})).join("&")}function R(t){return t.map((function(t){return A(t)}))}function A(t){var e=t.request.headers["x-algolia-api-key"]?{"x-algolia-api-key":"*****"}:{};return r(r({},t),{},{request:r(r({},t.request),{},{headers:r(r({},t.request.headers),e)})})}var C=function(t){return function(e,r){return t.transporter.write({method:j,path:"2/abtests",data:e},r)}},U=function(t){return function(e,r){return t.transporter.write({method:I,path:h("2/abtests/%s",e)},r)}},z=function(t){return function(e,r){return t.transporter.read({method:x,path:h("2/abtests/%s",e)},r)}},J=function(t){return function(e){return t.transporter.read({method:x,path:"2/abtests"},e)}},F=function(t){return function(e,r){return t.transporter.write({method:j,path:h("2/abtests/%s/stop",e)},r)}},H=function(t){return function(e){return t.transporter.read({method:x,path:"1/strategies/personalization"},e)}},M=function(t){return function(e,r){return t.transporter.write({method:j,path:"1/strategies/personalization",data:e},r)}};function K(t){return function e(r){return t.request(r).then((function(n){if(void 0!==t.batch&&t.batch(n.hits),!t.shouldStop(n))return n.cursor?e({cursor:n.cursor}):e({page:(r.page||0)+1})}))}({})}var W=function(t){return function(e,a){var o=a||{},i=o.queryParameters,u=n(o,["queryParameters"]),s=r({acl:e},void 0!==i?{queryParameters:i}:{});return d(t.transporter.write({method:j,path:"1/keys",data:s},u),(function(e,r){return f((function(n){return tt(t)(e.key,r).catch((function(t){if(404!==t.status)throw t;return n()}))}))}))}},B=function(t){return function(e,r,n){var a=y(n);return a.queryParameters["X-Algolia-User-ID"]=e,t.transporter.write({method:j,path:"1/clusters/mapping",data:{cluster:r}},a)}},Q=function(t){return function(e,r,n){return t.transporter.write({method:j,path:"1/clusters/mapping/batch",data:{users:e,cluster:r}},n)}},G=function(t){return function(e,r){return d(t.transporter.write({method:j,path:h("/1/dictionaries/%s/batch",e),data:{clearExistingDictionaryEntries:!0,requests:{action:"addEntry",body:[]}}},r),(function(e,r){return jt(t)(e.taskID,r)}))}},L=function(t){return function(e,r,n){return d(t.transporter.write({method:j,path:h("1/indexes/%s/operation",e),data:{operation:"copy",destination:r}},n),(function(r,n){return ut(t)(e,{methods:{waitTask:de}}).waitTask(r.taskID,n)}))}},V=function(t){return function(e,n,a){return L(t)(e,n,r(r({},a),{},{scope:[pe.Rules]}))}},_=function(t){return function(e,n,a){return L(t)(e,n,r(r({},a),{},{scope:[pe.Settings]}))}},X=function(t){return function(e,n,a){return L(t)(e,n,r(r({},a),{},{scope:[pe.Synonyms]}))}},Y=function(t){return function(e,r){return e.method===x?t.transporter.read(e,r):t.transporter.write(e,r)}},Z=function(t){return function(e,r){return d(t.transporter.write({method:I,path:h("1/keys/%s",e)},r),(function(r,n){return f((function(r){return tt(t)(e,n).then(r).catch((function(t){if(404!==t.status)throw t}))}))}))}},$=function(t){return function(e,r,n){var a=r.map((function(t){return{action:"deleteEntry",body:{objectID:t}}}));return d(t.transporter.write({method:j,path:h("/1/dictionaries/%s/batch",e),data:{clearExistingDictionaryEntries:!1,requests:a}},n),(function(e,r){return jt(t)(e.taskID,r)}))}},tt=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/keys/%s",e)},r)}},et=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/task/%s",e.toString())},r)}},rt=function(t){return function(e){return t.transporter.read({method:x,path:"/1/dictionaries/*/settings"},e)}},nt=function(t){return function(e){return t.transporter.read({method:x,path:"1/logs"},e)}},at=function(t){return function(e){return t.transporter.read({method:x,path:"1/clusters/mapping/top"},e)}},ot=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/clusters/mapping/%s",e)},r)}},it=function(t){return function(e){var r=e||{},a=r.retrieveMappings,o=n(r,["retrieveMappings"]);return!0===a&&(o.getClusters=!0),t.transporter.read({method:x,path:"1/clusters/mapping/pending"},o)}},ut=function(t){return function(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n={transporter:t.transporter,appId:t.appId,indexName:e};return p(n,r.methods)}},st=function(t){return function(e){return t.transporter.read({method:x,path:"1/keys"},e)}},ct=function(t){return function(e){return t.transporter.read({method:x,path:"1/clusters"},e)}},ft=function(t){return function(e){return t.transporter.read({method:x,path:"1/indexes"},e)}},dt=function(t){return function(e){return t.transporter.read({method:x,path:"1/clusters/mapping"},e)}},lt=function(t){return function(e,r,n){return d(t.transporter.write({method:j,path:h("1/indexes/%s/operation",e),data:{operation:"move",destination:r}},n),(function(r,n){return ut(t)(e,{methods:{waitTask:de}}).waitTask(r.taskID,n)}))}},pt=function(t){return function(e,r){return d(t.transporter.write({method:j,path:"1/indexes/*/batch",data:{requests:e}},r),(function(e,r){return Promise.all(Object.keys(e.taskID).map((function(n){return ut(t)(n,{methods:{waitTask:de}}).waitTask(e.taskID[n],r)})))}))}},ht=function(t){return function(e,r){return t.transporter.read({method:j,path:"1/indexes/*/objects",data:{requests:e}},r)}},mt=function(t){return function(e,n){var a=e.map((function(t){return r(r({},t),{},{params:E(t.params||{})})}));return t.transporter.read({method:j,path:"1/indexes/*/queries",data:{requests:a},cacheable:!0},n)}},yt=function(t){return function(e,a){return Promise.all(e.map((function(e){var o=e.params,i=o.facetName,u=o.facetQuery,s=n(o,["facetName","facetQuery"]);return ut(t)(e.indexName,{methods:{searchForFacetValues:ue}}).searchForFacetValues(i,u,r(r({},a),s))})))}},gt=function(t){return function(e,r){var n=y(r);return n.queryParameters["X-Algolia-User-ID"]=e,t.transporter.write({method:I,path:"1/clusters/mapping"},n)}},vt=function(t){return function(e,r,n){var a=r.map((function(t){return{action:"addEntry",body:t}}));return d(t.transporter.write({method:j,path:h("/1/dictionaries/%s/batch",e),data:{clearExistingDictionaryEntries:!0,requests:a}},n),(function(e,r){return jt(t)(e.taskID,r)}))}},bt=function(t){return function(e,r){return d(t.transporter.write({method:j,path:h("1/keys/%s/restore",e)},r),(function(r,n){return f((function(r){return tt(t)(e,n).catch((function(t){if(404!==t.status)throw t;return r()}))}))}))}},Pt=function(t){return function(e,r,n){var a=r.map((function(t){return{action:"addEntry",body:t}}));return d(t.transporter.write({method:j,path:h("/1/dictionaries/%s/batch",e),data:{clearExistingDictionaryEntries:!1,requests:a}},n),(function(e,r){return jt(t)(e.taskID,r)}))}},wt=function(t){return function(e,r,n){return t.transporter.read({method:j,path:h("/1/dictionaries/%s/search",e),data:{query:r},cacheable:!0},n)}},Ot=function(t){return function(e,r){return t.transporter.read({method:j,path:"1/clusters/mapping/search",data:{query:e}},r)}},It=function(t){return function(e,r){return d(t.transporter.write({method:D,path:"/1/dictionaries/*/settings",data:e},r),(function(e,r){return jt(t)(e.taskID,r)}))}},xt=function(t){return function(e,r){var a=Object.assign({},r),o=r||{},i=o.queryParameters,u=n(o,["queryParameters"]),s=i?{queryParameters:i}:{},c=["acl","indexes","referers","restrictSources","queryParameters","description","maxQueriesPerIPPerHour","maxHitsPerQuery"];return d(t.transporter.write({method:D,path:h("1/keys/%s",e),data:s},u),(function(r,n){return f((function(r){return tt(t)(e,n).then((function(t){return function(t){return Object.keys(a).filter((function(t){return-1!==c.indexOf(t)})).every((function(e){return t[e]===a[e]}))}(t)?Promise.resolve():r()}))}))}))}},jt=function(t){return function(e,r){return f((function(n){return et(t)(e,r).then((function(t){return"published"!==t.status?n():void 0}))}))}},Dt=function(t){return function(e,r){return d(t.transporter.write({method:j,path:h("1/indexes/%s/batch",t.indexName),data:{requests:e}},r),(function(e,r){return de(t)(e.taskID,r)}))}},qt=function(t){return function(e){return K(r(r({shouldStop:function(t){return void 0===t.cursor}},e),{},{request:function(r){return t.transporter.read({method:j,path:h("1/indexes/%s/browse",t.indexName),data:r},e)}}))}},St=function(t){return function(e){var n=r({hitsPerPage:1e3},e);return K(r(r({shouldStop:function(t){return t.hits.length<n.hitsPerPage}},n),{},{request:function(e){return se(t)("",r(r({},n),e)).then((function(t){return r(r({},t),{},{hits:t.hits.map((function(t){return delete t._highlightResult,t}))})}))}}))}},kt=function(t){return function(e){var n=r({hitsPerPage:1e3},e);return K(r(r({shouldStop:function(t){return t.hits.length<n.hitsPerPage}},n),{},{request:function(e){return ce(t)("",r(r({},n),e)).then((function(t){return r(r({},t),{},{hits:t.hits.map((function(t){return delete t._highlightResult,t}))})}))}}))}},Tt=function(t){return function(e,r,a){var o=a||{},i=o.batchSize,u=n(o,["batchSize"]),s={taskIDs:[],objectIDs:[]};return d(function n(){var a,o=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,c=[];for(a=o;a<e.length&&(c.push(e[a]),c.length!==(i||1e3));a++);return 0===c.length?Promise.resolve(s):Dt(t)(c.map((function(t){return{action:r,body:t}})),u).then((function(t){return s.objectIDs=s.objectIDs.concat(t.objectIDs),s.taskIDs.push(t.taskID),a++,n(a)}))}(),(function(e,r){return Promise.all(e.taskIDs.map((function(e){return de(t)(e,r)})))}))}},Nt=function(t){return function(e){return d(t.transporter.write({method:j,path:h("1/indexes/%s/clear",t.indexName)},e),(function(e,r){return de(t)(e.taskID,r)}))}},Et=function(t){return function(e){var r=e||{},a=r.forwardToReplicas,o=y(n(r,["forwardToReplicas"]));return a&&(o.queryParameters.forwardToReplicas=1),d(t.transporter.write({method:j,path:h("1/indexes/%s/rules/clear",t.indexName)},o),(function(e,r){return de(t)(e.taskID,r)}))}},Rt=function(t){return function(e){var r=e||{},a=r.forwardToReplicas,o=y(n(r,["forwardToReplicas"]));return a&&(o.queryParameters.forwardToReplicas=1),d(t.transporter.write({method:j,path:h("1/indexes/%s/synonyms/clear",t.indexName)},o),(function(e,r){return de(t)(e.taskID,r)}))}},At=function(t){return function(e,r){return d(t.transporter.write({method:j,path:h("1/indexes/%s/deleteByQuery",t.indexName),data:e},r),(function(e,r){return de(t)(e.taskID,r)}))}},Ct=function(t){return function(e){return d(t.transporter.write({method:I,path:h("1/indexes/%s",t.indexName)},e),(function(e,r){return de(t)(e.taskID,r)}))}},Ut=function(t){return function(e,r){return d(zt(t)([e],r).then((function(t){return{taskID:t.taskIDs[0]}})),(function(e,r){return de(t)(e.taskID,r)}))}},zt=function(t){return function(e,r){var n=e.map((function(t){return{objectID:t}}));return Tt(t)(n,le.DeleteObject,r)}},Jt=function(t){return function(e,r){var a=r||{},o=a.forwardToReplicas,i=y(n(a,["forwardToReplicas"]));return o&&(i.queryParameters.forwardToReplicas=1),d(t.transporter.write({method:I,path:h("1/indexes/%s/rules/%s",t.indexName,e)},i),(function(e,r){return de(t)(e.taskID,r)}))}},Ft=function(t){return function(e,r){var a=r||{},o=a.forwardToReplicas,i=y(n(a,["forwardToReplicas"]));return o&&(i.queryParameters.forwardToReplicas=1),d(t.transporter.write({method:I,path:h("1/indexes/%s/synonyms/%s",t.indexName,e)},i),(function(e,r){return de(t)(e.taskID,r)}))}},Ht=function(t){return function(e){return Lt(t)(e).then((function(){return!0})).catch((function(t){if(404!==t.status)throw t;return!1}))}},Mt=function(t){return function(e,r,n){return t.transporter.read({method:j,path:h("1/answers/%s/prediction",t.indexName),data:{query:e,queryLanguages:r},cacheable:!0},n)}},Kt=function(t){return function(e,o){var i=o||{},u=i.query,s=i.paginate,c=n(i,["query","paginate"]),f=0;return function n(){return ie(t)(u||"",r(r({},c),{},{page:f})).then((function(t){for(var r=0,o=Object.entries(t.hits);r<o.length;r++){var i=a(o[r],2),u=i[0],c=i[1];if(e(c))return{object:c,position:parseInt(u,10),page:f}}if(f++,!1===s||f>=t.nbPages)throw{name:"ObjectNotFoundError",message:"Object not found."};return n()}))}()}},Wt=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/indexes/%s/%s",t.indexName,e)},r)}},Bt=function(){return function(t,e){for(var r=0,n=Object.entries(t.hits);r<n.length;r++){var o=a(n[r],2),i=o[0];if(o[1].objectID===e)return parseInt(i,10)}return-1}},Qt=function(t){return function(e,a){var o=a||{},i=o.attributesToRetrieve,u=n(o,["attributesToRetrieve"]),s=e.map((function(e){return r({indexName:t.indexName,objectID:e},i?{attributesToRetrieve:i}:{})}));return t.transporter.read({method:j,path:"1/indexes/*/objects",data:{requests:s}},u)}},Gt=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/indexes/%s/rules/%s",t.indexName,e)},r)}},Lt=function(t){return function(e){return t.transporter.read({method:x,path:h("1/indexes/%s/settings",t.indexName),data:{getVersion:2}},e)}},Vt=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/indexes/%s/synonyms/%s",t.indexName,e)},r)}},_t=function(t){return function(e,r){return d(Xt(t)([e],r).then((function(t){return{objectID:t.objectIDs[0],taskID:t.taskIDs[0]}})),(function(e,r){return de(t)(e.taskID,r)}))}},Xt=function(t){return function(e,r){var a=r||{},o=a.createIfNotExists,i=n(a,["createIfNotExists"]),u=o?le.PartialUpdateObject:le.PartialUpdateObjectNoCreate;return Tt(t)(e,u,i)}},Yt=function(t){return function(e,i){var u=i||{},s=u.safe,c=u.autoGenerateObjectIDIfNotExist,f=u.batchSize,l=n(u,["safe","autoGenerateObjectIDIfNotExist","batchSize"]),p=function(e,r,n,a){return d(t.transporter.write({method:j,path:h("1/indexes/%s/operation",e),data:{operation:n,destination:r}},a),(function(e,r){return de(t)(e.taskID,r)}))},m=Math.random().toString(36).substring(7),y="".concat(t.indexName,"_tmp_").concat(m),g=ee({appId:t.appId,transporter:t.transporter,indexName:y}),v=[],b=p(t.indexName,y,"copy",r(r({},l),{},{scope:["settings","synonyms","rules"]}));return v.push(b),d((s?b.wait(l):b).then((function(){var t=g(e,r(r({},l),{},{autoGenerateObjectIDIfNotExist:c,batchSize:f}));return v.push(t),s?t.wait(l):t})).then((function(){var e=p(y,t.indexName,"move",l);return v.push(e),s?e.wait(l):e})).then((function(){return Promise.all(v)})).then((function(t){var e=a(t,3),r=e[0],n=e[1],i=e[2];return{objectIDs:n.objectIDs,taskIDs:[r.taskID].concat(o(n.taskIDs),[i.taskID])}})),(function(t,e){return Promise.all(v.map((function(t){return t.wait(e)})))}))}},Zt=function(t){return function(e,n){return ne(t)(e,r(r({},n),{},{clearExistingRules:!0}))}},$t=function(t){return function(e,n){return oe(t)(e,r(r({},n),{},{clearExistingSynonyms:!0}))}},te=function(t){return function(e,r){return d(ee(t)([e],r).then((function(t){return{objectID:t.objectIDs[0],taskID:t.taskIDs[0]}})),(function(e,r){return de(t)(e.taskID,r)}))}},ee=function(t){return function(e,r){var a=r||{},o=a.autoGenerateObjectIDIfNotExist,i=n(a,["autoGenerateObjectIDIfNotExist"]),u=o?le.AddObject:le.UpdateObject;if(u===le.UpdateObject){var s=!0,c=!1,f=void 0;try{for(var l,p=e[Symbol.iterator]();!(s=(l=p.next()).done);s=!0){if(void 0===l.value.objectID)return d(Promise.reject({name:"MissingObjectIDError",message:"All objects must have an unique objectID (like a primary key) to be valid. Algolia is also able to generate objectIDs automatically but *it's not recommended*. To do it, use the `{'autoGenerateObjectIDIfNotExist': true}` option."}))}}catch(t){c=!0,f=t}finally{try{s||null==p.return||p.return()}finally{if(c)throw f}}}return Tt(t)(e,u,i)}},re=function(t){return function(e,r){return ne(t)([e],r)}},ne=function(t){return function(e,r){var a=r||{},o=a.forwardToReplicas,i=a.clearExistingRules,u=y(n(a,["forwardToReplicas","clearExistingRules"]));return o&&(u.queryParameters.forwardToReplicas=1),i&&(u.queryParameters.clearExistingRules=1),d(t.transporter.write({method:j,path:h("1/indexes/%s/rules/batch",t.indexName),data:e},u),(function(e,r){return de(t)(e.taskID,r)}))}},ae=function(t){return function(e,r){return oe(t)([e],r)}},oe=function(t){return function(e,r){var a=r||{},o=a.forwardToReplicas,i=a.clearExistingSynonyms,u=a.replaceExistingSynonyms,s=y(n(a,["forwardToReplicas","clearExistingSynonyms","replaceExistingSynonyms"]));return o&&(s.queryParameters.forwardToReplicas=1),(u||i)&&(s.queryParameters.replaceExistingSynonyms=1),d(t.transporter.write({method:j,path:h("1/indexes/%s/synonyms/batch",t.indexName),data:e},s),(function(e,r){return de(t)(e.taskID,r)}))}},ie=function(t){return function(e,r){return t.transporter.read({method:j,path:h("1/indexes/%s/query",t.indexName),data:{query:e},cacheable:!0},r)}},ue=function(t){return function(e,r,n){return t.transporter.read({method:j,path:h("1/indexes/%s/facets/%s/query",t.indexName,e),data:{facetQuery:r},cacheable:!0},n)}},se=function(t){return function(e,r){return t.transporter.read({method:j,path:h("1/indexes/%s/rules/search",t.indexName),data:{query:e}},r)}},ce=function(t){return function(e,r){return t.transporter.read({method:j,path:h("1/indexes/%s/synonyms/search",t.indexName),data:{query:e}},r)}},fe=function(t){return function(e,r){var a=r||{},o=a.forwardToReplicas,i=y(n(a,["forwardToReplicas"]));return o&&(i.queryParameters.forwardToReplicas=1),d(t.transporter.write({method:D,path:h("1/indexes/%s/settings",t.indexName),data:e},i),(function(e,r){return de(t)(e.taskID,r)}))}},de=function(t){return function(e,r){return f((function(n){return function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/indexes/%s/task/%s",t.indexName,e.toString())},r)}}(t)(e,r).then((function(t){return"published"!==t.status?n():void 0}))}))}},le={AddObject:"addObject",UpdateObject:"updateObject",PartialUpdateObject:"partialUpdateObject",PartialUpdateObjectNoCreate:"partialUpdateObjectNoCreate",DeleteObject:"deleteObject",DeleteIndex:"delete",ClearIndex:"clear"},pe={Settings:"settings",Synonyms:"synonyms",Rules:"rules"},he=1,me=2,ye=3;function ge(t,e,n){var a,o={appId:t,apiKey:e,timeouts:{connect:1,read:2,write:30},requester:{send:function(t){return new Promise((function(e){var r=new XMLHttpRequest;r.open(t.method,t.url,!0),Object.keys(t.headers).forEach((function(e){return r.setRequestHeader(e,t.headers[e])}));var n,a=function(t,n){return setTimeout((function(){r.abort(),e({status:0,content:n,isTimedOut:!0})}),1e3*t)},o=a(t.connectTimeout,"Connection timeout");r.onreadystatechange=function(){r.readyState>r.OPENED&&void 0===n&&(clearTimeout(o),n=a(t.responseTimeout,"Socket timeout"))},r.onerror=function(){0===r.status&&(clearTimeout(o),clearTimeout(n),e({content:r.responseText||"Network request failed",status:r.status,isTimedOut:!1}))},r.onload=function(){clearTimeout(o),clearTimeout(n),e({content:r.responseText,status:r.status,isTimedOut:!1})},r.send(t.data)}))}},logger:(a=ye,{debug:function(t,e){return he>=a&&console.debug(t,e),Promise.resolve()},info:function(t,e){return me>=a&&console.info(t,e),Promise.resolve()},error:function(t,e){return console.error(t,e),Promise.resolve()}}),responsesCache:s(),requestsCache:s({serializable:!1}),hostsCache:u({caches:[i({key:"".concat("4.14.2","-").concat(t)}),s()]}),userAgent:T("4.14.2").add({segment:"Browser"})},f=r(r({},o),n),d=function(){return function(t){return function(t){var e=t.region||"us",n=c(m.WithinHeaders,t.appId,t.apiKey),a=k(r(r({hosts:[{url:"personalization.".concat(e,".algolia.com")}]},t),{},{headers:r(r(r({},n.headers()),{"content-type":"application/json"}),t.headers),queryParameters:r(r({},n.queryParameters()),t.queryParameters)}));return p({appId:t.appId,transporter:a},t.methods)}(r(r(r({},o),t),{},{methods:{getPersonalizationStrategy:H,setPersonalizationStrategy:M}}))}};return function(t){var e=t.appId,n=c(void 0!==t.authMode?t.authMode:m.WithinHeaders,e,t.apiKey),a=k(r(r({hosts:[{url:"".concat(e,"-dsn.algolia.net"),accept:g.Read},{url:"".concat(e,".algolia.net"),accept:g.Write}].concat(l([{url:"".concat(e,"-1.algolianet.com")},{url:"".concat(e,"-2.algolianet.com")},{url:"".concat(e,"-3.algolianet.com")}]))},t),{},{headers:r(r(r({},n.headers()),{"content-type":"application/x-www-form-urlencoded"}),t.headers),queryParameters:r(r({},n.queryParameters()),t.queryParameters)}));return p({transporter:a,appId:e,addAlgoliaAgent:function(t,e){a.userAgent.add({segment:t,version:e})},clearCache:function(){return Promise.all([a.requestsCache.clear(),a.responsesCache.clear()]).then((function(){}))}},t.methods)}(r(r({},f),{},{methods:{search:mt,searchForFacetValues:yt,multipleBatch:pt,multipleGetObjects:ht,multipleQueries:mt,copyIndex:L,copySettings:_,copySynonyms:X,copyRules:V,moveIndex:lt,listIndices:ft,getLogs:nt,listClusters:ct,multipleSearchForFacetValues:yt,getApiKey:tt,addApiKey:W,listApiKeys:st,updateApiKey:xt,deleteApiKey:Z,restoreApiKey:bt,assignUserID:B,assignUserIDs:Q,getUserID:ot,searchUserIDs:Ot,listUserIDs:dt,getTopUserIDs:at,removeUserID:gt,hasPendingMappings:it,clearDictionaryEntries:G,deleteDictionaryEntries:$,getDictionarySettings:rt,getAppTask:et,replaceDictionaryEntries:vt,saveDictionaryEntries:Pt,searchDictionaryEntries:wt,setDictionarySettings:It,waitAppTask:jt,customRequest:Y,initIndex:function(t){return function(e){return ut(t)(e,{methods:{batch:Dt,delete:Ct,findAnswers:Mt,getObject:Wt,getObjects:Qt,saveObject:te,saveObjects:ee,search:ie,searchForFacetValues:ue,waitTask:de,setSettings:fe,getSettings:Lt,partialUpdateObject:_t,partialUpdateObjects:Xt,deleteObject:Ut,deleteObjects:zt,deleteBy:At,clearObjects:Nt,browseObjects:qt,getObjectPosition:Bt,findObject:Kt,exists:Ht,saveSynonym:ae,saveSynonyms:oe,getSynonym:Vt,searchSynonyms:ce,browseSynonyms:kt,deleteSynonym:Ft,clearSynonyms:Rt,replaceAllObjects:Yt,replaceAllSynonyms:$t,searchRules:se,getRule:Gt,deleteRule:Jt,saveRule:re,saveRules:ne,replaceAllRules:Zt,browseRules:St,clearRules:Et}})}},initAnalytics:function(){return function(t){return function(t){var e=t.region||"us",n=c(m.WithinHeaders,t.appId,t.apiKey),a=k(r(r({hosts:[{url:"analytics.".concat(e,".algolia.com")}]},t),{},{headers:r(r(r({},n.headers()),{"content-type":"application/json"}),t.headers),queryParameters:r(r({},n.queryParameters()),t.queryParameters)}));return p({appId:t.appId,transporter:a},t.methods)}(r(r(r({},o),t),{},{methods:{addABTest:C,getABTest:z,getABTests:J,stopABTest:F,deleteABTest:U}}))}},initPersonalization:d,initRecommendation:function(){return function(t){return f.logger.info("The `initRecommendation` method is deprecated. Use `initPersonalization` instead."),d()(t)}}}}))}return ge.version="4.14.2",ge}));


/***/ }),

/***/ 40409:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():0}(this,function(){"use strict";var e="undefined"!=typeof window?window:"undefined"!=typeof __webpack_require__.g?__webpack_require__.g:"undefined"!=typeof self?self:{},t="Expected a function",n=NaN,o="[object Symbol]",i=/^\s+|\s+$/g,a=/^[-+]0x[0-9a-f]+$/i,r=/^0b[01]+$/i,c=/^0o[0-7]+$/i,s=parseInt,u="object"==typeof e&&e&&e.Object===Object&&e,d="object"==typeof self&&self&&self.Object===Object&&self,l=u||d||Function("return this")(),f=Object.prototype.toString,m=Math.max,p=Math.min,b=function(){return l.Date.now()};function v(e,n,o){var i,a,r,c,s,u,d=0,l=!1,f=!1,v=!0;if("function"!=typeof e)throw new TypeError(t);function y(t){var n=i,o=a;return i=a=void 0,d=t,c=e.apply(o,n)}function h(e){var t=e-u;return void 0===u||t>=n||t<0||f&&e-d>=r}function k(){var e=b();if(h(e))return x(e);s=setTimeout(k,function(e){var t=n-(e-u);return f?p(t,r-(e-d)):t}(e))}function x(e){return s=void 0,v&&i?y(e):(i=a=void 0,c)}function O(){var e=b(),t=h(e);if(i=arguments,a=this,u=e,t){if(void 0===s)return function(e){return d=e,s=setTimeout(k,n),l?y(e):c}(u);if(f)return s=setTimeout(k,n),y(u)}return void 0===s&&(s=setTimeout(k,n)),c}return n=w(n)||0,g(o)&&(l=!!o.leading,r=(f="maxWait"in o)?m(w(o.maxWait)||0,n):r,v="trailing"in o?!!o.trailing:v),O.cancel=function(){void 0!==s&&clearTimeout(s),d=0,i=u=a=s=void 0},O.flush=function(){return void 0===s?c:x(b())},O}function g(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function w(e){if("number"==typeof e)return e;if(function(e){return"symbol"==typeof e||function(e){return!!e&&"object"==typeof e}(e)&&f.call(e)==o}(e))return n;if(g(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=g(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(i,"");var u=r.test(e);return u||c.test(e)?s(e.slice(2),u?2:8):a.test(e)?n:+e}var y=function(e,n,o){var i=!0,a=!0;if("function"!=typeof e)throw new TypeError(t);return g(o)&&(i="leading"in o?!!o.leading:i,a="trailing"in o?!!o.trailing:a),v(e,n,{leading:i,maxWait:n,trailing:a})},h="Expected a function",k=NaN,x="[object Symbol]",O=/^\s+|\s+$/g,j=/^[-+]0x[0-9a-f]+$/i,E=/^0b[01]+$/i,N=/^0o[0-7]+$/i,z=parseInt,C="object"==typeof e&&e&&e.Object===Object&&e,A="object"==typeof self&&self&&self.Object===Object&&self,q=C||A||Function("return this")(),L=Object.prototype.toString,T=Math.max,M=Math.min,S=function(){return q.Date.now()};function D(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function H(e){if("number"==typeof e)return e;if(function(e){return"symbol"==typeof e||function(e){return!!e&&"object"==typeof e}(e)&&L.call(e)==x}(e))return k;if(D(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=D(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(O,"");var n=E.test(e);return n||N.test(e)?z(e.slice(2),n?2:8):j.test(e)?k:+e}var $=function(e,t,n){var o,i,a,r,c,s,u=0,d=!1,l=!1,f=!0;if("function"!=typeof e)throw new TypeError(h);function m(t){var n=o,a=i;return o=i=void 0,u=t,r=e.apply(a,n)}function p(e){var n=e-s;return void 0===s||n>=t||n<0||l&&e-u>=a}function b(){var e=S();if(p(e))return v(e);c=setTimeout(b,function(e){var n=t-(e-s);return l?M(n,a-(e-u)):n}(e))}function v(e){return c=void 0,f&&o?m(e):(o=i=void 0,r)}function g(){var e=S(),n=p(e);if(o=arguments,i=this,s=e,n){if(void 0===c)return function(e){return u=e,c=setTimeout(b,t),d?m(e):r}(s);if(l)return c=setTimeout(b,t),m(s)}return void 0===c&&(c=setTimeout(b,t)),r}return t=H(t)||0,D(n)&&(d=!!n.leading,a=(l="maxWait"in n)?T(H(n.maxWait)||0,t):a,f="trailing"in n?!!n.trailing:f),g.cancel=function(){void 0!==c&&clearTimeout(c),u=0,o=s=i=c=void 0},g.flush=function(){return void 0===c?r:v(S())},g},W=function(){};function P(e){e&&e.forEach(function(e){var t=Array.prototype.slice.call(e.addedNodes),n=Array.prototype.slice.call(e.removedNodes);if(function e(t){var n=void 0,o=void 0;for(n=0;n<t.length;n+=1){if((o=t[n]).dataset&&o.dataset.aos)return!0;if(o.children&&e(o.children))return!0}return!1}(t.concat(n)))return W()})}function Y(){return window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver}var _={isSupported:function(){return!!Y()},ready:function(e,t){var n=window.document,o=new(Y())(P);W=t,o.observe(n.documentElement,{childList:!0,subtree:!0,removedNodes:!0})}},B=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},F=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),I=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},K=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,G=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,J=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,Q=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i;function R(){return navigator.userAgent||navigator.vendor||window.opera||""}var U=new(function(){function e(){B(this,e)}return F(e,[{key:"phone",value:function(){var e=R();return!(!K.test(e)&&!G.test(e.substr(0,4)))}},{key:"mobile",value:function(){var e=R();return!(!J.test(e)&&!Q.test(e.substr(0,4)))}},{key:"tablet",value:function(){return this.mobile()&&!this.phone()}},{key:"ie11",value:function(){return"-ms-scroll-limit"in document.documentElement.style&&"-ms-ime-align"in document.documentElement.style}}]),e}()),V=function(e,t){var n=void 0;return U.ie11()?(n=document.createEvent("CustomEvent")).initCustomEvent(e,!0,!0,{detail:t}):n=new CustomEvent(e,{detail:t}),document.dispatchEvent(n)},X=function(e){return e.forEach(function(e,t){return function(e,t){var n=e.options,o=e.position,i=e.node,a=(e.data,function(){e.animated&&(function(e,t){t&&t.forEach(function(t){return e.classList.remove(t)})}(i,n.animatedClassNames),V("aos:out",i),e.options.id&&V("aos:in:"+e.options.id,i),e.animated=!1)});n.mirror&&t>=o.out&&!n.once?a():t>=o.in?e.animated||(function(e,t){t&&t.forEach(function(t){return e.classList.add(t)})}(i,n.animatedClassNames),V("aos:in",i),e.options.id&&V("aos:in:"+e.options.id,i),e.animated=!0):e.animated&&!n.once&&a()}(e,window.pageYOffset)})},Z=function(e){for(var t=0,n=0;e&&!isNaN(e.offsetLeft)&&!isNaN(e.offsetTop);)t+=e.offsetLeft-("BODY"!=e.tagName?e.scrollLeft:0),n+=e.offsetTop-("BODY"!=e.tagName?e.scrollTop:0),e=e.offsetParent;return{top:n,left:t}},ee=function(e,t,n){var o=e.getAttribute("data-aos-"+t);if(void 0!==o){if("true"===o)return!0;if("false"===o)return!1}return o||n},te=function(e,t){return e.forEach(function(e,n){var o=ee(e.node,"mirror",t.mirror),i=ee(e.node,"once",t.once),a=ee(e.node,"id"),r=t.useClassNames&&e.node.getAttribute("data-aos"),c=[t.animatedClassName].concat(r?r.split(" "):[]).filter(function(e){return"string"==typeof e});t.initClassName&&e.node.classList.add(t.initClassName),e.position={in:function(e,t,n){var o=window.innerHeight,i=ee(e,"anchor"),a=ee(e,"anchor-placement"),r=Number(ee(e,"offset",a?0:t)),c=a||n,s=e;i&&document.querySelectorAll(i)&&(s=document.querySelectorAll(i)[0]);var u=Z(s).top-o;switch(c){case"top-bottom":break;case"center-bottom":u+=s.offsetHeight/2;break;case"bottom-bottom":u+=s.offsetHeight;break;case"top-center":u+=o/2;break;case"center-center":u+=o/2+s.offsetHeight/2;break;case"bottom-center":u+=o/2+s.offsetHeight;break;case"top-top":u+=o;break;case"bottom-top":u+=o+s.offsetHeight;break;case"center-top":u+=o+s.offsetHeight/2}return u+r}(e.node,t.offset,t.anchorPlacement),out:o&&function(e,t){window.innerHeight;var n=ee(e,"anchor"),o=ee(e,"offset",t),i=e;return n&&document.querySelectorAll(n)&&(i=document.querySelectorAll(n)[0]),Z(i).top+i.offsetHeight-o}(e.node,t.offset)},e.options={once:i,mirror:o,animatedClassNames:c,id:a}}),e},ne=function(){var e=document.querySelectorAll("[data-aos]");return Array.prototype.map.call(e,function(e){return{node:e}})},oe=[],ie=!1,ae={offset:120,delay:0,easing:"ease",duration:400,disable:!1,once:!1,mirror:!1,anchorPlacement:"top-bottom",startEvent:"DOMContentLoaded",animatedClassName:"aos-animate",initClassName:"aos-init",useClassNames:!1,disableMutationObserver:!1,throttleDelay:99,debounceDelay:50},re=function(){return document.all&&!window.atob},ce=function(){arguments.length>0&&void 0!==arguments[0]&&arguments[0]&&(ie=!0),ie&&(oe=te(oe,ae),X(oe),window.addEventListener("scroll",y(function(){X(oe,ae.once)},ae.throttleDelay)))},se=function(){if(oe=ne(),de(ae.disable)||re())return ue();ce()},ue=function(){oe.forEach(function(e,t){e.node.removeAttribute("data-aos"),e.node.removeAttribute("data-aos-easing"),e.node.removeAttribute("data-aos-duration"),e.node.removeAttribute("data-aos-delay"),ae.initClassName&&e.node.classList.remove(ae.initClassName),ae.animatedClassName&&e.node.classList.remove(ae.animatedClassName)})},de=function(e){return!0===e||"mobile"===e&&U.mobile()||"phone"===e&&U.phone()||"tablet"===e&&U.tablet()||"function"==typeof e&&!0===e()};return{init:function(e){return ae=I(ae,e),oe=ne(),ae.disableMutationObserver||_.isSupported()||(console.info('\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '),ae.disableMutationObserver=!0),ae.disableMutationObserver||_.ready("[data-aos]",se),de(ae.disable)||re()?ue():(document.querySelector("body").setAttribute("data-aos-easing",ae.easing),document.querySelector("body").setAttribute("data-aos-duration",ae.duration),document.querySelector("body").setAttribute("data-aos-delay",ae.delay),-1===["DOMContentLoaded","load"].indexOf(ae.startEvent)?document.addEventListener(ae.startEvent,function(){ce(!0)}):window.addEventListener("load",function(){ce(!0)}),"DOMContentLoaded"===ae.startEvent&&["complete","interactive"].indexOf(document.readyState)>-1&&ce(!0),window.addEventListener("resize",$(ce,ae.debounceDelay,!0)),window.addEventListener("orientationchange",$(ce,ae.debounceDelay,!0)),oe)},refresh:ce,refreshHard:se}});


/***/ }),

/***/ 56779:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 28954:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var deselectCurrent = __webpack_require__(94843);

var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
}

var defaultMessage = "Copy to clipboard: #{key}, Enter";

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
    message,
    reselectPrevious,
    range,
    selection,
    mark,
    success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement("span");
    mark.textContent = text;
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function(e) {
      e.stopPropagation();
      if (options.format) {
        e.preventDefault();
        if (typeof e.clipboardData === "undefined") { // IE 11
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"]
          window.clipboardData.setData(format, text);
        } else { // all other browsers
          e.clipboardData.clearData();
          e.clipboardData.setData(options.format, text);
        }
      }
      if (options.onCopy) {
        e.preventDefault();
        options.onCopy(e.clipboardData);
      }
    });

    document.body.appendChild(mark);

    range.selectNodeContents(mark);
    selection.addRange(range);

    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

module.exports = copy;


/***/ }),

/***/ 72455:
/***/ (function(__unused_webpack_module, exports) {

(function (global, factory) {
	 true ? factory(exports) :
	0;
}(this, (function (exports) { 'use strict';

	/*!
	 * ScrollToPlugin 3.12.5
	 * https://gsap.com
	 *
	 * @license Copyright 2008-2024, GreenSock. All rights reserved.
	 * Subject to the terms at https://gsap.com/standard-license or for
	 * Club GSAP members, the agreement issued with that membership.
	 * @author: Jack Doyle, jack@greensock.com
	*/
	var gsap,
	    _coreInitted,
	    _window,
	    _docEl,
	    _body,
	    _toArray,
	    _config,
	    ScrollTrigger,
	    _windowExists = function _windowExists() {
	  return typeof window !== "undefined";
	},
	    _getGSAP = function _getGSAP() {
	  return gsap || _windowExists() && (gsap = window.gsap) && gsap.registerPlugin && gsap;
	},
	    _isString = function _isString(value) {
	  return typeof value === "string";
	},
	    _isFunction = function _isFunction(value) {
	  return typeof value === "function";
	},
	    _max = function _max(element, axis) {
	  var dim = axis === "x" ? "Width" : "Height",
	      scroll = "scroll" + dim,
	      client = "client" + dim;
	  return element === _window || element === _docEl || element === _body ? Math.max(_docEl[scroll], _body[scroll]) - (_window["inner" + dim] || _docEl[client] || _body[client]) : element[scroll] - element["offset" + dim];
	},
	    _buildGetter = function _buildGetter(e, axis) {
	  var p = "scroll" + (axis === "x" ? "Left" : "Top");

	  if (e === _window) {
	    if (e.pageXOffset != null) {
	      p = "page" + axis.toUpperCase() + "Offset";
	    } else {
	      e = _docEl[p] != null ? _docEl : _body;
	    }
	  }

	  return function () {
	    return e[p];
	  };
	},
	    _clean = function _clean(value, index, target, targets) {
	  _isFunction(value) && (value = value(index, target, targets));

	  if (typeof value !== "object") {
	    return _isString(value) && value !== "max" && value.charAt(1) !== "=" ? {
	      x: value,
	      y: value
	    } : {
	      y: value
	    };
	  } else if (value.nodeType) {
	    return {
	      y: value,
	      x: value
	    };
	  } else {
	    var result = {},
	        p;

	    for (p in value) {
	      result[p] = p !== "onAutoKill" && _isFunction(value[p]) ? value[p](index, target, targets) : value[p];
	    }

	    return result;
	  }
	},
	    _getOffset = function _getOffset(element, container) {
	  element = _toArray(element)[0];

	  if (!element || !element.getBoundingClientRect) {
	    return console.warn("scrollTo target doesn't exist. Using 0") || {
	      x: 0,
	      y: 0
	    };
	  }

	  var rect = element.getBoundingClientRect(),
	      isRoot = !container || container === _window || container === _body,
	      cRect = isRoot ? {
	    top: _docEl.clientTop - (_window.pageYOffset || _docEl.scrollTop || _body.scrollTop || 0),
	    left: _docEl.clientLeft - (_window.pageXOffset || _docEl.scrollLeft || _body.scrollLeft || 0)
	  } : container.getBoundingClientRect(),
	      offsets = {
	    x: rect.left - cRect.left,
	    y: rect.top - cRect.top
	  };

	  if (!isRoot && container) {
	    offsets.x += _buildGetter(container, "x")();
	    offsets.y += _buildGetter(container, "y")();
	  }

	  return offsets;
	},
	    _parseVal = function _parseVal(value, target, axis, currentVal, offset) {
	  return !isNaN(value) && typeof value !== "object" ? parseFloat(value) - offset : _isString(value) && value.charAt(1) === "=" ? parseFloat(value.substr(2)) * (value.charAt(0) === "-" ? -1 : 1) + currentVal - offset : value === "max" ? _max(target, axis) - offset : Math.min(_max(target, axis), _getOffset(value, target)[axis] - offset);
	},
	    _initCore = function _initCore() {
	  gsap = _getGSAP();

	  if (_windowExists() && gsap && typeof document !== "undefined" && document.body) {
	    _window = window;
	    _body = document.body;
	    _docEl = document.documentElement;
	    _toArray = gsap.utils.toArray;
	    gsap.config({
	      autoKillThreshold: 7
	    });
	    _config = gsap.config();
	    _coreInitted = 1;
	  }
	};

	var ScrollToPlugin = {
	  version: "3.12.5",
	  name: "scrollTo",
	  rawVars: 1,
	  register: function register(core) {
	    gsap = core;

	    _initCore();
	  },
	  init: function init(target, value, tween, index, targets) {
	    _coreInitted || _initCore();
	    var data = this,
	        snapType = gsap.getProperty(target, "scrollSnapType");
	    data.isWin = target === _window;
	    data.target = target;
	    data.tween = tween;
	    value = _clean(value, index, target, targets);
	    data.vars = value;
	    data.autoKill = !!value.autoKill;
	    data.getX = _buildGetter(target, "x");
	    data.getY = _buildGetter(target, "y");
	    data.x = data.xPrev = data.getX();
	    data.y = data.yPrev = data.getY();
	    ScrollTrigger || (ScrollTrigger = gsap.core.globals().ScrollTrigger);
	    gsap.getProperty(target, "scrollBehavior") === "smooth" && gsap.set(target, {
	      scrollBehavior: "auto"
	    });

	    if (snapType && snapType !== "none") {
	      data.snap = 1;
	      data.snapInline = target.style.scrollSnapType;
	      target.style.scrollSnapType = "none";
	    }

	    if (value.x != null) {
	      data.add(data, "x", data.x, _parseVal(value.x, target, "x", data.x, value.offsetX || 0), index, targets);

	      data._props.push("scrollTo_x");
	    } else {
	      data.skipX = 1;
	    }

	    if (value.y != null) {
	      data.add(data, "y", data.y, _parseVal(value.y, target, "y", data.y, value.offsetY || 0), index, targets);

	      data._props.push("scrollTo_y");
	    } else {
	      data.skipY = 1;
	    }
	  },
	  render: function render(ratio, data) {
	    var pt = data._pt,
	        target = data.target,
	        tween = data.tween,
	        autoKill = data.autoKill,
	        xPrev = data.xPrev,
	        yPrev = data.yPrev,
	        isWin = data.isWin,
	        snap = data.snap,
	        snapInline = data.snapInline,
	        x,
	        y,
	        yDif,
	        xDif,
	        threshold;

	    while (pt) {
	      pt.r(ratio, pt.d);
	      pt = pt._next;
	    }

	    x = isWin || !data.skipX ? data.getX() : xPrev;
	    y = isWin || !data.skipY ? data.getY() : yPrev;
	    yDif = y - yPrev;
	    xDif = x - xPrev;
	    threshold = _config.autoKillThreshold;

	    if (data.x < 0) {
	      data.x = 0;
	    }

	    if (data.y < 0) {
	      data.y = 0;
	    }

	    if (autoKill) {
	      if (!data.skipX && (xDif > threshold || xDif < -threshold) && x < _max(target, "x")) {
	        data.skipX = 1;
	      }

	      if (!data.skipY && (yDif > threshold || yDif < -threshold) && y < _max(target, "y")) {
	        data.skipY = 1;
	      }

	      if (data.skipX && data.skipY) {
	        tween.kill();
	        data.vars.onAutoKill && data.vars.onAutoKill.apply(tween, data.vars.onAutoKillParams || []);
	      }
	    }

	    if (isWin) {
	      _window.scrollTo(!data.skipX ? data.x : x, !data.skipY ? data.y : y);
	    } else {
	      data.skipY || (target.scrollTop = data.y);
	      data.skipX || (target.scrollLeft = data.x);
	    }

	    if (snap && (ratio === 1 || ratio === 0)) {
	      y = target.scrollTop;
	      x = target.scrollLeft;
	      snapInline ? target.style.scrollSnapType = snapInline : target.style.removeProperty("scroll-snap-type");
	      target.scrollTop = y + 1;
	      target.scrollLeft = x + 1;
	      target.scrollTop = y;
	      target.scrollLeft = x;
	    }

	    data.xPrev = data.x;
	    data.yPrev = data.y;
	    ScrollTrigger && ScrollTrigger.update();
	  },
	  kill: function kill(property) {
	    var both = property === "scrollTo",
	        i = this._props.indexOf(property);

	    if (both || property === "scrollTo_x") {
	      this.skipX = 1;
	    }

	    if (both || property === "scrollTo_y") {
	      this.skipY = 1;
	    }

	    i > -1 && this._props.splice(i, 1);
	    return !this._props.length;
	  }
	};
	ScrollToPlugin.max = _max;
	ScrollToPlugin.getOffset = _getOffset;
	ScrollToPlugin.buildGetter = _buildGetter;
	_getGSAP() && gsap.registerPlugin(ScrollToPlugin);

	exports.ScrollToPlugin = ScrollToPlugin;
	exports.default = ScrollToPlugin;

	Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),

/***/ 46285:
/***/ (function(__unused_webpack_module, exports) {

(function (global, factory) {
   true ? factory(exports) :
  0;
}(this, (function (exports) { 'use strict';

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  /*!
   * Observer 3.12.5
   * https://gsap.com
   *
   * @license Copyright 2008-2024, GreenSock. All rights reserved.
   * Subject to the terms at https://gsap.com/standard-license or for
   * Club GSAP members, the agreement issued with that membership.
   * @author: Jack Doyle, jack@greensock.com
  */
  var gsap,
      _coreInitted,
      _clamp,
      _win,
      _doc,
      _docEl,
      _body,
      _isTouch,
      _pointerType,
      ScrollTrigger,
      _root,
      _normalizer,
      _eventTypes,
      _context,
      _getGSAP = function _getGSAP() {
    return gsap || typeof window !== "undefined" && (gsap = window.gsap) && gsap.registerPlugin && gsap;
  },
      _startup = 1,
      _observers = [],
      _scrollers = [],
      _proxies = [],
      _getTime = Date.now,
      _bridge = function _bridge(name, value) {
    return value;
  },
      _integrate = function _integrate() {
    var core = ScrollTrigger.core,
        data = core.bridge || {},
        scrollers = core._scrollers,
        proxies = core._proxies;
    scrollers.push.apply(scrollers, _scrollers);
    proxies.push.apply(proxies, _proxies);
    _scrollers = scrollers;
    _proxies = proxies;

    _bridge = function _bridge(name, value) {
      return data[name](value);
    };
  },
      _getProxyProp = function _getProxyProp(element, property) {
    return ~_proxies.indexOf(element) && _proxies[_proxies.indexOf(element) + 1][property];
  },
      _isViewport = function _isViewport(el) {
    return !!~_root.indexOf(el);
  },
      _addListener = function _addListener(element, type, func, passive, capture) {
    return element.addEventListener(type, func, {
      passive: passive !== false,
      capture: !!capture
    });
  },
      _removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
  },
      _scrollLeft = "scrollLeft",
      _scrollTop = "scrollTop",
      _onScroll = function _onScroll() {
    return _normalizer && _normalizer.isPressed || _scrollers.cache++;
  },
      _scrollCacheFunc = function _scrollCacheFunc(f, doNotCache) {
    var cachingFunc = function cachingFunc(value) {
      if (value || value === 0) {
        _startup && (_win.history.scrollRestoration = "manual");
        var isNormalizing = _normalizer && _normalizer.isPressed;
        value = cachingFunc.v = Math.round(value) || (_normalizer && _normalizer.iOS ? 1 : 0);
        f(value);
        cachingFunc.cacheID = _scrollers.cache;
        isNormalizing && _bridge("ss", value);
      } else if (doNotCache || _scrollers.cache !== cachingFunc.cacheID || _bridge("ref")) {
        cachingFunc.cacheID = _scrollers.cache;
        cachingFunc.v = f();
      }

      return cachingFunc.v + cachingFunc.offset;
    };

    cachingFunc.offset = 0;
    return f && cachingFunc;
  },
      _horizontal = {
    s: _scrollLeft,
    p: "left",
    p2: "Left",
    os: "right",
    os2: "Right",
    d: "width",
    d2: "Width",
    a: "x",
    sc: _scrollCacheFunc(function (value) {
      return arguments.length ? _win.scrollTo(value, _vertical.sc()) : _win.pageXOffset || _doc[_scrollLeft] || _docEl[_scrollLeft] || _body[_scrollLeft] || 0;
    })
  },
      _vertical = {
    s: _scrollTop,
    p: "top",
    p2: "Top",
    os: "bottom",
    os2: "Bottom",
    d: "height",
    d2: "Height",
    a: "y",
    op: _horizontal,
    sc: _scrollCacheFunc(function (value) {
      return arguments.length ? _win.scrollTo(_horizontal.sc(), value) : _win.pageYOffset || _doc[_scrollTop] || _docEl[_scrollTop] || _body[_scrollTop] || 0;
    })
  },
      _getTarget = function _getTarget(t, self) {
    return (self && self._ctx && self._ctx.selector || gsap.utils.toArray)(t)[0] || (typeof t === "string" && gsap.config().nullTargetWarn !== false ? console.warn("Element not found:", t) : null);
  },
      _getScrollFunc = function _getScrollFunc(element, _ref) {
    var s = _ref.s,
        sc = _ref.sc;
    _isViewport(element) && (element = _doc.scrollingElement || _docEl);

    var i = _scrollers.indexOf(element),
        offset = sc === _vertical.sc ? 1 : 2;

    !~i && (i = _scrollers.push(element) - 1);
    _scrollers[i + offset] || _addListener(element, "scroll", _onScroll);
    var prev = _scrollers[i + offset],
        func = prev || (_scrollers[i + offset] = _scrollCacheFunc(_getProxyProp(element, s), true) || (_isViewport(element) ? sc : _scrollCacheFunc(function (value) {
      return arguments.length ? element[s] = value : element[s];
    })));
    func.target = element;
    prev || (func.smooth = gsap.getProperty(element, "scrollBehavior") === "smooth");
    return func;
  },
      _getVelocityProp = function _getVelocityProp(value, minTimeRefresh, useDelta) {
    var v1 = value,
        v2 = value,
        t1 = _getTime(),
        t2 = t1,
        min = minTimeRefresh || 50,
        dropToZeroTime = Math.max(500, min * 3),
        update = function update(value, force) {
      var t = _getTime();

      if (force || t - t1 > min) {
        v2 = v1;
        v1 = value;
        t2 = t1;
        t1 = t;
      } else if (useDelta) {
        v1 += value;
      } else {
        v1 = v2 + (value - v2) / (t - t2) * (t1 - t2);
      }
    },
        reset = function reset() {
      v2 = v1 = useDelta ? 0 : v1;
      t2 = t1 = 0;
    },
        getVelocity = function getVelocity(latestValue) {
      var tOld = t2,
          vOld = v2,
          t = _getTime();

      (latestValue || latestValue === 0) && latestValue !== v1 && update(latestValue);
      return t1 === t2 || t - t2 > dropToZeroTime ? 0 : (v1 + (useDelta ? vOld : -vOld)) / ((useDelta ? t : t1) - tOld) * 1000;
    };

    return {
      update: update,
      reset: reset,
      getVelocity: getVelocity
    };
  },
      _getEvent = function _getEvent(e, preventDefault) {
    preventDefault && !e._gsapAllow && e.preventDefault();
    return e.changedTouches ? e.changedTouches[0] : e;
  },
      _getAbsoluteMax = function _getAbsoluteMax(a) {
    var max = Math.max.apply(Math, a),
        min = Math.min.apply(Math, a);
    return Math.abs(max) >= Math.abs(min) ? max : min;
  },
      _setScrollTrigger = function _setScrollTrigger() {
    ScrollTrigger = gsap.core.globals().ScrollTrigger;
    ScrollTrigger && ScrollTrigger.core && _integrate();
  },
      _initCore = function _initCore(core) {
    gsap = core || _getGSAP();

    if (!_coreInitted && gsap && typeof document !== "undefined" && document.body) {
      _win = window;
      _doc = document;
      _docEl = _doc.documentElement;
      _body = _doc.body;
      _root = [_win, _doc, _docEl, _body];
      _clamp = gsap.utils.clamp;

      _context = gsap.core.context || function () {};

      _pointerType = "onpointerenter" in _body ? "pointer" : "mouse";
      _isTouch = Observer.isTouch = _win.matchMedia && _win.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in _win || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0;
      _eventTypes = Observer.eventTypes = ("ontouchstart" in _docEl ? "touchstart,touchmove,touchcancel,touchend" : !("onpointerdown" in _docEl) ? "mousedown,mousemove,mouseup,mouseup" : "pointerdown,pointermove,pointercancel,pointerup").split(",");
      setTimeout(function () {
        return _startup = 0;
      }, 500);

      _setScrollTrigger();

      _coreInitted = 1;
    }

    return _coreInitted;
  };

  _horizontal.op = _vertical;
  _scrollers.cache = 0;
  var Observer = function () {
    function Observer(vars) {
      this.init(vars);
    }

    var _proto = Observer.prototype;

    _proto.init = function init(vars) {
      _coreInitted || _initCore(gsap) || console.warn("Please gsap.registerPlugin(Observer)");
      ScrollTrigger || _setScrollTrigger();
      var tolerance = vars.tolerance,
          dragMinimum = vars.dragMinimum,
          type = vars.type,
          target = vars.target,
          lineHeight = vars.lineHeight,
          debounce = vars.debounce,
          preventDefault = vars.preventDefault,
          onStop = vars.onStop,
          onStopDelay = vars.onStopDelay,
          ignore = vars.ignore,
          wheelSpeed = vars.wheelSpeed,
          event = vars.event,
          onDragStart = vars.onDragStart,
          onDragEnd = vars.onDragEnd,
          onDrag = vars.onDrag,
          onPress = vars.onPress,
          onRelease = vars.onRelease,
          onRight = vars.onRight,
          onLeft = vars.onLeft,
          onUp = vars.onUp,
          onDown = vars.onDown,
          onChangeX = vars.onChangeX,
          onChangeY = vars.onChangeY,
          onChange = vars.onChange,
          onToggleX = vars.onToggleX,
          onToggleY = vars.onToggleY,
          onHover = vars.onHover,
          onHoverEnd = vars.onHoverEnd,
          onMove = vars.onMove,
          ignoreCheck = vars.ignoreCheck,
          isNormalizer = vars.isNormalizer,
          onGestureStart = vars.onGestureStart,
          onGestureEnd = vars.onGestureEnd,
          onWheel = vars.onWheel,
          onEnable = vars.onEnable,
          onDisable = vars.onDisable,
          onClick = vars.onClick,
          scrollSpeed = vars.scrollSpeed,
          capture = vars.capture,
          allowClicks = vars.allowClicks,
          lockAxis = vars.lockAxis,
          onLockAxis = vars.onLockAxis;
      this.target = target = _getTarget(target) || _docEl;
      this.vars = vars;
      ignore && (ignore = gsap.utils.toArray(ignore));
      tolerance = tolerance || 1e-9;
      dragMinimum = dragMinimum || 0;
      wheelSpeed = wheelSpeed || 1;
      scrollSpeed = scrollSpeed || 1;
      type = type || "wheel,touch,pointer";
      debounce = debounce !== false;
      lineHeight || (lineHeight = parseFloat(_win.getComputedStyle(_body).lineHeight) || 22);

      var id,
          onStopDelayedCall,
          dragged,
          moved,
          wheeled,
          locked,
          axis,
          self = this,
          prevDeltaX = 0,
          prevDeltaY = 0,
          passive = vars.passive || !preventDefault,
          scrollFuncX = _getScrollFunc(target, _horizontal),
          scrollFuncY = _getScrollFunc(target, _vertical),
          scrollX = scrollFuncX(),
          scrollY = scrollFuncY(),
          limitToTouch = ~type.indexOf("touch") && !~type.indexOf("pointer") && _eventTypes[0] === "pointerdown",
          isViewport = _isViewport(target),
          ownerDoc = target.ownerDocument || _doc,
          deltaX = [0, 0, 0],
          deltaY = [0, 0, 0],
          onClickTime = 0,
          clickCapture = function clickCapture() {
        return onClickTime = _getTime();
      },
          _ignoreCheck = function _ignoreCheck(e, isPointerOrTouch) {
        return (self.event = e) && ignore && ~ignore.indexOf(e.target) || isPointerOrTouch && limitToTouch && e.pointerType !== "touch" || ignoreCheck && ignoreCheck(e, isPointerOrTouch);
      },
          onStopFunc = function onStopFunc() {
        self._vx.reset();

        self._vy.reset();

        onStopDelayedCall.pause();
        onStop && onStop(self);
      },
          update = function update() {
        var dx = self.deltaX = _getAbsoluteMax(deltaX),
            dy = self.deltaY = _getAbsoluteMax(deltaY),
            changedX = Math.abs(dx) >= tolerance,
            changedY = Math.abs(dy) >= tolerance;

        onChange && (changedX || changedY) && onChange(self, dx, dy, deltaX, deltaY);

        if (changedX) {
          onRight && self.deltaX > 0 && onRight(self);
          onLeft && self.deltaX < 0 && onLeft(self);
          onChangeX && onChangeX(self);
          onToggleX && self.deltaX < 0 !== prevDeltaX < 0 && onToggleX(self);
          prevDeltaX = self.deltaX;
          deltaX[0] = deltaX[1] = deltaX[2] = 0;
        }

        if (changedY) {
          onDown && self.deltaY > 0 && onDown(self);
          onUp && self.deltaY < 0 && onUp(self);
          onChangeY && onChangeY(self);
          onToggleY && self.deltaY < 0 !== prevDeltaY < 0 && onToggleY(self);
          prevDeltaY = self.deltaY;
          deltaY[0] = deltaY[1] = deltaY[2] = 0;
        }

        if (moved || dragged) {
          onMove && onMove(self);

          if (dragged) {
            onDrag(self);
            dragged = false;
          }

          moved = false;
        }

        locked && !(locked = false) && onLockAxis && onLockAxis(self);

        if (wheeled) {
          onWheel(self);
          wheeled = false;
        }

        id = 0;
      },
          onDelta = function onDelta(x, y, index) {
        deltaX[index] += x;
        deltaY[index] += y;

        self._vx.update(x);

        self._vy.update(y);

        debounce ? id || (id = requestAnimationFrame(update)) : update();
      },
          onTouchOrPointerDelta = function onTouchOrPointerDelta(x, y) {
        if (lockAxis && !axis) {
          self.axis = axis = Math.abs(x) > Math.abs(y) ? "x" : "y";
          locked = true;
        }

        if (axis !== "y") {
          deltaX[2] += x;

          self._vx.update(x, true);
        }

        if (axis !== "x") {
          deltaY[2] += y;

          self._vy.update(y, true);
        }

        debounce ? id || (id = requestAnimationFrame(update)) : update();
      },
          _onDrag = function _onDrag(e) {
        if (_ignoreCheck(e, 1)) {
          return;
        }

        e = _getEvent(e, preventDefault);
        var x = e.clientX,
            y = e.clientY,
            dx = x - self.x,
            dy = y - self.y,
            isDragging = self.isDragging;
        self.x = x;
        self.y = y;

        if (isDragging || Math.abs(self.startX - x) >= dragMinimum || Math.abs(self.startY - y) >= dragMinimum) {
          onDrag && (dragged = true);
          isDragging || (self.isDragging = true);
          onTouchOrPointerDelta(dx, dy);
          isDragging || onDragStart && onDragStart(self);
        }
      },
          _onPress = self.onPress = function (e) {
        if (_ignoreCheck(e, 1) || e && e.button) {
          return;
        }

        self.axis = axis = null;
        onStopDelayedCall.pause();
        self.isPressed = true;
        e = _getEvent(e);
        prevDeltaX = prevDeltaY = 0;
        self.startX = self.x = e.clientX;
        self.startY = self.y = e.clientY;

        self._vx.reset();

        self._vy.reset();

        _addListener(isNormalizer ? target : ownerDoc, _eventTypes[1], _onDrag, passive, true);

        self.deltaX = self.deltaY = 0;
        onPress && onPress(self);
      },
          _onRelease = self.onRelease = function (e) {
        if (_ignoreCheck(e, 1)) {
          return;
        }

        _removeListener(isNormalizer ? target : ownerDoc, _eventTypes[1], _onDrag, true);

        var isTrackingDrag = !isNaN(self.y - self.startY),
            wasDragging = self.isDragging,
            isDragNotClick = wasDragging && (Math.abs(self.x - self.startX) > 3 || Math.abs(self.y - self.startY) > 3),
            eventData = _getEvent(e);

        if (!isDragNotClick && isTrackingDrag) {
          self._vx.reset();

          self._vy.reset();

          if (preventDefault && allowClicks) {
            gsap.delayedCall(0.08, function () {
              if (_getTime() - onClickTime > 300 && !e.defaultPrevented) {
                if (e.target.click) {
                  e.target.click();
                } else if (ownerDoc.createEvent) {
                  var syntheticEvent = ownerDoc.createEvent("MouseEvents");
                  syntheticEvent.initMouseEvent("click", true, true, _win, 1, eventData.screenX, eventData.screenY, eventData.clientX, eventData.clientY, false, false, false, false, 0, null);
                  e.target.dispatchEvent(syntheticEvent);
                }
              }
            });
          }
        }

        self.isDragging = self.isGesturing = self.isPressed = false;
        onStop && wasDragging && !isNormalizer && onStopDelayedCall.restart(true);
        onDragEnd && wasDragging && onDragEnd(self);
        onRelease && onRelease(self, isDragNotClick);
      },
          _onGestureStart = function _onGestureStart(e) {
        return e.touches && e.touches.length > 1 && (self.isGesturing = true) && onGestureStart(e, self.isDragging);
      },
          _onGestureEnd = function _onGestureEnd() {
        return (self.isGesturing = false) || onGestureEnd(self);
      },
          onScroll = function onScroll(e) {
        if (_ignoreCheck(e)) {
          return;
        }

        var x = scrollFuncX(),
            y = scrollFuncY();
        onDelta((x - scrollX) * scrollSpeed, (y - scrollY) * scrollSpeed, 1);
        scrollX = x;
        scrollY = y;
        onStop && onStopDelayedCall.restart(true);
      },
          _onWheel = function _onWheel(e) {
        if (_ignoreCheck(e)) {
          return;
        }

        e = _getEvent(e, preventDefault);
        onWheel && (wheeled = true);
        var multiplier = (e.deltaMode === 1 ? lineHeight : e.deltaMode === 2 ? _win.innerHeight : 1) * wheelSpeed;
        onDelta(e.deltaX * multiplier, e.deltaY * multiplier, 0);
        onStop && !isNormalizer && onStopDelayedCall.restart(true);
      },
          _onMove = function _onMove(e) {
        if (_ignoreCheck(e)) {
          return;
        }

        var x = e.clientX,
            y = e.clientY,
            dx = x - self.x,
            dy = y - self.y;
        self.x = x;
        self.y = y;
        moved = true;
        onStop && onStopDelayedCall.restart(true);
        (dx || dy) && onTouchOrPointerDelta(dx, dy);
      },
          _onHover = function _onHover(e) {
        self.event = e;
        onHover(self);
      },
          _onHoverEnd = function _onHoverEnd(e) {
        self.event = e;
        onHoverEnd(self);
      },
          _onClick = function _onClick(e) {
        return _ignoreCheck(e) || _getEvent(e, preventDefault) && onClick(self);
      };

      onStopDelayedCall = self._dc = gsap.delayedCall(onStopDelay || 0.25, onStopFunc).pause();
      self.deltaX = self.deltaY = 0;
      self._vx = _getVelocityProp(0, 50, true);
      self._vy = _getVelocityProp(0, 50, true);
      self.scrollX = scrollFuncX;
      self.scrollY = scrollFuncY;
      self.isDragging = self.isGesturing = self.isPressed = false;

      _context(this);

      self.enable = function (e) {
        if (!self.isEnabled) {
          _addListener(isViewport ? ownerDoc : target, "scroll", _onScroll);

          type.indexOf("scroll") >= 0 && _addListener(isViewport ? ownerDoc : target, "scroll", onScroll, passive, capture);
          type.indexOf("wheel") >= 0 && _addListener(target, "wheel", _onWheel, passive, capture);

          if (type.indexOf("touch") >= 0 && _isTouch || type.indexOf("pointer") >= 0) {
            _addListener(target, _eventTypes[0], _onPress, passive, capture);

            _addListener(ownerDoc, _eventTypes[2], _onRelease);

            _addListener(ownerDoc, _eventTypes[3], _onRelease);

            allowClicks && _addListener(target, "click", clickCapture, true, true);
            onClick && _addListener(target, "click", _onClick);
            onGestureStart && _addListener(ownerDoc, "gesturestart", _onGestureStart);
            onGestureEnd && _addListener(ownerDoc, "gestureend", _onGestureEnd);
            onHover && _addListener(target, _pointerType + "enter", _onHover);
            onHoverEnd && _addListener(target, _pointerType + "leave", _onHoverEnd);
            onMove && _addListener(target, _pointerType + "move", _onMove);
          }

          self.isEnabled = true;
          e && e.type && _onPress(e);
          onEnable && onEnable(self);
        }

        return self;
      };

      self.disable = function () {
        if (self.isEnabled) {
          _observers.filter(function (o) {
            return o !== self && _isViewport(o.target);
          }).length || _removeListener(isViewport ? ownerDoc : target, "scroll", _onScroll);

          if (self.isPressed) {
            self._vx.reset();

            self._vy.reset();

            _removeListener(isNormalizer ? target : ownerDoc, _eventTypes[1], _onDrag, true);
          }

          _removeListener(isViewport ? ownerDoc : target, "scroll", onScroll, capture);

          _removeListener(target, "wheel", _onWheel, capture);

          _removeListener(target, _eventTypes[0], _onPress, capture);

          _removeListener(ownerDoc, _eventTypes[2], _onRelease);

          _removeListener(ownerDoc, _eventTypes[3], _onRelease);

          _removeListener(target, "click", clickCapture, true);

          _removeListener(target, "click", _onClick);

          _removeListener(ownerDoc, "gesturestart", _onGestureStart);

          _removeListener(ownerDoc, "gestureend", _onGestureEnd);

          _removeListener(target, _pointerType + "enter", _onHover);

          _removeListener(target, _pointerType + "leave", _onHoverEnd);

          _removeListener(target, _pointerType + "move", _onMove);

          self.isEnabled = self.isPressed = self.isDragging = false;
          onDisable && onDisable(self);
        }
      };

      self.kill = self.revert = function () {
        self.disable();

        var i = _observers.indexOf(self);

        i >= 0 && _observers.splice(i, 1);
        _normalizer === self && (_normalizer = 0);
      };

      _observers.push(self);

      isNormalizer && _isViewport(target) && (_normalizer = self);
      self.enable(event);
    };

    _createClass(Observer, [{
      key: "velocityX",
      get: function get() {
        return this._vx.getVelocity();
      }
    }, {
      key: "velocityY",
      get: function get() {
        return this._vy.getVelocity();
      }
    }]);

    return Observer;
  }();
  Observer.version = "3.12.5";

  Observer.create = function (vars) {
    return new Observer(vars);
  };

  Observer.register = _initCore;

  Observer.getAll = function () {
    return _observers.slice();
  };

  Observer.getById = function (id) {
    return _observers.filter(function (o) {
      return o.vars.id === id;
    })[0];
  };

  _getGSAP() && gsap.registerPlugin(Observer);

  /*!
   * ScrollTrigger 3.12.5
   * https://gsap.com
   *
   * @license Copyright 2008-2024, GreenSock. All rights reserved.
   * Subject to the terms at https://gsap.com/standard-license or for
   * Club GSAP members, the agreement issued with that membership.
   * @author: Jack Doyle, jack@greensock.com
  */

  var gsap$1,
      _coreInitted$1,
      _win$1,
      _doc$1,
      _docEl$1,
      _body$1,
      _root$1,
      _resizeDelay,
      _toArray,
      _clamp$1,
      _time2,
      _syncInterval,
      _refreshing,
      _pointerIsDown,
      _transformProp,
      _i,
      _prevWidth,
      _prevHeight,
      _autoRefresh,
      _sort,
      _suppressOverwrites,
      _ignoreResize,
      _normalizer$1,
      _ignoreMobileResize,
      _baseScreenHeight,
      _baseScreenWidth,
      _fixIOSBug,
      _context$1,
      _scrollRestoration,
      _div100vh,
      _100vh,
      _isReverted,
      _clampingMax,
      _limitCallbacks,
      _startup$1 = 1,
      _getTime$1 = Date.now,
      _time1 = _getTime$1(),
      _lastScrollTime = 0,
      _enabled = 0,
      _parseClamp = function _parseClamp(value, type, self) {
    var clamp = _isString(value) && (value.substr(0, 6) === "clamp(" || value.indexOf("max") > -1);
    self["_" + type + "Clamp"] = clamp;
    return clamp ? value.substr(6, value.length - 7) : value;
  },
      _keepClamp = function _keepClamp(value, clamp) {
    return clamp && (!_isString(value) || value.substr(0, 6) !== "clamp(") ? "clamp(" + value + ")" : value;
  },
      _rafBugFix = function _rafBugFix() {
    return _enabled && requestAnimationFrame(_rafBugFix);
  },
      _pointerDownHandler = function _pointerDownHandler() {
    return _pointerIsDown = 1;
  },
      _pointerUpHandler = function _pointerUpHandler() {
    return _pointerIsDown = 0;
  },
      _passThrough = function _passThrough(v) {
    return v;
  },
      _round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
  },
      _windowExists = function _windowExists() {
    return typeof window !== "undefined";
  },
      _getGSAP$1 = function _getGSAP() {
    return gsap$1 || _windowExists() && (gsap$1 = window.gsap) && gsap$1.registerPlugin && gsap$1;
  },
      _isViewport$1 = function _isViewport(e) {
    return !!~_root$1.indexOf(e);
  },
      _getViewportDimension = function _getViewportDimension(dimensionProperty) {
    return (dimensionProperty === "Height" ? _100vh : _win$1["inner" + dimensionProperty]) || _docEl$1["client" + dimensionProperty] || _body$1["client" + dimensionProperty];
  },
      _getBoundsFunc = function _getBoundsFunc(element) {
    return _getProxyProp(element, "getBoundingClientRect") || (_isViewport$1(element) ? function () {
      _winOffsets.width = _win$1.innerWidth;
      _winOffsets.height = _100vh;
      return _winOffsets;
    } : function () {
      return _getBounds(element);
    });
  },
      _getSizeFunc = function _getSizeFunc(scroller, isViewport, _ref) {
    var d = _ref.d,
        d2 = _ref.d2,
        a = _ref.a;
    return (a = _getProxyProp(scroller, "getBoundingClientRect")) ? function () {
      return a()[d];
    } : function () {
      return (isViewport ? _getViewportDimension(d2) : scroller["client" + d2]) || 0;
    };
  },
      _getOffsetsFunc = function _getOffsetsFunc(element, isViewport) {
    return !isViewport || ~_proxies.indexOf(element) ? _getBoundsFunc(element) : function () {
      return _winOffsets;
    };
  },
      _maxScroll = function _maxScroll(element, _ref2) {
    var s = _ref2.s,
        d2 = _ref2.d2,
        d = _ref2.d,
        a = _ref2.a;
    return Math.max(0, (s = "scroll" + d2) && (a = _getProxyProp(element, s)) ? a() - _getBoundsFunc(element)()[d] : _isViewport$1(element) ? (_docEl$1[s] || _body$1[s]) - _getViewportDimension(d2) : element[s] - element["offset" + d2]);
  },
      _iterateAutoRefresh = function _iterateAutoRefresh(func, events) {
    for (var i = 0; i < _autoRefresh.length; i += 3) {
      (!events || ~events.indexOf(_autoRefresh[i + 1])) && func(_autoRefresh[i], _autoRefresh[i + 1], _autoRefresh[i + 2]);
    }
  },
      _isString = function _isString(value) {
    return typeof value === "string";
  },
      _isFunction = function _isFunction(value) {
    return typeof value === "function";
  },
      _isNumber = function _isNumber(value) {
    return typeof value === "number";
  },
      _isObject = function _isObject(value) {
    return typeof value === "object";
  },
      _endAnimation = function _endAnimation(animation, reversed, pause) {
    return animation && animation.progress(reversed ? 0 : 1) && pause && animation.pause();
  },
      _callback = function _callback(self, func) {
    if (self.enabled) {
      var result = self._ctx ? self._ctx.add(function () {
        return func(self);
      }) : func(self);
      result && result.totalTime && (self.callbackAnimation = result);
    }
  },
      _abs = Math.abs,
      _left = "left",
      _top = "top",
      _right = "right",
      _bottom = "bottom",
      _width = "width",
      _height = "height",
      _Right = "Right",
      _Left = "Left",
      _Top = "Top",
      _Bottom = "Bottom",
      _padding = "padding",
      _margin = "margin",
      _Width = "Width",
      _Height = "Height",
      _px = "px",
      _getComputedStyle = function _getComputedStyle(element) {
    return _win$1.getComputedStyle(element);
  },
      _makePositionable = function _makePositionable(element) {
    var position = _getComputedStyle(element).position;

    element.style.position = position === "absolute" || position === "fixed" ? position : "relative";
  },
      _setDefaults = function _setDefaults(obj, defaults) {
    for (var p in defaults) {
      p in obj || (obj[p] = defaults[p]);
    }

    return obj;
  },
      _getBounds = function _getBounds(element, withoutTransforms) {
    var tween = withoutTransforms && _getComputedStyle(element)[_transformProp] !== "matrix(1, 0, 0, 1, 0, 0)" && gsap$1.to(element, {
      x: 0,
      y: 0,
      xPercent: 0,
      yPercent: 0,
      rotation: 0,
      rotationX: 0,
      rotationY: 0,
      scale: 1,
      skewX: 0,
      skewY: 0
    }).progress(1),
        bounds = element.getBoundingClientRect();
    tween && tween.progress(0).kill();
    return bounds;
  },
      _getSize = function _getSize(element, _ref3) {
    var d2 = _ref3.d2;
    return element["offset" + d2] || element["client" + d2] || 0;
  },
      _getLabelRatioArray = function _getLabelRatioArray(timeline) {
    var a = [],
        labels = timeline.labels,
        duration = timeline.duration(),
        p;

    for (p in labels) {
      a.push(labels[p] / duration);
    }

    return a;
  },
      _getClosestLabel = function _getClosestLabel(animation) {
    return function (value) {
      return gsap$1.utils.snap(_getLabelRatioArray(animation), value);
    };
  },
      _snapDirectional = function _snapDirectional(snapIncrementOrArray) {
    var snap = gsap$1.utils.snap(snapIncrementOrArray),
        a = Array.isArray(snapIncrementOrArray) && snapIncrementOrArray.slice(0).sort(function (a, b) {
      return a - b;
    });
    return a ? function (value, direction, threshold) {
      if (threshold === void 0) {
        threshold = 1e-3;
      }

      var i;

      if (!direction) {
        return snap(value);
      }

      if (direction > 0) {
        value -= threshold;

        for (i = 0; i < a.length; i++) {
          if (a[i] >= value) {
            return a[i];
          }
        }

        return a[i - 1];
      } else {
        i = a.length;
        value += threshold;

        while (i--) {
          if (a[i] <= value) {
            return a[i];
          }
        }
      }

      return a[0];
    } : function (value, direction, threshold) {
      if (threshold === void 0) {
        threshold = 1e-3;
      }

      var snapped = snap(value);
      return !direction || Math.abs(snapped - value) < threshold || snapped - value < 0 === direction < 0 ? snapped : snap(direction < 0 ? value - snapIncrementOrArray : value + snapIncrementOrArray);
    };
  },
      _getLabelAtDirection = function _getLabelAtDirection(timeline) {
    return function (value, st) {
      return _snapDirectional(_getLabelRatioArray(timeline))(value, st.direction);
    };
  },
      _multiListener = function _multiListener(func, element, types, callback) {
    return types.split(",").forEach(function (type) {
      return func(element, type, callback);
    });
  },
      _addListener$1 = function _addListener(element, type, func, nonPassive, capture) {
    return element.addEventListener(type, func, {
      passive: !nonPassive,
      capture: !!capture
    });
  },
      _removeListener$1 = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
  },
      _wheelListener = function _wheelListener(func, el, scrollFunc) {
    scrollFunc = scrollFunc && scrollFunc.wheelHandler;

    if (scrollFunc) {
      func(el, "wheel", scrollFunc);
      func(el, "touchmove", scrollFunc);
    }
  },
      _markerDefaults = {
    startColor: "green",
    endColor: "red",
    indent: 0,
    fontSize: "16px",
    fontWeight: "normal"
  },
      _defaults = {
    toggleActions: "play",
    anticipatePin: 0
  },
      _keywords = {
    top: 0,
    left: 0,
    center: 0.5,
    bottom: 1,
    right: 1
  },
      _offsetToPx = function _offsetToPx(value, size) {
    if (_isString(value)) {
      var eqIndex = value.indexOf("="),
          relative = ~eqIndex ? +(value.charAt(eqIndex - 1) + 1) * parseFloat(value.substr(eqIndex + 1)) : 0;

      if (~eqIndex) {
        value.indexOf("%") > eqIndex && (relative *= size / 100);
        value = value.substr(0, eqIndex - 1);
      }

      value = relative + (value in _keywords ? _keywords[value] * size : ~value.indexOf("%") ? parseFloat(value) * size / 100 : parseFloat(value) || 0);
    }

    return value;
  },
      _createMarker = function _createMarker(type, name, container, direction, _ref4, offset, matchWidthEl, containerAnimation) {
    var startColor = _ref4.startColor,
        endColor = _ref4.endColor,
        fontSize = _ref4.fontSize,
        indent = _ref4.indent,
        fontWeight = _ref4.fontWeight;

    var e = _doc$1.createElement("div"),
        useFixedPosition = _isViewport$1(container) || _getProxyProp(container, "pinType") === "fixed",
        isScroller = type.indexOf("scroller") !== -1,
        parent = useFixedPosition ? _body$1 : container,
        isStart = type.indexOf("start") !== -1,
        color = isStart ? startColor : endColor,
        css = "border-color:" + color + ";font-size:" + fontSize + ";color:" + color + ";font-weight:" + fontWeight + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";

    css += "position:" + ((isScroller || containerAnimation) && useFixedPosition ? "fixed;" : "absolute;");
    (isScroller || containerAnimation || !useFixedPosition) && (css += (direction === _vertical ? _right : _bottom) + ":" + (offset + parseFloat(indent)) + "px;");
    matchWidthEl && (css += "box-sizing:border-box;text-align:left;width:" + matchWidthEl.offsetWidth + "px;");
    e._isStart = isStart;
    e.setAttribute("class", "gsap-marker-" + type + (name ? " marker-" + name : ""));
    e.style.cssText = css;
    e.innerText = name || name === 0 ? type + "-" + name : type;
    parent.children[0] ? parent.insertBefore(e, parent.children[0]) : parent.appendChild(e);
    e._offset = e["offset" + direction.op.d2];

    _positionMarker(e, 0, direction, isStart);

    return e;
  },
      _positionMarker = function _positionMarker(marker, start, direction, flipped) {
    var vars = {
      display: "block"
    },
        side = direction[flipped ? "os2" : "p2"],
        oppositeSide = direction[flipped ? "p2" : "os2"];
    marker._isFlipped = flipped;
    vars[direction.a + "Percent"] = flipped ? -100 : 0;
    vars[direction.a] = flipped ? "1px" : 0;
    vars["border" + side + _Width] = 1;
    vars["border" + oppositeSide + _Width] = 0;
    vars[direction.p] = start + "px";
    gsap$1.set(marker, vars);
  },
      _triggers = [],
      _ids = {},
      _rafID,
      _sync = function _sync() {
    return _getTime$1() - _lastScrollTime > 34 && (_rafID || (_rafID = requestAnimationFrame(_updateAll)));
  },
      _onScroll$1 = function _onScroll() {
    if (!_normalizer$1 || !_normalizer$1.isPressed || _normalizer$1.startX > _body$1.clientWidth) {
      _scrollers.cache++;

      if (_normalizer$1) {
        _rafID || (_rafID = requestAnimationFrame(_updateAll));
      } else {
        _updateAll();
      }

      _lastScrollTime || _dispatch("scrollStart");
      _lastScrollTime = _getTime$1();
    }
  },
      _setBaseDimensions = function _setBaseDimensions() {
    _baseScreenWidth = _win$1.innerWidth;
    _baseScreenHeight = _win$1.innerHeight;
  },
      _onResize = function _onResize() {
    _scrollers.cache++;
    !_refreshing && !_ignoreResize && !_doc$1.fullscreenElement && !_doc$1.webkitFullscreenElement && (!_ignoreMobileResize || _baseScreenWidth !== _win$1.innerWidth || Math.abs(_win$1.innerHeight - _baseScreenHeight) > _win$1.innerHeight * 0.25) && _resizeDelay.restart(true);
  },
      _listeners = {},
      _emptyArray = [],
      _softRefresh = function _softRefresh() {
    return _removeListener$1(ScrollTrigger$1, "scrollEnd", _softRefresh) || _refreshAll(true);
  },
      _dispatch = function _dispatch(type) {
    return _listeners[type] && _listeners[type].map(function (f) {
      return f();
    }) || _emptyArray;
  },
      _savedStyles = [],
      _revertRecorded = function _revertRecorded(media) {
    for (var i = 0; i < _savedStyles.length; i += 5) {
      if (!media || _savedStyles[i + 4] && _savedStyles[i + 4].query === media) {
        _savedStyles[i].style.cssText = _savedStyles[i + 1];
        _savedStyles[i].getBBox && _savedStyles[i].setAttribute("transform", _savedStyles[i + 2] || "");
        _savedStyles[i + 3].uncache = 1;
      }
    }
  },
      _revertAll = function _revertAll(kill, media) {
    var trigger;

    for (_i = 0; _i < _triggers.length; _i++) {
      trigger = _triggers[_i];

      if (trigger && (!media || trigger._ctx === media)) {
        if (kill) {
          trigger.kill(1);
        } else {
          trigger.revert(true, true);
        }
      }
    }

    _isReverted = true;
    media && _revertRecorded(media);
    media || _dispatch("revert");
  },
      _clearScrollMemory = function _clearScrollMemory(scrollRestoration, force) {
    _scrollers.cache++;
    (force || !_refreshingAll) && _scrollers.forEach(function (obj) {
      return _isFunction(obj) && obj.cacheID++ && (obj.rec = 0);
    });
    _isString(scrollRestoration) && (_win$1.history.scrollRestoration = _scrollRestoration = scrollRestoration);
  },
      _refreshingAll,
      _refreshID = 0,
      _queueRefreshID,
      _queueRefreshAll = function _queueRefreshAll() {
    if (_queueRefreshID !== _refreshID) {
      var id = _queueRefreshID = _refreshID;
      requestAnimationFrame(function () {
        return id === _refreshID && _refreshAll(true);
      });
    }
  },
      _refresh100vh = function _refresh100vh() {
    _body$1.appendChild(_div100vh);

    _100vh = !_normalizer$1 && _div100vh.offsetHeight || _win$1.innerHeight;

    _body$1.removeChild(_div100vh);
  },
      _hideAllMarkers = function _hideAllMarkers(hide) {
    return _toArray(".gsap-marker-start, .gsap-marker-end, .gsap-marker-scroller-start, .gsap-marker-scroller-end").forEach(function (el) {
      return el.style.display = hide ? "none" : "block";
    });
  },
      _refreshAll = function _refreshAll(force, skipRevert) {
    if (_lastScrollTime && !force && !_isReverted) {
      _addListener$1(ScrollTrigger$1, "scrollEnd", _softRefresh);

      return;
    }

    _refresh100vh();

    _refreshingAll = ScrollTrigger$1.isRefreshing = true;

    _scrollers.forEach(function (obj) {
      return _isFunction(obj) && ++obj.cacheID && (obj.rec = obj());
    });

    var refreshInits = _dispatch("refreshInit");

    _sort && ScrollTrigger$1.sort();
    skipRevert || _revertAll();

    _scrollers.forEach(function (obj) {
      if (_isFunction(obj)) {
        obj.smooth && (obj.target.style.scrollBehavior = "auto");
        obj(0);
      }
    });

    _triggers.slice(0).forEach(function (t) {
      return t.refresh();
    });

    _isReverted = false;

    _triggers.forEach(function (t) {
      if (t._subPinOffset && t.pin) {
        var prop = t.vars.horizontal ? "offsetWidth" : "offsetHeight",
            original = t.pin[prop];
        t.revert(true, 1);
        t.adjustPinSpacing(t.pin[prop] - original);
        t.refresh();
      }
    });

    _clampingMax = 1;

    _hideAllMarkers(true);

    _triggers.forEach(function (t) {
      var max = _maxScroll(t.scroller, t._dir),
          endClamp = t.vars.end === "max" || t._endClamp && t.end > max,
          startClamp = t._startClamp && t.start >= max;

      (endClamp || startClamp) && t.setPositions(startClamp ? max - 1 : t.start, endClamp ? Math.max(startClamp ? max : t.start + 1, max) : t.end, true);
    });

    _hideAllMarkers(false);

    _clampingMax = 0;
    refreshInits.forEach(function (result) {
      return result && result.render && result.render(-1);
    });

    _scrollers.forEach(function (obj) {
      if (_isFunction(obj)) {
        obj.smooth && requestAnimationFrame(function () {
          return obj.target.style.scrollBehavior = "smooth";
        });
        obj.rec && obj(obj.rec);
      }
    });

    _clearScrollMemory(_scrollRestoration, 1);

    _resizeDelay.pause();

    _refreshID++;
    _refreshingAll = 2;

    _updateAll(2);

    _triggers.forEach(function (t) {
      return _isFunction(t.vars.onRefresh) && t.vars.onRefresh(t);
    });

    _refreshingAll = ScrollTrigger$1.isRefreshing = false;

    _dispatch("refresh");
  },
      _lastScroll = 0,
      _direction = 1,
      _primary,
      _updateAll = function _updateAll(force) {
    if (force === 2 || !_refreshingAll && !_isReverted) {
      ScrollTrigger$1.isUpdating = true;
      _primary && _primary.update(0);

      var l = _triggers.length,
          time = _getTime$1(),
          recordVelocity = time - _time1 >= 50,
          scroll = l && _triggers[0].scroll();

      _direction = _lastScroll > scroll ? -1 : 1;
      _refreshingAll || (_lastScroll = scroll);

      if (recordVelocity) {
        if (_lastScrollTime && !_pointerIsDown && time - _lastScrollTime > 200) {
          _lastScrollTime = 0;

          _dispatch("scrollEnd");
        }

        _time2 = _time1;
        _time1 = time;
      }

      if (_direction < 0) {
        _i = l;

        while (_i-- > 0) {
          _triggers[_i] && _triggers[_i].update(0, recordVelocity);
        }

        _direction = 1;
      } else {
        for (_i = 0; _i < l; _i++) {
          _triggers[_i] && _triggers[_i].update(0, recordVelocity);
        }
      }

      ScrollTrigger$1.isUpdating = false;
    }

    _rafID = 0;
  },
      _propNamesToCopy = [_left, _top, _bottom, _right, _margin + _Bottom, _margin + _Right, _margin + _Top, _margin + _Left, "display", "flexShrink", "float", "zIndex", "gridColumnStart", "gridColumnEnd", "gridRowStart", "gridRowEnd", "gridArea", "justifySelf", "alignSelf", "placeSelf", "order"],
      _stateProps = _propNamesToCopy.concat([_width, _height, "boxSizing", "max" + _Width, "max" + _Height, "position", _margin, _padding, _padding + _Top, _padding + _Right, _padding + _Bottom, _padding + _Left]),
      _swapPinOut = function _swapPinOut(pin, spacer, state) {
    _setState(state);

    var cache = pin._gsap;

    if (cache.spacerIsNative) {
      _setState(cache.spacerState);
    } else if (pin._gsap.swappedIn) {
      var parent = spacer.parentNode;

      if (parent) {
        parent.insertBefore(pin, spacer);
        parent.removeChild(spacer);
      }
    }

    pin._gsap.swappedIn = false;
  },
      _swapPinIn = function _swapPinIn(pin, spacer, cs, spacerState) {
    if (!pin._gsap.swappedIn) {
      var i = _propNamesToCopy.length,
          spacerStyle = spacer.style,
          pinStyle = pin.style,
          p;

      while (i--) {
        p = _propNamesToCopy[i];
        spacerStyle[p] = cs[p];
      }

      spacerStyle.position = cs.position === "absolute" ? "absolute" : "relative";
      cs.display === "inline" && (spacerStyle.display = "inline-block");
      pinStyle[_bottom] = pinStyle[_right] = "auto";
      spacerStyle.flexBasis = cs.flexBasis || "auto";
      spacerStyle.overflow = "visible";
      spacerStyle.boxSizing = "border-box";
      spacerStyle[_width] = _getSize(pin, _horizontal) + _px;
      spacerStyle[_height] = _getSize(pin, _vertical) + _px;
      spacerStyle[_padding] = pinStyle[_margin] = pinStyle[_top] = pinStyle[_left] = "0";

      _setState(spacerState);

      pinStyle[_width] = pinStyle["max" + _Width] = cs[_width];
      pinStyle[_height] = pinStyle["max" + _Height] = cs[_height];
      pinStyle[_padding] = cs[_padding];

      if (pin.parentNode !== spacer) {
        pin.parentNode.insertBefore(spacer, pin);
        spacer.appendChild(pin);
      }

      pin._gsap.swappedIn = true;
    }
  },
      _capsExp = /([A-Z])/g,
      _setState = function _setState(state) {
    if (state) {
      var style = state.t.style,
          l = state.length,
          i = 0,
          p,
          value;
      (state.t._gsap || gsap$1.core.getCache(state.t)).uncache = 1;

      for (; i < l; i += 2) {
        value = state[i + 1];
        p = state[i];

        if (value) {
          style[p] = value;
        } else if (style[p]) {
          style.removeProperty(p.replace(_capsExp, "-$1").toLowerCase());
        }
      }
    }
  },
      _getState = function _getState(element) {
    var l = _stateProps.length,
        style = element.style,
        state = [],
        i = 0;

    for (; i < l; i++) {
      state.push(_stateProps[i], style[_stateProps[i]]);
    }

    state.t = element;
    return state;
  },
      _copyState = function _copyState(state, override, omitOffsets) {
    var result = [],
        l = state.length,
        i = omitOffsets ? 8 : 0,
        p;

    for (; i < l; i += 2) {
      p = state[i];
      result.push(p, p in override ? override[p] : state[i + 1]);
    }

    result.t = state.t;
    return result;
  },
      _winOffsets = {
    left: 0,
    top: 0
  },
      _parsePosition = function _parsePosition(value, trigger, scrollerSize, direction, scroll, marker, markerScroller, self, scrollerBounds, borderWidth, useFixedPosition, scrollerMax, containerAnimation, clampZeroProp) {
    _isFunction(value) && (value = value(self));

    if (_isString(value) && value.substr(0, 3) === "max") {
      value = scrollerMax + (value.charAt(4) === "=" ? _offsetToPx("0" + value.substr(3), scrollerSize) : 0);
    }

    var time = containerAnimation ? containerAnimation.time() : 0,
        p1,
        p2,
        element;
    containerAnimation && containerAnimation.seek(0);
    isNaN(value) || (value = +value);

    if (!_isNumber(value)) {
      _isFunction(trigger) && (trigger = trigger(self));
      var offsets = (value || "0").split(" "),
          bounds,
          localOffset,
          globalOffset,
          display;
      element = _getTarget(trigger, self) || _body$1;
      bounds = _getBounds(element) || {};

      if ((!bounds || !bounds.left && !bounds.top) && _getComputedStyle(element).display === "none") {
        display = element.style.display;
        element.style.display = "block";
        bounds = _getBounds(element);
        display ? element.style.display = display : element.style.removeProperty("display");
      }

      localOffset = _offsetToPx(offsets[0], bounds[direction.d]);
      globalOffset = _offsetToPx(offsets[1] || "0", scrollerSize);
      value = bounds[direction.p] - scrollerBounds[direction.p] - borderWidth + localOffset + scroll - globalOffset;
      markerScroller && _positionMarker(markerScroller, globalOffset, direction, scrollerSize - globalOffset < 20 || markerScroller._isStart && globalOffset > 20);
      scrollerSize -= scrollerSize - globalOffset;
    } else {
      containerAnimation && (value = gsap$1.utils.mapRange(containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, 0, scrollerMax, value));
      markerScroller && _positionMarker(markerScroller, scrollerSize, direction, true);
    }

    if (clampZeroProp) {
      self[clampZeroProp] = value || -0.001;
      value < 0 && (value = 0);
    }

    if (marker) {
      var position = value + scrollerSize,
          isStart = marker._isStart;
      p1 = "scroll" + direction.d2;

      _positionMarker(marker, position, direction, isStart && position > 20 || !isStart && (useFixedPosition ? Math.max(_body$1[p1], _docEl$1[p1]) : marker.parentNode[p1]) <= position + 1);

      if (useFixedPosition) {
        scrollerBounds = _getBounds(markerScroller);
        useFixedPosition && (marker.style[direction.op.p] = scrollerBounds[direction.op.p] - direction.op.m - marker._offset + _px);
      }
    }

    if (containerAnimation && element) {
      p1 = _getBounds(element);
      containerAnimation.seek(scrollerMax);
      p2 = _getBounds(element);
      containerAnimation._caScrollDist = p1[direction.p] - p2[direction.p];
      value = value / containerAnimation._caScrollDist * scrollerMax;
    }

    containerAnimation && containerAnimation.seek(time);
    return containerAnimation ? value : Math.round(value);
  },
      _prefixExp = /(webkit|moz|length|cssText|inset)/i,
      _reparent = function _reparent(element, parent, top, left) {
    if (element.parentNode !== parent) {
      var style = element.style,
          p,
          cs;

      if (parent === _body$1) {
        element._stOrig = style.cssText;
        cs = _getComputedStyle(element);

        for (p in cs) {
          if (!+p && !_prefixExp.test(p) && cs[p] && typeof style[p] === "string" && p !== "0") {
            style[p] = cs[p];
          }
        }

        style.top = top;
        style.left = left;
      } else {
        style.cssText = element._stOrig;
      }

      gsap$1.core.getCache(element).uncache = 1;
      parent.appendChild(element);
    }
  },
      _interruptionTracker = function _interruptionTracker(getValueFunc, initialValue, onInterrupt) {
    var last1 = initialValue,
        last2 = last1;
    return function (value) {
      var current = Math.round(getValueFunc());

      if (current !== last1 && current !== last2 && Math.abs(current - last1) > 3 && Math.abs(current - last2) > 3) {
        value = current;
        onInterrupt && onInterrupt();
      }

      last2 = last1;
      last1 = value;
      return value;
    };
  },
      _shiftMarker = function _shiftMarker(marker, direction, value) {
    var vars = {};
    vars[direction.p] = "+=" + value;
    gsap$1.set(marker, vars);
  },
      _getTweenCreator = function _getTweenCreator(scroller, direction) {
    var getScroll = _getScrollFunc(scroller, direction),
        prop = "_scroll" + direction.p2,
        getTween = function getTween(scrollTo, vars, initialValue, change1, change2) {
      var tween = getTween.tween,
          onComplete = vars.onComplete,
          modifiers = {};
      initialValue = initialValue || getScroll();

      var checkForInterruption = _interruptionTracker(getScroll, initialValue, function () {
        tween.kill();
        getTween.tween = 0;
      });

      change2 = change1 && change2 || 0;
      change1 = change1 || scrollTo - initialValue;
      tween && tween.kill();
      vars[prop] = scrollTo;
      vars.inherit = false;
      vars.modifiers = modifiers;

      modifiers[prop] = function () {
        return checkForInterruption(initialValue + change1 * tween.ratio + change2 * tween.ratio * tween.ratio);
      };

      vars.onUpdate = function () {
        _scrollers.cache++;
        getTween.tween && _updateAll();
      };

      vars.onComplete = function () {
        getTween.tween = 0;
        onComplete && onComplete.call(tween);
      };

      tween = getTween.tween = gsap$1.to(scroller, vars);
      return tween;
    };

    scroller[prop] = getScroll;

    getScroll.wheelHandler = function () {
      return getTween.tween && getTween.tween.kill() && (getTween.tween = 0);
    };

    _addListener$1(scroller, "wheel", getScroll.wheelHandler);

    ScrollTrigger$1.isTouch && _addListener$1(scroller, "touchmove", getScroll.wheelHandler);
    return getTween;
  };

  var ScrollTrigger$1 = function () {
    function ScrollTrigger(vars, animation) {
      _coreInitted$1 || ScrollTrigger.register(gsap$1) || console.warn("Please gsap.registerPlugin(ScrollTrigger)");

      _context$1(this);

      this.init(vars, animation);
    }

    var _proto = ScrollTrigger.prototype;

    _proto.init = function init(vars, animation) {
      this.progress = this.start = 0;
      this.vars && this.kill(true, true);

      if (!_enabled) {
        this.update = this.refresh = this.kill = _passThrough;
        return;
      }

      vars = _setDefaults(_isString(vars) || _isNumber(vars) || vars.nodeType ? {
        trigger: vars
      } : vars, _defaults);

      var _vars = vars,
          onUpdate = _vars.onUpdate,
          toggleClass = _vars.toggleClass,
          id = _vars.id,
          onToggle = _vars.onToggle,
          onRefresh = _vars.onRefresh,
          scrub = _vars.scrub,
          trigger = _vars.trigger,
          pin = _vars.pin,
          pinSpacing = _vars.pinSpacing,
          invalidateOnRefresh = _vars.invalidateOnRefresh,
          anticipatePin = _vars.anticipatePin,
          onScrubComplete = _vars.onScrubComplete,
          onSnapComplete = _vars.onSnapComplete,
          once = _vars.once,
          snap = _vars.snap,
          pinReparent = _vars.pinReparent,
          pinSpacer = _vars.pinSpacer,
          containerAnimation = _vars.containerAnimation,
          fastScrollEnd = _vars.fastScrollEnd,
          preventOverlaps = _vars.preventOverlaps,
          direction = vars.horizontal || vars.containerAnimation && vars.horizontal !== false ? _horizontal : _vertical,
          isToggle = !scrub && scrub !== 0,
          scroller = _getTarget(vars.scroller || _win$1),
          scrollerCache = gsap$1.core.getCache(scroller),
          isViewport = _isViewport$1(scroller),
          useFixedPosition = ("pinType" in vars ? vars.pinType : _getProxyProp(scroller, "pinType") || isViewport && "fixed") === "fixed",
          callbacks = [vars.onEnter, vars.onLeave, vars.onEnterBack, vars.onLeaveBack],
          toggleActions = isToggle && vars.toggleActions.split(" "),
          markers = "markers" in vars ? vars.markers : _defaults.markers,
          borderWidth = isViewport ? 0 : parseFloat(_getComputedStyle(scroller)["border" + direction.p2 + _Width]) || 0,
          self = this,
          onRefreshInit = vars.onRefreshInit && function () {
        return vars.onRefreshInit(self);
      },
          getScrollerSize = _getSizeFunc(scroller, isViewport, direction),
          getScrollerOffsets = _getOffsetsFunc(scroller, isViewport),
          lastSnap = 0,
          lastRefresh = 0,
          prevProgress = 0,
          scrollFunc = _getScrollFunc(scroller, direction),
          tweenTo,
          pinCache,
          snapFunc,
          scroll1,
          scroll2,
          start,
          end,
          markerStart,
          markerEnd,
          markerStartTrigger,
          markerEndTrigger,
          markerVars,
          executingOnRefresh,
          change,
          pinOriginalState,
          pinActiveState,
          pinState,
          spacer,
          offset,
          pinGetter,
          pinSetter,
          pinStart,
          pinChange,
          spacingStart,
          spacerState,
          markerStartSetter,
          pinMoves,
          markerEndSetter,
          cs,
          snap1,
          snap2,
          scrubTween,
          scrubSmooth,
          snapDurClamp,
          snapDelayedCall,
          prevScroll,
          prevAnimProgress,
          caMarkerSetter,
          customRevertReturn;

      self._startClamp = self._endClamp = false;
      self._dir = direction;
      anticipatePin *= 45;
      self.scroller = scroller;
      self.scroll = containerAnimation ? containerAnimation.time.bind(containerAnimation) : scrollFunc;
      scroll1 = scrollFunc();
      self.vars = vars;
      animation = animation || vars.animation;

      if ("refreshPriority" in vars) {
        _sort = 1;
        vars.refreshPriority === -9999 && (_primary = self);
      }

      scrollerCache.tweenScroll = scrollerCache.tweenScroll || {
        top: _getTweenCreator(scroller, _vertical),
        left: _getTweenCreator(scroller, _horizontal)
      };
      self.tweenTo = tweenTo = scrollerCache.tweenScroll[direction.p];

      self.scrubDuration = function (value) {
        scrubSmooth = _isNumber(value) && value;

        if (!scrubSmooth) {
          scrubTween && scrubTween.progress(1).kill();
          scrubTween = 0;
        } else {
          scrubTween ? scrubTween.duration(value) : scrubTween = gsap$1.to(animation, {
            ease: "expo",
            totalProgress: "+=0",
            inherit: false,
            duration: scrubSmooth,
            paused: true,
            onComplete: function onComplete() {
              return onScrubComplete && onScrubComplete(self);
            }
          });
        }
      };

      if (animation) {
        animation.vars.lazy = false;
        animation._initted && !self.isReverted || animation.vars.immediateRender !== false && vars.immediateRender !== false && animation.duration() && animation.render(0, true, true);
        self.animation = animation.pause();
        animation.scrollTrigger = self;
        self.scrubDuration(scrub);
        snap1 = 0;
        id || (id = animation.vars.id);
      }

      if (snap) {
        if (!_isObject(snap) || snap.push) {
          snap = {
            snapTo: snap
          };
        }

        "scrollBehavior" in _body$1.style && gsap$1.set(isViewport ? [_body$1, _docEl$1] : scroller, {
          scrollBehavior: "auto"
        });

        _scrollers.forEach(function (o) {
          return _isFunction(o) && o.target === (isViewport ? _doc$1.scrollingElement || _docEl$1 : scroller) && (o.smooth = false);
        });

        snapFunc = _isFunction(snap.snapTo) ? snap.snapTo : snap.snapTo === "labels" ? _getClosestLabel(animation) : snap.snapTo === "labelsDirectional" ? _getLabelAtDirection(animation) : snap.directional !== false ? function (value, st) {
          return _snapDirectional(snap.snapTo)(value, _getTime$1() - lastRefresh < 500 ? 0 : st.direction);
        } : gsap$1.utils.snap(snap.snapTo);
        snapDurClamp = snap.duration || {
          min: 0.1,
          max: 2
        };
        snapDurClamp = _isObject(snapDurClamp) ? _clamp$1(snapDurClamp.min, snapDurClamp.max) : _clamp$1(snapDurClamp, snapDurClamp);
        snapDelayedCall = gsap$1.delayedCall(snap.delay || scrubSmooth / 2 || 0.1, function () {
          var scroll = scrollFunc(),
              refreshedRecently = _getTime$1() - lastRefresh < 500,
              tween = tweenTo.tween;

          if ((refreshedRecently || Math.abs(self.getVelocity()) < 10) && !tween && !_pointerIsDown && lastSnap !== scroll) {
            var progress = (scroll - start) / change,
                totalProgress = animation && !isToggle ? animation.totalProgress() : progress,
                velocity = refreshedRecently ? 0 : (totalProgress - snap2) / (_getTime$1() - _time2) * 1000 || 0,
                change1 = gsap$1.utils.clamp(-progress, 1 - progress, _abs(velocity / 2) * velocity / 0.185),
                naturalEnd = progress + (snap.inertia === false ? 0 : change1),
                endValue,
                endScroll,
                _snap = snap,
                onStart = _snap.onStart,
                _onInterrupt = _snap.onInterrupt,
                _onComplete = _snap.onComplete;
            endValue = snapFunc(naturalEnd, self);
            _isNumber(endValue) || (endValue = naturalEnd);
            endScroll = Math.round(start + endValue * change);

            if (scroll <= end && scroll >= start && endScroll !== scroll) {
              if (tween && !tween._initted && tween.data <= _abs(endScroll - scroll)) {
                return;
              }

              if (snap.inertia === false) {
                change1 = endValue - progress;
              }

              tweenTo(endScroll, {
                duration: snapDurClamp(_abs(Math.max(_abs(naturalEnd - totalProgress), _abs(endValue - totalProgress)) * 0.185 / velocity / 0.05 || 0)),
                ease: snap.ease || "power3",
                data: _abs(endScroll - scroll),
                onInterrupt: function onInterrupt() {
                  return snapDelayedCall.restart(true) && _onInterrupt && _onInterrupt(self);
                },
                onComplete: function onComplete() {
                  self.update();
                  lastSnap = scrollFunc();

                  if (animation) {
                    scrubTween ? scrubTween.resetTo("totalProgress", endValue, animation._tTime / animation._tDur) : animation.progress(endValue);
                  }

                  snap1 = snap2 = animation && !isToggle ? animation.totalProgress() : self.progress;
                  onSnapComplete && onSnapComplete(self);
                  _onComplete && _onComplete(self);
                }
              }, scroll, change1 * change, endScroll - scroll - change1 * change);
              onStart && onStart(self, tweenTo.tween);
            }
          } else if (self.isActive && lastSnap !== scroll) {
            snapDelayedCall.restart(true);
          }
        }).pause();
      }

      id && (_ids[id] = self);
      trigger = self.trigger = _getTarget(trigger || pin !== true && pin);
      customRevertReturn = trigger && trigger._gsap && trigger._gsap.stRevert;
      customRevertReturn && (customRevertReturn = customRevertReturn(self));
      pin = pin === true ? trigger : _getTarget(pin);
      _isString(toggleClass) && (toggleClass = {
        targets: trigger,
        className: toggleClass
      });

      if (pin) {
        pinSpacing === false || pinSpacing === _margin || (pinSpacing = !pinSpacing && pin.parentNode && pin.parentNode.style && _getComputedStyle(pin.parentNode).display === "flex" ? false : _padding);
        self.pin = pin;
        pinCache = gsap$1.core.getCache(pin);

        if (!pinCache.spacer) {
          if (pinSpacer) {
            pinSpacer = _getTarget(pinSpacer);
            pinSpacer && !pinSpacer.nodeType && (pinSpacer = pinSpacer.current || pinSpacer.nativeElement);
            pinCache.spacerIsNative = !!pinSpacer;
            pinSpacer && (pinCache.spacerState = _getState(pinSpacer));
          }

          pinCache.spacer = spacer = pinSpacer || _doc$1.createElement("div");
          spacer.classList.add("pin-spacer");
          id && spacer.classList.add("pin-spacer-" + id);
          pinCache.pinState = pinOriginalState = _getState(pin);
        } else {
          pinOriginalState = pinCache.pinState;
        }

        vars.force3D !== false && gsap$1.set(pin, {
          force3D: true
        });
        self.spacer = spacer = pinCache.spacer;
        cs = _getComputedStyle(pin);
        spacingStart = cs[pinSpacing + direction.os2];
        pinGetter = gsap$1.getProperty(pin);
        pinSetter = gsap$1.quickSetter(pin, direction.a, _px);

        _swapPinIn(pin, spacer, cs);

        pinState = _getState(pin);
      }

      if (markers) {
        markerVars = _isObject(markers) ? _setDefaults(markers, _markerDefaults) : _markerDefaults;
        markerStartTrigger = _createMarker("scroller-start", id, scroller, direction, markerVars, 0);
        markerEndTrigger = _createMarker("scroller-end", id, scroller, direction, markerVars, 0, markerStartTrigger);
        offset = markerStartTrigger["offset" + direction.op.d2];

        var content = _getTarget(_getProxyProp(scroller, "content") || scroller);

        markerStart = this.markerStart = _createMarker("start", id, content, direction, markerVars, offset, 0, containerAnimation);
        markerEnd = this.markerEnd = _createMarker("end", id, content, direction, markerVars, offset, 0, containerAnimation);
        containerAnimation && (caMarkerSetter = gsap$1.quickSetter([markerStart, markerEnd], direction.a, _px));

        if (!useFixedPosition && !(_proxies.length && _getProxyProp(scroller, "fixedMarkers") === true)) {
          _makePositionable(isViewport ? _body$1 : scroller);

          gsap$1.set([markerStartTrigger, markerEndTrigger], {
            force3D: true
          });
          markerStartSetter = gsap$1.quickSetter(markerStartTrigger, direction.a, _px);
          markerEndSetter = gsap$1.quickSetter(markerEndTrigger, direction.a, _px);
        }
      }

      if (containerAnimation) {
        var oldOnUpdate = containerAnimation.vars.onUpdate,
            oldParams = containerAnimation.vars.onUpdateParams;
        containerAnimation.eventCallback("onUpdate", function () {
          self.update(0, 0, 1);
          oldOnUpdate && oldOnUpdate.apply(containerAnimation, oldParams || []);
        });
      }

      self.previous = function () {
        return _triggers[_triggers.indexOf(self) - 1];
      };

      self.next = function () {
        return _triggers[_triggers.indexOf(self) + 1];
      };

      self.revert = function (revert, temp) {
        if (!temp) {
          return self.kill(true);
        }

        var r = revert !== false || !self.enabled,
            prevRefreshing = _refreshing;

        if (r !== self.isReverted) {
          if (r) {
            prevScroll = Math.max(scrollFunc(), self.scroll.rec || 0);
            prevProgress = self.progress;
            prevAnimProgress = animation && animation.progress();
          }

          markerStart && [markerStart, markerEnd, markerStartTrigger, markerEndTrigger].forEach(function (m) {
            return m.style.display = r ? "none" : "block";
          });

          if (r) {
            _refreshing = self;
            self.update(r);
          }

          if (pin && (!pinReparent || !self.isActive)) {
            if (r) {
              _swapPinOut(pin, spacer, pinOriginalState);
            } else {
              _swapPinIn(pin, spacer, _getComputedStyle(pin), spacerState);
            }
          }

          r || self.update(r);
          _refreshing = prevRefreshing;
          self.isReverted = r;
        }
      };

      self.refresh = function (soft, force, position, pinOffset) {
        if ((_refreshing || !self.enabled) && !force) {
          return;
        }

        if (pin && soft && _lastScrollTime) {
          _addListener$1(ScrollTrigger, "scrollEnd", _softRefresh);

          return;
        }

        !_refreshingAll && onRefreshInit && onRefreshInit(self);
        _refreshing = self;

        if (tweenTo.tween && !position) {
          tweenTo.tween.kill();
          tweenTo.tween = 0;
        }

        scrubTween && scrubTween.pause();
        invalidateOnRefresh && animation && animation.revert({
          kill: false
        }).invalidate();
        self.isReverted || self.revert(true, true);
        self._subPinOffset = false;

        var size = getScrollerSize(),
            scrollerBounds = getScrollerOffsets(),
            max = containerAnimation ? containerAnimation.duration() : _maxScroll(scroller, direction),
            isFirstRefresh = change <= 0.01,
            offset = 0,
            otherPinOffset = pinOffset || 0,
            parsedEnd = _isObject(position) ? position.end : vars.end,
            parsedEndTrigger = vars.endTrigger || trigger,
            parsedStart = _isObject(position) ? position.start : vars.start || (vars.start === 0 || !trigger ? 0 : pin ? "0 0" : "0 100%"),
            pinnedContainer = self.pinnedContainer = vars.pinnedContainer && _getTarget(vars.pinnedContainer, self),
            triggerIndex = trigger && Math.max(0, _triggers.indexOf(self)) || 0,
            i = triggerIndex,
            cs,
            bounds,
            scroll,
            isVertical,
            override,
            curTrigger,
            curPin,
            oppositeScroll,
            initted,
            revertedPins,
            forcedOverflow,
            markerStartOffset,
            markerEndOffset;

        if (markers && _isObject(position)) {
          markerStartOffset = gsap$1.getProperty(markerStartTrigger, direction.p);
          markerEndOffset = gsap$1.getProperty(markerEndTrigger, direction.p);
        }

        while (i--) {
          curTrigger = _triggers[i];
          curTrigger.end || curTrigger.refresh(0, 1) || (_refreshing = self);
          curPin = curTrigger.pin;

          if (curPin && (curPin === trigger || curPin === pin || curPin === pinnedContainer) && !curTrigger.isReverted) {
            revertedPins || (revertedPins = []);
            revertedPins.unshift(curTrigger);
            curTrigger.revert(true, true);
          }

          if (curTrigger !== _triggers[i]) {
            triggerIndex--;
            i--;
          }
        }

        _isFunction(parsedStart) && (parsedStart = parsedStart(self));
        parsedStart = _parseClamp(parsedStart, "start", self);
        start = _parsePosition(parsedStart, trigger, size, direction, scrollFunc(), markerStart, markerStartTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._startClamp && "_startClamp") || (pin ? -0.001 : 0);
        _isFunction(parsedEnd) && (parsedEnd = parsedEnd(self));

        if (_isString(parsedEnd) && !parsedEnd.indexOf("+=")) {
          if (~parsedEnd.indexOf(" ")) {
            parsedEnd = (_isString(parsedStart) ? parsedStart.split(" ")[0] : "") + parsedEnd;
          } else {
            offset = _offsetToPx(parsedEnd.substr(2), size);
            parsedEnd = _isString(parsedStart) ? parsedStart : (containerAnimation ? gsap$1.utils.mapRange(0, containerAnimation.duration(), containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, start) : start) + offset;
            parsedEndTrigger = trigger;
          }
        }

        parsedEnd = _parseClamp(parsedEnd, "end", self);
        end = Math.max(start, _parsePosition(parsedEnd || (parsedEndTrigger ? "100% 0" : max), parsedEndTrigger, size, direction, scrollFunc() + offset, markerEnd, markerEndTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._endClamp && "_endClamp")) || -0.001;
        offset = 0;
        i = triggerIndex;

        while (i--) {
          curTrigger = _triggers[i];
          curPin = curTrigger.pin;

          if (curPin && curTrigger.start - curTrigger._pinPush <= start && !containerAnimation && curTrigger.end > 0) {
            cs = curTrigger.end - (self._startClamp ? Math.max(0, curTrigger.start) : curTrigger.start);

            if ((curPin === trigger && curTrigger.start - curTrigger._pinPush < start || curPin === pinnedContainer) && isNaN(parsedStart)) {
              offset += cs * (1 - curTrigger.progress);
            }

            curPin === pin && (otherPinOffset += cs);
          }
        }

        start += offset;
        end += offset;
        self._startClamp && (self._startClamp += offset);

        if (self._endClamp && !_refreshingAll) {
          self._endClamp = end || -0.001;
          end = Math.min(end, _maxScroll(scroller, direction));
        }

        change = end - start || (start -= 0.01) && 0.001;

        if (isFirstRefresh) {
          prevProgress = gsap$1.utils.clamp(0, 1, gsap$1.utils.normalize(start, end, prevScroll));
        }

        self._pinPush = otherPinOffset;

        if (markerStart && offset) {
          cs = {};
          cs[direction.a] = "+=" + offset;
          pinnedContainer && (cs[direction.p] = "-=" + scrollFunc());
          gsap$1.set([markerStart, markerEnd], cs);
        }

        if (pin && !(_clampingMax && self.end >= _maxScroll(scroller, direction))) {
          cs = _getComputedStyle(pin);
          isVertical = direction === _vertical;
          scroll = scrollFunc();
          pinStart = parseFloat(pinGetter(direction.a)) + otherPinOffset;

          if (!max && end > 1) {
            forcedOverflow = (isViewport ? _doc$1.scrollingElement || _docEl$1 : scroller).style;
            forcedOverflow = {
              style: forcedOverflow,
              value: forcedOverflow["overflow" + direction.a.toUpperCase()]
            };

            if (isViewport && _getComputedStyle(_body$1)["overflow" + direction.a.toUpperCase()] !== "scroll") {
              forcedOverflow.style["overflow" + direction.a.toUpperCase()] = "scroll";
            }
          }

          _swapPinIn(pin, spacer, cs);

          pinState = _getState(pin);
          bounds = _getBounds(pin, true);
          oppositeScroll = useFixedPosition && _getScrollFunc(scroller, isVertical ? _horizontal : _vertical)();

          if (pinSpacing) {
            spacerState = [pinSpacing + direction.os2, change + otherPinOffset + _px];
            spacerState.t = spacer;
            i = pinSpacing === _padding ? _getSize(pin, direction) + change + otherPinOffset : 0;

            if (i) {
              spacerState.push(direction.d, i + _px);
              spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i + _px);
            }

            _setState(spacerState);

            if (pinnedContainer) {
              _triggers.forEach(function (t) {
                if (t.pin === pinnedContainer && t.vars.pinSpacing !== false) {
                  t._subPinOffset = true;
                }
              });
            }

            useFixedPosition && scrollFunc(prevScroll);
          } else {
            i = _getSize(pin, direction);
            i && spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i + _px);
          }

          if (useFixedPosition) {
            override = {
              top: bounds.top + (isVertical ? scroll - start : oppositeScroll) + _px,
              left: bounds.left + (isVertical ? oppositeScroll : scroll - start) + _px,
              boxSizing: "border-box",
              position: "fixed"
            };
            override[_width] = override["max" + _Width] = Math.ceil(bounds.width) + _px;
            override[_height] = override["max" + _Height] = Math.ceil(bounds.height) + _px;
            override[_margin] = override[_margin + _Top] = override[_margin + _Right] = override[_margin + _Bottom] = override[_margin + _Left] = "0";
            override[_padding] = cs[_padding];
            override[_padding + _Top] = cs[_padding + _Top];
            override[_padding + _Right] = cs[_padding + _Right];
            override[_padding + _Bottom] = cs[_padding + _Bottom];
            override[_padding + _Left] = cs[_padding + _Left];
            pinActiveState = _copyState(pinOriginalState, override, pinReparent);
            _refreshingAll && scrollFunc(0);
          }

          if (animation) {
            initted = animation._initted;

            _suppressOverwrites(1);

            animation.render(animation.duration(), true, true);
            pinChange = pinGetter(direction.a) - pinStart + change + otherPinOffset;
            pinMoves = Math.abs(change - pinChange) > 1;
            useFixedPosition && pinMoves && pinActiveState.splice(pinActiveState.length - 2, 2);
            animation.render(0, true, true);
            initted || animation.invalidate(true);
            animation.parent || animation.totalTime(animation.totalTime());

            _suppressOverwrites(0);
          } else {
            pinChange = change;
          }

          forcedOverflow && (forcedOverflow.value ? forcedOverflow.style["overflow" + direction.a.toUpperCase()] = forcedOverflow.value : forcedOverflow.style.removeProperty("overflow-" + direction.a));
        } else if (trigger && scrollFunc() && !containerAnimation) {
          bounds = trigger.parentNode;

          while (bounds && bounds !== _body$1) {
            if (bounds._pinOffset) {
              start -= bounds._pinOffset;
              end -= bounds._pinOffset;
            }

            bounds = bounds.parentNode;
          }
        }

        revertedPins && revertedPins.forEach(function (t) {
          return t.revert(false, true);
        });
        self.start = start;
        self.end = end;
        scroll1 = scroll2 = _refreshingAll ? prevScroll : scrollFunc();

        if (!containerAnimation && !_refreshingAll) {
          scroll1 < prevScroll && scrollFunc(prevScroll);
          self.scroll.rec = 0;
        }

        self.revert(false, true);
        lastRefresh = _getTime$1();

        if (snapDelayedCall) {
          lastSnap = -1;
          snapDelayedCall.restart(true);
        }

        _refreshing = 0;
        animation && isToggle && (animation._initted || prevAnimProgress) && animation.progress() !== prevAnimProgress && animation.progress(prevAnimProgress || 0, true).render(animation.time(), true, true);

        if (isFirstRefresh || prevProgress !== self.progress || containerAnimation || invalidateOnRefresh) {
          animation && !isToggle && animation.totalProgress(containerAnimation && start < -0.001 && !prevProgress ? gsap$1.utils.normalize(start, end, 0) : prevProgress, true);
          self.progress = isFirstRefresh || (scroll1 - start) / change === prevProgress ? 0 : prevProgress;
        }

        pin && pinSpacing && (spacer._pinOffset = Math.round(self.progress * pinChange));
        scrubTween && scrubTween.invalidate();

        if (!isNaN(markerStartOffset)) {
          markerStartOffset -= gsap$1.getProperty(markerStartTrigger, direction.p);
          markerEndOffset -= gsap$1.getProperty(markerEndTrigger, direction.p);

          _shiftMarker(markerStartTrigger, direction, markerStartOffset);

          _shiftMarker(markerStart, direction, markerStartOffset - (pinOffset || 0));

          _shiftMarker(markerEndTrigger, direction, markerEndOffset);

          _shiftMarker(markerEnd, direction, markerEndOffset - (pinOffset || 0));
        }

        isFirstRefresh && !_refreshingAll && self.update();

        if (onRefresh && !_refreshingAll && !executingOnRefresh) {
          executingOnRefresh = true;
          onRefresh(self);
          executingOnRefresh = false;
        }
      };

      self.getVelocity = function () {
        return (scrollFunc() - scroll2) / (_getTime$1() - _time2) * 1000 || 0;
      };

      self.endAnimation = function () {
        _endAnimation(self.callbackAnimation);

        if (animation) {
          scrubTween ? scrubTween.progress(1) : !animation.paused() ? _endAnimation(animation, animation.reversed()) : isToggle || _endAnimation(animation, self.direction < 0, 1);
        }
      };

      self.labelToScroll = function (label) {
        return animation && animation.labels && (start || self.refresh() || start) + animation.labels[label] / animation.duration() * change || 0;
      };

      self.getTrailing = function (name) {
        var i = _triggers.indexOf(self),
            a = self.direction > 0 ? _triggers.slice(0, i).reverse() : _triggers.slice(i + 1);

        return (_isString(name) ? a.filter(function (t) {
          return t.vars.preventOverlaps === name;
        }) : a).filter(function (t) {
          return self.direction > 0 ? t.end <= start : t.start >= end;
        });
      };

      self.update = function (reset, recordVelocity, forceFake) {
        if (containerAnimation && !forceFake && !reset) {
          return;
        }

        var scroll = _refreshingAll === true ? prevScroll : self.scroll(),
            p = reset ? 0 : (scroll - start) / change,
            clipped = p < 0 ? 0 : p > 1 ? 1 : p || 0,
            prevProgress = self.progress,
            isActive,
            wasActive,
            toggleState,
            action,
            stateChanged,
            toggled,
            isAtMax,
            isTakingAction;

        if (recordVelocity) {
          scroll2 = scroll1;
          scroll1 = containerAnimation ? scrollFunc() : scroll;

          if (snap) {
            snap2 = snap1;
            snap1 = animation && !isToggle ? animation.totalProgress() : clipped;
          }
        }

        if (anticipatePin && pin && !_refreshing && !_startup$1 && _lastScrollTime) {
          if (!clipped && start < scroll + (scroll - scroll2) / (_getTime$1() - _time2) * anticipatePin) {
            clipped = 0.0001;
          } else if (clipped === 1 && end > scroll + (scroll - scroll2) / (_getTime$1() - _time2) * anticipatePin) {
            clipped = 0.9999;
          }
        }

        if (clipped !== prevProgress && self.enabled) {
          isActive = self.isActive = !!clipped && clipped < 1;
          wasActive = !!prevProgress && prevProgress < 1;
          toggled = isActive !== wasActive;
          stateChanged = toggled || !!clipped !== !!prevProgress;
          self.direction = clipped > prevProgress ? 1 : -1;
          self.progress = clipped;

          if (stateChanged && !_refreshing) {
            toggleState = clipped && !prevProgress ? 0 : clipped === 1 ? 1 : prevProgress === 1 ? 2 : 3;

            if (isToggle) {
              action = !toggled && toggleActions[toggleState + 1] !== "none" && toggleActions[toggleState + 1] || toggleActions[toggleState];
              isTakingAction = animation && (action === "complete" || action === "reset" || action in animation);
            }
          }

          preventOverlaps && (toggled || isTakingAction) && (isTakingAction || scrub || !animation) && (_isFunction(preventOverlaps) ? preventOverlaps(self) : self.getTrailing(preventOverlaps).forEach(function (t) {
            return t.endAnimation();
          }));

          if (!isToggle) {
            if (scrubTween && !_refreshing && !_startup$1) {
              scrubTween._dp._time - scrubTween._start !== scrubTween._time && scrubTween.render(scrubTween._dp._time - scrubTween._start);

              if (scrubTween.resetTo) {
                scrubTween.resetTo("totalProgress", clipped, animation._tTime / animation._tDur);
              } else {
                scrubTween.vars.totalProgress = clipped;
                scrubTween.invalidate().restart();
              }
            } else if (animation) {
              animation.totalProgress(clipped, !!(_refreshing && (lastRefresh || reset)));
            }
          }

          if (pin) {
            reset && pinSpacing && (spacer.style[pinSpacing + direction.os2] = spacingStart);

            if (!useFixedPosition) {
              pinSetter(_round(pinStart + pinChange * clipped));
            } else if (stateChanged) {
              isAtMax = !reset && clipped > prevProgress && end + 1 > scroll && scroll + 1 >= _maxScroll(scroller, direction);

              if (pinReparent) {
                if (!reset && (isActive || isAtMax)) {
                  var bounds = _getBounds(pin, true),
                      _offset = scroll - start;

                  _reparent(pin, _body$1, bounds.top + (direction === _vertical ? _offset : 0) + _px, bounds.left + (direction === _vertical ? 0 : _offset) + _px);
                } else {
                  _reparent(pin, spacer);
                }
              }

              _setState(isActive || isAtMax ? pinActiveState : pinState);

              pinMoves && clipped < 1 && isActive || pinSetter(pinStart + (clipped === 1 && !isAtMax ? pinChange : 0));
            }
          }

          snap && !tweenTo.tween && !_refreshing && !_startup$1 && snapDelayedCall.restart(true);
          toggleClass && (toggled || once && clipped && (clipped < 1 || !_limitCallbacks)) && _toArray(toggleClass.targets).forEach(function (el) {
            return el.classList[isActive || once ? "add" : "remove"](toggleClass.className);
          });
          onUpdate && !isToggle && !reset && onUpdate(self);

          if (stateChanged && !_refreshing) {
            if (isToggle) {
              if (isTakingAction) {
                if (action === "complete") {
                  animation.pause().totalProgress(1);
                } else if (action === "reset") {
                  animation.restart(true).pause();
                } else if (action === "restart") {
                  animation.restart(true);
                } else {
                  animation[action]();
                }
              }

              onUpdate && onUpdate(self);
            }

            if (toggled || !_limitCallbacks) {
              onToggle && toggled && _callback(self, onToggle);
              callbacks[toggleState] && _callback(self, callbacks[toggleState]);
              once && (clipped === 1 ? self.kill(false, 1) : callbacks[toggleState] = 0);

              if (!toggled) {
                toggleState = clipped === 1 ? 1 : 3;
                callbacks[toggleState] && _callback(self, callbacks[toggleState]);
              }
            }

            if (fastScrollEnd && !isActive && Math.abs(self.getVelocity()) > (_isNumber(fastScrollEnd) ? fastScrollEnd : 2500)) {
              _endAnimation(self.callbackAnimation);

              scrubTween ? scrubTween.progress(1) : _endAnimation(animation, action === "reverse" ? 1 : !clipped, 1);
            }
          } else if (isToggle && onUpdate && !_refreshing) {
            onUpdate(self);
          }
        }

        if (markerEndSetter) {
          var n = containerAnimation ? scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0) : scroll;
          markerStartSetter(n + (markerStartTrigger._isFlipped ? 1 : 0));
          markerEndSetter(n);
        }

        caMarkerSetter && caMarkerSetter(-scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0));
      };

      self.enable = function (reset, refresh) {
        if (!self.enabled) {
          self.enabled = true;

          _addListener$1(scroller, "resize", _onResize);

          isViewport || _addListener$1(scroller, "scroll", _onScroll$1);
          onRefreshInit && _addListener$1(ScrollTrigger, "refreshInit", onRefreshInit);

          if (reset !== false) {
            self.progress = prevProgress = 0;
            scroll1 = scroll2 = lastSnap = scrollFunc();
          }

          refresh !== false && self.refresh();
        }
      };

      self.getTween = function (snap) {
        return snap && tweenTo ? tweenTo.tween : scrubTween;
      };

      self.setPositions = function (newStart, newEnd, keepClamp, pinOffset) {
        if (containerAnimation) {
          var st = containerAnimation.scrollTrigger,
              duration = containerAnimation.duration(),
              _change = st.end - st.start;

          newStart = st.start + _change * newStart / duration;
          newEnd = st.start + _change * newEnd / duration;
        }

        self.refresh(false, false, {
          start: _keepClamp(newStart, keepClamp && !!self._startClamp),
          end: _keepClamp(newEnd, keepClamp && !!self._endClamp)
        }, pinOffset);
        self.update();
      };

      self.adjustPinSpacing = function (amount) {
        if (spacerState && amount) {
          var i = spacerState.indexOf(direction.d) + 1;
          spacerState[i] = parseFloat(spacerState[i]) + amount + _px;
          spacerState[1] = parseFloat(spacerState[1]) + amount + _px;

          _setState(spacerState);
        }
      };

      self.disable = function (reset, allowAnimation) {
        if (self.enabled) {
          reset !== false && self.revert(true, true);
          self.enabled = self.isActive = false;
          allowAnimation || scrubTween && scrubTween.pause();
          prevScroll = 0;
          pinCache && (pinCache.uncache = 1);
          onRefreshInit && _removeListener$1(ScrollTrigger, "refreshInit", onRefreshInit);

          if (snapDelayedCall) {
            snapDelayedCall.pause();
            tweenTo.tween && tweenTo.tween.kill() && (tweenTo.tween = 0);
          }

          if (!isViewport) {
            var i = _triggers.length;

            while (i--) {
              if (_triggers[i].scroller === scroller && _triggers[i] !== self) {
                return;
              }
            }

            _removeListener$1(scroller, "resize", _onResize);

            isViewport || _removeListener$1(scroller, "scroll", _onScroll$1);
          }
        }
      };

      self.kill = function (revert, allowAnimation) {
        self.disable(revert, allowAnimation);
        scrubTween && !allowAnimation && scrubTween.kill();
        id && delete _ids[id];

        var i = _triggers.indexOf(self);

        i >= 0 && _triggers.splice(i, 1);
        i === _i && _direction > 0 && _i--;
        i = 0;

        _triggers.forEach(function (t) {
          return t.scroller === self.scroller && (i = 1);
        });

        i || _refreshingAll || (self.scroll.rec = 0);

        if (animation) {
          animation.scrollTrigger = null;
          revert && animation.revert({
            kill: false
          });
          allowAnimation || animation.kill();
        }

        markerStart && [markerStart, markerEnd, markerStartTrigger, markerEndTrigger].forEach(function (m) {
          return m.parentNode && m.parentNode.removeChild(m);
        });
        _primary === self && (_primary = 0);

        if (pin) {
          pinCache && (pinCache.uncache = 1);
          i = 0;

          _triggers.forEach(function (t) {
            return t.pin === pin && i++;
          });

          i || (pinCache.spacer = 0);
        }

        vars.onKill && vars.onKill(self);
      };

      _triggers.push(self);

      self.enable(false, false);
      customRevertReturn && customRevertReturn(self);

      if (animation && animation.add && !change) {
        var updateFunc = self.update;

        self.update = function () {
          self.update = updateFunc;
          start || end || self.refresh();
        };

        gsap$1.delayedCall(0.01, self.update);
        change = 0.01;
        start = end = 0;
      } else {
        self.refresh();
      }

      pin && _queueRefreshAll();
    };

    ScrollTrigger.register = function register(core) {
      if (!_coreInitted$1) {
        gsap$1 = core || _getGSAP$1();
        _windowExists() && window.document && ScrollTrigger.enable();
        _coreInitted$1 = _enabled;
      }

      return _coreInitted$1;
    };

    ScrollTrigger.defaults = function defaults(config) {
      if (config) {
        for (var p in config) {
          _defaults[p] = config[p];
        }
      }

      return _defaults;
    };

    ScrollTrigger.disable = function disable(reset, kill) {
      _enabled = 0;

      _triggers.forEach(function (trigger) {
        return trigger[kill ? "kill" : "disable"](reset);
      });

      _removeListener$1(_win$1, "wheel", _onScroll$1);

      _removeListener$1(_doc$1, "scroll", _onScroll$1);

      clearInterval(_syncInterval);

      _removeListener$1(_doc$1, "touchcancel", _passThrough);

      _removeListener$1(_body$1, "touchstart", _passThrough);

      _multiListener(_removeListener$1, _doc$1, "pointerdown,touchstart,mousedown", _pointerDownHandler);

      _multiListener(_removeListener$1, _doc$1, "pointerup,touchend,mouseup", _pointerUpHandler);

      _resizeDelay.kill();

      _iterateAutoRefresh(_removeListener$1);

      for (var i = 0; i < _scrollers.length; i += 3) {
        _wheelListener(_removeListener$1, _scrollers[i], _scrollers[i + 1]);

        _wheelListener(_removeListener$1, _scrollers[i], _scrollers[i + 2]);
      }
    };

    ScrollTrigger.enable = function enable() {
      _win$1 = window;
      _doc$1 = document;
      _docEl$1 = _doc$1.documentElement;
      _body$1 = _doc$1.body;

      if (gsap$1) {
        _toArray = gsap$1.utils.toArray;
        _clamp$1 = gsap$1.utils.clamp;
        _context$1 = gsap$1.core.context || _passThrough;
        _suppressOverwrites = gsap$1.core.suppressOverwrites || _passThrough;
        _scrollRestoration = _win$1.history.scrollRestoration || "auto";
        _lastScroll = _win$1.pageYOffset;
        gsap$1.core.globals("ScrollTrigger", ScrollTrigger);

        if (_body$1) {
          _enabled = 1;
          _div100vh = document.createElement("div");
          _div100vh.style.height = "100vh";
          _div100vh.style.position = "absolute";

          _refresh100vh();

          _rafBugFix();

          Observer.register(gsap$1);
          ScrollTrigger.isTouch = Observer.isTouch;
          _fixIOSBug = Observer.isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent);
          _ignoreMobileResize = Observer.isTouch === 1;

          _addListener$1(_win$1, "wheel", _onScroll$1);

          _root$1 = [_win$1, _doc$1, _docEl$1, _body$1];

          if (gsap$1.matchMedia) {
            ScrollTrigger.matchMedia = function (vars) {
              var mm = gsap$1.matchMedia(),
                  p;

              for (p in vars) {
                mm.add(p, vars[p]);
              }

              return mm;
            };

            gsap$1.addEventListener("matchMediaInit", function () {
              return _revertAll();
            });
            gsap$1.addEventListener("matchMediaRevert", function () {
              return _revertRecorded();
            });
            gsap$1.addEventListener("matchMedia", function () {
              _refreshAll(0, 1);

              _dispatch("matchMedia");
            });
            gsap$1.matchMedia("(orientation: portrait)", function () {
              _setBaseDimensions();

              return _setBaseDimensions;
            });
          } else {
            console.warn("Requires GSAP 3.11.0 or later");
          }

          _setBaseDimensions();

          _addListener$1(_doc$1, "scroll", _onScroll$1);

          var bodyStyle = _body$1.style,
              border = bodyStyle.borderTopStyle,
              AnimationProto = gsap$1.core.Animation.prototype,
              bounds,
              i;
          AnimationProto.revert || Object.defineProperty(AnimationProto, "revert", {
            value: function value() {
              return this.time(-0.01, true);
            }
          });
          bodyStyle.borderTopStyle = "solid";
          bounds = _getBounds(_body$1);
          _vertical.m = Math.round(bounds.top + _vertical.sc()) || 0;
          _horizontal.m = Math.round(bounds.left + _horizontal.sc()) || 0;
          border ? bodyStyle.borderTopStyle = border : bodyStyle.removeProperty("border-top-style");
          _syncInterval = setInterval(_sync, 250);
          gsap$1.delayedCall(0.5, function () {
            return _startup$1 = 0;
          });

          _addListener$1(_doc$1, "touchcancel", _passThrough);

          _addListener$1(_body$1, "touchstart", _passThrough);

          _multiListener(_addListener$1, _doc$1, "pointerdown,touchstart,mousedown", _pointerDownHandler);

          _multiListener(_addListener$1, _doc$1, "pointerup,touchend,mouseup", _pointerUpHandler);

          _transformProp = gsap$1.utils.checkPrefix("transform");

          _stateProps.push(_transformProp);

          _coreInitted$1 = _getTime$1();
          _resizeDelay = gsap$1.delayedCall(0.2, _refreshAll).pause();
          _autoRefresh = [_doc$1, "visibilitychange", function () {
            var w = _win$1.innerWidth,
                h = _win$1.innerHeight;

            if (_doc$1.hidden) {
              _prevWidth = w;
              _prevHeight = h;
            } else if (_prevWidth !== w || _prevHeight !== h) {
              _onResize();
            }
          }, _doc$1, "DOMContentLoaded", _refreshAll, _win$1, "load", _refreshAll, _win$1, "resize", _onResize];

          _iterateAutoRefresh(_addListener$1);

          _triggers.forEach(function (trigger) {
            return trigger.enable(0, 1);
          });

          for (i = 0; i < _scrollers.length; i += 3) {
            _wheelListener(_removeListener$1, _scrollers[i], _scrollers[i + 1]);

            _wheelListener(_removeListener$1, _scrollers[i], _scrollers[i + 2]);
          }
        }
      }
    };

    ScrollTrigger.config = function config(vars) {
      "limitCallbacks" in vars && (_limitCallbacks = !!vars.limitCallbacks);
      var ms = vars.syncInterval;
      ms && clearInterval(_syncInterval) || (_syncInterval = ms) && setInterval(_sync, ms);
      "ignoreMobileResize" in vars && (_ignoreMobileResize = ScrollTrigger.isTouch === 1 && vars.ignoreMobileResize);

      if ("autoRefreshEvents" in vars) {
        _iterateAutoRefresh(_removeListener$1) || _iterateAutoRefresh(_addListener$1, vars.autoRefreshEvents || "none");
        _ignoreResize = (vars.autoRefreshEvents + "").indexOf("resize") === -1;
      }
    };

    ScrollTrigger.scrollerProxy = function scrollerProxy(target, vars) {
      var t = _getTarget(target),
          i = _scrollers.indexOf(t),
          isViewport = _isViewport$1(t);

      if (~i) {
        _scrollers.splice(i, isViewport ? 6 : 2);
      }

      if (vars) {
        isViewport ? _proxies.unshift(_win$1, vars, _body$1, vars, _docEl$1, vars) : _proxies.unshift(t, vars);
      }
    };

    ScrollTrigger.clearMatchMedia = function clearMatchMedia(query) {
      _triggers.forEach(function (t) {
        return t._ctx && t._ctx.query === query && t._ctx.kill(true, true);
      });
    };

    ScrollTrigger.isInViewport = function isInViewport(element, ratio, horizontal) {
      var bounds = (_isString(element) ? _getTarget(element) : element).getBoundingClientRect(),
          offset = bounds[horizontal ? _width : _height] * ratio || 0;
      return horizontal ? bounds.right - offset > 0 && bounds.left + offset < _win$1.innerWidth : bounds.bottom - offset > 0 && bounds.top + offset < _win$1.innerHeight;
    };

    ScrollTrigger.positionInViewport = function positionInViewport(element, referencePoint, horizontal) {
      _isString(element) && (element = _getTarget(element));
      var bounds = element.getBoundingClientRect(),
          size = bounds[horizontal ? _width : _height],
          offset = referencePoint == null ? size / 2 : referencePoint in _keywords ? _keywords[referencePoint] * size : ~referencePoint.indexOf("%") ? parseFloat(referencePoint) * size / 100 : parseFloat(referencePoint) || 0;
      return horizontal ? (bounds.left + offset) / _win$1.innerWidth : (bounds.top + offset) / _win$1.innerHeight;
    };

    ScrollTrigger.killAll = function killAll(allowListeners) {
      _triggers.slice(0).forEach(function (t) {
        return t.vars.id !== "ScrollSmoother" && t.kill();
      });

      if (allowListeners !== true) {
        var listeners = _listeners.killAll || [];
        _listeners = {};
        listeners.forEach(function (f) {
          return f();
        });
      }
    };

    return ScrollTrigger;
  }();
  ScrollTrigger$1.version = "3.12.5";

  ScrollTrigger$1.saveStyles = function (targets) {
    return targets ? _toArray(targets).forEach(function (target) {
      if (target && target.style) {
        var i = _savedStyles.indexOf(target);

        i >= 0 && _savedStyles.splice(i, 5);

        _savedStyles.push(target, target.style.cssText, target.getBBox && target.getAttribute("transform"), gsap$1.core.getCache(target), _context$1());
      }
    }) : _savedStyles;
  };

  ScrollTrigger$1.revert = function (soft, media) {
    return _revertAll(!soft, media);
  };

  ScrollTrigger$1.create = function (vars, animation) {
    return new ScrollTrigger$1(vars, animation);
  };

  ScrollTrigger$1.refresh = function (safe) {
    return safe ? _onResize() : (_coreInitted$1 || ScrollTrigger$1.register()) && _refreshAll(true);
  };

  ScrollTrigger$1.update = function (force) {
    return ++_scrollers.cache && _updateAll(force === true ? 2 : 0);
  };

  ScrollTrigger$1.clearScrollMemory = _clearScrollMemory;

  ScrollTrigger$1.maxScroll = function (element, horizontal) {
    return _maxScroll(element, horizontal ? _horizontal : _vertical);
  };

  ScrollTrigger$1.getScrollFunc = function (element, horizontal) {
    return _getScrollFunc(_getTarget(element), horizontal ? _horizontal : _vertical);
  };

  ScrollTrigger$1.getById = function (id) {
    return _ids[id];
  };

  ScrollTrigger$1.getAll = function () {
    return _triggers.filter(function (t) {
      return t.vars.id !== "ScrollSmoother";
    });
  };

  ScrollTrigger$1.isScrolling = function () {
    return !!_lastScrollTime;
  };

  ScrollTrigger$1.snapDirectional = _snapDirectional;

  ScrollTrigger$1.addEventListener = function (type, callback) {
    var a = _listeners[type] || (_listeners[type] = []);
    ~a.indexOf(callback) || a.push(callback);
  };

  ScrollTrigger$1.removeEventListener = function (type, callback) {
    var a = _listeners[type],
        i = a && a.indexOf(callback);
    i >= 0 && a.splice(i, 1);
  };

  ScrollTrigger$1.batch = function (targets, vars) {
    var result = [],
        varsCopy = {},
        interval = vars.interval || 0.016,
        batchMax = vars.batchMax || 1e9,
        proxyCallback = function proxyCallback(type, callback) {
      var elements = [],
          triggers = [],
          delay = gsap$1.delayedCall(interval, function () {
        callback(elements, triggers);
        elements = [];
        triggers = [];
      }).pause();
      return function (self) {
        elements.length || delay.restart(true);
        elements.push(self.trigger);
        triggers.push(self);
        batchMax <= elements.length && delay.progress(1);
      };
    },
        p;

    for (p in vars) {
      varsCopy[p] = p.substr(0, 2) === "on" && _isFunction(vars[p]) && p !== "onRefreshInit" ? proxyCallback(p, vars[p]) : vars[p];
    }

    if (_isFunction(batchMax)) {
      batchMax = batchMax();

      _addListener$1(ScrollTrigger$1, "refresh", function () {
        return batchMax = vars.batchMax();
      });
    }

    _toArray(targets).forEach(function (target) {
      var config = {};

      for (p in varsCopy) {
        config[p] = varsCopy[p];
      }

      config.trigger = target;
      result.push(ScrollTrigger$1.create(config));
    });

    return result;
  };

  var _clampScrollAndGetDurationMultiplier = function _clampScrollAndGetDurationMultiplier(scrollFunc, current, end, max) {
    current > max ? scrollFunc(max) : current < 0 && scrollFunc(0);
    return end > max ? (max - current) / (end - current) : end < 0 ? current / (current - end) : 1;
  },
      _allowNativePanning = function _allowNativePanning(target, direction) {
    if (direction === true) {
      target.style.removeProperty("touch-action");
    } else {
      target.style.touchAction = direction === true ? "auto" : direction ? "pan-" + direction + (Observer.isTouch ? " pinch-zoom" : "") : "none";
    }

    target === _docEl$1 && _allowNativePanning(_body$1, direction);
  },
      _overflow = {
    auto: 1,
    scroll: 1
  },
      _nestedScroll = function _nestedScroll(_ref5) {
    var event = _ref5.event,
        target = _ref5.target,
        axis = _ref5.axis;

    var node = (event.changedTouches ? event.changedTouches[0] : event).target,
        cache = node._gsap || gsap$1.core.getCache(node),
        time = _getTime$1(),
        cs;

    if (!cache._isScrollT || time - cache._isScrollT > 2000) {
      while (node && node !== _body$1 && (node.scrollHeight <= node.clientHeight && node.scrollWidth <= node.clientWidth || !(_overflow[(cs = _getComputedStyle(node)).overflowY] || _overflow[cs.overflowX]))) {
        node = node.parentNode;
      }

      cache._isScroll = node && node !== target && !_isViewport$1(node) && (_overflow[(cs = _getComputedStyle(node)).overflowY] || _overflow[cs.overflowX]);
      cache._isScrollT = time;
    }

    if (cache._isScroll || axis === "x") {
      event.stopPropagation();
      event._gsapAllow = true;
    }
  },
      _inputObserver = function _inputObserver(target, type, inputs, nested) {
    return Observer.create({
      target: target,
      capture: true,
      debounce: false,
      lockAxis: true,
      type: type,
      onWheel: nested = nested && _nestedScroll,
      onPress: nested,
      onDrag: nested,
      onScroll: nested,
      onEnable: function onEnable() {
        return inputs && _addListener$1(_doc$1, Observer.eventTypes[0], _captureInputs, false, true);
      },
      onDisable: function onDisable() {
        return _removeListener$1(_doc$1, Observer.eventTypes[0], _captureInputs, true);
      }
    });
  },
      _inputExp = /(input|label|select|textarea)/i,
      _inputIsFocused,
      _captureInputs = function _captureInputs(e) {
    var isInput = _inputExp.test(e.target.tagName);

    if (isInput || _inputIsFocused) {
      e._gsapAllow = true;
      _inputIsFocused = isInput;
    }
  },
      _getScrollNormalizer = function _getScrollNormalizer(vars) {
    _isObject(vars) || (vars = {});
    vars.preventDefault = vars.isNormalizer = vars.allowClicks = true;
    vars.type || (vars.type = "wheel,touch");
    vars.debounce = !!vars.debounce;
    vars.id = vars.id || "normalizer";

    var _vars2 = vars,
        normalizeScrollX = _vars2.normalizeScrollX,
        momentum = _vars2.momentum,
        allowNestedScroll = _vars2.allowNestedScroll,
        onRelease = _vars2.onRelease,
        self,
        maxY,
        target = _getTarget(vars.target) || _docEl$1,
        smoother = gsap$1.core.globals().ScrollSmoother,
        smootherInstance = smoother && smoother.get(),
        content = _fixIOSBug && (vars.content && _getTarget(vars.content) || smootherInstance && vars.content !== false && !smootherInstance.smooth() && smootherInstance.content()),
        scrollFuncY = _getScrollFunc(target, _vertical),
        scrollFuncX = _getScrollFunc(target, _horizontal),
        scale = 1,
        initialScale = (Observer.isTouch && _win$1.visualViewport ? _win$1.visualViewport.scale * _win$1.visualViewport.width : _win$1.outerWidth) / _win$1.innerWidth,
        wheelRefresh = 0,
        resolveMomentumDuration = _isFunction(momentum) ? function () {
      return momentum(self);
    } : function () {
      return momentum || 2.8;
    },
        lastRefreshID,
        skipTouchMove,
        inputObserver = _inputObserver(target, vars.type, true, allowNestedScroll),
        resumeTouchMove = function resumeTouchMove() {
      return skipTouchMove = false;
    },
        scrollClampX = _passThrough,
        scrollClampY = _passThrough,
        updateClamps = function updateClamps() {
      maxY = _maxScroll(target, _vertical);
      scrollClampY = _clamp$1(_fixIOSBug ? 1 : 0, maxY);
      normalizeScrollX && (scrollClampX = _clamp$1(0, _maxScroll(target, _horizontal)));
      lastRefreshID = _refreshID;
    },
        removeContentOffset = function removeContentOffset() {
      content._gsap.y = _round(parseFloat(content._gsap.y) + scrollFuncY.offset) + "px";
      content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + parseFloat(content._gsap.y) + ", 0, 1)";
      scrollFuncY.offset = scrollFuncY.cacheID = 0;
    },
        ignoreDrag = function ignoreDrag() {
      if (skipTouchMove) {
        requestAnimationFrame(resumeTouchMove);

        var offset = _round(self.deltaY / 2),
            scroll = scrollClampY(scrollFuncY.v - offset);

        if (content && scroll !== scrollFuncY.v + scrollFuncY.offset) {
          scrollFuncY.offset = scroll - scrollFuncY.v;

          var y = _round((parseFloat(content && content._gsap.y) || 0) - scrollFuncY.offset);

          content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + y + ", 0, 1)";
          content._gsap.y = y + "px";
          scrollFuncY.cacheID = _scrollers.cache;

          _updateAll();
        }

        return true;
      }

      scrollFuncY.offset && removeContentOffset();
      skipTouchMove = true;
    },
        tween,
        startScrollX,
        startScrollY,
        onStopDelayedCall,
        onResize = function onResize() {
      updateClamps();

      if (tween.isActive() && tween.vars.scrollY > maxY) {
        scrollFuncY() > maxY ? tween.progress(1) && scrollFuncY(maxY) : tween.resetTo("scrollY", maxY);
      }
    };

    content && gsap$1.set(content, {
      y: "+=0"
    });

    vars.ignoreCheck = function (e) {
      return _fixIOSBug && e.type === "touchmove" && ignoreDrag() || scale > 1.05 && e.type !== "touchstart" || self.isGesturing || e.touches && e.touches.length > 1;
    };

    vars.onPress = function () {
      skipTouchMove = false;
      var prevScale = scale;
      scale = _round((_win$1.visualViewport && _win$1.visualViewport.scale || 1) / initialScale);
      tween.pause();
      prevScale !== scale && _allowNativePanning(target, scale > 1.01 ? true : normalizeScrollX ? false : "x");
      startScrollX = scrollFuncX();
      startScrollY = scrollFuncY();
      updateClamps();
      lastRefreshID = _refreshID;
    };

    vars.onRelease = vars.onGestureStart = function (self, wasDragging) {
      scrollFuncY.offset && removeContentOffset();

      if (!wasDragging) {
        onStopDelayedCall.restart(true);
      } else {
        _scrollers.cache++;
        var dur = resolveMomentumDuration(),
            currentScroll,
            endScroll;

        if (normalizeScrollX) {
          currentScroll = scrollFuncX();
          endScroll = currentScroll + dur * 0.05 * -self.velocityX / 0.227;
          dur *= _clampScrollAndGetDurationMultiplier(scrollFuncX, currentScroll, endScroll, _maxScroll(target, _horizontal));
          tween.vars.scrollX = scrollClampX(endScroll);
        }

        currentScroll = scrollFuncY();
        endScroll = currentScroll + dur * 0.05 * -self.velocityY / 0.227;
        dur *= _clampScrollAndGetDurationMultiplier(scrollFuncY, currentScroll, endScroll, _maxScroll(target, _vertical));
        tween.vars.scrollY = scrollClampY(endScroll);
        tween.invalidate().duration(dur).play(0.01);

        if (_fixIOSBug && tween.vars.scrollY >= maxY || currentScroll >= maxY - 1) {
          gsap$1.to({}, {
            onUpdate: onResize,
            duration: dur
          });
        }
      }

      onRelease && onRelease(self);
    };

    vars.onWheel = function () {
      tween._ts && tween.pause();

      if (_getTime$1() - wheelRefresh > 1000) {
        lastRefreshID = 0;
        wheelRefresh = _getTime$1();
      }
    };

    vars.onChange = function (self, dx, dy, xArray, yArray) {
      _refreshID !== lastRefreshID && updateClamps();
      dx && normalizeScrollX && scrollFuncX(scrollClampX(xArray[2] === dx ? startScrollX + (self.startX - self.x) : scrollFuncX() + dx - xArray[1]));

      if (dy) {
        scrollFuncY.offset && removeContentOffset();
        var isTouch = yArray[2] === dy,
            y = isTouch ? startScrollY + self.startY - self.y : scrollFuncY() + dy - yArray[1],
            yClamped = scrollClampY(y);
        isTouch && y !== yClamped && (startScrollY += yClamped - y);
        scrollFuncY(yClamped);
      }

      (dy || dx) && _updateAll();
    };

    vars.onEnable = function () {
      _allowNativePanning(target, normalizeScrollX ? false : "x");

      ScrollTrigger$1.addEventListener("refresh", onResize);

      _addListener$1(_win$1, "resize", onResize);

      if (scrollFuncY.smooth) {
        scrollFuncY.target.style.scrollBehavior = "auto";
        scrollFuncY.smooth = scrollFuncX.smooth = false;
      }

      inputObserver.enable();
    };

    vars.onDisable = function () {
      _allowNativePanning(target, true);

      _removeListener$1(_win$1, "resize", onResize);

      ScrollTrigger$1.removeEventListener("refresh", onResize);
      inputObserver.kill();
    };

    vars.lockAxis = vars.lockAxis !== false;
    self = new Observer(vars);
    self.iOS = _fixIOSBug;
    _fixIOSBug && !scrollFuncY() && scrollFuncY(1);
    _fixIOSBug && gsap$1.ticker.add(_passThrough);
    onStopDelayedCall = self._dc;
    tween = gsap$1.to(self, {
      ease: "power4",
      paused: true,
      inherit: false,
      scrollX: normalizeScrollX ? "+=0.1" : "+=0",
      scrollY: "+=0.1",
      modifiers: {
        scrollY: _interruptionTracker(scrollFuncY, scrollFuncY(), function () {
          return tween.pause();
        })
      },
      onUpdate: _updateAll,
      onComplete: onStopDelayedCall.vars.onComplete
    });
    return self;
  };

  ScrollTrigger$1.sort = function (func) {
    return _triggers.sort(func || function (a, b) {
      return (a.vars.refreshPriority || 0) * -1e6 + a.start - (b.start + (b.vars.refreshPriority || 0) * -1e6);
    });
  };

  ScrollTrigger$1.observe = function (vars) {
    return new Observer(vars);
  };

  ScrollTrigger$1.normalizeScroll = function (vars) {
    if (typeof vars === "undefined") {
      return _normalizer$1;
    }

    if (vars === true && _normalizer$1) {
      return _normalizer$1.enable();
    }

    if (vars === false) {
      _normalizer$1 && _normalizer$1.kill();
      _normalizer$1 = vars;
      return;
    }

    var normalizer = vars instanceof Observer ? vars : _getScrollNormalizer(vars);
    _normalizer$1 && _normalizer$1.target === normalizer.target && _normalizer$1.kill();
    _isViewport$1(normalizer.target) && (_normalizer$1 = normalizer);
    return normalizer;
  };

  ScrollTrigger$1.core = {
    _getVelocityProp: _getVelocityProp,
    _inputObserver: _inputObserver,
    _scrollers: _scrollers,
    _proxies: _proxies,
    bridge: {
      ss: function ss() {
        _lastScrollTime || _dispatch("scrollStart");
        _lastScrollTime = _getTime$1();
      },
      ref: function ref() {
        return _refreshing;
      }
    }
  };
  _getGSAP$1() && gsap$1.registerPlugin(ScrollTrigger$1);

  exports.ScrollTrigger = ScrollTrigger$1;
  exports.default = ScrollTrigger$1;

  if (typeof(window) === 'undefined' || window !== exports) {Object.defineProperty(exports, '__esModule', { value: true });} else {delete window.default;}

})));


/***/ }),

/***/ 30050:
/***/ (function(__unused_webpack_module, exports) {

(function (global, factory) {
	 true ? factory(exports) :
	0;
}(this, (function (exports) { 'use strict';

	var _trimExp = /(?:^\s+|\s+$)/g;
	var emojiExp = /([\uD800-\uDBFF][\uDC00-\uDFFF](?:[\u200D\uFE0F][\uD800-\uDBFF][\uDC00-\uDFFF]){2,}|\uD83D\uDC69(?:\u200D(?:(?:\uD83D\uDC69\u200D)?\uD83D\uDC67|(?:\uD83D\uDC69\u200D)?\uD83D\uDC66)|\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69\u200D(?:\uD83D\uDC69\u200D)?\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D(?:\uD83D\uDC69\u200D)?\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]\uFE0F|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC6F\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3C-\uDD3E\uDDD6-\uDDDF])\u200D[\u2640\u2642]\uFE0F|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F\u200D[\u2640\u2642]|(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642])\uFE0F|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\uD83D\uDC69\u200D[\u2695\u2696\u2708]|\uD83D\uDC68(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708]))\uFE0F|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83D\uDC69\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|\uD83D\uDC68(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC66\u200D\uD83D\uDC66|(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92])|(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]))|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDD1-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\u200D(?:(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC67|(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC66)|\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC69\uDC6E\uDC70-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD26\uDD30-\uDD39\uDD3D\uDD3E\uDDD1-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])?|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDEEB\uDEEC\uDEF4-\uDEF8]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267B\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEF8]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6])\uFE0F)/;
	function getText(e) {
	  var type = e.nodeType,
	      result = "";

	  if (type === 1 || type === 9 || type === 11) {
	    if (typeof e.textContent === "string") {
	      return e.textContent;
	    } else {
	      for (e = e.firstChild; e; e = e.nextSibling) {
	        result += getText(e);
	      }
	    }
	  } else if (type === 3 || type === 4) {
	    return e.nodeValue;
	  }

	  return result;
	}
	function splitInnerHTML(element, delimiter, trim, preserveSpaces) {
	  var node = element.firstChild,
	      result = [],
	      s;

	  while (node) {
	    if (node.nodeType === 3) {
	      s = (node.nodeValue + "").replace(/^\n+/g, "");

	      if (!preserveSpaces) {
	        s = s.replace(/\s+/g, " ");
	      }

	      result.push.apply(result, emojiSafeSplit(s, delimiter, trim, preserveSpaces));
	    } else if ((node.nodeName + "").toLowerCase() === "br") {
	      result[result.length - 1] += "<br>";
	    } else {
	      result.push(node.outerHTML);
	    }

	    node = node.nextSibling;
	  }

	  s = result.length;

	  while (s--) {
	    result[s] === "&" && result.splice(s, 1, "&amp;");
	  }

	  return result;
	}
	function emojiSafeSplit(text, delimiter, trim, preserveSpaces) {
	  text += "";
	  trim && (text = text.trim ? text.trim() : text.replace(_trimExp, ""));

	  if (delimiter && delimiter !== "") {
	    return text.replace(/>/g, "&gt;").replace(/</g, "&lt;").split(delimiter);
	  }

	  var result = [],
	      l = text.length,
	      i = 0,
	      j,
	      character;

	  for (; i < l; i++) {
	    character = text.charAt(i);

	    if (character.charCodeAt(0) >= 0xD800 && character.charCodeAt(0) <= 0xDBFF || text.charCodeAt(i + 1) >= 0xFE00 && text.charCodeAt(i + 1) <= 0xFE0F) {
	      j = ((text.substr(i, 12).split(emojiExp) || [])[1] || "").length || 2;
	      character = text.substr(i, j);
	      result.emoji = 1;
	      i += j - 1;
	    }

	    result.push(character === ">" ? "&gt;" : character === "<" ? "&lt;" : preserveSpaces && character === " " && (text.charAt(i - 1) === " " || text.charAt(i + 1) === " ") ? "&nbsp;" : character);
	  }

	  return result;
	}

	/*!
	 * TextPlugin 3.12.5
	 * https://gsap.com
	 *
	 * @license Copyright 2008-2024, GreenSock. All rights reserved.
	 * Subject to the terms at https://gsap.com/standard-license or for
	 * Club GSAP members, the agreement issued with that membership.
	 * @author: Jack Doyle, jack@greensock.com
	*/

	var gsap,
	    _tempDiv,
	    _getGSAP = function _getGSAP() {
	  return gsap || typeof window !== "undefined" && (gsap = window.gsap) && gsap.registerPlugin && gsap;
	};

	var TextPlugin = {
	  version: "3.12.5",
	  name: "text",
	  init: function init(target, value, tween) {
	    typeof value !== "object" && (value = {
	      value: value
	    });

	    var i = target.nodeName.toUpperCase(),
	        data = this,
	        _value = value,
	        newClass = _value.newClass,
	        oldClass = _value.oldClass,
	        preserveSpaces = _value.preserveSpaces,
	        rtl = _value.rtl,
	        delimiter = data.delimiter = value.delimiter || "",
	        fillChar = data.fillChar = value.fillChar || (value.padSpace ? "&nbsp;" : ""),
	        _short,
	        text,
	        original,
	        j,
	        condensedText,
	        condensedOriginal,
	        aggregate,
	        s;

	    data.svg = target.getBBox && (i === "TEXT" || i === "TSPAN");

	    if (!("innerHTML" in target) && !data.svg) {
	      return false;
	    }

	    data.target = target;

	    if (!("value" in value)) {
	      data.text = data.original = [""];
	      return;
	    }

	    original = splitInnerHTML(target, delimiter, false, preserveSpaces);
	    _tempDiv || (_tempDiv = document.createElement("div"));
	    _tempDiv.innerHTML = value.value;
	    text = splitInnerHTML(_tempDiv, delimiter, false, preserveSpaces);
	    data.from = tween._from;

	    if ((data.from || rtl) && !(rtl && data.from)) {
	      i = original;
	      original = text;
	      text = i;
	    }

	    data.hasClass = !!(newClass || oldClass);
	    data.newClass = rtl ? oldClass : newClass;
	    data.oldClass = rtl ? newClass : oldClass;
	    i = original.length - text.length;
	    _short = i < 0 ? original : text;

	    if (i < 0) {
	      i = -i;
	    }

	    while (--i > -1) {
	      _short.push(fillChar);
	    }

	    if (value.type === "diff") {
	      j = 0;
	      condensedText = [];
	      condensedOriginal = [];
	      aggregate = "";

	      for (i = 0; i < text.length; i++) {
	        s = text[i];

	        if (s === original[i]) {
	          aggregate += s;
	        } else {
	          condensedText[j] = aggregate + s;
	          condensedOriginal[j++] = aggregate + original[i];
	          aggregate = "";
	        }
	      }

	      text = condensedText;
	      original = condensedOriginal;

	      if (aggregate) {
	        text.push(aggregate);
	        original.push(aggregate);
	      }
	    }

	    value.speed && tween.duration(Math.min(0.05 / value.speed * _short.length, value.maxDuration || 9999));
	    data.rtl = rtl;
	    data.original = original;
	    data.text = text;

	    data._props.push("text");
	  },
	  render: function render(ratio, data) {
	    if (ratio > 1) {
	      ratio = 1;
	    } else if (ratio < 0) {
	      ratio = 0;
	    }

	    if (data.from) {
	      ratio = 1 - ratio;
	    }

	    var text = data.text,
	        hasClass = data.hasClass,
	        newClass = data.newClass,
	        oldClass = data.oldClass,
	        delimiter = data.delimiter,
	        target = data.target,
	        fillChar = data.fillChar,
	        original = data.original,
	        rtl = data.rtl,
	        l = text.length,
	        i = (rtl ? 1 - ratio : ratio) * l + 0.5 | 0,
	        applyNew,
	        applyOld,
	        str;

	    if (hasClass && ratio) {
	      applyNew = newClass && i;
	      applyOld = oldClass && i !== l;
	      str = (applyNew ? "<span class='" + newClass + "'>" : "") + text.slice(0, i).join(delimiter) + (applyNew ? "</span>" : "") + (applyOld ? "<span class='" + oldClass + "'>" : "") + delimiter + original.slice(i).join(delimiter) + (applyOld ? "</span>" : "");
	    } else {
	      str = text.slice(0, i).join(delimiter) + delimiter + original.slice(i).join(delimiter);
	    }

	    if (data.svg) {
	      target.textContent = str;
	    } else {
	      target.innerHTML = fillChar === "&nbsp;" && ~str.indexOf("  ") ? str.split("  ").join("&nbsp;&nbsp;") : str;
	    }
	  }
	};
	TextPlugin.splitInnerHTML = splitInnerHTML;
	TextPlugin.emojiSafeSplit = emojiSafeSplit;
	TextPlugin.getText = getText;
	_getGSAP() && gsap.registerPlugin(TextPlugin);

	exports.TextPlugin = TextPlugin;
	exports.default = TextPlugin;

	Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),

/***/ 27924:
/***/ (function(__unused_webpack_module, exports) {

(function (global, factory) {
   true ? factory(exports) :
  0;
}(this, (function (exports) { 'use strict';

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  /*!
   * GSAP 3.12.5
   * https://gsap.com
   *
   * @license Copyright 2008-2024, GreenSock. All rights reserved.
   * Subject to the terms at https://gsap.com/standard-license or for
   * Club GSAP members, the agreement issued with that membership.
   * @author: Jack Doyle, jack@greensock.com
  */
  var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
      lineHeight: ""
    }
  },
      _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
  },
      _suppressOverwrites,
      _reverting,
      _context,
      _bigNum = 1e8,
      _tinyNum = 1 / _bigNum,
      _2PI = Math.PI * 2,
      _HALF_PI = _2PI / 4,
      _gsID = 0,
      _sqrt = Math.sqrt,
      _cos = Math.cos,
      _sin = Math.sin,
      _isString = function _isString(value) {
    return typeof value === "string";
  },
      _isFunction = function _isFunction(value) {
    return typeof value === "function";
  },
      _isNumber = function _isNumber(value) {
    return typeof value === "number";
  },
      _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
  },
      _isObject = function _isObject(value) {
    return typeof value === "object";
  },
      _isNotFalse = function _isNotFalse(value) {
    return value !== false;
  },
      _windowExists = function _windowExists() {
    return typeof window !== "undefined";
  },
      _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
  },
      _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function () {},
      _isArray = Array.isArray,
      _strictNumExp = /(?:-?\.?\d|\.)+/gi,
      _numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
      _numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
      _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
      _relExp = /[+-]=-?[.\d]+/,
      _delimitedValueExp = /[^,'"\[\]\s]+/gi,
      _unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,
      _globalTimeline,
      _win,
      _coreInitted,
      _doc,
      _globals = {},
      _installScope = {},
      _coreReady,
      _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
  },
      _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
  },
      _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
  },
      _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
  },
      _emptyFunc = function _emptyFunc() {
    return 0;
  },
      _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
  },
      _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
  },
      _revertConfig = {
    suppressEvents: true
  },
      _reservedProps = {},
      _lazyTweens = [],
      _lazyLookup = {},
      _lastRenderedFrame,
      _plugins = {},
      _effects = {},
      _nextGCFrame = 30,
      _harnessPlugins = [],
      _callbackNames = "",
      _harness = function _harness(targets) {
    var target = targets[0],
        harnessPlugin,
        i;
    _isObject(target) || _isFunction(target) || (targets = [targets]);

    if (!(harnessPlugin = (target._gsap || {}).harness)) {
      i = _harnessPlugins.length;

      while (i-- && !_harnessPlugins[i].targetTest(target)) {}

      harnessPlugin = _harnessPlugins[i];
    }

    i = targets.length;

    while (i--) {
      targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    }

    return targets;
  },
      _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
  },
      _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
  },
      _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
  },
      _round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
  },
      _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
  },
      _parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0),
        end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
  },
      _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    var l = toFind.length,
        i = 0;

    for (; toSearch.indexOf(toFind[i]) < 0 && ++i < l;) {}

    return i < l;
  },
      _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length,
        a = _lazyTweens.slice(0),
        i,
        tween;

    _lazyLookup = {};
    _lazyTweens.length = 0;

    for (i = 0; i < l; i++) {
      tween = a[i];
      tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
  },
      _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || _reverting && time < 0 && (animation._initted || animation._startAt));
    _lazyTweens.length && !_reverting && _lazyRender();
  },
      _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
  },
      _passThrough = function _passThrough(p) {
    return p;
  },
      _setDefaults = function _setDefaults(obj, defaults) {
    for (var p in defaults) {
      p in obj || (obj[p] = defaults[p]);
    }

    return obj;
  },
      _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function (obj, defaults) {
      for (var p in defaults) {
        p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
      }
    };
  },
      _merge = function _merge(base, toMerge) {
    for (var p in toMerge) {
      base[p] = toMerge[p];
    }

    return base;
  },
      _mergeDeep = function _mergeDeep(base, toMerge) {
    for (var p in toMerge) {
      p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    }

    return base;
  },
      _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {},
        p;

    for (p in obj) {
      p in excluding || (copy[p] = obj[p]);
    }

    return copy;
  },
      _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline,
        func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;

    if (_isNotFalse(vars.inherit)) {
      while (parent) {
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
      }
    }

    return vars;
  },
      _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length,
        match = i === a2.length;

    while (match && i-- && a1[i] === a2[i]) {}

    return i < 0;
  },
      _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) {
      firstProp = "_first";
    }

    if (lastProp === void 0) {
      lastProp = "_last";
    }

    var prev = parent[lastProp],
        t;

    if (sortBy) {
      t = child[sortBy];

      while (prev && prev[sortBy] > t) {
        prev = prev._prev;
      }
    }

    if (prev) {
      child._next = prev._next;
      prev._next = child;
    } else {
      child._next = parent[firstProp];
      parent[firstProp] = child;
    }

    if (child._next) {
      child._next._prev = child;
    } else {
      parent[lastProp] = child;
    }

    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
  },
      _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) {
      firstProp = "_first";
    }

    if (lastProp === void 0) {
      lastProp = "_last";
    }

    var prev = child._prev,
        next = child._next;

    if (prev) {
      prev._next = next;
    } else if (parent[firstProp] === child) {
      parent[firstProp] = next;
    }

    if (next) {
      next._prev = prev;
    } else if (parent[lastProp] === child) {
      parent[lastProp] = prev;
    }

    child._next = child._prev = child.parent = null;
  },
      _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
  },
      _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
      var a = animation;

      while (a) {
        a._dirty = 1;
        a = a.parent;
      }
    }

    return animation;
  },
      _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;

    while (parent && parent.parent) {
      parent._dirty = 1;
      parent.totalDuration();
      parent = parent.parent;
    }

    return animation;
  },
      _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
  },
      _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
  },
      _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
  },
      _animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime /= cycleDuration);
    return tTime && whole === tTime ? whole - 1 : whole;
  },
      _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
  },
      _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
  },
      _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    var parent = animation._dp;

    if (parent && parent.smoothChildTiming && animation._ts) {
      animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));

      _setEnd(animation);

      parent._dirty || _uncache(parent, animation);
    }

    return animation;
  },
      _postAddChecks = function _postAddChecks(timeline, child) {
    var t;

    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
      t = _parentToChildTotalTime(timeline.rawTime(), child);

      if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) {
        child.render(t, true);
      }
    }

    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
      if (timeline._dur < timeline.duration()) {
        t = timeline;

        while (t._dp) {
          t.rawTime() >= 0 && t.totalTime(t._tTime);
          t = t._dp;
        }
      }

      timeline._zTime = -_tinyNum;
    }
  },
      _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));

    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);

    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime);
    return timeline;
  },
      _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
  },
      _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);

    if (!tween._initted) {
      return 1;
    }

    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
      _lazyTweens.push(tween);

      tween._lazy = [tTime, suppressEvents];
      return 1;
    }
  },
      _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
  },
      _isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
  },
      _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio,
        ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1,
        repeatDelay = tween._rDelay,
        tTime = 0,
        pt,
        iteration,
        prevIteration;

    if (repeatDelay && tween._repeat) {
      tTime = _clamp(0, tween._tDur, totalTime);
      iteration = _animationCycle(tTime, repeatDelay);
      tween._yoyo && iteration & 1 && (ratio = 1 - ratio);

      if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
        prevRatio = 1 - ratio;
        tween.vars.repeatRefresh && tween._initted && tween.invalidate();
      }
    }

    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
      if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) {
        return;
      }

      prevIteration = tween._zTime;
      tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0);
      suppressEvents || (suppressEvents = totalTime && !prevIteration);
      tween.ratio = ratio;
      tween._from && (ratio = 1 - ratio);
      tween._time = 0;
      tween._tTime = tTime;
      pt = tween._pt;

      while (pt) {
        pt.r(ratio, pt.d);
        pt = pt._next;
      }

      totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
      tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
      tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");

      if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
        ratio && _removeFromParent(tween, 1);

        if (!suppressEvents && !_reverting) {
          _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);

          tween._prom && tween._prom();
        }
      }
    } else if (!tween._zTime) {
      tween._zTime = totalTime;
    }
  },
      _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;

    if (time > prevTime) {
      child = animation._first;

      while (child && child._start <= time) {
        if (child.data === "isPause" && child._start > prevTime) {
          return child;
        }

        child = child._next;
      }
    } else {
      child = animation._last;

      while (child && child._start >= time) {
        if (child.data === "isPause" && child._start < prevTime) {
          return child;
        }

        child = child._prev;
      }
    }
  },
      _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat,
        dur = _roundPrecise(duration) || 0,
        totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
  },
      _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
  },
      _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
  },
      _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels,
        recent = animation._recent || _zeroPosition,
        clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur,
        i,
        offset,
        isPercent;

    if (_isString(position) && (isNaN(position) || position in labels)) {
      offset = position.charAt(0);
      isPercent = position.substr(-1) === "%";
      i = position.indexOf("=");

      if (offset === "<" || offset === ">") {
        i >= 0 && (position = position.replace(/=/, ""));
        return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
      }

      if (i < 0) {
        position in labels || (labels[position] = clippedDuration);
        return labels[position];
      }

      offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));

      if (isPercent && percentAnimation) {
        offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
      }

      return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }

    return position == null ? clippedDuration : +position;
  },
      _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]),
        varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1),
        vars = params[varsIndex],
        irVars,
        parent;

    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;

    if (type) {
      irVars = vars;
      parent = timeline;

      while (parent && !("immediateRender" in irVars)) {
        irVars = parent.vars.defaults || {};
        parent = _isNotFalse(parent.vars.inherit) && parent.parent;
      }

      vars.immediateRender = _isNotFalse(irVars.immediateRender);
      type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1];
    }

    return new Tween(params[0], vars, params[varsIndex + 1]);
  },
      _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
  },
      _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
  },
      getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
  },
      clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function (v) {
      return _clamp(min, max, v);
    });
  },
      _slice = [].slice,
      _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
  },
      _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) {
      accumulator = [];
    }

    return ar.forEach(function (value) {
      var _accumulator;

      return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
  },
      toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [value] : [];
  },
      selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function (v) {
      var el = value.current || value.nativeElement || value;
      return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
  },
      shuffle = function shuffle(a) {
    return a.sort(function () {
      return .5 - Math.random();
    });
  },
      distribute = function distribute(v) {
    if (_isFunction(v)) {
      return v;
    }

    var vars = _isObject(v) ? v : {
      each: v
    },
        ease = _parseEase(vars.ease),
        from = vars.from || 0,
        base = parseFloat(vars.base) || 0,
        cache = {},
        isDecimal = from > 0 && from < 1,
        ratios = isNaN(from) || isDecimal,
        axis = vars.axis,
        ratioX = from,
        ratioY = from;

    if (_isString(from)) {
      ratioX = ratioY = {
        center: .5,
        edges: .5,
        end: 1
      }[from] || 0;
    } else if (!isDecimal && ratios) {
      ratioX = from[0];
      ratioY = from[1];
    }

    return function (i, target, a) {
      var l = (a || vars).length,
          distances = cache[l],
          originX,
          originY,
          x,
          y,
          d,
          j,
          max,
          min,
          wrapAt;

      if (!distances) {
        wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [1, _bigNum])[1];

        if (!wrapAt) {
          max = -_bigNum;

          while (max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l) {}

          wrapAt < l && wrapAt--;
        }

        distances = cache[l] = [];
        originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
        originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
        max = 0;
        min = _bigNum;

        for (j = 0; j < l; j++) {
          x = j % wrapAt - originX;
          y = originY - (j / wrapAt | 0);
          distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
          d > max && (max = d);
          d < min && (min = d);
        }

        from === "random" && shuffle(distances);
        distances.max = max - min;
        distances.min = min;
        distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
        distances.b = l < 0 ? base - l : base;
        distances.u = getUnit(vars.amount || vars.each) || 0;
        ease = ease && l < 0 ? _invertEase(ease) : ease;
      }

      l = (distances[i] - distances.min) / distances.max || 0;
      return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u;
    };
  },
      _roundModifier = function _roundModifier(v) {
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length);
    return function (raw) {
      var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);

      return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw));
    };
  },
      snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo),
        radius,
        is2D;

    if (!isArray && _isObject(snapTo)) {
      radius = isArray = snapTo.radius || _bigNum;

      if (snapTo.values) {
        snapTo = toArray(snapTo.values);

        if (is2D = !_isNumber(snapTo[0])) {
          radius *= radius;
        }
      } else {
        snapTo = _roundModifier(snapTo.increment);
      }
    }

    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function (raw) {
      is2D = snapTo(raw);
      return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function (raw) {
      var x = parseFloat(is2D ? raw.x : raw),
          y = parseFloat(is2D ? raw.y : 0),
          min = _bigNum,
          closest = 0,
          i = snapTo.length,
          dx,
          dy;

      while (i--) {
        if (is2D) {
          dx = snapTo[i].x - x;
          dy = snapTo[i].y - y;
          dx = dx * dx + dy * dy;
        } else {
          dx = Math.abs(snapTo[i] - x);
        }

        if (dx < min) {
          min = dx;
          closest = i;
        }
      }

      closest = !radius || min <= radius ? snapTo[closest] : raw;
      return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
  },
      random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? !!(roundingIncrement = 0) : !returnFunction, function () {
      return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5) && (returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
  },
      pipe = function pipe() {
    for (var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++) {
      functions[_key] = arguments[_key];
    }

    return function (value) {
      return functions.reduce(function (v, f) {
        return f(v);
      }, value);
    };
  },
      unitize = function unitize(func, unit) {
    return function (value) {
      return func(parseFloat(value)) + (unit || getUnit(value));
    };
  },
      normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
  },
      _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function (index) {
      return a[~~wrapper(index)];
    });
  },
      wrap = function wrap(min, max, value) {
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function (value) {
      return (range + (value - min) % range) % range + min;
    });
  },
      wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min,
        total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function (value) {
      value = (total + (value - min) % total) % total || 0;
      return min + (value > range ? total - value : value);
    });
  },
      _replaceRandom = function _replaceRandom(value) {
    var prev = 0,
        s = "",
        i,
        nums,
        end,
        isArray;

    while (~(i = value.indexOf("random(", prev))) {
      end = value.indexOf(")", i);
      isArray = value.charAt(i + 7) === "[";
      nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
      s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
      prev = end + 1;
    }

    return s + value.substr(prev, value.length - prev);
  },
      mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin,
        outRange = outMax - outMin;
    return _conditionalReturn(value, function (value) {
      return outMin + ((value - inMin) / inRange * outRange || 0);
    });
  },
      interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function (p) {
      return (1 - p) * start + p * end;
    };

    if (!func) {
      var isString = _isString(start),
          master = {},
          p,
          i,
          interpolators,
          l,
          il;

      progress === true && (mutate = 1) && (progress = null);

      if (isString) {
        start = {
          p: start
        };
        end = {
          p: end
        };
      } else if (_isArray(start) && !_isArray(end)) {
        interpolators = [];
        l = start.length;
        il = l - 2;

        for (i = 1; i < l; i++) {
          interpolators.push(interpolate(start[i - 1], start[i]));
        }

        l--;

        func = function func(p) {
          p *= l;
          var i = Math.min(il, ~~p);
          return interpolators[i](p - i);
        };

        progress = end;
      } else if (!mutate) {
        start = _merge(_isArray(start) ? [] : {}, start);
      }

      if (!interpolators) {
        for (p in end) {
          _addPropTween.call(master, start, p, "get", end[p]);
        }

        func = function func(p) {
          return _renderPropTweens(p, master) || (isString ? start.p : start);
        };
      }
    }

    return _conditionalReturn(progress, func);
  },
      _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    var labels = timeline.labels,
        min = _bigNum,
        p,
        distance,
        label;

    for (p in labels) {
      distance = labels[p] - fromTime;

      if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
        label = p;
        min = distance;
      }
    }

    return label;
  },
      _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars,
        callback = v[type],
        prevContext = _context,
        context = animation._ctx,
        params,
        scope,
        result;

    if (!callback) {
      return;
    }

    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender();
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
  },
      _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);

    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
  },
      _quickTween,
      _registerPluginQueue = [],
      _createPlugin = function _createPlugin(config) {
    if (!config) return;
    config = !config.name && config["default"] || config;

    if (_windowExists() || config.headless) {
      var name = config.name,
          isFunc = _isFunction(config),
          Plugin = name && !isFunc && config.init ? function () {
        this._props = [];
      } : config,
          instanceDefaults = {
        init: _emptyFunc,
        render: _renderPropTweens,
        add: _addPropTween,
        kill: _killPropTweensOf,
        modifier: _addPluginModifier,
        rawVars: 0
      },
          statics = {
        targetTest: 0,
        get: 0,
        getSetter: _getSetter,
        aliases: {},
        register: 0
      };

      _wake();

      if (config !== Plugin) {
        if (_plugins[name]) {
          return;
        }

        _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics));

        _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics)));

        _plugins[Plugin.prop = name] = Plugin;

        if (config.targetTest) {
          _harnessPlugins.push(Plugin);

          _reservedProps[name] = 1;
        }

        name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin";
      }

      _addGlobal(name, Plugin);

      config.register && config.register(gsap, Plugin, PropTween);
    } else {
      _registerPluginQueue.push(config);
    }
  },
      _255 = 255,
      _colorLookup = {
    aqua: [0, _255, _255],
    lime: [0, _255, 0],
    silver: [192, 192, 192],
    black: [0, 0, 0],
    maroon: [128, 0, 0],
    teal: [0, 128, 128],
    blue: [0, 0, _255],
    navy: [0, 0, 128],
    white: [_255, _255, _255],
    olive: [128, 128, 0],
    yellow: [_255, _255, 0],
    orange: [_255, 165, 0],
    gray: [128, 128, 128],
    purple: [128, 0, 128],
    green: [0, 128, 0],
    red: [_255, 0, 0],
    pink: [_255, 192, 203],
    cyan: [0, _255, _255],
    transparent: [_255, _255, _255, 0]
  },
      _hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
  },
      splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [v >> 16, v >> 8 & _255, v & _255] : 0,
        r,
        g,
        b,
        h,
        s,
        l,
        max,
        min,
        d,
        wasHSL;

    if (!a) {
      if (v.substr(-1) === ",") {
        v = v.substr(0, v.length - 1);
      }

      if (_colorLookup[v]) {
        a = _colorLookup[v];
      } else if (v.charAt(0) === "#") {
        if (v.length < 6) {
          r = v.charAt(1);
          g = v.charAt(2);
          b = v.charAt(3);
          v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
        }

        if (v.length === 9) {
          a = parseInt(v.substr(1, 6), 16);
          return [a >> 16, a >> 8 & _255, a & _255, parseInt(v.substr(7), 16) / 255];
        }

        v = parseInt(v.substr(1), 16);
        a = [v >> 16, v >> 8 & _255, v & _255];
      } else if (v.substr(0, 3) === "hsl") {
        a = wasHSL = v.match(_strictNumExp);

        if (!toHSL) {
          h = +a[0] % 360 / 360;
          s = +a[1] / 100;
          l = +a[2] / 100;
          g = l <= .5 ? l * (s + 1) : l + s - l * s;
          r = l * 2 - g;
          a.length > 3 && (a[3] *= 1);
          a[0] = _hue(h + 1 / 3, r, g);
          a[1] = _hue(h, r, g);
          a[2] = _hue(h - 1 / 3, r, g);
        } else if (~v.indexOf("=")) {
          a = v.match(_numExp);
          forceAlpha && a.length < 4 && (a[3] = 1);
          return a;
        }
      } else {
        a = v.match(_strictNumExp) || _colorLookup.transparent;
      }

      a = a.map(Number);
    }

    if (toHSL && !wasHSL) {
      r = a[0] / _255;
      g = a[1] / _255;
      b = a[2] / _255;
      max = Math.max(r, g, b);
      min = Math.min(r, g, b);
      l = (max + min) / 2;

      if (max === min) {
        h = s = 0;
      } else {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
        h *= 60;
      }

      a[0] = ~~(h + .5);
      a[1] = ~~(s * 100 + .5);
      a[2] = ~~(l * 100 + .5);
    }

    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
  },
      _colorOrderData = function _colorOrderData(v) {
    var values = [],
        c = [],
        i = -1;
    v.split(_colorExp).forEach(function (v) {
      var a = v.match(_numWithUnitExp) || [];
      values.push.apply(values, a);
      c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
  },
      _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "",
        colors = (s + result).match(_colorExp),
        type = toHSL ? "hsla(" : "rgba(",
        i = 0,
        c,
        shell,
        d,
        l;

    if (!colors) {
      return s;
    }

    colors = colors.map(function (color) {
      return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });

    if (orderMatchData) {
      d = _colorOrderData(s);
      c = orderMatchData.c;

      if (c.join(result) !== d.c.join(result)) {
        shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
        l = shell.length - 1;

        for (; i < l; i++) {
          result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
      }
    }

    if (!shell) {
      shell = s.split(_colorExp);
      l = shell.length - 1;

      for (; i < l; i++) {
        result += shell[i] + colors[i];
      }
    }

    return result + shell[l];
  },
      _colorExp = function () {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b",
        p;

    for (p in _colorLookup) {
      s += "|" + p + "\\b";
    }

    return new RegExp(s + ")", "gi");
  }(),
      _hslExp = /hsl[a]?\(/,
      _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "),
        toHSL;
    _colorExp.lastIndex = 0;

    if (_colorExp.test(combined)) {
      toHSL = _hslExp.test(combined);
      a[1] = _formatColors(a[1], toHSL);
      a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1]));
      return true;
    }
  },
      _tickerActive,
      _ticker = function () {
    var _getTime = Date.now,
        _lagThreshold = 500,
        _adjustedLag = 33,
        _startTime = _getTime(),
        _lastUpdate = _startTime,
        _gap = 1000 / 240,
        _nextTime = _gap,
        _listeners = [],
        _id,
        _req,
        _raf,
        _self,
        _delta,
        _i,
        _tick = function _tick(v) {
      var elapsed = _getTime() - _lastUpdate,
          manual = v === true,
          overlap,
          dispatch,
          time,
          frame;

      (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
      _lastUpdate += elapsed;
      time = _lastUpdate - _startTime;
      overlap = time - _nextTime;

      if (overlap > 0 || manual) {
        frame = ++_self.frame;
        _delta = time - _self.time * 1000;
        _self.time = time = time / 1000;
        _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
        dispatch = 1;
      }

      manual || (_id = _req(_tick));

      if (dispatch) {
        for (_i = 0; _i < _listeners.length; _i++) {
          _listeners[_i](time, _delta, frame, v);
        }
      }
    };

    _self = {
      time: 0,
      frame: 0,
      tick: function tick() {
        _tick(true);
      },
      deltaRatio: function deltaRatio(fps) {
        return _delta / (1000 / (fps || 60));
      },
      wake: function wake() {
        if (_coreReady) {
          if (!_coreInitted && _windowExists()) {
            _win = _coreInitted = window;
            _doc = _win.document || {};
            _globals.gsap = gsap;
            (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);

            _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});

            _registerPluginQueue.forEach(_createPlugin);
          }

          _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
          _id && _self.sleep();

          _req = _raf || function (f) {
            return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
          };

          _tickerActive = 1;

          _tick(2);
        }
      },
      sleep: function sleep() {
        (_raf ? cancelAnimationFrame : clearTimeout)(_id);
        _tickerActive = 0;
        _req = _emptyFunc;
      },
      lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
        _lagThreshold = threshold || Infinity;
        _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
      },
      fps: function fps(_fps) {
        _gap = 1000 / (_fps || 240);
        _nextTime = _self.time * 1000 + _gap;
      },
      add: function add(callback, once, prioritize) {
        var func = once ? function (t, d, f, v) {
          callback(t, d, f, v);

          _self.remove(func);
        } : callback;

        _self.remove(callback);

        _listeners[prioritize ? "unshift" : "push"](func);

        _wake();

        return func;
      },
      remove: function remove(callback, i) {
        ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
      },
      _listeners: _listeners
    };
    return _self;
  }(),
      _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
  },
      _easeMap = {},
      _customEaseExp = /^[\d.\-M][\d.\-,\s]/,
      _quotesExp = /["']/g,
      _parseObjectInString = function _parseObjectInString(value) {
    var obj = {},
        split = value.substr(1, value.length - 3).split(":"),
        key = split[0],
        i = 1,
        l = split.length,
        index,
        val,
        parsedVal;

    for (; i < l; i++) {
      val = split[i];
      index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
      parsedVal = val.substr(0, index);
      obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
      key = val.substr(index + 1).trim();
    }

    return obj;
  },
      _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1,
        close = value.indexOf(")"),
        nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
  },
      _configEaseFromString = function _configEaseFromString(name) {
    var split = (name + "").split("("),
        ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [_parseObjectInString(split[1])] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
  },
      _invertEase = function _invertEase(ease) {
    return function (p) {
      return 1 - ease(1 - p);
    };
  },
      _propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first,
        ease;

    while (child) {
      if (child instanceof Timeline) {
        _propagateYoyoEase(child, isYoyo);
      } else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
        if (child.timeline) {
          _propagateYoyoEase(child.timeline, isYoyo);
        } else {
          ease = child._ease;
          child._ease = child._yEase;
          child._yEase = ease;
          child._yoyo = isYoyo;
        }
      }

      child = child._next;
    }
  },
      _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
  },
      _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) {
      easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
      };
    }

    if (easeInOut === void 0) {
      easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
      };
    }

    var ease = {
      easeIn: easeIn,
      easeOut: easeOut,
      easeInOut: easeInOut
    },
        lowercaseName;

    _forEachName(names, function (name) {
      _easeMap[name] = _globals[name] = ease;
      _easeMap[lowercaseName = name.toLowerCase()] = easeOut;

      for (var p in ease) {
        _easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
      }
    });

    return ease;
  },
      _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function (p) {
      return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
  },
      _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1,
        p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1),
        p3 = p2 / _2PI * (Math.asin(1 / p1) || 0),
        easeOut = function easeOut(p) {
      return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    },
        ease = type === "out" ? easeOut : type === "in" ? function (p) {
      return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);

    p2 = _2PI / p2;

    ease.config = function (amplitude, period) {
      return _configElastic(type, amplitude, period);
    };

    return ease;
  },
      _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) {
      overshoot = 1.70158;
    }

    var easeOut = function easeOut(p) {
      return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    },
        ease = type === "out" ? easeOut : type === "in" ? function (p) {
      return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);

    ease.config = function (overshoot) {
      return _configBack(type, overshoot);
    };

    return ease;
  };

  _forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function (name, i) {
    var power = i < 5 ? i + 1 : i;

    _insertEase(name + ",Power" + (power - 1), i ? function (p) {
      return Math.pow(p, power);
    } : function (p) {
      return p;
    }, function (p) {
      return 1 - Math.pow(1 - p, power);
    }, function (p) {
      return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
  });

  _easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;

  _insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());

  (function (n, c) {
    var n1 = 1 / c,
        n2 = 2 * n1,
        n3 = 2.5 * n1,
        easeOut = function easeOut(p) {
      return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };

    _insertEase("Bounce", function (p) {
      return 1 - easeOut(1 - p);
    }, easeOut);
  })(7.5625, 2.75);

  _insertEase("Expo", function (p) {
    return p ? Math.pow(2, 10 * (p - 1)) : 0;
  });

  _insertEase("Circ", function (p) {
    return -(_sqrt(1 - p * p) - 1);
  });

  _insertEase("Sine", function (p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
  });

  _insertEase("Back", _configBack("in"), _configBack("out"), _configBack());

  _easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
      if (steps === void 0) {
        steps = 1;
      }

      var p1 = 1 / steps,
          p2 = steps + (immediateStart ? 0 : 1),
          p3 = immediateStart ? 1 : 0,
          max = 1 - _tinyNum;
      return function (p) {
        return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
      };
    }
  };
  _defaults.ease = _easeMap["quad.out"];

  _forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function (name) {
    return _callbackNames += name + "," + name + "Params,";
  });

  var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
  };
  var Animation = function () {
    function Animation(vars) {
      this.vars = vars;
      this._delay = +vars.delay || 0;

      if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
        this._rDelay = vars.repeatDelay || 0;
        this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
      }

      this._ts = 1;

      _setDuration(this, +vars.duration, 1, 1);

      this.data = vars.data;

      if (_context) {
        this._ctx = _context;

        _context.data.push(this);
      }

      _tickerActive || _ticker.wake();
    }

    var _proto = Animation.prototype;

    _proto.delay = function delay(value) {
      if (value || value === 0) {
        this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
        this._delay = value;
        return this;
      }

      return this._delay;
    };

    _proto.duration = function duration(value) {
      return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };

    _proto.totalDuration = function totalDuration(value) {
      if (!arguments.length) {
        return this._tDur;
      }

      this._dirty = 0;
      return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };

    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
      _wake();

      if (!arguments.length) {
        return this._tTime;
      }

      var parent = this._dp;

      if (parent && parent.smoothChildTiming && this._ts) {
        _alignPlayhead(this, _totalTime);

        !parent._dp || parent.parent || _postAddChecks(parent, this);

        while (parent && parent.parent) {
          if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) {
            parent.totalTime(parent._tTime, true);
          }

          parent = parent.parent;
        }

        if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) {
          _addToTimeline(this._dp, this, this._start - this._delay);
        }
      }

      if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
        this._ts || (this._pTime = _totalTime);

        _lazySafeRender(this, _totalTime, suppressEvents);
      }

      return this;
    };

    _proto.time = function time(value, suppressEvents) {
      return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time;
    };

    _proto.totalProgress = function totalProgress(value, suppressEvents) {
      return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() > 0 ? 1 : 0;
    };

    _proto.progress = function progress(value, suppressEvents) {
      return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
    };

    _proto.iteration = function iteration(value, suppressEvents) {
      var cycleDuration = this.duration() + this._rDelay;

      return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    };

    _proto.timeScale = function timeScale(value, suppressEvents) {
      if (!arguments.length) {
        return this._rts === -_tinyNum ? 0 : this._rts;
      }

      if (this._rts === value) {
        return this;
      }

      var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime;
      this._rts = +value || 0;
      this._ts = this._ps || value === -_tinyNum ? 0 : this._rts;
      this.totalTime(_clamp(-Math.abs(this._delay), this._tDur, tTime), suppressEvents !== false);

      _setEnd(this);

      return _recacheAncestors(this);
    };

    _proto.paused = function paused(value) {
      if (!arguments.length) {
        return this._ps;
      }

      if (this._ps !== value) {
        this._ps = value;

        if (value) {
          this._pTime = this._tTime || Math.max(-this._delay, this.rawTime());
          this._ts = this._act = 0;
        } else {
          _wake();

          this._ts = this._rts;
          this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum));
        }
      }

      return this;
    };

    _proto.startTime = function startTime(value) {
      if (arguments.length) {
        this._start = value;
        var parent = this.parent || this._dp;
        parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
        return this;
      }

      return this._start;
    };

    _proto.endTime = function endTime(includeRepeats) {
      return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };

    _proto.rawTime = function rawTime(wrapRepeats) {
      var parent = this.parent || this._dp;
      return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };

    _proto.revert = function revert(config) {
      if (config === void 0) {
        config = _revertConfig;
      }

      var prevIsReverting = _reverting;
      _reverting = config;

      if (this._initted || this._startAt) {
        this.timeline && this.timeline.revert(config);
        this.totalTime(-0.01, config.suppressEvents);
      }

      this.data !== "nested" && config.kill !== false && this.kill();
      _reverting = prevIsReverting;
      return this;
    };

    _proto.globalTime = function globalTime(rawTime) {
      var animation = this,
          time = arguments.length ? rawTime : animation.rawTime();

      while (animation) {
        time = animation._start + time / (Math.abs(animation._ts) || 1);
        animation = animation._dp;
      }

      return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time;
    };

    _proto.repeat = function repeat(value) {
      if (arguments.length) {
        this._repeat = value === Infinity ? -2 : value;
        return _onUpdateTotalDuration(this);
      }

      return this._repeat === -2 ? Infinity : this._repeat;
    };

    _proto.repeatDelay = function repeatDelay(value) {
      if (arguments.length) {
        var time = this._time;
        this._rDelay = value;

        _onUpdateTotalDuration(this);

        return time ? this.time(time) : this;
      }

      return this._rDelay;
    };

    _proto.yoyo = function yoyo(value) {
      if (arguments.length) {
        this._yoyo = value;
        return this;
      }

      return this._yoyo;
    };

    _proto.seek = function seek(position, suppressEvents) {
      return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };

    _proto.restart = function restart(includeDelay, suppressEvents) {
      return this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
    };

    _proto.play = function play(from, suppressEvents) {
      from != null && this.seek(from, suppressEvents);
      return this.reversed(false).paused(false);
    };

    _proto.reverse = function reverse(from, suppressEvents) {
      from != null && this.seek(from || this.totalDuration(), suppressEvents);
      return this.reversed(true).paused(false);
    };

    _proto.pause = function pause(atTime, suppressEvents) {
      atTime != null && this.seek(atTime, suppressEvents);
      return this.paused(true);
    };

    _proto.resume = function resume() {
      return this.paused(false);
    };

    _proto.reversed = function reversed(value) {
      if (arguments.length) {
        !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0));
        return this;
      }

      return this._rts < 0;
    };

    _proto.invalidate = function invalidate() {
      this._initted = this._act = 0;
      this._zTime = -_tinyNum;
      return this;
    };

    _proto.isActive = function isActive() {
      var parent = this.parent || this._dp,
          start = this._start,
          rawTime;
      return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };

    _proto.eventCallback = function eventCallback(type, callback, params) {
      var vars = this.vars;

      if (arguments.length > 1) {
        if (!callback) {
          delete vars[type];
        } else {
          vars[type] = callback;
          params && (vars[type + "Params"] = params);
          type === "onUpdate" && (this._onUpdate = callback);
        }

        return this;
      }

      return vars[type];
    };

    _proto.then = function then(onFulfilled) {
      var self = this;
      return new Promise(function (resolve) {
        var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough,
            _resolve = function _resolve() {
          var _then = self.then;
          self.then = null;
          _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
          resolve(f);
          self.then = _then;
        };

        if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) {
          _resolve();
        } else {
          self._prom = _resolve;
        }
      });
    };

    _proto.kill = function kill() {
      _interrupt(this);
    };

    return Animation;
  }();

  _setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
  });

  var Timeline = function (_Animation) {
    _inheritsLoose(Timeline, _Animation);

    function Timeline(vars, position) {
      var _this;

      if (vars === void 0) {
        vars = {};
      }

      _this = _Animation.call(this, vars) || this;
      _this.labels = {};
      _this.smoothChildTiming = !!vars.smoothChildTiming;
      _this.autoRemoveChildren = !!vars.autoRemoveChildren;
      _this._sort = _isNotFalse(vars.sortChildren);
      _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
      vars.reversed && _this.reverse();
      vars.paused && _this.paused(true);
      vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
      return _this;
    }

    var _proto2 = Timeline.prototype;

    _proto2.to = function to(targets, vars, position) {
      _createTweenType(0, arguments, this);

      return this;
    };

    _proto2.from = function from(targets, vars, position) {
      _createTweenType(1, arguments, this);

      return this;
    };

    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
      _createTweenType(2, arguments, this);

      return this;
    };

    _proto2.set = function set(targets, vars, position) {
      vars.duration = 0;
      vars.parent = this;
      _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
      vars.immediateRender = !!vars.immediateRender;
      new Tween(targets, vars, _parsePosition(this, position), 1);
      return this;
    };

    _proto2.call = function call(callback, params, position) {
      return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    };

    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
      vars.duration = duration;
      vars.stagger = vars.stagger || stagger;
      vars.onComplete = onCompleteAll;
      vars.onCompleteParams = onCompleteAllParams;
      vars.parent = this;
      new Tween(targets, vars, _parsePosition(this, position));
      return this;
    };

    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
      vars.runBackwards = 1;
      _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
      return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };

    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
      toVars.startAt = fromVars;
      _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
      return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };

    _proto2.render = function render(totalTime, suppressEvents, force) {
      var prevTime = this._time,
          tDur = this._dirty ? this.totalDuration() : this._tDur,
          dur = this._dur,
          tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime),
          crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur),
          time,
          child,
          next,
          iteration,
          cycleDuration,
          prevPaused,
          pauseTween,
          timeScale,
          prevStart,
          prevIteration,
          yoyo,
          isYoyo;
      this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);

      if (tTime !== this._tTime || force || crossingStart) {
        if (prevTime !== this._time && dur) {
          tTime += this._time - prevTime;
          totalTime += this._time - prevTime;
        }

        time = tTime;
        prevStart = this._start;
        timeScale = this._ts;
        prevPaused = !timeScale;

        if (crossingStart) {
          dur || (prevTime = this._zTime);
          (totalTime || !suppressEvents) && (this._zTime = totalTime);
        }

        if (this._repeat) {
          yoyo = this._yoyo;
          cycleDuration = dur + this._rDelay;

          if (this._repeat < -1 && totalTime < 0) {
            return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
          }

          time = _roundPrecise(tTime % cycleDuration);

          if (tTime === tDur) {
            iteration = this._repeat;
            time = dur;
          } else {
            iteration = ~~(tTime / cycleDuration);

            if (iteration && iteration === tTime / cycleDuration) {
              time = dur;
              iteration--;
            }

            time > dur && (time = dur);
          }

          prevIteration = _animationCycle(this._tTime, cycleDuration);
          !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration);

          if (yoyo && iteration & 1) {
            time = dur - time;
            isYoyo = 1;
          }

          if (iteration !== prevIteration && !this._lock) {
            var rewinding = yoyo && prevIteration & 1,
                doesWrap = rewinding === (yoyo && iteration & 1);
            iteration < prevIteration && (rewinding = !rewinding);
            prevTime = rewinding ? 0 : tTime % dur ? dur : tTime;
            this._lock = 1;
            this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
            this._tTime = tTime;
            !suppressEvents && this.parent && _callback(this, "onRepeat");
            this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);

            if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) {
              return this;
            }

            dur = this._dur;
            tDur = this._tDur;

            if (doesWrap) {
              this._lock = 2;
              prevTime = rewinding ? dur : -0.0001;
              this.render(prevTime, true);
              this.vars.repeatRefresh && !isYoyo && this.invalidate();
            }

            this._lock = 0;

            if (!this._ts && !prevPaused) {
              return this;
            }

            _propagateYoyoEase(this, isYoyo);
          }
        }

        if (this._hasPause && !this._forcing && this._lock < 2) {
          pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));

          if (pauseTween) {
            tTime -= time - (time = pauseTween._start);
          }
        }

        this._tTime = tTime;
        this._time = time;
        this._act = !timeScale;

        if (!this._initted) {
          this._onUpdate = this.vars.onUpdate;
          this._initted = 1;
          this._zTime = totalTime;
          prevTime = 0;
        }

        if (!prevTime && time && !suppressEvents && !iteration) {
          _callback(this, "onStart");

          if (this._tTime !== tTime) {
            return this;
          }
        }

        if (time >= prevTime && totalTime >= 0) {
          child = this._first;

          while (child) {
            next = child._next;

            if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
              if (child.parent !== this) {
                return this.render(totalTime, suppressEvents, force);
              }

              child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);

              if (time !== this._time || !this._ts && !prevPaused) {
                pauseTween = 0;
                next && (tTime += this._zTime = -_tinyNum);
                break;
              }
            }

            child = next;
          }
        } else {
          child = this._last;
          var adjustedTime = totalTime < 0 ? totalTime : time;

          while (child) {
            next = child._prev;

            if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
              if (child.parent !== this) {
                return this.render(totalTime, suppressEvents, force);
              }

              child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && (child._initted || child._startAt));

              if (time !== this._time || !this._ts && !prevPaused) {
                pauseTween = 0;
                next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum);
                break;
              }
            }

            child = next;
          }
        }

        if (pauseTween && !suppressEvents) {
          this.pause();
          pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;

          if (this._ts) {
            this._start = prevStart;

            _setEnd(this);

            return this.render(totalTime, suppressEvents, force);
          }
        }

        this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
        if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) if (!this._lock) {
          (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1);

          if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);

            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
          }
        }
      }

      return this;
    };

    _proto2.add = function add(child, position) {
      var _this2 = this;

      _isNumber(position) || (position = _parsePosition(this, position, child));

      if (!(child instanceof Animation)) {
        if (_isArray(child)) {
          child.forEach(function (obj) {
            return _this2.add(obj, position);
          });
          return this;
        }

        if (_isString(child)) {
          return this.addLabel(child, position);
        }

        if (_isFunction(child)) {
          child = Tween.delayedCall(0, child);
        } else {
          return this;
        }
      }

      return this !== child ? _addToTimeline(this, child, position) : this;
    };

    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
      if (nested === void 0) {
        nested = true;
      }

      if (tweens === void 0) {
        tweens = true;
      }

      if (timelines === void 0) {
        timelines = true;
      }

      if (ignoreBeforeTime === void 0) {
        ignoreBeforeTime = -_bigNum;
      }

      var a = [],
          child = this._first;

      while (child) {
        if (child._start >= ignoreBeforeTime) {
          if (child instanceof Tween) {
            tweens && a.push(child);
          } else {
            timelines && a.push(child);
            nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
          }
        }

        child = child._next;
      }

      return a;
    };

    _proto2.getById = function getById(id) {
      var animations = this.getChildren(1, 1, 1),
          i = animations.length;

      while (i--) {
        if (animations[i].vars.id === id) {
          return animations[i];
        }
      }
    };

    _proto2.remove = function remove(child) {
      if (_isString(child)) {
        return this.removeLabel(child);
      }

      if (_isFunction(child)) {
        return this.killTweensOf(child);
      }

      _removeLinkedListItem(this, child);

      if (child === this._recent) {
        this._recent = this._last;
      }

      return _uncache(this);
    };

    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
      if (!arguments.length) {
        return this._tTime;
      }

      this._forcing = 1;

      if (!this._dp && this._ts) {
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
      }

      _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);

      this._forcing = 0;
      return this;
    };

    _proto2.addLabel = function addLabel(label, position) {
      this.labels[label] = _parsePosition(this, position);
      return this;
    };

    _proto2.removeLabel = function removeLabel(label) {
      delete this.labels[label];
      return this;
    };

    _proto2.addPause = function addPause(position, callback, params) {
      var t = Tween.delayedCall(0, callback || _emptyFunc, params);
      t.data = "isPause";
      this._hasPause = 1;
      return _addToTimeline(this, t, _parsePosition(this, position));
    };

    _proto2.removePause = function removePause(position) {
      var child = this._first;
      position = _parsePosition(this, position);

      while (child) {
        if (child._start === position && child.data === "isPause") {
          _removeFromParent(child);
        }

        child = child._next;
      }
    };

    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
      var tweens = this.getTweensOf(targets, onlyActive),
          i = tweens.length;

      while (i--) {
        _overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
      }

      return this;
    };

    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
      var a = [],
          parsedTargets = toArray(targets),
          child = this._first,
          isGlobalTime = _isNumber(onlyActive),
          children;

      while (child) {
        if (child instanceof Tween) {
          if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) {
            a.push(child);
          }
        } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) {
          a.push.apply(a, children);
        }

        child = child._next;
      }

      return a;
    };

    _proto2.tweenTo = function tweenTo(position, vars) {
      vars = vars || {};

      var tl = this,
          endTime = _parsePosition(tl, position),
          _vars = vars,
          startAt = _vars.startAt,
          _onStart = _vars.onStart,
          onStartParams = _vars.onStartParams,
          immediateRender = _vars.immediateRender,
          initted,
          tween = Tween.to(tl, _setDefaults({
        ease: vars.ease || "none",
        lazy: false,
        immediateRender: false,
        time: endTime,
        overwrite: "auto",
        duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
        onStart: function onStart() {
          tl.pause();

          if (!initted) {
            var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
            tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
            initted = 1;
          }

          _onStart && _onStart.apply(tween, onStartParams || []);
        }
      }, vars));

      return immediateRender ? tween.render(0) : tween;
    };

    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
      return this.tweenTo(toPosition, _setDefaults({
        startAt: {
          time: _parsePosition(this, fromPosition)
        }
      }, vars));
    };

    _proto2.recent = function recent() {
      return this._recent;
    };

    _proto2.nextLabel = function nextLabel(afterTime) {
      if (afterTime === void 0) {
        afterTime = this._time;
      }

      return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };

    _proto2.previousLabel = function previousLabel(beforeTime) {
      if (beforeTime === void 0) {
        beforeTime = this._time;
      }

      return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };

    _proto2.currentLabel = function currentLabel(value) {
      return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };

    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
      if (ignoreBeforeTime === void 0) {
        ignoreBeforeTime = 0;
      }

      var child = this._first,
          labels = this.labels,
          p;

      while (child) {
        if (child._start >= ignoreBeforeTime) {
          child._start += amount;
          child._end += amount;
        }

        child = child._next;
      }

      if (adjustLabels) {
        for (p in labels) {
          if (labels[p] >= ignoreBeforeTime) {
            labels[p] += amount;
          }
        }
      }

      return _uncache(this);
    };

    _proto2.invalidate = function invalidate(soft) {
      var child = this._first;
      this._lock = 0;

      while (child) {
        child.invalidate(soft);
        child = child._next;
      }

      return _Animation.prototype.invalidate.call(this, soft);
    };

    _proto2.clear = function clear(includeLabels) {
      if (includeLabels === void 0) {
        includeLabels = true;
      }

      var child = this._first,
          next;

      while (child) {
        next = child._next;
        this.remove(child);
        child = next;
      }

      this._dp && (this._time = this._tTime = this._pTime = 0);
      includeLabels && (this.labels = {});
      return _uncache(this);
    };

    _proto2.totalDuration = function totalDuration(value) {
      var max = 0,
          self = this,
          child = self._last,
          prevStart = _bigNum,
          prev,
          start,
          parent;

      if (arguments.length) {
        return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
      }

      if (self._dirty) {
        parent = self.parent;

        while (child) {
          prev = child._prev;
          child._dirty && child.totalDuration();
          start = child._start;

          if (start > prevStart && self._sort && child._ts && !self._lock) {
            self._lock = 1;
            _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
          } else {
            prevStart = start;
          }

          if (start < 0 && child._ts) {
            max -= start;

            if (!parent && !self._dp || parent && parent.smoothChildTiming) {
              self._start += start / self._ts;
              self._time -= start;
              self._tTime -= start;
            }

            self.shiftChildren(-start, false, -1e999);
            prevStart = 0;
          }

          child._end > max && child._ts && (max = child._end);
          child = prev;
        }

        _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);

        self._dirty = 0;
      }

      return self._tDur;
    };

    Timeline.updateRoot = function updateRoot(time) {
      if (_globalTimeline._ts) {
        _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));

        _lastRenderedFrame = _ticker.frame;
      }

      if (_ticker.frame >= _nextGCFrame) {
        _nextGCFrame += _config.autoSleep || 120;
        var child = _globalTimeline._first;
        if (!child || !child._ts) if (_config.autoSleep && _ticker._listeners.length < 2) {
          while (child && !child._ts) {
            child = child._next;
          }

          child || _ticker.sleep();
        }
      }
    };

    return Timeline;
  }(Animation);

  _setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
  });

  var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter),
        index = 0,
        matchIndex = 0,
        result,
        startNums,
        color,
        endNum,
        chunk,
        startNum,
        hasRandom,
        a;
    pt.b = start;
    pt.e = end;
    start += "";
    end += "";

    if (hasRandom = ~end.indexOf("random(")) {
      end = _replaceRandom(end);
    }

    if (stringFilter) {
      a = [start, end];
      stringFilter(a, target, prop);
      start = a[0];
      end = a[1];
    }

    startNums = start.match(_complexStringNumExp) || [];

    while (result = _complexStringNumExp.exec(end)) {
      endNum = result[0];
      chunk = end.substring(index, result.index);

      if (color) {
        color = (color + 1) % 5;
      } else if (chunk.substr(-5) === "rgba(") {
        color = 1;
      }

      if (endNum !== startNums[matchIndex++]) {
        startNum = parseFloat(startNums[matchIndex - 1]) || 0;
        pt._pt = {
          _next: pt._pt,
          p: chunk || matchIndex === 1 ? chunk : ",",
          s: startNum,
          c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
          m: color && color < 4 ? Math.round : 0
        };
        index = _complexStringNumExp.lastIndex;
      }
    }

    pt.c = index < end.length ? end.substring(index, end.length) : "";
    pt.fp = funcParam;

    if (_relExp.test(end) || hasRandom) {
      pt.e = 0;
    }

    this._pt = pt;
    return pt;
  },
      _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop],
        parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](),
        setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc,
        pt;

    if (_isString(end)) {
      if (~end.indexOf("random(")) {
        end = _replaceRandom(end);
      }

      if (end.charAt(1) === "=") {
        pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);

        if (pt || pt === 0) {
          end = pt;
        }
      }
    }

    if (!optional || parsedStart !== end || _forceAllPropTweens) {
      if (!isNaN(parsedStart * end) && end !== "") {
        pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
        funcParam && (pt.fp = funcParam);
        modifier && pt.modifier(modifier, this, target);
        return this._pt = pt;
      }

      !currentValue && !(prop in target) && _missingPlugin(prop, end);
      return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
  },
      _processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));

    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) {
      return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    }

    var copy = {},
        p;

    for (p in vars) {
      copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    }

    return copy;
  },
      _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;

    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
      tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);

      if (tween !== _quickTween) {
        ptLookup = tween._ptLookup[tween._targets.indexOf(target)];
        i = plugin._props.length;

        while (i--) {
          ptLookup[plugin._props[i]] = pt;
        }
      }
    }

    return plugin;
  },
      _overwritingTween,
      _forceAllPropTweens,
      _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars,
        ease = vars.ease,
        startAt = vars.startAt,
        immediateRender = vars.immediateRender,
        lazy = vars.lazy,
        onUpdate = vars.onUpdate,
        runBackwards = vars.runBackwards,
        yoyoEase = vars.yoyoEase,
        keyframes = vars.keyframes,
        autoRevert = vars.autoRevert,
        dur = tween._dur,
        prevStartAt = tween._startAt,
        targets = tween._targets,
        parent = tween.parent,
        fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets,
        autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites,
        tl = tween.timeline,
        cleanVars,
        i,
        p,
        pt,
        target,
        hasPriority,
        gsData,
        harness,
        plugin,
        ptLookup,
        index,
        harnessVars,
        overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;

    if (yoyoEase && tween._yoyo && !tween._repeat) {
      yoyoEase = tween._yEase;
      tween._yEase = tween._ease;
      tween._ease = yoyoEase;
    }

    tween._from = !tl && !!vars.runBackwards;

    if (!tl || keyframes && !vars.stagger) {
      harness = targets[0] ? _getCache(targets[0]).harness : 0;
      harnessVars = harness && vars[harness.prop];
      cleanVars = _copyExcluding(vars, _reservedProps);

      if (prevStartAt) {
        prevStartAt._zTime < 0 && prevStartAt.progress(1);
        time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig);
        prevStartAt._lazy = 0;
      }

      if (startAt) {
        _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
          data: "isStart",
          overwrite: false,
          parent: parent,
          immediateRender: true,
          lazy: !prevStartAt && _isNotFalse(lazy),
          startAt: null,
          delay: 0,
          onUpdate: onUpdate && function () {
            return _callback(tween, "onUpdate");
          },
          stagger: 0
        }, startAt)));

        tween._startAt._dp = 0;
        tween._startAt._sat = tween;
        time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill);

        if (immediateRender) {
          if (dur && time <= 0 && tTime <= 0) {
            time && (tween._zTime = time);
            return;
          }
        }
      } else if (runBackwards && dur) {
        if (!prevStartAt) {
          time && (immediateRender = false);
          p = _setDefaults({
            overwrite: false,
            data: "isFromStart",
            lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
            immediateRender: immediateRender,
            stagger: 0,
            parent: parent
          }, cleanVars);
          harnessVars && (p[harness.prop] = harnessVars);

          _removeFromParent(tween._startAt = Tween.set(targets, p));

          tween._startAt._dp = 0;
          tween._startAt._sat = tween;
          time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
          tween._zTime = time;

          if (!immediateRender) {
            _initTween(tween._startAt, _tinyNum, _tinyNum);
          } else if (!time) {
            return;
          }
        }
      }

      tween._pt = tween._ptCache = 0;
      lazy = dur && _isNotFalse(lazy) || lazy && !dur;

      for (i = 0; i < targets.length; i++) {
        target = targets[i];
        gsData = target._gsap || _harness(targets)[i]._gsap;
        tween._ptLookup[i] = ptLookup = {};
        _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender();
        index = fullTargets === targets ? i : fullTargets.indexOf(target);

        if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
          tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);

          plugin._props.forEach(function (name) {
            ptLookup[name] = pt;
          });

          plugin.priority && (hasPriority = 1);
        }

        if (!harness || harnessVars) {
          for (p in cleanVars) {
            if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) {
              plugin.priority && (hasPriority = 1);
            } else {
              ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
          }
        }

        tween._op && tween._op[i] && tween.kill(target, tween._op[i]);

        if (autoOverwrite && tween._pt) {
          _overwritingTween = tween;

          _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time));

          overwritten = !tween.parent;
          _overwritingTween = 0;
        }

        tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
      }

      hasPriority && _sortPropTweensByPriority(tween);
      tween._onInit && tween._onInit(tween);
    }

    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten;
    keyframes && time <= 0 && tl.render(_bigNum, true, true);
  },
      _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property],
        pt,
        rootPT,
        lookup,
        i;

    if (!ptCache) {
      ptCache = tween._ptCache[property] = [];
      lookup = tween._ptLookup;
      i = tween._targets.length;

      while (i--) {
        pt = lookup[i][property];

        if (pt && pt.d && pt.d._pt) {
          pt = pt.d._pt;

          while (pt && pt.p !== property && pt.fp !== property) {
            pt = pt._next;
          }
        }

        if (!pt) {
          _forceAllPropTweens = 1;
          tween.vars[property] = "+=0";

          _initTween(tween, time);

          _forceAllPropTweens = 0;
          return skipRecursion ? _warn(property + " not eligible for reset") : 1;
        }

        ptCache.push(pt);
      }
    }

    i = ptCache.length;

    while (i--) {
      rootPT = ptCache[i];
      pt = rootPT._pt || rootPT;
      pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
      pt.c = value - pt.s;
      rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e));
      rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b));
    }
  },
      _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0,
        propertyAliases = harness && harness.aliases,
        copy,
        p,
        i,
        aliases;

    if (!propertyAliases) {
      return vars;
    }

    copy = _merge({}, vars);

    for (p in propertyAliases) {
      if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;

        while (i--) {
          copy[aliases[i]] = copy[p];
        }
      }
    }

    return copy;
  },
      _parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut",
        p,
        a;

    if (_isArray(obj)) {
      a = allProps[prop] || (allProps[prop] = []);
      obj.forEach(function (value, i) {
        return a.push({
          t: i / (obj.length - 1) * 100,
          v: value,
          e: ease
        });
      });
    } else {
      for (p in obj) {
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
          t: parseFloat(prop),
          v: obj[p],
          e: ease
        });
      }
    }
  },
      _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
  },
      _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert",
      _staggerPropsToSkip = {};

  _forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function (name) {
    return _staggerPropsToSkip[name] = 1;
  });

  var Tween = function (_Animation2) {
    _inheritsLoose(Tween, _Animation2);

    function Tween(targets, vars, position, skipInherit) {
      var _this3;

      if (typeof vars === "number") {
        position.duration = vars;
        vars = position;
        position = null;
      }

      _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
      var _this3$vars = _this3.vars,
          duration = _this3$vars.duration,
          delay = _this3$vars.delay,
          immediateRender = _this3$vars.immediateRender,
          stagger = _this3$vars.stagger,
          overwrite = _this3$vars.overwrite,
          keyframes = _this3$vars.keyframes,
          defaults = _this3$vars.defaults,
          scrollTrigger = _this3$vars.scrollTrigger,
          yoyoEase = _this3$vars.yoyoEase,
          parent = vars.parent || _globalTimeline,
          parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [targets] : toArray(targets),
          tl,
          i,
          copy,
          l,
          p,
          curTarget,
          staggerFunc,
          staggerVarsToMerge;
      _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
      _this3._ptLookup = [];
      _this3._overwrite = overwrite;

      if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
        vars = _this3.vars;
        tl = _this3.timeline = new Timeline({
          data: "nested",
          defaults: defaults || {},
          targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
        });
        tl.kill();
        tl.parent = tl._dp = _assertThisInitialized(_this3);
        tl._start = 0;

        if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
          l = parsedTargets.length;
          staggerFunc = stagger && distribute(stagger);

          if (_isObject(stagger)) {
            for (p in stagger) {
              if (~_staggerTweenProps.indexOf(p)) {
                staggerVarsToMerge || (staggerVarsToMerge = {});
                staggerVarsToMerge[p] = stagger[p];
              }
            }
          }

          for (i = 0; i < l; i++) {
            copy = _copyExcluding(vars, _staggerPropsToSkip);
            copy.stagger = 0;
            yoyoEase && (copy.yoyoEase = yoyoEase);
            staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
            curTarget = parsedTargets[i];
            copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
            copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;

            if (!stagger && l === 1 && copy.delay) {
              _this3._delay = delay = copy.delay;
              _this3._start += delay;
              copy.delay = 0;
            }

            tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
            tl._ease = _easeMap.none;
          }

          tl.duration() ? duration = delay = 0 : _this3.timeline = 0;
        } else if (keyframes) {
          _inheritDefaults(_setDefaults(tl.vars.defaults, {
            ease: "none"
          }));

          tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
          var time = 0,
              a,
              kf,
              v;

          if (_isArray(keyframes)) {
            keyframes.forEach(function (frame) {
              return tl.to(parsedTargets, frame, ">");
            });
            tl.duration();
          } else {
            copy = {};

            for (p in keyframes) {
              p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
            }

            for (p in copy) {
              a = copy[p].sort(function (a, b) {
                return a.t - b.t;
              });
              time = 0;

              for (i = 0; i < a.length; i++) {
                kf = a[i];
                v = {
                  ease: kf.e,
                  duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                };
                v[p] = kf.v;
                tl.to(parsedTargets, v, time);
                time += v.duration;
              }
            }

            tl.duration() < duration && tl.to({}, {
              duration: duration - tl.duration()
            });
          }
        }

        duration || _this3.duration(duration = tl.duration());
      } else {
        _this3.timeline = 0;
      }

      if (overwrite === true && !_suppressOverwrites) {
        _overwritingTween = _assertThisInitialized(_this3);

        _globalTimeline.killTweensOf(parsedTargets);

        _overwritingTween = 0;
      }

      _addToTimeline(parent, _assertThisInitialized(_this3), position);

      vars.reversed && _this3.reverse();
      vars.paused && _this3.paused(true);

      if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
        _this3._tTime = -_tinyNum;

        _this3.render(Math.max(0, -delay) || 0);
      }

      scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
      return _this3;
    }

    var _proto3 = Tween.prototype;

    _proto3.render = function render(totalTime, suppressEvents, force) {
      var prevTime = this._time,
          tDur = this._tDur,
          dur = this._dur,
          isNegative = totalTime < 0,
          tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime,
          time,
          pt,
          iteration,
          cycleDuration,
          prevIteration,
          isYoyo,
          ratio,
          timeline,
          yoyoEase;

      if (!dur) {
        _renderZeroDurationTween(this, totalTime, suppressEvents, force);
      } else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative) {
        time = tTime;
        timeline = this.timeline;

        if (this._repeat) {
          cycleDuration = dur + this._rDelay;

          if (this._repeat < -1 && isNegative) {
            return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
          }

          time = _roundPrecise(tTime % cycleDuration);

          if (tTime === tDur) {
            iteration = this._repeat;
            time = dur;
          } else {
            iteration = ~~(tTime / cycleDuration);

            if (iteration && iteration === _roundPrecise(tTime / cycleDuration)) {
              time = dur;
              iteration--;
            }

            time > dur && (time = dur);
          }

          isYoyo = this._yoyo && iteration & 1;

          if (isYoyo) {
            yoyoEase = this._yEase;
            time = dur - time;
          }

          prevIteration = _animationCycle(this._tTime, cycleDuration);

          if (time === prevTime && !force && this._initted && iteration === prevIteration) {
            this._tTime = tTime;
            return this;
          }

          if (iteration !== prevIteration) {
            timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo);

            if (this.vars.repeatRefresh && !isYoyo && !this._lock && this._time !== cycleDuration && this._initted) {
              this._lock = force = 1;
              this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
            }
          }
        }

        if (!this._initted) {
          if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
            this._tTime = 0;
            return this;
          }

          if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) {
            return this;
          }

          if (dur !== this._dur) {
            return this.render(totalTime, suppressEvents, force);
          }
        }

        this._tTime = tTime;
        this._time = time;

        if (!this._act && this._ts) {
          this._act = 1;
          this._lazy = 0;
        }

        this.ratio = ratio = (yoyoEase || this._ease)(time / dur);

        if (this._from) {
          this.ratio = ratio = 1 - ratio;
        }

        if (time && !prevTime && !suppressEvents && !iteration) {
          _callback(this, "onStart");

          if (this._tTime !== tTime) {
            return this;
          }
        }

        pt = this._pt;

        while (pt) {
          pt.r(ratio, pt.d);
          pt = pt._next;
        }

        timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);

        if (this._onUpdate && !suppressEvents) {
          isNegative && _rewindStartAt(this, totalTime, suppressEvents, force);

          _callback(this, "onUpdate");
        }

        this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");

        if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
          isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
          (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1);

          if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
            _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);

            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
          }
        }
      }

      return this;
    };

    _proto3.targets = function targets() {
      return this._targets;
    };

    _proto3.invalidate = function invalidate(soft) {
      (!soft || !this.vars.runBackwards) && (this._startAt = 0);
      this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
      this._ptLookup = [];
      this.timeline && this.timeline.invalidate(soft);
      return _Animation2.prototype.invalidate.call(this, soft);
    };

    _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
      _tickerActive || _ticker.wake();
      this._ts || this.play();
      var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts),
          ratio;
      this._initted || _initTween(this, time);
      ratio = this._ease(time / this._dur);

      if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) {
        return this.resetTo(property, value, start, startIsRelative, 1);
      }

      _alignPlayhead(this, 0);

      this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
      return this.render(0);
    };

    _proto3.kill = function kill(targets, vars) {
      if (vars === void 0) {
        vars = "all";
      }

      if (!targets && (!vars || vars === "all")) {
        this._lazy = this._pt = 0;
        return this.parent ? _interrupt(this) : this;
      }

      if (this.timeline) {
        var tDur = this.timeline.totalDuration();
        this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this);
        this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1);
        return this;
      }

      var parsedTargets = this._targets,
          killingTargets = targets ? toArray(targets) : parsedTargets,
          propTweenLookup = this._ptLookup,
          firstPT = this._pt,
          overwrittenProps,
          curLookup,
          curOverwriteProps,
          props,
          p,
          pt,
          i;

      if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
        vars === "all" && (this._pt = 0);
        return _interrupt(this);
      }

      overwrittenProps = this._op = this._op || [];

      if (vars !== "all") {
        if (_isString(vars)) {
          p = {};

          _forEachName(vars, function (name) {
            return p[name] = 1;
          });

          vars = p;
        }

        vars = _addAliasesToVars(parsedTargets, vars);
      }

      i = parsedTargets.length;

      while (i--) {
        if (~killingTargets.indexOf(parsedTargets[i])) {
          curLookup = propTweenLookup[i];

          if (vars === "all") {
            overwrittenProps[i] = vars;
            props = curLookup;
            curOverwriteProps = {};
          } else {
            curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
            props = vars;
          }

          for (p in props) {
            pt = curLookup && curLookup[p];

            if (pt) {
              if (!("kill" in pt.d) || pt.d.kill(p) === true) {
                _removeLinkedListItem(this, pt, "_pt");
              }

              delete curLookup[p];
            }

            if (curOverwriteProps !== "all") {
              curOverwriteProps[p] = 1;
            }
          }
        }
      }

      this._initted && !this._pt && firstPT && _interrupt(this);
      return this;
    };

    Tween.to = function to(targets, vars) {
      return new Tween(targets, vars, arguments[2]);
    };

    Tween.from = function from(targets, vars) {
      return _createTweenType(1, arguments);
    };

    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
      return new Tween(callback, 0, {
        immediateRender: false,
        lazy: false,
        overwrite: false,
        delay: delay,
        onComplete: callback,
        onReverseComplete: callback,
        onCompleteParams: params,
        onReverseCompleteParams: params,
        callbackScope: scope
      });
    };

    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
      return _createTweenType(2, arguments);
    };

    Tween.set = function set(targets, vars) {
      vars.duration = 0;
      vars.repeatDelay || (vars.repeat = 0);
      return new Tween(targets, vars);
    };

    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
      return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };

    return Tween;
  }(Animation);

  _setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
  });

  _forEachName("staggerTo,staggerFrom,staggerFromTo", function (name) {
    Tween[name] = function () {
      var tl = new Timeline(),
          params = _slice.call(arguments, 0);

      params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
      return tl[name].apply(tl, params);
    };
  });

  var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
  },
      _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
  },
      _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
  },
      _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
  },
      _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
  },
      _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
  },
      _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
  },
      _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt,
        s = "";

    if (!ratio && data.b) {
      s = data.b;
    } else if (ratio === 1 && data.e) {
      s = data.e;
    } else {
      while (pt) {
        s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s;
        pt = pt._next;
      }

      s += data.c;
    }

    data.set(data.t, data.p, s, data);
  },
      _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;

    while (pt) {
      pt.r(ratio, pt.d);
      pt = pt._next;
    }
  },
      _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt,
        next;

    while (pt) {
      next = pt._next;
      pt.p === property && pt.modifier(modifier, tween, target);
      pt = next;
    }
  },
      _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt,
        hasNonDependentRemaining,
        next;

    while (pt) {
      next = pt._next;

      if (pt.p === property && !pt.op || pt.op === property) {
        _removeLinkedListItem(this, pt, "_pt");
      } else if (!pt.dep) {
        hasNonDependentRemaining = 1;
      }

      pt = next;
    }

    return !hasNonDependentRemaining;
  },
      _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
  },
      _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt,
        next,
        pt2,
        first,
        last;

    while (pt) {
      next = pt._next;
      pt2 = first;

      while (pt2 && pt2.pr > pt.pr) {
        pt2 = pt2._next;
      }

      if (pt._prev = pt2 ? pt2._prev : last) {
        pt._prev._next = pt;
      } else {
        first = pt;
      }

      if (pt._next = pt2) {
        pt2._prev = pt;
      } else {
        last = pt;
      }

      pt = next;
    }

    parent._pt = first;
  };

  var PropTween = function () {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
      this.t = target;
      this.s = start;
      this.c = change;
      this.p = prop;
      this.r = renderer || _renderPlain;
      this.d = data || this;
      this.set = setter || _setterPlain;
      this.pr = priority || 0;
      this._next = next;

      if (next) {
        next._prev = this;
      }
    }

    var _proto4 = PropTween.prototype;

    _proto4.modifier = function modifier(func, tween, target) {
      this.mSet = this.mSet || this.set;
      this.set = _setterWithModifier;
      this.m = func;
      this.mt = target;
      this.tween = tween;
    };

    return PropTween;
  }();

  _forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function (name) {
    return _reservedProps[name] = 1;
  });

  _globals.TweenMax = _globals.TweenLite = Tween;
  _globals.TimelineLite = _globals.TimelineMax = Timeline;
  _globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
  });
  _config.stringFilter = _colorStringFilter;

  var _media = [],
      _listeners = {},
      _emptyArray = [],
      _lastMediaTime = 0,
      _contextID = 0,
      _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function (f) {
      return f();
    });
  },
      _onMediaChange = function _onMediaChange() {
    var time = Date.now(),
        matches = [];

    if (time - _lastMediaTime > 2) {
      _dispatch("matchMediaInit");

      _media.forEach(function (c) {
        var queries = c.queries,
            conditions = c.conditions,
            match,
            p,
            anyMatch,
            toggled;

        for (p in queries) {
          match = _win.matchMedia(queries[p]).matches;
          match && (anyMatch = 1);

          if (match !== conditions[p]) {
            conditions[p] = match;
            toggled = 1;
          }
        }

        if (toggled) {
          c.revert();
          anyMatch && matches.push(c);
        }
      });

      _dispatch("matchMediaRevert");

      matches.forEach(function (c) {
        return c.onMatch(c, function (func) {
          return c.add(null, func);
        });
      });
      _lastMediaTime = time;

      _dispatch("matchMedia");
    }
  };

  var Context = function () {
    function Context(func, scope) {
      this.selector = scope && selector(scope);
      this.data = [];
      this._r = [];
      this.isReverted = false;
      this.id = _contextID++;
      func && this.add(func);
    }

    var _proto5 = Context.prototype;

    _proto5.add = function add(name, func, scope) {
      if (_isFunction(name)) {
        scope = func;
        func = name;
        name = _isFunction;
      }

      var self = this,
          f = function f() {
        var prev = _context,
            prevSelector = self.selector,
            result;
        prev && prev !== self && prev.data.push(self);
        scope && (self.selector = selector(scope));
        _context = self;
        result = func.apply(self, arguments);
        _isFunction(result) && self._r.push(result);
        _context = prev;
        self.selector = prevSelector;
        self.isReverted = false;
        return result;
      };

      self.last = f;
      return name === _isFunction ? f(self, function (func) {
        return self.add(null, func);
      }) : name ? self[name] = f : f;
    };

    _proto5.ignore = function ignore(func) {
      var prev = _context;
      _context = null;
      func(this);
      _context = prev;
    };

    _proto5.getTweens = function getTweens() {
      var a = [];
      this.data.forEach(function (e) {
        return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
      });
      return a;
    };

    _proto5.clear = function clear() {
      this._r.length = this.data.length = 0;
    };

    _proto5.kill = function kill(revert, matchMedia) {
      var _this4 = this;

      if (revert) {
        (function () {
          var tweens = _this4.getTweens(),
              i = _this4.data.length,
              t;

          while (i--) {
            t = _this4.data[i];

            if (t.data === "isFlip") {
              t.revert();
              t.getChildren(true, true, false).forEach(function (tween) {
                return tweens.splice(tweens.indexOf(tween), 1);
              });
            }
          }

          tweens.map(function (t) {
            return {
              g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
              t: t
            };
          }).sort(function (a, b) {
            return b.g - a.g || -Infinity;
          }).forEach(function (o) {
            return o.t.revert(revert);
          });
          i = _this4.data.length;

          while (i--) {
            t = _this4.data[i];

            if (t instanceof Timeline) {
              if (t.data !== "nested") {
                t.scrollTrigger && t.scrollTrigger.revert();
                t.kill();
              }
            } else {
              !(t instanceof Tween) && t.revert && t.revert(revert);
            }
          }

          _this4._r.forEach(function (f) {
            return f(revert, _this4);
          });

          _this4.isReverted = true;
        })();
      } else {
        this.data.forEach(function (e) {
          return e.kill && e.kill();
        });
      }

      this.clear();

      if (matchMedia) {
        var i = _media.length;

        while (i--) {
          _media[i].id === this.id && _media.splice(i, 1);
        }
      }
    };

    _proto5.revert = function revert(config) {
      this.kill(config || {});
    };

    return Context;
  }();

  var MatchMedia = function () {
    function MatchMedia(scope) {
      this.contexts = [];
      this.scope = scope;
      _context && _context.data.push(this);
    }

    var _proto6 = MatchMedia.prototype;

    _proto6.add = function add(conditions, func, scope) {
      _isObject(conditions) || (conditions = {
        matches: conditions
      });
      var context = new Context(0, scope || this.scope),
          cond = context.conditions = {},
          mq,
          p,
          active;
      _context && !context.selector && (context.selector = _context.selector);
      this.contexts.push(context);
      func = context.add("onMatch", func);
      context.queries = conditions;

      for (p in conditions) {
        if (p === "all") {
          active = 1;
        } else {
          mq = _win.matchMedia(conditions[p]);

          if (mq) {
            _media.indexOf(context) < 0 && _media.push(context);
            (cond[p] = mq.matches) && (active = 1);
            mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
          }
        }
      }

      active && func(context, function (f) {
        return context.add(null, f);
      });
      return this;
    };

    _proto6.revert = function revert(config) {
      this.kill(config || {});
    };

    _proto6.kill = function kill(revert) {
      this.contexts.forEach(function (c) {
        return c.kill(revert, true);
      });
    };

    return MatchMedia;
  }();

  var _gsap = {
    registerPlugin: function registerPlugin() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      args.forEach(function (config) {
        return _createPlugin(config);
      });
    },
    timeline: function timeline(vars) {
      return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
      return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
      _isString(target) && (target = toArray(target)[0]);

      var getter = _getCache(target || {}).get,
          format = unit ? _passThrough : _numericIfPossible;

      unit === "native" && (unit = "");
      return !target ? target : !property ? function (property, unit, uncache) {
        return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
      } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
      target = toArray(target);

      if (target.length > 1) {
        var setters = target.map(function (t) {
          return gsap.quickSetter(t, property, unit);
        }),
            l = setters.length;
        return function (value) {
          var i = l;

          while (i--) {
            setters[i](value);
          }
        };
      }

      target = target[0] || {};

      var Plugin = _plugins[property],
          cache = _getCache(target),
          p = cache.harness && (cache.harness.aliases || {})[property] || property,
          setter = Plugin ? function (value) {
        var p = new Plugin();
        _quickTween._pt = 0;
        p.init(target, unit ? value + unit : value, _quickTween, 0, [target]);
        p.render(1, p);
        _quickTween._pt && _renderPropTweens(1, _quickTween);
      } : cache.set(target, p);

      return Plugin ? setter : function (value) {
        return setter(target, p, unit ? value + unit : value, cache, 1);
      };
    },
    quickTo: function quickTo(target, property, vars) {
      var _merge2;

      var tween = gsap.to(target, _merge((_merge2 = {}, _merge2[property] = "+=0.1", _merge2.paused = true, _merge2), vars || {})),
          func = function func(value, start, startIsRelative) {
        return tween.resetTo(property, value, start, startIsRelative);
      };

      func.tween = tween;
      return func;
    },
    isTweening: function isTweening(targets) {
      return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
      value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
      return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
      return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
      var name = _ref3.name,
          effect = _ref3.effect,
          plugins = _ref3.plugins,
          defaults = _ref3.defaults,
          extendTimeline = _ref3.extendTimeline;
      (plugins || "").split(",").forEach(function (pluginName) {
        return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
      });

      _effects[name] = function (targets, vars, tl) {
        return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
      };

      if (extendTimeline) {
        Timeline.prototype[name] = function (targets, vars, position) {
          return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
      }
    },
    registerEase: function registerEase(name, ease) {
      _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
      return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
      return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
      if (vars === void 0) {
        vars = {};
      }

      var tl = new Timeline(vars),
          child,
          next;
      tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);

      _globalTimeline.remove(tl);

      tl._dp = 0;
      tl._time = tl._tTime = _globalTimeline._time;
      child = _globalTimeline._first;

      while (child) {
        next = child._next;

        if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) {
          _addToTimeline(tl, child, child._start - child._delay);
        }

        child = next;
      }

      _addToTimeline(_globalTimeline, tl, 0);

      return tl;
    },
    context: function context(func, scope) {
      return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
      return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
      return _media.forEach(function (c) {
        var cond = c.conditions,
            found,
            p;

        for (p in cond) {
          if (cond[p]) {
            cond[p] = false;
            found = 1;
          }
        }

        found && c.revert();
      }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
      var a = _listeners[type] || (_listeners[type] = []);
      ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
      var a = _listeners[type],
          i = a && a.indexOf(callback);
      i >= 0 && a.splice(i, 1);
    },
    utils: {
      wrap: wrap,
      wrapYoyo: wrapYoyo,
      distribute: distribute,
      random: random,
      snap: snap,
      normalize: normalize,
      getUnit: getUnit,
      clamp: clamp,
      splitColor: splitColor,
      toArray: toArray,
      selector: selector,
      mapRange: mapRange,
      pipe: pipe,
      unitize: unitize,
      interpolate: interpolate,
      shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
      PropTween: PropTween,
      globals: _addGlobal,
      Tween: Tween,
      Timeline: Timeline,
      Animation: Animation,
      getCache: _getCache,
      _removeLinkedListItem: _removeLinkedListItem,
      reverting: function reverting() {
        return _reverting;
      },
      context: function context(toAdd) {
        if (toAdd && _context) {
          _context.data.push(toAdd);

          toAdd._ctx = _context;
        }

        return _context;
      },
      suppressOverwrites: function suppressOverwrites(value) {
        return _suppressOverwrites = value;
      }
    }
  };

  _forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function (name) {
    return _gsap[name] = Tween[name];
  });

  _ticker.add(Timeline.updateRoot);

  _quickTween = _gsap.to({}, {
    duration: 0
  });

  var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;

    while (pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop) {
      pt = pt._next;
    }

    return pt;
  },
      _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets,
        p,
        i,
        pt;

    for (p in modifiers) {
      i = targets.length;

      while (i--) {
        pt = tween._ptLookup[i][p];

        if (pt && (pt = pt.d)) {
          if (pt._pt) {
            pt = _getPluginPropTween(pt, p);
          }

          pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
        }
      }
    }
  },
      _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
      name: name,
      rawVars: 1,
      init: function init(target, vars, tween) {
        tween._onInit = function (tween) {
          var temp, p;

          if (_isString(vars)) {
            temp = {};

            _forEachName(vars, function (name) {
              return temp[name] = 1;
            });

            vars = temp;
          }

          if (modifier) {
            temp = {};

            for (p in vars) {
              temp[p] = modifier(vars[p]);
            }

            vars = temp;
          }

          _addModifiers(tween, vars);
        };
      }
    };
  };

  var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
      var p, pt, v;
      this.tween = tween;

      for (p in vars) {
        v = target.getAttribute(p) || "";
        pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
        pt.op = p;
        pt.b = v;

        this._props.push(p);
      }
    },
    render: function render(ratio, data) {
      var pt = data._pt;

      while (pt) {
        _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d);
        pt = pt._next;
      }
    }
  }, {
    name: "endArray",
    init: function init(target, value) {
      var i = value.length;

      while (i--) {
        this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
      }
    }
  }, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap;
  Tween.version = Timeline.version = gsap.version = "3.12.5";
  _coreReady = 1;
  _windowExists() && _wake();
  var Power0 = _easeMap.Power0,
      Power1 = _easeMap.Power1,
      Power2 = _easeMap.Power2,
      Power3 = _easeMap.Power3,
      Power4 = _easeMap.Power4,
      Linear = _easeMap.Linear,
      Quad = _easeMap.Quad,
      Cubic = _easeMap.Cubic,
      Quart = _easeMap.Quart,
      Quint = _easeMap.Quint,
      Strong = _easeMap.Strong,
      Elastic = _easeMap.Elastic,
      Back = _easeMap.Back,
      SteppedEase = _easeMap.SteppedEase,
      Bounce = _easeMap.Bounce,
      Sine = _easeMap.Sine,
      Expo = _easeMap.Expo,
      Circ = _easeMap.Circ;

  var _win$1,
      _doc$1,
      _docElement,
      _pluginInitted,
      _tempDiv,
      _tempDivStyler,
      _recentSetterPlugin,
      _reverting$1,
      _windowExists$1 = function _windowExists() {
    return typeof window !== "undefined";
  },
      _transformProps = {},
      _RAD2DEG = 180 / Math.PI,
      _DEG2RAD = Math.PI / 180,
      _atan2 = Math.atan2,
      _bigNum$1 = 1e8,
      _capsExp = /([A-Z])/g,
      _horizontalExp = /(left|right|width|margin|padding|x)/i,
      _complexExp = /[\s,\(]\S/,
      _propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
  },
      _renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
  },
      _renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
  },
      _renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
  },
      _renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -.5 : .5)) + data.u, data);
  },
      _renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
  },
      _renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
  },
      _setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
  },
      _setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
  },
      _setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
  },
      _setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
  },
      _setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
  },
      _setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
  },
      _transformProp = "transform",
      _transformOriginProp = _transformProp + "Origin",
      _saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;

    var target = this.target,
        style = target.style,
        cache = target._gsap;

    if (property in _transformProps && style) {
      this.tfm = this.tfm || {};

      if (property !== "transform") {
        property = _propertyAliases[property] || property;
        ~property.indexOf(",") ? property.split(",").forEach(function (a) {
          return _this.tfm[a] = _get(target, a);
        }) : this.tfm[property] = cache.x ? cache[property] : _get(target, property);
        property === _transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
      } else {
        return _propertyAliases.transform.split(",").forEach(function (p) {
          return _saveStyle.call(_this, p, isNotCSS);
        });
      }

      if (this.props.indexOf(_transformProp) >= 0) {
        return;
      }

      if (cache.svg) {
        this.svgo = target.getAttribute("data-svg-origin");
        this.props.push(_transformOriginProp, isNotCSS, "");
      }

      property = _transformProp;
    }

    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
  },
      _removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
      style.removeProperty("translate");
      style.removeProperty("scale");
      style.removeProperty("rotate");
    }
  },
      _revertStyle = function _revertStyle() {
    var props = this.props,
        target = this.target,
        style = target.style,
        cache = target._gsap,
        i,
        p;

    for (i = 0; i < props.length; i += 3) {
      props[i + 1] ? target[props[i]] = props[i + 2] : props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace(_capsExp, "-$1").toLowerCase());
    }

    if (this.tfm) {
      for (p in this.tfm) {
        cache[p] = this.tfm[p];
      }

      if (cache.svg) {
        cache.renderTransform();
        target.setAttribute("data-svg-origin", this.svgo || "");
      }

      i = _reverting$1();

      if ((!i || !i.isStart) && !style[_transformProp]) {
        _removeIndependentTransforms(style);

        if (cache.zOrigin && style[_transformOriginProp]) {
          style[_transformOriginProp] += " " + cache.zOrigin + "px";
          cache.zOrigin = 0;
          cache.renderTransform();
        }

        cache.uncache = 1;
      }
    }
  },
      _getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
      target: target,
      props: [],
      revert: _revertStyle,
      save: _saveStyle
    };
    target._gsap || gsap.core.getCache(target);
    properties && properties.split(",").forEach(function (p) {
      return saver.save(p);
    });
    return saver;
  },
      _supports3D,
      _createElement = function _createElement(type, ns) {
    var e = _doc$1.createElementNS ? _doc$1.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : _doc$1.createElement(type);
    return e && e.style ? e : _doc$1.createElement(type);
  },
      _getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace(_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, _checkPropPrefix(property) || property, 1) || "";
  },
      _prefixes = "O,Moz,ms,Ms,Webkit".split(","),
      _checkPropPrefix = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || _tempDiv,
        s = e.style,
        i = 5;

    if (property in s && !preferPrefix) {
      return property;
    }

    property = property.charAt(0).toUpperCase() + property.substr(1);

    while (i-- && !(_prefixes[i] + property in s)) {}

    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? _prefixes[i] : "") + property;
  },
      _initCore = function _initCore() {
    if (_windowExists$1() && window.document) {
      _win$1 = window;
      _doc$1 = _win$1.document;
      _docElement = _doc$1.documentElement;
      _tempDiv = _createElement("div") || {
        style: {}
      };
      _tempDivStyler = _createElement("div");
      _transformProp = _checkPropPrefix(_transformProp);
      _transformOriginProp = _transformProp + "Origin";
      _tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0";
      _supports3D = !!_checkPropPrefix("perspective");
      _reverting$1 = gsap.core.reverting;
      _pluginInitted = 1;
    }
  },
      _getBBoxHack = function _getBBoxHack(swapIfPossible) {
    var svg = _createElement("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"),
        oldParent = this.parentNode,
        oldSibling = this.nextSibling,
        oldCSS = this.style.cssText,
        bbox;

    _docElement.appendChild(svg);

    svg.appendChild(this);
    this.style.display = "block";

    if (swapIfPossible) {
      try {
        bbox = this.getBBox();
        this._gsapBBox = this.getBBox;
        this.getBBox = _getBBoxHack;
      } catch (e) {}
    } else if (this._gsapBBox) {
      bbox = this._gsapBBox();
    }

    if (oldParent) {
      if (oldSibling) {
        oldParent.insertBefore(this, oldSibling);
      } else {
        oldParent.appendChild(this);
      }
    }

    _docElement.removeChild(svg);

    this.style.cssText = oldCSS;
    return bbox;
  },
      _getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;

    while (i--) {
      if (target.hasAttribute(attributesArray[i])) {
        return target.getAttribute(attributesArray[i]);
      }
    }
  },
      _getBBox = function _getBBox(target) {
    var bounds;

    try {
      bounds = target.getBBox();
    } catch (error) {
      bounds = _getBBoxHack.call(target, true);
    }

    bounds && (bounds.width || bounds.height) || target.getBBox === _getBBoxHack || (bounds = _getBBoxHack.call(target, true));
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
      x: +_getAttributeFallbacks(target, ["x", "cx", "x1"]) || 0,
      y: +_getAttributeFallbacks(target, ["y", "cy", "y1"]) || 0,
      width: 0,
      height: 0
    } : bounds;
  },
      _isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && _getBBox(e));
  },
      _removeProperty = function _removeProperty(target, property) {
    if (property) {
      var style = target.style,
          first2Chars;

      if (property in _transformProps && property !== _transformOriginProp) {
        property = _transformProp;
      }

      if (style.removeProperty) {
        first2Chars = property.substr(0, 2);

        if (first2Chars === "ms" || property.substr(0, 6) === "webkit") {
          property = "-" + property;
        }

        style.removeProperty(first2Chars === "--" ? property : property.replace(_capsExp, "-$1").toLowerCase());
      } else {
        style.removeAttribute(property);
      }
    }
  },
      _addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new PropTween(plugin._pt, target, property, 0, 1, onlySetAtEnd ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;

    plugin._props.push(property);

    return pt;
  },
      _nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
  },
      _nonStandardLayouts = {
    grid: 1,
    flex: 1
  },
      _convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0,
        curUnit = (value + "").trim().substr((curValue + "").length) || "px",
        style = _tempDiv.style,
        horizontal = _horizontalExp.test(property),
        isRootSVG = target.tagName.toLowerCase() === "svg",
        measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"),
        amount = 100,
        toPixels = unit === "px",
        toPercent = unit === "%",
        px,
        parent,
        cache,
        isSVG;

    if (unit === curUnit || !curValue || _nonConvertibleUnits[unit] || _nonConvertibleUnits[curUnit]) {
      return curValue;
    }

    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && _isSVG(target);

    if ((toPercent || curUnit === "%") && (_transformProps[property] || ~property.indexOf("adius"))) {
      px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
      return _round(toPercent ? curValue / px * amount : curValue / 100 * px);
    }

    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;

    if (isSVG) {
      parent = (target.ownerSVGElement || {}).parentNode;
    }

    if (!parent || parent === _doc$1 || !parent.appendChild) {
      parent = _doc$1.body;
    }

    cache = parent._gsap;

    if (cache && toPercent && cache.width && horizontal && cache.time === _ticker.time && !cache.uncache) {
      return _round(curValue / cache.width * amount);
    } else {
      if (toPercent && (property === "height" || property === "width")) {
        var v = target.style[property];
        target.style[property] = amount + unit;
        px = target[measureProperty];
        v ? target.style[property] = v : _removeProperty(target, property);
      } else {
        (toPercent || curUnit === "%") && !_nonStandardLayouts[_getComputedProperty(parent, "display")] && (style.position = _getComputedProperty(target, "position"));
        parent === target && (style.position = "static");
        parent.appendChild(_tempDiv);
        px = _tempDiv[measureProperty];
        parent.removeChild(_tempDiv);
        style.position = "absolute";
      }

      if (horizontal && toPercent) {
        cache = _getCache(parent);
        cache.time = _ticker.time;
        cache.width = parent[measureProperty];
      }
    }

    return _round(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
  },
      _get = function _get(target, property, unit, uncache) {
    var value;
    _pluginInitted || _initCore();

    if (property in _propertyAliases && property !== "transform") {
      property = _propertyAliases[property];

      if (~property.indexOf(",")) {
        property = property.split(",")[0];
      }
    }

    if (_transformProps[property] && property !== "transform") {
      value = _parseTransform(target, uncache);
      value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : _firstTwoOnly(_getComputedProperty(target, _transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
      value = target.style[property];

      if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) {
        value = _specialProps[property] && _specialProps[property](target, property, unit) || _getComputedProperty(target, property) || _getProperty(target, property) || (property === "opacity" ? 1 : 0);
      }
    }

    return unit && !~(value + "").trim().indexOf(" ") ? _convertToUnit(target, property, value, unit) + unit : value;
  },
      _tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    if (!start || start === "none") {
      var p = _checkPropPrefix(prop, target, 1),
          s = p && _getComputedProperty(target, p, 1);

      if (s && s !== start) {
        prop = p;
        start = s;
      } else if (prop === "borderColor") {
        start = _getComputedProperty(target, "borderTopColor");
      }
    }

    var pt = new PropTween(this._pt, target.style, prop, 0, 1, _renderComplexString),
        index = 0,
        matchIndex = 0,
        a,
        result,
        startValues,
        startNum,
        color,
        startValue,
        endValue,
        endNum,
        chunk,
        endUnit,
        startUnit,
        endValues;
    pt.b = start;
    pt.e = end;
    start += "";
    end += "";

    if (end === "auto") {
      startValue = target.style[prop];
      target.style[prop] = end;
      end = _getComputedProperty(target, prop) || end;
      startValue ? target.style[prop] = startValue : _removeProperty(target, prop);
    }

    a = [start, end];

    _colorStringFilter(a);

    start = a[0];
    end = a[1];
    startValues = start.match(_numWithUnitExp) || [];
    endValues = end.match(_numWithUnitExp) || [];

    if (endValues.length) {
      while (result = _numWithUnitExp.exec(end)) {
        endValue = result[0];
        chunk = end.substring(index, result.index);

        if (color) {
          color = (color + 1) % 5;
        } else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") {
          color = 1;
        }

        if (endValue !== (startValue = startValues[matchIndex++] || "")) {
          startNum = parseFloat(startValue) || 0;
          startUnit = startValue.substr((startNum + "").length);
          endValue.charAt(1) === "=" && (endValue = _parseRelative(startNum, endValue) + startUnit);
          endNum = parseFloat(endValue);
          endUnit = endValue.substr((endNum + "").length);
          index = _numWithUnitExp.lastIndex - endUnit.length;

          if (!endUnit) {
            endUnit = endUnit || _config.units[prop] || startUnit;

            if (index === end.length) {
              end += endUnit;
              pt.e += endUnit;
            }
          }

          if (startUnit !== endUnit) {
            startNum = _convertToUnit(target, prop, startValue, endUnit) || 0;
          }

          pt._pt = {
            _next: pt._pt,
            p: chunk || matchIndex === 1 ? chunk : ",",
            s: startNum,
            c: endNum - startNum,
            m: color && color < 4 || prop === "zIndex" ? Math.round : 0
          };
        }
      }

      pt.c = index < end.length ? end.substring(index, end.length) : "";
    } else {
      pt.r = prop === "display" && end === "none" ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue;
    }

    _relExp.test(end) && (pt.e = 0);
    this._pt = pt;
    return pt;
  },
      _keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
  },
      _convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "),
        x = split[0],
        y = split[1] || "50%";

    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
      value = x;
      x = y;
      y = value;
    }

    split[0] = _keywordToPercent[x] || x;
    split[1] = _keywordToPercent[y] || y;
    return split.join(" ");
  },
      _renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
      var target = data.t,
          style = target.style,
          props = data.u,
          cache = target._gsap,
          prop,
          clearTransforms,
          i;

      if (props === "all" || props === true) {
        style.cssText = "";
        clearTransforms = 1;
      } else {
        props = props.split(",");
        i = props.length;

        while (--i > -1) {
          prop = props[i];

          if (_transformProps[prop]) {
            clearTransforms = 1;
            prop = prop === "transformOrigin" ? _transformOriginProp : _transformProp;
          }

          _removeProperty(target, prop);
        }
      }

      if (clearTransforms) {
        _removeProperty(target, _transformProp);

        if (cache) {
          cache.svg && target.removeAttribute("transform");

          _parseTransform(target, 1);

          cache.uncache = 1;

          _removeIndependentTransforms(style);
        }
      }
    }
  },
      _specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
      if (tween.data !== "isFromStart") {
        var pt = plugin._pt = new PropTween(plugin._pt, target, property, 0, 0, _renderClearProps);
        pt.u = endValue;
        pt.pr = -10;
        pt.tween = tween;

        plugin._props.push(property);

        return 1;
      }
    }
  },
      _identity2DMatrix = [1, 0, 0, 1, 0, 0],
      _rotationalProperties = {},
      _isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
  },
      _getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = _getComputedProperty(target, _transformProp);

    return _isNullTransform(matrixString) ? _identity2DMatrix : matrixString.substr(7).match(_numExp).map(_round);
  },
      _getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || _getCache(target),
        style = target.style,
        matrix = _getComputedTransformMatrixAsArray(target),
        parent,
        nextSibling,
        temp,
        addedToDOM;

    if (cache.svg && target.getAttribute("transform")) {
      temp = target.transform.baseVal.consolidate().matrix;
      matrix = [temp.a, temp.b, temp.c, temp.d, temp.e, temp.f];
      return matrix.join(",") === "1,0,0,1,0,0" ? _identity2DMatrix : matrix;
    } else if (matrix === _identity2DMatrix && !target.offsetParent && target !== _docElement && !cache.svg) {
      temp = style.display;
      style.display = "block";
      parent = target.parentNode;

      if (!parent || !target.offsetParent) {
        addedToDOM = 1;
        nextSibling = target.nextElementSibling;

        _docElement.appendChild(target);
      }

      matrix = _getComputedTransformMatrixAsArray(target);
      temp ? style.display = temp : _removeProperty(target, "display");

      if (addedToDOM) {
        nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : _docElement.removeChild(target);
      }
    }

    return force2D && matrix.length > 6 ? [matrix[0], matrix[1], matrix[4], matrix[5], matrix[12], matrix[13]] : matrix;
  },
      _applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap,
        matrix = matrixArray || _getMatrix(target, true),
        xOriginOld = cache.xOrigin || 0,
        yOriginOld = cache.yOrigin || 0,
        xOffsetOld = cache.xOffset || 0,
        yOffsetOld = cache.yOffset || 0,
        a = matrix[0],
        b = matrix[1],
        c = matrix[2],
        d = matrix[3],
        tx = matrix[4],
        ty = matrix[5],
        originSplit = origin.split(" "),
        xOrigin = parseFloat(originSplit[0]) || 0,
        yOrigin = parseFloat(originSplit[1]) || 0,
        bounds,
        determinant,
        x,
        y;

    if (!originIsAbsolute) {
      bounds = _getBBox(target);
      xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
      yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin);
    } else if (matrix !== _identity2DMatrix && (determinant = a * d - b * c)) {
      x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
      y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
      xOrigin = x;
      yOrigin = y;
    }

    if (smooth || smooth !== false && cache.smooth) {
      tx = xOrigin - xOriginOld;
      ty = yOrigin - yOriginOld;
      cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
      cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else {
      cache.xOffset = cache.yOffset = 0;
    }

    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[_transformOriginProp] = "0px 0px";

    if (pluginToAddPropTweensTo) {
      _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);

      _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);

      _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);

      _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }

    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
  },
      _parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new GSCache(target);

    if ("x" in cache && !uncache && !cache.uncache) {
      return cache;
    }

    var style = target.style,
        invertedScaleX = cache.scaleX < 0,
        px = "px",
        deg = "deg",
        cs = getComputedStyle(target),
        origin = _getComputedProperty(target, _transformOriginProp) || "0",
        x,
        y,
        z,
        scaleX,
        scaleY,
        rotation,
        rotationX,
        rotationY,
        skewX,
        skewY,
        perspective,
        xOrigin,
        yOrigin,
        matrix,
        angle,
        cos,
        sin,
        a,
        b,
        c,
        d,
        a12,
        a22,
        t1,
        t2,
        t3,
        a13,
        a23,
        a33,
        a42,
        a43,
        a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && _isSVG(target));

    if (cs.translate) {
      if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") {
        style[_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[_transformProp] !== "none" ? cs[_transformProp] : "");
      }

      style.scale = style.rotate = style.translate = "none";
    }

    matrix = _getMatrix(target, cache.svg);

    if (cache.svg) {
      if (cache.uncache) {
        t2 = target.getBBox();
        origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
        t1 = "";
      } else {
        t1 = !uncache && target.getAttribute("data-svg-origin");
      }

      _applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }

    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;

    if (matrix !== _identity2DMatrix) {
      a = matrix[0];
      b = matrix[1];
      c = matrix[2];
      d = matrix[3];
      x = a12 = matrix[4];
      y = a22 = matrix[5];

      if (matrix.length === 6) {
        scaleX = Math.sqrt(a * a + b * b);
        scaleY = Math.sqrt(d * d + c * c);
        rotation = a || b ? _atan2(b, a) * _RAD2DEG : 0;
        skewX = c || d ? _atan2(c, d) * _RAD2DEG + rotation : 0;
        skewX && (scaleY *= Math.abs(Math.cos(skewX * _DEG2RAD)));

        if (cache.svg) {
          x -= xOrigin - (xOrigin * a + yOrigin * c);
          y -= yOrigin - (xOrigin * b + yOrigin * d);
        }
      } else {
        a32 = matrix[6];
        a42 = matrix[7];
        a13 = matrix[8];
        a23 = matrix[9];
        a33 = matrix[10];
        a43 = matrix[11];
        x = matrix[12];
        y = matrix[13];
        z = matrix[14];
        angle = _atan2(a32, a33);
        rotationX = angle * _RAD2DEG;

        if (angle) {
          cos = Math.cos(-angle);
          sin = Math.sin(-angle);
          t1 = a12 * cos + a13 * sin;
          t2 = a22 * cos + a23 * sin;
          t3 = a32 * cos + a33 * sin;
          a13 = a12 * -sin + a13 * cos;
          a23 = a22 * -sin + a23 * cos;
          a33 = a32 * -sin + a33 * cos;
          a43 = a42 * -sin + a43 * cos;
          a12 = t1;
          a22 = t2;
          a32 = t3;
        }

        angle = _atan2(-c, a33);
        rotationY = angle * _RAD2DEG;

        if (angle) {
          cos = Math.cos(-angle);
          sin = Math.sin(-angle);
          t1 = a * cos - a13 * sin;
          t2 = b * cos - a23 * sin;
          t3 = c * cos - a33 * sin;
          a43 = d * sin + a43 * cos;
          a = t1;
          b = t2;
          c = t3;
        }

        angle = _atan2(b, a);
        rotation = angle * _RAD2DEG;

        if (angle) {
          cos = Math.cos(angle);
          sin = Math.sin(angle);
          t1 = a * cos + b * sin;
          t2 = a12 * cos + a22 * sin;
          b = b * cos - a * sin;
          a22 = a22 * cos - a12 * sin;
          a = t1;
          a12 = t2;
        }

        if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
          rotationX = rotation = 0;
          rotationY = 180 - rotationY;
        }

        scaleX = _round(Math.sqrt(a * a + b * b + c * c));
        scaleY = _round(Math.sqrt(a22 * a22 + a32 * a32));
        angle = _atan2(a12, a22);
        skewX = Math.abs(angle) > 0.0002 ? angle * _RAD2DEG : 0;
        perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
      }

      if (cache.svg) {
        t1 = target.getAttribute("transform");
        cache.forceCSS = target.setAttribute("transform", "") || !_isNullTransform(_getComputedProperty(target, _transformProp));
        t1 && target.setAttribute("transform", t1);
      }
    }

    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
      if (invertedScaleX) {
        scaleX *= -1;
        skewX += rotation <= 0 ? 180 : -180;
        rotation += rotation <= 0 ? 180 : -180;
      } else {
        scaleY *= -1;
        skewX += skewX <= 0 ? 180 : -180;
      }
    }

    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = _round(scaleX);
    cache.scaleY = _round(scaleY);
    cache.rotation = _round(rotation) + deg;
    cache.rotationX = _round(rotationX) + deg;
    cache.rotationY = _round(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;

    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) {
      style[_transformOriginProp] = _firstTwoOnly(origin);
    }

    cache.xOffset = cache.yOffset = 0;
    cache.force3D = _config.force3D;
    cache.renderTransform = cache.svg ? _renderSVGTransforms : _supports3D ? _renderCSSTransforms : _renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
  },
      _firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
  },
      _addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = getUnit(start);
    return _round(parseFloat(start) + parseFloat(_convertToUnit(target, "x", value + "px", unit))) + unit;
  },
      _renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;

    _renderCSSTransforms(ratio, cache);
  },
      _zeroDeg = "0deg",
      _zeroPx = "0px",
      _endParenthesis = ") ",
      _renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this,
        xPercent = _ref.xPercent,
        yPercent = _ref.yPercent,
        x = _ref.x,
        y = _ref.y,
        z = _ref.z,
        rotation = _ref.rotation,
        rotationY = _ref.rotationY,
        rotationX = _ref.rotationX,
        skewX = _ref.skewX,
        skewY = _ref.skewY,
        scaleX = _ref.scaleX,
        scaleY = _ref.scaleY,
        transformPerspective = _ref.transformPerspective,
        force3D = _ref.force3D,
        target = _ref.target,
        zOrigin = _ref.zOrigin,
        transforms = "",
        use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true;

    if (zOrigin && (rotationX !== _zeroDeg || rotationY !== _zeroDeg)) {
      var angle = parseFloat(rotationY) * _DEG2RAD,
          a13 = Math.sin(angle),
          a33 = Math.cos(angle),
          cos;

      angle = parseFloat(rotationX) * _DEG2RAD;
      cos = Math.cos(angle);
      x = _addPxTranslate(target, x, a13 * cos * -zOrigin);
      y = _addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
      z = _addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }

    if (transformPerspective !== _zeroPx) {
      transforms += "perspective(" + transformPerspective + _endParenthesis;
    }

    if (xPercent || yPercent) {
      transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    }

    if (use3D || x !== _zeroPx || y !== _zeroPx || z !== _zeroPx) {
      transforms += z !== _zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + _endParenthesis;
    }

    if (rotation !== _zeroDeg) {
      transforms += "rotate(" + rotation + _endParenthesis;
    }

    if (rotationY !== _zeroDeg) {
      transforms += "rotateY(" + rotationY + _endParenthesis;
    }

    if (rotationX !== _zeroDeg) {
      transforms += "rotateX(" + rotationX + _endParenthesis;
    }

    if (skewX !== _zeroDeg || skewY !== _zeroDeg) {
      transforms += "skew(" + skewX + ", " + skewY + _endParenthesis;
    }

    if (scaleX !== 1 || scaleY !== 1) {
      transforms += "scale(" + scaleX + ", " + scaleY + _endParenthesis;
    }

    target.style[_transformProp] = transforms || "translate(0, 0)";
  },
      _renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this,
        xPercent = _ref2.xPercent,
        yPercent = _ref2.yPercent,
        x = _ref2.x,
        y = _ref2.y,
        rotation = _ref2.rotation,
        skewX = _ref2.skewX,
        skewY = _ref2.skewY,
        scaleX = _ref2.scaleX,
        scaleY = _ref2.scaleY,
        target = _ref2.target,
        xOrigin = _ref2.xOrigin,
        yOrigin = _ref2.yOrigin,
        xOffset = _ref2.xOffset,
        yOffset = _ref2.yOffset,
        forceCSS = _ref2.forceCSS,
        tx = parseFloat(x),
        ty = parseFloat(y),
        a11,
        a21,
        a12,
        a22,
        temp;

    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);

    if (skewY) {
      skewY = parseFloat(skewY);
      skewX += skewY;
      rotation += skewY;
    }

    if (rotation || skewX) {
      rotation *= _DEG2RAD;
      skewX *= _DEG2RAD;
      a11 = Math.cos(rotation) * scaleX;
      a21 = Math.sin(rotation) * scaleX;
      a12 = Math.sin(rotation - skewX) * -scaleY;
      a22 = Math.cos(rotation - skewX) * scaleY;

      if (skewX) {
        skewY *= _DEG2RAD;
        temp = Math.tan(skewX - skewY);
        temp = Math.sqrt(1 + temp * temp);
        a12 *= temp;
        a22 *= temp;

        if (skewY) {
          temp = Math.tan(skewY);
          temp = Math.sqrt(1 + temp * temp);
          a11 *= temp;
          a21 *= temp;
        }
      }

      a11 = _round(a11);
      a21 = _round(a21);
      a12 = _round(a12);
      a22 = _round(a22);
    } else {
      a11 = scaleX;
      a22 = scaleY;
      a21 = a12 = 0;
    }

    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
      tx = _convertToUnit(target, "x", x, "px");
      ty = _convertToUnit(target, "y", y, "px");
    }

    if (xOrigin || yOrigin || xOffset || yOffset) {
      tx = _round(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
      ty = _round(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }

    if (xPercent || yPercent) {
      temp = target.getBBox();
      tx = _round(tx + xPercent / 100 * temp.width);
      ty = _round(ty + yPercent / 100 * temp.height);
    }

    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[_transformProp] = temp);
  },
      _addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360,
        isString = _isString(endValue),
        endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? _RAD2DEG : 1),
        change = endNum - startNum,
        finalValue = startNum + change + "deg",
        direction,
        pt;

    if (isString) {
      direction = endValue.split("_")[1];

      if (direction === "short") {
        change %= cap;

        if (change !== change % (cap / 2)) {
          change += change < 0 ? cap : -cap;
        }
      }

      if (direction === "cw" && change < 0) {
        change = (change + cap * _bigNum$1) % cap - ~~(change / cap) * cap;
      } else if (direction === "ccw" && change > 0) {
        change = (change - cap * _bigNum$1) % cap - ~~(change / cap) * cap;
      }
    }

    plugin._pt = pt = new PropTween(plugin._pt, target, property, startNum, change, _renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";

    plugin._props.push(property);

    return pt;
  },
      _assign = function _assign(target, source) {
    for (var p in source) {
      target[p] = source[p];
    }

    return target;
  },
      _addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    var startCache = _assign({}, target._gsap),
        exclude = "perspective,force3D,transformOrigin,svgOrigin",
        style = target.style,
        endCache,
        p,
        startValue,
        endValue,
        startNum,
        endNum,
        startUnit,
        endUnit;

    if (startCache.svg) {
      startValue = target.getAttribute("transform");
      target.setAttribute("transform", "");
      style[_transformProp] = transforms;
      endCache = _parseTransform(target, 1);

      _removeProperty(target, _transformProp);

      target.setAttribute("transform", startValue);
    } else {
      startValue = getComputedStyle(target)[_transformProp];
      style[_transformProp] = transforms;
      endCache = _parseTransform(target, 1);
      style[_transformProp] = startValue;
    }

    for (p in _transformProps) {
      startValue = startCache[p];
      endValue = endCache[p];

      if (startValue !== endValue && exclude.indexOf(p) < 0) {
        startUnit = getUnit(startValue);
        endUnit = getUnit(endValue);
        startNum = startUnit !== endUnit ? _convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
        endNum = parseFloat(endValue);
        plugin._pt = new PropTween(plugin._pt, endCache, p, startNum, endNum - startNum, _renderCSSProp);
        plugin._pt.u = endUnit || 0;

        plugin._props.push(p);
      }
    }

    _assign(endCache, startCache);
  };

  _forEachName("padding,margin,Width,Radius", function (name, index) {
    var t = "Top",
        r = "Right",
        b = "Bottom",
        l = "Left",
        props = (index < 3 ? [t, r, b, l] : [t + l, t + r, b + r, b + l]).map(function (side) {
      return index < 2 ? name + side : "border" + side + name;
    });

    _specialProps[index > 1 ? "border" + name : name] = function (plugin, target, property, endValue, tween) {
      var a, vars;

      if (arguments.length < 4) {
        a = props.map(function (prop) {
          return _get(plugin, prop, property);
        });
        vars = a.join(" ");
        return vars.split(a[0]).length === 5 ? a[0] : vars;
      }

      a = (endValue + "").split(" ");
      vars = {};
      props.forEach(function (prop, i) {
        return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
      });
      plugin.init(target, vars, tween);
    };
  });

  var CSSPlugin = {
    name: "css",
    register: _initCore,
    targetTest: function targetTest(target) {
      return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
      var props = this._props,
          style = target.style,
          startAt = tween.vars.startAt,
          startValue,
          endValue,
          endNum,
          startNum,
          type,
          specialProp,
          p,
          startUnit,
          endUnit,
          relative,
          isTransformRelated,
          transformPropTween,
          cache,
          smooth,
          hasPriority,
          inlineProps;
      _pluginInitted || _initCore();
      this.styles = this.styles || _getStyleSaver(target);
      inlineProps = this.styles.props;
      this.tween = tween;

      for (p in vars) {
        if (p === "autoRound") {
          continue;
        }

        endValue = vars[p];

        if (_plugins[p] && _checkPlugin(p, vars, tween, index, target, targets)) {
          continue;
        }

        type = typeof endValue;
        specialProp = _specialProps[p];

        if (type === "function") {
          endValue = endValue.call(tween, index, target, targets);
          type = typeof endValue;
        }

        if (type === "string" && ~endValue.indexOf("random(")) {
          endValue = _replaceRandom(endValue);
        }

        if (specialProp) {
          specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
        } else if (p.substr(0, 2) === "--") {
          startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
          endValue += "";
          _colorExp.lastIndex = 0;

          if (!_colorExp.test(startValue)) {
            startUnit = getUnit(startValue);
            endUnit = getUnit(endValue);
          }

          endUnit ? startUnit !== endUnit && (startValue = _convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
          this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
          props.push(p);
          inlineProps.push(p, 0, style[p]);
        } else if (type !== "undefined") {
          if (startAt && p in startAt) {
            startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
            _isString(startValue) && ~startValue.indexOf("random(") && (startValue = _replaceRandom(startValue));
            getUnit(startValue + "") || startValue === "auto" || (startValue += _config.units[p] || getUnit(_get(target, p)) || "");
            (startValue + "").charAt(1) === "=" && (startValue = _get(target, p));
          } else {
            startValue = _get(target, p);
          }

          startNum = parseFloat(startValue);
          relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
          relative && (endValue = endValue.substr(2));
          endNum = parseFloat(endValue);

          if (p in _propertyAliases) {
            if (p === "autoAlpha") {
              if (startNum === 1 && _get(target, "visibility") === "hidden" && endNum) {
                startNum = 0;
              }

              inlineProps.push("visibility", 0, style.visibility);

              _addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
            }

            if (p !== "scale" && p !== "transform") {
              p = _propertyAliases[p];
              ~p.indexOf(",") && (p = p.split(",")[0]);
            }
          }

          isTransformRelated = p in _transformProps;

          if (isTransformRelated) {
            this.styles.save(p);

            if (!transformPropTween) {
              cache = target._gsap;
              cache.renderTransform && !vars.parseTransform || _parseTransform(target, vars.parseTransform);
              smooth = vars.smoothOrigin !== false && cache.smooth;
              transformPropTween = this._pt = new PropTween(this._pt, style, _transformProp, 0, 1, cache.renderTransform, cache, 0, -1);
              transformPropTween.dep = 1;
            }

            if (p === "scale") {
              this._pt = new PropTween(this._pt, cache, "scaleY", cache.scaleY, (relative ? _parseRelative(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, _renderCSSProp);
              this._pt.u = 0;
              props.push("scaleY", p);
              p += "X";
            } else if (p === "transformOrigin") {
              inlineProps.push(_transformOriginProp, 0, style[_transformOriginProp]);
              endValue = _convertKeywordsToPercentages(endValue);

              if (cache.svg) {
                _applySVGOrigin(target, endValue, 0, smooth, 0, this);
              } else {
                endUnit = parseFloat(endValue.split(" ")[2]) || 0;
                endUnit !== cache.zOrigin && _addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);

                _addNonTweeningPT(this, style, p, _firstTwoOnly(startValue), _firstTwoOnly(endValue));
              }

              continue;
            } else if (p === "svgOrigin") {
              _applySVGOrigin(target, endValue, 1, smooth, 0, this);

              continue;
            } else if (p in _rotationalProperties) {
              _addRotationalPropTween(this, cache, p, startNum, relative ? _parseRelative(startNum, relative + endValue) : endValue);

              continue;
            } else if (p === "smoothOrigin") {
              _addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);

              continue;
            } else if (p === "force3D") {
              cache[p] = endValue;
              continue;
            } else if (p === "transform") {
              _addRawTransformPTs(this, endValue, target);

              continue;
            }
          } else if (!(p in style)) {
            p = _checkPropPrefix(p) || p;
          }

          if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !_complexExp.test(endValue) && p in style) {
            startUnit = (startValue + "").substr((startNum + "").length);
            endNum || (endNum = 0);
            endUnit = getUnit(endValue) || (p in _config.units ? _config.units[p] : startUnit);
            startUnit !== endUnit && (startNum = _convertToUnit(target, p, startValue, endUnit));
            this._pt = new PropTween(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? _parseRelative(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? _renderRoundedCSSProp : _renderCSSProp);
            this._pt.u = endUnit || 0;

            if (startUnit !== endUnit && endUnit !== "%") {
              this._pt.b = startValue;
              this._pt.r = _renderCSSPropWithBeginning;
            }
          } else if (!(p in style)) {
            if (p in target) {
              this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
            } else if (p !== "parseTransform") {
              _missingPlugin(p, endValue);

              continue;
            }
          } else {
            _tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
          }

          isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : inlineProps.push(p, 1, startValue || target[p]));
          props.push(p);
        }
      }

      hasPriority && _sortPropTweensByPriority(this);
    },
    render: function render(ratio, data) {
      if (data.tween._time || !_reverting$1()) {
        var pt = data._pt;

        while (pt) {
          pt.r(ratio, pt.d);
          pt = pt._next;
        }
      } else {
        data.styles.revert();
      }
    },
    get: _get,
    aliases: _propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
      var p = _propertyAliases[property];
      p && p.indexOf(",") < 0 && (property = p);
      return property in _transformProps && property !== _transformOriginProp && (target._gsap.x || _get(target, "x")) ? plugin && _recentSetterPlugin === plugin ? property === "scale" ? _setterScale : _setterTransform : (_recentSetterPlugin = plugin || {}) && (property === "scale" ? _setterScaleWithRender : _setterTransformWithRender) : target.style && !_isUndefined(target.style[property]) ? _setterCSSStyle : ~property.indexOf("-") ? _setterCSSProp : _getSetter(target, property);
    },
    core: {
      _removeProperty: _removeProperty,
      _getMatrix: _getMatrix
    }
  };
  gsap.utils.checkPrefix = _checkPropPrefix;
  gsap.core.getStyleSaver = _getStyleSaver;

  (function (positionAndScale, rotation, others, aliases) {
    var all = _forEachName(positionAndScale + "," + rotation + "," + others, function (name) {
      _transformProps[name] = 1;
    });

    _forEachName(rotation, function (name) {
      _config.units[name] = "deg";
      _rotationalProperties[name] = 1;
    });

    _propertyAliases[all[13]] = positionAndScale + "," + rotation;

    _forEachName(aliases, function (name) {
      var split = name.split(":");
      _propertyAliases[split[1]] = all[split[0]];
    });
  })("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");

  _forEachName("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function (name) {
    _config.units[name] = "px";
  });

  gsap.registerPlugin(CSSPlugin);

  var gsapWithCSS = gsap.registerPlugin(CSSPlugin) || gsap,
      TweenMaxWithCSS = gsapWithCSS.core.Tween;

  exports.Back = Back;
  exports.Bounce = Bounce;
  exports.CSSPlugin = CSSPlugin;
  exports.Circ = Circ;
  exports.Cubic = Cubic;
  exports.Elastic = Elastic;
  exports.Expo = Expo;
  exports.Linear = Linear;
  exports.Power0 = Power0;
  exports.Power1 = Power1;
  exports.Power2 = Power2;
  exports.Power3 = Power3;
  exports.Power4 = Power4;
  exports.Quad = Quad;
  exports.Quart = Quart;
  exports.Quint = Quint;
  exports.Sine = Sine;
  exports.SteppedEase = SteppedEase;
  exports.Strong = Strong;
  exports.TimelineLite = Timeline;
  exports.TimelineMax = Timeline;
  exports.TweenLite = Tween;
  exports.TweenMax = TweenMaxWithCSS;
  exports.default = gsapWithCSS;
  exports.gsap = gsapWithCSS;

  if (typeof(window) === 'undefined' || window !== exports) {Object.defineProperty(exports, '__esModule', { value: true });} else {delete window.default;}

})));


/***/ }),

/***/ 48158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$i": function() { return /* binding */ _plugins; },
/* harmony export */   "Au": function() { return /* binding */ Expo; },
/* harmony export */   "DY": function() { return /* binding */ _getCache; },
/* harmony export */   "Fc": function() { return /* binding */ _config; },
/* harmony export */   "Fo": function() { return /* binding */ PropTween; },
/* harmony export */   "GN": function() { return /* binding */ _colorExp; },
/* harmony export */   "JV": function() { return /* binding */ _sortPropTweensByPriority; },
/* harmony export */   "Ks": function() { return /* binding */ _renderComplexString; },
/* harmony export */   "Ok": function() { return /* binding */ _getProperty; },
/* harmony export */   "Pr": function() { return /* binding */ _round; },
/* harmony export */   "S5": function() { return /* binding */ _getSetter; },
/* harmony export */   "SI": function() { return /* binding */ _numExp; },
/* harmony export */   "UI": function() { return /* binding */ _replaceRandom; },
/* harmony export */   "Wy": function() { return /* binding */ getUnit; },
/* harmony export */   "Yp": function() { return /* binding */ Power4; },
/* harmony export */   "bQ": function() { return /* binding */ _relExp; },
/* harmony export */   "cy": function() { return /* binding */ _parseRelative; },
/* harmony export */   "d4": function() { return /* binding */ _numWithUnitExp; },
/* harmony export */   "fS": function() { return /* binding */ _forEachName; },
/* harmony export */   "if": function() { return /* binding */ _checkPlugin; },
/* harmony export */   "kr": function() { return /* binding */ _colorStringFilter; },
/* harmony export */   "l1": function() { return /* binding */ GSCache; },
/* harmony export */   "lC": function() { return /* binding */ _missingPlugin; },
/* harmony export */   "m2": function() { return /* binding */ _isUndefined; },
/* harmony export */   "p8": function() { return /* binding */ gsap; },
/* harmony export */   "r9": function() { return /* binding */ _isString; },
/* harmony export */   "xr": function() { return /* binding */ _ticker; }
/* harmony export */ });
/* unused harmony exports Animation, Timeline, Tween, Power0, Power1, Power2, Power3, Linear, Quad, Cubic, Quart, Quint, Strong, Elastic, Back, SteppedEase, Bounce, Sine, Circ, TweenMax, TweenLite, TimelineMax, TimelineLite, default, wrap, wrapYoyo, distribute, random, snap, normalize, clamp, splitColor, toArray, selector, mapRange, pipe, unitize, interpolate, shuffle, _setDefaults, _removeLinkedListItem, _roundModifier */
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/*!
 * GSAP 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/

/* eslint-disable */
var _config = {
  autoSleep: 120,
  force3D: "auto",
  nullTargetWarn: 1,
  units: {
    lineHeight: ""
  }
},
    _defaults = {
  duration: .5,
  overwrite: false,
  delay: 0
},
    _suppressOverwrites,
    _reverting,
    _context,
    _bigNum = 1e8,
    _tinyNum = 1 / _bigNum,
    _2PI = Math.PI * 2,
    _HALF_PI = _2PI / 4,
    _gsID = 0,
    _sqrt = Math.sqrt,
    _cos = Math.cos,
    _sin = Math.sin,
    _isString = function _isString(value) {
  return typeof value === "string";
},
    _isFunction = function _isFunction(value) {
  return typeof value === "function";
},
    _isNumber = function _isNumber(value) {
  return typeof value === "number";
},
    _isUndefined = function _isUndefined(value) {
  return typeof value === "undefined";
},
    _isObject = function _isObject(value) {
  return typeof value === "object";
},
    _isNotFalse = function _isNotFalse(value) {
  return value !== false;
},
    _windowExists = function _windowExists() {
  return typeof window !== "undefined";
},
    _isFuncOrString = function _isFuncOrString(value) {
  return _isFunction(value) || _isString(value);
},
    _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function () {},
    // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray,
    _strictNumExp = /(?:-?\.?\d|\.)+/gi,
    //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
    //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
    _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
    //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/,
    _delimitedValueExp = /[^,'"\[\]\s]+/gi,
    // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,
    _globalTimeline,
    _win,
    _coreInitted,
    _doc,
    _globals = {},
    _installScope = {},
    _coreReady,
    _install = function _install(scope) {
  return (_installScope = _merge(scope, _globals)) && gsap;
},
    _missingPlugin = function _missingPlugin(property, value) {
  return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
},
    _warn = function _warn(message, suppress) {
  return !suppress && console.warn(message);
},
    _addGlobal = function _addGlobal(name, obj) {
  return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
},
    _emptyFunc = function _emptyFunc() {
  return 0;
},
    _startAtRevertConfig = {
  suppressEvents: true,
  isStart: true,
  kill: false
},
    _revertConfigNoKill = {
  suppressEvents: true,
  kill: false
},
    _revertConfig = {
  suppressEvents: true
},
    _reservedProps = {},
    _lazyTweens = [],
    _lazyLookup = {},
    _lastRenderedFrame,
    _plugins = {},
    _effects = {},
    _nextGCFrame = 30,
    _harnessPlugins = [],
    _callbackNames = "",
    _harness = function _harness(targets) {
  var target = targets[0],
      harnessPlugin,
      i;
  _isObject(target) || _isFunction(target) || (targets = [targets]);

  if (!(harnessPlugin = (target._gsap || {}).harness)) {
    // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
    i = _harnessPlugins.length;

    while (i-- && !_harnessPlugins[i].targetTest(target)) {}

    harnessPlugin = _harnessPlugins[i];
  }

  i = targets.length;

  while (i--) {
    targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
  }

  return targets;
},
    _getCache = function _getCache(target) {
  return target._gsap || _harness(toArray(target))[0]._gsap;
},
    _getProperty = function _getProperty(target, property, v) {
  return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
},
    _forEachName = function _forEachName(names, func) {
  return (names = names.split(",")).forEach(func) || names;
},
    //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
  return Math.round(value * 100000) / 100000 || 0;
},
    _roundPrecise = function _roundPrecise(value) {
  return Math.round(value * 10000000) / 10000000 || 0;
},
    // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
  var operator = value.charAt(0),
      end = parseFloat(value.substr(2));
  start = parseFloat(start);
  return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
},
    _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
  //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
  var l = toFind.length,
      i = 0;

  for (; toSearch.indexOf(toFind[i]) < 0 && ++i < l;) {}

  return i < l;
},
    _lazyRender = function _lazyRender() {
  var l = _lazyTweens.length,
      a = _lazyTweens.slice(0),
      i,
      tween;

  _lazyLookup = {};
  _lazyTweens.length = 0;

  for (i = 0; i < l; i++) {
    tween = a[i];
    tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
  }
},
    _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
  _lazyTweens.length && !_reverting && _lazyRender();
  animation.render(time, suppressEvents, force || _reverting && time < 0 && (animation._initted || animation._startAt));
  _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
},
    _numericIfPossible = function _numericIfPossible(value) {
  var n = parseFloat(value);
  return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
},
    _passThrough = function _passThrough(p) {
  return p;
},
    _setDefaults = function _setDefaults(obj, defaults) {
  for (var p in defaults) {
    p in obj || (obj[p] = defaults[p]);
  }

  return obj;
},
    _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
  return function (obj, defaults) {
    for (var p in defaults) {
      p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    }
  };
},
    _merge = function _merge(base, toMerge) {
  for (var p in toMerge) {
    base[p] = toMerge[p];
  }

  return base;
},
    _mergeDeep = function _mergeDeep(base, toMerge) {
  for (var p in toMerge) {
    p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
  }

  return base;
},
    _copyExcluding = function _copyExcluding(obj, excluding) {
  var copy = {},
      p;

  for (p in obj) {
    p in excluding || (copy[p] = obj[p]);
  }

  return copy;
},
    _inheritDefaults = function _inheritDefaults(vars) {
  var parent = vars.parent || _globalTimeline,
      func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;

  if (_isNotFalse(vars.inherit)) {
    while (parent) {
      func(vars, parent.vars.defaults);
      parent = parent.parent || parent._dp;
    }
  }

  return vars;
},
    _arraysMatch = function _arraysMatch(a1, a2) {
  var i = a1.length,
      match = i === a2.length;

  while (match && i-- && a1[i] === a2[i]) {}

  return i < 0;
},
    _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
  if (firstProp === void 0) {
    firstProp = "_first";
  }

  if (lastProp === void 0) {
    lastProp = "_last";
  }

  var prev = parent[lastProp],
      t;

  if (sortBy) {
    t = child[sortBy];

    while (prev && prev[sortBy] > t) {
      prev = prev._prev;
    }
  }

  if (prev) {
    child._next = prev._next;
    prev._next = child;
  } else {
    child._next = parent[firstProp];
    parent[firstProp] = child;
  }

  if (child._next) {
    child._next._prev = child;
  } else {
    parent[lastProp] = child;
  }

  child._prev = prev;
  child.parent = child._dp = parent;
  return child;
},
    _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
  if (firstProp === void 0) {
    firstProp = "_first";
  }

  if (lastProp === void 0) {
    lastProp = "_last";
  }

  var prev = child._prev,
      next = child._next;

  if (prev) {
    prev._next = next;
  } else if (parent[firstProp] === child) {
    parent[firstProp] = next;
  }

  if (next) {
    next._prev = prev;
  } else if (parent[lastProp] === child) {
    parent[lastProp] = prev;
  }

  child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
},
    _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
  child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
  child._act = 0;
},
    _uncache = function _uncache(animation, child) {
  if (animation && (!child || child._end > animation._dur || child._start < 0)) {
    // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
    var a = animation;

    while (a) {
      a._dirty = 1;
      a = a.parent;
    }
  }

  return animation;
},
    _recacheAncestors = function _recacheAncestors(animation) {
  var parent = animation.parent;

  while (parent && parent.parent) {
    //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
    parent._dirty = 1;
    parent.totalDuration();
    parent = parent.parent;
  }

  return animation;
},
    _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
  return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
},
    _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
  return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
},
    _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
  return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
},
    // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
  var whole = Math.floor(tTime /= cycleDuration);
  return tTime && whole === tTime ? whole - 1 : whole;
},
    _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
  return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
},
    _setEnd = function _setEnd(animation) {
  return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
},
    _alignPlayhead = function _alignPlayhead(animation, totalTime) {
  // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
  var parent = animation._dp;

  if (parent && parent.smoothChildTiming && animation._ts) {
    animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));

    _setEnd(animation);

    parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
  }

  return animation;
},

/*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/
_postAddChecks = function _postAddChecks(timeline, child) {
  var t;

  if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
    // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
    t = _parentToChildTotalTime(timeline.rawTime(), child);

    if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) {
      child.render(t, true);
    }
  } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.


  if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
    //in case any of the ancestors had completed but should now be enabled...
    if (timeline._dur < timeline.duration()) {
      t = timeline;

      while (t._dp) {
        t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.

        t = t._dp;
      }
    }

    timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
  }
},
    _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
  child.parent && _removeFromParent(child);
  child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
  child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));

  _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);

  _isFromOrFromStart(child) || (timeline._recent = child);
  skipChecks || _postAddChecks(timeline, child);
  timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)

  return timeline;
},
    _scrollTrigger = function _scrollTrigger(animation, trigger) {
  return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
},
    _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
  _initTween(tween, time, tTime);

  if (!tween._initted) {
    return 1;
  }

  if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
    _lazyTweens.push(tween);

    tween._lazy = [tTime, suppressEvents];
    return 1;
  }
},
    _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
  var parent = _ref.parent;
  return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
},
    // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
  var data = _ref2.data;
  return data === "isFromStart" || data === "isStart";
},
    _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
  var prevRatio = tween.ratio,
      ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1,
      // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
  repeatDelay = tween._rDelay,
      tTime = 0,
      pt,
      iteration,
      prevIteration;

  if (repeatDelay && tween._repeat) {
    // in case there's a zero-duration tween that has a repeat with a repeatDelay
    tTime = _clamp(0, tween._tDur, totalTime);
    iteration = _animationCycle(tTime, repeatDelay);
    tween._yoyo && iteration & 1 && (ratio = 1 - ratio);

    if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
      // if iteration changed
      prevRatio = 1 - ratio;
      tween.vars.repeatRefresh && tween._initted && tween.invalidate();
    }
  }

  if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
    if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) {
      // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
      return;
    }

    prevIteration = tween._zTime;
    tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.

    suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.

    tween.ratio = ratio;
    tween._from && (ratio = 1 - ratio);
    tween._time = 0;
    tween._tTime = tTime;
    pt = tween._pt;

    while (pt) {
      pt.r(ratio, pt.d);
      pt = pt._next;
    }

    totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
    tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
    tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");

    if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
      ratio && _removeFromParent(tween, 1);

      if (!suppressEvents && !_reverting) {
        _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);

        tween._prom && tween._prom();
      }
    }
  } else if (!tween._zTime) {
    tween._zTime = totalTime;
  }
},
    _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
  var child;

  if (time > prevTime) {
    child = animation._first;

    while (child && child._start <= time) {
      if (child.data === "isPause" && child._start > prevTime) {
        return child;
      }

      child = child._next;
    }
  } else {
    child = animation._last;

    while (child && child._start >= time) {
      if (child.data === "isPause" && child._start < prevTime) {
        return child;
      }

      child = child._prev;
    }
  }
},
    _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
  var repeat = animation._repeat,
      dur = _roundPrecise(duration) || 0,
      totalProgress = animation._tTime / animation._tDur;
  totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
  animation._dur = dur;
  animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
  totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
  animation.parent && _setEnd(animation);
  skipUncache || _uncache(animation.parent, animation);
  return animation;
},
    _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
  return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
},
    _zeroPosition = {
  _start: 0,
  endTime: _emptyFunc,
  totalDuration: _emptyFunc
},
    _parsePosition = function _parsePosition(animation, position, percentAnimation) {
  var labels = animation.labels,
      recent = animation._recent || _zeroPosition,
      clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur,
      //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
  i,
      offset,
      isPercent;

  if (_isString(position) && (isNaN(position) || position in labels)) {
    //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
    offset = position.charAt(0);
    isPercent = position.substr(-1) === "%";
    i = position.indexOf("=");

    if (offset === "<" || offset === ">") {
      i >= 0 && (position = position.replace(/=/, ""));
      return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
    }

    if (i < 0) {
      position in labels || (labels[position] = clippedDuration);
      return labels[position];
    }

    offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));

    if (isPercent && percentAnimation) {
      offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
    }

    return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
  }

  return position == null ? clippedDuration : +position;
},
    _createTweenType = function _createTweenType(type, params, timeline) {
  var isLegacy = _isNumber(params[1]),
      varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1),
      vars = params[varsIndex],
      irVars,
      parent;

  isLegacy && (vars.duration = params[1]);
  vars.parent = timeline;

  if (type) {
    irVars = vars;
    parent = timeline;

    while (parent && !("immediateRender" in irVars)) {
      // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
      irVars = parent.vars.defaults || {};
      parent = _isNotFalse(parent.vars.inherit) && parent.parent;
    }

    vars.immediateRender = _isNotFalse(irVars.immediateRender);
    type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
  }

  return new Tween(params[0], vars, params[varsIndex + 1]);
},
    _conditionalReturn = function _conditionalReturn(value, func) {
  return value || value === 0 ? func(value) : func;
},
    _clamp = function _clamp(min, max, value) {
  return value < min ? min : value > max ? max : value;
},
    getUnit = function getUnit(value, v) {
  return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
},
    // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
  return _conditionalReturn(value, function (v) {
    return _clamp(min, max, v);
  });
},
    _slice = [].slice,
    _isArrayLike = function _isArrayLike(value, nonEmpty) {
  return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
},
    _flatten = function _flatten(ar, leaveStrings, accumulator) {
  if (accumulator === void 0) {
    accumulator = [];
  }

  return ar.forEach(function (value) {
    var _accumulator;

    return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
  }) || accumulator;
},
    //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
  return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [value] : [];
},
    selector = function selector(value) {
  value = toArray(value)[0] || _warn("Invalid scope") || {};
  return function (v) {
    var el = value.current || value.nativeElement || value;
    return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
  };
},
    shuffle = function shuffle(a) {
  return a.sort(function () {
    return .5 - Math.random();
  });
},
    // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = Math.floor(Math.random() * i), v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
distribute = function distribute(v) {
  if (_isFunction(v)) {
    return v;
  }

  var vars = _isObject(v) ? v : {
    each: v
  },
      //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
  ease = _parseEase(vars.ease),
      from = vars.from || 0,
      base = parseFloat(vars.base) || 0,
      cache = {},
      isDecimal = from > 0 && from < 1,
      ratios = isNaN(from) || isDecimal,
      axis = vars.axis,
      ratioX = from,
      ratioY = from;

  if (_isString(from)) {
    ratioX = ratioY = {
      center: .5,
      edges: .5,
      end: 1
    }[from] || 0;
  } else if (!isDecimal && ratios) {
    ratioX = from[0];
    ratioY = from[1];
  }

  return function (i, target, a) {
    var l = (a || vars).length,
        distances = cache[l],
        originX,
        originY,
        x,
        y,
        d,
        j,
        max,
        min,
        wrapAt;

    if (!distances) {
      wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [1, _bigNum])[1];

      if (!wrapAt) {
        max = -_bigNum;

        while (max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l) {}

        wrapAt < l && wrapAt--;
      }

      distances = cache[l] = [];
      originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
      originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
      max = 0;
      min = _bigNum;

      for (j = 0; j < l; j++) {
        x = j % wrapAt - originX;
        y = originY - (j / wrapAt | 0);
        distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
        d > max && (max = d);
        d < min && (min = d);
      }

      from === "random" && shuffle(distances);
      distances.max = max - min;
      distances.min = min;
      distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
      distances.b = l < 0 ? base - l : base;
      distances.u = getUnit(vars.amount || vars.each) || 0; //unit

      ease = ease && l < 0 ? _invertEase(ease) : ease;
    }

    l = (distances[i] - distances.min) / distances.max || 0;
    return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
  };
},
    _roundModifier = function _roundModifier(v) {
  //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
  var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())

  return function (raw) {
    var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);

    return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
  };
},
    snap = function snap(snapTo, value) {
  var isArray = _isArray(snapTo),
      radius,
      is2D;

  if (!isArray && _isObject(snapTo)) {
    radius = isArray = snapTo.radius || _bigNum;

    if (snapTo.values) {
      snapTo = toArray(snapTo.values);

      if (is2D = !_isNumber(snapTo[0])) {
        radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
      }
    } else {
      snapTo = _roundModifier(snapTo.increment);
    }
  }

  return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function (raw) {
    is2D = snapTo(raw);
    return Math.abs(is2D - raw) <= radius ? is2D : raw;
  } : function (raw) {
    var x = parseFloat(is2D ? raw.x : raw),
        y = parseFloat(is2D ? raw.y : 0),
        min = _bigNum,
        closest = 0,
        i = snapTo.length,
        dx,
        dy;

    while (i--) {
      if (is2D) {
        dx = snapTo[i].x - x;
        dy = snapTo[i].y - y;
        dx = dx * dx + dy * dy;
      } else {
        dx = Math.abs(snapTo[i] - x);
      }

      if (dx < min) {
        min = dx;
        closest = i;
      }
    }

    closest = !radius || min <= radius ? snapTo[closest] : raw;
    return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
  });
},
    random = function random(min, max, roundingIncrement, returnFunction) {
  return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? !!(roundingIncrement = 0) : !returnFunction, function () {
    return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5) && (returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
  });
},
    pipe = function pipe() {
  for (var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++) {
    functions[_key] = arguments[_key];
  }

  return function (value) {
    return functions.reduce(function (v, f) {
      return f(v);
    }, value);
  };
},
    unitize = function unitize(func, unit) {
  return function (value) {
    return func(parseFloat(value)) + (unit || getUnit(value));
  };
},
    normalize = function normalize(min, max, value) {
  return mapRange(min, max, 0, 1, value);
},
    _wrapArray = function _wrapArray(a, wrapper, value) {
  return _conditionalReturn(value, function (index) {
    return a[~~wrapper(index)];
  });
},
    wrap = function wrap(min, max, value) {
  // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
  var range = max - min;
  return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function (value) {
    return (range + (value - min) % range) % range + min;
  });
},
    wrapYoyo = function wrapYoyo(min, max, value) {
  var range = max - min,
      total = range * 2;
  return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function (value) {
    value = (total + (value - min) % total) % total || 0;
    return min + (value > range ? total - value : value);
  });
},
    _replaceRandom = function _replaceRandom(value) {
  //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
  var prev = 0,
      s = "",
      i,
      nums,
      end,
      isArray;

  while (~(i = value.indexOf("random(", prev))) {
    end = value.indexOf(")", i);
    isArray = value.charAt(i + 7) === "[";
    nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
    s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
    prev = end + 1;
  }

  return s + value.substr(prev, value.length - prev);
},
    mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
  var inRange = inMax - inMin,
      outRange = outMax - outMin;
  return _conditionalReturn(value, function (value) {
    return outMin + ((value - inMin) / inRange * outRange || 0);
  });
},
    interpolate = function interpolate(start, end, progress, mutate) {
  var func = isNaN(start + end) ? 0 : function (p) {
    return (1 - p) * start + p * end;
  };

  if (!func) {
    var isString = _isString(start),
        master = {},
        p,
        i,
        interpolators,
        l,
        il;

    progress === true && (mutate = 1) && (progress = null);

    if (isString) {
      start = {
        p: start
      };
      end = {
        p: end
      };
    } else if (_isArray(start) && !_isArray(end)) {
      interpolators = [];
      l = start.length;
      il = l - 2;

      for (i = 1; i < l; i++) {
        interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
      }

      l--;

      func = function func(p) {
        p *= l;
        var i = Math.min(il, ~~p);
        return interpolators[i](p - i);
      };

      progress = end;
    } else if (!mutate) {
      start = _merge(_isArray(start) ? [] : {}, start);
    }

    if (!interpolators) {
      for (p in end) {
        _addPropTween.call(master, start, p, "get", end[p]);
      }

      func = function func(p) {
        return _renderPropTweens(p, master) || (isString ? start.p : start);
      };
    }
  }

  return _conditionalReturn(progress, func);
},
    _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
  //used for nextLabel() and previousLabel()
  var labels = timeline.labels,
      min = _bigNum,
      p,
      distance,
      label;

  for (p in labels) {
    distance = labels[p] - fromTime;

    if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
      label = p;
      min = distance;
    }
  }

  return label;
},
    _callback = function _callback(animation, type, executeLazyFirst) {
  var v = animation.vars,
      callback = v[type],
      prevContext = _context,
      context = animation._ctx,
      params,
      scope,
      result;

  if (!callback) {
    return;
  }

  params = v[type + "Params"];
  scope = v.callbackScope || animation;
  executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.

  context && (_context = context);
  result = params ? callback.apply(scope, params) : callback.call(scope);
  _context = prevContext;
  return result;
},
    _interrupt = function _interrupt(animation) {
  _removeFromParent(animation);

  animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
  animation.progress() < 1 && _callback(animation, "onInterrupt");
  return animation;
},
    _quickTween,
    _registerPluginQueue = [],
    _createPlugin = function _createPlugin(config) {
  if (!config) return;
  config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.

  if (_windowExists() || config.headless) {
    // edge case: some build tools may pass in a null/undefined value
    var name = config.name,
        isFunc = _isFunction(config),
        Plugin = name && !isFunc && config.init ? function () {
      this._props = [];
    } : config,
        //in case someone passes in an object that's not a plugin, like CustomEase
    instanceDefaults = {
      init: _emptyFunc,
      render: _renderPropTweens,
      add: _addPropTween,
      kill: _killPropTweensOf,
      modifier: _addPluginModifier,
      rawVars: 0
    },
        statics = {
      targetTest: 0,
      get: 0,
      getSetter: _getSetter,
      aliases: {},
      register: 0
    };

    _wake();

    if (config !== Plugin) {
      if (_plugins[name]) {
        return;
      }

      _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods


      _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods


      _plugins[Plugin.prop = name] = Plugin;

      if (config.targetTest) {
        _harnessPlugins.push(Plugin);

        _reservedProps[name] = 1;
      }

      name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
    }

    _addGlobal(name, Plugin);

    config.register && config.register(gsap, Plugin, PropTween);
  } else {
    _registerPluginQueue.push(config);
  }
},

/*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */
_255 = 255,
    _colorLookup = {
  aqua: [0, _255, _255],
  lime: [0, _255, 0],
  silver: [192, 192, 192],
  black: [0, 0, 0],
  maroon: [128, 0, 0],
  teal: [0, 128, 128],
  blue: [0, 0, _255],
  navy: [0, 0, 128],
  white: [_255, _255, _255],
  olive: [128, 128, 0],
  yellow: [_255, _255, 0],
  orange: [_255, 165, 0],
  gray: [128, 128, 128],
  purple: [128, 0, 128],
  green: [0, 128, 0],
  red: [_255, 0, 0],
  pink: [_255, 192, 203],
  cyan: [0, _255, _255],
  transparent: [_255, _255, _255, 0]
},
    // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
  h += h < 0 ? 1 : h > 1 ? -1 : 0;
  return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
},
    splitColor = function splitColor(v, toHSL, forceAlpha) {
  var a = !v ? _colorLookup.black : _isNumber(v) ? [v >> 16, v >> 8 & _255, v & _255] : 0,
      r,
      g,
      b,
      h,
      s,
      l,
      max,
      min,
      d,
      wasHSL;

  if (!a) {
    if (v.substr(-1) === ",") {
      //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
      v = v.substr(0, v.length - 1);
    }

    if (_colorLookup[v]) {
      a = _colorLookup[v];
    } else if (v.charAt(0) === "#") {
      if (v.length < 6) {
        //for shorthand like #9F0 or #9F0F (could have alpha)
        r = v.charAt(1);
        g = v.charAt(2);
        b = v.charAt(3);
        v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
      }

      if (v.length === 9) {
        // hex with alpha, like #fd5e53ff
        a = parseInt(v.substr(1, 6), 16);
        return [a >> 16, a >> 8 & _255, a & _255, parseInt(v.substr(7), 16) / 255];
      }

      v = parseInt(v.substr(1), 16);
      a = [v >> 16, v >> 8 & _255, v & _255];
    } else if (v.substr(0, 3) === "hsl") {
      a = wasHSL = v.match(_strictNumExp);

      if (!toHSL) {
        h = +a[0] % 360 / 360;
        s = +a[1] / 100;
        l = +a[2] / 100;
        g = l <= .5 ? l * (s + 1) : l + s - l * s;
        r = l * 2 - g;
        a.length > 3 && (a[3] *= 1); //cast as number

        a[0] = _hue(h + 1 / 3, r, g);
        a[1] = _hue(h, r, g);
        a[2] = _hue(h - 1 / 3, r, g);
      } else if (~v.indexOf("=")) {
        //if relative values are found, just return the raw strings with the relative prefixes in place.
        a = v.match(_numExp);
        forceAlpha && a.length < 4 && (a[3] = 1);
        return a;
      }
    } else {
      a = v.match(_strictNumExp) || _colorLookup.transparent;
    }

    a = a.map(Number);
  }

  if (toHSL && !wasHSL) {
    r = a[0] / _255;
    g = a[1] / _255;
    b = a[2] / _255;
    max = Math.max(r, g, b);
    min = Math.min(r, g, b);
    l = (max + min) / 2;

    if (max === min) {
      h = s = 0;
    } else {
      d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
      h *= 60;
    }

    a[0] = ~~(h + .5);
    a[1] = ~~(s * 100 + .5);
    a[2] = ~~(l * 100 + .5);
  }

  forceAlpha && a.length < 4 && (a[3] = 1);
  return a;
},
    _colorOrderData = function _colorOrderData(v) {
  // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
  var values = [],
      c = [],
      i = -1;
  v.split(_colorExp).forEach(function (v) {
    var a = v.match(_numWithUnitExp) || [];
    values.push.apply(values, a);
    c.push(i += a.length + 1);
  });
  values.c = c;
  return values;
},
    _formatColors = function _formatColors(s, toHSL, orderMatchData) {
  var result = "",
      colors = (s + result).match(_colorExp),
      type = toHSL ? "hsla(" : "rgba(",
      i = 0,
      c,
      shell,
      d,
      l;

  if (!colors) {
    return s;
  }

  colors = colors.map(function (color) {
    return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
  });

  if (orderMatchData) {
    d = _colorOrderData(s);
    c = orderMatchData.c;

    if (c.join(result) !== d.c.join(result)) {
      shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
      l = shell.length - 1;

      for (; i < l; i++) {
        result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
      }
    }
  }

  if (!shell) {
    shell = s.split(_colorExp);
    l = shell.length - 1;

    for (; i < l; i++) {
      result += shell[i] + colors[i];
    }
  }

  return result + shell[l];
},
    _colorExp = function () {
  var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b",
      //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
  p;

  for (p in _colorLookup) {
    s += "|" + p + "\\b";
  }

  return new RegExp(s + ")", "gi");
}(),
    _hslExp = /hsl[a]?\(/,
    _colorStringFilter = function _colorStringFilter(a) {
  var combined = a.join(" "),
      toHSL;
  _colorExp.lastIndex = 0;

  if (_colorExp.test(combined)) {
    toHSL = _hslExp.test(combined);
    a[1] = _formatColors(a[1], toHSL);
    a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.

    return true;
  }
},

/*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */
_tickerActive,
    _ticker = function () {
  var _getTime = Date.now,
      _lagThreshold = 500,
      _adjustedLag = 33,
      _startTime = _getTime(),
      _lastUpdate = _startTime,
      _gap = 1000 / 240,
      _nextTime = _gap,
      _listeners = [],
      _id,
      _req,
      _raf,
      _self,
      _delta,
      _i,
      _tick = function _tick(v) {
    var elapsed = _getTime() - _lastUpdate,
        manual = v === true,
        overlap,
        dispatch,
        time,
        frame;

    (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
    _lastUpdate += elapsed;
    time = _lastUpdate - _startTime;
    overlap = time - _nextTime;

    if (overlap > 0 || manual) {
      frame = ++_self.frame;
      _delta = time - _self.time * 1000;
      _self.time = time = time / 1000;
      _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
      dispatch = 1;
    }

    manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.

    if (dispatch) {
      for (_i = 0; _i < _listeners.length; _i++) {
        // use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
      }
    }
  };

  _self = {
    time: 0,
    frame: 0,
    tick: function tick() {
      _tick(true);
    },
    deltaRatio: function deltaRatio(fps) {
      return _delta / (1000 / (fps || 60));
    },
    wake: function wake() {
      if (_coreReady) {
        if (!_coreInitted && _windowExists()) {
          _win = _coreInitted = window;
          _doc = _win.document || {};
          _globals.gsap = gsap;
          (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);

          _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});

          _registerPluginQueue.forEach(_createPlugin);
        }

        _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
        _id && _self.sleep();

        _req = _raf || function (f) {
          return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
        };

        _tickerActive = 1;

        _tick(2);
      }
    },
    sleep: function sleep() {
      (_raf ? cancelAnimationFrame : clearTimeout)(_id);
      _tickerActive = 0;
      _req = _emptyFunc;
    },
    lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
      _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited

      _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
    },
    fps: function fps(_fps) {
      _gap = 1000 / (_fps || 240);
      _nextTime = _self.time * 1000 + _gap;
    },
    add: function add(callback, once, prioritize) {
      var func = once ? function (t, d, f, v) {
        callback(t, d, f, v);

        _self.remove(func);
      } : callback;

      _self.remove(callback);

      _listeners[prioritize ? "unshift" : "push"](func);

      _wake();

      return func;
    },
    remove: function remove(callback, i) {
      ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
    },
    _listeners: _listeners
  };
  return _self;
}(),
    _wake = function _wake() {
  return !_tickerActive && _ticker.wake();
},
    //also ensures the core classes are initialized.

/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/
_easeMap = {},
    _customEaseExp = /^[\d.\-M][\d.\-,\s]/,
    _quotesExp = /["']/g,
    _parseObjectInString = function _parseObjectInString(value) {
  //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
  var obj = {},
      split = value.substr(1, value.length - 3).split(":"),
      key = split[0],
      i = 1,
      l = split.length,
      index,
      val,
      parsedVal;

  for (; i < l; i++) {
    val = split[i];
    index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
    parsedVal = val.substr(0, index);
    obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
    key = val.substr(index + 1).trim();
  }

  return obj;
},
    _valueInParentheses = function _valueInParentheses(value) {
  var open = value.indexOf("(") + 1,
      close = value.indexOf(")"),
      nested = value.indexOf("(", open);
  return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
},
    _configEaseFromString = function _configEaseFromString(name) {
  //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
  var split = (name + "").split("("),
      ease = _easeMap[split[0]];
  return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [_parseObjectInString(split[1])] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
},
    _invertEase = function _invertEase(ease) {
  return function (p) {
    return 1 - ease(1 - p);
  };
},
    // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
  var child = timeline._first,
      ease;

  while (child) {
    if (child instanceof Timeline) {
      _propagateYoyoEase(child, isYoyo);
    } else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
      if (child.timeline) {
        _propagateYoyoEase(child.timeline, isYoyo);
      } else {
        ease = child._ease;
        child._ease = child._yEase;
        child._yEase = ease;
        child._yoyo = isYoyo;
      }
    }

    child = child._next;
  }
},
    _parseEase = function _parseEase(ease, defaultEase) {
  return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
},
    _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
  if (easeOut === void 0) {
    easeOut = function easeOut(p) {
      return 1 - easeIn(1 - p);
    };
  }

  if (easeInOut === void 0) {
    easeInOut = function easeInOut(p) {
      return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
  }

  var ease = {
    easeIn: easeIn,
    easeOut: easeOut,
    easeInOut: easeInOut
  },
      lowercaseName;

  _forEachName(names, function (name) {
    _easeMap[name] = _globals[name] = ease;
    _easeMap[lowercaseName = name.toLowerCase()] = easeOut;

    for (var p in ease) {
      _easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    }
  });

  return ease;
},
    _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
  return function (p) {
    return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
  };
},
    _configElastic = function _configElastic(type, amplitude, period) {
  var p1 = amplitude >= 1 ? amplitude : 1,
      //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
  p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1),
      p3 = p2 / _2PI * (Math.asin(1 / p1) || 0),
      easeOut = function easeOut(p) {
    return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
  },
      ease = type === "out" ? easeOut : type === "in" ? function (p) {
    return 1 - easeOut(1 - p);
  } : _easeInOutFromOut(easeOut);

  p2 = _2PI / p2; //precalculate to optimize

  ease.config = function (amplitude, period) {
    return _configElastic(type, amplitude, period);
  };

  return ease;
},
    _configBack = function _configBack(type, overshoot) {
  if (overshoot === void 0) {
    overshoot = 1.70158;
  }

  var easeOut = function easeOut(p) {
    return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
  },
      ease = type === "out" ? easeOut : type === "in" ? function (p) {
    return 1 - easeOut(1 - p);
  } : _easeInOutFromOut(easeOut);

  ease.config = function (overshoot) {
    return _configBack(type, overshoot);
  };

  return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };


_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function (name, i) {
  var power = i < 5 ? i + 1 : i;

  _insertEase(name + ",Power" + (power - 1), i ? function (p) {
    return Math.pow(p, power);
  } : function (p) {
    return p;
  }, function (p) {
    return 1 - Math.pow(1 - p, power);
  }, function (p) {
    return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
  });
});

_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;

_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());

(function (n, c) {
  var n1 = 1 / c,
      n2 = 2 * n1,
      n3 = 2.5 * n1,
      easeOut = function easeOut(p) {
    return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
  };

  _insertEase("Bounce", function (p) {
    return 1 - easeOut(1 - p);
  }, easeOut);
})(7.5625, 2.75);

_insertEase("Expo", function (p) {
  return p ? Math.pow(2, 10 * (p - 1)) : 0;
});

_insertEase("Circ", function (p) {
  return -(_sqrt(1 - p * p) - 1);
});

_insertEase("Sine", function (p) {
  return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});

_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());

_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
  config: function config(steps, immediateStart) {
    if (steps === void 0) {
      steps = 1;
    }

    var p1 = 1 / steps,
        p2 = steps + (immediateStart ? 0 : 1),
        p3 = immediateStart ? 1 : 0,
        max = 1 - _tinyNum;
    return function (p) {
      return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
    };
  }
};
_defaults.ease = _easeMap["quad.out"];

_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function (name) {
  return _callbackNames += name + "," + name + "Params,";
});
/*
 * --------------------------------------------------------------------------------------
 * CACHE
 * --------------------------------------------------------------------------------------
 */


var GSCache = function GSCache(target, harness) {
  this.id = _gsID++;
  target._gsap = this;
  this.target = target;
  this.harness = harness;
  this.get = harness ? harness.get : _getProperty;
  this.set = harness ? harness.getSetter : _getSetter;
};
/*
 * --------------------------------------------------------------------------------------
 * ANIMATION
 * --------------------------------------------------------------------------------------
 */

var Animation = /*#__PURE__*/function () {
  function Animation(vars) {
    this.vars = vars;
    this._delay = +vars.delay || 0;

    if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
      // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
      this._rDelay = vars.repeatDelay || 0;
      this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
    }

    this._ts = 1;

    _setDuration(this, +vars.duration, 1, 1);

    this.data = vars.data;

    if (_context) {
      this._ctx = _context;

      _context.data.push(this);
    }

    _tickerActive || _ticker.wake();
  }

  var _proto = Animation.prototype;

  _proto.delay = function delay(value) {
    if (value || value === 0) {
      this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
      this._delay = value;
      return this;
    }

    return this._delay;
  };

  _proto.duration = function duration(value) {
    return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
  };

  _proto.totalDuration = function totalDuration(value) {
    if (!arguments.length) {
      return this._tDur;
    }

    this._dirty = 0;
    return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
  };

  _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
    _wake();

    if (!arguments.length) {
      return this._tTime;
    }

    var parent = this._dp;

    if (parent && parent.smoothChildTiming && this._ts) {
      _alignPlayhead(this, _totalTime);

      !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
      //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.

      while (parent && parent.parent) {
        if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) {
          parent.totalTime(parent._tTime, true);
        }

        parent = parent.parent;
      }

      if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) {
        //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
        _addToTimeline(this._dp, this, this._start - this._delay);
      }
    }

    if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
      // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
      this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
      //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
      //   this._lock = 1;

      _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
      //}

    }

    return this;
  };

  _proto.time = function time(value, suppressEvents) {
    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
  };

  _proto.totalProgress = function totalProgress(value, suppressEvents) {
    return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() > 0 ? 1 : 0;
  };

  _proto.progress = function progress(value, suppressEvents) {
    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
  };

  _proto.iteration = function iteration(value, suppressEvents) {
    var cycleDuration = this.duration() + this._rDelay;

    return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
  } // potential future addition:
  // isPlayingBackwards() {
  // 	let animation = this,
  // 		orientation = 1; // 1 = forward, -1 = backward
  // 	while (animation) {
  // 		orientation *= animation.reversed() || (animation.repeat() && !(animation.iteration() & 1)) ? -1 : 1;
  // 		animation = animation.parent;
  // 	}
  // 	return orientation < 0;
  // }
  ;

  _proto.timeScale = function timeScale(value, suppressEvents) {
    if (!arguments.length) {
      return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
    }

    if (this._rts === value) {
      return this;
    }

    var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
    // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
    //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
    // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.

    this._rts = +value || 0;
    this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.

    this.totalTime(_clamp(-Math.abs(this._delay), this._tDur, tTime), suppressEvents !== false);

    _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.


    return _recacheAncestors(this);
  };

  _proto.paused = function paused(value) {
    if (!arguments.length) {
      return this._ps;
    }

    if (this._ps !== value) {
      this._ps = value;

      if (value) {
        this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.

        this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
      } else {
        _wake();

        this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.

        this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
      }
    }

    return this;
  };

  _proto.startTime = function startTime(value) {
    if (arguments.length) {
      this._start = value;
      var parent = this.parent || this._dp;
      parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
      return this;
    }

    return this._start;
  };

  _proto.endTime = function endTime(includeRepeats) {
    return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
  };

  _proto.rawTime = function rawTime(wrapRepeats) {
    var parent = this.parent || this._dp; // _dp = detached parent

    return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
  };

  _proto.revert = function revert(config) {
    if (config === void 0) {
      config = _revertConfig;
    }

    var prevIsReverting = _reverting;
    _reverting = config;

    if (this._initted || this._startAt) {
      this.timeline && this.timeline.revert(config);
      this.totalTime(-0.01, config.suppressEvents);
    }

    this.data !== "nested" && config.kill !== false && this.kill();
    _reverting = prevIsReverting;
    return this;
  };

  _proto.globalTime = function globalTime(rawTime) {
    var animation = this,
        time = arguments.length ? rawTime : animation.rawTime();

    while (animation) {
      time = animation._start + time / (Math.abs(animation._ts) || 1);
      animation = animation._dp;
    }

    return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
  };

  _proto.repeat = function repeat(value) {
    if (arguments.length) {
      this._repeat = value === Infinity ? -2 : value;
      return _onUpdateTotalDuration(this);
    }

    return this._repeat === -2 ? Infinity : this._repeat;
  };

  _proto.repeatDelay = function repeatDelay(value) {
    if (arguments.length) {
      var time = this._time;
      this._rDelay = value;

      _onUpdateTotalDuration(this);

      return time ? this.time(time) : this;
    }

    return this._rDelay;
  };

  _proto.yoyo = function yoyo(value) {
    if (arguments.length) {
      this._yoyo = value;
      return this;
    }

    return this._yoyo;
  };

  _proto.seek = function seek(position, suppressEvents) {
    return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
  };

  _proto.restart = function restart(includeDelay, suppressEvents) {
    return this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
  };

  _proto.play = function play(from, suppressEvents) {
    from != null && this.seek(from, suppressEvents);
    return this.reversed(false).paused(false);
  };

  _proto.reverse = function reverse(from, suppressEvents) {
    from != null && this.seek(from || this.totalDuration(), suppressEvents);
    return this.reversed(true).paused(false);
  };

  _proto.pause = function pause(atTime, suppressEvents) {
    atTime != null && this.seek(atTime, suppressEvents);
    return this.paused(true);
  };

  _proto.resume = function resume() {
    return this.paused(false);
  };

  _proto.reversed = function reversed(value) {
    if (arguments.length) {
      !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.

      return this;
    }

    return this._rts < 0;
  };

  _proto.invalidate = function invalidate() {
    this._initted = this._act = 0;
    this._zTime = -_tinyNum;
    return this;
  };

  _proto.isActive = function isActive() {
    var parent = this.parent || this._dp,
        start = this._start,
        rawTime;
    return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
  };

  _proto.eventCallback = function eventCallback(type, callback, params) {
    var vars = this.vars;

    if (arguments.length > 1) {
      if (!callback) {
        delete vars[type];
      } else {
        vars[type] = callback;
        params && (vars[type + "Params"] = params);
        type === "onUpdate" && (this._onUpdate = callback);
      }

      return this;
    }

    return vars[type];
  };

  _proto.then = function then(onFulfilled) {
    var self = this;
    return new Promise(function (resolve) {
      var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough,
          _resolve = function _resolve() {
        var _then = self.then;
        self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)

        _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
        resolve(f);
        self.then = _then;
      };

      if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) {
        _resolve();
      } else {
        self._prom = _resolve;
      }
    });
  };

  _proto.kill = function kill() {
    _interrupt(this);
  };

  return Animation;
}();

_setDefaults(Animation.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: false,
  parent: null,
  _initted: false,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -_tinyNum,
  _prom: 0,
  _ps: false,
  _rts: 1
});
/*
 * -------------------------------------------------
 * TIMELINE
 * -------------------------------------------------
 */


var Timeline = /*#__PURE__*/function (_Animation) {
  _inheritsLoose(Timeline, _Animation);

  function Timeline(vars, position) {
    var _this;

    if (vars === void 0) {
      vars = {};
    }

    _this = _Animation.call(this, vars) || this;
    _this.labels = {};
    _this.smoothChildTiming = !!vars.smoothChildTiming;
    _this.autoRemoveChildren = !!vars.autoRemoveChildren;
    _this._sort = _isNotFalse(vars.sortChildren);
    _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
    vars.reversed && _this.reverse();
    vars.paused && _this.paused(true);
    vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
    return _this;
  }

  var _proto2 = Timeline.prototype;

  _proto2.to = function to(targets, vars, position) {
    _createTweenType(0, arguments, this);

    return this;
  };

  _proto2.from = function from(targets, vars, position) {
    _createTweenType(1, arguments, this);

    return this;
  };

  _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
    _createTweenType(2, arguments, this);

    return this;
  };

  _proto2.set = function set(targets, vars, position) {
    vars.duration = 0;
    vars.parent = this;
    _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
    vars.immediateRender = !!vars.immediateRender;
    new Tween(targets, vars, _parsePosition(this, position), 1);
    return this;
  };

  _proto2.call = function call(callback, params, position) {
    return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
  } //ONLY for backward compatibility! Maybe delete?
  ;

  _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
    vars.duration = duration;
    vars.stagger = vars.stagger || stagger;
    vars.onComplete = onCompleteAll;
    vars.onCompleteParams = onCompleteAllParams;
    vars.parent = this;
    new Tween(targets, vars, _parsePosition(this, position));
    return this;
  };

  _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
    vars.runBackwards = 1;
    _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
    return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
  };

  _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
    toVars.startAt = fromVars;
    _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
    return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
  };

  _proto2.render = function render(totalTime, suppressEvents, force) {
    var prevTime = this._time,
        tDur = this._dirty ? this.totalDuration() : this._tDur,
        dur = this._dur,
        tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime),
        // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
    crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur),
        time,
        child,
        next,
        iteration,
        cycleDuration,
        prevPaused,
        pauseTween,
        timeScale,
        prevStart,
        prevIteration,
        yoyo,
        isYoyo;
    this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);

    if (tTime !== this._tTime || force || crossingStart) {
      if (prevTime !== this._time && dur) {
        //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
        tTime += this._time - prevTime;
        totalTime += this._time - prevTime;
      }

      time = tTime;
      prevStart = this._start;
      timeScale = this._ts;
      prevPaused = !timeScale;

      if (crossingStart) {
        dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.

        (totalTime || !suppressEvents) && (this._zTime = totalTime);
      }

      if (this._repeat) {
        //adjust the time for repeats and yoyos
        yoyo = this._yoyo;
        cycleDuration = dur + this._rDelay;

        if (this._repeat < -1 && totalTime < 0) {
          return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
        }

        time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)

        if (tTime === tDur) {
          // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
          iteration = this._repeat;
          time = dur;
        } else {
          iteration = ~~(tTime / cycleDuration);

          if (iteration && iteration === tTime / cycleDuration) {
            time = dur;
            iteration--;
          }

          time > dur && (time = dur);
        }

        prevIteration = _animationCycle(this._tTime, cycleDuration);
        !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion

        if (yoyo && iteration & 1) {
          time = dur - time;
          isYoyo = 1;
        }
        /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */


        if (iteration !== prevIteration && !this._lock) {
          var rewinding = yoyo && prevIteration & 1,
              doesWrap = rewinding === (yoyo && iteration & 1);
          iteration < prevIteration && (rewinding = !rewinding);
          prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.

          this._lock = 1;
          this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
          this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.

          !suppressEvents && this.parent && _callback(this, "onRepeat");
          this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);

          if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) {
            // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
            return this;
          }

          dur = this._dur; // in case the duration changed in the onRepeat

          tDur = this._tDur;

          if (doesWrap) {
            this._lock = 2;
            prevTime = rewinding ? dur : -0.0001;
            this.render(prevTime, true);
            this.vars.repeatRefresh && !isYoyo && this.invalidate();
          }

          this._lock = 0;

          if (!this._ts && !prevPaused) {
            return this;
          } //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.


          _propagateYoyoEase(this, isYoyo);
        }
      }

      if (this._hasPause && !this._forcing && this._lock < 2) {
        pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));

        if (pauseTween) {
          tTime -= time - (time = pauseTween._start);
        }
      }

      this._tTime = tTime;
      this._time = time;
      this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.

      if (!this._initted) {
        this._onUpdate = this.vars.onUpdate;
        this._initted = 1;
        this._zTime = totalTime;
        prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
      }

      if (!prevTime && time && !suppressEvents && !iteration) {
        _callback(this, "onStart");

        if (this._tTime !== tTime) {
          // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
          return this;
        }
      }

      if (time >= prevTime && totalTime >= 0) {
        child = this._first;

        while (child) {
          next = child._next;

          if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
            if (child.parent !== this) {
              // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
              return this.render(totalTime, suppressEvents, force);
            }

            child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);

            if (time !== this._time || !this._ts && !prevPaused) {
              //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
              pauseTween = 0;
              next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)

              break;
            }
          }

          child = next;
        }
      } else {
        child = this._last;
        var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.

        while (child) {
          next = child._prev;

          if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
            if (child.parent !== this) {
              // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
              return this.render(totalTime, suppressEvents, force);
            }

            child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && (child._initted || child._startAt)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.

            if (time !== this._time || !this._ts && !prevPaused) {
              //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
              pauseTween = 0;
              next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)

              break;
            }
          }

          child = next;
        }
      }

      if (pauseTween && !suppressEvents) {
        this.pause();
        pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;

        if (this._ts) {
          //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
          this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.

          _setEnd(this);

          return this.render(totalTime, suppressEvents, force);
        }
      }

      this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
      if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) if (!this._lock) {
        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.

        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
          _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);

          this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
        }
      }
    }

    return this;
  };

  _proto2.add = function add(child, position) {
    var _this2 = this;

    _isNumber(position) || (position = _parsePosition(this, position, child));

    if (!(child instanceof Animation)) {
      if (_isArray(child)) {
        child.forEach(function (obj) {
          return _this2.add(obj, position);
        });
        return this;
      }

      if (_isString(child)) {
        return this.addLabel(child, position);
      }

      if (_isFunction(child)) {
        child = Tween.delayedCall(0, child);
      } else {
        return this;
      }
    }

    return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
  };

  _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
    if (nested === void 0) {
      nested = true;
    }

    if (tweens === void 0) {
      tweens = true;
    }

    if (timelines === void 0) {
      timelines = true;
    }

    if (ignoreBeforeTime === void 0) {
      ignoreBeforeTime = -_bigNum;
    }

    var a = [],
        child = this._first;

    while (child) {
      if (child._start >= ignoreBeforeTime) {
        if (child instanceof Tween) {
          tweens && a.push(child);
        } else {
          timelines && a.push(child);
          nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
        }
      }

      child = child._next;
    }

    return a;
  };

  _proto2.getById = function getById(id) {
    var animations = this.getChildren(1, 1, 1),
        i = animations.length;

    while (i--) {
      if (animations[i].vars.id === id) {
        return animations[i];
      }
    }
  };

  _proto2.remove = function remove(child) {
    if (_isString(child)) {
      return this.removeLabel(child);
    }

    if (_isFunction(child)) {
      return this.killTweensOf(child);
    }

    _removeLinkedListItem(this, child);

    if (child === this._recent) {
      this._recent = this._last;
    }

    return _uncache(this);
  };

  _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
    if (!arguments.length) {
      return this._tTime;
    }

    this._forcing = 1;

    if (!this._dp && this._ts) {
      //special case for the global timeline (or any other that has no parent or detached parent).
      this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
    }

    _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);

    this._forcing = 0;
    return this;
  };

  _proto2.addLabel = function addLabel(label, position) {
    this.labels[label] = _parsePosition(this, position);
    return this;
  };

  _proto2.removeLabel = function removeLabel(label) {
    delete this.labels[label];
    return this;
  };

  _proto2.addPause = function addPause(position, callback, params) {
    var t = Tween.delayedCall(0, callback || _emptyFunc, params);
    t.data = "isPause";
    this._hasPause = 1;
    return _addToTimeline(this, t, _parsePosition(this, position));
  };

  _proto2.removePause = function removePause(position) {
    var child = this._first;
    position = _parsePosition(this, position);

    while (child) {
      if (child._start === position && child.data === "isPause") {
        _removeFromParent(child);
      }

      child = child._next;
    }
  };

  _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
    var tweens = this.getTweensOf(targets, onlyActive),
        i = tweens.length;

    while (i--) {
      _overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
    }

    return this;
  };

  _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
    var a = [],
        parsedTargets = toArray(targets),
        child = this._first,
        isGlobalTime = _isNumber(onlyActive),
        // a number is interpreted as a global time. If the animation spans
    children;

    while (child) {
      if (child instanceof Tween) {
        if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) {
          // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
          a.push(child);
        }
      } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) {
        a.push.apply(a, children);
      }

      child = child._next;
    }

    return a;
  } // potential future feature - targets() on timelines
  // targets() {
  // 	let result = [];
  // 	this.getChildren(true, true, false).forEach(t => result.push(...t.targets()));
  // 	return result.filter((v, i) => result.indexOf(v) === i);
  // }
  ;

  _proto2.tweenTo = function tweenTo(position, vars) {
    vars = vars || {};

    var tl = this,
        endTime = _parsePosition(tl, position),
        _vars = vars,
        startAt = _vars.startAt,
        _onStart = _vars.onStart,
        onStartParams = _vars.onStartParams,
        immediateRender = _vars.immediateRender,
        initted,
        tween = Tween.to(tl, _setDefaults({
      ease: vars.ease || "none",
      lazy: false,
      immediateRender: false,
      time: endTime,
      overwrite: "auto",
      duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
      onStart: function onStart() {
        tl.pause();

        if (!initted) {
          var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
          tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
          initted = 1;
        }

        _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
      }
    }, vars));

    return immediateRender ? tween.render(0) : tween;
  };

  _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
    return this.tweenTo(toPosition, _setDefaults({
      startAt: {
        time: _parsePosition(this, fromPosition)
      }
    }, vars));
  };

  _proto2.recent = function recent() {
    return this._recent;
  };

  _proto2.nextLabel = function nextLabel(afterTime) {
    if (afterTime === void 0) {
      afterTime = this._time;
    }

    return _getLabelInDirection(this, _parsePosition(this, afterTime));
  };

  _proto2.previousLabel = function previousLabel(beforeTime) {
    if (beforeTime === void 0) {
      beforeTime = this._time;
    }

    return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
  };

  _proto2.currentLabel = function currentLabel(value) {
    return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
  };

  _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
    if (ignoreBeforeTime === void 0) {
      ignoreBeforeTime = 0;
    }

    var child = this._first,
        labels = this.labels,
        p;

    while (child) {
      if (child._start >= ignoreBeforeTime) {
        child._start += amount;
        child._end += amount;
      }

      child = child._next;
    }

    if (adjustLabels) {
      for (p in labels) {
        if (labels[p] >= ignoreBeforeTime) {
          labels[p] += amount;
        }
      }
    }

    return _uncache(this);
  };

  _proto2.invalidate = function invalidate(soft) {
    var child = this._first;
    this._lock = 0;

    while (child) {
      child.invalidate(soft);
      child = child._next;
    }

    return _Animation.prototype.invalidate.call(this, soft);
  };

  _proto2.clear = function clear(includeLabels) {
    if (includeLabels === void 0) {
      includeLabels = true;
    }

    var child = this._first,
        next;

    while (child) {
      next = child._next;
      this.remove(child);
      child = next;
    }

    this._dp && (this._time = this._tTime = this._pTime = 0);
    includeLabels && (this.labels = {});
    return _uncache(this);
  };

  _proto2.totalDuration = function totalDuration(value) {
    var max = 0,
        self = this,
        child = self._last,
        prevStart = _bigNum,
        prev,
        start,
        parent;

    if (arguments.length) {
      return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
    }

    if (self._dirty) {
      parent = self.parent;

      while (child) {
        prev = child._prev; //record it here in case the tween changes position in the sequence...

        child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.

        start = child._start;

        if (start > prevStart && self._sort && child._ts && !self._lock) {
          //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
          self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().

          _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
        } else {
          prevStart = start;
        }

        if (start < 0 && child._ts) {
          //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
          max -= start;

          if (!parent && !self._dp || parent && parent.smoothChildTiming) {
            self._start += start / self._ts;
            self._time -= start;
            self._tTime -= start;
          }

          self.shiftChildren(-start, false, -1e999);
          prevStart = 0;
        }

        child._end > max && child._ts && (max = child._end);
        child = prev;
      }

      _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);

      self._dirty = 0;
    }

    return self._tDur;
  };

  Timeline.updateRoot = function updateRoot(time) {
    if (_globalTimeline._ts) {
      _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));

      _lastRenderedFrame = _ticker.frame;
    }

    if (_ticker.frame >= _nextGCFrame) {
      _nextGCFrame += _config.autoSleep || 120;
      var child = _globalTimeline._first;
      if (!child || !child._ts) if (_config.autoSleep && _ticker._listeners.length < 2) {
        while (child && !child._ts) {
          child = child._next;
        }

        child || _ticker.sleep();
      }
    }
  };

  return Timeline;
}(Animation);

_setDefaults(Timeline.prototype, {
  _lock: 0,
  _hasPause: 0,
  _forcing: 0
});

var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
  //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
  var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter),
      index = 0,
      matchIndex = 0,
      result,
      startNums,
      color,
      endNum,
      chunk,
      startNum,
      hasRandom,
      a;
  pt.b = start;
  pt.e = end;
  start += ""; //ensure values are strings

  end += "";

  if (hasRandom = ~end.indexOf("random(")) {
    end = _replaceRandom(end);
  }

  if (stringFilter) {
    a = [start, end];
    stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.

    start = a[0];
    end = a[1];
  }

  startNums = start.match(_complexStringNumExp) || [];

  while (result = _complexStringNumExp.exec(end)) {
    endNum = result[0];
    chunk = end.substring(index, result.index);

    if (color) {
      color = (color + 1) % 5;
    } else if (chunk.substr(-5) === "rgba(") {
      color = 1;
    }

    if (endNum !== startNums[matchIndex++]) {
      startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.

      pt._pt = {
        _next: pt._pt,
        p: chunk || matchIndex === 1 ? chunk : ",",
        //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
        s: startNum,
        c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
        m: color && color < 4 ? Math.round : 0
      };
      index = _complexStringNumExp.lastIndex;
    }
  }

  pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)

  pt.fp = funcParam;

  if (_relExp.test(end) || hasRandom) {
    pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
  }

  this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.

  return pt;
},
    _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
  _isFunction(end) && (end = end(index || 0, target, targets));
  var currentValue = target[prop],
      parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](),
      setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc,
      pt;

  if (_isString(end)) {
    if (~end.indexOf("random(")) {
      end = _replaceRandom(end);
    }

    if (end.charAt(1) === "=") {
      pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);

      if (pt || pt === 0) {
        // to avoid isNaN, like if someone passes in a value like "!= whatever"
        end = pt;
      }
    }
  }

  if (!optional || parsedStart !== end || _forceAllPropTweens) {
    if (!isNaN(parsedStart * end) && end !== "") {
      // fun fact: any number multiplied by "" is evaluated as the number 0!
      pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
      funcParam && (pt.fp = funcParam);
      modifier && pt.modifier(modifier, this, target);
      return this._pt = pt;
    }

    !currentValue && !(prop in target) && _missingPlugin(prop, end);
    return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
  }
},
    //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
  _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));

  if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) {
    return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
  }

  var copy = {},
      p;

  for (p in vars) {
    copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
  }

  return copy;
},
    _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
  var plugin, pt, ptLookup, i;

  if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
    tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);

    if (tween !== _quickTween) {
      ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.

      i = plugin._props.length;

      while (i--) {
        ptLookup[plugin._props[i]] = pt;
      }
    }
  }

  return plugin;
},
    _overwritingTween,
    //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens,
    _initTween = function _initTween(tween, time, tTime) {
  var vars = tween.vars,
      ease = vars.ease,
      startAt = vars.startAt,
      immediateRender = vars.immediateRender,
      lazy = vars.lazy,
      onUpdate = vars.onUpdate,
      runBackwards = vars.runBackwards,
      yoyoEase = vars.yoyoEase,
      keyframes = vars.keyframes,
      autoRevert = vars.autoRevert,
      dur = tween._dur,
      prevStartAt = tween._startAt,
      targets = tween._targets,
      parent = tween.parent,
      fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets,
      autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites,
      tl = tween.timeline,
      cleanVars,
      i,
      p,
      pt,
      target,
      hasPriority,
      gsData,
      harness,
      plugin,
      ptLookup,
      index,
      harnessVars,
      overwritten;
  tl && (!keyframes || !ease) && (ease = "none");
  tween._ease = _parseEase(ease, _defaults.ease);
  tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;

  if (yoyoEase && tween._yoyo && !tween._repeat) {
    //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
    yoyoEase = tween._yEase;
    tween._yEase = tween._ease;
    tween._ease = yoyoEase;
  }

  tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.

  if (!tl || keyframes && !vars.stagger) {
    //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
    harness = targets[0] ? _getCache(targets[0]).harness : 0;
    harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.

    cleanVars = _copyExcluding(vars, _reservedProps);

    if (prevStartAt) {
      prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.

      time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
      // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.

      prevStartAt._lazy = 0;
    }

    if (startAt) {
      _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
        data: "isStart",
        overwrite: false,
        parent: parent,
        immediateRender: true,
        lazy: !prevStartAt && _isNotFalse(lazy),
        startAt: null,
        delay: 0,
        onUpdate: onUpdate && function () {
          return _callback(tween, "onUpdate");
        },
        stagger: 0
      }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);


      tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.

      tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween

      time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.

      if (immediateRender) {
        if (dur && time <= 0 && tTime <= 0) {
          // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
          time && (tween._zTime = time);
          return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
        }
      }
    } else if (runBackwards && dur) {
      //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
      if (!prevStartAt) {
        time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0

        p = _setDefaults({
          overwrite: false,
          data: "isFromStart",
          //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
          lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
          immediateRender: immediateRender,
          //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
          stagger: 0,
          parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})

        }, cleanVars);
        harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})

        _removeFromParent(tween._startAt = Tween.set(targets, p));

        tween._startAt._dp = 0; // don't allow it to get put back into root timeline!

        tween._startAt._sat = tween; // used in globalTime()

        time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
        tween._zTime = time;

        if (!immediateRender) {
          _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded

        } else if (!time) {
          return;
        }
      }
    }

    tween._pt = tween._ptCache = 0;
    lazy = dur && _isNotFalse(lazy) || lazy && !dur;

    for (i = 0; i < targets.length; i++) {
      target = targets[i];
      gsData = target._gsap || _harness(targets)[i]._gsap;
      tween._ptLookup[i] = ptLookup = {};
      _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)

      index = fullTargets === targets ? i : fullTargets.indexOf(target);

      if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);

        plugin._props.forEach(function (name) {
          ptLookup[name] = pt;
        });

        plugin.priority && (hasPriority = 1);
      }

      if (!harness || harnessVars) {
        for (p in cleanVars) {
          if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) {
            plugin.priority && (hasPriority = 1);
          } else {
            ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
          }
        }
      }

      tween._op && tween._op[i] && tween.kill(target, tween._op[i]);

      if (autoOverwrite && tween._pt) {
        _overwritingTween = tween;

        _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!


        overwritten = !tween.parent;
        _overwritingTween = 0;
      }

      tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
    }

    hasPriority && _sortPropTweensByPriority(tween);
    tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
  }

  tween._onUpdate = onUpdate;
  tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.

  keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
},
    _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
  var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property],
      pt,
      rootPT,
      lookup,
      i;

  if (!ptCache) {
    ptCache = tween._ptCache[property] = [];
    lookup = tween._ptLookup;
    i = tween._targets.length;

    while (i--) {
      pt = lookup[i][property];

      if (pt && pt.d && pt.d._pt) {
        // it's a plugin, so find the nested PropTween
        pt = pt.d._pt;

        while (pt && pt.p !== property && pt.fp !== property) {
          // "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
          pt = pt._next;
        }
      }

      if (!pt) {
        // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
        // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
        _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.

        tween.vars[property] = "+=0";

        _initTween(tween, time);

        _forceAllPropTweens = 0;
        return skipRecursion ? _warn(property + " not eligible for reset") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
      }

      ptCache.push(pt);
    }
  }

  i = ptCache.length;

  while (i--) {
    rootPT = ptCache[i];
    pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.

    pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
    pt.c = value - pt.s;
    rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)

    rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
  }
},
    _addAliasesToVars = function _addAliasesToVars(targets, vars) {
  var harness = targets[0] ? _getCache(targets[0]).harness : 0,
      propertyAliases = harness && harness.aliases,
      copy,
      p,
      i,
      aliases;

  if (!propertyAliases) {
    return vars;
  }

  copy = _merge({}, vars);

  for (p in propertyAliases) {
    if (p in copy) {
      aliases = propertyAliases[p].split(",");
      i = aliases.length;

      while (i--) {
        copy[aliases[i]] = copy[p];
      }
    }
  }

  return copy;
},
    // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
  var ease = obj.ease || easeEach || "power1.inOut",
      p,
      a;

  if (_isArray(obj)) {
    a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease

    obj.forEach(function (value, i) {
      return a.push({
        t: i / (obj.length - 1) * 100,
        v: value,
        e: ease
      });
    });
  } else {
    for (p in obj) {
      a = allProps[p] || (allProps[p] = []);
      p === "ease" || a.push({
        t: parseFloat(prop),
        v: obj[p],
        e: ease
      });
    }
  }
},
    _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
  return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
},
    _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert",
    _staggerPropsToSkip = {};

_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function (name) {
  return _staggerPropsToSkip[name] = 1;
});
/*
 * --------------------------------------------------------------------------------------
 * TWEEN
 * --------------------------------------------------------------------------------------
 */


var Tween = /*#__PURE__*/function (_Animation2) {
  _inheritsLoose(Tween, _Animation2);

  function Tween(targets, vars, position, skipInherit) {
    var _this3;

    if (typeof vars === "number") {
      position.duration = vars;
      vars = position;
      position = null;
    }

    _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
    var _this3$vars = _this3.vars,
        duration = _this3$vars.duration,
        delay = _this3$vars.delay,
        immediateRender = _this3$vars.immediateRender,
        stagger = _this3$vars.stagger,
        overwrite = _this3$vars.overwrite,
        keyframes = _this3$vars.keyframes,
        defaults = _this3$vars.defaults,
        scrollTrigger = _this3$vars.scrollTrigger,
        yoyoEase = _this3$vars.yoyoEase,
        parent = vars.parent || _globalTimeline,
        parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [targets] : toArray(targets),
        tl,
        i,
        copy,
        l,
        p,
        curTarget,
        staggerFunc,
        staggerVarsToMerge;
    _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
    _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property

    _this3._overwrite = overwrite;

    if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
      vars = _this3.vars;
      tl = _this3.timeline = new Timeline({
        data: "nested",
        defaults: defaults || {},
        targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
      }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.

      tl.kill();
      tl.parent = tl._dp = _assertThisInitialized(_this3);
      tl._start = 0;

      if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
        l = parsedTargets.length;
        staggerFunc = stagger && distribute(stagger);

        if (_isObject(stagger)) {
          //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
          for (p in stagger) {
            if (~_staggerTweenProps.indexOf(p)) {
              staggerVarsToMerge || (staggerVarsToMerge = {});
              staggerVarsToMerge[p] = stagger[p];
            }
          }
        }

        for (i = 0; i < l; i++) {
          copy = _copyExcluding(vars, _staggerPropsToSkip);
          copy.stagger = 0;
          yoyoEase && (copy.yoyoEase = yoyoEase);
          staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
          curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.

          copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
          copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;

          if (!stagger && l === 1 && copy.delay) {
            // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
            _this3._delay = delay = copy.delay;
            _this3._start += delay;
            copy.delay = 0;
          }

          tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
          tl._ease = _easeMap.none;
        }

        tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
      } else if (keyframes) {
        _inheritDefaults(_setDefaults(tl.vars.defaults, {
          ease: "none"
        }));

        tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
        var time = 0,
            a,
            kf,
            v;

        if (_isArray(keyframes)) {
          keyframes.forEach(function (frame) {
            return tl.to(parsedTargets, frame, ">");
          });
          tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
        } else {
          copy = {};

          for (p in keyframes) {
            p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
          }

          for (p in copy) {
            a = copy[p].sort(function (a, b) {
              return a.t - b.t;
            });
            time = 0;

            for (i = 0; i < a.length; i++) {
              kf = a[i];
              v = {
                ease: kf.e,
                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
              };
              v[p] = kf.v;
              tl.to(parsedTargets, v, time);
              time += v.duration;
            }
          }

          tl.duration() < duration && tl.to({}, {
            duration: duration - tl.duration()
          }); // in case keyframes didn't go to 100%
        }
      }

      duration || _this3.duration(duration = tl.duration());
    } else {
      _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
    }

    if (overwrite === true && !_suppressOverwrites) {
      _overwritingTween = _assertThisInitialized(_this3);

      _globalTimeline.killTweensOf(parsedTargets);

      _overwritingTween = 0;
    }

    _addToTimeline(parent, _assertThisInitialized(_this3), position);

    vars.reversed && _this3.reverse();
    vars.paused && _this3.paused(true);

    if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
      _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)

      _this3.render(Math.max(0, -delay) || 0); //in case delay is negative

    }

    scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
    return _this3;
  }

  var _proto3 = Tween.prototype;

  _proto3.render = function render(totalTime, suppressEvents, force) {
    var prevTime = this._time,
        tDur = this._tDur,
        dur = this._dur,
        isNegative = totalTime < 0,
        tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime,
        time,
        pt,
        iteration,
        cycleDuration,
        prevIteration,
        isYoyo,
        ratio,
        timeline,
        yoyoEase;

    if (!dur) {
      _renderZeroDurationTween(this, totalTime, suppressEvents, force);
    } else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative) {
      //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
      time = tTime;
      timeline = this.timeline;

      if (this._repeat) {
        //adjust the time for repeats and yoyos
        cycleDuration = dur + this._rDelay;

        if (this._repeat < -1 && isNegative) {
          return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
        }

        time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)

        if (tTime === tDur) {
          // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
          iteration = this._repeat;
          time = dur;
        } else {
          iteration = ~~(tTime / cycleDuration);

          if (iteration && iteration === _roundPrecise(tTime / cycleDuration)) {
            time = dur;
            iteration--;
          }

          time > dur && (time = dur);
        }

        isYoyo = this._yoyo && iteration & 1;

        if (isYoyo) {
          yoyoEase = this._yEase;
          time = dur - time;
        }

        prevIteration = _animationCycle(this._tTime, cycleDuration);

        if (time === prevTime && !force && this._initted && iteration === prevIteration) {
          //could be during the repeatDelay part. No need to render and fire callbacks.
          this._tTime = tTime;
          return this;
        }

        if (iteration !== prevIteration) {
          timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality

          if (this.vars.repeatRefresh && !isYoyo && !this._lock && this._time !== cycleDuration && this._initted) {
            // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
            this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.

            this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
          }
        }
      }

      if (!this._initted) {
        if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
          this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.

          return this;
        }

        if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) {
          // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
          return this;
        }

        if (dur !== this._dur) {
          // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
          return this.render(totalTime, suppressEvents, force);
        }
      }

      this._tTime = tTime;
      this._time = time;

      if (!this._act && this._ts) {
        this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.

        this._lazy = 0;
      }

      this.ratio = ratio = (yoyoEase || this._ease)(time / dur);

      if (this._from) {
        this.ratio = ratio = 1 - ratio;
      }

      if (time && !prevTime && !suppressEvents && !iteration) {
        _callback(this, "onStart");

        if (this._tTime !== tTime) {
          // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
          return this;
        }
      }

      pt = this._pt;

      while (pt) {
        pt.r(ratio, pt.d);
        pt = pt._next;
      }

      timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);

      if (this._onUpdate && !suppressEvents) {
        isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.

        _callback(this, "onUpdate");
      }

      this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");

      if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
        isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
        (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.

        if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
          // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
          _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);

          this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
        }
      }
    }

    return this;
  };

  _proto3.targets = function targets() {
    return this._targets;
  };

  _proto3.invalidate = function invalidate(soft) {
    // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
    (!soft || !this.vars.runBackwards) && (this._startAt = 0);
    this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
    this._ptLookup = [];
    this.timeline && this.timeline.invalidate(soft);
    return _Animation2.prototype.invalidate.call(this, soft);
  };

  _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
    _tickerActive || _ticker.wake();
    this._ts || this.play();
    var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts),
        ratio;
    this._initted || _initTween(this, time);
    ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
    // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
    // if (_isObject(property)) { // performance optimization
    // 	for (p in property) {
    // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
    // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
    // 		}
    // 	}
    // } else {

    if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) {
      return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
    } //}


    _alignPlayhead(this, 0);

    this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
    return this.render(0);
  };

  _proto3.kill = function kill(targets, vars) {
    if (vars === void 0) {
      vars = "all";
    }

    if (!targets && (!vars || vars === "all")) {
      this._lazy = this._pt = 0;
      return this.parent ? _interrupt(this) : this;
    }

    if (this.timeline) {
      var tDur = this.timeline.totalDuration();
      this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.

      this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.

      return this;
    }

    var parsedTargets = this._targets,
        killingTargets = targets ? toArray(targets) : parsedTargets,
        propTweenLookup = this._ptLookup,
        firstPT = this._pt,
        overwrittenProps,
        curLookup,
        curOverwriteProps,
        props,
        p,
        pt,
        i;

    if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
      vars === "all" && (this._pt = 0);
      return _interrupt(this);
    }

    overwrittenProps = this._op = this._op || [];

    if (vars !== "all") {
      //so people can pass in a comma-delimited list of property names
      if (_isString(vars)) {
        p = {};

        _forEachName(vars, function (name) {
          return p[name] = 1;
        });

        vars = p;
      }

      vars = _addAliasesToVars(parsedTargets, vars);
    }

    i = parsedTargets.length;

    while (i--) {
      if (~killingTargets.indexOf(parsedTargets[i])) {
        curLookup = propTweenLookup[i];

        if (vars === "all") {
          overwrittenProps[i] = vars;
          props = curLookup;
          curOverwriteProps = {};
        } else {
          curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
          props = vars;
        }

        for (p in props) {
          pt = curLookup && curLookup[p];

          if (pt) {
            if (!("kill" in pt.d) || pt.d.kill(p) === true) {
              _removeLinkedListItem(this, pt, "_pt");
            }

            delete curLookup[p];
          }

          if (curOverwriteProps !== "all") {
            curOverwriteProps[p] = 1;
          }
        }
      }
    }

    this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.

    return this;
  };

  Tween.to = function to(targets, vars) {
    return new Tween(targets, vars, arguments[2]);
  };

  Tween.from = function from(targets, vars) {
    return _createTweenType(1, arguments);
  };

  Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
    return new Tween(callback, 0, {
      immediateRender: false,
      lazy: false,
      overwrite: false,
      delay: delay,
      onComplete: callback,
      onReverseComplete: callback,
      onCompleteParams: params,
      onReverseCompleteParams: params,
      callbackScope: scope
    }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
  };

  Tween.fromTo = function fromTo(targets, fromVars, toVars) {
    return _createTweenType(2, arguments);
  };

  Tween.set = function set(targets, vars) {
    vars.duration = 0;
    vars.repeatDelay || (vars.repeat = 0);
    return new Tween(targets, vars);
  };

  Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
    return _globalTimeline.killTweensOf(targets, props, onlyActive);
  };

  return Tween;
}(Animation);

_setDefaults(Tween.prototype, {
  _targets: [],
  _lazy: 0,
  _startAt: 0,
  _op: 0,
  _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.


_forEachName("staggerTo,staggerFrom,staggerFromTo", function (name) {
  Tween[name] = function () {
    var tl = new Timeline(),
        params = _slice.call(arguments, 0);

    params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
    return tl[name].apply(tl, params);
  };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */


var _setterPlain = function _setterPlain(target, property, value) {
  return target[property] = value;
},
    _setterFunc = function _setterFunc(target, property, value) {
  return target[property](value);
},
    _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
  return target[property](data.fp, value);
},
    _setterAttribute = function _setterAttribute(target, property, value) {
  return target.setAttribute(property, value);
},
    _getSetter = function _getSetter(target, property) {
  return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
},
    _renderPlain = function _renderPlain(ratio, data) {
  return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
},
    _renderBoolean = function _renderBoolean(ratio, data) {
  return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
},
    _renderComplexString = function _renderComplexString(ratio, data) {
  var pt = data._pt,
      s = "";

  if (!ratio && data.b) {
    //b = beginning string
    s = data.b;
  } else if (ratio === 1 && data.e) {
    //e = ending string
    s = data.e;
  } else {
    while (pt) {
      s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.

      pt = pt._next;
    }

    s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
  }

  data.set(data.t, data.p, s, data);
},
    _renderPropTweens = function _renderPropTweens(ratio, data) {
  var pt = data._pt;

  while (pt) {
    pt.r(ratio, pt.d);
    pt = pt._next;
  }
},
    _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
  var pt = this._pt,
      next;

  while (pt) {
    next = pt._next;
    pt.p === property && pt.modifier(modifier, tween, target);
    pt = next;
  }
},
    _killPropTweensOf = function _killPropTweensOf(property) {
  var pt = this._pt,
      hasNonDependentRemaining,
      next;

  while (pt) {
    next = pt._next;

    if (pt.p === property && !pt.op || pt.op === property) {
      _removeLinkedListItem(this, pt, "_pt");
    } else if (!pt.dep) {
      hasNonDependentRemaining = 1;
    }

    pt = next;
  }

  return !hasNonDependentRemaining;
},
    _setterWithModifier = function _setterWithModifier(target, property, value, data) {
  data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
},
    _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
  var pt = parent._pt,
      next,
      pt2,
      first,
      last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)

  while (pt) {
    next = pt._next;
    pt2 = first;

    while (pt2 && pt2.pr > pt.pr) {
      pt2 = pt2._next;
    }

    if (pt._prev = pt2 ? pt2._prev : last) {
      pt._prev._next = pt;
    } else {
      first = pt;
    }

    if (pt._next = pt2) {
      pt2._prev = pt;
    } else {
      last = pt;
    }

    pt = next;
  }

  parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)


var PropTween = /*#__PURE__*/function () {
  function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
    this.t = target;
    this.s = start;
    this.c = change;
    this.p = prop;
    this.r = renderer || _renderPlain;
    this.d = data || this;
    this.set = setter || _setterPlain;
    this.pr = priority || 0;
    this._next = next;

    if (next) {
      next._prev = this;
    }
  }

  var _proto4 = PropTween.prototype;

  _proto4.modifier = function modifier(func, tween, target) {
    this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)

    this.set = _setterWithModifier;
    this.m = func;
    this.mt = target; //modifier target

    this.tween = tween;
  };

  return PropTween;
}(); //Initialization tasks

_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function (name) {
  return _reservedProps[name] = 1;
});

_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
  sortChildren: false,
  defaults: _defaults,
  autoRemoveChildren: true,
  id: "root",
  smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;

var _media = [],
    _listeners = {},
    _emptyArray = [],
    _lastMediaTime = 0,
    _contextID = 0,
    _dispatch = function _dispatch(type) {
  return (_listeners[type] || _emptyArray).map(function (f) {
    return f();
  });
},
    _onMediaChange = function _onMediaChange() {
  var time = Date.now(),
      matches = [];

  if (time - _lastMediaTime > 2) {
    _dispatch("matchMediaInit");

    _media.forEach(function (c) {
      var queries = c.queries,
          conditions = c.conditions,
          match,
          p,
          anyMatch,
          toggled;

      for (p in queries) {
        match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.

        match && (anyMatch = 1);

        if (match !== conditions[p]) {
          conditions[p] = match;
          toggled = 1;
        }
      }

      if (toggled) {
        c.revert();
        anyMatch && matches.push(c);
      }
    });

    _dispatch("matchMediaRevert");

    matches.forEach(function (c) {
      return c.onMatch(c, function (func) {
        return c.add(null, func);
      });
    });
    _lastMediaTime = time;

    _dispatch("matchMedia");
  }
};

var Context = /*#__PURE__*/function () {
  function Context(func, scope) {
    this.selector = scope && selector(scope);
    this.data = [];
    this._r = []; // returned/cleanup functions

    this.isReverted = false;
    this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely

    func && this.add(func);
  }

  var _proto5 = Context.prototype;

  _proto5.add = function add(name, func, scope) {
    // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
    // if (name && _isFunction(name.revert)) {
    // 	this.data.push(name);
    // 	return (name._ctx = this);
    // }
    if (_isFunction(name)) {
      scope = func;
      func = name;
      name = _isFunction;
    }

    var self = this,
        f = function f() {
      var prev = _context,
          prevSelector = self.selector,
          result;
      prev && prev !== self && prev.data.push(self);
      scope && (self.selector = selector(scope));
      _context = self;
      result = func.apply(self, arguments);
      _isFunction(result) && self._r.push(result);
      _context = prev;
      self.selector = prevSelector;
      self.isReverted = false;
      return result;
    };

    self.last = f;
    return name === _isFunction ? f(self, function (func) {
      return self.add(null, func);
    }) : name ? self[name] = f : f;
  };

  _proto5.ignore = function ignore(func) {
    var prev = _context;
    _context = null;
    func(this);
    _context = prev;
  };

  _proto5.getTweens = function getTweens() {
    var a = [];
    this.data.forEach(function (e) {
      return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
    });
    return a;
  };

  _proto5.clear = function clear() {
    this._r.length = this.data.length = 0;
  };

  _proto5.kill = function kill(revert, matchMedia) {
    var _this4 = this;

    if (revert) {
      (function () {
        var tweens = _this4.getTweens(),
            i = _this4.data.length,
            t;

        while (i--) {
          // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
          t = _this4.data[i];

          if (t.data === "isFlip") {
            t.revert();
            t.getChildren(true, true, false).forEach(function (tween) {
              return tweens.splice(tweens.indexOf(tween), 1);
            });
          }
        } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort


        tweens.map(function (t) {
          return {
            g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
            t: t
          };
        }).sort(function (a, b) {
          return b.g - a.g || -Infinity;
        }).forEach(function (o) {
          return o.t.revert(revert);
        }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.

        i = _this4.data.length;

        while (i--) {
          // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
          t = _this4.data[i];

          if (t instanceof Timeline) {
            if (t.data !== "nested") {
              t.scrollTrigger && t.scrollTrigger.revert();
              t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
            }
          } else {
            !(t instanceof Tween) && t.revert && t.revert(revert);
          }
        }

        _this4._r.forEach(function (f) {
          return f(revert, _this4);
        });

        _this4.isReverted = true;
      })();
    } else {
      this.data.forEach(function (e) {
        return e.kill && e.kill();
      });
    }

    this.clear();

    if (matchMedia) {
      var i = _media.length;

      while (i--) {
        // previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
        _media[i].id === this.id && _media.splice(i, 1);
      }
    }
  };

  _proto5.revert = function revert(config) {
    this.kill(config || {});
  };

  return Context;
}();

var MatchMedia = /*#__PURE__*/function () {
  function MatchMedia(scope) {
    this.contexts = [];
    this.scope = scope;
    _context && _context.data.push(this);
  }

  var _proto6 = MatchMedia.prototype;

  _proto6.add = function add(conditions, func, scope) {
    _isObject(conditions) || (conditions = {
      matches: conditions
    });
    var context = new Context(0, scope || this.scope),
        cond = context.conditions = {},
        mq,
        p,
        active;
    _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()

    this.contexts.push(context);
    func = context.add("onMatch", func);
    context.queries = conditions;

    for (p in conditions) {
      if (p === "all") {
        active = 1;
      } else {
        mq = _win.matchMedia(conditions[p]);

        if (mq) {
          _media.indexOf(context) < 0 && _media.push(context);
          (cond[p] = mq.matches) && (active = 1);
          mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
        }
      }
    }

    active && func(context, function (f) {
      return context.add(null, f);
    });
    return this;
  } // refresh() {
  // 	let time = _lastMediaTime,
  // 		media = _media;
  // 	_lastMediaTime = -1;
  // 	_media = this.contexts;
  // 	_onMediaChange();
  // 	_lastMediaTime = time;
  // 	_media = media;
  // }
  ;

  _proto6.revert = function revert(config) {
    this.kill(config || {});
  };

  _proto6.kill = function kill(revert) {
    this.contexts.forEach(function (c) {
      return c.kill(revert, true);
    });
  };

  return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */


var _gsap = {
  registerPlugin: function registerPlugin() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    args.forEach(function (config) {
      return _createPlugin(config);
    });
  },
  timeline: function timeline(vars) {
    return new Timeline(vars);
  },
  getTweensOf: function getTweensOf(targets, onlyActive) {
    return _globalTimeline.getTweensOf(targets, onlyActive);
  },
  getProperty: function getProperty(target, property, unit, uncache) {
    _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in

    var getter = _getCache(target || {}).get,
        format = unit ? _passThrough : _numericIfPossible;

    unit === "native" && (unit = "");
    return !target ? target : !property ? function (property, unit, uncache) {
      return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
  },
  quickSetter: function quickSetter(target, property, unit) {
    target = toArray(target);

    if (target.length > 1) {
      var setters = target.map(function (t) {
        return gsap.quickSetter(t, property, unit);
      }),
          l = setters.length;
      return function (value) {
        var i = l;

        while (i--) {
          setters[i](value);
        }
      };
    }

    target = target[0] || {};

    var Plugin = _plugins[property],
        cache = _getCache(target),
        p = cache.harness && (cache.harness.aliases || {})[property] || property,
        // in case it's an alias, like "rotate" for "rotation".
    setter = Plugin ? function (value) {
      var p = new Plugin();
      _quickTween._pt = 0;
      p.init(target, unit ? value + unit : value, _quickTween, 0, [target]);
      p.render(1, p);
      _quickTween._pt && _renderPropTweens(1, _quickTween);
    } : cache.set(target, p);

    return Plugin ? setter : function (value) {
      return setter(target, p, unit ? value + unit : value, cache, 1);
    };
  },
  quickTo: function quickTo(target, property, vars) {
    var _merge2;

    var tween = gsap.to(target, _merge((_merge2 = {}, _merge2[property] = "+=0.1", _merge2.paused = true, _merge2), vars || {})),
        func = function func(value, start, startIsRelative) {
      return tween.resetTo(property, value, start, startIsRelative);
    };

    func.tween = tween;
    return func;
  },
  isTweening: function isTweening(targets) {
    return _globalTimeline.getTweensOf(targets, true).length > 0;
  },
  defaults: function defaults(value) {
    value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
    return _mergeDeep(_defaults, value || {});
  },
  config: function config(value) {
    return _mergeDeep(_config, value || {});
  },
  registerEffect: function registerEffect(_ref3) {
    var name = _ref3.name,
        effect = _ref3.effect,
        plugins = _ref3.plugins,
        defaults = _ref3.defaults,
        extendTimeline = _ref3.extendTimeline;
    (plugins || "").split(",").forEach(function (pluginName) {
      return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
    });

    _effects[name] = function (targets, vars, tl) {
      return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
    };

    if (extendTimeline) {
      Timeline.prototype[name] = function (targets, vars, position) {
        return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
      };
    }
  },
  registerEase: function registerEase(name, ease) {
    _easeMap[name] = _parseEase(ease);
  },
  parseEase: function parseEase(ease, defaultEase) {
    return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
  },
  getById: function getById(id) {
    return _globalTimeline.getById(id);
  },
  exportRoot: function exportRoot(vars, includeDelayedCalls) {
    if (vars === void 0) {
      vars = {};
    }

    var tl = new Timeline(vars),
        child,
        next;
    tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);

    _globalTimeline.remove(tl);

    tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).

    tl._time = tl._tTime = _globalTimeline._time;
    child = _globalTimeline._first;

    while (child) {
      next = child._next;

      if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) {
        _addToTimeline(tl, child, child._start - child._delay);
      }

      child = next;
    }

    _addToTimeline(_globalTimeline, tl, 0);

    return tl;
  },
  context: function context(func, scope) {
    return func ? new Context(func, scope) : _context;
  },
  matchMedia: function matchMedia(scope) {
    return new MatchMedia(scope);
  },
  matchMediaRefresh: function matchMediaRefresh() {
    return _media.forEach(function (c) {
      var cond = c.conditions,
          found,
          p;

      for (p in cond) {
        if (cond[p]) {
          cond[p] = false;
          found = 1;
        }
      }

      found && c.revert();
    }) || _onMediaChange();
  },
  addEventListener: function addEventListener(type, callback) {
    var a = _listeners[type] || (_listeners[type] = []);
    ~a.indexOf(callback) || a.push(callback);
  },
  removeEventListener: function removeEventListener(type, callback) {
    var a = _listeners[type],
        i = a && a.indexOf(callback);
    i >= 0 && a.splice(i, 1);
  },
  utils: {
    wrap: wrap,
    wrapYoyo: wrapYoyo,
    distribute: distribute,
    random: random,
    snap: snap,
    normalize: normalize,
    getUnit: getUnit,
    clamp: clamp,
    splitColor: splitColor,
    toArray: toArray,
    selector: selector,
    mapRange: mapRange,
    pipe: pipe,
    unitize: unitize,
    interpolate: interpolate,
    shuffle: shuffle
  },
  install: _install,
  effects: _effects,
  ticker: _ticker,
  updateRoot: Timeline.updateRoot,
  plugins: _plugins,
  globalTimeline: _globalTimeline,
  core: {
    PropTween: PropTween,
    globals: _addGlobal,
    Tween: Tween,
    Timeline: Timeline,
    Animation: Animation,
    getCache: _getCache,
    _removeLinkedListItem: _removeLinkedListItem,
    reverting: function reverting() {
      return _reverting;
    },
    context: function context(toAdd) {
      if (toAdd && _context) {
        _context.data.push(toAdd);

        toAdd._ctx = _context;
      }

      return _context;
    },
    suppressOverwrites: function suppressOverwrites(value) {
      return _suppressOverwrites = value;
    }
  }
};

_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function (name) {
  return _gsap[name] = Tween[name];
});

_ticker.add(Timeline.updateRoot);

_quickTween = _gsap.to({}, {
  duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------

var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
  var pt = plugin._pt;

  while (pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop) {
    pt = pt._next;
  }

  return pt;
},
    _addModifiers = function _addModifiers(tween, modifiers) {
  var targets = tween._targets,
      p,
      i,
      pt;

  for (p in modifiers) {
    i = targets.length;

    while (i--) {
      pt = tween._ptLookup[i][p];

      if (pt && (pt = pt.d)) {
        if (pt._pt) {
          // is a plugin
          pt = _getPluginPropTween(pt, p);
        }

        pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
      }
    }
  }
},
    _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
  return {
    name: name,
    rawVars: 1,
    //don't pre-process function-based values or "random()" strings.
    init: function init(target, vars, tween) {
      tween._onInit = function (tween) {
        var temp, p;

        if (_isString(vars)) {
          temp = {};

          _forEachName(vars, function (name) {
            return temp[name] = 1;
          }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.


          vars = temp;
        }

        if (modifier) {
          temp = {};

          for (p in vars) {
            temp[p] = modifier(vars[p]);
          }

          vars = temp;
        }

        _addModifiers(tween, vars);
      };
    }
  };
}; //register core plugins


var gsap = _gsap.registerPlugin({
  name: "attr",
  init: function init(target, vars, tween, index, targets) {
    var p, pt, v;
    this.tween = tween;

    for (p in vars) {
      v = target.getAttribute(p) || "";
      pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
      pt.op = p;
      pt.b = v; // record the beginning value so we can revert()

      this._props.push(p);
    }
  },
  render: function render(ratio, data) {
    var pt = data._pt;

    while (pt) {
      _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)

      pt = pt._next;
    }
  }
}, {
  name: "endArray",
  init: function init(target, value) {
    var i = value.length;

    while (i--) {
      this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
  }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.

Tween.version = Timeline.version = gsap.version = "3.12.5";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0,
    Power1 = _easeMap.Power1,
    Power2 = _easeMap.Power2,
    Power3 = _easeMap.Power3,
    Power4 = _easeMap.Power4,
    Linear = _easeMap.Linear,
    Quad = _easeMap.Quad,
    Cubic = _easeMap.Cubic,
    Quart = _easeMap.Quart,
    Quint = _easeMap.Quint,
    Strong = _easeMap.Strong,
    Elastic = _easeMap.Elastic,
    Back = _easeMap.Back,
    SteppedEase = _easeMap.SteppedEase,
    Bounce = _easeMap.Bounce,
    Sine = _easeMap.Sine,
    Expo = _easeMap.Expo,
    Circ = _easeMap.Circ;

 //export some internal methods/orojects for use in CSSPlugin so that we can externalize that file and allow custom builds that exclude it.



/***/ }),

/***/ 30334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ gsapWithCSS; }
});

// UNUSED EXPORTS: Back, Bounce, CSSPlugin, Circ, Cubic, Elastic, Expo, Linear, Power0, Power1, Power2, Power3, Power4, Quad, Quart, Quint, Sine, SteppedEase, Strong, TimelineLite, TimelineMax, TweenLite, TweenMax, gsap

// EXTERNAL MODULE: ./node_modules/gsap/gsap-core.js
var gsap_core = __webpack_require__(48158);
;// CONCATENATED MODULE: ./node_modules/gsap/CSSPlugin.js
/*!
 * CSSPlugin 3.12.5
 * https://gsap.com
 *
 * Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/

/* eslint-disable */


var _win,
    _doc,
    _docElement,
    _pluginInitted,
    _tempDiv,
    _tempDivStyler,
    _recentSetterPlugin,
    _reverting,
    _windowExists = function _windowExists() {
  return typeof window !== "undefined";
},
    _transformProps = {},
    _RAD2DEG = 180 / Math.PI,
    _DEG2RAD = Math.PI / 180,
    _atan2 = Math.atan2,
    _bigNum = 1e8,
    _capsExp = /([A-Z])/g,
    _horizontalExp = /(left|right|width|margin|padding|x)/i,
    _complexExp = /[\s,\(]\S/,
    _propertyAliases = {
  autoAlpha: "opacity,visibility",
  scale: "scaleX,scaleY",
  alpha: "opacity"
},
    _renderCSSProp = function _renderCSSProp(ratio, data) {
  return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
},
    _renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
  return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
},
    _renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
  return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
},
    //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
  var value = data.s + data.c * ratio;
  data.set(data.t, data.p, ~~(value + (value < 0 ? -.5 : .5)) + data.u, data);
},
    _renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
  return data.set(data.t, data.p, ratio ? data.e : data.b, data);
},
    _renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
  return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
},
    _setterCSSStyle = function _setterCSSStyle(target, property, value) {
  return target.style[property] = value;
},
    _setterCSSProp = function _setterCSSProp(target, property, value) {
  return target.style.setProperty(property, value);
},
    _setterTransform = function _setterTransform(target, property, value) {
  return target._gsap[property] = value;
},
    _setterScale = function _setterScale(target, property, value) {
  return target._gsap.scaleX = target._gsap.scaleY = value;
},
    _setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
  var cache = target._gsap;
  cache.scaleX = cache.scaleY = value;
  cache.renderTransform(ratio, cache);
},
    _setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
  var cache = target._gsap;
  cache[property] = value;
  cache.renderTransform(ratio, cache);
},
    _transformProp = "transform",
    _transformOriginProp = _transformProp + "Origin",
    _saveStyle = function _saveStyle(property, isNotCSS) {
  var _this = this;

  var target = this.target,
      style = target.style,
      cache = target._gsap;

  if (property in _transformProps && style) {
    this.tfm = this.tfm || {};

    if (property !== "transform") {
      property = _propertyAliases[property] || property;
      ~property.indexOf(",") ? property.split(",").forEach(function (a) {
        return _this.tfm[a] = _get(target, a);
      }) : this.tfm[property] = cache.x ? cache[property] : _get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.

      property === _transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
    } else {
      return _propertyAliases.transform.split(",").forEach(function (p) {
        return _saveStyle.call(_this, p, isNotCSS);
      });
    }

    if (this.props.indexOf(_transformProp) >= 0) {
      return;
    }

    if (cache.svg) {
      this.svgo = target.getAttribute("data-svg-origin");
      this.props.push(_transformOriginProp, isNotCSS, "");
    }

    property = _transformProp;
  }

  (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
},
    _removeIndependentTransforms = function _removeIndependentTransforms(style) {
  if (style.translate) {
    style.removeProperty("translate");
    style.removeProperty("scale");
    style.removeProperty("rotate");
  }
},
    _revertStyle = function _revertStyle() {
  var props = this.props,
      target = this.target,
      style = target.style,
      cache = target._gsap,
      i,
      p;

  for (i = 0; i < props.length; i += 3) {
    // stored like this: property, isNotCSS, value
    props[i + 1] ? target[props[i]] = props[i + 2] : props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace(_capsExp, "-$1").toLowerCase());
  }

  if (this.tfm) {
    for (p in this.tfm) {
      cache[p] = this.tfm[p];
    }

    if (cache.svg) {
      cache.renderTransform();
      target.setAttribute("data-svg-origin", this.svgo || "");
    }

    i = _reverting();

    if ((!i || !i.isStart) && !style[_transformProp]) {
      _removeIndependentTransforms(style);

      if (cache.zOrigin && style[_transformOriginProp]) {
        style[_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.

        cache.zOrigin = 0;
        cache.renderTransform();
      }

      cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
    }
  }
},
    _getStyleSaver = function _getStyleSaver(target, properties) {
  var saver = {
    target: target,
    props: [],
    revert: _revertStyle,
    save: _saveStyle
  };
  target._gsap || gsap_core/* gsap.core.getCache */.p8.core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.

  properties && properties.split(",").forEach(function (p) {
    return saver.save(p);
  });
  return saver;
},
    _supports3D,
    _createElement = function _createElement(type, ns) {
  var e = _doc.createElementNS ? _doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : _doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.

  return e && e.style ? e : _doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
},
    _getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
  var cs = getComputedStyle(target);
  return cs[property] || cs.getPropertyValue(property.replace(_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, _checkPropPrefix(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
},
    _prefixes = "O,Moz,ms,Ms,Webkit".split(","),
    _checkPropPrefix = function _checkPropPrefix(property, element, preferPrefix) {
  var e = element || _tempDiv,
      s = e.style,
      i = 5;

  if (property in s && !preferPrefix) {
    return property;
  }

  property = property.charAt(0).toUpperCase() + property.substr(1);

  while (i-- && !(_prefixes[i] + property in s)) {}

  return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? _prefixes[i] : "") + property;
},
    _initCore = function _initCore() {
  if (_windowExists() && window.document) {
    _win = window;
    _doc = _win.document;
    _docElement = _doc.documentElement;
    _tempDiv = _createElement("div") || {
      style: {}
    };
    _tempDivStyler = _createElement("div");
    _transformProp = _checkPropPrefix(_transformProp);
    _transformOriginProp = _transformProp + "Origin";
    _tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.

    _supports3D = !!_checkPropPrefix("perspective");
    _reverting = gsap_core/* gsap.core.reverting */.p8.core.reverting;
    _pluginInitted = 1;
  }
},
    _getBBoxHack = function _getBBoxHack(swapIfPossible) {
  //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
  var svg = _createElement("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"),
      oldParent = this.parentNode,
      oldSibling = this.nextSibling,
      oldCSS = this.style.cssText,
      bbox;

  _docElement.appendChild(svg);

  svg.appendChild(this);
  this.style.display = "block";

  if (swapIfPossible) {
    try {
      bbox = this.getBBox();
      this._gsapBBox = this.getBBox; //store the original

      this.getBBox = _getBBoxHack;
    } catch (e) {}
  } else if (this._gsapBBox) {
    bbox = this._gsapBBox();
  }

  if (oldParent) {
    if (oldSibling) {
      oldParent.insertBefore(this, oldSibling);
    } else {
      oldParent.appendChild(this);
    }
  }

  _docElement.removeChild(svg);

  this.style.cssText = oldCSS;
  return bbox;
},
    _getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
  var i = attributesArray.length;

  while (i--) {
    if (target.hasAttribute(attributesArray[i])) {
      return target.getAttribute(attributesArray[i]);
    }
  }
},
    _getBBox = function _getBBox(target) {
  var bounds;

  try {
    bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
  } catch (error) {
    bounds = _getBBoxHack.call(target, true);
  }

  bounds && (bounds.width || bounds.height) || target.getBBox === _getBBoxHack || (bounds = _getBBoxHack.call(target, true)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.

  return bounds && !bounds.width && !bounds.x && !bounds.y ? {
    x: +_getAttributeFallbacks(target, ["x", "cx", "x1"]) || 0,
    y: +_getAttributeFallbacks(target, ["y", "cy", "y1"]) || 0,
    width: 0,
    height: 0
  } : bounds;
},
    _isSVG = function _isSVG(e) {
  return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && _getBBox(e));
},
    //reports if the element is an SVG on which getBBox() actually works
_removeProperty = function _removeProperty(target, property) {
  if (property) {
    var style = target.style,
        first2Chars;

    if (property in _transformProps && property !== _transformOriginProp) {
      property = _transformProp;
    }

    if (style.removeProperty) {
      first2Chars = property.substr(0, 2);

      if (first2Chars === "ms" || property.substr(0, 6) === "webkit") {
        //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
        property = "-" + property;
      }

      style.removeProperty(first2Chars === "--" ? property : property.replace(_capsExp, "-$1").toLowerCase());
    } else {
      //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
      style.removeAttribute(property);
    }
  }
},
    _addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
  var pt = new gsap_core/* PropTween */.Fo(plugin._pt, target, property, 0, 1, onlySetAtEnd ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue);
  plugin._pt = pt;
  pt.b = beginning;
  pt.e = end;

  plugin._props.push(property);

  return pt;
},
    _nonConvertibleUnits = {
  deg: 1,
  rad: 1,
  turn: 1
},
    _nonStandardLayouts = {
  grid: 1,
  flex: 1
},
    //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
_convertToUnit = function _convertToUnit(target, property, value, unit) {
  var curValue = parseFloat(value) || 0,
      curUnit = (value + "").trim().substr((curValue + "").length) || "px",
      // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
  style = _tempDiv.style,
      horizontal = _horizontalExp.test(property),
      isRootSVG = target.tagName.toLowerCase() === "svg",
      measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"),
      amount = 100,
      toPixels = unit === "px",
      toPercent = unit === "%",
      px,
      parent,
      cache,
      isSVG;

  if (unit === curUnit || !curValue || _nonConvertibleUnits[unit] || _nonConvertibleUnits[curUnit]) {
    return curValue;
  }

  curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
  isSVG = target.getCTM && _isSVG(target);

  if ((toPercent || curUnit === "%") && (_transformProps[property] || ~property.indexOf("adius"))) {
    px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
    return (0,gsap_core/* _round */.Pr)(toPercent ? curValue / px * amount : curValue / 100 * px);
  }

  style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
  parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;

  if (isSVG) {
    parent = (target.ownerSVGElement || {}).parentNode;
  }

  if (!parent || parent === _doc || !parent.appendChild) {
    parent = _doc.body;
  }

  cache = parent._gsap;

  if (cache && toPercent && cache.width && horizontal && cache.time === gsap_core/* _ticker.time */.xr.time && !cache.uncache) {
    return (0,gsap_core/* _round */.Pr)(curValue / cache.width * amount);
  } else {
    if (toPercent && (property === "height" || property === "width")) {
      // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
      var v = target.style[property];
      target.style[property] = amount + unit;
      px = target[measureProperty];
      v ? target.style[property] = v : _removeProperty(target, property);
    } else {
      (toPercent || curUnit === "%") && !_nonStandardLayouts[_getComputedProperty(parent, "display")] && (style.position = _getComputedProperty(target, "position"));
      parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.

      parent.appendChild(_tempDiv);
      px = _tempDiv[measureProperty];
      parent.removeChild(_tempDiv);
      style.position = "absolute";
    }

    if (horizontal && toPercent) {
      cache = (0,gsap_core/* _getCache */.DY)(parent);
      cache.time = gsap_core/* _ticker.time */.xr.time;
      cache.width = parent[measureProperty];
    }
  }

  return (0,gsap_core/* _round */.Pr)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
},
    _get = function _get(target, property, unit, uncache) {
  var value;
  _pluginInitted || _initCore();

  if (property in _propertyAliases && property !== "transform") {
    property = _propertyAliases[property];

    if (~property.indexOf(",")) {
      property = property.split(",")[0];
    }
  }

  if (_transformProps[property] && property !== "transform") {
    value = _parseTransform(target, uncache);
    value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : _firstTwoOnly(_getComputedProperty(target, _transformOriginProp)) + " " + value.zOrigin + "px";
  } else {
    value = target.style[property];

    if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) {
      value = _specialProps[property] && _specialProps[property](target, property, unit) || _getComputedProperty(target, property) || (0,gsap_core/* _getProperty */.Ok)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
  }

  return unit && !~(value + "").trim().indexOf(" ") ? _convertToUnit(target, property, value, unit) + unit : value;
},
    _tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
  // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
  if (!start || start === "none") {
    // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
    var p = _checkPropPrefix(prop, target, 1),
        s = p && _getComputedProperty(target, p, 1);

    if (s && s !== start) {
      prop = p;
      start = s;
    } else if (prop === "borderColor") {
      start = _getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
  }

  var pt = new gsap_core/* PropTween */.Fo(this._pt, target.style, prop, 0, 1, gsap_core/* _renderComplexString */.Ks),
      index = 0,
      matchIndex = 0,
      a,
      result,
      startValues,
      startNum,
      color,
      startValue,
      endValue,
      endNum,
      chunk,
      endUnit,
      startUnit,
      endValues;
  pt.b = start;
  pt.e = end;
  start += ""; // ensure values are strings

  end += "";

  if (end === "auto") {
    startValue = target.style[prop];
    target.style[prop] = end;
    end = _getComputedProperty(target, prop) || end;
    startValue ? target.style[prop] = startValue : _removeProperty(target, prop);
  }

  a = [start, end];

  (0,gsap_core/* _colorStringFilter */.kr)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().


  start = a[0];
  end = a[1];
  startValues = start.match(gsap_core/* _numWithUnitExp */.d4) || [];
  endValues = end.match(gsap_core/* _numWithUnitExp */.d4) || [];

  if (endValues.length) {
    while (result = gsap_core/* _numWithUnitExp.exec */.d4.exec(end)) {
      endValue = result[0];
      chunk = end.substring(index, result.index);

      if (color) {
        color = (color + 1) % 5;
      } else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") {
        color = 1;
      }

      if (endValue !== (startValue = startValues[matchIndex++] || "")) {
        startNum = parseFloat(startValue) || 0;
        startUnit = startValue.substr((startNum + "").length);
        endValue.charAt(1) === "=" && (endValue = (0,gsap_core/* _parseRelative */.cy)(startNum, endValue) + startUnit);
        endNum = parseFloat(endValue);
        endUnit = endValue.substr((endNum + "").length);
        index = gsap_core/* _numWithUnitExp.lastIndex */.d4.lastIndex - endUnit.length;

        if (!endUnit) {
          //if something like "perspective:300" is passed in and we must add a unit to the end
          endUnit = endUnit || gsap_core/* _config.units */.Fc.units[prop] || startUnit;

          if (index === end.length) {
            end += endUnit;
            pt.e += endUnit;
          }
        }

        if (startUnit !== endUnit) {
          startNum = _convertToUnit(target, prop, startValue, endUnit) || 0;
        } // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.


        pt._pt = {
          _next: pt._pt,
          p: chunk || matchIndex === 1 ? chunk : ",",
          //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
          s: startNum,
          c: endNum - startNum,
          m: color && color < 4 || prop === "zIndex" ? Math.round : 0
        };
      }
    }

    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
  } else {
    pt.r = prop === "display" && end === "none" ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue;
  }

  gsap_core/* _relExp.test */.bQ.test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).

  this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.

  return pt;
},
    _keywordToPercent = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
},
    _convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
  var split = value.split(" "),
      x = split[0],
      y = split[1] || "50%";

  if (x === "top" || x === "bottom" || y === "left" || y === "right") {
    //the user provided them in the wrong order, so flip them
    value = x;
    x = y;
    y = value;
  }

  split[0] = _keywordToPercent[x] || x;
  split[1] = _keywordToPercent[y] || y;
  return split.join(" ");
},
    _renderClearProps = function _renderClearProps(ratio, data) {
  if (data.tween && data.tween._time === data.tween._dur) {
    var target = data.t,
        style = target.style,
        props = data.u,
        cache = target._gsap,
        prop,
        clearTransforms,
        i;

    if (props === "all" || props === true) {
      style.cssText = "";
      clearTransforms = 1;
    } else {
      props = props.split(",");
      i = props.length;

      while (--i > -1) {
        prop = props[i];

        if (_transformProps[prop]) {
          clearTransforms = 1;
          prop = prop === "transformOrigin" ? _transformOriginProp : _transformProp;
        }

        _removeProperty(target, prop);
      }
    }

    if (clearTransforms) {
      _removeProperty(target, _transformProp);

      if (cache) {
        cache.svg && target.removeAttribute("transform");

        _parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.


        cache.uncache = 1;

        _removeIndependentTransforms(style);
      }
    }
  }
},
    // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
_specialProps = {
  clearProps: function clearProps(plugin, target, property, endValue, tween) {
    if (tween.data !== "isFromStart") {
      var pt = plugin._pt = new gsap_core/* PropTween */.Fo(plugin._pt, target, property, 0, 0, _renderClearProps);
      pt.u = endValue;
      pt.pr = -10;
      pt.tween = tween;

      plugin._props.push(property);

      return 1;
    }
  }
  /* className feature (about 0.4kb gzipped).
  , className(plugin, target, property, endValue, tween) {
  	let _renderClassName = (ratio, data) => {
  			data.css.render(ratio, data.css);
  			if (!ratio || ratio === 1) {
  				let inline = data.rmv,
  					target = data.t,
  					p;
  				target.setAttribute("class", ratio ? data.e : data.b);
  				for (p in inline) {
  					_removeProperty(target, p);
  				}
  			}
  		},
  		_getAllStyles = (target) => {
  			let styles = {},
  				computed = getComputedStyle(target),
  				p;
  			for (p in computed) {
  				if (isNaN(p) && p !== "cssText" && p !== "length") {
  					styles[p] = computed[p];
  				}
  			}
  			_setDefaults(styles, _parseTransform(target, 1));
  			return styles;
  		},
  		startClassList = target.getAttribute("class"),
  		style = target.style,
  		cssText = style.cssText,
  		cache = target._gsap,
  		classPT = cache.classPT,
  		inlineToRemoveAtEnd = {},
  		data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
  		changingVars = {},
  		startVars = _getAllStyles(target),
  		transformRelated = /(transform|perspective)/i,
  		endVars, p;
  	if (classPT) {
  		classPT.r(1, classPT.d);
  		_removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
  	}
  	target.setAttribute("class", data.e);
  	endVars = _getAllStyles(target, true);
  	target.setAttribute("class", startClassList);
  	for (p in endVars) {
  		if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
  			changingVars[p] = endVars[p];
  			if (!style[p] && style[p] !== "0") {
  				inlineToRemoveAtEnd[p] = 1;
  			}
  		}
  	}
  	cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
  	if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://gsap.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
  		style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
  	}
  	_parseTransform(target, true); //to clear the caching of transforms
  	data.css = new gsap.plugins.css();
  	data.css.init(target, changingVars, tween);
  	plugin._props.push(...data.css._props);
  	return 1;
  }
  */

},

/*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */
_identity2DMatrix = [1, 0, 0, 1, 0, 0],
    _rotationalProperties = {},
    _isNullTransform = function _isNullTransform(value) {
  return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
},
    _getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
  var matrixString = _getComputedProperty(target, _transformProp);

  return _isNullTransform(matrixString) ? _identity2DMatrix : matrixString.substr(7).match(gsap_core/* _numExp */.SI).map(gsap_core/* _round */.Pr);
},
    _getMatrix = function _getMatrix(target, force2D) {
  var cache = target._gsap || (0,gsap_core/* _getCache */.DY)(target),
      style = target.style,
      matrix = _getComputedTransformMatrixAsArray(target),
      parent,
      nextSibling,
      temp,
      addedToDOM;

  if (cache.svg && target.getAttribute("transform")) {
    temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.

    matrix = [temp.a, temp.b, temp.c, temp.d, temp.e, temp.f];
    return matrix.join(",") === "1,0,0,1,0,0" ? _identity2DMatrix : matrix;
  } else if (matrix === _identity2DMatrix && !target.offsetParent && target !== _docElement && !cache.svg) {
    //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
    //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
    temp = style.display;
    style.display = "block";
    parent = target.parentNode;

    if (!parent || !target.offsetParent) {
      // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375
      addedToDOM = 1; //flag

      nextSibling = target.nextElementSibling;

      _docElement.appendChild(target); //we must add it to the DOM in order to get values properly

    }

    matrix = _getComputedTransformMatrixAsArray(target);
    temp ? style.display = temp : _removeProperty(target, "display");

    if (addedToDOM) {
      nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : _docElement.removeChild(target);
    }
  }

  return force2D && matrix.length > 6 ? [matrix[0], matrix[1], matrix[4], matrix[5], matrix[12], matrix[13]] : matrix;
},
    _applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
  var cache = target._gsap,
      matrix = matrixArray || _getMatrix(target, true),
      xOriginOld = cache.xOrigin || 0,
      yOriginOld = cache.yOrigin || 0,
      xOffsetOld = cache.xOffset || 0,
      yOffsetOld = cache.yOffset || 0,
      a = matrix[0],
      b = matrix[1],
      c = matrix[2],
      d = matrix[3],
      tx = matrix[4],
      ty = matrix[5],
      originSplit = origin.split(" "),
      xOrigin = parseFloat(originSplit[0]) || 0,
      yOrigin = parseFloat(originSplit[1]) || 0,
      bounds,
      determinant,
      x,
      y;

  if (!originIsAbsolute) {
    bounds = _getBBox(target);
    xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
    yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
  } else if (matrix !== _identity2DMatrix && (determinant = a * d - b * c)) {
    //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
    x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
    y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
    xOrigin = x;
    yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
  }

  if (smooth || smooth !== false && cache.smooth) {
    tx = xOrigin - xOriginOld;
    ty = yOrigin - yOriginOld;
    cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
    cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
  } else {
    cache.xOffset = cache.yOffset = 0;
  }

  cache.xOrigin = xOrigin;
  cache.yOrigin = yOrigin;
  cache.smooth = !!smooth;
  cache.origin = origin;
  cache.originIsAbsolute = !!originIsAbsolute;
  target.style[_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).

  if (pluginToAddPropTweensTo) {
    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);

    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);

    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);

    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
  }

  target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
},
    _parseTransform = function _parseTransform(target, uncache) {
  var cache = target._gsap || new gsap_core/* GSCache */.l1(target);

  if ("x" in cache && !uncache && !cache.uncache) {
    return cache;
  }

  var style = target.style,
      invertedScaleX = cache.scaleX < 0,
      px = "px",
      deg = "deg",
      cs = getComputedStyle(target),
      origin = _getComputedProperty(target, _transformOriginProp) || "0",
      x,
      y,
      z,
      scaleX,
      scaleY,
      rotation,
      rotationX,
      rotationY,
      skewX,
      skewY,
      perspective,
      xOrigin,
      yOrigin,
      matrix,
      angle,
      cos,
      sin,
      a,
      b,
      c,
      d,
      a12,
      a22,
      t1,
      t2,
      t3,
      a13,
      a23,
      a33,
      a42,
      a43,
      a32;
  x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
  scaleX = scaleY = 1;
  cache.svg = !!(target.getCTM && _isSVG(target));

  if (cs.translate) {
    // accommodate independent transforms by combining them into normal ones.
    if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") {
      style[_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[_transformProp] !== "none" ? cs[_transformProp] : "");
    }

    style.scale = style.rotate = style.translate = "none";
  }

  matrix = _getMatrix(target, cache.svg);

  if (cache.svg) {
    if (cache.uncache) {
      // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
      t2 = target.getBBox();
      origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
      t1 = "";
    } else {
      t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
    }

    _applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
  }

  xOrigin = cache.xOrigin || 0;
  yOrigin = cache.yOrigin || 0;

  if (matrix !== _identity2DMatrix) {
    a = matrix[0]; //a11

    b = matrix[1]; //a21

    c = matrix[2]; //a31

    d = matrix[3]; //a41

    x = a12 = matrix[4];
    y = a22 = matrix[5]; //2D matrix

    if (matrix.length === 6) {
      scaleX = Math.sqrt(a * a + b * b);
      scaleY = Math.sqrt(d * d + c * c);
      rotation = a || b ? _atan2(b, a) * _RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).

      skewX = c || d ? _atan2(c, d) * _RAD2DEG + rotation : 0;
      skewX && (scaleY *= Math.abs(Math.cos(skewX * _DEG2RAD)));

      if (cache.svg) {
        x -= xOrigin - (xOrigin * a + yOrigin * c);
        y -= yOrigin - (xOrigin * b + yOrigin * d);
      } //3D matrix

    } else {
      a32 = matrix[6];
      a42 = matrix[7];
      a13 = matrix[8];
      a23 = matrix[9];
      a33 = matrix[10];
      a43 = matrix[11];
      x = matrix[12];
      y = matrix[13];
      z = matrix[14];
      angle = _atan2(a32, a33);
      rotationX = angle * _RAD2DEG; //rotationX

      if (angle) {
        cos = Math.cos(-angle);
        sin = Math.sin(-angle);
        t1 = a12 * cos + a13 * sin;
        t2 = a22 * cos + a23 * sin;
        t3 = a32 * cos + a33 * sin;
        a13 = a12 * -sin + a13 * cos;
        a23 = a22 * -sin + a23 * cos;
        a33 = a32 * -sin + a33 * cos;
        a43 = a42 * -sin + a43 * cos;
        a12 = t1;
        a22 = t2;
        a32 = t3;
      } //rotationY


      angle = _atan2(-c, a33);
      rotationY = angle * _RAD2DEG;

      if (angle) {
        cos = Math.cos(-angle);
        sin = Math.sin(-angle);
        t1 = a * cos - a13 * sin;
        t2 = b * cos - a23 * sin;
        t3 = c * cos - a33 * sin;
        a43 = d * sin + a43 * cos;
        a = t1;
        b = t2;
        c = t3;
      } //rotationZ


      angle = _atan2(b, a);
      rotation = angle * _RAD2DEG;

      if (angle) {
        cos = Math.cos(angle);
        sin = Math.sin(angle);
        t1 = a * cos + b * sin;
        t2 = a12 * cos + a22 * sin;
        b = b * cos - a * sin;
        a22 = a22 * cos - a12 * sin;
        a = t1;
        a12 = t2;
      }

      if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
        //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
        rotationX = rotation = 0;
        rotationY = 180 - rotationY;
      }

      scaleX = (0,gsap_core/* _round */.Pr)(Math.sqrt(a * a + b * b + c * c));
      scaleY = (0,gsap_core/* _round */.Pr)(Math.sqrt(a22 * a22 + a32 * a32));
      angle = _atan2(a12, a22);
      skewX = Math.abs(angle) > 0.0002 ? angle * _RAD2DEG : 0;
      perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
    }

    if (cache.svg) {
      //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
      t1 = target.getAttribute("transform");
      cache.forceCSS = target.setAttribute("transform", "") || !_isNullTransform(_getComputedProperty(target, _transformProp));
      t1 && target.setAttribute("transform", t1);
    }
  }

  if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
    if (invertedScaleX) {
      scaleX *= -1;
      skewX += rotation <= 0 ? 180 : -180;
      rotation += rotation <= 0 ? 180 : -180;
    } else {
      scaleY *= -1;
      skewX += skewX <= 0 ? 180 : -180;
    }
  }

  uncache = uncache || cache.uncache;
  cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
  cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
  cache.z = z + px;
  cache.scaleX = (0,gsap_core/* _round */.Pr)(scaleX);
  cache.scaleY = (0,gsap_core/* _round */.Pr)(scaleY);
  cache.rotation = (0,gsap_core/* _round */.Pr)(rotation) + deg;
  cache.rotationX = (0,gsap_core/* _round */.Pr)(rotationX) + deg;
  cache.rotationY = (0,gsap_core/* _round */.Pr)(rotationY) + deg;
  cache.skewX = skewX + deg;
  cache.skewY = skewY + deg;
  cache.transformPerspective = perspective + px;

  if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) {
    style[_transformOriginProp] = _firstTwoOnly(origin);
  }

  cache.xOffset = cache.yOffset = 0;
  cache.force3D = gsap_core/* _config.force3D */.Fc.force3D;
  cache.renderTransform = cache.svg ? _renderSVGTransforms : _supports3D ? _renderCSSTransforms : _renderNon3DTransforms;
  cache.uncache = 0;
  return cache;
},
    _firstTwoOnly = function _firstTwoOnly(value) {
  return (value = value.split(" "))[0] + " " + value[1];
},
    //for handling transformOrigin values, stripping out the 3rd dimension
_addPxTranslate = function _addPxTranslate(target, start, value) {
  var unit = (0,gsap_core/* getUnit */.Wy)(start);
  return (0,gsap_core/* _round */.Pr)(parseFloat(start) + parseFloat(_convertToUnit(target, "x", value + "px", unit))) + unit;
},
    _renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
  cache.z = "0px";
  cache.rotationY = cache.rotationX = "0deg";
  cache.force3D = 0;

  _renderCSSTransforms(ratio, cache);
},
    _zeroDeg = "0deg",
    _zeroPx = "0px",
    _endParenthesis = ") ",
    _renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
  var _ref = cache || this,
      xPercent = _ref.xPercent,
      yPercent = _ref.yPercent,
      x = _ref.x,
      y = _ref.y,
      z = _ref.z,
      rotation = _ref.rotation,
      rotationY = _ref.rotationY,
      rotationX = _ref.rotationX,
      skewX = _ref.skewX,
      skewY = _ref.skewY,
      scaleX = _ref.scaleX,
      scaleY = _ref.scaleY,
      transformPerspective = _ref.transformPerspective,
      force3D = _ref.force3D,
      target = _ref.target,
      zOrigin = _ref.zOrigin,
      transforms = "",
      use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)


  if (zOrigin && (rotationX !== _zeroDeg || rotationY !== _zeroDeg)) {
    var angle = parseFloat(rotationY) * _DEG2RAD,
        a13 = Math.sin(angle),
        a33 = Math.cos(angle),
        cos;

    angle = parseFloat(rotationX) * _DEG2RAD;
    cos = Math.cos(angle);
    x = _addPxTranslate(target, x, a13 * cos * -zOrigin);
    y = _addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
    z = _addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
  }

  if (transformPerspective !== _zeroPx) {
    transforms += "perspective(" + transformPerspective + _endParenthesis;
  }

  if (xPercent || yPercent) {
    transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
  }

  if (use3D || x !== _zeroPx || y !== _zeroPx || z !== _zeroPx) {
    transforms += z !== _zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + _endParenthesis;
  }

  if (rotation !== _zeroDeg) {
    transforms += "rotate(" + rotation + _endParenthesis;
  }

  if (rotationY !== _zeroDeg) {
    transforms += "rotateY(" + rotationY + _endParenthesis;
  }

  if (rotationX !== _zeroDeg) {
    transforms += "rotateX(" + rotationX + _endParenthesis;
  }

  if (skewX !== _zeroDeg || skewY !== _zeroDeg) {
    transforms += "skew(" + skewX + ", " + skewY + _endParenthesis;
  }

  if (scaleX !== 1 || scaleY !== 1) {
    transforms += "scale(" + scaleX + ", " + scaleY + _endParenthesis;
  }

  target.style[_transformProp] = transforms || "translate(0, 0)";
},
    _renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
  var _ref2 = cache || this,
      xPercent = _ref2.xPercent,
      yPercent = _ref2.yPercent,
      x = _ref2.x,
      y = _ref2.y,
      rotation = _ref2.rotation,
      skewX = _ref2.skewX,
      skewY = _ref2.skewY,
      scaleX = _ref2.scaleX,
      scaleY = _ref2.scaleY,
      target = _ref2.target,
      xOrigin = _ref2.xOrigin,
      yOrigin = _ref2.yOrigin,
      xOffset = _ref2.xOffset,
      yOffset = _ref2.yOffset,
      forceCSS = _ref2.forceCSS,
      tx = parseFloat(x),
      ty = parseFloat(y),
      a11,
      a21,
      a12,
      a22,
      temp;

  rotation = parseFloat(rotation);
  skewX = parseFloat(skewX);
  skewY = parseFloat(skewY);

  if (skewY) {
    //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
    skewY = parseFloat(skewY);
    skewX += skewY;
    rotation += skewY;
  }

  if (rotation || skewX) {
    rotation *= _DEG2RAD;
    skewX *= _DEG2RAD;
    a11 = Math.cos(rotation) * scaleX;
    a21 = Math.sin(rotation) * scaleX;
    a12 = Math.sin(rotation - skewX) * -scaleY;
    a22 = Math.cos(rotation - skewX) * scaleY;

    if (skewX) {
      skewY *= _DEG2RAD;
      temp = Math.tan(skewX - skewY);
      temp = Math.sqrt(1 + temp * temp);
      a12 *= temp;
      a22 *= temp;

      if (skewY) {
        temp = Math.tan(skewY);
        temp = Math.sqrt(1 + temp * temp);
        a11 *= temp;
        a21 *= temp;
      }
    }

    a11 = (0,gsap_core/* _round */.Pr)(a11);
    a21 = (0,gsap_core/* _round */.Pr)(a21);
    a12 = (0,gsap_core/* _round */.Pr)(a12);
    a22 = (0,gsap_core/* _round */.Pr)(a22);
  } else {
    a11 = scaleX;
    a22 = scaleY;
    a21 = a12 = 0;
  }

  if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
    tx = _convertToUnit(target, "x", x, "px");
    ty = _convertToUnit(target, "y", y, "px");
  }

  if (xOrigin || yOrigin || xOffset || yOffset) {
    tx = (0,gsap_core/* _round */.Pr)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
    ty = (0,gsap_core/* _round */.Pr)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
  }

  if (xPercent || yPercent) {
    //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
    temp = target.getBBox();
    tx = (0,gsap_core/* _round */.Pr)(tx + xPercent / 100 * temp.width);
    ty = (0,gsap_core/* _round */.Pr)(ty + yPercent / 100 * temp.height);
  }

  temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
  target.setAttribute("transform", temp);
  forceCSS && (target.style[_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
},
    _addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
  var cap = 360,
      isString = (0,gsap_core/* _isString */.r9)(endValue),
      endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? _RAD2DEG : 1),
      change = endNum - startNum,
      finalValue = startNum + change + "deg",
      direction,
      pt;

  if (isString) {
    direction = endValue.split("_")[1];

    if (direction === "short") {
      change %= cap;

      if (change !== change % (cap / 2)) {
        change += change < 0 ? cap : -cap;
      }
    }

    if (direction === "cw" && change < 0) {
      change = (change + cap * _bigNum) % cap - ~~(change / cap) * cap;
    } else if (direction === "ccw" && change > 0) {
      change = (change - cap * _bigNum) % cap - ~~(change / cap) * cap;
    }
  }

  plugin._pt = pt = new gsap_core/* PropTween */.Fo(plugin._pt, target, property, startNum, change, _renderPropWithEnd);
  pt.e = finalValue;
  pt.u = "deg";

  plugin._props.push(property);

  return pt;
},
    _assign = function _assign(target, source) {
  // Internet Explorer doesn't have Object.assign(), so we recreate it here.
  for (var p in source) {
    target[p] = source[p];
  }

  return target;
},
    _addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
  //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
  var startCache = _assign({}, target._gsap),
      exclude = "perspective,force3D,transformOrigin,svgOrigin",
      style = target.style,
      endCache,
      p,
      startValue,
      endValue,
      startNum,
      endNum,
      startUnit,
      endUnit;

  if (startCache.svg) {
    startValue = target.getAttribute("transform");
    target.setAttribute("transform", "");
    style[_transformProp] = transforms;
    endCache = _parseTransform(target, 1);

    _removeProperty(target, _transformProp);

    target.setAttribute("transform", startValue);
  } else {
    startValue = getComputedStyle(target)[_transformProp];
    style[_transformProp] = transforms;
    endCache = _parseTransform(target, 1);
    style[_transformProp] = startValue;
  }

  for (p in _transformProps) {
    startValue = startCache[p];
    endValue = endCache[p];

    if (startValue !== endValue && exclude.indexOf(p) < 0) {
      //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
      startUnit = (0,gsap_core/* getUnit */.Wy)(startValue);
      endUnit = (0,gsap_core/* getUnit */.Wy)(endValue);
      startNum = startUnit !== endUnit ? _convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
      endNum = parseFloat(endValue);
      plugin._pt = new gsap_core/* PropTween */.Fo(plugin._pt, endCache, p, startNum, endNum - startNum, _renderCSSProp);
      plugin._pt.u = endUnit || 0;

      plugin._props.push(p);
    }
  }

  _assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.


(0,gsap_core/* _forEachName */.fS)("padding,margin,Width,Radius", function (name, index) {
  var t = "Top",
      r = "Right",
      b = "Bottom",
      l = "Left",
      props = (index < 3 ? [t, r, b, l] : [t + l, t + r, b + r, b + l]).map(function (side) {
    return index < 2 ? name + side : "border" + side + name;
  });

  _specialProps[index > 1 ? "border" + name : name] = function (plugin, target, property, endValue, tween) {
    var a, vars;

    if (arguments.length < 4) {
      // getter, passed target, property, and unit (from _get())
      a = props.map(function (prop) {
        return _get(plugin, prop, property);
      });
      vars = a.join(" ");
      return vars.split(a[0]).length === 5 ? a[0] : vars;
    }

    a = (endValue + "").split(" ");
    vars = {};
    props.forEach(function (prop, i) {
      return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
    });
    plugin.init(target, vars, tween);
  };
});

var CSSPlugin = {
  name: "css",
  register: _initCore,
  targetTest: function targetTest(target) {
    return target.style && target.nodeType;
  },
  init: function init(target, vars, tween, index, targets) {
    var props = this._props,
        style = target.style,
        startAt = tween.vars.startAt,
        startValue,
        endValue,
        endNum,
        startNum,
        type,
        specialProp,
        p,
        startUnit,
        endUnit,
        relative,
        isTransformRelated,
        transformPropTween,
        cache,
        smooth,
        hasPriority,
        inlineProps;
    _pluginInitted || _initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps

    this.styles = this.styles || _getStyleSaver(target);
    inlineProps = this.styles.props;
    this.tween = tween;

    for (p in vars) {
      if (p === "autoRound") {
        continue;
      }

      endValue = vars[p];

      if (gsap_core/* _plugins */.$i[p] && (0,gsap_core/* _checkPlugin */["if"])(p, vars, tween, index, target, targets)) {
        // plugins
        continue;
      }

      type = typeof endValue;
      specialProp = _specialProps[p];

      if (type === "function") {
        endValue = endValue.call(tween, index, target, targets);
        type = typeof endValue;
      }

      if (type === "string" && ~endValue.indexOf("random(")) {
        endValue = (0,gsap_core/* _replaceRandom */.UI)(endValue);
      }

      if (specialProp) {
        specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
      } else if (p.substr(0, 2) === "--") {
        //CSS variable
        startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
        endValue += "";
        gsap_core/* _colorExp.lastIndex */.GN.lastIndex = 0;

        if (!gsap_core/* _colorExp.test */.GN.test(startValue)) {
          // colors don't have units
          startUnit = (0,gsap_core/* getUnit */.Wy)(startValue);
          endUnit = (0,gsap_core/* getUnit */.Wy)(endValue);
        }

        endUnit ? startUnit !== endUnit && (startValue = _convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
        this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
        props.push(p);
        inlineProps.push(p, 0, style[p]);
      } else if (type !== "undefined") {
        if (startAt && p in startAt) {
          // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
          startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
          (0,gsap_core/* _isString */.r9)(startValue) && ~startValue.indexOf("random(") && (startValue = (0,gsap_core/* _replaceRandom */.UI)(startValue));
          (0,gsap_core/* getUnit */.Wy)(startValue + "") || startValue === "auto" || (startValue += gsap_core/* _config.units */.Fc.units[p] || (0,gsap_core/* getUnit */.Wy)(_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.

          (startValue + "").charAt(1) === "=" && (startValue = _get(target, p)); // can't work with relative values
        } else {
          startValue = _get(target, p);
        }

        startNum = parseFloat(startValue);
        relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
        relative && (endValue = endValue.substr(2));
        endNum = parseFloat(endValue);

        if (p in _propertyAliases) {
          if (p === "autoAlpha") {
            //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
            if (startNum === 1 && _get(target, "visibility") === "hidden" && endNum) {
              //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
              startNum = 0;
            }

            inlineProps.push("visibility", 0, style.visibility);

            _addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
          }

          if (p !== "scale" && p !== "transform") {
            p = _propertyAliases[p];
            ~p.indexOf(",") && (p = p.split(",")[0]);
          }
        }

        isTransformRelated = p in _transformProps; //--- TRANSFORM-RELATED ---

        if (isTransformRelated) {
          this.styles.save(p);

          if (!transformPropTween) {
            cache = target._gsap;
            cache.renderTransform && !vars.parseTransform || _parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.

            smooth = vars.smoothOrigin !== false && cache.smooth;
            transformPropTween = this._pt = new gsap_core/* PropTween */.Fo(this._pt, style, _transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)

            transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
          }

          if (p === "scale") {
            this._pt = new gsap_core/* PropTween */.Fo(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0,gsap_core/* _parseRelative */.cy)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, _renderCSSProp);
            this._pt.u = 0;
            props.push("scaleY", p);
            p += "X";
          } else if (p === "transformOrigin") {
            inlineProps.push(_transformOriginProp, 0, style[_transformOriginProp]);
            endValue = _convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.

            if (cache.svg) {
              _applySVGOrigin(target, endValue, 0, smooth, 0, this);
            } else {
              endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!

              endUnit !== cache.zOrigin && _addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);

              _addNonTweeningPT(this, style, p, _firstTwoOnly(startValue), _firstTwoOnly(endValue));
            }

            continue;
          } else if (p === "svgOrigin") {
            _applySVGOrigin(target, endValue, 1, smooth, 0, this);

            continue;
          } else if (p in _rotationalProperties) {
            _addRotationalPropTween(this, cache, p, startNum, relative ? (0,gsap_core/* _parseRelative */.cy)(startNum, relative + endValue) : endValue);

            continue;
          } else if (p === "smoothOrigin") {
            _addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);

            continue;
          } else if (p === "force3D") {
            cache[p] = endValue;
            continue;
          } else if (p === "transform") {
            _addRawTransformPTs(this, endValue, target);

            continue;
          }
        } else if (!(p in style)) {
          p = _checkPropPrefix(p) || p;
        }

        if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !_complexExp.test(endValue) && p in style) {
          startUnit = (startValue + "").substr((startNum + "").length);
          endNum || (endNum = 0); // protect against NaN

          endUnit = (0,gsap_core/* getUnit */.Wy)(endValue) || (p in gsap_core/* _config.units */.Fc.units ? gsap_core/* _config.units */.Fc.units[p] : startUnit);
          startUnit !== endUnit && (startNum = _convertToUnit(target, p, startValue, endUnit));
          this._pt = new gsap_core/* PropTween */.Fo(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0,gsap_core/* _parseRelative */.cy)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? _renderRoundedCSSProp : _renderCSSProp);
          this._pt.u = endUnit || 0;

          if (startUnit !== endUnit && endUnit !== "%") {
            //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
            this._pt.b = startValue;
            this._pt.r = _renderCSSPropWithBeginning;
          }
        } else if (!(p in style)) {
          if (p in target) {
            //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
            this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
          } else if (p !== "parseTransform") {
            (0,gsap_core/* _missingPlugin */.lC)(p, endValue);

            continue;
          }
        } else {
          _tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
        }

        isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : inlineProps.push(p, 1, startValue || target[p]));
        props.push(p);
      }
    }

    hasPriority && (0,gsap_core/* _sortPropTweensByPriority */.JV)(this);
  },
  render: function render(ratio, data) {
    if (data.tween._time || !_reverting()) {
      var pt = data._pt;

      while (pt) {
        pt.r(ratio, pt.d);
        pt = pt._next;
      }
    } else {
      data.styles.revert();
    }
  },
  get: _get,
  aliases: _propertyAliases,
  getSetter: function getSetter(target, property, plugin) {
    //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
    var p = _propertyAliases[property];
    p && p.indexOf(",") < 0 && (property = p);
    return property in _transformProps && property !== _transformOriginProp && (target._gsap.x || _get(target, "x")) ? plugin && _recentSetterPlugin === plugin ? property === "scale" ? _setterScale : _setterTransform : (_recentSetterPlugin = plugin || {}) && (property === "scale" ? _setterScaleWithRender : _setterTransformWithRender) : target.style && !(0,gsap_core/* _isUndefined */.m2)(target.style[property]) ? _setterCSSStyle : ~property.indexOf("-") ? _setterCSSProp : (0,gsap_core/* _getSetter */.S5)(target, property);
  },
  core: {
    _removeProperty: _removeProperty,
    _getMatrix: _getMatrix
  }
};
gsap_core/* gsap.utils.checkPrefix */.p8.utils.checkPrefix = _checkPropPrefix;
gsap_core/* gsap.core.getStyleSaver */.p8.core.getStyleSaver = _getStyleSaver;

(function (positionAndScale, rotation, others, aliases) {
  var all = (0,gsap_core/* _forEachName */.fS)(positionAndScale + "," + rotation + "," + others, function (name) {
    _transformProps[name] = 1;
  });

  (0,gsap_core/* _forEachName */.fS)(rotation, function (name) {
    gsap_core/* _config.units */.Fc.units[name] = "deg";
    _rotationalProperties[name] = 1;
  });

  _propertyAliases[all[13]] = positionAndScale + "," + rotation;

  (0,gsap_core/* _forEachName */.fS)(aliases, function (name) {
    var split = name.split(":");
    _propertyAliases[split[1]] = all[split[0]];
  });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");

(0,gsap_core/* _forEachName */.fS)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function (name) {
  gsap_core/* _config.units */.Fc.units[name] = "px";
});

gsap_core/* gsap.registerPlugin */.p8.registerPlugin(CSSPlugin);

;// CONCATENATED MODULE: ./node_modules/gsap/index.js


var gsapWithCSS = gsap_core/* gsap.registerPlugin */.p8.registerPlugin(CSSPlugin) || gsap_core/* gsap */.p8,
    // to protect from tree shaking
TweenMaxWithCSS = gsapWithCSS.core.Tween;


/***/ }),

/***/ 94915:
/***/ (function(module) {

"use strict";


function pad (hash, len) {
  while (hash.length < len) {
    hash = '0' + hash;
  }
  return hash;
}

function fold (hash, text) {
  var i;
  var chr;
  var len;
  if (text.length === 0) {
    return hash;
  }
  for (i = 0, len = text.length; i < len; i++) {
    chr = text.charCodeAt(i);
    hash = ((hash << 5) - hash) + chr;
    hash |= 0;
  }
  return hash < 0 ? hash * -2 : hash;
}

function foldObject (hash, o, seen) {
  return Object.keys(o).sort().reduce(foldKey, hash);
  function foldKey (hash, key) {
    return foldValue(hash, o[key], key, seen);
  }
}

function foldValue (input, value, key, seen) {
  var hash = fold(fold(fold(input, key), toString(value)), typeof value);
  if (value === null) {
    return fold(hash, 'null');
  }
  if (value === undefined) {
    return fold(hash, 'undefined');
  }
  if (typeof value === 'object' || typeof value === 'function') {
    if (seen.indexOf(value) !== -1) {
      return fold(hash, '[Circular]' + key);
    }
    seen.push(value);

    var objHash = foldObject(hash, value, seen)

    if (!('valueOf' in value) || typeof value.valueOf !== 'function') {
      return objHash;
    }

    try {
      return fold(objHash, String(value.valueOf()))
    } catch (err) {
      return fold(objHash, '[valueOf exception]' + (err.stack || err.message))
    }
  }
  return fold(hash, value.toString());
}

function toString (o) {
  return Object.prototype.toString.call(o);
}

function sum (o) {
  return pad(foldValue(0, o, '', []).toString(16), 8);
}

module.exports = sum;


/***/ }),

/***/ 89471:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(82497),
    root = __webpack_require__(48425);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 99551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(2219),
    hashDelete = __webpack_require__(82064),
    hashGet = __webpack_require__(18968),
    hashHas = __webpack_require__(2089),
    hashSet = __webpack_require__(79116);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 53036:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(76493),
    listCacheDelete = __webpack_require__(85102),
    listCacheGet = __webpack_require__(76689),
    listCacheHas = __webpack_require__(7439),
    listCacheSet = __webpack_require__(90267);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 89759:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(82497),
    root = __webpack_require__(48425);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 71619:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(81111),
    mapCacheDelete = __webpack_require__(33577),
    mapCacheGet = __webpack_require__(79186),
    mapCacheHas = __webpack_require__(89719),
    mapCacheSet = __webpack_require__(81738);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 15628:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(82497),
    root = __webpack_require__(48425);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 76435:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(82497),
    root = __webpack_require__(48425);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 88567:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(53036),
    stackClear = __webpack_require__(49542),
    stackDelete = __webpack_require__(4833),
    stackGet = __webpack_require__(34539),
    stackHas = __webpack_require__(7280),
    stackSet = __webpack_require__(29031);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 3478:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(48425);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 61419:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(48425);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 1238:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(82497),
    root = __webpack_require__(48425);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 48219:
/***/ (function(module) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 33648:
/***/ (function(module) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 49969:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 76750:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(31853),
    isArguments = __webpack_require__(21026),
    isArray = __webpack_require__(70771),
    isBuffer = __webpack_require__(36371),
    isIndex = __webpack_require__(65025),
    isTypedArray = __webpack_require__(64879);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 7976:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 57634:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 68692:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(67249),
    eq = __webpack_require__(47484);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 33089:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(47484);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 30305:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(11546),
    keys = __webpack_require__(49679);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),

/***/ 81035:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(11546),
    keysIn = __webpack_require__(73301);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),

/***/ 67249:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(97700);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 35746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(88567),
    arrayEach = __webpack_require__(33648),
    assignValue = __webpack_require__(68692),
    baseAssign = __webpack_require__(30305),
    baseAssignIn = __webpack_require__(81035),
    cloneBuffer = __webpack_require__(26551),
    copyArray = __webpack_require__(48023),
    copySymbols = __webpack_require__(11071),
    copySymbolsIn = __webpack_require__(91680),
    getAllKeys = __webpack_require__(78433),
    getAllKeysIn = __webpack_require__(10476),
    getTag = __webpack_require__(84253),
    initCloneArray = __webpack_require__(85339),
    initCloneByTag = __webpack_require__(39371),
    initCloneObject = __webpack_require__(50848),
    isArray = __webpack_require__(70771),
    isBuffer = __webpack_require__(36371),
    isMap = __webpack_require__(34714),
    isObject = __webpack_require__(44593),
    isSet = __webpack_require__(47893),
    keys = __webpack_require__(49679),
    keysIn = __webpack_require__(73301);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),

/***/ 11647:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(44593);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ 39306:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(57634),
    isFlattenable = __webpack_require__(28504);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ 96239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(51548),
    toKey = __webpack_require__(93384);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 7316:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(57634),
    isArray = __webpack_require__(70771);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 12954:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(3478),
    getRawTag = __webpack_require__(37309),
    objectToString = __webpack_require__(75414);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 54240:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(12954),
    isObjectLike = __webpack_require__(65295);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 91108:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(84253),
    isObjectLike = __webpack_require__(65295);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),

/***/ 74038:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(62343),
    isMasked = __webpack_require__(56083),
    isObject = __webpack_require__(44593),
    toSource = __webpack_require__(8541);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 96730:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(84253),
    isObjectLike = __webpack_require__(65295);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),

/***/ 24468:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(12954),
    isLength = __webpack_require__(29775),
    isObjectLike = __webpack_require__(65295);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 50474:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(80811),
    nativeKeys = __webpack_require__(83818);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 45879:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(44593),
    isPrototype = __webpack_require__(80811),
    nativeKeysIn = __webpack_require__(27991);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ 73570:
/***/ (function(module) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),

/***/ 50995:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var constant = __webpack_require__(14006),
    defineProperty = __webpack_require__(97700),
    identity = __webpack_require__(33556);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 91395:
/***/ (function(module) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 31853:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 90716:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(3478),
    arrayMap = __webpack_require__(7976),
    isArray = __webpack_require__(70771),
    isSymbol = __webpack_require__(67442);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 20551:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 41297:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(51548),
    last = __webpack_require__(13048),
    parent = __webpack_require__(2625),
    toKey = __webpack_require__(93384);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),

/***/ 51548:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(70771),
    isKey = __webpack_require__(84658),
    stringToPath = __webpack_require__(89265),
    toString = __webpack_require__(14106);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 66139:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Uint8Array = __webpack_require__(61419);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ 26551:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(48425);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;


/***/ }),

/***/ 96183:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(66139);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),

/***/ 4361:
/***/ (function(module) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),

/***/ 99334:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(3478);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),

/***/ 52189:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(66139);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ 48023:
/***/ (function(module) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 11546:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(68692),
    baseAssignValue = __webpack_require__(67249);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ 11071:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(11546),
    getSymbols = __webpack_require__(29888);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),

/***/ 91680:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(11546),
    getSymbolsIn = __webpack_require__(39017);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),

/***/ 62374:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(48425);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 97470:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPlainObject = __webpack_require__(40737);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),

/***/ 97700:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(82497);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 88520:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var flatten = __webpack_require__(23688),
    overRest = __webpack_require__(98073),
    setToString = __webpack_require__(17233);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),

/***/ 98333:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 78433:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(7316),
    getSymbols = __webpack_require__(29888),
    keys = __webpack_require__(49679);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 10476:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(7316),
    getSymbolsIn = __webpack_require__(39017),
    keysIn = __webpack_require__(73301);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),

/***/ 90282:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(75015);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 82497:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(74038),
    getValue = __webpack_require__(96839);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 24854:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(15611);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 37309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(3478);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 29888:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(49969),
    stubArray = __webpack_require__(23369);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 39017:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(57634),
    getPrototype = __webpack_require__(24854),
    getSymbols = __webpack_require__(29888),
    stubArray = __webpack_require__(23369);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),

/***/ 84253:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(89471),
    Map = __webpack_require__(89759),
    Promise = __webpack_require__(15628),
    Set = __webpack_require__(76435),
    WeakMap = __webpack_require__(1238),
    baseGetTag = __webpack_require__(12954),
    toSource = __webpack_require__(8541);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 96839:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 2219:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99933);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 82064:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 18968:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99933);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 2089:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99933);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 79116:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99933);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 85339:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),

/***/ 39371:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(66139),
    cloneDataView = __webpack_require__(96183),
    cloneRegExp = __webpack_require__(4361),
    cloneSymbol = __webpack_require__(99334),
    cloneTypedArray = __webpack_require__(52189);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),

/***/ 50848:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseCreate = __webpack_require__(11647),
    getPrototype = __webpack_require__(24854),
    isPrototype = __webpack_require__(80811);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ 28504:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(3478),
    isArguments = __webpack_require__(21026),
    isArray = __webpack_require__(70771);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ 65025:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 84658:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(70771),
    isSymbol = __webpack_require__(67442);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 75015:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 56083:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(62374);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 80811:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 76493:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 85102:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(33089);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 76689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(33089);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 7439:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(33089);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 90267:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(33089);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 81111:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(99551),
    ListCache = __webpack_require__(53036),
    Map = __webpack_require__(89759);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 33577:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(90282);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 79186:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(90282);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 89719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(90282);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 81738:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(90282);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 34240:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(80053);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 99933:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(82497);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 83818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(15611);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 27991:
/***/ (function(module) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ 33771:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(98333);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 75414:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 15611:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 98073:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var apply = __webpack_require__(48219);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 2625:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(96239),
    baseSlice = __webpack_require__(91395);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),

/***/ 48425:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(98333);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 17233:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSetToString = __webpack_require__(50995),
    shortOut = __webpack_require__(46652);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 46652:
/***/ (function(module) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 49542:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(53036);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 4833:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 34539:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 7280:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 29031:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(53036),
    Map = __webpack_require__(89759),
    MapCache = __webpack_require__(71619);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 89265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(34240);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 93384:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(67442);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 8541:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 31209:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(73570);

/** Used to map HTML entities to characters. */
var htmlUnescapes = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'"
};

/**
 * Used by `_.unescape` to convert HTML entities to characters.
 *
 * @private
 * @param {string} chr The matched character to unescape.
 * @returns {string} Returns the unescaped character.
 */
var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

module.exports = unescapeHtmlChar;


/***/ }),

/***/ 14006:
/***/ (function(module) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 47484:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 23688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(39306);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),

/***/ 33556:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 21026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(54240),
    isObjectLike = __webpack_require__(65295);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 70771:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 87609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(62343),
    isLength = __webpack_require__(29775);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 36371:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(48425),
    stubFalse = __webpack_require__(96485);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 62343:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(12954),
    isObject = __webpack_require__(44593);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 29775:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 34714:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMap = __webpack_require__(91108),
    baseUnary = __webpack_require__(20551),
    nodeUtil = __webpack_require__(33771);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),

/***/ 44593:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 65295:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 40737:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(12954),
    getPrototype = __webpack_require__(24854),
    isObjectLike = __webpack_require__(65295);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 47893:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsSet = __webpack_require__(96730),
    baseUnary = __webpack_require__(20551),
    nodeUtil = __webpack_require__(33771);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),

/***/ 67442:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(12954),
    isObjectLike = __webpack_require__(65295);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 64879:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(24468),
    baseUnary = __webpack_require__(20551),
    nodeUtil = __webpack_require__(33771);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 49679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(76750),
    baseKeys = __webpack_require__(50474),
    isArrayLike = __webpack_require__(87609);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 73301:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(76750),
    baseKeysIn = __webpack_require__(45879),
    isArrayLike = __webpack_require__(87609);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ 13048:
/***/ (function(module) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ 16638:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ 80053:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(71619);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 13110:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(7976),
    baseClone = __webpack_require__(35746),
    baseUnset = __webpack_require__(41297),
    castPath = __webpack_require__(51548),
    copyObject = __webpack_require__(11546),
    customOmitClone = __webpack_require__(97470),
    flatRest = __webpack_require__(88520),
    getAllKeysIn = __webpack_require__(10476);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),

/***/ 23369:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 96485:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 14106:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(90716);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 16561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toString = __webpack_require__(14106),
    unescapeHtmlChar = __webpack_require__(31209);

/** Used to match HTML entities and HTML characters. */
var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
    reHasEscapedHtml = RegExp(reEscapedHtml.source);

/**
 * The inverse of `_.escape`; this method converts the HTML entities
 * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
 * their corresponding characters.
 *
 * **Note:** No other HTML entities are unescaped. To unescape additional
 * HTML entities use a third-party library like [_he_](https://mths.be/he).
 *
 * @static
 * @memberOf _
 * @since 0.6.0
 * @category String
 * @param {string} [string=''] The string to unescape.
 * @returns {string} Returns the unescaped string.
 * @example
 *
 * _.unescape('fred, barney, &amp; pebbles');
 * // => 'fred, barney, & pebbles'
 */
function unescape(string) {
  string = toString(string);
  return (string && reHasEscapedHtml.test(string))
    ? string.replace(reEscapedHtml, unescapeHtmlChar)
    : string;
}

module.exports = unescape;


/***/ }),

/***/ 41390:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(21520)


/***/ }),

/***/ 28584:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(42397);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 87043:
/***/ (function(module) {

var __dirname = "/";
(function(){"use strict";var e={114:function(e){function assertPath(e){if(typeof e!=="string"){throw new TypeError("Path must be a string. Received "+JSON.stringify(e))}}function normalizeStringPosix(e,r){var t="";var i=0;var n=-1;var a=0;var f;for(var l=0;l<=e.length;++l){if(l<e.length)f=e.charCodeAt(l);else if(f===47)break;else f=47;if(f===47){if(n===l-1||a===1){}else if(n!==l-1&&a===2){if(t.length<2||i!==2||t.charCodeAt(t.length-1)!==46||t.charCodeAt(t.length-2)!==46){if(t.length>2){var s=t.lastIndexOf("/");if(s!==t.length-1){if(s===-1){t="";i=0}else{t=t.slice(0,s);i=t.length-1-t.lastIndexOf("/")}n=l;a=0;continue}}else if(t.length===2||t.length===1){t="";i=0;n=l;a=0;continue}}if(r){if(t.length>0)t+="/..";else t="..";i=2}}else{if(t.length>0)t+="/"+e.slice(n+1,l);else t=e.slice(n+1,l);i=l-n-1}n=l;a=0}else if(f===46&&a!==-1){++a}else{a=-1}}return t}function _format(e,r){var t=r.dir||r.root;var i=r.base||(r.name||"")+(r.ext||"");if(!t){return i}if(t===r.root){return t+i}return t+e+i}var r={resolve:function resolve(){var e="";var r=false;var t;for(var i=arguments.length-1;i>=-1&&!r;i--){var n;if(i>=0)n=arguments[i];else{if(t===undefined)t="";n=t}assertPath(n);if(n.length===0){continue}e=n+"/"+e;r=n.charCodeAt(0)===47}e=normalizeStringPosix(e,!r);if(r){if(e.length>0)return"/"+e;else return"/"}else if(e.length>0){return e}else{return"."}},normalize:function normalize(e){assertPath(e);if(e.length===0)return".";var r=e.charCodeAt(0)===47;var t=e.charCodeAt(e.length-1)===47;e=normalizeStringPosix(e,!r);if(e.length===0&&!r)e=".";if(e.length>0&&t)e+="/";if(r)return"/"+e;return e},isAbsolute:function isAbsolute(e){assertPath(e);return e.length>0&&e.charCodeAt(0)===47},join:function join(){if(arguments.length===0)return".";var e;for(var t=0;t<arguments.length;++t){var i=arguments[t];assertPath(i);if(i.length>0){if(e===undefined)e=i;else e+="/"+i}}if(e===undefined)return".";return r.normalize(e)},relative:function relative(e,t){assertPath(e);assertPath(t);if(e===t)return"";e=r.resolve(e);t=r.resolve(t);if(e===t)return"";var i=1;for(;i<e.length;++i){if(e.charCodeAt(i)!==47)break}var n=e.length;var a=n-i;var f=1;for(;f<t.length;++f){if(t.charCodeAt(f)!==47)break}var l=t.length;var s=l-f;var o=a<s?a:s;var u=-1;var h=0;for(;h<=o;++h){if(h===o){if(s>o){if(t.charCodeAt(f+h)===47){return t.slice(f+h+1)}else if(h===0){return t.slice(f+h)}}else if(a>o){if(e.charCodeAt(i+h)===47){u=h}else if(h===0){u=0}}break}var c=e.charCodeAt(i+h);var v=t.charCodeAt(f+h);if(c!==v)break;else if(c===47)u=h}var g="";for(h=i+u+1;h<=n;++h){if(h===n||e.charCodeAt(h)===47){if(g.length===0)g+="..";else g+="/.."}}if(g.length>0)return g+t.slice(f+u);else{f+=u;if(t.charCodeAt(f)===47)++f;return t.slice(f)}},_makeLong:function _makeLong(e){return e},dirname:function dirname(e){assertPath(e);if(e.length===0)return".";var r=e.charCodeAt(0);var t=r===47;var i=-1;var n=true;for(var a=e.length-1;a>=1;--a){r=e.charCodeAt(a);if(r===47){if(!n){i=a;break}}else{n=false}}if(i===-1)return t?"/":".";if(t&&i===1)return"//";return e.slice(0,i)},basename:function basename(e,r){if(r!==undefined&&typeof r!=="string")throw new TypeError('"ext" argument must be a string');assertPath(e);var t=0;var i=-1;var n=true;var a;if(r!==undefined&&r.length>0&&r.length<=e.length){if(r.length===e.length&&r===e)return"";var f=r.length-1;var l=-1;for(a=e.length-1;a>=0;--a){var s=e.charCodeAt(a);if(s===47){if(!n){t=a+1;break}}else{if(l===-1){n=false;l=a+1}if(f>=0){if(s===r.charCodeAt(f)){if(--f===-1){i=a}}else{f=-1;i=l}}}}if(t===i)i=l;else if(i===-1)i=e.length;return e.slice(t,i)}else{for(a=e.length-1;a>=0;--a){if(e.charCodeAt(a)===47){if(!n){t=a+1;break}}else if(i===-1){n=false;i=a+1}}if(i===-1)return"";return e.slice(t,i)}},extname:function extname(e){assertPath(e);var r=-1;var t=0;var i=-1;var n=true;var a=0;for(var f=e.length-1;f>=0;--f){var l=e.charCodeAt(f);if(l===47){if(!n){t=f+1;break}continue}if(i===-1){n=false;i=f+1}if(l===46){if(r===-1)r=f;else if(a!==1)a=1}else if(r!==-1){a=-1}}if(r===-1||i===-1||a===0||a===1&&r===i-1&&r===t+1){return""}return e.slice(r,i)},format:function format(e){if(e===null||typeof e!=="object"){throw new TypeError('The "pathObject" argument must be of type Object. Received type '+typeof e)}return _format("/",e)},parse:function parse(e){assertPath(e);var r={root:"",dir:"",base:"",ext:"",name:""};if(e.length===0)return r;var t=e.charCodeAt(0);var i=t===47;var n;if(i){r.root="/";n=1}else{n=0}var a=-1;var f=0;var l=-1;var s=true;var o=e.length-1;var u=0;for(;o>=n;--o){t=e.charCodeAt(o);if(t===47){if(!s){f=o+1;break}continue}if(l===-1){s=false;l=o+1}if(t===46){if(a===-1)a=o;else if(u!==1)u=1}else if(a!==-1){u=-1}}if(a===-1||l===-1||u===0||u===1&&a===l-1&&a===f+1){if(l!==-1){if(f===0&&i)r.base=r.name=e.slice(1,l);else r.base=r.name=e.slice(f,l)}}else{if(f===0&&i){r.name=e.slice(1,a);r.base=e.slice(1,l)}else{r.name=e.slice(f,a);r.base=e.slice(f,l)}r.ext=e.slice(a,l)}if(f>0)r.dir=e.slice(0,f-1);else if(i)r.dir="/";return r},sep:"/",delimiter:":",win32:null,posix:null};r.posix=r;e.exports=r}};var r={};function __nccwpck_require__(t){var i=r[t];if(i!==undefined){return i.exports}var n=r[t]={exports:{}};var a=true;try{e[t](n,n.exports,__nccwpck_require__);a=false}finally{if(a)delete r[t]}return n.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(114);module.exports=t})();

/***/ }),

/***/ 42397:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 54666:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(45656)


/***/ }),

/***/ 42132:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(31675)


/***/ }),

/***/ 48771:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(16067)


/***/ }),

/***/ 76899:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(52780)


/***/ }),

/***/ 75407:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(38355)


/***/ }),

/***/ 97033:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports =
   false
    ? 0
    : __webpack_require__(79448)


/***/ }),

/***/ 1053:
/***/ (function(module, exports) {

"use strict";


// ref: https://github.com/tc39/proposal-global
var getGlobal = function () {
	// the only reliable means to get the global object is
	// `Function('return this')()`
	// However, this causes CSP violations in Chrome apps.
	if (typeof self !== 'undefined') { return self; }
	if (typeof window !== 'undefined') { return window; }
	if (typeof global !== 'undefined') { return global; }
	throw new Error('unable to locate global object');
}

var global = getGlobal();

module.exports = exports = global.fetch;

// Needed for TypeScript and Webpack.
if (global.fetch) {
	exports["default"] = global.fetch.bind(global);
}

exports.Headers = global.Headers;
exports.Request = global.Request;
exports.Response = global.Response;

/***/ }),

/***/ 7370:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(16563);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 74895:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(7370)();
}


/***/ }),

/***/ 16563:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 6404:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CopyToClipboard = void 0;

var _react = _interopRequireDefault(__webpack_require__(62991));

var _copyToClipboard = _interopRequireDefault(__webpack_require__(28954));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CopyToClipboard =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(CopyToClipboard, _React$PureComponent);

  function CopyToClipboard() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CopyToClipboard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CopyToClipboard)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
      var _this$props = _this.props,
          text = _this$props.text,
          onCopy = _this$props.onCopy,
          children = _this$props.children,
          options = _this$props.options;

      var elem = _react["default"].Children.only(children);

      var result = (0, _copyToClipboard["default"])(text, options);

      if (onCopy) {
        onCopy(text, result);
      } // Bypass onClick if it was present


      if (elem && elem.props && typeof elem.props.onClick === 'function') {
        elem.props.onClick(event);
      }
    });

    return _this;
  }

  _createClass(CopyToClipboard, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _text = _this$props2.text,
          _onCopy = _this$props2.onCopy,
          _options = _this$props2.options,
          children = _this$props2.children,
          props = _objectWithoutProperties(_this$props2, ["text", "onCopy", "options", "children"]);

      var elem = _react["default"].Children.only(children);

      return _react["default"].cloneElement(elem, _objectSpread({}, props, {
        onClick: this.onClick
      }));
    }
  }]);

  return CopyToClipboard;
}(_react["default"].PureComponent);

exports.CopyToClipboard = CopyToClipboard;

_defineProperty(CopyToClipboard, "defaultProps", {
  onCopy: undefined,
  options: undefined
});

/***/ }),

/***/ 45630:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(6404),
    CopyToClipboard = _require.CopyToClipboard;

CopyToClipboard.CopyToClipboard = CopyToClipboard;
module.exports = CopyToClipboard;

/***/ }),

/***/ 43469:
/***/ (function(module) {

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),

/***/ 87834:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
"use client"


function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

__webpack_unused_export__ = ({ value: true });

var React = __webpack_require__(62991);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

___$insertStyle(".rfm-marquee-container {\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  width: var(--width);\n  transform: var(--transform);\n}\n.rfm-marquee-container:hover div {\n  animation-play-state: var(--pause-on-hover);\n}\n.rfm-marquee-container:active div {\n  animation-play-state: var(--pause-on-click);\n}\n\n.rfm-overlay {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n.rfm-overlay::before, .rfm-overlay::after {\n  background: linear-gradient(to right, var(--gradient-color), rgba(255, 255, 255, 0));\n  content: \"\";\n  height: 100%;\n  position: absolute;\n  width: var(--gradient-width);\n  z-index: 2;\n  pointer-events: none;\n  touch-action: none;\n}\n.rfm-overlay::after {\n  right: 0;\n  top: 0;\n  transform: rotateZ(180deg);\n}\n.rfm-overlay::before {\n  left: 0;\n  top: 0;\n}\n\n.rfm-marquee {\n  flex: 0 0 auto;\n  min-width: var(--min-width);\n  z-index: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  animation: scroll var(--duration) linear var(--delay) var(--iteration-count);\n  animation-play-state: var(--play);\n  animation-delay: var(--delay);\n  animation-direction: var(--direction);\n}\n@keyframes scroll {\n  0% {\n    transform: translateX(0%);\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n}\n\n.rfm-initial-child-container {\n  flex: 0 0 auto;\n  display: flex;\n  min-width: auto;\n  flex-direction: row;\n  align-items: center;\n}\n\n.rfm-child {\n  transform: var(--transform);\n}");

const Marquee = React.forwardRef(function Marquee({ style = {}, className = "", autoFill = false, play = true, pauseOnHover = false, pauseOnClick = false, direction = "left", speed = 50, delay = 0, loop = 0, gradient = false, gradientColor = "white", gradientWidth = 200, onFinish, onCycleComplete, onMount, children, }, ref) {
    // React Hooks
    const [containerWidth, setContainerWidth] = React.useState(0);
    const [marqueeWidth, setMarqueeWidth] = React.useState(0);
    const [multiplier, setMultiplier] = React.useState(1);
    const [isMounted, setIsMounted] = React.useState(false);
    const rootRef = React.useRef(null);
    const containerRef = ref || rootRef;
    const marqueeRef = React.useRef(null);
    // Calculate width of container and marquee and set multiplier
    const calculateWidth = React.useCallback(() => {
        if (marqueeRef.current && containerRef.current) {
            const containerRect = containerRef.current.getBoundingClientRect();
            const marqueeRect = marqueeRef.current.getBoundingClientRect();
            let containerWidth = containerRect.width;
            let marqueeWidth = marqueeRect.width;
            // Swap width and height if direction is up or down
            if (direction === "up" || direction === "down") {
                containerWidth = containerRect.height;
                marqueeWidth = marqueeRect.height;
            }
            if (autoFill && containerWidth && marqueeWidth) {
                setMultiplier(marqueeWidth < containerWidth
                    ? Math.ceil(containerWidth / marqueeWidth)
                    : 1);
            }
            else {
                setMultiplier(1);
            }
            setContainerWidth(containerWidth);
            setMarqueeWidth(marqueeWidth);
        }
    }, [autoFill, containerRef, direction]);
    // Calculate width and multiplier on mount and on window resize
    React.useEffect(() => {
        if (!isMounted)
            return;
        calculateWidth();
        if (marqueeRef.current && containerRef.current) {
            const resizeObserver = new ResizeObserver(() => calculateWidth());
            resizeObserver.observe(containerRef.current);
            resizeObserver.observe(marqueeRef.current);
            return () => {
                if (!resizeObserver)
                    return;
                resizeObserver.disconnect();
            };
        }
    }, [calculateWidth, containerRef, isMounted]);
    // Recalculate width when children change
    React.useEffect(() => {
        calculateWidth();
    }, [calculateWidth, children]);
    React.useEffect(() => {
        setIsMounted(true);
    }, []);
    // Runs the onMount callback, if it is a function, when Marquee is mounted.
    React.useEffect(() => {
        if (typeof onMount === "function") {
            onMount();
        }
    }, []);
    // Animation duration
    const duration = React.useMemo(() => {
        if (autoFill) {
            return (marqueeWidth * multiplier) / speed;
        }
        else {
            return marqueeWidth < containerWidth
                ? containerWidth / speed
                : marqueeWidth / speed;
        }
    }, [autoFill, containerWidth, marqueeWidth, multiplier, speed]);
    const containerStyle = React.useMemo(() => (Object.assign(Object.assign({}, style), { ["--pause-on-hover"]: !play || pauseOnHover ? "paused" : "running", ["--pause-on-click"]: !play || (pauseOnHover && !pauseOnClick) || pauseOnClick
            ? "paused"
            : "running", ["--width"]: direction === "up" || direction === "down" ? `100vh` : "100%", ["--transform"]: direction === "up"
            ? "rotate(-90deg)"
            : direction === "down"
                ? "rotate(90deg)"
                : "none" })), [style, play, pauseOnHover, pauseOnClick, direction]);
    const gradientStyle = React.useMemo(() => ({
        ["--gradient-color"]: gradientColor,
        ["--gradient-width"]: typeof gradientWidth === "number"
            ? `${gradientWidth}px`
            : gradientWidth,
    }), [gradientColor, gradientWidth]);
    const marqueeStyle = React.useMemo(() => ({
        ["--play"]: play ? "running" : "paused",
        ["--direction"]: direction === "left" ? "normal" : "reverse",
        ["--duration"]: `${duration}s`,
        ["--delay"]: `${delay}s`,
        ["--iteration-count"]: !!loop ? `${loop}` : "infinite",
        ["--min-width"]: autoFill ? `auto` : "100%",
    }), [play, direction, duration, delay, loop, autoFill]);
    const childStyle = React.useMemo(() => ({
        ["--transform"]: direction === "up"
            ? "rotate(90deg)"
            : direction === "down"
                ? "rotate(-90deg)"
                : "none",
    }), [direction]);
    // Render {multiplier} number of children
    const multiplyChildren = React.useCallback((multiplier) => {
        return [
            ...Array(Number.isFinite(multiplier) && multiplier >= 0 ? multiplier : 0),
        ].map((_, i) => (React__default['default'].createElement(React.Fragment, { key: i }, React.Children.map(children, (child) => {
            return (React__default['default'].createElement("div", { style: childStyle, className: "rfm-child" }, child));
        }))));
    }, [childStyle, children]);
    return !isMounted ? null : (React__default['default'].createElement("div", { ref: containerRef, style: containerStyle, className: "rfm-marquee-container " + className },
        gradient && React__default['default'].createElement("div", { style: gradientStyle, className: "rfm-overlay" }),
        React__default['default'].createElement("div", { className: "rfm-marquee", style: marqueeStyle, onAnimationIteration: onCycleComplete, onAnimationEnd: onFinish },
            React__default['default'].createElement("div", { className: "rfm-initial-child-container", ref: marqueeRef }, React.Children.map(children, (child) => {
                return (React__default['default'].createElement("div", { style: childStyle, className: "rfm-child" }, child));
            })),
            multiplyChildren(multiplier - 1)),
        React__default['default'].createElement("div", { className: "rfm-marquee", style: marqueeStyle }, multiplyChildren(multiplier))));
});

exports.Z = Marquee;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 31882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ usePopper; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(62991);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(65883);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindow.js
function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js


function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}


;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/math.js
var math_max = Math.max;
var math_min = Math.min;
var round = Math.round;
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js


function getBoundingClientRect(element, includeScale) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  var rect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (isHTMLElement(element) && includeScale) {
    var offsetHeight = element.offsetHeight;
    var offsetWidth = element.offsetWidth; // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
    // Fallback to 1 in case both values are `0`

    if (offsetWidth > 0) {
      scaleX = round(rect.width) / offsetWidth || 1;
    }

    if (offsetHeight > 0) {
      scaleY = round(rect.height) / offsetHeight || 1;
    }
  }

  return {
    width: rect.width / scaleX,
    height: rect.height / scaleY,
    top: rect.top / scaleY,
    right: rect.right / scaleX,
    bottom: rect.bottom / scaleY,
    left: rect.left / scaleX,
    x: rect.left / scaleX,
    y: rect.top / scaleY
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js




function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js









function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js



function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js




/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isTableElement.js

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js







function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
  var isIE = navigator.userAgent.indexOf('Trident') !== -1;

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/enums.js
var enums_top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [enums_top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var enums_placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/orderModifiers.js
 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/debounce.js
function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergeByName.js
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/createPopper.js














var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (false) { var _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft, flipModifier, modifiers; }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (false) {}

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (false) {}

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      if (false) {}

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper = /*#__PURE__*/(/* unused pure expression or super */ null && (popperGenerator())); // eslint-disable-next-line import/no-unused-modules


;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/eventListeners.js
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var eventListeners = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getBasePlacement.js

function getBasePlacement(placement) {
  return placement.split('-')[0];
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getVariation.js
function getVariation(placement) {
  return placement.split('-')[1];
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeOffsets.js




function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case enums_top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js


function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_popperOffsets = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/computeStyles.js







 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = enums_top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === enums_top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === enums_top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  if (false) { var transitionProperty; }

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_computeStyles = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/applyStyles.js

 // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function applyStyles_effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_applyStyles = ({
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: applyStyles_effect,
  requires: ['computeStyles']
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/offset.js

 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, enums_top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = enums_placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_offset = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
var getOppositeVariationPlacement_hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return getOppositeVariationPlacement_hash[matched];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js



function getViewportRect(element) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
  // can be obscured underneath it.
  // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
  // if it isn't open, so if this isn't available, the popper will be detected
  // to overflow the bottom of the screen too early.

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
    // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
    // errors due to floating point numbers, so we need to check precision.
    // Safari returns a number <= 0, usually < -1 when pinch-zoomed
    // Feature detection fails in mobile emulation mode in Chrome.
    // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
    // 0.001
    // Fallback here: "Not Safari" userAgent

    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = math_max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = math_max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === 'rtl') {
    x += math_max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/contains.js

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js















function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = math_max(rect.top, accRect.top);
    accRect.right = math_min(rect.right, accRect.right);
    accRect.bottom = math_min(rect.bottom, accRect.bottom);
    accRect.left = math_max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/expandToHashMap.js
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/detectOverflow.js








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [enums_top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js




function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? enums_placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;

    if (false) {}
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/flip.js






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [enums_top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : enums_top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_flip = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getAltAxis.js
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/within.js

function within(min, value, max) {
  return math_max(min, math_min(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js












function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? enums_top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? math_min(min, tetherMin) : min, offset, tether ? math_max(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? enums_top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [enums_top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_preventOverflow = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/arrow.js









 // eslint-disable-next-line import/no-unused-modules

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? enums_top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function arrow_effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (false) {}

  if (!contains(state.elements.popper, arrowElement)) {
    if (false) {}

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_arrow = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: arrow_effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/hide.js



function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [enums_top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_hide = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/popper.js










var defaultModifiers = [eventListeners, modifiers_popperOffsets, modifiers_computeStyles, modifiers_applyStyles, modifiers_offset, modifiers_flip, modifiers_preventOverflow, modifiers_arrow, modifiers_hide];
var popper_createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules


// EXTERNAL MODULE: ./node_modules/react-fast-compare/index.js
var react_fast_compare = __webpack_require__(43469);
var react_fast_compare_default = /*#__PURE__*/__webpack_require__.n(react_fast_compare);
;// CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/utils.js


/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === 'function') {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};
/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? react.useLayoutEffect : react.useEffect;
;// CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/usePopper.js





var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = react.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };

  var _React$useState = react.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      },
      arrow: {
        position: 'absolute'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var updateStateModifier = react.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        react_dom.flushSync(function () {
          setState({
            styles: fromEntries(elements.map(function (element) {
              return [element, state.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function (element) {
              return [element, state.attributes[element]];
            }))
          });
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = react.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };

    if (react_fast_compare_default()(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = react.useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }

    var createPopper = options.createPopper || popper_createPopper;
    var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

/***/ }),

/***/ 30281:
/***/ (function() {

(function () {
    'use strict';

    var UNSUPPORTED_ENVIRONMENT = typeof window === "undefined";

    /**
     * Is true if the browser natively supports the 'scroll-behavior' CSS-property.
     * @type {boolean}
     */
    var SUPPORTS_SCROLL_BEHAVIOR = UNSUPPORTED_ENVIRONMENT ? false : "scrollBehavior" in document.documentElement.style;

    

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function getScrollingElement() {
        if (document.scrollingElement != null) {
            return document.scrollingElement;
        }
        else {
            return document.documentElement;
        }
    }

    var STYLE_ATTRIBUTE_PROPERTY_NAME = "scroll-behavior";
    var STYLE_ATTRIBUTE_PROPERTY_REGEXP = new RegExp(STYLE_ATTRIBUTE_PROPERTY_NAME + ":\\s*([^;]*)");
    /**
     * Given an Element, this function appends the given ScrollBehavior CSS property value to the elements' 'style' attribute.
     * If it doesnt already have one, it will add it.
     * @param {Element} element
     * @param {ScrollBehavior} behavior
     */
    function appendScrollBehaviorToStyleAttribute(element, behavior) {
        var addition = STYLE_ATTRIBUTE_PROPERTY_NAME + ":" + behavior;
        var attributeValue = element.getAttribute("style");
        if (attributeValue == null || attributeValue === "") {
            element.setAttribute("style", addition);
            return;
        }
        // The style attribute may already include a 'scroll-behavior:<something>' in which case that should be replaced
        var existingValueForProperty = parseScrollBehaviorFromStyleAttribute(element);
        if (existingValueForProperty != null) {
            var replacementProperty = STYLE_ATTRIBUTE_PROPERTY_NAME + ":" + existingValueForProperty;
            // Replace the variant that ends with a semi-colon which it may
            attributeValue = attributeValue.replace(replacementProperty + ";", "");
            // Replace the variant that *doesn't* end with a semi-colon
            attributeValue = attributeValue.replace(replacementProperty, "");
        }
        // Now, append the behavior to the string.
        element.setAttribute("style", attributeValue.endsWith(";") ? "" + attributeValue + addition : ";" + attributeValue + addition);
    }
    /**
     * Given an Element, this function attempts to parse its 'style' attribute (if it has one)' to extract
     * a value for the 'scroll-behavior' CSS property (if it is given within that style attribute)
     * @param {Element} element
     * @returns {ScrollBehavior?}
     */
    function parseScrollBehaviorFromStyleAttribute(element) {
        var styleAttributeValue = element.getAttribute("style");
        if (styleAttributeValue != null && styleAttributeValue.includes(STYLE_ATTRIBUTE_PROPERTY_NAME)) {
            var match = styleAttributeValue.match(STYLE_ATTRIBUTE_PROPERTY_REGEXP);
            if (match != null) {
                var _a = __read(match, 2), behavior = _a[1];
                if (behavior != null && behavior !== "") {
                    return behavior;
                }
            }
        }
        return undefined;
    }

    var styleDeclarationPropertyName = "scrollBehavior";
    /**
     * Determines the scroll behavior to use, depending on the given ScrollOptions and the position of the Element
     * within the DOM
     * @param {Element|HTMLElement|Window} inputTarget
     * @param {ScrollOptions} [options]
     * @returns {ScrollBehavior}
     */
    function getScrollBehavior(inputTarget, options) {
        // If the given 'behavior' is 'smooth', apply smooth scrolling no matter what
        if (options != null && options.behavior === "smooth")
            return "smooth";
        var target = "style" in inputTarget ? inputTarget : getScrollingElement();
        var value;
        if ("style" in target) {
            // Check if scroll-behavior is set as a property on the CSSStyleDeclaration
            var scrollBehaviorPropertyValue = target.style[styleDeclarationPropertyName];
            // Return it if it is given and has a proper value
            if (scrollBehaviorPropertyValue != null && scrollBehaviorPropertyValue !== "") {
                value = scrollBehaviorPropertyValue;
            }
        }
        if (value == null) {
            var attributeValue = target.getAttribute("scroll-behavior");
            if (attributeValue != null && attributeValue !== "") {
                value = attributeValue;
            }
        }
        if (value == null) {
            // Otherwise, check if it is set as an inline style
            value = parseScrollBehaviorFromStyleAttribute(target);
        }
        if (value == null) {
            // Take the computed style for the element and see if it contains a specific 'scroll-behavior' value
            var computedStyle = getComputedStyle(target);
            var computedStyleValue = computedStyle.getPropertyValue("scrollBehavior");
            if (computedStyleValue != null && computedStyleValue !== "") {
                value = computedStyleValue;
            }
        }
        // In all other cases, use the value from the CSSOM
        return value;
    }

    

    

    var HALF = 0.5;
    /**
     * The easing function to use when applying the smooth scrolling
     * @param {number} k
     * @returns {number}
     */
    function ease(k) {
        return HALF * (1 - Math.cos(Math.PI * k));
    }

    var NOOP = {
        reset: function () { }
    };
    var map = typeof WeakMap === "undefined" ? undefined : new WeakMap();
    function disableScrollSnap(scroller) {
        // If scroll-behavior is natively supported, or if there is no native WeakMap support, there's no need for this fix
        if (SUPPORTS_SCROLL_BEHAVIOR || map == null) {
            return NOOP;
        }
        var scrollingElement = getScrollingElement();
        var cachedScrollSnapValue;
        var cachedScrollBehaviorStyleAttributeValue;
        var secondaryScroller;
        var secondaryScrollerCachedScrollSnapValue;
        var secondaryScrollerCachedScrollBehaviorStyleAttributeValue;
        var existingResult = map.get(scroller);
        if (existingResult != null) {
            cachedScrollSnapValue = existingResult.cachedScrollSnapValue;
            cachedScrollBehaviorStyleAttributeValue = existingResult.cachedScrollBehaviorStyleAttributeValue;
            secondaryScroller = existingResult.secondaryScroller;
            secondaryScrollerCachedScrollSnapValue = existingResult.secondaryScrollerCachedScrollSnapValue;
            secondaryScrollerCachedScrollBehaviorStyleAttributeValue = existingResult.secondaryScrollerCachedScrollBehaviorStyleAttributeValue;
            existingResult.release();
        }
        else {
            cachedScrollSnapValue = scroller.style.scrollSnapType === "" ? null : scroller.style.scrollSnapType;
            cachedScrollBehaviorStyleAttributeValue = parseScrollBehaviorFromStyleAttribute(scroller);
            secondaryScroller = scroller === scrollingElement && scrollingElement !== document.body ? document.body : undefined;
            secondaryScrollerCachedScrollSnapValue =
                secondaryScroller == null ? undefined : secondaryScroller.style.scrollSnapType === "" ? null : secondaryScroller.style.scrollSnapType;
            secondaryScrollerCachedScrollBehaviorStyleAttributeValue =
                secondaryScroller == null ? undefined : parseScrollBehaviorFromStyleAttribute(secondaryScroller);
            var cachedComputedScrollSnapValue = getComputedStyle(scroller).getPropertyValue("scroll-snap-type");
            var secondaryScrollerCachedComputedScrollSnapValue = secondaryScroller == null ? undefined : getComputedStyle(secondaryScroller).getPropertyValue("scroll-snap-type");
            // If it just so happens that there actually isn't any scroll snapping going on, there's no point in performing any additional work here.
            if (cachedComputedScrollSnapValue === "none" && secondaryScrollerCachedComputedScrollSnapValue === "none") {
                return NOOP;
            }
        }
        scroller.style.scrollSnapType = "none";
        if (secondaryScroller !== undefined) {
            secondaryScroller.style.scrollSnapType = "none";
        }
        if (cachedScrollBehaviorStyleAttributeValue !== undefined) {
            appendScrollBehaviorToStyleAttribute(scroller, cachedScrollBehaviorStyleAttributeValue);
        }
        if (secondaryScroller !== undefined && secondaryScrollerCachedScrollBehaviorStyleAttributeValue !== undefined) {
            appendScrollBehaviorToStyleAttribute(secondaryScroller, secondaryScrollerCachedScrollBehaviorStyleAttributeValue);
        }
        var hasReleased = false;
        var eventTarget = scroller === scrollingElement ? window : scroller;
        function release() {
            eventTarget.removeEventListener("scroll", resetHandler);
            if (map != null) {
                map["delete"](scroller);
            }
            hasReleased = true;
        }
        function resetHandler() {
            scroller.style.scrollSnapType = cachedScrollSnapValue;
            if (secondaryScroller != null && secondaryScrollerCachedScrollSnapValue !== undefined) {
                secondaryScroller.style.scrollSnapType = secondaryScrollerCachedScrollSnapValue;
            }
            if (cachedScrollBehaviorStyleAttributeValue !== undefined) {
                appendScrollBehaviorToStyleAttribute(scroller, cachedScrollBehaviorStyleAttributeValue);
            }
            if (secondaryScroller !== undefined && secondaryScrollerCachedScrollBehaviorStyleAttributeValue !== undefined) {
                appendScrollBehaviorToStyleAttribute(secondaryScroller, secondaryScrollerCachedScrollBehaviorStyleAttributeValue);
            }
            release();
        }
        function reset() {
            setTimeout(function () {
                if (hasReleased)
                    return;
                eventTarget.addEventListener("scroll", resetHandler);
            });
        }
        map.set(scroller, {
            release: release,
            cachedScrollSnapValue: cachedScrollSnapValue,
            cachedScrollBehaviorStyleAttributeValue: cachedScrollBehaviorStyleAttributeValue,
            secondaryScroller: secondaryScroller,
            secondaryScrollerCachedScrollSnapValue: secondaryScrollerCachedScrollSnapValue,
            secondaryScrollerCachedScrollBehaviorStyleAttributeValue: secondaryScrollerCachedScrollBehaviorStyleAttributeValue
        });
        return {
            reset: reset
        };
    }

    /**
     * The duration of a smooth scroll
     * @type {number}
     */
    var SCROLL_TIME = 15000;
    /**
     * Performs a smooth repositioning of the scroll
     * @param {ISmoothScrollOptions} options
     */
    function smoothScroll(options) {
        var startTime = options.startTime, startX = options.startX, startY = options.startY, endX = options.endX, endY = options.endY, method = options.method, scroller = options.scroller;
        var timeLapsed = 0;
        var distanceX = endX - startX;
        var distanceY = endY - startY;
        var speed = Math.max(Math.abs((distanceX / 1000) * SCROLL_TIME), Math.abs((distanceY / 1000) * SCROLL_TIME));
        // Temporarily disables any scroll snapping that may be active since it fights for control over the scroller with this polyfill
        var scrollSnapFix = disableScrollSnap(scroller);
        requestAnimationFrame(function animate(timestamp) {
            timeLapsed += timestamp - startTime;
            var percentage = Math.max(0, Math.min(1, speed === 0 ? 0 : timeLapsed / speed));
            var positionX = Math.floor(startX + distanceX * ease(percentage));
            var positionY = Math.floor(startY + distanceY * ease(percentage));
            method(positionX, positionY);
            if (positionX !== endX || positionY !== endY) {
                requestAnimationFrame(animate);
            }
            else {
                if (scrollSnapFix != null) {
                    scrollSnapFix.reset();
                    scrollSnapFix = undefined;
                }
            }
        });
    }

    /**
     * Returns a High Resolution timestamp if possible, otherwise fallbacks to Date.now()
     * @returns {number}
     */
    function now() {
        if ("performance" in window)
            return performance.now();
        return Date.now();
    }

    

    var ELEMENT_ORIGINAL_SCROLL = UNSUPPORTED_ENVIRONMENT ? undefined : Element.prototype.scroll;

    var WINDOW_ORIGINAL_SCROLL = UNSUPPORTED_ENVIRONMENT ? undefined : window.scroll;

    var ELEMENT_ORIGINAL_SCROLL_BY = UNSUPPORTED_ENVIRONMENT ? undefined : Element.prototype.scrollBy;

    var WINDOW_ORIGINAL_SCROLL_BY = UNSUPPORTED_ENVIRONMENT ? undefined : window.scrollBy;

    var ELEMENT_ORIGINAL_SCROLL_TO = UNSUPPORTED_ENVIRONMENT ? undefined : Element.prototype.scrollTo;

    var WINDOW_ORIGINAL_SCROLL_TO = UNSUPPORTED_ENVIRONMENT ? undefined : window.scrollTo;

    /**
     * A fallback if Element.prototype.scroll is not defined
     * @param {number} x
     * @param {number} y
     */
    function elementPrototypeScrollFallback(x, y) {
        this.__adjustingScrollPosition = true;
        this.scrollLeft = x;
        this.scrollTop = y;
        delete this.__adjustingScrollPosition;
    }
    /**
     * A fallback if Element.prototype.scrollTo is not defined
     * @param {number} x
     * @param {number} y
     */
    function elementPrototypeScrollToFallback(x, y) {
        return elementPrototypeScrollFallback.call(this, x, y);
    }
    /**
     * A fallback if Element.prototype.scrollBy is not defined
     * @param {number} x
     * @param {number} y
     */
    function elementPrototypeScrollByFallback(x, y) {
        this.__adjustingScrollPosition = true;
        this.scrollLeft += x;
        this.scrollTop += y;
        delete this.__adjustingScrollPosition;
    }
    /**
     * Gets the original non-patched prototype method for the given kind
     * @param {ScrollMethodName} kind
     * @param {Element|Window} element
     * @return {Function}
     */
    function getOriginalScrollMethodForKind(kind, element) {
        switch (kind) {
            case "scroll":
                if (element instanceof Element) {
                    if (ELEMENT_ORIGINAL_SCROLL != null) {
                        return ELEMENT_ORIGINAL_SCROLL;
                    }
                    else {
                        return elementPrototypeScrollFallback;
                    }
                }
                else {
                    return WINDOW_ORIGINAL_SCROLL;
                }
            case "scrollBy":
                if (element instanceof Element) {
                    if (ELEMENT_ORIGINAL_SCROLL_BY != null) {
                        return ELEMENT_ORIGINAL_SCROLL_BY;
                    }
                    else {
                        return elementPrototypeScrollByFallback;
                    }
                }
                else {
                    return WINDOW_ORIGINAL_SCROLL_BY;
                }
            case "scrollTo":
                if (element instanceof Element) {
                    if (ELEMENT_ORIGINAL_SCROLL_TO != null) {
                        return ELEMENT_ORIGINAL_SCROLL_TO;
                    }
                    else {
                        return elementPrototypeScrollToFallback;
                    }
                }
                else {
                    return WINDOW_ORIGINAL_SCROLL_TO;
                }
        }
    }

    /**
     * Gets the Smooth Scroll Options to use for the step function
     * @param {Element|Window} element
     * @param {number} x
     * @param {number} y
     * @param {ScrollMethodName} kind
     * @returns {ISmoothScrollOptions}
     */
    function getSmoothScrollOptions(element, x, y, kind) {
        var startTime = now();
        if (!(element instanceof Element)) {
            // Use window as the scroll container
            var scrollX_1 = window.scrollX, pageXOffset_1 = window.pageXOffset, scrollY_1 = window.scrollY, pageYOffset_1 = window.pageYOffset;
            var startX = scrollX_1 == null || scrollX_1 === 0 ? pageXOffset_1 : scrollX_1;
            var startY = scrollY_1 == null || scrollY_1 === 0 ? pageYOffset_1 : scrollY_1;
            return {
                startTime: startTime,
                startX: startX,
                startY: startY,
                endX: Math.floor(kind === "scrollBy" ? startX + x : x),
                endY: Math.floor(kind === "scrollBy" ? startY + y : y),
                method: getOriginalScrollMethodForKind("scrollTo", window).bind(window),
                scroller: getScrollingElement()
            };
        }
        else {
            var scrollLeft = element.scrollLeft, scrollTop = element.scrollTop;
            var startX = scrollLeft;
            var startY = scrollTop;
            return {
                startTime: startTime,
                startX: startX,
                startY: startY,
                endX: Math.floor(kind === "scrollBy" ? startX + x : x),
                endY: Math.floor(kind === "scrollBy" ? startY + y : y),
                method: getOriginalScrollMethodForKind("scrollTo", element).bind(element),
                scroller: element
            };
        }
    }

    /**
     * Ensures that the given value is numeric
     * @param {number} value
     * @return {number}
     */
    function ensureNumeric(value) {
        if (value == null)
            return 0;
        else if (typeof value === "number") {
            return value;
        }
        else if (typeof value === "string") {
            return parseFloat(value);
        }
        else {
            return 0;
        }
    }

    /**
     * Returns true if the given value is some ScrollToOptions
     * @param {number | ScrollToOptions} value
     * @return {value is ScrollToOptions}
     */
    function isScrollToOptions(value) {
        return value != null && typeof value === "object";
    }

    /**
     * Handles a scroll method
     * @param {Element|Window} element
     * @param {ScrollMethodName} kind
     * @param {number | ScrollToOptions} optionsOrX
     * @param {number} y
     */
    function handleScrollMethod(element, kind, optionsOrX, y) {
        onScrollWithOptions(getScrollToOptionsWithValidation(optionsOrX, y), element, kind);
    }
    /**
     * Invoked when a 'ScrollToOptions' dict is provided to 'scroll()' as the first argument
     * @param {ScrollToOptions} options
     * @param {Element|Window} element
     * @param {ScrollMethodName} kind
     */
    function onScrollWithOptions(options, element, kind) {
        var behavior = getScrollBehavior(element, options);
        // If the behavior is 'auto' apply instantaneous scrolling
        if (behavior == null || behavior === "auto") {
            getOriginalScrollMethodForKind(kind, element).call(element, options.left, options.top);
        }
        else {
            smoothScroll(getSmoothScrollOptions(element, options.left, options.top, kind));
        }
    }
    /**
     * Normalizes the given scroll coordinates
     * @param {number?} x
     * @param {number?} y
     * @return {Required<Pick<ScrollToOptions, "top" | "left">>}
     */
    function normalizeScrollCoordinates(x, y) {
        return {
            left: ensureNumeric(x),
            top: ensureNumeric(y)
        };
    }
    /**
     * Gets ScrollToOptions based on the given arguments. Will throw if validation fails
     * @param {number | ScrollToOptions} optionsOrX
     * @param {number} y
     * @return {Required<ScrollToOptions>}
     */
    function getScrollToOptionsWithValidation(optionsOrX, y) {
        // If only one argument is given, and it isn't an options object, throw a TypeError
        if (y === undefined && !isScrollToOptions(optionsOrX)) {
            throw new TypeError("Failed to execute 'scroll' on 'Element': parameter 1 ('options') is not an object.");
        }
        // Scroll based on the primitive values given as arguments
        if (!isScrollToOptions(optionsOrX)) {
            return __assign(__assign({}, normalizeScrollCoordinates(optionsOrX, y)), { behavior: "auto" });
        }
        // Scroll based on the received options object
        else {
            return __assign(__assign({}, normalizeScrollCoordinates(optionsOrX.left, optionsOrX.top)), { behavior: optionsOrX.behavior == null ? "auto" : optionsOrX.behavior });
        }
    }

    /**
     * Patches the 'scroll' method on the Element prototype
     */
    function patchElementScroll() {
        Element.prototype.scroll = function (optionsOrX, y) {
            handleScrollMethod(this, "scroll", optionsOrX, y);
        };
    }

    /**
     * Patches the 'scrollBy' method on the Element prototype
     */
    function patchElementScrollBy() {
        Element.prototype.scrollBy = function (optionsOrX, y) {
            handleScrollMethod(this, "scrollBy", optionsOrX, y);
        };
    }

    /**
     * Patches the 'scrollTo' method on the Element prototype
     */
    function patchElementScrollTo() {
        Element.prototype.scrollTo = function (optionsOrX, y) {
            handleScrollMethod(this, "scrollTo", optionsOrX, y);
        };
    }

    /**
     * Patches the 'scroll' method on the Window prototype
     */
    function patchWindowScroll() {
        window.scroll = function (optionsOrX, y) {
            handleScrollMethod(this, "scroll", optionsOrX, y);
        };
    }

    /**
     * Patches the 'scrollBy' method on the Window prototype
     */
    function patchWindowScrollBy() {
        window.scrollBy = function (optionsOrX, y) {
            handleScrollMethod(this, "scrollBy", optionsOrX, y);
        };
    }

    /**
     * Patches the 'scrollTo' method on the Window prototype
     */
    function patchWindowScrollTo() {
        window.scrollTo = function (optionsOrX, y) {
            handleScrollMethod(this, "scrollTo", optionsOrX, y);
        };
    }

    // tslint:disable:no-any
    /**
     * Gets the parent of an element, taking into account DocumentFragments, ShadowRoots, as well as the root context (window)
     * @param {EventTarget} currentElement
     * @returns {EventTarget | null}
     */
    function getParent(currentElement) {
        if ("nodeType" in currentElement && currentElement.nodeType === 1) {
            return currentElement.parentNode;
        }
        if ("ShadowRoot" in window && currentElement instanceof window.ShadowRoot) {
            return currentElement.host;
        }
        else if (currentElement === document) {
            return window;
        }
        else if (currentElement instanceof Node)
            return currentElement.parentNode;
        return null;
    }

    /**
     * Returns true if the given overflow property represents a scrollable overflow value
     * @param {string | null} overflow
     * @return {boolean}
     */
    function canOverflow(overflow) {
        return overflow !== "visible" && overflow !== "clip";
    }
    /**
     * Returns true if the given element is scrollable
     * @param {Element} element
     * @return {boolean}
     */
    function isScrollable(element) {
        if (element.clientHeight < element.scrollHeight || element.clientWidth < element.scrollWidth) {
            var style = getComputedStyle(element, null);
            return canOverflow(style.overflowY) || canOverflow(style.overflowX);
        }
        return false;
    }
    /**
     * Finds the nearest ancestor of an element that can scroll
     * @param {Element} target
     * @returns {Element|Window?}
     */
    function findNearestAncestorsWithScrollBehavior(target) {
        var currentElement = target;
        var scrollingElement = getScrollingElement();
        while (currentElement != null) {
            var behavior = getScrollBehavior(currentElement);
            if (behavior != null && (currentElement === scrollingElement || isScrollable(currentElement))) {
                return [currentElement, behavior];
            }
            var parent_1 = getParent(currentElement);
            currentElement = parent_1;
        }
        // No such element could be found. Start over, but this time find the nearest ancestor that can simply scroll
        currentElement = target;
        while (currentElement != null) {
            if (currentElement === scrollingElement || isScrollable(currentElement)) {
                return [currentElement, "auto"];
            }
            var parent_2 = getParent(currentElement);
            currentElement = parent_2;
        }
        // Default to the scrolling element
        return [scrollingElement, "auto"];
    }

    // tslint:disable:no-any
    /**
     * Finds the nearest root from an element
     * @param {Element} target
     * @returns {Document|ShadowRoot}
     */
    function findNearestRoot(target) {
        var currentElement = target;
        while (currentElement != null) {
            if ("ShadowRoot" in window && currentElement instanceof window.ShadowRoot) {
                // Assume this is a ShadowRoot
                return currentElement;
            }
            var parent_1 = getParent(currentElement);
            if (parent_1 === currentElement) {
                return document;
            }
            currentElement = parent_1;
        }
        return document;
    }

    /**
     * Gets the origin of the given Location or HTMLAnchorElement if available in the runtime, and otherwise shims it. (it's a one-liner)
     * @returns {string}
     */
    function getLocationOrigin(locationLike) {
        if (locationLike === void 0) { locationLike = location; }
        if ("origin" in locationLike && locationLike.origin != null) {
            return locationLike.origin;
        }
        var port = locationLike.port != null && locationLike.port.length > 0 ? ":" + locationLike.port : "";
        if (locationLike.protocol === "http:" && port === ":80") {
            port = "";
        }
        else if (locationLike.protocol === "https:" && port === ":443") {
            port = "";
        }
        return locationLike.protocol + "//" + locationLike.hostname + port;
    }

    /**
     * A Regular expression that matches id's of the form "#[digit]"
     * @type {RegExp}
     */
    var ID_WITH_LEADING_DIGIT_REGEXP = /^#\d/;
    /**
     * Catches anchor navigation to IDs within the same root and ensures that they can be smooth-scrolled
     * if the scroll behavior is smooth in the first rooter within that context
     */
    function catchNavigation() {
        // Listen for 'click' events globally
        window.addEventListener("click", function (e) {
            // Only work with trusted events on HTMLAnchorElements
            if (!e.isTrusted || !(e.target instanceof HTMLAnchorElement))
                return;
            var _a = e.target, pathname = _a.pathname, search = _a.search, hash = _a.hash;
            var pointsToCurrentPage = getLocationOrigin(e.target) === getLocationOrigin(location) && pathname === location.pathname && search === location.search;
            // Only work with HTMLAnchorElements that navigates to a specific ID on the current page
            if (!pointsToCurrentPage || hash == null || hash.length < 1) {
                return;
            }
            // Find the nearest root, whether it be a ShadowRoot or the document itself
            var root = findNearestRoot(e.target);
            // Attempt to match the selector from that root. querySelector' doesn't support IDs that start with a digit, so work around that limitation
            var elementMatch = hash.match(ID_WITH_LEADING_DIGIT_REGEXP) != null ? root.getElementById(hash.slice(1)) : root.querySelector(hash);
            // If no selector could be found, don't proceed
            if (elementMatch == null)
                return;
            // Find the nearest ancestor that can be scrolled
            var _b = __read(findNearestAncestorsWithScrollBehavior(elementMatch), 2), behavior = _b[1];
            // If the behavior isn't smooth, don't proceed
            if (behavior !== "smooth")
                return;
            // Otherwise, first prevent the default action.
            e.preventDefault();
            // Now, scroll to the element with that ID
            elementMatch.scrollIntoView({
                behavior: behavior
            });
        });
    }

    var ELEMENT_ORIGINAL_SCROLL_INTO_VIEW = UNSUPPORTED_ENVIRONMENT ? undefined : Element.prototype.scrollIntoView;

    /**
     * The majority of this file is based on https://github.com/stipsan/compute-scroll-into-view (MIT license),
     * but has been rewritten to accept a scroller as an argument.
     */
    /**
     * Find out which edge to align against when logical scroll position is "nearest"
     * Interesting fact: "nearest" works similarly to "if-needed", if the element is fully visible it will not scroll it
     *
     * Legends:
     * ┌────────┐ ┏ ━ ━ ━ ┓
     * │ target │   frame
     * └────────┘ ┗ ━ ━ ━ ┛
     */
    function alignNearest(scrollingEdgeStart, scrollingEdgeEnd, scrollingSize, scrollingBorderStart, scrollingBorderEnd, elementEdgeStart, elementEdgeEnd, elementSize) {
        /**
         * If element edge A and element edge B are both outside scrolling box edge A and scrolling box edge B
         *
         *          ┌──┐
         *        ┏━│━━│━┓
         *          │  │
         *        ┃ │  │ ┃        do nothing
         *          │  │
         *        ┗━│━━│━┛
         *          └──┘
         *
         *  If element edge C and element edge D are both outside scrolling box edge C and scrolling box edge D
         *
         *    ┏ ━ ━ ━ ━ ┓
         *   ┌───────────┐
         *   │┃         ┃│        do nothing
         *   └───────────┘
         *    ┗ ━ ━ ━ ━ ┛
         */
        if ((elementEdgeStart < scrollingEdgeStart && elementEdgeEnd > scrollingEdgeEnd) ||
            (elementEdgeStart > scrollingEdgeStart && elementEdgeEnd < scrollingEdgeEnd)) {
            return 0;
        }
        /**
         * If element edge A is outside scrolling box edge A and element height is less than scrolling box height
         *
         *          ┌──┐
         *        ┏━│━━│━┓         ┏━┌━━┐━┓
         *          └──┘             │  │
         *  from  ┃      ┃     to  ┃ └──┘ ┃
         *
         *        ┗━ ━━ ━┛         ┗━ ━━ ━┛
         *
         * If element edge B is outside scrolling box edge B and element height is greater than scrolling box height
         *
         *        ┏━ ━━ ━┓         ┏━┌━━┐━┓
         *                           │  │
         *  from  ┃ ┌──┐ ┃     to  ┃ │  │ ┃
         *          │  │             │  │
         *        ┗━│━━│━┛         ┗━│━━│━┛
         *          │  │             └──┘
         *          │  │
         *          └──┘
         *
         * If element edge C is outside scrolling box edge C and element width is less than scrolling box width
         *
         *       from                 to
         *    ┏ ━ ━ ━ ━ ┓         ┏ ━ ━ ━ ━ ┓
         *  ┌───┐                 ┌───┐
         *  │ ┃ │       ┃         ┃   │     ┃
         *  └───┘                 └───┘
         *    ┗ ━ ━ ━ ━ ┛         ┗ ━ ━ ━ ━ ┛
         *
         * If element edge D is outside scrolling box edge D and element width is greater than scrolling box width
         *
         *       from                 to
         *    ┏ ━ ━ ━ ━ ┓         ┏ ━ ━ ━ ━ ┓
         *        ┌───────────┐   ┌───────────┐
         *    ┃   │     ┃     │   ┃         ┃ │
         *        └───────────┘   └───────────┘
         *    ┗ ━ ━ ━ ━ ┛         ┗ ━ ━ ━ ━ ┛
         */
        if ((elementEdgeStart <= scrollingEdgeStart && elementSize <= scrollingSize) ||
            (elementEdgeEnd >= scrollingEdgeEnd && elementSize >= scrollingSize)) {
            return elementEdgeStart - scrollingEdgeStart - scrollingBorderStart;
        }
        /**
         * If element edge B is outside scrolling box edge B and element height is less than scrolling box height
         *
         *        ┏━ ━━ ━┓         ┏━ ━━ ━┓
         *
         *  from  ┃      ┃     to  ┃ ┌──┐ ┃
         *          ┌──┐             │  │
         *        ┗━│━━│━┛         ┗━└━━┘━┛
         *          └──┘
         *
         * If element edge A is outside scrolling box edge A and element height is greater than scrolling box height
         *
         *          ┌──┐
         *          │  │
         *          │  │             ┌──┐
         *        ┏━│━━│━┓         ┏━│━━│━┓
         *          │  │             │  │
         *  from  ┃ └──┘ ┃     to  ┃ │  │ ┃
         *                           │  │
         *        ┗━ ━━ ━┛         ┗━└━━┘━┛
         *
         * If element edge C is outside scrolling box edge C and element width is greater than scrolling box width
         *
         *           from                 to
         *        ┏ ━ ━ ━ ━ ┓         ┏ ━ ━ ━ ━ ┓
         *  ┌───────────┐           ┌───────────┐
         *  │     ┃     │   ┃       │ ┃         ┃
         *  └───────────┘           └───────────┘
         *        ┗ ━ ━ ━ ━ ┛         ┗ ━ ━ ━ ━ ┛
         *
         * If element edge D is outside scrolling box edge D and element width is less than scrolling box width
         *
         *           from                 to
         *        ┏ ━ ━ ━ ━ ┓         ┏ ━ ━ ━ ━ ┓
         *                ┌───┐             ┌───┐
         *        ┃       │ ┃ │       ┃     │   ┃
         *                └───┘             └───┘
         *        ┗ ━ ━ ━ ━ ┛         ┗ ━ ━ ━ ━ ┛
         *
         */
        if ((elementEdgeEnd > scrollingEdgeEnd && elementSize < scrollingSize) || (elementEdgeStart < scrollingEdgeStart && elementSize > scrollingSize)) {
            return elementEdgeEnd - scrollingEdgeEnd + scrollingBorderEnd;
        }
        return 0;
    }
    function computeScrollIntoView(target, scroller, options) {
        var block = options.block, inline = options.inline;
        // Used to handle the top most element that can be scrolled
        var scrollingElement = getScrollingElement();
        // Support pinch-zooming properly, making sure elements scroll into the visual viewport
        // Browsers that don't support visualViewport will report the layout viewport dimensions on document.documentElement.clientWidth/Height
        // and viewport dimensions on window.innerWidth/Height
        // https://www.quirksmode.org/mobile/viewports2.html
        // https://bokand.github.io/viewport/index.html
        var viewportWidth = window.visualViewport != null ? visualViewport.width : innerWidth;
        var viewportHeight = window.visualViewport != null ? visualViewport.height : innerHeight;
        var viewportX = window.scrollX != null ? window.scrollX : window.pageXOffset;
        var viewportY = window.scrollY != null ? window.scrollY : window.pageYOffset;
        var _a = target.getBoundingClientRect(), targetHeight = _a.height, targetWidth = _a.width, targetTop = _a.top, targetRight = _a.right, targetBottom = _a.bottom, targetLeft = _a.left;
        // These values mutate as we loop through and generate scroll coordinates
        var targetBlock = block === "start" || block === "nearest" ? targetTop : block === "end" ? targetBottom : targetTop + targetHeight / 2; // block === 'center
        var targetInline = inline === "center" ? targetLeft + targetWidth / 2 : inline === "end" ? targetRight : targetLeft; // inline === 'start || inline === 'nearest
        var _b = scroller.getBoundingClientRect(), height = _b.height, width = _b.width, top = _b.top, right = _b.right, bottom = _b.bottom, left = _b.left;
        var frameStyle = getComputedStyle(scroller);
        var borderLeft = parseInt(frameStyle.borderLeftWidth, 10);
        var borderTop = parseInt(frameStyle.borderTopWidth, 10);
        var borderRight = parseInt(frameStyle.borderRightWidth, 10);
        var borderBottom = parseInt(frameStyle.borderBottomWidth, 10);
        var blockScroll = 0;
        var inlineScroll = 0;
        // The property existance checks for offset[Width|Height] is because only HTMLElement objects have them, but any Element might pass by here
        // @TODO find out if the "as HTMLElement" overrides can be dropped
        var scrollbarWidth = "offsetWidth" in scroller ? scroller.offsetWidth - scroller.clientWidth - borderLeft - borderRight : 0;
        var scrollbarHeight = "offsetHeight" in scroller ? scroller.offsetHeight - scroller.clientHeight - borderTop - borderBottom : 0;
        if (scrollingElement === scroller) {
            // Handle viewport logic (document.documentElement or document.body)
            if (block === "start") {
                blockScroll = targetBlock;
            }
            else if (block === "end") {
                blockScroll = targetBlock - viewportHeight;
            }
            else if (block === "nearest") {
                blockScroll = alignNearest(viewportY, viewportY + viewportHeight, viewportHeight, borderTop, borderBottom, viewportY + targetBlock, viewportY + targetBlock + targetHeight, targetHeight);
            }
            else {
                // block === 'center' is the default
                blockScroll = targetBlock - viewportHeight / 2;
            }
            if (inline === "start") {
                inlineScroll = targetInline;
            }
            else if (inline === "center") {
                inlineScroll = targetInline - viewportWidth / 2;
            }
            else if (inline === "end") {
                inlineScroll = targetInline - viewportWidth;
            }
            else {
                // inline === 'nearest' is the default
                inlineScroll = alignNearest(viewportX, viewportX + viewportWidth, viewportWidth, borderLeft, borderRight, viewportX + targetInline, viewportX + targetInline + targetWidth, targetWidth);
            }
            // Apply scroll position offsets and ensure they are within bounds
            // @TODO add more test cases to cover this 100%
            blockScroll = Math.max(0, blockScroll + viewportY);
            inlineScroll = Math.max(0, inlineScroll + viewportX);
        }
        else {
            // Handle each scrolling frame that might exist between the target and the viewport
            if (block === "start") {
                blockScroll = targetBlock - top - borderTop;
            }
            else if (block === "end") {
                blockScroll = targetBlock - bottom + borderBottom + scrollbarHeight;
            }
            else if (block === "nearest") {
                blockScroll = alignNearest(top, bottom, height, borderTop, borderBottom + scrollbarHeight, targetBlock, targetBlock + targetHeight, targetHeight);
            }
            else {
                // block === 'center' is the default
                blockScroll = targetBlock - (top + height / 2) + scrollbarHeight / 2;
            }
            if (inline === "start") {
                inlineScroll = targetInline - left - borderLeft;
            }
            else if (inline === "center") {
                inlineScroll = targetInline - (left + width / 2) + scrollbarWidth / 2;
            }
            else if (inline === "end") {
                inlineScroll = targetInline - right + borderRight + scrollbarWidth;
            }
            else {
                // inline === 'nearest' is the default
                inlineScroll = alignNearest(left, right, width, borderLeft, borderRight + scrollbarWidth, targetInline, targetInline + targetWidth, targetWidth);
            }
            var scrollLeft = scroller.scrollLeft, scrollTop = scroller.scrollTop;
            // Ensure scroll coordinates are not out of bounds while applying scroll offsets
            blockScroll = Math.max(0, Math.min(scrollTop + blockScroll, scroller.scrollHeight - height + scrollbarHeight));
            inlineScroll = Math.max(0, Math.min(scrollLeft + inlineScroll, scroller.scrollWidth - width + scrollbarWidth));
        }
        return {
            top: blockScroll,
            left: inlineScroll
        };
    }

    /**
     * Patches the 'scrollIntoView' method on the Element prototype
     */
    function patchElementScrollIntoView() {
        Element.prototype.scrollIntoView = function (arg) {
            var normalizedOptions = arg == null || arg === true
                ? {
                    block: "start",
                    inline: "nearest"
                }
                : arg === false
                    ? {
                        block: "end",
                        inline: "nearest"
                    }
                    : arg;
            // Find the nearest ancestor that can be scrolled
            var _a = __read(findNearestAncestorsWithScrollBehavior(this), 2), ancestorWithScroll = _a[0], ancestorWithScrollBehavior = _a[1];
            var behavior = normalizedOptions.behavior != null ? normalizedOptions.behavior : ancestorWithScrollBehavior;
            // If the behavior isn't smooth, simply invoke the original implementation and do no more
            if (behavior !== "smooth") {
                // Assert that 'scrollIntoView' is actually defined
                if (ELEMENT_ORIGINAL_SCROLL_INTO_VIEW != null) {
                    ELEMENT_ORIGINAL_SCROLL_INTO_VIEW.call(this, normalizedOptions);
                }
                // Otherwise, invoke 'scrollTo' instead and provide the scroll coordinates
                else {
                    var _b = computeScrollIntoView(this, ancestorWithScroll, normalizedOptions), top_1 = _b.top, left = _b.left;
                    getOriginalScrollMethodForKind("scrollTo", this).call(this, left, top_1);
                }
                return;
            }
            ancestorWithScroll.scrollTo(__assign({ behavior: behavior }, computeScrollIntoView(this, ancestorWithScroll, normalizedOptions)));
        };
        // On IE11, HTMLElement has its own declaration of scrollIntoView and does not inherit this from the prototype chain, so we'll need to patch that one too.
        if (HTMLElement.prototype.scrollIntoView != null && HTMLElement.prototype.scrollIntoView !== Element.prototype.scrollIntoView) {
            HTMLElement.prototype.scrollIntoView = Element.prototype.scrollIntoView;
        }
    }

    var ELEMENT_ORIGINAL_SCROLL_TOP_SET_DESCRIPTOR = UNSUPPORTED_ENVIRONMENT
        ? undefined
        : Object.getOwnPropertyDescriptor(Element.prototype, "scrollTop").set;

    /**
     * Patches the 'scrollTop' property descriptor on the Element prototype
     */
    function patchElementScrollTop() {
        Object.defineProperty(Element.prototype, "scrollTop", {
            set: function (scrollTop) {
                if (this.__adjustingScrollPosition) {
                    return ELEMENT_ORIGINAL_SCROLL_TOP_SET_DESCRIPTOR.call(this, scrollTop);
                }
                handleScrollMethod(this, "scrollTo", this.scrollLeft, scrollTop);
                return scrollTop;
            }
        });
    }

    var ELEMENT_ORIGINAL_SCROLL_LEFT_SET_DESCRIPTOR = UNSUPPORTED_ENVIRONMENT
        ? undefined
        : Object.getOwnPropertyDescriptor(Element.prototype, "scrollLeft").set;

    /**
     * Patches the 'scrollLeft' property descriptor on the Element prototype
     */
    function patchElementScrollLeft() {
        Object.defineProperty(Element.prototype, "scrollLeft", {
            set: function (scrollLeft) {
                if (this.__adjustingScrollPosition) {
                    return ELEMENT_ORIGINAL_SCROLL_LEFT_SET_DESCRIPTOR.call(this, scrollLeft);
                }
                handleScrollMethod(this, "scrollTo", scrollLeft, this.scrollTop);
                return scrollLeft;
            }
        });
    }

    /**
     * Applies the polyfill
     */
    function patch() {
        // Element.prototype methods
        patchElementScroll();
        patchElementScrollBy();
        patchElementScrollTo();
        patchElementScrollIntoView();
        // Element.prototype descriptors
        patchElementScrollLeft();
        patchElementScrollTop();
        // window methods
        patchWindowScroll();
        patchWindowScrollBy();
        patchWindowScrollTo();
        // Navigation
        catchNavigation();
    }

    /**
     * Is true if the browser natively supports the Element.prototype.[scroll|scrollTo|scrollBy|scrollIntoView] methods
     * @type {boolean}
     */
    var SUPPORTS_ELEMENT_PROTOTYPE_SCROLL_METHODS = UNSUPPORTED_ENVIRONMENT
        ? false
        : "scroll" in Element.prototype && "scrollTo" in Element.prototype && "scrollBy" in Element.prototype && "scrollIntoView" in Element.prototype;

    if (!UNSUPPORTED_ENVIRONMENT && (!SUPPORTS_SCROLL_BEHAVIOR || !SUPPORTS_ELEMENT_PROTOTYPE_SCROLL_METHODS)) {
        patch();
    }

}());
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 94843:
/***/ (function(module) {


module.exports = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};


/***/ }),

/***/ 7917:
/***/ (function(module) {

"use strict";


// TODO: use call-bind, is-date, is-regex, is-string, is-boolean-object, is-number-object
function toS(obj) { return Object.prototype.toString.call(obj); }
function isDate(obj) { return toS(obj) === '[object Date]'; }
function isRegExp(obj) { return toS(obj) === '[object RegExp]'; }
function isError(obj) { return toS(obj) === '[object Error]'; }
function isBoolean(obj) { return toS(obj) === '[object Boolean]'; }
function isNumber(obj) { return toS(obj) === '[object Number]'; }
function isString(obj) { return toS(obj) === '[object String]'; }

// TODO: use isarray
var isArray = Array.isArray || function isArray(xs) {
	return Object.prototype.toString.call(xs) === '[object Array]';
};

// TODO: use for-each?
function forEach(xs, fn) {
	if (xs.forEach) { return xs.forEach(fn); }
	for (var i = 0; i < xs.length; i++) {
		fn(xs[i], i, xs);
	}
	return void undefined;
}

// TODO: use object-keys
var objectKeys = Object.keys || function keys(obj) {
	var res = [];
	for (var key in obj) { res.push(key); } // eslint-disable-line no-restricted-syntax
	return res;
};

// TODO: use object.hasown
var hasOwnProperty = Object.prototype.hasOwnProperty || function (obj, key) {
	return key in obj;
};

function copy(src) {
	if (typeof src === 'object' && src !== null) {
		var dst;

		if (isArray(src)) {
			dst = [];
		} else if (isDate(src)) {
			dst = new Date(src.getTime ? src.getTime() : src);
		} else if (isRegExp(src)) {
			dst = new RegExp(src);
		} else if (isError(src)) {
			dst = { message: src.message };
		} else if (isBoolean(src) || isNumber(src) || isString(src)) {
			dst = Object(src);
		} else if (Object.create && Object.getPrototypeOf) {
			dst = Object.create(Object.getPrototypeOf(src));
		} else if (src.constructor === Object) {
			dst = {};
		} else {
			var proto = (src.constructor && src.constructor.prototype)
                || src.__proto__
                || {};
			var T = function T() {}; // eslint-disable-line func-style, func-name-matching
			T.prototype = proto;
			dst = new T();
		}

		forEach(objectKeys(src), function (key) {
			dst[key] = src[key];
		});
		return dst;
	}
	return src;
}

function walk(root, cb, immutable) {
	var path = [];
	var parents = [];
	var alive = true;

	return (function walker(node_) {
		var node = immutable ? copy(node_) : node_;
		var modifiers = {};

		var keepGoing = true;

		var state = {
			node: node,
			node_: node_,
			path: [].concat(path),
			parent: parents[parents.length - 1],
			parents: parents,
			key: path[path.length - 1],
			isRoot: path.length === 0,
			level: path.length,
			circular: null,
			update: function (x, stopHere) {
				if (!state.isRoot) {
					state.parent.node[state.key] = x;
				}
				state.node = x;
				if (stopHere) { keepGoing = false; }
			},
			delete: function (stopHere) {
				delete state.parent.node[state.key];
				if (stopHere) { keepGoing = false; }
			},
			remove: function (stopHere) {
				if (isArray(state.parent.node)) {
					state.parent.node.splice(state.key, 1);
				} else {
					delete state.parent.node[state.key];
				}
				if (stopHere) { keepGoing = false; }
			},
			keys: null,
			before: function (f) { modifiers.before = f; },
			after: function (f) { modifiers.after = f; },
			pre: function (f) { modifiers.pre = f; },
			post: function (f) { modifiers.post = f; },
			stop: function () { alive = false; },
			block: function () { keepGoing = false; },
		};

		if (!alive) { return state; }

		function updateState() {
			if (typeof state.node === 'object' && state.node !== null) {
				if (!state.keys || state.node_ !== state.node) {
					state.keys = objectKeys(state.node);
				}

				state.isLeaf = state.keys.length === 0;

				for (var i = 0; i < parents.length; i++) {
					if (parents[i].node_ === node_) {
						state.circular = parents[i];
						break; // eslint-disable-line no-restricted-syntax
					}
				}
			} else {
				state.isLeaf = true;
				state.keys = null;
			}

			state.notLeaf = !state.isLeaf;
			state.notRoot = !state.isRoot;
		}

		updateState();

		// use return values to update if defined
		var ret = cb.call(state, state.node);
		if (ret !== undefined && state.update) { state.update(ret); }

		if (modifiers.before) { modifiers.before.call(state, state.node); }

		if (!keepGoing) { return state; }

		if (
			typeof state.node === 'object'
			&& state.node !== null
			&& !state.circular
		) {
			parents.push(state);

			updateState();

			forEach(state.keys, function (key, i) {
				path.push(key);

				if (modifiers.pre) { modifiers.pre.call(state, state.node[key], key); }

				var child = walker(state.node[key]);
				if (immutable && hasOwnProperty.call(state.node, key)) {
					state.node[key] = child.node;
				}

				child.isLast = i === state.keys.length - 1;
				child.isFirst = i === 0;

				if (modifiers.post) { modifiers.post.call(state, child); }

				path.pop();
			});
			parents.pop();
		}

		if (modifiers.after) { modifiers.after.call(state, state.node); }

		return state;
	}(root)).node;
}

function Traverse(obj) {
	this.value = obj;
}

Traverse.prototype.get = function (ps) {
	var node = this.value;
	for (var i = 0; i < ps.length; i++) {
		var key = ps[i];
		if (!node || !hasOwnProperty.call(node, key)) {
			return void undefined;
		}
		node = node[key];
	}
	return node;
};

Traverse.prototype.has = function (ps) {
	var node = this.value;
	for (var i = 0; i < ps.length; i++) {
		var key = ps[i];
		if (!node || !hasOwnProperty.call(node, key)) {
			return false;
		}
		node = node[key];
	}
	return true;
};

Traverse.prototype.set = function (ps, value) {
	var node = this.value;
	for (var i = 0; i < ps.length - 1; i++) {
		var key = ps[i];
		if (!hasOwnProperty.call(node, key)) { node[key] = {}; }
		node = node[key];
	}
	node[ps[i]] = value;
	return value;
};

Traverse.prototype.map = function (cb) {
	return walk(this.value, cb, true);
};

Traverse.prototype.forEach = function (cb) {
	this.value = walk(this.value, cb, false);
	return this.value;
};

Traverse.prototype.reduce = function (cb, init) {
	var skip = arguments.length === 1;
	var acc = skip ? this.value : init;
	this.forEach(function (x) {
		if (!this.isRoot || !skip) {
			acc = cb.call(this, acc, x);
		}
	});
	return acc;
};

Traverse.prototype.paths = function () {
	var acc = [];
	this.forEach(function () {
		acc.push(this.path);
	});
	return acc;
};

Traverse.prototype.nodes = function () {
	var acc = [];
	this.forEach(function () {
		acc.push(this.node);
	});
	return acc;
};

Traverse.prototype.clone = function () {
	var parents = [];
	var nodes = [];

	return (function clone(src) {
		for (var i = 0; i < parents.length; i++) {
			if (parents[i] === src) {
				return nodes[i];
			}
		}

		if (typeof src === 'object' && src !== null) {
			var dst = copy(src);

			parents.push(src);
			nodes.push(dst);

			forEach(objectKeys(src), function (key) {
				dst[key] = clone(src[key]);
			});

			parents.pop();
			nodes.pop();
			return dst;
		}

		return src;

	}(this.value));
};

function traverse(obj) {
	return new Traverse(obj);
}

// TODO: replace with object.assign?
forEach(objectKeys(Traverse.prototype), function (key) {
	traverse[key] = function (obj) {
		var args = [].slice.call(arguments, 1);
		var t = new Traverse(obj);
		return t[key].apply(t, args);
	};
});

module.exports = traverse;


/***/ }),

/***/ 56385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "pi": function() { return /* binding */ __assign; }
/* harmony export */ });
/* unused harmony exports __extends, __rest, __decorate, __param, __metadata, __awaiter, __generator, __createBinding, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(13801);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z$": function() { return /* binding */ awaitBuilderData; },
  "LV": function() { return /* binding */ getBlockDataMap; },
  "QR": function() { return /* binding */ registerComponents; }
});

// NAMESPACE OBJECT: ./components/afterpay-goes-green/b2b-access-hero/b2b-access-hero.builder-component.ts
var b2b_access_hero_builder_component_namespaceObject = {};
__webpack_require__.r(b2b_access_hero_builder_component_namespaceObject);
__webpack_require__.d(b2b_access_hero_builder_component_namespaceObject, {
  "B2BAccessHeroBuilderConfig": function() { return B2BAccessHeroBuilderConfig; },
  "default": function() { return b2b_access_hero_builder_component; }
});

// NAMESPACE OBJECT: ./components/afterpay-goes-green/b2b-business-article-grid/b2b-article-grid.builder-component.ts
var b2b_article_grid_builder_component_namespaceObject = {};
__webpack_require__.r(b2b_article_grid_builder_component_namespaceObject);
__webpack_require__.d(b2b_article_grid_builder_component_namespaceObject, {
  "B2BArticleGridBuilderConfig": function() { return B2BArticleGridBuilderConfig; },
  "default": function() { return b2b_article_grid_builder_component; }
});

// NAMESPACE OBJECT: ./components/afterpay-goes-green/b2b-carousel-lifecycle/b2b-carousel-lifecycle.builder-component.ts
var b2b_carousel_lifecycle_builder_component_namespaceObject = {};
__webpack_require__.r(b2b_carousel_lifecycle_builder_component_namespaceObject);
__webpack_require__.d(b2b_carousel_lifecycle_builder_component_namespaceObject, {
  "B2BCarouselLifecycleBuilderConfig": function() { return B2BCarouselLifecycleBuilderConfig; },
  "default": function() { return b2b_carousel_lifecycle_builder_component; }
});

// NAMESPACE OBJECT: ./components/afterpay-goes-green/b2b-category-feature/b2b-category-feature.builder-component.ts
var b2b_category_feature_builder_component_namespaceObject = {};
__webpack_require__.r(b2b_category_feature_builder_component_namespaceObject);
__webpack_require__.d(b2b_category_feature_builder_component_namespaceObject, {
  "B2BCategoryFeatureBuilderConfig": function() { return B2BCategoryFeatureBuilderConfig; },
  "default": function() { return b2b_category_feature_builder_component; }
});

// NAMESPACE OBJECT: ./components/afterpay-goes-green/b2b-collapse/b2b-collapse.builder-component.ts
var b2b_collapse_builder_component_namespaceObject = {};
__webpack_require__.r(b2b_collapse_builder_component_namespaceObject);
__webpack_require__.d(b2b_collapse_builder_component_namespaceObject, {
  "B2BCollapseTextBuilderConfig": function() { return B2BCollapseTextBuilderConfig; },
  "default": function() { return b2b_collapse_builder_component; }
});

// NAMESPACE OBJECT: ./components/afterpay-goes-green/b2b-faq/b2b-faq.builder-component.ts
var b2b_faq_builder_component_namespaceObject = {};
__webpack_require__.r(b2b_faq_builder_component_namespaceObject);
__webpack_require__.d(b2b_faq_builder_component_namespaceObject, {
  "B2BFAQBuilderConfig": function() { return B2BFAQBuilderConfig; },
  "default": function() { return b2b_faq_builder_component; }
});

// NAMESPACE OBJECT: ./components/afterpay-goes-green/b2b-framed-info-block/b2b-framed-info-block.builder-component.ts
var b2b_framed_info_block_builder_component_namespaceObject = {};
__webpack_require__.r(b2b_framed_info_block_builder_component_namespaceObject);
__webpack_require__.d(b2b_framed_info_block_builder_component_namespaceObject, {
  "B2BFramedInfoBlockBuilderConfig": function() { return B2BFramedInfoBlockBuilderConfig; },
  "default": function() { return b2b_framed_info_block_builder_component; }
});

// NAMESPACE OBJECT: ./components/afterpay-goes-green/b2b-good-for-v2/b2b-good-for.builder-component.ts
var b2b_good_for_builder_component_namespaceObject = {};
__webpack_require__.r(b2b_good_for_builder_component_namespaceObject);
__webpack_require__.d(b2b_good_for_builder_component_namespaceObject, {
  "B2BGoodForBuilderConfig": function() { return B2BGoodForBuilderConfig; },
  "default": function() { return b2b_good_for_builder_component; }
});

// NAMESPACE OBJECT: ./components/afterpay-goes-green/b2b-headlining-latest-articles/b2b-headlining-latest-articles.builder-component.ts
var b2b_headlining_latest_articles_builder_component_namespaceObject = {};
__webpack_require__.r(b2b_headlining_latest_articles_builder_component_namespaceObject);
__webpack_require__.d(b2b_headlining_latest_articles_builder_component_namespaceObject, {
  "B2BHeadliningLatestArticlesBuilderConfig": function() { return B2BHeadliningLatestArticlesBuilderConfig; },
  "default": function() { return b2b_headlining_latest_articles_builder_component; }
});

// NAMESPACE OBJECT: ./components/afterpay-goes-green/b2b-hero/b2b-hero.builder-component.ts
var b2b_hero_builder_component_namespaceObject = {};
__webpack_require__.r(b2b_hero_builder_component_namespaceObject);
__webpack_require__.d(b2b_hero_builder_component_namespaceObject, {
  "B2BHeroBuilderConfig": function() { return B2BHeroBuilderConfig; },
  "default": function() { return b2b_hero_builder_component; }
});

// NAMESPACE OBJECT: ./components/afterpay-goes-green/b2b-integrations/b2b-integrations.builder-component.ts
var b2b_integrations_builder_component_namespaceObject = {};
__webpack_require__.r(b2b_integrations_builder_component_namespaceObject);
__webpack_require__.d(b2b_integrations_builder_component_namespaceObject, {
  "B2BIntegrationsBuilderConfig": function() { return B2BIntegrationsBuilderConfig; },
  "default": function() { return b2b_integrations_builder_component; }
});

// NAMESPACE OBJECT: ./components/afterpay-goes-green/b2b-learning-series-block/b2b-learning-series-block.builder-component.ts
var b2b_learning_series_block_builder_component_namespaceObject = {};
__webpack_require__.r(b2b_learning_series_block_builder_component_namespaceObject);
__webpack_require__.d(b2b_learning_series_block_builder_component_namespaceObject, {
  "B2BLearningSeriesBlockPropsBuilderConfig": function() { return B2BLearningSeriesBlockPropsBuilderConfig; },
  "default": function() { return b2b_learning_series_block_builder_component; }
});

// NAMESPACE OBJECT: ./components/afterpay-goes-green/b2b-list-card-resources/b2b-list-card-resources.builder-component.ts
var b2b_list_card_resources_builder_component_namespaceObject = {};
__webpack_require__.r(b2b_list_card_resources_builder_component_namespaceObject);
__webpack_require__.d(b2b_list_card_resources_builder_component_namespaceObject, {
  "B2BListCardResourcesConfig": function() { return B2BListCardResourcesConfig; },
  "default": function() { return b2b_list_card_resources_builder_component; }
});

// NAMESPACE OBJECT: ./components/afterpay-goes-green/b2b-online-payment/b2b-online-payment.builder-component.ts
var b2b_online_payment_builder_component_namespaceObject = {};
__webpack_require__.r(b2b_online_payment_builder_component_namespaceObject);
__webpack_require__.d(b2b_online_payment_builder_component_namespaceObject, {
  "B2BOnlinePaymentBuilderConfig": function() { return B2BOnlinePaymentBuilderConfig; },
  "default": function() { return b2b_online_payment_builder_component; }
});

// NAMESPACE OBJECT: ./components/afterpay-goes-green/b2b-platform/b2b-platform.builder-component.ts
var b2b_platform_builder_component_namespaceObject = {};
__webpack_require__.r(b2b_platform_builder_component_namespaceObject);
__webpack_require__.d(b2b_platform_builder_component_namespaceObject, {
  "B2BVideoHeroBuilderConfig": function() { return B2BVideoHeroBuilderConfig; },
  "default": function() { return b2b_platform_builder_component; }
});

// NAMESPACE OBJECT: ./components/afterpay-goes-green/b2b-scrolling-content/b2b-scrolling-content.builder-component.ts
var b2b_scrolling_content_builder_component_namespaceObject = {};
__webpack_require__.r(b2b_scrolling_content_builder_component_namespaceObject);
__webpack_require__.d(b2b_scrolling_content_builder_component_namespaceObject, {
  "B2BScrollingContentBuilderConfig": function() { return B2BScrollingContentBuilderConfig; },
  "default": function() { return b2b_scrolling_content_builder_component; }
});

// NAMESPACE OBJECT: ./components/afterpay-goes-green/b2b-series-collection-article-block/b2b-series-collection-articles-block.builder-component.ts
var b2b_series_collection_articles_block_builder_component_namespaceObject = {};
__webpack_require__.r(b2b_series_collection_articles_block_builder_component_namespaceObject);
__webpack_require__.d(b2b_series_collection_articles_block_builder_component_namespaceObject, {
  "B2BSeriesCollectionArticlesBuilderConfig": function() { return B2BSeriesCollectionArticlesBuilderConfig; },
  "default": function() { return b2b_series_collection_articles_block_builder_component; }
});

// NAMESPACE OBJECT: ./components/afterpay-goes-green/b2b-trending-topics/b2b-trending-topics.builder-component.ts
var b2b_trending_topics_builder_component_namespaceObject = {};
__webpack_require__.r(b2b_trending_topics_builder_component_namespaceObject);
__webpack_require__.d(b2b_trending_topics_builder_component_namespaceObject, {
  "B2BTrendingTopicsBuilderConfig": function() { return B2BTrendingTopicsBuilderConfig; },
  "default": function() { return b2b_trending_topics_builder_component; }
});

// NAMESPACE OBJECT: ./components/afterpay-goes-green/b2b-video-card/b2b-video-card.builder-component.ts
var b2b_video_card_builder_component_namespaceObject = {};
__webpack_require__.r(b2b_video_card_builder_component_namespaceObject);
__webpack_require__.d(b2b_video_card_builder_component_namespaceObject, {
  "B2BVideoCardBuilderConfig": function() { return B2BVideoCardBuilderConfig; },
  "default": function() { return b2b_video_card_builder_component; }
});

// NAMESPACE OBJECT: ./components/afterpay-goes-green/b2b-video-carousel/b2b-video-carousel.builder-component.ts
var b2b_video_carousel_builder_component_namespaceObject = {};
__webpack_require__.r(b2b_video_carousel_builder_component_namespaceObject);
__webpack_require__.d(b2b_video_carousel_builder_component_namespaceObject, {
  "B2BVideoCarouselBuilderConfig": function() { return B2BVideoCarouselBuilderConfig; },
  "default": function() { return b2b_video_carousel_builder_component; }
});

// NAMESPACE OBJECT: ./components/afterpay-goes-green/b2b-video-list/b2b-video-list.builder-component.ts
var b2b_video_list_builder_component_namespaceObject = {};
__webpack_require__.r(b2b_video_list_builder_component_namespaceObject);
__webpack_require__.d(b2b_video_list_builder_component_namespaceObject, {
  "B2bVideoListBuilderConfig": function() { return B2bVideoListBuilderConfig; },
  "default": function() { return b2b_video_list_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-article-grid/business-article-grid.builder-component.ts
var business_article_grid_builder_component_namespaceObject = {};
__webpack_require__.r(business_article_grid_builder_component_namespaceObject);
__webpack_require__.d(business_article_grid_builder_component_namespaceObject, {
  "BusinessArticleGridBuilderConfig": function() { return BusinessArticleGridBuilderConfig; },
  "default": function() { return business_article_grid_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-article-hero/business-featured-article-hero/business-featured-article-hero.builder-component.ts
var business_featured_article_hero_builder_component_namespaceObject = {};
__webpack_require__.r(business_featured_article_hero_builder_component_namespaceObject);
__webpack_require__.d(business_featured_article_hero_builder_component_namespaceObject, {
  "FullWidthArticleHeroBuilderConfig": function() { return FullWidthArticleHeroBuilderConfig; },
  "default": function() { return business_featured_article_hero_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-article-image/business-article-image.builder-component.ts
var business_article_image_builder_component_namespaceObject = {};
__webpack_require__.r(business_article_image_builder_component_namespaceObject);
__webpack_require__.d(business_article_image_builder_component_namespaceObject, {
  "BusinessArticleImageBuilderConfig": function() { return BusinessArticleImageBuilderConfig; },
  "default": function() { return business_article_image_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-article-quote/business-article-quote-wrap.builder-component.ts
var business_article_quote_wrap_builder_component_namespaceObject = {};
__webpack_require__.r(business_article_quote_wrap_builder_component_namespaceObject);
__webpack_require__.d(business_article_quote_wrap_builder_component_namespaceObject, {
  "BusinessArticleQuoteWrapBuilderConfig": function() { return BusinessArticleQuoteWrapBuilderConfig; },
  "default": function() { return business_article_quote_wrap_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-button/business-button-wrap.builder-component.ts
var business_button_wrap_builder_component_namespaceObject = {};
__webpack_require__.r(business_button_wrap_builder_component_namespaceObject);
__webpack_require__.d(business_button_wrap_builder_component_namespaceObject, {
  "BusinessButtonWrapBuilderConfig": function() { return BusinessButtonWrapBuilderConfig; },
  "default": function() { return business_button_wrap_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-collapse/business-collapse.builder-component.ts
var business_collapse_builder_component_namespaceObject = {};
__webpack_require__.r(business_collapse_builder_component_namespaceObject);
__webpack_require__.d(business_collapse_builder_component_namespaceObject, {
  "BusinessCollapseTextBuilderConfig": function() { return BusinessCollapseTextBuilderConfig; },
  "default": function() { return business_collapse_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-emphasized-text/business-emphasized-text.builder-component.ts
var business_emphasized_text_builder_component_namespaceObject = {};
__webpack_require__.r(business_emphasized_text_builder_component_namespaceObject);
__webpack_require__.d(business_emphasized_text_builder_component_namespaceObject, {
  "BusinessEmphasizedTextBuilderConfig": function() { return BusinessEmphasizedTextBuilderConfig; },
  "default": function() { return business_emphasized_text_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-framed-info-block/business-framed-info-block.builder-component.ts
var business_framed_info_block_builder_component_namespaceObject = {};
__webpack_require__.r(business_framed_info_block_builder_component_namespaceObject);
__webpack_require__.d(business_framed_info_block_builder_component_namespaceObject, {
  "BusinessFramedInfoBlockBuilderConfig": function() { return BusinessFramedInfoBlockBuilderConfig; },
  "default": function() { return business_framed_info_block_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-headlining-latest-articles/business-headlining-latest-articles.builder-component.ts
var business_headlining_latest_articles_builder_component_namespaceObject = {};
__webpack_require__.r(business_headlining_latest_articles_builder_component_namespaceObject);
__webpack_require__.d(business_headlining_latest_articles_builder_component_namespaceObject, {
  "HeadliningLatestArticlesBuilderConfig": function() { return HeadliningLatestArticlesBuilderConfig; },
  "default": function() { return business_headlining_latest_articles_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-build-for-industry/business-hub-build-for-industry.builder-component.ts
var business_hub_build_for_industry_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_build_for_industry_builder_component_namespaceObject);
__webpack_require__.d(business_hub_build_for_industry_builder_component_namespaceObject, {
  "BusinessHubBuildForIndustryBuilderConfig": function() { return BusinessHubBuildForIndustryBuilderConfig; },
  "default": function() { return business_hub_build_for_industry_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-carousel-lifecycle/business-hub-carousel-lifecycle.builder-component.ts
var business_hub_carousel_lifecycle_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_carousel_lifecycle_builder_component_namespaceObject);
__webpack_require__.d(business_hub_carousel_lifecycle_builder_component_namespaceObject, {
  "BusinessHubCarouselLifecycleBuilderConfig": function() { return BusinessHubCarouselLifecycleBuilderConfig; },
  "default": function() { return business_hub_carousel_lifecycle_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-carousel-product/business-hub-carousel-product.builder-component.ts
var business_hub_carousel_product_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_carousel_product_builder_component_namespaceObject);
__webpack_require__.d(business_hub_carousel_product_builder_component_namespaceObject, {
  "BusinessHubCarouselProductBuilderConfig": function() { return BusinessHubCarouselProductBuilderConfig; },
  "default": function() { return business_hub_carousel_product_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-faq/business-hub-faq.builder-component.ts
var business_hub_faq_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_faq_builder_component_namespaceObject);
__webpack_require__.d(business_hub_faq_builder_component_namespaceObject, {
  "BusinessHubFAQBuilderConfig": function() { return BusinessHubFAQBuilderConfig; },
  "default": function() { return business_hub_faq_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-gateway/business-hub-gateway.builder-component.ts
var business_hub_gateway_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_gateway_builder_component_namespaceObject);
__webpack_require__.d(business_hub_gateway_builder_component_namespaceObject, {
  "FullBleedConfig": function() { return FullBleedConfig; },
  "default": function() { return business_hub_gateway_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-good-for-v2/business-hub-good-for.builder-component.ts
var business_hub_good_for_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_good_for_builder_component_namespaceObject);
__webpack_require__.d(business_hub_good_for_builder_component_namespaceObject, {
  "BusinessHubGoodForBuilderConfig": function() { return BusinessHubGoodForBuilderConfig; },
  "default": function() { return business_hub_good_for_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-good-for/business-hub-good-for.builder-component.ts
var business_hub_good_for_business_hub_good_for_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_good_for_business_hub_good_for_builder_component_namespaceObject);
__webpack_require__.d(business_hub_good_for_business_hub_good_for_builder_component_namespaceObject, {
  "BusinessHubGoodForBuilderConfig": function() { return business_hub_good_for_builder_component_BusinessHubGoodForBuilderConfig; },
  "default": function() { return business_hub_good_for_business_hub_good_for_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-hero-enterprise/business-hub-hero-enterprise.builder-component.ts
var business_hub_hero_enterprise_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_hero_enterprise_builder_component_namespaceObject);
__webpack_require__.d(business_hub_hero_enterprise_builder_component_namespaceObject, {
  "BusinessHubHeroEnterPriseBuilderConfig": function() { return BusinessHubHeroEnterPriseBuilderConfig; },
  "default": function() { return business_hub_hero_enterprise_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-hero-home/business-hub-hero-home.builder-component.ts
var business_hub_hero_home_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_hero_home_builder_component_namespaceObject);
__webpack_require__.d(business_hub_hero_home_builder_component_namespaceObject, {
  "BusinessHubHeroHomeBuilderConfig": function() { return BusinessHubHeroHomeBuilderConfig; },
  "default": function() { return business_hub_hero_home_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-hero-industry/business-hub-hero-industry.builder-component.ts
var business_hub_hero_industry_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_hero_industry_builder_component_namespaceObject);
__webpack_require__.d(business_hub_hero_industry_builder_component_namespaceObject, {
  "BusinessHubHeroIndustryBuilderConfig": function() { return BusinessHubHeroIndustryBuilderConfig; },
  "default": function() { return business_hub_hero_industry_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-hero-training/business-hub-hero-training.builder-component.ts
var business_hub_hero_training_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_hero_training_builder_component_namespaceObject);
__webpack_require__.d(business_hub_hero_training_builder_component_namespaceObject, {
  "BusinessHubHeroTrainingBuilderConfig": function() { return BusinessHubHeroTrainingBuilderConfig; },
  "default": function() { return business_hub_hero_training_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-how-ap-works/business-hub-how-ap-works.builder-component.ts
var business_hub_how_ap_works_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_how_ap_works_builder_component_namespaceObject);
__webpack_require__.d(business_hub_how_ap_works_builder_component_namespaceObject, {
  "BusinessHubHowApWorksBuilderConfig": function() { return BusinessHubHowApWorksBuilderConfig; },
  "default": function() { return business_hub_how_ap_works_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-how-it-work/business-hub-how-it-works.builder-component.ts
var business_hub_how_it_works_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_how_it_works_builder_component_namespaceObject);
__webpack_require__.d(business_hub_how_it_works_builder_component_namespaceObject, {
  "BusinessHubHowItWorksBuilderConfig": function() { return BusinessHubHowItWorksBuilderConfig; },
  "default": function() { return business_hub_how_it_works_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-image-block-full/business-hub-image-block-full.builder-component.ts
var business_hub_image_block_full_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_image_block_full_builder_component_namespaceObject);
__webpack_require__.d(business_hub_image_block_full_builder_component_namespaceObject, {
  "BusinessHubImageBlockFullBuilderConfig": function() { return BusinessHubImageBlockFullBuilderConfig; },
  "default": function() { return business_hub_image_block_full_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-image-block/business-hub-image-block.builder-component.ts
var business_hub_image_block_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_image_block_builder_component_namespaceObject);
__webpack_require__.d(business_hub_image_block_builder_component_namespaceObject, {
  "BusinessHubImageBlockBuilderConfig": function() { return BusinessHubImageBlockBuilderConfig; },
  "default": function() { return business_hub_image_block_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-image-hero/business-hub-image-hero.builder-component.ts
var business_hub_image_hero_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_image_hero_builder_component_namespaceObject);
__webpack_require__.d(business_hub_image_hero_builder_component_namespaceObject, {
  "BusinessHubImageHeroBuilderConfig": function() { return BusinessHubImageHeroBuilderConfig; },
  "default": function() { return business_hub_image_hero_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-In-action-carousel/business-hub-In-action-carousel.builder-component.ts
var business_hub_In_action_carousel_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_In_action_carousel_builder_component_namespaceObject);
__webpack_require__.d(business_hub_In_action_carousel_builder_component_namespaceObject, {
  "BusinessHubInActionCarouselBuilderConfig": function() { return BusinessHubInActionCarouselBuilderConfig; },
  "default": function() { return business_hub_In_action_carousel_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-industries-card-block/business-hub-industries-card-block.builder-component.ts
var business_hub_industries_card_block_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_industries_card_block_builder_component_namespaceObject);
__webpack_require__.d(business_hub_industries_card_block_builder_component_namespaceObject, {
  "BusinessHubIndustriesCardBlockBuilderConfig": function() { return BusinessHubIndustriesCardBlockBuilderConfig; },
  "default": function() { return business_hub_industries_card_block_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-industries-carousel/business-hub-industries-carousel.builder-component.ts
var business_hub_industries_carousel_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_industries_carousel_builder_component_namespaceObject);
__webpack_require__.d(business_hub_industries_carousel_builder_component_namespaceObject, {
  "BusinessHubIndustriesCarouselBuilderConfig": function() { return BusinessHubIndustriesCarouselBuilderConfig; },
  "default": function() { return business_hub_industries_carousel_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-industries-grid/business-hub-industries-grid.builder-component.ts
var business_hub_industries_grid_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_industries_grid_builder_component_namespaceObject);
__webpack_require__.d(business_hub_industries_grid_builder_component_namespaceObject, {
  "BusinessHubIndustriesGridBuilderConfig": function() { return BusinessHubIndustriesGridBuilderConfig; },
  "default": function() { return business_hub_industries_grid_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-industries-optional-quote/business-hub-industries-optional-quote.builder-component.ts
var business_hub_industries_optional_quote_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_industries_optional_quote_builder_component_namespaceObject);
__webpack_require__.d(business_hub_industries_optional_quote_builder_component_namespaceObject, {
  "BusinessHubIndustriesOptionalQuoteBuilderConfig": function() { return BusinessHubIndustriesOptionalQuoteBuilderConfig; },
  "default": function() { return business_hub_industries_optional_quote_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-industries-stats/business-hub-industries-stats.builder-component.ts
var business_hub_industries_stats_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_industries_stats_builder_component_namespaceObject);
__webpack_require__.d(business_hub_industries_stats_builder_component_namespaceObject, {
  "BusinessHubIndustriesStatsBuilderConfig": function() { return BusinessHubIndustriesStatsBuilderConfig; },
  "default": function() { return business_hub_industries_stats_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-integrations/business-hub-integrations.builder-component.ts
var business_hub_integrations_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_integrations_builder_component_namespaceObject);
__webpack_require__.d(business_hub_integrations_builder_component_namespaceObject, {
  "BusinessHubIntegrationsBuilderConfig": function() { return BusinessHubIntegrationsBuilderConfig; },
  "default": function() { return business_hub_integrations_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-list-card-resources/business-hub-list-card-resources.builder-component.ts
var business_hub_list_card_resources_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_list_card_resources_builder_component_namespaceObject);
__webpack_require__.d(business_hub_list_card_resources_builder_component_namespaceObject, {
  "BusinessHubListCardResourcesConfig": function() { return BusinessHubListCardResourcesConfig; },
  "default": function() { return business_hub_list_card_resources_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-list-e-commerce/business-hub-list-e-commerce.builder-component.ts
var business_hub_list_e_commerce_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_list_e_commerce_builder_component_namespaceObject);
__webpack_require__.d(business_hub_list_e_commerce_builder_component_namespaceObject, {
  "BusinessHubListE_CommerceBuilderConfig": function() { return BusinessHubListE_CommerceBuilderConfig; },
  "default": function() { return business_hub_list_e_commerce_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-online-payment/business-hub-online-payment.builder-component.ts
var business_hub_online_payment_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_online_payment_builder_component_namespaceObject);
__webpack_require__.d(business_hub_online_payment_builder_component_namespaceObject, {
  "BusinessHubOnlinePaymentBuilderConfig": function() { return BusinessHubOnlinePaymentBuilderConfig; },
  "default": function() { return business_hub_online_payment_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-platform-integrations/business-hub-platform-integrations.builder-component.ts
var business_hub_platform_integrations_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_platform_integrations_builder_component_namespaceObject);
__webpack_require__.d(business_hub_platform_integrations_builder_component_namespaceObject, {
  "BusinessHubHeroPlatFormIntegrationsBuilderConfig": function() { return BusinessHubHeroPlatFormIntegrationsBuilderConfig; },
  "default": function() { return business_hub_platform_integrations_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-platform/business-hub-platform.builder-component.ts
var business_hub_platform_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_platform_builder_component_namespaceObject);
__webpack_require__.d(business_hub_platform_builder_component_namespaceObject, {
  "BusinessHubVideoHeroBuilderConfig": function() { return BusinessHubVideoHeroBuilderConfig; },
  "default": function() { return business_hub_platform_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-solutions/business-hub-solutions.builder-component.ts
var business_hub_solutions_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_solutions_builder_component_namespaceObject);
__webpack_require__.d(business_hub_solutions_builder_component_namespaceObject, {
  "FullBleedConfig": function() { return business_hub_solutions_builder_component_FullBleedConfig; },
  "default": function() { return business_hub_solutions_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-stats/business-hub-stats.builder-component.ts
var business_hub_stats_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_stats_builder_component_namespaceObject);
__webpack_require__.d(business_hub_stats_builder_component_namespaceObject, {
  "BusinessHubStatsConfig": function() { return BusinessHubStatsConfig; },
  "default": function() { return business_hub_stats_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-trusted-brand/business-hub-trusted-brand.builder-component.ts
var business_hub_trusted_brand_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_trusted_brand_builder_component_namespaceObject);
__webpack_require__.d(business_hub_trusted_brand_builder_component_namespaceObject, {
  "BusinessHubTrustedBrandConfig": function() { return BusinessHubTrustedBrandConfig; },
  "default": function() { return business_hub_trusted_brand_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-used-by/business-hub-used-by.builder-component.ts
var business_hub_used_by_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_used_by_builder_component_namespaceObject);
__webpack_require__.d(business_hub_used_by_builder_component_namespaceObject, {
  "BusinessHubUsedByBuilderConfig": function() { return BusinessHubUsedByBuilderConfig; },
  "default": function() { return business_hub_used_by_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-hub-video-hero/business-hub-video-hero.builder-component.ts
var business_hub_video_hero_builder_component_namespaceObject = {};
__webpack_require__.r(business_hub_video_hero_builder_component_namespaceObject);
__webpack_require__.d(business_hub_video_hero_builder_component_namespaceObject, {
  "BusinessHubVideoHeroBuilderConfig": function() { return business_hub_video_hero_builder_component_BusinessHubVideoHeroBuilderConfig; },
  "default": function() { return business_hub_video_hero_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-download-all-button/business-resource-download-all-button.builder-component.ts
var business_resource_download_all_button_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_download_all_button_builder_component_namespaceObject);
__webpack_require__.d(business_resource_download_all_button_builder_component_namespaceObject, {
  "default": function() { return business_resource_download_all_button_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-asset-grid/business-resource-grid.builder-component.ts
var business_resource_grid_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_grid_builder_component_namespaceObject);
__webpack_require__.d(business_resource_grid_builder_component_namespaceObject, {
  "default": function() { return business_resource_grid_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-asset-container/business-resource-asset-container.builder-component.ts
var business_resource_asset_container_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_asset_container_builder_component_namespaceObject);
__webpack_require__.d(business_resource_asset_container_builder_component_namespaceObject, {
  "default": function() { return business_resource_asset_container_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-asset-library/business-resource-asset-library.builder-component.ts
var business_resource_asset_library_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_asset_library_builder_component_namespaceObject);
__webpack_require__.d(business_resource_asset_library_builder_component_namespaceObject, {
  "BusinessResourceAssetBuilderConfig": function() { return BusinessResourceAssetBuilderConfig; },
  "default": function() { return business_resource_asset_library_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-background-text-wrap/business-resource-background-text-wrap.builder-component.ts
var business_resource_background_text_wrap_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_background_text_wrap_builder_component_namespaceObject);
__webpack_require__.d(business_resource_background_text_wrap_builder_component_namespaceObject, {
  "BusinessResourceBackgroundTextWrapBuilderConfig": function() { return BusinessResourceBackgroundTextWrapBuilderConfig; },
  "default": function() { return business_resource_background_text_wrap_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-banner-carousel/business-resource-asset.builder-component.ts
var business_resource_asset_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_asset_builder_component_namespaceObject);
__webpack_require__.d(business_resource_asset_builder_component_namespaceObject, {
  "BusinessResourceBannerCarouselBuilderConfig": function() { return BusinessResourceBannerCarouselBuilderConfig; },
  "default": function() { return business_resource_asset_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-banners/business-resource-banners.builder-component.ts
var business_resource_banners_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_banners_builder_component_namespaceObject);
__webpack_require__.d(business_resource_banners_builder_component_namespaceObject, {
  "BusinessResourceBannersBuilderConfig": function() { return BusinessResourceBannersBuilderConfig; },
  "default": function() { return business_resource_banners_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-card/business-resource-card.builder-component.ts
var business_resource_card_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_card_builder_component_namespaceObject);
__webpack_require__.d(business_resource_card_builder_component_namespaceObject, {
  "BusinessResourceCardBuilderConfig": function() { return BusinessResourceCardBuilderConfig; },
  "default": function() { return business_resource_card_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-centre-hero/business-resource-centre-hero.builder-component.ts
var business_resource_centre_hero_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_centre_hero_builder_component_namespaceObject);
__webpack_require__.d(business_resource_centre_hero_builder_component_namespaceObject, {
  "BusinessResourceCentreHeroBuilderConfig": function() { return BusinessResourceCentreHeroBuilderConfig; },
  "default": function() { return business_resource_centre_hero_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-colour-palette/business-resource-colour-palette.builder-component.ts
var business_resource_colour_palette_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_colour_palette_builder_component_namespaceObject);
__webpack_require__.d(business_resource_colour_palette_builder_component_namespaceObject, {
  "BusinessResourceColourPaletteBuilderConfig": function() { return BusinessResourceColourPaletteBuilderConfig; },
  "default": function() { return business_resource_colour_palette_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-divider/business-resource-divider.builder-component.ts
var business_resource_divider_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_divider_builder_component_namespaceObject);
__webpack_require__.d(business_resource_divider_builder_component_namespaceObject, {
  "BusinessResourceDividerBuilderConfig": function() { return BusinessResourceDividerBuilderConfig; },
  "default": function() { return business_resource_divider_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-download-card/business-resource-download-card.builder-component.ts
var business_resource_download_card_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_download_card_builder_component_namespaceObject);
__webpack_require__.d(business_resource_download_card_builder_component_namespaceObject, {
  "BusinessResourceDownloadCardBuilderConfig": function() { return BusinessResourceDownloadCardBuilderConfig; },
  "default": function() { return business_resource_download_card_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-download-grid/business-resource-download-grid.builder-component.ts
var business_resource_download_grid_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_download_grid_builder_component_namespaceObject);
__webpack_require__.d(business_resource_download_grid_builder_component_namespaceObject, {
  "BusinessResourceDownloadGridBuilderConfig": function() { return BusinessResourceDownloadGridBuilderConfig; },
  "default": function() { return business_resource_download_grid_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-faq/business-resource-faq.builder-component.ts
var business_resource_faq_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_faq_builder_component_namespaceObject);
__webpack_require__.d(business_resource_faq_builder_component_namespaceObject, {
  "BusinessResourceFAQBuilderConfig": function() { return BusinessResourceFAQBuilderConfig; },
  "default": function() { return business_resource_faq_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-hero-sub/business-resource-hero-sub.builder-component.ts
var business_resource_hero_sub_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_hero_sub_builder_component_namespaceObject);
__webpack_require__.d(business_resource_hero_sub_builder_component_namespaceObject, {
  "BusinessResourceHeroSubBuilderConfig": function() { return BusinessResourceHeroSubBuilderConfig; },
  "default": function() { return business_resource_hero_sub_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-hiws/business-resource-hiws.builder-component.ts
var business_resource_hiws_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_hiws_builder_component_namespaceObject);
__webpack_require__.d(business_resource_hiws_builder_component_namespaceObject, {
  "BusinessResourceHIWsBuilderConfig": function() { return BusinessResourceHIWsBuilderConfig; },
  "default": function() { return business_resource_hiws_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-image-carousel/business-resource-image-carousel.builder-component.ts
var business_resource_image_carousel_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_image_carousel_builder_component_namespaceObject);
__webpack_require__.d(business_resource_image_carousel_builder_component_namespaceObject, {
  "BusinessResourceImageCarouselConfig": function() { return BusinessResourceImageCarouselConfig; },
  "default": function() { return business_resource_image_carousel_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-image-comparison-slider/business-resource-image-comparison-slider.builder-component.ts
var business_resource_image_comparison_slider_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_image_comparison_slider_builder_component_namespaceObject);
__webpack_require__.d(business_resource_image_comparison_slider_builder_component_namespaceObject, {
  "BusinessResourceImageComparisonSliderBuilderConfig": function() { return BusinessResourceImageComparisonSliderBuilderConfig; },
  "default": function() { return business_resource_image_comparison_slider_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-in-situ/business-resource-in-situ.builder-component.ts
var business_resource_in_situ_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_in_situ_builder_component_namespaceObject);
__webpack_require__.d(business_resource_in_situ_builder_component_namespaceObject, {
  "default": function() { return business_resource_in_situ_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-lightbox/business-resource-lightbox.builder-component.ts
var business_resource_lightbox_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_lightbox_builder_component_namespaceObject);
__webpack_require__.d(business_resource_lightbox_builder_component_namespaceObject, {
  "BusinessResourceLightboxBuilderConfig": function() { return BusinessResourceLightboxBuilderConfig; },
  "default": function() { return business_resource_lightbox_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-logo-usage/business-resource-logo-usage.builder-component.ts
var business_resource_logo_usage_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_logo_usage_builder_component_namespaceObject);
__webpack_require__.d(business_resource_logo_usage_builder_component_namespaceObject, {
  "BusinessResourceLogoUsageBuilderConfig": function() { return BusinessResourceLogoUsageBuilderConfig; },
  "default": function() { return business_resource_logo_usage_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-logos/business-resource-logos.builder-component.ts
var business_resource_logos_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_logos_builder_component_namespaceObject);
__webpack_require__.d(business_resource_logos_builder_component_namespaceObject, {
  "BusinessResourceLogosBuilderConfig": function() { return BusinessResourceLogosBuilderConfig; },
  "default": function() { return business_resource_logos_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-messaging/business-resource-messaging.builder-component.ts
var business_resource_messaging_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_messaging_builder_component_namespaceObject);
__webpack_require__.d(business_resource_messaging_builder_component_namespaceObject, {
  "BusinessResourceMessagingBuilderConfig": function() { return BusinessResourceMessagingBuilderConfig; },
  "default": function() { return business_resource_messaging_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-page-title/business-resource-page-title.builder-component.ts
var business_resource_page_title_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_page_title_builder_component_namespaceObject);
__webpack_require__.d(business_resource_page_title_builder_component_namespaceObject, {
  "BusinessResourcePageTitleBuilderConfig": function() { return BusinessResourcePageTitleBuilderConfig; },
  "default": function() { return business_resource_page_title_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-price-breakdown/business-resource-price-breakdown.builder-component.ts
var business_resource_price_breakdown_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_price_breakdown_builder_component_namespaceObject);
__webpack_require__.d(business_resource_price_breakdown_builder_component_namespaceObject, {
  "BusinessResourcePriceBreakdownBuilderConfig": function() { return BusinessResourcePriceBreakdownBuilderConfig; },
  "default": function() { return business_resource_price_breakdown_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-related/business-image-grid-slider.builder-component.ts
var business_image_grid_slider_builder_component_namespaceObject = {};
__webpack_require__.r(business_image_grid_slider_builder_component_namespaceObject);
__webpack_require__.d(business_image_grid_slider_builder_component_namespaceObject, {
  "ImageGridSliderBuilderConfig": function() { return ImageGridSliderBuilderConfig; },
  "default": function() { return business_image_grid_slider_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-super-text/business-resource-super-text.builder-component.ts
var business_resource_super_text_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_super_text_builder_component_namespaceObject);
__webpack_require__.d(business_resource_super_text_builder_component_namespaceObject, {
  "BusinessResourceTextHighlightBuilderConfig": function() { return BusinessResourceTextHighlightBuilderConfig; },
  "default": function() { return business_resource_super_text_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-text-hightlight/business-resource-text-highlight.builder-component.ts
var business_resource_text_highlight_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_text_highlight_builder_component_namespaceObject);
__webpack_require__.d(business_resource_text_highlight_builder_component_namespaceObject, {
  "BusinessResourceTextHighlightBuilderConfig": function() { return business_resource_text_highlight_builder_component_BusinessResourceTextHighlightBuilderConfig; },
  "default": function() { return business_resource_text_highlight_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-text-list/business-resource-text-list.builder-component.ts
var business_resource_text_list_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_text_list_builder_component_namespaceObject);
__webpack_require__.d(business_resource_text_list_builder_component_namespaceObject, {
  "BusinessResourceTextListBuilderConfig": function() { return BusinessResourceTextListBuilderConfig; },
  "default": function() { return business_resource_text_list_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-text-wrap/business-resource-text-wrap.builder-component.ts
var business_resource_text_wrap_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_text_wrap_builder_component_namespaceObject);
__webpack_require__.d(business_resource_text_wrap_builder_component_namespaceObject, {
  "BusinessResourceTextWrapBuilderConfig": function() { return BusinessResourceTextWrapBuilderConfig; },
  "default": function() { return business_resource_text_wrap_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-top-strips/business-resource-top-strips.builder-component.ts
var business_resource_top_strips_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_top_strips_builder_component_namespaceObject);
__webpack_require__.d(business_resource_top_strips_builder_component_namespaceObject, {
  "BusinessResourceTopStripsBuilderConfig": function() { return BusinessResourceTopStripsBuilderConfig; },
  "default": function() { return business_resource_top_strips_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-training-block/business-resource-training-block.builder-component.ts
var business_resource_training_block_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_training_block_builder_component_namespaceObject);
__webpack_require__.d(business_resource_training_block_builder_component_namespaceObject, {
  "ResourceTrainingBlockBuilderConfig": function() { return ResourceTrainingBlockBuilderConfig; },
  "default": function() { return business_resource_training_block_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-typography-review/business-resource-typography-review.builder-component.ts
var business_resource_typography_review_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_typography_review_builder_component_namespaceObject);
__webpack_require__.d(business_resource_typography_review_builder_component_namespaceObject, {
  "BusinessResourceTypographyReviewBuilderConfig": function() { return BusinessResourceTypographyReviewBuilderConfig; },
  "default": function() { return business_resource_typography_review_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-value-block/business-resource-value-block.builder-component.ts
var business_resource_value_block_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_value_block_builder_component_namespaceObject);
__webpack_require__.d(business_resource_value_block_builder_component_namespaceObject, {
  "BusinessResourceValueBlockBuilderConfig": function() { return BusinessResourceValueBlockBuilderConfig; },
  "default": function() { return business_resource_value_block_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-resource-video-list/business-resource-video-list.builder-component.ts
var business_resource_video_list_builder_component_namespaceObject = {};
__webpack_require__.r(business_resource_video_list_builder_component_namespaceObject);
__webpack_require__.d(business_resource_video_list_builder_component_namespaceObject, {
  "BusinessVideoListBuilderConfig": function() { return BusinessVideoListBuilderConfig; },
  "default": function() { return business_resource_video_list_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-text-caption/business-text-caption.builder-component.ts
var business_text_caption_builder_component_namespaceObject = {};
__webpack_require__.r(business_text_caption_builder_component_namespaceObject);
__webpack_require__.d(business_text_caption_builder_component_namespaceObject, {
  "BusinessTextWrapBuilderConfig": function() { return BusinessTextWrapBuilderConfig; },
  "default": function() { return business_text_caption_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-text-wrap/business-text-wrap.builder-component.ts
var business_text_wrap_builder_component_namespaceObject = {};
__webpack_require__.r(business_text_wrap_builder_component_namespaceObject);
__webpack_require__.d(business_text_wrap_builder_component_namespaceObject, {
  "BusinessTextWrapBuilderConfig": function() { return business_text_wrap_builder_component_BusinessTextWrapBuilderConfig; },
  "default": function() { return business_text_wrap_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-trending-topics/business-trending-topics.builder-component.ts
var business_trending_topics_builder_component_namespaceObject = {};
__webpack_require__.r(business_trending_topics_builder_component_namespaceObject);
__webpack_require__.d(business_trending_topics_builder_component_namespaceObject, {
  "BusinessTrendingTopicsBuilderConfig": function() { return BusinessTrendingTopicsBuilderConfig; },
  "default": function() { return business_trending_topics_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-vimeo-embed/business-vimeo-embed-wrap.builder-component.ts
var business_vimeo_embed_wrap_builder_component_namespaceObject = {};
__webpack_require__.r(business_vimeo_embed_wrap_builder_component_namespaceObject);
__webpack_require__.d(business_vimeo_embed_wrap_builder_component_namespaceObject, {
  "BusinessVimeoEmbedWrapBuilderConfig": function() { return BusinessVimeoEmbedWrapBuilderConfig; },
  "default": function() { return business_vimeo_embed_wrap_builder_component; }
});

// NAMESPACE OBJECT: ./components/business-youtube-embed/business-youtube-embed.builder-component.ts
var business_youtube_embed_builder_component_namespaceObject = {};
__webpack_require__.r(business_youtube_embed_builder_component_namespaceObject);
__webpack_require__.d(business_youtube_embed_builder_component_namespaceObject, {
  "BusinessYoutubeEmbedWrapBuilderConfig": function() { return BusinessYoutubeEmbedWrapBuilderConfig; },
  "default": function() { return business_youtube_embed_builder_component; }
});

// NAMESPACE OBJECT: ./components/bussines-video-player/business-video-player.builder-component.ts
var business_video_player_builder_component_namespaceObject = {};
__webpack_require__.r(business_video_player_builder_component_namespaceObject);
__webpack_require__.d(business_video_player_builder_component_namespaceObject, {
  "BusinessVideoPlayerWrapBuilderConfig": function() { return BusinessVideoPlayerWrapBuilderConfig; },
  "default": function() { return business_video_player_builder_component; }
});

// NAMESPACE OBJECT: ./components/category-feature/category-feature.builder-component.ts
var category_feature_builder_component_namespaceObject = {};
__webpack_require__.r(category_feature_builder_component_namespaceObject);
__webpack_require__.d(category_feature_builder_component_namespaceObject, {
  "CategoryFeatureBuilderConfig": function() { return CategoryFeatureBuilderConfig; },
  "default": function() { return category_feature_builder_component; }
});

// NAMESPACE OBJECT: ./components/category-hero/category-hero.builder-component.ts
var category_hero_builder_component_namespaceObject = {};
__webpack_require__.r(category_hero_builder_component_namespaceObject);
__webpack_require__.d(category_hero_builder_component_namespaceObject, {
  "CategoryHeroBuilderConfig": function() { return CategoryHeroBuilderConfig; },
  "default": function() { return category_hero_builder_component; }
});

// NAMESPACE OBJECT: ./components/learning-series-block/learning-series-block.builder-component.ts
var learning_series_block_builder_component_namespaceObject = {};
__webpack_require__.r(learning_series_block_builder_component_namespaceObject);
__webpack_require__.d(learning_series_block_builder_component_namespaceObject, {
  "LearningSeriesBlockPropsBuilderConfig": function() { return LearningSeriesBlockPropsBuilderConfig; },
  "default": function() { return learning_series_block_builder_component; }
});

// NAMESPACE OBJECT: ./components/numerical-highlight-list/numerical-highlight-list.builder-component.ts
var numerical_highlight_list_builder_component_namespaceObject = {};
__webpack_require__.r(numerical_highlight_list_builder_component_namespaceObject);
__webpack_require__.d(numerical_highlight_list_builder_component_namespaceObject, {
  "NumericalHighlightListBuilderConfig": function() { return NumericalHighlightListBuilderConfig; },
  "default": function() { return numerical_highlight_list_builder_component; }
});

// NAMESPACE OBJECT: ./components/series-collection-article-block/series-collection-articles-block.builder-component.ts
var series_collection_articles_block_builder_component_namespaceObject = {};
__webpack_require__.r(series_collection_articles_block_builder_component_namespaceObject);
__webpack_require__.d(series_collection_articles_block_builder_component_namespaceObject, {
  "SeriesCollectionArticlesBuilderConfig": function() { return SeriesCollectionArticlesBuilderConfig; },
  "default": function() { return series_collection_articles_block_builder_component; }
});

// NAMESPACE OBJECT: ./components/trustpilot-widget/trustpilot-widget.builder-component.ts
var trustpilot_widget_builder_component_namespaceObject = {};
__webpack_require__.r(trustpilot_widget_builder_component_namespaceObject);
__webpack_require__.d(trustpilot_widget_builder_component_namespaceObject, {
  "TrustpilotWidgetBuilderConfig": function() { return TrustpilotWidgetBuilderConfig; },
  "default": function() { return trustpilot_widget_builder_component; }
});

// NAMESPACE OBJECT: ./components/unordered-highlight-list/unordered-highlight-list.builder-component.ts
var unordered_highlight_list_builder_component_namespaceObject = {};
__webpack_require__.r(unordered_highlight_list_builder_component_namespaceObject);
__webpack_require__.d(unordered_highlight_list_builder_component_namespaceObject, {
  "UnorderedHighlightListBuilderConfig": function() { return UnorderedHighlightListBuilderConfig; },
  "default": function() { return unordered_highlight_list_builder_component; }
});

// NAMESPACE OBJECT: ./components/video-card-section/video-card-section.builder-component.ts
var video_card_section_builder_component_namespaceObject = {};
__webpack_require__.r(video_card_section_builder_component_namespaceObject);
__webpack_require__.d(video_card_section_builder_component_namespaceObject, {
  "VideoCardSectionBuilderConfig": function() { return VideoCardSectionBuilderConfig; },
  "default": function() { return video_card_section_builder_component; }
});

// NAMESPACE OBJECT: ./components/video-card/video-card.builder-component.ts
var video_card_builder_component_namespaceObject = {};
__webpack_require__.r(video_card_builder_component_namespaceObject);
__webpack_require__.d(video_card_builder_component_namespaceObject, {
  "VideoCardBuilderConfig": function() { return VideoCardBuilderConfig; },
  "default": function() { return video_card_builder_component; }
});

// NAMESPACE OBJECT: ./components/video-carousel/video-carousel.builder-component.ts
var video_carousel_builder_component_namespaceObject = {};
__webpack_require__.r(video_carousel_builder_component_namespaceObject);
__webpack_require__.d(video_carousel_builder_component_namespaceObject, {
  "VideoCarouselBuilderConfig": function() { return VideoCarouselBuilderConfig; },
  "default": function() { return video_carousel_builder_component; }
});

// NAMESPACE OBJECT: ./components/video-hero/video-hero.builder-component.ts
var video_hero_builder_component_namespaceObject = {};
__webpack_require__.r(video_hero_builder_component_namespaceObject);
__webpack_require__.d(video_hero_builder_component_namespaceObject, {
  "VideoHeroBuilderConfig": function() { return VideoHeroBuilderConfig; },
  "default": function() { return video_hero_builder_component; }
});

// EXTERNAL MODULE: ./node_modules/@builder.io/sdk/dist/index.esm.js
var index_esm = __webpack_require__(11183);
// EXTERNAL MODULE: ./node_modules/@builder.io/utils/dist/index.js
var dist = __webpack_require__(31258);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(62991);
// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-access-hero/b2b-access-hero.module.scss
var b2b_access_hero_module = __webpack_require__(49239);
var b2b_access_hero_module_default = /*#__PURE__*/__webpack_require__.n(b2b_access_hero_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(48771);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(56779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-category/b2b-category.tsx
var b2b_category = __webpack_require__(94430);
// EXTERNAL MODULE: ./helpers/LangHelper.ts
var LangHelper = __webpack_require__(77868);
// EXTERNAL MODULE: ./helpers/BuilderHelper.ts
var BuilderHelper = __webpack_require__(31198);
// EXTERNAL MODULE: ./components/business-button/business-button.tsx
var business_button = __webpack_require__(52955);
// EXTERNAL MODULE: ./components/business-button/business-button.constants.ts
var business_button_constants = __webpack_require__(79892);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-access-hero/b2b-access-hero.tsx










const B2BAccessHero = (props)=>{
    const [article, setArticle] = (0,react.useState)(props.article);
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const categories = (article === null || article === void 0 ? void 0 : article.categories) || [];
    const getLatestArticle = async ()=>{
        const articles = await (0,BuilderHelper/* getLatestArticles */.gg)({
            locale,
            offset: 0,
            limit: 1
        });
        if (articles === null || articles === void 0 ? void 0 : articles[0]) {
            setArticle(articles === null || articles === void 0 ? void 0 : articles[0]);
        }
    };
    (0,react.useEffect)(()=>{
        if (props.article) return;
        getLatestArticle();
    }, [
        props.article
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((b2b_access_hero_module_default()).container),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_access_hero_module_default()).background,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (b2b_access_hero_module_default()).image,
                    children: [
                        (article === null || article === void 0 ? void 0 : article.leadImage) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            className: classnames_default()({
                                [(b2b_access_hero_module_default()).desktop]: !!(article === null || article === void 0 ? void 0 : article.leadPortraitImage)
                            }),
                            src: article === null || article === void 0 ? void 0 : article.leadImage,
                            alt: "",
                            loading: "lazy",
                            fill: true,
                            style: {
                                objectFit: "cover",
                                objectPosition: "center"
                            },
                            loader: (param)=>{
                                let { src , width , quality  } = param;
                                return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                            }
                        }),
                        (article === null || article === void 0 ? void 0 : article.leadPortraitImage) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            className: classnames_default()({
                                [(b2b_access_hero_module_default()).mobile]: !!(article === null || article === void 0 ? void 0 : article.leadImage)
                            }),
                            src: article.leadPortraitImage,
                            alt: "",
                            loading: "lazy",
                            fill: true,
                            style: {
                                objectFit: "cover",
                                objectPosition: "center"
                            },
                            loader: (param)=>{
                                let { src , width , quality  } = param;
                                return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (b2b_access_hero_module_default()).content,
                children: [
                    categories.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(b2b_category/* B2BCategory */.M, {
                        categories: categories,
                        className: (b2b_access_hero_module_default()).categories,
                        theme: "light"
                    }) : null,
                    (article === null || article === void 0 ? void 0 : article.title) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((b2b_access_hero_module_default()).title),
                        dangerouslySetInnerHTML: {
                            __html: article === null || article === void 0 ? void 0 : article.title
                        }
                    }) : null,
                    (article === null || article === void 0 ? void 0 : article.description) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (b2b_access_hero_module_default()).description,
                        dangerouslySetInnerHTML: {
                            __html: article.description
                        }
                    }) : null,
                    (article === null || article === void 0 ? void 0 : article.articleUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                        link: (0,LangHelper/* replaceOrAddLocale */.yM)(article === null || article === void 0 ? void 0 : article.articleUrl, LangHelper/* Locale.USA */.go.USA),
                        buttonText: "Read More",
                        target: "_self",
                        autoMargin: false,
                        color: business_button_constants/* COLORS.WHITE */.DM.WHITE
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var b2b_access_hero = (B2BAccessHero);

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-access-hero/b2b-access-hero.builder-component.ts

const B2BAccessHeroBuilderConfig = {
    name: "B2B Access Hero",
    inputs: []
};
const builderConfig = {
    component: b2b_access_hero,
    config: B2BAccessHeroBuilderConfig
};
/* harmony default export */ var b2b_access_hero_builder_component = (builderConfig);

// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-article-grid/b2b-article-grid.tsx
var b2b_article_grid = __webpack_require__(33508);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-business-article-grid/b2b-article-grid.tsx





const B2BArticleGrid = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    var _initialArticles;
    const [articles, setArticles] = (0,react.useState)((_initialArticles = props.initialArticles) !== null && _initialArticles !== void 0 ? _initialArticles : []);
    const [offset, setOffsetArticle] = (0,react.useState)(props.offset);
    const [isLoadingMoreArticles, setIsLoadingMoreArticles] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        let cancelled = false;
        if (props.offset === offset) return;
        const fetchArticles = async ()=>{
            setIsLoadingMoreArticles(true);
            try {
                const newArticles = await (0,BuilderHelper/* getLatestArticles */.gg)({
                    locale,
                    offset,
                    limit: 9
                });
                if (!cancelled) {
                    setArticles((oldArticles)=>[
                            ...oldArticles,
                            ...newArticles
                        ]);
                }
            } catch (error) {
                console.error("Error fetching articles:", error);
            } finally{
                if (!cancelled) {
                    setIsLoadingMoreArticles(false);
                }
            }
        };
        fetchArticles();
        return ()=>{
            cancelled = true;
        };
    }, [
        locale,
        offset,
        props.offset
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(b2b_article_grid/* default */.Z, {
        articles: articles,
        isLoadingMoreArticles: isLoadingMoreArticles,
        setOffsetArticle: setOffsetArticle,
        offsetArticle: offset
    });
};

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-business-article-grid/b2b-article-grid.constants.ts
var B2BArticleGridSource;
(function(B2BArticleGridSource) {
    B2BArticleGridSource["Latest"] = "latest";
    B2BArticleGridSource["Standard"] = "standard";
})(B2BArticleGridSource || (B2BArticleGridSource = {}));
const ALL_ARTICLE_GRID_TYPES = Object.values(B2BArticleGridSource);

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-business-article-grid/b2b-article-grid.builder-component.ts


const B2BArticleGridBuilderConfig = {
    name: "B2B Article Grid",
    inputs: [
        {
            name: "offset",
            type: "number",
            default: 0
        },
        {
            name: "articleSource",
            type: "text",
            enum: ALL_ARTICLE_GRID_TYPES
        }
    ]
};
const b2b_article_grid_builder_component_builderConfig = {
    component: B2BArticleGrid,
    config: B2BArticleGridBuilderConfig
};
/* harmony default export */ var b2b_article_grid_builder_component = (b2b_article_grid_builder_component_builderConfig);

// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination.css
var pagination = __webpack_require__(89995);
// EXTERNAL MODULE: ./node_modules/swiper/swiper-react.mjs + 2 modules
var swiper_react = __webpack_require__(48929);
// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-carousel-lifecycle/card/card-lifecycle.module.scss
var card_lifecycle_module = __webpack_require__(47620);
var card_lifecycle_module_default = /*#__PURE__*/__webpack_require__.n(card_lifecycle_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-carousel-lifecycle/card/card-lifecycle.tsx




const CardLifecycle = (props)=>{
    const { image , title , description , backgroundContent , buttonText , buttonLink , tileClickable  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (card_lifecycle_module_default()).container,
        children: [
            tileClickable && buttonLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: (card_lifecycle_module_default()).link,
                target: "_blank",
                href: buttonLink
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (card_lifecycle_module_default()).image,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: image,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (card_lifecycle_module_default()).wrapperContent,
                style: {
                    backgroundColor: backgroundContent
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (card_lifecycle_module_default()).title,
                        dangerouslySetInnerHTML: {
                            __html: title !== null && title !== void 0 ? title : ""
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (card_lifecycle_module_default()).description,
                        dangerouslySetInnerHTML: {
                            __html: description !== null && description !== void 0 ? description : ""
                        }
                    }),
                    buttonText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (card_lifecycle_module_default()).button,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                            buttonText: buttonText || "Learn more",
                            link: buttonLink || "",
                            color: business_button_constants/* COLORS.BLACK */.DM.BLACK
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var card_lifecycle = (CardLifecycle);

// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-carousel-lifecycle/b2b-carousel-lifecycle.module.scss
var b2b_carousel_lifecycle_module = __webpack_require__(39440);
var b2b_carousel_lifecycle_module_default = /*#__PURE__*/__webpack_require__.n(b2b_carousel_lifecycle_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-carousel-lifecycle/b2b-carousel-lifecycle.tsx






const B2BCarouselLifecycle = (props)=>{
    const { title , subTitle , items =[] , backgroundColor , colorText , optionButton , autoplay  } = props;
    const options = {
        spaceBetween: 30,
        allowTouchMove: true,
        slidesPerView: "auto",
        noSwiping: false,
        pagination: {
            enabled: false,
            clickable: true
        },
        loop: false,
        speed: 1000,
        autoplay: autoplay ? {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
            waitForTransition: true
        } : false,
        slidesPerGroupSkip: 0,
        breakpoints: {
            378: {
                slidesPerView: "auto",
                watchOverflow: true,
                centeredSlides: false,
                spaceBetween: 20
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (b2b_carousel_lifecycle_module_default()).container,
        style: {
            backgroundColor: backgroundColor,
            color: colorText
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (b2b_carousel_lifecycle_module_default()).wrapperContent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (b2b_carousel_lifecycle_module_default()).title,
                    dangerouslySetInnerHTML: {
                        __html: title || ""
                    }
                }),
                subTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (b2b_carousel_lifecycle_module_default()).subTitle,
                    children: subTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (b2b_carousel_lifecycle_module_default()).listCard,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        ...options,
                        children: items.map((item, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card_lifecycle, {
                                    image: item.image,
                                    title: item.title,
                                    description: item.description,
                                    backgroundContent: item.backgroundContent,
                                    buttonText: item.buttonText,
                                    buttonLink: item.buttonLink,
                                    tileClickable: item.tileClickable
                                })
                            }, index);
                        })
                    })
                }),
                (optionButton === null || optionButton === void 0 ? void 0 : optionButton.buttonText) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (b2b_carousel_lifecycle_module_default()).button,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                        buttonText: (optionButton === null || optionButton === void 0 ? void 0 : optionButton.buttonText) || "Learn more",
                        link: (optionButton === null || optionButton === void 0 ? void 0 : optionButton.buttonLink) || "",
                        color: optionButton === null || optionButton === void 0 ? void 0 : optionButton.buttonColor,
                        target: "_blank"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var b2b_carousel_lifecycle = (B2BCarouselLifecycle);

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-carousel-lifecycle/b2b-carousel-lifecycle.builder-component.ts


const B2BCarouselLifecycleBuilderConfig = {
    name: "B2B Carousel Lifecycle",
    inputs: [
        {
            name: "title",
            type: "html"
        },
        {
            name: "subTitle",
            type: "string"
        },
        {
            name: "autoplay",
            type: "boolean"
        },
        {
            name: "optionButton",
            type: "object",
            subFields: [
                {
                    name: "buttonText",
                    type: "string"
                },
                {
                    name: "buttonLink",
                    type: "string"
                },
                {
                    name: "buttonColor",
                    type: "string",
                    enum: Object.values(business_button_constants/* COLORS */.DM),
                    defaultValue: business_button_constants/* COLORS.MINT */.DM.MINT
                }
            ]
        },
        {
            name: "backgroundColor",
            type: "color"
        },
        {
            name: "colorText",
            type: "color"
        },
        {
            name: "items",
            type: "list",
            subFields: [
                {
                    name: "image",
                    type: "file"
                },
                {
                    name: "title",
                    type: "html"
                },
                {
                    name: "description",
                    type: "html"
                },
                {
                    name: "backgroundContent",
                    type: "color"
                },
                {
                    name: "buttonText",
                    type: "string"
                },
                {
                    name: "buttonLink",
                    type: "string"
                },
                {
                    name: "tileClickable",
                    type: "boolean"
                }
            ]
        }
    ]
};
const b2b_carousel_lifecycle_builder_component_builderConfig = {
    component: b2b_carousel_lifecycle,
    config: B2BCarouselLifecycleBuilderConfig
};
/* harmony default export */ var b2b_carousel_lifecycle_builder_component = (b2b_carousel_lifecycle_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/icons/index.tsx + 91 modules
var icons = __webpack_require__(66714);
// EXTERNAL MODULE: ./hook/useWindowSize.ts
var useWindowSize = __webpack_require__(77442);
// EXTERNAL MODULE: ./components/lazy-background-image/lazy-background-image.tsx
var lazy_background_image = __webpack_require__(40204);
// EXTERNAL MODULE: ./components/image-zoom/image-zoom.module.scss
var image_zoom_module = __webpack_require__(8278);
var image_zoom_module_default = /*#__PURE__*/__webpack_require__.n(image_zoom_module);
;// CONCATENATED MODULE: ./components/image-zoom/image-zoom.tsx





const ImageZoom = (param)=>{
    let { src , ratio =[] , className ="" , children  } = param;
    const [ratioWidth, ratioHeight] = ratio;
    let imageBoxStyle = {};
    if (ratioWidth && ratioHeight) {
        const boxPaddingTop = ratioHeight / ratioWidth * 100;
        imageBoxStyle = {
            paddingTop: "".concat(boxPaddingTop, "%")
        };
    }
    const classNameImageZoom = classnames_default()(className, {
        "image-zoom": true
    });
    const classNameImageMain = classnames_default()((image_zoom_module_default())["image-main"], {
        "image-hover-zoom": true
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (image_zoom_module_default())["c-background-zoom"] + " " + "".concat(classNameImageZoom),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (image_zoom_module_default())["image-box"],
            style: imageBoxStyle,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_background_image/* LazyBackgroundImage */.I, {
                imageUrl: src,
                className: classNameImageMain,
                imageWidth: ratio[0] * 2,
                children: children
            })
        })
    });
};
/* harmony default export */ var image_zoom = (ImageZoom);

// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-community-card/b2b-community-card.module.scss
var b2b_community_card_module = __webpack_require__(23224);
var b2b_community_card_module_default = /*#__PURE__*/__webpack_require__.n(b2b_community_card_module);
// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-categories/b2b-categories.tsx
var b2b_categories = __webpack_require__(90997);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-community-card/b2b-community-card.tsx










const B2BCommunityCard = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const { article  } = props;
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const windowWidth = (windowSize === null || windowSize === void 0 ? void 0 : windowSize.width) || 0;
    const isMobile = windowWidth && windowWidth <= 768 ? true : false;
    const ratioImage = isMobile ? [
        345,
        410
    ] : [
        834,
        700
    ];
    if (!article) {
        return null;
    }
    const articleUrl = (0,LangHelper/* localifyLink */.Bj)("/".concat(locale).concat(article.articleUrl), locale);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (b2b_community_card_module_default()).communityCard,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_community_card_module_default()).communityCardWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_zoom, {
                    src: article.leadImage || "",
                    ratio: ratioImage
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (b2b_community_card_module_default()).infoArticle,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(b2b_categories/* default */.Z, {
                        categories: article.categories,
                        type: "SMALL",
                        color: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (b2b_community_card_module_default()).articleTitle,
                        children: article.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (b2b_community_card_module_default()).articleDescription,
                        children: article.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (b2b_community_card_module_default()).readMoreBtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                            icon: icons/* IconType.ArrowRightMedium3 */.T.ArrowRightMedium3,
                            buttonText: "Read more",
                            link: articleUrl,
                            color: "white",
                            position: business_button_constants/* POSITION.LEFT */.Vr.LEFT
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_community_card_module_default()).overlay
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: articleUrl,
                className: (b2b_community_card_module_default()).articleUrl
            })
        ]
    });
};
/* harmony default export */ var b2b_community_card = (B2BCommunityCard);

// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-category-feature/b2b-category-feature.module.scss
var b2b_category_feature_module = __webpack_require__(51744);
var b2b_category_feature_module_default = /*#__PURE__*/__webpack_require__.n(b2b_category_feature_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-category-feature/b2b-category-feature.tsx








const B2BCategoryFeature = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    var _categoryArticles;
    const [featuredArticles, setFeaturedArticles] = (0,react.useState)((_categoryArticles = props.categoryArticles) !== null && _categoryArticles !== void 0 ? _categoryArticles : []);
    const [articleSelected, setArticleSelected] = (0,react.useState)(featuredArticles[0]);
    const [category, setCategory] = (0,react.useState)();
    const linkReadAll = (0,LangHelper/* localifyLink */.Bj)("/".concat(locale) + (category === null || category === void 0 ? void 0 : category.categoryUrl), locale);
    const categoryName = category === null || category === void 0 ? void 0 : category.name;
    (0,react.useEffect)(()=>{
        let cancelled = false;
        if (typeof props.category === "string") {
            (0,BuilderHelper/* getCategoryFromID */.s$)(props.category).then((foundCategory)=>{
                if (!cancelled && foundCategory) {
                    setCategory(foundCategory);
                }
            });
        } else {
            setCategory(props.category);
        }
        return ()=>{
            cancelled = true;
        };
    }, []);
    (0,react.useEffect)(()=>{
        let cancelled = false;
        if (category && !props.categoryArticles) {
            (0,BuilderHelper/* getArticlesByCategory */.Zd)({
                locale,
                limit: 3,
                categoryIds: [
                    category === null || category === void 0 ? void 0 : category.id
                ]
            }).then((articles)=>{
                if (!cancelled) {
                    setFeaturedArticles(articles);
                }
            });
        }
        return ()=>{
            cancelled = true;
        };
    }, [
        category
    ]);
    (0,react.useEffect)(()=>{
        if (!articleSelected) {
            setArticleSelected(featuredArticles[0]);
        }
    }, [
        featuredArticles
    ]);
    if (!featuredArticles || featuredArticles.length === 0) {
        return null;
    }
    const renderArticleItem = (article)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (b2b_category_feature_module_default()).articleItem,
            onMouseEnter: ()=>setArticleSelected(article),
            onClick: ()=>setArticleSelected(article),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(b2b_categories/* default */.Z, {
                    categories: article.categories,
                    type: "SMALL",
                    color: "black"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (b2b_category_feature_module_default()).articleContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (b2b_category_feature_module_default()).articleTitle,
                            children: article.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "32",
                            height: "27",
                            viewBox: "0 0 32 27",
                            fill: "none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M30.1103 9.99056C30.9634 10.8931 31.4008 12.0965 31.4008 13.2768C31.4008 14.4571 30.9634 15.6605 30.1103 16.563L20.7262 26.4912L17.6418 23.2281L24.8604 15.5911L0.798828 15.5911L0.798828 10.9625L24.8385 10.9625L17.6418 3.32544L20.7262 0.0622351L30.1103 9.99056Z",
                                fill: "black"
                            })
                        })
                    ]
                })
            ]
        }, "article_feature_".concat(article.articleUrl));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (b2b_category_feature_module_default()).wrapperCategoryFeature,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (b2b_category_feature_module_default()).categoryHeader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (b2b_category_feature_module_default()).headerText,
                        children: categoryName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (b2b_category_feature_module_default()).articleCardButtonReadAll,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (b2b_category_feature_module_default()).businessButtonText,
                                children: "Read all"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: icons/* IconType.ArrowRightMedium4 */.T.ArrowRightMedium4
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: linkReadAll,
                                className: (b2b_category_feature_module_default()).linkReadAllArticle
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (b2b_category_feature_module_default()).categoryFeature,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (b2b_category_feature_module_default()).categoryFeatureContainer,
                        children: featuredArticles === null || featuredArticles === void 0 ? void 0 : featuredArticles.map((article)=>renderArticleItem(article))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (b2b_category_feature_module_default()).articlesFeature,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(b2b_community_card, {
                            article: articleSelected
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var b2b_category_feature = (B2BCategoryFeature);

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-category-feature/b2b-category-feature.builder-component.ts

const B2BCategoryFeatureBuilderConfig = {
    name: "B2B Category Feature",
    inputs: [
        {
            name: "category",
            type: "text"
        }
    ]
};
const b2b_category_feature_builder_component_builderConfig = {
    component: b2b_category_feature,
    config: B2BCategoryFeatureBuilderConfig
};
/* harmony default export */ var b2b_category_feature_builder_component = (b2b_category_feature_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-collapse/b2b-collapse.tsx
var b2b_collapse = __webpack_require__(12812);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-collapse/b2b-collapse.builder-component.ts

const B2BCollapseTextBuilderConfig = {
    name: "B2B Collapse",
    image: "https://cdn.builder.io/api/v1/image/assets%2F035a3d41874344d79b6c7499e2e7a5bc%2F3810bcb3ce57490b8f66ce0b394f54a2",
    screenshot: "https://cdn.builder.io/api/v1/image/assets%2F035a3d41874344d79b6c7499e2e7a5bc%2F8bfa3504d5c84d9eaf5dfa7950c7e768",
    canHaveChildren: true,
    inputs: [
        {
            name: "item",
            type: "object",
            copyOnAdd: false,
            subFields: [
                {
                    name: "title",
                    type: "richText"
                },
                {
                    name: "content",
                    type: "uiBlocks",
                    defaultValue: []
                }
            ],
            defaultValue: {
                name: "Collapse 1",
                content: []
            }
        }
    ]
};
const b2b_collapse_builder_component_builderConfig = {
    component: b2b_collapse/* default */.Z,
    config: B2BCollapseTextBuilderConfig
};
/* harmony default export */ var b2b_collapse_builder_component = (b2b_collapse_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-faq/b2b-faq.module.scss
var b2b_faq_module = __webpack_require__(94215);
var b2b_faq_module_default = /*#__PURE__*/__webpack_require__.n(b2b_faq_module);
// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-faq/faq-item/faq-item.module.scss
var faq_item_module = __webpack_require__(81794);
var faq_item_module_default = /*#__PURE__*/__webpack_require__.n(faq_item_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-faq/faq-item/faq-item.tsx



const FAQItem = (props)=>{
    const { question , answer , isOpen , zIndex , onQuestionClick  } = props;
    const handleFQA = ()=>{
        if (onQuestionClick) {
            onQuestionClick(question || "");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((faq_item_module_default()).container, {
            [(faq_item_module_default()).containerExpanded]: isOpen
        }),
        style: {
            zIndex
        },
        onClick: handleFQA,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((faq_item_module_default()).divider, " ").concat(isOpen ? (faq_item_module_default()).hidden : "")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (faq_item_module_default()).wrapperQuestion,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (faq_item_module_default()).question,
                        dangerouslySetInnerHTML: {
                            __html: question || ""
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((faq_item_module_default()).icon, " ").concat(isOpen ? (faq_item_module_default()).opened : (faq_item_module_default()).closed),
                        onClick: handleFQA,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (faq_item_module_default()).horizontal
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (faq_item_module_default()).vertical
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((faq_item_module_default()).wrapperAnswer, " ").concat(isOpen ? (faq_item_module_default()).showAnswer : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (faq_item_module_default()).answer,
                    dangerouslySetInnerHTML: {
                        __html: answer || ""
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var faq_item = (FAQItem);

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-faq/b2b-faq.tsx




const BusinessHubFAQ = (props)=>{
    const { title , description , items  } = props;
    const [currentOpenQuestion, setCurrentOpenQuestion] = (0,react.useState)(null);
    const [showAll, setShowAll] = (0,react.useState)(false);
    const handleViewMore = ()=>{
        setShowAll(true);
    };
    const handleQuestionClick = (question)=>{
        if (question === currentOpenQuestion) {
            setCurrentOpenQuestion(null);
        } else {
            setCurrentOpenQuestion(question);
        }
    };
    const displayedItems = showAll ? items : items === null || items === void 0 ? void 0 : items.slice(0, 3);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (b2b_faq_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (b2b_faq_module_default()).content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (b2b_faq_module_default()).title,
                    dangerouslySetInnerHTML: {
                        __html: title || ""
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (b2b_faq_module_default()).description,
                    dangerouslySetInnerHTML: {
                        __html: description || ""
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (b2b_faq_module_default()).wrapperFAQ,
                    children: [
                        displayedItems === null || displayedItems === void 0 ? void 0 : displayedItems.map((item, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(faq_item, {
                                question: item.question,
                                answer: item.answer,
                                isOpen: item.question === currentOpenQuestion,
                                onQuestionClick: handleQuestionClick,
                                zIndex: displayedItems.length - index
                            }, index);
                        }),
                        !showAll && items && items.length > 3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (b2b_faq_module_default()).btnViewMore,
                            onClick: handleViewMore,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (b2b_faq_module_default()).text,
                                    children: "View more"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (b2b_faq_module_default()).iconArrow,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "13",
                                        height: "12",
                                        viewBox: "0 0 13 12",
                                        fill: "none",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M1 3.5L6.5 9.5L12 3.5",
                                            stroke: "black",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var b2b_faq = (BusinessHubFAQ);

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-faq/b2b-faq.builder-component.ts

const B2BFAQBuilderConfig = {
    name: "B2B FAQ",
    inputs: [
        {
            name: "title",
            type: "html",
            defaultValue: ""
        },
        {
            name: "description",
            type: "html",
            defaultValue: ""
        },
        {
            name: "items",
            type: "list",
            subFields: [
                {
                    name: "question",
                    type: "html"
                },
                {
                    name: "answer",
                    type: "html"
                }
            ]
        }
    ]
};
const b2b_faq_builder_component_builderConfig = {
    component: b2b_faq,
    config: B2BFAQBuilderConfig
};
/* harmony default export */ var b2b_faq_builder_component = (b2b_faq_builder_component_builderConfig);

;// CONCATENATED MODULE: ./helpers/ColourMap.ts
const DEFAULT_BACKGROUND_COLORS = {
    MINT: "mint",
    PLUM: "plum",
    ORCA: "orca",
    ORCA_PASTEL: "orcaPastel",
    BLACK: "black",
    WHITE: "white"
};
const mapNameToColour = (color)=>{
    switch(color){
        case "mint":
            return "#B2FCE4";
        case "plum":
            return "#EADDF2";
        case "orca":
            return "#3375C9";
        case "orcaPastel":
            return "#EFF4FB";
        case "black":
            return "#000000";
        case "white":
            return "#FFFFFF";
    }
};
const hexToRgb = (hex)=>{
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
};
const rgbToHex = (r, g, b)=>{
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
};
const isWhite = (color)=>{
    if (!color) return false;
    return !!color.match(/^(?:white|#fff(?:fff)?|rgba?\(\s*255\s*,\s*255\s*,\s*255\s*(?:,\s*1\s*)?\))$/i);
};

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-framed-info-block/b2b-framed-info-block.constants.ts
const IMAGE_POSITIONS = {
    LEFT: "left",
    RIGHT: "right"
};

// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-framed-info-block/b2b-framed-info-block.module.scss
var b2b_framed_info_block_module = __webpack_require__(90958);
var b2b_framed_info_block_module_default = /*#__PURE__*/__webpack_require__.n(b2b_framed_info_block_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-framed-info-block/b2b-framed-info-block.tsx







const FramedInfoBlock = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const { borderColor =DEFAULT_BACKGROUND_COLORS.MINT , image , title , description , mediaPosition ="left" , ctaText , ctaIcon  } = props;
    var _url;
    let url = (0,LangHelper/* replaceOrAddLocale */.yM)((_url = props.url) !== null && _url !== void 0 ? _url : "", locale);
    const mediaBlock = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((b2b_framed_info_block_module_default()).businessResourceBlockMediaContainer, " ").concat((b2b_framed_info_block_module_default())[mediaPosition]),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_framed_info_block_module_default()).businessResourceBlockMedia,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((b2b_framed_info_block_module_default()).mediaImageWrapper, " ").concat((b2b_framed_info_block_module_default())[mediaPosition]),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (b2b_framed_info_block_module_default()).mediaImageBox,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (b2b_framed_info_block_module_default()).mediaImageMain,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_zoom, {
                                src: image
                            })
                        })
                    })
                })
            })
        });
    const infoBlock = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((b2b_framed_info_block_module_default()).businessResourceBlockInfo, " ").concat((b2b_framed_info_block_module_default())[mediaPosition]),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (b2b_framed_info_block_module_default()).infoTitle,
                    dangerouslySetInnerHTML: {
                        __html: title
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (b2b_framed_info_block_module_default()).infoDescription,
                    dangerouslySetInnerHTML: {
                        __html: description
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: url,
                    className: (b2b_framed_info_block_module_default()).infoCTA,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: ctaText !== null && ctaText !== void 0 ? ctaText : "Download"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "15",
                            height: "13",
                            viewBox: "0 0 15 13",
                            fill: "none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M13.7686 5.1286C14.1684 5.55168 14.3735 6.11577 14.3735 6.66902C14.3735 7.22228 14.1684 7.78637 13.7686 8.20944L9.36975 12.8633L7.92397 11.3337L11.3077 7.75384L0.0288087 7.75384L0.0288087 5.58421L11.2974 5.58421L7.92397 2.00433L9.36975 0.474699L13.7686 5.1286Z",
                                fill: "white"
                            })
                        })
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (b2b_framed_info_block_module_default()).businessResourceBlockContainer,
        children: [
            mediaPosition === IMAGE_POSITIONS.LEFT ? mediaBlock() : null,
            infoBlock(),
            mediaPosition === IMAGE_POSITIONS.RIGHT ? mediaBlock() : null
        ]
    });
};
/* harmony default export */ var b2b_framed_info_block = (FramedInfoBlock);

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-framed-info-block/b2b-framed-info-block.builder-component.ts




const B2BFramedInfoBlockBuilderConfig = {
    name: "B2B Framed Info Block",
    inputs: [
        {
            name: "borderColor",
            type: "string",
            enum: Object.values(DEFAULT_BACKGROUND_COLORS),
            defaultValue: DEFAULT_BACKGROUND_COLORS.MINT
        },
        {
            name: "image",
            type: "file",
            required: true
        },
        {
            name: "title",
            type: "string",
            defaultValue: ""
        },
        {
            name: "description",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "url",
            type: "url"
        },
        {
            name: "ctaText",
            type: "string",
            defaultValue: ""
        },
        {
            name: "ctaIcon",
            type: "string",
            enum: [
                icons/* IconType.Download */.T.Download,
                icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
            ]
        },
        {
            name: "mediaPosition",
            type: "string",
            enum: Object.values(IMAGE_POSITIONS),
            defaultValue: IMAGE_POSITIONS.LEFT
        }
    ]
};
const b2b_framed_info_block_builder_component_builderConfig = {
    component: b2b_framed_info_block,
    config: B2BFramedInfoBlockBuilderConfig
};
/* harmony default export */ var b2b_framed_info_block_builder_component = (b2b_framed_info_block_builder_component_builderConfig);

// EXTERNAL MODULE: ./node_modules/gsap/dist/ScrollTrigger.js
var ScrollTrigger = __webpack_require__(46285);
// EXTERNAL MODULE: ./node_modules/gsap/dist/TextPlugin.js
var TextPlugin = __webpack_require__(30050);
var TextPlugin_default = /*#__PURE__*/__webpack_require__.n(TextPlugin);
// EXTERNAL MODULE: ./node_modules/gsap/dist/gsap.js
var gsap = __webpack_require__(27924);
// EXTERNAL MODULE: ./node_modules/@gsap/react/src/index.js
var src = __webpack_require__(14172);
// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-good-for-v2/b2b-good-for.module.scss
var b2b_good_for_module = __webpack_require__(76800);
var b2b_good_for_module_default = /*#__PURE__*/__webpack_require__.n(b2b_good_for_module);
// EXTERNAL MODULE: ./components/splitchar/splitchar.tsx
var splitchar = __webpack_require__(3128);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-good-for-v2/b2b-good-for.tsx












gsap.gsap.registerPlugin(src/* useGSAP */.V);
gsap.gsap.registerPlugin(ScrollTrigger.ScrollTrigger);
gsap.gsap.registerPlugin((TextPlugin_default()));
const B2BGoodFor = (props)=>{
    const { backgroundColor ="#E7EAED" , textColor ="#000" , content =[]  } = props;
    const containerRef = (0,react.useRef)(null);
    (0,src/* useGSAP */.V)(()=>{
        const selector = gsap.gsap.utils.selector(containerRef.current);
        const sections = gsap.gsap.utils.toArray(selector(".".concat((b2b_good_for_module_default()).section)));
        let mm = gsap.gsap.matchMedia();
        mm.add({
            isMobile: "(max-width: 992px)",
            isDesktop: "(min-width: 993px)"
        }, (context)=>{
            var ref;
            var ref1;
            let isMobile = (ref1 = (ref = context.conditions) === null || ref === void 0 ? void 0 : ref.isMobile) !== null && ref1 !== void 0 ? ref1 : false;
            gsap.gsap.timeline({
                scrollTrigger: {
                    trigger: containerRef.current,
                    pinnedContainer: containerRef.current,
                    pin: true,
                    start: "center center",
                    end: "+=100%",
                    scrub: 1
                }
            });
            let masterTl = gsap.gsap.timeline({
                scrollTrigger: {
                    invalidateOnRefresh: true,
                    trigger: containerRef.current,
                    start: "top center+=40%",
                    end: "bottom top",
                    scrub: true
                }
            });
            gsap.gsap.set(sections, {
                autoAlpha: 0
            });
            for(let i = 0; i < sections.length; i++){
                const section = sections[i];
                const title = isMobile ? gsap.gsap.utils.toArray(gsap.gsap.utils.selector(section)(".".concat((b2b_good_for_module_default()).sectionTitle, ".").concat((b2b_good_for_module_default()).desktopHide)))[0] : gsap.gsap.utils.toArray(gsap.gsap.utils.selector(section)(".".concat((b2b_good_for_module_default()).sectionTitle, ".").concat((b2b_good_for_module_default()).mobileHide)))[0];
                const prvSection = sections[i - 1];
                if (prvSection) {
                    const prvTitle = isMobile ? gsap.gsap.utils.toArray(gsap.gsap.utils.selector(prvSection)(".".concat((b2b_good_for_module_default()).sectionTitle, ".").concat((b2b_good_for_module_default()).desktopHide)))[0] : gsap.gsap.utils.toArray(gsap.gsap.utils.selector(prvSection)(".".concat((b2b_good_for_module_default()).sectionTitle, ".").concat((b2b_good_for_module_default()).mobileHide)))[0];
                    const tlOut = animateSection(prvSection, prvTitle, "out");
                    masterTl.add(tlOut);
                }
                const tlIn = animateSection(section, title, "in", i === 0 ? "+=1" : "<");
                masterTl.to(section, {
                    xPercent: -100 * i,
                    x: 0
                }, "<");
                masterTl.add(tlIn, "-=0.5");
            }
        }, containerRef);
    }, {
        scope: containerRef,
        dependencies: [
            content
        ]
    });
    const animateSection = (section, title, animationType, position)=>{
        const sectionSelector = gsap.gsap.utils.selector(section);
        const illustrations = gsap.gsap.utils.toArray(sectionSelector(".".concat((b2b_good_for_module_default()).sectionImage)));
        const contentItems = gsap.gsap.utils.toArray(sectionSelector(".".concat((b2b_good_for_module_default()).sectionDescription, " span, a")));
        const titleSplits = gsap.gsap.utils.toArray(gsap.gsap.utils.selector(title)("span"));
        const tl = gsap.gsap.timeline({});
        if (animationType === "in") {
            tl.to(section, {
                autoAlpha: 1
            }, position);
            tl.fromTo(illustrations, {
                autoAlpha: 0
            }, {
                autoAlpha: 1,
                stagger: 0.25
            }, "<");
            tl.fromTo([
                titleSplits,
                contentItems
            ], {
                autoAlpha: 0
            }, {
                duration: 1,
                autoAlpha: 1,
                stagger: {
                    from: "start",
                    each: 0.01
                }
            }, ">-=0.5");
        } else {
            tl.to([
                titleSplits,
                contentItems
            ], {
                duration: 0.5,
                autoAlpha: 0,
                stagger: {
                    from: "start",
                    each: 0.005
                }
            }, "+=1");
        }
        return tl;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: containerRef,
        className: (b2b_good_for_module_default()).container,
        style: {
            color: textColor,
            "--bg-color": backgroundColor
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_good_for_module_default()).background
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_good_for_module_default()).content,
                children: content.map((section)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: (b2b_good_for_module_default()).section,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((b2b_good_for_module_default()).sectionTitle, (b2b_good_for_module_default()).mobileHide),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(splitchar/* SplitChar */.k, {
                                        text: "Good for your\xa0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(splitchar/* SplitChar */.k, {
                                        text: section.title,
                                        className: (b2b_good_for_module_default()).colorMint
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (b2b_good_for_module_default()).sectionContent,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (b2b_good_for_module_default()).sectionImage,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                    media: "(min-width: 640.1px)",
                                                    srcSet: section.image
                                                }),
                                                section.imageMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                    media: "(max-width: 640px)",
                                                    srcSet: section.imageMobile
                                                }) : null,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: section.image || "",
                                                    alt: "",
                                                    style: {
                                                        objectFit: "cover",
                                                        objectPosition: "center"
                                                    },
                                                    sizes: "(max-width: 638px) 98vw, (max-width: 998px) 43vw, 46vw",
                                                    fill: true,
                                                    loading: "eager",
                                                    loader: (param)=>{
                                                        let { src , width , quality  } = param;
                                                        return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                                                    }
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classnames_default()((b2b_good_for_module_default()).sectionTitle, (b2b_good_for_module_default()).desktopHide),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(splitchar/* SplitChar */.k, {
                                                text: "Good for your "
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(splitchar/* SplitChar */.k, {
                                                    text: section.title
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (b2b_good_for_module_default()).sectionDescription,
                                        children: [
                                            section.item.map((param, index)=>{
                                                let { content  } = param;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(splitchar/* SplitChar */.k, {
                                                    text: content,
                                                    className: (b2b_good_for_module_default()).item
                                                }, "".concat(index));
                                            }),
                                            section.buttonLink && section.buttonText ? /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                                                className: (b2b_good_for_module_default()).sectionButton,
                                                link: section.buttonLink,
                                                buttonText: section.buttonText,
                                                autoMargin: false,
                                                color: business_button_constants/* COLORS.BLACK */.DM.BLACK
                                            }) : null
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, section.title);
                })
            })
        ]
    });
};
/* harmony default export */ var b2b_good_for = (B2BGoodFor);

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-good-for-v2/b2b-good-for.builder-component.ts

const B2BGoodForBuilderConfig = {
    name: "B2B Good For V2",
    inputs: [
        {
            name: "backgroundColor",
            type: "color"
        },
        {
            name: "textColor",
            type: "color"
        },
        {
            name: "content",
            type: "list",
            subFields: [
                {
                    name: "image",
                    type: "file"
                },
                {
                    name: "imageMobile",
                    type: "file"
                },
                {
                    name: "title",
                    type: "text"
                },
                {
                    name: "buttonText",
                    type: "text"
                },
                {
                    name: "buttonLink",
                    type: "url"
                },
                {
                    name: "item",
                    type: "list",
                    subFields: [
                        {
                            name: "content",
                            type: "string"
                        }
                    ]
                }
            ]
        }
    ]
};
const b2b_good_for_builder_component_builderConfig = {
    component: b2b_good_for,
    config: B2BGoodForBuilderConfig
};
/* harmony default export */ var b2b_good_for_builder_component = (b2b_good_for_builder_component_builderConfig);

// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(97650);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.mjs
var swiper = __webpack_require__(78592);
// EXTERNAL MODULE: ./components/article-card/article-card.tsx
var article_card = __webpack_require__(12790);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-headlining-articles-block/b2b-headlining-articles-block.constants.ts
const TYPES_OF_CARD = {
    ARTICLE: "article",
    LEARNING: "learning"
};

// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-headlining-articles-block/b2b-headlining-articles-block.module.scss
var b2b_headlining_articles_block_module = __webpack_require__(30770);
var b2b_headlining_articles_block_module_default = /*#__PURE__*/__webpack_require__.n(b2b_headlining_articles_block_module);
// EXTERNAL MODULE: ./node_modules/swiper/modules/index.mjs + 27 modules
var modules = __webpack_require__(94135);
// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-learning-card/b2b-learning-card.module.scss
var b2b_learning_card_module = __webpack_require__(79042);
var b2b_learning_card_module_default = /*#__PURE__*/__webpack_require__.n(b2b_learning_card_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(76899);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-learning-card/b2b-learning-card.tsx








const B2BLearningCard = (props)=>{
    const { learningSeries  } = props;
    const [quantityArticle, setQuantityArticle] = (0,react.useState)(null);
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const category = learningSeries.category;
    (0,react.useEffect)(()=>{
        let cancelled = false;
        if (!learningSeries) return;
        if (learningSeries.articleCount) {
            setQuantityArticle(learningSeries.articleCount);
        } else {
            (0,BuilderHelper/* getAllArticles */.zC)(locale, {
                categoryIds: [
                    category.id
                ],
                limit: 30
            }).then((article)=>{
                if (!cancelled) {
                    setQuantityArticle(article.length);
                }
            });
        }
        return ()=>{
            cancelled = true;
        };
    }, [
        learningSeries
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (b2b_learning_card_module_default()).learningCard,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_learning_card_module_default()).imageCard,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_zoom, {
                    src: (category === null || category === void 0 ? void 0 : category.image) || "",
                    ratio: [
                        406,
                        188
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (b2b_learning_card_module_default()).learningCardContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (b2b_learning_card_module_default()).quantity,
                        children: [
                            quantityArticle,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: quantityArticle && quantityArticle > 1 ? " ARTICLES" : " ARTICLE"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "".concat((b2b_learning_card_module_default()).title, " ").concat((b2b_learning_card_module_default()).threeLinesLimit),
                        children: category.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "".concat((b2b_learning_card_module_default()).description, " ").concat((b2b_learning_card_module_default()).threeLinesLimit),
                        children: category.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (b2b_learning_card_module_default()).btnReadAll,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Read all"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: icons/* IconType.ArrowRightMedium4 */.T.ArrowRightMedium4
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                className: (b2b_learning_card_module_default()).learningUrl,
                href: (0,LangHelper/* replaceOrAddLocale */.yM)(category.categoryUrl || "", locale),
                rel: "noreferrer"
            })
        ]
    });
};
/* harmony default export */ var b2b_learning_card = (B2BLearningCard);

// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-article-card/b2b-article-card.tsx
var b2b_article_card = __webpack_require__(1395);
// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-sign-up-card/b2b-sign-up-card.tsx
var b2b_sign_up_card = __webpack_require__(60054);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-headlining-articles-block/b2b-headlining-articles-block.tsx















swiper/* default.use */.Z.use([
    modules/* Navigation */.W_
]);
const B2BHeadliningArticlesBlock = (props)=>{
    const { cardData , showSignupCard =true , typeOfCard =TYPES_OF_CARD.ARTICLE , includeLargeCard  } = props;
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const windowWidth = windowSize.width || 0;
    const isMobile = windowWidth <= 992 ? true : false;
    const prevRef = (0,react.useRef)(null);
    const nextRef = (0,react.useRef)(null);
    const navigationConfig = {
        prevEl: prevRef.current ? prevRef.current : undefined,
        nextEl: nextRef.current ? nextRef.current : undefined
    };
    // Because layout breaks if you try to populate the DOM before slider is initalised, we debounce it with state, Only set data after swiper is initialised
    const [swiperCardList, setSwiperCardList] = (0,react.useState)(props.debounce ? [] : cardData);
    const { ref , inView  } = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true
    });
    const [swiper, setSwiper] = (0,react.useState)(null);
    const swiperOption = {
        navigation: navigationConfig,
        slidesPerView: "auto",
        spaceBetween: isMobile ? 40 : 20,
        centeredSlides: isMobile,
        centeredSlidesBounds: true,
        watchOverflow: true,
        lazyPreloadPrevNext: 1,
        updateOnWindowResize: true,
        init: false
    };
    (0,react.useEffect)(()=>{
        if (swiper && inView) {
            swiper.init();
            setSwiperCardList(cardData);
        }
    }, [
        swiper,
        inView,
        cardData
    ]);
    const cardTemplate = [
        article_card/* ArticleCardType.Large */._.Large,
        article_card/* ArticleCardType.Small */._.Small,
        article_card/* ArticleCardType.Small */._.Small
    ];
    const getCard = (item, cardSize)=>{
        switch(typeOfCard){
            case TYPES_OF_CARD.ARTICLE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(b2b_article_card/* default */.Z, {
                    cardBackgroundColor: props.cardBackgroundColor,
                    type: cardSize || article_card/* ArticleCardType.Small */._.Small,
                    article: item,
                    fixedWidth: true
                });
            case TYPES_OF_CARD.LEARNING:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(b2b_learning_card, {
                    learningSeries: item
                });
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(b2b_article_card/* default */.Z, {
                    cardBackgroundColor: props.cardBackgroundColor,
                    type: cardSize || article_card/* ArticleCardType.Small */._.Small,
                    article: item,
                    fixedWidth: true
                });
        }
    };
    const renderArticleItem = (item, index)=>{
        let cardSize = article_card/* ArticleCardType.Small */._.Small;
        if (includeLargeCard && !isMobile) {
            cardSize = cardTemplate[index % cardTemplate.length];
        }
        if (index === cardData.length - 1) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                className: classnames_default()((b2b_headlining_articles_block_module_default()).headliningArticlesBlockSlide, {
                    [(b2b_headlining_articles_block_module_default()).headliningArticlesBlockSlideLarge]: cardSize === article_card/* ArticleCardType.Large */._.Large
                }),
                children: showSignupCard ? /*#__PURE__*/ (0,jsx_runtime.jsx)(b2b_sign_up_card/* default */.Z, {}) : getCard(item, cardSize)
            }, "card_slide_key_".concat(index));
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
            className: classnames_default()((b2b_headlining_articles_block_module_default()).headliningArticlesBlockSlide, {
                [(b2b_headlining_articles_block_module_default()).headliningArticlesBlockSlideLarge]: cardSize === article_card/* ArticleCardType.Large */._.Large
            }),
            children: getCard(item, cardSize)
        }, "card_slide_key_".concat(index));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (b2b_headlining_articles_block_module_default()).headliningArticlesBlock,
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: nextRef,
                className: (b2b_headlining_articles_block_module_default()).swiperButtonNext,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                    type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: prevRef,
                className: (b2b_headlining_articles_block_module_default()).swiperButtonPrev,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                    type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                ...swiperOption,
                onInit: (swiper)=>{
                    if (!swiper) {
                        return;
                    }
                    const navigation = swiper === null || swiper === void 0 ? void 0 : swiper.params.navigation;
                    navigation.prevEl = prevRef.current;
                    navigation.nextEl = nextRef.current;
                    swiper.navigation.init();
                    swiper.navigation.update();
                },
                onSwiper: (sw)=>{
                    setSwiper(sw);
                },
                className: (b2b_headlining_articles_block_module_default()).headliningArticlesSlider,
                children: (swiperCardList || []).map((item, index)=>renderArticleItem(item, index))
            })
        ]
    });
};
/* harmony default export */ var b2b_headlining_articles_block = (B2BHeadliningArticlesBlock);

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-headlining-latest-articles/b2b-headlining-latest-articles.tsx





const B2BHeadliningLatestArticles = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const [featuredArticles, setFeaturedArticles] = (0,react.useState)(props.articles || []);
    // const [isFirstLoad, setIsFirstLoad] = useState(true);
    (0,react.useEffect)(()=>{
        let cancelled = false;
        const fetchArticles = async ()=>{
            try {
                var _offset;
                const articles = await (0,BuilderHelper/* getLatestArticles */.gg)({
                    locale,
                    offset: (_offset = props.offset) !== null && _offset !== void 0 ? _offset : 1,
                    limit: 3
                });
                if (Array.isArray(articles)) {
                    setFeaturedArticles([
                        ...articles
                    ]);
                } else {
                    console.error("Articles are not an array or fetch was cancelled");
                }
            } catch (error) {
                console.error("Error fetching articles:", error);
            }
        };
        fetchArticles();
        // if (isFirstLoad) {
        //     setIsFirstLoad(false);
        // }
        return ()=>{
            cancelled = true;
        };
    }, [
        locale,
        props.offset
    ]);
    (0,react.useEffect)(()=>{}, [
        featuredArticles
    ]);
    var _showSignupForAfterpay;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(b2b_headlining_articles_block, {
        cardData: featuredArticles,
        showSignupCard: (_showSignupForAfterpay = props.showSignupForAfterpay) !== null && _showSignupForAfterpay !== void 0 ? _showSignupForAfterpay : false
    });
};

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-headlining-latest-articles/b2b-headlining-latest-articles.builder-component.ts

const B2BHeadliningLatestArticlesBuilderConfig = {
    name: "B2B Headlining Latest Articles",
    inputs: [
        {
            name: "offset",
            type: "text",
            default: "1"
        },
        {
            name: "showSignupForAfterpay",
            type: "boolean",
            default: true
        }
    ]
};
const b2b_headlining_latest_articles_builder_component_builderConfig = {
    component: B2BHeadliningLatestArticles,
    config: B2BHeadliningLatestArticlesBuilderConfig
};
/* harmony default export */ var b2b_headlining_latest_articles_builder_component = (b2b_headlining_latest_articles_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-hero/b2b-hero.tsx
var b2b_hero = __webpack_require__(16779);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-hero/b2b-hero.builder-component.ts

const B2BHeroBuilderConfig = {
    name: "B2B Hero",
    inputs: [
        {
            name: "subTitle",
            type: "richText"
        },
        {
            name: "title",
            type: "richText"
        },
        {
            name: "useLargeTitle",
            type: "boolean"
        },
        {
            name: "description",
            type: "richText"
        },
        {
            name: "categories",
            type: "list",
            subFields: [
                {
                    name: "category",
                    type: "reference",
                    model: "category",
                    includeRefs: true
                }
            ]
        },
        {
            name: "fontSizeTitle",
            type: ""
        },
        {
            name: "titleMaxWidth",
            type: "number"
        },
        {
            name: "descriptionMaxWidth",
            type: "number"
        },
        {
            name: "backgroundImage",
            type: "object",
            subFields: [
                {
                    name: "desktop",
                    type: "file"
                },
                {
                    name: "mobile",
                    type: "file"
                }
            ]
        },
        {
            name: "background",
            type: "color"
        },
        {
            name: "textColor",
            type: "color"
        },
        {
            name: "button",
            type: "object",
            subFields: [
                {
                    name: "name",
                    type: "string"
                },
                {
                    name: "url",
                    type: "string"
                }
            ]
        }
    ]
};
const b2b_hero_builder_component_builderConfig = {
    component: b2b_hero/* default */.Z,
    config: B2BHeroBuilderConfig
};
/* harmony default export */ var b2b_hero_builder_component = (b2b_hero_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-integrations/b2b-integrations.module.scss
var b2b_integrations_module = __webpack_require__(449);
var b2b_integrations_module_default = /*#__PURE__*/__webpack_require__.n(b2b_integrations_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-integrations/b2b-integrations.tsx











gsap.gsap.registerPlugin(src/* useGSAP */.V);
gsap.gsap.registerPlugin(ScrollTrigger.ScrollTrigger);
gsap.gsap.registerPlugin((TextPlugin_default()));
const options = {
    slidesPerView: "auto",
    spaceBetween: 10,
    allowTouchMove: true,
    noSwiping: false,
    freeMode: false,
    loop: false,
    navigation: false,
    pagination: false,
    breakpoints: {
        992: {
            enabled: false
        }
    }
};
const B2BIntegrations = (props)=>{
    const { title , sections =[]  } = props;
    const [render, setRender] = (0,react.useState)(false);
    const containerRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        setTimeout(()=>{
            setRender(true);
        }, 1000);
    }, []);
    (0,src/* useGSAP */.V)(()=>{
        if (!render) return;
        const selector = gsap.gsap.utils.selector(containerRef.current);
        const sections = gsap.gsap.utils.toArray(selector(".".concat((b2b_integrations_module_default()).section)));
        let mm = gsap.gsap.matchMedia();
        mm.add("(min-width: 993px)", (context)=>{
            gsap.gsap.timeline({
                scrollTrigger: {
                    trigger: containerRef.current,
                    pinnedContainer: containerRef.current,
                    pin: true,
                    start: "center center",
                    end: "+=100%",
                    scrub: 1
                }
            });
            let masterTl = gsap.gsap.timeline({
                scrollTrigger: {
                    invalidateOnRefresh: true,
                    trigger: containerRef.current,
                    start: "top center+=40%",
                    end: "bottom top",
                    scrub: true
                }
            });
            gsap.gsap.set(sections, {
                autoAlpha: 0
            });
            for(let i = 0; i < sections.length; i++){
                const section = sections[i];
                const title = gsap.gsap.utils.toArray(gsap.gsap.utils.selector(section)(".".concat((b2b_integrations_module_default()).sectionTitle)))[0];
                const prvSection = sections[i - 1];
                if (prvSection) {
                    const prvTitle = gsap.gsap.utils.toArray(gsap.gsap.utils.selector(prvSection)(".".concat((b2b_integrations_module_default()).sectionTitle)))[0];
                    const tlOut = animateSection(prvSection, prvTitle, "out");
                    masterTl.add(tlOut);
                }
                const tlIn = animateSection(section, title, "in", i === 0 ? "+=1" : "<");
                masterTl.to(section, {
                    xPercent: -100 * i,
                    x: 0
                }, "<");
                masterTl.add(tlIn, "-=0.4");
            }
        });
    }, {
        scope: containerRef,
        dependencies: [
            sections,
            render
        ]
    });
    const animateSection = (section, title, animationType, position)=>{
        const sectionSelector = gsap.gsap.utils.selector(section);
        const contentItems = gsap.gsap.utils.toArray(sectionSelector(".".concat((b2b_integrations_module_default()).sectionRightContent, " .").concat((b2b_integrations_module_default()).logoTile)));
        const titleSplits = gsap.gsap.utils.toArray(gsap.gsap.utils.selector(title)("span"));
        const tl = gsap.gsap.timeline({});
        if (animationType === "in") {
            tl.to(section, {
                autoAlpha: 1
            }, position);
            tl.fromTo([
                titleSplits,
                contentItems
            ], {
                autoAlpha: 0
            }, {
                duration: 1,
                autoAlpha: 1,
                stagger: {
                    from: "start",
                    each: 0.02
                }
            }, ">-=0.5");
        } else {
            tl.to([
                titleSplits,
                contentItems
            ], {
                duration: 0.5,
                autoAlpha: 0,
                stagger: {
                    from: "start",
                    each: 0.005
                }
            }, "+=1");
        }
        return tl;
    };
    const _renderCarousel = (brands)=>{
        if (brands.length > 3) {
            let halfwayThrough = Math.floor(brands.length / 2);
            let arrayFirstHalf = brands.slice(0, halfwayThrough);
            let arraySecondHalf = brands.slice(halfwayThrough, brands.length);
            return arrayFirstHalf.map((brand, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (b2b_integrations_module_default()).logoGroup,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (b2b_integrations_module_default()).logoTile,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (b2b_integrations_module_default()).logo,
                                    style: {
                                        aspectRatio: "".concat((brand.width || 1) / (brand.height || 1)),
                                        maxWidth: brand.width,
                                        height: brand.height
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: brand.logo || "",
                                        alt: brand.name,
                                        style: {
                                            objectFit: "contain",
                                            objectPosition: "center"
                                        },
                                        sizes: "(max-width: 638px) 98vw, (max-width: 998px) 43vw, 46vw",
                                        fill: true,
                                        loading: "eager",
                                        loader: (param)=>{
                                            let { src , width , quality  } = param;
                                            return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                                        }
                                    })
                                })
                            }),
                            arraySecondHalf[index] ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (b2b_integrations_module_default()).logoTile,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (b2b_integrations_module_default()).logo,
                                    style: {
                                        aspectRatio: "".concat((arraySecondHalf[index].width || 1) / (arraySecondHalf[index].height || 1)),
                                        maxWidth: arraySecondHalf[index].width,
                                        height: arraySecondHalf[index].height
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: arraySecondHalf[index].logo || "",
                                        alt: arraySecondHalf[index].name,
                                        style: {
                                            objectFit: "contain",
                                            objectPosition: "center"
                                        },
                                        sizes: "(max-width: 638px) 98vw, (max-width: 998px) 43vw, 46vw",
                                        fill: true,
                                        loading: "eager",
                                        loader: (param)=>{
                                            let { src , width , quality  } = param;
                                            return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                                        }
                                    })
                                })
                            }) : null
                        ]
                    })
                }, brand.name));
        }
        return brands.map((brand)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (b2b_integrations_module_default()).logoTile,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (b2b_integrations_module_default()).logo,
                        style: {
                            aspectRatio: "".concat((brand.width || 1) / (brand.height || 1)),
                            maxWidth: brand.width,
                            height: brand.height
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: brand.logo || "",
                            alt: brand.name,
                            style: {
                                objectFit: "contain",
                                objectPosition: "center"
                            },
                            sizes: "(max-width: 638px) 98vw, (max-width: 998px) 43vw, 46vw",
                            fill: true,
                            loading: "eager",
                            loader: (param)=>{
                                let { src , width , quality  } = param;
                                return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                            }
                        })
                    })
                })
            }, brand.name));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: containerRef,
        className: (b2b_integrations_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (b2b_integrations_module_default()).content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(splitchar/* SplitChar */.k, {
                    text: title,
                    className: classnames_default()((b2b_integrations_module_default()).title, (b2b_integrations_module_default()).desktopHide)
                }),
                sections.map((section, index)=>{
                    const { title: sectionTitle = "" , brands =[]  } = section;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: (b2b_integrations_module_default()).section,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (b2b_integrations_module_default()).sectionLeft,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(splitchar/* SplitChar */.k, {
                                        text: title,
                                        className: classnames_default()((b2b_integrations_module_default()).title, (b2b_integrations_module_default()).mobileHide)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(splitchar/* SplitChar */.k, {
                                        text: sectionTitle,
                                        className: (b2b_integrations_module_default()).sectionTitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (b2b_integrations_module_default()).sectionRight,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (b2b_integrations_module_default()).sectionRightContent,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (b2b_integrations_module_default()).mobileHide,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (b2b_integrations_module_default()).sectionGrid,
                                                children: brands.map((brand)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (b2b_integrations_module_default()).logoTile,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (b2b_integrations_module_default()).logo,
                                                            style: {
                                                                aspectRatio: "".concat((brand.width || 1) / (brand.height || 1)),
                                                                maxWidth: brand.width,
                                                                height: brand.height
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: brand.logo || "",
                                                                alt: brand.name,
                                                                style: {
                                                                    objectFit: "contain",
                                                                    objectPosition: "center"
                                                                },
                                                                sizes: "(max-width: 638px) 98vw, (max-width: 998px) 43vw, 46vw",
                                                                fill: true,
                                                                loading: "eager",
                                                                loader: (param)=>{
                                                                    let { src , width , quality  } = param;
                                                                    return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                                                                }
                                                            })
                                                        })
                                                    }, brand.name))
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (b2b_integrations_module_default()).desktopHide,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                                ...options,
                                                children: _renderCarousel(brands)
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }, "".concat(sectionTitle, "_").concat(index));
                })
            ]
        })
    });
};
/* harmony default export */ var b2b_integrations = (B2BIntegrations);

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-integrations/b2b-integrations.builder-component.ts

const B2BIntegrationsBuilderConfig = {
    name: "B2B Integrations",
    inputs: [
        {
            name: "title",
            type: "string"
        },
        {
            name: "sections",
            type: "list",
            copyOnAdd: false,
            subFields: [
                {
                    name: "title",
                    type: "string"
                },
                {
                    name: "brands",
                    type: "list",
                    copyOnAdd: false,
                    subFields: [
                        {
                            name: "name",
                            type: "string"
                        },
                        {
                            name: "link",
                            type: "url"
                        },
                        {
                            name: "logo",
                            type: "file"
                        },
                        {
                            name: "width",
                            type: "number"
                        },
                        {
                            name: "height",
                            type: "number"
                        }
                    ]
                }
            ]
        }
    ]
};
const b2b_integrations_builder_component_builderConfig = {
    component: b2b_integrations,
    config: B2BIntegrationsBuilderConfig
};
/* harmony default export */ var b2b_integrations_builder_component = (b2b_integrations_builder_component_builderConfig);

// EXTERNAL MODULE: ./shared/env.ts
var env = __webpack_require__(69771);
;// CONCATENATED MODULE: ./helpers/CategoryHelper.ts

const GET_ALL_CATEGORY = "https://cdn.builder.io/api/v1/query/".concat(env/* BUILDER_API_KEY */.uT, "/category%3A3c5b3b30?omit=meta.componentsUsed&apiKey=").concat(env/* BUILDER_API_KEY */.uT, "&options.category:3c5b3b30.limit=30&options.category:3c5b3b30.query={%22data.isSeries%22:{%22$eq%22:true}}");

// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-learning-series-block/b2b-learning-series-block.module.scss
var b2b_learning_series_block_module = __webpack_require__(65008);
var b2b_learning_series_block_module_default = /*#__PURE__*/__webpack_require__.n(b2b_learning_series_block_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-learning-series-block/b2b-learning-series-block.tsx








const B2BLearningSeriesBlock = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const { titleSeries , descriptionSeries , viewAllText , backgroundColor ="" , category1 , category2 , category3 , viewAllUrl  } = props;
    var _seriesData;
    const [series, setSeries] = (0,react.useState)((_seriesData = props.seriesData) !== null && _seriesData !== void 0 ? _seriesData : []);
    const viewAllUrlLocale = (0,LangHelper/* localifyLink */.Bj)("/".concat(locale).concat(viewAllUrl), locale);
    (0,react.useEffect)(()=>{
        let cancelled = false;
        if (!category1 && !category2 && !category3) return;
        // Don't re-fetch the category data if it's already presented
        if (props.seriesData) return;
        const categories = [
            category1 || "",
            category2 || "",
            category3 || ""
        ].filter((category)=>!!category);
        if (categories && categories.length) {
            (0,BuilderHelper/* getCategoriesFromIDs */.nq)(categories).then((data)=>{
                if (!cancelled) {
                    setSeries(data.map((category)=>{
                        return {
                            category
                        };
                    }));
                }
            });
        }
        return ()=>{
            cancelled = true;
        };
    }, [
        category1,
        category2,
        category3,
        props.seriesData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (b2b_learning_series_block_module_default()).seriesCollectionBlock,
        children: [
            backgroundColor ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_learning_series_block_module_default())["seriesCollectionBlock".concat(backgroundColor.replace(" ", ""))]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (b2b_learning_series_block_module_default()).seriesHeader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (b2b_learning_series_block_module_default()).infoSeries,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (b2b_learning_series_block_module_default()).title,
                                children: titleSeries
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (b2b_learning_series_block_module_default()).description,
                                children: descriptionSeries
                            })
                        ]
                    }),
                    viewAllUrl ? /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                        href: viewAllUrlLocale,
                        className: (b2b_learning_series_block_module_default()).btnViewAll,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: viewAllText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(b2b_headlining_articles_block, {
                cardData: series,
                typeOfCard: "learning",
                showSignupCard: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_learning_series_block_module_default()).btnViewMobile,
                children: viewAllUrl ? /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                    href: viewAllUrlLocale,
                    className: (b2b_learning_series_block_module_default()).btnViewAllMobile,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: viewAllText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                        })
                    ]
                }) : null
            })
        ]
    });
};
/* harmony default export */ var b2b_learning_series_block = (B2BLearningSeriesBlock);

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-learning-series-block/b2b-learning-series-block.builder-component.ts


const B2BLearningSeriesBlockPropsBuilderConfig = {
    name: "B2B Learning series block",
    inputs: [
        {
            name: "titleSeries",
            type: "string"
        },
        {
            name: "descriptionSeries",
            type: "longText",
            defaultValue: ""
        },
        {
            name: "viewAllUrl",
            type: "url",
            defaultValue: ""
        },
        {
            name: "viewAllText",
            type: "string",
            defaultValue: ""
        },
        {
            name: "category1",
            type: "dynamic-dropdown",
            options: {
                url: GET_ALL_CATEGORY,
                mapper: "({data}) => {\n                  return ({\n                    category: Object.values(data)[0].reduce((rs, curr) => {\n                      return [...rs, { value: curr.id, name: curr.name }]\n                    }, [])\n                  })\n                }",
                expectMultipleDropdowns: false
            }
        },
        {
            name: "category2",
            type: "dynamic-dropdown",
            options: {
                url: GET_ALL_CATEGORY,
                mapper: "({data}) => {\n                  return ({\n                    category: Object.values(data)[0].reduce((rs, curr) => {\n                      return [...rs, { value: curr.id, name: curr.name }]\n                    }, [])\n                  })\n                }",
                expectMultipleDropdowns: false
            }
        },
        {
            name: "category3",
            type: "dynamic-dropdown",
            options: {
                url: GET_ALL_CATEGORY,
                mapper: "({data}) => {\n                  return ({\n                    category: Object.values(data)[0].reduce((rs, curr) => {\n                      return [...rs, { value: curr.id, name: curr.name }]\n                    }, [])\n                  })\n                }",
                expectMultipleDropdowns: false
            }
        },
        {
            name: "backgroundColor",
            type: "string",
            enum: [
                "Orca Pastel"
            ]
        }
    ]
};
const b2b_learning_series_block_builder_component_builderConfig = {
    component: b2b_learning_series_block,
    config: B2BLearningSeriesBlockPropsBuilderConfig
};
/* harmony default export */ var b2b_learning_series_block_builder_component = (b2b_learning_series_block_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-list-card-resources/b2b-list-card-resources.module.scss
var b2b_list_card_resources_module = __webpack_require__(98851);
var b2b_list_card_resources_module_default = /*#__PURE__*/__webpack_require__.n(b2b_list_card_resources_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-list-card-resources/b2b-list-card-resources.tsx




const BusinessHubListCardResources = (props)=>{
    const { card , backgroundCard , buttonBackground , showListNameCard , quantityColumnCard , buttonFullWidthMobile , buttonPadding , buttonTextSize , buttonPaddingMobile , paddingContentCartMobile , heightImageCardMobile , minHeightCardMobile , gapListCardMobile  } = props;
    const handleScrollTovView = (index)=>{
        const element = document.querySelectorAll(".".concat((b2b_list_card_resources_module_default()).card))[index];
        if (element) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (b2b_list_card_resources_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (b2b_list_card_resources_module_default()).wrapperContent,
            children: [
                showListNameCard && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (b2b_list_card_resources_module_default()).wrapperListNameCard,
                    children: card === null || card === void 0 ? void 0 : card.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (b2b_list_card_resources_module_default()).nameCard,
                            onClick: ()=>handleScrollTovView(index),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                dangerouslySetInnerHTML: {
                                    __html: item.title || ""
                                }
                            })
                        }, index))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (b2b_list_card_resources_module_default()).wrapperCard,
                    style: {
                        ...{
                            gridTemplateColumns: "repeat(".concat(quantityColumnCard, ", 1fr)")
                        },
                        ...gapListCardMobile ? {
                            "--gap-list-card-mobile": gapListCardMobile
                        } : {}
                    },
                    children: card === null || card === void 0 ? void 0 : card.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (b2b_list_card_resources_module_default()).card,
                            style: {
                                ...minHeightCardMobile ? {
                                    "--mint-height-cart-mobile": minHeightCardMobile
                                } : {}
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (b2b_list_card_resources_module_default()).cardImage,
                                    style: {
                                        ...heightImageCardMobile ? {
                                            "--height-image-cart-mobile": heightImageCardMobile
                                        } : {}
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: item.image,
                                        alt: item.title
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (b2b_list_card_resources_module_default()).cardContent,
                                    style: {
                                        ...{
                                            background: backgroundCard
                                        },
                                        ...paddingContentCartMobile ? {
                                            "--padding-content-cart-mobile": paddingContentCartMobile
                                        } : {}
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (b2b_list_card_resources_module_default()).content,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (b2b_list_card_resources_module_default()).title,
                                                    dangerouslySetInnerHTML: {
                                                        __html: item.title || ""
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (b2b_list_card_resources_module_default()).description,
                                                    style: item.fontSizeDescription ? {
                                                        fontSize: "".concat(item.fontSizeDescription, "px")
                                                    } : {},
                                                    dangerouslySetInnerHTML: {
                                                        __html: item.description || ""
                                                    }
                                                })
                                            ]
                                        }),
                                        item.link && item.buttonText ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (b2b_list_card_resources_module_default()).readMore,
                                            style: {
                                                ...buttonFullWidthMobile ? {
                                                    "--button-width": "100%"
                                                } : {},
                                                ...buttonPadding ? {
                                                    "--button-padding": buttonPadding
                                                } : {},
                                                ...buttonPaddingMobile ? {
                                                    "--button-padding-mobile": buttonPaddingMobile
                                                } : {}
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                                                link: item.link,
                                                buttonText: item.buttonText || "Read more",
                                                position: business_button_constants/* POSITION.LEFT */.Vr.LEFT,
                                                color: buttonBackground,
                                                autoMargin: false,
                                                icon: item.iconType ? item.iconType : undefined,
                                                size: buttonTextSize
                                            })
                                        }) : null
                                    ]
                                })
                            ]
                        }, index))
                })
            ]
        })
    });
};
/* harmony default export */ var b2b_list_card_resources = (BusinessHubListCardResources);

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-list-card-resources/b2b-list-card-resources.builder-component.ts


const B2BListCardResourcesConfig = {
    name: "B2b List Card Resources",
    inputs: [
        {
            name: "backgroundCard",
            type: "color",
            defaultValue: "#E7EAED"
        },
        {
            name: "showListNameCard",
            type: "boolean"
        },
        {
            name: "quantityColumnCard",
            type: "number",
            defaultValue: 3
        },
        {
            name: "card",
            type: "list",
            subFields: [
                {
                    name: "image",
                    type: "file",
                    defaultValue: ""
                },
                {
                    name: "title",
                    type: "html",
                    defaultValue: ""
                },
                {
                    name: "description",
                    type: "html",
                    defaultValue: ""
                },
                {
                    name: "fontSizeDescription",
                    type: "number"
                },
                {
                    name: "link",
                    type: "url",
                    defaultValue: ""
                },
                {
                    name: "buttonText",
                    type: "html"
                },
                {
                    name: "iconType",
                    type: "string",
                    enum: Object.values(business_button_constants/* ICONS */.UZ),
                    defaultValue: ""
                }
            ]
        },
        {
            name: "buttonTextSize",
            type: "string",
            enum: Object.values(business_button_constants/* SIZES */.zf),
            defaultValue: business_button_constants/* SIZES.NORMAL */.zf.NORMAL
        },
        {
            name: "buttonBackground",
            type: "string",
            enum: Object.values(business_button_constants/* COLORS */.DM),
            defaultValue: business_button_constants/* COLORS.MINT */.DM.MINT
        },
        {
            name: "buttonFullWidthMobile",
            type: "boolean"
        },
        {
            name: "buttonPadding",
            type: "string",
            default: "15px 30px"
        },
        {
            name: "buttonPaddingMobile",
            type: "string",
            default: ""
        },
        {
            name: "paddingContentCartMobile",
            type: "string",
            default: ""
        },
        {
            name: "heightImageCardMobile",
            type: "string",
            default: ""
        },
        {
            name: "minHeightCardMobile",
            type: "string",
            default: ""
        },
        {
            name: "gapListCardMobile",
            type: "string",
            default: ""
        }
    ]
};
const b2b_list_card_resources_builder_component_builderConfig = {
    component: b2b_list_card_resources,
    config: B2BListCardResourcesConfig
};
/* harmony default export */ var b2b_list_card_resources_builder_component = (b2b_list_card_resources_builder_component_builderConfig);

// EXTERNAL MODULE: ./node_modules/gsap/dist/ScrollToPlugin.js
var ScrollToPlugin = __webpack_require__(72455);
var ScrollToPlugin_default = /*#__PURE__*/__webpack_require__.n(ScrollToPlugin);
// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-online-payment/b2b-online-payment-step.module.scss
var b2b_online_payment_step_module = __webpack_require__(11301);
var b2b_online_payment_step_module_default = /*#__PURE__*/__webpack_require__.n(b2b_online_payment_step_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-online-payment/b2b-online-payment-step.tsx





const B2BOnlinePaymentStepBase = (props, ref)=>{
    const { name , description , icon , screenImage , illustration , illustrationRatio , className , contentClassName  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        ref: ref,
        className: classnames_default()((b2b_online_payment_step_module_default()).container, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((b2b_online_payment_step_module_default()).box, contentClassName),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (b2b_online_payment_step_module_default()).text,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (b2b_online_payment_step_module_default()).icon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (b2b_online_payment_step_module_default()).box,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: icon,
                                    alt: "",
                                    style: {
                                        objectFit: "contain",
                                        objectPosition: "center"
                                    },
                                    fill: true,
                                    loader: (param)=>{
                                        let { src , width , quality  } = param;
                                        return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75, "&format=webp");
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (b2b_online_payment_step_module_default()).title,
                            children: name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (b2b_online_payment_step_module_default()).description,
                            dangerouslySetInnerHTML: {
                                __html: description || ""
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (b2b_online_payment_step_module_default()).screenImage
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (b2b_online_payment_step_module_default()).illustration,
                    style: {
                        "--data-ratio": "".concat(illustrationRatio)
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: illustration,
                        alt: "",
                        style: {
                            objectFit: "cover",
                            objectPosition: "center"
                        },
                        fill: true,
                        loader: (param)=>{
                            let { src , width , quality  } = param;
                            return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75, "&format=webp");
                        }
                    })
                })
            ]
        })
    });
};
const B2BOnlinePaymentStep = /*#__PURE__*/ (0,react.forwardRef)(B2BOnlinePaymentStepBase);
B2BOnlinePaymentStep.displayName = "B2BOnlinePaymentStep";


// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-online-payment/b2b-online-payment.module.scss
var b2b_online_payment_module = __webpack_require__(40144);
var b2b_online_payment_module_default = /*#__PURE__*/__webpack_require__.n(b2b_online_payment_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-online-payment/b2b-online-payment.tsx









gsap.gsap.registerPlugin((ScrollToPlugin_default()));
gsap.gsap.registerPlugin(ScrollTrigger.ScrollTrigger);
gsap.gsap.registerPlugin(src/* useGSAP */.V);
const BusinessHubOnlinePayment = (props)=>{
    const { title , description , backgroundColor , steps =[]  } = props;
    const containerRef = (0,react.useRef)(null);
    const scollTo = (id)=>{
        if (window.location.hash.startsWith("#".concat(id))) {
            setTimeout(()=>{
                const elem = document.getElementById(id);
                if (!elem) return;
                const position = elem.getBoundingClientRect();
                gsap.gsap.to(window, {
                    duration: 1,
                    scrollTo: position.top + window.scrollY - 116
                });
            }, 500);
        }
    };
    (0,src/* useGSAP */.V)(()=>{
        let mm = gsap.gsap.matchMedia();
        mm.add({
            reducedMotion: "(prefers-reduced-motion: no-preference)"
        }, ()=>{
            const selector = gsap.gsap.utils.selector(containerRef.current);
            const sectionContainer = gsap.gsap.utils.toArray(selector(".".concat((b2b_online_payment_module_default()).sections)));
            const sections = gsap.gsap.utils.toArray(selector(".".concat((b2b_online_payment_module_default()).stepWrapper)));
            const progresses = gsap.gsap.utils.toArray(selector(".".concat((b2b_online_payment_module_default()).progressItem)));
            const screens = gsap.gsap.utils.toArray(selector(".".concat((b2b_online_payment_module_default()).phoneScreenBox)));
            const titles = gsap.gsap.utils.toArray(selector(".".concat((b2b_online_payment_module_default()).title)));
            const descriptions = gsap.gsap.utils.toArray(selector(".".concat((b2b_online_payment_module_default()).description)));
            gsap.gsap.timeline({
                scrollTrigger: {
                    trigger: containerRef.current,
                    pinnedContainer: containerRef.current,
                    pin: true,
                    start: "bottom bottom",
                    end: "+=".concat(sections.length * 100, "%"),
                    scrub: 1
                }
            });
            let masterTl = gsap.gsap.timeline({
                defaults: {
                    ease: "sine.inOut"
                },
                scrollTrigger: {
                    trigger: containerRef.current,
                    start: "top+=20% center+=45%",
                    end: "+=".concat(sections.length * 100, "%"),
                    scrub: 1.5,
                    invalidateOnRefresh: true
                }
            });
            gsap.gsap.set(sections, {
                autoAlpha: 0,
                y: (i)=>{
                    return "".concat(100 * i, "vh");
                },
                transformOrigin: "top",
                xPercent: (index)=>-100 * index
            });
            gsap.gsap.set([
                titles,
                descriptions,
                sectionContainer
            ], {
                autoAlpha: 0
            });
            gsap.gsap.set(screens, {
                autoAlpha: 0,
                zIndex: (index)=>sections.length - index
            });
            gsap.gsap.set(progresses, {
                yPercent: 100,
                zIndex: (index)=>sections.length - index
            });
            masterTl.to([
                titles,
                descriptions,
                sectionContainer
            ], {
                ease: "power4.in",
                autoAlpha: 1,
                z: 0,
                stagger: 0.05
            });
            for(let index = 0; index < sections.length; index++){
                const section = sections[index];
                const screen = screens[index];
                const progress = progresses[index];
                const prevScreen = screens[index - 1];
                const prevSection = sections[index - 1];
                const prevProgress = progresses[index - 1];
                const nextProgress = progresses[index + 1];
                if (prevSection) {
                    masterTl.to([
                        prevSection,
                        prevProgress
                    ], {
                        yPercent: -200,
                        autoAlpha: 0
                    }, index == 0 ? 0 : "+=1").to(prevScreen, {
                        autoAlpha: 0
                    }, "<");
                }
                if (nextProgress) {
                    masterTl.to(nextProgress, {
                        yPercent: 50,
                        autoAlpha: 1
                    }, "<");
                }
                masterTl.to([
                    section,
                    progress
                ], {
                    autoAlpha: 1,
                    y: 0,
                    yPercent: 0,
                    onComplete: (progress)=>{
                        progress.classList.add((b2b_online_payment_module_default()).active);
                    },
                    onReverseComplete: (progress)=>{
                        progress.classList.remove((b2b_online_payment_module_default()).active);
                    },
                    onCompleteParams: [
                        progress
                    ],
                    onReverseCompleteParams: [
                        progress
                    ]
                }, index == 0 ? 0 : "<").to(screen, {
                    autoAlpha: 1
                }, "<");
            }
        });
        scollTo("solutions-for-the-omnichannel-world");
        scollTo("business-hub");
    }, {
        scope: containerRef
    });
    if (!steps.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (b2b_online_payment_module_default()).container,
        style: {
            "--data-bg-color": backgroundColor
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_online_payment_module_default()).background
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (b2b_online_payment_module_default()).box,
                ref: containerRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (b2b_online_payment_module_default()).titleBox,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (b2b_online_payment_module_default()).title,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (b2b_online_payment_module_default()).description,
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (b2b_online_payment_module_default()).sections,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (b2b_online_payment_module_default()).overlay,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (b2b_online_payment_module_default()).phoneFrame,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "https://cdn.builder.io/api/v1/image/assets%2F035a3d41874344d79b6c7499e2e7a5bc%2F081f2dc1939c4286b2011c9b07307053",
                                                alt: "",
                                                style: {
                                                    objectFit: "contain",
                                                    objectPosition: "center"
                                                },
                                                fill: true,
                                                loading: "eager",
                                                loader: (param)=>{
                                                    let { src , width , quality  } = param;
                                                    return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75, "&format=webp");
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (b2b_online_payment_module_default()).phoneScreen,
                                                children: steps.map((step, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (b2b_online_payment_module_default()).phoneScreenBox,
                                                        style: {
                                                            backgroundImage: "url(".concat(step.screenImage, "?quality=75&format=webp)")
                                                        }
                                                    }, step.name + index))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (b2b_online_payment_module_default()).progress,
                                        children: steps.map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (b2b_online_payment_module_default()).progressItem,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (b2b_online_payment_module_default()).progressBox,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: index + 1
                                                    })
                                                })
                                            }, index))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (b2b_online_payment_module_default()).sectionContainer,
                                children: steps.map((step, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(B2BOnlinePaymentStep, {
                                        ...step,
                                        className: (b2b_online_payment_module_default()).stepWrapper,
                                        contentClassName: (b2b_online_payment_module_default()).stepBox
                                    }, step.name + index))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var b2b_online_payment = (BusinessHubOnlinePayment);

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-online-payment/b2b-online-payment.builder-component.ts

const B2BOnlinePaymentBuilderConfig = {
    name: "B2B Online Payment",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: ""
        },
        {
            name: "description",
            type: "string"
        },
        {
            name: "backgroundColor",
            type: "color",
            defaultValue: "#E7EAED"
        },
        {
            name: "steps",
            type: "list",
            subFields: [
                {
                    name: "name",
                    type: "string",
                    required: true
                },
                {
                    name: "description",
                    type: "richText"
                },
                {
                    name: "icon",
                    type: "file",
                    required: true
                },
                {
                    name: "screenImage",
                    type: "file",
                    required: true
                },
                {
                    name: "illustration",
                    type: "file",
                    required: true
                },
                {
                    name: "illustrationRatio",
                    type: "text"
                }
            ]
        }
    ]
};
const b2b_online_payment_builder_component_builderConfig = {
    component: b2b_online_payment,
    config: B2BOnlinePaymentBuilderConfig
};
/* harmony default export */ var b2b_online_payment_builder_component = (b2b_online_payment_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-platform/b2b-platform-card-item/platform-card-item.module.scss
var platform_card_item_module = __webpack_require__(88474);
var platform_card_item_module_default = /*#__PURE__*/__webpack_require__.n(platform_card_item_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-platform/b2b-platform-card-item/platform-card-item.tsx


const PlatFromCardItem = (props)=>{
    const { logo , title , description , linkLearnMore , showLearnMore , backgroundColorCard  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (platform_card_item_module_default()).container,
        style: {
            backgroundColor: showLearnMore ? "#E7EAED" : "#00D533",
            cursor: showLearnMore ? "pointer" : "default"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((platform_card_item_module_default()).logo, " ").concat(showLearnMore ? (platform_card_item_module_default()).canHover : ""),
                style: {
                    backgroundColor: showLearnMore ? "#00D533" : "#E7EAED"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        WebkitMaskImage: "url(".concat(logo, ")"),
                        maskImage: "url(".concat(logo, ")"),
                        backgroundColor: showLearnMore ? "#000000" : "#ffffff"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (platform_card_item_module_default()).title,
                dangerouslySetInnerHTML: {
                    __html: title || ""
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (platform_card_item_module_default()).description,
                dangerouslySetInnerHTML: {
                    __html: description || ""
                }
            }),
            showLearnMore && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: (platform_card_item_module_default()).tileClick,
                        href: linkLearnMore,
                        target: "_blank"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (platform_card_item_module_default()).learnMore,
                        children: "Learn more"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var platform_card_item = (PlatFromCardItem);

// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-platform/b2b-platform.module.scss
var b2b_platform_module = __webpack_require__(44331);
var b2b_platform_module_default = /*#__PURE__*/__webpack_require__.n(b2b_platform_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-platform/b2b-platform.tsx








swiper/* default.use */.Z.use([
    modules/* Autoplay */.pt,
    modules/* A11y */.s5
]);
const b2b_platform_options = {
    slidesPerView: "auto",
    spaceBetween: 36,
    allowTouchMove: true,
    noSwiping: false,
    freeMode: true,
    loop: true,
    navigation: false,
    pagination: false,
    speed: 1000,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false
    },
    breakpoints: {
        992: {
            watchOverflow: true,
            spaceBetween: 20
        }
    }
};
const B2BPlatForm = (props)=>{
    const { backgroundColor , header , subHeader , cards =[] , showLearnMore  } = props;
    const { width =0  } = (0,useWindowSize/* useWindowSize */.i)();
    const isMobile = (0,react.useMemo)(()=>width <= 998, [
        width
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (b2b_platform_module_default()).container,
        style: {
            backgroundColor: backgroundColor
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (b2b_platform_module_default()).wrapperContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (b2b_platform_module_default()).header,
                    dangerouslySetInnerHTML: {
                        __html: header
                    }
                }),
                subHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (b2b_platform_module_default()).subHeader,
                    dangerouslySetInnerHTML: {
                        __html: subHeader
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (b2b_platform_module_default()).wrapperCards,
                    children: !isMobile ? cards.map((card, index)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(platform_card_item, {
                                logo: card.logo,
                                title: card.title,
                                description: card.description,
                                linkLearnMore: card.linkLearnMore,
                                showLearnMore: showLearnMore
                            }, index)
                        }, index);
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        ...b2b_platform_options,
                        children: cards.map((card, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(platform_card_item, {
                                    logo: card.logo,
                                    title: card.title,
                                    description: card.description,
                                    linkLearnMore: card.linkLearnMore,
                                    showLearnMore: showLearnMore
                                }, index)
                            }, index);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var b2b_platform = (B2BPlatForm);

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-platform/b2b-platform.builder-component.ts

const B2BVideoHeroBuilderConfig = {
    name: "B2B Platform",
    inputs: [
        {
            name: "backgroundColor",
            type: "color",
            defaultValue: ""
        },
        {
            name: "header",
            type: "html",
            defaultValue: ""
        },
        {
            name: "subHeader",
            type: "html",
            defaultValue: ""
        },
        {
            name: "showLearnMore",
            type: "boolean",
            defaultValue: false
        },
        {
            name: "cards",
            type: "list",
            // copyOnAdd: false,
            subFields: [
                {
                    name: "backgroundColorCard",
                    type: "color"
                },
                {
                    name: "logo",
                    type: "file",
                    defaultValue: ""
                },
                {
                    name: "title",
                    type: "html"
                },
                {
                    name: "description",
                    type: "html"
                },
                {
                    name: "linkLearnMore",
                    type: "string"
                }
            ]
        }
    ]
};
const b2b_platform_builder_component_builderConfig = {
    component: b2b_platform,
    config: B2BVideoHeroBuilderConfig
};
/* harmony default export */ var b2b_platform_builder_component = (b2b_platform_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-scrolling-content/b2b-scrolling-content.module.scss
var b2b_scrolling_content_module = __webpack_require__(10434);
var b2b_scrolling_content_module_default = /*#__PURE__*/__webpack_require__.n(b2b_scrolling_content_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-scrolling-content/b2b-scrolling-content.tsx









gsap.gsap.registerPlugin(src/* useGSAP */.V);
gsap.gsap.registerPlugin(ScrollTrigger.ScrollTrigger);
gsap.gsap.registerPlugin((TextPlugin_default()));
const B2BScrollingContent = (props)=>{
    const { title , description , sections =[]  } = props;
    const containerRef = (0,react.useRef)(null);
    (0,src/* useGSAP */.V)(()=>{
        const selector = gsap.gsap.utils.selector(containerRef.current);
        const sections = gsap.gsap.utils.toArray(selector(".".concat((b2b_scrolling_content_module_default()).section)));
        let mm = gsap.gsap.matchMedia();
        gsap.gsap.timeline({
            scrollTrigger: {
                trigger: containerRef.current,
                pinnedContainer: containerRef.current,
                pin: true,
                start: "center center",
                end: "+=100%",
                scrub: 1
            }
        });
        let masterTl = gsap.gsap.timeline({
            scrollTrigger: {
                trigger: containerRef.current,
                start: "top center+=40%",
                end: "bottom top",
                scrub: true
            }
        });
        gsap.gsap.set(sections, {
            autoAlpha: 0
        });
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const left = gsap.gsap.utils.toArray(gsap.gsap.utils.selector(section)(".".concat((b2b_scrolling_content_module_default()).left)))[0];
            const prvSection = sections[i - 1];
            if (prvSection) {
                const prvTitle = gsap.gsap.utils.toArray(gsap.gsap.utils.selector(prvSection)(".".concat((b2b_scrolling_content_module_default()).left)))[0];
                const tlOut = animateSection(prvSection, prvTitle, "out");
                masterTl.add(tlOut);
            }
            const tlIn = animateSection(section, left, "in", i === 0 ? "+=1" : "<");
            masterTl.to(section, {
                xPercent: -100 * i,
                x: 0
            }, "<");
            masterTl.add(tlIn, "-=0.4");
        }
    }, {
        scope: containerRef,
        dependencies: [
            sections
        ]
    });
    const animateSection = (section, leftElm, animationType, position)=>{
        const sectionSelector = gsap.gsap.utils.selector(section);
        const contentItems = gsap.gsap.utils.toArray(sectionSelector(".".concat((b2b_scrolling_content_module_default()).right)));
        const number = gsap.gsap.utils.toArray(gsap.gsap.utils.selector(leftElm)(".".concat((b2b_scrolling_content_module_default()).number)));
        const titleSplits = gsap.gsap.utils.toArray(gsap.gsap.utils.selector(leftElm)(".".concat((b2b_scrolling_content_module_default()).title, " span")));
        const desSplits = gsap.gsap.utils.toArray(gsap.gsap.utils.selector(leftElm)(".".concat((b2b_scrolling_content_module_default()).description, " span")));
        const tl = gsap.gsap.timeline({});
        if (animationType === "in") {
            tl.to(section, {
                autoAlpha: 1
            }, position);
            tl.fromTo([
                contentItems,
                number,
                titleSplits,
                desSplits
            ], {
                autoAlpha: 0
            }, {
                duration: 1,
                autoAlpha: 1,
                stagger: {
                    from: "start",
                    each: 0.02
                }
            }, ">-=0.5");
        } else {
            tl.to([
                contentItems,
                number,
                titleSplits,
                desSplits
            ], {
                duration: 0.5,
                autoAlpha: 0,
                stagger: {
                    from: "start",
                    each: 0.005
                }
            }, "+=1");
        }
        return tl;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: containerRef,
        className: (b2b_scrolling_content_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (b2b_scrolling_content_module_default()).head,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (b2b_scrolling_content_module_default()).title,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (b2b_scrolling_content_module_default()).description,
                        dangerouslySetInnerHTML: {
                            __html: description || ""
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_scrolling_content_module_default()).scrolling,
                children: sections.map((section, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: (b2b_scrolling_content_module_default()).section,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (b2b_scrolling_content_module_default()).left,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (b2b_scrolling_content_module_default()).number,
                                        children: index + 1
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (b2b_scrolling_content_module_default()).title,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(splitchar/* SplitChar */.k, {
                                            text: section.title
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (b2b_scrolling_content_module_default()).description,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(splitchar/* SplitChar */.k, {
                                            text: section.description
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (b2b_scrolling_content_module_default()).right,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: section.image,
                                    alt: "",
                                    style: {
                                        objectFit: "contain",
                                        objectPosition: "center"
                                    },
                                    fill: true,
                                    loading: "eager",
                                    sizes: "(max-width: 638px) 98vw, (max-width: 998px) 43vw, 46vw",
                                    className: (b2b_scrolling_content_module_default()).image
                                })
                            })
                        ]
                    }))
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-scrolling-content/b2b-scrolling-content.builder-component.ts

const B2BScrollingContentBuilderConfig = {
    name: "B2B Scrolling Content",
    inputs: [
        {
            name: "title",
            type: "string"
        },
        {
            name: "description",
            type: "richText"
        },
        {
            name: "sections",
            type: "list",
            copyOnAdd: false,
            subFields: [
                {
                    name: "title",
                    type: "string"
                },
                {
                    name: "description",
                    type: "string"
                },
                {
                    name: "image",
                    type: "file"
                }
            ]
        }
    ]
};
const b2b_scrolling_content_builder_component_builderConfig = {
    component: B2BScrollingContent,
    config: B2BScrollingContentBuilderConfig
};
/* harmony default export */ var b2b_scrolling_content_builder_component = (b2b_scrolling_content_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-series-collection-article-block/b2b-series-collection-articles-block.module.scss
var b2b_series_collection_articles_block_module = __webpack_require__(37606);
var b2b_series_collection_articles_block_module_default = /*#__PURE__*/__webpack_require__.n(b2b_series_collection_articles_block_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-series-collection-article-block/b2b-series-collection-articles-block.tsx







const B2BSeriesCollectionArticles = (props)=>{
    const { titleSeries , descriptionSeries , viewAllUrl , viewAllText , typeOfCard , includeLargeCard , articles: articlesProps , category , categoryObject , backgroundColor ="" , cardBackgroundColor =""  } = props;
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const [articles, setArticles] = (0,react.useState)(articlesProps);
    const getArticles = (0,react.useCallback)(async ()=>{
        if (category && !articlesProps) {
            setTimeout(async ()=>{
                const articles = await (0,BuilderHelper/* getArticlesByCategory */.Zd)({
                    locale: LangHelper/* Locale.USA */.go.USA,
                    categoryIds: [
                        category
                    ]
                });
                setArticles(articles);
            }, 500);
        }
    }, [
        articlesProps,
        category
    ]);
    (0,react.useEffect)(()=>{
        getArticles();
    }, [
        getArticles
    ]);
    let getViewAllUrl = (0,LangHelper/* localifyLink */.Bj)("/".concat(locale).concat(viewAllUrl), locale);
    const viewAllTexts = (viewAllText)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: viewAllText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                    type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                })
            ]
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (b2b_series_collection_articles_block_module_default()).seriesCollectionBlock,
        children: [
            backgroundColor ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_series_collection_articles_block_module_default())["seriesCollectionBlock".concat(backgroundColor.replace(" ", ""))]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (b2b_series_collection_articles_block_module_default()).seriesHeader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (b2b_series_collection_articles_block_module_default()).infoSeries,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (b2b_series_collection_articles_block_module_default()).title,
                                children: titleSeries
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (b2b_series_collection_articles_block_module_default()).description,
                                children: descriptionSeries
                            })
                        ]
                    }),
                    viewAllUrl === undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (b2b_series_collection_articles_block_module_default()).btnViewAll,
                        children: viewAllTexts(viewAllText)
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: getViewAllUrl,
                        className: (b2b_series_collection_articles_block_module_default()).btnViewAll,
                        children: viewAllTexts(viewAllText)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(b2b_headlining_articles_block, {
                cardBackgroundColor: cardBackgroundColor,
                cardData: articles,
                typeOfCard: typeOfCard,
                showSignupCard: false,
                includeLargeCard: includeLargeCard,
                debounce: true
            })
        ]
    });
};
/* harmony default export */ var b2b_series_collection_articles_block = (B2BSeriesCollectionArticles);

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-series-collection-article-block/b2b-series-collection-articles-block.builder-component.ts



const B2BSeriesCollectionArticlesBuilderConfig = {
    name: "B2B Series Collection Articles",
    inputs: [
        {
            name: "titleSeries",
            type: "string"
        },
        {
            name: "descriptionSeries",
            type: "longText",
            defaultValue: ""
        },
        {
            name: "viewAllUrl",
            type: "url",
            defaultValue: ""
        },
        {
            name: "viewAllText",
            type: "string",
            defaultValue: ""
        },
        {
            name: "category",
            type: "dynamic-dropdown",
            options: {
                url: GET_ALL_CATEGORY,
                mapper: "({data}) => {\n                  return ({\n                    category: Object.values(data)[0].reduce((rs, curr) => {\n                      return [...rs, { value: curr.id, name: curr.name }]\n                    }, [])\n                  })\n                }",
                expectMultipleDropdowns: false
            }
        },
        {
            name: "typeOfCard",
            type: "string",
            defaultValue: TYPES_OF_CARD.ARTICLE,
            enum: Object.values(TYPES_OF_CARD)
        },
        {
            name: "includeLargeCard",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "backgroundColor",
            type: "string",
            enum: [
                "white",
                "gray-2",
                "gray-1"
            ]
        },
        {
            name: "cardBackgroundColor",
            type: "string",
            enum: [
                "white",
                "gray-2",
                "gray-1"
            ]
        }
    ]
};
const b2b_series_collection_articles_block_builder_component_builderConfig = {
    component: b2b_series_collection_articles_block,
    config: B2BSeriesCollectionArticlesBuilderConfig
};
/* harmony default export */ var b2b_series_collection_articles_block_builder_component = (b2b_series_collection_articles_block_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-trending-topics/b2b-treding-topic-item/b2b-trending-topic-item.module.scss
var b2b_trending_topic_item_module = __webpack_require__(44695);
var b2b_trending_topic_item_module_default = /*#__PURE__*/__webpack_require__.n(b2b_trending_topic_item_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-trending-topics/b2b-treding-topic-item/b2b-trending-topic-item.tsx





const BusinessTrendingTopicItem = (param)=>{
    let { category  } = param;
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const { image , name  } = category;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        href: (0,LangHelper/* localifyLink */.Bj)("/".concat(locale).concat(category.categoryUrl), locale),
        className: (b2b_trending_topic_item_module_default()).businessTrendingTopicsItem,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_trending_topic_item_module_default()).itemBackground,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_zoom, {
                    src: image !== null && image !== void 0 ? image : "",
                    ratio: [
                        200,
                        200
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_trending_topic_item_module_default()).itemDescription,
                children: name
            })
        ]
    });
};
/* harmony default export */ var b2b_trending_topic_item = (BusinessTrendingTopicItem);

// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-trending-topics/b2b-trending-topics.module.scss
var b2b_trending_topics_module = __webpack_require__(97182);
var b2b_trending_topics_module_default = /*#__PURE__*/__webpack_require__.n(b2b_trending_topics_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-trending-topics/b2b-trending-topics.tsx










swiper/* default.use */.Z.use([
    modules/* Navigation */.W_
]);
const B2BTrendingTopics = (props)=>{
    const [categories, setCategories] = (0,react.useState)([]);
    const { title , description  } = props;
    const prevRef = (0,react.useRef)(null);
    const nextRef = (0,react.useRef)(null);
    const { ref , inView  } = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true
    });
    const [swiper, setSwiper] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        const fetchCategories = async ()=>{
            try {
                // Replace this with your actual data fetching logic
                const fetchedCategories = await (0,BuilderHelper/* getCategoriesFromIDs */.nq)(props.categories.map((c)=>c.categoryId));
                setCategories(fetchedCategories);
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        };
        fetchCategories();
    }, [
        props.categories
    ]);
    (0,react.useEffect)(()=>{
        if (swiper && inView) {
            swiper.init();
        }
    }, [
        swiper,
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (b2b_trending_topics_module_default()).businessTrendingTopicsWrapper,
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_trending_topics_module_default()).businessTrendingTopicsTitle,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_trending_topics_module_default()).businessTrendingTopicsDescription,
                children: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (b2b_trending_topics_module_default()).businessTrendingTopicsCarousel,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: nextRef,
                        className: (b2b_trending_topics_module_default()).carouselButtonNext,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: prevRef,
                        className: (b2b_trending_topics_module_default()).carouselButtonPrev,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        grabCursor: true,
                        navigation: {
                            prevEl: prevRef.current ? prevRef.current : undefined,
                            nextEl: nextRef.current ? nextRef.current : undefined
                        },
                        onInit: (swiper)=>{
                            if (!swiper) {
                                return;
                            }
                            const navigation = swiper === null || swiper === void 0 ? void 0 : swiper.params.navigation;
                            navigation.prevEl = prevRef.current;
                            navigation.nextEl = nextRef.current;
                            swiper.navigation.init();
                            swiper.navigation.update();
                        },
                        slidesPerView: "auto",
                        spaceBetween: 15,
                        breakpoints: {
                            768: {
                                spaceBetween: 24
                            },
                            1440: {
                                spaceBetween: 24
                            }
                        },
                        centeredSlides: false,
                        centeredSlidesBounds: true,
                        watchOverflow: true,
                        lazyPreloadPrevNext: 1,
                        updateOnWindowResize: true,
                        onSwiper: (sw)=>{
                            setSwiper(sw);
                        },
                        children: categories.map((category, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                className: (b2b_trending_topics_module_default()).relatedArticleSlide,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(b2b_trending_topic_item, {
                                    category: category
                                })
                            }, "".concat(index, "_").concat(category.categorySlug));
                        })
                    }, title)
                ]
            })
        ]
    });
};
/* harmony default export */ var b2b_trending_topics = (B2BTrendingTopics);

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-trending-topics/b2b-trending-topics.builder-component.ts

const B2BTrendingTopicsBuilderConfig = {
    name: "B2B Trending topics",
    inputs: [
        {
            name: "title",
            type: "string",
            required: true
        },
        {
            name: "description",
            type: "string",
            required: true
        },
        {
            name: "categories",
            type: "list",
            required: true,
            subFields: [
                {
                    name: "categoryId",
                    type: "string"
                }
            ]
        }
    ]
};
const b2b_trending_topics_builder_component_builderConfig = {
    component: b2b_trending_topics,
    config: B2BTrendingTopicsBuilderConfig
};
/* harmony default export */ var b2b_trending_topics_builder_component = (b2b_trending_topics_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-video-card-list-item/b2b-video-card-item/b2b-video-card-item.constants.ts
const VIDEO_CARD_ITEM_TYPES = {
    DISCOUNT: "discount",
    IMAGE: "image",
    QUOTE: "quote",
    IMAGE_BRAND: "imageBrand",
    CTA_BLOCK: "CTABlock"
};

// EXTERNAL MODULE: ./node_modules/aos/dist/aos.js
var aos = __webpack_require__(40409);
var aos_default = /*#__PURE__*/__webpack_require__.n(aos);
// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-video-card-list-item/b2b-video-card-item/b2b-video-card-item.module.scss
var b2b_video_card_item_module = __webpack_require__(68026);
var b2b_video_card_item_module_default = /*#__PURE__*/__webpack_require__.n(b2b_video_card_item_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-video-card-list-item/b2b-video-card-item/b2b-video-card-item.tsx
/* eslint-disable @next/next/no-img-element */ 





const B2BVideoCardItem = (props)=>{
    const { typeOfItem , discountContent ="" , discountText ="" , imageBrandUrl ="" , imageUrl ="" , authorName ="" , quote ="" , quoteMaxWidth , ctaContent ="" , ctaUrl ="" , discountPercentImage =""  } = props.item;
    const { isSingleBlock  } = props;
    const { ratio =[
        256,
        256
    ]  } = props;
    switch(typeOfItem){
        case VIDEO_CARD_ITEM_TYPES.IMAGE_BRAND:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_video_card_item_module_default()).imageBrand,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: imageBrandUrl,
                    alt: ""
                })
            });
        case VIDEO_CARD_ITEM_TYPES.IMAGE:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_video_card_item_module_default()).image,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_zoom, {
                    ratio: ratio,
                    src: imageUrl
                })
            });
        case VIDEO_CARD_ITEM_TYPES.QUOTE:
            let quoteClassName = classnames_default()((b2b_video_card_item_module_default()).quote);
            if (isSingleBlock) {
                quoteClassName = classnames_default()((b2b_video_card_item_module_default()).quote, (b2b_video_card_item_module_default()).singleBlock);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: quoteClassName,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (b2b_video_card_item_module_default()).quoteContent,
                        style: {
                            maxWidth: quoteMaxWidth
                        },
                        children: quote
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (b2b_video_card_item_module_default()).quoteAuthorName,
                        children: [
                            "- ",
                            authorName
                        ]
                    })
                ]
            });
        case VIDEO_CARD_ITEM_TYPES.DISCOUNT:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_video_card_item_module_default()).discount,
                children: discountPercentImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(image_zoom, {
                    ratio: ratio,
                    src: discountPercentImage,
                    className: "image-discount"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (b2b_video_card_item_module_default()).discountPercent,
                            children: discountContent
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (b2b_video_card_item_module_default()).discountText,
                            children: discountText
                        })
                    ]
                })
            });
        case VIDEO_CARD_ITEM_TYPES.CTA_BLOCK:
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (b2b_video_card_item_module_default()).CTABlock,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (b2b_video_card_item_module_default()).CTABlockContent,
                        children: [
                            ctaContent,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (b2b_video_card_item_module_default()).CTABlockBtn,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Click here"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: (b2b_video_card_item_module_default()).CTABlockUrl,
                        href: ctaUrl,
                        target: "_self"
                    })
                ]
            });
        default:
            return null;
    }
};
/* harmony default export */ var b2b_video_card_item = (B2BVideoCardItem);

// EXTERNAL MODULE: ./node_modules/aos/dist/aos.css
var dist_aos = __webpack_require__(66130);
// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-video-card-list-item/b2b-video-card-list-item.module.scss
var b2b_video_card_list_item_module = __webpack_require__(81304);
var b2b_video_card_list_item_module_default = /*#__PURE__*/__webpack_require__.n(b2b_video_card_list_item_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-video-card-list-item/b2b-video-card-list-item.tsx










const b2b_video_card_list_item_B2BVideoCardItem = (props)=>{
    const { items  } = props;
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const windowWidth = windowSize.width || 0;
    const isMobile = (0,react.useMemo)(()=>{
        return (windowSize.width || 0) < 1199;
    }, [
        windowSize
    ]);
    (0,react.useEffect)(()=>{
        setTimeout(()=>{
            aos_default().init({
                duration: 1200
            });
        }, 500);
    }, []);
    (0,react.useEffect)(()=>{
        aos_default().refreshHard();
    }, [
        isMobile
    ]);
    const animationOption = (type)=>{
        if (type === "slider" && windowWidth < 1200) {
            return {
                "data-aos": "fade-up",
                "data-aos-anchor-placement": "bottom-bottom"
            };
        }
        if (type === "slideItem" && windowWidth > 1200) {
            return {
                "data-aos": "fade-up",
                "data-aos-anchor-placement": "bottom-bottom"
            };
        }
        return null;
    };
    const countImageInItems = (items)=>{
        const imagesItem = items.filter((item)=>item.typeOfItem === VIDEO_CARD_ITEM_TYPES.IMAGE);
        var ref;
        const secondImage = (ref = imagesItem[1]) !== null && ref !== void 0 ? ref : null;
        const indexOfSecondImage = items.indexOf(secondImage);
        return {
            count: imagesItem.length,
            secondImageIndex: indexOfSecondImage
        };
    };
    const handleSliderItemClassName = (item, index)=>{
        let slideClassName = classnames_default()((b2b_video_card_list_item_module_default()).discountCarouselSlide);
        let ratio = [
            256,
            256
        ];
        let isSingleBlock = false;
        const numberOfItems = items.length;
        const imageAmount = countImageInItems(items).count;
        const secondImage = countImageInItems(items).secondImageIndex;
        if (numberOfItems % 5 !== 0 && item.typeOfItem === VIDEO_CARD_ITEM_TYPES.QUOTE) {
            slideClassName = classnames_default()((b2b_video_card_list_item_module_default()).discountCarouselSlide);
            isSingleBlock = true;
        }
        if (numberOfItems % 5 === 0 && item.typeOfItem === VIDEO_CARD_ITEM_TYPES.QUOTE) {
            slideClassName = classnames_default()((b2b_video_card_list_item_module_default()).discountCarouselSlide, (b2b_video_card_list_item_module_default()).columnSpanQuote);
        }
        if (numberOfItems % 5 === 0 && item.typeOfItem === VIDEO_CARD_ITEM_TYPES.QUOTE && imageAmount >= 2) {
            slideClassName = classnames_default()((b2b_video_card_list_item_module_default()).discountCarouselSlide);
            isSingleBlock = true;
        }
        if (numberOfItems % 4 === 0 && item.typeOfItem === VIDEO_CARD_ITEM_TYPES.IMAGE) {
            slideClassName = classnames_default()((b2b_video_card_list_item_module_default()).discountCarouselSlide);
        }
        if (numberOfItems % 4 !== 0 && item.typeOfItem === VIDEO_CARD_ITEM_TYPES.IMAGE) {
            slideClassName = classnames_default()((b2b_video_card_list_item_module_default()).discountCarouselSlide, (b2b_video_card_list_item_module_default()).columnSpan);
            ratio = windowWidth > 1200 ? [
                536,
                256
            ] : [
                256,
                256
            ];
        }
        if (numberOfItems % 4 !== 0 && item.typeOfItem === VIDEO_CARD_ITEM_TYPES.IMAGE && imageAmount >= 2) {
            slideClassName = classnames_default()((b2b_video_card_list_item_module_default()).discountCarouselSlide);
            ratio = [
                256,
                256
            ];
        }
        if (item.typeOfItem === VIDEO_CARD_ITEM_TYPES.IMAGE && index === secondImage) {
            slideClassName = classnames_default()((b2b_video_card_list_item_module_default()).discountCarouselSlide, (b2b_video_card_list_item_module_default()).columnSpan);
            ratio = windowWidth > 1200 ? [
                536,
                256
            ] : [
                256,
                256
            ];
        }
        if (item.typeOfItem === VIDEO_CARD_ITEM_TYPES.QUOTE && imageAmount >= 2) {
            slideClassName = classnames_default()((b2b_video_card_list_item_module_default()).discountCarouselSlide, (b2b_video_card_list_item_module_default()).columnSpanQuote);
            isSingleBlock = false;
        }
        return {
            slideClassName: slideClassName,
            ratio: ratio,
            isSingleBlock: isSingleBlock
        };
    };
    const renderSliderItem = (item, index)=>{
        const className = handleSliderItemClassName(item, index).slideClassName;
        const ratio = handleSliderItemClassName(item, index).ratio;
        const isSingleBlock = handleSliderItemClassName(item, index).isSingleBlock;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
            className: className,
            ...animationOption("slideItem"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(b2b_video_card_item, {
                item: item,
                ratio: ratio,
                isSingleBlock: isSingleBlock
            })
        }, index);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (b2b_video_card_list_item_module_default()).discountCarousel,
        ...animationOption("slider"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
            className: (b2b_video_card_list_item_module_default()).discountCarouselSlider,
            grabCursor: true,
            slidesPerView: "auto",
            spaceBetween: 20,
            centeredSlides: true,
            breakpoints: {
                768: {
                    centeredSlides: false
                }
            },
            centeredSlidesBounds: true,
            watchOverflow: true,
            updateOnWindowResize: true,
            lazyPreloadPrevNext: 1,
            children: items.map((item, index)=>renderSliderItem(item, index))
        })
    });
};
/* harmony default export */ var b2b_video_card_list_item = (b2b_video_card_list_item_B2BVideoCardItem);

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-video-card/b2b-video-card.constants.ts
const VIDEO_POSITIONS = {
    LEFT: "left",
    RIGHT: "right"
};

// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-video-card/b2b-video-card.module.scss
var b2b_video_card_module = __webpack_require__(11193);
var b2b_video_card_module_default = /*#__PURE__*/__webpack_require__.n(b2b_video_card_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-video-card/b2b-video-card.tsx
/* eslint-disable @next/next/no-img-element */ 









const B2BVideoCard = (props)=>{
    const { leadImage , title , description , mediaPosition ="left" , ctaText , imageBrand , videoCardItems , sectionId  } = props;
    const url = props.href || "";
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const windowWidth = windowSize.width || 0;
    (0,react.useEffect)(()=>{
        setTimeout(()=>{
            aos_default().init({
                duration: 1200
            });
        }, 500);
    }, []);
    const animationOption = function(type) {
        let delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "300";
        const handleDataAos = (type, mediaPosition)=>{
            if (type === "media" && mediaPosition === "left") {
                return "right";
            }
            if (type === "media" && mediaPosition === "right") {
                return "left";
            }
            return mediaPosition;
        };
        return {
            "data-aos": "fade-" + handleDataAos(type, mediaPosition),
            "data-aos-delay": delay
        };
    };
    const renderMediaContent = ()=>{
        const imageRatio = windowWidth < 786 ? [
            315,
            379
        ] : [
            488,
            428
        ];
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (b2b_video_card_module_default()).mediaContent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (b2b_video_card_module_default()).playButton,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                        type: icons/* IconType.Triangle */.T.Triangle
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(image_zoom, {
                    src: leadImage,
                    ratio: imageRatio
                })
            ]
        });
    };
    const mediaBlock = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((b2b_video_card_module_default()).media, " ").concat((b2b_video_card_module_default())[mediaPosition]),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (b2b_video_card_module_default()).ratioBox,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((b2b_video_card_module_default()).ratioBoxContent, " ").concat((b2b_video_card_module_default())[mediaPosition]),
                        ...animationOption("media", "300"),
                        children: [
                            renderMediaContent(),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: url,
                                target: "_self",
                                className: (b2b_video_card_module_default()).link
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((b2b_video_card_module_default()).background, " ").concat((b2b_video_card_module_default())[mediaPosition]),
                        "data-aos": "fade-up",
                        "data-aos-easing": "linear",
                        "data-aos-anchor-placement": "top-center",
                        "data-aos-duration": "500"
                    })
                ]
            })
        });
    const infoBlock = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((b2b_video_card_module_default()).info, " ").concat((b2b_video_card_module_default())[mediaPosition]),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: imageBrand,
                    alt: "",
                    className: (b2b_video_card_module_default()).brand,
                    ...animationOption("info", "250")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (b2b_video_card_module_default()).title,
                    dangerouslySetInnerHTML: {
                        __html: title
                    },
                    ...animationOption("info", "300")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (b2b_video_card_module_default()).description,
                    dangerouslySetInnerHTML: {
                        __html: description
                    },
                    ...animationOption("info", "350")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: url,
                    target: "_self",
                    className: (b2b_video_card_module_default()).cta,
                    ...animationOption("info", "350"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: ctaText !== null && ctaText !== void 0 ? ctaText : "Watch now"
                    })
                })
            ]
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (b2b_video_card_module_default()).container,
        id: sectionId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (b2b_video_card_module_default()).videoCard,
                children: [
                    mediaPosition === VIDEO_POSITIONS.LEFT ? mediaBlock() : null,
                    infoBlock(),
                    mediaPosition === VIDEO_POSITIONS.RIGHT ? mediaBlock() : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(b2b_video_card_list_item, {
                items: videoCardItems
            })
        ]
    });
};
/* harmony default export */ var b2b_video_card = (B2BVideoCard);

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-video-card/b2b-video-card.builder-component.ts




const B2BVideoCardBuilderConfig = {
    name: "B2B Video Card",
    inputs: [
        {
            name: "leadImage",
            type: "file",
            defaultValue: ""
        },
        {
            name: "imageBrand",
            type: "file"
        },
        {
            name: "title",
            type: "string",
            defaultValue: ""
        },
        {
            name: "description",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "href",
            type: "url"
        },
        {
            name: "ctaText",
            type: "string",
            defaultValue: ""
        },
        {
            name: "ctaIcon",
            type: "string",
            enum: [
                icons/* IconType.Download */.T.Download,
                icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
            ]
        },
        {
            name: "mediaPosition",
            type: "string",
            enum: Object.values(VIDEO_POSITIONS),
            defaultValue: VIDEO_POSITIONS.LEFT
        },
        {
            name: "videoCardItems",
            type: "list",
            defaultValue: [],
            subFields: [
                {
                    name: "typeOfItem",
                    type: "string",
                    enum: Object.values(VIDEO_CARD_ITEM_TYPES),
                    defaultValue: VIDEO_CARD_ITEM_TYPES.DISCOUNT
                },
                {
                    name: "imageBrandUrl",
                    type: "file",
                    helperText: "Use for item type image brand"
                },
                {
                    name: "discountPercentImage",
                    type: "file",
                    defaultValue: "",
                    helperText: "Use for item type discount"
                },
                {
                    name: "discountContent",
                    type: "string",
                    defaultValue: "+74%",
                    helperText: "Use for item type discount"
                },
                {
                    name: "discountText",
                    type: "text",
                    defaultValue: "",
                    helperText: "Use for item type discount"
                },
                {
                    name: "imageUrl",
                    type: "file",
                    defaultValue: "",
                    helperText: "Use for item type image"
                },
                {
                    name: "quote",
                    type: "text",
                    defaultValue: "",
                    helperText: "Use for item type quote"
                },
                {
                    name: "quoteMaxWidth",
                    type: "number"
                },
                {
                    name: "authorName",
                    type: "text",
                    defaultValue: "",
                    helperText: "Use for item type quote"
                },
                {
                    name: "ctaContent",
                    type: "text",
                    defaultValue: "",
                    helperText: "Use for item type CTABlock"
                },
                {
                    name: "ctaUrl",
                    type: "text",
                    defaultValue: "",
                    helperText: "Use for item type CTABlock"
                }
            ]
        },
        {
            name: "sectionId",
            type: "string",
            defaultValue: "",
            helperText: "This field must be the same with sectionId above the carousel Item"
        }
    ]
};
const b2b_video_card_builder_component_builderConfig = {
    component: b2b_video_card,
    config: B2BVideoCardBuilderConfig
};
/* harmony default export */ var b2b_video_card_builder_component = (b2b_video_card_builder_component_builderConfig);

// EXTERNAL MODULE: ./node_modules/scroll-behavior-polyfill/dist/index.js
var scroll_behavior_polyfill_dist = __webpack_require__(30281);
;// CONCATENATED MODULE: ./helpers/index.ts

const scrollToById = async function(id) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, delay = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10;
    if (!("scrollBehavior" in document.documentElement.style)) {
        await Promise.resolve(/* import() */).then(__webpack_require__.t.bind(__webpack_require__, 30281, 23));
    }
    const { detalY =0  } = options;
    setTimeout(()=>{
        const element = document.getElementById(id);
        if (!element) {
            return;
        }
        const y = element.getBoundingClientRect().top + window.pageYOffset + detalY;
        window.scrollTo({
            top: y,
            behavior: "smooth"
        });
    }, delay);
};

// EXTERNAL MODULE: ./node_modules/swiper/swiper.css
var swiper_swiper = __webpack_require__(4839);
// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-video-carousel/b2b-video-carousel.module.scss
var b2b_video_carousel_module = __webpack_require__(39912);
var b2b_video_carousel_module_default = /*#__PURE__*/__webpack_require__.n(b2b_video_carousel_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-video-carousel/b2b-video-carousel.tsx









swiper/* default.use */.Z.use([
    modules/* Navigation */.W_
]);
const VideoCarousel = (props)=>{
    const { videoCarouselItems , onItemChange  } = props;
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const windowWidth = windowSize.width || 0;
    if (!videoCarouselItems || videoCarouselItems.length <= 0) {
        return null;
    }
    const spaceWhenScroll = windowWidth > 786 ? -150 : -30;
    const renderVideoCarouselItem = (item)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
            className: (b2b_video_carousel_module_default()).videoItem,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_video_carousel_module_default()).videoItemContainer,
                onClick: ()=>scrollToById(item.sectionId, {
                        detalY: spaceWhenScroll
                    }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_zoom, {
                    src: item.thumbnailUrl,
                    ratio: [
                        424,
                        424
                    ],
                    className: (b2b_video_carousel_module_default()).videoItemThumbnailUrl
                })
            })
        }, item.name);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (b2b_video_carousel_module_default()).videoCarousel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
            grabCursor: true,
            slidesPerView: "auto",
            spaceBetween: 24,
            breakpoints: {
                320: {
                    centeredSlides: true,
                    spaceBetween: 15
                },
                768: {
                    spaceBetween: 24,
                    centeredSlides: true
                }
            },
            onSlideChange: (swiper)=>{
                if (onItemChange) {
                    onItemChange(swiper.realIndex);
                }
            },
            loop: true,
            centeredSlides: true,
            watchOverflow: true,
            lazyPreloadPrevNext: 1,
            updateOnWindowResize: true,
            children: videoCarouselItems.map((item)=>renderVideoCarouselItem(item))
        }, "video_carousel")
    });
};
/* harmony default export */ var b2b_video_carousel = (VideoCarousel);

// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-video-carousel/b2b-video-carousel-quote/b2b-video-carousel-quote.module.scss
var b2b_video_carousel_quote_module = __webpack_require__(18007);
var b2b_video_carousel_quote_module_default = /*#__PURE__*/__webpack_require__.n(b2b_video_carousel_quote_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-video-carousel/b2b-video-carousel-quote/b2b-video-carousel-quote.tsx



const B2BVideoCarouselQuoteItem = (param)=>{
    let { quote , authorQuote  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (b2b_video_carousel_quote_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("q", {
                className: (b2b_video_carousel_quote_module_default()).content,
                children: quote
            }),
            authorQuote && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (b2b_video_carousel_quote_module_default()).author,
                children: [
                    "- ",
                    authorQuote
                ]
            })
        ]
    });
};
/* harmony default export */ var b2b_video_carousel_quote = (B2BVideoCarouselQuoteItem);

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-video-carousel/b2b-video-carousel-wrapper.tsx






const B2BVideoCarouselWrapper = (props)=>{
    const { videoCarouselItems  } = props;
    const [swiper, setSwiper] = (0,react.useState)(null);
    const quotes = (videoCarouselItems === null || videoCarouselItems === void 0 ? void 0 : videoCarouselItems.map((item)=>{
        const quote = {
            quote: item.quote,
            authorQuote: item.authorQuote
        };
        return quote;
    })) || [];
    const onItemChange = (index)=>{
        swiper === null || swiper === void 0 ? void 0 : swiper.slideTo(index, 1000);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (b2b_video_carousel_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_video_carousel_module_default()).background
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(b2b_video_carousel, {
                videoCarouselItems: videoCarouselItems,
                onItemChange: onItemChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_video_carousel_module_default()).quoteContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    direction: "vertical",
                    spaceBetween: 40,
                    className: (b2b_video_carousel_module_default()).videoCarouselQuote,
                    autoHeight: true,
                    onSwiper: setSwiper,
                    children: quotes.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(b2b_video_carousel_quote, {
                                quote: item.quote,
                                authorQuote: item.authorQuote
                            })
                        }, "quote_key_".concat(index)))
                }, "video_carousel_quote")
            })
        ]
    });
};
/* harmony default export */ var b2b_video_carousel_wrapper = (B2BVideoCarouselWrapper);

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-video-carousel/b2b-video-carousel.builder-component.ts

const B2BVideoCarouselBuilderConfig = {
    name: "B2B Video Carousel",
    inputs: [
        {
            name: "videoCarouselItems",
            type: "list",
            subFields: [
                {
                    name: "thumbnailUrl",
                    type: "file"
                },
                {
                    name: "quote",
                    type: "text",
                    defaultValue: ""
                },
                {
                    name: "authorQuote",
                    type: "text",
                    defaultValue: ""
                },
                {
                    name: "sectionId",
                    type: "string",
                    defaultValue: "",
                    helperText: "This is id for scroll to section below."
                }
            ]
        }
    ]
};
const b2b_video_carousel_builder_component_builderConfig = {
    component: b2b_video_carousel_wrapper,
    config: B2BVideoCarouselBuilderConfig
};
/* harmony default export */ var b2b_video_carousel_builder_component = (b2b_video_carousel_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-video-list/b2b-video-list.module.scss
var b2b_video_list_module = __webpack_require__(29960);
var b2b_video_list_module_default = /*#__PURE__*/__webpack_require__.n(b2b_video_list_module);
// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-card-selected/b2b-card-selected.module.scss
var b2b_card_selected_module = __webpack_require__(74522);
var b2b_card_selected_module_default = /*#__PURE__*/__webpack_require__.n(b2b_card_selected_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-card-selected/b2b-card-selected.tsx
/* eslint-disable @next/next/no-img-element */ 







const B2BCardSelected = (props)=>{
    const { video  } = props;
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const windowWidth = (windowSize === null || windowSize === void 0 ? void 0 : windowSize.width) || 0;
    const isMobile = windowWidth && windowWidth <= 768 ? true : false;
    const ratioImage = isMobile ? [
        345,
        345
    ] : [
        720,
        638
    ];
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (b2b_card_selected_module_default()).videoWrap,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_card_selected_module_default()).videoWrapButtonPlay,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                    type: icons/* IconType.Triangle2 */.T.Triangle2
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(image_zoom, {
                ratio: ratioImage,
                src: (ref = video === null || video === void 0 ? void 0 : video.leadImage) !== null && ref !== void 0 ? ref : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_card_selected_module_default()).videoOverlay
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (b2b_card_selected_module_default()).videoContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: (b2b_card_selected_module_default()).videoItemImageBrand,
                        src: (ref1 = video === null || video === void 0 ? void 0 : video.imageBrandUrl) !== null && ref1 !== void 0 ? ref1 : "",
                        alt: "",
                        priority: false,
                        loading: "lazy",
                        width: 160,
                        height: 32,
                        fill: false,
                        style: {
                            objectFit: "scale-down",
                            objectPosition: "left"
                        },
                        loader: (param)=>{
                            let { src , width , quality  } = param;
                            return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (b2b_card_selected_module_default()).videoContainerTitle,
                        children: video === null || video === void 0 ? void 0 : video.title
                    }),
                    (video === null || video === void 0 ? void 0 : video.description) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (b2b_card_selected_module_default()).videoContainerDescription,
                        children: video === null || video === void 0 ? void 0 : video.description
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (b2b_card_selected_module_default()).videoContainerWatchNow,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Watch Now"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: icons/* IconType.ArrowRightMedium3 */.T.ArrowRightMedium3
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: (video === null || video === void 0 ? void 0 : video.videoUrl) || "",
                className: (b2b_card_selected_module_default()).videoLink
            })
        ]
    });
};
/* harmony default export */ var b2b_card_selected = (B2BCardSelected);

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-video-list/b2b-video-list.tsx







const B2BVideoList = (props)=>{
    const { videoList , watchAllUrl , description , title , ctaText  } = props;
    const [videoSelected, setVideoSelected] = (0,react.useState)(videoList === null || videoList === void 0 ? void 0 : videoList[0]);
    (0,react.useEffect)(()=>{
        if (videoList && (videoList === null || videoList === void 0 ? void 0 : videoList.length) > 0) {
            setVideoSelected(videoList[0]);
        }
    }, [
        videoList
    ]);
    if (!videoList || (videoList === null || videoList === void 0 ? void 0 : videoList.length) === 0) {
        return null;
    }
    const renderVideoItem = (video)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (b2b_video_list_module_default()).videoItem,
            onMouseEnter: ()=>setVideoSelected(video),
            onClick: ()=>setVideoSelected(video),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: (b2b_video_list_module_default()).videoItemImageBrand,
                    src: video.imageBrandUrl,
                    alt: "",
                    priority: false,
                    loading: "lazy",
                    width: 160,
                    height: 32,
                    fill: false,
                    style: {
                        objectFit: "scale-down",
                        objectPosition: "left"
                    },
                    loader: (param)=>{
                        let { src , width , quality  } = param;
                        return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (b2b_video_list_module_default()).videoItemContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (b2b_video_list_module_default()).videoItemTitle,
                            children: video.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: icons/* IconType.ArrowRightBig2 */.T.ArrowRightBig2
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: video.videoUrl,
                    className: (b2b_video_list_module_default()).videoItemLink
                })
            ]
        }, "video_item_".concat(video.leadImage));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (b2b_video_list_module_default()).videoList,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (b2b_video_list_module_default()).videoListHeader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (b2b_video_list_module_default()).videoListHeaderText,
                                children: title
                            }),
                            description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (b2b_video_list_module_default()).videoListDescriptionText,
                                children: description
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (b2b_video_list_module_default()).videoListHeaderTextWatchAll,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (b2b_video_list_module_default()).businessButtonText,
                                children: ctaText !== null && ctaText !== void 0 ? ctaText : "Learn more"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: icons/* IconType.ArrowRightMedium3 */.T.ArrowRightMedium3
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: watchAllUrl,
                                className: (b2b_video_list_module_default()).linkWatchAllVideo
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_video_list_module_default()).videoBlock,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(b2b_card_selected, {
                    video: videoSelected
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_video_list_module_default()).videoListContainer,
                children: videoList === null || videoList === void 0 ? void 0 : videoList.map((video)=>renderVideoItem(video))
            })
        ]
    });
};
/* harmony default export */ var b2b_video_list = (B2BVideoList);

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-video-list/b2b-video-list.builder-component.ts

const B2bVideoListBuilderConfig = {
    name: "B2B Video List",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: "Make it your Way"
        },
        {
            name: "description",
            type: "string"
        },
        {
            name: "ctaText",
            type: "string",
            defaultValue: "Learn More"
        },
        {
            name: "videoList",
            type: "list",
            subFields: [
                {
                    name: "title",
                    type: "string"
                },
                {
                    name: "description",
                    type: "string"
                },
                {
                    name: "leadImage",
                    type: "file"
                },
                {
                    name: "imageBrandUrl",
                    type: "file"
                },
                {
                    name: "videoUrl",
                    type: "string"
                }
            ]
        },
        {
            name: "watchAllUrl",
            type: "string"
        }
    ]
};
const b2b_video_list_builder_component_builderConfig = {
    component: b2b_video_list,
    config: B2bVideoListBuilderConfig
};
/* harmony default export */ var b2b_video_list_builder_component = (b2b_video_list_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/article-grid/article-grid.tsx
var article_grid = __webpack_require__(13650);
;// CONCATENATED MODULE: ./components/business-article-grid/business-article-grid.tsx





const BusinessArticleGrid = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    var _initialArticles;
    const [articles, setArticles] = (0,react.useState)((_initialArticles = props.initialArticles) !== null && _initialArticles !== void 0 ? _initialArticles : []);
    const [offset, setOffsetArticle] = (0,react.useState)(props.offset);
    const [isLoadingMoreArticles, setIsLoadingMoreArticles] = (0,react.useState)(false);
    const getUniqueArticles = (newArticles)=>{
        let mapper = {};
        newArticles.forEach((article)=>{
            mapper[article.builderModel.id] = article;
        });
        return Object.values(mapper);
    };
    (0,react.useEffect)(()=>{
        let cancelled = false;
        if (offset !== props.offset) {
            setIsLoadingMoreArticles(true);
            (0,BuilderHelper/* getLatestArticles */.gg)({
                locale,
                offset,
                limit: props.offset !== offset ? 10 : 9
            }).then((newArticles)=>{
                if (!cancelled && newArticles) {
                    setArticles((oldArticles)=>getUniqueArticles([
                            ...oldArticles,
                            ...newArticles
                        ]));
                }
            }).finally(()=>{
                if (!cancelled) {
                    setIsLoadingMoreArticles(false);
                }
            });
        }
        return ()=>{
            cancelled = true;
        };
    }, [
        offset
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(article_grid/* default */.Z, {
        articles: articles,
        isLoadingMoreArticles: isLoadingMoreArticles,
        setOffsetArticle: setOffsetArticle,
        offsetArticle: offset
    });
};

;// CONCATENATED MODULE: ./components/business-article-grid/business-article-grid.constants.ts
var ArticleGridSource;
(function(ArticleGridSource) {
    ArticleGridSource["Latest"] = "latest";
    ArticleGridSource["Standard"] = "standard";
})(ArticleGridSource || (ArticleGridSource = {}));
const business_article_grid_constants_ALL_ARTICLE_GRID_TYPES = Object.values(ArticleGridSource);

;// CONCATENATED MODULE: ./components/business-article-grid/business-article-grid.builder-component.ts


const BusinessArticleGridBuilderConfig = {
    name: "Article Grid",
    inputs: [
        {
            name: "offset",
            type: "number",
            default: 0
        },
        {
            name: "articleSource",
            type: "text",
            enum: business_article_grid_constants_ALL_ARTICLE_GRID_TYPES
        }
    ]
};
const business_article_grid_builder_component_builderConfig = {
    component: BusinessArticleGrid,
    config: BusinessArticleGridBuilderConfig
};
/* harmony default export */ var business_article_grid_builder_component = (business_article_grid_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-article-single-hero/business-article-single-hero.tsx + 1 modules
var business_article_single_hero = __webpack_require__(72379);
// EXTERNAL MODULE: ./contexts/LayoutContext.tsx
var LayoutContext = __webpack_require__(21513);
;// CONCATENATED MODULE: ./components/business-article-hero/business-featured-article-hero/business-featured-article-hero.tsx



const FeaturedArticleHero = (props)=>{
    const { breadcrumbs  } = (0,LayoutContext/* useBusinessLayout */.Vp)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !!props.article && /*#__PURE__*/ (0,jsx_runtime.jsx)(business_article_single_hero/* default */.Z, {
            article: props.article,
            isMarginLower: true,
            breadcrumbs: breadcrumbs,
            isShowReadMore: true,
            isFeaturedBlock: true
        })
    });
};

;// CONCATENATED MODULE: ./components/business-article-hero/business-featured-article-hero/business-featured-article-hero.builder-component.ts

const FullWidthArticleHeroBuilderConfig = {
    name: "Full Width Featured Article Hero",
    inputs: []
};
const business_featured_article_hero_builder_component_builderConfig = {
    component: FeaturedArticleHero,
    config: FullWidthArticleHeroBuilderConfig
};
/* harmony default export */ var business_featured_article_hero_builder_component = (business_featured_article_hero_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-article-image/business-article-image.module.scss
var business_article_image_module = __webpack_require__(55746);
var business_article_image_module_default = /*#__PURE__*/__webpack_require__.n(business_article_image_module);
;// CONCATENATED MODULE: ./components/business-article-image/business-article-image.tsx




const BusinessArticleImage = (props)=>{
    const { image , autoHeight , autoWidth , squared  } = props;
    const [imageBoxStyle, setImageBoxStyle] = (0,react.useState)({});
    const [articleImageWrapperStyle, setArticleImageWrapperStyle] = (0,react.useState)({});
    (0,react.useEffect)(()=>{
        const img = new Image();
        img.onload = function() {
            if (autoWidth) {
                setArticleImageWrapperStyle({
                    maxWidth: Math.min(872, img.width),
                    width: "100%"
                });
            } else {
                setArticleImageWrapperStyle({});
            }
            if (autoHeight) {
                setImageBoxStyle({
                    paddingTop: "".concat(img.height / img.width * 100, "%")
                });
            } else {
                setImageBoxStyle({
                    paddingTop: "".concat(581 / 872 * 100, "%")
                });
            }
        };
        img.src = image;
    }, [
        autoHeight,
        image,
        autoWidth
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_article_image_module_default()).businessArticleImageContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (business_article_image_module_default()).businessArticleImageWrapper,
            style: articleImageWrapperStyle,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((business_article_image_module_default()).businessArticleImageBox, {
                    [(business_article_image_module_default()).squared]: squared
                }),
                style: imageBoxStyle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_article_image_module_default()).businessArticleImage,
                    style: {
                        backgroundImage: "url('".concat(image, "')")
                    }
                })
            })
        })
    });
};
/* harmony default export */ var business_article_image = (BusinessArticleImage);

;// CONCATENATED MODULE: ./components/business-article-image/business-article-image.builder-component.ts

const BusinessArticleImageBuilderConfig = {
    name: "Article Image",
    inputs: [
        {
            name: "image",
            type: "file",
            required: true
        },
        {
            name: "autoHeight",
            type: "boolean"
        },
        {
            name: "autoWidth",
            type: "boolean"
        },
        {
            name: "squared",
            type: "boolean"
        }
    ]
};
const business_article_image_builder_component_builderConfig = {
    component: business_article_image,
    config: BusinessArticleImageBuilderConfig
};
/* harmony default export */ var business_article_image_builder_component = (business_article_image_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/business-article-quote/business-article-quote.constants.ts
const BACKGROUND_COLORS = {
    MINT: "mint",
    PLUM: "plum"
};
const WIDTHS = {
    SMALL: "small",
    MEDIUM: "medium",
    LARGE: "large",
    FULL: "full"
};

// EXTERNAL MODULE: ./components/business-article-quote/business-article-quote.module.scss
var business_article_quote_module = __webpack_require__(59891);
var business_article_quote_module_default = /*#__PURE__*/__webpack_require__.n(business_article_quote_module);
;// CONCATENATED MODULE: ./components/business-article-quote/business-article-quote.tsx






const BusinessArticleQuoteWrap = (props)=>{
    const { text , authorName , backgroundColor =BACKGROUND_COLORS.MINT , width =WIDTHS.MEDIUM  } = props;
    const { breadcrumbType  } = (0,LayoutContext/* useBusinessLayout */.Vp)();
    const getBackgroundColor = ()=>{
        const backgroundColorMap = {
            [BACKGROUND_COLORS.MINT]: "#b2fce4",
            [BACKGROUND_COLORS.PLUM]: "#EADDF2"
        };
        return backgroundColorMap[backgroundColor];
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_article_quote_module_default()).businessArticleQuoteContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((business_article_quote_module_default()).businessArticleQuoteBox, (business_article_quote_module_default())[breadcrumbType]),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_article_quote_module_default()).businessArticleQuote,
                        dangerouslySetInnerHTML: {
                            __html: text
                        }
                    }),
                    authorName && authorName !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (business_article_quote_module_default()).businessArticleAuthorName,
                        children: authorName
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    backgroundColor: getBackgroundColor()
                },
                className: (business_article_quote_module_default()).businessArticleQuoteBackground + " " + (business_article_quote_module_default())[width]
            })
        ]
    });
};
/* harmony default export */ var business_article_quote = (BusinessArticleQuoteWrap);

;// CONCATENATED MODULE: ./components/business-article-quote/business-article-quote-wrap.builder-component.ts


const BusinessArticleQuoteWrapBuilderConfig = {
    name: "Article Quote",
    inputs: [
        {
            name: "text",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "authorName",
            type: "string",
            defaultValue: ""
        },
        {
            name: "backgroundColor",
            type: "string",
            enum: Object.values(BACKGROUND_COLORS),
            defaultValue: BACKGROUND_COLORS.PLUM
        },
        {
            name: "width",
            type: "string",
            enum: Object.values(WIDTHS),
            defaultValue: WIDTHS.MEDIUM
        }
    ]
};
const business_article_quote_wrap_builder_component_builderConfig = {
    component: business_article_quote,
    config: BusinessArticleQuoteWrapBuilderConfig
};
/* harmony default export */ var business_article_quote_wrap_builder_component = (business_article_quote_wrap_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/business-button/business-button-wrap.builder-component.ts


const BusinessButtonWrapBuilderConfig = {
    name: "Button",
    inputs: [
        {
            name: "buttonText",
            type: "string",
            defaultValue: ""
        },
        {
            name: "color",
            type: "string",
            enum: Object.values(business_button_constants/* COLORS */.DM),
            defaultValue: business_button_constants/* COLORS.MINT */.DM.MINT
        },
        {
            name: "size",
            type: "string",
            enum: Object.values(business_button_constants/* SIZES */.zf),
            defaultValue: business_button_constants/* SIZES.NORMAL */.zf.NORMAL
        },
        {
            name: "icon",
            type: "string",
            enum: Object.values(business_button_constants/* ICONS */.UZ),
            defaultValue: business_button_constants/* ICONS.ArrowBack */.UZ.ArrowBack
        },
        {
            name: "link",
            type: "url",
            defaultValue: ""
        },
        {
            name: "square",
            type: "boolean",
            defaultValue: false
        },
        {
            name: "position",
            type: "string",
            enum: Object.values(business_button_constants/* POSITION */.Vr),
            defaultValue: business_button_constants/* POSITION.CENTER */.Vr.CENTER
        }
    ]
};
const business_button_wrap_builder_component_builderConfig = {
    component: business_button/* default */.Z,
    config: BusinessButtonWrapBuilderConfig
};
/* harmony default export */ var business_button_wrap_builder_component = (business_button_wrap_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-collapse/business-collapse.tsx
var business_collapse = __webpack_require__(4980);
;// CONCATENATED MODULE: ./components/business-collapse/business-collapse.builder-component.ts

const BusinessCollapseTextBuilderConfig = {
    name: "Collapse",
    image: "https://cdn.builder.io/api/v1/image/assets%2F035a3d41874344d79b6c7499e2e7a5bc%2F3810bcb3ce57490b8f66ce0b394f54a2",
    screenshot: "https://cdn.builder.io/api/v1/image/assets%2F035a3d41874344d79b6c7499e2e7a5bc%2F8bfa3504d5c84d9eaf5dfa7950c7e768",
    canHaveChildren: true,
    inputs: [
        {
            name: "item",
            type: "object",
            copyOnAdd: false,
            subFields: [
                {
                    name: "title",
                    type: "richText"
                },
                {
                    name: "content",
                    type: "uiBlocks",
                    defaultValue: []
                }
            ],
            defaultValue: {
                name: "Collapse 1",
                content: []
            }
        }
    ]
};
const business_collapse_builder_component_builderConfig = {
    component: business_collapse/* default */.Z,
    config: BusinessCollapseTextBuilderConfig
};
/* harmony default export */ var business_collapse_builder_component = (business_collapse_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-emphasized-text/business-emphasized-text.module.scss
var business_emphasized_text_module = __webpack_require__(77926);
var business_emphasized_text_module_default = /*#__PURE__*/__webpack_require__.n(business_emphasized_text_module);
;// CONCATENATED MODULE: ./components/business-emphasized-text/business-emphasized-text.tsx





const BusinessEmphasizedText = (props)=>{
    const { text , textSize  } = props;
    const { breadcrumbType  } = (0,LayoutContext/* useBusinessLayout */.Vp)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_emphasized_text_module_default()).businessEmphasizedTextContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()((business_emphasized_text_module_default()).businessEmphasizedText, (business_emphasized_text_module_default())[breadcrumbType], {
                [(business_emphasized_text_module_default()).small]: textSize === "small"
            }),
            dangerouslySetInnerHTML: {
                __html: text
            }
        })
    });
};
/* harmony default export */ var business_emphasized_text = (BusinessEmphasizedText);

;// CONCATENATED MODULE: ./components/business-emphasized-text/business-emphasized-text.builder-component.ts

const BusinessEmphasizedTextBuilderConfig = {
    name: "Emphasized Text",
    inputs: [
        {
            name: "text",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "textSize",
            type: "enum",
            enum: [
                "default",
                "small"
            ]
        }
    ]
};
const business_emphasized_text_builder_component_builderConfig = {
    component: business_emphasized_text,
    config: BusinessEmphasizedTextBuilderConfig
};
/* harmony default export */ var business_emphasized_text_builder_component = (business_emphasized_text_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/business-framed-info-block/business-framed-info-block.constants.ts
const business_framed_info_block_constants_IMAGE_POSITIONS = {
    LEFT: "left",
    RIGHT: "right"
};

// EXTERNAL MODULE: ./components/business-framed-info-block/business-framed-info-block.module.scss
var business_framed_info_block_module = __webpack_require__(87882);
var business_framed_info_block_module_default = /*#__PURE__*/__webpack_require__.n(business_framed_info_block_module);
;// CONCATENATED MODULE: ./components/business-framed-info-block/business-framed-info-block.tsx








const business_framed_info_block_FramedInfoBlock = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const { borderColor =DEFAULT_BACKGROUND_COLORS.MINT , image , title , description , mediaPosition ="left" , ctaText , ctaIcon  } = props;
    var _url;
    let url = (0,LangHelper/* replaceOrAddLocale */.yM)((_url = props.url) !== null && _url !== void 0 ? _url : "", locale);
    const mediaBlock = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((business_framed_info_block_module_default()).businessResourceBlockMediaContainer, " ").concat((business_framed_info_block_module_default())[mediaPosition]),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_framed_info_block_module_default()).businessResourceBlockMedia,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((business_framed_info_block_module_default()).mediaImageWrapper, " ").concat((business_framed_info_block_module_default())[mediaPosition]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_framed_info_block_module_default()).mediaImageBox,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_framed_info_block_module_default()).mediaImageMain,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_zoom, {
                                    src: image
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((business_framed_info_block_module_default()).mediaBackground, " ").concat((business_framed_info_block_module_default())[mediaPosition]),
                        style: {
                            backgroundColor: mapNameToColour(borderColor)
                        }
                    })
                ]
            })
        });
    const infoBlock = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((business_framed_info_block_module_default()).businessResourceBlockInfo, " ").concat((business_framed_info_block_module_default())[mediaPosition]),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_framed_info_block_module_default()).infoTitle,
                    dangerouslySetInnerHTML: {
                        __html: title
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_framed_info_block_module_default()).infoDescription,
                    dangerouslySetInnerHTML: {
                        __html: description
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: url,
                    className: (business_framed_info_block_module_default()).infoCTA,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: ctaText !== null && ctaText !== void 0 ? ctaText : "Download"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: ctaIcon !== null && ctaIcon !== void 0 ? ctaIcon : icons/* IconType.Download */.T.Download
                        })
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_framed_info_block_module_default()).businessResourceBlockContainer,
        children: [
            mediaPosition === business_framed_info_block_constants_IMAGE_POSITIONS.LEFT ? mediaBlock() : null,
            infoBlock(),
            mediaPosition === business_framed_info_block_constants_IMAGE_POSITIONS.RIGHT ? mediaBlock() : null
        ]
    });
};
/* harmony default export */ var business_framed_info_block = (business_framed_info_block_FramedInfoBlock);

;// CONCATENATED MODULE: ./components/business-framed-info-block/business-framed-info-block.builder-component.ts




const BusinessFramedInfoBlockBuilderConfig = {
    name: "Framed Info Block",
    inputs: [
        {
            name: "borderColor",
            type: "string",
            enum: Object.values(DEFAULT_BACKGROUND_COLORS),
            defaultValue: DEFAULT_BACKGROUND_COLORS.MINT
        },
        {
            name: "image",
            type: "file",
            required: true
        },
        {
            name: "title",
            type: "string",
            defaultValue: ""
        },
        {
            name: "description",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "url",
            type: "url"
        },
        {
            name: "ctaText",
            type: "string",
            defaultValue: ""
        },
        {
            name: "ctaIcon",
            type: "string",
            enum: [
                icons/* IconType.Download */.T.Download,
                icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
            ]
        },
        {
            name: "mediaPosition",
            type: "string",
            enum: Object.values(business_framed_info_block_constants_IMAGE_POSITIONS),
            defaultValue: business_framed_info_block_constants_IMAGE_POSITIONS.LEFT
        }
    ]
};
const business_framed_info_block_builder_component_builderConfig = {
    component: business_framed_info_block,
    config: BusinessFramedInfoBlockBuilderConfig
};
/* harmony default export */ var business_framed_info_block_builder_component = (business_framed_info_block_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/learning-card/learning-card.module.scss
var learning_card_module = __webpack_require__(30853);
var learning_card_module_default = /*#__PURE__*/__webpack_require__.n(learning_card_module);
;// CONCATENATED MODULE: ./components/learning-card/learning-card.tsx








const LearningCard = (props)=>{
    const { learningSeries  } = props;
    const [quantityArticle, setQuantityArticle] = (0,react.useState)(null);
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const category = learningSeries.category;
    (0,react.useEffect)(()=>{
        let cancelled = false;
        if (!learningSeries) return;
        if (learningSeries.articleCount) {
            setQuantityArticle(learningSeries.articleCount);
        } else {
            (0,BuilderHelper/* getAllArticles */.zC)(locale, {
                categoryIds: [
                    category.id
                ],
                limit: 30
            }).then((article)=>{
                if (!cancelled) {
                    setQuantityArticle(article.length);
                }
            });
        }
        return ()=>{
            cancelled = true;
        };
    }, [
        learningSeries
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (learning_card_module_default()).learningCard,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(image_zoom, {
                src: (category === null || category === void 0 ? void 0 : category.image) || "",
                ratio: [
                    424,
                    540
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (learning_card_module_default()).overlay
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (learning_card_module_default()).learningCardContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (learning_card_module_default()).quantity,
                        children: [
                            quantityArticle,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: quantityArticle && quantityArticle > 1 ? " ARTICLES" : " ARTICLE"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "".concat((learning_card_module_default()).title, " ").concat((learning_card_module_default()).threeLinesLimit),
                        children: category.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "".concat((learning_card_module_default()).description, " ").concat((learning_card_module_default()).threeLinesLimit),
                        children: category.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (learning_card_module_default()).btnReadAll,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Read all"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                className: (learning_card_module_default()).learningUrl,
                href: (0,LangHelper/* replaceOrAddLocale */.yM)(category.categoryUrl || "", locale),
                rel: "noreferrer"
            })
        ]
    });
};
/* harmony default export */ var learning_card = (LearningCard);

// EXTERNAL MODULE: ./components/sign-up-card/sign-up-card.tsx
var sign_up_card = __webpack_require__(78845);
;// CONCATENATED MODULE: ./components/headlining-articles-block/headlining-articles-block.constants.ts
const headlining_articles_block_constants_TYPES_OF_CARD = {
    ARTICLE: "article",
    LEARNING: "learning"
};

// EXTERNAL MODULE: ./components/headlining-articles-block/headlining-articles-block.module.scss
var headlining_articles_block_module = __webpack_require__(48313);
var headlining_articles_block_module_default = /*#__PURE__*/__webpack_require__.n(headlining_articles_block_module);
;// CONCATENATED MODULE: ./components/headlining-articles-block/headlining-articles-block.tsx














swiper/* default.use */.Z.use([
    modules/* Navigation */.W_
]);
const HeadliningArticlesBlock = (props)=>{
    const { cardData , showSignupCard =true , typeOfCard =headlining_articles_block_constants_TYPES_OF_CARD.ARTICLE , includeLargeCard  } = props;
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const windowWidth = windowSize.width || 0;
    const isMobile = windowWidth <= 768 ? true : false;
    const prevRef = (0,react.useRef)(null);
    const nextRef = (0,react.useRef)(null);
    const navigationConfig = {
        prevEl: prevRef.current ? prevRef.current : undefined,
        nextEl: nextRef.current ? nextRef.current : undefined
    };
    // Because layout breaks if you try to populate the DOM before slider is initalised, we debounce it with state, Only set data after swiper is initialised
    const [swiperCardList, setSwiperCardList] = (0,react.useState)(props.debounce ? [] : cardData);
    const { ref , inView  } = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true
    });
    const [swiper, setSwiper] = (0,react.useState)(null);
    const swiperOption = {
        navigation: navigationConfig,
        slidesPerView: "auto",
        spaceBetween: isMobile ? 8 : 24,
        centeredSlides: isMobile,
        centeredSlidesBounds: true,
        watchOverflow: true,
        lazyPreloadPrevNext: 1,
        updateOnWindowResize: true,
        init: false
    };
    (0,react.useEffect)(()=>{
        if (swiper && inView) {
            swiper.init();
            setSwiperCardList(cardData);
        }
    }, [
        swiper,
        inView,
        cardData
    ]);
    const cardTemplate = [
        article_card/* ArticleCardType.Large */._.Large,
        article_card/* ArticleCardType.Small */._.Small,
        article_card/* ArticleCardType.Small */._.Small
    ];
    const getCard = (item, cardSize)=>{
        switch(typeOfCard){
            case headlining_articles_block_constants_TYPES_OF_CARD.ARTICLE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(article_card/* default */.Z, {
                    type: cardSize || article_card/* ArticleCardType.Small */._.Small,
                    article: item,
                    fixedWidth: true
                });
            case headlining_articles_block_constants_TYPES_OF_CARD.LEARNING:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(learning_card, {
                    learningSeries: item
                });
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(article_card/* default */.Z, {
                    type: cardSize || article_card/* ArticleCardType.Small */._.Small,
                    article: item,
                    fixedWidth: true
                });
        }
    };
    const renderArticleItem = (item, index)=>{
        let cardSize = article_card/* ArticleCardType.Small */._.Small;
        if (includeLargeCard && !isMobile) {
            cardSize = cardTemplate[index % cardTemplate.length];
        }
        if (index === cardData.length - 1) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                className: classnames_default()((headlining_articles_block_module_default()).headliningArticlesBlockSlide, {
                    [(headlining_articles_block_module_default()).headliningArticlesBlockSlideLarge]: cardSize === article_card/* ArticleCardType.Large */._.Large
                }),
                children: showSignupCard ? /*#__PURE__*/ (0,jsx_runtime.jsx)(sign_up_card/* default */.Z, {}) : getCard(item, cardSize)
            }, "card_slide_key_".concat(index));
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
            className: classnames_default()((headlining_articles_block_module_default()).headliningArticlesBlockSlide, {
                [(headlining_articles_block_module_default()).headliningArticlesBlockSlideLarge]: cardSize === article_card/* ArticleCardType.Large */._.Large
            }),
            children: getCard(item, cardSize)
        }, "card_slide_key_".concat(index));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (headlining_articles_block_module_default()).headliningArticlesBlock,
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: nextRef,
                className: (headlining_articles_block_module_default()).swiperButtonNext,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                    type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: prevRef,
                className: (headlining_articles_block_module_default()).swiperButtonPrev,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                    type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                ...swiperOption,
                onInit: (swiper)=>{
                    if (!swiper) {
                        return;
                    }
                    const navigation = swiper === null || swiper === void 0 ? void 0 : swiper.params.navigation;
                    navigation.prevEl = prevRef.current;
                    navigation.nextEl = nextRef.current;
                    swiper.navigation.init();
                    swiper.navigation.update();
                },
                onSwiper: (sw)=>{
                    setSwiper(sw);
                },
                className: (headlining_articles_block_module_default()).headliningArticlesSlider,
                children: (swiperCardList || []).map((item, index)=>renderArticleItem(item, index))
            })
        ]
    });
};
/* harmony default export */ var headlining_articles_block = (HeadliningArticlesBlock);

;// CONCATENATED MODULE: ./components/business-headlining-latest-articles/business-headlining-latest-articles.tsx





const BusinessHeadliningLatestArticles = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const [featuredArticles, setFeaturedArticles] = (0,react.useState)(props.articles || []);
    const [isFirstLoad, setIsFirstLoad] = (0,react.useState)(true);
    (0,react.useEffect)(()=>{
        let cancelled = false;
        // Return on first load since articles would be populated via getStaticProps
        if (isFirstLoad && featuredArticles.length) {
            setIsFirstLoad(true);
            return;
        }
        setIsFirstLoad(false);
        var _offset;
        (0,BuilderHelper/* getLatestArticles */.gg)({
            locale,
            offset: (_offset = props.offset) !== null && _offset !== void 0 ? _offset : 1,
            limit: 3
        }).then((articles)=>{
            if (!cancelled) {
                setFeaturedArticles(articles);
            }
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        props.offset
    ]);
    var _showSignupForAfterpay;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(headlining_articles_block, {
        cardData: featuredArticles,
        showSignupCard: (_showSignupForAfterpay = props.showSignupForAfterpay) !== null && _showSignupForAfterpay !== void 0 ? _showSignupForAfterpay : false
    });
};

;// CONCATENATED MODULE: ./components/business-headlining-latest-articles/business-headlining-latest-articles.builder-component.ts

const HeadliningLatestArticlesBuilderConfig = {
    name: "Headlining Latest Articles",
    inputs: [
        {
            name: "offset",
            type: "text",
            default: "1"
        },
        {
            name: "showSignupForAfterpay",
            type: "boolean",
            default: true
        }
    ]
};
const business_headlining_latest_articles_builder_component_builderConfig = {
    component: BusinessHeadliningLatestArticles,
    config: HeadliningLatestArticlesBuilderConfig
};
/* harmony default export */ var business_headlining_latest_articles_builder_component = (business_headlining_latest_articles_builder_component_builderConfig);

// EXTERNAL MODULE: ./node_modules/@builder.io/react/dist/builder-react.es5.js
var builder_react_es5 = __webpack_require__(75102);
// EXTERNAL MODULE: ./node_modules/gsap/index.js + 1 modules
var node_modules_gsap = __webpack_require__(30334);
// EXTERNAL MODULE: ./node_modules/react-fast-marquee/dist/index.js
var react_fast_marquee_dist = __webpack_require__(87834);
// EXTERNAL MODULE: ./components/business-hub-trusted-brand/business-hub-trusted-brand.module.scss
var business_hub_trusted_brand_module = __webpack_require__(23884);
var business_hub_trusted_brand_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_trusted_brand_module);
;// CONCATENATED MODULE: ./components/business-hub-trusted-brand/business-hub-trusted-brand.tsx






const BusinessHubTrustedBrand = (props)=>{
    const { title , className , trustedBrands =[] , industryCommon , textColor , background , roundedBottom , isCarousel  } = props;
    const brands = (0,react.useMemo)(()=>{
        var ref, ref1;
        if ((trustedBrands === null || trustedBrands === void 0 ? void 0 : trustedBrands.length) > 0) return trustedBrands;
        const commonTrustedBrands = (ref1 = industryCommon === null || industryCommon === void 0 ? void 0 : (ref = industryCommon.value) === null || ref === void 0 ? void 0 : ref.data) === null || ref1 === void 0 ? void 0 : ref1.trustedBrands;
        if (commonTrustedBrands && commonTrustedBrands.length > 0) return commonTrustedBrands;
        return [];
    }, [
        trustedBrands,
        industryCommon
    ]);
    const _renderItem = (item)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: item.logo,
            alt: "",
            style: {
                objectFit: "contain",
                objectPosition: "center center"
            },
            fill: true,
            sizes: "(max-width: 638px) 98vw, (max-width: 998px) 43vw, 46vw",
            loading: "eager",
            loader: (param)=>{
                let { src , width , quality  } = param;
                return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
            },
            className: (business_hub_trusted_brand_module_default()).image
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((business_hub_trusted_brand_module_default()).container, className),
        style: {
            "--data-text-color": textColor,
            "--data-background": background
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((business_hub_trusted_brand_module_default()).background, {
                    [(business_hub_trusted_brand_module_default()).roundedBottom]: roundedBottom
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_hub_trusted_brand_module_default()).wrapperContent,
                children: [
                    title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_hub_trusted_brand_module_default()).title,
                        children: title
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((business_hub_trusted_brand_module_default()).wrapperLogo, {
                            [(business_hub_trusted_brand_module_default()).flexWrap]: !isCarousel,
                            [(business_hub_trusted_brand_module_default()).fullwidth]: isCarousel
                        }),
                        children: isCarousel ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_fast_marquee_dist/* default */.Z, {
                            loop: 0,
                            autoFill: true,
                            children: brands.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((business_hub_trusted_brand_module_default()).logo, " ").concat((business_hub_trusted_brand_module_default()).autoMargin),
                                    style: {
                                        aspectRatio: "".concat(item.ratio ? 1 / item.ratio : ""),
                                        maxWidth: item.maxWidth,
                                        height: item.maxHeight
                                    },
                                    children: _renderItem(item)
                                }, "".concat(item.logo, "-").concat(index)))
                        }) : brands.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_hub_trusted_brand_module_default()).logo,
                                style: {
                                    aspectRatio: "".concat(item.ratio ? 1 / item.ratio : ""),
                                    maxWidth: item.maxWidth,
                                    height: item.maxHeight
                                },
                                children: _renderItem(item)
                            }, item.logo))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var business_hub_trusted_brand = (BusinessHubTrustedBrand);

// EXTERNAL MODULE: ./components/business-hub-build-for-industry/business-hub-build-for-industry.module.scss
var business_hub_build_for_industry_module = __webpack_require__(21922);
var business_hub_build_for_industry_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_build_for_industry_module);
// EXTERNAL MODULE: ./components/business-hub-build-for-industry/industries-item.module.scss
var industries_item_module = __webpack_require__(35618);
var industries_item_module_default = /*#__PURE__*/__webpack_require__.n(industries_item_module);
;// CONCATENATED MODULE: ./components/business-hub-build-for-industry/industries-item.tsx







const IndustriesItem = (props)=>{
    const { icon ="" , name , description , bannerImage , reversed , hide , builderPage , quote , video , showQuote , showLearnMore  } = props;
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const url = (0,react.useMemo)(()=>{
        var ref;
        if (!(builderPage === null || builderPage === void 0 ? void 0 : (ref = builderPage.value) === null || ref === void 0 ? void 0 : ref.data)) return "";
        return (0,LangHelper/* replaceOrAddLocale */.yM)(builderPage === null || builderPage === void 0 ? void 0 : builderPage.value.data.url, locale);
    }, [
        locale,
        builderPage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((industries_item_module_default()).container, {
            [(industries_item_module_default()).reversed]: reversed,
            [(industries_item_module_default()).hide]: hide
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (industries_item_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (industries_item_module_default()).title,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (industries_item_module_default()).iconBox,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (industries_item_module_default()).icon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: icon,
                                        alt: "",
                                        style: {
                                            objectFit: "contain",
                                            objectPosition: "center"
                                        },
                                        fill: true,
                                        sizes: "(max-width: 638px) 98vw, (max-width: 998px) 43vw, 46vw",
                                        loader: (param)=>{
                                            let { src , width , quality  } = param;
                                            return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (industries_item_module_default()).description,
                        dangerouslySetInnerHTML: {
                            __html: description || ""
                        }
                    }),
                    showLearnMore && url ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        className: (industries_item_module_default()).link,
                        href: url,
                        target: "_blank",
                        children: "Learn more"
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (industries_item_module_default()).banner,
                children: [
                    bannerImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: bannerImage,
                        alt: "",
                        style: {
                            objectFit: "cover",
                            objectPosition: "bottom"
                        },
                        fill: true,
                        sizes: "(max-width: 638px) 98vw, (max-width: 998px) 43vw, 46vw",
                        loading: "eager",
                        loader: (param)=>{
                            let { src , width , quality  } = param;
                            return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                        }
                    }) : null,
                    showQuote && quote ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (industries_item_module_default()).bannerOverlay,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (industries_item_module_default()).quoteContent,
                                dangerouslySetInnerHTML: {
                                    __html: quote.content || ""
                                }
                            }),
                            quote.author ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (industries_item_module_default()).quoteAuthor,
                                children: quote.author
                            }) : null,
                            quote.company || video ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (industries_item_module_default()).bannerFooter,
                                children: [
                                    quote.company ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (industries_item_module_default()).quoteCompany,
                                        children: quote.company
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                    video ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: video,
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            width: "41",
                                            height: "44",
                                            viewBox: "0 0 41 44",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M8.45128 44C7.11993 44 5.78864 43.6546 4.5547 42.995C1.92447 41.5815 0.300781 38.8487 0.300781 35.8647V8.12856C0.300781 5.14452 1.92447 2.41209 4.5547 0.998599C7.08752 -0.383483 10.1074 -0.320922 12.5753 1.12398L36.1824 14.9763C38.6827 16.4526 40.2089 19.0597 40.2089 21.9809C40.2089 24.9021 38.7152 27.5092 36.1824 28.9855L12.5753 42.8378C11.2764 43.5917 9.88005 43.9686 8.45128 43.9686V44ZM8.45128 6.30686C8.15903 6.30686 7.93172 6.40128 7.73689 6.49551C7.1524 6.80962 6.79518 7.43755 6.79518 8.16V35.8961C6.79518 36.6186 7.1524 37.2151 7.73689 37.5606C8.06161 37.7491 8.61368 37.8747 9.19817 37.5606L32.8053 23.7087C33.6171 23.2375 33.6821 22.4207 33.6821 22.0752C33.6821 21.7297 33.5846 20.913 32.8053 20.4418L9.19817 6.58946C8.93839 6.4324 8.67858 6.36975 8.45128 6.36975V6.30686Z",
                                                fill: "white"
                                            })
                                        })
                                    }) : null
                                ]
                            }) : null
                        ]
                    }) : null
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/business-hub-build-for-industry/business-hub-build-for-industry.tsx













node_modules_gsap/* default.registerPlugin */.ZP.registerPlugin(src/* useGSAP */.V);
node_modules_gsap/* default.registerPlugin */.ZP.registerPlugin((ScrollToPlugin_default()));
const business_hub_build_for_industry_options = {
    slidesPerView: "auto",
    allowTouchMove: true,
    centeredSlides: true,
    centeredSlidesBounds: true,
    centerInsufficientSlides: true,
    initialSlide: 1,
    freeMode: {
        enabled: true,
        sticky: false
    },
    modules: [
        modules/* FreeMode */.Rv
    ],
    watchOverflow: false,
    grabCursor: true,
    breakpoints: {
        608: {
            initialSlide: 0,
            watchOverflow: true
        }
    }
};
const BusinessHubBuildForIndustry = (props)=>{
    var ref, ref1;
    const { industries: industriesProps , showLearnMore =true , builderState  } = props;
    const config = builderState === null || builderState === void 0 ? void 0 : builderState.state[BusinessHubBuildForIndustryBuilderConfig.name];
    const containerRef = (0,react.useRef)(null);
    const wordsRef = (0,react.useRef)(null);
    const [trustedBrandSwiper, setTrustedBrandSwiper] = (0,react.useState)();
    const [industryCardSwiper, setIndustryCardSwiper] = (0,react.useState)();
    const [industryListSwiper, setIndustryListSwiper] = (0,react.useState)();
    const [activeIndex, setActiveIndex] = (0,react.useState)(-1);
    const clickIndex = (0,react.useRef)(null);
    (0,src/* useGSAP */.V)(()=>{
        if (window.location.hash.startsWith("#industries")) {
            setTimeout(()=>{
                const elem = document.getElementById("industries");
                if (!elem) return;
                const position = elem.getBoundingClientRect();
                node_modules_gsap/* default.to */.ZP.to(window, {
                    duration: 1,
                    scrollTo: position.top + window.scrollY - 116
                });
            }, 500);
        }
    }, {
        scope: containerRef
    });
    (0,react.useEffect)(()=>{
        if (!containerRef.current) return;
        if (!industryListSwiper) return;
        if (activeIndex === -1) {
            industryListSwiper.setProgress(0, 500);
            return;
        }
        const parent = containerRef.current.querySelector(".".concat((business_hub_build_for_industry_module_default()).carouselContainer));
        const elem = containerRef.current.querySelector(".".concat((business_hub_build_for_industry_module_default()).industries, " .").concat((business_hub_build_for_industry_module_default()).carouselItem, ":nth-child(").concat(activeIndex + 1, ")"));
        if (!elem || !parent) return;
        const parentBounds = parent.getBoundingClientRect();
        const childBounds = elem.getBoundingClientRect();
        const center = childBounds.x + childBounds.width / 2;
        const centerParent = parentBounds.width;
        if (childBounds.x < 0) {
            industryListSwiper.setProgress(0.1, 500);
        } else {
            industryListSwiper.setProgress(Math.abs(center / centerParent * (parentBounds.width / industryListSwiper.width)), 500);
        }
    }, [
        activeIndex,
        industryListSwiper,
        containerRef
    ]);
    const industries = (0,react.useMemo)(()=>{
        let indus = industriesProps;
        if (builder_react_es5/* Builder.isEditing */.Ib.isEditing || builder_react_es5/* Builder.isPreviewing */.Ib.isPreviewing) {
            indus = industriesProps || (config === null || config === void 0 ? void 0 : config.industries);
        }
        if (!indus) return indus;
        return indus.sort((a, b)=>{
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
            return 0;
        });
    }, [
        industriesProps,
        config
    ]) || [];
    const changeWords = (0,react.useCallback)(()=>{
        if (!wordsRef.current) return;
        const words = wordsRef.current.querySelectorAll("span");
        if (!words.length) return;
        let realIndex = activeIndex + 1;
        words[realIndex].classList.remove((business_hub_build_for_industry_module_default()).isHidden);
        words[realIndex].classList.add((business_hub_build_for_industry_module_default()).isVisible);
        for(let index = 0; index < words.length; index++){
            const element = words[index];
            if (index === realIndex) continue;
            element.classList.add((business_hub_build_for_industry_module_default()).isHidden);
            element.classList.remove((business_hub_build_for_industry_module_default()).isVisible);
        }
    }, [
        wordsRef,
        activeIndex
    ]);
    (0,react.useEffect)(()=>{
        changeWords();
    }, [
        changeWords,
        activeIndex
    ]);
    (0,react.useEffect)(()=>{
        if (!industryCardSwiper) return;
        if (!containerRef.current) return;
        const observer = new IntersectionObserver((entries)=>{
            if (entries) entries.forEach((entry)=>{
                if (entry.intersectionRatio > 0) {
                    industryCardSwiper.params.autoplay = {
                        delay: 4000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true
                    };
                    industryCardSwiper.update();
                    industryCardSwiper.autoplay.start();
                    observer.disconnect();
                }
            });
        });
        observer.observe(containerRef.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        containerRef,
        industryCardSwiper
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_hub_build_for_industry_module_default()).container,
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: wordsRef,
                className: (business_hub_build_for_industry_module_default()).wordsContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Built for\xa0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_hub_build_for_industry_module_default()).wordsWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (business_hub_build_for_industry_module_default()).isVisible,
                                children: "your industry."
                            }),
                            industries === null || industries === void 0 ? void 0 : industries.map((param, index)=>{
                                let { name  } = param;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        name === null || name === void 0 ? void 0 : name.toLowerCase(),
                                        "."
                                    ]
                                }, "".concat(name, "-").concat(index));
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_build_for_industry_module_default()).carouselContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                    ...business_hub_build_for_industry_options,
                    onInit: (swiper)=>{
                        swiper.setProgress(0.5);
                        setIndustryListSwiper(swiper);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            className: (business_hub_build_for_industry_module_default()).mdHide
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_hub_build_for_industry_module_default()).industries,
                                children: industries.map((param, index)=>{
                                    let { name  } = param;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()((business_hub_build_for_industry_module_default()).carouselItem, {
                                            [(business_hub_build_for_industry_module_default()).active]: index === activeIndex || index === 0 && activeIndex === -1
                                        }),
                                        onClick: ()=>{
                                            clickIndex.current = index;
                                            industryCardSwiper === null || industryCardSwiper === void 0 ? void 0 : industryCardSwiper.slideTo(index);
                                        },
                                        children: name
                                    }, name);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            className: (business_hub_build_for_industry_module_default()).mdHide
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_build_for_industry_module_default()).industriesContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    slidesPerView: 1,
                    speed: 300,
                    // autoplay={}
                    modules: [
                        modules/* EffectFade */.xW,
                        modules/* Thumbs */.o3,
                        modules/* Pagination */.tl,
                        modules/* Autoplay */.pt
                    ],
                    pagination: {
                        clickable: true,
                        el: ".".concat((business_hub_build_for_industry_module_default()).pagination)
                    },
                    onInit: (swiper)=>{
                        setIndustryCardSwiper(swiper);
                    },
                    thumbs: {
                        swiper: trustedBrandSwiper
                    },
                    onSlideChange: (swiper)=>{
                        if (clickIndex.current === null && swiper.realIndex === 0) {
                            setActiveIndex(-1);
                            swiper.autoplay.stop();
                            setTimeout(()=>{
                                setActiveIndex(0);
                                swiper.autoplay.start();
                            }, 4000);
                            return;
                        }
                        clickIndex.current = null;
                        setActiveIndex(swiper.realIndex);
                    },
                    children: industries.map((industry)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IndustriesItem, {
                                ...industry,
                                showQuote: true,
                                showLearnMore: showLearnMore
                            }, industry.name)
                        }, industry.name);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((business_hub_build_for_industry_module_default()).trustedBrandContainer, {
                    [(business_hub_build_for_industry_module_default()).hide]: activeIndex !== -1 && !((ref = industries[activeIndex]) === null || ref === void 0 ? void 0 : (ref1 = ref.trustedBrands) === null || ref1 === void 0 ? void 0 : ref1.length)
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((business_hub_build_for_industry_module_default()).trustedTitle),
                        children: "Trusted by"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        slidesPerView: 1,
                        draggable: false,
                        noSwiping: true,
                        allowTouchMove: false,
                        effect: "fade",
                        fadeEffect: {
                            crossFade: true
                        },
                        modules: [
                            modules/* EffectFade */.xW
                        ],
                        onInit: (swiper)=>{
                            setTrustedBrandSwiper(swiper);
                        },
                        children: industries.map((industry)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                className: (business_hub_build_for_industry_module_default()).trustedBrandSlide,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_hub_trusted_brand, {
                                    trustedBrands: industry.trustedBrands,
                                    className: (business_hub_build_for_industry_module_default()).trustedBrand
                                })
                            }, industry.name))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_build_for_industry_module_default()).pagination
            })
        ]
    });
};
/* harmony default export */ var business_hub_build_for_industry = (BusinessHubBuildForIndustry);

;// CONCATENATED MODULE: ./components/business-hub-build-for-industry/business-hub-build-for-industry.builder-component.ts

const BusinessHubBuildForIndustryBuilderConfig = {
    name: "Business Hub Build For Industry",
    inputs: [
        {
            name: "showLearnMore",
            type: "boolean",
            defaultValue: true
        }
    ]
};
const business_hub_build_for_industry_builder_component_builderConfig = {
    component: business_hub_build_for_industry,
    config: BusinessHubBuildForIndustryBuilderConfig
};
/* harmony default export */ var business_hub_build_for_industry_builder_component = (business_hub_build_for_industry_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-hub-carousel-lifecycle/card/card-lifecycle.module.scss
var card_card_lifecycle_module = __webpack_require__(39079);
var card_card_lifecycle_module_default = /*#__PURE__*/__webpack_require__.n(card_card_lifecycle_module);
;// CONCATENATED MODULE: ./components/business-hub-carousel-lifecycle/card/card-lifecycle.tsx




const card_lifecycle_CardLifecycle = (props)=>{
    const { image , title , description , backgroundContent , buttonText , buttonLink , tileClickable  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (card_card_lifecycle_module_default()).container,
        children: [
            tileClickable && buttonLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: (card_card_lifecycle_module_default()).link,
                target: "_blank",
                href: buttonLink
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (card_card_lifecycle_module_default()).image,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: image,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (card_card_lifecycle_module_default()).wrapperContent,
                style: {
                    backgroundColor: backgroundContent
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (card_card_lifecycle_module_default()).title,
                        dangerouslySetInnerHTML: {
                            __html: title !== null && title !== void 0 ? title : ""
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (card_card_lifecycle_module_default()).description,
                        dangerouslySetInnerHTML: {
                            __html: description !== null && description !== void 0 ? description : ""
                        }
                    }),
                    buttonText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (card_card_lifecycle_module_default()).button,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                            buttonText: buttonText || "Learn more",
                            link: buttonLink || "",
                            color: business_button_constants/* COLORS.BLACK */.DM.BLACK
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var card_card_lifecycle = (card_lifecycle_CardLifecycle);

// EXTERNAL MODULE: ./components/business-hub-carousel-lifecycle/business-hub-carousel-lifecycle.module.scss
var business_hub_carousel_lifecycle_module = __webpack_require__(33102);
var business_hub_carousel_lifecycle_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_carousel_lifecycle_module);
;// CONCATENATED MODULE: ./components/business-hub-carousel-lifecycle/business-hub-carousel-lifecycle.tsx






const BusinessHubCarouselLifecycle = (props)=>{
    const { title , subTitle , items =[] , backgroundColor , colorText , optionButton , autoplay  } = props;
    const options = {
        spaceBetween: 30,
        allowTouchMove: true,
        slidesPerView: "auto",
        noSwiping: false,
        pagination: {
            enabled: false,
            clickable: true
        },
        loop: false,
        speed: 1000,
        autoplay: autoplay ? {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
            waitForTransition: true
        } : false,
        slidesPerGroupSkip: 0,
        breakpoints: {
            378: {
                slidesPerView: "auto",
                watchOverflow: true,
                centeredSlides: false,
                spaceBetween: 20
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_hub_carousel_lifecycle_module_default()).container,
        style: {
            backgroundColor: backgroundColor,
            color: colorText
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (business_hub_carousel_lifecycle_module_default()).wrapperContent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_carousel_lifecycle_module_default()).title,
                    dangerouslySetInnerHTML: {
                        __html: title || ""
                    }
                }),
                subTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_carousel_lifecycle_module_default()).subTitle,
                    children: subTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_carousel_lifecycle_module_default()).listCard,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        ...options,
                        children: items.map((item, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card_card_lifecycle, {
                                    image: item.image,
                                    title: item.title,
                                    description: item.description,
                                    backgroundContent: item.backgroundContent,
                                    buttonText: item.buttonText,
                                    buttonLink: item.buttonLink,
                                    tileClickable: item.tileClickable
                                })
                            }, index);
                        })
                    })
                }),
                (optionButton === null || optionButton === void 0 ? void 0 : optionButton.buttonText) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_carousel_lifecycle_module_default()).button,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                        buttonText: (optionButton === null || optionButton === void 0 ? void 0 : optionButton.buttonText) || "Learn more",
                        link: (optionButton === null || optionButton === void 0 ? void 0 : optionButton.buttonLink) || "",
                        color: optionButton === null || optionButton === void 0 ? void 0 : optionButton.buttonColor,
                        target: "_blank"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var business_hub_carousel_lifecycle = (BusinessHubCarouselLifecycle);

;// CONCATENATED MODULE: ./components/business-hub-carousel-lifecycle/business-hub-carousel-lifecycle.builder-component.ts


const BusinessHubCarouselLifecycleBuilderConfig = {
    name: "Business Hub Carousel Lifecycle",
    inputs: [
        {
            name: "title",
            type: "html"
        },
        {
            name: "subTitle",
            type: "string"
        },
        {
            name: "autoplay",
            type: "boolean"
        },
        {
            name: "optionButton",
            type: "object",
            subFields: [
                {
                    name: "buttonText",
                    type: "string"
                },
                {
                    name: "buttonLink",
                    type: "string"
                },
                {
                    name: "buttonColor",
                    type: "string",
                    enum: Object.values(business_button_constants/* COLORS */.DM),
                    defaultValue: business_button_constants/* COLORS.MINT */.DM.MINT
                }
            ]
        },
        {
            name: "backgroundColor",
            type: "color"
        },
        {
            name: "colorText",
            type: "color"
        },
        {
            name: "items",
            type: "list",
            subFields: [
                {
                    name: "image",
                    type: "file"
                },
                {
                    name: "title",
                    type: "html"
                },
                {
                    name: "description",
                    type: "html"
                },
                {
                    name: "backgroundContent",
                    type: "color"
                },
                {
                    name: "buttonText",
                    type: "string"
                },
                {
                    name: "buttonLink",
                    type: "string"
                },
                {
                    name: "tileClickable",
                    type: "boolean"
                }
            ]
        }
    ]
};
const business_hub_carousel_lifecycle_builder_component_builderConfig = {
    component: business_hub_carousel_lifecycle,
    config: BusinessHubCarouselLifecycleBuilderConfig
};
/* harmony default export */ var business_hub_carousel_lifecycle_builder_component = (business_hub_carousel_lifecycle_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-hub-carousel-product/business-hub-carousel-product.module.scss
var business_hub_carousel_product_module = __webpack_require__(4038);
var business_hub_carousel_product_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_carousel_product_module);
;// CONCATENATED MODULE: ./components/business-hub-carousel-product/business-hub-carousel-product.tsx










var ITEMS_POSITION;
(function(ITEMS_POSITION) {
    ITEMS_POSITION["Left"] = "Left";
    ITEMS_POSITION["Right"] = "Right";
})(ITEMS_POSITION || (ITEMS_POSITION = {}));
var IMAGE_POSITION;
(function(IMAGE_POSITION) {
    IMAGE_POSITION["Center"] = "Center";
    IMAGE_POSITION["Bottom"] = "Bottom";
})(IMAGE_POSITION || (IMAGE_POSITION = {}));
const BusinessHubCarouselProduct = (props)=>{
    const { title , subTitle , positionItems , items =[] , backgroundColor , colorText , colorPaginationBulletActive  } = props;
    const options = {
        spaceBetween: 10,
        allowTouchMove: true,
        noSwiping: false,
        freeMode: false,
        loop: true,
        effect: "fade",
        pagination: {
            enabled: true,
            clickable: true
        },
        speed: 1000,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        },
        slidesPerGroupSkip: 0,
        breakpoints: {
            998: {
                watchOverflow: true
            }
        }
    };
    const [isMobile, setIsMobile] = (0,react.useState)(false);
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const windowWidth = windowSize.width || 0;
    (0,react.useEffect)(()=>{
        if (windowWidth <= 998) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    }, [
        windowWidth
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_hub_carousel_product_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (business_hub_carousel_product_module_default()).wrapperContent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_carousel_product_module_default()).header,
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_carousel_product_module_default()).subHeader,
                    children: subTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_carousel_product_module_default()).content,
                    style: {
                        marginTop: subTitle ? "36px" : "44px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        ...options,
                        modules: [
                            modules/* Pagination */.tl
                        ],
                        style: {
                            ["--swiper-pagination-color"]: colorPaginationBulletActive
                        },
                        children: items.map((item, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((business_hub_carousel_product_module_default()).item, {
                                        [(business_hub_carousel_product_module_default()).left]: positionItems === ITEMS_POSITION.Left,
                                        [(business_hub_carousel_product_module_default()).right]: positionItems === ITEMS_POSITION.Right,
                                        [(business_hub_carousel_product_module_default()).center]: item.imagePosition === IMAGE_POSITION.Center
                                    }),
                                    style: {
                                        backgroundColor: backgroundColor
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classnames_default()((business_hub_carousel_product_module_default()).wrappeImage, {
                                                [(business_hub_carousel_product_module_default()).center]: item.imagePosition === IMAGE_POSITION.Center,
                                                [(business_hub_carousel_product_module_default()).bottom]: item.imagePosition === IMAGE_POSITION.Bottom
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: (business_hub_carousel_product_module_default()).image,
                                                src: item.image,
                                                alt: "",
                                                style: {
                                                    maxWidth: isMobile ? "".concat(item.maxWidthImageMobile, "px") : "".concat(item.maxWidthImage, "px"),
                                                    height: isMobile ? "".concat(item.heightImageMobile, "%") : "auto"
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (business_hub_carousel_product_module_default()).wrapperText,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (business_hub_carousel_product_module_default()).title,
                                                    dangerouslySetInnerHTML: {
                                                        __html: item.title
                                                    },
                                                    style: {
                                                        color: colorText,
                                                        maxWidth: item.maxWidthTitle
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (business_hub_carousel_product_module_default()).description,
                                                    style: {
                                                        color: colorText
                                                    },
                                                    children: item.description
                                                }),
                                                item.ctaText && item.ctaUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                                                    className: (business_hub_carousel_product_module_default()).learnMore,
                                                    link: item.ctaUrl,
                                                    buttonText: item.ctaText,
                                                    autoMargin: false,
                                                    color: business_button_constants/* COLORS.WHITE */.DM.WHITE,
                                                    target: item.openLinkInNewTab ? "_blank" : "_self"
                                                }) : null
                                            ]
                                        })
                                    ]
                                }, index)
                            }, index);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var business_hub_carousel_product = (BusinessHubCarouselProduct);

;// CONCATENATED MODULE: ./components/business-hub-carousel-product/business-hub-carousel-product.builder-component.ts

const BusinessHubCarouselProductBuilderConfig = {
    name: "Business Hub Carousel Product",
    inputs: [
        {
            name: "title",
            type: "string"
        },
        {
            name: "subTitle",
            type: "string"
        },
        {
            name: "backgroundColor",
            type: "color"
        },
        {
            name: "colorText",
            type: "color"
        },
        {
            name: "colorPaginationBulletActive",
            type: "color"
        },
        {
            name: "positionItems",
            type: "string",
            enum: Object.values(ITEMS_POSITION),
            defaultValue: ITEMS_POSITION.Left
        },
        {
            name: "items",
            type: "list",
            subFields: [
                {
                    name: "image",
                    type: "file",
                    helperText: "Use for mobile"
                },
                {
                    name: "heightImageMobile",
                    type: "number"
                },
                {
                    name: "maxWidthImage",
                    type: "number"
                },
                {
                    name: "maxWidthImageMobile",
                    type: "number"
                },
                {
                    name: "imagePosition",
                    type: "string",
                    enum: Object.values(IMAGE_POSITION),
                    defaultValue: IMAGE_POSITION.Center
                },
                {
                    name: "title",
                    type: "html"
                },
                {
                    name: "maxWidthTitle",
                    type: "number"
                },
                {
                    name: "description",
                    type: "string"
                },
                {
                    name: "ctaText",
                    type: "string",
                    required: false
                },
                {
                    name: "ctaUrl",
                    type: "url",
                    required: false
                },
                {
                    name: "openLinkInNewTab",
                    type: "boolean",
                    defaultValue: true
                }
            ]
        }
    ]
};
const business_hub_carousel_product_builder_component_builderConfig = {
    component: business_hub_carousel_product,
    config: BusinessHubCarouselProductBuilderConfig
};
/* harmony default export */ var business_hub_carousel_product_builder_component = (business_hub_carousel_product_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-hub-faq/business-hub-faq.module.scss
var business_hub_faq_module = __webpack_require__(97516);
var business_hub_faq_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_faq_module);
// EXTERNAL MODULE: ./components/business-hub-faq/faq-item/faq-item.module.scss
var faq_item_faq_item_module = __webpack_require__(17806);
var faq_item_faq_item_module_default = /*#__PURE__*/__webpack_require__.n(faq_item_faq_item_module);
;// CONCATENATED MODULE: ./components/business-hub-faq/faq-item/faq-item.tsx



const faq_item_FAQItem = (props)=>{
    const { question , answer , isOpen , zIndex , onQuestionClick  } = props;
    const handleFQA = ()=>{
        if (onQuestionClick) {
            onQuestionClick(question || "");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((faq_item_faq_item_module_default()).container, {
            [(faq_item_faq_item_module_default()).containerExpanded]: isOpen
        }),
        style: {
            zIndex
        },
        onClick: handleFQA,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((faq_item_faq_item_module_default()).divider, " ").concat(isOpen ? (faq_item_faq_item_module_default()).hidden : "")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (faq_item_faq_item_module_default()).wrapperQuestion,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (faq_item_faq_item_module_default()).question,
                        dangerouslySetInnerHTML: {
                            __html: question || ""
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((faq_item_faq_item_module_default()).icon, " ").concat(isOpen ? (faq_item_faq_item_module_default()).opened : (faq_item_faq_item_module_default()).closed),
                        onClick: handleFQA,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (faq_item_faq_item_module_default()).horizontal
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (faq_item_faq_item_module_default()).vertical
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((faq_item_faq_item_module_default()).wrapperAnswer, " ").concat(isOpen ? (faq_item_faq_item_module_default()).showAnswer : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (faq_item_faq_item_module_default()).answer,
                    dangerouslySetInnerHTML: {
                        __html: answer || ""
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var faq_item_faq_item = (faq_item_FAQItem);

;// CONCATENATED MODULE: ./components/business-hub-faq/business-hub-faq.tsx




const business_hub_faq_BusinessHubFAQ = (props)=>{
    const { title , description , items  } = props;
    const [currentOpenQuestion, setCurrentOpenQuestion] = (0,react.useState)(null);
    const [showAll, setShowAll] = (0,react.useState)(false);
    const handleViewMore = ()=>{
        setShowAll(true);
    };
    const handleQuestionClick = (question)=>{
        if (question === currentOpenQuestion) {
            setCurrentOpenQuestion(null);
        } else {
            setCurrentOpenQuestion(question);
        }
    };
    const displayedItems = showAll ? items : items === null || items === void 0 ? void 0 : items.slice(0, 3);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_hub_faq_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (business_hub_faq_module_default()).content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_faq_module_default()).title,
                    dangerouslySetInnerHTML: {
                        __html: title || ""
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_faq_module_default()).description,
                    dangerouslySetInnerHTML: {
                        __html: description || ""
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (business_hub_faq_module_default()).wrapperFAQ,
                    children: [
                        displayedItems === null || displayedItems === void 0 ? void 0 : displayedItems.map((item, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(faq_item_faq_item, {
                                question: item.question,
                                answer: item.answer,
                                isOpen: item.question === currentOpenQuestion,
                                onQuestionClick: handleQuestionClick,
                                zIndex: displayedItems.length - index
                            }, index);
                        }),
                        !showAll && items && items.length > 3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (business_hub_faq_module_default()).btnViewMore,
                            onClick: handleViewMore,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (business_hub_faq_module_default()).text,
                                    children: "View more"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (business_hub_faq_module_default()).iconArrow,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "13",
                                        height: "12",
                                        viewBox: "0 0 13 12",
                                        fill: "none",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M1 3.5L6.5 9.5L12 3.5",
                                            stroke: "black",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var business_hub_faq = (business_hub_faq_BusinessHubFAQ);

;// CONCATENATED MODULE: ./components/business-hub-faq/business-hub-faq.builder-component.ts

const BusinessHubFAQBuilderConfig = {
    name: "Business Hub FAQ",
    inputs: [
        {
            name: "title",
            type: "html",
            defaultValue: ""
        },
        {
            name: "description",
            type: "html",
            defaultValue: ""
        },
        {
            name: "items",
            type: "list",
            subFields: [
                {
                    name: "question",
                    type: "html"
                },
                {
                    name: "answer",
                    type: "html"
                }
            ]
        }
    ]
};
const business_hub_faq_builder_component_builderConfig = {
    component: business_hub_faq,
    config: BusinessHubFAQBuilderConfig
};
/* harmony default export */ var business_hub_faq_builder_component = (business_hub_faq_builder_component_builderConfig);

// EXTERNAL MODULE: ./node_modules/gsap/gsap-core.js
var gsap_core = __webpack_require__(48158);
// EXTERNAL MODULE: ./components/business-hub-gateway/business-hub-gateway.module.scss
var business_hub_gateway_module = __webpack_require__(96709);
var business_hub_gateway_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_gateway_module);
;// CONCATENATED MODULE: ./components/business-hub-gateway/iphone-shell.tsx

const IphoneShell = (param)=>{
    let { backgroundColor ="transparent"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "291",
        height: "465",
        viewBox: "0 0 291 465",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "290.061",
                height: "588.354",
                fill: backgroundColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "290.061",
                height: "588.354",
                fill: "url(#pattern0)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("pattern", {
                        id: "pattern0",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            xlinkHref: "#image0_535_4256",
                            transform: "matrix(0.00351863 0 0 0.00172851 -0.0103427 -0.00849829)"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("image", {
                        id: "image0_535_4256",
                        width: "291",
                        height: "589",
                        xlinkHref: "data:image/png;base64,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"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/business-hub-gateway/business-hub-gateway.tsx










gsap.gsap.registerPlugin(ScrollTrigger.ScrollTrigger);
const BusinessHubGateway = (props)=>{
    const { backgroundColor , title , description , slides  } = props;
    const [isRendered, setIsRendered] = (0,react.useState)(false);
    const containerRef = (0,react.useRef)(null);
    const headingRef = (0,react.useRef)(null);
    const sections = (0,react.useRef)([]);
    (0,react.useEffect)(()=>{
        ()=>{
            sections.current = [];
        };
    }, []);
    const ctx = (0,react.useRef)();
    (0,react.useLayoutEffect)(()=>{
        if (!containerRef.current) return;
        if (!sections.current.length) return;
        if (isRendered) return;
        setIsRendered(true);
        ctx.current = gsap.gsap.context(()=>{
            let tl = gsap.gsap.timeline({
                defaults: {
                    duration: 1,
                    ease: gsap_core/* Power4.easeInOut */.Yp.easeInOut
                },
                scrollTrigger: {
                    trigger: containerRef.current,
                    pinnedContainer: containerRef.current,
                    pin: true,
                    scrub: 1,
                    start: ()=>{
                        var ref;
                        const containerHeight = ((ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect().height) || 0;
                        const windowHeight = window.innerHeight;
                        if (containerHeight < windowHeight) {
                            return "center center";
                        }
                        return "bottom bottom";
                    },
                    end: "+=300%",
                    invalidateOnRefresh: true
                }
            });
            gsap.gsap.set(sections.current, {
                autoAlpha: 1,
                opacity: 0,
                y: (i)=>{
                    return "".concat(100 * i, "vh");
                },
                transformOrigin: "top",
                xPercent: (index)=>-100 * index
            });
            for(let index = 1; index < sections.current.length; index++){
                const section = sections.current[index];
                const prevSection = sections.current[index - 1];
                tl.to([
                    section
                ], {
                    y: 0,
                    opacity: 1
                }, "+=1").to([
                    prevSection
                ], {
                    opacity: 0
                }, "<");
            }
            tl.set({}, {}, "+=4");
        });
    }, [
        containerRef,
        sections
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_hub_gateway_module_default()).container,
        style: {
            "--data-bg-color": backgroundColor
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: containerRef,
            className: (business_hub_gateway_module_default()).box,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    ref: headingRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_hub_gateway_module_default()).headingTitle,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_hub_gateway_module_default()).headingDescription,
                            children: description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_gateway_module_default()).parallaxContainer,
                    children: slides === null || slides === void 0 ? void 0 : slides.map((param, idx)=>/*#__PURE__*/ {
                        let { title , description , backgroundImage , ctaText , ctaUrl  } = param;
                        return (0,jsx_runtime.jsx)("section", {
                            className: (business_hub_gateway_module_default()).section,
                            ref: (ref)=>{
                                if (ref) sections.current.push(ref);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (business_hub_gateway_module_default()).contentBox,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (business_hub_gateway_module_default()).contentLeft,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classnames_default()((business_hub_gateway_module_default()).contentSection, (business_hub_gateway_module_default()).left),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: (business_hub_gateway_module_default()).title,
                                                    children: title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: (business_hub_gateway_module_default()).description,
                                                    children: description
                                                }),
                                                ctaText && ctaUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                                                    className: (business_hub_gateway_module_default()).learnMore,
                                                    link: ctaUrl,
                                                    buttonText: ctaText,
                                                    autoMargin: false,
                                                    color: business_button_constants/* COLORS.WHITE */.DM.WHITE
                                                }) : null
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (business_hub_gateway_module_default()).contentRight,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IphoneShell, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (business_hub_gateway_module_default()).iphoneShellContainer,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (business_hub_gateway_module_default()).screen,
                                                    style: {
                                                        backgroundImage: "url(".concat(backgroundImage, ")")
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, "section-".concat(idx));
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var business_hub_gateway = (BusinessHubGateway);

;// CONCATENATED MODULE: ./components/business-hub-gateway/business-hub-gateway.builder-component.ts

const FullBleedConfig = {
    name: "Business Hub Gateways",
    inputs: [
        {
            name: "title",
            type: "text"
        },
        {
            name: "description",
            type: "text"
        },
        {
            name: "backgroundColor",
            type: "color",
            defaultValue: "#5b9e9b"
        },
        {
            name: "slides",
            type: "list",
            required: true,
            defaultValue: [
                {
                    header: "Step 1",
                    subheader: "Browse all your favorite places to shop online or in retail stores near you.",
                    body: "Afterpay works online or in-store wherever you are used to shopping.",
                    backgroundImage: "/iphone-body1.png",
                    imageAltText: "Image1"
                },
                {
                    header: "Step 2",
                    subheader: "Browse all your favorite places to shop online or in retail stores near you.",
                    body: "Afterpay works online or in-store wherever you are used to shopping.",
                    backgroundImage: "/iphone-body2.png",
                    imageAltText: "Image2"
                }
            ],
            subFields: [
                {
                    name: "title",
                    type: "string",
                    required: true
                },
                {
                    name: "description",
                    type: "string",
                    required: false
                },
                {
                    name: "backgroundImage",
                    type: "file",
                    helperText: "Use vertical images that are 2-3x resolution to ensure images render nicely on retina devices",
                    allowedFileTypes: [
                        "jpg",
                        "jpeg",
                        "png"
                    ],
                    required: true
                },
                {
                    name: "imageAltText",
                    type: "string",
                    required: false
                },
                {
                    name: "ctaText",
                    type: "string",
                    required: false
                },
                {
                    name: "ctaUrl",
                    type: "url",
                    required: false
                }
            ]
        }
    ]
};
const business_hub_gateway_builder_component_builderConfig = {
    component: business_hub_gateway,
    config: FullBleedConfig
};
/* harmony default export */ var business_hub_gateway_builder_component = (business_hub_gateway_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-hub-good-for-v2/business-hub-good-for.module.scss
var business_hub_good_for_module = __webpack_require__(73123);
var business_hub_good_for_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_good_for_module);
;// CONCATENATED MODULE: ./components/business-hub-good-for-v2/business-hub-good-for.tsx











gsap.gsap.registerPlugin(src/* useGSAP */.V);
gsap.gsap.registerPlugin(ScrollTrigger.ScrollTrigger);
gsap.gsap.registerPlugin((TextPlugin_default()));
const BusinessHubGoodFor = (props)=>{
    const { backgroundColor ="#2D3F39" , textColor ="#fff" , content =[]  } = props;
    const containerRef = (0,react.useRef)(null);
    (0,src/* useGSAP */.V)(()=>{
        const selector = gsap.gsap.utils.selector(containerRef.current);
        const sections = gsap.gsap.utils.toArray(selector(".".concat((business_hub_good_for_module_default()).section)));
        let mm = gsap.gsap.matchMedia();
        mm.add({
            isMobile: "(max-width: 992px)",
            isDesktop: "(min-width: 993px)"
        }, (context)=>{
            var ref;
            var ref1;
            let isMobile = (ref1 = (ref = context.conditions) === null || ref === void 0 ? void 0 : ref.isMobile) !== null && ref1 !== void 0 ? ref1 : false;
            gsap.gsap.timeline({
                scrollTrigger: {
                    trigger: containerRef.current,
                    pinnedContainer: containerRef.current,
                    pin: true,
                    start: "center center",
                    end: "+=100%",
                    scrub: 1
                }
            });
            let masterTl = gsap.gsap.timeline({
                scrollTrigger: {
                    trigger: containerRef.current,
                    start: "top center+=40%",
                    end: "bottom top",
                    scrub: true
                }
            });
            gsap.gsap.set(sections, {
                autoAlpha: 0
            });
            for(let i = 0; i < sections.length; i++){
                const section = sections[i];
                const title = isMobile ? gsap.gsap.utils.toArray(gsap.gsap.utils.selector(section)(".".concat((business_hub_good_for_module_default()).sectionTitle, ".").concat((business_hub_good_for_module_default()).desktopHide)))[0] : gsap.gsap.utils.toArray(gsap.gsap.utils.selector(section)(".".concat((business_hub_good_for_module_default()).sectionTitle, ".").concat((business_hub_good_for_module_default()).mobileHide)))[0];
                const prvSection = sections[i - 1];
                if (prvSection) {
                    const prvTitle = isMobile ? gsap.gsap.utils.toArray(gsap.gsap.utils.selector(prvSection)(".".concat((business_hub_good_for_module_default()).sectionTitle, ".").concat((business_hub_good_for_module_default()).desktopHide)))[0] : gsap.gsap.utils.toArray(gsap.gsap.utils.selector(prvSection)(".".concat((business_hub_good_for_module_default()).sectionTitle, ".").concat((business_hub_good_for_module_default()).mobileHide)))[0];
                    const tlOut = animateSection(prvSection, prvTitle, "out");
                    masterTl.add(tlOut);
                }
                const tlIn = animateSection(section, title, "in", i === 0 ? "+=1" : "<");
                masterTl.to(section, {
                    xPercent: -100 * i,
                    x: 0
                }, "<");
                masterTl.add(tlIn, "-=0.5");
            }
        }, containerRef);
    }, {
        scope: containerRef,
        dependencies: [
            content
        ]
    });
    const animateSection = (section, title, animationType, position)=>{
        const sectionSelector = gsap.gsap.utils.selector(section);
        const illustrations = gsap.gsap.utils.toArray(sectionSelector(".".concat((business_hub_good_for_module_default()).sectionImage)));
        const contentItems = gsap.gsap.utils.toArray(sectionSelector(".".concat((business_hub_good_for_module_default()).sectionDescription, " span, a")));
        const titleSplits = gsap.gsap.utils.toArray(gsap.gsap.utils.selector(title)("span"));
        const tl = gsap.gsap.timeline({});
        if (animationType === "in") {
            tl.to(section, {
                autoAlpha: 1
            }, position);
            tl.fromTo(illustrations, {
                autoAlpha: 0
            }, {
                autoAlpha: 1,
                stagger: 0.25
            }, "<");
            tl.fromTo([
                titleSplits,
                contentItems
            ], {
                autoAlpha: 0
            }, {
                duration: 1,
                autoAlpha: 1,
                stagger: {
                    from: "start",
                    each: 0.01
                }
            }, ">-=0.5");
        } else {
            tl.to([
                titleSplits,
                contentItems
            ], {
                duration: 0.5,
                autoAlpha: 0,
                stagger: {
                    from: "start",
                    each: 0.005
                }
            }, "+=1");
        }
        return tl;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: containerRef,
        className: (business_hub_good_for_module_default()).container,
        style: {
            color: textColor,
            "--bg-color": backgroundColor
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_good_for_module_default()).background
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_good_for_module_default()).content,
                children: content.map((section)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: (business_hub_good_for_module_default()).section,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((business_hub_good_for_module_default()).sectionTitle, (business_hub_good_for_module_default()).mobileHide),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(splitchar/* SplitChar */.k, {
                                        text: "Good for your\xa0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(splitchar/* SplitChar */.k, {
                                        text: section.title,
                                        className: (business_hub_good_for_module_default()).colorMint
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (business_hub_good_for_module_default()).sectionContent,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (business_hub_good_for_module_default()).sectionImage,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                    media: "(min-width: 640.1px)",
                                                    srcSet: section.image
                                                }),
                                                section.imageMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                    media: "(max-width: 640px)",
                                                    srcSet: section.imageMobile
                                                }) : null,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: section.image || "",
                                                    alt: "",
                                                    style: {
                                                        objectFit: "cover",
                                                        objectPosition: "center"
                                                    },
                                                    sizes: "(max-width: 638px) 98vw, (max-width: 998px) 43vw, 46vw",
                                                    fill: true,
                                                    loading: "eager",
                                                    loader: (param)=>{
                                                        let { src , width , quality  } = param;
                                                        return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                                                    }
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classnames_default()((business_hub_good_for_module_default()).sectionTitle, (business_hub_good_for_module_default()).desktopHide),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(splitchar/* SplitChar */.k, {
                                                text: "Good for your "
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (business_hub_good_for_module_default()).colorMint,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(splitchar/* SplitChar */.k, {
                                                    text: section.title
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (business_hub_good_for_module_default()).sectionDescription,
                                        children: [
                                            section.item.map((param, index)=>{
                                                let { content  } = param;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(splitchar/* SplitChar */.k, {
                                                    text: content,
                                                    className: (business_hub_good_for_module_default()).item
                                                }, "".concat(index));
                                            }),
                                            section.buttonLink && section.buttonText ? /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                                                className: (business_hub_good_for_module_default()).sectionButton,
                                                link: section.buttonLink,
                                                buttonText: section.buttonText,
                                                autoMargin: false
                                            }) : null
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, section.title);
                })
            })
        ]
    });
};
/* harmony default export */ var business_hub_good_for = (BusinessHubGoodFor);

;// CONCATENATED MODULE: ./components/business-hub-good-for-v2/business-hub-good-for.builder-component.ts

const BusinessHubGoodForBuilderConfig = {
    name: "Business Hub Good For V2",
    inputs: [
        {
            name: "backgroundColor",
            type: "color"
        },
        {
            name: "textColor",
            type: "color"
        },
        {
            name: "content",
            type: "list",
            subFields: [
                {
                    name: "image",
                    type: "file"
                },
                {
                    name: "imageMobile",
                    type: "file"
                },
                {
                    name: "title",
                    type: "text"
                },
                {
                    name: "buttonText",
                    type: "text"
                },
                {
                    name: "buttonLink",
                    type: "url"
                },
                {
                    name: "item",
                    type: "list",
                    subFields: [
                        {
                            name: "content",
                            type: "string"
                        }
                    ]
                }
            ]
        }
    ]
};
const business_hub_good_for_builder_component_builderConfig = {
    component: business_hub_good_for,
    config: BusinessHubGoodForBuilderConfig
};
/* harmony default export */ var business_hub_good_for_builder_component = (business_hub_good_for_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-hub-good-for/business-hub-good-for.module.scss
var business_hub_good_for_business_hub_good_for_module = __webpack_require__(10389);
var business_hub_good_for_business_hub_good_for_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_good_for_business_hub_good_for_module);
;// CONCATENATED MODULE: ./components/business-hub-good-for/business-hub-good-for.tsx










gsap.gsap.registerPlugin(src/* useGSAP */.V);
gsap.gsap.registerPlugin(ScrollTrigger.ScrollTrigger);
gsap.gsap.registerPlugin((TextPlugin_default()));
const business_hub_good_for_BusinessHubGoodFor = (props)=>{
    const { title , backgroundColor ="#2D3F39" , textColor ="#fff" , content =[]  } = props;
    const containerRef = (0,react.useRef)(null);
    (0,src/* useGSAP */.V)(()=>{
        const selector = gsap.gsap.utils.selector(containerRef.current);
        const sections = gsap.gsap.utils.toArray(selector(".".concat((business_hub_good_for_business_hub_good_for_module_default()).section)));
        gsap.gsap.timeline({
            scrollTrigger: {
                trigger: containerRef.current,
                pinnedContainer: containerRef.current,
                // markers: true,
                pin: true,
                start: "center center",
                end: "+=100%",
                scrub: 1
            }
        });
        let masterTl = gsap.gsap.timeline({
            defaults: {
                ease: "none"
            },
            scrollTrigger: {
                trigger: containerRef.current,
                start: "top center+=40%",
                end: "bottom top",
                scrub: true
            }
        });
        setMaxHeight(sections, "".concat((business_hub_good_for_business_hub_good_for_module_default()).section, " ").concat((business_hub_good_for_business_hub_good_for_module_default()).absoluteElem));
        gsap.gsap.set(sections, {
            autoAlpha: 0,
            yPercent: 0,
            zIndex: (index)=>index
        });
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const title = gsap.gsap.utils.toArray(gsap.gsap.utils.selector(section)(".".concat((business_hub_good_for_business_hub_good_for_module_default()).list, " .").concat((business_hub_good_for_business_hub_good_for_module_default()).listTitle)))[0];
            const prvSection = sections[i - 1];
            if (prvSection) {
                const prvTitle = gsap.gsap.utils.toArray(gsap.gsap.utils.selector(prvSection)(".".concat((business_hub_good_for_business_hub_good_for_module_default()).list, " .").concat((business_hub_good_for_business_hub_good_for_module_default()).listTitle)))[0];
                const tlOut = animateSection(prvSection, prvTitle, "out");
                masterTl.add(tlOut);
            }
            const tlIn = animateSection(section, title, "in", i === 0 ? "+=1" : "<");
            masterTl.add(tlIn, "-=0.5");
        }
    }, {
        scope: containerRef
    });
    const animateSection = (section, title, animationType, position)=>{
        const sectionSelector = gsap.gsap.utils.selector(section);
        const illustrations = gsap.gsap.utils.toArray(sectionSelector(".".concat((business_hub_good_for_business_hub_good_for_module_default()).illustration)));
        const contentItems = gsap.gsap.utils.toArray(sectionSelector(".".concat((business_hub_good_for_business_hub_good_for_module_default()).list, " span:not(.").concat((business_hub_good_for_business_hub_good_for_module_default()).invisible, ")")));
        const titleSplits = gsap.gsap.utils.toArray(gsap.gsap.utils.selector(title)("span"));
        const tl = gsap.gsap.timeline({});
        if (animationType === "in") {
            tl.to(section, {
                autoAlpha: 1
            }, position);
            tl.to(titleSplits, {
                duration: 1,
                autoAlpha: 1,
                stagger: {
                    from: "start",
                    each: 0.01
                }
            }, "<");
            tl.fromTo(illustrations, {
                autoAlpha: 0
            }, {
                autoAlpha: 1,
                stagger: 0.25
            }, "<");
            tl.fromTo(contentItems, {
                autoAlpha: 0
            }, {
                duration: 1,
                autoAlpha: 1,
                stagger: {
                    from: "start",
                    each: 0.01
                }
            }, ">-=0.5");
        } else {
            tl.to(contentItems, {
                duration: 0.5,
                autoAlpha: 0,
                stagger: {
                    from: "start",
                    each: 0.005
                }
            }, "+=1");
            tl.to(titleSplits, {
                duration: 0.5,
                autoAlpha: 0,
                stagger: {
                    from: "start",
                    each: 0.005
                }
            }, "<");
        // tl.to(illustrations, { autoAlpha: 0, stagger: 0.1 }, '<');
        }
        return tl;
    };
    const setMaxHeight = (elements, className)=>{
        let maxHeightIndex = 0;
        let elemMaxHeight = 0;
        for(let index = 0; index < elements.length; index++){
            const elem = elements[index];
            if (elem.clientHeight > elemMaxHeight) {
                elemMaxHeight = elem.clientHeight;
                maxHeightIndex = index;
            }
        }
        const smaller = elements.filter((_, index)=>index !== maxHeightIndex);
        if (className) {
            gsap.gsap.set(smaller, {
                className
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: containerRef,
        className: (business_hub_good_for_business_hub_good_for_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_good_for_business_hub_good_for_module_default()).title,
                dangerouslySetInnerHTML: {
                    __html: title || ""
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_good_for_business_hub_good_for_module_default()).sectionContainer,
                style: {
                    color: textColor,
                    backgroundColor
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: content.map((item, index)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: (business_hub_good_for_business_hub_good_for_module_default()).section,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (business_hub_good_for_business_hub_good_for_module_default()).sectionBox,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (business_hub_good_for_business_hub_good_for_module_default()).illustrations,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classnames_default()((business_hub_good_for_business_hub_good_for_module_default()).illustration),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: item.image || "",
                                                    alt: "",
                                                    style: {
                                                        objectFit: "cover",
                                                        objectPosition: "center"
                                                    },
                                                    fill: true,
                                                    loading: "eager",
                                                    sizes: "(max-width: 638px) 98vw, (max-width: 998px) 43vw, 46vw",
                                                    loader: (param)=>{
                                                        let { src , width , quality  } = param;
                                                        return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (business_hub_good_for_business_hub_good_for_module_default()).list,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: classnames_default()((business_hub_good_for_business_hub_good_for_module_default()).listTitle, (business_hub_good_for_business_hub_good_for_module_default()).desktop),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            style: {
                                                                whiteSpace: "nowrap"
                                                            },
                                                            className: classnames_default()((business_hub_good_for_business_hub_good_for_module_default()).titleItem, (business_hub_good_for_business_hub_good_for_module_default()).titleCommon),
                                                            children: "Good for your".split("").map((char, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    style: {
                                                                        visibility: "hidden",
                                                                        opacity: 0
                                                                    },
                                                                    className: (business_hub_good_for_business_hub_good_for_module_default()).invisible,
                                                                    children: char
                                                                }, "".concat(char, "-").concat(i)))
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: classnames_default()((business_hub_good_for_business_hub_good_for_module_default()).colorMint, (business_hub_good_for_business_hub_good_for_module_default()).titleItem),
                                                            children: item.title.split("").map((char, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    style: {
                                                                        visibility: "hidden",
                                                                        opacity: 0
                                                                    },
                                                                    className: (business_hub_good_for_business_hub_good_for_module_default()).invisible,
                                                                    children: char
                                                                }, "".concat(char, "-").concat(i)))
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classnames_default()((business_hub_good_for_business_hub_good_for_module_default()).illustration, (business_hub_good_for_business_hub_good_for_module_default()).right, (business_hub_good_for_business_hub_good_for_module_default()).desktop),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: item.image2 || "",
                                                    alt: "",
                                                    style: {
                                                        objectFit: "cover",
                                                        objectPosition: "center"
                                                    },
                                                    sizes: "(max-width: 638px) 98vw, (max-width: 998px) 43vw, 46vw",
                                                    fill: true,
                                                    loading: "eager",
                                                    loader: (param)=>{
                                                        let { src , width , quality  } = param;
                                                        return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (business_hub_good_for_business_hub_good_for_module_default()).list,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (business_hub_good_for_business_hub_good_for_module_default()).listTitle,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: "Good for your"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (business_hub_good_for_business_hub_good_for_module_default()).colorMint,
                                                        children: item.title
                                                    })
                                                ]
                                            }),
                                            item.item.map((param, index)=>{
                                                let { content  } = param;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(splitchar/* SplitChar */.k, {
                                                    text: content,
                                                    className: (business_hub_good_for_business_hub_good_for_module_default()).item
                                                }, "".concat(index));
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                                ]
                            })
                        }, "section-".concat(index));
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var business_hub_good_for_business_hub_good_for = (business_hub_good_for_BusinessHubGoodFor);

;// CONCATENATED MODULE: ./components/business-hub-good-for/business-hub-good-for.builder-component.ts

const business_hub_good_for_builder_component_BusinessHubGoodForBuilderConfig = {
    name: "Business Hub Good For",
    inputs: [
        {
            name: "title",
            type: "richText"
        },
        {
            name: "backgroundColor",
            type: "color"
        },
        {
            name: "textColor",
            type: "color"
        },
        {
            name: "content",
            type: "list",
            subFields: [
                {
                    name: "image",
                    type: "file"
                },
                {
                    name: "image2",
                    type: "file"
                },
                {
                    name: "title",
                    type: "text"
                },
                {
                    name: "item",
                    type: "list",
                    subFields: [
                        {
                            name: "content",
                            type: "string"
                        }
                    ]
                }
            ]
        }
    ]
};
const business_hub_good_for_business_hub_good_for_builder_component_builderConfig = {
    component: business_hub_good_for_business_hub_good_for,
    config: business_hub_good_for_builder_component_BusinessHubGoodForBuilderConfig
};
/* harmony default export */ var business_hub_good_for_business_hub_good_for_builder_component = (business_hub_good_for_business_hub_good_for_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-hub-hero-enterprise/business-hub-hero-enterprise.module.scss
var business_hub_hero_enterprise_module = __webpack_require__(43480);
var business_hub_hero_enterprise_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_hero_enterprise_module);
;// CONCATENATED MODULE: ./components/business-hub-hero-enterprise/business-hub-hero-enterprise.tsx





const BusinessHubHeroEnterPrise = (props)=>{
    const { backgroundColor , backgroundImage , backgroundImageMobile , content  } = props;
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const windowWidth = windowSize.width || 0;
    const isMobile = windowWidth <= 575;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_hub_hero_enterprise_module_default()).container,
        style: {
            backgroundColor: "".concat(backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "#ffff")
        },
        children: [
            !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_hero_enterprise_module_default()).backgroundImage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: backgroundImage,
                    alt: ""
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_hero_enterprise_module_default()).backgroundImageMobile,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: backgroundImageMobile,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_hub_hero_enterprise_module_default()).wrapperContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_hub_hero_enterprise_module_default()).wrapperContentText,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_hub_hero_enterprise_module_default()).title,
                                dangerouslySetInnerHTML: {
                                    __html: (content === null || content === void 0 ? void 0 : content.title) || ""
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_hub_hero_enterprise_module_default()).description,
                                dangerouslySetInnerHTML: {
                                    __html: (content === null || content === void 0 ? void 0 : content.description) || ""
                                }
                            }),
                            (content === null || content === void 0 ? void 0 : content.ctaText) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_hub_hero_enterprise_module_default()).button,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                                    color: business_button_constants/* COLORS.MINT */.DM.MINT,
                                    link: content.ctaLink,
                                    buttonText: content.ctaText
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_hub_hero_enterprise_module_default()).image,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: content === null || content === void 0 ? void 0 : content.image,
                            alt: ""
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var business_hub_hero_enterprise = (BusinessHubHeroEnterPrise);

;// CONCATENATED MODULE: ./components/business-hub-hero-enterprise/business-hub-hero-enterprise.builder-component.ts

const BusinessHubHeroEnterPriseBuilderConfig = {
    name: "Business Hub Hero Enterprise",
    inputs: [
        {
            name: "backgroundColor",
            type: "color",
            defaultValue: ""
        },
        {
            name: "backgroundImage",
            type: "file"
        },
        {
            name: "backgroundImageMobile",
            type: "file"
        },
        {
            name: "content",
            type: "object",
            subFields: [
                {
                    name: "image",
                    type: "file",
                    defaultValue: ""
                },
                {
                    name: "title",
                    type: "richText",
                    defaultValue: ""
                },
                {
                    name: "description",
                    type: "richText",
                    defaultValue: ""
                },
                {
                    name: "ctaText",
                    type: "string"
                },
                {
                    name: "ctaLink",
                    type: "string",
                    defaultValue: ""
                }
            ]
        }
    ]
};
const business_hub_hero_enterprise_builder_component_builderConfig = {
    component: business_hub_hero_enterprise,
    config: BusinessHubHeroEnterPriseBuilderConfig
};
/* harmony default export */ var business_hub_hero_enterprise_builder_component = (business_hub_hero_enterprise_builder_component_builderConfig);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(74895);
// EXTERNAL MODULE: ./node_modules/@vimeo/player/dist/player.es.js
var player_es = __webpack_require__(41806);
;// CONCATENATED MODULE: ./node_modules/@u-wave/react-vimeo/dist/react-vimeo.es.js




function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var eventNames = {
  play: 'onPlay',
  pause: 'onPause',
  ended: 'onEnd',
  timeupdate: 'onTimeUpdate',
  progress: 'onProgress',
  seeked: 'onSeeked',
  texttrackchange: 'onTextTrackChange',
  cuechange: 'onCueChange',
  cuepoint: 'onCuePoint',
  volumechange: 'onVolumeChange',
  playbackratechange: 'onPlaybackRateChange',
  error: 'onError',
  loaded: 'onLoaded'
};

var Vimeo = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Vimeo, _React$Component);

  function Vimeo(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.refContainer = _this.refContainer.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = Vimeo.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.createPlayer();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    // eslint-disable-next-line react/destructuring-assignment
    var changes = Object.keys(this.props).filter(function (name) {
      return _this2.props[name] !== prevProps[name];
    });
    this.updateProps(changes);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.player.destroy();
  }
  /**
   * @private
   */
  ;

  _proto.getInitialOptions = function getInitialOptions() {
    /* eslint-disable react/destructuring-assignment */
    return {
      id: this.props.video,
      width: this.props.width,
      height: this.props.height,
      autopause: this.props.autopause,
      autoplay: this.props.autoplay,
      byline: this.props.showByline,
      color: this.props.color,
      controls: this.props.controls,
      loop: this.props.loop,
      portrait: this.props.showPortrait,
      title: this.props.showTitle,
      muted: this.props.muted,
      background: this.props.background,
      responsive: this.props.responsive,
      dnt: this.props.dnt,
      speed: this.props.speed
    };
    /* eslint-enable react/destructuring-assignment */
  }
  /**
   * @private
   */
  ;

  _proto.updateProps = function updateProps(propNames) {
    var _this3 = this;

    var player = this.player;
    propNames.forEach(function (name) {
      // eslint-disable-next-line react/destructuring-assignment
      var value = _this3.props[name];

      switch (name) {
        case 'autopause':
          player.setAutopause(value);
          break;

        case 'color':
          player.setColor(value);
          break;

        case 'loop':
          player.setLoop(value);
          break;

        case 'volume':
          player.setVolume(value);
          break;

        case 'paused':
          player.getPaused().then(function (paused) {
            if (value && !paused) {
              return player.pause();
            }

            if (!value && paused) {
              return player.play();
            }

            return null;
          });
          break;

        case 'width':
        case 'height':
          player.element[name] = value;
          break;

        case 'video':
          if (value) {
            var start = _this3.props.start;
            var loaded = player.loadVideo(value); // Set the start time only when loading a new video.
            // It seems like this has to be done after the video has loaded, else it just starts at
            // the beginning!

            if (typeof start === 'number') {
              loaded.then(function () {
                player.setCurrentTime(start);
              });
            }
          } else {
            player.unload();
          }

          break;

      }
    });
  }
  /**
   * @private
   */
  ;

  _proto.createPlayer = function createPlayer() {
    var _this4 = this;

    var _this$props = this.props,
        start = _this$props.start,
        volume = _this$props.volume;
    this.player = new player_es/* default */.Z(this.container, this.getInitialOptions());
    Object.keys(eventNames).forEach(function (dmName) {
      var reactName = eventNames[dmName];

      _this4.player.on(dmName, function (event) {
        // eslint-disable-next-line react/destructuring-assignment
        var handler = _this4.props[reactName];

        if (handler) {
          handler(event);
        }
      });
    });
    var _this$props2 = this.props,
        onError = _this$props2.onError,
        onReady = _this$props2.onReady;
    this.player.ready().then(function () {
      if (onReady) {
        onReady(_this4.player);
      }
    }, function (err) {
      if (onError) {
        onError(err);
      } else {
        throw err;
      }
    });

    if (typeof start === 'number') {
      this.player.setCurrentTime(start);
    }

    if (typeof volume === 'number') {
      this.updateProps(['volume']);
    }
  }
  /**
   * @private
   */
  ;

  _proto.refContainer = function refContainer(container) {
    this.container = container;
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        id = _this$props3.id,
        className = _this$props3.className,
        style = _this$props3.style;
    return /*#__PURE__*/react.createElement("div", {
      id: id,
      className: className,
      style: style,
      ref: this.refContainer
    });
  };

  return Vimeo;
}(react.Component);

if (false) {}

Vimeo.defaultProps = {
  autopause: true,
  autoplay: false,
  showByline: true,
  controls: true,
  loop: false,
  showPortrait: true,
  showTitle: true,
  muted: false,
  background: false,
  responsive: false,
  dnt: false,
  speed: false
};

/* harmony default export */ var react_vimeo_es = (Vimeo);

// EXTERNAL MODULE: ./components/business-hub-hero-home/business-hub-hero-home.module.scss
var business_hub_hero_home_module = __webpack_require__(2621);
var business_hub_hero_home_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_hero_home_module);
;// CONCATENATED MODULE: ./components/business-hub-hero-home/business-hub-hero-home.tsx








const BusinessHubHeroHome = (props)=>{
    const { video , imagePlaceholder , title , description , ctaText , ctaLink , borderRadiusBackground , imageMobile  } = props;
    const { width =0  } = (0,useWindowSize/* useWindowSize */.i)();
    const [volume, setVolume] = (0,react.useState)(0);
    const videoContainerRef = (0,react.useRef)(null);
    if (!video || !title || !description) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_hub_hero_home_module_default()).container,
        style: {
            ["--borderRadius"]: borderRadiusBackground ? "30px" : "0px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_hero_home_module_default()).imageHero,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: (width > 992 ? imagePlaceholder : imageMobile) || "",
                    alt: "",
                    style: {
                        objectFit: "cover",
                        objectPosition: "center"
                    },
                    fill: true,
                    loading: "eager",
                    loader: (param)=>{
                        let { src , width , quality  } = param;
                        return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                    }
                })
            }),
            width > 992 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: videoContainerRef,
                className: (business_hub_hero_home_module_default()).videoHero,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_vimeo_es, {
                    onLoaded: ()=>{
                        var ref;
                        videoContainerRef === null || videoContainerRef === void 0 ? void 0 : (ref = videoContainerRef.current) === null || ref === void 0 ? void 0 : ref.classList.add((business_hub_hero_home_module_default()).loaded);
                    },
                    video: video,
                    muted: true,
                    volume: volume,
                    autoplay: true,
                    controls: false,
                    loop: true,
                    onVolumeChange: (e)=>setVolume(e.volume)
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_hero_home_module_default()).content,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (business_hub_hero_home_module_default()).wrapperText,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_hub_hero_home_module_default()).title,
                            dangerouslySetInnerHTML: {
                                __html: title
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_hub_hero_home_module_default()).description,
                            dangerouslySetInnerHTML: {
                                __html: description
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                            className: (business_hub_hero_home_module_default()).btn,
                            link: ctaLink,
                            buttonText: ctaText,
                            position: business_button_constants/* POSITION.LEFT */.Vr.LEFT,
                            autoMargin: false,
                            target: "_blank"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var business_hub_hero_home = (BusinessHubHeroHome);

;// CONCATENATED MODULE: ./components/business-hub-hero-home/business-hub-hero-home.builder-component.ts

const BusinessHubHeroHomeBuilderConfig = {
    name: "Business Hub Home Hero",
    inputs: [
        {
            name: "video",
            type: "string",
            defaultValue: ""
        },
        {
            name: "imagePlaceholder",
            type: "file",
            defaultValue: ""
        },
        {
            name: "imageMobile",
            type: "file",
            defaultValue: ""
        },
        {
            name: "borderRadiusBackground",
            type: "boolean"
        },
        {
            name: "title",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "description",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "ctaText",
            type: "string",
            defaultValue: ""
        },
        {
            name: "ctaLink",
            type: "string",
            defaultValue: ""
        }
    ]
};
const business_hub_hero_home_builder_component_builderConfig = {
    component: business_hub_hero_home,
    config: BusinessHubHeroHomeBuilderConfig
};
/* harmony default export */ var business_hub_hero_home_builder_component = (business_hub_hero_home_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-hub-hero-industry/business-hub-hero-industry.module.scss
var business_hub_hero_industry_module = __webpack_require__(13794);
var business_hub_hero_industry_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_hero_industry_module);
;// CONCATENATED MODULE: ./components/business-hub-hero-industry/busines-hub-hero-industry.tsx







swiper/* default.use */.Z.use([
    modules/* Autoplay */.pt
]);
const BusinessHubHeroIndustry = (props)=>{
    const { backgroundColor , content , listImageHero =[]  } = props;
    const options = {
        slidesPerView: "auto",
        spaceBetween: 40,
        allowTouchMove: true,
        noSwiping: false,
        freeMode: false,
        loop: true,
        effect: "fade",
        navigation: true,
        pagination: false,
        speed: 3000,
        autoplay: {
            delay: 1,
            disableOnInteraction: false
        },
        breakpoints: {
            998: {
                spaceBetween: 42,
                watchOverflow: true
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_hub_hero_industry_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (business_hub_hero_industry_module_default()).wrapperContent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_hero_industry_module_default()).wrapperText,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_hub_hero_industry_module_default()).contentText,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_hub_hero_industry_module_default()).title,
                                dangerouslySetInnerHTML: {
                                    __html: (content === null || content === void 0 ? void 0 : content.title) || ""
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_hub_hero_industry_module_default()).description,
                                dangerouslySetInnerHTML: {
                                    __html: (content === null || content === void 0 ? void 0 : content.description) || ""
                                }
                            }),
                            (content === null || content === void 0 ? void 0 : content.ctaLink) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_hub_hero_industry_module_default()).btnHero,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                                    position: business_button_constants/* POSITION.LEFT */.Vr.LEFT,
                                    color: business_button_constants/* COLORS.MINT */.DM.MINT,
                                    link: content === null || content === void 0 ? void 0 : content.ctaLink,
                                    buttonText: "Get started",
                                    target: "_blank"
                                })
                            }) : null
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_hero_industry_module_default()).wrapperImage,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_hub_hero_industry_module_default()).containerImage,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_hub_hero_industry_module_default()).wrapperImage,
                            children: listImageHero ? /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                ...options,
                                children: listImageHero.map((item, index)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                        children: item.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (business_hub_hero_industry_module_default()).item,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: item.image,
                                                alt: "image"
                                            })
                                        })
                                    }, index);
                                })
                            }) : null
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var busines_hub_hero_industry = (BusinessHubHeroIndustry);

;// CONCATENATED MODULE: ./components/business-hub-hero-industry/business-hub-hero-industry.builder-component.ts

const BusinessHubHeroIndustryBuilderConfig = {
    name: "Business Hub Hero Industry",
    inputs: [
        {
            name: "backgroundColor",
            type: "color",
            defaultValue: ""
        },
        {
            name: "content",
            type: "object",
            subFields: [
                {
                    name: "title",
                    type: "html",
                    defaultValue: ""
                },
                {
                    name: "description",
                    type: "html",
                    defaultValue: ""
                },
                {
                    name: "ctaLink",
                    type: "string",
                    defaultValue: ""
                }
            ]
        },
        {
            name: "listImageHero",
            type: "list",
            subFields: [
                {
                    name: "image",
                    type: "file",
                    defaultValue: ""
                }
            ]
        }
    ]
};
const business_hub_hero_industry_builder_component_builderConfig = {
    component: busines_hub_hero_industry,
    config: BusinessHubHeroIndustryBuilderConfig
};
/* harmony default export */ var business_hub_hero_industry_builder_component = (business_hub_hero_industry_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-hub-hero-training/business-hub-hero-training.module.scss
var business_hub_hero_training_module = __webpack_require__(89097);
var business_hub_hero_training_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_hero_training_module);
;// CONCATENATED MODULE: ./components/business-hub-hero-training/business-hub-hero-training.tsx





const BusinessHubHeroTraining = (props)=>{
    var ref, ref1;
    const { title , description , ctaText , ctaLink , background  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_hub_hero_training_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_hub_hero_training_module_default()).content,
                style: {
                    color: background.textColor || "#ffffff"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_hub_hero_training_module_default()).title,
                        dangerouslySetInnerHTML: {
                            __html: title || ""
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_hub_hero_training_module_default()).description,
                        dangerouslySetInnerHTML: {
                            __html: description || ""
                        }
                    }),
                    ctaText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_hub_hero_training_module_default()).button,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                            position: business_button_constants/* POSITION.LEFT */.Vr.LEFT,
                            link: ctaLink,
                            buttonText: ctaText,
                            autoMargin: false
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_hero_training_module_default()).backgroundMobile,
                style: {
                    background: background.backgroundColor
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_hub_hero_training_module_default()).background,
                style: {
                    background: background.backgroundColor
                },
                children: [
                    (background === null || background === void 0 ? void 0 : (ref = background.backgroundRightImage) === null || ref === void 0 ? void 0 : ref.desktop) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_hub_hero_training_module_default()).imageRight,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    media: "(max-width: 998px)",
                                    srcSet: background.backgroundRightImage.mobile || background.backgroundRightImage.desktop
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: background.backgroundRightImage.desktop,
                                    alt: "Hero Image",
                                    style: {
                                        objectFit: "cover",
                                        objectPosition: "center"
                                    },
                                    fill: true,
                                    loader: (param)=>{
                                        let { src , width , quality  } = param;
                                        return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                                    }
                                })
                            ]
                        })
                    }) : null,
                    (background === null || background === void 0 ? void 0 : (ref1 = background.backgroundImage) === null || ref1 === void 0 ? void 0 : ref1.desktop) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_hub_hero_training_module_default()).imageImage,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    media: "(max-width: 765px)",
                                    srcSet: background.backgroundImage.mobile || background.backgroundImage.desktop
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: background.backgroundImage.desktop,
                                    alt: "Hero Image Background",
                                    style: {
                                        objectFit: "cover",
                                        objectPosition: "center"
                                    },
                                    fill: true,
                                    loader: (param)=>{
                                        let { src , width , quality  } = param;
                                        return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                                    }
                                })
                            ]
                        })
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var business_hub_hero_training = (BusinessHubHeroTraining);

;// CONCATENATED MODULE: ./components/business-hub-hero-training/business-hub-hero-training.builder-component.ts

const BusinessHubHeroTrainingBuilderConfig = {
    name: "Business Hub Hero Training",
    inputs: [
        {
            name: "title",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "description",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "ctaText",
            type: "text",
            defaultValue: ""
        },
        {
            name: "ctaLink",
            type: "url",
            defaultValue: ""
        },
        {
            name: "background",
            type: "object",
            subFields: [
                {
                    name: "backgroundRightImage",
                    type: "object",
                    subFields: [
                        {
                            name: "desktop",
                            type: "file"
                        },
                        {
                            name: "mobile",
                            type: "file"
                        }
                    ]
                },
                {
                    name: "backgroundImage",
                    type: "object",
                    subFields: [
                        {
                            name: "desktop",
                            type: "file"
                        },
                        {
                            name: "mobile",
                            type: "file"
                        }
                    ]
                },
                {
                    name: "backgroundColor",
                    type: "color"
                },
                {
                    name: "textColor",
                    type: "color"
                }
            ]
        }
    ]
};
const business_hub_hero_training_builder_component_builderConfig = {
    component: business_hub_hero_training,
    config: BusinessHubHeroTrainingBuilderConfig
};
/* harmony default export */ var business_hub_hero_training_builder_component = (business_hub_hero_training_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-hub-how-ap-works/business-hub-how-ap-works.module.scss
var business_hub_how_ap_works_module = __webpack_require__(56220);
var business_hub_how_ap_works_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_how_ap_works_module);
;// CONCATENATED MODULE: ./components/business-hub-how-ap-works/business-hub-how-ap-works.tsx







gsap.gsap.registerPlugin(ScrollTrigger.ScrollTrigger);
gsap.gsap.registerPlugin(src/* useGSAP */.V);
const BusinessHubHowApWorks = (props)=>{
    const { title , steps =[]  } = props;
    const containerRef = (0,react.useRef)(null);
    (0,src/* useGSAP */.V)(()=>{
        const selector = gsap.gsap.utils.selector(containerRef);
        const sections = gsap.gsap.utils.toArray(selector(".".concat((business_hub_how_ap_works_module_default()).section)));
        const progresses = gsap.gsap.utils.toArray(selector(".".concat((business_hub_how_ap_works_module_default()).progressItem)));
        let tl = gsap.gsap.timeline({
            defaults: {
                gap: 1,
                duration: 1,
                ease: "none"
            },
            scrollTrigger: {
                trigger: containerRef.current,
                pinnedContainer: containerRef.current,
                pin: true,
                start: "bottom bottom",
                scrub: true,
                end: "+=300%",
                invalidateOnRefresh: true
            }
        });
        gsap.gsap.set(sections, {
            yPercent: 100,
            opacity: 0
        });
        gsap.gsap.set(progresses, {
            yPercent: 100
        });
        for(let index = 0; index < sections.length; index++){
            const section = sections[index];
            const progress = progresses[index];
            if (index === 0) {
                tl.to({}, {}, "+=1");
                gsap.gsap.set([
                    section
                ], {
                    yPercent: 0,
                    y: 0,
                    autoAlpha: 1
                });
                gsap.gsap.set(progress, {
                    yPercent: 0,
                    autoAlpha: 1,
                    className: "".concat((business_hub_how_ap_works_module_default()).progressItem, " ").concat((business_hub_how_ap_works_module_default()).active)
                });
                if (progresses[index + 1]) {
                    gsap.gsap.set(progresses[index + 1], {
                        yPercent: 50,
                        opacity: 1
                    });
                }
                continue;
            }
            const prevSection = sections[index - 1];
            const prevProgress = progresses[index - 1];
            const nextProgress = progresses[index + 1];
            tl.to({}, {
                onStart: ()=>{
                    progress.classList.add((business_hub_how_ap_works_module_default()).active);
                    const subTL = gsap.gsap.timeline({}).to([
                        progress,
                        section
                    ], {
                        yPercent: 0,
                        opacity: 1
                    });
                    if (prevSection) {
                        subTL.to([
                            prevSection,
                            prevProgress
                        ], {
                            yPercent: -50,
                            opacity: 0
                        }, "<");
                    }
                    if (nextProgress) {
                        subTL.to(nextProgress, {
                            yPercent: 50,
                            opacity: 1
                        }, "<");
                    }
                },
                onReverseComplete: ()=>{
                    progress.classList.remove((business_hub_how_ap_works_module_default()).active);
                    const subTL = gsap.gsap.timeline({}).to([
                        section
                    ], {
                        yPercent: 100,
                        opacity: 0
                    }).to(progress, {
                        yPercent: 50,
                        opacity: 1
                    }, "<");
                    if (prevProgress) {
                        subTL.to([
                            prevSection
                        ], {
                            yPercent: 0,
                            opacity: 1
                        }, "<").to([
                            prevProgress
                        ], {
                            yPercent: 0,
                            opacity: 1
                        }, "<");
                    }
                    if (nextProgress) {
                        subTL.to(nextProgress, {
                            yPercent: 100,
                            opacity: 0
                        }, "<");
                    }
                }
            }, "+=1");
            tl.to({}, {}, "+=0.5");
        }
    }, {
        scope: containerRef
    });
    if (!steps.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_hub_how_ap_works_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_how_ap_works_module_default()).background
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: containerRef,
                className: (business_hub_how_ap_works_module_default()).box,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (business_hub_how_ap_works_module_default()).parallaxContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_hub_how_ap_works_module_default()).title,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (business_hub_how_ap_works_module_default()).scrollContent,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (business_hub_how_ap_works_module_default()).scrollContentOverlay,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (business_hub_how_ap_works_module_default()).progress,
                                            children: steps.map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (business_hub_how_ap_works_module_default()).progressItem,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (business_hub_how_ap_works_module_default()).progressBox,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: index + 1
                                                        })
                                                    })
                                                }, index))
                                        })
                                    ]
                                }),
                                steps.map((step, index)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                        className: (business_hub_how_ap_works_module_default()).section,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (business_hub_how_ap_works_module_default()).sectionImage,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: step.illustration,
                                                    alt: "",
                                                    style: {
                                                        objectFit: "cover",
                                                        objectPosition: "center"
                                                    },
                                                    fill: true,
                                                    loading: "eager",
                                                    loader: (param)=>{
                                                        let { src , width , quality  } = param;
                                                        return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                                                    },
                                                    className: (business_hub_how_ap_works_module_default()).image
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (business_hub_how_ap_works_module_default()).sectionContent,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (business_hub_how_ap_works_module_default()).sectionContentIcon,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (business_hub_how_ap_works_module_default()).sectionContentIconBox,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: step.icon,
                                                                alt: "",
                                                                style: {
                                                                    objectFit: "contain",
                                                                    objectPosition: "center"
                                                                },
                                                                fill: true,
                                                                loader: (param)=>{
                                                                    let { src , width , quality  } = param;
                                                                    return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                                                                }
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (business_hub_how_ap_works_module_default()).sectionContentDescription,
                                                        style: {
                                                            "--des-max-width": step.descriptionMaxWidth ? "".concat(step.descriptionMaxWidth, "px") : null
                                                        },
                                                        dangerouslySetInnerHTML: {
                                                            __html: step.description
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }, "step_".concat(index));
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var business_hub_how_ap_works = (BusinessHubHowApWorks);

;// CONCATENATED MODULE: ./components/business-hub-how-ap-works/business-hub-how-ap-works.builder-component.ts

const BusinessHubHowApWorksBuilderConfig = {
    name: "Business Hub How Afterpay Works",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: ""
        },
        {
            name: "steps",
            type: "list",
            subFields: [
                // {
                //     name: 'name',
                //     type: 'string',
                //     required: true,
                // },
                {
                    name: "description",
                    type: "richText"
                },
                {
                    name: "descriptionMaxWidth",
                    type: "number"
                },
                {
                    name: "icon",
                    type: "file",
                    required: true
                },
                {
                    name: "illustration",
                    type: "file",
                    required: true
                }
            ]
        }
    ]
};
const business_hub_how_ap_works_builder_component_builderConfig = {
    component: business_hub_how_ap_works,
    config: BusinessHubHowApWorksBuilderConfig
};
/* harmony default export */ var business_hub_how_ap_works_builder_component = (business_hub_how_ap_works_builder_component_builderConfig);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(16638);
// EXTERNAL MODULE: ./components/business-hub-how-it-work/business-hub-how-it-works.module.scss
var business_hub_how_it_works_module = __webpack_require__(19485);
var business_hub_how_it_works_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_how_it_works_module);
;// CONCATENATED MODULE: ./components/business-hub-how-it-work/business-hub-how-it-works.tsx

 // Đảm bảo đã cài đặt lodash




const BusinessHubHowItWorks = (props)=>{
    const { title , steps =[]  } = props;
    const [activeStepIndex, setActiveStepIndex] = (0,react.useState)(null);
    const sectionRefs = (0,react.useRef)([]);
    (0,react.useEffect)(()=>{
        const handleScroll = (0,lodash.debounce)(()=>{
            const currentScrollY = window.scrollY;
            let closestIndex = null;
            let smallestDistance = Infinity;
            sectionRefs.current.forEach((section, index)=>{
                if (section) {
                    const sectionTop = section.getBoundingClientRect().top + currentScrollY - 30;
                    const distance = Math.abs(currentScrollY - sectionTop);
                    if (distance < smallestDistance) {
                        smallestDistance = distance;
                        closestIndex = index;
                    }
                }
            });
            if (closestIndex !== null) {
                setActiveStepIndex(closestIndex);
            }
        }, 10);
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        steps
    ]);
    if (!steps.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_hub_how_it_works_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_how_it_works_module_default()).background
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_how_it_works_module_default()).box,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (business_hub_how_it_works_module_default()).parallaxContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_hub_how_it_works_module_default()).title,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_hub_how_it_works_module_default()).scrollContent,
                            children: steps.map((step, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                    "data-index": index + 1,
                                    ref: (el)=>sectionRefs.current[index] = el,
                                    className: "".concat((business_hub_how_it_works_module_default()).section, " ").concat(index === activeStepIndex ? (business_hub_how_it_works_module_default()).activeSection : ""),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (business_hub_how_it_works_module_default()).sectionContent,
                                        "data-index": index + 1,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (business_hub_how_it_works_module_default()).progress,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (business_hub_how_it_works_module_default()).progressItem
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (business_hub_how_it_works_module_default()).progressBox,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: index + 1
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (business_hub_how_it_works_module_default()).sectionContentIcon,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (business_hub_how_it_works_module_default()).sectionContentIconBox,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: step.icon,
                                                        alt: "",
                                                        style: {
                                                            objectFit: "contain",
                                                            objectPosition: "center"
                                                        },
                                                        fill: true,
                                                        loader: (param)=>{
                                                            let { src , width , quality  } = param;
                                                            return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                                                        }
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (business_hub_how_it_works_module_default()).sectionContentDescription,
                                                style: {
                                                    "--des-max-width": step.descriptionMaxWidth ? "".concat(step.descriptionMaxWidth, "px") : null
                                                },
                                                dangerouslySetInnerHTML: {
                                                    __html: step.description
                                                }
                                            })
                                        ]
                                    })
                                }, index))
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var business_hub_how_it_works = (BusinessHubHowItWorks);

;// CONCATENATED MODULE: ./components/business-hub-how-it-work/business-hub-how-it-works.builder-component.ts

const BusinessHubHowItWorksBuilderConfig = {
    name: "Business Hub Time Line How It Work",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: ""
        },
        {
            name: "steps",
            type: "list",
            subFields: [
                {
                    name: "description",
                    type: "richText"
                },
                {
                    name: "descriptionMaxWidth",
                    type: "number"
                },
                {
                    name: "icon",
                    type: "file",
                    required: true
                },
                {
                    name: "illustration",
                    type: "file",
                    required: true
                }
            ]
        }
    ]
};
const business_hub_how_it_works_builder_component_builderConfig = {
    component: business_hub_how_it_works,
    config: BusinessHubHowItWorksBuilderConfig
};
/* harmony default export */ var business_hub_how_it_works_builder_component = (business_hub_how_it_works_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/ratio-image/ratio-image.module.scss
var ratio_image_module = __webpack_require__(77270);
var ratio_image_module_default = /*#__PURE__*/__webpack_require__.n(ratio_image_module);
;// CONCATENATED MODULE: ./components/ratio-image/ratio-image.tsx



const RatioImage = (param)=>{
    let { image , ratio ="auto" , maxHeight , maxWidth , minHeight  } = param;
    const [imageBoxStyle, setImageBoxStyle] = (0,react.useState)(typeof ratio === "number" ? {
        paddingTop: "".concat(ratio * 100, "%")
    } : {});
    const [imageStyle, setImageStyle] = (0,react.useState)({
        maxHeight,
        maxWidth,
        minHeight
    });
    (0,react.useEffect)(()=>{
        if (image) {
            const img = new Image();
            img.onload = function() {
                if (ratio === "auto") {
                    setImageBoxStyle({
                        ...imageBoxStyle,
                        paddingTop: "".concat(img.height / img.width * 100, "%")
                    });
                }
                if (maxHeight || maxWidth) {
                    setImageStyle({
                        ...imageStyle,
                        maxWidth: maxWidth ? maxWidth : maxHeight && maxHeight * (img.width / img.height),
                        maxHeight: maxHeight ? maxHeight : maxWidth && maxWidth * (img.height / img.width)
                    });
                }
            };
            img.src = image;
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ratio_image_module_default()).root,
        style: imageStyle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (ratio_image_module_default()).imageContainer,
            style: imageBoxStyle,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: (ratio_image_module_default()).image,
                src: image,
                alt: ""
            })
        })
    });
};
/* harmony default export */ var ratio_image = (RatioImage);

// EXTERNAL MODULE: ./components/business-hub-image-block-full/business-hub-image-block-full.module.scss
var business_hub_image_block_full_module = __webpack_require__(82966);
var business_hub_image_block_full_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_image_block_full_module);
;// CONCATENATED MODULE: ./components/business-hub-image-block-full/business-hub-image-block-full.tsx



const BusinessHubImageBlockFull = (props)=>{
    const { image , maxWidth , maxHeight , ratio  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_hub_image_block_full_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (business_hub_image_block_full_module_default()).wrapperImage,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ratio_image, {
                image: image,
                ratio: ratio,
                maxWidth: maxWidth,
                maxHeight: maxHeight
            })
        })
    });
};
/* harmony default export */ var business_hub_image_block_full = (BusinessHubImageBlockFull);

;// CONCATENATED MODULE: ./components/business-hub-image-block-full/business-hub-image-block-full.builder-component.ts

const BusinessHubImageBlockFullBuilderConfig = {
    name: "Image Block Full",
    inputs: [
        {
            name: "image",
            type: "file",
            defaultValue: ""
        },
        {
            name: "ratio",
            type: "number"
        },
        {
            name: "maxWidth",
            type: "number"
        },
        {
            name: "maxHeight",
            type: "number"
        },
        {
            name: "minHeight",
            type: "number"
        }
    ]
};
const business_hub_image_block_full_builder_component_builderConfig = {
    component: business_hub_image_block_full,
    config: BusinessHubImageBlockFullBuilderConfig
};
/* harmony default export */ var business_hub_image_block_full_builder_component = (business_hub_image_block_full_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-hub-image-block/business-hub-image-block.module.scss
var business_hub_image_block_module = __webpack_require__(298);
var business_hub_image_block_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_image_block_module);
;// CONCATENATED MODULE: ./components/business-hub-image-block/business-hub-image-block.tsx







var business_hub_image_block_IMAGE_POSITION;
(function(IMAGE_POSITION) {
    IMAGE_POSITION["Left"] = "Left";
    IMAGE_POSITION["Right"] = "Right";
    IMAGE_POSITION["Top"] = "Top";
    IMAGE_POSITION["TopRight"] = "TopRight";
    IMAGE_POSITION["Bottom"] = "Bottom";
    IMAGE_POSITION["BottomRight"] = "BottomRight";
})(business_hub_image_block_IMAGE_POSITION || (business_hub_image_block_IMAGE_POSITION = {}));
var IMAGE_POSITION_MOBILE;
(function(IMAGE_POSITION_MOBILE) {
    IMAGE_POSITION_MOBILE["TopMobile"] = "Top";
    IMAGE_POSITION_MOBILE["BottomMobile"] = "Bottom";
})(IMAGE_POSITION_MOBILE || (IMAGE_POSITION_MOBILE = {}));
var THEME_CONTENT;
(function(THEME_CONTENT) {
    THEME_CONTENT["default"] = "default";
    THEME_CONTENT["gray"] = "gray";
})(THEME_CONTENT || (THEME_CONTENT = {}));
const BusinessHubImageBlock = (props)=>{
    var ref, ref1;
    const { image , backgroundColor , text , backgroundImage , backgroundLinearGradient , heightContainer , paddingTopContainer , paddingBottomContainer , paddingBottomContainerMobile , paddingTopContainerMobile , backgroundContent , backgroundLoop , bottomBackgroundLoop , positionImageLoop  } = props;
    const [isMobile, setIsMobile] = (0,react.useState)(false);
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const windowWidth = windowSize.width || 0;
    (0,react.useEffect)(()=>{
        if (windowWidth <= 998) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    }, [
        windowWidth
    ]);
    const backgroundContentStyle = backgroundContent === THEME_CONTENT.gray ? (business_hub_image_block_module_default()).bgGray : (business_hub_image_block_module_default())["default"];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_hub_image_block_module_default()).container,
        style: {
            backgroundColor: "".concat(backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "#ffff"),
            background: "".concat(backgroundLinearGradient),
            height: heightContainer,
            paddingBottom: isMobile ? paddingBottomContainerMobile : paddingBottomContainer,
            paddingTop: isMobile ? paddingTopContainerMobile : paddingTopContainer
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_image_block_module_default()).backgroundImage,
                style: {
                    zIndex: "".concat(backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.zIndex)
                },
                children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: ((ref = props.backgroundImage) === null || ref === void 0 ? void 0 : ref.imageMobile) || "",
                    alt: ""
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: ((ref1 = props.backgroundImage) === null || ref1 === void 0 ? void 0 : ref1.image) || "",
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((business_hub_image_block_module_default()).wrapperContent, backgroundContentStyle, isMobile ? {
                    [(business_hub_image_block_module_default()).topMobile]: (image === null || image === void 0 ? void 0 : image.positionImageMobile) === IMAGE_POSITION_MOBILE.TopMobile,
                    [(business_hub_image_block_module_default()).bottomMobile]: (image === null || image === void 0 ? void 0 : image.positionImageMobile) === IMAGE_POSITION_MOBILE.BottomMobile
                } : {
                    [(business_hub_image_block_module_default()).left]: (image === null || image === void 0 ? void 0 : image.positionImage) === business_hub_image_block_IMAGE_POSITION.Left,
                    [(business_hub_image_block_module_default()).right]: (image === null || image === void 0 ? void 0 : image.positionImage) === business_hub_image_block_IMAGE_POSITION.Right,
                    [(business_hub_image_block_module_default()).top]: (image === null || image === void 0 ? void 0 : image.positionImage) === business_hub_image_block_IMAGE_POSITION.Top,
                    [(business_hub_image_block_module_default()).topRight]: (image === null || image === void 0 ? void 0 : image.positionImage) === business_hub_image_block_IMAGE_POSITION.TopRight,
                    [(business_hub_image_block_module_default()).bottom]: (image === null || image === void 0 ? void 0 : image.positionImage) === business_hub_image_block_IMAGE_POSITION.Bottom,
                    [(business_hub_image_block_module_default()).bottomRight]: (image === null || image === void 0 ? void 0 : image.positionImage) === business_hub_image_block_IMAGE_POSITION.BottomRight
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_hub_image_block_module_default()).image,
                        style: {
                            maxWidth: isMobile ? image === null || image === void 0 ? void 0 : image.maxWidthMobile : image === null || image === void 0 ? void 0 : image.maxWidth
                        },
                        children: [
                            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: image === null || image === void 0 ? void 0 : image.sourceMobile,
                                alt: ""
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: image === null || image === void 0 ? void 0 : image.source,
                                alt: ""
                            }),
                            isMobile && backgroundLoop && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_hub_image_block_module_default()).backgroundLoop,
                                style: {
                                    ["--bottom-background-loop"]: bottomBackgroundLoop
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: backgroundLoop,
                                    alt: "",
                                    className: classnames_default()((business_hub_image_block_module_default()).backgroundLoopImage, {
                                        [(business_hub_image_block_module_default()).top]: positionImageLoop === "top",
                                        [(business_hub_image_block_module_default()).bottom]: positionImageLoop === "bottom"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_hub_image_block_module_default()).wrapperText,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (business_hub_image_block_module_default()).wrapper,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (business_hub_image_block_module_default()).title,
                                    style: {
                                        ["--fil-color"]: text.fillColor,
                                        maxWidth: isMobile ? text.maxWidthTitleMobile : "100%"
                                    },
                                    dangerouslySetInnerHTML: {
                                        __html: text.title || ""
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (business_hub_image_block_module_default()).description,
                                    dangerouslySetInnerHTML: {
                                        __html: (text === null || text === void 0 ? void 0 : text.description) || ""
                                    },
                                    style: {
                                        maxWidth: text.maxWidthDescription
                                    }
                                }),
                                text.ctaText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (business_hub_image_block_module_default()).button,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                                        position: business_button_constants/* POSITION.LEFT */.Vr.LEFT,
                                        color: text.backgroundButton,
                                        link: text.ctaLink,
                                        buttonText: text.ctaText,
                                        autoMargin: false,
                                        target: "_blank"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var business_hub_image_block = (BusinessHubImageBlock);

;// CONCATENATED MODULE: ./components/business-hub-image-block/business-hub-image-block.builder-component.ts


const BusinessHubImageBlockBuilderConfig = {
    name: "Business Hub Image Block",
    inputs: [
        {
            name: "backgroundColor",
            type: "color"
        },
        {
            name: "backgroundLinearGradient",
            type: "string"
        },
        {
            name: "heightContainer",
            type: "number"
        },
        {
            name: "paddingTopContainer",
            type: "number"
        },
        {
            name: "paddingBottomContainer",
            type: "number"
        },
        {
            name: "paddingTopContainerMobile",
            type: "number"
        },
        {
            name: "paddingBottomContainerMobile",
            type: "number"
        },
        {
            name: "backgroundContent",
            type: "string",
            enum: Object.values(THEME_CONTENT),
            defaultValue: THEME_CONTENT["default"]
        },
        {
            name: "backgroundImage",
            type: "object",
            subFields: [
                {
                    name: "image",
                    type: "file"
                },
                {
                    name: "imageMobile",
                    type: "file"
                },
                {
                    name: "zIndex",
                    type: "number",
                    defaultValue: 0
                }
            ]
        },
        {
            name: "image",
            type: "object",
            subFields: [
                {
                    name: "source",
                    type: "file"
                },
                {
                    name: "sourceMobile",
                    type: "file"
                },
                {
                    name: "maxWidth",
                    type: "number"
                },
                {
                    name: "maxWidthMobile",
                    type: "number"
                },
                {
                    name: "positionImage",
                    type: "string",
                    enum: Object.values(business_hub_image_block_IMAGE_POSITION),
                    defaultValue: business_hub_image_block_IMAGE_POSITION.Left
                },
                {
                    name: "positionImageMobile",
                    type: "string",
                    enum: Object.values(IMAGE_POSITION_MOBILE),
                    defaultValue: IMAGE_POSITION_MOBILE.TopMobile
                }
            ]
        },
        {
            name: "backgroundLoop",
            type: "file"
        },
        {
            name: "bottomBackgroundLoop",
            type: "number"
        },
        {
            name: "positionImageLoop",
            type: "string",
            enum: [
                "top",
                "bottom"
            ]
        },
        {
            name: "text",
            type: "object",
            subFields: [
                {
                    name: "title",
                    type: "richText"
                },
                {
                    name: "maxWidthTitleMobile",
                    type: "number"
                },
                {
                    name: "description",
                    type: "richText"
                },
                {
                    name: "maxWidthDescription",
                    type: "number"
                },
                {
                    name: "ctaText",
                    type: "string"
                },
                {
                    name: "ctaLink",
                    type: "string"
                },
                {
                    name: "backgroundButton",
                    type: "string",
                    enum: Object.values(business_button_constants/* COLORS */.DM),
                    defaultValue: business_button_constants/* COLORS.BLACK */.DM.BLACK
                },
                {
                    name: "fillColor",
                    type: "color"
                }
            ]
        }
    ]
};
const business_hub_image_block_builder_component_builderConfig = {
    component: business_hub_image_block,
    config: BusinessHubImageBlockBuilderConfig
};
/* harmony default export */ var business_hub_image_block_builder_component = (business_hub_image_block_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-hub-image-hero/business-hub-image-hero.module.scss
var business_hub_image_hero_module = __webpack_require__(43859);
var business_hub_image_hero_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_image_hero_module);
;// CONCATENATED MODULE: ./components/business-hub-image-hero/business-hub-image-hero.tsx






const BusinessHubImageHero = (props)=>{
    var ref, ref1, ref2;
    const { title , description , maxWithDescription , industryIcon , ctaText , ctaLink , ctaColor , background  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_hub_image_hero_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_hub_image_hero_module_default()).content,
                style: {
                    color: background.textColor
                },
                children: [
                    industryIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_hub_image_hero_module_default()).industryIcon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: industryIcon,
                            alt: title,
                            style: {
                                objectFit: "contain",
                                objectPosition: "center"
                            }
                        })
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_hub_image_hero_module_default()).title,
                        dangerouslySetInnerHTML: {
                            __html: title || ""
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_hub_image_hero_module_default()).description,
                        style: maxWithDescription ? {
                            maxWidth: "".concat(maxWithDescription, "px")
                        } : {},
                        dangerouslySetInnerHTML: {
                            __html: description || ""
                        }
                    }),
                    ctaText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_hub_image_hero_module_default()).button,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                            color: ctaColor,
                            position: business_button_constants/* POSITION.LEFT */.Vr.LEFT,
                            link: ctaLink,
                            buttonText: ctaText,
                            autoMargin: false,
                            target: "_blank"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_image_hero_module_default()).backgroundMobile,
                style: {
                    background: background.backgroundColor
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_hub_image_hero_module_default()).background,
                style: {
                    background: background.backgroundColor
                },
                children: [
                    (background === null || background === void 0 ? void 0 : (ref = background.backgroundRightImage) === null || ref === void 0 ? void 0 : ref.desktop) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_hub_image_hero_module_default()).imageRight,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    media: "(max-width: 998px)",
                                    srcSet: background.backgroundRightImage.mobile || background.backgroundRightImage.desktop
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: background.backgroundRightImage.desktop,
                                    alt: "Hero Image",
                                    style: {
                                        objectFit: "cover",
                                        objectPosition: "center"
                                    },
                                    fill: true,
                                    loader: (param)=>{
                                        let { src , width , quality  } = param;
                                        return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                                    }
                                })
                            ]
                        })
                    }) : null,
                    (background === null || background === void 0 ? void 0 : (ref1 = background.backgroundImage) === null || ref1 === void 0 ? void 0 : ref1.desktop) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((business_hub_image_hero_module_default()).imageImage, (business_hub_image_hero_module_default()).desktop),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    media: "(max-width: 765px)",
                                    srcSet: background.backgroundImage.desktop
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: background.backgroundImage.desktop,
                                    alt: "",
                                    style: {
                                        objectFit: "cover",
                                        objectPosition: "center"
                                    },
                                    fill: true,
                                    loader: (param)=>{
                                        let { src , width , quality  } = param;
                                        return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                                    }
                                })
                            ]
                        })
                    }) : null,
                    (background === null || background === void 0 ? void 0 : (ref2 = background.backgroundImage) === null || ref2 === void 0 ? void 0 : ref2.mobile) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((business_hub_image_hero_module_default()).imageImage, (business_hub_image_hero_module_default()).mobile),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    media: "(max-width: 765px)",
                                    srcSet: background.backgroundImage.mobile
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: background.backgroundImage.mobile,
                                    alt: "",
                                    style: {
                                        objectFit: "cover",
                                        objectPosition: "center"
                                    },
                                    fill: true,
                                    loader: (param)=>{
                                        let { src , width , quality  } = param;
                                        return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                                    }
                                })
                            ]
                        })
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var business_hub_image_hero = (BusinessHubImageHero);

;// CONCATENATED MODULE: ./components/business-hub-image-hero/business-hub-image-hero.builder-component.ts


const BusinessHubImageHeroBuilderConfig = {
    name: "Business Hub Image Hero",
    inputs: [
        {
            name: "industryIcon",
            type: "file"
        },
        {
            name: "title",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "description",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "maxWithDescription",
            type: "number"
        },
        {
            name: "ctaText",
            type: "text",
            defaultValue: ""
        },
        {
            name: "ctaColor",
            type: "string",
            enum: Object.values(business_button_constants/* COLORS */.DM),
            defaultValue: business_button_constants/* COLORS.MINT */.DM.MINT
        },
        {
            name: "ctaLink",
            type: "url",
            defaultValue: ""
        },
        {
            name: "background",
            type: "object",
            subFields: [
                {
                    name: "backgroundRightImage",
                    type: "object",
                    subFields: [
                        {
                            name: "desktop",
                            type: "file"
                        },
                        {
                            name: "mobile",
                            type: "file"
                        }
                    ]
                },
                {
                    name: "backgroundImage",
                    type: "object",
                    subFields: [
                        {
                            name: "desktop",
                            type: "file"
                        },
                        {
                            name: "mobile",
                            type: "file"
                        }
                    ]
                },
                {
                    name: "backgroundColor",
                    type: "color"
                },
                {
                    name: "textColor",
                    type: "color"
                }
            ]
        }
    ]
};
const business_hub_image_hero_builder_component_builderConfig = {
    component: business_hub_image_hero,
    config: BusinessHubImageHeroBuilderConfig
};
/* harmony default export */ var business_hub_image_hero_builder_component = (business_hub_image_hero_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-hub-In-action-carousel/business-hub-In-action-carousel.module.scss
var business_hub_In_action_carousel_module = __webpack_require__(58267);
var business_hub_In_action_carousel_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_In_action_carousel_module);
;// CONCATENATED MODULE: ./components/business-hub-In-action-carousel/business-hub-In-action-carousel.tsx






const business_hub_In_action_carousel_options = {
    spaceBetween: 10,
    allowTouchMove: true,
    noSwiping: false,
    freeMode: false,
    loop: true,
    effect: "fade",
    pagination: {
        enabled: true,
        clickable: true
    },
    speed: 1000,
    // autoplay: {
    //     delay: 3000,
    //     disableOnInteraction: false,
    // },
    slidesPerGroupSkip: 0,
    breakpoints: {
        998: {
            watchOverflow: true
        }
    }
};
const BusinessHubInActionCarousel = (props)=>{
    const { title , items =[]  } = props;
    const containerRef = (0,react.useRef)(null);
    const [swiper, setSwiper] = (0,react.useState)();
    (0,react.useEffect)(()=>{
        if (!swiper) return;
        if (!containerRef.current) return;
        const observer = new IntersectionObserver((entries)=>{
            if (entries) entries.forEach((entry)=>{
                if (entry.intersectionRatio > 0) {
                    swiper.params.autoplay = {
                        delay: 6000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true
                    };
                    swiper.update();
                    swiper.autoplay.start();
                    observer.disconnect();
                }
            });
        });
        observer.observe(containerRef.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        containerRef,
        swiper
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: containerRef,
        className: (business_hub_In_action_carousel_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (business_hub_In_action_carousel_module_default()).wrapperContent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_In_action_carousel_module_default()).header,
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_In_action_carousel_module_default()).content,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        ...business_hub_In_action_carousel_options,
                        onInit: (swiper)=>setSwiper(swiper),
                        modules: [
                            modules/* Pagination */.tl
                        ],
                        children: items.map((item, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (business_hub_In_action_carousel_module_default()).item,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (business_hub_In_action_carousel_module_default()).image,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: (business_hub_In_action_carousel_module_default()).desktop,
                                                    src: item.banner,
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: (business_hub_In_action_carousel_module_default()).mobile,
                                                    src: item.image,
                                                    alt: ""
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (business_hub_In_action_carousel_module_default()).wrapperText,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (business_hub_In_action_carousel_module_default()).subTitle,
                                                    children: item.subTitle
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (business_hub_In_action_carousel_module_default()).title,
                                                    children: item.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (business_hub_In_action_carousel_module_default()).description,
                                                    children: item.description
                                                })
                                            ]
                                        })
                                    ]
                                }, index)
                            }, item.title);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var business_hub_In_action_carousel = (BusinessHubInActionCarousel);

;// CONCATENATED MODULE: ./components/business-hub-In-action-carousel/business-hub-In-action-carousel.builder-component.ts

const BusinessHubInActionCarouselBuilderConfig = {
    name: "Business Hub In Action Carousel",
    inputs: [
        {
            name: "title",
            type: "string"
        },
        {
            name: "items",
            type: "list",
            subFields: [
                {
                    name: "image",
                    type: "file",
                    helperText: "Use for mobile"
                },
                {
                    name: "banner",
                    type: "file",
                    helperText: "Use for desktop"
                },
                {
                    name: "subTitle",
                    type: "string"
                },
                {
                    name: "title",
                    type: "string"
                },
                {
                    name: "description",
                    type: "string"
                }
            ]
        }
    ]
};
const business_hub_In_action_carousel_builder_component_builderConfig = {
    component: business_hub_In_action_carousel,
    config: BusinessHubInActionCarouselBuilderConfig
};
/* harmony default export */ var business_hub_In_action_carousel_builder_component = (business_hub_In_action_carousel_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-hub-industries-card-block/business-hub-industries-card-block.module.scss
var business_hub_industries_card_block_module = __webpack_require__(29526);
var business_hub_industries_card_block_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_industries_card_block_module);
// EXTERNAL MODULE: ./types/Media.ts
var Media = __webpack_require__(39289);
// EXTERNAL MODULE: ./components/business-youtube-embed/business-youtube-embed.module.scss
var business_youtube_embed_module = __webpack_require__(36242);
var business_youtube_embed_module_default = /*#__PURE__*/__webpack_require__.n(business_youtube_embed_module);
;// CONCATENATED MODULE: ./components/business-youtube-embed/business-youtube-embed.tsx





const BusinessYoutubeEmbed = (props)=>{
    const { videoUrl , ratio ="1:1" , autoHeight , containerMaxWidth , disableMargin , className  } = props;
    const renderVidPlayer = ()=>{
        const [width, height] = Media/* MEDIA_RATIO */.r[ratio];
        const youtubeVideoPaddingTop = height / width * 100;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()((business_youtube_embed_module_default()).youtubeVideo, className),
            style: {
                paddingTop: autoHeight ? 0 : "".concat(youtubeVideoPaddingTop, "%")
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                width: "872",
                height: "872",
                src: videoUrl,
                frameBorder: "0",
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                allowFullScreen: true
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((business_youtube_embed_module_default()).businessYoutubeEmbedContainer, {
            [(business_youtube_embed_module_default()).margin0]: disableMargin
        }, {
            [(business_youtube_embed_module_default()).autoHeight]: autoHeight
        }),
        style: {
            width: containerMaxWidth
        },
        children: renderVidPlayer()
    });
};
/* harmony default export */ var business_youtube_embed = (BusinessYoutubeEmbed);

;// CONCATENATED MODULE: ./components/business-hub-industries-card-block/business-hub-industries-card-block.tsx







const BusinessHubIndustriesBlock = (props)=>{
    const { afterpayAccessTitle , afterpayAccessTitleColor , title , description , icon , image , imageMobile , background , textColor , ctaColor , ctaText , ctaUrl , reversed , iconBackground , ctaDisableBorder , youtubeUrl  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_hub_industries_card_block_module_default()).container,
        style: {
            "--bg-color": background,
            "--icon-bg-color": iconBackground,
            "--text-color": textColor
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((business_hub_industries_card_block_module_default()).gird, {
                [(business_hub_industries_card_block_module_default()).reversed]: reversed
            }, {
                [(business_hub_industries_card_block_module_default()).minHeight]: !youtubeUrl
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((business_hub_industries_card_block_module_default()).content, {
                        [(business_hub_industries_card_block_module_default()).noPadding]: youtubeUrl
                    }),
                    children: [
                        afterpayAccessTitle ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (business_hub_industries_card_block_module_default()).heading,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (business_hub_industries_card_block_module_default()).icon,
                                    children: icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: icon,
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (business_hub_industries_card_block_module_default()).text,
                                    style: {
                                        color: afterpayAccessTitleColor
                                    },
                                    children: afterpayAccessTitle
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_hub_industries_card_block_module_default()).title,
                            dangerouslySetInnerHTML: {
                                __html: title || ""
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_hub_industries_card_block_module_default()).description,
                            dangerouslySetInnerHTML: {
                                __html: description || ""
                            }
                        }),
                        ctaText && ctaUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                            className: classnames_default()((business_hub_industries_card_block_module_default()).cta, {
                                [(business_hub_industries_card_block_module_default()).disableBorder]: ctaDisableBorder
                            }),
                            position: business_button_constants/* POSITION.LEFT */.Vr.LEFT,
                            color: ctaColor,
                            link: ctaUrl,
                            buttonText: ctaText,
                            autoMargin: false,
                            target: "_blank"
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((business_hub_industries_card_block_module_default()).illustration, {
                        [(business_hub_industries_card_block_module_default()).bg]: !image && !youtubeUrl
                    }),
                    children: [
                        youtubeUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_hub_industries_card_block_module_default()).youtube,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_youtube_embed, {
                                videoUrl: youtubeUrl,
                                className: (business_hub_industries_card_block_module_default()).youtubebox,
                                autoHeight: true,
                                disableMargin: true
                            })
                        }) : null,
                        !youtubeUrl && image && /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    media: "(max-width: 998px)",
                                    srcSet: imageMobile || image
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: image,
                                    alt: "",
                                    style: {
                                        objectFit: "cover",
                                        objectPosition: "center"
                                    },
                                    fill: true,
                                    loader: (param)=>{
                                        let { src , width , quality  } = param;
                                        return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                                    }
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var business_hub_industries_card_block = (BusinessHubIndustriesBlock);

;// CONCATENATED MODULE: ./components/business-hub-industries-card-block/business-hub-industries-card-block.builder-component.ts


const BusinessHubIndustriesCardBlockBuilderConfig = {
    name: "Business Hub Industries Card Block",
    inputs: [
        {
            name: "icon",
            type: "file"
        },
        {
            name: "iconBackground",
            type: "color"
        },
        {
            name: "afterpayAccessTitle",
            type: "text"
        },
        {
            name: "afterpayAccessTitleColor",
            type: "color"
        },
        {
            name: "title",
            type: "html"
        },
        {
            name: "description",
            type: "html"
        },
        {
            name: "image",
            type: "file"
        },
        {
            name: "imageMobile",
            type: "file"
        },
        {
            name: "youtubeUrl",
            type: "link"
        },
        {
            name: "background",
            type: "color"
        },
        {
            name: "textColor",
            type: "color"
        },
        {
            name: "ctaText",
            type: "text"
        },
        {
            name: "ctaUrl",
            type: "link"
        },
        {
            name: "ctaColor",
            type: "string",
            enum: Object.values(business_button_constants/* COLORS */.DM),
            defaultValue: business_button_constants/* COLORS.MINT */.DM.MINT
        },
        {
            name: "ctaDisableBorder",
            type: "boolean"
        },
        {
            name: "reversed",
            type: "boolean"
        }
    ]
};
const business_hub_industries_card_block_builder_component_builderConfig = {
    component: business_hub_industries_card_block,
    config: BusinessHubIndustriesCardBlockBuilderConfig
};
/* harmony default export */ var business_hub_industries_card_block_builder_component = (business_hub_industries_card_block_builder_component_builderConfig);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(75407);
// EXTERNAL MODULE: ./components/business-hub-industries-carousel/business-hub-industries-carousel.module.scss
var business_hub_industries_carousel_module = __webpack_require__(82812);
var business_hub_industries_carousel_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_industries_carousel_module);
;// CONCATENATED MODULE: ./components/business-hub-industries-carousel/business-hub-industries-carousel.tsx











const business_hub_industries_carousel_options = {
    slidesPerView: "auto",
    allowTouchMove: true,
    centeredSlides: true,
    centeredSlidesBounds: true,
    centerInsufficientSlides: true,
    initialSlide: 1,
    freeMode: {
        enabled: true,
        sticky: false
    },
    modules: [
        modules/* FreeMode */.Rv
    ],
    watchOverflow: false,
    grabCursor: true,
    breakpoints: {
        608: {
            initialSlide: 0,
            watchOverflow: true
        }
    }
};
const BusinessHubIndustriesCarousel = (props)=>{
    const { industries: industriesProps , builderState  } = props;
    const config = builderState === null || builderState === void 0 ? void 0 : builderState.state[BusinessHubIndustriesCarouselBuilderConfig.name];
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const router = (0,next_router.useRouter)();
    const pagePath = (0,react.useMemo)(()=>{
        const path = Array.isArray(router.query.slug) ? router.query.slug.join("/") : router.query.slug;
        return (0,LangHelper/* replaceOrAddLocale */.yM)("/".concat(path) || 0, locale);
    }, [
        router,
        locale
    ]);
    const industries = (0,react.useMemo)(()=>{
        let indus = industriesProps;
        if (builder_react_es5/* Builder.isEditing */.Ib.isEditing || builder_react_es5/* Builder.isPreviewing */.Ib.isPreviewing) {
            indus = industriesProps || (config === null || config === void 0 ? void 0 : config.industries);
        }
        if (!indus) return indus;
        return indus.filter((item)=>{
            if (builder_react_es5/* Builder.isEditing */.Ib.isEditing || builder_react_es5/* Builder.isPreviewing */.Ib.isPreviewing) {
                return true;
            }
            return !item.isInPreview;
        }).filter((i)=>i.builderPage).sort((a, b)=>{
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
            return 0;
        });
    }, [
        industriesProps,
        config
    ]) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_hub_industries_carousel_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
            ...business_hub_industries_carousel_options,
            onInit: (swiper)=>{
                swiper.setProgress(0.5);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    className: (business_hub_industries_carousel_module_default()).mdHide
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_hub_industries_carousel_module_default()).industries,
                        children: industries.map((param)=>{
                            let { name , builderPage  } = param;
                            var ref, ref1;
                            const href = (0,LangHelper/* replaceOrAddLocale */.yM)(((ref1 = builderPage === null || builderPage === void 0 ? void 0 : (ref = builderPage.value) === null || ref === void 0 ? void 0 : ref.data) === null || ref1 === void 0 ? void 0 : ref1.url) || "", locale);
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                className: classnames_default()((business_hub_industries_carousel_module_default()).carouselItem, {
                                    [(business_hub_industries_carousel_module_default()).active]: pagePath === href
                                }),
                                href: href,
                                children: name
                            }, name);
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    className: (business_hub_industries_carousel_module_default()).mdHide
                })
            ]
        })
    });
};
/* harmony default export */ var business_hub_industries_carousel = (BusinessHubIndustriesCarousel);

;// CONCATENATED MODULE: ./components/business-hub-industries-carousel/business-hub-industries-carousel.builder-component.ts

const BusinessHubIndustriesCarouselBuilderConfig = {
    name: "Business Hub Industries Carousel",
    inputs: []
};
const business_hub_industries_carousel_builder_component_builderConfig = {
    component: business_hub_industries_carousel,
    config: BusinessHubIndustriesCarouselBuilderConfig
};
/* harmony default export */ var business_hub_industries_carousel_builder_component = (business_hub_industries_carousel_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-hub-industries-grid/business-hub-industries-grid.module.scss
var business_hub_industries_grid_module = __webpack_require__(54761);
var business_hub_industries_grid_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_industries_grid_module);
// EXTERNAL MODULE: ./components/business-hub-industries-grid/industries-item.module.scss
var business_hub_industries_grid_industries_item_module = __webpack_require__(24680);
var business_hub_industries_grid_industries_item_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_industries_grid_industries_item_module);
;// CONCATENATED MODULE: ./components/business-hub-industries-grid/industries-item.tsx







const industries_item_IndustriesItem = (props)=>{
    const { icon ="" , name , description , bannerImage , reversed , hide , builderPage , quote , video , showQuote  } = props;
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const url = (0,react.useMemo)(()=>{
        var ref;
        if (!(builderPage === null || builderPage === void 0 ? void 0 : (ref = builderPage.value) === null || ref === void 0 ? void 0 : ref.data)) return "";
        return (0,LangHelper/* replaceOrAddLocale */.yM)(builderPage === null || builderPage === void 0 ? void 0 : builderPage.value.data.url, locale);
    }, [
        locale,
        builderPage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((business_hub_industries_grid_industries_item_module_default()).container, {
            [(business_hub_industries_grid_industries_item_module_default()).reversed]: reversed,
            [(business_hub_industries_grid_industries_item_module_default()).hide]: hide
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_hub_industries_grid_industries_item_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_hub_industries_grid_industries_item_module_default()).title,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_hub_industries_grid_industries_item_module_default()).iconBox,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (business_hub_industries_grid_industries_item_module_default()).icon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: icon,
                                        alt: "",
                                        style: {
                                            objectFit: "contain",
                                            objectPosition: "center"
                                        },
                                        fill: true,
                                        sizes: "(max-width: 638px) 98vw, (max-width: 998px) 43vw, 46vw",
                                        loader: (param)=>{
                                            let { src , width , quality  } = param;
                                            return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_hub_industries_grid_industries_item_module_default()).description,
                        dangerouslySetInnerHTML: {
                            __html: description || ""
                        }
                    }),
                    url ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        className: (business_hub_industries_grid_industries_item_module_default()).link,
                        href: url,
                        children: "Learn more"
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_hub_industries_grid_industries_item_module_default()).banner,
                children: [
                    bannerImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: bannerImage,
                        alt: "",
                        style: {
                            objectFit: "cover",
                            objectPosition: "bottom"
                        },
                        fill: true,
                        sizes: "(max-width: 638px) 98vw, (max-width: 998px) 43vw, 46vw",
                        loading: "eager",
                        loader: (param)=>{
                            let { src , width , quality  } = param;
                            return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                        }
                    }) : null,
                    showQuote && quote ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_hub_industries_grid_industries_item_module_default()).bannerOverlay,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_hub_industries_grid_industries_item_module_default()).quoteContent,
                                dangerouslySetInnerHTML: {
                                    __html: quote.content || ""
                                }
                            }),
                            quote.author ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_hub_industries_grid_industries_item_module_default()).quoteAuthor,
                                children: quote.author
                            }) : null,
                            quote.company || video ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (business_hub_industries_grid_industries_item_module_default()).bannerFooter,
                                children: [
                                    quote.company ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (business_hub_industries_grid_industries_item_module_default()).quoteCompany,
                                        children: quote.company
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                    video ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: video,
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            width: "41",
                                            height: "44",
                                            viewBox: "0 0 41 44",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M8.45128 44C7.11993 44 5.78864 43.6546 4.5547 42.995C1.92447 41.5815 0.300781 38.8487 0.300781 35.8647V8.12856C0.300781 5.14452 1.92447 2.41209 4.5547 0.998599C7.08752 -0.383483 10.1074 -0.320922 12.5753 1.12398L36.1824 14.9763C38.6827 16.4526 40.2089 19.0597 40.2089 21.9809C40.2089 24.9021 38.7152 27.5092 36.1824 28.9855L12.5753 42.8378C11.2764 43.5917 9.88005 43.9686 8.45128 43.9686V44ZM8.45128 6.30686C8.15903 6.30686 7.93172 6.40128 7.73689 6.49551C7.1524 6.80962 6.79518 7.43755 6.79518 8.16V35.8961C6.79518 36.6186 7.1524 37.2151 7.73689 37.5606C8.06161 37.7491 8.61368 37.8747 9.19817 37.5606L32.8053 23.7087C33.6171 23.2375 33.6821 22.4207 33.6821 22.0752C33.6821 21.7297 33.5846 20.913 32.8053 20.4418L9.19817 6.58946C8.93839 6.4324 8.67858 6.36975 8.45128 6.36975V6.30686Z",
                                                fill: "white"
                                            })
                                        })
                                    }) : null
                                ]
                            }) : null
                        ]
                    }) : null
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/business-hub-industries-grid/business-hub-industries-grid.tsx












const business_hub_industries_grid_options = {
    slidesPerView: "auto",
    spaceBetween: 10,
    allowTouchMove: true,
    breakpoints: {
        992: {
            spaceBetween: 20
        }
    }
};
const BusinessHubIndustriesGrid = (props)=>{
    const { industries: industriesProps , builderState , showJustedBrands , autoplay , showTitle  } = props;
    const config = builderState === null || builderState === void 0 ? void 0 : builderState.state[BusinessHubIndustriesGridBuilderConfig.name];
    const { width =0  } = (0,useWindowSize/* useWindowSize */.i)();
    const [displayIndustries, setDisplayIndustries] = (0,react.useState)([]);
    const [pagination, setPagination] = (0,react.useState)({
        page: 0,
        size: 4
    });
    const [selectedIndex, setSelectedIndex] = (0,react.useState)(autoplay ? -1 : undefined);
    const intervalRef = (0,react.useRef)();
    const wordsRef = (0,react.useRef)(null);
    const [trustedBrandSwiper, setTrustedBrandSwiper] = (0,react.useState)();
    const { ref , inView  } = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true
    });
    const industries = (0,react.useMemo)(()=>{
        if (builder_react_es5/* Builder.isEditing */.Ib.isEditing || builder_react_es5/* Builder.isPreviewing */.Ib.isPreviewing) {
            return industriesProps || (config === null || config === void 0 ? void 0 : config.industries);
        }
        return industriesProps;
    }, [
        industriesProps,
        config
    ]) || [];
    const _getNextPage = ()=>{
        if (autoplay) {
            setDisplayIndustries(industries.map((i)=>i.name));
        } else {
            const nextItems = [
                ...industries
            ].slice(pagination.size * pagination.page, pagination.size * (pagination.page + 1)).map((i)=>i.name);
            setDisplayIndustries([
                ...displayIndustries,
                ...nextItems
            ]);
            setPagination((p)=>({
                    ...p,
                    page: p.page + 1
                }));
        }
    };
    (0,react.useEffect)(()=>{
        _getNextPage();
    }, []);
    const _industryClick = (index)=>{
        if (!autoplay && index === selectedIndex) {
            setSelectedIndex(undefined);
        } else {
            setSelectedIndex(index);
        }
    };
    const play = (0,react.useCallback)(()=>{
        if (!autoplay) return;
        const interval = setInterval(()=>{
            setSelectedIndex((val)=>{
                let index = (val || 0) + 1;
                if (index >= industries.length) {
                    index = -1;
                }
                return index;
            });
        }, 4000);
        intervalRef.current = interval;
    }, [
        industries
    ]);
    const pause = ()=>{
        if (!autoplay) return;
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }
    };
    (0,react.useEffect)(()=>{
        if (inView) play();
        return ()=>{
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [
        inView,
        play
    ]);
    (0,react.useEffect)(()=>{
        if (!showTitle) return;
        if (!wordsRef.current) return;
        if (!Number.isInteger(selectedIndex) || selectedIndex === undefined) return;
        const words = wordsRef.current.querySelectorAll("span");
        if (!words.length) return;
        const realIndex = selectedIndex + 1;
        words[realIndex].classList.remove((business_hub_industries_grid_module_default()).isHidden);
        words[realIndex].classList.add((business_hub_industries_grid_module_default()).isVisible);
        for(let index = 0; index < words.length; index++){
            const element = words[index];
            if (index === realIndex) continue;
            element.classList.add((business_hub_industries_grid_module_default()).isHidden);
            element.classList.remove((business_hub_industries_grid_module_default()).isVisible);
        }
        if ((trustedBrandSwiper === null || trustedBrandSwiper === void 0 ? void 0 : trustedBrandSwiper.realIndex) !== realIndex - 1) {
            trustedBrandSwiper === null || trustedBrandSwiper === void 0 ? void 0 : trustedBrandSwiper.slideTo(realIndex - 1, 300);
        }
    }, [
        selectedIndex,
        wordsRef,
        showTitle
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: ref,
        className: (business_hub_industries_grid_module_default()).container,
        onMouseEnter: pause,
        onMouseLeave: play,
        children: [
            showTitle ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: wordsRef,
                className: (business_hub_industries_grid_module_default()).wordsContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Built for\xa0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_hub_industries_grid_module_default()).wordsWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (business_hub_industries_grid_module_default()).isVisible,
                                children: "your industry."
                            }),
                            industries === null || industries === void 0 ? void 0 : industries.map((param, index)=>{
                                let { name  } = param;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        name === null || name === void 0 ? void 0 : name.toLowerCase(),
                                        "."
                                    ]
                                }, "".concat(name, "-index"));
                            })
                        ]
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_industries_grid_module_default()).carouselContainer,
                children: width > 992 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    ...business_hub_industries_grid_options,
                    children: industries.map((param, index)=>/*#__PURE__*/ {
                        let { name  } = param;
                        return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            className: classnames_default()((business_hub_industries_grid_module_default()).carouselItem, {
                                [(business_hub_industries_grid_module_default()).active]: index === selectedIndex || index === 0 && selectedIndex === -1
                            }),
                            onClick: ()=>_industryClick(index),
                            children: name
                        }, name);
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (business_hub_industries_grid_module_default()).mobileContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                            ...business_hub_industries_grid_options,
                            children: industries.slice(0, industries.length / 2).map((param, index)=>/*#__PURE__*/ {
                                let { name  } = param;
                                return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    className: classnames_default()((business_hub_industries_grid_module_default()).carouselItem, {
                                        [(business_hub_industries_grid_module_default()).active]: index === selectedIndex || index === 0 && selectedIndex === -1
                                    }),
                                    onClick: ()=>_industryClick(index),
                                    children: name
                                }, name);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                            ...business_hub_industries_grid_options,
                            children: industries.slice(industries.length / 2).map((param, index)=>/*#__PURE__*/ {
                                let { name  } = param;
                                return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    className: classnames_default()((business_hub_industries_grid_module_default()).carouselItem, {
                                        [(business_hub_industries_grid_module_default()).active]: index + industries.length / 2 === selectedIndex || index + industries.length / 2 === 0 && selectedIndex === -1
                                    }),
                                    onClick: ()=>_industryClick(index + industries.length / 2),
                                    children: name
                                }, name);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_industries_grid_module_default()).industriesContainer,
                children: industries.map((industry, index)=>{
                    let hide = Number.isInteger(selectedIndex) ? selectedIndex !== index : false;
                    if (index === 0 && selectedIndex === -1) {
                        hide = false;
                    }
                    if (!Number.isInteger(selectedIndex)) {
                        hide = !displayIndustries.includes(industry.name);
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(industries_item_IndustriesItem, {
                        ...industry,
                        reversed: !autoplay && index % 2 !== 0,
                        hide: hide,
                        showQuote: autoplay
                    }, industry.name);
                })
            }),
            showJustedBrands ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_hub_industries_grid_module_default()).trustedBrandContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_hub_industries_grid_module_default()).trustedTitle,
                        children: "Trusted by"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        slidesPerView: 1,
                        draggable: false,
                        noSwiping: true,
                        allowTouchMove: false,
                        effect: "fade",
                        fadeEffect: {
                            crossFade: true
                        },
                        // creativeEffect={{
                        //     prev: {
                        //         opacity: 0,
                        //     },
                        //     next: {
                        //         opacity: 1,
                        //     },
                        // }}
                        modules: [
                            modules/* EffectFade */.xW
                        ],
                        onInit: (swiper)=>{
                            setTrustedBrandSwiper(swiper);
                        },
                        children: industries.map((industry)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                className: (business_hub_industries_grid_module_default()).trustedBrandSlide,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_hub_trusted_brand, {
                                    trustedBrands: industry.trustedBrands,
                                    className: (business_hub_industries_grid_module_default()).trustedBrand
                                })
                            }, industry.name))
                    })
                ]
            }) : null,
            autoplay || displayIndustries.length === industries.length ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_industries_grid_module_default()).loadMore,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: (business_hub_industries_grid_module_default()).loadMoreButton,
                    onClick: _getNextPage,
                    children: "Load more"
                })
            })
        ]
    });
};
/* harmony default export */ var business_hub_industries_grid = (BusinessHubIndustriesGrid);

;// CONCATENATED MODULE: ./components/business-hub-industries-grid/business-hub-industries-grid.builder-component.ts

const BusinessHubIndustriesGridBuilderConfig = {
    name: "Business Hub Industries Grid",
    inputs: [
        {
            name: "showJustedBrands",
            type: "boolean"
        },
        {
            name: "autoplay",
            type: "boolean",
            helperText: "Also enable single mode"
        },
        {
            name: "showTitle",
            type: "boolean"
        }
    ]
};
const business_hub_industries_grid_builder_component_builderConfig = {
    component: business_hub_industries_grid,
    config: BusinessHubIndustriesGridBuilderConfig
};
/* harmony default export */ var business_hub_industries_grid_builder_component = (business_hub_industries_grid_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-hub-industries-optional-quote/business-hub-industries-optional-quote.module.scss
var business_hub_industries_optional_quote_module = __webpack_require__(11644);
var business_hub_industries_optional_quote_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_industries_optional_quote_module);
;// CONCATENATED MODULE: ./components/business-hub-industries-optional-quote/business-hub-industries-optional-quote.tsx



const BusinessHubIndustriesOptionalQuote = (props)=>{
    const { quote , author , illustration , background , textColor , textSize , reversed , hideIllustrationOnMobile , gridTemplateColumns  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_hub_industries_optional_quote_module_default()).container,
        style: {
            "--bg-color": background,
            "--text-color": textColor
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((business_hub_industries_optional_quote_module_default()).gird, {
                [(business_hub_industries_optional_quote_module_default()).reversed]: reversed
            }),
            style: {
                "--grid-template-columns": gridTemplateColumns
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (business_hub_industries_optional_quote_module_default()).content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((business_hub_industries_optional_quote_module_default()).quote, {
                                [(business_hub_industries_optional_quote_module_default()).small]: textSize === "small"
                            }),
                            dangerouslySetInnerHTML: {
                                __html: quote || ""
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_hub_industries_optional_quote_module_default()).author,
                            dangerouslySetInnerHTML: {
                                __html: author || ""
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((business_hub_industries_optional_quote_module_default()).illustration, {
                        [(business_hub_industries_optional_quote_module_default()).desktop]: hideIllustrationOnMobile
                    }),
                    children: illustration && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: "",
                        src: illustration,
                        style: {
                            objectFit: "cover",
                            objectPosition: "bottom"
                        }
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var business_hub_industries_optional_quote = (BusinessHubIndustriesOptionalQuote);

;// CONCATENATED MODULE: ./components/business-hub-industries-optional-quote/business-hub-industries-optional-quote.builder-component.ts

const BusinessHubIndustriesOptionalQuoteBuilderConfig = {
    name: "Business Hub Industries Optional Quote",
    inputs: [
        {
            name: "quote",
            type: "richText"
        },
        {
            name: "author",
            type: "richText"
        },
        {
            name: "illustration",
            type: "file",
            required: true
        },
        {
            name: "background",
            type: "color"
        },
        {
            name: "textColor",
            type: "color"
        },
        {
            name: "textSize",
            type: "enum",
            enum: [
                "default",
                "small"
            ]
        },
        {
            name: "reversed",
            type: "boolean"
        },
        {
            name: "hideIllustrationOnMobile",
            type: "boolean"
        },
        {
            name: "gridTemplateColumns",
            type: "text",
            helperText: "https://developer.mozilla.org/en-US/docs/Web/CSS/grid-template-columns"
        }
    ]
};
const business_hub_industries_optional_quote_builder_component_builderConfig = {
    component: business_hub_industries_optional_quote,
    config: BusinessHubIndustriesOptionalQuoteBuilderConfig
};
/* harmony default export */ var business_hub_industries_optional_quote_builder_component = (business_hub_industries_optional_quote_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-hub-industries-stats/business-hub-industries-stats.module.scss
var business_hub_industries_stats_module = __webpack_require__(3187);
var business_hub_industries_stats_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_industries_stats_module);
;// CONCATENATED MODULE: ./components/business-hub-industries-stats/business-hub-industries-stats.tsx


const BusinessHubIndustriesStats = (props)=>{
    const { stats , disclaimer  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_hub_industries_stats_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_industries_stats_module_default()).tiles,
                children: stats.map((tile, index)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_hub_industries_stats_module_default()).tile,
                        style: {
                            "--tile-bg-color": tile.background,
                            "--tile-color": tile.textColor
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_hub_industries_stats_module_default()).icon,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: tile.icon,
                                    title: tile.stats
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_hub_industries_stats_module_default()).stats,
                                dangerouslySetInnerHTML: {
                                    __html: tile.stats || ""
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_hub_industries_stats_module_default()).description,
                                dangerouslySetInnerHTML: {
                                    __html: tile.description || ""
                                }
                            })
                        ]
                    }, index);
                })
            }),
            disclaimer ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_industries_stats_module_default()).disclaimer,
                dangerouslySetInnerHTML: {
                    __html: disclaimer
                }
            }) : null
        ]
    });
};
/* harmony default export */ var business_hub_industries_stats = (BusinessHubIndustriesStats);

;// CONCATENATED MODULE: ./components/business-hub-industries-stats/business-hub-industries-stats.builder-component.ts

const BusinessHubIndustriesStatsBuilderConfig = {
    name: "Business Hub Industries Stats",
    inputs: [
        {
            name: "stats",
            type: "list",
            subFields: [
                {
                    name: "icon",
                    type: "file"
                },
                {
                    name: "stats",
                    type: "richText",
                    helperText: 'Wrap percent character in "percent" class'
                },
                {
                    name: "description",
                    type: "richText"
                },
                {
                    name: "background",
                    type: "color"
                },
                {
                    name: "textColor",
                    type: "color"
                }
            ]
        },
        {
            name: "disclaimer",
            type: "richText"
        }
    ]
};
const business_hub_industries_stats_builder_component_builderConfig = {
    component: business_hub_industries_stats,
    config: BusinessHubIndustriesStatsBuilderConfig
};
/* harmony default export */ var business_hub_industries_stats_builder_component = (business_hub_industries_stats_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-hub-integrations/business-hub-integrations.module.scss
var business_hub_integrations_module = __webpack_require__(97403);
var business_hub_integrations_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_integrations_module);
;// CONCATENATED MODULE: ./components/business-hub-integrations/business-hub-integrations.tsx











gsap.gsap.registerPlugin(src/* useGSAP */.V);
gsap.gsap.registerPlugin(ScrollTrigger.ScrollTrigger);
gsap.gsap.registerPlugin((TextPlugin_default()));
const business_hub_integrations_options = {
    slidesPerView: "auto",
    spaceBetween: 10,
    allowTouchMove: true,
    noSwiping: false,
    freeMode: false,
    loop: false,
    navigation: false,
    pagination: false,
    breakpoints: {
        992: {
            enabled: false
        }
    }
};
const BusinessHubIntegrations = (props)=>{
    const { title , sections =[]  } = props;
    const [render, setRender] = (0,react.useState)(false);
    const containerRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        setTimeout(()=>{
            setRender(true);
        }, 1000);
    }, []);
    (0,src/* useGSAP */.V)(()=>{
        if (!render) return;
        const selector = gsap.gsap.utils.selector(containerRef.current);
        const sections = gsap.gsap.utils.toArray(selector(".".concat((business_hub_integrations_module_default()).section)));
        let mm = gsap.gsap.matchMedia();
        mm.add("(min-width: 993px)", (context)=>{
            gsap.gsap.timeline({
                scrollTrigger: {
                    trigger: containerRef.current,
                    pinnedContainer: containerRef.current,
                    pin: true,
                    start: "center center",
                    end: "+=100%",
                    scrub: 1
                }
            });
            let masterTl = gsap.gsap.timeline({
                scrollTrigger: {
                    trigger: containerRef.current,
                    start: "top center+=40%",
                    end: "bottom top",
                    scrub: true
                }
            });
            gsap.gsap.set(sections, {
                autoAlpha: 0
            });
            for(let i = 0; i < sections.length; i++){
                const section = sections[i];
                const title = gsap.gsap.utils.toArray(gsap.gsap.utils.selector(section)(".".concat((business_hub_integrations_module_default()).sectionTitle)))[0];
                const prvSection = sections[i - 1];
                if (prvSection) {
                    const prvTitle = gsap.gsap.utils.toArray(gsap.gsap.utils.selector(prvSection)(".".concat((business_hub_integrations_module_default()).sectionTitle)))[0];
                    const tlOut = animateSection(prvSection, prvTitle, "out");
                    masterTl.add(tlOut);
                }
                const tlIn = animateSection(section, title, "in", i === 0 ? "+=1" : "<");
                masterTl.to(section, {
                    xPercent: -100 * i,
                    x: 0
                }, "<");
                masterTl.add(tlIn, "-=0.4");
            }
        });
    }, {
        scope: containerRef,
        dependencies: [
            sections,
            render
        ]
    });
    const animateSection = (section, title, animationType, position)=>{
        const sectionSelector = gsap.gsap.utils.selector(section);
        const contentItems = gsap.gsap.utils.toArray(sectionSelector(".".concat((business_hub_integrations_module_default()).sectionRightContent, " .").concat((business_hub_integrations_module_default()).logoTile)));
        const titleSplits = gsap.gsap.utils.toArray(gsap.gsap.utils.selector(title)("span"));
        const tl = gsap.gsap.timeline({});
        if (animationType === "in") {
            tl.to(section, {
                autoAlpha: 1
            }, position);
            tl.fromTo([
                titleSplits,
                contentItems
            ], {
                autoAlpha: 0
            }, {
                duration: 1,
                autoAlpha: 1,
                stagger: {
                    from: "start",
                    each: 0.02
                }
            }, ">-=0.5");
        } else {
            tl.to([
                titleSplits,
                contentItems
            ], {
                duration: 0.5,
                autoAlpha: 0,
                stagger: {
                    from: "start",
                    each: 0.005
                }
            }, "+=1");
        }
        return tl;
    };
    const _renderCarousel = (brands)=>{
        if (brands.length > 3) {
            let halfwayThrough = Math.floor(brands.length / 2);
            let arrayFirstHalf = brands.slice(0, halfwayThrough);
            let arraySecondHalf = brands.slice(halfwayThrough, brands.length);
            return arrayFirstHalf.map((brand, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_hub_integrations_module_default()).logoGroup,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_hub_integrations_module_default()).logoTile,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (business_hub_integrations_module_default()).logo,
                                    style: {
                                        aspectRatio: "".concat((brand.width || 1) / (brand.height || 1)),
                                        maxWidth: brand.width,
                                        height: brand.height
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: brand.logo || "",
                                        alt: brand.name,
                                        style: {
                                            objectFit: "contain",
                                            objectPosition: "center"
                                        },
                                        sizes: "(max-width: 638px) 98vw, (max-width: 998px) 43vw, 46vw",
                                        fill: true,
                                        loading: "eager",
                                        loader: (param)=>{
                                            let { src , width , quality  } = param;
                                            return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                                        }
                                    })
                                })
                            }),
                            arraySecondHalf[index] ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_hub_integrations_module_default()).logoTile,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (business_hub_integrations_module_default()).logo,
                                    style: {
                                        aspectRatio: "".concat((arraySecondHalf[index].width || 1) / (arraySecondHalf[index].height || 1)),
                                        maxWidth: arraySecondHalf[index].width,
                                        height: arraySecondHalf[index].height
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: arraySecondHalf[index].logo || "",
                                        alt: arraySecondHalf[index].name,
                                        style: {
                                            objectFit: "contain",
                                            objectPosition: "center"
                                        },
                                        sizes: "(max-width: 638px) 98vw, (max-width: 998px) 43vw, 46vw",
                                        fill: true,
                                        loading: "eager",
                                        loader: (param)=>{
                                            let { src , width , quality  } = param;
                                            return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                                        }
                                    })
                                })
                            }) : null
                        ]
                    })
                }, brand.name));
        }
        return brands.map((brand)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_integrations_module_default()).logoTile,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_hub_integrations_module_default()).logo,
                        style: {
                            aspectRatio: "".concat((brand.width || 1) / (brand.height || 1)),
                            maxWidth: brand.width,
                            height: brand.height
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: brand.logo || "",
                            alt: brand.name,
                            style: {
                                objectFit: "contain",
                                objectPosition: "center"
                            },
                            sizes: "(max-width: 638px) 98vw, (max-width: 998px) 43vw, 46vw",
                            fill: true,
                            loading: "eager",
                            loader: (param)=>{
                                let { src , width , quality  } = param;
                                return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                            }
                        })
                    })
                })
            }, brand.name));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: containerRef,
        className: (business_hub_integrations_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (business_hub_integrations_module_default()).content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(splitchar/* SplitChar */.k, {
                    text: title,
                    className: classnames_default()((business_hub_integrations_module_default()).title, (business_hub_integrations_module_default()).desktopHide)
                }),
                sections.map((section, index)=>{
                    const { title: sectionTitle = "" , brands =[]  } = section;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: (business_hub_integrations_module_default()).section,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (business_hub_integrations_module_default()).sectionLeft,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(splitchar/* SplitChar */.k, {
                                        text: title,
                                        className: classnames_default()((business_hub_integrations_module_default()).title, (business_hub_integrations_module_default()).mobileHide)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(splitchar/* SplitChar */.k, {
                                        text: sectionTitle,
                                        className: (business_hub_integrations_module_default()).sectionTitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_hub_integrations_module_default()).sectionRight,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (business_hub_integrations_module_default()).sectionRightContent,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (business_hub_integrations_module_default()).mobileHide,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (business_hub_integrations_module_default()).sectionGrid,
                                                children: brands.map((brand)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (business_hub_integrations_module_default()).logoTile,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (business_hub_integrations_module_default()).logo,
                                                            style: {
                                                                aspectRatio: "".concat((brand.width || 1) / (brand.height || 1)),
                                                                maxWidth: brand.width,
                                                                height: brand.height
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: brand.logo || "",
                                                                alt: brand.name,
                                                                style: {
                                                                    objectFit: "contain",
                                                                    objectPosition: "center"
                                                                },
                                                                sizes: "(max-width: 638px) 98vw, (max-width: 998px) 43vw, 46vw",
                                                                fill: true,
                                                                loading: "eager",
                                                                loader: (param)=>{
                                                                    let { src , width , quality  } = param;
                                                                    return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                                                                }
                                                            })
                                                        })
                                                    }, brand.name))
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (business_hub_integrations_module_default()).desktopHide,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                                ...business_hub_integrations_options,
                                                children: _renderCarousel(brands)
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }, "".concat(sectionTitle, "_").concat(index));
                })
            ]
        })
    });
};
/* harmony default export */ var business_hub_integrations = (BusinessHubIntegrations);

;// CONCATENATED MODULE: ./components/business-hub-integrations/business-hub-integrations.builder-component.ts

const BusinessHubIntegrationsBuilderConfig = {
    name: "Business Hub Integrations",
    inputs: [
        {
            name: "title",
            type: "string"
        },
        {
            name: "sections",
            type: "list",
            copyOnAdd: false,
            subFields: [
                {
                    name: "title",
                    type: "string"
                },
                {
                    name: "brands",
                    type: "list",
                    copyOnAdd: false,
                    subFields: [
                        {
                            name: "name",
                            type: "string"
                        },
                        {
                            name: "link",
                            type: "url"
                        },
                        {
                            name: "logo",
                            type: "file"
                        },
                        {
                            name: "width",
                            type: "number"
                        },
                        {
                            name: "height",
                            type: "number"
                        }
                    ]
                }
            ]
        }
    ]
};
const business_hub_integrations_builder_component_builderConfig = {
    component: business_hub_integrations,
    config: BusinessHubIntegrationsBuilderConfig
};
/* harmony default export */ var business_hub_integrations_builder_component = (business_hub_integrations_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-hub-list-card-resources/business-hub-list-card-resources.module.scss
var business_hub_list_card_resources_module = __webpack_require__(70197);
var business_hub_list_card_resources_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_list_card_resources_module);
;// CONCATENATED MODULE: ./components/business-hub-list-card-resources/business-hub-list-card-resources.tsx




const business_hub_list_card_resources_BusinessHubListCardResources = (props)=>{
    const { card , backgroundCard , buttonBackground , showListNameCard , quantityColumnCard  } = props;
    const handleScrollTovView = (index)=>{
        const element = document.querySelectorAll(".".concat((business_hub_list_card_resources_module_default()).card))[index];
        if (element) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_hub_list_card_resources_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (business_hub_list_card_resources_module_default()).wrapperContent,
            children: [
                showListNameCard && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_list_card_resources_module_default()).wrapperListNameCard,
                    children: card === null || card === void 0 ? void 0 : card.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_hub_list_card_resources_module_default()).nameCard,
                            onClick: ()=>handleScrollTovView(index),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                dangerouslySetInnerHTML: {
                                    __html: item.title || ""
                                }
                            })
                        }, index))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_list_card_resources_module_default()).wrapperCard,
                    style: {
                        gridTemplateColumns: "repeat(".concat(quantityColumnCard, ", 1fr)")
                    },
                    children: card === null || card === void 0 ? void 0 : card.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (business_hub_list_card_resources_module_default()).card,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (business_hub_list_card_resources_module_default()).cardImage,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: item.image,
                                        alt: item.title
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (business_hub_list_card_resources_module_default()).cardContent,
                                    style: {
                                        background: backgroundCard
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (business_hub_list_card_resources_module_default()).title,
                                            dangerouslySetInnerHTML: {
                                                __html: item.title || ""
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (business_hub_list_card_resources_module_default()).description,
                                            style: item.fontSizeDescription ? {
                                                fontSize: "".concat(item.fontSizeDescription, "px")
                                            } : {},
                                            dangerouslySetInnerHTML: {
                                                __html: item.description || ""
                                            }
                                        }),
                                        item.link && item.buttonText ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (business_hub_list_card_resources_module_default()).readMore,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                                                link: item.link,
                                                buttonText: item.buttonText || "Read more",
                                                position: business_button_constants/* POSITION.LEFT */.Vr.LEFT,
                                                color: buttonBackground,
                                                autoMargin: false
                                            })
                                        }) : null
                                    ]
                                })
                            ]
                        }, index))
                })
            ]
        })
    });
};
/* harmony default export */ var business_hub_list_card_resources = (business_hub_list_card_resources_BusinessHubListCardResources);

;// CONCATENATED MODULE: ./components/business-hub-list-card-resources/business-hub-list-card-resources.builder-component.ts


const BusinessHubListCardResourcesConfig = {
    name: "List Card Resources",
    inputs: [
        {
            name: "backgroundCard",
            type: "color"
        },
        {
            name: "showListNameCard",
            type: "boolean"
        },
        {
            name: "quantityColumnCard",
            type: "number",
            defaultValue: 3
        },
        {
            name: "card",
            type: "list",
            subFields: [
                {
                    name: "image",
                    type: "file",
                    defaultValue: ""
                },
                {
                    name: "title",
                    type: "html",
                    defaultValue: ""
                },
                {
                    name: "description",
                    type: "html",
                    defaultValue: ""
                },
                {
                    name: "fontSizeDescription",
                    type: "number"
                },
                {
                    name: "link",
                    type: "url",
                    defaultValue: ""
                },
                {
                    name: "buttonText",
                    type: "html"
                }
            ]
        },
        {
            name: "buttonBackground",
            type: "string",
            enum: Object.values(business_button_constants/* COLORS */.DM),
            defaultValue: business_button_constants/* COLORS.MINT */.DM.MINT
        }
    ]
};
const business_hub_list_card_resources_builder_component_builderConfig = {
    component: business_hub_list_card_resources,
    config: BusinessHubListCardResourcesConfig
};
/* harmony default export */ var business_hub_list_card_resources_builder_component = (business_hub_list_card_resources_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-hub-list-e-commerce/business-hub-list-e-commerce.module.scss
var business_hub_list_e_commerce_module = __webpack_require__(42206);
var business_hub_list_e_commerce_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_list_e_commerce_module);
// EXTERNAL MODULE: ./components/business-hub-list-e-commerce/e-commerce-item/e-commerce-item.module.scss
var e_commerce_item_module = __webpack_require__(83630);
var e_commerce_item_module_default = /*#__PURE__*/__webpack_require__.n(e_commerce_item_module);
;// CONCATENATED MODULE: ./components/business-hub-list-e-commerce/e-commerce-item/e-commerce-item.tsx



const E_CommerceItem = (props)=>{
    const { image , borderItem , linkPartner , ratio , maxHeight , maxWidth , backgroundItem , filterGrayScale  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        target: "_blank",
        href: linkPartner,
        className: (e_commerce_item_module_default()).container,
        style: {
            border: borderItem ? "1px solid #E0E0E0" : "",
            backgroundColor: backgroundItem,
            filter: filterGrayScale ? "grayscale(1)" : ""
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (e_commerce_item_module_default()).image,
            style: {
                aspectRatio: "".concat(ratio ? 1 / ratio : ""),
                maxWidth: maxWidth,
                height: maxHeight
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: image !== null && image !== void 0 ? image : "",
                alt: "",
                style: {
                    objectFit: "contain",
                    objectPosition: "center center"
                },
                fill: true,
                loading: "eager",
                loader: (param)=>{
                    let { src , width , quality  } = param;
                    return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                }
            })
        })
    });
};
/* harmony default export */ var e_commerce_item = (E_CommerceItem);

;// CONCATENATED MODULE: ./components/business-hub-list-e-commerce/business-hub-list-e-commerce.tsx




var ALIGHT_ITEMS_TITLE;
(function(ALIGHT_ITEMS_TITLE) {
    ALIGHT_ITEMS_TITLE["center"] = "Center";
    ALIGHT_ITEMS_TITLE["start"] = "Start";
    ALIGHT_ITEMS_TITLE["end"] = "End";
})(ALIGHT_ITEMS_TITLE || (ALIGHT_ITEMS_TITLE = {}));
var BACKGROUND_CONTENT;
(function(BACKGROUND_CONTENT) {
    BACKGROUND_CONTENT["default"] = "default";
    BACKGROUND_CONTENT["gray"] = "gray";
})(BACKGROUND_CONTENT || (BACKGROUND_CONTENT = {}));
const BusinessHubListE_Commerce = (props)=>{
    var ref;
    const { background , content  } = props;
    // const backgroundContent = content?.backgroundContent === 'gray' ? styles.bgGray : styles.default;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_hub_list_e_commerce_module_default()).container,
        style: {
            backgroundColor: background === null || background === void 0 ? void 0 : background.backgroundColor
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_list_e_commerce_module_default()).backgroundImage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: background === null || background === void 0 ? void 0 : background.backgroundImage,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((business_hub_list_e_commerce_module_default()).content),
                style: {
                    paddingTop: content === null || content === void 0 ? void 0 : content.paddingContent,
                    paddingBottom: content === null || content === void 0 ? void 0 : content.paddingContent,
                    ["--alignItemsTitle"]: content === null || content === void 0 ? void 0 : content.alignItemsTitle,
                    backgroundColor: content === null || content === void 0 ? void 0 : content.backgroundContent
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (business_hub_list_e_commerce_module_default()).wrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_hub_list_e_commerce_module_default()).title,
                            style: {
                                maxWidth: content === null || content === void 0 ? void 0 : content.maxWidthTitle
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                dangerouslySetInnerHTML: {
                                    __html: (content === null || content === void 0 ? void 0 : content.title) || ""
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_hub_list_e_commerce_module_default()).wrapperItems,
                            style: {
                                ["--positionPartner"]: content === null || content === void 0 ? void 0 : content.positionPartner
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_hub_list_e_commerce_module_default()).items,
                                children: content === null || content === void 0 ? void 0 : (ref = content.items) === null || ref === void 0 ? void 0 : ref.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (business_hub_list_e_commerce_module_default()).item,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(e_commerce_item, {
                                            image: item.image,
                                            borderItem: content.borderItem,
                                            backgroundItem: content.backgroundItem,
                                            linkPartner: item.linkPartner,
                                            ratio: item.ratio,
                                            maxHeight: item.maxHeight,
                                            maxWidth: item.maxWidth,
                                            filterGrayScale: item.filterGrayScale
                                        })
                                    }, index))
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var business_hub_list_e_commerce = (BusinessHubListE_Commerce);

;// CONCATENATED MODULE: ./components/business-hub-list-e-commerce/business-hub-list-e-commerce.builder-component.ts

const BusinessHubListE_CommerceBuilderConfig = {
    name: "Business Hub List E-Commerce",
    inputs: [
        {
            name: "background",
            type: "object",
            subFields: [
                {
                    name: "backgroundColor",
                    type: "color"
                },
                {
                    name: "backgroundImage",
                    type: "file"
                }
            ]
        },
        {
            name: "content",
            type: "object",
            subFields: [
                {
                    name: "backgroundContent",
                    type: "color"
                },
                {
                    name: "title",
                    type: "html",
                    defaultValue: ""
                },
                {
                    name: "alignItemsTitle",
                    type: "string",
                    enum: Object.values(ALIGHT_ITEMS_TITLE),
                    defaultValue: ALIGHT_ITEMS_TITLE.center
                },
                {
                    name: "maxWidthTitle",
                    type: "number",
                    defaultValue: ""
                },
                {
                    name: "positionPartner",
                    type: "string",
                    enum: Object.values(ALIGHT_ITEMS_TITLE),
                    defaultValue: ALIGHT_ITEMS_TITLE.end
                },
                {
                    name: "items",
                    type: "list",
                    subFields: [
                        {
                            name: "image",
                            type: "file",
                            defaultValue: ""
                        },
                        {
                            name: "linkPartner",
                            type: "string",
                            defaultValue: ""
                        },
                        {
                            name: "ratio",
                            type: "number",
                            helperText: "image height / image width"
                        },
                        {
                            name: "maxWidth",
                            type: "number"
                        },
                        {
                            name: "maxHeight",
                            type: "number"
                        },
                        {
                            name: "filterGrayScale",
                            type: "boolean"
                        }
                    ]
                },
                {
                    name: "backgroundItem",
                    type: "color"
                },
                {
                    name: "borderItem",
                    type: "boolean",
                    defaultValue: false
                },
                {
                    name: "paddingContent",
                    type: "number",
                    defaultValue: ""
                }
            ]
        }
    ]
};
const business_hub_list_e_commerce_builder_component_builderConfig = {
    component: business_hub_list_e_commerce,
    config: BusinessHubListE_CommerceBuilderConfig
};
/* harmony default export */ var business_hub_list_e_commerce_builder_component = (business_hub_list_e_commerce_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-hub-online-payment/business-hub-online-payment-step.module.scss
var business_hub_online_payment_step_module = __webpack_require__(82939);
var business_hub_online_payment_step_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_online_payment_step_module);
;// CONCATENATED MODULE: ./components/business-hub-online-payment/business-hub-online-payment-step.tsx





const BusinessHubOnlinePaymentStepBase = (props, ref)=>{
    const { name , description , icon , screenImage , illustration , illustrationRatio , className , contentClassName  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        ref: ref,
        className: classnames_default()((business_hub_online_payment_step_module_default()).container, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((business_hub_online_payment_step_module_default()).box, contentClassName),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (business_hub_online_payment_step_module_default()).text,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_hub_online_payment_step_module_default()).icon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_hub_online_payment_step_module_default()).box,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: icon,
                                    alt: "",
                                    style: {
                                        objectFit: "contain",
                                        objectPosition: "center"
                                    },
                                    fill: true,
                                    loader: (param)=>{
                                        let { src , width , quality  } = param;
                                        return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75, "&format=webp");
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_hub_online_payment_step_module_default()).title,
                            children: name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_hub_online_payment_step_module_default()).description,
                            dangerouslySetInnerHTML: {
                                __html: description || ""
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_online_payment_step_module_default()).screenImage
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_online_payment_step_module_default()).illustration,
                    style: {
                        "--data-ratio": "".concat(illustrationRatio)
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: illustration,
                        alt: "",
                        style: {
                            objectFit: "cover",
                            objectPosition: "center"
                        },
                        fill: true,
                        loader: (param)=>{
                            let { src , width , quality  } = param;
                            return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75, "&format=webp");
                        }
                    })
                })
            ]
        })
    });
};
const BusinessHubOnlinePaymentStep = /*#__PURE__*/ (0,react.forwardRef)(BusinessHubOnlinePaymentStepBase);
BusinessHubOnlinePaymentStep.displayName = "BusinessHubOnlinePaymentStep";


// EXTERNAL MODULE: ./components/business-hub-online-payment/business-hub-online-payment.module.scss
var business_hub_online_payment_module = __webpack_require__(49241);
var business_hub_online_payment_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_online_payment_module);
;// CONCATENATED MODULE: ./components/business-hub-online-payment/business-hub-online-payment.tsx









gsap.gsap.registerPlugin((ScrollToPlugin_default()));
gsap.gsap.registerPlugin(ScrollTrigger.ScrollTrigger);
gsap.gsap.registerPlugin(src/* useGSAP */.V);
const business_hub_online_payment_BusinessHubOnlinePayment = (props)=>{
    const { title , description , backgroundColor , steps =[]  } = props;
    const containerRef = (0,react.useRef)(null);
    const scollTo = (id)=>{
        if (window.location.hash.startsWith("#".concat(id))) {
            setTimeout(()=>{
                const elem = document.getElementById(id);
                if (!elem) return;
                const position = elem.getBoundingClientRect();
                gsap.gsap.to(window, {
                    duration: 1,
                    scrollTo: position.top + window.scrollY - 116
                });
            }, 500);
        }
    };
    (0,src/* useGSAP */.V)(()=>{
        let mm = gsap.gsap.matchMedia();
        mm.add({
            reducedMotion: "(prefers-reduced-motion: no-preference)"
        }, ()=>{
            const selector = gsap.gsap.utils.selector(containerRef.current);
            const sectionContainer = gsap.gsap.utils.toArray(selector(".".concat((business_hub_online_payment_module_default()).sections)));
            const sections = gsap.gsap.utils.toArray(selector(".".concat((business_hub_online_payment_module_default()).stepWrapper)));
            const progresses = gsap.gsap.utils.toArray(selector(".".concat((business_hub_online_payment_module_default()).progressItem)));
            const screens = gsap.gsap.utils.toArray(selector(".".concat((business_hub_online_payment_module_default()).phoneScreenBox)));
            const titles = gsap.gsap.utils.toArray(selector(".".concat((business_hub_online_payment_module_default()).title)));
            const descriptions = gsap.gsap.utils.toArray(selector(".".concat((business_hub_online_payment_module_default()).description)));
            gsap.gsap.timeline({
                scrollTrigger: {
                    trigger: containerRef.current,
                    pinnedContainer: containerRef.current,
                    pin: true,
                    start: "bottom bottom",
                    end: "+=".concat(sections.length * 100, "%"),
                    scrub: 1
                }
            });
            let masterTl = gsap.gsap.timeline({
                defaults: {
                    ease: "sine.inOut"
                },
                scrollTrigger: {
                    trigger: containerRef.current,
                    start: "top+=20% center+=45%",
                    end: "+=".concat(sections.length * 100, "%"),
                    scrub: 1.5,
                    invalidateOnRefresh: true
                }
            });
            gsap.gsap.set(sections, {
                autoAlpha: 0,
                y: (i)=>{
                    return "".concat(100 * i, "vh");
                },
                transformOrigin: "top",
                xPercent: (index)=>-100 * index
            });
            gsap.gsap.set([
                titles,
                descriptions,
                sectionContainer
            ], {
                autoAlpha: 0
            });
            gsap.gsap.set(screens, {
                autoAlpha: 0,
                zIndex: (index)=>sections.length - index
            });
            gsap.gsap.set(progresses, {
                yPercent: 100,
                zIndex: (index)=>sections.length - index
            });
            masterTl.to([
                titles,
                descriptions,
                sectionContainer
            ], {
                ease: "power4.in",
                autoAlpha: 1,
                z: 0,
                stagger: 0.05
            });
            for(let index = 0; index < sections.length; index++){
                const section = sections[index];
                const screen = screens[index];
                const progress = progresses[index];
                const prevScreen = screens[index - 1];
                const prevSection = sections[index - 1];
                const prevProgress = progresses[index - 1];
                const nextProgress = progresses[index + 1];
                if (prevSection) {
                    masterTl.to([
                        prevSection,
                        prevProgress
                    ], {
                        yPercent: -200,
                        autoAlpha: 0
                    }, index == 0 ? 0 : "+=1").to(prevScreen, {
                        autoAlpha: 0
                    }, "<");
                }
                if (nextProgress) {
                    masterTl.to(nextProgress, {
                        yPercent: 50,
                        autoAlpha: 1
                    }, "<");
                }
                masterTl.to([
                    section,
                    progress
                ], {
                    autoAlpha: 1,
                    y: 0,
                    yPercent: 0,
                    onComplete: (progress)=>{
                        progress.classList.add((business_hub_online_payment_module_default()).active);
                    },
                    onReverseComplete: (progress)=>{
                        progress.classList.remove((business_hub_online_payment_module_default()).active);
                    },
                    onCompleteParams: [
                        progress
                    ],
                    onReverseCompleteParams: [
                        progress
                    ]
                }, index == 0 ? 0 : "<").to(screen, {
                    autoAlpha: 1
                }, "<");
            }
        });
        scollTo("solutions-for-the-omnichannel-world");
        scollTo("business-hub");
    }, {
        scope: containerRef
    });
    if (!steps.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_hub_online_payment_module_default()).container,
        style: {
            "--data-bg-color": backgroundColor
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_online_payment_module_default()).background
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_hub_online_payment_module_default()).box,
                ref: containerRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_hub_online_payment_module_default()).titleBox,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_hub_online_payment_module_default()).title,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_hub_online_payment_module_default()).description,
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_hub_online_payment_module_default()).sections,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (business_hub_online_payment_module_default()).overlay,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (business_hub_online_payment_module_default()).phoneFrame,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "https://cdn.builder.io/api/v1/image/assets%2F035a3d41874344d79b6c7499e2e7a5bc%2Fe42c03b90c6c471194ffe2a8f6735893",
                                                alt: "",
                                                style: {
                                                    objectFit: "contain",
                                                    objectPosition: "center"
                                                },
                                                fill: true,
                                                loading: "eager",
                                                loader: (param)=>{
                                                    let { src , width , quality  } = param;
                                                    return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75, "&format=webp");
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (business_hub_online_payment_module_default()).phoneScreen,
                                                children: steps.map((step, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (business_hub_online_payment_module_default()).phoneScreenBox,
                                                        style: {
                                                            backgroundImage: "url(".concat(step.screenImage, "?quality=75&format=webp)")
                                                        }
                                                    }, step.name + index))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (business_hub_online_payment_module_default()).progress,
                                        children: steps.map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (business_hub_online_payment_module_default()).progressItem,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (business_hub_online_payment_module_default()).progressBox,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: index + 1
                                                    })
                                                })
                                            }, index))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_hub_online_payment_module_default()).sectionContainer,
                                children: steps.map((step, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BusinessHubOnlinePaymentStep, {
                                        ...step,
                                        className: (business_hub_online_payment_module_default()).stepWrapper,
                                        contentClassName: (business_hub_online_payment_module_default()).stepBox
                                    }, step.name + index))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var business_hub_online_payment = (business_hub_online_payment_BusinessHubOnlinePayment);

;// CONCATENATED MODULE: ./components/business-hub-online-payment/business-hub-online-payment.builder-component.ts

const BusinessHubOnlinePaymentBuilderConfig = {
    name: "Business Hub Online Payment",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: ""
        },
        {
            name: "description",
            type: "string"
        },
        {
            name: "backgroundColor",
            type: "color",
            defaultValue: "#5b9e9b"
        },
        {
            name: "steps",
            type: "list",
            subFields: [
                {
                    name: "name",
                    type: "string",
                    required: true
                },
                {
                    name: "description",
                    type: "richText"
                },
                {
                    name: "icon",
                    type: "file",
                    required: true
                },
                {
                    name: "screenImage",
                    type: "file",
                    required: true
                },
                {
                    name: "illustration",
                    type: "file",
                    required: true
                },
                {
                    name: "illustrationRatio",
                    type: "text"
                }
            ]
        }
    ]
};
const business_hub_online_payment_builder_component_builderConfig = {
    component: business_hub_online_payment,
    config: BusinessHubOnlinePaymentBuilderConfig
};
/* harmony default export */ var business_hub_online_payment_builder_component = (business_hub_online_payment_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-hub-platform-integrations/business-hub-platform-integrations.module.scss
var business_hub_platform_integrations_module = __webpack_require__(4154);
var business_hub_platform_integrations_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_platform_integrations_module);
;// CONCATENATED MODULE: ./components/business-hub-platform-integrations/business-hub-platform-integrations.tsx






const BusinessHubPlatFormIntegrations = (props)=>{
    const { background , content  } = props;
    const { width =0  } = (0,useWindowSize/* useWindowSize */.i)();
    const [isMobile, setIsMobile] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (width < 998) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    }, [
        width
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_hub_platform_integrations_module_default()).container,
        style: {
            backgroundColor: background === null || background === void 0 ? void 0 : background.backgroundColor
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_platform_integrations_module_default()).wrapperContent,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (business_hub_platform_integrations_module_default()).content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_hub_platform_integrations_module_default()).title,
                            dangerouslySetInnerHTML: {
                                __html: (content === null || content === void 0 ? void 0 : content.title) || ""
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_hub_platform_integrations_module_default()).description,
                            dangerouslySetInnerHTML: {
                                __html: (content === null || content === void 0 ? void 0 : content.description) || ""
                            }
                        }),
                        (content === null || content === void 0 ? void 0 : content.ctaText) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_hub_platform_integrations_module_default()).button,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                                position: business_button_constants/* POSITION.LEFT */.Vr.LEFT,
                                color: content === null || content === void 0 ? void 0 : content.backgroundButton,
                                link: content === null || content === void 0 ? void 0 : content.ctaLink,
                                buttonText: content === null || content === void 0 ? void 0 : content.ctaText,
                                autoMargin: false
                            })
                        })
                    ]
                })
            }),
            (background === null || background === void 0 ? void 0 : background.backgroundImage) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_platform_integrations_module_default()).backgroundImage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: (background === null || background === void 0 ? void 0 : background.backgroundImage) || "",
                    alt: ""
                })
            }),
            (content === null || content === void 0 ? void 0 : content.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_platform_integrations_module_default()).imageContent,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_platform_integrations_module_default()).wrapperImage,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (isMobile && content.imageMobile ? content.imageMobile : content === null || content === void 0 ? void 0 : content.image) || "",
                        alt: ""
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var business_hub_platform_integrations = (BusinessHubPlatFormIntegrations);

;// CONCATENATED MODULE: ./components/business-hub-platform-integrations/business-hub-platform-integrations.builder-component.ts


const BusinessHubHeroPlatFormIntegrationsBuilderConfig = {
    name: "Hero Platform Integrations",
    inputs: [
        {
            name: "background",
            type: "object",
            subFields: [
                {
                    name: "backgroundImage",
                    type: "file",
                    defaultValue: ""
                },
                {
                    name: "backgroundColor",
                    type: "color",
                    defaultValue: ""
                }
            ]
        },
        {
            name: "content",
            type: "object",
            subFields: [
                {
                    name: "title",
                    type: "html",
                    defaultValue: ""
                },
                {
                    name: "description",
                    type: "html",
                    defaultValue: ""
                },
                {
                    name: "ctaText",
                    type: "text",
                    defaultValue: ""
                },
                {
                    name: "ctaLink",
                    type: "text",
                    defaultValue: ""
                },
                {
                    name: "image",
                    type: "file",
                    defaultValue: ""
                },
                {
                    name: "imageMobile",
                    type: "file",
                    defaultValue: ""
                },
                {
                    name: "backgroundButton",
                    type: "string",
                    enum: Object.values(business_button_constants/* COLORS */.DM),
                    defaultValue: business_button_constants/* COLORS.BLACK */.DM.BLACK
                }
            ]
        }
    ]
};
const business_hub_platform_integrations_builder_component_builderConfig = {
    component: business_hub_platform_integrations,
    config: BusinessHubHeroPlatFormIntegrationsBuilderConfig
};
/* harmony default export */ var business_hub_platform_integrations_builder_component = (business_hub_platform_integrations_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-hub-platform/business-hub-platform-card-item/platform-card-item.module.scss
var business_hub_platform_card_item_platform_card_item_module = __webpack_require__(8001);
var business_hub_platform_card_item_platform_card_item_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_platform_card_item_platform_card_item_module);
;// CONCATENATED MODULE: ./components/business-hub-platform/business-hub-platform-card-item/platform-card-item.tsx


const platform_card_item_PlatFromCardItem = (props)=>{
    const { logo , title , description , linkLearnMore , showLearnMore , backgroundColorCard  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_hub_platform_card_item_platform_card_item_module_default()).container,
        style: {
            backgroundColor: showLearnMore ? "#f5f5f5" : "#b2fce4",
            cursor: showLearnMore ? "pointer" : "default"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((business_hub_platform_card_item_platform_card_item_module_default()).logo, " ").concat(showLearnMore ? (business_hub_platform_card_item_platform_card_item_module_default()).canHover : ""),
                style: {
                    backgroundColor: showLearnMore ? "#b2fce4" : "#2d3f39"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        WebkitMaskImage: "url(".concat(logo, ")"),
                        maskImage: "url(".concat(logo, ")"),
                        backgroundColor: showLearnMore ? "#000000" : "#ffffff"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_platform_card_item_platform_card_item_module_default()).title,
                dangerouslySetInnerHTML: {
                    __html: title || ""
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_platform_card_item_platform_card_item_module_default()).description,
                dangerouslySetInnerHTML: {
                    __html: description || ""
                }
            }),
            showLearnMore && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: (business_hub_platform_card_item_platform_card_item_module_default()).tileClick,
                        href: linkLearnMore,
                        target: "_blank"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_hub_platform_card_item_platform_card_item_module_default()).learnMore,
                        children: "Learn more"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var business_hub_platform_card_item_platform_card_item = (platform_card_item_PlatFromCardItem);

// EXTERNAL MODULE: ./components/business-hub-platform/business-hub-platform.module.scss
var business_hub_platform_module = __webpack_require__(50735);
var business_hub_platform_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_platform_module);
;// CONCATENATED MODULE: ./components/business-hub-platform/business-hub-platform.tsx








swiper/* default.use */.Z.use([
    modules/* Autoplay */.pt,
    modules/* A11y */.s5
]);
const business_hub_platform_options = {
    slidesPerView: "auto",
    spaceBetween: 36,
    allowTouchMove: true,
    noSwiping: false,
    freeMode: true,
    loop: true,
    navigation: true,
    pagination: false,
    speed: 1000,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false
    },
    breakpoints: {
        992: {
            watchOverflow: true,
            spaceBetween: 20
        }
    }
};
const BusinessHubPlatForm = (props)=>{
    const { backgroundColor , header , subHeader , cards =[] , showLearnMore  } = props;
    const { width =0  } = (0,useWindowSize/* useWindowSize */.i)();
    const isMobile = (0,react.useMemo)(()=>width <= 998, [
        width
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_hub_platform_module_default()).container,
        style: {
            backgroundColor: backgroundColor
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (business_hub_platform_module_default()).wrapperContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_platform_module_default()).header,
                    dangerouslySetInnerHTML: {
                        __html: header
                    }
                }),
                subHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_platform_module_default()).subHeader,
                    dangerouslySetInnerHTML: {
                        __html: subHeader
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_platform_module_default()).wrapperCards,
                    children: !isMobile ? cards.map((card, index)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_hub_platform_card_item_platform_card_item, {
                                logo: card.logo,
                                title: card.title,
                                description: card.description,
                                linkLearnMore: card.linkLearnMore,
                                showLearnMore: showLearnMore
                            }, index)
                        }, index);
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        ...business_hub_platform_options,
                        children: cards.map((card, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_hub_platform_card_item_platform_card_item, {
                                    logo: card.logo,
                                    title: card.title,
                                    description: card.description,
                                    linkLearnMore: card.linkLearnMore,
                                    showLearnMore: showLearnMore
                                }, index)
                            }, index);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var business_hub_platform = (BusinessHubPlatForm);

;// CONCATENATED MODULE: ./components/business-hub-platform/business-hub-platform.builder-component.ts

const BusinessHubVideoHeroBuilderConfig = {
    name: "Business Hub Platform",
    inputs: [
        {
            name: "backgroundColor",
            type: "color",
            defaultValue: ""
        },
        {
            name: "header",
            type: "html",
            defaultValue: ""
        },
        {
            name: "subHeader",
            type: "html",
            defaultValue: ""
        },
        {
            name: "showLearnMore",
            type: "boolean",
            defaultValue: false
        },
        {
            name: "cards",
            type: "list",
            // copyOnAdd: false,
            subFields: [
                {
                    name: "backgroundColorCard",
                    type: "color"
                },
                {
                    name: "logo",
                    type: "file",
                    defaultValue: ""
                },
                {
                    name: "title",
                    type: "html"
                },
                {
                    name: "description",
                    type: "html"
                },
                {
                    name: "linkLearnMore",
                    type: "string"
                }
            ]
        }
    ]
};
const business_hub_platform_builder_component_builderConfig = {
    component: business_hub_platform,
    config: BusinessHubVideoHeroBuilderConfig
};
/* harmony default export */ var business_hub_platform_builder_component = (business_hub_platform_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-hub-solutions/business-hub-solutions.module.scss
var business_hub_solutions_module = __webpack_require__(28079);
var business_hub_solutions_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_solutions_module);
;// CONCATENATED MODULE: ./components/business-hub-solutions/business-hub-solutions.tsx








gsap.gsap.registerPlugin(ScrollTrigger.ScrollTrigger);
const BusinessHubSolutions = (props)=>{
    const { title , slides =[]  } = props;
    const [isRendered, setIsRendered] = (0,react.useState)(false);
    const containerRef = (0,react.useRef)(null);
    const sections = (0,react.useRef)([]);
    (0,react.useEffect)(()=>{
        ()=>{
            sections.current = [];
        };
    }, []);
    const ctx = (0,react.useRef)();
    (0,react.useLayoutEffect)(()=>{
        if (!containerRef.current) return;
        if (!sections.current.length) return;
        if (isRendered) return;
        setIsRendered(true);
        ctx.current = gsap.gsap.context(()=>{
            let tl = gsap.gsap.timeline({
                defaults: {
                    duration: 2,
                    ease: gsap_core/* Expo.easeOut */.Au.easeOut
                },
                scrollTrigger: {
                    trigger: containerRef.current,
                    pinnedContainer: containerRef.current,
                    anticipatePin: 1,
                    pin: true,
                    start: ()=>{
                        var ref;
                        const containerHeight = ((ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect().height) || 0;
                        const windowHeight = window.innerHeight;
                        if (containerHeight < windowHeight) {
                            return "center center";
                        }
                        return "bottom bottom";
                    },
                    scrub: true,
                    end: "+=300%",
                    invalidateOnRefresh: true
                }
            });
            gsap.gsap.set(sections.current, {
                autoAlpha: 1,
                yPercent: (index)=>index === 0 ? 0 : 100,
                xPercent: (index)=>-100 * index
            });
            for(let index = 1; index < sections.current.length; index++){
                const section = sections.current[index];
                const prevSection = sections.current[index - 1];
                tl.to([
                    section
                ], {
                    yPercent: 0,
                    opacity: 1
                }, "+=2").to([
                    prevSection
                ], {
                    yPercent: -50 * index,
                    opacity: 0
                }, "<");
            }
        });
    }, [
        containerRef,
        sections
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_hub_solutions_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: containerRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_solutions_module_default()).title,
                    dangerouslySetInnerHTML: {
                        __html: title || ""
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_solutions_module_default()).contentBox,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_hub_solutions_module_default()).parallaxContainer,
                        children: slides === null || slides === void 0 ? void 0 : slides.map((param, idx)=>/*#__PURE__*/ {
                            let { title , description , image , imageRatio , imagePosition ="center" , imageBordered  } = param;
                            return (0,jsx_runtime.jsxs)("section", {
                                className: classnames_default()((business_hub_solutions_module_default()).section, (business_hub_solutions_module_default())[imagePosition]),
                                ref: (ref)=>{
                                    if (ref) sections.current.push(ref);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()((business_hub_solutions_module_default()).sectionLeft, (business_hub_solutions_module_default())[imagePosition]),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classnames_default()((business_hub_solutions_module_default()).image, (business_hub_solutions_module_default())[imagePosition], {
                                                [(business_hub_solutions_module_default()).bordered]: imageBordered
                                            }),
                                            style: {
                                                aspectRatio: "".concat(imageRatio)
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: image || "",
                                                alt: "",
                                                style: {
                                                    objectFit: "contain",
                                                    objectPosition: "center"
                                                },
                                                fill: true,
                                                loading: "eager",
                                                loader: (param)=>{
                                                    let { src , width , quality  } = param;
                                                    return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                                                }
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (business_hub_solutions_module_default()).sectionRight,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (business_hub_solutions_module_default()).number,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: idx + 1
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (business_hub_solutions_module_default()).content,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                        className: (business_hub_solutions_module_default()).title,
                                                        dangerouslySetInnerHTML: {
                                                            __html: title || ""
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (business_hub_solutions_module_default()).description,
                                                        dangerouslySetInnerHTML: {
                                                            __html: description || ""
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: classnames_default()((business_hub_solutions_module_default()).imageMobile, {
                                                            [(business_hub_solutions_module_default()).bordered]: imageBordered
                                                        }),
                                                        style: {
                                                            aspectRatio: "".concat(imageRatio)
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: image || "",
                                                            alt: "",
                                                            style: {
                                                                objectFit: "contain",
                                                                objectPosition: "center"
                                                            },
                                                            fill: true,
                                                            loading: "eager",
                                                            loader: (param)=>{
                                                                let { src , width , quality  } = param;
                                                                return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, "section-".concat(idx));
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var business_hub_solutions = (BusinessHubSolutions);

;// CONCATENATED MODULE: ./components/business-hub-solutions/business-hub-solutions.builder-component.ts

const business_hub_solutions_builder_component_FullBleedConfig = {
    name: "Business Hub Solutions",
    inputs: [
        {
            name: "title",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "slides",
            type: "list",
            required: true,
            subFields: [
                {
                    name: "title",
                    type: "string",
                    required: true
                },
                {
                    name: "description",
                    type: "richText",
                    required: false
                },
                {
                    name: "image",
                    type: "file",
                    helperText: "Use vertical images that are 2-3x resolution to ensure images render nicely on retina devices",
                    allowedFileTypes: [
                        "jpg",
                        "jpeg",
                        "png"
                    ],
                    required: true
                },
                {
                    name: "imageRatio",
                    type: "number"
                },
                {
                    name: "imagePosition",
                    type: "enum",
                    enum: [
                        "center",
                        "bottom"
                    ]
                },
                {
                    name: "imageBordered",
                    type: "boolean"
                }
            ]
        }
    ]
};
const business_hub_solutions_builder_component_builderConfig = {
    component: business_hub_solutions,
    config: business_hub_solutions_builder_component_FullBleedConfig
};
/* harmony default export */ var business_hub_solutions_builder_component = (business_hub_solutions_builder_component_builderConfig);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(54666);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/business-hub-stats/business-hub-stats.tsx


const BusinessHubStatsMobile = dynamic_default()(()=>__webpack_require__.e(/* import() */ 231).then(__webpack_require__.bind(__webpack_require__, 80231)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(80231)
            ]
    }
});
const BusinessHubStats = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BusinessHubStatsMobile, {
        ...props
    });
};
/* harmony default export */ var business_hub_stats = (BusinessHubStats);

;// CONCATENATED MODULE: ./components/business-hub-stats/business-hub-stats.builder-component.ts

const BusinessHubStatsConfig = {
    name: "Business Hub Stats",
    inputs: [
        {
            name: "stats",
            type: "list",
            subFields: [
                {
                    name: "title",
                    type: "string"
                },
                {
                    name: "stats",
                    type: "list",
                    subFields: [
                        {
                            name: "percent",
                            type: "string",
                            max: 100,
                            min: 0
                        },
                        {
                            name: "plus",
                            type: "boolean"
                        },
                        {
                            name: "hidePercent",
                            type: "boolean"
                        },
                        {
                            name: "description",
                            type: "string"
                        }
                    ]
                }
            ]
        }
    ]
};
const business_hub_stats_builder_component_builderConfig = {
    component: business_hub_stats,
    config: BusinessHubStatsConfig
};
/* harmony default export */ var business_hub_stats_builder_component = (business_hub_stats_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/business-hub-trusted-brand/business-hub-trusted-brand.builder-component.ts

const BusinessHubTrustedBrandConfig = {
    name: "Business Hub Trusted Brand",
    inputs: [
        {
            name: "title",
            type: "string"
        },
        {
            name: "industryCommon",
            type: "reference",
            model: "business-industries"
        },
        {
            name: "textColor",
            type: "color"
        },
        {
            name: "background",
            type: "color"
        },
        {
            name: "roundedBottom",
            type: "boolean"
        },
        {
            name: "isCarousel",
            type: "boolean"
        },
        {
            name: "trustedBrands",
            type: "list",
            helperText: "Override trusted brands in the common field",
            subFields: [
                {
                    name: "logo",
                    type: "file"
                },
                {
                    name: "name",
                    type: "string"
                },
                {
                    name: "ratio",
                    type: "number",
                    helperText: "image height / image width"
                },
                {
                    name: "maxWidth",
                    type: "number"
                },
                {
                    name: "maxHeight",
                    type: "number"
                }
            ]
        }
    ]
};
const business_hub_trusted_brand_builder_component_builderConfig = {
    component: business_hub_trusted_brand,
    config: BusinessHubTrustedBrandConfig
};
/* harmony default export */ var business_hub_trusted_brand_builder_component = (business_hub_trusted_brand_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-hub-used-by/business-hub-used-by.module.scss
var business_hub_used_by_module = __webpack_require__(9410);
var business_hub_used_by_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_used_by_module);
// EXTERNAL MODULE: ./components/business-hub-used-by/used-by-item/used-by-item.module.scss
var used_by_item_module = __webpack_require__(5876);
var used_by_item_module_default = /*#__PURE__*/__webpack_require__.n(used_by_item_module);
;// CONCATENATED MODULE: ./components/business-hub-used-by/used-by-item/used-by-item.tsx


const UsedByItem = (props)=>{
    const { textNumber , subNumber , subNumberMaxWidth  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (used_by_item_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (used_by_item_module_default()).textNumber,
                dangerouslySetInnerHTML: {
                    __html: textNumber || ""
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (used_by_item_module_default()).subNumber,
                style: {
                    maxWidth: subNumberMaxWidth
                },
                dangerouslySetInnerHTML: {
                    __html: subNumber || ""
                }
            })
        ]
    });
};
/* harmony default export */ var used_by_item = (UsedByItem);

;// CONCATENATED MODULE: ./components/business-hub-used-by/business-hub-used-by.tsx






swiper/* default.use */.Z.use([
    modules/* Autoplay */.pt
]);
const business_hub_used_by_options = {
    slidesPerView: 1,
    spaceBetween: 30,
    allowTouchMove: true,
    loop: true,
    speed: 1000,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false
    },
    breakpoints: {
        992: {
            spaceBetween: 60,
            slidesPerView: "auto",
            autoplay: false,
            loop: false
        },
        575: {
            slidesPerView: 2
        }
    }
};
const BusinessHubUsedBy = (props)=>{
    const { title , subTitle , listItem  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_hub_used_by_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (business_hub_used_by_module_default()).wrapperContent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_used_by_module_default()).title,
                    dangerouslySetInnerHTML: {
                        __html: title || ""
                    }
                }),
                subTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_used_by_module_default()).subTitle,
                    dangerouslySetInnerHTML: {
                        __html: subTitle || ""
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_hub_used_by_module_default()).listItem,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        ...business_hub_used_by_options,
                        children: listItem.sort((a, b)=>(a.order || 0) - (b.order || 0)).map((item, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (business_hub_used_by_module_default()).item,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(used_by_item, {
                                        ...item
                                    }, Math.random())
                                })
                            }, Math.random());
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var business_hub_used_by = (BusinessHubUsedBy);

;// CONCATENATED MODULE: ./components/business-hub-used-by/business-hub-used-by.builder-component.ts


const BusinessHubUsedByBuilderConfig = {
    name: "Business Hub Used By",
    inputs: [
        {
            name: "title",
            type: "html",
            defaultValue: ""
        },
        {
            name: "subTitle",
            type: "html",
            defaultValue: ""
        },
        {
            name: "listItem",
            type: "list",
            subFields: [
                {
                    name: "textNumber",
                    type: "html",
                    defaultValue: ""
                },
                {
                    name: "subNumber",
                    type: "html",
                    defaultValue: ""
                },
                {
                    name: "subNumberMaxWidth",
                    type: "number",
                    min: 234
                },
                {
                    name: "order",
                    type: "number",
                    min: 0
                }
            ]
        }
    ]
};
const business_hub_used_by_builder_component_builderConfig = {
    component: (0,builder_react_es5/* withChildren */.u7)(business_hub_used_by),
    config: BusinessHubUsedByBuilderConfig
};
/* harmony default export */ var business_hub_used_by_builder_component = (business_hub_used_by_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-hub-video-hero/business-hub-video-hero.module.scss
var business_hub_video_hero_module = __webpack_require__(17222);
var business_hub_video_hero_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_video_hero_module);
;// CONCATENATED MODULE: ./components/business-hub-video-hero/business-hub-video-hero.tsx








const BusinessHubVideoHero = (props)=>{
    const { videoHero , imagePlaceholder , title , description , ctaText , ctaLink , borderRadiusBackground , staticImageOnMobile  } = props;
    const [volume, setVolume] = (0,react.useState)(0);
    const videoContainerRef = (0,react.useRef)(null);
    const { width =0  } = (0,useWindowSize/* useWindowSize */.i)();
    if (!videoHero || !title || !description) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_hub_video_hero_module_default()).container,
        style: {
            ["--borderRadius"]: borderRadiusBackground ? "30px" : "0px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_hub_video_hero_module_default()).imageHero,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: imagePlaceholder || "",
                        alt: "",
                        style: {
                            objectFit: "cover",
                            objectPosition: "center"
                        },
                        fill: true,
                        loading: "eager",
                        loader: (param)=>{
                            let { src , width , quality  } = param;
                            return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                        }
                    }),
                    staticImageOnMobile && width <= 992 ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: staticImageOnMobile || "",
                        alt: "",
                        style: {
                            objectFit: "cover",
                            objectPosition: "center"
                        },
                        fill: true,
                        loading: "eager",
                        loader: (param)=>{
                            let { src , width , quality  } = param;
                            return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                        }
                    }) : null
                ]
            }),
            staticImageOnMobile && width > 992 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: videoContainerRef,
                className: (business_hub_video_hero_module_default()).videoHero,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_vimeo_es, {
                    onLoaded: ()=>{
                        var ref;
                        videoContainerRef === null || videoContainerRef === void 0 ? void 0 : (ref = videoContainerRef.current) === null || ref === void 0 ? void 0 : ref.classList.add((business_hub_video_hero_module_default()).loaded);
                    },
                    video: videoHero,
                    muted: true,
                    volume: volume,
                    autoplay: true,
                    controls: false,
                    loop: true,
                    onVolumeChange: (e)=>setVolume(e.volume)
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_hub_video_hero_module_default()).content,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (business_hub_video_hero_module_default()).wrapperText,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_hub_video_hero_module_default()).title,
                            dangerouslySetInnerHTML: {
                                __html: title
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_hub_video_hero_module_default()).description,
                            dangerouslySetInnerHTML: {
                                __html: description
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                            className: (business_hub_video_hero_module_default()).btn,
                            link: ctaLink,
                            buttonText: ctaText,
                            position: business_button_constants/* POSITION.LEFT */.Vr.LEFT,
                            autoMargin: false,
                            target: "_blank"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var business_hub_video_hero = (BusinessHubVideoHero);

;// CONCATENATED MODULE: ./components/business-hub-video-hero/business-hub-video-hero.builder-component.ts

const business_hub_video_hero_builder_component_BusinessHubVideoHeroBuilderConfig = {
    name: "Business Video Hero",
    inputs: [
        {
            name: "videoHero",
            type: "string",
            defaultValue: ""
        },
        {
            name: "imagePlaceholder",
            type: "file",
            defaultValue: ""
        },
        {
            name: "borderRadiusBackground",
            type: "boolean"
        },
        {
            name: "title",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "description",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "ctaText",
            type: "string",
            defaultValue: ""
        },
        {
            name: "ctaLink",
            type: "string",
            defaultValue: ""
        },
        {
            name: "staticImageOnMobile",
            type: "file",
            defaultValue: ""
        }
    ]
};
const business_hub_video_hero_builder_component_builderConfig = {
    component: business_hub_video_hero,
    config: business_hub_video_hero_builder_component_BusinessHubVideoHeroBuilderConfig
};
/* harmony default export */ var business_hub_video_hero_builder_component = (business_hub_video_hero_builder_component_builderConfig);

// EXTERNAL MODULE: ./node_modules/react-popper/lib/esm/usePopper.js + 53 modules
var usePopper = __webpack_require__(31882);
// EXTERNAL MODULE: ./components/business-resource-download-button/business-resource-download-button.module.scss
var business_resource_download_button_module = __webpack_require__(51082);
var business_resource_download_button_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_download_button_module);
;// CONCATENATED MODULE: ./components/business-resource-download-button/business-resource-download-tooltip/business-resource-download-tooltip.tsx




const BusinessResourceDownloadTooltip = (props, ref)=>{
    const { arrowRef , item , onVariantClick , popperStyles , attributes , disabled , allOption =true  } = props;
    if (!item) return null;
    const handleVariantClick = (event, variant)=>{
        if (disabled) return;
        event.preventDefault();
        event.stopPropagation();
        onVariantClick === null || onVariantClick === void 0 ? void 0 : onVariantClick(variant);
    };
    if (!item.variants || item.variants.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: ref,
        className: (business_resource_download_button_module_default()).tooltip,
        style: popperStyles.popper,
        ...(attributes === null || attributes === void 0 ? void 0 : attributes.popper) || {},
        children: [
            allOption ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                disabled: disabled,
                type: "button",
                className: (business_resource_download_button_module_default()).button,
                onClick: (e)=>handleVariantClick(e, "ALL"),
                children: "ALL"
            }) : null,
            item.variants.map((variant)=>{
                if (variant.variantName) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        disabled: disabled,
                        type: "button",
                        className: (business_resource_download_button_module_default()).button,
                        onClick: (e)=>handleVariantClick(e, variant),
                        children: variant.variantName
                    }, "".concat(Math.random()));
                }
                return null;
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((business_resource_download_button_module_default()).tooltipArrow, {
                    [(business_resource_download_button_module_default()).visible]: !!arrowRef
                }),
                ref: arrowRef,
                style: popperStyles.arrow
            })
        ]
    });
};
/* harmony default export */ var business_resource_download_tooltip = (/*#__PURE__*/(0,react.forwardRef)(BusinessResourceDownloadTooltip));

;// CONCATENATED MODULE: ./components/business-resource-download-button/business-resource-download-button.tsx






const BussinessResourceDownloadButton = (props)=>{
    const { children , item , type , onVariantClick , className , containerClass , disabled , allOption , directlyDownload =false , mobileFullWidth , ...buttonProps } = props;
    const [referenceElement, setReferenceElement] = (0,react.useState)(null);
    const [popperElement, setPopperElement] = (0,react.useState)(null);
    const [arrowElement, setArrowElement] = (0,react.useState)(null);
    const { styles: popperStyles , attributes  } = (0,usePopper/* usePopper */.D)(referenceElement, popperElement, {
        modifiers: [
            {
                name: "arrow",
                options: {
                    element: arrowElement,
                    padding: 5
                }
            }
        ],
        placement: "top",
        strategy: "fixed"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((business_resource_download_button_module_default()).container, containerClass, {
            [(business_resource_download_button_module_default()).mobileFullWidth]: mobileFullWidth
        }),
        children: [
            !directlyDownload && /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_download_tooltip, {
                ref: setPopperElement,
                arrowRef: setArrowElement,
                attributes: attributes,
                popperStyles: popperStyles,
                item: item,
                onVariantClick: onVariantClick,
                disabled: disabled,
                allOption: allOption
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                disabled: disabled,
                ref: setReferenceElement,
                type: "button",
                className: classnames_default()((business_resource_download_button_module_default()).download, {
                    [(business_resource_download_button_module_default()).mobileFullWidth]: mobileFullWidth,
                    [(business_resource_download_button_module_default()).icon]: type === "icon"
                }, className),
                ...buttonProps,
                children: children
            })
        ]
    });
};
/* harmony default export */ var business_resource_download_button = (BussinessResourceDownloadButton);

// EXTERNAL MODULE: ./types/Resource.ts
var Resource = __webpack_require__(23366);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/path-browserify/index.js
var path_browserify = __webpack_require__(87043);
var path_browserify_default = /*#__PURE__*/__webpack_require__.n(path_browserify);
;// CONCATENATED MODULE: ./helpers/ResourceHelper.ts


const RESOURCE_CREATE_ZIP_API = "".concat("https://m7q46igbwl.execute-api.ap-southeast-2.amazonaws.com/production", "/api/zip/create");
const RESOURCE_PULL_ZIP_API = "https://afterpay-adhoc-api-media-production-bucket.s3.ap-southeast-2.amazonaws.com";
const assetTypeToRequest = (assets, rootFolderName)=>{
    const result = {
        name: rootFolderName,
        variants: []
    };
    const assetNameCheck = overlapCheckHof();
    assets.filter((param)=>{
        let { skipDownload  } = param;
        return !skipDownload;
    }).forEach((asset, i)=>{
        const assetName = assetNameCheck("asset", asset.name);
        const filenameCheck = overlapCheckHof();
        asset.variants.forEach((variant, j)=>{
            const filename = filenameCheck("variant", getFileNameWithExtension(variant));
            result.variants.push({
                downloadUrl: variant.downloadUrl,
                filename,
                extension: "",
                path: assetName
            });
        });
    });
    return result;
};
const resourceTypeToRequest = (resources, rootFolderName)=>{
    const result = {
        name: rootFolderName,
        variants: []
    };
    const typeCheck = overlapCheckHof();
    resources === null || resources === void 0 ? void 0 : resources.forEach((param, k)=>{
        let { assets , type , title  } = param;
        const typeName = typeCheck("resource", title || type);
        const assetNameCheck = overlapCheckHof();
        assets === null || assets === void 0 ? void 0 : assets.filter((param)=>{
            let { skipDownload  } = param;
            return !skipDownload;
        }).forEach((asset, i)=>{
            const assetName = assetNameCheck("asset", asset.name);
            const variantNameCheck = overlapCheckHof();
            asset.variants.forEach((variant, j)=>{
                const variantName = variantNameCheck("variant", getFileNameWithExtension(variant));
                result.variants.push({
                    downloadUrl: variant.downloadUrl,
                    filename: variantName,
                    extension: "",
                    path: path_browserify_default().join(typeName, assetName)
                });
            });
        });
    });
    return result;
};
const downloadAsset = async (assets, rootFolderName)=>{
    if (!assets || !assets.length) {
        console.warn("No variant to download");
        return;
    }
    const body = assetTypeToRequest(assets, rootFolderName);
    await baseDownloadAsset(body);
};
const baseDownloadAsset = async (body)=>{
    if (!body) {
        console.warn("No request body");
        return;
    }
    const data = await fetch(RESOURCE_CREATE_ZIP_API, {
        method: "POST",
        body: JSON.stringify(body)
    });
    if (data.headers.get("Content-Disposition")) {
        await downloadFromResponse(data);
        return;
    }
    const key = (await data.json()).key;
    if (!key) {
        console.error("Invalid key", data);
        return;
    }
    for(let count = 0; count < 150; count++){
        const pullResult = await pullAsset(key);
        if (pullResult) {
            break;
        }
        await new Promise((resolve)=>setTimeout(()=>{
                resolve(true);
            }, 6000));
    }
};
const overlapCheckHof = ()=>{
    let index = 1;
    const typeNames = [];
    return (initialDefaultName, name)=>{
        let typeName = name || initialDefaultName;
        if (typeNames.includes(typeName)) {
            typeName = "".concat(typeName, "_").concat(index);
            index += 1;
        }
        typeNames.push(typeName);
        return typeName;
    };
};
const getColorCode = function(colorName) {
    let hash = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!colorName) return;
    const mapping = {
        [Resource/* COLORS.Mint */.D.Mint]: "B2FCE4",
        [Resource/* COLORS.Black */.D.Black]: "000",
        [Resource/* COLORS.White */.D.White]: "FFF",
        [Resource/* COLORS.Grey */.D.Grey]: "969696"
    };
    const code = mapping[colorName];
    if (!code) return;
    return "".concat(hash ? "#" : "").concat(code);
};
const getFileNameWithExtension = (variant)=>{
    return "".concat(variant.fileName || "").concat(variant.extension ? "." + variant.extension : "");
};
const pullAsset = async (key)=>{
    try {
        const response = await fetch("".concat(RESOURCE_PULL_ZIP_API, "/").concat(key));
        if (response.ok) {
            const filename = response.headers.get("x-amz-meta-name") || undefined;
            await downloadFromResponse(response, filename);
            return true;
        }
        return false;
    } catch (ex) {
        console.log(ex);
        return false;
    }
};
const downloadFromResponse = async (data, filename)=>{
    const downloadElement = document.createElement("a");
    const url = window.URL.createObjectURL(await data.blob());
    downloadElement.href = url;
    downloadElement.download = filename || "";
    if (!filename) {
        const disposition = data.headers.get("Content-Disposition");
        let filename1 = "assets";
        if (disposition) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
                filename1 = matches[1].replace(/['"]/g, "");
            }
            downloadElement.download = filename1;
        }
    }
    downloadElement.click();
    window.URL.revokeObjectURL(url);
};

;// CONCATENATED MODULE: ./hook/useDownloadResource.ts


const useDownloadResource = ()=>{
    const [loading, setLoading] = (0,react.useState)(false);
    const downloadResources = async (resources, rootFolderName)=>{
        setLoading(true);
        try {
            const body = resourceTypeToRequest(resources, rootFolderName);
            await baseDownloadAsset(body);
        } catch (ex) {
            console.error(ex);
        } finally{
            setLoading(false);
        }
    };
    return {
        loading,
        downloadResources
    };
};
/* harmony default export */ var hook_useDownloadResource = (useDownloadResource);

;// CONCATENATED MODULE: ./components/business-resource-download-button/business-resource-download-resources-button-container.tsx




const BusinessResourceDownloadResourcesButtonContainer = (param)=>{
    let { onClick , disabled , resources , rootContainerName , skipCompressResource , ...props } = param;
    const { loading , downloadResources  } = hook_useDownloadResource();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_download_button, {
        onClick: async (e)=>{
            var ref, ref1, ref2;
            if (skipCompressResource && resources.length === 1 && ((ref = resources[0].assets) === null || ref === void 0 ? void 0 : ref.length) === 1 && ((ref2 = (ref1 = resources[0].assets) === null || ref1 === void 0 ? void 0 : ref1[0].variants) === null || ref2 === void 0 ? void 0 : ref2.length) === 1) {
                window.open(resources[0].assets[0].variants[0].downloadUrl);
                return;
            }
            await downloadResources(resources, rootContainerName);
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
        },
        disabled: loading || disabled,
        ...props
    });
};
/* harmony default export */ var business_resource_download_resources_button_container = (BusinessResourceDownloadResourcesButtonContainer);

// EXTERNAL MODULE: ./components/icons/Icons/Download.tsx
var Download = __webpack_require__(37763);
;// CONCATENATED MODULE: ./components/business-resource-download-all-button/business-resource-download-all-button.tsx




const BusinessResourceDownloadAllButton = (param)=>{
    let { text , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(business_resource_download_resources_button_container, {
        ...props,
        children: [
            text,
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Download/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var business_resource_download_all_button = (BusinessResourceDownloadAllButton);

;// CONCATENATED MODULE: ./components/business-resource-download-all-button/business-resource-download-all-button.builder-component.ts

const BusinessResourceWebsiteConfig = {
    name: "Resource Download All Button",
    inputs: [
        {
            name: "text",
            type: "string"
        },
        {
            name: "rootContainerName",
            type: "string"
        },
        {
            name: "mobileFullWidth",
            type: "boolean"
        },
        {
            name: "skipCompressResource",
            type: "boolean",
            description: "Skip compress if there are only 1 file"
        }
    ]
};
const business_resource_download_all_button_builder_component_builderConfig = {
    component: business_resource_download_all_button,
    config: BusinessResourceWebsiteConfig
};
/* harmony default export */ var business_resource_download_all_button_builder_component = (business_resource_download_all_button_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-link-button/business-resource-link-button.module.scss
var business_resource_link_button_module = __webpack_require__(39901);
var business_resource_link_button_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_link_button_module);
;// CONCATENATED MODULE: ./components/business-resource-link-button/business-resource-link-button.tsx




const BusinessResourceLinkButton = (param)=>{
    let { disabled , className , children , icon , strong , onClick , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        className: classnames_default()((business_resource_link_button_module_default()).root, {
            [(business_resource_link_button_module_default()).disabled]: disabled
        }, className),
        onClick: (e)=>{
            if (disabled) {
                e.preventDefault();
            } else onClick === null || onClick === void 0 ? void 0 : onClick(e);
        },
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: classnames_default()((business_resource_link_button_module_default()).text, {
                    [(business_resource_link_button_module_default()).strong]: strong
                }),
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (business_resource_link_button_module_default()).icon,
                children: icon
            })
        ]
    });
};
/* harmony default export */ var business_resource_link_button = (BusinessResourceLinkButton);

;// CONCATENATED MODULE: ./components/icons/Icons/ArrowRightXSmall.tsx


const ArrowRightXSmall = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.9999 8L1.33325 8",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.66675 2.66668L12.0001 8.00001L6.66675 13.3333",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_ArrowRightXSmall = (ArrowRightXSmall);

// EXTERNAL MODULE: ./components/asset-card/asset-card.module.scss
var asset_card_module = __webpack_require__(84179);
var asset_card_module_default = /*#__PURE__*/__webpack_require__.n(asset_card_module);
;// CONCATENATED MODULE: ./components/asset-card/asset-card.tsx









swiper/* default.use */.Z.use([
    modules/* Pagination */.tl
]);
const AssetCard = (param)=>{
    let { asset: { variants  } , children , RatioImageProps ={}  } = param;
    const filteredVariants = (variants || []).filter((param)=>{
        let { hide , colors  } = param;
        return !hide;
    });
    const [backgroundColor, setBackgroundColor] = (0,react.useState)(undefined);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (asset_card_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                onSlideChange: (swiper)=>{
                    const realIndex = swiper.realIndex;
                    const currentSlide = filteredVariants[realIndex];
                    setBackgroundColor(currentSlide.backgroundColor);
                },
                loop: true,
                className: (asset_card_module_default()).swiperContainer,
                slidesPerView: 1,
                navigation: false,
                pagination: {
                    clickable: true,
                    renderBullet: (index)=>{
                        var ref, ref1;
                        if (!filteredVariants) {
                            return "";
                        }
                        const { colors  } = filteredVariants[index];
                        return "<div style='background-color: ".concat(getColorCode(colors === null || colors === void 0 ? void 0 : (ref = colors[0]) === null || ref === void 0 ? void 0 : ref.color, true), "; ").concat((colors === null || colors === void 0 ? void 0 : (ref1 = colors[0]) === null || ref1 === void 0 ? void 0 : ref1.color) === Resource/* COLORS.White */.D.White ? "border-color: #000" : "", "' class='swiper-pagination-bullet'></div>");
                    }
                },
                children: filteredVariants.map((param, index)=>/*#__PURE__*/ {
                    let { previewUrl  } = param;
                    return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                backgroundColor
                            },
                            className: (asset_card_module_default()).content,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ratio_image, {
                                image: previewUrl,
                                ...RatioImageProps
                            })
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (asset_card_module_default()).checkbox,
                children: children
            })
        ]
    });
};
/* harmony default export */ var asset_card = (AssetCard);

;// CONCATENATED MODULE: ./hook/useDownloadVariant.ts


const useDownloadVariant = ()=>{
    const [loading, setLoading] = (0,react.useState)(false);
    const downloadVariant = async (asset, variant, defaultFolderName)=>{
        setLoading(true);
        try {
            await downloadAsset(variant === "ALL" ? [
                asset
            ] : [
                {
                    ...asset,
                    variants: [
                        variant
                    ]
                }
            ], asset.name || defaultFolderName || "asset");
        } catch (ex) {
            console.error(ex);
        } finally{
            setLoading(false);
        }
    };
    return {
        loading,
        downloadVariant
    };
};
/* harmony default export */ var hook_useDownloadVariant = (useDownloadVariant);

;// CONCATENATED MODULE: ./hook/useDownloadAssets.ts


const useDownloadAssets = ()=>{
    const [loading, setLoading] = (0,react.useState)(false);
    const downloadAssetWrapper = async (assets, rootFolderName)=>{
        setLoading(true);
        try {
            await downloadAsset(assets, rootFolderName);
        } catch (ex) {
            console.error(ex);
        } finally{
            setLoading(false);
        }
    };
    return {
        loading,
        downloadAssets: downloadAssetWrapper
    };
};
/* harmony default export */ var hook_useDownloadAssets = (useDownloadAssets);

;// CONCATENATED MODULE: ./components/business-resource-download-button/business-resource-download-variant-button-container.tsx






const BusinessResourceDownloadVariantButtonContainer = (param)=>{
    let { defaultFolderName , disabled , item , onVariantClick , directlyDownload , ...props } = param;
    const { loading , downloadVariant  } = hook_useDownloadVariant();
    const { loading: assetLoading , downloadAssets  } = hook_useDownloadAssets();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_download_button, {
        disabled: loading || assetLoading || disabled,
        item: item,
        onClick: async ()=>{
            if (directlyDownload) {
                if (item) downloadAssets([
                    item
                ], (item === null || item === void 0 ? void 0 : item.name) || defaultFolderName || "assets");
            }
        },
        onVariantClick: async (variant)=>{
            if (!directlyDownload) {
                onVariantClick === null || onVariantClick === void 0 ? void 0 : onVariantClick(variant);
                if (item) {
                    await downloadVariant(item, variant, defaultFolderName);
                }
            }
        },
        directlyDownload: directlyDownload,
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
            type: icons/* IconType.Download */.T.Download
        })
    });
};
/* harmony default export */ var business_resource_download_variant_button_container = (BusinessResourceDownloadVariantButtonContainer);

;// CONCATENATED MODULE: ./components/asset-card/download-asset-card.tsx




const DownloadAssetCard = (param)=>{
    let { asset , AssetCardProps ={}  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_card, {
        asset: asset,
        ...AssetCardProps,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_download_variant_button_container, {
            type: "icon",
            directlyDownload: true,
            item: asset
        })
    });
};
/* harmony default export */ var download_asset_card = (DownloadAssetCard);

// EXTERNAL MODULE: ./components/business-resource-asset-grid/business-resource-asset-grid.module.scss
var business_resource_asset_grid_module = __webpack_require__(16414);
var business_resource_asset_grid_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_asset_grid_module);
;// CONCATENATED MODULE: ./components/business-resource-download-button/business-resource-download-assets-button-container.tsx




const BusinessResourceDownloadAssetsButtonContainer = (param)=>{
    let { onClick , disabled , assets , rootContainerName , ...props } = param;
    const { loading , downloadAssets  } = hook_useDownloadAssets();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_download_button, {
        onClick: async (e)=>{
            await downloadAssets(assets, rootContainerName);
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
        },
        disabled: loading || disabled,
        ...props
    });
};
/* harmony default export */ var business_resource_download_assets_button_container = (BusinessResourceDownloadAssetsButtonContainer);

// EXTERNAL MODULE: ./components/business-resource-divider/business-resource-divider.module.scss
var business_resource_divider_module = __webpack_require__(88874);
var business_resource_divider_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_divider_module);
;// CONCATENATED MODULE: ./components/business-resource-divider/business-resource-divider.tsx


const BusinessResourceDivider = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_resource_divider_module_default()).container
    });
};
/* harmony default export */ var business_resource_divider = (BusinessResourceDivider);

;// CONCATENATED MODULE: ./components/business-resource-asset-grid/business-resource-asset-grid.tsx










const BusinessResourceAssetGrid = (param)=>{
    let { resources , limitRows =2 , columns =2 , showDownloadButton =false , showDivider , renderAssetCard , ...props } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var _resourceIndex;
    const resourceIndex = (_resourceIndex = props.resourceIndex) !== null && _resourceIndex !== void 0 ? _resourceIndex : 0;
    const [show, setShow] = (0,react.useState)(false);
    if (!resources || !resources[resourceIndex]) return null;
    const hasShowMore = !!((ref = resources[resourceIndex].assets) === null || ref === void 0 ? void 0 : ref.slice(limitRows * columns).length);
    const renderDefaultAssetCard = (asset, index)=>{
        return (renderAssetCard === null || renderAssetCard === void 0 ? void 0 : renderAssetCard(asset)) || /*#__PURE__*/ (0,jsx_runtime.jsx)(download_asset_card, {
            asset: asset,
            AssetCardProps: {
                RatioImageProps: {
                    maxHeight: 216,
                    minHeight: 120
                }
            }
        }, index);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: (ref1 = resources[resourceIndex]) === null || ref1 === void 0 ? void 0 : ref1.id,
                className: classnames_default()((business_resource_asset_grid_module_default()).root, {
                    [(business_resource_asset_grid_module_default()).hasShowMore]: hasShowMore,
                    [(business_resource_asset_grid_module_default()).showDivider]: showDivider
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_resource_asset_grid_module_default()).titleContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_resource_asset_grid_module_default()).title,
                                children: (ref2 = resources[resourceIndex]) === null || ref2 === void 0 ? void 0 : ref2.title
                            }),
                            (resources === null || resources === void 0 ? void 0 : (ref3 = resources[resourceIndex]) === null || ref3 === void 0 ? void 0 : ref3.assets) && (resources === null || resources === void 0 ? void 0 : (ref4 = resources[resourceIndex]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.assets) === null || ref5 === void 0 ? void 0 : ref5.length) && showDownloadButton ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_resource_asset_grid_module_default()).downloadButton,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(business_resource_download_assets_button_container, {
                                    mobileFullWidth: true,
                                    assets: (resources === null || resources === void 0 ? void 0 : (ref6 = resources[resourceIndex]) === null || ref6 === void 0 ? void 0 : ref6.assets) || [],
                                    rootContainerName: ((ref7 = resources[resourceIndex]) === null || ref7 === void 0 ? void 0 : ref7.title) || ((ref8 = resources[resourceIndex]) === null || ref8 === void 0 ? void 0 : ref8.type) || "afterpay asset",
                                    children: [
                                        "Download ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Download/* default */.Z, {})
                                    ]
                                })
                            }) : null
                        ]
                    }),
                    ((ref9 = resources[resourceIndex]) === null || ref9 === void 0 ? void 0 : ref9.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_asset_grid_module_default()).description,
                        dangerouslySetInnerHTML: {
                            __html: ((ref10 = resources[resourceIndex]) === null || ref10 === void 0 ? void 0 : ref10.description) || ""
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_asset_grid_module_default()).resourceContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                gridTemplateColumns: "repeat(".concat(columns, ", minmax(0, 1fr))")
                            },
                            className: (business_resource_asset_grid_module_default()).resource,
                            children: [
                                (ref11 = resources[resourceIndex]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.assets) === null || ref12 === void 0 ? void 0 : ref12.slice(0, limitRows * columns).filter((param)=>{
                                    let { hide  } = param;
                                    return !hide;
                                }).map(renderDefaultAssetCard),
                                hasShowMore && show && ((ref13 = resources[resourceIndex]) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.assets) === null || ref14 === void 0 ? void 0 : ref14.slice(limitRows * columns).filter((param)=>{
                                    let { hide  } = param;
                                    return !hide;
                                }).map(renderDefaultAssetCard))
                            ]
                        })
                    }),
                    hasShowMore && !show && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_asset_grid_module_default()).button,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_link_button, {
                            strong: true,
                            onClick: ()=>setShow(true),
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ArrowRightXSmall, {}),
                            children: "View more"
                        })
                    })
                ]
            }),
            Number.isInteger(props.resourceIndex) ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    showDivider && resources.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_divider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BusinessResourceAssetGrid, {
                        resources: resources.slice(1),
                        limitRows: limitRows,
                        showDownloadButton: showDownloadButton,
                        columns: columns,
                        showDivider: showDivider,
                        renderAssetCard: renderAssetCard
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var business_resource_asset_grid = (BusinessResourceAssetGrid);

;// CONCATENATED MODULE: ./components/business-resource-asset-grid/business-resource-grid.builder-component.ts

const config = {
    name: "Resource Asset Grid",
    inputs: [
        {
            name: "showDownloadButton",
            type: "boolean"
        },
        {
            name: "columns",
            type: "number"
        },
        {
            name: "limitRows",
            type: "number"
        },
        {
            name: "resourceIndex",
            type: "number"
        }
    ]
};
const business_resource_grid_builder_component_builderConfig = {
    component: business_resource_asset_grid,
    config
};
/* harmony default export */ var business_resource_grid_builder_component = (business_resource_grid_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/business-resource-asset-container/business-resource-asset-container.tsx





const passableComponents = [
    business_resource_grid_builder_component,
    business_resource_download_all_button_builder_component
];
const passableComponentNames = passableComponents.map((param)=>{
    let { config: { name  }  } = param;
    return name;
});
const BusinessResourceAssetContainer = (param)=>{
    let { resources , children  } = param;
    const recursivePassResourcesProp = (block)=>{
        var ref, ref1, ref2, ref3, ref4;
        if (block.children) {
            return {
                ...block,
                children: block.children.map(recursivePassResourcesProp)
            };
        }
        if (((ref = block.component) === null || ref === void 0 ? void 0 : ref.name) === BusinessCollapseTextBuilderConfig.name && ((ref1 = block.component.options) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.item) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.content) === null || ref3 === void 0 ? void 0 : ref3.length)) {
            var ref5;
            const content = (ref5 = block.component.options.item.content) === null || ref5 === void 0 ? void 0 : ref5.map(recursivePassResourcesProp);
            return {
                ...block,
                component: {
                    ...block.component,
                    options: {
                        ...block.component.options,
                        item: {
                            ...block.component.options.item,
                            content
                        }
                    }
                }
            };
        }
        if (((ref4 = block.component) === null || ref4 === void 0 ? void 0 : ref4.name) && passableComponentNames.includes(block.component.name)) return {
            ...block,
            component: {
                ...block.component,
                options: {
                    ...block.component.options,
                    resources
                }
            }
        };
        return block;
    };
    const passResourcesProp = ()=>react.Children.map(children, (c)=>{
            if (!/*#__PURE__*/ react.isValidElement(c)) return c;
            return /*#__PURE__*/ react.cloneElement(c, {
                block: recursivePassResourcesProp(c.props.block)
            });
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children && passResourcesProp()
    });
};
/* harmony default export */ var business_resource_asset_container = (BusinessResourceAssetContainer);

;// CONCATENATED MODULE: ./components/business-resource-asset-container/business-resource-asset-container.builder-component.ts



const business_resource_asset_container_builder_component_BusinessResourceWebsiteConfig = {
    name: "Resource Asset Container",
    inputs: [
        BuilderHelper/* resourcesInput */.WA
    ]
};
const business_resource_asset_container_builder_component_builderConfig = {
    component: (0,builder_react_es5/* withChildren */.u7)(business_resource_asset_container),
    config: business_resource_asset_container_builder_component_BusinessResourceWebsiteConfig
};
/* harmony default export */ var business_resource_asset_container_builder_component = (business_resource_asset_container_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-asset-library/business-resource-asset-library.module.scss
var business_resource_asset_library_module = __webpack_require__(77974);
var business_resource_asset_library_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_asset_library_module);
// EXTERNAL MODULE: ./components/outlined-button/outlined-button.module.scss
var outlined_button_module = __webpack_require__(98133);
var outlined_button_module_default = /*#__PURE__*/__webpack_require__.n(outlined_button_module);
;// CONCATENATED MODULE: ./components/outlined-button/outlined-button.tsx




const OutlinedButton = (param, ref)=>{
    let { children , className , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref,
        className: classnames_default()((outlined_button_module_default()).root, className),
        ...props,
        children: children
    });
};
/* harmony default export */ var outlined_button = (/*#__PURE__*/(0,react.forwardRef)(OutlinedButton));

// EXTERNAL MODULE: ./components/modal/modal.module.scss
var modal_module = __webpack_require__(33171);
var modal_module_default = /*#__PURE__*/__webpack_require__.n(modal_module);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(65883);
;// CONCATENATED MODULE: ./components/react-portal/react-portal.tsx


const ReactPortal = (param)=>{
    let { children , wrapperId ="react-portal-wrapper" , onClick  } = param;
    const [wrapperElement, setWrapperElement] = (0,react.useState)(null);
    (0,react.useLayoutEffect)(()=>{
        let element = document.getElementById(wrapperId);
        let systemCreated = false;
        if (!element) {
            systemCreated = true;
            element = createWrapperAndAppendToBody(wrapperId);
        }
        element.onclick = function(e) {
            if (onClick) {
                onClick(e);
            }
        };
        setWrapperElement(element);
        return ()=>{
            if (systemCreated && element && element.parentNode) {
                element.parentNode.removeChild(element);
            }
        };
    }, [
        wrapperId
    ]);
    if (wrapperElement === null) return null;
    return /*#__PURE__*/ (0,react_dom.createPortal)(children, wrapperElement);
};
function createWrapperAndAppendToBody(wrapperId) {
    const wrapperElement = document.createElement("div");
    wrapperElement.setAttribute("id", wrapperId);
    document.body.appendChild(wrapperElement);
    return wrapperElement;
}
/* harmony default export */ var react_portal = (ReactPortal);

;// CONCATENATED MODULE: ./components/icons/Icons/Cross.tsx


const Cross = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z",
            fill: "#B2B2B2"
        })
    });
};
/* harmony default export */ var Icons_Cross = (Cross);

;// CONCATENATED MODULE: ./components/modal/modal.tsx





const Modal = (param)=>{
    let { children , title ="" , open =false , onEscape , onOutsideClick , onCloseClick , actions  } = param;
    (0,react.useEffect)(()=>{
        const closeOnEscapeKey = (e)=>e.key === "Escape" ? onEscape && onEscape() : null;
        document.body.addEventListener("keydown", closeOnEscapeKey);
        return ()=>{
            document.body.removeEventListener("keydown", closeOnEscapeKey);
        };
    }, [
        onEscape
    ]);
    const modalRef = (0,react.useRef)(null);
    if (!open) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_portal, {
        onClick: (e)=>{
            var ref;
            if (!((ref = modalRef.current) === null || ref === void 0 ? void 0 : ref.contains(e.target))) {
                onOutsideClick && onOutsideClick();
            }
        },
        wrapperId: "react-portal-modal-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (modal_module_default()).modal,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: modalRef,
                className: (modal_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (modal_module_default()).header,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (modal_module_default()).title,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: (e)=>{
                                    onCloseClick && onCloseClick(e);
                                },
                                className: (modal_module_default()).closeButton,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Cross, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (modal_module_default()).footer,
                        children: actions
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var modal = (Modal);

// EXTERNAL MODULE: ./components/checkbox/checkbox.module.scss
var checkbox_module = __webpack_require__(62594);
var checkbox_module_default = /*#__PURE__*/__webpack_require__.n(checkbox_module);
;// CONCATENATED MODULE: ./components/checkbox/checkbox.tsx




const Checkbox = (param)=>{
    let { children , onChange , checked , id  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
        htmlFor: id,
        className: (checkbox_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: classnames_default()((checkbox_module_default()).checkbox, {
                    [(checkbox_module_default()).checked]: checked
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        id: id,
                        checked: checked,
                        onChange: onChange,
                        type: "checkbox",
                        className: (checkbox_module_default()).input
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (checkbox_module_default()).inner
                    })
                ]
            }),
            children && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: children
            })
        ]
    });
};
/* harmony default export */ var checkbox_checkbox = (Checkbox);

// EXTERNAL MODULE: ./components/business-resource-asset-library/components/filter-panel-container/filter-panel-container.module.scss
var filter_panel_container_module = __webpack_require__(73129);
var filter_panel_container_module_default = /*#__PURE__*/__webpack_require__.n(filter_panel_container_module);
;// CONCATENATED MODULE: ./components/business-resource-asset-library/context.tsx

const BusinessResourceAssetLibraryContext = /*#__PURE__*/ react.createContext({
    resources: [],
    getDownloadAssetResources: ()=>[],
    getDownloadAssets: ()=>[],
    getFilteredResources: ()=>[],
    colors: [],
    keyMessages: [],
    themedAssets: [],
    assetTypes: [],
    assets: []
});
const BusinessResourceAssetLibraryProvider = BusinessResourceAssetLibraryContext.Provider;

;// CONCATENATED MODULE: ./components/business-resource-asset-library/utils.ts
const onSelect = (newValue, selectedValues, options)=>{
    if (newValue === "All") {
        if (selectedValues.includes("All")) {
            return [];
        } else {
            return options;
        }
    } else {
        const index = selectedValues.findIndex((o)=>o === newValue);
        let newValues;
        if (index >= 0) {
            // Remove
            newValues = selectedValues.slice(0, index).concat(selectedValues.slice(index + 1));
            const allIndex = newValues.findIndex((v)=>v === "All");
            if (allIndex >= 0) {
                newValues = newValues.slice(0, allIndex).concat(newValues.slice(allIndex + 1));
            }
        } else {
            // Add
            newValues = selectedValues.concat([
                newValue
            ]);
            if (newValues.length === options.length - 1) {
                newValues = newValues.concat([
                    "All"
                ]);
            }
        }
        return newValues;
    }
};
const onMultiSelect = (newValue, selectedValues, idName)=>{
    const index = selectedValues.findIndex((o)=>o[idName] === newValue[idName]);
    let newValues;
    if (index >= 0) {
        // Remove
        newValues = selectedValues.slice(0, index).concat(selectedValues.slice(index + 1));
    } else {
        // Add
        newValues = selectedValues.concat([
            newValue
        ]);
    }
    return newValues;
};

;// CONCATENATED MODULE: ./components/business-resource-asset-library/components/filter-panel-container/filter-panel-container.tsx






const FilterPanelContainer = ()=>{
    const { resources , colors , setColors , keyMessages , setKeyMessages , themedAssets , setThemedAssets , assetTypes , setAssetTypes  } = (0,react.useContext)(BusinessResourceAssetLibraryContext);
    const getColors = ()=>{
        const colors = new Set();
        resources === null || resources === void 0 ? void 0 : resources.forEach((resource)=>{
            var ref;
            (ref = resource.assets) === null || ref === void 0 ? void 0 : ref.forEach((asset)=>{
                var ref;
                (ref = asset.variants) === null || ref === void 0 ? void 0 : ref.forEach((variant)=>{
                    var ref;
                    (ref = variant.colors) === null || ref === void 0 ? void 0 : ref.forEach((param)=>{
                        let { color  } = param;
                        return color && colors.add(color);
                    });
                });
            });
        });
        return Array.from(colors);
    };
    const getAttributes = (attrName)=>{
        const attrs = new Set();
        resources === null || resources === void 0 ? void 0 : resources.forEach((resource)=>{
            var ref;
            (ref = resource.assets) === null || ref === void 0 ? void 0 : ref.forEach((asset)=>{
                var ref;
                (ref = asset[attrName]) === null || ref === void 0 ? void 0 : ref.forEach(attrs.add, attrs);
            });
        });
        return Array.from(attrs);
    };
    const alphabetSort = (array)=>array.sort((a, b)=>a.localeCompare(b));
    const getAssetTypes = ()=>{
        return resources === null || resources === void 0 ? void 0 : resources.map((param)=>{
            let { type  } = param;
            return type;
        }).filter(Boolean);
    };
    const onChangeHof = (value, values, setVales)=>{
        return (e)=>{
            const index = values.findIndex((c)=>c === value);
            if (index >= 0) {
                setVales === null || setVales === void 0 ? void 0 : setVales(values.slice(0, index).concat(values.slice(index + 1)));
            } else {
                setVales === null || setVales === void 0 ? void 0 : setVales(values.concat([
                    value
                ]));
            }
        };
    };
    const isChecked = (value, values)=>{
        return values.includes(value);
    };
    const onReset = (setState)=>{
        return ()=>{
            setState === null || setState === void 0 ? void 0 : setState([]);
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (filter_panel_container_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (filter_panel_container_module_default()).title,
                        children: [
                            "Colour",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (filter_panel_container_module_default()).reset,
                                onClick: onReset(setColors),
                                children: "Reset"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (filter_panel_container_module_default()).content,
                        children: getColors().map((color)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_checkbox, {
                                checked: isChecked(color, colors),
                                onChange: onChangeHof(color, colors, setColors),
                                children: color
                            }, color))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (filter_panel_container_module_default()).title,
                        children: [
                            "Asset Type",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (filter_panel_container_module_default()).reset,
                                onClick: onReset(setAssetTypes),
                                children: "Reset"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (filter_panel_container_module_default()).content,
                        children: getAssetTypes().map((v)=>{
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(checkbox_checkbox, {
                                checked: isChecked(v, assetTypes),
                                onChange: ()=>{
                                    const newValues = onSelect(v, assetTypes, getAssetTypes());
                                    setAssetTypes === null || setAssetTypes === void 0 ? void 0 : setAssetTypes(newValues);
                                },
                                children: v
                            }, v);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (filter_panel_container_module_default()).keyMessages,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (filter_panel_container_module_default()).title,
                        children: [
                            "Key Messages",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (filter_panel_container_module_default()).reset,
                                onClick: onReset(setKeyMessages),
                                children: "Reset"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (filter_panel_container_module_default()).content,
                        children: alphabetSort(getAttributes("keyMessages")).map((v)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_checkbox, {
                                checked: isChecked(v, keyMessages),
                                onChange: onChangeHof(v, keyMessages, setKeyMessages),
                                children: v
                            }, v))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var filter_panel_container = (FilterPanelContainer);

// EXTERNAL MODULE: ./components/icons/Icons/ArrowRightMedium.tsx
var ArrowRightMedium = __webpack_require__(53145);
;// CONCATENATED MODULE: ./components/icons/Icons/BusinessResourceFilter.tsx


const BusinessResourceFilter = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.3333 12L7.99996 12M2.66663 12L5.33329 12",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.3333 8L7.99996 8M2.66663 8L5.33329 8",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.3333 4L10.6666 4M2.66663 4L7.99996 4",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.6666 5.33317V2.6665",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.33337 9.33317V6.6665",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 13.3332V10.6665",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_BusinessResourceFilter = (BusinessResourceFilter);

// EXTERNAL MODULE: ./components/inlined-multi-select/button/button.module.scss
var button_module = __webpack_require__(32016);
var button_module_default = /*#__PURE__*/__webpack_require__.n(button_module);
;// CONCATENATED MODULE: ./components/inlined-multi-select/button/button.tsx




const Button = (param)=>{
    let { children , selected =false , onClick , id  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((button_module_default()).root, {
            [(button_module_default()).selected]: selected
        }),
        onClick: (e)=>{
            if (onClick) {
                onClick(e, id);
            }
        },
        children: children
    });
};
/* harmony default export */ var button_button = (Button);

// EXTERNAL MODULE: ./components/inlined-multi-select/inlined-multi-select.module.scss
var inlined_multi_select_module = __webpack_require__(4722);
var inlined_multi_select_module_default = /*#__PURE__*/__webpack_require__.n(inlined_multi_select_module);
;// CONCATENATED MODULE: ./components/inlined-multi-select/inlined-multi-select.tsx





const InlinedMultiSelect = (param)=>{
    let { value =[] , onClick , options =[]  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (inlined_multi_select_module_default()).root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
            spaceBetween: 8,
            slidesPerGroup: 1,
            slidesPerView: "auto",
            className: (inlined_multi_select_module_default()).swiperContainer,
            children: options.map((option)=>{
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    style: {
                        width: "auto"
                    },
                    onClick: (e)=>{
                        return onClick === null || onClick === void 0 ? void 0 : onClick(e, option);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button, {
                        selected: value === null || value === void 0 ? void 0 : value.includes(option),
                        id: option,
                        children: option
                    })
                }, option);
            })
        })
    });
};
/* harmony default export */ var inlined_multi_select = (InlinedMultiSelect);

;// CONCATENATED MODULE: ./components/business-resource-asset-library/components/inlined-multi-select-container/inlined-multi-select-container.tsx





const InlinedMultiSelectContainer = ()=>{
    const { resources , assetTypes , setAssetTypes  } = (0,react.useContext)(BusinessResourceAssetLibraryContext);
    const options = [
        "All"
    ].concat(resources === null || resources === void 0 ? void 0 : resources.map((param)=>{
        let { type  } = param;
        return type;
    }).filter(Boolean));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(inlined_multi_select, {
            value: assetTypes,
            onClick: (e, value)=>{
                const newValues = onSelect(value, assetTypes, options);
                setAssetTypes === null || setAssetTypes === void 0 ? void 0 : setAssetTypes(newValues);
            },
            options: options
        })
    });
};
/* harmony default export */ var inlined_multi_select_container = (InlinedMultiSelectContainer);

// EXTERNAL MODULE: ./components/chip/chip.module.scss
var chip_module = __webpack_require__(52923);
var chip_module_default = /*#__PURE__*/__webpack_require__.n(chip_module);
;// CONCATENATED MODULE: ./components/icons/Icons/SquaredClose.tsx


const SquaredClose = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 3.66663L3.66663 13",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 13L3.66663 3.66663",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_SquaredClose = (SquaredClose);

;// CONCATENATED MODULE: ./components/chip/chip.tsx




const Chip = (param)=>{
    let { children , onCloseClick  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (chip_module_default()).root,
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                onClick: onCloseClick,
                className: (chip_module_default()).icon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_SquaredClose, {})
            })
        ]
    });
};
/* harmony default export */ var chip = (Chip);

;// CONCATENATED MODULE: ./components/business-resource-asset-library/components/chips-container/chips-container.tsx





const ChipsContainer = ()=>{
    const context = (0,react.useContext)(BusinessResourceAssetLibraryContext);
    const renderChips = (key, setState)=>{
        return context[key].map((v)=>{
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(chip, {
                onCloseClick: ()=>{
                    const newValues = onSelect(v, context[key], []);
                    setState === null || setState === void 0 ? void 0 : setState(newValues);
                },
                children: v
            }, v);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            renderChips("colors", context.setColors),
            renderChips("assetTypes", context.setAssetTypes),
            renderChips("keyMessages", context.setKeyMessages),
            renderChips("themedAssets", context.setThemedAssets)
        ]
    });
};
/* harmony default export */ var chips_container = (ChipsContainer);

// EXTERNAL MODULE: ./components/asset-card/checkbox-asset-card.module.scss
var checkbox_asset_card_module = __webpack_require__(31773);
var checkbox_asset_card_module_default = /*#__PURE__*/__webpack_require__.n(checkbox_asset_card_module);
;// CONCATENATED MODULE: ./components/asset-card/checkbox-asset-card.tsx





const CheckboxAssetCard = (param)=>{
    let { asset , onChange , checked , CheckboxProps , AssetCardProps ={}  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
        className: (checkbox_asset_card_module_default()).root,
        htmlFor: asset.id,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_card, {
            asset: asset,
            ...AssetCardProps,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_checkbox, {
                id: asset.id,
                checked: checked,
                onChange: onChange,
                ...CheckboxProps
            })
        })
    });
};
/* harmony default export */ var checkbox_asset_card = (CheckboxAssetCard);

;// CONCATENATED MODULE: ./components/business-resource-asset-library/components/asset-card-container/asset-card-container.tsx





const AssetCardContainer = (param)=>{
    let { asset  } = param;
    const { assets , setAssets  } = (0,react.useContext)(BusinessResourceAssetLibraryContext);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_asset_card, {
        checked: assets.some((param)=>{
            let { id  } = param;
            return id === asset.id;
        }),
        onChange: ()=>{
            const newAssets = onMultiSelect(asset, assets, "id");
            setAssets === null || setAssets === void 0 ? void 0 : setAssets(newAssets);
        },
        asset: asset,
        AssetCardProps: {
            RatioImageProps: {
                maxHeight: 216,
                minHeight: 120
            }
        }
    });
};
/* harmony default export */ var asset_card_container = (AssetCardContainer);

;// CONCATENATED MODULE: ./components/business-resource-asset-library/business-resource-asset-library.tsx


















const BusinessResourceAssetLibrary = (param)=>{
    let { showDownloadButton , columns , limitRows  } = param;
    const [open, setOpen] = (0,react.useState)(false);
    const [dropdownValue, setDropdownValue] = (0,react.useState)(1);
    const { getFilteredResources , assets , getDownloadAssetResources  } = (0,react.useContext)(BusinessResourceAssetLibraryContext);
    const buttonContainerRef = (0,react.useRef)(null);
    const [lock, setLock] = (0,react.useState)(false);
    const { width  } = (0,useWindowSize/* useWindowSize */.i)();
    const onScroll = (0,react.useCallback)((e)=>{
        if (width && width <= 768) {
            if (buttonContainerRef.current) {
                const { height , y  } = buttonContainerRef.current.getBoundingClientRect();
                const botPosition = height + y;
                if (botPosition <= 0) {
                    setLock(true);
                } else {
                    setLock(false);
                }
            }
        } else {
            setLock(false);
        }
    }, [
        width
    ]);
    (0,react.useEffect)(()=>{
        window.addEventListener("scroll", onScroll);
        return ()=>window.removeEventListener("scroll", onScroll);
    }, [
        width
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_asset_library_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal, {
                actions: /*#__PURE__*/ (0,jsx_runtime.jsxs)(business_resource_download_button, {
                    onClick: ()=>setOpen(false),
                    children: [
                        "Show me what I need ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightMedium/* default */.Z, {})
                    ]
                }),
                onCloseClick: ()=>setOpen(false),
                onEscape: ()=>setOpen(false),
                onOutsideClick: ()=>setOpen(false),
                open: open,
                title: "I'm not sure what I need",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(filter_panel_container, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_resource_asset_library_module_default()).action,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_asset_library_module_default()).leftAction,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(outlined_button, {
                            className: (business_resource_asset_library_module_default()).buttonResponsive,
                            onClick: ()=>setOpen(true),
                            children: [
                                "I'm not sure what I need",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        flexShrink: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_BusinessResourceFilter, {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_asset_library_module_default()).buttonContainer,
                        id: "container",
                        ref: buttonContainerRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()({
                                [(business_resource_asset_library_module_default()).lock]: lock && assets.length
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(business_resource_download_resources_button_container, {
                                resources: getDownloadAssetResources(),
                                rootContainerName: "asset-library",
                                disabled: !assets.length,
                                containerClass: (business_resource_asset_library_module_default()).buttonResponsive,
                                className: classnames_default()((business_resource_asset_library_module_default()).buttonResponsive, {
                                    [(business_resource_asset_library_module_default()).lockedButton]: lock
                                }),
                                mobileFullWidth: true,
                                children: [
                                    "Download Selected ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Download/* default */.Z, {})
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_asset_library_module_default()).tab,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(inlined_multi_select_container, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_asset_library_module_default()).chip,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chips_container, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_asset_grid, {
                renderAssetCard: (asset)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(asset_card_container, {
                        asset: asset
                    }),
                resources: getFilteredResources(),
                columns: columns,
                showDownloadButton: showDownloadButton,
                limitRows: limitRows,
                showDivider: true
            })
        ]
    });
};
const BusinessResourceAssetLibraryContextWrapper = (param)=>{
    let { resources: initResources = [] , ...props } = param;
    const [colors, setColors] = (0,react.useState)([]);
    const [keyMessages, setKeyMessages] = (0,react.useState)([]);
    const [themedAssets, setThemedAssets] = (0,react.useState)([]);
    const [assetTypes, setAssetTypes] = (0,react.useState)([]);
    const [assets, setAssets] = (0,react.useState)([]);
    const resources = (0,react.useMemo)(()=>{
        return initResources === null || initResources === void 0 ? void 0 : initResources.map((resource)=>{
            var ref;
            return {
                ...resource,
                id: Math.random().toString(8),
                assets: (ref = resource.assets) === null || ref === void 0 ? void 0 : ref.map((asset)=>({
                        ...asset,
                        id: Math.random().toString(8)
                    }))
            };
        });
    }, []);
    const getDownloadAssetResources = ()=>{
        return getFilteredResources().map((resource)=>{
            var ref;
            return {
                ...resource,
                assets: (ref = resource.assets) === null || ref === void 0 ? void 0 : ref.filter((asset)=>assets.some((param)=>{
                        let { id  } = param;
                        return id === asset.id;
                    }))
            };
        });
    };
    const getDownloadAssets = (resourceId)=>{
        var ref;
        const resource = resources.find((param)=>{
            let { id  } = param;
            return id === resourceId;
        });
        if (!resource) return [];
        return ((ref = resource.assets) === null || ref === void 0 ? void 0 : ref.filter((asset)=>assets.some((param)=>{
                let { id  } = param;
                return id === asset.id;
            }))) || [];
    };
    const getFilteredResources = ()=>{
        return (resources || []).filter((param)=>{
            let { type  } = param;
            return !type || !assetTypes.length || assetTypes.includes(type);
        }).map((resource)=>{
            var ref;
            return {
                ...resource,
                assets: (ref = resource.assets) === null || ref === void 0 ? void 0 : ref.filter((asset)=>!keyMessages.length || keyMessages.some((k)=>asset.keyMessages && asset.keyMessages.includes(k))).filter((asset)=>!themedAssets.length || themedAssets.some((k)=>asset.themedAssets && asset.themedAssets.includes(k))).map((asset)=>{
                    return {
                        ...asset,
                        variants: asset.variants.filter((variant)=>{
                            return !colors.length || colors.some((color)=>{
                                var ref, ref1;
                                return ((ref = variant.colors) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.color) === color;
                            });
                        })
                    };
                }).filter((param)=>{
                    let { variants  } = param;
                    return variants.length;
                })
            };
        }).filter((param)=>{
            let { assets  } = param;
            return assets === null || assets === void 0 ? void 0 : assets.length;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BusinessResourceAssetLibraryProvider, {
        value: {
            resources,
            colors,
            setColors,
            keyMessages,
            setKeyMessages,
            themedAssets,
            setThemedAssets,
            assetTypes,
            setAssetTypes,
            assets,
            setAssets,
            getDownloadAssetResources,
            getDownloadAssets,
            getFilteredResources
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BusinessResourceAssetLibrary, {
            ...props
        })
    });
};
/* harmony default export */ var business_resource_asset_library = (BusinessResourceAssetLibraryContextWrapper);

;// CONCATENATED MODULE: ./components/business-resource-asset-library/business-resource-asset-library.builder-component.ts


const BusinessResourceAssetBuilderConfig = {
    name: "Resource Asset Library",
    inputs: [
        {
            name: "showDownloadButton",
            type: "boolean"
        },
        {
            name: "columns",
            type: "number"
        },
        {
            name: "limitRows",
            type: "number"
        },
        BuilderHelper/* resourcesInput */.WA
    ]
};
const business_resource_asset_library_builder_component_builderConfig = {
    component: business_resource_asset_library,
    config: BusinessResourceAssetBuilderConfig
};
/* harmony default export */ var business_resource_asset_library_builder_component = (business_resource_asset_library_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-background-text-wrap/business-resource-background-text-wrap.module.scss
var business_resource_background_text_wrap_module = __webpack_require__(38032);
var business_resource_background_text_wrap_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_background_text_wrap_module);
// EXTERNAL MODULE: ./components/copy-button/copy-button.module.scss
var copy_button_module = __webpack_require__(12876);
var copy_button_module_default = /*#__PURE__*/__webpack_require__.n(copy_button_module);
// EXTERNAL MODULE: ./node_modules/react-copy-to-clipboard/lib/index.js
var lib = __webpack_require__(45630);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./components/copy-button/copy-button.tsx







const CopyButton = (param)=>{
    let { content  } = param;
    const [isCopied, setIsCopied] = (0,react.useState)(false);
    const [referenceElement, setReferenceElement] = (0,react.useState)(null);
    const [popperElement, setPopperElement] = (0,react.useState)(null);
    const [arrowElement, setArrowElement] = (0,react.useState)(null);
    const { styles: popperStyles , attributes  } = (0,usePopper/* usePopper */.D)(referenceElement, popperElement, {
        modifiers: [
            {
                name: "arrow",
                options: {
                    element: arrowElement,
                    padding: 5
                }
            }
        ],
        placement: "top",
        strategy: "fixed"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                ref: setPopperElement,
                className: classnames_default()((copy_button_module_default()).tooltip, {
                    [(copy_button_module_default()).visible]: isCopied
                }),
                style: popperStyles.popper,
                ...(attributes === null || attributes === void 0 ? void 0 : attributes.popper) || {},
                children: [
                    "Copied!",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: setArrowElement,
                        className: (copy_button_module_default()).tooltipArrow,
                        style: popperStyles.arrow
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                text: content,
                onCopy: ()=>{
                    setIsCopied(true);
                    setTimeout(()=>{
                        setIsCopied(false);
                    }, 2000);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    ref: setReferenceElement,
                    className: (copy_button_module_default()).copyIcon,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                        type: icons/* IconType.Copy */.T.Copy
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var copy_button = (CopyButton);

;// CONCATENATED MODULE: ./components/business-resource-background-text-wrap/business-resource-background-text-wrap.tsx




const BusinessResourceBackgroundTextWrap = (param)=>{
    let { text , copyableText  } = param;
    if (!text) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_background_text_wrap_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_background_text_wrap_module_default()).text,
                dangerouslySetInnerHTML: {
                    __html: text
                }
            }),
            copyableText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_background_text_wrap_module_default()).copyButton,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(copy_button, {
                    content: copyableText
                })
            })
        ]
    });
};
/* harmony default export */ var business_resource_background_text_wrap = (BusinessResourceBackgroundTextWrap);

;// CONCATENATED MODULE: ./components/business-resource-background-text-wrap/business-resource-background-text-wrap.builder-component.ts

const BusinessResourceBackgroundTextWrapBuilderConfig = {
    name: "Resource Background Text Wrap",
    inputs: [
        {
            name: "text",
            type: "richText"
        },
        {
            name: "copyableText",
            type: "longText"
        }
    ]
};
const business_resource_background_text_wrap_builder_component_builderConfig = {
    component: business_resource_background_text_wrap,
    config: BusinessResourceBackgroundTextWrapBuilderConfig
};
/* harmony default export */ var business_resource_background_text_wrap_builder_component = (business_resource_background_text_wrap_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-banner-carousel/business-resource-banner-carousel.module.scss
var business_resource_banner_carousel_module = __webpack_require__(83202);
var business_resource_banner_carousel_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_banner_carousel_module);
;// CONCATENATED MODULE: ./components/business-resource-banner-carousel/business-resource-banner-carousel.tsx








const business_resource_banner_carousel_options = {
    slidesPerView: "auto",
    spaceBetween: 45,
    allowTouchMove: true
};
const BusinessResourceBannerCarousel = (props)=>{
    const { banners =[] , ctaText  } = props;
    const [loading, setLoading] = (0,react.useState)(false);
    const downloadURLs = [];
    banners.map((banner)=>{
        if (banner.downloadUrl) {
            downloadURLs.push(banner.downloadUrl);
        }
    });
    const onDownloadAll = async ()=>{
        setLoading(true);
        try {
            const items = {
                name: "afterpay-banners",
                type: "banner",
                variants: banners.filter((banner)=>!!banner.downloadUrl).map((banner)=>{
                    return {
                        downloadUrl: banner.downloadUrl,
                        extension: banner.extension,
                        variantName: banner.bannerName
                    };
                })
            };
            await downloadAsset([
                items
            ], "afterpay-banners");
        } catch (ex) {
            console.error(ex);
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((business_resource_banner_carousel_module_default()).container, {
            [(business_resource_banner_carousel_module_default()).withDownloadButton]: (downloadURLs === null || downloadURLs === void 0 ? void 0 : downloadURLs.length) > 0
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (business_resource_banner_carousel_module_default()).content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    ...business_resource_banner_carousel_options,
                    children: banners.map((banner, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: (business_resource_banner_carousel_module_default()).bannerPreview,
                                src: banner.preview,
                                alt: ""
                            })
                        }, index))
                }),
                (downloadURLs === null || downloadURLs === void 0 ? void 0 : downloadURLs.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_resource_banner_carousel_module_default()).download,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(business_resource_download_button, {
                        disabled: loading,
                        onClick: onDownloadAll,
                        children: [
                            ctaText || "Download All Banners",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: icons/* IconType.Download */.T.Download
                            })
                        ]
                    })
                }) : null
            ]
        })
    });
};
/* harmony default export */ var business_resource_banner_carousel = (BusinessResourceBannerCarousel);

;// CONCATENATED MODULE: ./components/business-resource-banner-carousel/business-resource-asset.builder-component.ts

const BusinessResourceBannerCarouselBuilderConfig = {
    name: "Resource Banner Carousel",
    inputs: [
        {
            name: "banners",
            type: "list",
            subFields: [
                {
                    name: "bannerName",
                    type: "string"
                },
                {
                    name: "extension",
                    type: "string"
                },
                {
                    name: "preview",
                    type: "file"
                },
                {
                    name: "downloadUrl",
                    type: "url"
                }
            ]
        },
        {
            name: "ctaText",
            type: "string"
        }
    ]
};
const business_resource_asset_builder_component_builderConfig = {
    component: business_resource_banner_carousel,
    config: BusinessResourceBannerCarouselBuilderConfig
};
/* harmony default export */ var business_resource_asset_builder_component = (business_resource_asset_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-banners/business-resource-banners.module.scss
var business_resource_banners_module = __webpack_require__(98328);
var business_resource_banners_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_banners_module);
// EXTERNAL MODULE: ./components/business-resource-asset-single-variant/business-resource-asset-single-variant.module.scss
var business_resource_asset_single_variant_module = __webpack_require__(41280);
var business_resource_asset_single_variant_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_asset_single_variant_module);
;// CONCATENATED MODULE: ./components/business-resource-asset-single-variant/business-resource-single-asset-variant.tsx






const BusinessResourceSingleAssetVariant = (param)=>{
    let { asset , clickable , onClick , downloadPlacement , ButtonProps ={}  } = param;
    var ref;
    const firstVariant = asset === null || asset === void 0 ? void 0 : (ref = asset.variants) === null || ref === void 0 ? void 0 : ref[0];
    if (!firstVariant) return null;
    const getPlacementClass = ()=>{
        if (downloadPlacement === "center") {
            return (business_resource_asset_single_variant_module_default()).alignCentger;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((business_resource_asset_single_variant_module_default()).root, getPlacementClass()),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_asset_single_variant_module_default()).item,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_download_button, {
                    item: asset,
                    type: "icon",
                    ...ButtonProps,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Download/* default */.Z, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((business_resource_asset_single_variant_module_default()).item, (business_resource_asset_single_variant_module_default()).imageCol, {
                    [(business_resource_asset_single_variant_module_default()).clickable]: clickable
                }),
                onClick: (e)=>{
                    return onClick === null || onClick === void 0 ? void 0 : onClick(asset, e);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: (business_resource_asset_single_variant_module_default()).image,
                    src: firstVariant.previewUrl,
                    alt: ""
                })
            })
        ]
    });
};
/* harmony default export */ var business_resource_single_asset_variant = (BusinessResourceSingleAssetVariant);

;// CONCATENATED MODULE: ./components/business-resource-asset-single-variant/business-resource-single-asset-variant-container.tsx




const BusinessResourceSingleAssetVariantContainer = (param)=>{
    let { asset , ...props } = param;
    const { loading , downloadVariant  } = hook_useDownloadVariant();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_single_asset_variant, {
        ButtonProps: {
            disabled: loading,
            onVariantClick: (variant)=>{
                downloadVariant(asset, variant, "asset");
            }
        },
        asset: asset,
        ...props
    });
};
/* harmony default export */ var business_resource_single_asset_variant_container = (BusinessResourceSingleAssetVariantContainer);

// EXTERNAL MODULE: ./components/business-resource-group-label/business-resource-group-label.module.scss
var business_resource_group_label_module = __webpack_require__(39218);
var business_resource_group_label_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_group_label_module);
;// CONCATENATED MODULE: ./components/business-resource-group-label/business-resource-group-label.tsx




const BusinessResourceGroupLabel = (param)=>{
    let { children , DownloadButtonProps  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_group_label_module_default()).header,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_group_label_module_default()).title,
                children: children
            }),
            DownloadButtonProps && /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_download_button, {
                ...DownloadButtonProps
            })
        ]
    });
};
/* harmony default export */ var business_resource_group_label = (BusinessResourceGroupLabel);

;// CONCATENATED MODULE: ./components/business-resource-group-label/business-resource-group-label-container.tsx




const BusinessResourceGroupLabelContainer = (param)=>{
    let { assets , rootFolderName , DownloadButtonProps ={} , ...props } = param;
    const { loading , downloadAssets  } = hook_useDownloadAssets();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_group_label, {
        DownloadButtonProps: {
            disabled: loading || (DownloadButtonProps === null || DownloadButtonProps === void 0 ? void 0 : DownloadButtonProps.disabled),
            onClick: (e)=>{
                var ref;
                DownloadButtonProps === null || DownloadButtonProps === void 0 ? void 0 : (ref = DownloadButtonProps.onClick) === null || ref === void 0 ? void 0 : ref.call(DownloadButtonProps, e);
                downloadAssets(assets, rootFolderName);
            },
            ...DownloadButtonProps
        },
        ...props
    });
};
/* harmony default export */ var business_resource_group_label_container = (BusinessResourceGroupLabelContainer);

;// CONCATENATED MODULE: ./components/business-resource-banners/business-resource-banners.tsx








const BusinessResourceBanners = (param)=>{
    let { resources  } = param;
    var ref, ref1, ref2, ref3;
    const [selectedAsset, setSelectedAsset] = (0,react.useState)((resources === null || resources === void 0 ? void 0 : (ref = resources[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.assets) === null || ref1 === void 0 ? void 0 : ref1[0]) || null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_banners_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(business_resource_download_resources_button_container, {
                resources: resources || [],
                rootContainerName: "banners",
                children: [
                    "Download All Banners ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Download/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: (business_resource_banners_module_default()).pagePreviewImage,
                    src: selectedAsset === null || selectedAsset === void 0 ? void 0 : (ref2 = selectedAsset.variants) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.pagePreviewImage,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: resources === null || resources === void 0 ? void 0 : resources.map((resource, index)=>{
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_group_label_container, {
                                assets: resource.assets || [],
                                rootFolderName: resource.title || "banner",
                                DownloadButtonProps: {
                                    children: "Download All"
                                },
                                children: resource === null || resource === void 0 ? void 0 : resource.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_resource_banners_module_default()).resourceContainer,
                                children: resource === null || resource === void 0 ? void 0 : (ref = resource.assets) === null || ref === void 0 ? void 0 : ref.map((asset, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_single_asset_variant_container, {
                                        asset: asset,
                                        clickable: true,
                                        onClick: (asset)=>setSelectedAsset(asset)
                                    }, index))
                            }),
                            index !== (resources === null || resources === void 0 ? void 0 : resources.length) - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_divider, {})
                        ]
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var business_resource_banners = (BusinessResourceBanners);

;// CONCATENATED MODULE: ./components/business-resource-banners/business-resource-banners.builder-component.ts

const BusinessResourceBannersBuilderConfig = {
    name: "Resource Banners",
    inputs: [
        {
            name: "resources",
            type: "list",
            copyOnAdd: false,
            subFields: [
                {
                    name: "title",
                    type: "string"
                },
                {
                    name: "assets",
                    type: "list",
                    copyOnAdd: false,
                    subFields: [
                        {
                            name: "name",
                            type: "string"
                        },
                        {
                            name: "keyMessages",
                            type: "Tags"
                        },
                        {
                            name: "themedAssets",
                            type: "Tags"
                        },
                        {
                            name: "variants",
                            type: "list",
                            copyOnAdd: false,
                            subFields: [
                                {
                                    name: "variantName",
                                    type: "string"
                                },
                                {
                                    name: "color",
                                    type: "color"
                                },
                                {
                                    name: "backgroundColor",
                                    type: "color"
                                },
                                {
                                    name: "previewUrl",
                                    type: "url"
                                },
                                {
                                    name: "downloadUrl",
                                    type: "url"
                                },
                                {
                                    name: "extension",
                                    type: "string"
                                },
                                {
                                    name: "pagePreviewImage",
                                    type: "file"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
};
const business_resource_banners_builder_component_builderConfig = {
    component: business_resource_banners,
    config: BusinessResourceBannersBuilderConfig
};
/* harmony default export */ var business_resource_banners_builder_component = (business_resource_banners_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-card/business-resource-card.module.scss
var business_resource_card_module = __webpack_require__(29890);
var business_resource_card_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_card_module);
;// CONCATENATED MODULE: ./components/business-resource-card/business-resource-card.tsx





const ResourceCard = (props)=>{
    const { image , title , description , replaceLocalesOnLink  } = props;
    let url = props.url;
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    if (replaceLocalesOnLink) {
        if ((0,LangHelper/* doesContainLocale */.RO)(url)) {
            url = (0,LangHelper/* replaceLocale */.mC)(url, locale);
        } else {
            url = "/".concat(locale).concat(url);
        }
        url = (0,LangHelper/* localifyLink */.Bj)(url, locale);
    }
    var _buttonLabel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_card_module_default()).businessResourceCardWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_card_module_default()).businessResourceCardBackgroundWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_resource_card_module_default()).businessResourceCardBackgroundBox,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_card_module_default()).businessResourceCardBackground,
                        style: {
                            backgroundImage: "url(".concat(image, ")")
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_resource_card_module_default()).businessResourceCardOverlayWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_card_module_default()).businessResourceCardOverlayTitle,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_card_module_default()).businessResourceCardOverlayDescription,
                        dangerouslySetInnerHTML: {
                            __html: description
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: url,
                        className: (business_resource_card_module_default()).businessResourceCardOverlayCTA,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: (_buttonLabel = props.buttonLabel) !== null && _buttonLabel !== void 0 ? _buttonLabel : "Read more"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: icons/* IconType.ArrowRightSmall */.T.ArrowRightSmall
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var business_resource_card = (ResourceCard);

;// CONCATENATED MODULE: ./components/business-resource-card/business-resource-card.builder-component.ts

const BusinessResourceCardBuilderConfig = {
    name: "Resource Card",
    inputs: [
        {
            name: "image",
            type: "file",
            required: true
        },
        {
            name: "title",
            type: "string",
            defaultValue: "",
            required: true
        },
        {
            name: "description",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "buttonLabel",
            type: "string",
            defaultValue: "Read more"
        },
        {
            name: "url",
            type: "url"
        },
        {
            name: "replaceLocalesOnLink",
            type: "boolean",
            defaultValue: false
        }
    ]
};
const business_resource_card_builder_component_builderConfig = {
    component: business_resource_card,
    config: BusinessResourceCardBuilderConfig
};
/* harmony default export */ var business_resource_card_builder_component = (business_resource_card_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-centre-hero/business-resource-centre-hero.module.scss
var business_resource_centre_hero_module = __webpack_require__(57625);
var business_resource_centre_hero_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_centre_hero_module);
;// CONCATENATED MODULE: ./components/business-resource-centre-hero/business-resource-centre-hero.tsx




const BusinessResourceCentreHero = (props)=>{
    const { title  } = props;
    const Element = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_centre_hero_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_centre_hero_module_default()).background
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_centre_hero_module_default()).content,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_resource_centre_hero_module_default()).title,
                    children: title
                })
            })
        ]
    });
    (0,react.useEffect)(()=>{
        const container = document.getElementById("resource-centre-hero-container");
        if (!container) return;
        container.style.display = "block";
        react_dom.render(Element, container);
        return ()=>{
            container.style.display = "none";
        };
    }, []);
    return null;
};
/* harmony default export */ var business_resource_centre_hero = (BusinessResourceCentreHero);

;// CONCATENATED MODULE: ./components/business-resource-centre-hero/business-resource-centre-hero.builder-component.ts

const BusinessResourceCentreHeroBuilderConfig = {
    name: "Resource Centre Hero",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: ""
        },
        {
            name: "filterTilte",
            type: "string",
            defaultValue: ""
        }
    ]
};
const business_resource_centre_hero_builder_component_builderConfig = {
    component: business_resource_centre_hero,
    config: BusinessResourceCentreHeroBuilderConfig
};
/* harmony default export */ var business_resource_centre_hero_builder_component = (business_resource_centre_hero_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-colour-palette/colour-card/colour-card.module.scss
var colour_card_module = __webpack_require__(8315);
var colour_card_module_default = /*#__PURE__*/__webpack_require__.n(colour_card_module);
;// CONCATENATED MODULE: ./components/business-resource-colour-palette/colour-card/colour-card.tsx







const ColourCard = (props)=>{
    const { colour , name , description , textColor  } = props;
    const [rgbCopied, setRgbCopied] = (0,react.useState)(false);
    const [hexCopied, setHexCopied] = (0,react.useState)(false);
    if (!colour) return null;
    let rgbColor = hexToRgb(colour);
    if (!rgbColor) {
        const rgb = colour.replace(/[^\d,]/g, "").split(",");
        rgbColor = {};
        rgbColor.r = Number.parseInt(rgb[0], 10);
        rgbColor.g = Number.parseInt(rgb[1], 10);
        rgbColor.b = Number.parseInt(rgb[2], 10);
    }
    const hex = rgbToHex(rgbColor.r, rgbColor.g, rgbColor.b);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((colour_card_module_default()).container, {
            [(colour_card_module_default()).bordered]: isWhite(colour)
        }),
        style: {
            backgroundColor: colour
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (colour_card_module_default()).content,
            style: {
                color: textColor
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (colour_card_module_default()).name,
                    children: name
                }),
                description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (colour_card_module_default()).description,
                    children: description
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((colour_card_module_default()).colorCode, {
                        [(colour_card_module_default()).copied]: rgbCopied
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.CopyToClipboard, {
                        text: colour,
                        onCopy: ()=>{
                            setRgbCopied(true);
                            setTimeout(()=>{
                                setRgbCopied(false);
                            }, 3000);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (colour_card_module_default()).copyIcon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                        type: icons/* IconType.Copy */.T.Copy
                                    })
                                }),
                                rgbCopied ? "Copied!" : "RGB ".concat(rgbColor.r, " ").concat(rgbColor.g, " ").concat(rgbColor.b)
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((colour_card_module_default()).colorCode, {
                        [(colour_card_module_default()).copied]: hexCopied
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.CopyToClipboard, {
                        text: hex,
                        onCopy: ()=>{
                            setHexCopied(true);
                            setTimeout(()=>{
                                setHexCopied(false);
                            }, 3000);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (colour_card_module_default()).copyIcon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                        type: icons/* IconType.Copy */.T.Copy
                                    })
                                }),
                                hexCopied ? "Copied!" : "HEX ".concat(hex)
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var colour_card = (ColourCard);

// EXTERNAL MODULE: ./components/business-resource-colour-palette/business-resource-colour-palette.module.scss
var business_resource_colour_palette_module = __webpack_require__(1951);
var business_resource_colour_palette_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_colour_palette_module);
;// CONCATENATED MODULE: ./components/business-resource-colour-palette/business-resource-colour-palette.tsx




const BusinessResourceColourPalette = (props)=>{
    const { layout ="primary" , colours  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((business_resource_colour_palette_module_default()).container, (business_resource_colour_palette_module_default())[layout]),
        children: colours === null || colours === void 0 ? void 0 : colours.map((colour, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(colour_card, {
                ...colour
            }, index))
    });
};
/* harmony default export */ var business_resource_colour_palette = (BusinessResourceColourPalette);

;// CONCATENATED MODULE: ./components/business-resource-colour-palette/business-resource-colour-palette.builder-component.ts

const BusinessResourceColourPaletteBuilderConfig = {
    name: "Resource Colour Palette",
    inputs: [
        {
            name: "layout",
            type: "string",
            defaultValue: "primary",
            enum: [
                "primary",
                "secondary"
            ]
        },
        {
            name: "colours",
            type: "list",
            subFields: [
                {
                    name: "colour",
                    type: "color",
                    required: true
                },
                {
                    name: "name",
                    type: "string",
                    required: true
                },
                {
                    name: "description",
                    type: "string"
                },
                {
                    name: "textColor",
                    type: "color",
                    required: true
                }
            ]
        }
    ]
};
const business_resource_colour_palette_builder_component_builderConfig = {
    component: business_resource_colour_palette,
    config: BusinessResourceColourPaletteBuilderConfig
};
/* harmony default export */ var business_resource_colour_palette_builder_component = (business_resource_colour_palette_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/business-resource-divider/business-resource-divider.builder-component.ts

const BusinessResourceDividerBuilderConfig = {
    name: "Resource Divider",
    inputs: []
};
const business_resource_divider_builder_component_builderConfig = {
    component: business_resource_divider,
    config: BusinessResourceDividerBuilderConfig
};
/* harmony default export */ var business_resource_divider_builder_component = (business_resource_divider_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-download-card/business-resource-download-card.module.scss
var business_resource_download_card_module = __webpack_require__(6703);
var business_resource_download_card_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_download_card_module);
;// CONCATENATED MODULE: ./components/business-resource-download-card/business-resource-download-card.tsx








const BusinessResourceDownloadCard = (props)=>{
    var ref;
    const { item , type , height =128 , hideDowload  } = props;
    const [loading, setLoading] = (0,react.useState)(false);
    if (!item) return null;
    const showingVariant = (ref = item.variants) === null || ref === void 0 ? void 0 : ref[0];
    if (!showingVariant) return null;
    const onClick = async (variant)=>{
        setLoading(true);
        try {
            let asset = item;
            let name;
            if (variant === "ALL") {
                name = "".concat(item.name ? "".concat(item.name) : "") || "afterpay-assets";
            } else {
                name = "".concat(variant.variantName).toLowerCase() || "afterpay-assets";
                asset = {
                    ...item,
                    variants: [
                        variant
                    ]
                };
            }
            await downloadAsset([
                asset
            ], name);
        } catch (ex) {
            console.error(ex);
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((business_resource_download_card_module_default()).container, type && (business_resource_download_card_module_default())[type], {
            [(business_resource_download_card_module_default()).bordered]: isWhite(showingVariant.backgroundColor)
        }),
        style: {
            "--data-min-height": "".concat(height, "px")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_download_card_module_default()).downloadContainer,
                children: hideDowload ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_resource_download_card_module_default()).download,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_download_button, {
                        disabled: loading,
                        type: "icon",
                        item: item,
                        onVariantClick: onClick,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: icons/* IconType.Download */.T.Download
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_download_card_module_default()).box,
                style: {
                    background: showingVariant.backgroundColor
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: showingVariant.previewUrl,
                    alt: ""
                })
            })
        ]
    });
};
/* harmony default export */ var business_resource_download_card = (BusinessResourceDownloadCard);

;// CONCATENATED MODULE: ./components/business-resource-download-card/business-resource-download-card.builder-component.ts

const BusinessResourceDownloadCardBuilderConfig = {
    name: "Resource Download Card",
    inputs: [
        {
            name: "type",
            type: "string",
            defaultValue: "default",
            enum: [
                "large",
                "default"
            ]
        },
        {
            name: "item",
            type: "object",
            subFields: [
                {
                    name: "name",
                    type: "string"
                },
                {
                    name: "variants",
                    type: "list",
                    subFields: [
                        {
                            name: "variantName",
                            type: "string"
                        },
                        {
                            name: "color",
                            type: "color"
                        },
                        {
                            name: "backgroundColor",
                            type: "color",
                            helperText: "Background in the UI. Default is white",
                            defaultValue: "#ffffff"
                        },
                        {
                            name: "extension",
                            helperText: "Example: svg, png, ai, eps,...",
                            type: "string"
                        },
                        {
                            name: "previewUrl",
                            type: "url"
                        },
                        {
                            name: "downloadUrl",
                            type: "url"
                        }
                    ]
                }
            ]
        }
    ]
};
const business_resource_download_card_builder_component_builderConfig = {
    component: business_resource_download_card,
    config: BusinessResourceDownloadCardBuilderConfig
};
/* harmony default export */ var business_resource_download_card_builder_component = (business_resource_download_card_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-download-grid/business-resource-download-grid.module.scss
var business_resource_download_grid_module = __webpack_require__(67820);
var business_resource_download_grid_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_download_grid_module);
;// CONCATENATED MODULE: ./components/business-resource-download-grid/business-resource-download-grid.tsx







const BusinessResourceDownloadGrid = (props)=>{
    const { name , items , columns =3 , cardMinHeight , hideDownloadAll  } = props;
    const [loading, setLoading] = (0,react.useState)(false);
    if (!items) return null;
    const onDownloadAll = async ()=>{
        setLoading(true);
        try {
            await downloadAsset(items, name || "afterpay-assets");
        } catch (ex) {
            console.error(ex);
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_download_grid_module_default()).container,
        style: {
            "--data-grid-cols": columns
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_download_grid_module_default()).box,
                children: items.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_download_card, {
                        item: item,
                        height: cardMinHeight,
                        hideDowload: hideDownloadAll
                    }, "".concat(item.name, "_").concat(item.type, "_").concat(Math.random())))
            }),
            hideDownloadAll ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(business_resource_download_button, {
                containerClass: (business_resource_download_grid_module_default()).downloadButton,
                disabled: loading,
                onClick: onDownloadAll,
                children: [
                    "Download All Versions ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                        type: icons/* IconType.Download */.T.Download
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var business_resource_download_grid = (BusinessResourceDownloadGrid);

;// CONCATENATED MODULE: ./components/business-resource-download-grid/business-resource-download-grid.builder-component.ts

const BusinessResourceDownloadGridBuilderConfig = {
    name: "Resource Download Grid",
    inputs: [
        {
            name: "items",
            type: "list",
            subFields: [
                {
                    name: "name",
                    type: "string"
                },
                {
                    name: "variants",
                    type: "list",
                    subFields: [
                        {
                            name: "variantName",
                            type: "string"
                        },
                        {
                            name: "color",
                            type: "color"
                        },
                        {
                            name: "backgroundColor",
                            type: "color",
                            helperText: "Background in the UI. Default is white",
                            defaultValue: "#ffffff"
                        },
                        {
                            name: "extension",
                            helperText: "Example: svg, png, ai, eps,...",
                            type: "string"
                        },
                        {
                            name: "previewUrl",
                            type: "url"
                        },
                        {
                            name: "downloadUrl",
                            type: "url"
                        }
                    ]
                }
            ]
        }
    ]
};
const business_resource_download_grid_builder_component_builderConfig = {
    component: business_resource_download_grid,
    config: BusinessResourceDownloadGridBuilderConfig
};
/* harmony default export */ var business_resource_download_grid_builder_component = (business_resource_download_grid_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-faq/business-resource-faq.module.scss
var business_resource_faq_module = __webpack_require__(95355);
var business_resource_faq_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_faq_module);
;// CONCATENATED MODULE: ./components/business-resource-faq/business-resource-faq-item.tsx



const business_resource_faq_item_FAQItem = (props)=>{
    const { item  } = props;
    const id = (0,react.useMemo)(()=>"".concat(Math.random()), []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_faq_module_default()).itemContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "checkbox",
                id: id
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (business_resource_faq_module_default()).question,
                htmlFor: id,
                children: item.question
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_faq_module_default()).answer,
                dangerouslySetInnerHTML: {
                    __html: item.answer
                }
            })
        ]
    });
};
/* harmony default export */ var business_resource_faq_item = (business_resource_faq_item_FAQItem);

;// CONCATENATED MODULE: ./components/business-resource-faq/business-resource-faq.tsx



const BusinessResourceFAQ = (props)=>{
    const { faqs  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_resource_faq_module_default()).container,
        children: faqs === null || faqs === void 0 ? void 0 : faqs.map((faq, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_faq_item, {
                item: faq
            }, index))
    });
};
/* harmony default export */ var business_resource_faq = (BusinessResourceFAQ);

;// CONCATENATED MODULE: ./components/business-resource-faq/business-resource-faq.builder-component.ts

const BusinessResourceFAQBuilderConfig = {
    name: "Resource FAQ",
    inputs: [
        {
            name: "faqs",
            type: "list",
            subFields: [
                {
                    name: "question",
                    type: "string"
                },
                {
                    name: "answer",
                    type: "richText"
                }
            ]
        }
    ]
};
const business_resource_faq_builder_component_builderConfig = {
    component: business_resource_faq,
    config: BusinessResourceFAQBuilderConfig
};
/* harmony default export */ var business_resource_faq_builder_component = (business_resource_faq_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/breadcrumb/breadcrumb.tsx + 1 modules
var breadcrumb = __webpack_require__(53431);
// EXTERNAL MODULE: ./components/business-resource-hero-sub/business-resource-hero-sub.module.scss
var business_resource_hero_sub_module = __webpack_require__(73042);
var business_resource_hero_sub_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_hero_sub_module);
;// CONCATENATED MODULE: ./components/business-resource-hero-sub/business-resource-hero-sub.tsx






const ResourceHeroSub = (props)=>{
    const { image , title , description , breadcrumbs  } = props;
    const { width =0  } = (0,useWindowSize/* useWindowSize */.i)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((business_resource_hero_sub_module_default()).businessResourceHeroSubWrapper, {
            [(business_resource_hero_sub_module_default()).breadcrumb]: breadcrumbs && breadcrumbs.length
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_hero_sub_module_default()).businessResourceHeroSubBackgroundWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_resource_hero_sub_module_default()).box,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_hero_sub_module_default()).main,
                        style: {
                            backgroundImage: "url(".concat(image, ")")
                        }
                    })
                })
            }),
            breadcrumbs && breadcrumbs.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_hero_sub_module_default()).businessResourceHeroSubBreadcrumb,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb/* default */.Z, {
                    breadcrumbs: breadcrumbs,
                    type: width > 768 ? "dark" : "light"
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_resource_hero_sub_module_default()).businessResourceHeroSubOverlayWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_hero_sub_module_default()).businessResourceHeroSubOverlayTitle,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_hero_sub_module_default()).businessResourceHeroSubOverlayDescription,
                        dangerouslySetInnerHTML: {
                            __html: description
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var business_resource_hero_sub = (ResourceHeroSub);

;// CONCATENATED MODULE: ./components/business-resource-hero-sub/business-resource-hero-sub.builder-component.ts

const BusinessResourceHeroSubBuilderConfig = {
    name: "Resource Hero - Tight",
    inputs: [
        {
            name: "image",
            type: "file",
            required: true
        },
        {
            name: "title",
            type: "string",
            defaultValue: "",
            required: true
        },
        {
            name: "description",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "buttonLabel",
            type: "string",
            defaultValue: "Read more"
        },
        {
            name: "breadcrumbs",
            type: "list",
            subFields: [
                {
                    name: "name",
                    type: "string",
                    defaultValue: ""
                },
                {
                    name: "link",
                    type: "url",
                    defaultValue: ""
                }
            ]
        }
    ]
};
const business_resource_hero_sub_builder_component_builderConfig = {
    component: business_resource_hero_sub,
    config: BusinessResourceHeroSubBuilderConfig
};
/* harmony default export */ var business_resource_hero_sub_builder_component = (business_resource_hero_sub_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-hiws/business-resource-hiws.module.scss
var business_resource_hiws_module = __webpack_require__(65636);
var business_resource_hiws_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_hiws_module);
;// CONCATENATED MODULE: ./components/business-resource-hiws/business-resource-hiws.tsx






const BusinessResourceHiws = (param)=>{
    let { rows  } = param;
    var ref, ref1, ref2, ref3, ref4;
    const [selectedAsset, setSelectedAsset] = (0,react.useState)((rows === null || rows === void 0 ? void 0 : (ref = rows[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.assets) === null || ref1 === void 0 ? void 0 : ref1[0]) || null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_hiws_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(business_resource_download_assets_button_container, {
                assets: (rows === null || rows === void 0 ? void 0 : rows.reduce((result, param)=>{
                    let { assets  } = param;
                    return result.concat(assets || []);
                }, [])) || [],
                rootContainerName: "how-it-works",
                children: [
                    "Download All How It Works ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Download/* default */.Z, {})
                ]
            }),
            rows === null || rows === void 0 ? void 0 : (ref2 = rows.map) === null || ref2 === void 0 ? void 0 : ref2.call(rows, (row, index)=>{
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                    className: (business_resource_hiws_module_default()).resourceContainer,
                    children: row === null || row === void 0 ? void 0 : (ref = row.assets) === null || ref === void 0 ? void 0 : ref.map((asset, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_single_asset_variant_container, {
                            asset: asset,
                            clickable: true,
                            onClick: (asset)=>setSelectedAsset(asset)
                        }, index))
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: (business_resource_hiws_module_default()).pagePreviewImage,
                    src: selectedAsset === null || selectedAsset === void 0 ? void 0 : (ref3 = selectedAsset.variants) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.pagePreviewImage,
                    alt: ""
                })
            })
        ]
    });
};
/* harmony default export */ var business_resource_hiws = (BusinessResourceHiws);

;// CONCATENATED MODULE: ./components/business-resource-hiws/business-resource-hiws.builder-component.ts

const BusinessResourceHIWsBuilderConfig = {
    name: "Resource How It Works",
    inputs: [
        {
            name: "rows",
            type: "list",
            subFields: [
                {
                    name: "assets",
                    type: "list",
                    copyOnAdd: false,
                    subFields: [
                        {
                            name: "name",
                            type: "string"
                        },
                        {
                            name: "variants",
                            type: "list",
                            copyOnAdd: false,
                            subFields: [
                                {
                                    name: "variantName",
                                    type: "string"
                                },
                                {
                                    name: "previewUrl",
                                    type: "url"
                                },
                                {
                                    name: "downloadUrl",
                                    type: "url"
                                },
                                {
                                    name: "extension",
                                    type: "string"
                                },
                                {
                                    name: "pagePreviewImage",
                                    type: "file"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
};
const business_resource_hiws_builder_component_builderConfig = {
    component: business_resource_hiws,
    config: BusinessResourceHIWsBuilderConfig
};
/* harmony default export */ var business_resource_hiws_builder_component = (business_resource_hiws_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-image-carousel/business-resource-image-carousel.module.scss
var business_resource_image_carousel_module = __webpack_require__(24083);
var business_resource_image_carousel_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_image_carousel_module);
;// CONCATENATED MODULE: ./components/business-resource-image-carousel/business-resource-image-carousel.tsx







const getDefaultString = (defaultValue, value)=>{
    if (!value) return defaultValue;
    return value;
};
const getDefaultNumber = (defaultValue, value)=>{
    if (typeof value === "number") {
        return value;
    }
    return defaultValue;
};
const BusinessResourceImageCarousel = (param)=>{
    let { images =[] , spaceBetween: rawSpaceBetween , itemWidth: rawItemWidth , responsive =[]  } = param;
    let itemWidth = getDefaultString("auto", rawItemWidth);
    const spaceBetween = getDefaultNumber(undefined, rawSpaceBetween);
    const { width =0  } = (0,useWindowSize/* useWindowSize */.i)();
    const { ref , inView  } = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true
    });
    const [swiper, setSwiper] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (swiper && inView) {
            swiper.init();
        }
    }, [
        swiper,
        inView
    ]);
    const getWidth = ()=>{
        let w = itemWidth;
        let currentBreakpoint = 0;
        responsive === null || responsive === void 0 ? void 0 : responsive.forEach((param)=>{
            let { breakpoint: rawBreakPoint , itemWidth  } = param;
            const breakpoint = getDefaultNumber(0, rawBreakPoint);
            if (width >= breakpoint && breakpoint >= currentBreakpoint && itemWidth) {
                currentBreakpoint = breakpoint;
                w = itemWidth;
            }
        });
        return w;
    };
    const getBreakpoints = ()=>{
        if (!responsive) return undefined;
        return responsive.reduce((result, param)=>{
            let { breakpoint , spaceBetween  } = param;
            if (!breakpoint) return result;
            result[breakpoint] = result[breakpoint] || {};
            if (spaceBetween !== undefined) {
                result[breakpoint].spaceBetween = spaceBetween;
            }
            return result;
        }, {});
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_resource_image_carousel_module_default()).root,
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
            breakpoints: getBreakpoints(),
            spaceBetween: spaceBetween,
            slidesPerView: "auto",
            init: false,
            onSwiper: (sw)=>{
                setSwiper(sw);
            },
            children: images === null || images === void 0 ? void 0 : images.map((param, index)=>/*#__PURE__*/ {
                let { image  } = param;
                return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    style: {
                        width: getWidth()
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (business_resource_image_carousel_module_default()).image,
                        src: image
                    })
                }, index);
            })
        })
    });
};
/* harmony default export */ var business_resource_image_carousel = (BusinessResourceImageCarousel);

;// CONCATENATED MODULE: ./components/business-resource-image-carousel/business-resource-image-carousel.builder-component.ts

const sliderConfig = [
    {
        name: "itemWidth",
        type: "string",
        helperText: 'Should be number or "auto"'
    },
    {
        name: "spaceBetween",
        type: "number"
    }
];
const BusinessResourceImageCarouselConfig = {
    name: "Resource Image Carousel",
    inputs: [
        {
            name: "images",
            type: "list",
            copyOnAdd: false,
            subFields: [
                {
                    name: "image",
                    type: "file"
                }
            ]
        },
        ...sliderConfig,
        {
            name: "responsive",
            type: "list",
            copyOnAdd: false,
            subFields: [
                {
                    name: "breakpoint",
                    type: "number"
                },
                ...sliderConfig
            ]
        }
    ]
};
const business_resource_image_carousel_builder_component_builderConfig = {
    component: business_resource_image_carousel,
    config: BusinessResourceImageCarouselConfig
};
/* harmony default export */ var business_resource_image_carousel_builder_component = (business_resource_image_carousel_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-image-comparison-slider/business-resource-image-comparison-slider.module.scss
var business_resource_image_comparison_slider_module = __webpack_require__(45765);
var business_resource_image_comparison_slider_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_image_comparison_slider_module);
;// CONCATENATED MODULE: ./components/business-resource-image-comparison-slider/image-comparison-slider.utils.ts
function compareImages(img, sliderId, sliderClassName) {
    let slider;
    // let img;
    let clicked = 0;
    let w;
    let h;
    /* Get the width and height of the img element */ w = img.offsetWidth;
    h = img.offsetHeight;
    console.log("w", w);
    /* Set the width of the img element to 50%: */ img.style.width = w / 2 + "px";
    /* Create slider: */ slider = document.getElementById(sliderId);
    if (slider) {
        slider.remove();
    }
    slider = document.createElement("div");
    slider.appendChild(document.createElement("div"));
    slider.setAttribute("class", sliderClassName);
    slider.setAttribute("id", sliderId);
    /* Insert slider */ img.parentElement.insertBefore(slider, img);
    /* Position the slider in the middle: */ slider.style.top = h / 2 - slider.offsetHeight / 2 + "px";
    slider.style.left = w / 2 - slider.offsetWidth / 2 + "px";
    /* Execute a function when the mouse button is pressed: */ slider.addEventListener("mousedown", slideReady);
    /* And another function when the mouse button is released: */ window.addEventListener("mouseup", slideFinish);
    /* Or touched (for touch screens: */ slider.addEventListener("touchstart", slideReady);
    /* And released (for touch screens: */ window.addEventListener("touchend", slideFinish);
    function slideReady(e) {
        /* Prevent any other actions that may occur when moving over the image: */ e.preventDefault();
        /* The slider is now clicked and ready to move: */ clicked = 1;
        /* Execute a function when the slider is moved: */ window.addEventListener("mousemove", slideMove);
        window.addEventListener("touchmove", slideMove);
    }
    function slideFinish() {
        /* The slider is no longer clicked: */ clicked = 0;
    }
    function slideMove(e) {
        var pos;
        /* If the slider is no longer clicked, exit this function: */ if (clicked == 0) return false;
        /* Get the cursor's x position: */ pos = getCursorPos(e);
        /* Prevent the slider from being positioned outside the image: */ if (pos < 0) pos = 0;
        if (pos > w) pos = w;
        /* Execute a function that will resize the overlay image according to the cursor: */ slide(pos);
    }
    function getCursorPos(e) {
        var a, x = 0;
        e = e.changedTouches ? e.changedTouches[0] : e;
        /* Get the x positions of the image: */ a = img.getBoundingClientRect();
        /* Calculate the cursor's x coordinate, relative to the image: */ x = e.pageX - a.left;
        /* Consider any page scrolling: */ x = x - window.pageXOffset;
        return x;
    }
    function slide(x) {
        /* Resize the image: */ img.style.width = x + "px";
        /* Position the slider: */ slider.style.left = img.offsetWidth - slider.offsetWidth / 2 + "px";
    }
}

;// CONCATENATED MODULE: ./components/business-resource-image-comparison-slider/business-resource-image-comparison-slider.tsx






const BusinessResourceImageComparisonSlider = (props)=>{
    var ref;
    const { title , leftImage , rightImage  } = props;
    const containerRef = (0,react.useRef)(null);
    const containerWidth = (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect().width;
    const imgCompSliderId = (0,react.useMemo)(()=>"".concat(Math.random()), []);
    const { width  } = (0,useWindowSize/* useWindowSize */.i)();
    const lastWindowWidth = (0,react.useRef)();
    (0,react.useEffect)(()=>{
        var ref, ref1;
        if (!containerRef.current) return;
        const elemements = (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.getElementsByClassName((business_resource_image_comparison_slider_module_default()).imgCompOverlay);
        (ref1 = containerRef.current) === null || ref1 === void 0 ? void 0 : ref1.getElementsByClassName;
        const isWindowResize = lastWindowWidth.current !== undefined && width !== undefined && lastWindowWidth.current !== width;
        for(let i = 0; i < elemements.length; i++){
            const imgElement = elemements[i];
            if (isWindowResize) {
                imgElement.style.width = containerWidth + "px";
            }
            compareImages(imgElement, imgCompSliderId, (business_resource_image_comparison_slider_module_default()).imgCompSlider);
        }
        lastWindowWidth.current = width;
        return ()=>{
            var ref;
            (ref = document.getElementById(imgCompSliderId)) === null || ref === void 0 ? void 0 : ref.remove();
        };
    }, [
        containerWidth,
        width
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: containerRef,
        className: (business_resource_image_comparison_slider_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_image_comparison_slider_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_resource_image_comparison_slider_module_default()).sliderContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_resource_image_comparison_slider_module_default()).img,
                        style: {
                            width: containerWidth
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_resource_image_comparison_slider_module_default()).mask
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: rightImage,
                                style: {
                                    width: containerWidth
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_resource_image_comparison_slider_module_default())["do"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Do"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((business_resource_image_comparison_slider_module_default()).img, (business_resource_image_comparison_slider_module_default()).imgCompOverlay),
                        style: {
                            width: containerWidth
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_resource_image_comparison_slider_module_default()).mask
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: leftImage,
                                style: {
                                    width: containerWidth
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_resource_image_comparison_slider_module_default()).dont,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Don't"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var business_resource_image_comparison_slider = (BusinessResourceImageComparisonSlider);

;// CONCATENATED MODULE: ./components/business-resource-image-comparison-slider/business-resource-image-comparison-slider.builder-component.ts

const BusinessResourceImageComparisonSliderBuilderConfig = {
    name: "Resource Image Comparison Slider",
    inputs: [
        {
            name: "title",
            type: "string"
        },
        {
            name: "leftImage",
            type: "file",
            required: true
        },
        {
            name: "rightImage",
            type: "file",
            required: true
        }
    ]
};
const business_resource_image_comparison_slider_builder_component_builderConfig = {
    component: business_resource_image_comparison_slider,
    config: BusinessResourceImageComparisonSliderBuilderConfig
};
/* harmony default export */ var business_resource_image_comparison_slider_builder_component = (business_resource_image_comparison_slider_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-in-situ/business-resource-in-situ.module.scss
var business_resource_in_situ_module = __webpack_require__(94993);
var business_resource_in_situ_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_in_situ_module);
;// CONCATENATED MODULE: ./components/business-resource-in-situ/business-resource-in-situ.tsx








const BusinessResourceInSitu = (param)=>{
    let { sections =[]  } = param;
    const showDownloadButton = (downloadButton)=>{
        return !!(downloadButton === null || downloadButton === void 0 ? void 0 : downloadButton.assets) && !!downloadButton.assets.length;
    };
    const showViewMoreButton = (moreButton)=>{
        return !!(moreButton === null || moreButton === void 0 ? void 0 : moreButton.url);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_resource_in_situ_module_default()).root,
        children: sections === null || sections === void 0 ? void 0 : sections.map((param, index)=>{
            let { title , previewPages =[] , downloadButton , moreButton  } = param;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_resource_in_situ_module_default()).section,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_resource_in_situ_module_default()).title,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_resource_in_situ_module_default()).previewContainer,
                                children: previewPages === null || previewPages === void 0 ? void 0 : previewPages.map((param, index)=>/*#__PURE__*/ {
                                    let { previewImage , name  } = param;
                                    return (0,jsx_runtime.jsxs)("div", {
                                        className: (business_resource_in_situ_module_default()).previewBlock,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (business_resource_in_situ_module_default()).previewTitle,
                                                children: name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: (business_resource_in_situ_module_default()).previewImage,
                                                src: previewImage
                                            })
                                        ]
                                    }, index);
                                })
                            }),
                            (showDownloadButton(downloadButton) || showViewMoreButton(moreButton)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (business_resource_in_situ_module_default()).action,
                                children: [
                                    showDownloadButton(downloadButton) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(business_resource_download_assets_button_container, {
                                        assets: (downloadButton === null || downloadButton === void 0 ? void 0 : downloadButton.assets) || [],
                                        rootContainerName: title || "in-situ",
                                        containerClass: (business_resource_in_situ_module_default()).mobileFullWidth,
                                        className: (business_resource_in_situ_module_default()).mobileFullWidth,
                                        children: [
                                            downloadButton === null || downloadButton === void 0 ? void 0 : downloadButton.text,
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Download/* default */.Z, {})
                                        ]
                                    }),
                                    showViewMoreButton(moreButton) && /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_link_button, {
                                        className: (business_resource_in_situ_module_default()).mobileFullWidth,
                                        strong: true,
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightMedium/* default */.Z, {}),
                                        children: moreButton === null || moreButton === void 0 ? void 0 : moreButton.text
                                    })
                                ]
                            })
                        ]
                    }, index),
                    index !== (sections === null || sections === void 0 ? void 0 : sections.length) - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_divider, {})
                ]
            });
        })
    });
};
/* harmony default export */ var business_resource_in_situ = (BusinessResourceInSitu);

;// CONCATENATED MODULE: ./components/business-resource-in-situ/business-resource-in-situ.builder-component.ts

const BusinessResourceInSituConfig = {
    name: "Resource In Situ",
    inputs: [
        {
            name: "sections",
            type: "list",
            copyOnAdd: false,
            subFields: [
                {
                    name: "title",
                    type: "string"
                },
                {
                    name: "previewPages",
                    type: "list",
                    copyOnAdd: false,
                    subFields: [
                        {
                            name: "name",
                            type: "string"
                        },
                        {
                            name: "previewImage",
                            type: "file"
                        }
                    ]
                },
                {
                    name: "downloadButton",
                    type: "object",
                    subFields: [
                        {
                            name: "text",
                            type: "string"
                        },
                        {
                            name: "assets",
                            type: "list",
                            copyOnAdd: false,
                            subFields: [
                                {
                                    name: "name",
                                    type: "string"
                                },
                                // {
                                //     name: 'keyMessages',
                                //     type: 'Tags',
                                // },
                                // {
                                //     name: 'themedAssets',
                                //     type: 'Tags',
                                // },
                                {
                                    name: "variants",
                                    type: "list",
                                    copyOnAdd: false,
                                    subFields: [
                                        {
                                            name: "variantName",
                                            type: "string"
                                        },
                                        // {
                                        //     name: 'color',
                                        //     type: 'color',
                                        // },
                                        // {
                                        //     name: 'backgroundColor',
                                        //     type: 'color',
                                        // },
                                        // {
                                        //     name: 'previewUrl',
                                        //     type: 'url',
                                        // },
                                        {
                                            name: "downloadUrl",
                                            type: "url"
                                        },
                                        {
                                            name: "extension",
                                            type: "string"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name: "moreButton",
                    type: "object",
                    subFields: [
                        {
                            name: "text",
                            type: "string"
                        },
                        {
                            name: "url",
                            type: "url"
                        }
                    ]
                }
            ]
        }
    ]
};
const business_resource_in_situ_builder_component_builderConfig = {
    component: business_resource_in_situ,
    config: BusinessResourceInSituConfig
};
/* harmony default export */ var business_resource_in_situ_builder_component = (business_resource_in_situ_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-lightbox/business-resource-lightbox.module.scss
var business_resource_lightbox_module = __webpack_require__(34405);
var business_resource_lightbox_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_lightbox_module);
;// CONCATENATED MODULE: ./components/business-resource-lightbox/business-resource-lightbox.tsx






const BusinessResourceLightbox = (param)=>{
    let { assets  } = param;
    var ref, ref1;
    const [selectedAsset, setSelectedAsset] = (0,react.useState)((assets === null || assets === void 0 ? void 0 : assets[0]) || null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_lightbox_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(business_resource_download_assets_button_container, {
                assets: assets || [],
                rootContainerName: "lightbox",
                children: [
                    "Download All Lightbox ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Download/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: (business_resource_lightbox_module_default()).pagePreviewImage,
                    src: selectedAsset === null || selectedAsset === void 0 ? void 0 : (ref = selectedAsset.variants) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.pagePreviewImage,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_lightbox_module_default()).resourceContainer,
                children: assets === null || assets === void 0 ? void 0 : assets.map((asset, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_single_asset_variant_container, {
                        asset: asset,
                        clickable: true,
                        onClick: (asset)=>setSelectedAsset(asset)
                    }, index))
            })
        ]
    });
};
/* harmony default export */ var business_resource_lightbox = (BusinessResourceLightbox);

;// CONCATENATED MODULE: ./components/business-resource-lightbox/business-resource-lightbox.builder-component.ts

const BusinessResourceLightboxBuilderConfig = {
    name: "Resource Lightbox",
    inputs: [
        {
            name: "assets",
            type: "list",
            copyOnAdd: false,
            subFields: [
                {
                    name: "name",
                    type: "string"
                },
                {
                    name: "variants",
                    type: "list",
                    copyOnAdd: false,
                    subFields: [
                        {
                            name: "variantName",
                            type: "string"
                        },
                        {
                            name: "previewUrl",
                            type: "url"
                        },
                        {
                            name: "downloadUrl",
                            type: "url"
                        },
                        {
                            name: "pagePreviewImage",
                            type: "file"
                        },
                        {
                            name: "extension",
                            type: "string"
                        }
                    ]
                }
            ]
        }
    ]
};
const business_resource_lightbox_builder_component_builderConfig = {
    component: business_resource_lightbox,
    config: BusinessResourceLightboxBuilderConfig
};
/* harmony default export */ var business_resource_lightbox_builder_component = (business_resource_lightbox_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-logo-usage/business-resource-logo-usage.module.scss
var business_resource_logo_usage_module = __webpack_require__(61073);
var business_resource_logo_usage_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_logo_usage_module);
// EXTERNAL MODULE: ./components/business-resource-logo-usage/logo-usage-card/logo-usage-card.module.scss
var logo_usage_card_module = __webpack_require__(50955);
var logo_usage_card_module_default = /*#__PURE__*/__webpack_require__.n(logo_usage_card_module);
;// CONCATENATED MODULE: ./components/business-resource-logo-usage/logo-usage-card/logo-usage-card.tsx


const LogoUsageCard = (param)=>{
    let { item  } = param;
    const { title , image  } = item;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (logo_usage_card_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (logo_usage_card_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (logo_usage_card_module_default()).image,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: image,
                    alt: ""
                })
            })
        ]
    });
};
/* harmony default export */ var logo_usage_card = (LogoUsageCard);

;// CONCATENATED MODULE: ./components/business-resource-logo-usage/business-resource-logo-usage.tsx



const BusinessResourceLogoUsage = (param)=>{
    let { items  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_resource_logo_usage_module_default()).container,
        children: items === null || items === void 0 ? void 0 : items.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(logo_usage_card, {
                item: item
            }, item.image))
    });
};
/* harmony default export */ var business_resource_logo_usage = (BusinessResourceLogoUsage);

;// CONCATENATED MODULE: ./components/business-resource-logo-usage/business-resource-logo-usage.builder-component.ts

const BusinessResourceLogoUsageBuilderConfig = {
    name: "Resource Logo Usage",
    inputs: [
        {
            name: "items",
            type: "list",
            subFields: [
                {
                    name: "title",
                    type: "text"
                },
                {
                    name: "image",
                    type: "file",
                    required: true
                }
            ]
        }
    ]
};
const business_resource_logo_usage_builder_component_builderConfig = {
    component: business_resource_logo_usage,
    config: BusinessResourceLogoUsageBuilderConfig
};
/* harmony default export */ var business_resource_logo_usage_builder_component = (business_resource_logo_usage_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-text-wrap/business-resource-text-wrap.module.scss
var business_resource_text_wrap_module = __webpack_require__(4709);
var business_resource_text_wrap_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_text_wrap_module);
;// CONCATENATED MODULE: ./components/business-resource-text-wrap/business-resource-text-wrap.tsx




const BusinessResourceTextWrap = (param)=>{
    let { caption , content , size ="default" , row , textAlign ="left"  } = param;
    if (!caption && !content) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((business_resource_text_wrap_module_default()).root, (business_resource_text_wrap_module_default())[textAlign], {
            [(business_resource_text_wrap_module_default()).row]: row
        }),
        children: [
            caption && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((business_resource_text_wrap_module_default()).caption, (business_resource_text_wrap_module_default())[size]),
                dangerouslySetInnerHTML: {
                    __html: caption
                }
            }),
            content && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((business_resource_text_wrap_module_default()).content, (business_resource_text_wrap_module_default())[size]),
                dangerouslySetInnerHTML: {
                    __html: content
                }
            })
        ]
    });
};
/* harmony default export */ var business_resource_text_wrap = (BusinessResourceTextWrap);

// EXTERNAL MODULE: ./components/business-resource-logos/business-resource-logos.module.scss
var business_resource_logos_module = __webpack_require__(17080);
var business_resource_logos_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_logos_module);
;// CONCATENATED MODULE: ./components/business-resource-logos/business-resource-logos.v2.tsx








const BusinessResourceLogosV2 = (props)=>{
    const { downloadAllText ="Download logos" , resources , loading , onDownload  } = props;
    const { width =0  } = (0,useWindowSize/* useWindowSize */.i)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((business_resource_logos_module_default()).root, (business_resource_logos_module_default()).v2),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_download_button, {
                containerClass: classnames_default()((business_resource_logos_module_default()).downloadButton, (business_resource_logos_module_default()).v2),
                onClick: onDownload,
                disabled: loading,
                children: downloadAllText
            }),
            resources === null || resources === void 0 ? void 0 : resources.map((resource, index)=>{
                const { id , title , description , description2 , assets  } = resource;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_divider, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (business_resource_logos_module_default()).textContent,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_text_wrap, {
                                    size: "small",
                                    caption: title,
                                    textAlign: width > 768 ? "center" : "left"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_text_wrap, {
                                    size: "large",
                                    content: description,
                                    textAlign: width > 768 ? "center" : "left"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_text_wrap, {
                                    size: "large",
                                    content: description2,
                                    textAlign: width > 768 ? "center" : "left"
                                })
                            ]
                        }),
                        (assets === null || assets === void 0 ? void 0 : assets.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_download_grid, {
                            name: resource.type,
                            items: assets,
                            columns: 2,
                            cardMinHeight: 205,
                            hideDownloadAll: true
                        }) : null
                    ]
                }, id || Math.random());
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_download_button, {
                containerClass: classnames_default()((business_resource_logos_module_default()).downloadButton),
                onClick: onDownload,
                disabled: loading,
                children: downloadAllText
            })
        ]
    });
};
/* harmony default export */ var business_resource_logos_v2 = (BusinessResourceLogosV2);

;// CONCATENATED MODULE: ./components/business-resource-logos/business-resource-logos.tsx












const BusinessResourceLogos = (props)=>{
    const { downloadAllText ="Download logos" , layoutV2 , resources  } = props;
    const [loading, setLoading] = (0,react.useState)(false);
    const { width =0  } = (0,useWindowSize/* useWindowSize */.i)();
    const handleDownloadAll = async ()=>{
        setLoading(true);
        try {
            const assets = [];
            resources === null || resources === void 0 ? void 0 : resources.forEach((resource)=>assets.push(...resource.assets || []));
            if (assets.length > 0) {
                await downloadAsset(assets, "Logos");
            }
        } catch (ex) {
            console.error(ex);
        } finally{
            setLoading(false);
        }
    };
    if (layoutV2) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_logos_v2, {
            downloadAllText: downloadAllText,
            resources: resources,
            loading: loading,
            onDownload: handleDownloadAll
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(business_resource_download_button, {
                containerClass: (business_resource_logos_module_default()).downloadButton,
                onClick: handleDownloadAll,
                disabled: loading,
                children: [
                    downloadAllText,
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                        type: icons/* IconType.Download */.T.Download
                    })
                ]
            }),
            width > 768 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_divider, {}) : null,
            resources === null || resources === void 0 ? void 0 : resources.map((resource, index)=>{
                const { id , title , description , description2 , assets  } = resource;
                const largeAsset = assets === null || assets === void 0 ? void 0 : assets[0];
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        width > 768 && index !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_divider, {}) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_text_wrap, {
                            caption: title,
                            content: description
                        }),
                        largeAsset ? /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_download_card, {
                            item: largeAsset,
                            type: "large"
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_text_wrap, {
                            content: description2
                        }),
                        (assets === null || assets === void 0 ? void 0 : assets.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_download_grid, {
                            name: resource.type,
                            items: assets.slice(1, assets.length)
                        }) : null
                    ]
                }, id || Math.random());
            })
        ]
    });
};
/* harmony default export */ var business_resource_logos = (BusinessResourceLogos);

;// CONCATENATED MODULE: ./components/business-resource-logos/business-resource-logos.builder-component.ts


const BusinessResourceLogosBuilderConfig = {
    name: "Resource Logos",
    inputs: [
        {
            name: "downloadAllText",
            type: "string",
            defaultValue: "Download logos"
        },
        {
            name: "layoutV2",
            type: "boolean"
        },
        BuilderHelper/* resourcesInput */.WA
    ]
};
const business_resource_logos_builder_component_builderConfig = {
    component: business_resource_logos,
    config: BusinessResourceLogosBuilderConfig
};
/* harmony default export */ var business_resource_logos_builder_component = (business_resource_logos_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-messaging/business-resource-messaging.module.scss
var business_resource_messaging_module = __webpack_require__(68861);
var business_resource_messaging_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_messaging_module);
;// CONCATENATED MODULE: ./components/business-resource-messaging/business-resource-messaging.tsx







const BusinessResourceMessaging = (props)=>{
    const { content  } = props;
    const [isCopied, setIsCopied] = (0,react.useState)(false);
    const [plainText, setPlainText] = (0,react.useState)("");
    const [referenceElement, setReferenceElement] = (0,react.useState)(null);
    const [popperElement, setPopperElement] = (0,react.useState)(null);
    const [arrowElement, setArrowElement] = (0,react.useState)(null);
    const { styles: popperStyles , attributes  } = (0,usePopper/* usePopper */.D)(referenceElement, popperElement, {
        modifiers: [
            {
                name: "arrow",
                options: {
                    element: arrowElement,
                    padding: 5
                }
            }
        ],
        placement: "top",
        strategy: "fixed"
    });
    (0,react.useEffect)(()=>{
        const tempDivElement = document.createElement("div");
        tempDivElement.innerHTML = content;
        setPlainText(tempDivElement.textContent || tempDivElement.innerText || "");
    }, [
        content
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
        text: plainText,
        onCopy: ()=>{
            setIsCopied(true);
            setTimeout(()=>{
                setIsCopied(false);
            }, 2000);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (business_resource_messaging_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    dangerouslySetInnerHTML: {
                        __html: content
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    ref: setPopperElement,
                    className: classnames_default()((business_resource_messaging_module_default()).tooltip, {
                        [(business_resource_messaging_module_default()).visible]: isCopied
                    }),
                    style: popperStyles.popper,
                    ...(attributes === null || attributes === void 0 ? void 0 : attributes.popper) || {},
                    children: [
                        "Copied!",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: setArrowElement,
                            className: (business_resource_messaging_module_default()).tooltipArrow,
                            style: popperStyles.arrow
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    ref: setReferenceElement,
                    className: (business_resource_messaging_module_default()).copyIcon,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                        type: icons/* IconType.Copy */.T.Copy
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var business_resource_messaging = (BusinessResourceMessaging);

;// CONCATENATED MODULE: ./components/business-resource-messaging/business-resource-messaging.builder-component.ts

const BusinessResourceMessagingBuilderConfig = {
    name: "Resource Messaging",
    inputs: [
        {
            name: "content",
            type: "richText"
        }
    ]
};
const business_resource_messaging_builder_component_builderConfig = {
    component: business_resource_messaging,
    config: BusinessResourceMessagingBuilderConfig
};
/* harmony default export */ var business_resource_messaging_builder_component = (business_resource_messaging_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-page-title/business-resource-page-title.module.scss
var business_resource_page_title_module = __webpack_require__(57739);
var business_resource_page_title_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_page_title_module);
;// CONCATENATED MODULE: ./components/business-resource-page-title/business-resource-page-title.tsx




const BusinessResourcePageTitle = (param)=>{
    let { title , introduction , responsive  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_page_title_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_page_title_module_default()).title,
                dangerouslySetInnerHTML: {
                    __html: title
                }
            }),
            introduction && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((business_resource_page_title_module_default()).introduction, {
                    [(business_resource_page_title_module_default()).responsive]: responsive
                }),
                dangerouslySetInnerHTML: {
                    __html: introduction
                }
            })
        ]
    });
};
/* harmony default export */ var business_resource_page_title = (BusinessResourcePageTitle);

;// CONCATENATED MODULE: ./components/business-resource-page-title/business-resource-page-title.builder-component.ts

const BusinessResourcePageTitleBuilderConfig = {
    name: "Resource Page Title",
    inputs: [
        {
            name: "responsive",
            type: "boolean"
        },
        {
            name: "title",
            type: "richText"
        },
        {
            name: "introduction",
            type: "richText"
        }
    ]
};
const business_resource_page_title_builder_component_builderConfig = {
    component: business_resource_page_title,
    config: BusinessResourcePageTitleBuilderConfig
};
/* harmony default export */ var business_resource_page_title_builder_component = (business_resource_page_title_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-price-breakdown/business-resource-price-breakdown.module.scss
var business_resource_price_breakdown_module = __webpack_require__(89421);
var business_resource_price_breakdown_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_price_breakdown_module);
;// CONCATENATED MODULE: ./components/business-resource-price-breakdown/business-resource-price-breakdown.tsx




const BusinessResourcePriceBreakdown = (props)=>{
    const { priceText , position  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((business_resource_price_breakdown_module_default()).container, {
            [(business_resource_price_breakdown_module_default()).reversed]: position === "right"
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_price_breakdown_module_default()).priceText,
                children: priceText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_price_breakdown_module_default()).badge,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                    type: icons/* IconType.AfterpayBadge */.T.AfterpayBadge
                })
            })
        ]
    });
};
/* harmony default export */ var business_resource_price_breakdown = (BusinessResourcePriceBreakdown);

;// CONCATENATED MODULE: ./components/business-resource-price-breakdown/business-resource-price-breakdown.builder-component.ts

const BusinessResourcePriceBreakdownBuilderConfig = {
    name: "Resource Price Breakdown",
    inputs: [
        {
            name: "priceText",
            type: "string",
            defaultValue: ""
        },
        {
            name: "position",
            type: "string",
            defaultValue: "left",
            enum: [
                "left",
                "right"
            ]
        }
    ]
};
const business_resource_price_breakdown_builder_component_builderConfig = {
    component: business_resource_price_breakdown,
    config: BusinessResourcePriceBreakdownBuilderConfig
};
/* harmony default export */ var business_resource_price_breakdown_builder_component = (business_resource_price_breakdown_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-related/business-resource-related-item/business-resource-related-item.module.scss
var business_resource_related_item_module = __webpack_require__(77663);
var business_resource_related_item_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_related_item_module);
;// CONCATENATED MODULE: ./components/business-resource-related/business-resource-related-item/business-image-grid-slider-item.tsx





const ImageGridSliderItem = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const { image , title  } = props;
    let url = (0,LangHelper/* replaceOrAddLocale */.yM)(props.url, locale);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_related_item_module_default()).businessResourceRelatedItemContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_related_item_module_default()).businessResourceRelatedItemBackground,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_resource_related_item_module_default()).box,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_related_item_module_default()).main,
                        style: {
                            backgroundImage: "url(".concat(image, ")")
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_resource_related_item_module_default()).businessResourceRelatedItemContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_related_item_module_default()).contentTitle,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: url,
                        className: (business_resource_related_item_module_default()).contentCTA,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Read more"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: icons/* IconType.ArrowRightSmall */.T.ArrowRightSmall
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var business_image_grid_slider_item = (ImageGridSliderItem);

// EXTERNAL MODULE: ./components/business-resource-related/business-image-grid-slider.module.scss
var business_image_grid_slider_module = __webpack_require__(88068);
var business_image_grid_slider_module_default = /*#__PURE__*/__webpack_require__.n(business_image_grid_slider_module);
;// CONCATENATED MODULE: ./components/business-resource-related/business-image-grid-slider.tsx









swiper/* default.use */.Z.use([
    modules/* Navigation */.W_
]);
const ImageGridSlider = (props)=>{
    const { title , description , list  } = props;
    const prevRef = (0,react.useRef)(null);
    const nextRef = (0,react.useRef)(null);
    const { ref , inView  } = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true
    });
    const [swiper, setSwiper] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (swiper && inView) {
            swiper.init();
        }
    }, [
        swiper,
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_image_grid_slider_module_default()).businessResourceRelatedContainer,
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_image_grid_slider_module_default()).businessResourceRelatedTitle,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_image_grid_slider_module_default()).businessResourceRelatedDescription,
                dangerouslySetInnerHTML: {
                    __html: description
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_image_grid_slider_module_default()).businessResourceRelatedCarousel,
                children: [
                    !!(list === null || list === void 0 ? void 0 : list.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: nextRef,
                                className: (business_image_grid_slider_module_default()).carouselButtonNext,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                    type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: prevRef,
                                className: (business_image_grid_slider_module_default()).carouselButtonPrev,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                    type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        navigation: {
                            prevEl: prevRef.current ? prevRef.current : undefined,
                            nextEl: nextRef.current ? nextRef.current : undefined
                        },
                        onInit: (swiper)=>{
                            if (!swiper) {
                                return;
                            }
                            const navigation = swiper === null || swiper === void 0 ? void 0 : swiper.params.navigation;
                            navigation.prevEl = prevRef.current;
                            navigation.nextEl = nextRef.current;
                            swiper.navigation.init();
                            swiper.navigation.update();
                        },
                        slidesPerView: "auto",
                        spaceBetween: 4,
                        breakpoints: {
                            768: {
                                spaceBetween: 24
                            }
                        },
                        centeredSlidesBounds: true,
                        watchOverflow: true,
                        lazyPreloadPrevNext: 1,
                        updateOnWindowResize: true,
                        draggable: true,
                        grabCursor: true,
                        onSwiper: (sw)=>{
                            setSwiper(sw);
                        },
                        init: false,
                        children: list === null || list === void 0 ? void 0 : list.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_image_grid_slider_item, {
                                    ...item
                                })
                            }, "".concat(index)))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var business_image_grid_slider = (ImageGridSlider);

;// CONCATENATED MODULE: ./components/business-resource-related/business-image-grid-slider.builder-component.ts

const ImageGridSliderBuilderConfig = {
    name: "Grid Image Slider With Link",
    inputs: [
        {
            name: "title",
            type: "string",
            required: true
        },
        {
            name: "description",
            type: "richText",
            defaultValue: "",
            required: true
        },
        {
            name: "list",
            type: "list",
            defaultValue: [],
            subFields: [
                {
                    name: "image",
                    type: "file",
                    required: true
                },
                {
                    name: "title",
                    type: "text",
                    defaultValue: ""
                },
                {
                    name: "url",
                    type: "url",
                    defaultValue: ""
                }
            ]
        }
    ]
};
const business_image_grid_slider_builder_component_builderConfig = {
    component: business_image_grid_slider,
    config: ImageGridSliderBuilderConfig
};
/* harmony default export */ var business_image_grid_slider_builder_component = (business_image_grid_slider_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-super-text/business-resource-super-text.module.scss
var business_resource_super_text_module = __webpack_require__(77417);
var business_resource_super_text_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_super_text_module);
;// CONCATENATED MODULE: ./components/business-resource-super-text/business-resource-super-text.tsx



const BusinessResourceSuperText = (param)=>{
    let { text  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_resource_super_text_module_default()).root,
        children: text
    });
};
/* harmony default export */ var business_resource_super_text = (BusinessResourceSuperText);

;// CONCATENATED MODULE: ./components/business-resource-super-text/business-resource-super-text.builder-component.ts

const BusinessResourceTextHighlightBuilderConfig = {
    name: "Resource Super Text",
    inputs: [
        {
            name: "text",
            type: "string"
        }
    ]
};
const business_resource_super_text_builder_component_builderConfig = {
    component: business_resource_super_text,
    config: BusinessResourceTextHighlightBuilderConfig
};
/* harmony default export */ var business_resource_super_text_builder_component = (business_resource_super_text_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-text-hightlight/business-resource-text-highlight.module.scss
var business_resource_text_highlight_module = __webpack_require__(36690);
var business_resource_text_highlight_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_text_highlight_module);
;// CONCATENATED MODULE: ./components/business-resource-text-hightlight/business-resource-text-highlight.tsx




const BusinessResourceTextHighlight = (param)=>{
    let { headline , text  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((business_resource_text_highlight_module_default()).root),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_text_highlight_module_default()).headline,
                children: headline
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_text_highlight_module_default()).text,
                children: text
            })
        ]
    });
};
/* harmony default export */ var business_resource_text_highlight = (BusinessResourceTextHighlight);

;// CONCATENATED MODULE: ./components/business-resource-text-hightlight/business-resource-text-highlight.builder-component.ts

const business_resource_text_highlight_builder_component_BusinessResourceTextHighlightBuilderConfig = {
    name: "Resource Text Highlight",
    inputs: [
        {
            name: "headline",
            type: "string",
            defaultValue: ""
        },
        {
            name: "text",
            type: "string",
            defaultValue: ""
        }
    ]
};
const business_resource_text_highlight_builder_component_builderConfig = {
    component: business_resource_text_highlight,
    config: business_resource_text_highlight_builder_component_BusinessResourceTextHighlightBuilderConfig
};
/* harmony default export */ var business_resource_text_highlight_builder_component = (business_resource_text_highlight_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-text-list/business-resource-text-list.module.scss
var business_resource_text_list_module = __webpack_require__(76503);
var business_resource_text_list_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_text_list_module);
;// CONCATENATED MODULE: ./components/business-resource-text-list/business-resource-text-list.tsx


const BusinessResourceTextList = (props)=>{
    const { title , items  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_text_list_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_text_list_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_text_list_module_default()).items,
                children: items === null || items === void 0 ? void 0 : items.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_resource_text_list_module_default()).item,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (business_resource_text_list_module_default()).number,
                                children: index + 1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (business_resource_text_list_module_default()).content,
                                dangerouslySetInnerHTML: {
                                    __html: item.content
                                }
                            })
                        ]
                    }, index))
            })
        ]
    });
};
/* harmony default export */ var business_resource_text_list = (BusinessResourceTextList);

;// CONCATENATED MODULE: ./components/business-resource-text-list/business-resource-text-list.builder-component.ts

const BusinessResourceTextListBuilderConfig = {
    name: "Resource Text List",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: ""
        },
        {
            name: "items",
            type: "list",
            subFields: [
                {
                    name: "content",
                    type: "richText"
                }
            ]
        }
    ]
};
const business_resource_text_list_builder_component_builderConfig = {
    component: business_resource_text_list,
    config: BusinessResourceTextListBuilderConfig
};
/* harmony default export */ var business_resource_text_list_builder_component = (business_resource_text_list_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/business-resource-text-wrap/business-resource-text-wrap.builder-component.ts

const BusinessResourceTextWrapBuilderConfig = {
    name: "Resource Text Wrap",
    inputs: [
        {
            name: "caption",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "content",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "row",
            type: "boolean",
            defaultValue: false
        }
    ]
};
const business_resource_text_wrap_builder_component_builderConfig = {
    component: business_resource_text_wrap,
    config: BusinessResourceTextWrapBuilderConfig
};
/* harmony default export */ var business_resource_text_wrap_builder_component = (business_resource_text_wrap_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-top-strips/business-resource-top-strips.module.scss
var business_resource_top_strips_module = __webpack_require__(80877);
var business_resource_top_strips_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_top_strips_module);
;// CONCATENATED MODULE: ./components/business-resource-top-strips/business-resource-top-strips.tsx






const BusinessResourceTopStrips = (param)=>{
    let { assets =[]  } = param;
    var ref, ref1;
    const [selectedAsset, setSelectedAsset] = (0,react.useState)((assets === null || assets === void 0 ? void 0 : assets[0]) || null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_top_strips_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(business_resource_download_assets_button_container, {
                assets: assets,
                rootContainerName: "top-strips",
                children: [
                    "Download All Strips ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Download/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_resource_top_strips_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_top_strips_module_default()).leftBlock,
                        children: assets.map((asset, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_single_asset_variant_container, {
                                clickable: true,
                                asset: asset,
                                onClick: (asset)=>setSelectedAsset(asset)
                            }, index);
                        })
                    }),
                    selectedAsset && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_top_strips_module_default()).item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: (business_resource_top_strips_module_default()).image,
                            src: selectedAsset === null || selectedAsset === void 0 ? void 0 : (ref = selectedAsset.variants) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.pagePreviewImage,
                            alt: ""
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var business_resource_top_strips = (BusinessResourceTopStrips);

;// CONCATENATED MODULE: ./components/business-resource-top-strips/business-resource-top-strips.builder-component.ts

const BusinessResourceTopStripsBuilderConfig = {
    name: "Resource Top Strips",
    inputs: [
        {
            name: "assets",
            type: "list",
            copyOnAdd: false,
            subFields: [
                {
                    name: "name",
                    type: "string"
                },
                {
                    name: "variants",
                    type: "list",
                    copyOnAdd: false,
                    subFields: [
                        {
                            name: "variantName",
                            type: "string"
                        },
                        {
                            name: "previewUrl",
                            type: "url"
                        },
                        {
                            name: "downloadUrl",
                            type: "url"
                        },
                        {
                            name: "pagePreviewImage",
                            type: "file"
                        },
                        {
                            name: "extension",
                            type: "string"
                        }
                    ]
                }
            ]
        }
    ]
};
const business_resource_top_strips_builder_component_builderConfig = {
    component: business_resource_top_strips,
    config: BusinessResourceTopStripsBuilderConfig
};
/* harmony default export */ var business_resource_top_strips_builder_component = (business_resource_top_strips_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-training-block/business-resource-training-block-item/business-resource-training-block-item.module.scss
var business_resource_training_block_item_module = __webpack_require__(45288);
var business_resource_training_block_item_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_training_block_item_module);
;// CONCATENATED MODULE: ./components/business-resource-training-block/business-resource-training-block-item/business-resource-training-block-item.tsx




const ResourceTraningBlockItem = (props)=>{
    const { title , description , image , ctaText , ctaIcon , url , openLinkInNewTab  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_training_block_item_module_default()).businessResourceTrainingBlockItemContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_training_block_item_module_default()).businessResourceTrainingBlockItemBackground,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_resource_training_block_item_module_default()).box,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_training_block_item_module_default()).main,
                        style: {
                            backgroundImage: "url(".concat(image, ")")
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_resource_training_block_item_module_default()).businessResourceTrainingBlockItemContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_training_block_item_module_default()).contentTitle,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_resource_training_block_item_module_default()).contentDescription,
                        dangerouslySetInnerHTML: {
                            __html: description
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: url,
                        className: (business_resource_training_block_item_module_default()).contentCTA,
                        rel: "noreferrer",
                        target: openLinkInNewTab ? "_blank" : "_self",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: ctaText !== null && ctaText !== void 0 ? ctaText : "Download"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: ctaIcon !== null && ctaIcon !== void 0 ? ctaIcon : icons/* IconType.Download */.T.Download
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var business_resource_training_block_item = (ResourceTraningBlockItem);

// EXTERNAL MODULE: ./components/business-resource-training-block/business-resource-training-block.module.scss
var business_resource_training_block_module = __webpack_require__(60689);
var business_resource_training_block_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_training_block_module);
;// CONCATENATED MODULE: ./components/business-resource-training-block/business-resource-training-block.tsx




const ResourceTraningBlock = (props)=>{
    const { title , description , list  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_training_block_module_default()).businessResourceTrainingBlockContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_training_block_module_default()).businessResourceTrainingBlockTitle,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_training_block_module_default()).businessResourceTrainingBlockDescription,
                dangerouslySetInnerHTML: {
                    __html: description
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_training_block_module_default()).businessResourceTrainingBlockItems,
                children: list === null || list === void 0 ? void 0 : list.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_training_block_item, {
                        ...item
                    }, "".concat(index)))
            })
        ]
    });
};
/* harmony default export */ var business_resource_training_block = (ResourceTraningBlock);

;// CONCATENATED MODULE: ./components/business-resource-training-block/business-resource-training-block.builder-component.ts


const ResourceTrainingBlockBuilderConfig = {
    name: "Resource Training Block",
    inputs: [
        {
            name: "title",
            type: "string",
            required: true
        },
        {
            name: "description",
            type: "richText",
            defaultValue: "",
            required: true
        },
        {
            name: "list",
            type: "list",
            defaultValue: [],
            subFields: [
                {
                    name: "title",
                    type: "string",
                    required: true
                },
                {
                    name: "description",
                    type: "richText",
                    defaultValue: "",
                    required: true
                },
                {
                    name: "image",
                    type: "file",
                    required: true
                },
                {
                    name: "ctaText",
                    type: "text"
                },
                {
                    name: "ctaIcon",
                    type: "text",
                    enum: [
                        icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium,
                        icons/* IconType.Download */.T.Download
                    ],
                    default: icons/* IconType.Download */.T.Download
                },
                {
                    name: "url",
                    type: "url",
                    defaultValue: ""
                },
                {
                    name: "openLinkInNewTab",
                    type: "boolean",
                    defaultValue: true
                }
            ]
        }
    ]
};
const business_resource_training_block_builder_component_builderConfig = {
    component: business_resource_training_block,
    config: ResourceTrainingBlockBuilderConfig
};
/* harmony default export */ var business_resource_training_block_builder_component = (business_resource_training_block_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-typography-review/business-resource-typography-review.module.scss
var business_resource_typography_review_module = __webpack_require__(72618);
var business_resource_typography_review_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_typography_review_module);
// EXTERNAL MODULE: ./components/business-resource-typography-review/typography-review-card/typography-review-card.module.scss
var typography_review_card_module = __webpack_require__(26082);
var typography_review_card_module_default = /*#__PURE__*/__webpack_require__.n(typography_review_card_module);
;// CONCATENATED MODULE: ./components/business-resource-typography-review/typography-review-card/typography-review-card.tsx







const TypographyReviewCard = (props)=>{
    const { name , fontWeight ="light" , fontStyle ="normal" , downloadInfo , showDownloadButton =true  } = props;
    const [loading, setLoading] = (0,react.useState)(false);
    const onClick = async (variant)=>{
        setLoading(true);
        try {
            const name = "afterpay-fonts";
            let asset = {
                name,
                variants: variant === "ALL" ? downloadInfo : [
                    variant
                ]
            };
            await downloadAsset([
                asset
            ], name);
        } catch (ex) {
            console.error(ex);
        } finally{
            setLoading(false);
        }
    };
    const fontClasses = classnames_default()((typography_review_card_module_default())["font-".concat(fontWeight)], (typography_review_card_module_default())["font-".concat(fontStyle)]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (typography_review_card_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (typography_review_card_module_default()).headline,
                children: [
                    showDownloadButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_download_button, {
                        disabled: loading,
                        onVariantClick: onClick,
                        type: "icon",
                        item: {
                            variants: downloadInfo || []
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: icons/* IconType.Download */.T.Download
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: fontClasses,
                        children: name
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((typography_review_card_module_default()).preview, fontClasses),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (typography_review_card_module_default()).left,
                        children: "AaBb"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (typography_review_card_module_default()).right,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "abcdefghijklmnopqrstuvwxyz"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "0123456789 {[(&)]}*,.:;\xbf\xa1?!/|\\•\xb6@\xae\xa9TM"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "$\xa2\xa3\xa5€\xa7#%‰"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var typography_review_card = (TypographyReviewCard);

;// CONCATENATED MODULE: ./components/business-resource-typography-review/business-resource-typography-review.tsx








const BusinessResourceTypographyReview = (props)=>{
    const { fonts , showDownloadButton =true  } = props;
    const [loading, setLoading] = (0,react.useState)(false);
    const variants = [];
    fonts.forEach((font)=>{
        if (Array.isArray(font.downloadInfo)) {
            variants.push(...font.downloadInfo);
        }
    });
    const onDownload = async (variant)=>{
        setLoading(true);
        try {
            const name = "afterpay-fonts";
            let asset = {
                name,
                variants: variant === "ALL" ? variants : [
                    variant
                ]
            };
            await downloadAsset([
                asset
            ], name);
        } catch (ex) {
            console.error(ex);
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_typography_review_module_default()).container,
        children: [
            showDownloadButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_typography_review_module_default()).downloadButton,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(business_resource_download_button, {
                    disabled: loading,
                    item: {
                        variants
                    },
                    onVariantClick: onDownload,
                    allOption: false,
                    children: [
                        "Download Typeface Familly ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: icons/* IconType.Download */.T.Download
                        })
                    ]
                })
            }),
            fonts === null || fonts === void 0 ? void 0 : fonts.map((font, index)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_review_card, {
                            ...font,
                            showDownloadButton: showDownloadButton
                        }),
                        index !== fonts.length - 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(business_resource_divider, {}) : null
                    ]
                }, index);
            })
        ]
    });
};
/* harmony default export */ var business_resource_typography_review = (BusinessResourceTypographyReview);

;// CONCATENATED MODULE: ./components/business-resource-typography-review/business-resource-typography-review.builder-component.ts

const BusinessResourceTypographyReviewBuilderConfig = {
    name: "Resource Typography Review",
    inputs: [
        {
            name: "showDownloadButton",
            type: "boolean"
        },
        {
            name: "fonts",
            type: "list",
            subFields: [
                {
                    name: "name",
                    type: "string",
                    required: true
                },
                {
                    name: "fontWeight",
                    type: "string",
                    defaultValue: "light",
                    enum: [
                        "light",
                        "regular",
                        "demibold",
                        "bold"
                    ]
                },
                {
                    name: "fontStyle",
                    type: "string",
                    defaultValue: "normal",
                    enum: [
                        "normal",
                        "italic"
                    ]
                },
                {
                    name: "downloadInfo",
                    type: "list",
                    subFields: [
                        {
                            name: "variantName",
                            type: "string"
                        },
                        {
                            name: "downloadUrl",
                            type: "url",
                            required: true
                        },
                        {
                            name: "extension",
                            type: "string",
                            required: true
                        }
                    ]
                }
            ]
        }
    ]
};
const business_resource_typography_review_builder_component_builderConfig = {
    component: business_resource_typography_review,
    config: BusinessResourceTypographyReviewBuilderConfig
};
/* harmony default export */ var business_resource_typography_review_builder_component = (business_resource_typography_review_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-resource-value-block/business-resource-value-block.module.scss
var business_resource_value_block_module = __webpack_require__(89689);
var business_resource_value_block_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_value_block_module);
;// CONCATENATED MODULE: ./components/business-resource-value-block/business-resource-value-block.tsx


const BusinessResourceValueBlock = (props)=>{
    const { title , items  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_value_block_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_value_block_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_value_block_module_default()).items,
                children: items === null || items === void 0 ? void 0 : items.map((item)=>{
                    const { title , description , image  } = item;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_resource_value_block_module_default()).item,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_resource_value_block_module_default()).backgroundWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (business_resource_value_block_module_default()).backgroundBox,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (business_resource_value_block_module_default()).background,
                                        style: {
                                            backgroundImage: "url(".concat(image, ")")
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_resource_value_block_module_default()).itemMask
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_resource_value_block_module_default()).itemTitle,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_resource_value_block_module_default()).itemDescription,
                                dangerouslySetInnerHTML: {
                                    __html: description
                                }
                            })
                        ]
                    }, "item_".concat(title || Math.random()));
                })
            })
        ]
    });
};
/* harmony default export */ var business_resource_value_block = (BusinessResourceValueBlock);

;// CONCATENATED MODULE: ./components/business-resource-value-block/business-resource-value-block.builder-component.ts

const BusinessResourceValueBlockBuilderConfig = {
    name: "Resource Value Block",
    inputs: [
        {
            name: "title",
            type: "string",
            required: true
        },
        {
            name: "items",
            type: "list",
            defaultValue: [],
            subFields: [
                {
                    name: "title",
                    type: "string",
                    required: true
                },
                {
                    name: "description",
                    type: "richText",
                    defaultValue: "",
                    required: true
                },
                {
                    name: "image",
                    type: "file",
                    required: true
                }
            ]
        }
    ]
};
const business_resource_value_block_builder_component_builderConfig = {
    component: business_resource_value_block,
    config: BusinessResourceValueBlockBuilderConfig
};
/* harmony default export */ var business_resource_value_block_builder_component = (business_resource_value_block_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/video-card-selected/video-card-selected.module.scss
var video_card_selected_module = __webpack_require__(56833);
var video_card_selected_module_default = /*#__PURE__*/__webpack_require__.n(video_card_selected_module);
;// CONCATENATED MODULE: ./components/video-card-selected/video-card-selected.tsx
/* eslint-disable @next/next/no-img-element */ 







const VideoCardSelected = (props)=>{
    const { video  } = props;
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const windowWidth = (windowSize === null || windowSize === void 0 ? void 0 : windowSize.width) || 0;
    const isMobile = windowWidth && windowWidth <= 768 ? true : false;
    const ratioImage = isMobile ? [
        345,
        345
    ] : [
        720,
        638
    ];
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (video_card_selected_module_default()).videoWrap,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (video_card_selected_module_default()).videoWrapButtonPlay,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                    type: icons/* IconType.Triangle */.T.Triangle
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(image_zoom, {
                ratio: ratioImage,
                src: (ref = video === null || video === void 0 ? void 0 : video.leadImage) !== null && ref !== void 0 ? ref : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (video_card_selected_module_default()).videoOverlay
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (video_card_selected_module_default()).videoContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: (video_card_selected_module_default()).videoItemImageBrand,
                        src: (ref1 = video === null || video === void 0 ? void 0 : video.imageBrandUrl) !== null && ref1 !== void 0 ? ref1 : "",
                        alt: "",
                        priority: false,
                        loading: "lazy",
                        width: 160,
                        height: 32,
                        fill: false,
                        style: {
                            objectFit: "scale-down",
                            objectPosition: "left"
                        },
                        loader: (param)=>{
                            let { src , width , quality  } = param;
                            return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (video_card_selected_module_default()).videoContainerTitle,
                        children: video === null || video === void 0 ? void 0 : video.title
                    }),
                    (video === null || video === void 0 ? void 0 : video.description) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (video_card_selected_module_default()).videoContainerDescription,
                        children: video === null || video === void 0 ? void 0 : video.description
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (video_card_selected_module_default()).videoContainerWatchNow,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Watch Now"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: (video === null || video === void 0 ? void 0 : video.videoUrl) || "",
                className: (video_card_selected_module_default()).videoLink
            })
        ]
    });
};
/* harmony default export */ var video_card_selected = (VideoCardSelected);

// EXTERNAL MODULE: ./components/business-resource-video-list/business-resource-video-list.module.scss
var business_resource_video_list_module = __webpack_require__(14734);
var business_resource_video_list_module_default = /*#__PURE__*/__webpack_require__.n(business_resource_video_list_module);
;// CONCATENATED MODULE: ./components/business-resource-video-list/business-resource-video-list.tsx







const BusinessResourceVideoList = (props)=>{
    const { videoList , watchAllUrl , description , title , ctaText  } = props;
    const [videoSelected, setVideoSelected] = (0,react.useState)(videoList === null || videoList === void 0 ? void 0 : videoList[0]);
    (0,react.useEffect)(()=>{
        if (videoList && (videoList === null || videoList === void 0 ? void 0 : videoList.length) > 0) {
            setVideoSelected(videoList[0]);
        }
    }, [
        videoList
    ]);
    if (!videoList || (videoList === null || videoList === void 0 ? void 0 : videoList.length) === 0) {
        return null;
    }
    const renderVideoItem = (video)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (business_resource_video_list_module_default()).videoItem,
            onMouseEnter: ()=>setVideoSelected(video),
            onClick: ()=>setVideoSelected(video),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: (business_resource_video_list_module_default()).videoItemImageBrand,
                    src: video.imageBrandUrl,
                    alt: "",
                    priority: false,
                    loading: "lazy",
                    width: 160,
                    height: 32,
                    fill: false,
                    style: {
                        objectFit: "scale-down",
                        objectPosition: "left"
                    },
                    loader: (param)=>{
                        let { src , width , quality  } = param;
                        return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (business_resource_video_list_module_default()).videoItemContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_resource_video_list_module_default()).videoItemTitle,
                            children: video.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: icons/* IconType.ArrowRightBig */.T.ArrowRightBig
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: video.videoUrl,
                    className: (business_resource_video_list_module_default()).videoItemLink
                })
            ]
        }, "video_item_".concat(video.leadImage));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_resource_video_list_module_default()).videoList,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_resource_video_list_module_default()).videoListHeader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (business_resource_video_list_module_default()).videoListHeaderText,
                                children: title
                            }),
                            description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (business_resource_video_list_module_default()).videoListDescriptionText,
                                children: description
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_resource_video_list_module_default()).videoListHeaderTextWatchAll,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (business_resource_video_list_module_default()).businessButtonText,
                                children: ctaText !== null && ctaText !== void 0 ? ctaText : "Learn More"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: watchAllUrl,
                                className: (business_resource_video_list_module_default()).linkWatchAllVideo
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_video_list_module_default()).videoBlock,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(video_card_selected, {
                    video: videoSelected
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_resource_video_list_module_default()).videoListContainer,
                children: videoList === null || videoList === void 0 ? void 0 : videoList.map((video)=>renderVideoItem(video))
            })
        ]
    });
};
/* harmony default export */ var business_resource_video_list = (BusinessResourceVideoList);

;// CONCATENATED MODULE: ./components/business-resource-video-list/business-resource-video-list.builder-component.ts

const BusinessVideoListBuilderConfig = {
    name: "Video List",
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: "Make it your Way"
        },
        {
            name: "description",
            type: "string"
        },
        {
            name: "ctaText",
            type: "string",
            defaultValue: "Learn More"
        },
        {
            name: "videoList",
            type: "list",
            subFields: [
                {
                    name: "title",
                    type: "string"
                },
                {
                    name: "description",
                    type: "string"
                },
                {
                    name: "leadImage",
                    type: "file"
                },
                {
                    name: "imageBrandUrl",
                    type: "file"
                },
                {
                    name: "videoUrl",
                    type: "string"
                }
            ]
        },
        {
            name: "watchAllUrl",
            type: "string"
        }
    ]
};
const business_resource_video_list_builder_component_builderConfig = {
    component: business_resource_video_list,
    config: BusinessVideoListBuilderConfig
};
/* harmony default export */ var business_resource_video_list_builder_component = (business_resource_video_list_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-text-caption/business-text-caption.module.scss
var business_text_caption_module = __webpack_require__(73633);
var business_text_caption_module_default = /*#__PURE__*/__webpack_require__.n(business_text_caption_module);
;// CONCATENATED MODULE: ./components/business-text-caption/business-text-caption.tsx



const BusinessTextCaption = (props)=>{
    const { text  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_text_caption_module_default()).businessTextCaptionContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (business_text_caption_module_default()).businessTextCaption,
            dangerouslySetInnerHTML: {
                __html: text
            }
        })
    });
};
/* harmony default export */ var business_text_caption = (BusinessTextCaption);

;// CONCATENATED MODULE: ./components/business-text-caption/business-text-caption.builder-component.ts

const BusinessTextWrapBuilderConfig = {
    name: "Text Caption",
    inputs: [
        {
            name: "text",
            type: "richText",
            defaultValue: ""
        }
    ]
};
const business_text_caption_builder_component_builderConfig = {
    component: business_text_caption,
    config: BusinessTextWrapBuilderConfig
};
/* harmony default export */ var business_text_caption_builder_component = (business_text_caption_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-text-wrap/business-text-wrap.module.scss
var business_text_wrap_module = __webpack_require__(86151);
var business_text_wrap_module_default = /*#__PURE__*/__webpack_require__.n(business_text_wrap_module);
;// CONCATENATED MODULE: ./components/business-text-wrap/business-text-wrap.tsx





const BusinessTextWrap = (props)=>{
    const { text  } = props;
    const { breadcrumbType  } = (0,LayoutContext/* useBusinessLayout */.Vp)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (business_text_wrap_module_default()).businessTextWrapContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()((business_text_wrap_module_default()).businessTextWrap, (business_text_wrap_module_default())[breadcrumbType]),
            dangerouslySetInnerHTML: {
                __html: text
            }
        })
    });
};
/* harmony default export */ var business_text_wrap = (BusinessTextWrap);

;// CONCATENATED MODULE: ./components/business-text-wrap/business-text-wrap.builder-component.ts


const business_text_wrap_builder_component_BusinessTextWrapBuilderConfig = {
    name: "Text Wrap",
    inputs: [
        {
            name: "text",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "colorText",
            type: "string",
            enum: Object.values(Resource/* COLORS */.D),
            defaultValue: Resource/* COLORS.Grey */.D.Grey
        }
    ]
};
const business_text_wrap_builder_component_builderConfig = {
    component: business_text_wrap,
    config: business_text_wrap_builder_component_BusinessTextWrapBuilderConfig
};
/* harmony default export */ var business_text_wrap_builder_component = (business_text_wrap_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-trending-topics/business-treding-topic-item/business-trending-topic-item.module.scss
var business_trending_topic_item_module = __webpack_require__(88790);
var business_trending_topic_item_module_default = /*#__PURE__*/__webpack_require__.n(business_trending_topic_item_module);
;// CONCATENATED MODULE: ./components/business-trending-topics/business-treding-topic-item/business-trending-topic-item.tsx





const business_trending_topic_item_BusinessTrendingTopicItem = (param)=>{
    let { category  } = param;
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const { image , name  } = category;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        href: (0,LangHelper/* localifyLink */.Bj)("/".concat(locale).concat(category.categoryUrl), locale),
        className: (business_trending_topic_item_module_default()).businessTrendingTopicsItem,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_trending_topic_item_module_default()).itemBackground,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_zoom, {
                    src: image !== null && image !== void 0 ? image : "",
                    ratio: [
                        200,
                        200
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_trending_topic_item_module_default()).itemDescription,
                children: name
            })
        ]
    });
};
/* harmony default export */ var business_trending_topic_item = (business_trending_topic_item_BusinessTrendingTopicItem);

// EXTERNAL MODULE: ./components/business-trending-topics/business-trending-topics.module.scss
var business_trending_topics_module = __webpack_require__(54753);
var business_trending_topics_module_default = /*#__PURE__*/__webpack_require__.n(business_trending_topics_module);
;// CONCATENATED MODULE: ./components/business-trending-topics/business-trending-topics.tsx









swiper/* default.use */.Z.use([
    modules/* Navigation */.W_
]);
const BusinessTrendingTopics = (props)=>{
    var _categoryData;
    const [categories, setCategories] = (0,react.useState)((_categoryData = props.categoryData) !== null && _categoryData !== void 0 ? _categoryData : []);
    const { title , description  } = props;
    const prevRef = (0,react.useRef)(null);
    const nextRef = (0,react.useRef)(null);
    const { ref , inView  } = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true
    });
    const [swiper, setSwiper] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (swiper && inView) {
            swiper.init();
        }
    }, [
        swiper,
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (business_trending_topics_module_default()).businessTrendingTopicsWrapper,
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_trending_topics_module_default()).businessTrendingTopicsTitle,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_trending_topics_module_default()).businessTrendingTopicsDescription,
                children: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (business_trending_topics_module_default()).businessTrendingTopicsCarousel,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: nextRef,
                        className: (business_trending_topics_module_default()).carouselButtonNext,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: prevRef,
                        className: (business_trending_topics_module_default()).carouselButtonPrev,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        grabCursor: true,
                        navigation: {
                            prevEl: prevRef.current ? prevRef.current : undefined,
                            nextEl: nextRef.current ? nextRef.current : undefined
                        },
                        onInit: (swiper)=>{
                            if (!swiper) {
                                return;
                            }
                            const navigation = swiper === null || swiper === void 0 ? void 0 : swiper.params.navigation;
                            navigation.prevEl = prevRef.current;
                            navigation.nextEl = nextRef.current;
                            swiper.navigation.init();
                            swiper.navigation.update();
                        },
                        slidesPerView: "auto",
                        spaceBetween: 4,
                        breakpoints: {
                            768: {
                                spaceBetween: 24
                            },
                            1440: {
                                spaceBetween: 24
                            }
                        },
                        centeredSlides: false,
                        centeredSlidesBounds: true,
                        watchOverflow: true,
                        lazyPreloadPrevNext: 1,
                        updateOnWindowResize: true,
                        onSwiper: (sw)=>{
                            setSwiper(sw);
                        },
                        children: categories.map((category, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                className: (business_trending_topics_module_default()).relatedArticleSlide,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_trending_topic_item, {
                                    category: category
                                })
                            }, "".concat(index, "_").concat(category.categorySlug));
                        })
                    }, title)
                ]
            })
        ]
    });
};
/* harmony default export */ var business_trending_topics = (BusinessTrendingTopics);

;// CONCATENATED MODULE: ./components/business-trending-topics/business-trending-topics.builder-component.ts

const BusinessTrendingTopicsBuilderConfig = {
    name: "Trending topics",
    inputs: [
        {
            name: "title",
            type: "string",
            required: true
        },
        {
            name: "description",
            type: "string",
            required: true
        },
        {
            name: "categories",
            type: "list",
            required: true,
            subFields: [
                {
                    name: "categoryId",
                    type: "string"
                }
            ]
        }
    ]
};
const business_trending_topics_builder_component_builderConfig = {
    component: business_trending_topics,
    config: BusinessTrendingTopicsBuilderConfig
};
/* harmony default export */ var business_trending_topics_builder_component = (business_trending_topics_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/business-vimeo-embed/business-vimeo-embed.tsx
var business_vimeo_embed = __webpack_require__(78096);
;// CONCATENATED MODULE: ./components/business-vimeo-embed/business-vimeo-embed-wrap.builder-component.ts


const BusinessVimeoEmbedWrapBuilderConfig = {
    name: "Vimeo Embed",
    inputs: [
        {
            name: "videoUrl",
            type: "string",
            required: true
        },
        {
            name: "ratio",
            type: "string",
            enum: Object.keys(Media/* MEDIA_RATIO */.r),
            defaultValue: Object.keys(Media/* MEDIA_RATIO */.r)[0]
        },
        {
            name: "controls",
            type: "boolean"
        },
        {
            name: "backgroundTransform",
            type: "boolean",
            required: true
        },
        {
            name: "containerMaxWidth",
            type: "string"
        },
        {
            name: "isHero",
            type: "boolean"
        },
        {
            name: "playIcon",
            type: "file"
        }
    ]
};
const business_vimeo_embed_wrap_builder_component_builderConfig = {
    component: business_vimeo_embed/* default */.Z,
    config: BusinessVimeoEmbedWrapBuilderConfig
};
/* harmony default export */ var business_vimeo_embed_wrap_builder_component = (business_vimeo_embed_wrap_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/business-youtube-embed/business-youtube-embed.builder-component.ts


const BusinessYoutubeEmbedWrapBuilderConfig = {
    name: "Youtube Embed",
    inputs: [
        {
            name: "videoUrl",
            type: "string",
            required: true
        },
        {
            name: "containerMaxWidth",
            type: "string",
            required: true
        },
        {
            name: "ratio",
            type: "string",
            enum: Object.keys(Media/* MEDIA_RATIO */.r),
            defaultValue: Object.keys(Media/* MEDIA_RATIO */.r)[0]
        }
    ]
};
const business_youtube_embed_builder_component_builderConfig = {
    component: business_youtube_embed,
    config: BusinessYoutubeEmbedWrapBuilderConfig
};
/* harmony default export */ var business_youtube_embed_builder_component = (business_youtube_embed_builder_component_builderConfig);

// EXTERNAL MODULE: ./hook/useBackgroundTransform.ts
var useBackgroundTransform = __webpack_require__(52479);
// EXTERNAL MODULE: ./components/bussines-video-player/business-video-player.module.scss
var business_video_player_module = __webpack_require__(51635);
var business_video_player_module_default = /*#__PURE__*/__webpack_require__.n(business_video_player_module);
;// CONCATENATED MODULE: ./components/bussines-video-player/business-video-player.tsx






const VideoPLayer = (param)=>{
    let { src , className , onClick =()=>{} , loop =false , controls =false , muted =true , backgroundTransform =false  } = param;
    const [loading, setLoading] = (0,react.useState)(false);
    const [isPlayVideo, setPlayVideo] = (0,react.useState)(true);
    const refVideo = (0,react.useRef)(null);
    const elemRef = (0,react.useRef)(null);
    (0,useBackgroundTransform/* useBackgroundTransform */.L)(elemRef);
    const [isShowVideoControls, setShowVideoControls] = (0,react.useState)(false);
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const windowWidth = windowSize.width || 0;
    const isMobile = windowWidth <= 768;
    (0,react.useEffect)(()=>{
        window.addEventListener("focus", onFocusTab);
        window.addEventListener("blur", onLeaveTab);
        return ()=>{
            window.removeEventListener("focus", onFocusTab);
            window.removeEventListener("blur", onLeaveTab);
        };
    }, []);
    const handleLoadStart = ()=>{
        setLoading(true);
    };
    const handleCanPlay = ()=>{
        setLoading(false);
    };
    const togglePlayVideo = ()=>{
        var ref;
        if (refVideo === null || refVideo === void 0 ? void 0 : (ref = refVideo.current) === null || ref === void 0 ? void 0 : ref.paused) {
            var ref1;
            setPlayVideo(true);
            refVideo === null || refVideo === void 0 ? void 0 : (ref1 = refVideo.current) === null || ref1 === void 0 ? void 0 : ref1.play();
        } else {
            var ref2;
            setPlayVideo(false);
            refVideo === null || refVideo === void 0 ? void 0 : (ref2 = refVideo.current) === null || ref2 === void 0 ? void 0 : ref2.pause();
        }
    };
    const onFocusTab = ()=>{
        var ref;
        setPlayVideo(false);
        (ref = refVideo.current) === null || ref === void 0 ? void 0 : ref.pause();
    };
    const onLeaveTab = ()=>{
        var ref;
        setPlayVideo(false);
        (ref = refVideo.current) === null || ref === void 0 ? void 0 : ref.pause();
    };
    const renderPlayPauseBtn = ()=>{
        if (isPlayVideo) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_video_player_module_default()).buttonPlay
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_video_player_module_default()).buttonPause
            });
        }
    };
    const toggleMuteVideo = ()=>{
        var ref;
        if (refVideo === null || refVideo === void 0 ? void 0 : (ref = refVideo.current) === null || ref === void 0 ? void 0 : ref.muted) {
            refVideo.current.muted = false;
        } else {
            var ref1;
            var ref2;
            (ref2 = (ref1 = refVideo.current) === null || ref1 === void 0 ? void 0 : ref1.muted) !== null && ref2 !== void 0 ? ref2 : true;
        }
    };
    const classNameVideoPlayer = classnames_default()((business_video_player_module_default())["c-video-container"], loading && (business_video_player_module_default())["c-video-loading"], className);
    const classNameVideoControl = classnames_default()((business_video_player_module_default())["video-controls"], !isPlayVideo || isShowVideoControls ? (business_video_player_module_default()).show : (business_video_player_module_default()).hide);
    const classNameOverlay = classnames_default()((business_video_player_module_default()).controlOverLay, !isPlayVideo || isShowVideoControls ? (business_video_player_module_default()).show : (business_video_player_module_default()).hide);
    const handleClickVideoM = ()=>{
        if (isMobile) {
            setShowVideoControls(true);
            setTimeout(()=>{
                setShowVideoControls(false);
            }, 2000);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: backgroundTransform ? elemRef : null,
        className: classNameVideoPlayer,
        onClick: handleClickVideoM,
        onMouseEnter: ()=>setShowVideoControls(true),
        onMouseLeave: ()=>setShowVideoControls(false),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                ref: refVideo,
                onLoadStart: handleLoadStart,
                onCanPlay: handleCanPlay,
                onClick: onClick,
                className: (business_video_player_module_default())["c-video"],
                loop: loop,
                autoPlay: false,
                muted: muted,
                playsInline: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: src,
                    type: "video/mp4"
                })
            }),
            controls && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classNameVideoControl,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: togglePlayVideo,
                                className: classnames_default()((business_video_player_module_default())["video-controls__btnPlayPause"], {
                                    [(business_video_player_module_default()).play]: isPlayVideo,
                                    [(business_video_player_module_default()).pause]: !isPlayVideo
                                }),
                                children: renderPlayPauseBtn()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_video_player_module_default())["video-controls__btnMuted"],
                                onClick: toggleMuteVideo
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classNameOverlay
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_video_player_module_default())["c-video-loader"]
            })
        ]
    });
};
/* harmony default export */ var business_video_player = (VideoPLayer);

;// CONCATENATED MODULE: ./components/bussines-video-player/business-video-player.builder-component.ts

const BusinessVideoPlayerWrapBuilderConfig = {
    name: "Video Player",
    inputs: [
        {
            name: "videoUrl",
            type: "string",
            required: true
        },
        {
            name: "controls",
            type: "boolean"
        },
        {
            name: "loop",
            type: "boolean"
        },
        {
            name: "muted",
            type: "boolean"
        },
        {
            name: "backgroundTransform",
            type: "boolean",
            required: true
        }
    ]
};
const business_video_player_builder_component_builderConfig = {
    component: business_video_player,
    config: BusinessVideoPlayerWrapBuilderConfig
};
/* harmony default export */ var business_video_player_builder_component = (business_video_player_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/categories/categories.tsx
var categories = __webpack_require__(8324);
// EXTERNAL MODULE: ./components/community-card/community-card.module.scss
var community_card_module = __webpack_require__(54997);
var community_card_module_default = /*#__PURE__*/__webpack_require__.n(community_card_module);
;// CONCATENATED MODULE: ./components/community-card/community-card.tsx









const CommunityCard = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const { article  } = props;
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const windowWidth = (windowSize === null || windowSize === void 0 ? void 0 : windowSize.width) || 0;
    const isMobile = windowWidth && windowWidth <= 768 ? true : false;
    const ratioImage = isMobile ? [
        345,
        345
    ] : [
        720,
        638
    ];
    if (!article) {
        return null;
    }
    const articleUrl = (0,LangHelper/* localifyLink */.Bj)("/".concat(locale).concat(article.articleUrl), locale);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (community_card_module_default()).communityCard,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (community_card_module_default()).communityCardWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_zoom, {
                    src: article.leadImage || "",
                    ratio: ratioImage
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (community_card_module_default()).infoArticle,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(categories/* default */.Z, {
                        categories: article.categories,
                        type: "SMALL",
                        color: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (community_card_module_default()).articleTitle,
                        children: article.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (community_card_module_default()).articleDescription,
                        children: article.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (community_card_module_default()).readMoreBtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                            icon: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium,
                            buttonText: "Read more",
                            link: articleUrl,
                            color: "white"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (community_card_module_default()).overlay
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: articleUrl,
                className: (community_card_module_default()).articleUrl
            })
        ]
    });
};
/* harmony default export */ var community_card = (CommunityCard);

// EXTERNAL MODULE: ./components/category-feature/category-feature.module.scss
var category_feature_module = __webpack_require__(40267);
var category_feature_module_default = /*#__PURE__*/__webpack_require__.n(category_feature_module);
;// CONCATENATED MODULE: ./components/category-feature/category-feature.tsx








const CategoryFeature = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    var _categoryArticles;
    const [featuredArticles, setFeaturedArticles] = (0,react.useState)((_categoryArticles = props.categoryArticles) !== null && _categoryArticles !== void 0 ? _categoryArticles : []);
    const [articleSelected, setArticleSelected] = (0,react.useState)(featuredArticles[0]);
    const [category, setCategory] = (0,react.useState)();
    const linkReadAll = (0,LangHelper/* localifyLink */.Bj)("/".concat(locale) + (category === null || category === void 0 ? void 0 : category.categoryUrl), locale);
    const categoryName = category === null || category === void 0 ? void 0 : category.name;
    (0,react.useEffect)(()=>{
        let cancelled = false;
        if (typeof props.category === "string") {
            (0,BuilderHelper/* getCategoryFromID */.s$)(props.category).then((foundCategory)=>{
                if (!cancelled && foundCategory) {
                    setCategory(foundCategory);
                }
            });
        } else {
            setCategory(props.category);
        }
        return ()=>{
            cancelled = true;
        };
    }, []);
    (0,react.useEffect)(()=>{
        let cancelled = false;
        if (category && !props.categoryArticles) {
            (0,BuilderHelper/* getArticlesByCategory */.Zd)({
                locale,
                limit: 3,
                categoryIds: [
                    category === null || category === void 0 ? void 0 : category.id
                ]
            }).then((articles)=>{
                if (!cancelled) {
                    setFeaturedArticles(articles);
                }
            });
        }
        return ()=>{
            cancelled = true;
        };
    }, [
        category
    ]);
    (0,react.useEffect)(()=>{
        if (!articleSelected) {
            setArticleSelected(featuredArticles[0]);
        }
    }, [
        featuredArticles
    ]);
    if (!featuredArticles || featuredArticles.length === 0) {
        return null;
    }
    const renderArticleItem = (article)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (category_feature_module_default()).articleItem,
            onMouseEnter: ()=>setArticleSelected(article),
            onClick: ()=>setArticleSelected(article),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(categories/* default */.Z, {
                    categories: article.categories,
                    type: "SMALL"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (category_feature_module_default()).articleContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (category_feature_module_default()).articleTitle,
                            children: article.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: icons/* IconType.ArrowRightBig */.T.ArrowRightBig
                        })
                    ]
                })
            ]
        }, "article_feature_".concat(article.articleUrl));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (category_feature_module_default()).categoryFeature,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (category_feature_module_default()).categoryFeatureContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (category_feature_module_default()).categoryHeader,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (category_feature_module_default()).headerText,
                                children: categoryName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (category_feature_module_default()).articleCardButtonReadAll,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (category_feature_module_default()).businessButtonText,
                                        children: "Read all"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                        type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: linkReadAll,
                                        className: (category_feature_module_default()).linkReadAllArticle
                                    })
                                ]
                            })
                        ]
                    }),
                    featuredArticles === null || featuredArticles === void 0 ? void 0 : featuredArticles.map((article)=>renderArticleItem(article))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (category_feature_module_default()).articlesFeature,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(community_card, {
                    article: articleSelected
                })
            })
        ]
    });
};
/* harmony default export */ var category_feature = (CategoryFeature);

;// CONCATENATED MODULE: ./components/category-feature/category-feature.builder-component.ts

const CategoryFeatureBuilderConfig = {
    name: "Category Feature",
    inputs: [
        {
            name: "category",
            type: "text"
        }
    ]
};
const category_feature_builder_component_builderConfig = {
    component: category_feature,
    config: CategoryFeatureBuilderConfig
};
/* harmony default export */ var category_feature_builder_component = (category_feature_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/category-hero/category-hero.tsx + 1 modules
var category_hero = __webpack_require__(98816);
;// CONCATENATED MODULE: ./components/category-hero/category-hero.builder-component.ts

const CategoryHeroBuilderConfig = {
    name: "Category Hero",
    inputs: [
        {
            name: "breadcrumbs",
            type: "list",
            subFields: [
                {
                    name: "name",
                    type: "string",
                    defaultValue: ""
                },
                {
                    name: "link",
                    type: "url",
                    defaultValue: ""
                }
            ]
        },
        {
            name: "categoryHeroTitle",
            type: "longText",
            defaultValue: ""
        },
        {
            name: "categoryHeroDescription",
            type: "longText",
            defaultValue: ""
        },
        {
            name: "backgroundColor",
            type: "string",
            defaultValue: "Orca Pastel",
            enum: [
                "Blum",
                "Orca Pastel"
            ]
        },
        {
            name: "backgroundCoverContent",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "showFilter",
            type: "boolean",
            defaultValue: true
        }
    ]
};
const category_hero_builder_component_builderConfig = {
    component: category_hero/* default */.Z,
    config: CategoryHeroBuilderConfig
};
/* harmony default export */ var category_hero_builder_component = (category_hero_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/learning-series-block/learning-series-block.module.scss
var learning_series_block_module = __webpack_require__(86314);
var learning_series_block_module_default = /*#__PURE__*/__webpack_require__.n(learning_series_block_module);
;// CONCATENATED MODULE: ./components/learning-series-block/learning-series-block.tsx








const LearningSeriesBlock = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const { titleSeries , descriptionSeries , viewAllText , backgroundColor ="" , category1 , category2 , category3 , viewAllUrl  } = props;
    var _seriesData;
    const [series, setSeries] = (0,react.useState)((_seriesData = props.seriesData) !== null && _seriesData !== void 0 ? _seriesData : []);
    const viewAllUrlLocale = (0,LangHelper/* localifyLink */.Bj)("/".concat(locale).concat(viewAllUrl), locale);
    (0,react.useEffect)(()=>{
        let cancelled = false;
        if (!category1 && !category2 && !category3) return;
        // Don't re-fetch the category data if it's already presented
        if (props.seriesData) return;
        const categories = [
            category1 || "",
            category2 || "",
            category3 || ""
        ].filter((category)=>!!category);
        if (categories && categories.length) {
            (0,BuilderHelper/* getCategoriesFromIDs */.nq)(categories).then((data)=>{
                if (!cancelled) {
                    setSeries(data.map((category)=>{
                        return {
                            category
                        };
                    }));
                }
            });
        }
        return ()=>{
            cancelled = true;
        };
    }, [
        category1,
        category2,
        category3,
        props.seriesData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (learning_series_block_module_default()).seriesCollectionBlock,
        children: [
            backgroundColor ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (learning_series_block_module_default())["seriesCollectionBlock".concat(backgroundColor.replace(" ", ""))]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (learning_series_block_module_default()).seriesHeader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (learning_series_block_module_default()).infoSeries,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (learning_series_block_module_default()).title,
                                children: titleSeries
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (learning_series_block_module_default()).description,
                                children: descriptionSeries
                            })
                        ]
                    }),
                    viewAllUrl ? /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                        href: viewAllUrlLocale,
                        className: (learning_series_block_module_default()).btnViewAll,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: viewAllText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(headlining_articles_block, {
                cardData: series,
                typeOfCard: "learning",
                showSignupCard: false
            })
        ]
    });
};
/* harmony default export */ var learning_series_block = (LearningSeriesBlock);

;// CONCATENATED MODULE: ./components/learning-series-block/learning-series-block.builder-component.ts


const LearningSeriesBlockPropsBuilderConfig = {
    name: "Learning series block",
    inputs: [
        {
            name: "titleSeries",
            type: "string"
        },
        {
            name: "descriptionSeries",
            type: "longText",
            defaultValue: ""
        },
        {
            name: "viewAllUrl",
            type: "url",
            defaultValue: ""
        },
        {
            name: "viewAllText",
            type: "string",
            defaultValue: ""
        },
        {
            name: "category1",
            type: "dynamic-dropdown",
            options: {
                url: GET_ALL_CATEGORY,
                mapper: "({data}) => {\n                  return ({\n                    category: Object.values(data)[0].reduce((rs, curr) => {\n                      return [...rs, { value: curr.id, name: curr.name }]\n                    }, [])\n                  })\n                }",
                expectMultipleDropdowns: false
            }
        },
        {
            name: "category2",
            type: "dynamic-dropdown",
            options: {
                url: GET_ALL_CATEGORY,
                mapper: "({data}) => {\n                  return ({\n                    category: Object.values(data)[0].reduce((rs, curr) => {\n                      return [...rs, { value: curr.id, name: curr.name }]\n                    }, [])\n                  })\n                }",
                expectMultipleDropdowns: false
            }
        },
        {
            name: "category3",
            type: "dynamic-dropdown",
            options: {
                url: GET_ALL_CATEGORY,
                mapper: "({data}) => {\n                  return ({\n                    category: Object.values(data)[0].reduce((rs, curr) => {\n                      return [...rs, { value: curr.id, name: curr.name }]\n                    }, [])\n                  })\n                }",
                expectMultipleDropdowns: false
            }
        },
        {
            name: "backgroundColor",
            type: "string",
            enum: [
                "Orca Pastel"
            ]
        }
    ]
};
const learning_series_block_builder_component_builderConfig = {
    component: learning_series_block,
    config: LearningSeriesBlockPropsBuilderConfig
};
/* harmony default export */ var learning_series_block_builder_component = (learning_series_block_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/numerical-highlight-list/numerical-highlight-list.constants.ts
const numerical_highlight_list_constants_BACKGROUND_COLORS = {
    MINT: "mint",
    PLUM: "plum",
    GREY: "grey"
};

// EXTERNAL MODULE: ./components/numerical-highlight-list/numerical-highlight-list.module.scss
var numerical_highlight_list_module = __webpack_require__(86154);
var numerical_highlight_list_module_default = /*#__PURE__*/__webpack_require__.n(numerical_highlight_list_module);
;// CONCATENATED MODULE: ./components/numerical-highlight-list/numerical-highlight-list.tsx




const NumericalList = (props)=>{
    const { heading , list , backgroundColor =numerical_highlight_list_constants_BACKGROUND_COLORS.MINT  } = props;
    const getBackgroundColor = ()=>{
        const backgroundColorMap = {
            [numerical_highlight_list_constants_BACKGROUND_COLORS.MINT]: "#b2fce4",
            [numerical_highlight_list_constants_BACKGROUND_COLORS.PLUM]: "#EADDF2",
            [numerical_highlight_list_constants_BACKGROUND_COLORS.GREY]: "#E7EAED"
        };
        return backgroundColorMap[backgroundColor];
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            backgroundColor: getBackgroundColor()
        },
        className: (numerical_highlight_list_module_default()).numericalListContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (numerical_highlight_list_module_default()).numericalHeading,
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: (numerical_highlight_list_module_default()).numericalList,
                children: list.map((item, index)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (numerical_highlight_list_module_default()).numericalItem,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (numerical_highlight_list_module_default()).numericalWrapper,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (numerical_highlight_list_module_default()).numericalTitle,
                                    dangerouslySetInnerHTML: {
                                        __html: item.title
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (numerical_highlight_list_module_default()).numericalDescription,
                                    dangerouslySetInnerHTML: {
                                        __html: item.description
                                    }
                                })
                            ]
                        })
                    }, item.title + "" + index);
                })
            })
        ]
    });
};
/* harmony default export */ var numerical_highlight_list = (NumericalList);

;// CONCATENATED MODULE: ./components/numerical-highlight-list/numerical-highlight-list.builder-component.ts


const NumericalHighlightListBuilderConfig = {
    name: "Numerical Highlight List",
    inputs: [
        {
            name: "heading",
            type: "string",
            defaultValue: "Heading"
        },
        {
            name: "list",
            type: "list",
            defaultValue: [],
            subFields: [
                {
                    name: "title",
                    type: "text",
                    defaultValue: ""
                },
                {
                    name: "description",
                    type: "richText",
                    defaultValue: ""
                }
            ]
        },
        {
            name: "backgroundColor",
            type: "string",
            enum: Object.values(numerical_highlight_list_constants_BACKGROUND_COLORS),
            defaultValue: numerical_highlight_list_constants_BACKGROUND_COLORS.PLUM
        }
    ]
};
const numerical_highlight_list_builder_component_builderConfig = {
    component: numerical_highlight_list,
    config: NumericalHighlightListBuilderConfig
};
/* harmony default export */ var numerical_highlight_list_builder_component = (numerical_highlight_list_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/series-collection-article-block/series-collection-articles-block.module.scss
var series_collection_articles_block_module = __webpack_require__(24448);
var series_collection_articles_block_module_default = /*#__PURE__*/__webpack_require__.n(series_collection_articles_block_module);
;// CONCATENATED MODULE: ./components/series-collection-article-block/series-collection-articles-block.tsx





const SeriesCollectionArticles = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const { titleSeries , descriptionSeries , viewAllUrl , viewAllText , typeOfCard , categoryObject , articles , includeLargeCard , backgroundColor =""  } = props;
    let getViewAllUrl = (0,LangHelper/* localifyLink */.Bj)("/".concat(locale).concat(viewAllUrl), locale);
    const viewAllTexts = (viewAllText)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: viewAllText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                    type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                })
            ]
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (series_collection_articles_block_module_default()).seriesCollectionBlock,
        children: [
            backgroundColor ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (series_collection_articles_block_module_default())["seriesCollectionBlock".concat(backgroundColor.replace(" ", ""))]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (series_collection_articles_block_module_default()).seriesHeader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (series_collection_articles_block_module_default()).infoSeries,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (series_collection_articles_block_module_default()).title,
                                children: titleSeries
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (series_collection_articles_block_module_default()).description,
                                children: descriptionSeries
                            })
                        ]
                    }),
                    viewAllUrl === undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (series_collection_articles_block_module_default()).btnViewAll,
                        children: viewAllTexts(viewAllText)
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: getViewAllUrl,
                        className: (series_collection_articles_block_module_default()).btnViewAll,
                        children: viewAllTexts(viewAllText)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(headlining_articles_block, {
                cardData: articles,
                typeOfCard: typeOfCard,
                showSignupCard: false,
                includeLargeCard: includeLargeCard,
                debounce: true
            })
        ]
    });
};
/* harmony default export */ var series_collection_articles_block = (SeriesCollectionArticles);

;// CONCATENATED MODULE: ./components/series-collection-article-block/series-collection-articles-block.builder-component.ts



const SeriesCollectionArticlesBuilderConfig = {
    name: "Series Collection Articles",
    inputs: [
        {
            name: "titleSeries",
            type: "string"
        },
        {
            name: "descriptionSeries",
            type: "longText",
            defaultValue: ""
        },
        {
            name: "viewAllUrl",
            type: "url",
            defaultValue: ""
        },
        {
            name: "viewAllText",
            type: "string",
            defaultValue: ""
        },
        {
            name: "category",
            type: "dynamic-dropdown",
            options: {
                url: GET_ALL_CATEGORY,
                mapper: "({data}) => {\n                  return ({\n                    category: Object.values(data)[0].reduce((rs, curr) => {\n                      return [...rs, { value: curr.id, name: curr.name }]\n                    }, [])\n                  })\n                }",
                expectMultipleDropdowns: false
            }
        },
        {
            name: "typeOfCard",
            type: "string",
            defaultValue: headlining_articles_block_constants_TYPES_OF_CARD.ARTICLE,
            enum: Object.values(headlining_articles_block_constants_TYPES_OF_CARD)
        },
        {
            name: "includeLargeCard",
            type: "boolean",
            defaultValue: true
        },
        {
            name: "backgroundColor",
            type: "string",
            enum: [
                "Orca Pastel"
            ]
        }
    ]
};
const series_collection_articles_block_builder_component_builderConfig = {
    component: series_collection_articles_block,
    config: SeriesCollectionArticlesBuilderConfig
};
/* harmony default export */ var series_collection_articles_block_builder_component = (series_collection_articles_block_builder_component_builderConfig);

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(42132);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/trustpilot-widget/trustpilot-widget.module.scss
var trustpilot_widget_module = __webpack_require__(3253);
var trustpilot_widget_module_default = /*#__PURE__*/__webpack_require__.n(trustpilot_widget_module);
;// CONCATENATED MODULE: ./components/trustpilot-widget/trustpilot-widget.tsx





const TRUSTPILOT_CONFIG = {
    afterpay: {
        businessunitId: "56c5d65b0000ff0005891636",
        href: "https://www.trustpilot.com/review/afterpay.com"
    },
    clearpay: {
        businessunitId: "59e8a1f50000ff0005ae12db",
        href: "https://www.trustpilot.com/review/www.clearpay.co.uk"
    }
};
const TrustpilotWidget = (param)=>{
    let { id ="afterpay"  } = param;
    const config = TRUSTPILOT_CONFIG[id];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "text/javascript",
                    src: "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js",
                    async: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("trustpilot-widget", (trustpilot_widget_module_default())["trustpilot-widget-container"]),
                "data-locale": "en-US",
                "data-template-id": "5406e65db0d04a09e042d5fc",
                "data-businessunit-id": config.businessunitId,
                "data-style-height": "28px",
                "data-style-width": "100%",
                "data-theme": "light",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: config.href,
                    target: "_blank",
                    rel: "noopener",
                    children: "Trustpilot"
                })
            })
        ]
    });
};
/* harmony default export */ var trustpilot_widget = (TrustpilotWidget);

;// CONCATENATED MODULE: ./components/trustpilot-widget/trustpilot-widget.builder-component.ts

const TrustpilotWidgetBuilderConfig = {
    name: "Trustpilot Widget",
    inputs: [
        {
            name: "id",
            type: "string",
            defaultValue: "afterpay",
            enum: [
                "afterpay",
                "clearpay"
            ]
        }
    ]
};
const trustpilot_widget_builder_component_builderConfig = {
    component: trustpilot_widget,
    config: TrustpilotWidgetBuilderConfig
};
/* harmony default export */ var trustpilot_widget_builder_component = (trustpilot_widget_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/unordered-highlight-list/unordered-highlight-list.constants.ts
const unordered_highlight_list_constants_BACKGROUND_COLORS = {
    MINT: "mint",
    PLUM: "plum",
    GRAY: "gray"
};

// EXTERNAL MODULE: ./components/unordered-highlight-list/unordered-highlight-list.module.scss
var unordered_highlight_list_module = __webpack_require__(10715);
var unordered_highlight_list_module_default = /*#__PURE__*/__webpack_require__.n(unordered_highlight_list_module);
;// CONCATENATED MODULE: ./components/unordered-highlight-list/unordered-highlight-list.tsx




const UnorderedHighlightList = (props)=>{
    const { heading , list , backgroundColor =unordered_highlight_list_constants_BACKGROUND_COLORS.MINT  } = props;
    const getBackgroundColor = ()=>{
        const backgroundColorMap = {
            [unordered_highlight_list_constants_BACKGROUND_COLORS.MINT]: "#b2fce4",
            [unordered_highlight_list_constants_BACKGROUND_COLORS.PLUM]: "#EADDF2",
            [unordered_highlight_list_constants_BACKGROUND_COLORS.GRAY]: "#E7EAED"
        };
        return backgroundColorMap[backgroundColor];
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            backgroundColor: getBackgroundColor()
        },
        className: (unordered_highlight_list_module_default()).unorderedHighlightListContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (unordered_highlight_list_module_default()).unorderedHighlightHeading,
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: (unordered_highlight_list_module_default()).unorderedHighlightList,
                children: list.map((item)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (unordered_highlight_list_module_default()).unorderedHighlightItem,
                        dangerouslySetInnerHTML: {
                            __html: item.content
                        }
                    }, item.content);
                })
            })
        ]
    });
};
/* harmony default export */ var unordered_highlight_list = (UnorderedHighlightList);

;// CONCATENATED MODULE: ./components/unordered-highlight-list/unordered-highlight-list.builder-component.ts


const UnorderedHighlightListBuilderConfig = {
    name: "Unordered Highlight List",
    inputs: [
        {
            name: "heading",
            type: "string",
            defaultValue: "Heading"
        },
        {
            name: "list",
            type: "list",
            defaultValue: [],
            subFields: [
                {
                    name: "content",
                    type: "richText",
                    defaultValue: ""
                }
            ]
        },
        {
            name: "backgroundColor",
            type: "string",
            enum: Object.values(unordered_highlight_list_constants_BACKGROUND_COLORS),
            defaultValue: unordered_highlight_list_constants_BACKGROUND_COLORS.GRAY
        }
    ]
};
const unordered_highlight_list_builder_component_builderConfig = {
    component: unordered_highlight_list,
    config: UnorderedHighlightListBuilderConfig
};
/* harmony default export */ var unordered_highlight_list_builder_component = (unordered_highlight_list_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/video-card-section/video-card-section.module.scss
var video_card_section_module = __webpack_require__(393);
var video_card_section_module_default = /*#__PURE__*/__webpack_require__.n(video_card_section_module);
;// CONCATENATED MODULE: ./components/video-card-section/video-card-section.tsx



const VideoCardSection = (props)=>{
    const { children  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (video_card_section_module_default()).videoCardSection,
        children: children
    });
};
/* harmony default export */ var video_card_section = (VideoCardSection);

;// CONCATENATED MODULE: ./components/video-card-section/video-card-section.builder-component.ts


const VideoCardSectionWithChildren = (0,builder_react_es5/* withChildren */.u7)(video_card_section);
const VideoCardSectionBuilderConfig = {
    name: "Video Card Section"
};
const video_card_section_builder_component_builderConfig = {
    component: VideoCardSectionWithChildren,
    config: VideoCardSectionBuilderConfig
};
/* harmony default export */ var video_card_section_builder_component = (video_card_section_builder_component_builderConfig);

;// CONCATENATED MODULE: ./components/video-card-list-item/video-card-item/video-card-item.constants.ts
const video_card_item_constants_VIDEO_CARD_ITEM_TYPES = {
    DISCOUNT: "discount",
    IMAGE: "image",
    QUOTE: "quote",
    IMAGE_BRAND: "imageBrand",
    CTA_BLOCK: "CTABlock"
};

// EXTERNAL MODULE: ./components/video-card-list-item/video-card-item/video-card-item.module.scss
var video_card_item_module = __webpack_require__(29871);
var video_card_item_module_default = /*#__PURE__*/__webpack_require__.n(video_card_item_module);
;// CONCATENATED MODULE: ./components/video-card-list-item/video-card-item/video-card-item.tsx
/* eslint-disable @next/next/no-img-element */ 






const VideoCardItem = (props)=>{
    const { typeOfItem , discountContent ="" , discountText ="" , imageBrandUrl ="" , imageUrl ="" , authorName ="" , quote ="" , ctaContent ="" , ctaUrl ="" , discountPercentImage =""  } = props.item;
    const { isSingleBlock  } = props;
    const { ratio =[
        256,
        256
    ]  } = props;
    switch(typeOfItem){
        case video_card_item_constants_VIDEO_CARD_ITEM_TYPES.IMAGE_BRAND:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (video_card_item_module_default()).discountCarouselItemImageBrand,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: imageBrandUrl,
                    alt: ""
                })
            });
        case video_card_item_constants_VIDEO_CARD_ITEM_TYPES.IMAGE:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (video_card_item_module_default()).discountCarouselItemImage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_zoom, {
                    ratio: ratio,
                    src: imageUrl
                })
            });
        case video_card_item_constants_VIDEO_CARD_ITEM_TYPES.QUOTE:
            let quoteClassName = classnames_default()((video_card_item_module_default()).discountCarouselItemQuote);
            if (isSingleBlock) {
                quoteClassName = classnames_default()((video_card_item_module_default()).discountCarouselItemQuote, (video_card_item_module_default()).singleBlock);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: quoteClassName,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("q", {
                        className: (video_card_item_module_default()).discountCarouselItemQuoteContent,
                        children: quote
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (video_card_item_module_default()).discountCarouselItemQuoteAuthorName,
                        children: [
                            "- ",
                            authorName
                        ]
                    })
                ]
            });
        case video_card_item_constants_VIDEO_CARD_ITEM_TYPES.DISCOUNT:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (video_card_item_module_default()).discountCarouselItemDiscount,
                children: discountPercentImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(image_zoom, {
                    ratio: ratio,
                    src: discountPercentImage,
                    className: "image-discount"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (video_card_item_module_default()).discountCarouselItemDiscountPercent,
                            children: discountContent
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (video_card_item_module_default()).discountCarouselItemDiscountText,
                            children: discountText
                        })
                    ]
                })
            });
        case video_card_item_constants_VIDEO_CARD_ITEM_TYPES.CTA_BLOCK:
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (video_card_item_module_default()).discountCarouselItemCTABlock,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (video_card_item_module_default()).discountCarouselItemCTABlockContent,
                        children: [
                            ctaContent,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (video_card_item_module_default()).discountCarouselItemCTABlockBtn,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Click here"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: (video_card_item_module_default()).discountCarouselItemCTABlockUrl,
                        href: ctaUrl,
                        target: "_self"
                    })
                ]
            });
        default:
            return null;
    }
};
/* harmony default export */ var video_card_item = (VideoCardItem);

// EXTERNAL MODULE: ./components/video-card-list-item/video-card-list-item.module.scss
var video_card_list_item_module = __webpack_require__(55957);
var video_card_list_item_module_default = /*#__PURE__*/__webpack_require__.n(video_card_list_item_module);
;// CONCATENATED MODULE: ./components/video-card-list-item/video-card-list-item.tsx











const VideoCardListItem = (props)=>{
    const { items  } = props;
    const prevRef = (0,react.useRef)(null);
    const nextRef = (0,react.useRef)(null);
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const windowWidth = windowSize.width || 0;
    (0,react.useEffect)(()=>{
        setTimeout(()=>{
            aos_default().init({
                duration: 1200
            });
        }, 500);
    }, []);
    const animationOption = (type)=>{
        if (type === "slider" && windowWidth < 1200) {
            return {
                "data-aos": "fade-up",
                "data-aos-anchor-placement": "bottom-bottom"
            };
        }
        if (type === "slideItem" && windowWidth > 1200) {
            return {
                "data-aos": "fade-up",
                "data-aos-anchor-placement": "bottom-bottom"
            };
        }
        return null;
    };
    const countImageInItems = (items)=>{
        const imagesItem = items.filter((item)=>item.typeOfItem === video_card_item_constants_VIDEO_CARD_ITEM_TYPES.IMAGE);
        var ref;
        const secondImage = (ref = imagesItem[1]) !== null && ref !== void 0 ? ref : null;
        const indexOfSecondImage = items.indexOf(secondImage);
        return {
            count: imagesItem.length,
            secondImageIndex: indexOfSecondImage
        };
    };
    const handleSliderItemClassName = (item, index)=>{
        let slideClassName = classnames_default()((video_card_list_item_module_default()).discountCarouselSlide);
        let ratio = [
            256,
            256
        ];
        let isSingleBlock = false;
        const numberOfItems = items.length;
        const imageAmount = countImageInItems(items).count;
        const secondImage = countImageInItems(items).secondImageIndex;
        if (numberOfItems % 5 !== 0 && item.typeOfItem === video_card_item_constants_VIDEO_CARD_ITEM_TYPES.QUOTE) {
            slideClassName = classnames_default()((video_card_list_item_module_default()).discountCarouselSlide);
            isSingleBlock = true;
        }
        if (numberOfItems % 5 === 0 && item.typeOfItem === video_card_item_constants_VIDEO_CARD_ITEM_TYPES.QUOTE) {
            slideClassName = classnames_default()((video_card_list_item_module_default()).discountCarouselSlide, (video_card_list_item_module_default()).columnSpanQuote);
        }
        if (numberOfItems % 5 === 0 && item.typeOfItem === video_card_item_constants_VIDEO_CARD_ITEM_TYPES.QUOTE && imageAmount >= 2) {
            slideClassName = classnames_default()((video_card_list_item_module_default()).discountCarouselSlide);
            isSingleBlock = true;
        }
        if (numberOfItems % 4 === 0 && item.typeOfItem === video_card_item_constants_VIDEO_CARD_ITEM_TYPES.IMAGE) {
            slideClassName = classnames_default()((video_card_list_item_module_default()).discountCarouselSlide);
        }
        if (numberOfItems % 4 !== 0 && item.typeOfItem === video_card_item_constants_VIDEO_CARD_ITEM_TYPES.IMAGE) {
            slideClassName = classnames_default()((video_card_list_item_module_default()).discountCarouselSlide, (video_card_list_item_module_default()).columnSpan);
            ratio = windowWidth > 1200 ? [
                536,
                256
            ] : [
                256,
                256
            ];
        }
        if (numberOfItems % 4 !== 0 && item.typeOfItem === video_card_item_constants_VIDEO_CARD_ITEM_TYPES.IMAGE && imageAmount >= 2) {
            slideClassName = classnames_default()((video_card_list_item_module_default()).discountCarouselSlide);
            ratio = [
                256,
                256
            ];
        }
        if (item.typeOfItem === video_card_item_constants_VIDEO_CARD_ITEM_TYPES.IMAGE && index === secondImage) {
            slideClassName = classnames_default()((video_card_list_item_module_default()).discountCarouselSlide, (video_card_list_item_module_default()).columnSpan);
            ratio = windowWidth > 1200 ? [
                536,
                256
            ] : [
                256,
                256
            ];
        }
        if (item.typeOfItem === video_card_item_constants_VIDEO_CARD_ITEM_TYPES.QUOTE && imageAmount >= 2) {
            slideClassName = classnames_default()((video_card_list_item_module_default()).discountCarouselSlide, (video_card_list_item_module_default()).columnSpanQuote);
            isSingleBlock = false;
        }
        return {
            slideClassName: slideClassName,
            ratio: ratio,
            isSingleBlock: isSingleBlock
        };
    };
    const renderSliderItem = (item, index)=>{
        const className = handleSliderItemClassName(item, index).slideClassName;
        const ratio = handleSliderItemClassName(item, index).ratio;
        const isSingleBlock = handleSliderItemClassName(item, index).isSingleBlock;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
            className: className,
            ...animationOption("slideItem"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(video_card_item, {
                item: item,
                ratio: ratio,
                isSingleBlock: isSingleBlock
            })
        }, index);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (video_card_list_item_module_default()).discountCarousel,
        ...animationOption("slider"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: nextRef,
                className: (video_card_list_item_module_default()).discountCarouselButtonNext,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                    type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: prevRef,
                className: (video_card_list_item_module_default()).discountCarouselButtonPrev,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                    type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                className: (video_card_list_item_module_default()).discountCarouselSlider,
                grabCursor: true,
                navigation: {
                    prevEl: prevRef.current ? prevRef.current : undefined,
                    nextEl: nextRef.current ? nextRef.current : undefined
                },
                onInit: (swiper)=>{
                    if (!swiper) {
                        return;
                    }
                    const navigation = swiper === null || swiper === void 0 ? void 0 : swiper.params.navigation;
                    navigation.prevEl = prevRef.current;
                    navigation.nextEl = nextRef.current;
                    swiper.navigation.init();
                    swiper.navigation.update();
                },
                slidesPerView: "auto",
                spaceBetween: 24,
                breakpoints: {
                    320: {
                        centeredSlides: true,
                        spaceBetween: 15
                    },
                    768: {
                        spaceBetween: 24,
                        centeredSlides: false
                    }
                },
                centeredSlides: false,
                centeredSlidesBounds: true,
                watchOverflow: true,
                updateOnWindowResize: true,
                lazyPreloadPrevNext: 1,
                children: items.map((item, index)=>renderSliderItem(item, index))
            })
        ]
    });
};
/* harmony default export */ var video_card_list_item = (VideoCardListItem);

;// CONCATENATED MODULE: ./components/video-card/video-card.constants.ts
const video_card_constants_VIDEO_POSITIONS = {
    LEFT: "left",
    RIGHT: "right"
};

// EXTERNAL MODULE: ./components/video-card/video-card.module.scss
var video_card_module = __webpack_require__(26775);
var video_card_module_default = /*#__PURE__*/__webpack_require__.n(video_card_module);
;// CONCATENATED MODULE: ./components/video-card/video-card.tsx
/* eslint-disable @next/next/no-img-element */ 











const VideoCard = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const { borderColor =DEFAULT_BACKGROUND_COLORS.MINT , leadImage , title , description , mediaPosition ="left" , ctaText , ctaIcon , imageBrand , videoCardItems , sectionId  } = props;
    const url = props.href || "";
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const windowWidth = windowSize.width || 0;
    (0,react.useEffect)(()=>{
        setTimeout(()=>{
            aos_default().init({
                duration: 1200
            });
        }, 500);
    }, []);
    const animationOption = function(type) {
        let delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "300";
        const handleDataAos = (type, mediaPosition)=>{
            if (type === "media" && mediaPosition === "left") {
                return "right";
            }
            if (type === "media" && mediaPosition === "right") {
                return "left";
            }
            return mediaPosition;
        };
        return {
            "data-aos": "fade-" + handleDataAos(type, mediaPosition),
            "data-aos-delay": delay
        };
    };
    const renderMediaContent = ()=>{
        const imageRatio = windowWidth < 786 ? [
            313,
            311
        ] : [
            424,
            552
        ];
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (video_card_module_default()).mediaImageContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (video_card_module_default()).mediaImageContainerButtonPlay,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                        type: icons/* IconType.Triangle */.T.Triangle
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(image_zoom, {
                    src: leadImage,
                    ratio: imageRatio
                })
            ]
        });
    };
    const mediaBlock = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((video_card_module_default()).videoCardMediaContainer, " ").concat((video_card_module_default())[mediaPosition]),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (video_card_module_default()).videoCardMedia,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((video_card_module_default()).mediaImageWrapper, " ").concat((video_card_module_default())[mediaPosition]),
                        ...animationOption("media", "300"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (video_card_module_default()).mediaImageBox,
                            children: [
                                renderMediaContent(),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: url,
                                    target: "_self",
                                    className: (video_card_module_default()).mediaImageLink
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((video_card_module_default()).mediaBackground, " ").concat((video_card_module_default())[mediaPosition]),
                        style: {
                            borderColor: mapNameToColour(borderColor)
                        },
                        "data-aos": "fade-up",
                        "data-aos-easing": "linear",
                        "data-aos-anchor-placement": "top-center",
                        "data-aos-duration": "500"
                    })
                ]
            })
        });
    const infoBlock = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((video_card_module_default()).videoCardInfo, " ").concat((video_card_module_default())[mediaPosition]),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: imageBrand,
                    alt: "",
                    className: (video_card_module_default()).infoImageBrand,
                    ...animationOption("info", "250")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (video_card_module_default()).infoTitle,
                    dangerouslySetInnerHTML: {
                        __html: title
                    },
                    ...animationOption("info", "300")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (video_card_module_default()).infoDescription,
                    dangerouslySetInnerHTML: {
                        __html: description
                    },
                    ...animationOption("info", "350")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: url,
                    target: "_self",
                    className: (video_card_module_default()).infoCTA,
                    ...animationOption("info", "350"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: ctaText !== null && ctaText !== void 0 ? ctaText : "Watch Now"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: ctaIcon !== null && ctaIcon !== void 0 ? ctaIcon : icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                        })
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (video_card_module_default()).videoCard,
        id: sectionId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (video_card_module_default()).videoCardContainer,
                children: [
                    mediaPosition === video_card_constants_VIDEO_POSITIONS.LEFT ? mediaBlock() : null,
                    infoBlock(),
                    mediaPosition === video_card_constants_VIDEO_POSITIONS.RIGHT ? mediaBlock() : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(video_card_list_item, {
                items: videoCardItems
            })
        ]
    });
};
/* harmony default export */ var video_card = (VideoCard);

;// CONCATENATED MODULE: ./components/video-card/video-card.builder-component.ts





const VideoCardBuilderConfig = {
    name: "VideoCard",
    inputs: [
        {
            name: "leadImage",
            type: "file",
            defaultValue: ""
        },
        {
            name: "imageBrand",
            type: "file"
        },
        {
            name: "title",
            type: "string",
            defaultValue: ""
        },
        {
            name: "description",
            type: "richText",
            defaultValue: ""
        },
        {
            name: "href",
            type: "url"
        },
        {
            name: "ctaText",
            type: "string",
            defaultValue: ""
        },
        {
            name: "ctaIcon",
            type: "string",
            enum: [
                icons/* IconType.Download */.T.Download,
                icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
            ]
        },
        {
            name: "mediaPosition",
            type: "string",
            enum: Object.values(video_card_constants_VIDEO_POSITIONS),
            defaultValue: video_card_constants_VIDEO_POSITIONS.LEFT
        },
        {
            name: "videoCardItems",
            type: "list",
            defaultValue: [],
            subFields: [
                {
                    name: "typeOfItem",
                    type: "string",
                    enum: Object.values(video_card_item_constants_VIDEO_CARD_ITEM_TYPES),
                    defaultValue: video_card_item_constants_VIDEO_CARD_ITEM_TYPES.DISCOUNT
                },
                {
                    name: "imageBrandUrl",
                    type: "file",
                    helperText: "Use for item type image brand"
                },
                {
                    name: "discountPercentImage",
                    type: "file",
                    defaultValue: "",
                    helperText: "Use for item type discount"
                },
                {
                    name: "discountContent",
                    type: "string",
                    defaultValue: "+74%",
                    helperText: "Use for item type discount"
                },
                {
                    name: "discountText",
                    type: "text",
                    defaultValue: "",
                    helperText: "Use for item type discount"
                },
                {
                    name: "imageUrl",
                    type: "file",
                    defaultValue: "",
                    helperText: "Use for item type image"
                },
                {
                    name: "quote",
                    type: "text",
                    defaultValue: "",
                    helperText: "Use for item type quote"
                },
                {
                    name: "authorName",
                    type: "text",
                    defaultValue: "",
                    helperText: "Use for item type quote"
                },
                {
                    name: "ctaContent",
                    type: "text",
                    defaultValue: "",
                    helperText: "Use for item type CTABlock"
                },
                {
                    name: "ctaUrl",
                    type: "text",
                    defaultValue: "",
                    helperText: "Use for item type CTABlock"
                }
            ]
        },
        {
            name: "borderColor",
            type: "string",
            enum: Object.values(DEFAULT_BACKGROUND_COLORS),
            defaultValue: DEFAULT_BACKGROUND_COLORS.MINT
        },
        {
            name: "sectionId",
            type: "string",
            defaultValue: "",
            helperText: "This field must be the same with sectionId above the carousel Item"
        }
    ]
};
const video_card_builder_component_builderConfig = {
    component: video_card,
    config: VideoCardBuilderConfig
};
/* harmony default export */ var video_card_builder_component = (video_card_builder_component_builderConfig);

// EXTERNAL MODULE: ./components/video-carousel/video-carousel.module.scss
var video_carousel_module = __webpack_require__(46223);
var video_carousel_module_default = /*#__PURE__*/__webpack_require__.n(video_carousel_module);
;// CONCATENATED MODULE: ./components/video-carousel/video-carousel.tsx
/* eslint-disable @next/next/no-img-element */ 










swiper/* default.use */.Z.use([
    modules/* Navigation */.W_
]);
const video_carousel_VideoCarousel = (props)=>{
    const { videoCarouselItems , onItemChange  } = props;
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const windowWidth = windowSize.width || 0;
    const prevRef = (0,react.useRef)(null);
    const nextRef = (0,react.useRef)(null);
    if (!videoCarouselItems || videoCarouselItems.length <= 0) {
        return null;
    }
    const spaceWhenScroll = windowWidth > 786 ? -150 : -30;
    const renderVideoCarouselItem = (item)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
            className: (video_carousel_module_default()).videoItem,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (video_carousel_module_default()).videoItemContainer,
                onClick: ()=>scrollToById(item.sectionId, {
                        detalY: spaceWhenScroll
                    }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_zoom, {
                    src: item.thumbnailUrl,
                    ratio: [
                        424,
                        424
                    ],
                    className: (video_carousel_module_default()).videoItemThumbnailUrl
                })
            })
        }, item.name);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (video_carousel_module_default()).videoCarousel,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: nextRef,
                className: (video_carousel_module_default()).videoCarouselButtonNext,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                    type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: prevRef,
                className: (video_carousel_module_default()).videoCarouselButtonPrev,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                    type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                grabCursor: true,
                navigation: {
                    prevEl: prevRef.current ? prevRef.current : undefined,
                    nextEl: nextRef.current ? nextRef.current : undefined
                },
                onInit: (swiper)=>{
                    if (!swiper) {
                        return;
                    }
                    const navigation = swiper === null || swiper === void 0 ? void 0 : swiper.params.navigation;
                    navigation.prevEl = prevRef.current;
                    navigation.nextEl = nextRef.current;
                    swiper.navigation.init();
                    swiper.navigation.update();
                },
                slidesPerView: "auto",
                spaceBetween: 24,
                breakpoints: {
                    320: {
                        centeredSlides: true,
                        spaceBetween: 15
                    },
                    768: {
                        spaceBetween: 24,
                        centeredSlides: true
                    }
                },
                onSlideChange: (swiper)=>{
                    if (onItemChange) {
                        onItemChange(swiper.realIndex);
                    }
                },
                loop: true,
                centeredSlides: true,
                watchOverflow: true,
                lazyPreloadPrevNext: 1,
                updateOnWindowResize: true,
                children: videoCarouselItems.map((item)=>renderVideoCarouselItem(item))
            }, "video_carousel")
        ]
    });
};
/* harmony default export */ var video_carousel = (video_carousel_VideoCarousel);

// EXTERNAL MODULE: ./components/video-carousel/video-carousel-quote/video-carousel-quote.module.scss
var video_carousel_quote_module = __webpack_require__(25558);
var video_carousel_quote_module_default = /*#__PURE__*/__webpack_require__.n(video_carousel_quote_module);
;// CONCATENATED MODULE: ./components/video-carousel/video-carousel-quote/video-carousel-quote-item.tsx



const VideoCarouselQuoteItem = (param)=>{
    let { quote , authorQuote  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (video_carousel_quote_module_default()).videoCarouselQuoteItem,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("q", {
                className: (video_carousel_quote_module_default()).videoCarouselQuoteItemContent,
                children: quote
            }),
            authorQuote && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (video_carousel_quote_module_default()).videoCarouselQuoteItemAuthorName,
                children: [
                    "- ",
                    authorQuote
                ]
            })
        ]
    });
};
/* harmony default export */ var video_carousel_quote_item = (VideoCarouselQuoteItem);

;// CONCATENATED MODULE: ./components/video-carousel/video-carousel-wrapper.tsx
/* eslint-disable @next/next/no-img-element */ 





const VideoCarouselWrapper = (props)=>{
    const { videoCarouselItems  } = props;
    const [swiper, setSwiper] = (0,react.useState)(null);
    const quotes = videoCarouselItems.map((item)=>{
        const quote = {
            quote: item.quote,
            authorQuote: item.authorQuote
        };
        return quote;
    });
    const onItemChange = (index)=>{
        swiper === null || swiper === void 0 ? void 0 : swiper.slideTo(index, 1000);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (video_carousel_module_default()).videoCarouselWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(video_carousel, {
                videoCarouselItems: videoCarouselItems,
                onItemChange: onItemChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (video_carousel_module_default()).videoCarouselQuoteContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (video_carousel_module_default()).videoCarouselQuoteContainerDivider
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        direction: "vertical",
                        spaceBetween: 40,
                        className: (video_carousel_module_default()).videoCarouselQuote,
                        autoHeight: true,
                        onSwiper: setSwiper,
                        children: quotes.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(video_carousel_quote_item, {
                                    quote: item.quote,
                                    authorQuote: item.authorQuote
                                })
                            }, "quote_key_".concat(index)))
                    }, "video_carousel_quote")
                ]
            })
        ]
    });
};
/* harmony default export */ var video_carousel_wrapper = (VideoCarouselWrapper);

;// CONCATENATED MODULE: ./components/video-carousel/video-carousel.builder-component.ts

const VideoCarouselBuilderConfig = {
    name: "Video Carousel",
    inputs: [
        {
            name: "videoCarouselItems",
            type: "list",
            subFields: [
                {
                    name: "thumbnailUrl",
                    type: "file"
                },
                {
                    name: "quote",
                    type: "text",
                    defaultValue: ""
                },
                {
                    name: "authorQuote",
                    type: "text",
                    defaultValue: ""
                },
                {
                    name: "sectionId",
                    type: "string",
                    defaultValue: "",
                    helperText: "This is id for scroll to section below."
                }
            ]
        }
    ]
};
const video_carousel_builder_component_builderConfig = {
    component: video_carousel_wrapper,
    config: VideoCarouselBuilderConfig
};
/* harmony default export */ var video_carousel_builder_component = (video_carousel_builder_component_builderConfig);

;// CONCATENATED MODULE: ./hook/useScroll.ts

const EmptySSRRect = {
    bottom: 0,
    height: 0,
    left: 0,
    right: 0,
    top: 0,
    width: 0,
    x: 0,
    y: 0
};
const useScroll = ()=>{
    const [bodyOffset, setBodyOffset] = (0,react.useState)( false || !window.document ? EmptySSRRect : document.body.getBoundingClientRect());
    const [scrollY, setScrollY] = (0,react.useState)(bodyOffset.top);
    const [scrollX, setScrollX] = (0,react.useState)(bodyOffset.left);
    const [scrollDirection, setScrollDirection] = (0,react.useState)();
    const listener = ()=>{
        setBodyOffset( false || !window.document ? EmptySSRRect : document.body.getBoundingClientRect());
        setScrollY(-bodyOffset.top);
        setScrollX(bodyOffset.left);
        setScrollDirection(scrollY > -bodyOffset.top ? "up" : "down");
    };
    (0,react.useEffect)(()=>{
        window.addEventListener("scroll", listener);
        return ()=>{
            window.removeEventListener("scroll", listener);
        };
    });
    return {
        scrollY,
        scrollX,
        scrollDirection
    };
};


// EXTERNAL MODULE: ./components/video-hero/video-hero.module.scss
var video_hero_module = __webpack_require__(15719);
var video_hero_module_default = /*#__PURE__*/__webpack_require__.n(video_hero_module);
;// CONCATENATED MODULE: ./components/video-hero/video-hero.tsx






const VideoHero = (props)=>{
    const { vimeoId , videoContent , children  } = props;
    const { scrollY  } = useScroll();
    const [isVimeoPause, setIsVimeoPause] = (0,react.useState)(false);
    const [volume, setVolume] = (0,react.useState)(0);
    const vimeoRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        var ref, ref1;
        const offsetHeight = (vimeoRef === null || vimeoRef === void 0 ? void 0 : (ref = vimeoRef.current) === null || ref === void 0 ? void 0 : ref.offsetHeight) || 0;
        const offsetTop = (vimeoRef === null || vimeoRef === void 0 ? void 0 : (ref1 = vimeoRef.current) === null || ref1 === void 0 ? void 0 : ref1.offsetTop) || 0;
        if (scrollY > offsetTop + offsetHeight) {
            setIsVimeoPause(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scrollY
    ]);
    const [width, height] = Media/* MEDIA_RATIO.16:9 */.r["16:9"];
    const vimeoVideoPaddingTop = height / width * 100;
    const handleOnPlay = ()=>{
        setIsVimeoPause(false);
        setVolume(0.5);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (video_hero_module_default()).videoHero,
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (video_hero_module_default()).videoHeroContainer,
                ref: vimeoRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (video_hero_module_default()).vimeoVideo,
                    style: {
                        paddingTop: "".concat(vimeoVideoPaddingTop, "%")
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_vimeo_es, {
                        video: vimeoId,
                        muted: true,
                        paused: isVimeoPause,
                        volume: volume,
                        onPlay: handleOnPlay,
                        onVolumeChange: (e)=>setVolume(e.volume)
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (video_hero_module_default()).videoHeroContent,
                dangerouslySetInnerHTML: {
                    __html: videoContent
                }
            })
        ]
    });
};
/* harmony default export */ var video_hero = (VideoHero);

;// CONCATENATED MODULE: ./components/video-hero/video-hero.builder-component.ts

const VideoHeroBuilderConfig = {
    name: "Video Hero",
    inputs: [
        {
            name: "vimeoId",
            type: "string",
            require: true
        },
        {
            name: "videoContent",
            type: "richText"
        }
    ]
};
const video_hero_builder_component_builderConfig = {
    component: video_hero,
    config: VideoHeroBuilderConfig
};
/* harmony default export */ var video_hero_builder_component = (video_hero_builder_component_builderConfig);

// EXTERNAL MODULE: ./models/BusinessIndustries.ts
var BusinessIndustries = __webpack_require__(71354);
;// CONCATENATED MODULE: ./builder/index.ts


// @ts-ignore - Suppressing "unable to find module" error because webpack preloader will load all matching files



















































































































let builderComponentConfigs = [
    b2b_access_hero_builder_component_namespaceObject,
    b2b_article_grid_builder_component_namespaceObject,
    b2b_carousel_lifecycle_builder_component_namespaceObject,
    b2b_category_feature_builder_component_namespaceObject,
    b2b_collapse_builder_component_namespaceObject,
    b2b_faq_builder_component_namespaceObject,
    b2b_framed_info_block_builder_component_namespaceObject,
    b2b_good_for_builder_component_namespaceObject,
    b2b_headlining_latest_articles_builder_component_namespaceObject,
    b2b_hero_builder_component_namespaceObject,
    b2b_integrations_builder_component_namespaceObject,
    b2b_learning_series_block_builder_component_namespaceObject,
    b2b_list_card_resources_builder_component_namespaceObject,
    b2b_online_payment_builder_component_namespaceObject,
    b2b_platform_builder_component_namespaceObject,
    b2b_scrolling_content_builder_component_namespaceObject,
    b2b_series_collection_articles_block_builder_component_namespaceObject,
    b2b_trending_topics_builder_component_namespaceObject,
    b2b_video_card_builder_component_namespaceObject,
    b2b_video_carousel_builder_component_namespaceObject,
    b2b_video_list_builder_component_namespaceObject,
    business_article_grid_builder_component_namespaceObject,
    business_featured_article_hero_builder_component_namespaceObject,
    business_article_image_builder_component_namespaceObject,
    business_article_quote_wrap_builder_component_namespaceObject,
    business_button_wrap_builder_component_namespaceObject,
    business_collapse_builder_component_namespaceObject,
    business_emphasized_text_builder_component_namespaceObject,
    business_framed_info_block_builder_component_namespaceObject,
    business_headlining_latest_articles_builder_component_namespaceObject,
    business_hub_build_for_industry_builder_component_namespaceObject,
    business_hub_carousel_lifecycle_builder_component_namespaceObject,
    business_hub_carousel_product_builder_component_namespaceObject,
    business_hub_faq_builder_component_namespaceObject,
    business_hub_gateway_builder_component_namespaceObject,
    business_hub_good_for_builder_component_namespaceObject,
    business_hub_good_for_business_hub_good_for_builder_component_namespaceObject,
    business_hub_hero_enterprise_builder_component_namespaceObject,
    business_hub_hero_home_builder_component_namespaceObject,
    business_hub_hero_industry_builder_component_namespaceObject,
    business_hub_hero_training_builder_component_namespaceObject,
    business_hub_how_ap_works_builder_component_namespaceObject,
    business_hub_how_it_works_builder_component_namespaceObject,
    business_hub_image_block_full_builder_component_namespaceObject,
    business_hub_image_block_builder_component_namespaceObject,
    business_hub_image_hero_builder_component_namespaceObject,
    business_hub_In_action_carousel_builder_component_namespaceObject,
    business_hub_industries_card_block_builder_component_namespaceObject,
    business_hub_industries_carousel_builder_component_namespaceObject,
    business_hub_industries_grid_builder_component_namespaceObject,
    business_hub_industries_optional_quote_builder_component_namespaceObject,
    business_hub_industries_stats_builder_component_namespaceObject,
    business_hub_integrations_builder_component_namespaceObject,
    business_hub_list_card_resources_builder_component_namespaceObject,
    business_hub_list_e_commerce_builder_component_namespaceObject,
    business_hub_online_payment_builder_component_namespaceObject,
    business_hub_platform_integrations_builder_component_namespaceObject,
    business_hub_platform_builder_component_namespaceObject,
    business_hub_solutions_builder_component_namespaceObject,
    business_hub_stats_builder_component_namespaceObject,
    business_hub_trusted_brand_builder_component_namespaceObject,
    business_hub_used_by_builder_component_namespaceObject,
    business_hub_video_hero_builder_component_namespaceObject,
    business_resource_asset_container_builder_component_namespaceObject,
    business_resource_grid_builder_component_namespaceObject,
    business_resource_asset_library_builder_component_namespaceObject,
    business_resource_background_text_wrap_builder_component_namespaceObject,
    business_resource_asset_builder_component_namespaceObject,
    business_resource_banners_builder_component_namespaceObject,
    business_resource_card_builder_component_namespaceObject,
    business_resource_centre_hero_builder_component_namespaceObject,
    business_resource_colour_palette_builder_component_namespaceObject,
    business_resource_divider_builder_component_namespaceObject,
    business_resource_download_all_button_builder_component_namespaceObject,
    business_resource_download_card_builder_component_namespaceObject,
    business_resource_download_grid_builder_component_namespaceObject,
    business_resource_faq_builder_component_namespaceObject,
    business_resource_hero_sub_builder_component_namespaceObject,
    business_resource_hiws_builder_component_namespaceObject,
    business_resource_image_carousel_builder_component_namespaceObject,
    business_resource_image_comparison_slider_builder_component_namespaceObject,
    business_resource_in_situ_builder_component_namespaceObject,
    business_resource_lightbox_builder_component_namespaceObject,
    business_resource_logo_usage_builder_component_namespaceObject,
    business_resource_logos_builder_component_namespaceObject,
    business_resource_messaging_builder_component_namespaceObject,
    business_resource_page_title_builder_component_namespaceObject,
    business_resource_price_breakdown_builder_component_namespaceObject,
    business_image_grid_slider_builder_component_namespaceObject,
    business_resource_super_text_builder_component_namespaceObject,
    business_resource_text_highlight_builder_component_namespaceObject,
    business_resource_text_list_builder_component_namespaceObject,
    business_resource_text_wrap_builder_component_namespaceObject,
    business_resource_top_strips_builder_component_namespaceObject,
    business_resource_training_block_builder_component_namespaceObject,
    business_resource_typography_review_builder_component_namespaceObject,
    business_resource_value_block_builder_component_namespaceObject,
    business_resource_video_list_builder_component_namespaceObject,
    business_text_caption_builder_component_namespaceObject,
    business_text_wrap_builder_component_namespaceObject,
    business_trending_topics_builder_component_namespaceObject,
    business_vimeo_embed_wrap_builder_component_namespaceObject,
    business_youtube_embed_builder_component_namespaceObject,
    business_video_player_builder_component_namespaceObject,
    category_feature_builder_component_namespaceObject,
    category_hero_builder_component_namespaceObject,
    learning_series_block_builder_component_namespaceObject,
    numerical_highlight_list_builder_component_namespaceObject,
    series_collection_articles_block_builder_component_namespaceObject,
    trustpilot_widget_builder_component_namespaceObject,
    unordered_highlight_list_builder_component_namespaceObject,
    video_card_section_builder_component_namespaceObject,
    video_card_builder_component_namespaceObject,
    video_carousel_builder_component_namespaceObject,
    video_hero_builder_component_namespaceObject
];


















index_esm/* builder.init */.fl.init(env/* BUILDER_API_KEY */.uT);
const registerComponents = ()=>{
    for (const exports of builderComponentConfigs){
        if (Object.hasOwnProperty.call(exports, "default")) {
            const { component , config  } = exports.default;
            if (component && config) {
                //     console.log({component});
                index_esm/* Builder.registerComponent */.Ib.registerComponent(component, config);
            }
        }
    }
};
const awaitBuilderData = async (page, lang)=>{
    return await (0,dist.getAsyncProps)(page, {
        "Full Width Featured Article Hero": async (props)=>{
            const articles = await (0,BuilderHelper/* getLatestArticles */.gg)({
                locale: lang,
                offset: 0,
                limit: 1
            });
            return {
                article: articles === null || articles === void 0 ? void 0 : articles[0]
            };
        },
        [B2BAccessHeroBuilderConfig.name]: async (props)=>{
            const articles = await (0,BuilderHelper/* getLatestArticles */.gg)({
                locale: lang,
                offset: 0,
                limit: 1
            });
            return {
                article: articles === null || articles === void 0 ? void 0 : articles[0]
            };
        },
        [HeadliningLatestArticlesBuilderConfig.name]: async (props)=>{
            var _offset;
            const articles = await (0,BuilderHelper/* getLatestArticles */.gg)({
                locale: lang,
                offset: (_offset = props.offset) !== null && _offset !== void 0 ? _offset : 1,
                limit: 3
            });
            return {
                articles
            };
        },
        [B2BHeadliningLatestArticlesBuilderConfig.name]: async (props)=>{
            var _offset;
            const articles = await (0,BuilderHelper/* getLatestArticles */.gg)({
                locale: lang,
                offset: (_offset = props.offset) !== null && _offset !== void 0 ? _offset : 1,
                limit: 3
            });
            return {
                articles
            };
        },
        [LearningSeriesBlockPropsBuilderConfig.name]: async (props)=>{
            const { category1 , category2 , category3  } = props;
            const categories = [
                category1 || "",
                category2 || "",
                category3 || ""
            ].filter((category)=>!!category);
            let seriesData = [];
            if (categories && categories.length) {
                const foundCategories = await (0,BuilderHelper/* getCategoriesFromIDs */.nq)(categories);
                for (const category of foundCategories){
                    const articles = await (0,BuilderHelper/* getAllArticles */.zC)(lang, {
                        categoryIds: [
                            category.id
                        ],
                        limit: 30
                    });
                    seriesData.push({
                        category: category,
                        articleCount: articles.length
                    });
                }
            }
            return {
                seriesData
            };
        },
        [BusinessArticleGridBuilderConfig.name]: async (props)=>{
            return {
                initialArticles: await (0,BuilderHelper/* getLatestArticles */.gg)({
                    locale: lang,
                    offset: 1,
                    limit: 9
                })
            };
        },
        [B2BArticleGridBuilderConfig.name]: async (props)=>{
            return {
                initialArticles: await (0,BuilderHelper/* getLatestArticles */.gg)({
                    locale: lang,
                    offset: 1,
                    limit: 9
                })
            };
        },
        [CategoryFeatureBuilderConfig.name]: async (props)=>{
            let category;
            let articles = [];
            if (typeof props.category === "string") {
                category = await (0,BuilderHelper/* getCategoryFromID */.s$)(props.category);
            } else {
                category = props.category;
            }
            if (category) {
                articles = await (0,BuilderHelper/* getArticlesByCategory */.Zd)({
                    locale: lang,
                    limit: 3,
                    categoryIds: [
                        category.id
                    ]
                });
            }
            return {
                category,
                categoryArticles: articles
            };
        },
        [B2BCategoryFeatureBuilderConfig.name]: async (props)=>{
            let category;
            let articles = [];
            if (typeof props.category === "string") {
                category = await (0,BuilderHelper/* getCategoryFromID */.s$)(props.category);
            } else {
                category = props.category;
            }
            if (category) {
                articles = await (0,BuilderHelper/* getArticlesByCategory */.Zd)({
                    locale: lang,
                    limit: 3,
                    categoryIds: [
                        category.id
                    ]
                });
            }
            return {
                category,
                categoryArticles: articles
            };
        },
        [BusinessTrendingTopicsBuilderConfig.name]: async (props)=>{
            const categoryIds = props.categories.map((category)=>category.categoryId);
            const fetchedCategories = await (0,BuilderHelper/* getCategoriesFromIDs */.nq)(categoryIds);
            // Create a temporary key object that's sorted in the way that it comes from Builder
            const keyOrder = {};
            categoryIds.forEach((id)=>{
                keyOrder[id] = undefined;
            });
            // Then loop though the objects we just got to make sure they're in the same order.
            fetchedCategories.forEach((newCategory)=>{
                keyOrder[newCategory.id] = newCategory;
            });
            // and now set the categories to Object.value'd version of the order.
            // Voila - easy sort
            const categoryData = Object.values(keyOrder);
            return {
                categoryData
            };
        },
        [B2BTrendingTopicsBuilderConfig.name]: async (props)=>{
            const categoryIds = props.categories.map((category)=>category.categoryId);
            const fetchedCategories = await (0,BuilderHelper/* getCategoriesFromIDs */.nq)(categoryIds);
            // Create a temporary key object that's sorted in the way that it comes from Builder
            const keyOrder = {};
            categoryIds.forEach((id)=>{
                keyOrder[id] = undefined;
            });
            // Then loop though the objects we just got to make sure they're in the same order.
            fetchedCategories.forEach((newCategory)=>{
                keyOrder[newCategory.id] = newCategory;
            });
            // and now set the categories to Object.value'd version of the order.
            // Voila - easy sort
            const categoryData = Object.values(keyOrder);
            return {
                categoryData
            };
        },
        [SeriesCollectionArticlesBuilderConfig.name]: async (props)=>{
            if (props.category) {
                const [articles, categoryObject] = await Promise.all([
                    (0,BuilderHelper/* getArticlesByCategory */.Zd)({
                        locale: lang,
                        categoryIds: [
                            props.category
                        ]
                    }),
                    (0,BuilderHelper/* getCategoriesFromIDs */.nq)([
                        props.category
                    ])
                ]);
                return {
                    categoryObject,
                    articles
                };
            }
            return {};
        },
        [B2BSeriesCollectionArticlesBuilderConfig.name]: async (props)=>{
            if (props.category) {
                const [articles, categoryObject] = await Promise.all([
                    (0,BuilderHelper/* getArticlesByCategory */.Zd)({
                        locale: lang,
                        categoryIds: [
                            props.category
                        ]
                    }),
                    (0,BuilderHelper/* getCategoriesFromIDs */.nq)([
                        props.category
                    ])
                ]);
                return {
                    categoryObject,
                    articles
                };
            }
            return {};
        },
        [BusinessHubIndustriesGridBuilderConfig.name]: async ()=>{
            const res = await BusinessIndustries/* default.getAllIndustries */.Z.getAllIndustries({
                locale: lang
            });
            const industries = res.map((item)=>item.data).sort((a, b)=>(b.order || 0) - (a.order || 0));
            return {
                industries
            };
        },
        [BusinessHubIndustriesCarouselBuilderConfig.name]: async ()=>{
            const res = await BusinessIndustries/* default.getAllIndustries */.Z.getAllIndustries({
                locale: lang,
                includeUnpublished: true
            });
            const industries = res.filter((item)=>item.published === "published" || item.data.isInPreview).map((item)=>item.data).sort((a, b)=>(b.order || 0) - (a.order || 0));
            return {
                industries
            };
        },
        [BusinessHubBuildForIndustryBuilderConfig.name]: async ()=>{
            const res = await BusinessIndustries/* default.getAllIndustries */.Z.getAllIndustries({
                locale: lang
            });
            const industries = res.map((item)=>item.data).sort((a, b)=>(b.order || 0) - (a.order || 0));
            return {
                industries
            };
        }
    });
};
const getBlockDataMap = (content)=>{
    var ref, ref1;
    if (!content) return content;
    return ((ref = content.data) === null || ref === void 0 ? void 0 : (ref1 = ref.blocks) === null || ref1 === void 0 ? void 0 : ref1.reduce((rs, block)=>{
        var ref;
        if (!(block === null || block === void 0 ? void 0 : (ref = block.component) === null || ref === void 0 ? void 0 : ref.name)) return rs;
        return {
            ...rs,
            [block.component.name]: block.component.options
        };
    }, {})) || {};
};


/***/ }),

/***/ 1395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ ArticleCardType; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76899);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62991);
/* harmony import */ var _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77868);
/* harmony import */ var _hook_useWindowSize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77442);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66714);
/* harmony import */ var _lazy_background_image_lazy_background_image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40204);
/* harmony import */ var _skeleton_load_article_card_skeleton_article_card_skeleton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78533);
/* harmony import */ var _b2b_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11127);
/* harmony import */ var _b2b_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_b2b_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _b2b_categories_b2b_categories__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(90997);











var ArticleCardType;
(function(ArticleCardType) {
    ArticleCardType["Small"] = "small";
    ArticleCardType["Large"] = "large";
})(ArticleCardType || (ArticleCardType = {}));
const B2BArticleCard = (props)=>{
    const { locale  } = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_4__/* .useLocale */ .bU)();
    const [isLoading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const { article , type , fixedWidth  } = props;
    const windowSize = (0,_hook_useWindowSize__WEBPACK_IMPORTED_MODULE_5__/* .useWindowSize */ .i)();
    const getClassSkeletonImage = ()=>{
        if (isLoading) {
            return "loading";
        } else {
            return "";
        }
    };
    const targetUrl = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_4__/* .localifyLink */ .Bj)("/".concat(locale).concat(article.articleUrl), locale);
    const articleImage = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(()=>{
        // Horiz image for small card
        let articleImage = article.leadImage || article.leadPortraitImage;
        let imageWidth = 500;
        var _width;
        if (((_width = windowSize.width) !== null && _width !== void 0 ? _width : 0) > 768 && type === ArticleCardType.Large) {
            // Portrait image for Large card
            articleImage = article.leadPortraitImage || article.leadImage;
            imageWidth = 800;
        }
        return {
            url: articleImage,
            width: imageWidth
        };
    }, [
        type,
        windowSize.width,
        article
    ]);
    return isLoading || !article ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_skeleton_load_article_card_skeleton_article_card_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        type
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_b2b_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().articleCard), (_b2b_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default())[type], {
            [(_b2b_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().fixedWidth)]: fixedWidth
        }),
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_b2b_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().articleCardImageWrapper) + " " + (_b2b_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default())[getClassSkeletonImage()],
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lazy_background_image_lazy_background_image__WEBPACK_IMPORTED_MODULE_7__/* .LazyBackgroundImage */ .I, {
                    className: (_b2b_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().articleCardImage),
                    imageUrl: articleImage.url,
                    imageWidth: articleImage.width
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "".concat((_b2b_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().articleCardContentWrapper), " ").concat((_b2b_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default())[props.cardBackgroundColor || ""]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_b2b_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().categoriesList),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_categories_b2b_categories__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            type: "SMALL",
                            categories: article.categories
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_b2b_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().articleCardContent),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat((_b2b_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().articleCardContentTitle), " ").concat((_b2b_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().threeLinesLimit)),
                                children: article.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat((_b2b_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().articleCardContentDescription), " ").concat((_b2b_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().threeLinesLimit)),
                                children: article.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: targetUrl || "",
                        target: "_self",
                        className: (_b2b_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().articleCardButtonReadMore),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_b2b_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().businessButtonText),
                                children: "Read more"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                type: _icons__WEBPACK_IMPORTED_MODULE_6__/* .IconType.ArrowRightMedium5 */ .T.ArrowRightMedium5
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: targetUrl || "",
                target: "_self",
                className: (_b2b_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().articleCardLink)
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (B2BArticleCard);


/***/ }),

/***/ 33508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62991);
/* harmony import */ var _helpers_cookieUtils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65443);
/* harmony import */ var _hook_useWindowSize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77442);
/* harmony import */ var _shared_sharedContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36224);
/* harmony import */ var _article_card_article_card__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12790);
/* harmony import */ var _skeleton_load_article_grid_skeleton_article_grid_skeleton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77408);
/* harmony import */ var _b2b_article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8159);
/* harmony import */ var _b2b_article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_b2b_article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _b2b_sign_up_card_b2b_sign_up_card__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60054);
/* harmony import */ var _b2b_article_card_b2b_article_card__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1395);










const CardType = {
    SMALL: "SMALL",
    LARGE: "LARGE",
    NEWSLETTER: "NEWSLETTER"
};
const templates = [
    [
        CardType.SMALL,
        CardType.LARGE
    ],
    [
        CardType.SMALL,
        CardType.SMALL,
        CardType.SMALL
    ],
    [
        CardType.LARGE,
        CardType.SMALL
    ],
    [
        CardType.SMALL,
        CardType.SMALL,
        CardType.SMALL
    ]
];
const tabletTemplate = [
    [
        CardType.SMALL,
        CardType.SMALL
    ],
    [
        CardType.LARGE,
        CardType.SMALL
    ]
];
const B2BArticleGrid = (props)=>{
    const { articles , setOffsetArticle , offsetArticle , isLoadingMoreArticles  } = props;
    const [haveNewsletterCookie, setNewsLetterCookie] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const windowSize = (0,_hook_useWindowSize__WEBPACK_IMPORTED_MODULE_2__/* .useWindowSize */ .i)();
    const [filteredArticles, setFilteredArticles] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const categoryCtx = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_shared_sharedContext__WEBPACK_IMPORTED_MODULE_3__/* .CategoryCtx */ .N);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!categoryCtx) return;
        const newsletterSignUpCookie = (0,_helpers_cookieUtils__WEBPACK_IMPORTED_MODULE_8__/* .getCookie */ .ej)("NewsletterSignUp");
        if (newsletterSignUpCookie && newsletterSignUpCookie !== "") {
            setNewsLetterCookie(true);
        }
        return ()=>{
            if (categoryCtx === null || categoryCtx === void 0 ? void 0 : categoryCtx.setCategoriesToFilter) {
                categoryCtx.setCategoriesToFilter([]);
            }
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setFilteredArticles(articles);
        if (categoryCtx === null || categoryCtx === void 0 ? void 0 : categoryCtx.setAllCategories) {
            const categories = {};
            articles.forEach((article)=>{
                article.categories.forEach((category)=>{
                    categories[category.id] = category;
                });
            });
            categoryCtx === null || categoryCtx === void 0 ? void 0 : categoryCtx.setAllCategories(Object.values(categories));
        }
    }, [
        articles
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!categoryCtx.categoriesToFilter || categoryCtx.categoriesToFilter.length === 0) {
            setFilteredArticles(articles);
            return;
        }
        const categoryIds = categoryCtx.categoriesToFilter.map((category)=>category.id);
        const updateFilteredArticles = articles.filter((article)=>article.categories.some((category)=>categoryIds.includes(category.id)));
        setFilteredArticles(updateFilteredArticles);
    }, [
        articles,
        categoryCtx.categoriesToFilter
    ]);
    const getIsMobile = ()=>{
        const windowWidth = windowSize.width || 0;
        if (windowWidth < 992) {
            return true;
        } else {
            return false;
        }
    };
    const isMobile = getIsMobile();
    const handleCards = ()=>{
        const maxTotalRows = filteredArticles.length;
        const cards = [];
        let articleIndex = 0;
        const cardTemplate = (windowSize.width || 0) > 1200 ? templates : tabletTemplate;
        for(let rowNumber = 0; rowNumber < maxTotalRows; rowNumber += 1){
            const templateIndex = rowNumber % cardTemplate.length;
            const templateRow = cardTemplate[templateIndex];
            if (articleIndex >= maxTotalRows) {
                break;
            }
            for(let colNumber = 0; colNumber < templateRow.length; colNumber++){
                const cartType = templateRow[colNumber];
                if (articleIndex >= maxTotalRows) {
                    break;
                }
                if (isMobile && !haveNewsletterCookie && rowNumber === 0 && colNumber === 1) {
                    cards.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_sign_up_card_b2b_sign_up_card__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}, "sign_up_card_".concat(articleIndex)));
                    continue;
                }
                if (!isMobile && !haveNewsletterCookie && rowNumber === 1 && colNumber === 2) {
                    cards.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_sign_up_card_b2b_sign_up_card__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}, "sign_up_card_".concat(articleIndex)));
                    continue;
                }
                const article = filteredArticles[articleIndex];
                if (cartType === CardType.SMALL) {
                    cards.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_article_card_b2b_article_card__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        type: _article_card_article_card__WEBPACK_IMPORTED_MODULE_4__/* .ArticleCardType.Small */ ._.Small,
                        article: article
                    }, "article_card_".concat(articleIndex)));
                }
                if (cartType === CardType.LARGE) {
                    cards.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_b2b_article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9___default().articleLarge),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_article_card_b2b_article_card__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            type: _article_card_article_card__WEBPACK_IMPORTED_MODULE_4__/* .ArticleCardType.Large */ ._.Large,
                            article: article
                        })
                    }, "article_card_".concat(article.url || Math.random())));
                }
                articleIndex += 1;
            }
        }
        return cards;
    };
    const handleLoadMoreArticle = ()=>{
        const count = offsetArticle + (offsetArticle === 0 ? 9 : 10);
        setOffsetArticle(count);
    };
    const renderButtonLoadMore = ()=>{
        if (articles.length < 9 || offsetArticle > articles.length) {
            return null;
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_b2b_article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9___default().buttonLoadMore) + " " + (isLoadingMoreArticles ? (_b2b_article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9___default().loading) : (_b2b_article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9___default().loaded)),
            onClick: ()=>handleLoadMoreArticle(),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_b2b_article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9___default().buttonLoadMoreContent),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: "Load more posts"
                })
            })
        });
    };
    const renderArticleContent = ()=>{
        if (articles.length === 0 && !isLoadingMoreArticles) {
            return null;
        }
        if (articles.length === 0) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_skeleton_load_article_grid_skeleton_article_grid_skeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {});
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_b2b_article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9___default().articlesContainer),
            children: handleCards().map((card)=>card)
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_b2b_article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9___default().articleGrid),
        children: [
            renderArticleContent(),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_b2b_article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9___default().loadMoreContainer),
                children: [
                    renderButtonLoadMore(),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_b2b_article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9___default().spinnerLoadMore) + " " + (isLoadingMoreArticles ? (_b2b_article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9___default().loading) : (_b2b_article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9___default().loaded))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(B2BArticleGrid));


/***/ }),

/***/ 90997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62991);
/* harmony import */ var _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77868);
/* harmony import */ var _b2b_categories_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65511);
/* harmony import */ var _b2b_categories_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_b2b_categories_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const B2BCategoriesComponent = (props)=>{
    const { locale  } = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_2__/* .useLocale */ .bU)();
    const { categories , type , color ="black"  } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_b2b_categories_module_scss__WEBPACK_IMPORTED_MODULE_3___default().categoriesList) + " " + (_b2b_categories_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[type],
        children: (categories || []).map((item, index)=>{
            var _categoryUrl;
            const url = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_2__/* .replaceOrAddLocale */ .yM)((_categoryUrl = item.categoryUrl) !== null && _categoryUrl !== void 0 ? _categoryUrl : "", locale);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                className: (_b2b_categories_module_scss__WEBPACK_IMPORTED_MODULE_3___default().categoryName) + " " + (_b2b_categories_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[color],
                href: url,
                children: categories.length - index > 1 ? item.name + "," : item.name + ""
            }, index);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (B2BCategoriesComponent);


/***/ }),

/***/ 94430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ B2BCategory; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var _b2b_category_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89367);
/* harmony import */ var _b2b_category_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_b2b_category_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77868);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);




const B2BCategory = (props)=>{
    const { categories =[] , theme ="dark"  } = props;
    const { locale  } = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_1__/* .useLocale */ .bU)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_b2b_category_module_scss__WEBPACK_IMPORTED_MODULE_3___default().container), (_b2b_category_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[theme]),
        children: categories.map((cate)=>{
            var _categoryUrl;
            const url = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_1__/* .replaceOrAddLocale */ .yM)((_categoryUrl = cate.categoryUrl) !== null && _categoryUrl !== void 0 ? _categoryUrl : "", locale);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                className: (_b2b_category_module_scss__WEBPACK_IMPORTED_MODULE_3___default().item),
                href: url,
                children: cate.name
            }, cate.id);
        })
    });
};


/***/ }),

/***/ 12812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var _builder_io_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75102);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62991);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _b2b_collapse_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63841);
/* harmony import */ var _b2b_collapse_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_b2b_collapse_module_scss__WEBPACK_IMPORTED_MODULE_4__);





const B2BCollapse = (props)=>{
    const { item  } = props;
    const [active, setActive] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const contentContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const _toggleShowHide = ()=>{
        try {
            var ref, ref, ref, ref, ref;
            if ((ref = props.builderBlock.meta) === null || ref === void 0 ? void 0 : (ref = ref.eventActions) === null || ref === void 0 ? void 0 : (ref = ref.click) === null || ref === void 0 ? void 0 : (ref = ref[0]) === null || ref === void 0 ? void 0 : (ref = ref.options) === null || ref === void 0 ? void 0 : ref.code) {
                var ref, ref, ref, ref, ref;
                eval("(function() {".concat((ref = props.builderBlock.meta) === null || ref === void 0 ? void 0 : (ref = ref.eventActions) === null || ref === void 0 ? void 0 : (ref = ref.click) === null || ref === void 0 ? void 0 : (ref = ref[0]) === null || ref === void 0 ? void 0 : (ref = ref.options) === null || ref === void 0 ? void 0 : ref.code, "}())"));
            }
        } catch (ex) {
            console.error(ex);
        }
        setActive(!active);
        if (!contentRef.current) return;
        if (!contentContainerRef.current) return;
        if (active) {
            contentContainerRef.current.style.maxHeight = "0px";
        } else {
            contentContainerRef.current.style.maxHeight = contentRef.current.scrollHeight + "px";
        }
    };
    const _onResize = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(()=>{
        if (!active) return;
        if (!contentRef.current) return;
        if (!contentContainerRef.current) return;
        contentContainerRef.current.style.maxHeight = contentRef.current.scrollHeight + "px";
    }, [
        active,
        contentRef,
        contentContainerRef
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (!contentRef.current) return;
        const target = contentRef.current;
        const observer = new ResizeObserver(_onResize);
        observer.observe(target);
        return ()=>{
            observer.unobserve(target);
        };
    }, [
        contentRef,
        _onResize
    ]);
    if (!item) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_b2b_collapse_module_scss__WEBPACK_IMPORTED_MODULE_4___default().accordion), {
            [(_b2b_collapse_module_scss__WEBPACK_IMPORTED_MODULE_4___default().active)]: active
        }),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: (_b2b_collapse_module_scss__WEBPACK_IMPORTED_MODULE_4___default().button),
                onClick: _toggleShowHide,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: item.title
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_b2b_collapse_module_scss__WEBPACK_IMPORTED_MODULE_4___default().symbol)
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: contentContainerRef,
                className: (_b2b_collapse_module_scss__WEBPACK_IMPORTED_MODULE_4___default().contentContainer),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    ref: contentRef,
                    className: (_b2b_collapse_module_scss__WEBPACK_IMPORTED_MODULE_4___default().content),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_builder_io_react__WEBPACK_IMPORTED_MODULE_1__/* .BuilderBlocks */ .Wp, {
                        parent: props.builderBlock.id,
                        dataPath: "component.options.item.content",
                        blocks: item.content
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (B2BCollapse);


/***/ }),

/***/ 16779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62991);
/* harmony import */ var _b2b_hero_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26557);
/* harmony import */ var _b2b_hero_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_b2b_hero_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48771);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _b2b_category_b2b_category__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94430);






const B2BHero = (props)=>{
    const { background , textColor , subTitle , title , useLargeTitle , description , titleMaxWidth , descriptionMaxWidth , backgroundImage , articleCategories =[] , button , position  } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_b2b_hero_module_scss__WEBPACK_IMPORTED_MODULE_5___default().container), {
            [(_b2b_hero_module_scss__WEBPACK_IMPORTED_MODULE_5___default().article)]: articleCategories.length > 0
        }),
        style: {
            color: textColor
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_b2b_hero_module_scss__WEBPACK_IMPORTED_MODULE_5___default().background),
                style: {
                    backgroundColor: background
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_b2b_hero_module_scss__WEBPACK_IMPORTED_MODULE_5___default().image),
                    children: [
                        (backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.desktop) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()({
                                [(_b2b_hero_module_scss__WEBPACK_IMPORTED_MODULE_5___default().desktop)]: !!backgroundImage.mobile
                            }),
                            src: backgroundImage.desktop,
                            alt: "",
                            loading: "lazy",
                            fill: true,
                            style: {
                                objectFit: "cover",
                                objectPosition: position
                            },
                            loader: (param)=>{
                                let { src , width , quality  } = param;
                                return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                            }
                        }),
                        (backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.mobile) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()({
                                [(_b2b_hero_module_scss__WEBPACK_IMPORTED_MODULE_5___default().mobile)]: !!backgroundImage.desktop
                            }),
                            src: backgroundImage.mobile,
                            alt: "",
                            loading: "lazy",
                            fill: true,
                            style: {
                                objectFit: "cover",
                                objectPosition: "center"
                            },
                            loader: (param)=>{
                                let { src , width , quality  } = param;
                                return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_b2b_hero_module_scss__WEBPACK_IMPORTED_MODULE_5___default().content),
                children: [
                    articleCategories.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_category_b2b_category__WEBPACK_IMPORTED_MODULE_4__/* .B2BCategory */ .M, {
                        categories: articleCategories,
                        className: (_b2b_hero_module_scss__WEBPACK_IMPORTED_MODULE_5___default().categories),
                        theme: "light"
                    }) : null,
                    subTitle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_b2b_hero_module_scss__WEBPACK_IMPORTED_MODULE_5___default().subTitle),
                        dangerouslySetInnerHTML: {
                            __html: subTitle
                        }
                    }) : null,
                    title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_b2b_hero_module_scss__WEBPACK_IMPORTED_MODULE_5___default().title), {
                            [(_b2b_hero_module_scss__WEBPACK_IMPORTED_MODULE_5___default().large)]: useLargeTitle
                        }),
                        dangerouslySetInnerHTML: {
                            __html: title
                        },
                        style: {
                            maxWidth: titleMaxWidth
                        }
                    }) : null,
                    description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_b2b_hero_module_scss__WEBPACK_IMPORTED_MODULE_5___default().description),
                        style: {
                            maxWidth: descriptionMaxWidth
                        },
                        dangerouslySetInnerHTML: {
                            __html: description
                        }
                    }) : null,
                    (button === null || button === void 0 ? void 0 : button.url) || (button === null || button === void 0 ? void 0 : button.name) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: button === null || button === void 0 ? void 0 : button.url,
                        className: (_b2b_hero_module_scss__WEBPACK_IMPORTED_MODULE_5___default().button),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_b2b_hero_module_scss__WEBPACK_IMPORTED_MODULE_5___default().text),
                            children: (button === null || button === void 0 ? void 0 : button.name) || "sign up"
                        })
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (B2BHero);


/***/ }),

/***/ 60054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77868);
/* harmony import */ var _b2b_sign_up_card_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56662);
/* harmony import */ var _b2b_sign_up_card_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_b2b_sign_up_card_module_scss__WEBPACK_IMPORTED_MODULE_2__);



const B2BSignUpCard = (props)=>{
    const { locale  } = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_1__/* .useLocale */ .bU)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: (_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_1__/* .LOCALE_LINKS */ .kV[locale] || _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_1__/* .LOCALE_LINKS */ .kV[_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_1__/* .Locale.USA */ .go.USA]).signup,
        rel: "noreferrer",
        target: "_blank",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_b2b_sign_up_card_module_scss__WEBPACK_IMPORTED_MODULE_2___default().signUpCard),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_b2b_sign_up_card_module_scss__WEBPACK_IMPORTED_MODULE_2___default().backgroundImagePNG),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "https://cdn.builder.io/api/v1/image/assets%2F035a3d41874344d79b6c7499e2e7a5bc%2Fae580468d8b54acfa8730259d44f334a",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_b2b_sign_up_card_module_scss__WEBPACK_IMPORTED_MODULE_2___default().infoDetail),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: (_b2b_sign_up_card_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
                            children: [
                                "Sign up to ",
                                (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_1__/* .getCompanyName */ .Yd)(locale),
                                " Now!"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: (_b2b_sign_up_card_module_scss__WEBPACK_IMPORTED_MODULE_2___default().description),
                            children: [
                                "Get ",
                                (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_1__/* .getCompanyName */ .Yd)(locale),
                                " for your business."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_b2b_sign_up_card_module_scss__WEBPACK_IMPORTED_MODULE_2___default().buttonSubscribe),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: "Sign up"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (B2BSignUpCard);


/***/ }),

/***/ 12790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ ArticleCardType; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76899);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62991);
/* harmony import */ var _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77868);
/* harmony import */ var _hook_useWindowSize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77442);
/* harmony import */ var _categories_categories__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8324);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66714);
/* harmony import */ var _lazy_background_image_lazy_background_image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40204);
/* harmony import */ var _skeleton_load_article_card_skeleton_article_card_skeleton__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(78533);
/* harmony import */ var _article_card_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(42316);
/* harmony import */ var _article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10__);











var ArticleCardType;
(function(ArticleCardType) {
    ArticleCardType["Small"] = "small";
    ArticleCardType["Large"] = "large";
})(ArticleCardType || (ArticleCardType = {}));
const ArticleCard = (props)=>{
    const { locale  } = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_4__/* .useLocale */ .bU)();
    const [isLoading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const { article , type , fixedWidth  } = props;
    const windowSize = (0,_hook_useWindowSize__WEBPACK_IMPORTED_MODULE_5__/* .useWindowSize */ .i)();
    const getClassSkeletonImage = ()=>{
        if (isLoading) {
            return "loading";
        } else {
            return "";
        }
    };
    const targetUrl = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_4__/* .localifyLink */ .Bj)("/".concat(locale).concat(article.articleUrl), locale);
    const articleImage = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(()=>{
        // Horiz image for small card
        let articleImage = article.leadImage || article.leadPortraitImage;
        let imageWidth = 500;
        var _width;
        if (((_width = windowSize.width) !== null && _width !== void 0 ? _width : 0) > 768 && type === ArticleCardType.Large) {
            // Portrait image for Large card
            articleImage = article.leadPortraitImage || article.leadImage;
            imageWidth = 800;
        }
        return {
            url: articleImage,
            width: imageWidth
        };
    }, [
        type,
        windowSize.width,
        article
    ]);
    return isLoading || !article ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_skeleton_load_article_card_skeleton_article_card_skeleton__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        type
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().articleCard), (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default())[type], {
            [(_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().fixedWidth)]: fixedWidth
        }),
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().articleCardImageWrapper) + " " + (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default())[getClassSkeletonImage()],
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lazy_background_image_lazy_background_image__WEBPACK_IMPORTED_MODULE_8__/* .LazyBackgroundImage */ .I, {
                    className: (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().articleCardImage),
                    imageUrl: articleImage.url,
                    imageWidth: articleImage.width
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().articleCardContentWrapper),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().categoriesList),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_categories_categories__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            type: "SMALL",
                            categories: article.categories
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().articleCardContent),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat((_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().articleCardContentTitle), " ").concat((_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().threeLinesLimit)),
                                children: article.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat((_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().articleCardContentDescription), " ").concat((_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().threeLinesLimit)),
                                children: article.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: targetUrl || "",
                        target: "_self",
                        className: (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().articleCardButtonReadMore),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().businessButtonText),
                                children: "Read more"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                type: _icons__WEBPACK_IMPORTED_MODULE_7__/* .IconType.ArrowRightMedium */ .T.ArrowRightMedium
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: targetUrl || "",
                target: "_self",
                className: (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_10___default().articleCardLink)
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticleCard);


/***/ }),

/***/ 13650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62991);
/* harmony import */ var _helpers_cookieUtils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65443);
/* harmony import */ var _hook_useWindowSize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77442);
/* harmony import */ var _shared_sharedContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36224);
/* harmony import */ var _article_card_article_card__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12790);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66714);
/* harmony import */ var _sign_up_card_sign_up_card__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78845);
/* harmony import */ var _skeleton_load_article_grid_skeleton_article_grid_skeleton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77408);
/* harmony import */ var _article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(74688);
/* harmony import */ var _article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9__);










const CardType = {
    SMALL: "SMALL",
    LARGE: "LARGE",
    NEWSLETTER: "NEWSLETTER"
};
const templates = [
    [
        CardType.SMALL,
        CardType.LARGE
    ],
    [
        CardType.SMALL,
        CardType.SMALL,
        CardType.SMALL
    ],
    [
        CardType.LARGE,
        CardType.SMALL
    ],
    [
        CardType.SMALL,
        CardType.SMALL,
        CardType.SMALL
    ]
];
const tabletTemplate = [
    [
        CardType.SMALL,
        CardType.SMALL
    ],
    [
        CardType.LARGE,
        CardType.SMALL
    ]
];
const ArticleGrid = (props)=>{
    const { articles , setOffsetArticle , offsetArticle , isLoadingMoreArticles  } = props;
    const [haveNewsletterCookie, setNewsLetterCookie] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const windowSize = (0,_hook_useWindowSize__WEBPACK_IMPORTED_MODULE_2__/* .useWindowSize */ .i)();
    const [filteredArticles, setFilteredArticles] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const categoryCtx = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_shared_sharedContext__WEBPACK_IMPORTED_MODULE_3__/* .CategoryCtx */ .N);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!categoryCtx) return;
        const newsletterSignUpCookie = (0,_helpers_cookieUtils__WEBPACK_IMPORTED_MODULE_8__/* .getCookie */ .ej)("NewsletterSignUp");
        if (newsletterSignUpCookie && newsletterSignUpCookie !== "") {
            setNewsLetterCookie(true);
        }
        return ()=>{
            if (categoryCtx === null || categoryCtx === void 0 ? void 0 : categoryCtx.setCategoriesToFilter) {
                categoryCtx.setCategoriesToFilter([]);
            }
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setFilteredArticles(articles);
        if (categoryCtx === null || categoryCtx === void 0 ? void 0 : categoryCtx.setAllCategories) {
            const categories = {};
            articles.forEach((article)=>{
                article.categories.forEach((category)=>{
                    categories[category.id] = category;
                });
            });
            categoryCtx === null || categoryCtx === void 0 ? void 0 : categoryCtx.setAllCategories(Object.values(categories));
        }
    }, [
        articles
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!categoryCtx.categoriesToFilter || categoryCtx.categoriesToFilter.length === 0) {
            setFilteredArticles(articles);
            return;
        }
        const categoryIds = categoryCtx.categoriesToFilter.map((category)=>category.id);
        const updateFilteredArticles = articles.filter((article)=>article.categories.some((category)=>categoryIds.includes(category.id)));
        setFilteredArticles(updateFilteredArticles);
    }, [
        articles,
        categoryCtx.categoriesToFilter
    ]);
    const getIsMobile = ()=>{
        const windowWidth = windowSize.width || 0;
        if (windowWidth < 992) {
            return true;
        } else {
            return false;
        }
    };
    const isMobile = getIsMobile();
    const handleCards = ()=>{
        const maxTotalRows = filteredArticles.length;
        const cards = [];
        let articleIndex = 0;
        const cardTemplate = (windowSize.width || 0) > 1200 ? templates : tabletTemplate;
        for(let rowNumber = 0; rowNumber < maxTotalRows; rowNumber += 1){
            const templateIndex = rowNumber % cardTemplate.length;
            const templateRow = cardTemplate[templateIndex];
            if (articleIndex >= maxTotalRows) {
                break;
            }
            for(let colNumber = 0; colNumber < templateRow.length; colNumber++){
                const cartType = templateRow[colNumber];
                if (articleIndex >= maxTotalRows) {
                    break;
                }
                if (isMobile && !haveNewsletterCookie && rowNumber === 0 && colNumber === 1) {
                    cards.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sign_up_card_sign_up_card__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}, "sign_up_card_".concat(articleIndex)));
                    continue;
                }
                if (!isMobile && !haveNewsletterCookie && rowNumber === 1 && colNumber === 2) {
                    cards.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sign_up_card_sign_up_card__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}, "sign_up_card_".concat(articleIndex)));
                    continue;
                }
                const article = filteredArticles[articleIndex];
                if (cartType === CardType.SMALL) {
                    cards.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_article_card_article_card__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        type: _article_card_article_card__WEBPACK_IMPORTED_MODULE_4__/* .ArticleCardType.Small */ ._.Small,
                        article: article
                    }, "article_card_".concat(articleIndex)));
                }
                if (cartType === CardType.LARGE) {
                    cards.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9___default().articleLarge),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_article_card_article_card__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            type: _article_card_article_card__WEBPACK_IMPORTED_MODULE_4__/* .ArticleCardType.Large */ ._.Large,
                            article: article
                        })
                    }, "article_card_".concat(article.url || Math.random())));
                }
                articleIndex += 1;
            }
        }
        return cards;
    };
    const handleLoadMoreArticle = ()=>{
        const count = offsetArticle + (offsetArticle === 0 ? 9 : 10);
        setOffsetArticle(count);
    };
    const renderButtonLoadMore = ()=>{
        if (articles.length < 9 || offsetArticle > articles.length) {
            return null;
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9___default().buttonLoadMore) + " " + (isLoadingMoreArticles ? (_article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9___default().loading) : (_article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9___default().loaded)),
            onClick: ()=>handleLoadMoreArticle(),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9___default().buttonLoadMoreContent),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: "Load more posts"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        type: _icons__WEBPACK_IMPORTED_MODULE_5__/* .IconType.ArrowDown */ .T.ArrowDown
                    })
                ]
            })
        });
    };
    const renderArticleContent = ()=>{
        if (articles.length === 0 && !isLoadingMoreArticles) {
            return null;
        }
        if (articles.length === 0) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_skeleton_load_article_grid_skeleton_article_grid_skeleton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {});
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9___default().articlesContainer),
            children: handleCards().map((card)=>card)
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9___default().articleGrid),
        children: [
            renderArticleContent(),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9___default().loadMoreContainer),
                children: [
                    renderButtonLoadMore(),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9___default().spinnerLoadMore) + " " + (isLoadingMoreArticles ? (_article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9___default().loading) : (_article_grid_module_scss__WEBPACK_IMPORTED_MODULE_9___default().loaded))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(ArticleGrid));


/***/ }),

/***/ 53431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ breadcrumb; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(76899);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(62991);
// EXTERNAL MODULE: ./helpers/LangHelper.ts
var LangHelper = __webpack_require__(77868);
;// CONCATENATED MODULE: ./components/icons/Icons/IconArrowRight.tsx


const IconArrowRight = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "icon-arrow",
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M5 9L8 6L5 3",
            stroke: "black",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var Icons_IconArrowRight = (IconArrowRight);

// EXTERNAL MODULE: ./components/breadcrumb/breadcrumb.module.scss
var breadcrumb_module = __webpack_require__(33964);
var breadcrumb_module_default = /*#__PURE__*/__webpack_require__.n(breadcrumb_module);
;// CONCATENATED MODULE: ./components/breadcrumb/breadcrumb.tsx






const Breadcrumb = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const { breadcrumbs , type  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (breadcrumb_module_default()).breadcrumbContainer + " " + (breadcrumb_module_default())["".concat(type)],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: (breadcrumb_module_default()).breadcrumb,
            children: (breadcrumbs || []).map((breadcrumb, index)=>{
                const linkTags = {};
                var _link;
                const linkUrl = (0,LangHelper/* localifyLink */.Bj)((_link = breadcrumb.link) !== null && _link !== void 0 ? _link : "", locale);
                if (linkUrl) {
                    linkTags.href = "/".concat(locale).concat(linkUrl);
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: (breadcrumb_module_default()).separator,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_IconArrowRight, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: (breadcrumb_module_default()).breadcrumbName,
                            children: linkUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                ...linkTags,
                                target: "_self",
                                className: (breadcrumb_module_default()).link,
                                dangerouslySetInnerHTML: {
                                    __html: "".concat(breadcrumb.name)
                                }
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (breadcrumb_module_default()).link,
                                dangerouslySetInnerHTML: {
                                    __html: "".concat(breadcrumb.name)
                                }
                            })
                        })
                    ]
                }, index);
            })
        })
    });
};
/* harmony default export */ var breadcrumb = (Breadcrumb);


/***/ }),

/***/ 72379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ business_article_single_hero; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(56779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(48771);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(62991);
// EXTERNAL MODULE: ./contexts/LayoutContext.tsx
var LayoutContext = __webpack_require__(21513);
// EXTERNAL MODULE: ./hook/useWindowSize.ts
var useWindowSize = __webpack_require__(77442);
// EXTERNAL MODULE: ./components/breadcrumb/breadcrumb.tsx + 1 modules
var breadcrumb = __webpack_require__(53431);
// EXTERNAL MODULE: ./components/business-vimeo-embed/business-vimeo-embed.tsx
var business_vimeo_embed = __webpack_require__(78096);
// EXTERNAL MODULE: ./helpers/LangHelper.ts
var LangHelper = __webpack_require__(77868);
// EXTERNAL MODULE: ./components/categories/categories.tsx
var categories_categories = __webpack_require__(8324);
// EXTERNAL MODULE: ./components/icons/index.tsx + 91 modules
var icons = __webpack_require__(66714);
// EXTERNAL MODULE: ./components/business-article-single-hero/business-article-single-hero-info/business-article-single-hero-info.module.scss
var business_article_single_hero_info_module = __webpack_require__(59702);
var business_article_single_hero_info_module_default = /*#__PURE__*/__webpack_require__.n(business_article_single_hero_info_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(76899);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/business-article-single-hero/business-article-single-hero-info/business-article-single-hero-info.tsx









const BusinessArticleHeroInfo = (param)=>{
    let { title , description , categories , articleUrl , isShowReadMore , layout ="default" , theme  } = param;
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const isMobile = ()=>{
        const windowWidth = windowSize.width || 0;
        if (windowWidth < 768) {
            return true;
        } else {
            return false;
        }
    };
    const classNameArticleZHeroInfo = classnames_default()((business_article_single_hero_info_module_default()).businessArticleHeroInfo, {
        "article-hero-info": true
    }, (business_article_single_hero_info_module_default())[layout]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classNameArticleZHeroInfo,
        children: [
            categories && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_article_single_hero_info_module_default()).categories,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(categories_categories/* default */.Z, {
                    color: theme !== undefined ? theme === "dark" ? "grey" : "white" : undefined,
                    type: isMobile() ? "SMALL" : "LARGE",
                    categories: categories
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                className: classnames_default()((business_article_single_hero_info_module_default()).title, (business_article_single_hero_info_module_default())[theme || ""]),
                children: [
                    title,
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (business_article_single_hero_info_module_default()).description,
                        children: description
                    })
                ]
            }),
            isShowReadMore && articleUrl && /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                className: (business_article_single_hero_info_module_default()).readMoreUrl,
                href: (0,LangHelper/* replaceOrAddLocale */.yM)(articleUrl, locale),
                target: "_self",
                rel: "noopener",
                children: [
                    "Read More",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                        type: icons/* IconType.ArrowRightBig */.T.ArrowRightBig
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var business_article_single_hero_info = (BusinessArticleHeroInfo);

// EXTERNAL MODULE: ./components/business-article-single-hero/business-article-single-hero.module.scss
var business_article_single_hero_module = __webpack_require__(34099);
var business_article_single_hero_module_default = /*#__PURE__*/__webpack_require__.n(business_article_single_hero_module);
;// CONCATENATED MODULE: ./components/business-article-single-hero/business-article-single-hero.tsx










const BusinessArticleHero = (props)=>{
    const { title , leadImage , imageMobile , categories , articleUrl , description , leadVideo  } = props.article;
    const { breadcrumbs , isMarginLower =false , isShowReadMore =false , isFeaturedBlock  } = props;
    const isUseLeadVideo = leadVideo && leadVideo.videoUrl;
    const classNameArticleHero = classnames_default()((business_article_single_hero_module_default()).businessArticleHeroContainer, {
        [(business_article_single_hero_module_default()).marginLower]: isMarginLower
    }, {
        [(business_article_single_hero_module_default()).isFeatured]: isFeaturedBlock
    });
    const { breadcrumbType  } = (0,LayoutContext/* useBusinessLayout */.Vp)();
    const { width =0  } = (0,useWindowSize/* useWindowSize */.i)();
    const getBreadcrumbType = ()=>{
        if (isUseLeadVideo && breadcrumbType) {
            return breadcrumbType;
        }
        return width > 768 ? "dark" : "light";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classNameArticleHero,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_article_single_hero_module_default()).breadcrumb,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb/* default */.Z, {
                    breadcrumbs: breadcrumbs,
                    type: getBreadcrumbType()
                })
            }),
            isUseLeadVideo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_vimeo_embed/* default */.Z, {
                    ...leadVideo
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_article_single_hero_module_default()).businessArticleHeroWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (business_article_single_hero_module_default()).businessArticleHeroBox,
                        children: [
                            leadImage && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                className: classnames_default()({
                                    [(business_article_single_hero_module_default()).desktop]: !!imageMobile
                                }),
                                src: leadImage,
                                alt: "Headline article image ".concat(title),
                                style: {
                                    objectFit: "cover",
                                    objectPosition: "center"
                                },
                                fill: true,
                                loading: "eager",
                                loader: (param)=>{
                                    let { src , width , quality  } = param;
                                    return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                                }
                            }),
                            imageMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                className: classnames_default()({
                                    [(business_article_single_hero_module_default()).mobile]: !!leadImage
                                }),
                                src: imageMobile,
                                alt: "Headline article image ".concat(title),
                                style: {
                                    objectFit: "cover",
                                    objectPosition: "center"
                                },
                                fill: true,
                                loading: "eager",
                                loader: (param)=>{
                                    let { src , width , quality  } = param;
                                    return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                                }
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (business_article_single_hero_module_default()).businessArticleHeroInfoWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_article_single_hero_info, {
                    title,
                    articleUrl,
                    categories,
                    isShowReadMore,
                    description: isFeaturedBlock ? description : undefined,
                    layout: isUseLeadVideo ? "simple" : undefined,
                    theme: breadcrumbType
                })
            })
        ]
    });
};
/* harmony default export */ var business_article_single_hero = (BusinessArticleHero);


/***/ }),

/***/ 79892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ COLORS; },
/* harmony export */   "UZ": function() { return /* binding */ ICONS; },
/* harmony export */   "Vr": function() { return /* binding */ POSITION; },
/* harmony export */   "zf": function() { return /* binding */ SIZES; }
/* harmony export */ });
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66714);

const ICONS = _icons__WEBPACK_IMPORTED_MODULE_0__/* .IconType */ .T;
const COLORS = {
    MINT: "mint",
    PLUM: "plum",
    BLACK: "black",
    WHITE: "white"
};
var POSITION;
(function(POSITION) {
    POSITION["LEFT"] = "Left";
    POSITION["CENTER"] = "Center";
    POSITION["RIGHT"] = "Right";
})(POSITION || (POSITION = {}));
const SIZES = {
    NORMAL: "normal",
    SMALL: "small"
};


/***/ }),

/***/ 52955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62991);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66714);
/* harmony import */ var _business_button_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79892);
/* harmony import */ var _business_button_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34977);
/* harmony import */ var _business_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_business_button_module_scss__WEBPACK_IMPORTED_MODULE_5__);






const BusinessButton = (props)=>{
    var ref, ref1;
    const { buttonText , color =_business_button_constants__WEBPACK_IMPORTED_MODULE_4__/* .COLORS.MINT */ .DM.MINT , size =_business_button_constants__WEBPACK_IMPORTED_MODULE_4__/* .SIZES.NORMAL */ .zf.NORMAL , icon , square , position =_business_button_constants__WEBPACK_IMPORTED_MODULE_4__/* .POSITION.CENTER */ .Vr.CENTER , className , autoMargin =true , target  } = props;
    const getBackgroundColor = ()=>{
        const backgroundColorMap = {
            [_business_button_constants__WEBPACK_IMPORTED_MODULE_4__/* .COLORS.MINT */ .DM.MINT]: "#b2fce4",
            [_business_button_constants__WEBPACK_IMPORTED_MODULE_4__/* .COLORS.PLUM */ .DM.PLUM]: "#EADDF2",
            [_business_button_constants__WEBPACK_IMPORTED_MODULE_4__/* .COLORS.WHITE */ .DM.WHITE]: "#fff",
            [_business_button_constants__WEBPACK_IMPORTED_MODULE_4__/* .COLORS.BLACK */ .DM.BLACK]: "#000"
        };
        return backgroundColorMap[color];
    };
    const getIconClassNameColor = ()=>{
        const iconClassNameColorMap = {
            [_business_button_constants__WEBPACK_IMPORTED_MODULE_4__/* .COLORS.MINT */ .DM.MINT]: "mint",
            [_business_button_constants__WEBPACK_IMPORTED_MODULE_4__/* .COLORS.PLUM */ .DM.PLUM]: "plum",
            [_business_button_constants__WEBPACK_IMPORTED_MODULE_4__/* .COLORS.WHITE */ .DM.WHITE]: "white",
            [_business_button_constants__WEBPACK_IMPORTED_MODULE_4__/* .COLORS.BLACK */ .DM.BLACK]: "black"
        };
        return iconClassNameColorMap[color];
    };
    const getSize = ()=>{
        const sizeMap = {
            [_business_button_constants__WEBPACK_IMPORTED_MODULE_4__/* .SIZES.NORMAL */ .zf.NORMAL]: "normal",
            [_business_button_constants__WEBPACK_IMPORTED_MODULE_4__/* .SIZES.SMALL */ .zf.SMALL]: "small"
        };
        return sizeMap[size];
    };
    const getPosition = ()=>{
        const positionMap = {
            [_business_button_constants__WEBPACK_IMPORTED_MODULE_4__/* .POSITION.LEFT */ .Vr.LEFT]: "left",
            [_business_button_constants__WEBPACK_IMPORTED_MODULE_4__/* .POSITION.RIGHT */ .Vr.RIGHT]: "right",
            [_business_button_constants__WEBPACK_IMPORTED_MODULE_4__/* .POSITION.CENTER */ .Vr.CENTER]: "center"
        };
        return positionMap[position];
    };
    var ref2;
    const link = (ref2 = (ref = props.builderBlock) === null || ref === void 0 ? void 0 : (ref1 = ref.properties) === null || ref1 === void 0 ? void 0 : ref1.href) !== null && ref2 !== void 0 ? ref2 : props.link;
    var ref3;
    const isAnchorLink = (ref3 = link === null || link === void 0 ? void 0 : link.startsWith("#")) !== null && ref3 !== void 0 ? ref3 : false;
    const onClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((e)=>{
        if (!isAnchorLink) return;
        const target = document.querySelector(link);
        if (!target) return;
        e.preventDefault();
        e.stopPropagation();
        window.scrollTo({
            top: target.getBoundingClientRect().top + window.scrollY - 86,
            behavior: "smooth"
        });
    }, [
        link,
        isAnchorLink
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: link,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_business_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default().businessButtonWrapper), (_business_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[getSize()], (_business_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[getIconClassNameColor()], (_business_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[getPosition()], {
            [(_business_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default().square)]: square,
            [(_business_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default().autoMargin)]: autoMargin
        }, className),
        style: {
            backgroundColor: getBackgroundColor()
        },
        target: isAnchorLink ? "_self" : target,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            className: (_business_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default().businessButtonText) + " " + (_business_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[getSize()],
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: buttonText || ""
                    }
                }),
                icon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    type: icon
                }) : null
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BusinessButton);


/***/ }),

/***/ 4980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var _builder_io_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75102);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62991);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _business_collapse_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17379);
/* harmony import */ var _business_collapse_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_business_collapse_module_scss__WEBPACK_IMPORTED_MODULE_4__);





const BusinessCollapse = (props)=>{
    const { item  } = props;
    const [active, setActive] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const contentContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const _toggleShowHide = ()=>{
        try {
            var ref, ref, ref, ref, ref;
            if ((ref = props.builderBlock.meta) === null || ref === void 0 ? void 0 : (ref = ref.eventActions) === null || ref === void 0 ? void 0 : (ref = ref.click) === null || ref === void 0 ? void 0 : (ref = ref[0]) === null || ref === void 0 ? void 0 : (ref = ref.options) === null || ref === void 0 ? void 0 : ref.code) {
                var ref, ref, ref, ref, ref;
                eval("(function() {".concat((ref = props.builderBlock.meta) === null || ref === void 0 ? void 0 : (ref = ref.eventActions) === null || ref === void 0 ? void 0 : (ref = ref.click) === null || ref === void 0 ? void 0 : (ref = ref[0]) === null || ref === void 0 ? void 0 : (ref = ref.options) === null || ref === void 0 ? void 0 : ref.code, "}())"));
            }
        } catch (ex) {
            console.error(ex);
        }
        setActive(!active);
        if (!contentRef.current) return;
        if (!contentContainerRef.current) return;
        if (active) {
            contentContainerRef.current.style.maxHeight = "0px";
        } else {
            contentContainerRef.current.style.maxHeight = contentRef.current.scrollHeight + "px";
        }
    };
    const _onResize = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(()=>{
        if (!active) return;
        if (!contentRef.current) return;
        if (!contentContainerRef.current) return;
        contentContainerRef.current.style.maxHeight = contentRef.current.scrollHeight + "px";
    }, [
        active,
        contentRef,
        contentContainerRef
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (!contentRef.current) return;
        const target = contentRef.current;
        const observer = new ResizeObserver(_onResize);
        observer.observe(target);
        return ()=>{
            observer.unobserve(target);
        };
    }, [
        contentRef,
        _onResize
    ]);
    if (!item) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_business_collapse_module_scss__WEBPACK_IMPORTED_MODULE_4___default().accordion), {
            [(_business_collapse_module_scss__WEBPACK_IMPORTED_MODULE_4___default().active)]: active
        }),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: (_business_collapse_module_scss__WEBPACK_IMPORTED_MODULE_4___default().button),
                onClick: _toggleShowHide,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: item.title
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_business_collapse_module_scss__WEBPACK_IMPORTED_MODULE_4___default().symbol)
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: contentContainerRef,
                className: (_business_collapse_module_scss__WEBPACK_IMPORTED_MODULE_4___default().contentContainer),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    ref: contentRef,
                    className: (_business_collapse_module_scss__WEBPACK_IMPORTED_MODULE_4___default().content),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_builder_io_react__WEBPACK_IMPORTED_MODULE_1__/* .BuilderBlocks */ .Wp, {
                        parent: props.builderBlock.id,
                        dataPath: "component.options.item.content",
                        blocks: item.content
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BusinessCollapse);


/***/ }),

/***/ 78096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var _vimeo_player__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41806);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62991);
/* harmony import */ var _hook_useBackgroundTransform__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52479);
/* harmony import */ var _types_Media__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39289);
/* harmony import */ var _business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57654);
/* harmony import */ var _business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6__);







const BusinessVimeoEmbed = (props)=>{
    const { videoUrl , ratio ="1:1" , controls =false , backgroundTransform , containerMaxWidth , isHero , playIcon  } = props;
    const playerRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const iframeRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const [isPlayVideo, setIsPlayVideo] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const containerRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const [vimeoControls, setVimeoControls] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const { position  } = (0,_hook_useBackgroundTransform__WEBPACK_IMPORTED_MODULE_4__/* .useBackgroundTransform */ .L)(containerRef, isHero);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        if (!videoUrl) return;
        if (!controls) return;
        const url = new URL(videoUrl);
        var ref;
        const controlParam = (ref = url.searchParams.get("controls")) !== null && ref !== void 0 ? ref : true;
        setVimeoControls(controlParam === "1" || controlParam === "true");
    }, [
        videoUrl,
        controls
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        if (!videoUrl) return;
        if (!iframeRef.current) return;
        playerRef.current = null;
        playerRef.current = new _vimeo_player__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(iframeRef.current);
        playerRef.current.on("play", ()=>{
            var ref;
            setIsPlayVideo(true);
            (ref = playerRef.current) === null || ref === void 0 ? void 0 : ref.setVolume(0.5);
        });
        playerRef.current.on("pause", ()=>setIsPlayVideo(false));
    }, [
        videoUrl,
        iframeRef
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        if (position !== "ON_SCREEN") {
            var ref;
            (ref = playerRef.current) === null || ref === void 0 ? void 0 : ref.pause();
        }
    }, [
        position
    ]);
    const togglePlayVideo = ()=>{
        if (isPlayVideo) {
            var ref;
            (ref = playerRef.current) === null || ref === void 0 ? void 0 : ref.pause();
        } else {
            var ref1;
            (ref1 = playerRef.current) === null || ref1 === void 0 ? void 0 : ref1.play();
        }
    };
    const toggleMuteVideo = ()=>{
        playerRef.current;
    };
    const renderPlayPauseBtn = ()=>{
        if (isPlayVideo) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6___default().buttonPlay)
            });
        } else {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6___default().buttonPause)
            });
        }
    };
    const classNameVideoControl = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["video-controls"]), {
        [(_business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6___default().pause)]: !isPlayVideo
    });
    const classNameOverlay = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6___default().controlOverLay));
    const renderVidPlayer = ()=>{
        const [width, height] = _types_Media__WEBPACK_IMPORTED_MODULE_5__/* .MEDIA_RATIO */ .r[ratio];
        const vimeoVideoPaddingTop = height / width * 100;
        var _video;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            ref: backgroundTransform ? containerRef : null,
            className: (_business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6___default().vimeoVideo),
            style: {
                paddingTop: "".concat(vimeoVideoPaddingTop, "%")
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                    ref: iframeRef,
                    src: (_video = props.video) !== null && _video !== void 0 ? _video : videoUrl,
                    width: "872",
                    height: "872",
                    frameBorder: "0",
                    allow: "autoplay; muted; fullscreen; picture-in-picture",
                    allowFullScreen: true
                }),
                controls && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(classNameVideoControl, {
                                [(_business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["full-iframe"])]: !vimeoControls
                            }),
                            onClick: togglePlayVideo,
                            children: playIcon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6___default().buttonPlayCustom),
                                style: {
                                    backgroundImage: playIcon
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    alt: "",
                                    src: playIcon
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["video-controls__btnPlayPause"]), {
                                            [(_business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6___default().play)]: isPlayVideo,
                                            [(_business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6___default().pause)]: !isPlayVideo
                                        }),
                                        children: renderPlayPauseBtn()
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["video-controls__btnMuted"]),
                                        onClick: toggleMuteVideo
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: classNameOverlay
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_business_vimeo_embed_module_scss__WEBPACK_IMPORTED_MODULE_6___default().businessVimeoEmbedContainer),
        style: {
            width: containerMaxWidth
        },
        children: renderVidPlayer()
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BusinessVimeoEmbed);


/***/ }),

/***/ 8324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62991);
/* harmony import */ var _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77868);
/* harmony import */ var _categories_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68625);
/* harmony import */ var _categories_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_categories_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const CategoriesComponent = (props)=>{
    const { locale  } = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_2__/* .useLocale */ .bU)();
    const { categories , type , color ="grey"  } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_categories_module_scss__WEBPACK_IMPORTED_MODULE_3___default().categoriesList) + " " + (_categories_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[type],
        children: (categories || []).map((item, index)=>{
            var _categoryUrl;
            const url = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_2__/* .replaceOrAddLocale */ .yM)((_categoryUrl = item.categoryUrl) !== null && _categoryUrl !== void 0 ? _categoryUrl : "", locale);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                className: (_categories_module_scss__WEBPACK_IMPORTED_MODULE_3___default().categoryName) + " " + (_categories_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[color],
                href: url,
                children: item.name
            }, index);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CategoriesComponent);


/***/ }),

/***/ 98816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ category_hero; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(56779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(62991);
// EXTERNAL MODULE: ./components/breadcrumb/breadcrumb.tsx + 1 modules
var breadcrumb = __webpack_require__(53431);
// EXTERNAL MODULE: ./shared/sharedContext.tsx
var sharedContext = __webpack_require__(36224);
// EXTERNAL MODULE: ./components/icons/index.tsx + 91 modules
var icons = __webpack_require__(66714);
// EXTERNAL MODULE: ./components/category-filter/category-filter.module.scss
var category_filter_module = __webpack_require__(44184);
var category_filter_module_default = /*#__PURE__*/__webpack_require__.n(category_filter_module);
;// CONCATENATED MODULE: ./components/category-filter/category-filter.tsx





const CategoryFilter = (props)=>{
    const [isShownCategories, setIsShownCategories] = (0,react.useState)(false);
    const categoryCtx = (0,react.useContext)(sharedContext/* CategoryCtx */.N);
    const handleCategories = (category)=>{
        if (categoryCtx.categoriesToFilter.some((_category)=>_category.id === category.id)) {
            return categoryCtx.setCategoriesToFilter(categoryCtx.categoriesToFilter.filter((_category)=>_category.id !== category.id));
        }
        return categoryCtx.setCategoriesToFilter([
            ...categoryCtx.categoriesToFilter,
            category
        ]);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (category_filter_module_default()).categoryFilter,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (category_filter_module_default()).filterButton + " " + (category_filter_module_default())[isShownCategories ? "open" : "close"],
                onClick: ()=>setIsShownCategories(!isShownCategories),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                        type: icons/* IconType.Filter */.T.Filter
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Filter"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (category_filter_module_default()).filterIconDown,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: icons/* IconType.Down */.T.Down
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (category_filter_module_default()).categories + " " + (category_filter_module_default())[isShownCategories ? "open" : "close"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (category_filter_module_default()).categoriesList,
                    children: (categoryCtx.allCategories || []).map((category, index)=>{
                        const isItemChecked = categoryCtx.categoriesToFilter.some((_category)=>_category.id === category.id);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (category_filter_module_default()).categoryName + " " + (category_filter_module_default())[isItemChecked ? "checked" : "unCheck"],
                            onClick: ()=>handleCategories(category),
                            children: category.name
                        }, index);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var category_filter = (CategoryFilter);

// EXTERNAL MODULE: ./components/category-hero/category-hero.module.scss
var category_hero_module = __webpack_require__(59529);
var category_hero_module_default = /*#__PURE__*/__webpack_require__.n(category_hero_module);
;// CONCATENATED MODULE: ./components/category-hero/category-hero.tsx






const CategoryHero = (props)=>{
    const { categoryHeroTitle , breadcrumbs , categoryHeroDescription , backgroundColor ="Orca Pastel" , backgroundCoverContent =true , showFilter =true  } = props;
    const breadcrumbIncluded = breadcrumbs && breadcrumbs.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((category_hero_module_default()).categoryHero, {
            [(category_hero_module_default()).breadcrumb]: breadcrumbIncluded
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((category_hero_module_default()).categoryHeroBackground, (category_hero_module_default())["categoryHeroBackground".concat(backgroundColor.replace(" ", ""))], {
                    [(category_hero_module_default()).categoryHeroBackgroundCover]: backgroundCoverContent
                })
            }),
            breadcrumbIncluded ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (category_hero_module_default()).breadcrumbs,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb/* default */.Z, {
                    type: "dark",
                    breadcrumbs: breadcrumbs
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (category_hero_module_default()).categoryName,
                children: categoryHeroTitle
            }),
            categoryHeroDescription ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (category_hero_module_default()).categoryDescription,
                children: categoryHeroDescription
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (category_hero_module_default()).categoryFilter,
                children: showFilter ? /*#__PURE__*/ (0,jsx_runtime.jsx)(category_filter, {}) : null
            })
        ]
    });
};
/* harmony default export */ var category_hero = (CategoryHero);


/***/ }),

/***/ 53145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62991);


const ArrowRightMedium = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M0.5 8.5H15.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M10.5 3.5L15.5 8.5L10.5 13.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowRightMedium);


/***/ }),

/***/ 37763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62991);


const Download = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6 9V1",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M10 10L2 10",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M10 5L6 9L2 5",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Download);


/***/ }),

/***/ 66714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ IconType; },
  "Z": function() { return /* binding */ icons; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(62991);
;// CONCATENATED MODULE: ./components/icons/Icons/AfterPay.tsx


const AfterPay = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "121",
        height: "24",
        viewBox: "0 0 121 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.95859 11.7444C9.95859 9.5873 8.43108 8.07125 6.55474 8.07125C4.6784 8.07125 3.15087 9.61286 3.15087 11.7444C3.15087 13.8503 4.6784 15.4175 6.55474 15.4175C8.43299 15.4155 9.95859 13.9015 9.95859 11.7444ZM9.98543 18.1645V16.4951C9.05972 17.6513 7.68169 18.369 6.03151 18.369C2.60273 18.369 0 15.5433 0 11.7444C0 7.969 2.70239 5.0942 6.10817 5.0942C7.71044 5.0942 9.06163 5.81389 9.98735 6.94257V5.32427H13.0654V18.1645H9.98543Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.0167 15.3133C26.9396 15.3133 26.6406 14.9023 26.6406 13.8248V8.12434H28.6185V5.32427H26.6406V2.19189H23.4859V5.32427H19.4227V4.54363C19.4227 3.46411 19.8233 3.05314 20.9253 3.05314H21.6172V0.561789H20.0993C17.4965 0.561789 16.2699 1.43484 16.2699 4.10513V5.3223H14.5182V8.12237H16.2699V18.1625H19.4246V8.12237H23.4878V14.4147C23.4878 17.0338 24.4633 18.1645 27.0162 18.1645H28.6434V15.3133H28.0167Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M39.3303 10.5882C39.1061 8.91874 37.7779 7.91787 36.2273 7.91787C34.6749 7.91787 33.3985 8.89318 33.0746 10.5882H39.3303ZM33.0477 12.5919C33.2739 14.4914 34.6002 15.5709 36.2772 15.5709C37.6035 15.5709 38.6307 14.9279 39.2306 13.9015H42.4601C41.7088 16.6229 39.3303 18.369 36.2024 18.369C32.4229 18.369 29.7704 15.6476 29.7704 11.7699C29.7704 7.89231 32.5743 5.09224 36.2791 5.09224C40.0088 5.09224 42.7112 7.91787 42.7112 11.7699C42.7112 12.0531 42.6862 12.3343 42.6364 12.5919H33.0477Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M62.7683 11.7444C62.7683 9.66399 61.2408 8.07125 59.3644 8.07125C57.4881 8.07125 55.9606 9.61286 55.9606 11.7444C55.9606 13.8503 57.4881 15.4175 59.3644 15.4175C61.2408 15.4155 62.7683 13.8248 62.7683 11.7444ZM52.8557 5.32427H55.9337V6.99369C56.8594 5.81192 58.2355 5.0942 59.8876 5.0942C63.2666 5.0942 65.9192 7.9454 65.9192 11.7188C65.9192 15.4942 63.2168 18.371 59.8129 18.371C58.2356 18.371 56.9342 17.728 56.0334 16.6504V23.448H52.8557V5.32427Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M77.0143 11.7444C77.0143 9.5873 75.4887 8.07125 73.6104 8.07125C71.7341 8.07125 70.2066 9.61286 70.2066 11.7444C70.2066 13.8503 71.7341 15.4175 73.6104 15.4175C75.4887 15.4155 77.0143 13.9015 77.0143 11.7444ZM77.0411 18.1645V16.4951C76.1154 17.6513 74.7374 18.369 73.0872 18.369C69.6584 18.369 67.0557 15.5433 67.0557 11.7444C67.0557 7.969 69.7581 5.0942 73.1619 5.0942C74.7642 5.0942 76.1154 5.81389 77.0411 6.94257V5.32427H80.1191V18.1645H77.0411Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M47.3072 6.58273C47.3072 6.58273 48.091 5.0942 50.0096 5.0942C50.8299 5.0942 51.3608 5.38326 51.3608 5.38326V8.65918C51.3608 8.65918 50.2031 7.92574 49.1394 8.07322C48.0757 8.22069 47.403 9.22353 47.4068 10.5646V18.1665H44.2291V5.32624H47.3072V6.58273Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M94.4955 5.32426L86.7237 23.4067H83.4464L86.4976 16.4164L81.3381 5.32426H85.0525L88.0711 12.7354L91.1683 5.32426H94.4955Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M119.304 5.03325L111.599 0.471336C109.338 -0.867743 106.511 0.805615 106.511 3.48574V3.95373C106.511 4.37649 106.731 4.76779 107.087 4.97819L108.542 5.83945C108.97 6.09311 109.502 5.77653 109.502 5.27118V4.1071C109.502 3.52507 110.116 3.16129 110.606 3.45231L117.28 7.40466C117.771 7.69568 117.771 8.42323 117.28 8.71228L110.606 12.6646C110.116 12.9556 109.502 12.5919 109.502 12.0098V11.3904C109.502 8.71031 106.675 7.03499 104.412 8.37603L96.7072 12.9379C94.4457 14.277 94.4457 17.6277 96.7072 18.9668L104.412 23.5287C106.673 24.8677 109.502 23.1944 109.502 20.5143V20.0463C109.502 19.6235 109.282 19.2342 108.925 19.0218L107.471 18.1586C107.043 17.9049 106.511 18.2215 106.511 18.7269V19.8909C106.511 20.473 105.897 20.8367 105.407 20.5457L98.7331 16.5934C98.2424 16.3024 98.2424 15.5748 98.7331 15.2838L105.407 11.3314C105.897 11.0404 106.511 11.4042 106.511 11.9862V12.6056C106.511 15.2858 109.338 16.9611 111.599 15.62L119.304 11.0581C121.565 9.72298 121.565 6.37233 119.304 5.03325Z",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ var Icons_AfterPay = (AfterPay);

;// CONCATENATED MODULE: ./components/icons/Icons/ArrowBack.tsx


const ArrowBack = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.5 16.5H16.5C20.366 16.5 23.5 13.366 23.5 9.5C23.5 5.634 20.366 2.5 16.5 2.5H9.5",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.5 11.5L2.5 16.5L7.5 21.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_ArrowBack = (ArrowBack);

;// CONCATENATED MODULE: ./components/icons/Icons/ArrowDown.tsx


const ArrowDown = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 11.5V0.5",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 7.5L6 11.5L2 7.5",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_ArrowDown = (ArrowDown);

;// CONCATENATED MODULE: ./components/icons/Icons/ArrowRightBig.tsx


const ArrowRightBig = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.5 12.5H22.5",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.5 5.5L22.5 12.5L15.5 19.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_ArrowRightBig = (ArrowRightBig);

;// CONCATENATED MODULE: ./components/icons/Icons/ArrowRightBig2.tsx


const ArrowRightBig2_ArrowRightBig = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "27",
        viewBox: "0 0 32 27",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M30.1108 10.3275C30.9639 11.23 31.4013 12.4334 31.4013 13.6137C31.4013 14.794 30.9639 15.9974 30.1108 16.8999L20.7267 26.8281L17.6423 23.5651L24.8609 15.928L0.799317 15.928L0.799317 11.2994L24.839 11.2994L17.6423 3.66236L20.7267 0.399149L30.1108 10.3275Z",
            fill: "white"
        })
    });
};
/* harmony default export */ var ArrowRightBig2 = (ArrowRightBig2_ArrowRightBig);

// EXTERNAL MODULE: ./components/icons/Icons/ArrowRightMedium.tsx
var ArrowRightMedium = __webpack_require__(53145);
;// CONCATENATED MODULE: ./components/icons/Icons/ArrowRightOutline.tsx


const ArrowRightOutline = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.5 12.5H14.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.5 17.5V7.5L21.5 12.5L14.5 17.5Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_ArrowRightOutline = (ArrowRightOutline);

;// CONCATENATED MODULE: ./components/icons/Icons/ArrowRightSmall.tsx


const ArrowRightSmall = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.5 6H0.5",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.5 2L11.5 6L7.5 10",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_ArrowRightSmall = (ArrowRightSmall);

;// CONCATENATED MODULE: ./components/icons/Icons/ArrowUpBig.tsx


const ArrowUpBig = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M11.5 8.5L6 2.5L0.5 8.5",
            stroke: "black",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var Icons_ArrowUpBig = (ArrowUpBig);

;// CONCATENATED MODULE: ./components/icons/Icons/Barcode.tsx


const Barcode = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.5 2C5.5 1.72386 5.27614 1.5 5 1.5C4.72386 1.5 4.5 1.72386 4.5 2V14C4.5 14.2761 4.72386 14.5 5 14.5C5.27614 14.5 5.5 14.2761 5.5 14V2Z",
                stroke: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.5 2C8.5 1.72386 8.27614 1.5 8 1.5C7.72386 1.5 7.5 1.72386 7.5 2V14C7.5 14.2761 7.72386 14.5 8 14.5C8.27614 14.5 8.5 14.2761 8.5 14V2Z",
                stroke: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.5 2C13.5 1.72386 13.2761 1.5 13 1.5C12.7239 1.5 12.5 1.72386 12.5 2V14C12.5 14.2761 12.7239 14.5 13 14.5C13.2761 14.5 13.5 14.2761 13.5 14V2Z",
                stroke: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.500001 1.5L0.5 14.5",
                stroke: "black",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.5 1.5V14.5",
                stroke: "black",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.5 1.5V14.5",
                stroke: "black",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.5 1.5V14.5",
                stroke: "black",
                strokeLinecap: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_Barcode = (Barcode);

;// CONCATENATED MODULE: ./components/icons/Icons/Business.tsx


const Business = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "105",
        height: "30",
        viewBox: "0 0 105 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.853 19.7V21H13.393V7.4H15.933V12.22C16.333 11.7667 16.793 11.42 17.313 11.18C17.8464 10.94 18.413 10.82 19.013 10.82C20.373 10.82 21.513 11.3133 22.433 12.3C23.3664 13.2867 23.833 14.5133 23.833 15.98C23.833 17.4333 23.3597 18.66 22.413 19.66C21.4797 20.66 20.3264 21.16 18.953 21.16C18.3264 21.16 17.7464 21.04 17.213 20.8C16.6797 20.5467 16.2264 20.18 15.853 19.7ZM15.873 16C15.873 16.8133 16.133 17.4933 16.653 18.04C17.1864 18.5867 17.833 18.86 18.593 18.86C19.353 18.86 19.993 18.5867 20.513 18.04C21.0464 17.48 21.313 16.8 21.313 16C21.313 15.2 21.0464 14.5267 20.513 13.98C19.993 13.42 19.353 13.14 18.593 13.14C17.833 13.14 17.1864 13.4133 16.653 13.96C16.133 14.5067 15.873 15.1867 15.873 16ZM33.9862 11V21H31.5262V19.76C31.2995 20.1733 30.9328 20.5133 30.4262 20.78C29.9328 21.0333 29.3795 21.16 28.7662 21.16C27.6995 21.16 26.8595 20.8533 26.2462 20.24C25.6462 19.6267 25.3462 18.78 25.3462 17.7V11H27.8862V17.3C27.8862 17.82 28.0395 18.2333 28.3462 18.54C28.6528 18.8333 29.0728 18.98 29.6062 18.98C30.1395 18.98 30.5795 18.8267 30.9262 18.52C31.2862 18.2133 31.4662 17.82 31.4662 17.34V11H33.9862ZM40.1693 10.82C41.4493 10.82 42.4893 11.1 43.2893 11.66C44.1026 12.22 44.5626 13.0067 44.6693 14.02H42.2893C42.156 13.6067 41.896 13.3 41.5093 13.1C41.136 12.8867 40.636 12.78 40.0093 12.78C39.4226 12.78 38.956 12.8733 38.6093 13.06C38.276 13.2333 38.1093 13.48 38.1093 13.8C38.1093 14.08 38.256 14.3 38.5493 14.46C38.856 14.62 39.5293 14.76 40.5693 14.88C41.3826 14.9867 41.9826 15.0867 42.3693 15.18C42.7693 15.2733 43.1093 15.3867 43.3893 15.52C43.896 15.7467 44.2693 16.0533 44.5093 16.44C44.7493 16.8133 44.8693 17.2733 44.8693 17.82C44.8693 18.8333 44.4293 19.6467 43.5493 20.26C42.6826 20.86 41.5426 21.16 40.1293 21.16C38.7426 21.16 37.6426 20.88 36.8293 20.32C36.016 19.76 35.5493 18.9467 35.4293 17.88H37.8893C38.0493 18.3467 38.316 18.6867 38.6893 18.9C39.0626 19.1133 39.5826 19.22 40.2493 19.22C40.9026 19.22 41.416 19.12 41.7893 18.92C42.176 18.72 42.3693 18.44 42.3693 18.08C42.3693 17.7867 42.2093 17.5533 41.8893 17.38C41.5826 17.2067 40.896 17.06 39.8293 16.94C39.0293 16.8333 38.4293 16.74 38.0293 16.66C37.6426 16.5667 37.3093 16.4533 37.0293 16.32C36.536 16.0933 36.1693 15.7933 35.9293 15.42C35.6893 15.0467 35.5693 14.5933 35.5693 14.06C35.5693 13.0733 35.9826 12.2867 36.8093 11.7C37.636 11.1133 38.756 10.82 40.1693 10.82ZM49.1023 8.32C49.1023 8.70667 48.9556 9.04667 48.6623 9.34C48.3823 9.62 48.0489 9.76 47.6623 9.76C47.2756 9.76 46.9356 9.62 46.6423 9.34C46.3623 9.04667 46.2223 8.70667 46.2223 8.32C46.2223 7.93333 46.3623 7.6 46.6423 7.32C46.9356 7.02667 47.2756 6.88 47.6623 6.88C48.0489 6.88 48.3823 7.02667 48.6623 7.32C48.9556 7.6 49.1023 7.93333 49.1023 8.32ZM48.9023 11V21H46.3823V11H48.9023ZM59.6502 14.32V21H57.1302V14.78C57.1302 14.26 56.9702 13.8467 56.6502 13.54C56.3436 13.2333 55.9236 13.08 55.3902 13.08C54.8569 13.08 54.4169 13.24 54.0702 13.56C53.7236 13.8667 53.5502 14.2667 53.5502 14.76V21H51.0102V11H53.4702V12.26C53.7236 11.8333 54.0969 11.4867 54.5902 11.22C55.0969 10.9533 55.6502 10.82 56.2502 10.82C57.3036 10.82 58.1302 11.1333 58.7302 11.76C59.3436 12.3867 59.6502 13.24 59.6502 14.32ZM71.5334 16.02C71.5334 16.1267 71.5267 16.24 71.5134 16.36C71.5 16.4667 71.4867 16.5667 71.4734 16.66H63.8134C63.8934 17.3667 64.1667 17.9333 64.6334 18.36C65.1134 18.7733 65.7 18.98 66.3934 18.98C66.9 18.98 67.3534 18.8667 67.7534 18.64C68.1667 18.4133 68.5 18.0933 68.7534 17.68H71.3334C71.0267 18.7467 70.4267 19.5933 69.5334 20.22C68.64 20.8467 67.5734 21.16 66.3334 21.16C64.8267 21.16 63.5934 20.68 62.6334 19.72C61.6734 18.76 61.1934 17.5267 61.1934 16.02C61.1934 14.5267 61.6867 13.2867 62.6734 12.3C63.66 11.3133 64.9 10.82 66.3934 10.82C67.8867 10.82 69.1134 11.3133 70.0734 12.3C71.0467 13.2733 71.5334 14.5133 71.5334 16.02ZM66.3534 13.02C65.7134 13.02 65.16 13.2067 64.6934 13.58C64.24 13.9533 63.9534 14.46 63.8334 15.1H68.8334C68.7534 14.4733 68.48 13.9733 68.0134 13.6C67.56 13.2133 67.0067 13.02 66.3534 13.02ZM77.181 10.82C78.461 10.82 79.501 11.1 80.301 11.66C81.1143 12.22 81.5743 13.0067 81.681 14.02H79.301C79.1677 13.6067 78.9077 13.3 78.521 13.1C78.1477 12.8867 77.6477 12.78 77.021 12.78C76.4343 12.78 75.9677 12.8733 75.621 13.06C75.2877 13.2333 75.121 13.48 75.121 13.8C75.121 14.08 75.2677 14.3 75.561 14.46C75.8677 14.62 76.541 14.76 77.581 14.88C78.3943 14.9867 78.9943 15.0867 79.381 15.18C79.781 15.2733 80.121 15.3867 80.401 15.52C80.9077 15.7467 81.281 16.0533 81.521 16.44C81.761 16.8133 81.881 17.2733 81.881 17.82C81.881 18.8333 81.441 19.6467 80.561 20.26C79.6943 20.86 78.5543 21.16 77.141 21.16C75.7543 21.16 74.6543 20.88 73.841 20.32C73.0277 19.76 72.561 18.9467 72.441 17.88H74.901C75.061 18.3467 75.3277 18.6867 75.701 18.9C76.0743 19.1133 76.5943 19.22 77.261 19.22C77.9143 19.22 78.4277 19.12 78.801 18.92C79.1877 18.72 79.381 18.44 79.381 18.08C79.381 17.7867 79.221 17.5533 78.901 17.38C78.5943 17.2067 77.9077 17.06 76.841 16.94C76.041 16.8333 75.441 16.74 75.041 16.66C74.6543 16.5667 74.321 16.4533 74.041 16.32C73.5477 16.0933 73.181 15.7933 72.941 15.42C72.701 15.0467 72.581 14.5933 72.581 14.06C72.581 13.0733 72.9943 12.2867 73.821 11.7C74.6477 11.1133 75.7677 10.82 77.181 10.82ZM87.474 10.82C88.754 10.82 89.794 11.1 90.594 11.66C91.4073 12.22 91.8673 13.0067 91.974 14.02H89.594C89.4607 13.6067 89.2007 13.3 88.814 13.1C88.4407 12.8867 87.9407 12.78 87.314 12.78C86.7273 12.78 86.2607 12.8733 85.914 13.06C85.5807 13.2333 85.414 13.48 85.414 13.8C85.414 14.08 85.5607 14.3 85.854 14.46C86.1607 14.62 86.834 14.76 87.874 14.88C88.6873 14.9867 89.2873 15.0867 89.674 15.18C90.074 15.2733 90.414 15.3867 90.694 15.52C91.2007 15.7467 91.574 16.0533 91.814 16.44C92.054 16.8133 92.174 17.2733 92.174 17.82C92.174 18.8333 91.734 19.6467 90.854 20.26C89.9873 20.86 88.8473 21.16 87.434 21.16C86.0473 21.16 84.9473 20.88 84.134 20.32C83.3207 19.76 82.854 18.9467 82.734 17.88H85.194C85.354 18.3467 85.6207 18.6867 85.994 18.9C86.3673 19.1133 86.8873 19.22 87.554 19.22C88.2073 19.22 88.7207 19.12 89.094 18.92C89.4807 18.72 89.674 18.44 89.674 18.08C89.674 17.7867 89.514 17.5533 89.194 17.38C88.8873 17.2067 88.2007 17.06 87.134 16.94C86.334 16.8333 85.734 16.74 85.334 16.66C84.9473 16.5667 84.614 16.4533 84.334 16.32C83.8407 16.0933 83.474 15.7933 83.234 15.42C82.994 15.0467 82.874 14.5933 82.874 14.06C82.874 13.0733 83.2873 12.2867 84.114 11.7C84.9407 11.1133 86.0607 10.82 87.474 10.82Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1",
                y: "1",
                width: "103",
                height: "28",
                rx: "14",
                stroke: "white",
                strokeWidth: "2"
            })
        ]
    });
};
/* harmony default export */ var Icons_Business = (Business);

;// CONCATENATED MODULE: ./components/icons/Icons/BusinessSmall.tsx


const BusinessSmall = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "89",
        height: "28",
        viewBox: "0 0 89 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.436 18.09V19H16.714V9.48H18.492V12.854C18.772 12.5367 19.094 12.294 19.458 12.126C19.8313 11.958 20.228 11.874 20.648 11.874C21.6 11.874 22.398 12.2193 23.042 12.91C23.6953 13.6007 24.022 14.4593 24.022 15.486C24.022 16.5033 23.6907 17.362 23.028 18.062C22.3747 18.762 21.5673 19.112 20.606 19.112C20.1673 19.112 19.7613 19.028 19.388 18.86C19.0147 18.6827 18.6973 18.426 18.436 18.09ZM18.45 15.5C18.45 16.0693 18.632 16.5453 18.996 16.928C19.3693 17.3107 19.822 17.502 20.354 17.502C20.886 17.502 21.334 17.3107 21.698 16.928C22.0713 16.536 22.258 16.06 22.258 15.5C22.258 14.94 22.0713 14.4687 21.698 14.086C21.334 13.694 20.886 13.498 20.354 13.498C19.822 13.498 19.3693 13.6893 18.996 14.072C18.632 14.4547 18.45 14.9307 18.45 15.5ZM31.1292 12V19H29.4072V18.132C29.2485 18.4213 28.9919 18.6593 28.6372 18.846C28.2919 19.0233 27.9045 19.112 27.4752 19.112C26.7285 19.112 26.1405 18.8973 25.7112 18.468C25.2912 18.0387 25.0812 17.446 25.0812 16.69V12H26.8592V16.41C26.8592 16.774 26.9665 17.0633 27.1812 17.278C27.3959 17.4833 27.6899 17.586 28.0632 17.586C28.4365 17.586 28.7445 17.4787 28.9872 17.264C29.2392 17.0493 29.3652 16.774 29.3652 16.438V12H31.1292ZM35.4574 11.874C36.3534 11.874 37.0814 12.07 37.6414 12.462C38.2107 12.854 38.5327 13.4047 38.6074 14.114H36.9414C36.848 13.8247 36.666 13.61 36.3954 13.47C36.134 13.3207 35.784 13.246 35.3454 13.246C34.9347 13.246 34.608 13.3113 34.3654 13.442C34.132 13.5633 34.0154 13.736 34.0154 13.96C34.0154 14.156 34.118 14.31 34.3234 14.422C34.538 14.534 35.0094 14.632 35.7374 14.716C36.3067 14.7907 36.7267 14.8607 36.9974 14.926C37.2774 14.9913 37.5154 15.0707 37.7114 15.164C38.066 15.3227 38.3274 15.5373 38.4954 15.808C38.6634 16.0693 38.7474 16.3913 38.7474 16.774C38.7474 17.4833 38.4394 18.0527 37.8234 18.482C37.2167 18.902 36.4187 19.112 35.4294 19.112C34.4587 19.112 33.6887 18.916 33.1194 18.524C32.55 18.132 32.2234 17.5627 32.1394 16.816H33.8614C33.9734 17.1427 34.16 17.3807 34.4214 17.53C34.6827 17.6793 35.0467 17.754 35.5134 17.754C35.9707 17.754 36.33 17.684 36.5914 17.544C36.862 17.404 36.9974 17.208 36.9974 16.956C36.9974 16.7507 36.8854 16.5873 36.6614 16.466C36.4467 16.3447 35.966 16.242 35.2194 16.158C34.6594 16.0833 34.2394 16.018 33.9594 15.962C33.6887 15.8967 33.4554 15.8173 33.2594 15.724C32.914 15.5653 32.6574 15.3553 32.4894 15.094C32.3214 14.8327 32.2374 14.5153 32.2374 14.142C32.2374 13.4513 32.5267 12.9007 33.1054 12.49C33.684 12.0793 34.468 11.874 35.4574 11.874ZM41.7105 10.124C41.7105 10.3947 41.6078 10.6327 41.4025 10.838C41.2065 11.034 40.9731 11.132 40.7025 11.132C40.4318 11.132 40.1938 11.034 39.9885 10.838C39.7925 10.6327 39.6945 10.3947 39.6945 10.124C39.6945 9.85333 39.7925 9.62 39.9885 9.424C40.1938 9.21867 40.4318 9.116 40.7025 9.116C40.9731 9.116 41.2065 9.21867 41.4025 9.424C41.6078 9.62 41.7105 9.85333 41.7105 10.124ZM41.5705 12V19H39.8065V12H41.5705ZM49.094 14.324V19H47.33V14.646C47.33 14.282 47.218 13.9927 46.994 13.778C46.7794 13.5633 46.4854 13.456 46.112 13.456C45.7387 13.456 45.4307 13.568 45.188 13.792C44.9454 14.0067 44.824 14.2867 44.824 14.632V19H43.046V12H44.768V12.882C44.9454 12.5833 45.2067 12.3407 45.552 12.154C45.9067 11.9673 46.294 11.874 46.714 11.874C47.4514 11.874 48.03 12.0933 48.45 12.532C48.8794 12.9707 49.094 13.568 49.094 14.324ZM57.4122 15.514C57.4122 15.5887 57.4076 15.668 57.3982 15.752C57.3889 15.8267 57.3796 15.8967 57.3702 15.962H52.0082C52.0642 16.4567 52.2556 16.8533 52.5822 17.152C52.9182 17.4413 53.3289 17.586 53.8142 17.586C54.1689 17.586 54.4862 17.5067 54.7662 17.348C55.0556 17.1893 55.2889 16.9653 55.4662 16.676H57.2722C57.0576 17.4227 56.6376 18.0153 56.0122 18.454C55.3869 18.8927 54.6402 19.112 53.7722 19.112C52.7176 19.112 51.8542 18.776 51.1822 18.104C50.5102 17.432 50.1742 16.5687 50.1742 15.514C50.1742 14.4687 50.5196 13.6007 51.2102 12.91C51.9009 12.2193 52.7689 11.874 53.8142 11.874C54.8596 11.874 55.7182 12.2193 56.3902 12.91C57.0716 13.5913 57.4122 14.4593 57.4122 15.514ZM53.7862 13.414C53.3382 13.414 52.9509 13.5447 52.6242 13.806C52.3069 14.0673 52.1062 14.422 52.0222 14.87H55.5222C55.4662 14.4313 55.2749 14.0813 54.9482 13.82C54.6309 13.5493 54.2436 13.414 53.7862 13.414ZM61.3656 11.874C62.2616 11.874 62.9896 12.07 63.5496 12.462C64.1189 12.854 64.4409 13.4047 64.5156 14.114H62.8496C62.7562 13.8247 62.5742 13.61 62.3036 13.47C62.0422 13.3207 61.6922 13.246 61.2536 13.246C60.8429 13.246 60.5162 13.3113 60.2736 13.442C60.0402 13.5633 59.9236 13.736 59.9236 13.96C59.9236 14.156 60.0262 14.31 60.2316 14.422C60.4462 14.534 60.9176 14.632 61.6456 14.716C62.2149 14.7907 62.6349 14.8607 62.9056 14.926C63.1856 14.9913 63.4236 15.0707 63.6196 15.164C63.9742 15.3227 64.2356 15.5373 64.4036 15.808C64.5716 16.0693 64.6556 16.3913 64.6556 16.774C64.6556 17.4833 64.3476 18.0527 63.7316 18.482C63.1249 18.902 62.3269 19.112 61.3376 19.112C60.3669 19.112 59.5969 18.916 59.0276 18.524C58.4582 18.132 58.1316 17.5627 58.0476 16.816H59.7696C59.8816 17.1427 60.0682 17.3807 60.3296 17.53C60.5909 17.6793 60.9549 17.754 61.4216 17.754C61.8789 17.754 62.2382 17.684 62.4996 17.544C62.7702 17.404 62.9056 17.208 62.9056 16.956C62.9056 16.7507 62.7936 16.5873 62.5696 16.466C62.3549 16.3447 61.8742 16.242 61.1276 16.158C60.5676 16.0833 60.1476 16.018 59.8676 15.962C59.5969 15.8967 59.3636 15.8173 59.1676 15.724C58.8222 15.5653 58.5656 15.3553 58.3976 15.094C58.2296 14.8327 58.1456 14.5153 58.1456 14.142C58.1456 13.4513 58.4349 12.9007 59.0136 12.49C59.5922 12.0793 60.3762 11.874 61.3656 11.874ZM68.5707 11.874C69.4667 11.874 70.1947 12.07 70.7547 12.462C71.324 12.854 71.646 13.4047 71.7207 14.114H70.0547C69.9613 13.8247 69.7793 13.61 69.5087 13.47C69.2473 13.3207 68.8973 13.246 68.4587 13.246C68.048 13.246 67.7213 13.3113 67.4787 13.442C67.2453 13.5633 67.1287 13.736 67.1287 13.96C67.1287 14.156 67.2313 14.31 67.4367 14.422C67.6513 14.534 68.1227 14.632 68.8507 14.716C69.42 14.7907 69.84 14.8607 70.1107 14.926C70.3907 14.9913 70.6287 15.0707 70.8247 15.164C71.1793 15.3227 71.4407 15.5373 71.6087 15.808C71.7767 16.0693 71.8607 16.3913 71.8607 16.774C71.8607 17.4833 71.5527 18.0527 70.9367 18.482C70.33 18.902 69.532 19.112 68.5427 19.112C67.572 19.112 66.802 18.916 66.2327 18.524C65.6633 18.132 65.3367 17.5627 65.2527 16.816H66.9747C67.0867 17.1427 67.2733 17.3807 67.5347 17.53C67.796 17.6793 68.16 17.754 68.6267 17.754C69.084 17.754 69.4433 17.684 69.7047 17.544C69.9753 17.404 70.1107 17.208 70.1107 16.956C70.1107 16.7507 69.9987 16.5873 69.7747 16.466C69.56 16.3447 69.0793 16.242 68.3327 16.158C67.7727 16.0833 67.3527 16.018 67.0727 15.962C66.802 15.8967 66.5687 15.8173 66.3727 15.724C66.0273 15.5653 65.7707 15.3553 65.6027 15.094C65.4347 14.8327 65.3507 14.5153 65.3507 14.142C65.3507 13.4513 65.64 12.9007 66.2187 12.49C66.7973 12.0793 67.5813 11.874 68.5707 11.874Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1",
                y: "1",
                width: "87",
                height: "26",
                rx: "13",
                stroke: "white",
                strokeWidth: "2"
            })
        ]
    });
};
/* harmony default export */ var Icons_BusinessSmall = (BusinessSmall);

;// CONCATENATED MODULE: ./components/icons/Icons/Chat.tsx


const Chat = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 17H4C2.3 17 1 18.3 1 20V23H13V20C13 18.3 11.7 17 10 17Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 14C5.3 14 4 12.7 4 11V10C4 8.3 5.3 7 7 7C8.7 7 10 8.3 10 10V11C10 12.7 8.7 14 7 14Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 1V11L17 8H23V1H13Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_Chat = (Chat);

;// CONCATENATED MODULE: ./components/icons/Icons/CheckIn.tsx


const CheckIn = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 11.5H15.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 9L15.5 11.5L13 14",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.5 5.5H15.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.5 7.5V3.5C15.5 2.948 15.052 2.5 14.5 2.5H1.5C0.948 2.5 0.5 2.948 0.5 3.5V14.5C0.5 15.052 0.948 15.5 1.5 15.5H10.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.5 0.5V2.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.5 0.5V2.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_CheckIn = (CheckIn);

;// CONCATENATED MODULE: ./components/icons/Icons/CheckOut.tsx


const CheckOut = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 11.5H0.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3 9L0.5 11.5L3 14",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.5 5.5H0.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.5 7.5V3.5C0.5 2.948 0.948 2.5 1.5 2.5H14.5C15.052 2.5 15.5 2.948 15.5 3.5V14.5C15.5 15.052 15.052 15.5 14.5 15.5H5.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.5 0.5V2.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.5 0.5V2.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_CheckOut = (CheckOut);

;// CONCATENATED MODULE: ./components/icons/Icons/Close.tsx


const Close = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "8",
                fill: "#333333"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.375 5.375L10.625 10.625",
                stroke: "white",
                strokeMiterlimit: "10",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.375 10.625L10.625 5.375",
                stroke: "white",
                strokeMiterlimit: "10",
                strokeLinecap: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_Close = (Close);

;// CONCATENATED MODULE: ./components/icons/Icons/CreditCard.tsx


const CreditCard = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.5 10.5H6.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.5 10.5H12.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.5 6.5H0.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.5 13.5H1.5C0.948 13.5 0.5 13.052 0.5 12.5V3.5C0.5 2.948 0.948 2.5 1.5 2.5H14.5C15.052 2.5 15.5 2.948 15.5 3.5V12.5C15.5 13.052 15.052 13.5 14.5 13.5Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_CreditCard = (CreditCard);

;// CONCATENATED MODULE: ./components/icons/Icons/CreditCardBig.tsx


const CreditCardBig = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 7.5H23",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 11.5H23",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21 21.5H3C1.895 21.5 1 20.605 1 19.5V5.5C1 4.395 1.895 3.5 3 3.5H16H21C22.105 3.5 23 4.395 23 5.5V19.5C23 20.605 22.105 21.5 21 21.5Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 16.5H10",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 16.5H19",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_CreditCardBig = (CreditCardBig);

;// CONCATENATED MODULE: ./components/icons/Icons/CreditCardFilled.tsx


const CreditCardFilled = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 5V3C16 2.4 15.6 2 15 2H1C0.4 2 0 2.4 0 3V5H16Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 7V13C0 13.6 0.4 14 1 14H15C15.6 14 16 13.6 16 13V7H0ZM6 11H2V10H6V11ZM14 11H12V10H14V11Z",
                fill: "black"
            })
        ]
    });
};
/* harmony default export */ var Icons_CreditCardFilled = (CreditCardFilled);

;// CONCATENATED MODULE: ./components/icons/Icons/Dollar.tsx


const Dollar = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5 23.5C18.5751 23.5 23.5 18.5751 23.5 12.5C23.5 6.42487 18.5751 1.5 12.5 1.5C6.42487 1.5 1.5 6.42487 1.5 12.5C1.5 18.5751 6.42487 23.5 12.5 23.5Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5 5.5V19.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.875 7.71876C14.254 6.82776 9.148 6.16276 9.148 9.23176C9.148 12.9058 15.632 11.6088 15.632 14.8508C15.632 18.0928 11.418 17.8488 8.5 16.7958",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_Dollar = (Dollar);

;// CONCATENATED MODULE: ./components/icons/Icons/Dot.tsx


const Dot = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8 0C3.589 0 0 3.589 0 8C0 12.411 3.589 16 8 16C12.411 16 16 12.411 16 8C16 3.589 12.411 0 8 0ZM13.91 9H8.677L6.929 4.628L5.071 5.372L6.523 9H2.09C2.035 8.674 2 8.341 2 8C2 4.691 4.691 2 8 2C11.309 2 14 4.691 14 8C14 8.341 13.965 8.674 13.91 9Z",
            fill: "black"
        })
    });
};
/* harmony default export */ var Icons_Dot = (Dot);

;// CONCATENATED MODULE: ./components/icons/Icons/Down.tsx


const Down = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3 5L6 8L9 5",
            stroke: "black",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var Icons_Down = (Down);

// EXTERNAL MODULE: ./components/icons/Icons/Download.tsx
var Download = __webpack_require__(37763);
;// CONCATENATED MODULE: ./components/icons/Icons/External.tsx


const External = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 1.99997L6 6",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 2H10V6",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4 2H2V10H10V8",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_External = (External);

;// CONCATENATED MODULE: ./components/icons/Icons/FacebookFilled.tsx


const FacebookFilled = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9.14945 5.85957C9.14945 5.7349 9.16677 5.46565 9.2014 5.05355C9.23863 4.64058 9.39446 4.20856 9.6741 3.7549C9.95115 3.30297 10.4005 2.89693 11.0256 2.53764C11.648 2.18008 12.5476 2 13.7215 2H17.0288V5.60417H14.6072C14.3674 5.60417 14.144 5.69421 13.9423 5.87169C13.7423 6.04918 13.6393 6.218 13.6393 6.3747V8.61703H17.0279C16.9924 9.05597 16.9534 9.48279 16.9084 9.8949L16.7742 10.984C16.7206 11.352 16.666 11.6931 16.6123 12.0074H13.6151V22H9.14945V12.0065H6.97119V8.61703H9.14945V5.85957Z",
            fill: "#141414"
        })
    });
};
/* harmony default export */ var Icons_FacebookFilled = (FacebookFilled);

;// CONCATENATED MODULE: ./components/icons/Icons/FChat.tsx


const FChat = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.5 0.5H1.5C0.948 0.5 0.5 0.948 0.5 1.5V11.5C0.5 12.052 0.948 12.5 1.5 12.5H5.5L8 15.5L10.5 12.5H14.5C15.052 12.5 15.5 12.052 15.5 11.5V1.5C15.5 0.948 15.052 0.5 14.5 0.5Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.5 4.5H12.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.5 8.5H12.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_FChat = (FChat);

;// CONCATENATED MODULE: ./components/icons/Icons/Filter.tsx


const Filter = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M16.5 2.25H1.5L7.5 9.345V14.25L10.5 15.75V9.345L16.5 2.25Z",
            stroke: "black",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var Icons_Filter = (Filter);

;// CONCATENATED MODULE: ./components/icons/Icons/FlashFilled.tsx


const FlashFilled = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M14.9999 6.00016H8.39994L9.99994 1.30016C10.2999 0.300164 9.09995 -0.499837 8.29994 0.300164L0.299945 8.30016C-0.300055 8.90016 0.0999443 10.0002 0.999945 10.0002H7.59994L5.99994 14.7002C5.69994 15.7002 6.89994 16.5002 7.69994 15.7002L15.6999 7.70016C16.2999 7.10016 15.8999 6.00016 14.9999 6.00016Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_FlashFilled = (FlashFilled);

;// CONCATENATED MODULE: ./components/icons/Icons/HomeFilled.tsx


const HomeFilled = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M10.9996 16.0002H12.9996C13.5996 16.0002 13.9996 15.6002 13.9996 15.0002V8.0002H14.9996C15.2996 8.0002 15.5996 7.9002 15.7996 7.7002C16.1996 7.3002 16.0996 6.7002 15.6996 6.3002L8.69956 0.300195C8.29956 0.000195384 7.79956 0.000195384 7.39956 0.300195L0.399562 6.3002C-0.000438601 6.7002 -0.100438 7.3002 0.299562 7.7002C0.399562 7.9002 0.699562 8.0002 0.999562 8.0002C1.19956 8.0002 1.99956 8.0002 1.99956 8.0002V15.0002C1.99956 15.6002 2.39956 16.0002 2.99956 16.0002H4.99956C5.59956 16.0002 5.99956 15.6002 5.99956 15.0002V12.0002H9.99956V15.0002C9.99956 15.6002 10.3996 16.0002 10.9996 16.0002Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_HomeFilled = (HomeFilled);

;// CONCATENATED MODULE: ./components/icons/Icons/Info.tsx


const Info = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 8C9 7.44772 8.55228 7 8 7C7.44772 7 7 7.44772 7 8V11C7 11.5523 7.44772 12 8 12C8.55228 12 9 11.5523 9 11V8Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5Z",
                fill: "black"
            })
        ]
    });
};
/* harmony default export */ var Icons_Info = (Info);

;// CONCATENATED MODULE: ./components/icons/Icons/InfoBig.tsx


const InfoBig = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V11Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7C11 7.55228 11.4477 8 12 8C12.5523 8 13 7.55228 13 7Z",
                fill: "black"
            })
        ]
    });
};
/* harmony default export */ var Icons_InfoBig = (InfoBig);

;// CONCATENATED MODULE: ./components/icons/Icons/Instagram.tsx


const Instagram = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23.9763 7.05607C23.9201 5.78085 23.7139 4.90416 23.4185 4.14449C23.1137 3.33812 22.6449 2.61617 22.0306 2.01602C21.4305 1.40652 20.7038 0.932921 19.9067 0.632936C19.1427 0.337529 18.2706 0.131312 16.9954 0.0750879C15.7106 0.0141019 15.3028 0 12.0443 0C8.78588 0 8.37802 0.0141019 7.09805 0.0703262C5.82284 0.126551 4.94614 0.332951 4.18666 0.628174C3.3801 0.932922 2.65816 1.40176 2.05801 2.01602C1.44852 2.61617 0.975096 3.34288 0.674927 4.13991C0.379521 4.90416 0.173304 5.77609 0.11708 7.0513C0.056094 8.33604 0.0419922 8.7439 0.0419922 12.0023C0.0419922 15.2608 0.056094 15.6686 0.112318 16.9486C0.168543 18.2238 0.374943 19.1005 0.670349 19.8602C0.975096 20.6666 1.44852 21.3885 2.05801 21.9887C2.65816 22.5982 3.38487 23.0718 4.18189 23.3718C4.94614 23.6672 5.81808 23.8734 7.09347 23.9296C8.37326 23.986 8.7813 23.9999 12.0397 23.9999C15.2982 23.9999 15.706 23.986 16.986 23.9296C18.2612 23.8734 19.1379 23.6672 19.8974 23.3718C21.5103 22.7482 22.7855 21.4729 23.4091 19.8602C23.7044 19.096 23.9108 18.2238 23.967 16.9486C24.0232 15.6686 24.0373 15.2608 24.0373 12.0023C24.0373 8.7439 24.0325 8.33604 23.9763 7.05607ZM21.8151 16.8549C21.7634 18.027 21.5666 18.6599 21.4025 19.0819C20.9992 20.1274 20.1694 20.9572 19.1238 21.3605C18.7019 21.5246 18.0643 21.7215 16.8968 21.7729C15.631 21.8293 15.2513 21.8433 12.0491 21.8433C8.84686 21.8433 8.46245 21.8293 7.20116 21.7729C6.02905 21.7215 5.39612 21.5246 4.97416 21.3605C4.45386 21.1682 3.98026 20.8634 3.59584 20.4649C3.19733 20.0758 2.89258 19.6069 2.70028 19.0866C2.53619 18.6647 2.33931 18.027 2.28785 16.8596C2.23144 15.5937 2.21752 15.2139 2.21752 12.0117C2.21752 8.80946 2.23144 8.42505 2.28785 7.16394C2.33931 5.99183 2.53619 5.3589 2.70028 4.93694C2.89258 4.41645 3.19733 3.94303 3.60061 3.55843C3.9896 3.15992 4.45844 2.85517 4.97892 2.66306C5.40088 2.49896 6.03858 2.30209 7.20592 2.25044C8.47179 2.19422 8.85162 2.18011 12.0537 2.18011C15.2606 2.18011 15.6403 2.19422 16.9016 2.25044C18.0737 2.30209 18.7066 2.49896 19.1286 2.66306C19.6489 2.85517 20.1225 3.15992 20.5069 3.55843C20.9054 3.94761 21.2102 4.41645 21.4025 4.93694C21.5666 5.3589 21.7634 5.99641 21.8151 7.16394C21.8713 8.42981 21.8854 8.80946 21.8854 12.0117C21.8854 15.2139 21.8713 15.589 21.8151 16.8549Z",
                        fill: "#141414"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.0447 5.83716C8.64098 5.83716 5.87939 8.59856 5.87939 12.0024C5.87939 15.4063 8.64098 18.1677 12.0447 18.1677C15.4485 18.1677 18.2099 15.4063 18.2099 12.0024C18.2099 8.59856 15.4485 5.83716 12.0447 5.83716ZM12.0447 16.0017C9.83653 16.0017 8.04541 14.2108 8.04541 12.0024C8.04541 9.79411 9.83653 8.00317 12.0447 8.00317C14.253 8.00317 16.0439 9.79411 16.0439 12.0024C16.0439 14.2108 14.253 16.0017 12.0447 16.0017Z",
                        fill: "#141414"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M19.893 5.59336C19.893 6.3882 19.2485 7.03267 18.4535 7.03267C17.6586 7.03267 17.0142 6.3882 17.0142 5.59336C17.0142 4.79835 17.6586 4.15405 18.4535 4.15405C19.2485 4.15405 19.893 4.79835 19.893 5.59336Z",
                        fill: "#141414"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_Instagram = (Instagram);

;// CONCATENATED MODULE: ./components/icons/Icons/Left.tsx


const Left = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7 3L4 6L7 9",
            stroke: "black",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var Icons_Left = (Left);

;// CONCATENATED MODULE: ./components/icons/Icons/Like.tsx


const Like = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 21.9999H18.229C18.6568 22 19.0734 21.8629 19.4175 21.6088C19.7616 21.3546 20.0152 20.9968 20.141 20.5879L22.91 11.5879C23.002 11.2889 23.0225 10.9725 22.97 10.6641C22.9175 10.3558 22.7934 10.064 22.6076 9.8123C22.4218 9.5606 22.1796 9.35599 21.9004 9.2149C21.6212 9.07381 21.3128 9.00018 21 8.99993H14V4.99993C14 2.62693 12.749 1.50593 11.236 1.13993C11.0884 1.10526 10.9348 1.10441 10.7868 1.13744C10.6389 1.17048 10.5002 1.23654 10.3814 1.33069C10.2625 1.42484 10.1665 1.54464 10.1004 1.68113C10.0344 1.81763 10.0001 1.96729 10 2.11893V5.99993L5 11.9999",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 10H1V22H5V10Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_Like = (Like);

;// CONCATENATED MODULE: ./components/icons/Icons/LinkedInFilled.tsx


const LinkedInFilled = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.67055 3.07418C3.11772 2.65328 3.70143 2.44263 4.42183 2.44263C5.14227 2.44263 5.71973 2.6531 6.15359 3.07418C6.58748 3.49517 6.80899 4.02671 6.81766 4.66917C6.82628 5.30287 6.60714 5.83236 6.16015 6.25759C5.71317 6.68305 5.12498 6.89562 4.39574 6.89562H4.3697C3.65792 6.89562 3.08493 6.68287 2.65103 6.25759C2.21699 5.83236 2 5.30268 2 4.66917C2 4.02667 2.22342 3.49517 2.67055 3.07418ZM20.6458 9.83223C19.7432 8.84696 18.5494 8.35423 17.0651 8.35423C16.5183 8.35423 16.0212 8.4215 15.574 8.55613C15.127 8.69067 14.7495 8.87943 14.4413 9.12251C14.1332 9.36559 13.8878 9.59125 13.7057 9.79949C13.5325 9.99728 13.3631 10.2277 13.1978 10.4883V8.6535H8.91379L8.92692 9.27858C8.93572 9.69537 8.94006 10.98 8.94006 13.1327C8.94006 15.2855 8.93139 18.0936 8.91397 21.5571H13.1978V14.3565C13.1978 13.9139 13.2453 13.5624 13.341 13.3018C13.5234 12.8588 13.7987 12.488 14.1679 12.1887C14.5369 11.8889 14.9947 11.7392 15.5417 11.7392C16.288 11.7392 16.8373 11.9974 17.1889 12.5139C17.5404 13.0304 17.7162 13.7444 17.7162 14.6559V21.5567H22V14.1614C21.9997 12.2602 21.5486 10.8172 20.6458 9.83223ZM6.54414 8.65359H2.24731V21.557H6.54414V8.65359Z",
            fill: "#141414"
        })
    });
};
/* harmony default export */ var Icons_LinkedInFilled = (LinkedInFilled);

;// CONCATENATED MODULE: ./components/icons/Icons/LogoAfterPay.tsx


const LogoAfterPay = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "30",
                height: "30",
                rx: "15",
                fill: "#B2FCE4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.9558 10.9361L17.2124 8.27495C15.8201 7.49382 14.0796 8.46994 14.0796 10.0333V10.3063C14.0796 10.553 14.2153 10.7812 14.4348 10.9039L15.3304 11.4063C15.5935 11.5543 15.9215 11.3696 15.9215 11.0749V10.3958C15.9215 10.0563 16.2991 9.84409 16.6012 10.0138L20.7097 12.3194C21.0118 12.4891 21.0118 12.9135 20.7097 13.0822L16.6012 15.3877C16.2991 15.5575 15.9215 15.3453 15.9215 15.0057V14.6444C15.9215 13.081 14.1811 12.1037 12.7876 12.886L8.04425 15.5471C6.65192 16.3283 6.65192 18.2828 8.04425 19.0639L12.7876 21.7251C14.1799 22.5062 15.9215 21.5301 15.9215 19.9667V19.6937C15.9215 19.447 15.7858 19.2199 15.5664 19.0961L14.6708 18.5925C14.4077 18.4445 14.0796 18.6292 14.0796 18.924V19.603C14.0796 19.9426 13.7021 20.1548 13.4 19.985L9.29144 17.6795C8.98938 17.5097 8.98938 17.0853 9.29144 16.9155L13.4 14.61C13.7021 14.4402 14.0796 14.6524 14.0796 14.992V15.3533C14.0796 16.9167 15.8201 17.894 17.2124 17.1117L21.9558 14.4506C23.3481 13.6717 23.3481 11.7172 21.9558 10.9361Z",
                fill: "black"
            })
        ]
    });
};
/* harmony default export */ var Icons_LogoAfterPay = (LogoAfterPay);

;// CONCATENATED MODULE: ./components/icons/Icons/LogoAfterPayBusiness.tsx


const LogoAfterPayBusiness = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "218",
        height: "28",
        viewBox: "0 0 218 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.95859 13.7444C9.95859 11.5873 8.43108 10.0712 6.55474 10.0712C4.6784 10.0712 3.15087 11.6129 3.15087 13.7444C3.15087 15.8503 4.6784 17.4175 6.55474 17.4175C8.43299 17.4155 9.95859 15.9015 9.95859 13.7444ZM9.98543 20.1645V18.4951C9.05972 19.6513 7.68169 20.369 6.03151 20.369C2.60273 20.369 0 17.5433 0 13.7444C0 9.969 2.70239 7.0942 6.10817 7.0942C7.71044 7.0942 9.06163 7.81389 9.98735 8.94257V7.32427H13.0654V20.1645H9.98543Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.0167 17.3133C26.9396 17.3133 26.6406 16.9023 26.6406 15.8248V10.1243H28.6185V7.32427H26.6406V4.19189H23.4859V7.32427H19.4227V6.54363C19.4227 5.46411 19.8233 5.05314 20.9253 5.05314H21.6172V2.56179H20.0993C17.4965 2.56179 16.2699 3.43484 16.2699 6.10513V7.3223H14.5182V10.1224H16.2699V20.1625H19.4246V10.1224H23.4878V16.4147C23.4878 19.0338 24.4633 20.1645 27.0162 20.1645H28.6434V17.3133H28.0167Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M39.3303 12.5882C39.1061 10.9187 37.7779 9.91787 36.2273 9.91787C34.6749 9.91787 33.3985 10.8932 33.0746 12.5882H39.3303ZM33.0477 14.5919C33.2739 16.4914 34.6002 17.5709 36.2772 17.5709C37.6035 17.5709 38.6307 16.9279 39.2306 15.9015H42.4601C41.7088 18.6229 39.3303 20.369 36.2024 20.369C32.4229 20.369 29.7704 17.6476 29.7704 13.7699C29.7704 9.89231 32.5743 7.09224 36.2791 7.09224C40.0088 7.09224 42.7112 9.91787 42.7112 13.7699C42.7112 14.0531 42.6862 14.3343 42.6364 14.5919H33.0477Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M62.7683 13.7444C62.7683 11.664 61.2408 10.0712 59.3644 10.0712C57.4881 10.0712 55.9606 11.6129 55.9606 13.7444C55.9606 15.8503 57.4881 17.4175 59.3644 17.4175C61.2408 17.4155 62.7683 15.8248 62.7683 13.7444ZM52.8557 7.32427H55.9337V8.99369C56.8594 7.81192 58.2355 7.0942 59.8876 7.0942C63.2666 7.0942 65.9192 9.9454 65.9192 13.7188C65.9192 17.4942 63.2168 20.371 59.8129 20.371C58.2356 20.371 56.9342 19.728 56.0334 18.6504V25.448H52.8557V7.32427Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M77.0143 13.7444C77.0143 11.5873 75.4887 10.0712 73.6104 10.0712C71.7341 10.0712 70.2066 11.6129 70.2066 13.7444C70.2066 15.8503 71.7341 17.4175 73.6104 17.4175C75.4887 17.4155 77.0143 15.9015 77.0143 13.7444ZM77.0411 20.1645V18.4951C76.1154 19.6513 74.7374 20.369 73.0872 20.369C69.6584 20.369 67.0557 17.5433 67.0557 13.7444C67.0557 9.969 69.7581 7.0942 73.1619 7.0942C74.7642 7.0942 76.1154 7.81389 77.0411 8.94257V7.32427H80.1191V20.1645H77.0411Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M47.3072 8.58273C47.3072 8.58273 48.091 7.0942 50.0096 7.0942C50.8299 7.0942 51.3608 7.38326 51.3608 7.38326V10.6592C51.3608 10.6592 50.2031 9.92574 49.1394 10.0732C48.0757 10.2207 47.403 11.2235 47.4068 12.5646V20.1665H44.2291V7.32624H47.3072V8.58273Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M94.4955 7.32426L86.7237 25.4067H83.4464L86.4976 18.4164L81.3381 7.32426H85.0525L88.0711 14.7354L91.1683 7.32426H94.4955Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M119.304 7.03325L111.599 2.47134C109.338 1.13226 106.511 2.80561 106.511 5.48574V5.95373C106.511 6.37649 106.731 6.76779 107.087 6.97819L108.542 7.83945C108.97 8.09311 109.502 7.77653 109.502 7.27118V6.1071C109.502 5.52507 110.116 5.16129 110.606 5.45231L117.28 9.40466C117.771 9.69568 117.771 10.4232 117.28 10.7123L110.606 14.6646C110.116 14.9556 109.502 14.5919 109.502 14.0098V13.3904C109.502 10.7103 106.675 9.03499 104.412 10.376L96.7072 14.9379C94.4457 16.277 94.4457 19.6277 96.7072 20.9668L104.412 25.5287C106.673 26.8677 109.502 25.1944 109.502 22.5143V22.0463C109.502 21.6235 109.282 21.2342 108.925 21.0218L107.471 20.1586C107.043 19.9049 106.511 20.2215 106.511 20.7269V21.8909C106.511 22.473 105.897 22.8367 105.407 22.5457L98.7331 18.5934C98.2424 18.3024 98.2424 17.5748 98.7331 17.2838L105.407 13.3314C105.897 13.0404 106.511 13.4042 106.511 13.9862V14.6056C106.511 17.2858 109.338 18.9611 111.599 17.62L119.304 13.0581C121.565 11.723 121.565 8.37233 119.304 7.03325Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M147.436 18.09V19H145.714V9.48H147.492V12.854C147.772 12.5367 148.094 12.294 148.458 12.126C148.831 11.958 149.228 11.874 149.648 11.874C150.6 11.874 151.398 12.2193 152.042 12.91C152.695 13.6007 153.022 14.4593 153.022 15.486C153.022 16.5033 152.691 17.362 152.028 18.062C151.375 18.762 150.567 19.112 149.606 19.112C149.167 19.112 148.761 19.028 148.388 18.86C148.015 18.6827 147.697 18.426 147.436 18.09ZM147.45 15.5C147.45 16.0693 147.632 16.5453 147.996 16.928C148.369 17.3107 148.822 17.502 149.354 17.502C149.886 17.502 150.334 17.3107 150.698 16.928C151.071 16.536 151.258 16.06 151.258 15.5C151.258 14.94 151.071 14.4687 150.698 14.086C150.334 13.694 149.886 13.498 149.354 13.498C148.822 13.498 148.369 13.6893 147.996 14.072C147.632 14.4547 147.45 14.9307 147.45 15.5ZM160.129 12V19H158.407V18.132C158.249 18.4213 157.992 18.6593 157.637 18.846C157.292 19.0233 156.905 19.112 156.475 19.112C155.729 19.112 155.141 18.8973 154.711 18.468C154.291 18.0387 154.081 17.446 154.081 16.69V12H155.859V16.41C155.859 16.774 155.967 17.0633 156.181 17.278C156.396 17.4833 156.69 17.586 157.063 17.586C157.437 17.586 157.745 17.4787 157.987 17.264C158.239 17.0493 158.365 16.774 158.365 16.438V12H160.129ZM164.457 11.874C165.353 11.874 166.081 12.07 166.641 12.462C167.211 12.854 167.533 13.4047 167.607 14.114H165.941C165.848 13.8247 165.666 13.61 165.395 13.47C165.134 13.3207 164.784 13.246 164.345 13.246C163.935 13.246 163.608 13.3113 163.365 13.442C163.132 13.5633 163.015 13.736 163.015 13.96C163.015 14.156 163.118 14.31 163.323 14.422C163.538 14.534 164.009 14.632 164.737 14.716C165.307 14.7907 165.727 14.8607 165.997 14.926C166.277 14.9913 166.515 15.0707 166.711 15.164C167.066 15.3227 167.327 15.5373 167.495 15.808C167.663 16.0693 167.747 16.3913 167.747 16.774C167.747 17.4833 167.439 18.0527 166.823 18.482C166.217 18.902 165.419 19.112 164.429 19.112C163.459 19.112 162.689 18.916 162.119 18.524C161.55 18.132 161.223 17.5627 161.139 16.816H162.861C162.973 17.1427 163.16 17.3807 163.421 17.53C163.683 17.6793 164.047 17.754 164.513 17.754C164.971 17.754 165.33 17.684 165.591 17.544C165.862 17.404 165.997 17.208 165.997 16.956C165.997 16.7507 165.885 16.5873 165.661 16.466C165.447 16.3447 164.966 16.242 164.219 16.158C163.659 16.0833 163.239 16.018 162.959 15.962C162.689 15.8967 162.455 15.8173 162.259 15.724C161.914 15.5653 161.657 15.3553 161.489 15.094C161.321 14.8327 161.237 14.5153 161.237 14.142C161.237 13.4513 161.527 12.9007 162.105 12.49C162.684 12.0793 163.468 11.874 164.457 11.874ZM170.71 10.124C170.71 10.3947 170.608 10.6327 170.402 10.838C170.206 11.034 169.973 11.132 169.702 11.132C169.432 11.132 169.194 11.034 168.988 10.838C168.792 10.6327 168.694 10.3947 168.694 10.124C168.694 9.85333 168.792 9.62 168.988 9.424C169.194 9.21867 169.432 9.116 169.702 9.116C169.973 9.116 170.206 9.21867 170.402 9.424C170.608 9.62 170.71 9.85333 170.71 10.124ZM170.57 12V19H168.806V12H170.57ZM178.094 14.324V19H176.33V14.646C176.33 14.282 176.218 13.9927 175.994 13.778C175.779 13.5633 175.485 13.456 175.112 13.456C174.739 13.456 174.431 13.568 174.188 13.792C173.945 14.0067 173.824 14.2867 173.824 14.632V19H172.046V12H173.768V12.882C173.945 12.5833 174.207 12.3407 174.552 12.154C174.907 11.9673 175.294 11.874 175.714 11.874C176.451 11.874 177.03 12.0933 177.45 12.532C177.879 12.9707 178.094 13.568 178.094 14.324ZM186.412 15.514C186.412 15.5887 186.408 15.668 186.398 15.752C186.389 15.8267 186.38 15.8967 186.37 15.962H181.008C181.064 16.4567 181.256 16.8533 181.582 17.152C181.918 17.4413 182.329 17.586 182.814 17.586C183.169 17.586 183.486 17.5067 183.766 17.348C184.056 17.1893 184.289 16.9653 184.466 16.676H186.272C186.058 17.4227 185.638 18.0153 185.012 18.454C184.387 18.8927 183.64 19.112 182.772 19.112C181.718 19.112 180.854 18.776 180.182 18.104C179.51 17.432 179.174 16.5687 179.174 15.514C179.174 14.4687 179.52 13.6007 180.21 12.91C180.901 12.2193 181.769 11.874 182.814 11.874C183.86 11.874 184.718 12.2193 185.39 12.91C186.072 13.5913 186.412 14.4593 186.412 15.514ZM182.786 13.414C182.338 13.414 181.951 13.5447 181.624 13.806C181.307 14.0673 181.106 14.422 181.022 14.87H184.522C184.466 14.4313 184.275 14.0813 183.948 13.82C183.631 13.5493 183.244 13.414 182.786 13.414ZM190.366 11.874C191.262 11.874 191.99 12.07 192.55 12.462C193.119 12.854 193.441 13.4047 193.516 14.114H191.85C191.756 13.8247 191.574 13.61 191.304 13.47C191.042 13.3207 190.692 13.246 190.254 13.246C189.843 13.246 189.516 13.3113 189.274 13.442C189.04 13.5633 188.924 13.736 188.924 13.96C188.924 14.156 189.026 14.31 189.232 14.422C189.446 14.534 189.918 14.632 190.646 14.716C191.215 14.7907 191.635 14.8607 191.906 14.926C192.186 14.9913 192.424 15.0707 192.62 15.164C192.974 15.3227 193.236 15.5373 193.404 15.808C193.572 16.0693 193.656 16.3913 193.656 16.774C193.656 17.4833 193.348 18.0527 192.732 18.482C192.125 18.902 191.327 19.112 190.338 19.112C189.367 19.112 188.597 18.916 188.028 18.524C187.458 18.132 187.132 17.5627 187.048 16.816H188.77C188.882 17.1427 189.068 17.3807 189.33 17.53C189.591 17.6793 189.955 17.754 190.422 17.754C190.879 17.754 191.238 17.684 191.5 17.544C191.77 17.404 191.906 17.208 191.906 16.956C191.906 16.7507 191.794 16.5873 191.57 16.466C191.355 16.3447 190.874 16.242 190.128 16.158C189.568 16.0833 189.148 16.018 188.868 15.962C188.597 15.8967 188.364 15.8173 188.168 15.724C187.822 15.5653 187.566 15.3553 187.398 15.094C187.23 14.8327 187.146 14.5153 187.146 14.142C187.146 13.4513 187.435 12.9007 188.014 12.49C188.592 12.0793 189.376 11.874 190.366 11.874ZM197.571 11.874C198.467 11.874 199.195 12.07 199.755 12.462C200.324 12.854 200.646 13.4047 200.721 14.114H199.055C198.961 13.8247 198.779 13.61 198.509 13.47C198.247 13.3207 197.897 13.246 197.459 13.246C197.048 13.246 196.721 13.3113 196.479 13.442C196.245 13.5633 196.129 13.736 196.129 13.96C196.129 14.156 196.231 14.31 196.437 14.422C196.651 14.534 197.123 14.632 197.851 14.716C198.42 14.7907 198.84 14.8607 199.111 14.926C199.391 14.9913 199.629 15.0707 199.825 15.164C200.179 15.3227 200.441 15.5373 200.609 15.808C200.777 16.0693 200.861 16.3913 200.861 16.774C200.861 17.4833 200.553 18.0527 199.937 18.482C199.33 18.902 198.532 19.112 197.543 19.112C196.572 19.112 195.802 18.916 195.233 18.524C194.663 18.132 194.337 17.5627 194.253 16.816H195.975C196.087 17.1427 196.273 17.3807 196.535 17.53C196.796 17.6793 197.16 17.754 197.627 17.754C198.084 17.754 198.443 17.684 198.705 17.544C198.975 17.404 199.111 17.208 199.111 16.956C199.111 16.7507 198.999 16.5873 198.775 16.466C198.56 16.3447 198.079 16.242 197.333 16.158C196.773 16.0833 196.353 16.018 196.073 15.962C195.802 15.8967 195.569 15.8173 195.373 15.724C195.027 15.5653 194.771 15.3553 194.603 15.094C194.435 14.8327 194.351 14.5153 194.351 14.142C194.351 13.4513 194.64 12.9007 195.219 12.49C195.797 12.0793 196.581 11.874 197.571 11.874Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "130",
                y: "1",
                width: "87",
                height: "26",
                rx: "13",
                stroke: "white",
                strokeWidth: "2"
            })
        ]
    });
};
/* harmony default export */ var Icons_LogoAfterPayBusiness = (LogoAfterPayBusiness);

;// CONCATENATED MODULE: ./components/icons/Icons/Menu.tsx


const Menu = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2H15C15.5523 2 16 1.55228 16 1C16 0.447715 15.5523 0 15 0H1ZM0 8C0 7.44772 0.447715 7 1 7H15C15.5523 7 16 7.44772 16 8C16 8.55229 15.5523 9 15 9H1C0.447715 9 0 8.55229 0 8ZM0 15C0 14.4477 0.447715 14 1 14H15C15.5523 14 16 14.4477 16 15C16 15.5523 15.5523 16 15 16H1C0.447715 16 0 15.5523 0 15Z",
            fill: "black"
        })
    });
};
/* harmony default export */ var Icons_Menu = (Menu);

;// CONCATENATED MODULE: ./components/icons/Icons/MenuHeader.tsx


const MenuHeader = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1 3C0.447715 3 0 3.44772 0 4C0 4.55228 0.447715 5 1 5L23 5C23.5523 5 24 4.55228 24 4C24 3.44772 23.5523 3 23 3L1 3ZM0 12C0 11.4477 0.447715 11 1 11L23 11C23.5523 11 24 11.4477 24 12C24 12.5523 23.5523 13 23 13L1 13C0.447715 13 0 12.5523 0 12ZM0 20C0 19.4477 0.447715 19 1 19H23C23.5523 19 24 19.4477 24 20C24 20.5523 23.5523 21 23 21L1 21C0.447715 21 0 20.5523 0 20Z",
            fill: "white"
        })
    });
};
/* harmony default export */ var Icons_MenuHeader = (MenuHeader);

;// CONCATENATED MODULE: ./components/icons/Icons/OpeningTime.tsx


const OpeningTime = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.5 5.5H15.5",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.5 5.5V3.5C15.5 3.23478 15.3946 2.98043 15.2071 2.79289C15.0196 2.60536 14.7652 2.5 14.5 2.5H1.5C1.23478 2.5 0.98043 2.60536 0.792893 2.79289C0.605357 2.98043 0.5 3.23478 0.5 3.5V14.5C0.5 14.7652 0.605357 15.0196 0.792893 15.2071C0.98043 15.3946 1.23478 15.5 1.5 15.5H6.5",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.5 0.5V2.5",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.5 0.5V2.5",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.5 15.5C13.7091 15.5 15.5 13.7091 15.5 11.5C15.5 9.29086 13.7091 7.5 11.5 7.5C9.29086 7.5 7.5 9.29086 7.5 11.5C7.5 13.7091 9.29086 15.5 11.5 15.5Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.5 9.5V11.5H13.5",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_OpeningTime = (OpeningTime);

;// CONCATENATED MODULE: ./components/icons/Icons/PasswordHide.tsx


const PasswordHide = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.5 8C0.5 8 3.5 2.5 8 2.5C12.5 2.5 15.5 8 15.5 8C15.5 8 12.5 13.5 8 13.5C3.5 13.5 0.5 8 0.5 8Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 8C5 6.343 6.343 5 8 5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11 8C11 9.657 9.657 11 8 11",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 15L15 1",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_PasswordHide = (PasswordHide);

;// CONCATENATED MODULE: ./components/icons/Icons/PasswordShow.tsx


const PasswordShow = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.5 8C0.5 8 3.5 2.5 8 2.5C12.5 2.5 15.5 8 15.5 8C15.5 8 12.5 13.5 8 13.5C3.5 13.5 0.5 8 0.5 8Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 10.5C9.38071 10.5 10.5 9.38071 10.5 8C10.5 6.61929 9.38071 5.5 8 5.5C6.61929 5.5 5.5 6.61929 5.5 8C5.5 9.38071 6.61929 10.5 8 10.5Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_PasswordShow = (PasswordShow);

;// CONCATENATED MODULE: ./components/icons/Icons/PeopleCircle.tsx


const PeopleCircle = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 8.5C9.38071 8.5 10.5 7.38071 10.5 6C10.5 4.61929 9.38071 3.5 8 3.5C6.61929 3.5 5.5 4.61929 5.5 6C5.5 7.38071 6.61929 8.5 8 8.5Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.9529 13.6211C12.5057 12.6867 11.8033 11.8979 10.9269 11.3457C10.0505 10.7935 9.03575 10.5005 7.99988 10.5005C6.964 10.5005 5.94926 10.7935 5.07283 11.3457C4.19641 11.8979 3.49404 12.6867 3.04688 13.6211",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_PeopleCircle = (PeopleCircle);

;// CONCATENATED MODULE: ./components/icons/Icons/PeopleCircleFilled.tsx


const PeopleCircleFilled = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 10C9.65685 10 11 8.65685 11 7C11 5.34315 9.65685 4 8 4C6.34315 4 5 5.34315 5 7C5 8.65685 6.34315 10 8 10Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM12 12.4C11.4 11.7 10.6 11 9 11H7C5.4 11 4.6 11.7 4 12.4C2.8 11.3 2 9.8 2 8C2 4.7 4.7 2 8 2C11.3 2 14 4.7 14 8C14 9.8 13.2 11.3 12 12.4Z",
                fill: "black"
            })
        ]
    });
};
/* harmony default export */ var Icons_PeopleCircleFilled = (PeopleCircleFilled);

;// CONCATENATED MODULE: ./components/icons/Icons/PeopleCircleOutline.tsx


const PeopleCircleOutline = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.4996 20.9859V20.2409C19.4996 19.1639 18.9226 18.1699 17.9876 17.6359L14.7686 15.7939",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.227 15.792L7.012 17.636C6.077 18.17 5.5 19.164 5.5 20.241V20.986",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5 16.5C10.291 16.5 8.5 14.709 8.5 12.5V10.5C8.5 8.291 10.291 6.5 12.5 6.5C14.709 6.5 16.5 8.291 16.5 10.5V12.5C16.5 14.709 14.709 16.5 12.5 16.5Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5 23.5C18.5751 23.5 23.5 18.5751 23.5 12.5C23.5 6.42487 18.5751 1.5 12.5 1.5C6.42487 1.5 1.5 6.42487 1.5 12.5C1.5 18.5751 6.42487 23.5 12.5 23.5Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_PeopleCircleOutline = (PeopleCircleOutline);

;// CONCATENATED MODULE: ./components/icons/Icons/PieChart.tsx


const PieChart = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 2C3.1 2 0 5.1 0 9C0 12.9 3.1 16 7 16C10.9 16 14 12.9 14 9H7V2Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 0V7H16C16 3.1 12.9 0 9 0Z",
                fill: "black"
            })
        ]
    });
};
/* harmony default export */ var Icons_PieChart = (PieChart);

;// CONCATENATED MODULE: ./components/icons/Icons/ReadBook.tsx


const ReadBook = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 3H8C9.06087 3 10.0783 3.42143 10.8284 4.17157C11.5786 4.92172 12 5.93913 12 7V21C12 20.2044 11.6839 19.4413 11.1213 18.8787C10.5587 18.3161 9.79565 18 9 18H2V3Z",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22 3H16C14.9391 3 13.9217 3.42143 13.1716 4.17157C12.4214 4.92172 12 5.93913 12 7V21C12 20.2044 12.3161 19.4413 12.8787 18.8787C13.4413 18.3161 14.2044 18 15 18H22V3Z",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_ReadBook = (ReadBook);

;// CONCATENATED MODULE: ./components/icons/Icons/ReceiptList.tsx


const ReceiptList = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.5 1.5H21.5V22.5L18.5 20.5L15.5 22.5L12.5 20.5L9.5 22.5L6.5 20.5L3.5 22.5V1.5Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.5 7.5H12.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.5 7.5H17.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.5 11.5H12.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.5 11.5H17.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.5 15.5H12.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.5 15.5H17.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_ReceiptList = (ReceiptList);

;// CONCATENATED MODULE: ./components/icons/Icons/ReceiptListFilled.tsx


const ReceiptListFilled = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "17",
        height: "17",
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M14.0017 0.00170278H2.0017C1.86829 -0.00631686 1.73469 0.0140548 1.60973 0.0614728C1.48477 0.108891 1.37129 0.182276 1.27678 0.276784C1.18228 0.371292 1.10889 0.484772 1.06147 0.609732C1.01405 0.734692 0.993685 0.868289 1.0017 1.0017V16.0017L4.0017 14.0017L6.0017 16.0017L8.0017 14.0017L10.0017 16.0017L12.0017 14.0017L15.0017 16.0017V1.0017C15.0097 0.868289 14.9894 0.734692 14.9419 0.609732C14.8945 0.484772 14.8211 0.371292 14.7266 0.276784C14.6321 0.182276 14.5186 0.108891 14.3937 0.0614728C14.2687 0.0140548 14.1351 -0.00631686 14.0017 0.00170278ZM8.0017 10.0017H4.0017V8.0017H8.0017V10.0017ZM8.0017 6.0017H4.0017V4.0017H8.0017V6.0017ZM11.0017 10.0017C10.8039 10.0017 10.6106 9.94305 10.4461 9.83317C10.2817 9.72329 10.1535 9.56711 10.0778 9.38439C10.0021 9.20166 9.98233 9.00059 10.0209 8.80661C10.0595 8.61263 10.1547 8.43445 10.2946 8.2946C10.4344 8.15474 10.6126 8.0595 10.8066 8.02092C11.0006 7.98233 11.2017 8.00214 11.3844 8.07782C11.5671 8.15351 11.7233 8.28168 11.8332 8.44613C11.9431 8.61058 12.0017 8.80392 12.0017 9.0017C12.0017 9.26692 11.8963 9.52127 11.7088 9.70881C11.5213 9.89635 11.2669 10.0017 11.0017 10.0017ZM11.0017 6.0017C10.8039 6.0017 10.6106 5.94305 10.4461 5.83317C10.2817 5.72329 10.1535 5.56711 10.0778 5.38439C10.0021 5.20166 9.98233 5.00059 10.0209 4.80661C10.0595 4.61263 10.1547 4.43445 10.2946 4.2946C10.4344 4.15474 10.6126 4.0595 10.8066 4.02092C11.0006 3.98233 11.2017 4.00214 11.3844 4.07782C11.5671 4.15351 11.7233 4.28168 11.8332 4.44613C11.9431 4.61058 12.0017 4.80392 12.0017 5.0017C12.0017 5.26692 11.8963 5.52127 11.7088 5.70881C11.5213 5.89635 11.2669 6.0017 11.0017 6.0017Z",
            fill: "black"
        })
    });
};
/* harmony default export */ var Icons_ReceiptListFilled = (ReceiptListFilled);

;// CONCATENATED MODULE: ./components/icons/Icons/Remove.tsx


const Remove = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.5 5.5L5.5 19.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.5 19.5L5.5 5.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_Remove = (Remove);

;// CONCATENATED MODULE: ./components/icons/Icons/RemoveBold.tsx


const RemoveBold = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.63603 4.29289C5.24551 3.90237 4.61234 3.90237 4.22182 4.29289C3.83129 4.68342 3.83129 5.31658 4.22182 5.70711L11.5147 13L4.22187 20.2928C3.83135 20.6833 3.83135 21.3165 4.22187 21.707C4.61239 22.0976 5.24556 22.0976 5.63608 21.707L12.9289 14.4142L19.7782 21.2635C20.1687 21.654 20.8019 21.654 21.1924 21.2635C21.5829 20.8729 21.5829 20.2398 21.1924 19.8492L14.3431 13L21.1924 6.15069C21.583 5.76016 21.583 5.127 21.1924 4.73647C20.8019 4.34595 20.1687 4.34595 19.7782 4.73647L12.9289 11.5858L5.63603 4.29289Z",
            fill: "white"
        })
    });
};
/* harmony default export */ var Icons_RemoveBold = (RemoveBold);

;// CONCATENATED MODULE: ./components/icons/Icons/RemoveCircle.tsx


const RemoveCircle = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "8",
                fill: "#333333"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.375 5.375L10.625 10.625",
                stroke: "white",
                strokeMiterlimit: "10",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.375 10.625L10.625 5.375",
                stroke: "white",
                strokeMiterlimit: "10",
                strokeLinecap: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_RemoveCircle = (RemoveCircle);

;// CONCATENATED MODULE: ./components/icons/Icons/Resource.tsx


const Resource = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.5 9.40002L7.5 4.21002",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21 16V8.00002C20.9996 7.6493 20.9071 7.30483 20.7315 7.00119C20.556 6.69754 20.3037 6.44539 20 6.27002L13 2.27002C12.696 2.09449 12.3511 2.00208 12 2.00208C11.6489 2.00208 11.304 2.09449 11 2.27002L4 6.27002C3.69626 6.44539 3.44398 6.69754 3.26846 7.00119C3.09294 7.30483 3.00036 7.6493 3 8.00002V16C3.00036 16.3508 3.09294 16.6952 3.26846 16.9989C3.44398 17.3025 3.69626 17.5547 4 17.73L11 21.73C11.304 21.9056 11.6489 21.998 12 21.998C12.3511 21.998 12.696 21.9056 13 21.73L20 17.73C20.3037 17.5547 20.556 17.3025 20.7315 16.9989C20.9071 16.6952 20.9996 16.3508 21 16Z",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.27002 6.96002L12 12.01L20.73 6.96002",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 22.08V12",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_Resource = (Resource);

;// CONCATENATED MODULE: ./components/icons/Icons/Right.tsx


const Right = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M5 9L8 6L5 3",
            stroke: "black",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var Icons_Right = (Right);

;// CONCATENATED MODULE: ./components/icons/Icons/Schedule.tsx


const Schedule = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.5 16.5V18.5H19.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.5 23.5C20.2614 23.5 22.5 21.2614 22.5 18.5C22.5 15.7386 20.2614 13.5 17.5 13.5C14.7386 13.5 12.5 15.7386 12.5 18.5C12.5 21.2614 14.7386 23.5 17.5 23.5Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.5 22.5H1.5V4.5H23.5V11.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.5 1.5V4.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.5 1.5V4.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.5 8.5H23.5",
                stroke: "black",
                strokeMiterlimit: "10"
            })
        ]
    });
};
/* harmony default export */ var Icons_Schedule = (Schedule);

;// CONCATENATED MODULE: ./components/icons/Icons/Search.tsx


const Search = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.5 13.5C10.8137 13.5 13.5 10.8137 13.5 7.5C13.5 4.18629 10.8137 1.5 7.5 1.5C4.18629 1.5 1.5 4.18629 1.5 7.5C1.5 10.8137 4.18629 13.5 7.5 13.5Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.5002 15.5002L11.7422 11.7422",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_Search = (Search);

;// CONCATENATED MODULE: ./components/icons/Icons/SearchBig.tsx


const SearchBig = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.5002 22.4998L16.1562 16.1558",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.5 18.5C14.9183 18.5 18.5 14.9183 18.5 10.5C18.5 6.08172 14.9183 2.5 10.5 2.5C6.08172 2.5 2.5 6.08172 2.5 10.5C2.5 14.9183 6.08172 18.5 10.5 18.5Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_SearchBig = (SearchBig);

;// CONCATENATED MODULE: ./components/icons/Icons/SettingFilled.tsx


const SettingFilled = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M15.135 6.784C13.832 6.458 13.214 4.966 13.905 3.815C14.227 3.279 14.13 2.817 13.811 2.499L13.501 2.189C13.183 1.871 12.721 1.774 12.185 2.095C11.033 2.786 9.541 2.168 9.216 0.865C9.065 0.258 8.669 0 8.219 0H7.781C7.331 0 6.936 0.258 6.784 0.865C6.458 2.168 4.966 2.786 3.815 2.095C3.279 1.773 2.816 1.87 2.498 2.188L2.188 2.498C1.87 2.816 1.773 3.279 2.095 3.815C2.786 4.967 2.168 6.459 0.865 6.784C0.26 6.935 0 7.33 0 7.781V8.219C0 8.669 0.258 9.064 0.865 9.216C2.168 9.542 2.786 11.034 2.095 12.185C1.773 12.721 1.87 13.183 2.189 13.501L2.499 13.811C2.818 14.13 3.281 14.226 3.815 13.905C4.967 13.214 6.459 13.832 6.784 15.135C6.935 15.742 7.331 16 7.781 16H8.219C8.669 16 9.064 15.742 9.216 15.135C9.542 13.832 11.034 13.214 12.185 13.905C12.72 14.226 13.182 14.13 13.501 13.811L13.811 13.501C14.129 13.183 14.226 12.721 13.905 12.185C13.214 11.033 13.832 9.541 15.135 9.216C15.742 9.065 16 8.669 16 8.219V7.781C16 7.33 15.74 6.935 15.135 6.784ZM8 11C6.343 11 5 9.657 5 8C5 6.343 6.343 5 8 5C9.657 5 11 6.343 11 8C11 9.657 9.657 11 8 11Z",
            fill: "black"
        })
    });
};
/* harmony default export */ var Icons_SettingFilled = (SettingFilled);

;// CONCATENATED MODULE: ./components/icons/Icons/SettingOutline.tsx


const SettingOutline = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23 12C23 10.895 22.105 10 21 10H19.738C19.549 9.268 19.261 8.578 18.886 7.942L19.778 7.05C20.559 6.269 20.559 5.003 19.778 4.222C18.997 3.441 17.731 3.441 16.95 4.222L16.058 5.114C15.422 4.739 14.732 4.451 14 4.262V3C14 1.896 13.105 1 12 1C10.895 1 10 1.895 10 3V4.262C9.268 4.451 8.578 4.739 7.942 5.114L7.05 4.222C6.269 3.441 5.003 3.441 4.222 4.222C3.441 5.003 3.441 6.269 4.222 7.05L5.114 7.942C4.739 8.578 4.451 9.268 4.262 10H3C1.896 10 1 10.895 1 12C1 13.105 1.895 14 3 14H4.262C4.451 14.732 4.739 15.422 5.114 16.058L4.222 16.95C3.441 17.731 3.441 18.997 4.222 19.778C5.003 20.559 6.269 20.559 7.05 19.778L7.942 18.886C8.577 19.261 9.268 19.549 10 19.738V21C10 22.104 10.895 23 12 23C13.105 23 14 22.105 14 21V19.738C14.732 19.549 15.422 19.261 16.058 18.886L16.95 19.778C17.731 20.559 18.997 20.559 19.778 19.778C20.559 18.997 20.559 17.731 19.778 16.95L18.886 16.058C19.261 15.423 19.549 14.732 19.738 14H21C22.104 14 23 13.105 23 12Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_SettingOutline = (SettingOutline);

;// CONCATENATED MODULE: ./components/icons/Icons/Shop.tsx


const Shop = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.5 13.5V22.5H20.5V13.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.50001 2.5L1.50001 7.5C1.4985 8.17436 1.72485 8.82946 2.14235 9.35905C2.55985 9.88864 3.14402 10.2617 3.8001 10.4176C4.45619 10.5735 5.14572 10.5033 5.75686 10.2182C6.36801 9.93311 6.86492 9.44992 7.16701 8.847C7.41349 9.34349 7.79369 9.76131 8.26479 10.0534C8.7359 10.3455 9.2792 10.5003 9.83351 10.5003C10.3878 10.5003 10.9311 10.3455 11.4022 10.0534C11.8733 9.76131 12.2535 9.34349 12.5 8.847C12.7465 9.34349 13.1267 9.76131 13.5978 10.0534C14.0689 10.3455 14.6122 10.5003 15.1665 10.5003C15.7208 10.5003 16.2641 10.3455 16.7352 10.0534C17.2063 9.76131 17.5865 9.34349 17.833 8.847C18.1351 9.44992 18.632 9.93311 19.2432 10.2182C19.8543 10.5033 20.5438 10.5735 21.1999 10.4176C21.856 10.2617 22.4402 9.88864 22.8577 9.35905C23.2752 8.82946 23.5015 8.17436 23.5 7.5L20.5 2.5H4.50001Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.5 22.5V16.5H14.5V22.5",
                stroke: "black",
                strokeMiterlimit: "10"
            })
        ]
    });
};
/* harmony default export */ var Icons_Shop = (Shop);

;// CONCATENATED MODULE: ./components/icons/Icons/ShoppingBag.tsx


const ShoppingBag = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.5 23.5H2.5L4.5 7.5H20.5L22.5 23.5Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.5 10.5V5.5C8.50317 4.44011 8.92561 3.42453 9.67507 2.67507C10.4245 1.92561 11.4401 1.50317 12.5 1.5C13.5599 1.50317 14.5755 1.92561 15.3249 2.67507C16.0744 3.42453 16.4968 4.44011 16.5 5.5V10.5",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_ShoppingBag = (ShoppingBag);

;// CONCATENATED MODULE: ./components/icons/Icons/Subscribed.tsx


const Subscribed = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "24",
                cy: "24",
                r: "24",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M32.6036 16.5622L19.9918 29.1657L15.3964 24.5733C15.0184 24.2085 14.5122 24.0066 13.9867 24.0112C13.4612 24.0158 12.9586 24.2264 12.587 24.5977C12.2154 24.9691 12.0046 25.4714 12.0001 25.9965C11.9955 26.5216 12.1975 27.0275 12.5626 27.4053L18.5749 33.4136C18.9507 33.7891 19.4604 34 19.9918 34C20.5232 34 21.0329 33.7891 21.4087 33.4136L35.4374 19.3941C35.8025 19.0164 36.0045 18.5105 35.9999 17.9854C35.9954 17.4603 35.7846 16.9579 35.413 16.5866C35.0414 16.2153 34.5388 16.0046 34.0133 16.0001C33.4878 15.9955 32.9816 16.1974 32.6036 16.5622Z",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ var Icons_Subscribed = (Subscribed);

;// CONCATENATED MODULE: ./components/icons/Icons/Support.tsx


const Support = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.7781 4.22217L15.5361 8.46417",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.7781 19.7779L15.5361 15.5359",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.22168 19.7779L8.46368 15.5359",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.22168 4.22217L8.46368 8.46417",
                stroke: "black",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.7775 19.778C24.0732 15.4823 24.0732 8.51752 19.7775 4.22179C15.4817 -0.0739315 8.51704 -0.0739315 4.22131 4.22179C-0.07442 8.51752 -0.07442 15.4823 4.22131 19.778C8.51704 24.0737 15.4817 24.0737 19.7775 19.778Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.535 15.5354C17.4876 13.5828 17.4876 10.4171 15.535 8.46445C13.5824 6.51185 10.4166 6.51185 8.46396 8.46445C6.51136 10.4171 6.51136 13.5828 8.46396 15.5354C10.4166 17.488 13.5824 17.488 15.535 15.5354Z",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            })
        ]
    });
};
/* harmony default export */ var Icons_Support = (Support);

;// CONCATENATED MODULE: ./components/icons/Icons/Telegram.tsx


const Telegram = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M15.9683 1.68422C15.9557 1.62517 15.9276 1.57057 15.8868 1.52608C15.846 1.48158 15.794 1.44883 15.7363 1.43122C15.526 1.3893 15.3084 1.40484 15.1063 1.47622C15.1063 1.47622 1.08725 6.51422 0.286252 7.07222C0.114252 7.19322 0.056252 7.26222 0.027252 7.34422C-0.110748 7.74422 0.320252 7.91722 0.320252 7.91722L3.93325 9.09422C3.99426 9.10522 4.05701 9.10145 4.11625 9.08322C4.93825 8.56422 12.3863 3.86122 12.8163 3.70322C12.8843 3.68322 12.9343 3.70322 12.9163 3.75222C12.7443 4.35222 6.31025 10.0712 6.27525 10.1062C6.25818 10.1205 6.2448 10.1387 6.23627 10.1592C6.22774 10.1798 6.2243 10.2021 6.22625 10.2242L5.88925 13.7522C5.88925 13.7522 5.74725 14.8522 6.84525 13.7522C7.62425 12.9732 8.37225 12.3272 8.74525 12.0142C9.98725 12.8722 11.3243 13.8202 11.9013 14.3142C11.9979 14.4083 12.1125 14.4819 12.2383 14.5305C12.3641 14.5792 12.4985 14.6018 12.6333 14.5972C12.7992 14.5767 12.955 14.5062 13.0801 14.3952C13.2051 14.2841 13.2934 14.1376 13.3333 13.9752C13.3333 13.9752 15.8943 3.70022 15.9793 2.31722C15.9873 2.18222 16.0003 2.10022 16.0003 2.00022C16.0039 1.89392 15.9931 1.78762 15.9683 1.68422Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_Telegram = (Telegram);

;// CONCATENATED MODULE: ./components/icons/Icons/Trash.tsx


const Trash = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 9V21C20 21.5304 19.7893 22.0391 19.4142 22.4142C19.0391 22.7893 18.5304 23 18 23H6C5.46957 23 4.96086 22.7893 4.58579 22.4142C4.21071 22.0391 4 21.5304 4 21V9",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 5H23",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 12V18",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 12V18",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 12V18",
                stroke: "black",
                strokeMiterlimit: "10",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 5V1H16V5",
                stroke: "black",
                strokeMiterlimit: "10"
            })
        ]
    });
};
/* harmony default export */ var Icons_Trash = (Trash);

;// CONCATENATED MODULE: ./components/icons/Icons/TwitterFilled.tsx


const TwitteFilled = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M24 4.5585C23.1075 4.95 22.1565 5.2095 21.165 5.3355C22.185 4.7265 22.9635 3.7695 23.3295 2.616C22.3785 3.183 21.3285 3.5835 20.2095 3.807C19.3065 2.8455 18.0195 2.25 16.6155 2.25C13.8915 2.25 11.6985 4.461 11.6985 7.1715C11.6985 7.5615 11.7315 7.9365 11.8125 8.2935C7.722 8.094 4.1025 6.1335 1.671 3.147C1.2465 3.8835 0.9975 4.7265 0.9975 5.634C0.9975 7.338 1.875 8.8485 3.183 9.723C2.3925 9.708 1.617 9.4785 0.96 9.117C0.96 9.132 0.96 9.1515 0.96 9.171C0.96 11.562 2.6655 13.548 4.902 14.0055C4.5015 14.115 4.065 14.1675 3.612 14.1675C3.297 14.1675 2.979 14.1495 2.6805 14.0835C3.318 16.032 5.127 17.4645 7.278 17.511C5.604 18.8205 3.4785 19.6095 1.1775 19.6095C0.774 19.6095 0.387 19.5915 0 19.542C2.1795 20.9475 4.7625 21.75 7.548 21.75C16.602 21.75 21.552 14.25 21.552 7.749C21.552 7.5315 21.5445 7.3215 21.534 7.113C22.5105 6.42 23.331 5.5545 24 4.5585Z",
                    fill: "#141414"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var TwitterFilled = (TwitteFilled);

;// CONCATENATED MODULE: ./components/icons/Icons/Up.tsx


const Up = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3 7L6 4L9 7",
            stroke: "black",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var Icons_Up = (Up);

;// CONCATENATED MODULE: ./components/icons/Icons/WorldFilled.tsx


const WorldFilled = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM13.9 7H12C11.9 5.5 11.6 4.1 11.2 2.9C12.6 3.8 13.6 5.3 13.9 7ZM8 14C7.4 14 6.2 12.1 6 9H10C9.8 12.1 8.6 14 8 14ZM6 7C6.2 3.9 7.3 2 8 2C8.7 2 9.8 3.9 10 7H6ZM4.9 2.9C4.4 4.1 4.1 5.5 4 7H2.1C2.4 5.3 3.4 3.8 4.9 2.9ZM2.1 9H4C4.1 10.5 4.4 11.9 4.8 13.1C3.4 12.2 2.4 10.7 2.1 9ZM11.1 13.1C11.6 11.9 11.8 10.5 11.9 9H13.8C13.6 10.7 12.6 12.2 11.1 13.1Z",
            fill: "black"
        })
    });
};
/* harmony default export */ var Icons_WorldFilled = (WorldFilled);

;// CONCATENATED MODULE: ./components/icons/Icons/LogoClearpay.tsx

const LogoClearpay = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "121",
        height: "24",
        viewBox: "0 0 105 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("pattern", {
                    id: "logo-clearpay",
                    viewBox: "0 0 105 21",
                    width: "100%",
                    height: "100%",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M82.9458 4.64771L75.8063 19.8148H72.8483L75.5158 14.1487L71.3253 4.64771H74.3625L77.0564 11.0119L79.9967 4.64771H82.9458Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M55.7784 10.0328C55.7784 8.29216 54.5019 6.95041 52.9349 6.95041C51.3679 6.95041 50.0914 8.24683 50.0914 10.0328C50.0914 11.8006 51.3679 13.1152 52.9349 13.1152C54.5019 13.1152 55.7784 11.7734 55.7784 10.0328ZM47.4944 19.8148V4.64769H50.065V6.04383C50.8397 5.05565 51.9929 4.44824 53.3663 4.44824C56.1922 4.44824 58.4106 6.84162 58.4106 10.0056C58.4106 13.1696 56.1482 15.5811 53.3046 15.5811C51.9841 15.5811 50.9013 15.0462 50.1442 14.1396V19.8058H47.4944V19.8148Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M67.6896 10.0328C67.6896 8.2196 66.4131 6.95038 64.8461 6.95038C63.2791 6.95038 62.0026 8.2468 62.0026 10.0328C62.0026 11.8006 63.2791 13.1152 64.8461 13.1152C66.4131 13.1152 67.6896 11.8369 67.6896 10.0328ZM67.7072 15.4179V14.0217C66.9325 14.9918 65.7793 15.5901 64.4059 15.5901C61.536 15.5901 59.3616 13.2239 59.3616 10.0328C59.3616 6.86879 61.6241 4.45728 64.4676 4.45728C65.8057 4.45728 66.9325 5.06469 67.7072 6.00753V4.64766H70.2778V15.4179H67.7072Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M42.855 5.7003C42.855 5.7003 43.5065 4.44922 45.1175 4.44922C45.8042 4.44922 46.2444 4.694 46.2444 4.694V7.44094C46.2444 7.44094 45.276 6.82447 44.3868 6.95139C43.4977 7.07831 42.9343 7.91237 42.9343 9.03653V15.4189H40.2756V4.64867H42.8462V5.7003H42.855Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M102.912 4.04039L99.866 2.24535L96.776 0.423117C94.7336 -0.782639 92.1806 0.731354 92.1806 3.161V3.56896C92.1806 3.79561 92.2951 4.00412 92.4888 4.11291L93.9237 4.95604C94.3199 5.19175 94.8129 4.89258 94.8129 4.42115V3.45111C94.8129 2.97062 95.3147 2.67144 95.7196 2.90716L98.5367 4.57527L101.345 6.23432C101.75 6.47003 101.75 7.07744 101.345 7.31315L98.5367 8.9722L95.7196 10.6403C95.3147 10.876 94.8129 10.5769 94.8129 10.0964V9.61588C94.8129 7.18623 92.2599 5.66317 90.2175 6.87799L87.1275 8.70022L84.0815 10.4953C82.0303 11.7101 82.0303 14.7653 84.0815 15.9801L87.1275 17.7751L90.2175 19.5974C92.2599 20.8031 94.8129 19.2891 94.8129 16.8595V16.4515C94.8129 16.2249 94.6984 16.0164 94.5047 15.9076L93.0698 15.0644C92.6736 14.8287 92.1806 15.1279 92.1806 15.5993V16.5694C92.1806 17.0499 91.6789 17.349 91.2739 17.1133L88.4568 15.4452L85.6485 13.7862C85.2435 13.5504 85.2435 12.943 85.6485 12.7073L88.4568 11.0483L91.2739 9.38016C91.6789 9.14445 92.1806 9.44362 92.1806 9.92411V10.4046C92.1806 12.8342 94.7336 14.3573 96.776 13.1425L99.866 11.3203L102.912 9.52522C104.963 8.30133 104.963 5.25521 102.912 4.04039Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M10.7226 11.402C10.1592 13.877 8.09035 15.5813 5.41411 15.5813C2.3241 15.5813 0 13.188 0 10.024C0 6.86 2.35932 4.44849 5.45812 4.44849C8.07274 4.44849 10.1151 6.15286 10.705 8.58251H7.98471C7.50052 7.61246 6.54095 6.96879 5.47573 6.96879C3.92633 6.96879 2.63222 8.28334 2.63222 10.024C2.63222 11.7646 3.92633 13.0792 5.47573 13.0792C6.58496 13.0792 7.54454 12.4355 8.00231 11.402H10.7226Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M11.9462 15.4089V0.2146H14.5784V15.4089H11.9462Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M18.54 10.7401C18.7249 12.3357 19.8341 13.2332 21.2339 13.2332C22.3431 13.2332 23.197 12.6984 23.6988 11.8371H26.3927C25.7676 14.1217 23.778 15.5813 21.1634 15.5813C18.003 15.5813 15.7933 13.2967 15.7933 10.0511C15.7933 6.80557 18.135 4.45752 21.225 4.45752C24.3415 4.45752 26.5951 6.8237 26.5951 10.0511C26.5951 10.2869 26.5775 10.5226 26.5335 10.7401H18.54ZM23.7868 9.0539C23.602 7.65776 22.4927 6.81464 21.1986 6.81464C19.9045 6.81464 18.8393 7.63056 18.5664 9.0539H23.7868Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M35.9972 15.4091V14.0129C35.2225 14.983 34.0781 15.5813 32.696 15.5813C29.8348 15.5813 27.6604 13.2152 27.6604 10.024C27.6604 6.86 29.9141 4.44849 32.7576 4.44849C34.0957 4.44849 35.2225 5.04683 35.9972 5.99875V4.63887H38.5678V15.4H35.9972V15.4091ZM35.9708 10.024C35.9708 8.21987 34.6943 6.94159 33.1273 6.94159C31.5603 6.94159 30.2838 8.22894 30.2838 10.024C30.2838 11.7918 31.5603 13.1064 33.1273 13.1064C34.6943 13.1064 35.9708 11.8371 35.9708 10.024Z",
                            fill: "white"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                fill: "url(#logo-clearpay)",
                width: "100%",
                height: "100%"
            })
        ]
    });
};
/* harmony default export */ var Icons_LogoClearpay = (LogoClearpay);

;// CONCATENATED MODULE: ./components/icons/Icons/Triangle.tsx


const Triangle = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "41",
        height: "47",
        viewBox: "0 0 41 47",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M0.131655 0.537983L40.0226 23.569L0.131656 46.6001L0.131655 0.537983Z",
            fill: "white"
        })
    });
};
/* harmony default export */ var Icons_Triangle = (Triangle);

;// CONCATENATED MODULE: ./components/icons/Icons/Triangle-2.tsx


const Triangle2 = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "134",
        height: "134",
        viewBox: "0 0 134 134",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M109.585 0H24C10.7452 0 0 10.7452 0 24V109.585C0 122.84 10.7452 133.585 24 133.585H109.585C122.84 133.585 133.585 122.84 133.585 109.585V24C133.585 10.7452 122.84 0 109.585 0Z",
                fill: "url(#pattern0_1_66981)",
                fillOpacity: "0.91"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("pattern", {
                        id: "pattern0_1_66981",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            xlinkHref: "#image0_1_66981",
                            transform: "scale(0.00130548)"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("image", {
                        id: "image0_1_66981",
                        width: "766",
                        height: "766",
                        preserveAspectRatio: "none",
                        xlinkHref: "data:image/png;base64,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"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Triangle_2 = (Triangle2);

;// CONCATENATED MODULE: ./components/icons/Icons/Smartphone.tsx


const Smartphone = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "38",
        viewBox: "0 0 24 38",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.1006 34.7261L23.1006 2.89848C23.1006 1.84998 22.2506 1 21.2021 1L2.90278 1C1.85428 1 1.0043 1.84998 1.0043 2.89848L1.0043 34.7261C1.0043 35.7746 1.85428 36.6246 2.90278 36.6246H21.2021C22.2506 36.6246 23.1006 35.7746 23.1006 34.7261Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 5.05859H23.0963",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 34.3699H23.0963",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.019 3.25464H14.0775",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.2529 14.9884L16.2462 13.852L14.2125 12.6841C13.9051 12.5077 13.5568 12.4152 13.2025 12.416C12.8481 12.4168 12.5002 12.5108 12.1936 12.6885C11.8871 12.8662 11.6326 13.1214 11.4559 13.4286C11.2791 13.7357 11.1863 14.0839 11.1866 14.4383V14.6998C11.1865 14.77 11.2047 14.839 11.2395 14.8999C11.2743 14.9608 11.3245 15.0116 11.385 15.047L12.332 15.5882C12.3913 15.6234 12.4588 15.6423 12.5278 15.6428C12.5967 15.6433 12.6646 15.6253 12.7243 15.5909C12.784 15.5564 12.8335 15.5067 12.8676 15.4468C12.9016 15.3868 12.9192 15.3189 12.9183 15.25V14.6141C12.9185 14.544 12.9372 14.4752 12.9723 14.4146C13.0074 14.3539 13.0579 14.3035 13.1185 14.2684C13.1792 14.2333 13.248 14.2147 13.3181 14.2144C13.3882 14.2142 13.4571 14.2322 13.518 14.2669L15.3759 15.3356L17.2293 16.3999C17.2902 16.4345 17.3409 16.4847 17.3762 16.5453C17.4114 16.6059 17.43 16.6747 17.43 16.7448C17.43 16.8149 17.4114 16.8838 17.3762 16.9444C17.3409 17.005 17.2902 17.0552 17.2293 17.0898L15.3759 18.154L13.518 19.2183C13.4576 19.2542 13.3888 19.2734 13.3186 19.2741C13.2483 19.2747 13.1792 19.2566 13.1182 19.2218C13.0572 19.1869 13.0066 19.1365 12.9714 19.0757C12.9363 19.0149 12.918 18.9458 12.9183 18.8755V18.5644C12.9186 18.21 12.8258 17.8618 12.649 17.5547C12.4723 17.2476 12.2178 16.9923 11.9113 16.8146C11.6047 16.6369 11.2568 16.5429 10.9024 16.5422C10.5481 16.5414 10.1998 16.6338 9.89242 16.8102L7.85866 17.9782L5.85196 19.1281C5.54383 19.3057 5.28793 19.5613 5.10999 19.8693C4.93206 20.1772 4.83838 20.5266 4.83838 20.8823C4.83838 21.2379 4.93206 21.5873 5.10999 21.8952C5.28793 22.2032 5.54383 22.4588 5.85196 22.6364L7.85866 23.7728L9.89242 24.9408C10.1998 25.1171 10.5481 25.2096 10.9024 25.2088C11.2568 25.208 11.6047 25.1141 11.9113 24.9364C12.2178 24.7586 12.4723 24.5034 12.649 24.1963C12.8258 23.8891 12.9186 23.5409 12.9183 23.1866V22.925C12.9189 22.8548 12.9009 22.7856 12.866 22.7246C12.8311 22.6636 12.7807 22.6129 12.7198 22.5778L11.7729 22.0367C11.7136 22.0014 11.6461 21.9825 11.5771 21.9821C11.5082 21.9816 11.4403 21.9995 11.3806 22.0339C11.3209 22.0684 11.2714 22.1182 11.2373 22.1781C11.2032 22.238 11.1857 22.3059 11.1866 22.3749V22.9972C11.1863 23.0673 11.1677 23.1361 11.1326 23.1967C11.0974 23.2574 11.047 23.3078 10.9864 23.3429C10.9257 23.378 10.8569 23.3966 10.7868 23.3969C10.7167 23.3972 10.6478 23.3791 10.5869 23.3444L8.72898 22.2757L6.8756 21.2114C6.81466 21.1768 6.76398 21.1266 6.72873 21.066C6.69348 21.0054 6.67491 20.9366 6.67491 20.8665C6.67491 20.7964 6.69348 20.7275 6.72873 20.6669C6.76398 20.6063 6.81466 20.5561 6.8756 20.5215L8.72898 19.4573L10.5869 18.393C10.6472 18.3571 10.7161 18.3379 10.7863 18.3372C10.8565 18.3366 10.9257 18.3547 10.9867 18.3895C11.0477 18.4244 11.0983 18.4748 11.1335 18.5356C11.1686 18.5964 11.1869 18.6655 11.1866 18.7358V19.0469C11.1863 19.4013 11.2791 19.7495 11.4559 20.0566C11.6326 20.3637 11.8871 20.619 12.1936 20.7967C12.5002 20.9744 12.8481 21.0684 13.2025 21.0691C13.5568 21.0699 13.9051 20.9775 14.2125 20.8011L16.2462 19.6331L18.2529 18.4832C18.5579 18.3047 18.8108 18.0495 18.9866 17.743C19.1624 17.4364 19.2549 17.0892 19.2549 16.7358C19.2549 16.3824 19.1624 16.0352 18.9866 15.7287C18.8108 15.4221 18.5579 15.1669 18.2529 14.9884Z",
                fill: "black"
            })
        ]
    });
};
/* harmony default export */ var Icons_Smartphone = (Smartphone);

;// CONCATENATED MODULE: ./components/icons/Icons/Monitor.tsx


const Monitor = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "37",
        height: "26",
        viewBox: "0 0 37 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 24H21",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.76565 1H32.2343C32.7026 1 33.1517 1.1859 33.4829 1.51681C33.814 1.84771 34 2.29652 34 2.76449V23H3V2.76449C3 2.29652 3.18602 1.84771 3.51715 1.51681C3.84827 1.1859 4.29737 1 4.76565 1V1Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.9575 8.61405L22.8696 7.45927L20.7535 6.27241C20.4337 6.09316 20.0713 5.99922 19.7026 6C19.3339 6.00079 18.9719 6.09628 18.653 6.27688C18.334 6.45748 18.0693 6.71685 17.8854 7.02895C17.7015 7.34105 17.6048 7.6949 17.6052 8.05499V8.32078C17.605 8.39208 17.624 8.46219 17.6602 8.5241C17.6964 8.58602 17.7487 8.63757 17.8116 8.67363L18.797 9.22352C18.8586 9.25938 18.9289 9.27853 19.0006 9.27902C19.0724 9.27951 19.1429 9.26131 19.2051 9.22629C19.2672 9.19128 19.3187 9.14072 19.3542 9.07983C19.3896 9.01893 19.4078 8.9499 19.4069 8.87984V8.23371C19.4072 8.16248 19.4266 8.09257 19.4632 8.03094C19.4997 7.96931 19.5522 7.9181 19.6153 7.88241C19.6784 7.84673 19.75 7.8278 19.8229 7.82753C19.8958 7.82726 19.9676 7.84564 20.0309 7.88086L21.964 8.96691L23.8924 10.0484C23.9558 10.0836 24.0086 10.1346 24.0453 10.1961C24.0819 10.2577 24.1013 10.3277 24.1013 10.3989C24.1013 10.4702 24.0819 10.5401 24.0453 10.6017C24.0086 10.6633 23.9558 10.7143 23.8924 10.7495L21.964 11.831L20.0309 12.9124C19.9681 12.9489 19.8965 12.9685 19.8234 12.9691C19.7504 12.9698 19.6784 12.9514 19.615 12.916C19.5515 12.8806 19.4988 12.8294 19.4622 12.7675C19.4257 12.7057 19.4066 12.6355 19.4069 12.5642V12.248C19.4073 11.8879 19.3107 11.534 19.1268 11.2219C18.9429 10.9098 18.6781 10.6505 18.3592 10.4699C18.0402 10.2892 17.6782 10.1938 17.3095 10.193C16.9408 10.1922 16.5784 10.2861 16.2586 10.4654L14.1425 11.6522L12.0546 12.8208C11.734 13.0013 11.4677 13.261 11.2826 13.574C11.0975 13.8869 11 14.2419 11 14.6034C11 14.9648 11.0975 15.3198 11.2826 15.6327C11.4677 15.9457 11.734 16.2055 12.0546 16.3859L14.1425 17.5407L16.2586 18.7276C16.5784 18.9068 16.9408 19.0008 17.3095 19C17.6782 18.9992 18.0402 18.9037 18.3592 18.7231C18.6781 18.5425 18.9429 18.2832 19.1268 17.9711C19.3107 17.659 19.4073 17.3051 19.4069 16.945V16.6792C19.4076 16.6078 19.3888 16.5375 19.3525 16.4755C19.3163 16.4135 19.2638 16.3621 19.2005 16.3264L18.2152 15.7765C18.1535 15.7406 18.0832 15.7215 18.0115 15.721C17.9397 15.7205 17.8692 15.7387 17.807 15.7737C17.7449 15.8087 17.6934 15.8593 17.658 15.9202C17.6225 15.9811 17.6043 16.0501 17.6052 16.1202V16.7525C17.6049 16.8238 17.5855 16.8937 17.549 16.9553C17.5124 17.0169 17.46 17.0682 17.3968 17.1038C17.3337 17.1395 17.2621 17.1584 17.1892 17.1587C17.1163 17.159 17.0446 17.1406 16.9812 17.1054L15.0481 16.0193L13.1197 14.9379C13.0563 14.9027 13.0035 14.8517 12.9669 14.7901C12.9302 14.7285 12.9109 14.6586 12.9109 14.5873C12.9109 14.5161 12.9302 14.4461 12.9669 14.3845C13.0035 14.323 13.0563 14.272 13.1197 14.2368L15.0481 13.1553L16.9812 12.0738C17.044 12.0373 17.1156 12.0178 17.1887 12.0171C17.2618 12.0165 17.3337 12.0348 17.3972 12.0702C17.4606 12.1057 17.5133 12.1569 17.5499 12.2187C17.5864 12.2805 17.6055 12.3507 17.6052 12.4221V12.7383C17.6048 13.0984 17.7015 13.4522 17.8854 13.7643C18.0693 14.0764 18.334 14.3358 18.653 14.5164C18.9719 14.697 19.3339 14.7925 19.7026 14.7933C20.0713 14.7941 20.4337 14.7001 20.7535 14.5209L22.8696 13.334L24.9575 12.1655C25.2748 11.9841 25.538 11.7247 25.7209 11.4132C25.9038 11.1017 26 10.7489 26 10.3898C26 10.0307 25.9038 9.67783 25.7209 9.36632C25.538 9.0548 25.2748 8.79545 24.9575 8.61405Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M35.1139 23H1.88608C1.39671 23 1 23.4477 1 24C1 24.5523 1.39671 25 1.88608 25H35.1139C35.6033 25 36 24.5523 36 24C36 23.4477 35.6033 23 35.1139 23Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_Monitor = (Monitor);

;// CONCATENATED MODULE: ./components/icons/Icons/BookOpen.tsx


const BookOpen = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 3H8C9.06087 3 10.0783 3.42143 10.8284 4.17157C11.5786 4.92172 12 5.93913 12 7V21C12 20.2044 11.6839 19.4413 11.1213 18.8787C10.5587 18.3161 9.79565 18 9 18H2V3Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22 3H16C14.9391 3 13.9217 3.42143 13.1716 4.17157C12.4214 4.92172 12 5.93913 12 7V21C12 20.2044 12.3161 19.4413 12.8787 18.8787C13.4413 18.3161 14.2044 18 15 18H22V3Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_BookOpen = (BookOpen);

;// CONCATENATED MODULE: ./components/icons/Icons/Compass.tsx


const Compass = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.24 7.76001L14.12 14.12L7.76001 16.24L9.88001 9.88001L16.24 7.76001Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_Compass = (Compass);

;// CONCATENATED MODULE: ./components/icons/Icons/PenTool.tsx


const PenTool = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "28",
        height: "29",
        viewBox: "0 0 28 29",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.9728 20.6484L6.2002 22.6667L8.13635 15.613L22.1637 1L27.0002 6.03951L12.9728 20.6484Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.1333 3.6001H1V27.8668H25.2667V15.7334",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_PenTool = (PenTool);

;// CONCATENATED MODULE: ./components/icons/Icons/ThumbsUp.tsx


const ThumbsUp = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7 22H4C3.46957 22 2.96086 21.7893 2.58579 21.4142C2.21071 21.0391 2 20.5304 2 20V13C2 12.4696 2.21071 11.9609 2.58579 11.5858C2.96086 11.2107 3.46957 11 4 11H7M14 9V5C14 4.20435 13.6839 3.44129 13.1213 2.87868C12.5587 2.31607 11.7956 2 11 2L7 11V22H18.28C18.7623 22.0055 19.2304 21.8364 19.5979 21.524C19.9654 21.2116 20.2077 20.7769 20.28 20.3L21.66 11.3C21.7035 11.0134 21.6842 10.7207 21.6033 10.4423C21.5225 10.1638 21.3821 9.90629 21.1919 9.68751C21.0016 9.46873 20.7661 9.29393 20.5016 9.17522C20.2371 9.0565 19.9499 8.99672 19.66 9H14Z",
            stroke: "black",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var Icons_ThumbsUp = (ThumbsUp);

;// CONCATENATED MODULE: ./components/icons/Icons/Users.tsx


const Users = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23 20.9999V18.9999C22.9993 18.1136 22.7044 17.2527 22.1614 16.5522C21.6184 15.8517 20.8581 15.3515 20 15.1299",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 3.12988C16.8604 3.35018 17.623 3.85058 18.1676 4.55219C18.7122 5.2538 19.0078 6.11671 19.0078 7.00488C19.0078 7.89305 18.7122 8.75596 18.1676 9.45757C17.623 10.1592 16.8604 10.6596 16 10.8799",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_Users = (Users);

;// CONCATENATED MODULE: ./components/icons/Icons/Download2.tsx


const Download2 = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "25",
        height: "26",
        viewBox: "0 0 25 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 1L12 20",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19 13L12 20L5 13",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 20V25H24V20",
                stroke: "black"
            })
        ]
    });
};
/* harmony default export */ var Icons_Download2 = (Download2);

;// CONCATENATED MODULE: ./components/icons/Icons/Copy.tsx


const Copy = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7.5 2H2.5V8.5C2.5 8.775 2.275 9 2 9C1.725 9 1.5 8.775 1.5 8.5V2C1.5 1.45 1.95 1 2.5 1H7.5C7.775 1 8 1.225 8 1.5C8 1.775 7.775 2 7.5 2ZM10 4V10C10 10.55 9.55 11 9 11H4.5C3.95 11 3.5 10.55 3.5 10V4C3.5 3.45 3.95 3 4.5 3H9C9.55 3 10 3.45 10 4ZM9 4H4.5V10H9V4Z",
            fill: "black"
        })
    });
};
/* harmony default export */ var Icons_Copy = (Copy);

;// CONCATENATED MODULE: ./components/icons/Icons/AfterpayBadge.tsx


const AfterpayBadge = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "184",
        height: "64",
        viewBox: "0 0 184 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M151.982 64H32.0182C14.3337 64 0 49.6744 0 32C0 14.3256 14.3337 0 32.0182 0H151.982C169.666 0 184 14.3256 184 32C184.012 49.6628 169.666 64 151.982 64Z",
                fill: "#B2FCE4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M156.833 24.3482L148.724 19.7087C146.025 18.1622 142.651 20.1041 142.651 23.2203V23.7436C142.651 24.0343 142.802 24.3017 143.058 24.4413L144.954 25.5227C145.478 25.825 146.129 25.4413 146.129 24.8366V23.5924C146.129 22.9762 146.793 22.5924 147.328 22.8948L151.051 25.0343L154.762 27.1622C155.297 27.4645 155.297 28.2436 154.762 28.5459L151.051 30.6738L147.328 32.8134C146.793 33.1157 146.129 32.732 146.129 32.1157V31.4994C146.129 28.3831 142.755 26.4296 140.056 27.9878L131.947 32.6273C129.236 34.1855 129.236 38.1041 131.947 39.6622L140.056 44.3017C142.755 45.8482 146.129 43.9064 146.129 40.7901V40.2668C146.129 39.9762 145.978 39.7087 145.722 39.5692L143.826 38.4878C143.302 38.1855 142.651 38.5692 142.651 39.1738V40.418C142.651 41.0343 141.988 41.418 141.452 41.1157L137.729 38.9762L134.018 36.8482C133.483 36.5459 133.483 35.7668 134.018 35.4645L137.729 33.3366L141.452 31.1971C141.988 30.8948 142.651 31.2785 142.651 31.8948V32.511C142.651 35.6273 146.025 37.5808 148.724 36.0227L156.833 31.3831C159.544 29.8134 159.544 25.9064 156.833 24.3482Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M130.423 25.1157L120.999 44.5692H117.09L120.615 37.3017L115.065 25.1157H119.079L122.639 33.2785L126.525 25.1157H130.423Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M36.1948 32.0227C36.1948 29.6971 34.5078 28.0692 32.4369 28.0692C30.3659 28.0692 28.6789 29.732 28.6789 32.0227C28.6789 34.2901 30.3659 35.9762 32.4369 35.9762C34.5078 35.9762 36.1948 34.3482 36.1948 32.0227ZM36.2297 38.9296V37.1389C35.2059 38.3831 33.6818 39.1506 31.8668 39.1506C28.0739 39.1506 25.2002 36.1157 25.2002 32.0227C25.2002 27.9645 28.1903 24.8715 31.9482 24.8715C33.7167 24.8715 35.2059 25.6506 36.2297 26.8599V25.1157H39.627V38.9296H36.2297Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M56.148 35.8599C54.9613 35.8599 54.6239 35.418 54.6239 34.2552V28.1273H56.8112V25.1157H54.6239V21.7436H51.1452V25.1157H46.6543V23.7436C46.6543 22.5808 47.0964 22.1389 48.318 22.1389H49.0859V19.4645H47.4105C44.5368 19.4645 43.1755 20.4064 43.1755 23.2785V25.1273H41.2442V28.1273H43.1755V38.9296H46.6543V28.1273H51.1452V34.8948C51.1452 37.7087 52.2272 38.9296 55.0427 38.9296H56.8345V35.8599H56.148Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M68.6435 30.7785C68.3992 28.9878 66.9332 27.9064 65.2113 27.9064C63.501 27.9064 62.0816 28.9529 61.7326 30.7785H68.6435ZM61.6977 32.9296C61.942 34.9762 63.408 36.1389 65.2695 36.1389C66.7354 36.1389 67.864 35.4529 68.5272 34.3482H72.099C71.2729 37.2785 68.6435 39.1506 65.1881 39.1506C61.0113 39.1506 58.0794 36.2203 58.0794 32.0459C58.0794 27.8715 61.1741 24.8599 65.2695 24.8599C69.3881 24.8599 72.3782 27.8948 72.3782 32.0459C72.3782 32.3482 72.3549 32.6506 72.2968 32.9296H61.6977Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M94.5303 32.0227C94.5303 29.7901 92.8433 28.0692 90.7724 28.0692C88.7014 28.0692 87.0144 29.732 87.0144 32.0227C87.0144 34.2901 88.7014 35.9762 90.7724 35.9762C92.8433 35.9762 94.5303 34.2669 94.5303 32.0227ZM83.5822 44.5692V25.1157H86.9795V26.9064C88.0034 25.6389 89.5275 24.8599 91.3425 24.8599C95.0771 24.8599 98.0091 27.9296 98.0091 31.9878C98.0091 36.0459 95.019 39.1389 91.261 39.1389C89.5159 39.1389 88.0848 38.4529 87.0842 37.2901V44.5575H83.5822V44.5692Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M110.26 32.0227C110.26 29.6971 108.573 28.0692 106.502 28.0692C104.431 28.0692 102.744 29.732 102.744 32.0227C102.744 34.2901 104.431 35.9762 106.502 35.9762C108.573 35.9762 110.26 34.3482 110.26 32.0227ZM110.295 38.9296V37.1389C109.271 38.3831 107.747 39.1506 105.932 39.1506C102.139 39.1506 99.2656 36.1157 99.2656 32.0227C99.2656 27.9645 102.256 24.8715 106.014 24.8715C107.782 24.8715 109.271 25.6506 110.295 26.8599V25.1157H113.692V38.9296H110.295Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M77.4508 26.4645C77.4508 26.4645 78.3118 24.8599 80.4409 24.8599C81.3484 24.8599 81.9301 25.1738 81.9301 25.1738V28.6971C81.9301 28.6971 80.6503 27.9064 79.4752 28.0692C78.3002 28.232 77.5555 29.3017 77.5555 30.7436V38.918H74.0419V25.1157H77.4392V26.4645H77.4508Z",
                fill: "black"
            })
        ]
    });
};
/* harmony default export */ var Icons_AfterpayBadge = (AfterpayBadge);

;// CONCATENATED MODULE: ./components/icons/Icons/LogoAfterpayBlack.tsx

const LogoAfterpayBlack = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "29",
        height: "24",
        viewBox: "0 0 29 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M26.9845 4.82595L22.9479 2.69404L18.8568 0.502904C18.2386 0.171994 17.5379 -0.00143998 16.8251 9.00535e-06C16.1123 0.00145799 15.4124 0.177739 14.7957 0.511159C14.179 0.844579 13.6672 1.32341 13.3117 1.89959C12.9561 2.47578 12.7693 3.12904 12.7701 3.79383V4.28451C12.7697 4.41616 12.8064 4.54558 12.8764 4.65988C12.9465 4.77419 13.0474 4.86937 13.1692 4.93593L15.0741 5.95112C15.1933 6.01731 15.3292 6.05268 15.4679 6.05358C15.6066 6.05448 15.743 6.02088 15.8632 5.95624C15.9833 5.8916 16.0828 5.79826 16.1514 5.68583C16.22 5.57341 16.2552 5.44596 16.2534 5.31662V4.12377C16.2539 3.99227 16.2914 3.86321 16.3621 3.74943C16.4328 3.63565 16.5342 3.54111 16.6562 3.47522C16.7782 3.40934 16.9166 3.37441 17.0576 3.3739C17.1986 3.3734 17.3373 3.40734 17.4598 3.47235L21.1971 5.47737L24.9254 7.47392C25.048 7.53892 25.1499 7.63305 25.2208 7.74673C25.2917 7.86041 25.3291 7.98959 25.3291 8.12111C25.3291 8.25262 25.2917 8.3818 25.2208 8.49548C25.1499 8.60916 25.048 8.70329 24.9254 8.76829L21.1971 10.7648L17.4598 12.7614C17.3384 12.8288 17.2 12.8649 17.0587 12.8661C16.9174 12.8672 16.7783 12.8334 16.6556 12.768C16.5329 12.7026 16.431 12.608 16.3603 12.4939C16.2897 12.3798 16.2528 12.2502 16.2534 12.1184V11.5347C16.2541 10.8699 16.0673 10.2166 15.7117 9.64047C15.3562 9.06428 14.8444 8.58545 14.2277 8.25203C13.611 7.91861 12.9112 7.74233 12.1984 7.74088C11.4856 7.73943 10.7849 7.91287 10.1666 8.24378L6.07556 10.4349L2.0389 12.5922C1.41908 12.9254 0.904301 13.405 0.546374 13.9827C0.188448 14.5604 0 15.2159 0 15.8831C0 16.5504 0.188448 17.2058 0.546374 17.7835C0.904301 18.3612 1.41908 18.8408 2.0389 19.1741L6.07556 21.306L10.1666 23.4971C10.7849 23.828 11.4856 24.0014 12.1984 24C12.9112 23.9985 13.611 23.8223 14.2277 23.4888C14.8444 23.1554 15.3562 22.6766 15.7117 22.1004C16.0673 21.5242 16.2541 20.871 16.2534 20.2062V19.7155C16.2546 19.5837 16.2184 19.4539 16.1482 19.3395C16.0781 19.225 15.9766 19.13 15.8542 19.0641L13.9493 18.0489C13.8301 17.9827 13.6942 17.9473 13.5555 17.9464C13.4168 17.9455 13.2804 17.9791 13.1603 18.0438C13.0401 18.1084 12.9406 18.2017 12.8721 18.3142C12.8035 18.4266 12.7683 18.554 12.7701 18.6834V19.8509C12.7695 19.9823 12.732 20.1114 12.6613 20.2252C12.5906 20.339 12.4893 20.4335 12.3672 20.4994C12.2452 20.5653 12.1068 20.6002 11.9658 20.6007C11.8248 20.6012 11.6862 20.5673 11.5636 20.5023L7.82629 18.4973L4.09805 16.5007C3.97546 16.4357 3.87352 16.3416 3.8026 16.2279C3.73169 16.1142 3.69433 15.985 3.69433 15.8535C3.69433 15.722 3.73169 15.5928 3.8026 15.4791C3.87352 15.3655 3.97546 15.2713 4.09805 15.2063L7.82629 13.2098L11.5636 11.2132C11.685 11.1458 11.8235 11.1097 11.9648 11.1085C12.1061 11.1074 12.2452 11.1412 12.3679 11.2066C12.4905 11.272 12.5924 11.3666 12.6631 11.4807C12.7337 11.5948 12.7707 11.7244 12.7701 11.8562V12.4399C12.7693 13.1047 12.9561 13.758 13.3117 14.3342C13.6672 14.9103 14.179 15.3892 14.7957 15.7226C15.4124 16.056 16.1123 16.2323 16.8251 16.2337C17.5379 16.2352 18.2386 16.0618 18.8568 15.7308L22.9479 13.5397L26.9845 11.3824C27.598 11.0475 28.1068 10.5687 28.4604 9.99363C28.814 9.41852 29 8.76713 29 8.10419C29 7.44124 28.814 6.78985 28.4604 6.21474C28.1068 5.63963 27.598 5.16084 26.9845 4.82595Z",
            fill: "black"
        })
    });
};
/* harmony default export */ var Icons_LogoAfterpayBlack = (LogoAfterpayBlack);

;// CONCATENATED MODULE: ./components/icons/Icons/Check.tsx


const Check = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "27",
        height: "18",
        viewBox: "0 0 27 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1 8.70163L9.52579 17L26 1",
            stroke: "black",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var Icons_Check = (Check);

;// CONCATENATED MODULE: ./components/icons/Icons/Email.tsx


const Email = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "28",
        height: "20",
        viewBox: "0 0 28 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 1H27V17.5563C27 17.9392 26.844 18.3064 26.5663 18.5772C26.2885 18.8479 25.9119 19 25.5191 19H2.48087C2.08812 19 1.71145 18.8479 1.43374 18.5772C1.15602 18.3064 1 17.9392 1 17.5563V1Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 1.04899L13.9755 14L27 1",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_Email = (Email);

;// CONCATENATED MODULE: ./components/icons/Icons/Store.tsx


const Store = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "33",
        height: "26",
        viewBox: "0 0 33 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 9H8V25H16V9Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25 9H19V15H25V9Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28 25V1L4 1V25H28Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 25H32",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 5H32",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_Store = (Store);

;// CONCATENATED MODULE: ./components/icons/Icons/Monitor2.tsx


const Monitor2 = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20 3H4C2.89543 3 2 3.89543 2 5V15C2 16.1046 2.89543 17 4 17H20C21.1046 17 22 16.1046 22 15V5C22 3.89543 21.1046 3 20 3Z",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 21H16",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 17V21",
                stroke: "black",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_Monitor2 = (Monitor2);

;// CONCATENATED MODULE: ./components/icons/Icons/BowTie.tsx


const BowTie = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "20",
        viewBox: "0 0 25 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.8313 4.14515C24.4568 2.71901 23.4784 1.47163 22.1465 0.724338C20.1551 -0.393385 17.6498 -0.149386 15.9129 1.33232C15.5996 1.59887 15.2735 1.97574 15.048 2.27047L15.0456 2.26886L14.9634 2.38482C14.9634 2.38482 14.9602 2.38965 14.9586 2.39126L12.4461 5.93447C11.7448 4.89244 10.9202 3.74251 10.0843 2.78504C8.69034 1.08671 7.50659 -0.103486 5.02553 0.0374377C3.56718 0.120381 2.25136 0.760575 1.31966 1.84045C0.357352 2.95737 -0.115345 4.47048 0.0239676 5.99164C0.231729 8.26574 1.85355 10.1912 4.0584 10.7822C4.4554 10.8885 4.95064 10.9441 5.32107 10.9626L5.46924 10.9682C5.46924 10.9682 5.47085 10.9682 5.47246 10.9682L8.80872 11.015C8.80872 11.015 4.72114 16.8194 4.63337 17.2937C4.54559 17.768 5.45233 19.5887 5.45233 19.5887C5.921 20.3835 6.29948 19.7361 6.46698 19.5203L12.2448 11.0625L12.43 11.0649C12.6056 11.0713 12.7964 11.077 12.9986 11.081L13.4721 11.0874C13.6202 11.089 13.7716 11.0898 13.9262 11.0898C13.9874 11.0898 14.0486 11.0898 14.1098 11.0898C15.164 11.0858 17.2085 11.0472 19.0832 10.8297C21.2736 10.6437 22.9244 10.3425 24.2144 8.21984C24.973 6.97166 25.1912 5.52459 24.8297 4.14515H24.8313ZM6.20446 8.15945H6.19157C6.19157 8.15945 6.18674 8.15945 6.18433 8.15945L5.51595 8.14978C5.26551 8.14092 4.94179 8.10066 4.78798 8.05959C3.71777 7.77291 2.93101 6.83799 2.83035 5.73476C2.87062 4.98908 3.07194 4.30942 3.45444 3.68131C3.75723 3.33021 4.3032 2.9018 5.18498 2.85188C6.24794 2.79148 6.65783 3.05158 7.91969 4.59047L7.94868 4.62509C8.88119 5.68967 9.83383 7.08038 10.5803 8.22145L6.20365 8.16025L6.20446 8.15945ZM21.8075 6.75666C21.2543 7.66742 20.8081 7.85666 18.8255 8.02416L18.7804 8.02899C17.3076 8.20132 15.6036 8.26172 14.2548 8.26977L15.9104 5.96668L15.8903 5.95219L16.8574 4.58805L16.9017 4.52604C16.9017 4.52604 16.905 4.52121 16.9066 4.5188L17.2561 4.02597C17.405 3.82465 17.6217 3.58065 17.7424 3.47757C18.5856 2.75846 19.8007 2.64009 20.7671 3.18284C21.4362 3.5581 21.9242 4.17011 22.1054 4.86104C22.223 5.30877 22.2665 6.00211 21.8083 6.75746L21.8075 6.75666Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.2961 12.479H13.8398L18.9775 19.5381C19.1144 19.6975 19.5484 20.3844 19.9938 19.5759C19.9938 19.5759 20.8465 17.7286 20.7443 17.2575C20.642 16.7864 17.2961 12.4798 17.2961 12.4798V12.479Z",
                fill: "black"
            })
        ]
    });
};
/* harmony default export */ var Icons_BowTie = (BowTie);

;// CONCATENATED MODULE: ./components/icons/Icons/AfterpayLogo.tsx


const AfterpayLogo = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "168",
        height: "42",
        viewBox: "0 0 168 42",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.3021 0.00158345C11.1789 0.00158345 9.11571 0.00158348 6.91172 0.687215C4.47989 1.56919 2.56228 3.48833 1.68101 5.92525C0.978516 8.15316 0.978516 10.2148 0.978516 14.3428V26.7982C0.978516 30.9484 0.978516 32.9926 1.6636 35.2158C2.54488 37.6511 4.46249 39.5702 6.89431 40.4522C9.11887 41.1584 11.1789 41.1584 15.3021 41.1584H27.7602C31.8882 41.1584 33.9466 41.1584 36.1664 40.4522C38.5998 39.5702 40.5158 37.6511 41.3971 35.2158C42.0996 32.9879 42.0996 30.9262 42.0996 26.7982V14.3603C42.0996 10.2275 42.0996 8.16582 41.3971 5.94267C40.5158 3.50733 38.5982 1.58819 36.1664 0.706215C33.926 0 31.8882 0 27.7397 0H15.3005C15.3005 0 15.3021 0.00158345 15.3021 0.00158345Z",
                fill: "#00D533"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.2035 18.5803C27.5364 19.5095 29.5171 21.3059 29.5171 24.3413C29.5171 28.1466 26.421 30.9555 21.5878 31.2528L21.1162 33.5036C21.0701 33.7236 20.8762 33.8812 20.6516 33.8812H16.9333C16.6269 33.8812 16.4007 33.5949 16.4715 33.2965L17.0683 30.7794C14.6725 30.0972 12.7447 28.7702 11.6209 27.1322C11.4794 26.9259 11.5263 26.6442 11.7236 26.4906L14.3226 24.4676C14.5367 24.3009 14.8438 24.3497 15.0021 24.5703C16.3793 26.4885 18.492 27.6245 21.0371 27.6245C23.3273 27.6245 25.0604 26.5095 25.0604 24.8989C25.0604 23.6599 24.1939 23.1024 21.2847 22.4829C16.2709 21.4298 14.2902 19.5714 14.2902 16.536C14.2902 13.0142 17.2477 10.3537 21.7089 10.0082L22.1959 7.68346C22.242 7.46346 22.4359 7.30591 22.6605 7.30591H26.3289C26.6315 7.30591 26.8568 7.58553 26.7928 7.88153L26.2289 10.4863C28.1486 11.0776 29.7117 12.1351 30.6847 13.4399C30.8355 13.6421 30.7967 13.9285 30.6017 14.0886L28.2306 16.0344C28.0245 16.2035 27.7237 16.1666 27.5562 15.9592C26.3511 14.4675 24.4539 13.6245 22.3988 13.6245C20.1086 13.6245 18.685 14.6157 18.685 16.0404C18.685 17.2174 19.7991 17.8369 23.2035 18.5803Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M65.8507 10.5397C65.781 10.3547 65.6041 10.2322 65.4065 10.2322H61.547C61.3493 10.2322 61.1723 10.3548 61.1027 10.54L53.6675 30.3276C53.5508 30.6383 53.7802 30.9699 54.1118 30.9699H57.0355C57.2339 30.9699 57.4114 30.8463 57.4805 30.6601L59.0684 26.3776H67.8128L69.4145 30.6613C69.4839 30.8469 69.6611 30.9699 69.8591 30.9699H72.8554C73.1871 30.9699 73.4166 30.638 73.2996 30.3274L65.8507 10.5397ZM60.3382 22.955L63.4117 14.6368L66.5286 22.955H60.3382Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M92.1015 27.8456C91.8336 27.8683 91.5792 27.8797 91.2165 27.8797C90.0044 27.8797 89.254 27.7209 89.254 26.3922V18.9549H91.9106C92.1728 18.9549 92.3853 18.7422 92.3853 18.4799V16.2674C92.3853 16.005 92.1728 15.7924 91.9106 15.7924H89.254V11.8772C89.254 11.6148 89.0415 11.4022 88.7793 11.4022H86.0346C85.7724 11.4022 85.5599 11.6148 85.5599 11.8772V15.7924H79.5719V15.128C79.5719 13.5106 80.2789 13.1208 81.5921 13.1208C81.8156 13.1208 81.9814 13.1208 82.1432 13.1247C82.4104 13.1313 82.631 12.9175 82.631 12.6499V10.4207C82.631 10.1672 82.4317 9.95781 82.1787 9.94609C81.814 9.9292 81.5416 9.9292 81.1303 9.9292C77.5661 9.9292 75.82 11.7055 75.82 14.8825V15.7924H74.2168C73.9547 15.7924 73.7422 16.005 73.7422 16.2674V18.4799C73.7422 18.7422 73.9547 18.9549 74.2168 18.9549H75.82V30.4951C75.82 30.7575 76.0326 30.9701 76.2947 30.9701H79.0972C79.3594 30.9701 79.5719 30.7575 79.5719 30.4951V18.9549H85.5599V27.0855C85.5599 30.1904 87.1472 31.1434 90.1199 31.1434C90.894 31.1434 91.6109 31.0862 92.2164 30.9949C92.4473 30.9601 92.6163 30.7593 92.6163 30.5256V28.3187C92.6163 28.0406 92.3784 27.822 92.1015 27.8456Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M101.522 15.5034C97.2654 15.5034 94.2207 18.9261 94.2207 23.3883C94.2207 28.0818 97.2655 31.2878 101.666 31.2878C104.516 31.2878 106.881 29.8953 108.053 27.4711C108.174 27.2208 108.047 26.9202 107.786 26.8244L105.513 25.9908C105.281 25.9056 105.02 26.0124 104.92 26.2385C104.363 27.4904 103.158 28.154 101.681 28.154C99.5743 28.154 98.088 26.6665 97.8138 24.2115H107.873C108.135 24.2115 108.348 23.9988 108.348 23.7365V23.0418C108.348 18.8394 105.967 15.5034 101.522 15.5034ZM97.9725 21.5398C98.4775 19.5903 99.7907 18.5795 101.493 18.5795C103.571 18.5795 104.567 19.9514 104.596 21.5398H97.9725Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M119.378 15.7239C119.217 15.7129 119.039 15.7056 118.836 15.7056C116.931 15.7056 115.402 16.6155 114.738 17.9874V16.2673C114.738 16.005 114.526 15.7923 114.263 15.7923H111.461C111.199 15.7923 110.986 16.005 110.986 16.2673V30.4951C110.986 30.7574 111.199 30.9701 111.461 30.9701H114.263C114.526 30.9701 114.738 30.7574 114.738 30.4951V23.1286C114.738 20.7457 116.383 19.3882 118.533 19.3882C118.823 19.3882 119.062 19.3983 119.302 19.4184C119.579 19.4417 119.817 19.224 119.817 18.9454V16.1976C119.817 15.9489 119.626 15.7407 119.378 15.7239Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M130.323 15.5034C128.39 15.5034 126.947 16.2689 126.023 17.3807V16.2673C126.023 16.005 125.811 15.7923 125.549 15.7923H122.746C122.484 15.7923 122.271 16.005 122.271 16.2673V35.665C122.271 35.9274 122.484 36.1401 122.746 36.1401H125.549C125.811 36.1401 126.023 35.9274 126.023 35.665V29.396C126.947 30.5223 128.39 31.2878 130.323 31.2878C134.537 31.2878 136.961 27.7063 136.961 23.3883C136.961 19.0849 134.537 15.5034 130.323 15.5034ZM129.501 28.0385C127.466 28.0385 125.937 26.5221 125.937 23.8361V22.9696C125.937 20.2402 127.466 18.7527 129.501 18.7527C131.896 18.7527 133.181 20.6445 133.181 23.3883C133.181 26.1467 131.896 28.0385 129.501 28.0385Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M152.34 28.1348C151.755 28.1086 151.517 27.8094 151.517 27.1287V20.76C151.517 17.2509 149.266 15.5034 145.529 15.5034C142.297 15.5034 140.112 17.2496 139.24 19.5363C139.135 19.8113 139.298 20.1155 139.586 20.1753L142.194 20.7161C142.423 20.7638 142.654 20.6365 142.734 20.416C143.153 19.259 143.962 18.6805 145.384 18.6805C147.145 18.6805 147.852 19.5325 147.852 20.9045V21.1499L143.869 21.9442C140.882 22.5219 138.588 23.7928 138.588 26.7532C138.588 29.4537 140.796 31.23 143.725 31.23C145.702 31.23 147.26 30.609 148.227 29.5404C148.785 30.7244 150.098 31.2415 152.373 31.0192C152.616 30.9955 152.801 30.7898 152.801 30.5458V28.609C152.801 28.3522 152.597 28.1462 152.34 28.1348ZM147.852 25.5979C147.852 27.3741 146.164 28.3129 144.389 28.3129C143.119 28.3129 142.296 27.6775 142.296 26.5655C142.296 25.2802 143.335 24.8325 144.735 24.5437L147.852 23.8938V25.5979Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M167.369 15.7925H164.57C164.367 15.7925 164.186 15.9222 164.12 16.115L160.738 26.1036L157.27 16.1117C157.204 15.9206 157.024 15.7925 156.821 15.7925H153.934C153.603 15.7925 153.373 16.124 153.49 16.4346L158.732 30.3926L158.198 31.7067C157.736 32.8621 157.173 33.1654 156.062 33.1654C155.811 33.1654 155.619 33.1562 155.419 33.1406C155.144 33.1189 154.908 33.3373 154.908 33.614V35.7571C154.908 36.0016 155.093 36.207 155.337 36.23C155.621 36.2568 155.898 36.2703 156.409 36.2703C159.655 36.2703 161.012 34.6095 161.935 32.1112L167.813 16.4344C167.929 16.1238 167.7 15.7925 167.369 15.7925Z",
                fill: "black"
            })
        ]
    });
};
/* harmony default export */ var Icons_AfterpayLogo = (AfterpayLogo);

;// CONCATENATED MODULE: ./components/icons/Icons/DownloadMedium.tsx


const DownloadMedium = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "17",
        height: "18",
        viewBox: "0 0 17 18",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.5 13.0428V1.70947",
                stroke: "white",
                strokeWidth: "1.41667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.1659 14.4595H2.83252",
                stroke: "white",
                strokeWidth: "1.41667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.1659 7.37549L8.49919 13.0422L2.83252 7.37549",
                stroke: "white",
                strokeWidth: "1.41667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_DownloadMedium = (DownloadMedium);

;// CONCATENATED MODULE: ./components/icons/Icons/ArrowRightMedium2.tsx


const ArrowRightMedium2 = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "13",
        viewBox: "0 0 15 13",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M13.7686 5.26825C14.1684 5.69133 14.3735 6.25542 14.3735 6.80867C14.3735 7.36193 14.1684 7.92601 13.7686 8.34909L9.36975 13.0029L7.92397 11.4734L11.3077 7.89349L0.0288087 7.89349L0.0288087 5.72386L11.2974 5.72386L7.92397 2.14398L9.36975 0.614348L13.7686 5.26825Z",
            fill: "white"
        })
    });
};
/* harmony default export */ var Icons_ArrowRightMedium2 = (ArrowRightMedium2);

;// CONCATENATED MODULE: ./components/icons/Icons/ArrowRightMedium3.tsx


const ArrowRightMedium3 = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "14",
        viewBox: "0 0 15 14",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M13.7686 5.6037C14.1684 6.02678 14.3735 6.59087 14.3735 7.14412C14.3735 7.69738 14.1684 8.26146 13.7686 8.68454L9.36975 13.3384L7.92397 11.8088L11.3077 8.22894L0.0288087 8.22894L0.0288087 6.0593L11.2974 6.0593L7.92397 2.47943L9.36975 0.949797L13.7686 5.6037Z",
            fill: "black"
        })
    });
};
/* harmony default export */ var Icons_ArrowRightMedium3 = (ArrowRightMedium3);

;// CONCATENATED MODULE: ./components/icons/Icons/ArrowRightMedium4.tsx


const ArrowRightMedium4 = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "14",
        viewBox: "0 0 15 14",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M13.7686 5.6037C14.1684 6.02678 14.3735 6.59087 14.3735 7.14412C14.3735 7.69738 14.1684 8.26146 13.7686 8.68454L9.36975 13.3384L7.92397 11.8088L11.3077 8.22894L0.0288087 8.22894L0.0288087 6.0593L11.2974 6.0593L7.92397 2.47943L9.36975 0.949797L13.7686 5.6037Z",
            fill: "white"
        })
    });
};
/* harmony default export */ var Icons_ArrowRightMedium4 = (ArrowRightMedium4);

;// CONCATENATED MODULE: ./components/icons/Icons/ArrowRightMedium5.tsx


const ArrowRightMedium5 = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "31",
        height: "26",
        viewBox: "0 0 31 26",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M21.769 11.6037C22.1689 12.0268 22.374 12.5909 22.374 13.1441C22.374 13.6974 22.1689 14.2615 21.769 14.6845L17.3702 19.3384L15.9245 17.8088L19.3082 14.2289L8.0293 14.2289L8.0293 12.0593L19.2979 12.0593L15.9245 8.47943L17.3702 6.9498L21.769 11.6037Z",
            fill: "white"
        })
    });
};
/* harmony default export */ var Icons_ArrowRightMedium5 = (ArrowRightMedium5);

;// CONCATENATED MODULE: ./components/icons/index.tsx































































































var IconType;
(function(IconType) {
    IconType["ArrowBack"] = "Arrow-Back";
    IconType["ArrowDown"] = "Arrow-Down";
    IconType["ArrowRightBig"] = "Arrow-Right-Big";
    IconType["ArrowRightBig2"] = "Arrow-Right-Big2";
    IconType["ArrowRightMedium"] = "Arrow-Right-Medium";
    IconType["ArrowRightMedium2"] = "Arrow-Right-Medium-2";
    IconType["ArrowRightMedium3"] = "Arrow-Right-Medium-3";
    IconType["ArrowRightMedium4"] = "Arrow-Right-Medium-4";
    IconType["ArrowRightMedium5"] = "Arrow-Right-Medium-5";
    IconType["ArrowRightOutLine"] = "Arrow-Right-Outline";
    IconType["ArrowRightSmall"] = "Arrow-Right-Small";
    IconType["ArrowUpBig"] = "Arrow-Up-Big";
    IconType["Barcode"] = "Barcode";
    IconType["Chat"] = "Chat";
    IconType["CheckIn"] = "Check-In";
    IconType["CheckOut"] = "Check-Out";
    IconType["Close"] = "Close";
    IconType["CreditCard"] = "Credit-Card";
    IconType["CreditCardBig"] = "Credit-Card-Big";
    IconType["CreditCardFilled"] = "Credit-Card-Filled";
    IconType["Dollar"] = "Dollar";
    IconType["Dot"] = "Dot";
    IconType["Down"] = "Down";
    IconType["Download"] = "Download";
    IconType["External"] = "External";
    IconType["FacebookFilled"] = "Facebook-Filled";
    IconType["FChat"] = "F-Chat";
    IconType["FlashFilled"] = "Flash-Filled";
    IconType["HomeFilled"] = "Home-Filled";
    IconType["Info"] = "Info";
    IconType["InfoBig"] = "Info-Big";
    IconType["Instagram"] = "Instagram";
    IconType["Left"] = "Left";
    IconType["Like"] = "Like";
    IconType["LinkedInFilled"] = "LinkedIn-Filled";
    IconType["Menu"] = "Menu";
    IconType["OpeningTime"] = "Opening-Time";
    IconType["PasswordHide"] = "Password-Hide";
    IconType["PasswordShow"] = "Password-Show";
    IconType["PeopleCircle"] = "People-Circle";
    IconType["PeopleCircleFilled"] = "People-Circle-Filled";
    IconType["PeopleCircleOutline"] = "People-Circle-Outline";
    IconType["PieChart"] = "Pie-Chart";
    IconType["ReceiptList"] = "Receipt-List";
    IconType["ReceiptListFilled"] = "Receipt-List-Filled";
    IconType["Remove"] = "Remove";
    IconType["Right"] = "Right";
    IconType["Schedule"] = "Schedule";
    IconType["Search"] = "Search";
    IconType["SearchBig"] = "Search-Big";
    IconType["SettingFilled"] = "Setting-Filled";
    IconType["SettingOutline"] = "Setting-Outline";
    IconType["Shop"] = "Shop";
    IconType["ShoppingBag"] = "Shopping-Bag";
    IconType["Support"] = "Support";
    IconType["Telegram"] = "Telegram";
    IconType["Trash"] = "Trash";
    IconType["TwitterFilled"] = "Twitter-Filled";
    IconType["Up"] = "Up";
    IconType["WorldFilled"] = "World-Filled";
    IconType["Subscribed"] = "Subscribed";
    IconType["Filter"] = "Filter";
    IconType["LogoAfterPay"] = "Logo-AfterPay";
    IconType["LogoAfterPayBusiness"] = "Logo-AfterPay-Business";
    IconType["MenuHeader"] = "Menu-Header";
    IconType["ReadBook"] = "Read-book";
    IconType["Resource"] = "Resource";
    IconType["RemoveCircle"] = "Remove-Circle";
    IconType["Business"] = "Business";
    IconType["AfterPay"] = "AfterPay";
    IconType["BusinessSmall"] = "Business-Small";
    IconType["RemoveBold"] = "Remove-Bold";
    IconType["LogoClearpay"] = "LogoClearpay";
    IconType["Triangle"] = "Triangle";
    IconType["Triangle2"] = "Triangle2";
    IconType["Smartphone"] = "Smartphone";
    IconType["Monitor"] = "Monitor";
    IconType["Monitor2"] = "Monitor2";
    IconType["BookOpen"] = "BookOpen";
    IconType["Compass"] = "Compass";
    IconType["PenTool"] = "PenTool";
    IconType["ThumbsUp"] = "ThumbsUp";
    IconType["Users"] = "Users";
    IconType["Download2"] = "Download2";
    IconType["Copy"] = "Copy";
    IconType["AfterpayBadge"] = "AfterpayBadge";
    IconType["LogoAfterpayBlack"] = "LogoAfterpayBlack";
    IconType["Check"] = "Check";
    IconType["Email"] = "Email";
    IconType["Store"] = "Store";
    IconType["BowTie"] = "BowTie";
    IconType["None"] = "None";
    IconType["AfterpayLogo"] = "AfterpayLogo";
    IconType["DownloadMedium"] = "DownloadMedium";
})(IconType || (IconType = {}));
const Icon = (param)=>{
    let { type  } = param;
    switch(type){
        case IconType.ArrowBack:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ArrowBack, {});
        case IconType.ArrowDown:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ArrowDown, {});
        case IconType.ArrowRightBig:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ArrowRightBig, {});
        case IconType.ArrowRightBig2:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightBig2, {});
        case IconType.ArrowRightMedium:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightMedium/* default */.Z, {});
        case IconType.ArrowRightOutLine:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ArrowRightOutline, {});
        case IconType.ArrowRightMedium4:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ArrowRightMedium4, {});
        case IconType.ArrowRightSmall:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ArrowRightSmall, {});
        case IconType.ArrowUpBig:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ArrowUpBig, {});
        case IconType.Barcode:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Barcode, {});
        case IconType.Chat:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Chat, {});
        case IconType.CheckIn:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_CheckIn, {});
        case IconType.CheckOut:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_CheckOut, {});
        case IconType.Close:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Close, {});
        case IconType.CreditCard:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_CreditCard, {});
        case IconType.CreditCardBig:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_CreditCardBig, {});
        case IconType.CreditCardFilled:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_CreditCardFilled, {});
        case IconType.Dollar:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Dollar, {});
        case IconType.Dot:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Dot, {});
        case IconType.Down:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Down, {});
        case IconType.Download:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Download/* default */.Z, {});
        case IconType.External:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_External, {});
        case IconType.FacebookFilled:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_FacebookFilled, {});
        case IconType.FChat:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_FChat, {});
        case IconType.FlashFilled:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_FlashFilled, {});
        case IconType.HomeFilled:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_HomeFilled, {});
        case IconType.Info:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Info, {});
        case IconType.InfoBig:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_InfoBig, {});
        case IconType.Instagram:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Instagram, {});
        case IconType.Left:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Left, {});
        case IconType.Like:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Like, {});
        case IconType.LinkedInFilled:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_LinkedInFilled, {});
        case IconType.Menu:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Menu, {});
        case IconType.OpeningTime:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_OpeningTime, {});
        case IconType.PasswordHide:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_PasswordHide, {});
        case IconType.PasswordShow:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_PasswordShow, {});
        case IconType.PeopleCircle:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_PeopleCircle, {});
        case IconType.PeopleCircleFilled:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_PeopleCircleFilled, {});
        case IconType.PeopleCircleOutline:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_PeopleCircleOutline, {});
        case IconType.PieChart:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_PieChart, {});
        case IconType.ReceiptList:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ReceiptList, {});
        case IconType.ReceiptListFilled:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ReceiptListFilled, {});
        case IconType.Remove:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Remove, {});
        case IconType.Right:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Right, {});
        case IconType.Schedule:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Schedule, {});
        case IconType.Search:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Search, {});
        case IconType.SearchBig:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_SearchBig, {});
        case IconType.SettingFilled:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_SettingFilled, {});
        case IconType.SettingOutline:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_SettingOutline, {});
        case IconType.Shop:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Shop, {});
        case IconType.ShoppingBag:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ShoppingBag, {});
        case IconType.Support:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Support, {});
        case IconType.Telegram:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Telegram, {});
        case IconType.Trash:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Trash, {});
        case IconType.TwitterFilled:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TwitterFilled, {});
        case IconType.Up:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Up, {});
        case IconType.WorldFilled:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_WorldFilled, {});
        case IconType.Subscribed:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Subscribed, {});
        case IconType.Filter:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Filter, {});
        case IconType.LogoAfterPay:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_LogoAfterPay, {});
        case IconType.LogoAfterPayBusiness:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_LogoAfterPayBusiness, {});
        case IconType.MenuHeader:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_MenuHeader, {});
        case IconType.ReadBook:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ReadBook, {});
        case IconType.Resource:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Resource, {});
        case IconType.RemoveCircle:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_RemoveCircle, {});
        case IconType.Business:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Business, {});
        case IconType.AfterPay:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_AfterPay, {});
        case IconType.BusinessSmall:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_BusinessSmall, {});
        case IconType.RemoveBold:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_RemoveBold, {});
        case IconType.LogoClearpay:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_LogoClearpay, {});
        case IconType.Triangle:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Triangle, {});
        case IconType.Triangle2:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Triangle_2, {});
        case IconType.Smartphone:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Smartphone, {});
        case IconType.Monitor:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Monitor, {});
        case IconType.Monitor2:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Monitor2, {});
        case IconType.BookOpen:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_BookOpen, {});
        case IconType.Compass:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Compass, {});
        case IconType.PenTool:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_PenTool, {});
        case IconType.ThumbsUp:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ThumbsUp, {});
        case IconType.Users:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Users, {});
        case IconType.Download2:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Download2, {});
        case IconType.Copy:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Copy, {});
        case IconType.AfterpayBadge:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_AfterpayBadge, {});
        case IconType.LogoAfterpayBlack:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_LogoAfterpayBlack, {});
        case IconType.Check:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Check, {});
        case IconType.Email:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Email, {});
        case IconType.Store:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Store, {});
        case IconType.BowTie:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_BowTie, {});
        case IconType.AfterpayLogo:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_AfterpayLogo, {});
        case IconType.DownloadMedium:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_DownloadMedium, {});
        case IconType.ArrowRightMedium2:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ArrowRightMedium2, {});
        case IconType.ArrowRightMedium3:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ArrowRightMedium3, {});
        case IconType.ArrowRightMedium4:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ArrowRightMedium4, {});
        case IconType.ArrowRightMedium5:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ArrowRightMedium5, {});
        default:
            return null;
    }
};
/* harmony default export */ var icons = (Icon);


/***/ }),

/***/ 40204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ LazyBackgroundImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62991);
/* harmony import */ var _helpers_BuilderHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31198);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97650);




const LazyBackgroundImage = (props)=>{
    const { className ="" , imageUrl , imageWidth , ...rest } = props;
    const { ref , inView  } = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_3__/* .useInView */ .YD)();
    const [wasSeen, setWasSeen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [currentImage, setCurrentImage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((0,_helpers_BuilderHelper__WEBPACK_IMPORTED_MODULE_2__/* .getPlaceholderBuilderImage */ .W)(imageUrl));
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (inView && !wasSeen) {
            setWasSeen(true);
        }
    }, [
        inView
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let cancelled = false;
        const resizeParams = {};
        if (imageWidth && imageWidth > 1) {
            resizeParams.width = imageWidth;
        }
        if (wasSeen) {
            const resizedImage = (0,_helpers_BuilderHelper__WEBPACK_IMPORTED_MODULE_2__/* .getResizedBuilderImage */ .bs)(imageUrl, resizeParams);
            const loadingImage = new Image();
            loadingImage.onload = ()=>{
                if (!cancelled) {
                    setCurrentImage(resizedImage);
                }
            };
            loadingImage.src = resizedImage !== null && resizedImage !== void 0 ? resizedImage : "";
        }
        return ()=>{
            cancelled = true;
        };
    }, [
        wasSeen,
        imageUrl,
        imageWidth
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: ref,
        className: className,
        ...rest,
        style: {
            ...rest === null || rest === void 0 ? void 0 : rest.style,
            backgroundImage: "url('".concat(currentImage, "')")
        }
    });
};


/***/ }),

/***/ 78845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77868);
/* harmony import */ var _sign_up_card_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71170);
/* harmony import */ var _sign_up_card_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_sign_up_card_module_scss__WEBPACK_IMPORTED_MODULE_2__);



const SignUpCard = (props)=>{
    const { locale  } = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_1__/* .useLocale */ .bU)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: (_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_1__/* .LOCALE_LINKS */ .kV[locale] || _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_1__/* .LOCALE_LINKS */ .kV[_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_1__/* .Locale.USA */ .go.USA]).signup,
        rel: "noreferrer",
        target: "_blank",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_sign_up_card_module_scss__WEBPACK_IMPORTED_MODULE_2___default().signUpCard),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_sign_up_card_module_scss__WEBPACK_IMPORTED_MODULE_2___default().backgroundImagePNG),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "https://cdn.builder.io/api/v1/image/assets%2F035a3d41874344d79b6c7499e2e7a5bc%2Fae580468d8b54acfa8730259d44f334a",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_sign_up_card_module_scss__WEBPACK_IMPORTED_MODULE_2___default().infoDetail),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: (_sign_up_card_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
                            children: [
                                "Sign up to ",
                                (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_1__/* .getCompanyName */ .Yd)(locale),
                                " Now!"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: (_sign_up_card_module_scss__WEBPACK_IMPORTED_MODULE_2___default().description),
                            children: [
                                "Get ",
                                (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_1__/* .getCompanyName */ .Yd)(locale),
                                " for your business."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_sign_up_card_module_scss__WEBPACK_IMPORTED_MODULE_2___default().buttonSubscribe),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: "Sign up"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SignUpCard);


/***/ }),

/***/ 78533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ article_card_skeleton; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(62991);
// EXTERNAL MODULE: ./hook/useWindowSize.ts
var useWindowSize = __webpack_require__(77442);
// EXTERNAL MODULE: ./components/article-card/article-card.tsx
var article_card = __webpack_require__(12790);
// EXTERNAL MODULE: ./components/skeleton-load/image-skeleton/image-skeleton.module.scss
var image_skeleton_module = __webpack_require__(87);
var image_skeleton_module_default = /*#__PURE__*/__webpack_require__.n(image_skeleton_module);
;// CONCATENATED MODULE: ./components/skeleton-load/image-skeleton/image-skeleton.tsx



const ImageSkeleton = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (image_skeleton_module_default()).imageSkeleton
    });
};
/* harmony default export */ var image_skeleton = (ImageSkeleton);

// EXTERNAL MODULE: ./components/skeleton-load/text-skeleton/text-skeleton.module.scss
var text_skeleton_module = __webpack_require__(37751);
var text_skeleton_module_default = /*#__PURE__*/__webpack_require__.n(text_skeleton_module);
;// CONCATENATED MODULE: ./components/skeleton-load/text-skeleton/text-skeleton.tsx



const TextSkeleton = (props)=>{
    const [widthText, heightText] = props.size;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (text_skeleton_module_default()).textSkeleton,
        style: {
            height: heightText,
            width: widthText
        }
    });
};
/* harmony default export */ var text_skeleton = (TextSkeleton);

// EXTERNAL MODULE: ./components/skeleton-load/article-card-skeleton/article-card-skeleton.module.scss
var article_card_skeleton_module = __webpack_require__(34494);
var article_card_skeleton_module_default = /*#__PURE__*/__webpack_require__.n(article_card_skeleton_module);
;// CONCATENATED MODULE: ./components/skeleton-load/article-card-skeleton/article-card-skeleton.tsx







const ArticleCardSkeleton = (props)=>{
    const { type  } = props;
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const isMobile = ()=>{
        const windowWidth = windowSize.width || 0;
        if (windowWidth < 768) {
            return true;
        } else {
            return false;
        }
    };
    const renderSmallContent = ()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (article_card_skeleton_module_default()).articleCardSkeletonLeftContent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                    size: [
                        80,
                        24
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (article_card_skeleton_module_default()).articleCardSkeletonLeftContentTitle,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                            size: [
                                "100%",
                                isMobile() ? 24 : 32
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                            size: [
                                "100%",
                                isMobile() ? 24 : 32
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                            size: [
                                180,
                                isMobile() ? 24 : 32
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (article_card_skeleton_module_default()).articleCardSkeletonLeftContentDescription,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                            size: [
                                "100%",
                                16
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                            size: [
                                isMobile() ? 67 : 90,
                                16
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const renderLargeContent = ()=>{
        if (isMobile()) {
            return renderSmallContent();
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (article_card_skeleton_module_default()).articleCardSkeletonLeftContent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                    size: [
                        80,
                        24
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (article_card_skeleton_module_default()).articleCardSkeletonLeftContentTitle,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                            size: [
                                "100%",
                                40
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                            size: [
                                "100%",
                                40
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                            size: [
                                "100%",
                                40
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                            size: [
                                180,
                                40
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (article_card_skeleton_module_default()).articleCardSkeletonLeftContentDescription,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                            size: [
                                "100%",
                                24
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                            size: [
                                "100%",
                                24
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                            size: [
                                90,
                                24
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (article_card_skeleton_module_default()).articleCardSkeletonLeftContentButton,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton, {
                        size: [
                            154,
                            48
                        ]
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (article_card_skeleton_module_default()).articleCardSkeleton + " " + (article_card_skeleton_module_default())[isMobile() ? "small" : type],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (article_card_skeleton_module_default()).articleCardSkeletonImage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_skeleton, {})
            }),
            type === article_card/* ArticleCardType.Large */._.Large ? renderLargeContent() : renderSmallContent()
        ]
    });
};
/* harmony default export */ var article_card_skeleton = (ArticleCardSkeleton);


/***/ }),

/***/ 77408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62991);
/* harmony import */ var _article_card_article_card__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12790);
/* harmony import */ var _article_card_skeleton_article_card_skeleton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78533);
/* harmony import */ var _article_grid_skeleton_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43551);
/* harmony import */ var _article_grid_skeleton_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_article_grid_skeleton_module_scss__WEBPACK_IMPORTED_MODULE_4__);





const dummyArticleGridSkeleton = [
    {
        type: _article_card_article_card__WEBPACK_IMPORTED_MODULE_2__/* .ArticleCardType.Small */ ._.Small
    },
    {
        type: _article_card_article_card__WEBPACK_IMPORTED_MODULE_2__/* .ArticleCardType.Large */ ._.Large
    },
    {
        type: _article_card_article_card__WEBPACK_IMPORTED_MODULE_2__/* .ArticleCardType.Small */ ._.Small
    },
    {
        type: _article_card_article_card__WEBPACK_IMPORTED_MODULE_2__/* .ArticleCardType.Small */ ._.Small
    },
    {
        type: _article_card_article_card__WEBPACK_IMPORTED_MODULE_2__/* .ArticleCardType.Small */ ._.Small
    },
    {
        type: _article_card_article_card__WEBPACK_IMPORTED_MODULE_2__/* .ArticleCardType.Large */ ._.Large
    },
    {
        type: _article_card_article_card__WEBPACK_IMPORTED_MODULE_2__/* .ArticleCardType.Small */ ._.Small
    },
    {
        type: _article_card_article_card__WEBPACK_IMPORTED_MODULE_2__/* .ArticleCardType.Small */ ._.Small
    },
    {
        type: _article_card_article_card__WEBPACK_IMPORTED_MODULE_2__/* .ArticleCardType.Small */ ._.Small
    },
    {
        type: _article_card_article_card__WEBPACK_IMPORTED_MODULE_2__/* .ArticleCardType.Small */ ._.Small
    }
];
const ArticleGridSkeleton = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_article_grid_skeleton_module_scss__WEBPACK_IMPORTED_MODULE_4___default().articleGridSkeleton),
        children: dummyArticleGridSkeleton.map((articleSkeleton, index)=>{
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_article_card_skeleton_article_card_skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                type: articleSkeleton.type
            }, "article_skeleton_".concat(index));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticleGridSkeleton);


/***/ }),

/***/ 3128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ SplitChar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);

const SplitChar = (props)=>{
    const { text , className  } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        children: text.split("").map((char, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: char
            }, "".concat(char, "-").concat(i)))
    });
};


/***/ }),

/***/ 21513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AX": function() { return /* binding */ BusinessLayoutContextWrapper; },
/* harmony export */   "E2": function() { return /* binding */ BusinessTheme; },
/* harmony export */   "Vp": function() { return /* binding */ useBusinessLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62991);
/* harmony import */ var _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77868);
/* harmony import */ var _shared_commonPageDetails__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99829);
/* harmony import */ var _NotificationContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74121);





var BusinessTheme;
(function(BusinessTheme) {
    BusinessTheme["DEFAULT"] = "default";
    BusinessTheme["MARKETING_RESOURCE"] = "marketing resource";
    BusinessTheme["BUSINESS_HUB"] = "business hub";
})(BusinessTheme || (BusinessTheme = {}));
const defaultBreadcrumbs = [
    {
        name: "Business",
        link: "/business"
    }
];
const BusinessLayoutContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    breadcrumbs: defaultBreadcrumbs,
    breadcrumbType: "dark",
    footerItems: {
        global: [],
        regional: []
    },
    categories: [],
    businessHubMenuData: []
});
const BusinessLayoutContextWrapper = (props)=>{
    const { theme: themeProps , footerItems , categories , businessHubMenuData , children  } = props;
    const { locale  } = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_2__/* .useLocale */ .bU)();
    const [theme, setTheme] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const [breadcrumbs, setBreadcrumbs] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [breadcrumbType, setBreadcrumbType] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("dark");
    const [hideBreadcrumbs, setHideBreadcrumbs] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [menuData, setMenuData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(businessHubMenuData);
    const notification = (0,_NotificationContext__WEBPACK_IMPORTED_MODULE_4__/* .useNotification */ .lm)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setTheme(themeProps);
        notification.setTheme(themeProps);
    }, [
        themeProps
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!businessHubMenuData) {
            (0,_shared_commonPageDetails__WEBPACK_IMPORTED_MODULE_3__/* .getBusinessHubMenu */ .i)(locale).then((param)=>{
                let { menuData  } = param;
                setMenuData(menuData);
            });
        }
    }, [
        businessHubMenuData,
        locale
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BusinessLayoutContext.Provider, {
        value: {
            theme,
            breadcrumbs,
            breadcrumbType,
            hideBreadcrumbs,
            footerItems,
            categories,
            businessHubMenuData: menuData,
            setBreadcrumbs,
            setBreadcrumbType,
            setHideBreadcrumbs,
            changeTheme: setTheme
        },
        children: children
    });
};
const useBusinessLayout = ()=>(0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(BusinessLayoutContext);


/***/ }),

/***/ 74121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* binding */ NotificationCtx; },
  "NK": function() { return /* binding */ NotificationCtxWrapper; },
  "lm": function() { return /* binding */ useNotification; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/@builder.io/react/dist/builder-react.es5.js
var builder_react_es5 = __webpack_require__(75102);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(75407);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(62991);
// EXTERNAL MODULE: ./models/BaseModel.ts
var BaseModel = __webpack_require__(23385);
;// CONCATENATED MODULE: ./models/Message.ts

class MessageModel extends BaseModel/* default */.Z {
    constructor(){
        var _this;
        super({
            modelName: "message"
        }), _this = this;
        this.getAllMessages = async function(locale) {
            let includeUnpublished = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, includeDraft = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            const draft = includeDraft !== null && includeDraft !== void 0 ? includeDraft : "draft";
            const config = {
                options: {
                    includeUnpublished,
                    noTargeting: true
                },
                query: {
                    published: {
                        $ni: [
                            "archived",
                            draft
                        ]
                    }
                }
            };
            if (locale) {
                config.query.query = {
                    $elemMatch: {
                        property: {
                            $eq: "locale"
                        },
                        value: locale
                    }
                };
            }
            const messages = await _this.builder.getAll(_this.modelName, config);
            return messages;
        };
        this.getMessage = async function(id) {
            let includeUnpublished = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            return _this.find({
                params: {
                    modelId: id
                },
                includeUnpublished
            });
        };
        this.getValidMessage = (messages)=>{
            if (!messages) return;
            const message = messages.find((mess)=>{
                var ref, ref1;
                const startDate = (((ref = mess.data) === null || ref === void 0 ? void 0 : ref.startDate) ? new Date(mess.data.startDate) : new Date(2000, 1, 1)).getTime();
                const endDate = (((ref1 = mess.data) === null || ref1 === void 0 ? void 0 : ref1.endDate) ? new Date(mess.data.endDate) : new Date(9999, 1, 1)).getTime();
                const readDateStr = localStorage.getItem(mess.id);
                const isRead = !!readDateStr;
                let isShowAgain = false;
                if (readDateStr) {
                    const readDate = new Date(Number.parseInt(readDateStr));
                    const today = new Date();
                    const diffDays = today.getDate() - readDate.getDate();
                    const diffMonths = today.getMonth() - readDate.getMonth();
                    const diffYears = today.getFullYear() - readDate.getFullYear();
                    if (diffDays === 0 && diffMonths === 0 && diffYears === 0) {
                        isShowAgain = false;
                    } else {
                        isShowAgain = diffDays > 0 || diffMonths > 0 || diffYears > 0;
                    }
                }
                const now = Date.now();
                const isValid = now > startDate && now < endDate;
                return isValid && (!isRead || isShowAgain);
            });
            if (message && message.data) {
                return {
                    ...message.data,
                    id: message.id
                };
            }
            return undefined;
        };
    }
}
/* harmony default export */ var Message = (new MessageModel());

// EXTERNAL MODULE: ./helpers/LangHelper.ts
var LangHelper = __webpack_require__(77868);
// EXTERNAL MODULE: ./contexts/LayoutContext.tsx
var LayoutContext = __webpack_require__(21513);
;// CONCATENATED MODULE: ./contexts/NotificationContext.tsx







const NotificationCtx = /*#__PURE__*/ (0,react.createContext)({});
const NotificationCtxWrapper = (props)=>{
    const { children  } = props;
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const [theme, setTheme] = (0,react.useState)();
    const [messages, setMessages] = (0,react.useState)([]);
    const [isShowNoti, setIsShowingNoti] = (0,react.useState)(false);
    const [previewMessageId, setPreviewMessageId] = (0,react.useState)();
    const route = (0,router.useRouter)();
    (0,react.useEffect)(()=>{
        let messageId = route.query["message_id"];
        if (Array.isArray(messageId)) {
            messageId = messageId[0];
        }
        setPreviewMessageId(messageId);
    }, [
        route.query
    ]);
    (0,react.useEffect)(()=>{
        (async ()=>{
            let messages;
            if (previewMessageId && builder_react_es5/* Builder.isPreviewing */.Ib.isPreviewing) {
                messages = await Message.getMessage(previewMessageId, true);
                if (messages) {
                    messages = [
                        messages
                    ];
                }
            } else {
                messages = await Message.getAllMessages(locale);
            }
            const validMessage = Message.getValidMessage(messages);
            if (validMessage) {
                setMessages([
                    validMessage
                ]);
            }
        })();
    }, [
        previewMessageId,
        locale
    ]);
    const addMessages = (message)=>{
        setMessages((mess)=>{
            return [
                ...mess,
                message
            ];
        });
    };
    const popMessage = ()=>{
        const message = [
            ...messages
        ].pop();
        if (message) {
            var ref;
            if (theme === LayoutContext/* BusinessTheme.BUSINESS_HUB */.E2.BUSINESS_HUB) {
                var ref1;
                if (((ref1 = message.businessHubTheme) === null || ref1 === void 0 ? void 0 : ref1.enabled) === false) {
                    return undefined;
                }
            } else if (((ref = message.accessTheme) === null || ref === void 0 ? void 0 : ref.enabled) === false) {
                return undefined;
            }
        }
        setMessages((mess)=>{
            mess.pop();
            return mess;
        });
        return message;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationCtx.Provider, {
        value: {
            messages,
            isShowing: isShowNoti,
            theme,
            popMessage,
            addMessages,
            setIsShowing: setIsShowingNoti,
            setTheme
        },
        children: children
    });
};
const useNotification = ()=>(0,react.useContext)(NotificationCtx);


/***/ }),

/***/ 31198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Af": function() { return /* binding */ getQuickSearchResponses; },
/* harmony export */   "CN": function() { return /* binding */ getPageFromPageID; },
/* harmony export */   "Jq": function() { return /* binding */ mapBuilderObjectToArticle; },
/* harmony export */   "NE": function() { return /* binding */ getArticleFromID; },
/* harmony export */   "W": function() { return /* binding */ getPlaceholderBuilderImage; },
/* harmony export */   "WA": function() { return /* binding */ resourcesInput; },
/* harmony export */   "X6": function() { return /* binding */ CATEGORY_ROOT; },
/* harmony export */   "Zd": function() { return /* binding */ getArticlesByCategory; },
/* harmony export */   "bs": function() { return /* binding */ getResizedBuilderImage; },
/* harmony export */   "cA": function() { return /* binding */ getArticleSearchResults; },
/* harmony export */   "gg": function() { return /* binding */ getLatestArticles; },
/* harmony export */   "nq": function() { return /* binding */ getCategoriesFromIDs; },
/* harmony export */   "oI": function() { return /* binding */ excludedArticleIds; },
/* harmony export */   "s$": function() { return /* binding */ getCategoryFromID; },
/* harmony export */   "tG": function() { return /* binding */ getAllCategories; },
/* harmony export */   "yP": function() { return /* binding */ mapBuilderObjectToCategory; },
/* harmony export */   "zC": function() { return /* binding */ getAllArticles; }
/* harmony export */ });
/* unused harmony exports getBuilderPage, getArticlePageFromUrl, getCategoryFromName, getRelatedArticles, getAllArticlePaths */
/* harmony import */ var _builder_io_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75102);
/* harmony import */ var algoliasearch__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96441);
/* harmony import */ var algoliasearch__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(algoliasearch__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _shared_env__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69771);
/* harmony import */ var _LangHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77868);
/* harmony import */ var _types_Resource__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23366);





_builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* ["default"].init */ .ZP.init(_shared_env__WEBPACK_IMPORTED_MODULE_1__/* .BUILDER_API_KEY */ .uT);
const client = algoliasearch__WEBPACK_IMPORTED_MODULE_4___default()(_shared_env__WEBPACK_IMPORTED_MODULE_1__/* .ALGOLIA_APP_ID */ .$A, _shared_env__WEBPACK_IMPORTED_MODULE_1__/* .ALGOLIA_API_KEY */ .vd);
const articleIndex = client.initIndex("builder-article");
const CATEGORY_ROOT = "/business/access/";
/**
 * https://dijitally.atlassian.net/browse/APB-212
 * https://dijitally.atlassian.net/browse/APB-257
 */ const excludedArticleIds = [
    "03c8d98acf1341a1a78668a42f76f342",
    "6500a1b582874d038178ffca459b35b4",
    "9b182828368a49a6b0872ec7119b36c0",
    "e7d6577785ca4e35ae3a13f0ba811e2d",
    "9647e35f141a4d73aac1367e9093c6ce",
    "98980189fa414d4b8042b099ef9be739",
    "d258b5ff845a46ce8da8b549c5774023",
    "3813f56a18a44646bb94543fd3684ba7",
    "fcd0925629d44c73b60ac65b8d9196af",
    "3d5f6f728a8e480fae7507f2f82a64d4",
    "74fbbf2c675d44479f0df5ff6a95e7b1",
    "a1a6b180b0c440c99b9ad86d925db1c6",
    "e3d02593db2f4cd09c9caf6bd61cd8dc",
    "a0c28c5496ba4cefb7539ed335075a84",
    "957e67c8b8f54c95b1eed46e2615bc55",
    "c4d5b594468f4b63b9a0d36e9a236434",
    "e1f67ee797944b449e8db3b49b125558",
    "87ca4620882d4b04937f7921724c8c87",
    "1cc3c604bd514519b8f4a6bb2c1ab200",
    "237989ea7b774f20987ff8003ef88cc1",
    "4c2ee6ee27e84417a4e650e78bf6cc37"
];
function mapBuilderObjectToArticle(object) {
    var ref, ref1, ref2, ref3;
    if (!object) return object;
    const oData = object.data;
    const categories = (ref = oData.categories) === null || ref === void 0 ? void 0 : ref.map((category)=>mapBuilderObjectToCategory(category.category.value));
    const author = oData === null || oData === void 0 ? void 0 : (ref1 = oData.author) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.data;
    var ref4;
    const articleSlug = (ref4 = (ref3 = oData.url) === null || ref3 === void 0 ? void 0 : ref3.replace("/builder/", "")) !== null && ref4 !== void 0 ? ref4 : "";
    const articleUrl = categories && categories.length ? "".concat(categories[0].categoryUrl, "/").concat(articleSlug).replace(/\/{2,}/, "/") : null;
    var _id, _title, _description, _contributors, _leadImage, _leadPortraitImage, _imageMobile, _priority, _seoTitle, ref5, _seoDescription, ref6, _leadVideo, _lastUpdated;
    return {
        id: (_id = object.id) !== null && _id !== void 0 ? _id : null,
        title: (_title = oData.title) !== null && _title !== void 0 ? _title : "",
        description: (_description = oData.description) !== null && _description !== void 0 ? _description : "",
        categories: categories !== null && categories !== void 0 ? categories : null,
        author: author !== null && author !== void 0 ? author : null,
        contributors: (_contributors = oData.contributors) !== null && _contributors !== void 0 ? _contributors : [],
        leadImage: (_leadImage = oData.leadImage) !== null && _leadImage !== void 0 ? _leadImage : null,
        leadPortraitImage: (_leadPortraitImage = oData.leadPortraitImage) !== null && _leadPortraitImage !== void 0 ? _leadPortraitImage : null,
        imageMobile: (_imageMobile = oData.imageMobile) !== null && _imageMobile !== void 0 ? _imageMobile : null,
        url: articleUrl !== null && articleUrl !== void 0 ? articleUrl : "",
        articleUrl: articleUrl !== null && articleUrl !== void 0 ? articleUrl : "",
        articleSlug,
        priority: (_priority = oData.priority) !== null && _priority !== void 0 ? _priority : 0,
        builderModel: object !== null && object !== void 0 ? object : null,
        seoTitle: (ref5 = (_seoTitle = oData.seoTitle) !== null && _seoTitle !== void 0 ? _seoTitle : oData.title) !== null && ref5 !== void 0 ? ref5 : "",
        seoDescription: (ref6 = (_seoDescription = oData.seoDescription) !== null && _seoDescription !== void 0 ? _seoDescription : oData.description) !== null && ref6 !== void 0 ? ref6 : "",
        leadVideo: (_leadVideo = oData.leadVideo) !== null && _leadVideo !== void 0 ? _leadVideo : null,
        lastUpdated: (_lastUpdated = object.lastUpdated) !== null && _lastUpdated !== void 0 ? _lastUpdated : null
    };
}
function mapBuilderObjectToCategory(item) {
    if (!item) {
        return {
            id: "",
            name: "",
            longName: null,
            description: "",
            categoryUrl: "",
            isSeries: false,
            image: "",
            lastUpdated: "",
            exclusiveForLocales: []
        };
    }
    let name;
    let category = item;
    if (item.data === undefined) {
        var _name;
        name = (_name = item.name) !== null && _name !== void 0 ? _name : "";
    } else {
        category = item.data;
        var _name1;
        name = (_name1 = item.name) !== null && _name1 !== void 0 ? _name1 : item.data.name;
    }
    const categorySlug = categoryNameToUrlSlug(name);
    var _longName, _exclusiveForLocales;
    // TODO generalize this parser here
    return {
        id: item.id,
        name,
        longName: (_longName = category.longName) !== null && _longName !== void 0 ? _longName : null,
        categoryUrl: (CATEGORY_ROOT + categorySlug).replace(/\/{2,}/g, "/"),
        isSeries: !!category.isSeries || false,
        categorySlug,
        description: category.description || "",
        image: category.image || "",
        lastUpdated: item.lastUpdated || "",
        exclusiveForLocales: (_exclusiveForLocales = category.exclusiveForLocales) !== null && _exclusiveForLocales !== void 0 ? _exclusiveForLocales : []
    };
}
const categoryNameToUrlSlug = (name)=>{
    return name.trim().toLowerCase().replace(/[^A-z]/g, "-").trimEnd();
};
const getAllArticles = async function(locale, filters, sort) {
    let includeUnpublished = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, limitFields = arguments.length > 4 ? arguments[4] : void 0;
    var ref;
    const getConfig = {
        query: {},
        options: {
            noTargeting: true,
            includeUnpublished
        }
    };
    if (filters === null || filters === void 0 ? void 0 : filters.extra) {
        getConfig.query = filters === null || filters === void 0 ? void 0 : filters.extra;
    }
    if (locale) {
        getConfig.query.query = {
            $elemMatch: {
                property: {
                    $eq: "locale"
                },
                value: locale
            }
        };
    }
    if (filters === null || filters === void 0 ? void 0 : (ref = filters.categoryIds) === null || ref === void 0 ? void 0 : ref.length) {
        getConfig.query["data.categories"] = {
            $elemMatch: {
                "category.id": {
                    $in: filters.categoryIds
                }
            }
        };
    }
    if (sort && getConfig.options) {
        getConfig.options.sort = sort;
    }
    if (limitFields) {
        getConfig.fields = limitFields;
    }
    getConfig.limit = filters === null || filters === void 0 ? void 0 : filters.limit;
    if (getConfig.options) {
        if (typeof (filters === null || filters === void 0 ? void 0 : filters.offset) === "string") {
            var ref1;
            getConfig.options.offset = parseInt((ref1 = filters === null || filters === void 0 ? void 0 : filters.offset) !== null && ref1 !== void 0 ? ref1 : "0");
        } else {
            getConfig.options.offset = filters === null || filters === void 0 ? void 0 : filters.offset;
        }
    }
    const articles = await _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getAll */ .ZP.getAll("article", getConfig);
    return articles.map((page)=>{
        return mapBuilderObjectToArticle(page);
    });
};
const getArticlePage = async function(params) {
    let includeUnpublished = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getBuilderPage("article", params, includeUnpublished);
};
const getBuilderPage = async function(model, params) {
    let includeUnpublished = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    const query = {
        userAttributes: {},
        options: {
            includeUnpublished,
            noTargeting: false
        }
    };
    if (params.url) {
        query.userAttributes.urlPath = params.url;
        if (params.locale) {
            query.userAttributes.locale = params.locale;
        } else {
            query.userAttributes.locale = _LangHelper__WEBPACK_IMPORTED_MODULE_2__/* .ALL_LOCALES */ .En;
        }
    }
    if (params.modelId) {
        query.entry = params.modelId;
    }
    // TODO replace these string entries with constants
    const article = await _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get(model, query).toPromise() || null;
    return article;
};
const getArticlePageFromUrl = async function() {
    let path = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", locale = arguments.length > 1 ? arguments[1] : void 0, includeUnpublished = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return getArticlePage({
        url: "/builder/" + path,
        locale
    }, includeUnpublished);
};
const getArticleFromID = async function(modelId) {
    let includeUnpublished = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getArticlePage({
        modelId
    }, includeUnpublished);
};
const getCategoryFromName = async (name)=>{
    const slug = categoryNameToUrlSlug(name);
    const allPossibleCategories = await getAllCategories();
    for (const category of allPossibleCategories){
        if ("".concat(CATEGORY_ROOT).concat(slug) === category.categoryUrl) {
            // TODO refactor check to come from a generic place
            return category;
        }
    }
    return null;
};
const getCategoryFromID = async (modelId)=>{
    const foundCategory = await getBuilderPage("category", {
        modelId
    }, true);
    if (foundCategory) {
        return mapBuilderObjectToCategory(foundCategory);
    }
    return null;
};
const getArticlesByCategory = async (param)=>{
    let { locale , offset , limit =9 , categoryIds =[]  } = param;
    return await getAllArticles(locale, {
        categoryIds,
        limit,
        offset,
        extra: {
            id: {
                $nin: excludedArticleIds
            }
        }
    });
};
const getRelatedArticles = async (article, locale)=>{
    if (!article) {
        return [];
    }
    const categoryIds = article.categories ? [
        ...article.categories
    ].map((item)=>{
        return item.id;
    }) : [];
    const config = {
        options: {
            noTargeting: true
        },
        query: {
            id: {
                $nin: excludedArticleIds.concat([
                    article.builderModel.id
                ])
            },
            "data.categories": {
                $elemMatch: {
                    "category.id": {
                        $in: [
                            categoryIds[0]
                        ]
                    }
                }
            }
        },
        limit: 3
    };
    if (locale) {
        config.query.query = {
            $elemMatch: {
                property: {
                    $eq: "locale"
                },
                value: locale
            }
        };
    }
    const relatedPages = await builder.getAll("article", config);
    const relatedArticles = relatedPages.map((page)=>{
        return mapBuilderObjectToArticle(page);
    });
    return relatedArticles;
};
const getLatestArticles = async (param)=>{
    let { locale , offset , limit =4 , categoryIds =[]  } = param;
    const articles = await getAllArticles(locale, {
        extra: {
            data: {
                "leadVideo.videoUrl": {
                    $exists: false
                },
                priority: {
                    $exists: true,
                    $gt: -1
                }
            }
        },
        categoryIds,
        offset,
        limit
    }, {
        "data.priority": -1,
        lastUpdated: -1
    });
    if (articles.length < limit) {
        const excludeIds = articles.map((article)=>article.id);
        const articles2 = await getAllArticles(locale, {
            extra: {
                data: {
                    "leadVideo.videoUrl": {
                        $exists: false
                    }
                },
                ...excludeIds.length > 0 ? {
                    id: {
                        $nin: excludeIds
                    }
                } : {}
            },
            categoryIds,
            offset,
            limit: limit - articles.length
        }, {
            "data.priority": -1,
            lastUpdated: -1
        });
        if (articles2.length) {
            articles.push(...articles2);
        }
    }
    return articles;
};
let cachedCategoryList = [];
const getAllCategories = async (fields)=>{
    // TODO add caching mechanism to avoid loading this over and over again
    if (cachedCategoryList.length !== 0) {
        return cachedCategoryList;
    }
    const allCategory = await _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getAll */ .ZP.getAll("category", {
        options: {
            noTargeting: true,
            includeUnpublished: false
        },
        fields,
        limit: 100
    });
    const categoriesData = allCategory.map((item)=>mapBuilderObjectToCategory(item));
    if (cachedCategoryList.length === 0) {
        cachedCategoryList = categoriesData;
    }
    return categoriesData;
};
const getCategoriesFromIDs = async function() {
    let categoryIds = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const allCategory = await _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getAll */ .ZP.getAll("category", {
        options: {
            noTargeting: true,
            includeUnpublished: false
        },
        query: {
            id: {
                $in: categoryIds
            }
        }
    });
    const categoriesData = allCategory.map((item)=>mapBuilderObjectToCategory(item));
    return categoriesData;
};
const getPageFromPageID = async (id)=>{
    return getBuilderPage("page", {
        modelId: id
    }, true);
};
const getArticleSearchResults = async (param)=>{
    let { locale , keyword , limit =25 , offset =0 , onlyFields  } = param;
    try {
        const { hits: articles  } = await articleIndex.search(keyword, {
            hitsPerPage: limit,
            offset: offset,
            attributesToRetrieve: [
                "*"
            ],
            removeWordsIfNoResults: "none",
            exactOnSingleWordQuery: "word",
            facets: [
                "published",
                "query.value"
            ],
            facetFilters: [
                [
                    "query.value:".concat(locale)
                ],
                [
                    "published:published"
                ]
            ]
        });
        const ids = articles.map((article)=>article.objectID);
        return getAllArticles(locale, {
            extra: {
                id: {
                    $in: ids
                }
            },
            limit,
            offset
        }, undefined, false, onlyFields);
    } catch (ex) {
        console.error(ex);
        return getAllArticles(locale, {
            extra: {
                $or: [
                    {
                        name: {
                            $regex: keyword,
                            $options: "i"
                        }
                    },
                    {
                        description: {
                            $regex: keyword,
                            $options: "i"
                        }
                    },
                    {
                        "data.title": {
                            $regex: keyword,
                            $options: "i"
                        }
                    },
                    {
                        "data.blocks.$elemMatch.component.options.text": {
                            $regex: keyword,
                            $options: "i"
                        }
                    }
                ]
            },
            limit,
            offset
        }, undefined, false, onlyFields);
    }
};
/**
 * Function used for fetching paths for Static Path mapping
 *
 * @returns Promise
 */ const getAllArticlePaths = async ()=>{
    const pathArray = [];
    let currentOffset = 0;
    const fetchArticles = async (offset)=>{
        const currentArticles = await getAllArticles(undefined, {
            offset,
            limit: 100
        });
        currentArticles.map((page)=>{
            const queryFilters = page.builderModel.query;
            // Check if page has lang
            if (queryFilters.length > 0 && queryFilters[1].property == "locale") {
                queryFilters[1].value.forEach((lang)=>{
                    page.categories.forEach((category)=>{
                        if (category.categoryUrl) {
                            var ref;
                            const businessPath = (ref = LOCALE_LINKS[lang]) === null || ref === void 0 ? void 0 : ref.businessRoot;
                            if (lang !== Locale.USA) {
                                var _categorySlug;
                                pathArray.push({
                                    lang,
                                    category: (_categorySlug = category.categorySlug) !== null && _categorySlug !== void 0 ? _categorySlug : "",
                                    article: page.articleSlug,
                                    business: businessPath !== null && businessPath !== void 0 ? businessPath : BusinessUrlPrefix.Business
                                });
                            }
                        }
                    });
                });
            }
        });
        if (currentArticles.length === 100) {
            await fetchArticles(currentOffset += 100);
        }
    };
    await fetchArticles(currentOffset);
    return pathArray;
};
/**
 * Function will return a promise, with suggestions for category, and articles
 */ const getQuickSearchResponses = async (locale, query)=>{
    const articles = [];
    const categories = [];
    const queryPromises = [
        (async ()=>{
            const foundCategories = await getAllCategories();
            const includesRegex = new RegExp(query, "i");
            if (foundCategories.length) {
                for (const category of foundCategories){
                    var ref;
                    if (((ref = category.exclusiveForLocales) === null || ref === void 0 ? void 0 : ref.length) && !category.exclusiveForLocales.includes(locale)) {
                        continue;
                    }
                    if (includesRegex.test(category.name)) {
                        var _categoryUrl;
                        categories.push({
                            name: category.name,
                            link: (_categoryUrl = category.categoryUrl) !== null && _categoryUrl !== void 0 ? _categoryUrl : "",
                            id: category.id
                        });
                        if (categories.length >= 5) {
                            break;
                        }
                    }
                }
            }
        })(),
        (async ()=>{
            const foundArticles = await getArticleSearchResults({
                locale,
                keyword: query,
                limit: 5
            });
            if (foundArticles.length) {
                foundArticles.forEach((article)=>{
                    var _articleUrl;
                    articles.push({
                        name: article.title,
                        link: (_articleUrl = article.articleUrl) !== null && _articleUrl !== void 0 ? _articleUrl : "",
                        id: article.builderModel.id
                    });
                });
            }
        })()
    ];
    await Promise.all(queryPromises);
    return {
        categories,
        articles
    };
};
const resourcesInput = {
    name: "resources",
    type: "list",
    copyOnAdd: false,
    subFields: [
        {
            name: "id",
            type: "string"
        },
        {
            name: "type",
            type: "string"
        },
        {
            name: "title",
            type: "string"
        },
        {
            name: "description",
            type: "richText"
        },
        {
            name: "description2",
            type: "richText"
        },
        {
            name: "assets",
            type: "list",
            copyOnAdd: false,
            subFields: [
                {
                    name: "name",
                    type: "string"
                },
                {
                    name: "keyMessages",
                    type: "Tags"
                },
                {
                    name: "hide",
                    type: "boolean"
                },
                {
                    name: "skipDownload",
                    type: "boolean"
                },
                // {
                //     name: 'themedAssets',
                //     type: 'Tags',
                // },
                {
                    name: "variants",
                    type: "list",
                    copyOnAdd: false,
                    subFields: [
                        {
                            name: "variantName",
                            type: "string"
                        },
                        {
                            name: "colors",
                            type: "list",
                            copyOnAdd: false,
                            subFields: [
                                {
                                    name: "color",
                                    type: "string",
                                    enum: Object.values(_types_Resource__WEBPACK_IMPORTED_MODULE_3__/* .COLORS */ .D)
                                }
                            ]
                        },
                        {
                            name: "backgroundColor",
                            type: "color"
                        },
                        {
                            name: "previewUrl",
                            type: "url"
                        },
                        {
                            name: "downloadUrl",
                            type: "url"
                        },
                        {
                            name: "fileName",
                            type: "string"
                        },
                        {
                            name: "extension",
                            type: "string"
                        },
                        {
                            name: "hide",
                            type: "boolean"
                        }
                    ]
                }
            ]
        }
    ]
};
const getResizedBuilderImage = (source, parameters)=>{
    if (source && source.startsWith("https://cdn.builder.io/api/v1/image/")) {
        let queryArray = [];
        if (parameters) {
            var _quality;
            parameters.quality = (_quality = parameters.quality) !== null && _quality !== void 0 ? _quality : 85;
            parameters.format = "webp";
            const parameterKeys = Object.keys(parameters);
            parameterKeys.forEach((paramKey)=>{
                const paramValue = parameters[paramKey];
                if (paramValue) {
                    queryArray.push("".concat(paramKey, "=").concat(paramValue));
                }
            });
        }
        return "".concat(source, "?").concat(queryArray.join("&"));
    }
    return source;
};
const getPlaceholderBuilderImage = (source)=>{
    return getResizedBuilderImage(source, {
        width: 1,
        height: 1
    });
};


/***/ }),

/***/ 77868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bj": function() { return /* binding */ localifyLink; },
/* harmony export */   "CB": function() { return /* binding */ isUrl; },
/* harmony export */   "En": function() { return /* binding */ ALL_LOCALES; },
/* harmony export */   "FZ": function() { return /* binding */ getLocalePrettyName; },
/* harmony export */   "Fw": function() { return /* binding */ LIVE_LOCALES; },
/* harmony export */   "Hj": function() { return /* binding */ DEFAULT_LANG; },
/* harmony export */   "OT": function() { return /* binding */ ALL_BUSINESS_PREFIXES; },
/* harmony export */   "RO": function() { return /* binding */ doesContainLocale; },
/* harmony export */   "S2": function() { return /* binding */ standardizeLocale; },
/* harmony export */   "Yd": function() { return /* binding */ getCompanyName; },
/* harmony export */   "_y": function() { return /* binding */ getLocaleFromRoute; },
/* harmony export */   "bU": function() { return /* binding */ useLocale; },
/* harmony export */   "e7": function() { return /* binding */ stripLocaleFromURL; },
/* harmony export */   "go": function() { return /* binding */ Locale; },
/* harmony export */   "kV": function() { return /* binding */ LOCALE_LINKS; },
/* harmony export */   "mC": function() { return /* binding */ replaceLocale; },
/* harmony export */   "yM": function() { return /* binding */ replaceOrAddLocale; }
/* harmony export */ });
/* unused harmony exports BusinessUrlPrefix, MARKETING_RESOURCE_CENTRE_PREFIX, EXCLUDE_PAGES */
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75407);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);

var BusinessUrlPrefix;
(function(BusinessUrlPrefix) {
    BusinessUrlPrefix["ForRetail"] = "for-retailers";
    BusinessUrlPrefix["Business"] = "business";
})(BusinessUrlPrefix || (BusinessUrlPrefix = {}));
const MARKETING_RESOURCE_CENTRE_PREFIX = "/business/resources/marketing";
const ALL_BUSINESS_PREFIXES = Object.values(BusinessUrlPrefix);
var Locale;
(function(Locale) {
    Locale["USA"] = "en-US";
    Locale["GreatBritain"] = "en-GB";
    Locale["Australia"] = "en-AU";
    Locale["NewZealand"] = "en-NZ";
    Locale["CanadaEnglish"] = "en-CA";
    Locale["CanadaFrench"] = "fr-CA";
})(Locale || (Locale = {}));
const DEFAULT_LANG = Locale.Australia;
const LIVE_LOCALES = [
    Locale.USA,
    Locale.CanadaEnglish,
    Locale.GreatBritain,
    Locale.Australia,
    Locale.NewZealand
];
const EXCLUDE_PAGES = (/* unused pure expression or super */ null && ([
    "/business/access/guides",
    "/for-retailers/access/guides",
    "/for-retailers/resources",
    "/for-retailers/access/make-it-your-way",
    "/business/access/make-it-your-way"
])); // TODO this is a hack to make sure Guides page works as it matches a Category URL otherwise
const ALL_LOCALES = Object.values(Locale);
const LOCALE_LINKS = {
    [Locale.USA]: {
        signup: "https://hub.us.afterpay.com/signup",
        home: "https://afterpay.com/en-US",
        businessRoot: BusinessUrlPrefix.ForRetail,
        host: "https://www.afterpay.com"
    },
    [Locale.GreatBritain]: {
        signup: "https://hub.clearpay.co.uk/signup",
        home: "https://www.clearpay.co.uk/en-GB",
        businessRoot: BusinessUrlPrefix.ForRetail,
        host: "https://www.clearpay.com"
    },
    [Locale.Australia]: {
        signup: "https://hub.afterpay.com/signup?country=au",
        home: "https://www.afterpay.com/en-AU",
        businessRoot: BusinessUrlPrefix.Business,
        host: "https://www.afterpay.com"
    },
    [Locale.NewZealand]: {
        signup: "https://hub.afterpay.com/signup?country=nz",
        home: "https://www.afterpay.com/en-NZ",
        businessRoot: BusinessUrlPrefix.Business,
        host: "https://afterpay.com"
    },
    [Locale.CanadaEnglish]: {
        signup: "https://hub.us.afterpay.com/signup?country=ca",
        home: "https://www.afterpay.com/en-CA",
        businessRoot: BusinessUrlPrefix.Business,
        host: "https://www.afterpay.com"
    },
    [Locale.CanadaFrench]: {
        signup: "https://hub.us.afterpay.com/signup?country=ca",
        home: "https://www.afterpay.com/fr-CA",
        businessRoot: BusinessUrlPrefix.Business,
        host: "https://www.afterpay.com"
    }
};
const getLocalePrettyName = (local)=>{
    switch(local){
        case Locale.USA:
            return "United States";
        case Locale.Australia:
            return "Australia";
        case Locale.GreatBritain:
            return "Great Britain";
        case Locale.NewZealand:
            return "New Zealand";
        case Locale.CanadaEnglish:
            return "Canada - English";
        case Locale.CanadaFrench:
            return "Canada - Fran\xe7ais";
    }
};
const LOCALE_MATCH_REGEX = /^(\/|).{1,3}\-.{1,3}\//;
const URL_REGREX = /^(http|https):\/\//;
const isUrl = (url)=>URL_REGREX.test(url);
const doesContainLocale = (url)=>{
    const regex = new RegExp(LOCALE_MATCH_REGEX);
    return regex.test(url);
};
const getCompanyName = (locale)=>{
    if (locale === Locale.GreatBritain) {
        return "Clearpay";
    }
    return "Afterpay";
};
const stripLocaleFromURL = (url)=>{
    return url.replace(LOCALE_MATCH_REGEX, "/");
};
const replaceLocale = (url, newLocale)=>{
    return url.replace(LOCALE_MATCH_REGEX, newLocale);
};
const replaceOrAddLocale = (url, newLocale)=>{
    if (!url.match(/^(([a-z.\-+])+|(\/\/))(:?).+$/gim)) {
        let newTarget;
        if (doesContainLocale(url)) {
            newTarget = url;
        } else {
            newTarget = "/".concat(newLocale).concat(url);
        }
        return localifyLink(newTarget, newLocale);
    }
    return url;
};
const localifyLink = (url, locale)=>{
    const matchingRegex = new RegExp("/(".concat(ALL_BUSINESS_PREFIXES.join("|"), ")"));
    if (locale) {
        var ref;
        var ref1;
        return url.replace(matchingRegex, (ref1 = "/" + ((ref = LOCALE_LINKS[locale]) === null || ref === void 0 ? void 0 : ref.businessRoot)) !== null && ref1 !== void 0 ? ref1 : "");
    } else {
    // TODO do some magic to figure out the current locale
    }
    return url;
};
const getLocaleFromRoute = (path)=>{
    for (const locale of ALL_LOCALES){
        if (path.toLowerCase().startsWith("/".concat(locale).toLowerCase())) {
            return locale;
        }
    }
    // Default
    return Locale.Australia;
};
const useLocale = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    const locale = getLocaleFromRoute(router.asPath);
    if (locale == Locale.CanadaEnglish) {
        return {
            locale: Locale.USA
        };
    }
    return {
        locale
    };
};
const standardizeLocale = (localeText)=>{
    for (const locale of ALL_LOCALES){
        if (locale.toLowerCase() === localeText.toLowerCase()) {
            return locale;
        }
    }
    return localeText;
};


/***/ }),

/***/ 65443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d8": function() { return /* binding */ setCookie; },
/* harmony export */   "ej": function() { return /* binding */ getCookie; }
/* harmony export */ });
/* unused harmony export deleteCookie */
const setCookie = (name, value, days, path)=>{
    let date;
    if (days !== undefined) {
        date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    } else {
        // trick: no expiration date
        date = new Date(2147483647 * 1000);
    }
    const expires = "expires=".concat(date.toUTCString());
    document.cookie = "".concat(name, "=").concat(value, "; path=").concat(path !== null && path !== void 0 ? path : "/", "; ").concat(expires);
};
const getCookie = (name)=>{
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts && parts.length == 2) {
        const partFist = parts === null || parts === void 0 ? void 0 : parts.pop();
        if (partFist) {
            return partFist.split(";").shift();
        }
        return undefined;
    } else {
        return undefined;
    }
};
const deleteCookie = (name)=>{
    const date = new Date();
    date.setTime(date.getTime() + -1 * 24 * 60 * 60 * 1000);
    document.cookie = name + "=; expires=" + date.toUTCString() + "; path=/";
};


/***/ }),

/***/ 52479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useBackgroundTransform; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62991);
/* harmony import */ var _contexts_LayoutContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21513);


const useBackgroundTransform = (target, preventTopTransform)=>{
    const { setBreadcrumbType  } = (0,_contexts_LayoutContext__WEBPACK_IMPORTED_MODULE_1__/* .useBusinessLayout */ .Vp)();
    const [position, setPosition] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
    const transformDetector = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        if (!target || !target.current) return;
        const targetElem = target.current;
        const element_height = targetElem.clientHeight;
        const top_of_element = targetElem.offsetTop;
        const bottom_of_element = targetElem.offsetTop + element_height;
        const top_of_window = window.scrollY;
        const bottom_of_window = top_of_window + window.innerHeight;
        const window_height = window.innerHeight;
        let position = "ON_SCREEN";
        let top_transform_position = Math.max(top_of_element + 100, Math.min(window_height / 3, top_of_element / 3 * 4));
        if (top_transform_position > bottom_of_element) {
            top_transform_position = top_of_element;
        }
        let bottom_transform_position = Math.max(bottom_of_element - 100, Math.min(window_height / 3, top_of_element / 3 * 2));
        if (bottom_transform_position < top_of_element) {
            bottom_transform_position = bottom_of_element;
        }
        if ((bottom_of_window > top_transform_position || preventTopTransform) && top_of_window < bottom_transform_position) {
            document.body.classList.add("dark");
            setBreadcrumbType === null || setBreadcrumbType === void 0 ? void 0 : setBreadcrumbType("light");
            position = "TOP";
        } else {
            document.body.classList.remove("dark");
            setBreadcrumbType === null || setBreadcrumbType === void 0 ? void 0 : setBreadcrumbType("dark");
            position = "BOTTOM";
        }
        if (top_of_window < bottom_transform_position && bottom_of_window > top_transform_position) {
            position = "ON_SCREEN";
        }
        setPosition(position);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        target
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        transformDetector();
        document.addEventListener("scroll", transformDetector);
        return ()=>{
            setBreadcrumbType === null || setBreadcrumbType === void 0 ? void 0 : setBreadcrumbType("light");
            document.body.classList.remove("dark");
            document.removeEventListener("scroll", transformDetector);
        };
    }, [
        transformDetector
    ]);
    return {
        position
    };
};


/***/ }),

/***/ 77442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useWindowSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62991);

function useWindowSize() {
    const [windowSize, setWindowSize] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        width: undefined,
        height: undefined
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        function handleResize() {
            var ref, ref1, ref2, ref3;
            setWindowSize({
                width: (document === null || document === void 0 ? void 0 : (ref = document.documentElement) === null || ref === void 0 ? void 0 : ref.clientWidth) || (document === null || document === void 0 ? void 0 : (ref1 = document.body) === null || ref1 === void 0 ? void 0 : ref1.clientWidth) || (window === null || window === void 0 ? void 0 : window.innerWidth),
                height: (document === null || document === void 0 ? void 0 : (ref2 = document.documentElement) === null || ref2 === void 0 ? void 0 : ref2.clientHeight) || (document === null || document === void 0 ? void 0 : (ref3 = document.body) === null || ref3 === void 0 ? void 0 : ref3.clientHeight) || (window === null || window === void 0 ? void 0 : window.innerHeight)
            });
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    return windowSize;
}


/***/ }),

/***/ 23385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builder_io_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75102);
/* harmony import */ var _shared_env__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69771);


const fetchLimit = 100;
class BaseModel {
    constructor(props){
        var _this = this;
        this.fromBuilderContent = (object)=>{
            throw new Error("Not implemented");
        };
        this.findAll = (param)=>{
            let { filters , sort , includeUnpublished , limitFields , includeRefs , fields  } = param;
            const getConfig = {
                userAttributes: {},
                query: {},
                options: {
                    noTargeting: true,
                    includeUnpublished
                },
                includeRefs,
                fields
            };
            if (filters === null || filters === void 0 ? void 0 : filters.extra) {
                getConfig.query = filters === null || filters === void 0 ? void 0 : filters.extra;
            }
            if (filters === null || filters === void 0 ? void 0 : filters.locale) {
                var ref;
                getConfig.query = {
                    ...getConfig.query,
                    query: {
                        ...((ref = getConfig.query) === null || ref === void 0 ? void 0 : ref.query) || {},
                        $elemMatch: {
                            property: {
                                $eq: "locale"
                            },
                            value: filters === null || filters === void 0 ? void 0 : filters.locale
                        }
                    }
                };
            }
            if (sort && getConfig.options) {
                getConfig.options.sort = sort;
            }
            if (limitFields) {
                getConfig.fields = limitFields;
            }
            if (filters === null || filters === void 0 ? void 0 : filters.limit) {
                getConfig.limit = filters.limit;
            }
            if (Number.isInteger(filters === null || filters === void 0 ? void 0 : filters.offset) || !(filters === null || filters === void 0 ? void 0 : filters.offset)) {
                if (typeof (filters === null || filters === void 0 ? void 0 : filters.offset) === "string") {
                    var ref1;
                    getConfig.offset = parseInt((ref1 = filters === null || filters === void 0 ? void 0 : filters.offset) !== null && ref1 !== void 0 ? ref1 : "0");
                } else {
                    getConfig.offset = filters === null || filters === void 0 ? void 0 : filters.offset;
                }
            }
            if (getConfig.options) {
                if (typeof (filters === null || filters === void 0 ? void 0 : filters.offset) === "string") {
                    var ref2;
                    getConfig.options.offset = parseInt((ref2 = filters === null || filters === void 0 ? void 0 : filters.offset) !== null && ref2 !== void 0 ? ref2 : "0");
                } else {
                    getConfig.options.offset = filters === null || filters === void 0 ? void 0 : filters.offset;
                }
            }
            return this.builder.getAll(this.modelName, getConfig);
        };
        this.find = async (filter)=>{
            const { params , includeUnpublished =false , includeRefs =false , locale  } = filter || {};
            const { url , modelId  } = params || {};
            const query = {
                userAttributes: {},
                includeRefs,
                options: {
                    includeUnpublished,
                    noTargeting: false,
                    locale
                }
            };
            if (url) {
                query.userAttributes.urlPath = url;
            }
            if (locale) {
                query.userAttributes.locale = locale;
            }
            if (modelId) {
                query.entry = modelId;
            }
            const data = await this.builder.get(this.modelName, query).toPromise() || null;
            return data;
        };
        this.findByIds = async (ids)=>{
            return this.findAll({
                includeUnpublished: false,
                filters: {
                    extra: {
                        id: {
                            $in: ids
                        }
                    }
                },
                includeRefs: true
            });
        };
        this.findNextById = async (id, createdDate)=>{
            const articles = await this.findAll({
                filters: {
                    limit: 1,
                    offset: 0,
                    extra: {
                        createdDate: {
                            $gt: createdDate
                        },
                        id: {
                            $ne: id
                        }
                    }
                },
                sort: {
                    createdDate: 1
                }
            });
            return articles[0] || null;
        };
        this.findById = async function(id) {
            let includeUnpublished = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            return _this.find({
                params: {
                    modelId: id
                },
                includeUnpublished
            });
        };
        this.findAllRecursively = async (filter)=>{
            let allPages = await this.findAll(filter);
            if (allPages.length == fetchLimit) {
                var ref;
                allPages = [
                    ...allPages,
                    ...await this.findAllRecursively({
                        ...filter,
                        filters: {
                            ...filter.filters || {},
                            limit: fetchLimit,
                            offset: (((ref = filter.filters) === null || ref === void 0 ? void 0 : ref.offset) || 0) + fetchLimit
                        }
                    })
                ];
            }
            return allPages;
        };
        this.builder = _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* ["default"].init */ .ZP.init(_shared_env__WEBPACK_IMPORTED_MODULE_1__/* .BUILDER_API_KEY */ .uT);
        this.modelName = props.modelName;
    }
}
/* harmony default export */ __webpack_exports__["Z"] = (BaseModel);


/***/ }),

/***/ 71354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _BaseModel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23385);

class BusinessIndustriesModel extends _BaseModel__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z {
    constructor(){
        var _this;
        super({
            modelName: "business-industries"
        }), _this = this;
        this.getAllIndustries = async (param)=>{
            let { locale , includeUnpublished =false , includeDraft =false  } = param;
            const config = {
                options: {
                    includeUnpublished,
                    noTargeting: true
                },
                userAttributes: {
                    locale
                },
                query: {}
            };
            if (locale) {
                config.query.query = {
                    $elemMatch: {
                        property: {
                            $eq: "locale"
                        },
                        value: locale
                    }
                };
            }
            const messages = await this.builder.getAll(this.modelName, config);
            return messages;
        };
        this.getIndustry = async function(id) {
            let includeUnpublished = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            return _this.find({
                params: {
                    modelId: id
                },
                includeUnpublished
            });
        };
    }
}
/* harmony default export */ __webpack_exports__["Z"] = (new BusinessIndustriesModel());


/***/ }),

/***/ 97670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ core_site_WebFooterModel; }
});

// EXTERNAL MODULE: ./shared/env.ts
var env = __webpack_require__(69771);
;// CONCATENATED MODULE: ./models/core-site/CoreSiteBaseModel.ts

class CoreSiteBaseModel {
    constructor(model){
        this.baseURL = "https://cdn.builder.io/api/v3/content/";
        this.model = "";
        this.getURL = ()=>{
            return "".concat(this.baseURL).concat(this.model);
        };
        this.buildQueryString = (params)=>{
            const searchParams = new URLSearchParams({
                apiKey: env/* BUILDER_CORE_API_KEY */.ad
            });
            if (params.locale) {
                searchParams.append("userAttributes.locale", params.locale);
            }
            if (params.limit) {
                searchParams.append("limit", "".concat(params.limit));
            }
            if (params.offset) {
                searchParams.append("limit", "".concat(params.offset));
            }
            return "".concat(this.getURL(), "?").concat(searchParams.toString());
        };
        this.find = async (locale)=>{
            const url = this.buildQueryString({
                locale
            });
            const rs = await fetch(url);
            const builderContent = await rs.json();
            return builderContent.results;
        };
        this.model = model;
    }
}

;// CONCATENATED MODULE: ./models/core-site/WebFooterModel.ts

class WebFooterModel extends CoreSiteBaseModel {
    async getPageFooter(locale) {
        var ref, ref1;
        const footers = await this.find(locale);
        const globalFooter = footers.find((footer)=>footer.name.toLowerCase().startsWith("global"));
        const regionalFooter = footers.find((footer)=>footer.name.toLowerCase().startsWith("regional"));
        return {
            global: (globalFooter === null || globalFooter === void 0 ? void 0 : (ref = globalFooter.data) === null || ref === void 0 ? void 0 : ref.footers) || [],
            regional: (regionalFooter === null || regionalFooter === void 0 ? void 0 : (ref1 = regionalFooter.data) === null || ref1 === void 0 ? void 0 : ref1.footers) || []
        };
    }
    constructor(){
        super("global-footer-structure");
    }
}
/* harmony default export */ var core_site_WebFooterModel = (new WebFooterModel());


/***/ }),

/***/ 93681:
/***/ (function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
const basePath = (/* unused pure expression or super */ null && ( false || ""));
function getDomainLocale(path, locale, locales, domainLocales) {
    if (false) {} else {
        return false;
    }
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 16067:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

"use client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ImageLoaderProps", ({
    enumerable: true,
    get: function() {
        return _imageConfig.ImageLoaderProps;
    }
}));
exports["default"] = Image;
var _extends = (__webpack_require__(12875)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(45871)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(42456)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(99091)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(62991));
var _head = _interop_require_default(__webpack_require__(31675));
var _imageBlurSvg = __webpack_require__(94747);
var _imageConfig = __webpack_require__(63442);
var _imageConfigContext = __webpack_require__(18911);
var _warnOnce = __webpack_require__(55668);
var _imageLoader = _interop_require_default(__webpack_require__(49366));
function Image(_param) {
    var { src , sizes , unoptimized =false , priority =false , loading , className , quality , width , height , fill , style , onLoad , onLoadingComplete , placeholder ="empty" , blurDataURL , layout , objectFit , objectPosition , lazyBoundary , lazyRoot  } = _param, all = _object_without_properties_loose(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "className",
        "quality",
        "width",
        "height",
        "fill",
        "style",
        "onLoad",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL",
        "layout",
        "objectFit",
        "objectPosition",
        "lazyBoundary",
        "lazyRoot"
    ]);
    const configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    const config = (0, _react).useMemo(()=>{
        const c = configEnv || configContext || _imageConfig.imageConfigDefault;
        const allSizes = [
            ...c.deviceSizes,
            ...c.imageSizes
        ].sort((a, b)=>a - b);
        const deviceSizes = c.deviceSizes.sort((a, b)=>a - b);
        return _extends({}, c, {
            allSizes,
            deviceSizes
        });
    }, [
        configContext
    ]);
    let rest = all;
    let loader = rest.loader || _imageLoader.default;
    // Remove property so it's not spread on <img> element
    delete rest.loader;
    if ("__next_img_default" in loader) {
        // This special value indicates that the user
        // didn't define a "loader" prop or config.
        if (config.loader === "custom") {
            throw new Error('Image with src "'.concat(src, '" is missing "loader" prop.') + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
        }
    } else {
        // The user defined a "loader" prop or config.
        // Since the config object is internal only, we
        // must not pass it to the user-defined "loader".
        const customImageLoader = loader;
        var _tmp;
        _tmp = (obj)=>{
            const { config: _  } = obj, opts = _object_without_properties_loose(obj, [
                "config"
            ]);
            return customImageLoader(opts);
        }, loader = _tmp, _tmp;
    }
    if (layout) {
        if (layout === "fill") {
            fill = true;
        }
        const layoutToStyle = {
            intrinsic: {
                maxWidth: "100%",
                height: "auto"
            },
            responsive: {
                width: "100%",
                height: "auto"
            }
        };
        const layoutToSizes = {
            responsive: "100vw",
            fill: "100vw"
        };
        const layoutStyle = layoutToStyle[layout];
        if (layoutStyle) {
            style = _extends({}, style, layoutStyle);
        }
        const layoutSizes = layoutToSizes[layout];
        if (layoutSizes && !sizes) {
            sizes = layoutSizes;
        }
    }
    let staticSrc = "";
    let widthInt = getInt(width);
    let heightInt = getInt(height);
    let blurWidth;
    let blurHeight;
    if (isStaticImport(src)) {
        const staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        if (!staticImageData.height || !staticImageData.width) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurWidth = staticImageData.blurWidth;
        blurHeight = staticImageData.blurHeight;
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!fill) {
            if (!widthInt && !heightInt) {
                widthInt = staticImageData.width;
                heightInt = staticImageData.height;
            } else if (widthInt && !heightInt) {
                const ratio = widthInt / staticImageData.width;
                heightInt = Math.round(staticImageData.height * ratio);
            } else if (!widthInt && heightInt) {
                const ratio1 = heightInt / staticImageData.height;
                widthInt = Math.round(staticImageData.width * ratio1);
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    let isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if (config.unoptimized) {
        unoptimized = true;
    }
    const [blurComplete, setBlurComplete] = (0, _react).useState(false);
    const [showAltText, setShowAltText] = (0, _react).useState(false);
    const qualityInt = getInt(quality);
    if (false) {}
    const imgStyle = Object.assign(fill ? {
        position: "absolute",
        height: "100%",
        width: "100%",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        objectFit,
        objectPosition
    } : {}, showAltText ? {} : {
        color: "transparent"
    }, style);
    const blurStyle = placeholder === "blur" && blurDataURL && !blurComplete ? {
        backgroundSize: imgStyle.objectFit || "cover",
        backgroundPosition: imgStyle.objectPosition || "50% 50%",
        backgroundRepeat: "no-repeat",
        backgroundImage: 'url("data:image/svg+xml;charset=utf-8,'.concat((0, _imageBlurSvg).getImageBlurSvg({
            widthInt,
            heightInt,
            blurWidth,
            blurHeight,
            blurDataURL
        }), '")')
    } : {};
    if (false) {}
    const imgAttributes = generateImgAttrs({
        config,
        src,
        unoptimized,
        width: widthInt,
        quality: qualityInt,
        sizes,
        loader
    });
    let srcString = src;
    if (false) {}
    const linkProps = {
        // @ts-expect-error upgrade react types to react 18
        imageSrcSet: imgAttributes.srcSet,
        imageSizes: imgAttributes.sizes,
        crossOrigin: rest.crossOrigin
    };
    const onLoadRef = (0, _react).useRef(onLoad);
    (0, _react).useEffect(()=>{
        onLoadRef.current = onLoad;
    }, [
        onLoad
    ]);
    const onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    (0, _react).useEffect(()=>{
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    const imgElementArgs = _extends({
        isLazy,
        imgAttributes,
        heightInt,
        widthInt,
        qualityInt,
        className,
        imgStyle,
        blurStyle,
        loading,
        config,
        fill,
        unoptimized,
        placeholder,
        loader,
        srcString,
        onLoadRef,
        onLoadingCompleteRef,
        setBlurComplete,
        setShowAltText
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs)), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
"use client";
const configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","dangerouslyAllowSVG":false,"unoptimized":false};
const allImgs = new Map();
let perfObserver;
if (false) {}
const VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, sizes) {
    let { deviceSizes , allSizes  } = param;
    if (sizes) {
        // Find all the "vw" percent sizes used in the sizes prop
        const viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        const percentSizes = [];
        for(let match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            const smallestRatio = Math.min(...percentSizes) * 0.01;
            return {
                widths: allSizes.filter((s)=>s >= deviceSizes[0] * smallestRatio),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    const widths = [
        ...new Set(// > are actually 3x in the green color, but only 1.5x in the red and
        // > blue colors. Showing a 3x resolution image in the app vs a 2x
        // > resolution image will be visually the same, though the 3x image
        // > takes significantly more data. Even true 3x resolution screens are
        // > wasteful as the human eye cannot see that level of detail without
        // > something like a magnifying glass.
        // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
        [
            width,
            width * 2 /*, width * 3*/ 
        ].map((w)=>allSizes.find((p)=>p >= w) || allSizes[allSizes.length - 1]))
    ];
    return {
        widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    let { config , src , unoptimized , width , quality , sizes , loader  } = param;
    if (unoptimized) {
        return {
            src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    const { widths , kind  } = getWidths(config, width, sizes);
    const last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map((w, i)=>"".concat(loader({
                config,
                src,
                quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind)).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config,
            src,
            quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number" || typeof x === "undefined") {
        return x;
    }
    if (typeof x === "string" && /^[0-9]+$/.test(x)) {
        return parseInt(x, 10);
    }
    return NaN;
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, placeholder, onLoadRef, onLoadingCompleteRef, setBlurComplete, unoptimized) {
    if (!img || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    const p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(()=>{}).then(()=>{
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadRef == null ? void 0 : onLoadRef.current) {
            // Since we don't have the SyntheticEvent here,
            // we must create one with the same shape.
            // See https://reactjs.org/docs/events.html
            const event = new Event("load");
            Object.defineProperty(event, "target", {
                writable: false,
                value: img
            });
            let prevented = false;
            let stopped = false;
            onLoadRef.current(_extends({}, event, {
                nativeEvent: event,
                currentTarget: img,
                target: img,
                isDefaultPrevented: ()=>prevented,
                isPropagationStopped: ()=>stopped,
                persist: ()=>{},
                preventDefault: ()=>{
                    prevented = true;
                    event.preventDefault();
                },
                stopPropagation: ()=>{
                    stopped = true;
                    event.stopPropagation();
                }
            }));
        }
        if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
            onLoadingCompleteRef.current(img);
        }
        if (false) {}
    });
}
const ImageElement = (_param)=>{
    var { imgAttributes , heightInt , widthInt , qualityInt , className , imgStyle , blurStyle , isLazy , fill , placeholder , loading , srcString , config , unoptimized , loader , onLoadRef , onLoadingCompleteRef , setBlurComplete , setShowAltText , onLoad , onError  } = _param, rest = _object_without_properties_loose(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "fill",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadRef",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setShowAltText",
        "onLoad",
        "onError"
    ]);
    loading = isLazy ? "lazy" : loading;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        width: widthInt,
        height: heightInt,
        decoding: "async",
        "data-nimg": fill ? "fill" : "1",
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading,
        style: _extends({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback((img)=>{
            if (!img) {
                return;
            }
            if (onError) {
                // If the image has an error before react hydrates, then the error is lost.
                // The workaround is to wait until the image is mounted which is after hydration,
                // then we set the src again to trigger the error handler (if there was an error).
                // eslint-disable-next-line no-self-assign
                img.src = img.src;
            }
            if (false) {}
            if (img.complete) {
                handleLoading(img, srcString, placeholder, onLoadRef, onLoadingCompleteRef, setBlurComplete, unoptimized);
            }
        }, [
            srcString,
            placeholder,
            onLoadRef,
            onLoadingCompleteRef,
            setBlurComplete,
            onError,
            unoptimized
        ]),
        onLoad: (event)=>{
            const img = event.currentTarget;
            handleLoading(img, srcString, placeholder, onLoadRef, onLoadingCompleteRef, setBlurComplete, unoptimized);
        },
        onError: (event)=>{
            // if the real image fails to load, this will ensure "alt" is visible
            setShowAltText(true);
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })));
};
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 52780:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

"use client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(45871)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(99091)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(62991));
var _router = __webpack_require__(31163);
var _addLocale = __webpack_require__(11064);
var _routerContext = __webpack_require__(64893);
var _appRouterContext = __webpack_require__(69743);
var _useIntersection = __webpack_require__(73491);
var _getDomainLocale = __webpack_require__(93681);
var _addBasePath = __webpack_require__(27054);
"use client";
const prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch((err)=>{
        if (false) {}
    });
    const curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    const { target  } = event.currentTarget;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    const { nodeName  } = e.currentTarget;
    // anchors inside an svg have a lowercase nodeName
    const isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    const navigate = ()=>{
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow,
                locale,
                scroll
            });
        } else {
            // If `beforePopState` doesn't exist on the router it's the AppRouter.
            const method = replace ? "replace" : "push";
            // Apply `as` if it's provided.
            router[method](as || href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
/**
 * React Component that enables client-side transitions between routes.
 */ const Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) {}
    let children;
    const { href: hrefProp , as: asProp , children: childrenProp , prefetch: prefetchProp , passHref , replace , shallow , scroll , locale , onClick , onMouseEnter , onTouchStart , legacyBehavior =Boolean(true) !== true  } = props, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    const p = prefetchProp !== false;
    let router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    const appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    const { href , as  } = _react.default.useMemo(()=>{
        const [resolvedHref, resolvedAs] = (0, _router).resolveHref(router, hrefProp, true);
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]);
    const previousHref = _react.default.useRef(href);
    const previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    let child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    } else {
        if (false) { var ref; }
    }
    const childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    const [setIntersectionRef, isVisible, resetVisible] = (0, _useIntersection).useIntersection({
        rootMargin: "200px"
    });
    const setRef = _react.default.useCallback((el)=>{
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(()=>{
        const shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        const curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        const isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    const childProps = {
        ref: setRef,
        onClick: (e)=>{
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
            }
        },
        onMouseEnter: (e)=>{
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        },
        onTouchStart: (e)=>{
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        const curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        const localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 73491:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(62991);
var _requestIdleCallback = __webpack_require__(15348);
const hasIntersectionObserver = typeof IntersectionObserver === "function";
const observers = new Map();
const idList = [];
function createObserver(options) {
    const id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    const existing = idList.find((obj)=>obj.root === id.root && obj.margin === id.margin);
    let instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    const elements = new Map();
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            const callback = elements.get(entry.target);
            const isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id,
        observer,
        elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    const { id , observer , elements  } = createObserver(options);
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            const index = idList.findIndex((obj)=>obj.root === id.root && obj.margin === id.margin);
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    let { rootRef , rootMargin , disabled  } = param;
    const isDisabled = disabled || !hasIntersectionObserver;
    const [visible, setVisible] = (0, _react).useState(false);
    const [element, setElement] = (0, _react).useState(null);
    (0, _react).useEffect(()=>{
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                const unobserve = observe(element, (isVisible)=>isVisible && setVisible(isVisible), {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                const idleCallback = (0, _requestIdleCallback).requestIdleCallback(()=>setVisible(true));
                return ()=>(0, _requestIdleCallback).cancelIdleCallback(idleCallback);
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    const resetVisible = (0, _react).useCallback(()=>{
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 69743:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

"use client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(45871)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(62991));
"use client";
const AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
const LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
const GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
const TemplateContext = _react.default.createContext(null);
exports.TemplateContext = TemplateContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 45656:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(12875)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(45871)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(62991));
var _loadable = _interop_require_default(__webpack_require__(75350));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: (param)=>{
            let { error , isLoading , pastDelay  } = param;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 94747:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getImageBlurSvg = getImageBlurSvg;
function getImageBlurSvg(param) {
    let { widthInt , heightInt , blurWidth , blurHeight , blurDataURL  } = param;
    const std = blurWidth && blurHeight ? "1" : "20";
    const svgWidth = blurWidth || widthInt;
    const svgHeight = blurHeight || heightInt;
    const feComponentTransfer = blurDataURL.startsWith("data:image/jpeg") ? "%3CfeComponentTransfer%3E%3CfeFuncA type='discrete' tableValues='1 1'/%3E%3C/feComponentTransfer%3E%" : "";
    if (svgWidth && svgHeight) {
        return "%3Csvg xmlns='http%3A//www.w3.org/2000/svg' viewBox='0 0 ".concat(svgWidth, " ").concat(svgHeight, "'%3E%3Cfilter id='b' color-interpolation-filters='sRGB'%3E%3CfeGaussianBlur stdDeviation='").concat(std, "'/%3E").concat(feComponentTransfer, "%3C/filter%3E%3Cimage preserveAspectRatio='none' filter='url(%23b)' x='0' y='0' height='100%25' width='100%25' href='").concat(blurDataURL, "'/%3E%3C/svg%3E");
    }
    return "%3Csvg xmlns='http%3A//www.w3.org/2000/svg'%3E%3Cimage style='filter:blur(20px)' x='0' y='0' height='100%25' width='100%25' href='".concat(blurDataURL, "'/%3E%3C/svg%3E");
} //# sourceMappingURL=image-blur-svg.js.map


/***/ }),

/***/ 49366:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
function defaultLoader(param) {
    let { config , src , width , quality  } = param;
    if (false) {}
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat(config.path, "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
// We use this to determine if the import is the default loader
// or a custom loader defined by the user in next.config.js
defaultLoader.__next_img_default = true;
var _default = defaultLoader;
exports["default"] = _default; //# sourceMappingURL=image-loader.js.map


/***/ }),

/***/ 91318:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(45871)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(62991));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 75350:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(12875)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(42456)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(62991));
var _loadableContext = __webpack_require__(91318);
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = (0, _react).useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    let ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 13801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/next/app.js
var app = __webpack_require__(41390);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(42132);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(97033);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(56779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(62991);
// EXTERNAL MODULE: ./contexts/NotificationContext.tsx + 1 modules
var NotificationContext = __webpack_require__(74121);
;// CONCATENATED MODULE: ./hook/useBodyResize.ts

const useBodyResize = ()=>{
    const [marginTop, setMarginTop] = (0,react.useState)(0);
    const measuer = (mutations, target)=>{
        mutations.forEach((mutation)=>{
            if (mutation.attributeName === "style") {
                const marginT = Number.parseFloat((target.style.marginTop || "").replace("px", "")) || 0;
                setMarginTop(marginT);
                document.documentElement.style.setProperty("--app-banner-height", "".concat(target.style.marginTop));
            }
        });
    };
    (0,react.useEffect)(()=>{
        const target = document.body;
        if (!target) return;
        const observer = new MutationObserver((mutations)=>measuer(mutations, target));
        observer.observe(target, {
            attributes: true,
            attributeFilter: [
                "style"
            ]
        });
        return ()=>observer.disconnect();
    }, []);
    return {
        marginTop
    };
};

// EXTERNAL MODULE: ./components/business-notification/business-notification.module.scss
var business_notification_module = __webpack_require__(40063);
var business_notification_module_default = /*#__PURE__*/__webpack_require__.n(business_notification_module);
// EXTERNAL MODULE: ./contexts/LayoutContext.tsx
var LayoutContext = __webpack_require__(21513);
;// CONCATENATED MODULE: ./components/business-notification/business-notification.tsx







const Notification = ()=>{
    const { messages , isShowing , theme , setIsShowing , popMessage  } = (0,react.useContext)(NotificationContext/* NotificationCtx */.b);
    const [currentMessage, setCurrentMessage] = (0,react.useState)();
    const notiRef = (0,react.useRef)(null);
    const { marginTop: bodyMarginTop  } = useBodyResize();
    (0,react.useEffect)(()=>{
        if (!theme) return;
        setCurrentMessage(popMessage());
    }, [
        messages,
        theme
    ]);
    const measuer = (0,react.useCallback)(()=>{
        let height = 0;
        if (isShowing) {
            var ref;
            height = ((ref = notiRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect().height) || 0;
        }
        document.documentElement.style.setProperty("--noti-height", "".concat(height + bodyMarginTop, "px"));
    }, [
        isShowing,
        notiRef
    ]);
    (0,react.useEffect)(()=>{
        setIsShowing(!!currentMessage);
    }, [
        currentMessage
    ]);
    (0,react.useEffect)(()=>{
        if (!isShowing) {
            document.documentElement.style.setProperty("--noti-height", "0px");
        }
    }, [
        isShowing
    ]);
    (0,react.useEffect)(()=>{
        if (!notiRef.current) return;
        const target = notiRef.current;
        const observer = new ResizeObserver(measuer);
        observer.observe(target, {
            box: "border-box"
        });
        return ()=>observer.unobserve(target);
    }, [
        measuer
    ]);
    const _onClose = ()=>{
        if (currentMessage && currentMessage.id) {
            localStorage.setItem(currentMessage.id, "".concat(new Date().getTime()));
            setCurrentMessage(undefined);
        }
    };
    const closeable = !(currentMessage === null || currentMessage === void 0 ? void 0 : currentMessage.preventClosing);
    const colors = theme === LayoutContext/* BusinessTheme.BUSINESS_HUB */.E2.BUSINESS_HUB ? currentMessage === null || currentMessage === void 0 ? void 0 : currentMessage.businessHubTheme : currentMessage === null || currentMessage === void 0 ? void 0 : currentMessage.accessTheme;
    if (!theme) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((business_notification_module_default()).container, {
            [(business_notification_module_default()).haveContent]: !!currentMessage
        }),
        style: {
            "--background-color": colors === null || colors === void 0 ? void 0 : colors.background,
            "--text-color": colors === null || colors === void 0 ? void 0 : colors.textColor
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((business_notification_module_default()).box, (business_notification_module_default()).warning, "container"),
            ref: notiRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_notification_module_default()).background
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((business_notification_module_default()).main, {
                        [(business_notification_module_default()).gridOne]: !closeable
                    }),
                    children: [
                        closeable ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}) : null,
                        currentMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (business_notification_module_default()).messageContent,
                            dangerouslySetInnerHTML: {
                                __html: currentMessage.content
                            }
                        }) : null,
                        closeable ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: (business_notification_module_default()).closeButton,
                            onClick: _onClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_notification_module_default()).closeIcon
                            })
                        }) : null
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var business_notification = (Notification);

// EXTERNAL MODULE: ./helpers/LangHelper.ts
var LangHelper = __webpack_require__(77868);
// EXTERNAL MODULE: ./shared/commonPageDetails.ts
var commonPageDetails = __webpack_require__(99829);
// EXTERNAL MODULE: ./shared/env.ts
var env = __webpack_require__(69771);
// EXTERNAL MODULE: ./styles/globals.scss
var globals = __webpack_require__(97039);
;// CONCATENATED MODULE: ./pages/_app.tsx











function BusinessHome(param) {
    let { Component , pageProps , footerItems , categories , businessHubMenuData  } = param;
    var ref, ref1;
    let theme = pageProps === null || pageProps === void 0 ? void 0 : (ref = pageProps.page) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.layout;
    if ((pageProps === null || pageProps === void 0 ? void 0 : pageProps.model) === "business-hub") {
        theme = LayoutContext/* BusinessTheme.BUSINESS_HUB */.E2.BUSINESS_HUB;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1, maximum-scale=5"
                    }),
                    !!pageProps.canonicalUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: pageProps.canonicalUrl
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotificationContext/* NotificationCtxWrapper */.NK, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(business_notification, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutContext/* BusinessLayoutContextWrapper */.AX, {
                        footerItems: footerItems,
                        categories: categories,
                        businessHubMenuData: businessHubMenuData,
                        theme: theme,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                            ...pageProps
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "ga-script",
                dangerouslySetInnerHTML: {
                    __html: "\n                    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n                    })(window,document,'script','dataLayer','".concat(env/* GTM_ID */.Ax, "');")
                }
            })
        ]
    });
}
BusinessHome.getInitialProps = async (context)=>{
    const pageProps = await app["default"].getInitialProps(context); // Retrieves page's `getInitialProps`
    var _slug;
    let querySlug = (_slug = context.router.query.slug) !== null && _slug !== void 0 ? _slug : "";
    if (context.router.asPath.startsWith("/".concat(LangHelper/* Locale.USA */.go.USA))) {
        querySlug = [
            LangHelper/* Locale.USA */.go.USA,
            ...Array.isArray(querySlug) ? querySlug : [
                querySlug
            ]
        ];
    }
    let pageSlug = (0,LangHelper/* stripLocaleFromURL */.e7)(Array.isArray(querySlug) ? querySlug.join("/") : querySlug);
    let lang = querySlug === null || querySlug === void 0 ? void 0 : querySlug[0];
    if (LangHelper/* ALL_BUSINESS_PREFIXES.includes */.OT.includes(pageSlug.replace(/\//g, ""))) {
        pageSlug = "/business/resources";
    }
    let overrideLang = lang;
    if (lang === LangHelper/* Locale.CanadaEnglish */.go.CanadaEnglish) {
        overrideLang = LangHelper/* Locale.USA */.go.USA;
    }
    const { footerItems , categories  } = await (0,commonPageDetails/* getCommonPageDetails */._)(pageSlug, overrideLang);
    const { menuData  } = await (0,commonPageDetails/* getBusinessHubMenu */.i)(overrideLang);
    return {
        ...pageProps,
        footerItems,
        categories,
        businessHubMenuData: menuData
    };
};
/* harmony default export */ var _app = (BusinessHome);


/***/ }),

/***/ 99829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ getCommonPageDetails; },
/* harmony export */   "i": function() { return /* binding */ getBusinessHubMenu; }
/* harmony export */ });
/* harmony import */ var _models_core_site_WebFooterModel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97670);
/* harmony import */ var _builder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21776);
/* harmony import */ var _helpers_BuilderHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31198);
/* harmony import */ var _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77868);
/* harmony import */ var _models_BusinessIndustries__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71354);





const getCommonPageDetails = async (pageSlug, locale, builderPage)=>{
    var ref;
    if (!locale) {
        locale = _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.Australia */ .go.Australia;
    }
    const standardLocale = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .standardizeLocale */ .S2)(locale);
    const canonicalUrl = "".concat((ref = _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .LOCALE_LINKS */ .kV[standardLocale]) === null || ref === void 0 ? void 0 : ref.host, "/").concat(standardLocale).concat(pageSlug);
    const footerItems = await _models_core_site_WebFooterModel__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getPageFooter */ .Z.getPageFooter(standardLocale);
    const categories = await (0,_helpers_BuilderHelper__WEBPACK_IMPORTED_MODULE_2__/* .getAllCategories */ .tG)("id,name,data.isSeries,data.longName");
    if (builderPage) {
        await (0,_builder__WEBPACK_IMPORTED_MODULE_1__/* .awaitBuilderData */ .z$)(builderPage, locale);
    }
    return {
        footerItems,
        categories,
        canonicalUrl
    };
};
const getBusinessHubMenu = async (locale)=>{
    if (!locale) {
        locale = _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.Australia */ .go.Australia;
    }
    const standardLocale = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .standardizeLocale */ .S2)(locale);
    const res = await _models_BusinessIndustries__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getAllIndustries */ .Z.getAllIndustries({
        locale: standardLocale,
        includeUnpublished: false
    });
    const industries = res.filter((item)=>item.published === "published" || item.data.isInPreview).map((item)=>item.data).sort((a, b)=>(b.order || 0) - (a.order || 0)).map((data)=>{
        var ref, ref1, ref2;
        return {
            name: data.name,
            key: "industries-".concat(data.name),
            url: (ref2 = (ref = data.builderPage) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : ref1.data) === null || ref2 === void 0 ? void 0 : ref2.url,
            isInPreview: data.isInPreview
        };
    });
    return {
        menuData: [
            {
                name: "Home",
                key: "home",
                url: "/business"
            },
            {
                name: "Products",
                key: "product",
                url: "/business/products"
            },
            {
                name: "Partners",
                key: "partners",
                url: "/business/partners",
                locale: [
                    _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.USA */ .go.USA,
                    _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.CanadaEnglish */ .go.CanadaEnglish,
                    _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.GreatBritain */ .go.GreatBritain
                ]
            },
            {
                name: "Industries",
                key: "industries",
                childrenItems: industries,
                locale: [
                    _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.Australia */ .go.Australia,
                    _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.NewZealand */ .go.NewZealand
                ]
            },
            {
                name: "Larger businesses",
                key: "larger-businesses",
                url: "/business/larger-businesses",
                locale: [
                    _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.Australia */ .go.Australia,
                    _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.NewZealand */ .go.NewZealand
                ]
            },
            {
                name: "Franchise",
                key: "franchise",
                url: "/business/franchise",
                locale: [
                    _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.Australia */ .go.Australia,
                    _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.NewZealand */ .go.NewZealand
                ]
            },
            {
                name: "Resources",
                key: "business-resources",
                url: "/business/resources",
                locale: [
                    _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.Australia */ .go.Australia,
                    _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.NewZealand */ .go.NewZealand,
                    _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.USA */ .go.USA,
                    _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.CanadaEnglish */ .go.CanadaEnglish
                ],
                childrenItems: [
                    {
                        name: "Afterpay Success Stories",
                        key: "resource_afterpay_success_stories",
                        url: "/business/access/case-studies",
                        locale: [
                            _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.Australia */ .go.Australia,
                            _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.NewZealand */ .go.NewZealand,
                            _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.USA */ .go.USA,
                            _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.CanadaEnglish */ .go.CanadaEnglish
                        ]
                    },
                    {
                        name: "Developer/API Documentation",
                        key: "resource_developer_api_documentation",
                        url: "https://developers.afterpay.com/docs/api/welcome/getting-started",
                        locale: [
                            _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.Australia */ .go.Australia,
                            _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.NewZealand */ .go.NewZealand,
                            _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.USA */ .go.USA,
                            _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.CanadaEnglish */ .go.CanadaEnglish
                        ]
                    },
                    {
                        name: "Industry Partners",
                        key: "resource_industry_partners",
                        url: "/business/resources/industry-partners",
                        locale: [
                            _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.Australia */ .go.Australia
                        ]
                    },
                    {
                        name: "Marketing Resources",
                        key: "resource_marketing_resources",
                        url: "/business/resources/marketing",
                        locale: [
                            _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.Australia */ .go.Australia,
                            _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.NewZealand */ .go.NewZealand,
                            _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.USA */ .go.USA,
                            _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.CanadaEnglish */ .go.CanadaEnglish
                        ]
                    },
                    {
                        name: "Platform Integrations",
                        key: "resource_platform_integrations",
                        url: "/business/platform-integrations",
                        locale: [
                            _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.Australia */ .go.Australia,
                            _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.NewZealand */ .go.NewZealand
                        ]
                    },
                    // {
                    //     name: 'Platform Partners',
                    //     key: 'resource_platform_partners',
                    //     url: '/business/platform-partner',
                    //     locale: [Locale.Australia, Locale.NewZealand],
                    // },
                    {
                        name: "Trade Events",
                        key: "resource_trade_events",
                        url: "/business/trade-activity",
                        locale: [
                            _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.Australia */ .go.Australia,
                            _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.NewZealand */ .go.NewZealand
                        ]
                    },
                    {
                        name: "Training",
                        key: "resource_training",
                        url: "/business/resources/training",
                        locale: [
                            _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.Australia */ .go.Australia,
                            _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.NewZealand */ .go.NewZealand
                        ]
                    },
                    {
                        name: "Visual Merchandise",
                        key: "resource_visual_merchandise",
                        url: "/business/resources/marketing/in-store",
                        locale: [
                            _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.Australia */ .go.Australia,
                            _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.NewZealand */ .go.NewZealand
                        ]
                    }
                ]
            },
            {
                name: "Resources",
                key: "business-resources-gb",
                url: "/business/resources",
                locale: [
                    _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.GreatBritain */ .go.GreatBritain
                ],
                childrenItems: [
                    {
                        name: "Marketing Resources",
                        key: "resource_marketing_resources",
                        url: "/business/resources/marketing",
                        locale: [
                            _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.GreatBritain */ .go.GreatBritain
                        ]
                    },
                    {
                        name: "Developer/API Documentation",
                        key: "resource_developer_api_documentation",
                        url: "https://developers.clearpay.co.uk/clearpay-online/docs/getting-started-with-clearpay-online",
                        locale: [
                            _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.GreatBritain */ .go.GreatBritain
                        ]
                    },
                    {
                        name: "Platform Integrations",
                        key: "resource_platform_integrations",
                        url: "/business/partners",
                        locale: [
                            _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .Locale.GreatBritain */ .go.GreatBritain
                        ]
                    }
                ]
            }
        ]
    };
};


/***/ }),

/***/ 69771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$A": function() { return /* binding */ ALGOLIA_APP_ID; },
/* harmony export */   "Ax": function() { return /* binding */ GTM_ID; },
/* harmony export */   "ad": function() { return /* binding */ BUILDER_CORE_API_KEY; },
/* harmony export */   "uT": function() { return /* binding */ BUILDER_API_KEY; },
/* harmony export */   "vd": function() { return /* binding */ ALGOLIA_API_KEY; }
/* harmony export */ });
const BUILDER_API_KEY = String("035a3d41874344d79b6c7499e2e7a5bc");
const BUILDER_CORE_API_KEY = String("b4f4a2d9d03a447491041054df7592d3");
var ref;
const GTM_ID = (ref = String("GTM-WSSGH66")) !== null && ref !== void 0 ? ref : "";
var ref1;
const ALGOLIA_APP_ID = (ref1 = String("OUHK2JE0WG")) !== null && ref1 !== void 0 ? ref1 : "";
var ref2;
const ALGOLIA_API_KEY = (ref2 = String("4b873c447b42fe096a05f7e189e04a0d")) !== null && ref2 !== void 0 ? ref2 : "";


/***/ }),

/***/ 36224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ CategoryCtx; }
/* harmony export */ });
/* unused harmony export LocationCtx */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62991);

const CategoryCtx = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
const LocationCtx = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});


/***/ }),

/***/ 39289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ MEDIA_RATIO; }
/* harmony export */ });
const MEDIA_RATIO = {
    "1:1": [
        1,
        1
    ],
    "16:9": [
        16,
        9
    ],
    "9:16": [
        9,
        16
    ]
};


/***/ }),

/***/ 23366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ COLORS; }
/* harmony export */ });
var COLORS;
(function(COLORS) {
    COLORS["Mint"] = "Mint";
    COLORS["Black"] = "Black";
    COLORS["White"] = "White";
    COLORS["Grey"] = "Grey";
})(COLORS || (COLORS = {}));


/***/ }),

/***/ 49239:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"b2b-access-hero_container__p4PM9","article":"b2b-access-hero_article__Qgvm4","desktop":"b2b-access-hero_desktop__HRTsB","mobile":"b2b-access-hero_mobile__J3mPp","background":"b2b-access-hero_background___vuEQ","image":"b2b-access-hero_image__wlHkI","content":"b2b-access-hero_content__zaiQH","categories":"b2b-access-hero_categories__KZwI4","subTitle":"b2b-access-hero_subTitle__FgQ_s","title":"b2b-access-hero_title__pkIfI","large":"b2b-access-hero_large___UeH8","description":"b2b-access-hero_description__VkxMH"};

/***/ }),

/***/ 11127:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"threeLinesLimit":"b2b-article-card_threeLinesLimit__IaKt_","articleCard":"b2b-article-card_articleCard__F4z_f","fixedWidth":"b2b-article-card_fixedWidth__nLEPG","articleCardImage":"b2b-article-card_articleCardImage__zMQ_C","articleCardImageWrapper":"b2b-article-card_articleCardImageWrapper__fS_yM","loading":"b2b-article-card_loading__vRYfI","articleCardContentWrapper":"b2b-article-card_articleCardContentWrapper__X74PW","white":"b2b-article-card_white__bzvKl","gray-2":"b2b-article-card_gray-2__8o1Q7","gray-1":"b2b-article-card_gray-1__iNNqN","categoriesList":"b2b-article-card_categoriesList__hFh2n","articleCardContent":"b2b-article-card_articleCardContent__QbetJ","articleCardContentTitle":"b2b-article-card_articleCardContentTitle__TsKcO","articleCardContentDescription":"b2b-article-card_articleCardContentDescription__XqqVa","articleCardButtonReadMore":"b2b-article-card_articleCardButtonReadMore__yCmxk","small":"b2b-article-card_small__p6NYO","large":"b2b-article-card_large__hUXjK","articleCardLink":"b2b-article-card_articleCardLink__MWAwB","video-spin":"b2b-article-card_video-spin__PHGrB","expand":"b2b-article-card_expand__5EiXG"};

/***/ }),

/***/ 8159:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"articleGrid":"b2b-article-grid_articleGrid__TJZX1","articlesContainer":"b2b-article-grid_articlesContainer__8e9__","articleLarge":"b2b-article-grid_articleLarge__7VsG2","buttonLoadMore":"b2b-article-grid_buttonLoadMore__8DkhZ","buttonLoadMoreContent":"b2b-article-grid_buttonLoadMoreContent__77IsL","loading":"b2b-article-grid_loading__6iti5","loaded":"b2b-article-grid_loaded__CK6Tv","spinnerLoadMore":"b2b-article-grid_spinnerLoadMore__PA8ip","video-spin":"b2b-article-grid_video-spin__IkeuL","loadMoreContainer":"b2b-article-grid_loadMoreContainer__mUHkm"};

/***/ }),

/***/ 74522:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"videoWrap":"b2b-card-selected_videoWrap__xQXQj","videoWrapButtonPlay":"b2b-card-selected_videoWrapButtonPlay__Z0QQS","videoContainerWatchNow":"b2b-card-selected_videoContainerWatchNow__9sHl7","videoVideo":"b2b-card-selected_videoVideo__lg0MW","videoOverlay":"b2b-card-selected_videoOverlay__erjRv","videoContainer":"b2b-card-selected_videoContainer__Es_av","videoContainerImageBrand":"b2b-card-selected_videoContainerImageBrand__AHQg_","videoContainerTitle":"b2b-card-selected_videoContainerTitle__qEDP5","videoContainerDescription":"b2b-card-selected_videoContainerDescription__uYsFs","videoLink":"b2b-card-selected_videoLink__kY4Qm","video-spin":"b2b-card-selected_video-spin__UFg7h"};

/***/ }),

/***/ 39440:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"b2b-carousel-lifecycle_container__LNycK","wrapperContent":"b2b-carousel-lifecycle_wrapperContent__mTG_t","title":"b2b-carousel-lifecycle_title__wCNsR","subTitle":"b2b-carousel-lifecycle_subTitle__Z7uL1","listCard":"b2b-carousel-lifecycle_listCard__IKePi","button":"b2b-carousel-lifecycle_button___jgLU"};

/***/ }),

/***/ 47620:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"card-lifecycle_container__7i6_e","link":"card-lifecycle_link__P9Knk","image":"card-lifecycle_image__ICtd_","wrapperContent":"card-lifecycle_wrapperContent__v9Fqv","title":"card-lifecycle_title__DT077","description":"card-lifecycle_description__wO4Ik","button":"card-lifecycle_button__bKiQn"};

/***/ }),

/***/ 65511:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"categoriesList":"b2b-categories_categoriesList__sLHqK","categoryName":"b2b-categories_categoryName__O6BR6","SMALL":"b2b-categories_SMALL__c_ICU","white":"b2b-categories_white__1dC6K"};

/***/ }),

/***/ 51744:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapperCategoryFeature":"b2b-category-feature_wrapperCategoryFeature__GTeza","categoryFeature":"b2b-category-feature_categoryFeature__WxlKf","categoryFeatureContainer":"b2b-category-feature_categoryFeatureContainer__A7gyX","categoryHeader":"b2b-category-feature_categoryHeader__tNUkf","headerText":"b2b-category-feature_headerText__JDtlB","articleCardButtonReadAll":"b2b-category-feature_articleCardButtonReadAll__UzRZf","linkReadAllArticle":"b2b-category-feature_linkReadAllArticle__WaEeu","articleItem":"b2b-category-feature_articleItem__yshJb","categories_categoryName":"b2b-category-feature_categories_categoryName__5j4Z6","articleContainer":"b2b-category-feature_articleContainer__yIzHM","articlesFeature":"b2b-category-feature_articlesFeature__N_mb6","articleTitle":"b2b-category-feature_articleTitle__XaUyk","video-spin":"b2b-category-feature_video-spin__fSfQ6"};

/***/ }),

/***/ 89367:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"b2b-category_container__Z89Fm","item":"b2b-category_item__Fa8A_","light":"b2b-category_light__q6TQ2"};

/***/ }),

/***/ 63841:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"b2b-collapse_container__bOohJ","accordion":"b2b-collapse_accordion__MykzI","active":"b2b-collapse_active__1CHq5","contentContainer":"b2b-collapse_contentContainer__fCXc9","button":"b2b-collapse_button__mmEx3","symbol":"b2b-collapse_symbol__0nYlr","content":"b2b-collapse_content__BLZZq"};

/***/ }),

/***/ 23224:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"communityCard":"b2b-community-card_communityCard__Brign","overlay":"b2b-community-card_overlay__ZVe8_","infoArticle":"b2b-community-card_infoArticle__wawEQ","readMoreBtn":"b2b-community-card_readMoreBtn__302Jm","communityCardWrapper":"b2b-community-card_communityCardWrapper__a1uU9","articleTitle":"b2b-community-card_articleTitle__f4rE7","articleDescription":"b2b-community-card_articleDescription__H8OLq","articleUrl":"b2b-community-card_articleUrl__B3y_c","video-spin":"b2b-community-card_video-spin__MIaH6"};

/***/ }),

/***/ 94215:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"b2b-faq_container__wPjig","content":"b2b-faq_content__p7wAJ","title":"b2b-faq_title__g82pv","description":"b2b-faq_description__UcHoF","wrapperFAQ":"b2b-faq_wrapperFAQ__6r9en","btnViewMore":"b2b-faq_btnViewMore__C4mzV","text":"b2b-faq_text__0L75N","video-spin":"b2b-faq_video-spin___AHpF"};

/***/ }),

/***/ 81794:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"faq-item_container__vfjqY","divider":"faq-item_divider__s6_eD","wrapperQuestion":"faq-item_wrapperQuestion__blFf3","question":"faq-item_question__UgHPx","icon":"faq-item_icon__q6iDC","horizontal":"faq-item_horizontal__Ml4Ke","vertical":"faq-item_vertical__m7_tz","opened":"faq-item_opened__JIPbo","closed":"faq-item_closed__VtWWJ","wrapperAnswer":"faq-item_wrapperAnswer__GOdyL","showAnswer":"faq-item_showAnswer__GHjCK","answer":"faq-item_answer__U1auE","containerExpanded":"faq-item_containerExpanded__buhlI","hidden":"faq-item_hidden__OnoCM"};

/***/ }),

/***/ 90958:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessResourceBlockContainer":"b2b-framed-info-block_businessResourceBlockContainer__qaSDS","businessResourceBlockInfo":"b2b-framed-info-block_businessResourceBlockInfo__JQ5hb","infoTitle":"b2b-framed-info-block_infoTitle__RcHF1","infoDescription":"b2b-framed-info-block_infoDescription__CPAvG","infoCTA":"b2b-framed-info-block_infoCTA__0uViY","businessResourceBlockMediaContainer":"b2b-framed-info-block_businessResourceBlockMediaContainer__WDXSX","businessResourceBlockMedia":"b2b-framed-info-block_businessResourceBlockMedia__OAGvZ","mediaImageWrapper":"b2b-framed-info-block_mediaImageWrapper__t5uhb","box":"b2b-framed-info-block_box__KST8f","main":"b2b-framed-info-block_main__QvMk2","left":"b2b-framed-info-block_left__mMUGG","right":"b2b-framed-info-block_right__Uhd_h","mediaImageBox":"b2b-framed-info-block_mediaImageBox__ICWJv","mediaImageMain":"b2b-framed-info-block_mediaImageMain__KNhrr"};

/***/ }),

/***/ 76800:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"b2b-good-for_container__JDrWC","mobileHide":"b2b-good-for_mobileHide__lXZL9","desktopHide":"b2b-good-for_desktopHide__5uYTn","background":"b2b-good-for_background__0abAm","content":"b2b-good-for_content__oDrVK","section":"b2b-good-for_section__5Ym4V","sectionTitle":"b2b-good-for_sectionTitle__vE7DZ","sectionContent":"b2b-good-for_sectionContent__MqKsL","sectionImage":"b2b-good-for_sectionImage__Gdykh","sectionDescription":"b2b-good-for_sectionDescription__OENa8","sectionButton":"b2b-good-for_sectionButton__zTh1x"};

/***/ }),

/***/ 30770:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headliningArticlesBlock":"b2b-headlining-articles-block_headliningArticlesBlock__E9VaB","swiperButtonNext":"b2b-headlining-articles-block_swiperButtonNext__q_POX","swiperButtonPrev":"b2b-headlining-articles-block_swiperButtonPrev__WjOK9","headliningArticlesBlockSlideLarge":"b2b-headlining-articles-block_headliningArticlesBlockSlideLarge__xdKQ_"};

/***/ }),

/***/ 26557:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"b2b-hero_container__XrA1r","article":"b2b-hero_article__nLQKC","desktop":"b2b-hero_desktop__VMnl9","mobile":"b2b-hero_mobile__jeHNL","background":"b2b-hero_background__5JuY3","image":"b2b-hero_image__6RjJX","content":"b2b-hero_content__L_WLr","categories":"b2b-hero_categories__onUVR","subTitle":"b2b-hero_subTitle__C_umb","title":"b2b-hero_title__NpCBI","large":"b2b-hero_large__x1EaR","description":"b2b-hero_description__TZrHP","button":"b2b-hero_button__lkh4I","text":"b2b-hero_text__nFY87"};

/***/ }),

/***/ 449:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"b2b-integrations_container__CaScz","mobileHide":"b2b-integrations_mobileHide__MG4C9","desktopHide":"b2b-integrations_desktopHide___eemh","content":"b2b-integrations_content__9JjuG","section":"b2b-integrations_section__GSSKR","title":"b2b-integrations_title__cWokx","sectionTitle":"b2b-integrations_sectionTitle__N5S91","sectionLeft":"b2b-integrations_sectionLeft___CO3o","sectionRight":"b2b-integrations_sectionRight__TSmwg","sectionRightContent":"b2b-integrations_sectionRightContent__Yezxm","sectionGrid":"b2b-integrations_sectionGrid__2xQ71","logoGroup":"b2b-integrations_logoGroup__2QEzB","logoTile":"b2b-integrations_logoTile__aUowl","logo":"b2b-integrations_logo___p4H2"};

/***/ }),

/***/ 79042:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"learningCard":"b2b-learning-card_learningCard__fkfZa","learningCardContainer":"b2b-learning-card_learningCardContainer__FgzKR","overlay":"b2b-learning-card_overlay__FBiR1","quantity":"b2b-learning-card_quantity__JlNUU","title":"b2b-learning-card_title__SLBW5","description":"b2b-learning-card_description__STyd5","threeLinesLimit":"b2b-learning-card_threeLinesLimit__V6ybk","btnReadAll":"b2b-learning-card_btnReadAll__Dl0Oq","learningUrl":"b2b-learning-card_learningUrl__e1OCz","video-spin":"b2b-learning-card_video-spin__hA9_n"};

/***/ }),

/***/ 65008:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"seriesCollectionBlock":"b2b-learning-series-block_seriesCollectionBlock__g1CNm","seriesCollectionBlockOrcaPastel":"b2b-learning-series-block_seriesCollectionBlockOrcaPastel__xLBZT","seriesHeader":"b2b-learning-series-block_seriesHeader__XMbyb","title":"b2b-learning-series-block_title__IG657","description":"b2b-learning-series-block_description__MVWJ8","btnViewAll":"b2b-learning-series-block_btnViewAll__AyVOK","btnViewAllMobile":"b2b-learning-series-block_btnViewAllMobile__CMIIo","video-spin":"b2b-learning-series-block_video-spin__fiHGh"};

/***/ }),

/***/ 98851:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"b2b-list-card-resources_container__9Ey40","wrapperContent":"b2b-list-card-resources_wrapperContent__FNcKN","wrapperListNameCard":"b2b-list-card-resources_wrapperListNameCard__jvjGu","nameCard":"b2b-list-card-resources_nameCard__KZobP","wrapperCard":"b2b-list-card-resources_wrapperCard___Zi3w","card":"b2b-list-card-resources_card__IP8JU","cardImage":"b2b-list-card-resources_cardImage__I2dZr","cardContent":"b2b-list-card-resources_cardContent__ruba8","title":"b2b-list-card-resources_title__9Ycjs","description":"b2b-list-card-resources_description__uwzop","readMore":"b2b-list-card-resources_readMore__ohFpl","video-spin":"b2b-list-card-resources_video-spin__y_0EO"};

/***/ }),

/***/ 11301:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"b2b-online-payment-step_container__WNDw8","box":"b2b-online-payment-step_box__G4w1P","text":"b2b-online-payment-step_text__3mzmt","icon":"b2b-online-payment-step_icon__HqQZW","title":"b2b-online-payment-step_title__KlrZ_","description":"b2b-online-payment-step_description__0KBHK","illustration":"b2b-online-payment-step_illustration__unopF","screenImage":"b2b-online-payment-step_screenImage__Nu2y9"};

/***/ }),

/***/ 40144:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"b2b-online-payment_container__mOV8J","background":"b2b-online-payment_background__w4DzK","box":"b2b-online-payment_box__tK3v5","titleBox":"b2b-online-payment_titleBox__1tpbH","title":"b2b-online-payment_title__I2S4K","description":"b2b-online-payment_description__HNcjr","sections":"b2b-online-payment_sections__jMOxi","overlay":"b2b-online-payment_overlay__miBd0","stepContainer":"b2b-online-payment_stepContainer__G8nsc","phoneScreen":"b2b-online-payment_phoneScreen__Y1MH_","phoneFrame":"b2b-online-payment_phoneFrame__YK8DG","phoneScreenBox":"b2b-online-payment_phoneScreenBox__8pyRI","progress":"b2b-online-payment_progress__39kHc","progressItem":"b2b-online-payment_progressItem__an3lM","progressBox":"b2b-online-payment_progressBox__kuwXs","active":"b2b-online-payment_active__JEFiV","flashy":"b2b-online-payment_flashy__v82SJ","sectionContainer":"b2b-online-payment_sectionContainer__EVj67","stepWrapper":"b2b-online-payment_stepWrapper__N78DC","stepBox":"b2b-online-payment_stepBox__hf0QI"};

/***/ }),

/***/ 88474:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"platform-card-item_container__Njci_","logo":"platform-card-item_logo__BySR0","title":"platform-card-item_title__f1yZl","description":"platform-card-item_description__6607X","tileClick":"platform-card-item_tileClick__UI4Q9","learnMore":"platform-card-item_learnMore__ZVr2t","canHover":"platform-card-item_canHover__2o7fa"};

/***/ }),

/***/ 44331:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"b2b-platform_container__GmLVI","wrapperContainer":"b2b-platform_wrapperContainer__zjsJe","header":"b2b-platform_header__i1yFm","subHeader":"b2b-platform_subHeader__ncQWp","wrapperCards":"b2b-platform_wrapperCards___1RqE"};

/***/ }),

/***/ 10434:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"b2b-scrolling-content_container__EypDF","head":"b2b-scrolling-content_head__fKRxh","title":"b2b-scrolling-content_title__aBAIu","description":"b2b-scrolling-content_description__W0RbA","scrolling":"b2b-scrolling-content_scrolling__H_o2A","section":"b2b-scrolling-content_section__O6I7n","left":"b2b-scrolling-content_left__M0npc","number":"b2b-scrolling-content_number__R8Kyd","right":"b2b-scrolling-content_right__wLaPK"};

/***/ }),

/***/ 37606:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"seriesCollectionBlock":"b2b-series-collection-articles-block_seriesCollectionBlock__SGs5d","seriesCollectionBlockwhite":"b2b-series-collection-articles-block_seriesCollectionBlockwhite___r_nb","seriesCollectionBlockgray-2":"b2b-series-collection-articles-block_seriesCollectionBlockgray-2__k41DW","seriesCollectionBlockgray-1":"b2b-series-collection-articles-block_seriesCollectionBlockgray-1__gWwXV","seriesHeader":"b2b-series-collection-articles-block_seriesHeader___ebMr","title":"b2b-series-collection-articles-block_title__D1fKE","description":"b2b-series-collection-articles-block_description__sT53y","btnViewAll":"b2b-series-collection-articles-block_btnViewAll__CPgxi","btnViewAllMobile":"b2b-series-collection-articles-block_btnViewAllMobile__RZvPO","video-spin":"b2b-series-collection-articles-block_video-spin__Z79py"};

/***/ }),

/***/ 56662:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"signUpCard":"b2b-sign-up-card_signUpCard__Z0JV3","backgroundImagePNG":"b2b-sign-up-card_backgroundImagePNG__d8466","title":"b2b-sign-up-card_title__mqyAs","description":"b2b-sign-up-card_description__AVNlo","buttonSubscribe":"b2b-sign-up-card_buttonSubscribe__sRSyE","backgroundImage":"b2b-sign-up-card_backgroundImage__OxKwb","video-spin":"b2b-sign-up-card_video-spin__vTABm"};

/***/ }),

/***/ 44695:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessTrendingTopicsItem":"b2b-trending-topic-item_businessTrendingTopicsItem__McI_r","itemBackground":"b2b-trending-topic-item_itemBackground__668LL","itemDescription":"b2b-trending-topic-item_itemDescription__pPv9e"};

/***/ }),

/***/ 97182:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessTrendingTopicsWrapper":"b2b-trending-topics_businessTrendingTopicsWrapper__bEpmc","businessTrendingTopicsTitle":"b2b-trending-topics_businessTrendingTopicsTitle__qUAXP","businessTrendingTopicsDescription":"b2b-trending-topics_businessTrendingTopicsDescription__dwXqP","businessTrendingTopicsCarousel":"b2b-trending-topics_businessTrendingTopicsCarousel__eo5ZX","carouselButtonNext":"b2b-trending-topics_carouselButtonNext__0djlx","carouselButtonPrev":"b2b-trending-topics_carouselButtonPrev__vfVIx"};

/***/ }),

/***/ 68026:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"b2b-video-card-item_image__Ut8_1","quote":"b2b-video-card-item_quote__9Sehh","discount":"b2b-video-card-item_discount__E5yRN","imageBrand":"b2b-video-card-item_imageBrand__f_o2Q","CTABlock":"b2b-video-card-item_CTABlock__rErKB","quoteContent":"b2b-video-card-item_quoteContent__bDETc","quoteAuthorName":"b2b-video-card-item_quoteAuthorName__kKZw0","singleBlock":"b2b-video-card-item_singleBlock__9kxMY","discountPercent":"b2b-video-card-item_discountPercent__XGftM","discountText":"b2b-video-card-item_discountText__L25Xd","CTABlockContent":"b2b-video-card-item_CTABlockContent__4aqjY","CTABlockUrl":"b2b-video-card-item_CTABlockUrl__n38pr","CTABlockBtn":"b2b-video-card-item_CTABlockBtn__l1acJ"};

/***/ }),

/***/ 81304:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"discountCarousel":"b2b-video-card-list-item_discountCarousel__3TpR7","discountCarouselSlider":"b2b-video-card-list-item_discountCarouselSlider__cQBQ9","discountCarouselSlide":"b2b-video-card-list-item_discountCarouselSlide__Nrdt4","columnSpan":"b2b-video-card-list-item_columnSpan__Sknom","columnSpanQuote":"b2b-video-card-list-item_columnSpanQuote__9Hpyu"};

/***/ }),

/***/ 11193:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"b2b-video-card_container__406uL","videoCard":"b2b-video-card_videoCard__WArMI","media":"b2b-video-card_media__imX2h","ratioBox":"b2b-video-card_ratioBox__863Db","ratioBoxContent":"b2b-video-card_ratioBoxContent__efVrS","background":"b2b-video-card_background__brk_I","mediaContent":"b2b-video-card_mediaContent__FXAfv","playButton":"b2b-video-card_playButton__mbmja","link":"b2b-video-card_link__vvq21","info":"b2b-video-card_info__qBVyq","brand":"b2b-video-card_brand__TjgYs","title":"b2b-video-card_title__lQv1A","description":"b2b-video-card_description__P0z_J","cta":"b2b-video-card_cta__UeQEu"};

/***/ }),

/***/ 18007:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"b2b-video-carousel-quote_container__WR75a","content":"b2b-video-carousel-quote_content__kcwLw","author":"b2b-video-carousel-quote_author___D85R"};

/***/ }),

/***/ 39912:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"b2b-video-carousel_wrapper__9WFLE","background":"b2b-video-carousel_background__0_egp","quoteContainer":"b2b-video-carousel_quoteContainer__plUbR","videoCarousel":"b2b-video-carousel_videoCarousel__EV71S","videoItem":"b2b-video-carousel_videoItem__3_5wy","videoItemContainer":"b2b-video-carousel_videoItemContainer__emWFd","videoItemThumbnailUrl":"b2b-video-carousel_videoItemThumbnailUrl__1skya"};

/***/ }),

/***/ 29960:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"videoList":"b2b-video-list_videoList__Ed7tC","videoListContainer":"b2b-video-list_videoListContainer__LzasJ","videoListHeader":"b2b-video-list_videoListHeader__2umC5","videoListDescriptionText":"b2b-video-list_videoListDescriptionText__KjMiE","videoListHeaderText":"b2b-video-list_videoListHeaderText__Qh6m2","videoListHeaderTextWatchAll":"b2b-video-list_videoListHeaderTextWatchAll__uqqnG","linkWatchAllVideo":"b2b-video-list_linkWatchAllVideo__gPVTf","videoItem":"b2b-video-list_videoItem__jOBKE","videoItemLink":"b2b-video-list_videoItemLink__huFYT","videoItemContainer":"b2b-video-list_videoItemContainer__myOGJ","videoItemImageBrand":"b2b-video-list_videoItemImageBrand__FeB58","videoItemTitle":"b2b-video-list_videoItemTitle___Dijt","videoBlock":"b2b-video-list_videoBlock__3q9jr","video-spin":"b2b-video-list_video-spin__cE8An"};

/***/ }),

/***/ 42316:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"threeLinesLimit":"article-card_threeLinesLimit__prFUq","articleCard":"article-card_articleCard__HFkhe","fixedWidth":"article-card_fixedWidth__vXjkU","articleCardImage":"article-card_articleCardImage__fg3ta","articleCardImageWrapper":"article-card_articleCardImageWrapper__icPpM","loading":"article-card_loading__5rwx9","articleCardContentWrapper":"article-card_articleCardContentWrapper__8r6BV","categoriesList":"article-card_categoriesList__PRHah","articleCardContent":"article-card_articleCardContent___c9mF","articleCardContentTitle":"article-card_articleCardContentTitle__N7OBs","articleCardContentDescription":"article-card_articleCardContentDescription__WBryE","articleCardButtonReadMore":"article-card_articleCardButtonReadMore__CCSn9","small":"article-card_small__QuBQy","large":"article-card_large__tyR2F","articleCardLink":"article-card_articleCardLink__AKN6Y","video-spin":"article-card_video-spin__dgTcO","expand":"article-card_expand__D1L5l"};

/***/ }),

/***/ 74688:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"articleGrid":"article-grid_articleGrid__h5gxn","articlesContainer":"article-grid_articlesContainer__0_Gqg","articleLarge":"article-grid_articleLarge__wKq6N","buttonLoadMore":"article-grid_buttonLoadMore__tOrmA","buttonLoadMoreContent":"article-grid_buttonLoadMoreContent__Clnq0","loading":"article-grid_loading__vRiUm","loaded":"article-grid_loaded___t6kZ","spinnerLoadMore":"article-grid_spinnerLoadMore__tY_1b","video-spin":"article-grid_video-spin__PD195","loadMoreContainer":"article-grid_loadMoreContainer__V0lck"};

/***/ }),

/***/ 84179:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"asset-card_root__fSSO_","content":"asset-card_content___ESDt","imageContainer":"asset-card_imageContainer__cAsr9","image":"asset-card_image__2NH5M","checkbox":"asset-card_checkbox__Ly1x_","pagination":"asset-card_pagination___A6tM","swiperContainer":"asset-card_swiperContainer__HQPc2","black":"asset-card_black__IsRdL","mint":"asset-card_mint__WIag5","white":"asset-card_white__SwNF7"};

/***/ }),

/***/ 31773:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"checkbox-asset-card_root__ofxYS"};

/***/ }),

/***/ 33964:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbContainer":"breadcrumb_breadcrumbContainer__PXHE5","light":"breadcrumb_light__eyy6t","separator":"breadcrumb_separator__0KuRL","dark":"breadcrumb_dark__T0QBm","container":"breadcrumb_container__WEljr","breadcrumb":"breadcrumb_breadcrumb__4T6Pp"};

/***/ }),

/***/ 55746:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessArticleImageContainer":"business-article-image_businessArticleImageContainer__emV0r","businessArticleImageWrapper":"business-article-image_businessArticleImageWrapper__9vYHf","businessArticleImageBox":"business-article-image_businessArticleImageBox__ipbVI","squared":"business-article-image_squared___dFYo","businessArticleImage":"business-article-image_businessArticleImage__oDpQT"};

/***/ }),

/***/ 59891:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessArticleQuoteContainer":"business-article-quote_businessArticleQuoteContainer__McDIe","businessArticleQuoteBackground":"business-article-quote_businessArticleQuoteBackground__rWGmA","small":"business-article-quote_small__5qTK8","medium":"business-article-quote_medium__p7opP","large":"business-article-quote_large__mdKIf","full":"business-article-quote_full__j9L2X","businessArticleQuoteBox":"business-article-quote_businessArticleQuoteBox__fR6xs","light":"business-article-quote_light__G_S35","businessArticleQuote":"business-article-quote_businessArticleQuote__p_mhE","businessArticleAuthorName":"business-article-quote_businessArticleAuthorName__M5qsF"};

/***/ }),

/***/ 59702:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessArticleHeroInfo":"business-article-single-hero-info_businessArticleHeroInfo__RbsAs","simple":"business-article-single-hero-info_simple__mdZLA","categories":"business-article-single-hero-info_categories__eU0aW","title":"business-article-single-hero-info_title__pVjc9","light":"business-article-single-hero-info_light__ApBI_","description":"business-article-single-hero-info_description__Z1i4i","readMoreUrl":"business-article-single-hero-info_readMoreUrl__rgayb"};

/***/ }),

/***/ 34099:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessArticleHeroContainer":"business-article-single-hero_businessArticleHeroContainer__PxQsb","desktop":"business-article-single-hero_desktop__ftWn0","mobile":"business-article-single-hero_mobile__fj2rX","marginLower":"business-article-single-hero_marginLower__cbvWY","isFeatured":"business-article-single-hero_isFeatured__wh2ic","breadcrumb":"business-article-single-hero_breadcrumb__06ELX","businessArticleHeroInfoWrapper":"business-article-single-hero_businessArticleHeroInfoWrapper__k7lhS","businessArticleHeroWrapper":"business-article-single-hero_businessArticleHeroWrapper__FadIx","businessArticleHeroBox":"business-article-single-hero_businessArticleHeroBox__Rgx4O","video-spin":"business-article-single-hero_video-spin__0sBAl"};

/***/ }),

/***/ 34977:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessButtonWrapper":"business-button_businessButtonWrapper__pIUcQ","autoMargin":"business-button_autoMargin__3_aqL","mint":"business-button_mint__6y4PS","plum":"business-button_plum__At5_e","black":"business-button_black__B6eLH","white":"business-button_white__SiDp9","square":"business-button_square__SRK6Y","left":"business-button_left__RzyA2","right":"business-button_right__fYN7J","businessButtonText":"business-button_businessButtonText__LowYs","normal":"business-button_normal__m78de","small":"business-button_small__2bkxC","video-spin":"business-button_video-spin__2u_TY"};

/***/ }),

/***/ 17379:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-collapse_container__gGMhv","accordion":"business-collapse_accordion__yP0_2","active":"business-collapse_active__JvNSY","contentContainer":"business-collapse_contentContainer__WTxTO","button":"business-collapse_button__ZKNyh","symbol":"business-collapse_symbol__Sm6fm","content":"business-collapse_content__Vq3Gj"};

/***/ }),

/***/ 77926:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessEmphasizedTextContainer":"business-emphasized-text_businessEmphasizedTextContainer__q2CWR","businessEmphasizedText":"business-emphasized-text_businessEmphasizedText__GGJGO","light":"business-emphasized-text_light__wU6qh","small":"business-emphasized-text_small__PfCmx"};

/***/ }),

/***/ 87882:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessResourceBlockContainer":"business-framed-info-block_businessResourceBlockContainer__qkdS_","businessResourceBlockInfo":"business-framed-info-block_businessResourceBlockInfo__bBlN7","infoTitle":"business-framed-info-block_infoTitle__3PZEh","infoDescription":"business-framed-info-block_infoDescription__jZiwx","infoCTA":"business-framed-info-block_infoCTA__iMIWh","businessResourceBlockMediaContainer":"business-framed-info-block_businessResourceBlockMediaContainer__ychMr","businessResourceBlockMedia":"business-framed-info-block_businessResourceBlockMedia__rRsIW","mediaImageWrapper":"business-framed-info-block_mediaImageWrapper__HpZsr","box":"business-framed-info-block_box__MKJGo","main":"business-framed-info-block_main__3mDZM","left":"business-framed-info-block_left__dxtBA","right":"business-framed-info-block_right__N_oxX","mediaImageBox":"business-framed-info-block_mediaImageBox__w8M4N","mediaImageMain":"business-framed-info-block_mediaImageMain__1Lqnf","mediaBackground":"business-framed-info-block_mediaBackground__YaFRX"};

/***/ }),

/***/ 58267:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-In-action-carousel_container__CLxkI","wrapperContent":"business-hub-In-action-carousel_wrapperContent__3jS_4","header":"business-hub-In-action-carousel_header__lN9Yp","content":"business-hub-In-action-carousel_content__grMw2","item":"business-hub-In-action-carousel_item__FrAnJ","image":"business-hub-In-action-carousel_image__bZu2k","mobile":"business-hub-In-action-carousel_mobile__1fpek","desktop":"business-hub-In-action-carousel_desktop__aBYzL","wrapperText":"business-hub-In-action-carousel_wrapperText__ySJX0","subTitle":"business-hub-In-action-carousel_subTitle__IzrxE","title":"business-hub-In-action-carousel_title__V_OlD","description":"business-hub-In-action-carousel_description__2Xk9N"};

/***/ }),

/***/ 21922:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-build-for-industry_container__U_514","industriesContainer":"business-hub-build-for-industry_industriesContainer__Qb9Yc","carouselContainer":"business-hub-build-for-industry_carouselContainer__UZsvF","mdHide":"business-hub-build-for-industry_mdHide__Clqlc","industries":"business-hub-build-for-industry_industries__3xGV4","carouselItem":"business-hub-build-for-industry_carouselItem__4D622","active":"business-hub-build-for-industry_active__LLtKn","mobileContainer":"business-hub-build-for-industry_mobileContainer__ItSDy","trustedBrandContainer":"business-hub-build-for-industry_trustedBrandContainer__PB32s","hide":"business-hub-build-for-industry_hide__F2dw3","trustedTitle":"business-hub-build-for-industry_trustedTitle__QKJIW","trustedBrandSlide":"business-hub-build-for-industry_trustedBrandSlide__OtzZs","trustedBrand":"business-hub-build-for-industry_trustedBrand__JUNRm","pagination":"business-hub-build-for-industry_pagination__m5SkB","loadMore":"business-hub-build-for-industry_loadMore__INXFm","loadMoreButton":"business-hub-build-for-industry_loadMoreButton__WtzlH","wordsContainer":"business-hub-build-for-industry_wordsContainer__876Sr","wordsWrapper":"business-hub-build-for-industry_wordsWrapper__4CTAF","isVisible":"business-hub-build-for-industry_isVisible__Qb_S_","push-in":"business-hub-build-for-industry_push-in__ieFKE","isHidden":"business-hub-build-for-industry_isHidden___HNUU","push-out":"business-hub-build-for-industry_push-out__nISDE"};

/***/ }),

/***/ 35618:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"industries-item_container__lFccj","hide":"industries-item_hide__KqWMe","reversed":"industries-item_reversed__OTWwR","content":"industries-item_content__XDDv_","banner":"industries-item_banner__X6Dqx","title":"industries-item_title__hywA5","iconBox":"industries-item_iconBox__TonTS","icon":"industries-item_icon__rn42c","description":"industries-item_description__wtaAg","link":"industries-item_link__kSLG3","bannerOverlay":"industries-item_bannerOverlay__yAlEM","quoteContent":"industries-item_quoteContent__BWg_V","quoteAuthor":"industries-item_quoteAuthor__lEFdR","bannerFooter":"industries-item_bannerFooter__a_eWX","quoteCompany":"industries-item_quoteCompany___Pydr"};

/***/ }),

/***/ 33102:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-carousel-lifecycle_container__nHRQr","wrapperContent":"business-hub-carousel-lifecycle_wrapperContent__Hl_cQ","title":"business-hub-carousel-lifecycle_title__tQRwD","subTitle":"business-hub-carousel-lifecycle_subTitle__tN8VS","listCard":"business-hub-carousel-lifecycle_listCard__hLo12","button":"business-hub-carousel-lifecycle_button__9nLOI"};

/***/ }),

/***/ 39079:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"card-lifecycle_container__xJ_fl","link":"card-lifecycle_link__6DfEk","image":"card-lifecycle_image__hBWG1","wrapperContent":"card-lifecycle_wrapperContent__k5NuC","title":"card-lifecycle_title__yZBmm","description":"card-lifecycle_description__T_nwW","button":"card-lifecycle_button__MP58E"};

/***/ }),

/***/ 4038:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-carousel-product_container__jOXWp","wrapperContent":"business-hub-carousel-product_wrapperContent__6rpiF","header":"business-hub-carousel-product_header__RGDPd","subHeader":"business-hub-carousel-product_subHeader__dRSUF","content":"business-hub-carousel-product_content__I799c","item":"business-hub-carousel-product_item__tnAWI","center":"business-hub-carousel-product_center___A_Zr","left":"business-hub-carousel-product_left__s5cfx","wrappeImage":"business-hub-carousel-product_wrappeImage__PunKZ","wrapperText":"business-hub-carousel-product_wrapperText__ImhXv","right":"business-hub-carousel-product_right__x1Z3U","bottom":"business-hub-carousel-product_bottom__Tlr4k","image":"business-hub-carousel-product_image__2polo","title":"business-hub-carousel-product_title__BTked","description":"business-hub-carousel-product_description__50RT_","learnMore":"business-hub-carousel-product_learnMore__Oh7qy"};

/***/ }),

/***/ 97516:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-faq_container__W6D88","content":"business-hub-faq_content__jXK8q","title":"business-hub-faq_title__y6gDE","description":"business-hub-faq_description__I2oO_","wrapperFAQ":"business-hub-faq_wrapperFAQ__oqs5a","btnViewMore":"business-hub-faq_btnViewMore__Dm5LM","text":"business-hub-faq_text__J_jMV","video-spin":"business-hub-faq_video-spin__nXJar"};

/***/ }),

/***/ 17806:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"faq-item_container__2RUYo","divider":"faq-item_divider__P3a8v","wrapperQuestion":"faq-item_wrapperQuestion__nSc9h","question":"faq-item_question__qO_l_","icon":"faq-item_icon__hakv_","horizontal":"faq-item_horizontal___1wM4","vertical":"faq-item_vertical__wTMGz","opened":"faq-item_opened__mV1UJ","closed":"faq-item_closed__LqSho","wrapperAnswer":"faq-item_wrapperAnswer__eRFDV","showAnswer":"faq-item_showAnswer__aadHk","answer":"faq-item_answer__v6Gc1","containerExpanded":"faq-item_containerExpanded__yhEtJ","hidden":"faq-item_hidden__dInCD"};

/***/ }),

/***/ 96709:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-gateway_container__s3dnz","section":"business-hub-gateway_section__pqZCH","contentBox":"business-hub-gateway_contentBox__u0LGU","headingTitle":"business-hub-gateway_headingTitle__tg2WJ","headingDescription":"business-hub-gateway_headingDescription__ssfoH","contentLeft":"business-hub-gateway_contentLeft__urFBB","parallaxContainer":"business-hub-gateway_parallaxContainer__RGDkv","contentSection":"business-hub-gateway_contentSection__NQpZH","left":"business-hub-gateway_left__Dz8IA","title":"business-hub-gateway_title__6UIag","description":"business-hub-gateway_description__A80qH","learnMore":"business-hub-gateway_learnMore__FHAT_","contentRight":"business-hub-gateway_contentRight__PCVvB","iphoneShellContainer":"business-hub-gateway_iphoneShellContainer__8Oz_M","screen":"business-hub-gateway_screen__7wtcK"};

/***/ }),

/***/ 73123:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-good-for_container__2pFjq","colorMint":"business-hub-good-for_colorMint__TXJD5","mobileHide":"business-hub-good-for_mobileHide__OmqEj","desktopHide":"business-hub-good-for_desktopHide__n33am","background":"business-hub-good-for_background__XvJYB","content":"business-hub-good-for_content__JWEmM","section":"business-hub-good-for_section__l9btW","sectionTitle":"business-hub-good-for_sectionTitle__rJpMx","sectionContent":"business-hub-good-for_sectionContent__72_Ta","sectionImage":"business-hub-good-for_sectionImage__iV0LU","sectionDescription":"business-hub-good-for_sectionDescription__e8buv","sectionButton":"business-hub-good-for_sectionButton__J_3sN"};

/***/ }),

/***/ 10389:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-good-for_container__8tpIP","title":"business-hub-good-for_title__aPb3B","containerBox":"business-hub-good-for_containerBox__EB7OF","absoluteElem":"business-hub-good-for_absoluteElem__wPsrG","colorMint":"business-hub-good-for_colorMint__vBHOM","invisible":"business-hub-good-for_invisible__TABfn","sectionContainer":"business-hub-good-for_sectionContainer__izkjO","section":"business-hub-good-for_section__wlZ7U","sectionBox":"business-hub-good-for_sectionBox__9Poqv","illustrations":"business-hub-good-for_illustrations__CoMyV","illustration":"business-hub-good-for_illustration__ZgKrv","right":"business-hub-good-for_right__CzTQd","list":"business-hub-good-for_list__bjO6h","listTitle":"business-hub-good-for_listTitle__8GSK_","desktop":"business-hub-good-for_desktop__KCg2L","titleCommon":"business-hub-good-for_titleCommon___xeyS","item":"business-hub-good-for_item__SIhcZ"};

/***/ }),

/***/ 43480:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-hero-enterprise_container__46IYM","backgroundImage":"business-hub-hero-enterprise_backgroundImage__xpxeW","backgroundImageMobile":"business-hub-hero-enterprise_backgroundImageMobile__0rbEA","wrapperContent":"business-hub-hero-enterprise_wrapperContent__DzCIb","image":"business-hub-hero-enterprise_image__8FlFo","wrapperContentText":"business-hub-hero-enterprise_wrapperContentText__P4nk9","title":"business-hub-hero-enterprise_title__0n57Q","description":"business-hub-hero-enterprise_description__lpE13","button":"business-hub-hero-enterprise_button__MjqKn","video-spin":"business-hub-hero-enterprise_video-spin__uuCHo"};

/***/ }),

/***/ 2621:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-hero-home_container__qtUF2","videoHero":"business-hub-hero-home_videoHero__yZLAX","loaded":"business-hub-hero-home_loaded__jXVSX","imageHero":"business-hub-hero-home_imageHero__5gSgV","content":"business-hub-hero-home_content__5nBFw","wrapperText":"business-hub-hero-home_wrapperText__XSioJ","title":"business-hub-hero-home_title__hiDyl","description":"business-hub-hero-home_description__U_pMP","btn":"business-hub-hero-home_btn__oHFRC"};

/***/ }),

/***/ 13794:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-hero-industry_container__7ox4J","wrapperContent":"business-hub-hero-industry_wrapperContent__nV94F","wrapperText":"business-hub-hero-industry_wrapperText__8f8ub","contentText":"business-hub-hero-industry_contentText__XRSSR","title":"business-hub-hero-industry_title__ASoL8","description":"business-hub-hero-industry_description__vz9rb","btnHero":"business-hub-hero-industry_btnHero__S_lmK","wrapperImage":"business-hub-hero-industry_wrapperImage__2aJ_p","containerImage":"business-hub-hero-industry_containerImage__iwt7_","item":"business-hub-hero-industry_item__PhehW","video-spin":"business-hub-hero-industry_video-spin__j44ww"};

/***/ }),

/***/ 89097:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-hero-training_container__DKmI6","content":"business-hub-hero-training_content__cyVzg","title":"business-hub-hero-training_title__T1hto","description":"business-hub-hero-training_description__2M97N","button":"business-hub-hero-training_button__UhC_x","backgroundMobile":"business-hub-hero-training_backgroundMobile__p_tM8","background":"business-hub-hero-training_background__wy7Zc","imageRight":"business-hub-hero-training_imageRight__TjY0s","imageImage":"business-hub-hero-training_imageImage__0xe1R"};

/***/ }),

/***/ 56220:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-how-ap-works_container__4ha69","box":"business-hub-how-ap-works_box__OJCeA","background":"business-hub-how-ap-works_background__ssucA","parallaxContainer":"business-hub-how-ap-works_parallaxContainer__UJTs2","title":"business-hub-how-ap-works_title__qNl_G","scrollContent":"business-hub-how-ap-works_scrollContent__UBjqR","section":"business-hub-how-ap-works_section__uHj_a","scrollContentOverlay":"business-hub-how-ap-works_scrollContentOverlay__3f2_i","sectionImage":"business-hub-how-ap-works_sectionImage__rKDex","sectionContent":"business-hub-how-ap-works_sectionContent__xEofQ","sectionContentIcon":"business-hub-how-ap-works_sectionContentIcon__U6IV7","sectionContentIconBox":"business-hub-how-ap-works_sectionContentIconBox__8Srg9","sectionContentDescription":"business-hub-how-ap-works_sectionContentDescription__5t_RK","progress":"business-hub-how-ap-works_progress__nMjlY","progressItem":"business-hub-how-ap-works_progressItem__3XAn1","progressBox":"business-hub-how-ap-works_progressBox__FG2O6","active":"business-hub-how-ap-works_active__JwQrr","flashy":"business-hub-how-ap-works_flashy__veZr9"};

/***/ }),

/***/ 19485:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-how-it-works_container__MKwPp","box":"business-hub-how-it-works_box__JqUNY","background":"business-hub-how-it-works_background__x6KWD","parallaxContainer":"business-hub-how-it-works_parallaxContainer__7xzuo","title":"business-hub-how-it-works_title__QjlLd","scrollContent":"business-hub-how-it-works_scrollContent__crsRL","section":"business-hub-how-it-works_section__N_DwR","scrollContentOverlay":"business-hub-how-it-works_scrollContentOverlay__lGL_b","sectionContent":"business-hub-how-it-works_sectionContent__hwmOg","sectionContentIcon":"business-hub-how-it-works_sectionContentIcon__8D_dM","sectionContentIconBox":"business-hub-how-it-works_sectionContentIconBox__4_cZf","sectionContentDescription":"business-hub-how-it-works_sectionContentDescription__YvnU_","sectionImage":"business-hub-how-it-works_sectionImage__Dgxfa","progress":"business-hub-how-it-works_progress__63jsw","progressItem":"business-hub-how-it-works_progressItem__DA2_u","progressBox":"business-hub-how-it-works_progressBox__Z0Wi5","activeSection":"business-hub-how-it-works_activeSection__glw6u","flashy":"business-hub-how-it-works_flashy__mWwCh"};

/***/ }),

/***/ 82966:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-image-block-full_container__N8VM8","wrapperImage":"business-hub-image-block-full_wrapperImage__sHN6K"};

/***/ }),

/***/ 298:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-image-block_container__fGt1G","backgroundImage":"business-hub-image-block_backgroundImage__NAe0n","wrapperContent":"business-hub-image-block_wrapperContent__bBDDs","bgGray":"business-hub-image-block_bgGray__57wyu","backgroundContent":"business-hub-image-block_backgroundContent__9SlRQ","left":"business-hub-image-block_left__q8BTH","image":"business-hub-image-block_image__tIkWS","wrapperText":"business-hub-image-block_wrapperText__D7_Fz","right":"business-hub-image-block_right__9Q56A","top":"business-hub-image-block_top__DjpqM","topMobile":"business-hub-image-block_topMobile__fjyHP","bottomMobile":"business-hub-image-block_bottomMobile__cfJId","topRight":"business-hub-image-block_topRight__ENWCr","bottom":"business-hub-image-block_bottom__D0iOT","bottomRight":"business-hub-image-block_bottomRight__IPjr7","backgroundLoop":"business-hub-image-block_backgroundLoop__wAGyu","wrapper":"business-hub-image-block_wrapper__Gl4lZ","title":"business-hub-image-block_title___lHY7","description":"business-hub-image-block_description__97oPX","button":"business-hub-image-block_button__WWeGh"};

/***/ }),

/***/ 43859:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-image-hero_container__PHeSm","content":"business-hub-image-hero_content__k8o_B","industryIcon":"business-hub-image-hero_industryIcon__YIL64","title":"business-hub-image-hero_title___jt58","description":"business-hub-image-hero_description__UfBYD","button":"business-hub-image-hero_button__Nrxqp","backgroundMobile":"business-hub-image-hero_backgroundMobile__KEVMi","background":"business-hub-image-hero_background__6sJju","imageRight":"business-hub-image-hero_imageRight__iniX2","imageImage":"business-hub-image-hero_imageImage__MUPeD","desktop":"business-hub-image-hero_desktop__NTydE","mobile":"business-hub-image-hero_mobile__rjZEG"};

/***/ }),

/***/ 29526:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-industries-card-block_container__SQK95","gird":"business-hub-industries-card-block_gird__JUM6_","minHeight":"business-hub-industries-card-block_minHeight__xPpkF","reversed":"business-hub-industries-card-block_reversed__EfMXS","content":"business-hub-industries-card-block_content__O2op_","illustration":"business-hub-industries-card-block_illustration__wA2wX","noPadding":"business-hub-industries-card-block_noPadding__tzptQ","heading":"business-hub-industries-card-block_heading__IKeM4","icon":"business-hub-industries-card-block_icon__MkBLX","text":"business-hub-industries-card-block_text___HBCn","title":"business-hub-industries-card-block_title__apFx9","description":"business-hub-industries-card-block_description__a_Seb","cta":"business-hub-industries-card-block_cta__ElEKO","disableBorder":"business-hub-industries-card-block_disableBorder__hxVwQ","bg":"business-hub-industries-card-block_bg__fCECc","youtube":"business-hub-industries-card-block_youtube__EOX_Y","youtubebox":"business-hub-industries-card-block_youtubebox__jEUyC"};

/***/ }),

/***/ 82812:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-industries-carousel_container___MK9l","mdHide":"business-hub-industries-carousel_mdHide__E9ari","industries":"business-hub-industries-carousel_industries__cM_Sm","carouselItem":"business-hub-industries-carousel_carouselItem__TJNxr","link":"business-hub-industries-carousel_link__KXb77","active":"business-hub-industries-carousel_active__tx1wz"};

/***/ }),

/***/ 54761:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-industries-grid_container__cc3I5","industriesContainer":"business-hub-industries-grid_industriesContainer__VXq87","carouselContainer":"business-hub-industries-grid_carouselContainer__nUvyG","carouselItem":"business-hub-industries-grid_carouselItem__7SUA0","active":"business-hub-industries-grid_active__qlmNo","mobileContainer":"business-hub-industries-grid_mobileContainer__xtVif","trustedBrandContainer":"business-hub-industries-grid_trustedBrandContainer__4n2T1","trustedTitle":"business-hub-industries-grid_trustedTitle__oREny","trustedBrandSlide":"business-hub-industries-grid_trustedBrandSlide__hTLdc","trustedBrand":"business-hub-industries-grid_trustedBrand__1uxtl","loadMore":"business-hub-industries-grid_loadMore__hihw5","loadMoreButton":"business-hub-industries-grid_loadMoreButton__MiyUM","wordsContainer":"business-hub-industries-grid_wordsContainer___4L7G","wordsWrapper":"business-hub-industries-grid_wordsWrapper__HuZDT","isVisible":"business-hub-industries-grid_isVisible__2CEuH","push-in":"business-hub-industries-grid_push-in__uh1Fs","isHidden":"business-hub-industries-grid_isHidden__ieODX","push-out":"business-hub-industries-grid_push-out__uqGvI"};

/***/ }),

/***/ 24680:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"industries-item_container__mWmLE","hide":"industries-item_hide__TSdcC","reversed":"industries-item_reversed__qXTId","content":"industries-item_content__2pFAt","banner":"industries-item_banner__NAGAR","title":"industries-item_title__YZN1d","iconBox":"industries-item_iconBox__57mpF","icon":"industries-item_icon__OKGEY","description":"industries-item_description__4fw44","link":"industries-item_link__zZylV","bannerOverlay":"industries-item_bannerOverlay__pgTN6","quoteContent":"industries-item_quoteContent__qH3Bp","quoteAuthor":"industries-item_quoteAuthor__qdpqL","bannerFooter":"industries-item_bannerFooter__cuu8C","quoteCompany":"industries-item_quoteCompany__1LGHv"};

/***/ }),

/***/ 11644:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-industries-optional-quote_container__MvbQr","desktop":"business-hub-industries-optional-quote_desktop__CZkcv","gird":"business-hub-industries-optional-quote_gird__K704L","reversed":"business-hub-industries-optional-quote_reversed__r6yGr","content":"business-hub-industries-optional-quote_content__SAyIB","illustration":"business-hub-industries-optional-quote_illustration__oaQJT","quote":"business-hub-industries-optional-quote_quote__TXW5m","small":"business-hub-industries-optional-quote_small__olsM5","author":"business-hub-industries-optional-quote_author__Lusgq"};

/***/ }),

/***/ 3187:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-industries-stats_container__9J1Ci","tiles":"business-hub-industries-stats_tiles__5Akpq","tile":"business-hub-industries-stats_tile__CmdJX","icon":"business-hub-industries-stats_icon__EjubH","stats":"business-hub-industries-stats_stats__heSPZ","description":"business-hub-industries-stats_description__rzgdp","disclaimer":"business-hub-industries-stats_disclaimer__k3ws_"};

/***/ }),

/***/ 97403:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-integrations_container__aItn7","mobileHide":"business-hub-integrations_mobileHide__GWkWw","desktopHide":"business-hub-integrations_desktopHide__jUNj7","content":"business-hub-integrations_content__J1zId","section":"business-hub-integrations_section___Pk5f","title":"business-hub-integrations_title__coPUe","sectionTitle":"business-hub-integrations_sectionTitle__B8K4n","sectionLeft":"business-hub-integrations_sectionLeft__kK5mh","sectionRight":"business-hub-integrations_sectionRight__ZxSe8","sectionRightContent":"business-hub-integrations_sectionRightContent__VaFmT","sectionGrid":"business-hub-integrations_sectionGrid__OfXig","logoGroup":"business-hub-integrations_logoGroup__L1LdR","logoTile":"business-hub-integrations_logoTile__wd5ow","logo":"business-hub-integrations_logo__X5W4Y"};

/***/ }),

/***/ 70197:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-list-card-resources_container__ev2Ks","wrapperContent":"business-hub-list-card-resources_wrapperContent__Hyq_H","wrapperListNameCard":"business-hub-list-card-resources_wrapperListNameCard__avJZl","nameCard":"business-hub-list-card-resources_nameCard__sQtwL","wrapperCard":"business-hub-list-card-resources_wrapperCard__h6Ve_","card":"business-hub-list-card-resources_card__FJ7ol","cardImage":"business-hub-list-card-resources_cardImage__uqiIW","cardContent":"business-hub-list-card-resources_cardContent__xGIe5","title":"business-hub-list-card-resources_title__DqH4i","description":"business-hub-list-card-resources_description__hyqjP","readMore":"business-hub-list-card-resources_readMore__hGjzc","video-spin":"business-hub-list-card-resources_video-spin__AsSW4"};

/***/ }),

/***/ 42206:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-list-e-commerce_container__7tAbg","backgroundImage":"business-hub-list-e-commerce_backgroundImage___dr36","content":"business-hub-list-e-commerce_content__ot5KD","wrapper":"business-hub-list-e-commerce_wrapper__Gw0aK","title":"business-hub-list-e-commerce_title__00rh6","wrapperItems":"business-hub-list-e-commerce_wrapperItems__5wR4g","items":"business-hub-list-e-commerce_items__u9IXH","video-spin":"business-hub-list-e-commerce_video-spin__Uuege"};

/***/ }),

/***/ 83630:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"e-commerce-item_container__zcD5u","image":"e-commerce-item_image__qcaYa"};

/***/ }),

/***/ 82939:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-online-payment-step_container__tYMfo","box":"business-hub-online-payment-step_box__y6Ogf","text":"business-hub-online-payment-step_text__fx_84","icon":"business-hub-online-payment-step_icon__mhLJj","title":"business-hub-online-payment-step_title__raGlG","description":"business-hub-online-payment-step_description__gBmAj","illustration":"business-hub-online-payment-step_illustration__d2wBe","screenImage":"business-hub-online-payment-step_screenImage__ezSn2"};

/***/ }),

/***/ 49241:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-online-payment_container__xH_Oe","background":"business-hub-online-payment_background__dyU0S","box":"business-hub-online-payment_box__P9spr","titleBox":"business-hub-online-payment_titleBox__UjU5_","title":"business-hub-online-payment_title__5DCML","description":"business-hub-online-payment_description__pYndg","sections":"business-hub-online-payment_sections__S0chh","overlay":"business-hub-online-payment_overlay__To88R","stepContainer":"business-hub-online-payment_stepContainer__SHS__","phoneScreen":"business-hub-online-payment_phoneScreen__uGLvk","phoneFrame":"business-hub-online-payment_phoneFrame__EwoG7","phoneScreenBox":"business-hub-online-payment_phoneScreenBox__kdKT4","progress":"business-hub-online-payment_progress__ZxgHh","progressItem":"business-hub-online-payment_progressItem__9uj4v","progressBox":"business-hub-online-payment_progressBox__X4L8L","active":"business-hub-online-payment_active__RsquE","flashy":"business-hub-online-payment_flashy__C6EIn","sectionContainer":"business-hub-online-payment_sectionContainer___TTJ5","stepWrapper":"business-hub-online-payment_stepWrapper__6jrxS","stepBox":"business-hub-online-payment_stepBox__n_3dU"};

/***/ }),

/***/ 4154:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-platform-integrations_container__owFWk","backgroundImage":"business-hub-platform-integrations_backgroundImage__eJR_Y","imageContent":"business-hub-platform-integrations_imageContent__KAiBQ","wrapperImage":"business-hub-platform-integrations_wrapperImage__tT6i6","wrapperContent":"business-hub-platform-integrations_wrapperContent__XvJPP","content":"business-hub-platform-integrations_content__ebEwr","title":"business-hub-platform-integrations_title__5uQ20","description":"business-hub-platform-integrations_description__UQIQP","button":"business-hub-platform-integrations_button__EFNXs","video-spin":"business-hub-platform-integrations_video-spin__GF2HY"};

/***/ }),

/***/ 8001:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"platform-card-item_container__yPiHC","logo":"platform-card-item_logo__mBMsQ","title":"platform-card-item_title__3fA6u","description":"platform-card-item_description__2GERo","tileClick":"platform-card-item_tileClick__TZzo_","learnMore":"platform-card-item_learnMore__wpvOE","canHover":"platform-card-item_canHover__sF_gd"};

/***/ }),

/***/ 50735:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-platform_container__eynBx","wrapperContainer":"business-hub-platform_wrapperContainer__0JrXL","header":"business-hub-platform_header__OxU6s","subHeader":"business-hub-platform_subHeader__wIYlz","wrapperCards":"business-hub-platform_wrapperCards__tI59i"};

/***/ }),

/***/ 28079:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-solutions_container__KVxm9","bordered":"business-hub-solutions_bordered__9i3GF","title":"business-hub-solutions_title__xHp8X","contentBox":"business-hub-solutions_contentBox__PLKBd","contentContainer":"business-hub-solutions_contentContainer__Hc3Ho","parallaxContainer":"business-hub-solutions_parallaxContainer__8Nkfa","section":"business-hub-solutions_section__UvlOB","contentOverlay":"business-hub-solutions_contentOverlay__fSz8I","bottom":"business-hub-solutions_bottom__onEVc","sectionRight":"business-hub-solutions_sectionRight__3IrKJ","content":"business-hub-solutions_content__eBvPo","imageMobile":"business-hub-solutions_imageMobile__UzcRk","number":"business-hub-solutions_number__e8_k1","description":"business-hub-solutions_description__bFJ5U","sectionLeft":"business-hub-solutions_sectionLeft__o3EvT","overlayLeft":"business-hub-solutions_overlayLeft__9TTFm","image":"business-hub-solutions_image__slzn1"};

/***/ }),

/***/ 23884:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-trusted-brand_container__vlCYY","background":"business-hub-trusted-brand_background__UgOq5","roundedBottom":"business-hub-trusted-brand_roundedBottom__xPdNl","wrapperContent":"business-hub-trusted-brand_wrapperContent__nOGg5","title":"business-hub-trusted-brand_title__4AxmL","wrapperLogo":"business-hub-trusted-brand_wrapperLogo__ZaYbc","flexWrap":"business-hub-trusted-brand_flexWrap__CSlAS","fullwidth":"business-hub-trusted-brand_fullwidth__zUjfi","logo":"business-hub-trusted-brand_logo__ZC7TL","autoMargin":"business-hub-trusted-brand_autoMargin__pSv_X"};

/***/ }),

/***/ 9410:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-used-by_container__ZlZXd","wrapperContent":"business-hub-used-by_wrapperContent__3kdPR","title":"business-hub-used-by_title__Kh3hP","subTitle":"business-hub-used-by_subTitle__prWGh","listItem":"business-hub-used-by_listItem__H6gag","video-spin":"business-hub-used-by_video-spin__GyV6y"};

/***/ }),

/***/ 5876:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"used-by-item_container__7u8cX","textNumber":"used-by-item_textNumber__zbtF_","subNumber":"used-by-item_subNumber__LsQsP","video-spin":"used-by-item_video-spin__tNDiQ"};

/***/ }),

/***/ 17222:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-video-hero_container__yqUuC","videoHero":"business-hub-video-hero_videoHero__nSqP_","loaded":"business-hub-video-hero_loaded__Saiii","imageHero":"business-hub-video-hero_imageHero__VTkQ4","content":"business-hub-video-hero_content__dHHii","wrapperText":"business-hub-video-hero_wrapperText__A9PW2","title":"business-hub-video-hero_title__mYYPR","description":"business-hub-video-hero_description__7zNHS","btn":"business-hub-video-hero_btn__8v0az"};

/***/ }),

/***/ 40063:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-notification_container__Hj2OW","box":"business-notification_box__tUnpj","background":"business-notification_background__VSnRI","main":"business-notification_main__G_HBy","gridOne":"business-notification_gridOne__okKak","messageContent":"business-notification_messageContent__TS5QN","closeButton":"business-notification_closeButton__EdtFp","closeIcon":"business-notification_closeIcon__rbKxs","haveContent":"business-notification_haveContent__OxZ6j"};

/***/ }),

/***/ 16414:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-asset-grid_root__OeKHa","showDivider":"business-resource-asset-grid_showDivider__fyY3J","titleContainer":"business-resource-asset-grid_titleContainer__BJere","title":"business-resource-asset-grid_title__Uk5nY","button":"business-resource-asset-grid_button__U8c9A","resourceContainer":"business-resource-asset-grid_resourceContainer__YCt_s","resource":"business-resource-asset-grid_resource__Th0jE","downloadButton":"business-resource-asset-grid_downloadButton__qW9K5","description":"business-resource-asset-grid_description__IBZ28","video-spin":"business-resource-asset-grid_video-spin__9Beda"};

/***/ }),

/***/ 77974:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-asset-library_root__SJcYg","tab":"business-resource-asset-library_tab__PUqcq","action":"business-resource-asset-library_action__G9ndZ","buttonResponsive":"business-resource-asset-library_buttonResponsive__4R031","lock":"business-resource-asset-library_lock__DtxcP","buttonContainer":"business-resource-asset-library_buttonContainer___ixBo","leftAction":"business-resource-asset-library_leftAction__8nPYp","dropdownButton":"business-resource-asset-library_dropdownButton__yyD79","chip":"business-resource-asset-library_chip__opwcr"};

/***/ }),

/***/ 73129:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"filter-panel-container_title__V33n8","content":"filter-panel-container_content__RxgWL","root":"filter-panel-container_root__75_GS","reset":"filter-panel-container_reset__QSS0G","keyMessages":"filter-panel-container_keyMessages__b_sFq"};

/***/ }),

/***/ 41280:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"business-resource-asset-single-variant_image__hPIqo","root":"business-resource-asset-single-variant_root__ImqQo","leftBlock":"business-resource-asset-single-variant_leftBlock__S7Ixo","clickable":"business-resource-asset-single-variant_clickable__Rf5Fj","alignCenter":"business-resource-asset-single-variant_alignCenter__FbdWH"};

/***/ }),

/***/ 38032:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-background-text-wrap_root__mrHV7","text":"business-resource-background-text-wrap_text__KHT5j","copyButton":"business-resource-background-text-wrap_copyButton__fAKBV"};

/***/ }),

/***/ 83202:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-banner-carousel_container__LbFFw","withDownloadButton":"business-resource-banner-carousel_withDownloadButton__YVJ2t","content":"business-resource-banner-carousel_content__5PUyC","bannerPreview":"business-resource-banner-carousel_bannerPreview__c_SZq","download":"business-resource-banner-carousel_download__M5o63"};

/***/ }),

/***/ 98328:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-banners_root__Zai6q","resourceContainer":"business-resource-banners_resourceContainer__9hISU","pagePreviewImage":"business-resource-banners_pagePreviewImage__tq_yr"};

/***/ }),

/***/ 29890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessResourceCardWrapper":"business-resource-card_businessResourceCardWrapper__Y0H56","businessResourceCardBackgroundWrapper":"business-resource-card_businessResourceCardBackgroundWrapper__b243L","businessResourceCardBackgroundBox":"business-resource-card_businessResourceCardBackgroundBox__4JdHg","businessResourceCardBackground":"business-resource-card_businessResourceCardBackground__m582E","businessResourceCardOverlayWrapper":"business-resource-card_businessResourceCardOverlayWrapper__DL4Pr","businessResourceCardOverlayTitle":"business-resource-card_businessResourceCardOverlayTitle__PcgRW","businessResourceCardOverlayDescription":"business-resource-card_businessResourceCardOverlayDescription__MVQ6_","businessResourceCardOverlayCTA":"business-resource-card_businessResourceCardOverlayCTA__yA5oV"};

/***/ }),

/***/ 57625:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-centre-hero_container__0PLY5","background":"business-resource-centre-hero_background__v_qRz","title":"business-resource-centre-hero_title__o86a6","filterTitle":"business-resource-centre-hero_filterTitle__vd0Bw"};

/***/ }),

/***/ 1951:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-colour-palette_container__H3skS","primary":"business-resource-colour-palette_primary__0ekr_"};

/***/ }),

/***/ 8315:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"colour-card_container__hNLr4","bordered":"colour-card_bordered__8mgl_","content":"colour-card_content__n5uW5","name":"colour-card_name__mnj79","description":"colour-card_description__XLeAa","colorCode":"colour-card_colorCode__qESXC","copied":"colour-card_copied__aJo6C","copyIcon":"colour-card_copyIcon__K3ahT"};

/***/ }),

/***/ 88874:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-divider_container__PvmEu"};

/***/ }),

/***/ 51082:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-download-button_container__blE1D","tooltip":"business-resource-download-button_tooltip__mcqwi","download":"business-resource-download-button_download__xMRHy","icon":"business-resource-download-button_icon__Zmqox","tooltipArrow":"business-resource-download-button_tooltipArrow__hwCI5","visible":"business-resource-download-button_visible__F8f6F","button":"business-resource-download-button_button__bDvS_","mobileFullWidth":"business-resource-download-button_mobileFullWidth___4_cL","buttonDisable":"business-resource-download-button_buttonDisable___NhMP","video-spin":"business-resource-download-button_video-spin__Uwpuy"};

/***/ }),

/***/ 6703:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-download-card_container__h163f","bordered":"business-resource-download-card_bordered__iYK6_","large":"business-resource-download-card_large__yE7K1","box":"business-resource-download-card_box__FtsZV","downloadContainer":"business-resource-download-card_downloadContainer__f6rAV","tooltip":"business-resource-download-card_tooltip__rf_vr","tooltipArrow":"business-resource-download-card_tooltipArrow__sXT3G","download":"business-resource-download-card_download__Feae3"};

/***/ }),

/***/ 67820:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"box":"business-resource-download-grid_box__GnUTk","downloadButton":"business-resource-download-grid_downloadButton__zAuQP"};

/***/ }),

/***/ 95355:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-faq_container__bBVMQ","itemContainer":"business-resource-faq_itemContainer__DYCsE","question":"business-resource-faq_question__PWyr_","answer":"business-resource-faq_answer__x5JG5"};

/***/ }),

/***/ 39218:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"business-resource-group-label_header__aIuoO","title":"business-resource-group-label_title__LxrFU"};

/***/ }),

/***/ 73042:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessResourceHeroSubWrapper":"business-resource-hero-sub_businessResourceHeroSubWrapper__BM3Co","breadcrumb":"business-resource-hero-sub_breadcrumb__dTCV_","businessResourceHeroSubBreadcrumb":"business-resource-hero-sub_businessResourceHeroSubBreadcrumb__3Uwxs","businessResourceHeroSubBackgroundWrapper":"business-resource-hero-sub_businessResourceHeroSubBackgroundWrapper__wSWoO","box":"business-resource-hero-sub_box__iIvTU","main":"business-resource-hero-sub_main__S2cwn","businessResourceHeroSubOverlayWrapper":"business-resource-hero-sub_businessResourceHeroSubOverlayWrapper__b_KEz","businessResourceHeroSubOverlayTitle":"business-resource-hero-sub_businessResourceHeroSubOverlayTitle__HvTnu","businessResourceHeroSubOverlayDescription":"business-resource-hero-sub_businessResourceHeroSubOverlayDescription__5DT9p"};

/***/ }),

/***/ 65636:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-hiws_root__1KS2M","resourceContainer":"business-resource-hiws_resourceContainer__jh7Xn","pagePreviewImage":"business-resource-hiws_pagePreviewImage__elwYE"};

/***/ }),

/***/ 24083:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"business-resource-image-carousel_image__Nos02"};

/***/ }),

/***/ 45765:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-image-comparison-slider_container__ynDTb","title":"business-resource-image-comparison-slider_title__TtwIk","mask":"business-resource-image-comparison-slider_mask__bQyjt","sliderContainer":"business-resource-image-comparison-slider_sliderContainer__T_aok","do":"business-resource-image-comparison-slider_do__Rsuav","dont":"business-resource-image-comparison-slider_dont__4vzuc","imgCompSlider":"business-resource-image-comparison-slider_imgCompSlider__TQrtw","img":"business-resource-image-comparison-slider_img__ynmPF","imgCompOverlay":"business-resource-image-comparison-slider_imgCompOverlay__PhA8P"};

/***/ }),

/***/ 94993:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-in-situ_root__yVTnt","section":"business-resource-in-situ_section__UDhnZ","title":"business-resource-in-situ_title__sLvRs","previewContainer":"business-resource-in-situ_previewContainer__SCYfv","previewTitle":"business-resource-in-situ_previewTitle__HcGGb","previewImage":"business-resource-in-situ_previewImage__ANBr7","action":"business-resource-in-situ_action__8a0Vf","mobileFullWidth":"business-resource-in-situ_mobileFullWidth__suqcH"};

/***/ }),

/***/ 34405:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-lightbox_root__Iv4Bs","resourceContainer":"business-resource-lightbox_resourceContainer__lt8Wt","pagePreviewImage":"business-resource-lightbox_pagePreviewImage__YjHIN"};

/***/ }),

/***/ 39901:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-link-button_root__2TE3_","disabled":"business-resource-link-button_disabled__A4w15","text":"business-resource-link-button_text__Nz1FS","strong":"business-resource-link-button_strong__hAFyW","icon":"business-resource-link-button_icon__HXms3"};

/***/ }),

/***/ 61073:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-logo-usage_container__3mV5p"};

/***/ }),

/***/ 50955:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"logo-usage-card_container__sMUqR","title":"logo-usage-card_title__TD8_V","image":"logo-usage-card_image__8HtlH"};

/***/ }),

/***/ 17080:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-logos_root__sIPkq","v2":"business-resource-logos_v2__6F6m0","downloadButton":"business-resource-logos_downloadButton__tyvrD","textContent":"business-resource-logos_textContent__KmFM0"};

/***/ }),

/***/ 68861:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-messaging_container__FlGVv","copyIcon":"business-resource-messaging_copyIcon__yK5hx","tooltip":"business-resource-messaging_tooltip__iydZb","visible":"business-resource-messaging_visible__Gey5v","tooltipArrow":"business-resource-messaging_tooltipArrow__CQUuV"};

/***/ }),

/***/ 57739:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-page-title_root__LAaxP","title":"business-resource-page-title_title__6iMBJ","introduction":"business-resource-page-title_introduction__c5kxi","responsive":"business-resource-page-title_responsive__KIrOp"};

/***/ }),

/***/ 89421:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-price-breakdown_container__kBB_c","priceText":"business-resource-price-breakdown_priceText__jhEdt","badge":"business-resource-price-breakdown_badge__M_Egz","reversed":"business-resource-price-breakdown_reversed__ef5sq"};

/***/ }),

/***/ 88068:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessResourceRelatedContainer":"business-image-grid-slider_businessResourceRelatedContainer__mCMbP","businessResourceRelatedTitle":"business-image-grid-slider_businessResourceRelatedTitle__TCpKL","businessResourceRelatedDescription":"business-image-grid-slider_businessResourceRelatedDescription__YQn5q","businessResourceRelatedCarousel":"business-image-grid-slider_businessResourceRelatedCarousel__48vqt","carouselButtonNext":"business-image-grid-slider_carouselButtonNext__uS05c","carouselButtonPrev":"business-image-grid-slider_carouselButtonPrev__GHh3H"};

/***/ }),

/***/ 77663:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessResourceRelatedItemContainer":"business-resource-related-item_businessResourceRelatedItemContainer__vorSJ","businessResourceRelatedItemBackground":"business-resource-related-item_businessResourceRelatedItemBackground__NnceB","box":"business-resource-related-item_box__FZ2IM","main":"business-resource-related-item_main__rlcyn","businessResourceRelatedItemContent":"business-resource-related-item_businessResourceRelatedItemContent__AxbGu","contentTitle":"business-resource-related-item_contentTitle__zVw6J","contentCTA":"business-resource-related-item_contentCTA__aWFlk","video-spin":"business-resource-related-item_video-spin__i2LLQ"};

/***/ }),

/***/ 77417:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-super-text_root__fkd50"};

/***/ }),

/***/ 36690:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-text-highlight_root__DUUP6","headline":"business-resource-text-highlight_headline__U2U9r","text":"business-resource-text-highlight_text__nVAYZ"};

/***/ }),

/***/ 76503:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-text-list_container___Ho28","title":"business-resource-text-list_title__lZK19","item":"business-resource-text-list_item__zYeX5","number":"business-resource-text-list_number__5qQDG","content":"business-resource-text-list_content__KuUrb"};

/***/ }),

/***/ 4709:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-text-wrap_root__8rOyg","left":"business-resource-text-wrap_left__jkNhj","center":"business-resource-text-wrap_center__yrAbq","right":"business-resource-text-wrap_right__xxevY","row":"business-resource-text-wrap_row__XdN2z","caption":"business-resource-text-wrap_caption__oLy4a","content":"business-resource-text-wrap_content__ysUP5","small":"business-resource-text-wrap_small__20jOO","large":"business-resource-text-wrap_large__3_0I4"};

/***/ }),

/***/ 80877:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"business-resource-top-strips_root__h_FKa","container":"business-resource-top-strips_container__nNP1_","item":"business-resource-top-strips_item__DDcmJ","image":"business-resource-top-strips_image__KP5Oi","variant":"business-resource-top-strips_variant__6v9pF","leftBlock":"business-resource-top-strips_leftBlock__qvp4k","variantImage":"business-resource-top-strips_variantImage__efW9v"};

/***/ }),

/***/ 45288:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessResourceTrainingBlockItemContainer":"business-resource-training-block-item_businessResourceTrainingBlockItemContainer__oU3ug","businessResourceTrainingBlockItemBackground":"business-resource-training-block-item_businessResourceTrainingBlockItemBackground__RDqXi","box":"business-resource-training-block-item_box__tMk51","main":"business-resource-training-block-item_main__XhHRL","businessResourceTrainingBlockItemContent":"business-resource-training-block-item_businessResourceTrainingBlockItemContent__6yfOd","contentTitle":"business-resource-training-block-item_contentTitle__lmHP1","contentDescription":"business-resource-training-block-item_contentDescription__KksPc","contentCTA":"business-resource-training-block-item_contentCTA__zgOj2"};

/***/ }),

/***/ 60689:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessResourceTrainingBlockContainer":"business-resource-training-block_businessResourceTrainingBlockContainer__HKoxS","businessResourceTrainingBlockTitle":"business-resource-training-block_businessResourceTrainingBlockTitle__ZjkgP","businessResourceTrainingBlockDescription":"business-resource-training-block_businessResourceTrainingBlockDescription__jaWEA","businessResourceTrainingBlockItems":"business-resource-training-block_businessResourceTrainingBlockItems__8W13t"};

/***/ }),

/***/ 72618:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-typography-review_container__6dKeO","downloadButton":"business-resource-typography-review_downloadButton__rHCTR"};

/***/ }),

/***/ 26082:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"typography-review-card_container__YKvqA","headline":"typography-review-card_headline__VB92J","preview":"typography-review-card_preview__t2ov3","left":"typography-review-card_left__Dt2Lj","right":"typography-review-card_right__0m8aq","font-italic":"typography-review-card_font-italic__hxS_H","font-light":"typography-review-card_font-light___nhdF","font-regular":"typography-review-card_font-regular__4yxxe","font-demibold":"typography-review-card_font-demibold__HzJ6k","font-bold":"typography-review-card_font-bold__OvKr5"};

/***/ }),

/***/ 89689:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-value-block_container__MZ6hr","title":"business-resource-value-block_title__Zr6rE","items":"business-resource-value-block_items__0bxxj","item":"business-resource-value-block_item__wMwgn","backgroundWrapper":"business-resource-value-block_backgroundWrapper__FiBNB","backgroundBox":"business-resource-value-block_backgroundBox__OYnYK","background":"business-resource-value-block_background__w6MxI","itemMask":"business-resource-value-block_itemMask__K6S0E","itemTitle":"business-resource-value-block_itemTitle__vDlfz","itemDescription":"business-resource-value-block_itemDescription__Axh34"};

/***/ }),

/***/ 14734:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"videoList":"business-resource-video-list_videoList__cz5rq","videoListContainer":"business-resource-video-list_videoListContainer__OOWr5","videoListHeader":"business-resource-video-list_videoListHeader__k3jEh","videoListDescriptionText":"business-resource-video-list_videoListDescriptionText__nOLy4","videoListHeaderText":"business-resource-video-list_videoListHeaderText__F7chy","videoListHeaderTextWatchAll":"business-resource-video-list_videoListHeaderTextWatchAll__x2LPR","linkWatchAllVideo":"business-resource-video-list_linkWatchAllVideo__AO_sR","videoItem":"business-resource-video-list_videoItem__8KEIU","videoItemLink":"business-resource-video-list_videoItemLink__w6nKo","videoItemContainer":"business-resource-video-list_videoItemContainer__4LRmg","videoItemImageBrand":"business-resource-video-list_videoItemImageBrand__Am28a","videoItemTitle":"business-resource-video-list_videoItemTitle__Lq9If","videoBlock":"business-resource-video-list_videoBlock__zHIzV","video-spin":"business-resource-video-list_video-spin__qJKeH"};

/***/ }),

/***/ 73633:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessTextCaptionContainer":"business-text-caption_businessTextCaptionContainer__91a1S","businessTextCaption":"business-text-caption_businessTextCaption__PYuih"};

/***/ }),

/***/ 86151:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessTextWrapContainer":"business-text-wrap_businessTextWrapContainer__sc5Wj","businessTextWrap":"business-text-wrap_businessTextWrap__HYfjO","light":"business-text-wrap_light__Dez9U"};

/***/ }),

/***/ 88790:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessTrendingTopicsItem":"business-trending-topic-item_businessTrendingTopicsItem__DzHWe","itemBackground":"business-trending-topic-item_itemBackground__JdANv","itemDescription":"business-trending-topic-item_itemDescription__u0CoN"};

/***/ }),

/***/ 54753:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessTrendingTopicsWrapper":"business-trending-topics_businessTrendingTopicsWrapper__sjPKq","businessTrendingTopicsTitle":"business-trending-topics_businessTrendingTopicsTitle__HrWFI","businessTrendingTopicsDescription":"business-trending-topics_businessTrendingTopicsDescription__fuPp_","businessTrendingTopicsCarousel":"business-trending-topics_businessTrendingTopicsCarousel__qCf68","carouselButtonNext":"business-trending-topics_carouselButtonNext__kWk7t","carouselButtonPrev":"business-trending-topics_carouselButtonPrev__YA8H6"};

/***/ }),

/***/ 57654:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessVimeoEmbedContainer":"business-vimeo-embed_businessVimeoEmbedContainer__nrNJL","vimeoVideo":"business-vimeo-embed_vimeoVideo__t5ZgB","video-controls":"business-vimeo-embed_video-controls__7U__8","full-iframe":"business-vimeo-embed_full-iframe__e3qGV","buttonPlayCustom":"business-vimeo-embed_buttonPlayCustom__Sr78d","pause":"business-vimeo-embed_pause__mKjLv","video-controls__btnPlayPause":"business-vimeo-embed_video-controls__btnPlayPause__C5sH2","play":"business-vimeo-embed_play__wkcFk","video-controls__btnMuted":"business-vimeo-embed_video-controls__btnMuted__dISnd","video-controls__btnTopRight":"business-vimeo-embed_video-controls__btnTopRight__Zacph","icon-back":"business-vimeo-embed_icon-back__egClp","icon-close":"business-vimeo-embed_icon-close__zXPz7"};

/***/ }),

/***/ 36242:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"businessYoutubeEmbedContainer":"business-youtube-embed_businessYoutubeEmbedContainer__va9Ky","margin0":"business-youtube-embed_margin0__Wcz2D","autoHeight":"business-youtube-embed_autoHeight__X7Z4o","youtubeVideo":"business-youtube-embed_youtubeVideo__7qktS"};

/***/ }),

/***/ 51635:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"c-video-container":"business-video-player_c-video-container__42A6_","c-video":"business-video-player_c-video__D3fet","c-video-loader":"business-video-player_c-video-loader__9Vg2i","video-spin":"business-video-player_video-spin__jT0NK","c-video-loading":"business-video-player_c-video-loading___f27b","video-controls":"business-video-player_video-controls__oVSCr","show":"business-video-player_show__snOSZ","video-controls__btnPlayPause":"business-video-player_video-controls__btnPlayPause__E0n85","play":"business-video-player_play__Umdlf","video-controls__btnMuted":"business-video-player_video-controls__btnMuted__3iVH9","video-controls__btnTopRight":"business-video-player_video-controls__btnTopRight__whtIP","icon-back":"business-video-player_icon-back___1rL3","icon-close":"business-video-player_icon-close__zibQc","buttonPlay":"business-video-player_buttonPlay__2EBPW","controlOverLay":"business-video-player_controlOverLay__VikfG","hide":"business-video-player_hide__EcPEi"};

/***/ }),

/***/ 68625:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"categoriesList":"categories_categoriesList__oIEue","categoryName":"categories_categoryName__p1rIr","SMALL":"categories_SMALL__ljgjZ","white":"categories_white__ursPF"};

/***/ }),

/***/ 40267:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"categoryFeature":"category-feature_categoryFeature__ajHIo","categoryFeatureContainer":"category-feature_categoryFeatureContainer__KLfNi","categoryHeader":"category-feature_categoryHeader__bw_B1","headerText":"category-feature_headerText__iVj3s","articleCardButtonReadAll":"category-feature_articleCardButtonReadAll__1ujqe","linkReadAllArticle":"category-feature_linkReadAllArticle__zBp9z","articleItem":"category-feature_articleItem__nYjKM","articleContainer":"category-feature_articleContainer__51JRL","articleTitle":"category-feature_articleTitle__EWI13","articlesFeature":"category-feature_articlesFeature__v3Xia","video-spin":"category-feature_video-spin__E1eBq"};

/***/ }),

/***/ 44184:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"categoryFilter":"category-filter_categoryFilter__F_OO4","filterButton":"category-filter_filterButton__NHaXZ","filterIconDown":"category-filter_filterIconDown__xk2Wn","close":"category-filter_close__tyvrf","categories":"category-filter_categories__v8HZt","open":"category-filter_open__MIMNv","categoriesList":"category-filter_categoriesList__OG8zb","categoryName":"category-filter_categoryName__irctx","checked":"category-filter_checked__C6PCV"};

/***/ }),

/***/ 59529:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"categoryHero":"category-hero_categoryHero__kMcFU","breadcrumb":"category-hero_breadcrumb__1N_HC","categoryHeroBackground":"category-hero_categoryHeroBackground__euo6l","breadcrumbs":"category-hero_breadcrumbs__nSw__","categoryHeroBackgroundCover":"category-hero_categoryHeroBackgroundCover__ufVX0","categoryHeroBackgroundOrcaPastel":"category-hero_categoryHeroBackgroundOrcaPastel__pfx1q","categoryHeroBackgroundBlum":"category-hero_categoryHeroBackgroundBlum__0i4Yg","categoryName":"category-hero_categoryName__IpP6L","categoryDescription":"category-hero_categoryDescription__xo2PS","categoryFilter":"category-hero_categoryFilter__1LjhT"};

/***/ }),

/***/ 62594:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"checkbox_root__HSVjp","checkbox":"checkbox_checkbox__uXwIZ","checked":"checkbox_checked__zPoMa","inner":"checkbox_inner__mSZRi","antCheckboxEffect":"checkbox_antCheckboxEffect__tX3Xm","input":"checkbox_input__8OHRc"};

/***/ }),

/***/ 52923:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"chip_root__rwP_Y","icon":"chip_icon__ncd6E"};

/***/ }),

/***/ 54997:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"communityCard":"community-card_communityCard__OLx7x","overlay":"community-card_overlay__d5yN1","infoArticle":"community-card_infoArticle__kQmBS","readMoreBtn":"community-card_readMoreBtn__dWXL5","communityCardWrapper":"community-card_communityCardWrapper__SLuN2","articleTitle":"community-card_articleTitle__7cNg7","articleDescription":"community-card_articleDescription__pHu83","articleUrl":"community-card_articleUrl__nIRA3","video-spin":"community-card_video-spin__NPf6S"};

/***/ }),

/***/ 12876:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"copyIcon":"copy-button_copyIcon__ewgb5","tooltip":"copy-button_tooltip__g5mbt","visible":"copy-button_visible__o9z4D","tooltipArrow":"copy-button_tooltipArrow__fU5sS"};

/***/ }),

/***/ 48313:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headliningArticlesBlock":"headlining-articles-block_headliningArticlesBlock__VhMOT","swiperButtonNext":"headlining-articles-block_swiperButtonNext__ZJJIm","swiperButtonPrev":"headlining-articles-block_swiperButtonPrev__dFq_F","headliningArticlesBlockSlideLarge":"headlining-articles-block_headliningArticlesBlockSlideLarge__06vMP"};

/***/ }),

/***/ 8278:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"c-background-zoom":"image-zoom_c-background-zoom__Jqb_5","image-box":"image-zoom_image-box__U95yM","image-main":"image-zoom_image-main__OIogD"};

/***/ }),

/***/ 32016:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"button_root__ymWO5","selected":"button_selected__KFyxU"};

/***/ }),

/***/ 4722:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"swiperContainer":"inlined-multi-select_swiperContainer__Wu8dw","root":"inlined-multi-select_root__v8adK"};

/***/ }),

/***/ 30853:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"learningCard":"learning-card_learningCard__S8n5M","learningCardContainer":"learning-card_learningCardContainer__J_KMd","overlay":"learning-card_overlay__CwHY1","quantity":"learning-card_quantity__4sHU9","title":"learning-card_title__Dj2MU","description":"learning-card_description__jUWza","threeLinesLimit":"learning-card_threeLinesLimit__YF7W_","btnReadAll":"learning-card_btnReadAll__LnQ6c","learningUrl":"learning-card_learningUrl__nKSmo","video-spin":"learning-card_video-spin__tVe81"};

/***/ }),

/***/ 86314:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"seriesCollectionBlock":"learning-series-block_seriesCollectionBlock__TlNkB","seriesCollectionBlockOrcaPastel":"learning-series-block_seriesCollectionBlockOrcaPastel__HSEer","seriesHeader":"learning-series-block_seriesHeader___SyiO","title":"learning-series-block_title__4GAPw","description":"learning-series-block_description___5BNs","btnViewAll":"learning-series-block_btnViewAll__lq1iH","video-spin":"learning-series-block_video-spin__X25cp"};

/***/ }),

/***/ 33171:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal_modal__CPpAi","content":"modal_content__byEdw","header":"modal_header__t094_","title":"modal_title__qc2iA","closeButton":"modal_closeButton__AIwjt","footer":"modal_footer__uEHce"};

/***/ }),

/***/ 86154:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"numericalListContainer":"numerical-highlight-list_numericalListContainer__E9RlT","numericalHeading":"numerical-highlight-list_numericalHeading__VbkcE","numericalList":"numerical-highlight-list_numericalList__TLawN","numericalWrapper":"numerical-highlight-list_numericalWrapper__NC635","numericalTitle":"numerical-highlight-list_numericalTitle__w4q4m","numericalDescription":"numerical-highlight-list_numericalDescription__crZ1C","numericalItem":"numerical-highlight-list_numericalItem__hvrs9"};

/***/ }),

/***/ 98133:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"outlined-button_root__FoVZ3"};

/***/ }),

/***/ 77270:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"ratio-image_root__lp_z8","imageContainer":"ratio-image_imageContainer__QWedH","image":"ratio-image_image__AJGSH"};

/***/ }),

/***/ 24448:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"seriesCollectionBlock":"series-collection-articles-block_seriesCollectionBlock__62AUu","seriesCollectionBlockOrcaPastel":"series-collection-articles-block_seriesCollectionBlockOrcaPastel__hykKZ","seriesHeader":"series-collection-articles-block_seriesHeader__CY27E","title":"series-collection-articles-block_title__JfGSK","description":"series-collection-articles-block_description__e_Wmo","btnViewAll":"series-collection-articles-block_btnViewAll__XJD3K","video-spin":"series-collection-articles-block_video-spin__OtpDv"};

/***/ }),

/***/ 71170:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"signUpCard":"sign-up-card_signUpCard__ZOF8_","backgroundImagePNG":"sign-up-card_backgroundImagePNG__me5cV","title":"sign-up-card_title__h2wdj","description":"sign-up-card_description__4PAdM","buttonSubscribe":"sign-up-card_buttonSubscribe__tejMp","backgroundImage":"sign-up-card_backgroundImage__iHLpd","video-spin":"sign-up-card_video-spin__ug_iU"};

/***/ }),

/***/ 34494:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"articleCardSkeleton":"article-card-skeleton_articleCardSkeleton__NjLPl","articleCardSkeletonImage":"article-card-skeleton_articleCardSkeletonImage__4BY1w","articleCardSkeletonLeftContent":"article-card-skeleton_articleCardSkeletonLeftContent__ohasg","articleCardSkeletonLeftContentButton":"article-card-skeleton_articleCardSkeletonLeftContentButton__VxQah","articleCardSkeletonLeftContentTitle":"article-card-skeleton_articleCardSkeletonLeftContentTitle__V1ORu","articleCardSkeletonLeftContentDescription":"article-card-skeleton_articleCardSkeletonLeftContentDescription__iRuGz","small":"article-card-skeleton_small__9BU_u"};

/***/ }),

/***/ 43551:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"articleGridSkeleton":"article-grid-skeleton_articleGridSkeleton__2q0XE"};

/***/ }),

/***/ 87:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageSkeleton":"image-skeleton_imageSkeleton__qVtcU","shimmer":"image-skeleton_shimmer__iv_Tj","video-spin":"image-skeleton_video-spin__UZLsz","fadeIn":"image-skeleton_fadeIn__eOp5w"};

/***/ }),

/***/ 37751:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"textSkeleton":"text-skeleton_textSkeleton__4DoZV","shimmer":"text-skeleton_shimmer__sZS7G","video-spin":"text-skeleton_video-spin__HP3Ds","fadeIn":"text-skeleton_fadeIn__YNUIA"};

/***/ }),

/***/ 3253:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"trustpilot-widget-container":"trustpilot-widget_trustpilot-widget-container__5_bmN"};

/***/ }),

/***/ 10715:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"unorderedHighlightListContainer":"unordered-highlight-list_unorderedHighlightListContainer__Hy8FW","unorderedHighlightHeading":"unordered-highlight-list_unorderedHighlightHeading__e4lvM","unorderedHighlightList":"unordered-highlight-list_unorderedHighlightList__q_cUp","unorderedHighlightItem":"unordered-highlight-list_unorderedHighlightItem__dJOul","PLUM":"unordered-highlight-list_PLUM__eczQL"};

/***/ }),

/***/ 29871:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"discountCarouselItemImage":"video-card-item_discountCarouselItemImage__0Mm2x","discountCarouselItemQuote":"video-card-item_discountCarouselItemQuote__xBRti","discountCarouselItemDiscount":"video-card-item_discountCarouselItemDiscount__Nh7AS","discountCarouselItemImageBrand":"video-card-item_discountCarouselItemImageBrand__mbZm9","discountCarouselItemCTABlock":"video-card-item_discountCarouselItemCTABlock__Ysllz","discountCarouselItemQuoteContent":"video-card-item_discountCarouselItemQuoteContent__ivuUC","discountCarouselItemQuoteAuthorName":"video-card-item_discountCarouselItemQuoteAuthorName__pPaA4","singleBlock":"video-card-item_singleBlock__OxXDe","discountCarouselItemDiscountPercent":"video-card-item_discountCarouselItemDiscountPercent__OdELv","discountCarouselItemDiscountText":"video-card-item_discountCarouselItemDiscountText__MQRzp","discountCarouselItemCTABlockContent":"video-card-item_discountCarouselItemCTABlockContent__trnHR","discountCarouselItemCTABlockUrl":"video-card-item_discountCarouselItemCTABlockUrl__HmmAI","discountCarouselItemCTABlockBtn":"video-card-item_discountCarouselItemCTABlockBtn__eVT09"};

/***/ }),

/***/ 55957:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"discountCarousel":"video-card-list-item_discountCarousel__kwHiT","discountCarouselButtonNext":"video-card-list-item_discountCarouselButtonNext__4jtiG","discountCarouselButtonPrev":"video-card-list-item_discountCarouselButtonPrev__8vqaq","discountCarouselSlider":"video-card-list-item_discountCarouselSlider__Opxeq","discountCarouselSlide":"video-card-list-item_discountCarouselSlide__zDP_T","columnSpan":"video-card-list-item_columnSpan__ap0tC","columnSpanQuote":"video-card-list-item_columnSpanQuote__Y2zo3"};

/***/ }),

/***/ 393:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"videoCardSection":"video-card-section_videoCardSection__94WiR"};

/***/ }),

/***/ 56833:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"videoWrap":"video-card-selected_videoWrap__lprrk","videoWrapButtonPlay":"video-card-selected_videoWrapButtonPlay___b5GX","videoContainerWatchNow":"video-card-selected_videoContainerWatchNow__GfkFL","videoVideo":"video-card-selected_videoVideo__MiCyh","videoOverlay":"video-card-selected_videoOverlay__IRa1x","videoContainer":"video-card-selected_videoContainer__HFwGN","videoContainerImageBrand":"video-card-selected_videoContainerImageBrand__pmTbb","videoContainerTitle":"video-card-selected_videoContainerTitle__HRMQB","videoContainerDescription":"video-card-selected_videoContainerDescription__qPgyc","videoLink":"video-card-selected_videoLink__vuMHa","video-spin":"video-card-selected_video-spin___IqDe"};

/***/ }),

/***/ 26775:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"videoCard":"video-card_videoCard__w2EFs","videoCardContainer":"video-card_videoCardContainer__Nfbuf","videoCardInfo":"video-card_videoCardInfo__aRRxW","right":"video-card_right__b7CKQ","infoImageBrand":"video-card_infoImageBrand__g_QOI","infoTitle":"video-card_infoTitle__A9z_e","infoDescription":"video-card_infoDescription__P5EOI","infoCTA":"video-card_infoCTA__elNwC","videoCardMediaContainer":"video-card_videoCardMediaContainer__Ab4oD","left":"video-card_left__p2607","videoCardMedia":"video-card_videoCardMedia__TI1Pi","mediaImageWrapper":"video-card_mediaImageWrapper__q7oGt","mediaImageBox":"video-card_mediaImageBox__z1Y8d","mediaImageMain":"video-card_mediaImageMain__w0iR4","mediaImageLink":"video-card_mediaImageLink__uldB1","mediaImageContainer":"video-card_mediaImageContainer__97Lag","mediaImageContainerButtonPlay":"video-card_mediaImageContainerButtonPlay__87yR9","mediaBackground":"video-card_mediaBackground__oUmov"};

/***/ }),

/***/ 25558:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"videoCarouselQuoteItem":"video-carousel-quote_videoCarouselQuoteItem__upXP7","videoCarouselQuoteItemContent":"video-carousel-quote_videoCarouselQuoteItemContent__M_pF7","videoCarouselQuoteItemAuthorName":"video-carousel-quote_videoCarouselQuoteItemAuthorName__ESigx"};

/***/ }),

/***/ 46223:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"videoCarousel":"video-carousel_videoCarousel__nZN5f","videoCarouselContainer":"video-carousel_videoCarouselContainer__kAcg4","videoCarouselButtonNext":"video-carousel_videoCarouselButtonNext__3v0ZC","videoCarouselButtonPrev":"video-carousel_videoCarouselButtonPrev__5AbQM","videoCarouselQuoteContainer":"video-carousel_videoCarouselQuoteContainer__ri83Y","videoCarouselQuoteContainerDivider":"video-carousel_videoCarouselQuoteContainerDivider__5n3LP","videoItem":"video-carousel_videoItem__4Opoa","videoItemContainer":"video-carousel_videoItemContainer__nAXZ_","videoItemThumbnailUrl":"video-carousel_videoItemThumbnailUrl__fyPRN"};

/***/ }),

/***/ 15719:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"videoHero":"video-hero_videoHero__YBa6n","videoHeroTitle":"video-hero_videoHeroTitle__lo_4t","videoHeroTitleColored":"video-hero_videoHeroTitleColored__ZhBb7","videoHeroDescription":"video-hero_videoHeroDescription__UL0ur","videoHeroContainer":"video-hero_videoHeroContainer__V_Iho","videoHeroContent":"video-hero_videoHeroContent__hhfdd","vimeoVideo":"video-hero_vimeoVideo__pRf_H"};

/***/ }),

/***/ 66130:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 89995:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 4839:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 97039:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 97650:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, defaultFallbackInView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62991);


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const observerMap = new Map();
const RootIds = new WeakMap();
let rootId = 0;
let unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/

function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(key => options[key] !== undefined).map(key => {
    return `${key}_${key === 'root' ? getRootId(options.root) : options[key]}`;
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  let id = optionsToId(options);
  let instance = observerMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    const elements = new Map();
    let thresholds;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        const inView = entry.isIntersecting && thresholds.some(threshold => entry.intersectionRatio >= threshold); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(callback => {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {// Nothing to cleanup
    };
  } // An observer with the same options can be reused, so lets use this fact


  const {
    id,
    observer,
    elements
  } = createObserver(options); // Register the callback listener for this element

  let callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements.delete(element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

const _excluded = (/* unused pure expression or super */ null && (["children", "as", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView", "fallbackInView"]));

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


class InView extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    this.node = null;
    this._unobserveCb = null;

    this.handleNode = node => {
      if (this.node) {
        // Clear the old observer, before we start observing a new element
        this.unobserve();

        if (!node && !this.props.triggerOnce && !this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          this.setState({
            inView: !!this.props.initialInView,
            entry: undefined
          });
        }
      }

      this.node = node ? node : null;
      this.observeNode();
    };

    this.handleChange = (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        this.unobserve();
      }

      if (!isPlainChildren(this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        this.setState({
          inView,
          entry
        });
      }

      if (this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        this.props.onChange(inView, entry);
      }
    };

    this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
  }

  componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }

  componentWillUnmount() {
    this.unobserve();
    this.node = null;
  }

  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold,
      root,
      rootMargin,
      // @ts-ignore
      trackVisibility,
      // @ts-ignore
      delay
    }, fallbackInView);
  }

  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  }

  render() {
    if (!isPlainChildren(this.props)) {
      const {
        inView,
        entry
      } = this.state;
      return this.props.children({
        inView,
        entry,
        ref: this.handleNode
      });
    }

    const _this$props = this.props,
          {
      children,
      as
    } = _this$props,
          props = _objectWithoutPropertiesLoose(_this$props, _excluded);

    return React.createElement(as || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  }

}

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _state$entry;

  const [ref, setRef] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const callback = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView,
    entry: undefined
  }); // Store the onChange callback in a `ref`, so we can access the latest instance
  // inside the `useEffect`, but without triggering a rerender.

  callback.current = onChange;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    // Ensure we have node ref, and that we shouldn't skip observing
    if (skip || !ref) return;
    let unobserve = observe(ref, (inView, entry) => {
      setState({
        inView,
        entry
      });
      if (callback.current) callback.current(inView, entry);

      if (entry.isIntersecting && triggerOnce && unobserve) {
        // If it should only trigger once, unobserve the element after it's inView
        unobserve();
        unobserve = undefined;
      }
    }, {
      root,
      rootMargin,
      threshold,
      // @ts-ignore
      trackVisibility,
      // @ts-ignore
      delay
    }, fallbackInView);
    return () => {
      if (unobserve) {
        unobserve();
      }
    };
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string, so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, ref, root, rootMargin, triggerOnce, skip, trackVisibility, fallbackInView, delay]);
  const entryTarget = (_state$entry = state.entry) == null ? void 0 : _state$entry.target;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (!ref && entryTarget && !triggerOnce && !skip) {
      // If we don't have a node ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView,
        entry: undefined
      });
    }
  }, [ref, entryTarget, triggerOnce, skip, initialInView]);
  const result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}


//# sourceMappingURL=react-intersection-observer.modern.mjs.map


/***/ }),

/***/ 94135:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s5": function() { return /* reexport */ A11y; },
  "pt": function() { return /* reexport */ Autoplay; },
  "xW": function() { return /* reexport */ EffectFade; },
  "Rv": function() { return /* reexport */ freeMode; },
  "W_": function() { return /* reexport */ Navigation; },
  "tl": function() { return /* reexport */ Pagination; },
  "o3": function() { return /* reexport */ Thumb; }
});

// UNUSED EXPORTS: Controller, EffectCards, EffectCoverflow, EffectCreative, EffectCube, EffectFlip, Grid, HashNavigation, History, Keyboard, Manipulation, Mousewheel, Parallax, Scrollbar, Virtual, Zoom

// EXTERNAL MODULE: ./node_modules/swiper/shared/ssr-window.esm.mjs
var ssr_window_esm = __webpack_require__(13433);
// EXTERNAL MODULE: ./node_modules/swiper/shared/utils.mjs
var utils = __webpack_require__(7185);
;// CONCATENATED MODULE: ./node_modules/swiper/modules/virtual.mjs



function Virtual(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  extendParams({
    virtual: {
      enabled: false,
      slides: [],
      cache: true,
      renderSlide: null,
      renderExternal: null,
      renderExternalUpdate: true,
      addSlidesBefore: 0,
      addSlidesAfter: 0
    }
  });
  let cssModeTimeout;
  const document = getDocument();
  swiper.virtual = {
    cache: {},
    from: undefined,
    to: undefined,
    slides: [],
    offset: 0,
    slidesGrid: []
  };
  const tempDOM = document.createElement('div');
  function renderSlide(slide, index) {
    const params = swiper.params.virtual;
    if (params.cache && swiper.virtual.cache[index]) {
      return swiper.virtual.cache[index];
    }
    // eslint-disable-next-line
    let slideEl;
    if (params.renderSlide) {
      slideEl = params.renderSlide.call(swiper, slide, index);
      if (typeof slideEl === 'string') {
        tempDOM.innerHTML = slideEl;
        slideEl = tempDOM.children[0];
      }
    } else if (swiper.isElement) {
      slideEl = createElement('swiper-slide');
    } else {
      slideEl = createElement('div', swiper.params.slideClass);
    }
    slideEl.setAttribute('data-swiper-slide-index', index);
    if (!params.renderSlide) {
      slideEl.innerHTML = slide;
    }
    if (params.cache) {
      swiper.virtual.cache[index] = slideEl;
    }
    return slideEl;
  }
  function update(force, beforeInit) {
    const {
      slidesPerView,
      slidesPerGroup,
      centeredSlides,
      loop: isLoop,
      initialSlide
    } = swiper.params;
    if (beforeInit && !isLoop && initialSlide > 0) {
      return;
    }
    const {
      addSlidesBefore,
      addSlidesAfter
    } = swiper.params.virtual;
    const {
      from: previousFrom,
      to: previousTo,
      slides,
      slidesGrid: previousSlidesGrid,
      offset: previousOffset
    } = swiper.virtual;
    if (!swiper.params.cssMode) {
      swiper.updateActiveIndex();
    }
    const activeIndex = swiper.activeIndex || 0;
    let offsetProp;
    if (swiper.rtlTranslate) offsetProp = 'right';else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
    let slidesAfter;
    let slidesBefore;
    if (centeredSlides) {
      slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
      slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
    } else {
      slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
      slidesBefore = (isLoop ? slidesPerView : slidesPerGroup) + addSlidesBefore;
    }
    let from = activeIndex - slidesBefore;
    let to = activeIndex + slidesAfter;
    if (!isLoop) {
      from = Math.max(from, 0);
      to = Math.min(to, slides.length - 1);
    }
    let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
    if (isLoop && activeIndex >= slidesBefore) {
      from -= slidesBefore;
      if (!centeredSlides) offset += swiper.slidesGrid[0];
    } else if (isLoop && activeIndex < slidesBefore) {
      from = -slidesBefore;
      if (centeredSlides) offset += swiper.slidesGrid[0];
    }
    Object.assign(swiper.virtual, {
      from,
      to,
      offset,
      slidesGrid: swiper.slidesGrid,
      slidesBefore,
      slidesAfter
    });
    function onRendered() {
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();
      emit('virtualUpdate');
    }
    if (previousFrom === from && previousTo === to && !force) {
      if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
        swiper.slides.forEach(slideEl => {
          slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
        });
      }
      swiper.updateProgress();
      emit('virtualUpdate');
      return;
    }
    if (swiper.params.virtual.renderExternal) {
      swiper.params.virtual.renderExternal.call(swiper, {
        offset,
        from,
        to,
        slides: function getSlides() {
          const slidesToRender = [];
          for (let i = from; i <= to; i += 1) {
            slidesToRender.push(slides[i]);
          }
          return slidesToRender;
        }()
      });
      if (swiper.params.virtual.renderExternalUpdate) {
        onRendered();
      } else {
        emit('virtualUpdate');
      }
      return;
    }
    const prependIndexes = [];
    const appendIndexes = [];
    const getSlideIndex = index => {
      let slideIndex = index;
      if (index < 0) {
        slideIndex = slides.length + index;
      } else if (slideIndex >= slides.length) {
        // eslint-disable-next-line
        slideIndex = slideIndex - slides.length;
      }
      return slideIndex;
    };
    if (force) {
      swiper.slides.filter(el => el.matches(`.${swiper.params.slideClass}, swiper-slide`)).forEach(slideEl => {
        slideEl.remove();
      });
    } else {
      for (let i = previousFrom; i <= previousTo; i += 1) {
        if (i < from || i > to) {
          const slideIndex = getSlideIndex(i);
          swiper.slides.filter(el => el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`)).forEach(slideEl => {
            slideEl.remove();
          });
        }
      }
    }
    const loopFrom = isLoop ? -slides.length : 0;
    const loopTo = isLoop ? slides.length * 2 : slides.length;
    for (let i = loopFrom; i < loopTo; i += 1) {
      if (i >= from && i <= to) {
        const slideIndex = getSlideIndex(i);
        if (typeof previousTo === 'undefined' || force) {
          appendIndexes.push(slideIndex);
        } else {
          if (i > previousTo) appendIndexes.push(slideIndex);
          if (i < previousFrom) prependIndexes.push(slideIndex);
        }
      }
    }
    appendIndexes.forEach(index => {
      swiper.slidesEl.append(renderSlide(slides[index], index));
    });
    if (isLoop) {
      for (let i = prependIndexes.length - 1; i >= 0; i -= 1) {
        const index = prependIndexes[i];
        swiper.slidesEl.prepend(renderSlide(slides[index], index));
      }
    } else {
      prependIndexes.sort((a, b) => b - a);
      prependIndexes.forEach(index => {
        swiper.slidesEl.prepend(renderSlide(slides[index], index));
      });
    }
    elementChildren(swiper.slidesEl, '.swiper-slide, swiper-slide').forEach(slideEl => {
      slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
    });
    onRendered();
  }
  function appendSlide(slides) {
    if (typeof slides === 'object' && 'length' in slides) {
      for (let i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.push(slides[i]);
      }
    } else {
      swiper.virtual.slides.push(slides);
    }
    update(true);
  }
  function prependSlide(slides) {
    const activeIndex = swiper.activeIndex;
    let newActiveIndex = activeIndex + 1;
    let numberOfNewSlides = 1;
    if (Array.isArray(slides)) {
      for (let i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
      }
      newActiveIndex = activeIndex + slides.length;
      numberOfNewSlides = slides.length;
    } else {
      swiper.virtual.slides.unshift(slides);
    }
    if (swiper.params.virtual.cache) {
      const cache = swiper.virtual.cache;
      const newCache = {};
      Object.keys(cache).forEach(cachedIndex => {
        const cachedEl = cache[cachedIndex];
        const cachedElIndex = cachedEl.getAttribute('data-swiper-slide-index');
        if (cachedElIndex) {
          cachedEl.setAttribute('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
        }
        newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
      });
      swiper.virtual.cache = newCache;
    }
    update(true);
    swiper.slideTo(newActiveIndex, 0);
  }
  function removeSlide(slidesIndexes) {
    if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
    let activeIndex = swiper.activeIndex;
    if (Array.isArray(slidesIndexes)) {
      for (let i = slidesIndexes.length - 1; i >= 0; i -= 1) {
        if (swiper.params.virtual.cache) {
          delete swiper.virtual.cache[slidesIndexes[i]];
          // shift cache indexes
          Object.keys(swiper.virtual.cache).forEach(key => {
            if (key > slidesIndexes) {
              swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
              swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
              delete swiper.virtual.cache[key];
            }
          });
        }
        swiper.virtual.slides.splice(slidesIndexes[i], 1);
        if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
        activeIndex = Math.max(activeIndex, 0);
      }
    } else {
      if (swiper.params.virtual.cache) {
        delete swiper.virtual.cache[slidesIndexes];
        // shift cache indexes
        Object.keys(swiper.virtual.cache).forEach(key => {
          if (key > slidesIndexes) {
            swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
            swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
            delete swiper.virtual.cache[key];
          }
        });
      }
      swiper.virtual.slides.splice(slidesIndexes, 1);
      if (slidesIndexes < activeIndex) activeIndex -= 1;
      activeIndex = Math.max(activeIndex, 0);
    }
    update(true);
    swiper.slideTo(activeIndex, 0);
  }
  function removeAllSlides() {
    swiper.virtual.slides = [];
    if (swiper.params.virtual.cache) {
      swiper.virtual.cache = {};
    }
    update(true);
    swiper.slideTo(0, 0);
  }
  on('beforeInit', () => {
    if (!swiper.params.virtual.enabled) return;
    let domSlidesAssigned;
    if (typeof swiper.passedParams.virtual.slides === 'undefined') {
      const slides = [...swiper.slidesEl.children].filter(el => el.matches(`.${swiper.params.slideClass}, swiper-slide`));
      if (slides && slides.length) {
        swiper.virtual.slides = [...slides];
        domSlidesAssigned = true;
        slides.forEach((slideEl, slideIndex) => {
          slideEl.setAttribute('data-swiper-slide-index', slideIndex);
          swiper.virtual.cache[slideIndex] = slideEl;
          slideEl.remove();
        });
      }
    }
    if (!domSlidesAssigned) {
      swiper.virtual.slides = swiper.params.virtual.slides;
    }
    swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
    swiper.params.watchSlidesProgress = true;
    swiper.originalParams.watchSlidesProgress = true;
    update(false, true);
  });
  on('setTranslate', () => {
    if (!swiper.params.virtual.enabled) return;
    if (swiper.params.cssMode && !swiper._immediateVirtual) {
      clearTimeout(cssModeTimeout);
      cssModeTimeout = setTimeout(() => {
        update();
      }, 100);
    } else {
      update();
    }
  });
  on('init update resize', () => {
    if (!swiper.params.virtual.enabled) return;
    if (swiper.params.cssMode) {
      setCSSProperty(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    }
  });
  Object.assign(swiper.virtual, {
    appendSlide,
    prependSlide,
    removeSlide,
    removeAllSlides,
    update
  });
}



;// CONCATENATED MODULE: ./node_modules/swiper/modules/keyboard.mjs



/* eslint-disable consistent-return */
function Keyboard(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  const document = getDocument();
  const window = getWindow();
  swiper.keyboard = {
    enabled: false
  };
  extendParams({
    keyboard: {
      enabled: false,
      onlyInViewport: true,
      pageUpDown: true
    }
  });
  function handle(event) {
    if (!swiper.enabled) return;
    const {
      rtlTranslate: rtl
    } = swiper;
    let e = event;
    if (e.originalEvent) e = e.originalEvent; // jquery fix
    const kc = e.keyCode || e.charCode;
    const pageUpDown = swiper.params.keyboard.pageUpDown;
    const isPageUp = pageUpDown && kc === 33;
    const isPageDown = pageUpDown && kc === 34;
    const isArrowLeft = kc === 37;
    const isArrowRight = kc === 39;
    const isArrowUp = kc === 38;
    const isArrowDown = kc === 40;
    // Directions locks
    if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) {
      return false;
    }
    if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) {
      return false;
    }
    if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
      return undefined;
    }
    if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) {
      return undefined;
    }
    if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
      let inView = false;
      // Check that swiper should be inside of visible area of window
      if (elementParents(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && elementParents(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) {
        return undefined;
      }
      const el = swiper.el;
      const swiperWidth = el.clientWidth;
      const swiperHeight = el.clientHeight;
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const swiperOffset = elementOffset(el);
      if (rtl) swiperOffset.left -= el.scrollLeft;
      const swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiperWidth, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiperHeight], [swiperOffset.left + swiperWidth, swiperOffset.top + swiperHeight]];
      for (let i = 0; i < swiperCoord.length; i += 1) {
        const point = swiperCoord[i];
        if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
          if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
          inView = true;
        }
      }
      if (!inView) return undefined;
    }
    if (swiper.isHorizontal()) {
      if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }
      if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
      if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
    } else {
      if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }
      if (isPageDown || isArrowDown) swiper.slideNext();
      if (isPageUp || isArrowUp) swiper.slidePrev();
    }
    emit('keyPress', kc);
    return undefined;
  }
  function enable() {
    if (swiper.keyboard.enabled) return;
    document.addEventListener('keydown', handle);
    swiper.keyboard.enabled = true;
  }
  function disable() {
    if (!swiper.keyboard.enabled) return;
    document.removeEventListener('keydown', handle);
    swiper.keyboard.enabled = false;
  }
  on('init', () => {
    if (swiper.params.keyboard.enabled) {
      enable();
    }
  });
  on('destroy', () => {
    if (swiper.keyboard.enabled) {
      disable();
    }
  });
  Object.assign(swiper.keyboard, {
    enable,
    disable
  });
}



;// CONCATENATED MODULE: ./node_modules/swiper/modules/mousewheel.mjs



/* eslint-disable consistent-return */
function Mousewheel(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  const window = getWindow();
  extendParams({
    mousewheel: {
      enabled: false,
      releaseOnEdges: false,
      invert: false,
      forceToAxis: false,
      sensitivity: 1,
      eventsTarget: 'container',
      thresholdDelta: null,
      thresholdTime: null,
      noMousewheelClass: 'swiper-no-mousewheel'
    }
  });
  swiper.mousewheel = {
    enabled: false
  };
  let timeout;
  let lastScrollTime = now();
  let lastEventBeforeSnap;
  const recentWheelEvents = [];
  function normalize(e) {
    // Reasonable defaults
    const PIXEL_STEP = 10;
    const LINE_HEIGHT = 40;
    const PAGE_HEIGHT = 800;
    let sX = 0;
    let sY = 0; // spinX, spinY
    let pX = 0;
    let pY = 0; // pixelX, pixelY

    // Legacy
    if ('detail' in e) {
      sY = e.detail;
    }
    if ('wheelDelta' in e) {
      sY = -e.wheelDelta / 120;
    }
    if ('wheelDeltaY' in e) {
      sY = -e.wheelDeltaY / 120;
    }
    if ('wheelDeltaX' in e) {
      sX = -e.wheelDeltaX / 120;
    }

    // side scrolling on FF with DOMMouseScroll
    if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
      sX = sY;
      sY = 0;
    }
    pX = sX * PIXEL_STEP;
    pY = sY * PIXEL_STEP;
    if ('deltaY' in e) {
      pY = e.deltaY;
    }
    if ('deltaX' in e) {
      pX = e.deltaX;
    }
    if (e.shiftKey && !pX) {
      // if user scrolls with shift he wants horizontal scroll
      pX = pY;
      pY = 0;
    }
    if ((pX || pY) && e.deltaMode) {
      if (e.deltaMode === 1) {
        // delta in LINE units
        pX *= LINE_HEIGHT;
        pY *= LINE_HEIGHT;
      } else {
        // delta in PAGE units
        pX *= PAGE_HEIGHT;
        pY *= PAGE_HEIGHT;
      }
    }

    // Fall-back if spin cannot be determined
    if (pX && !sX) {
      sX = pX < 1 ? -1 : 1;
    }
    if (pY && !sY) {
      sY = pY < 1 ? -1 : 1;
    }
    return {
      spinX: sX,
      spinY: sY,
      pixelX: pX,
      pixelY: pY
    };
  }
  function handleMouseEnter() {
    if (!swiper.enabled) return;
    swiper.mouseEntered = true;
  }
  function handleMouseLeave() {
    if (!swiper.enabled) return;
    swiper.mouseEntered = false;
  }
  function animateSlider(newEvent) {
    if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) {
      // Prevent if delta of wheel scroll delta is below configured threshold
      return false;
    }
    if (swiper.params.mousewheel.thresholdTime && now() - lastScrollTime < swiper.params.mousewheel.thresholdTime) {
      // Prevent if time between scrolls is below configured threshold
      return false;
    }

    // If the movement is NOT big enough and
    // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
    //   Don't go any further (avoid insignificant scroll movement).
    if (newEvent.delta >= 6 && now() - lastScrollTime < 60) {
      // Return false as a default
      return true;
    }
    // If user is scrolling towards the end:
    //   If the slider hasn't hit the latest slide or
    //   if the slider is a loop and
    //   if the slider isn't moving right now:
    //     Go to next slide and
    //     emit a scroll event.
    // Else (the user is scrolling towards the beginning) and
    // if the slider hasn't hit the first slide or
    // if the slider is a loop and
    // if the slider isn't moving right now:
    //   Go to prev slide and
    //   emit a scroll event.
    if (newEvent.direction < 0) {
      if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
        swiper.slideNext();
        emit('scroll', newEvent.raw);
      }
    } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
      swiper.slidePrev();
      emit('scroll', newEvent.raw);
    }
    // If you got here is because an animation has been triggered so store the current time
    lastScrollTime = new window.Date().getTime();
    // Return false as a default
    return false;
  }
  function releaseScroll(newEvent) {
    const params = swiper.params.mousewheel;
    if (newEvent.direction < 0) {
      if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
        // Return true to animate scroll on edges
        return true;
      }
    } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
      // Return true to animate scroll on edges
      return true;
    }
    return false;
  }
  function handle(event) {
    let e = event;
    let disableParentSwiper = true;
    if (!swiper.enabled) return;

    // Ignore event if the target or its parents have the swiper-no-mousewheel class
    if (event.target.closest(`.${swiper.params.mousewheel.noMousewheelClass}`)) return;
    const params = swiper.params.mousewheel;
    if (swiper.params.cssMode) {
      e.preventDefault();
    }
    let targetEl = swiper.el;
    if (swiper.params.mousewheel.eventsTarget !== 'container') {
      targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
    }
    const targetElContainsTarget = targetEl && targetEl.contains(e.target);
    if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
    if (e.originalEvent) e = e.originalEvent; // jquery fix
    let delta = 0;
    const rtlFactor = swiper.rtlTranslate ? -1 : 1;
    const data = normalize(e);
    if (params.forceToAxis) {
      if (swiper.isHorizontal()) {
        if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;else return true;
      } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;else return true;
    } else {
      delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
    }
    if (delta === 0) return true;
    if (params.invert) delta = -delta;

    // Get the scroll positions
    let positions = swiper.getTranslate() + delta * params.sensitivity;
    if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
    if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();

    // When loop is true:
    //     the disableParentSwiper will be true.
    // When loop is false:
    //     if the scroll positions is not on edge,
    //     then the disableParentSwiper will be true.
    //     if the scroll on edge positions,
    //     then the disableParentSwiper will be false.
    disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
    if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
    if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
      // Register the new event in a variable which stores the relevant data
      const newEvent = {
        time: now(),
        delta: Math.abs(delta),
        direction: Math.sign(delta),
        raw: event
      };

      // Keep the most recent events
      if (recentWheelEvents.length >= 2) {
        recentWheelEvents.shift(); // only store the last N events
      }

      const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
      recentWheelEvents.push(newEvent);

      // If there is at least one previous recorded event:
      //   If direction has changed or
      //   if the scroll is quicker than the previous one:
      //     Animate the slider.
      // Else (this is the first time the wheel is moved):
      //     Animate the slider.
      if (prevEvent) {
        if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) {
          animateSlider(newEvent);
        }
      } else {
        animateSlider(newEvent);
      }

      // If it's time to release the scroll:
      //   Return now so you don't hit the preventDefault.
      if (releaseScroll(newEvent)) {
        return true;
      }
    } else {
      // Freemode or scrollContainer:

      // If we recently snapped after a momentum scroll, then ignore wheel events
      // to give time for the deceleration to finish. Stop ignoring after 500 msecs
      // or if it's a new scroll (larger delta or inverse sign as last event before
      // an end-of-momentum snap).
      const newEvent = {
        time: now(),
        delta: Math.abs(delta),
        direction: Math.sign(delta)
      };
      const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
      if (!ignoreWheelEvents) {
        lastEventBeforeSnap = undefined;
        let position = swiper.getTranslate() + delta * params.sensitivity;
        const wasBeginning = swiper.isBeginning;
        const wasEnd = swiper.isEnd;
        if (position >= swiper.minTranslate()) position = swiper.minTranslate();
        if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
        swiper.setTransition(0);
        swiper.setTranslate(position);
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
        if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
          swiper.updateSlidesClasses();
        }
        if (swiper.params.loop) {
          swiper.loopFix({
            direction: newEvent.direction < 0 ? 'next' : 'prev',
            byMousewheel: true
          });
        }
        if (swiper.params.freeMode.sticky) {
          // When wheel scrolling starts with sticky (aka snap) enabled, then detect
          // the end of a momentum scroll by storing recent (N=15?) wheel events.
          // 1. do all N events have decreasing or same (absolute value) delta?
          // 2. did all N events arrive in the last M (M=500?) msecs?
          // 3. does the earliest event have an (absolute value) delta that's
          //    at least P (P=1?) larger than the most recent event's delta?
          // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
          // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
          // Snap immediately and ignore remaining wheel events in this scroll.
          // See comment above for "remaining wheel events in this scroll" determination.
          // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
          clearTimeout(timeout);
          timeout = undefined;
          if (recentWheelEvents.length >= 15) {
            recentWheelEvents.shift(); // only store the last N events
          }

          const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
          const firstEvent = recentWheelEvents[0];
          recentWheelEvents.push(newEvent);
          if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) {
            // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
            recentWheelEvents.splice(0);
          } else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
            // We're at the end of the deceleration of a momentum scroll, so there's no need
            // to wait for more events. Snap ASAP on the next tick.
            // Also, because there's some remaining momentum we'll bias the snap in the
            // direction of the ongoing scroll because it's better UX for the scroll to snap
            // in the same direction as the scroll instead of reversing to snap.  Therefore,
            // if it's already scrolled more than 20% in the current direction, keep going.
            const snapToThreshold = delta > 0 ? 0.8 : 0.2;
            lastEventBeforeSnap = newEvent;
            recentWheelEvents.splice(0);
            timeout = nextTick(() => {
              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 0); // no delay; move on next tick
          }

          if (!timeout) {
            // if we get here, then we haven't detected the end of a momentum scroll, so
            // we'll consider a scroll "complete" when there haven't been any wheel events
            // for 500ms.
            timeout = nextTick(() => {
              const snapToThreshold = 0.5;
              lastEventBeforeSnap = newEvent;
              recentWheelEvents.splice(0);
              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 500);
          }
        }

        // Emit event
        if (!ignoreWheelEvents) emit('scroll', e);

        // Stop autoplay
        if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop();
        // Return page scroll on edge positions
        if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) {
          return true;
        }
      }
    }
    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    return false;
  }
  function events(method) {
    let targetEl = swiper.el;
    if (swiper.params.mousewheel.eventsTarget !== 'container') {
      targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
    }
    targetEl[method]('mouseenter', handleMouseEnter);
    targetEl[method]('mouseleave', handleMouseLeave);
    targetEl[method]('wheel', handle);
  }
  function enable() {
    if (swiper.params.cssMode) {
      swiper.wrapperEl.removeEventListener('wheel', handle);
      return true;
    }
    if (swiper.mousewheel.enabled) return false;
    events('addEventListener');
    swiper.mousewheel.enabled = true;
    return true;
  }
  function disable() {
    if (swiper.params.cssMode) {
      swiper.wrapperEl.addEventListener(event, handle);
      return true;
    }
    if (!swiper.mousewheel.enabled) return false;
    events('removeEventListener');
    swiper.mousewheel.enabled = false;
    return true;
  }
  on('init', () => {
    if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
      disable();
    }
    if (swiper.params.mousewheel.enabled) enable();
  });
  on('destroy', () => {
    if (swiper.params.cssMode) {
      enable();
    }
    if (swiper.mousewheel.enabled) disable();
  });
  Object.assign(swiper.mousewheel, {
    enable,
    disable
  });
}



;// CONCATENATED MODULE: ./node_modules/swiper/shared/create-element-if-not-defined.mjs


function create_element_if_not_defined_createElementIfNotDefined(swiper, originalParams, params, checkProps) {
  if (swiper.params.createElements) {
    Object.keys(checkProps).forEach(key => {
      if (!params[key] && params.auto === true) {
        let element = (0,utils.e)(swiper.el, `.${checkProps[key]}`)[0];
        if (!element) {
          element = (0,utils.c)('div', checkProps[key]);
          element.className = checkProps[key];
          swiper.el.append(element);
        }
        params[key] = element;
        originalParams[key] = element;
      }
    });
  }
  return params;
}



;// CONCATENATED MODULE: ./node_modules/swiper/modules/navigation.mjs



function Navigation(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  extendParams({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock',
      navigationDisabledClass: 'swiper-navigation-disabled'
    }
  });
  swiper.navigation = {
    nextEl: null,
    prevEl: null
  };
  function getEl(el) {
    let res;
    if (el && typeof el === 'string' && swiper.isElement) {
      res = swiper.el.querySelector(el);
      if (res) return res;
    }
    if (el) {
      if (typeof el === 'string') res = [...document.querySelectorAll(el)];
      if (swiper.params.uniqueNavElements && typeof el === 'string' && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) {
        res = swiper.el.querySelector(el);
      } else if (res && res.length === 1) {
        res = res[0];
      }
    }
    if (el && !res) return el;
    // if (Array.isArray(res) && res.length === 1) res = res[0];
    return res;
  }
  function toggleEl(el, disabled) {
    const params = swiper.params.navigation;
    el = (0,utils.m)(el);
    el.forEach(subEl => {
      if (subEl) {
        subEl.classList[disabled ? 'add' : 'remove'](...params.disabledClass.split(' '));
        if (subEl.tagName === 'BUTTON') subEl.disabled = disabled;
        if (swiper.params.watchOverflow && swiper.enabled) {
          subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
        }
      }
    });
  }
  function update() {
    // Update Navigation Buttons
    const {
      nextEl,
      prevEl
    } = swiper.navigation;
    if (swiper.params.loop) {
      toggleEl(prevEl, false);
      toggleEl(nextEl, false);
      return;
    }
    toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
    toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
  }
  function onPrevClick(e) {
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
    swiper.slidePrev();
    emit('navigationPrev');
  }
  function onNextClick(e) {
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
    swiper.slideNext();
    emit('navigationNext');
  }
  function init() {
    const params = swiper.params.navigation;
    swiper.params.navigation = create_element_if_not_defined_createElementIfNotDefined(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
      nextEl: 'swiper-button-next',
      prevEl: 'swiper-button-prev'
    });
    if (!(params.nextEl || params.prevEl)) return;
    let nextEl = getEl(params.nextEl);
    let prevEl = getEl(params.prevEl);
    Object.assign(swiper.navigation, {
      nextEl,
      prevEl
    });
    nextEl = (0,utils.m)(nextEl);
    prevEl = (0,utils.m)(prevEl);
    const initButton = (el, dir) => {
      if (el) {
        el.addEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
      }
      if (!swiper.enabled && el) {
        el.classList.add(...params.lockClass.split(' '));
      }
    };
    nextEl.forEach(el => initButton(el, 'next'));
    prevEl.forEach(el => initButton(el, 'prev'));
  }
  function destroy() {
    let {
      nextEl,
      prevEl
    } = swiper.navigation;
    nextEl = (0,utils.m)(nextEl);
    prevEl = (0,utils.m)(prevEl);
    const destroyButton = (el, dir) => {
      el.removeEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
      el.classList.remove(...swiper.params.navigation.disabledClass.split(' '));
    };
    nextEl.forEach(el => destroyButton(el, 'next'));
    prevEl.forEach(el => destroyButton(el, 'prev'));
  }
  on('init', () => {
    if (swiper.params.navigation.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      update();
    }
  });
  on('toEdge fromEdge lock unlock', () => {
    update();
  });
  on('destroy', () => {
    destroy();
  });
  on('enable disable', () => {
    let {
      nextEl,
      prevEl
    } = swiper.navigation;
    nextEl = (0,utils.m)(nextEl);
    prevEl = (0,utils.m)(prevEl);
    if (swiper.enabled) {
      update();
      return;
    }
    [...nextEl, ...prevEl].filter(el => !!el).forEach(el => el.classList.add(swiper.params.navigation.lockClass));
  });
  on('click', (_s, e) => {
    let {
      nextEl,
      prevEl
    } = swiper.navigation;
    nextEl = (0,utils.m)(nextEl);
    prevEl = (0,utils.m)(prevEl);
    const targetEl = e.target;
    if (swiper.params.navigation.hideOnClick && !prevEl.includes(targetEl) && !nextEl.includes(targetEl)) {
      if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
      let isHidden;
      if (nextEl.length) {
        isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
      } else if (prevEl.length) {
        isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
      }
      if (isHidden === true) {
        emit('navigationShow');
      } else {
        emit('navigationHide');
      }
      [...nextEl, ...prevEl].filter(el => !!el).forEach(el => el.classList.toggle(swiper.params.navigation.hiddenClass));
    }
  });
  const enable = () => {
    swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(' '));
    init();
    update();
  };
  const disable = () => {
    swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(' '));
    destroy();
  };
  Object.assign(swiper.navigation, {
    enable,
    disable,
    update,
    init,
    destroy
  });
}



;// CONCATENATED MODULE: ./node_modules/swiper/shared/classes-to-selector.mjs
function classes_to_selector_classesToSelector(classes) {
  if (classes === void 0) {
    classes = '';
  }
  return `.${classes.trim().replace(/([\.:!+\/])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.')}`;
}



;// CONCATENATED MODULE: ./node_modules/swiper/modules/pagination.mjs




function Pagination(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  const pfx = 'swiper-pagination';
  extendParams({
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets',
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: number => number,
      formatFractionTotal: number => number,
      bulletClass: `${pfx}-bullet`,
      bulletActiveClass: `${pfx}-bullet-active`,
      modifierClass: `${pfx}-`,
      currentClass: `${pfx}-current`,
      totalClass: `${pfx}-total`,
      hiddenClass: `${pfx}-hidden`,
      progressbarFillClass: `${pfx}-progressbar-fill`,
      progressbarOppositeClass: `${pfx}-progressbar-opposite`,
      clickableClass: `${pfx}-clickable`,
      lockClass: `${pfx}-lock`,
      horizontalClass: `${pfx}-horizontal`,
      verticalClass: `${pfx}-vertical`,
      paginationDisabledClass: `${pfx}-disabled`
    }
  });
  swiper.pagination = {
    el: null,
    bullets: []
  };
  let bulletSize;
  let dynamicBulletIndex = 0;
  function isPaginationDisabled() {
    return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
  }
  function setSideBullets(bulletEl, position) {
    const {
      bulletActiveClass
    } = swiper.params.pagination;
    if (!bulletEl) return;
    bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
    if (bulletEl) {
      bulletEl.classList.add(`${bulletActiveClass}-${position}`);
      bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
      if (bulletEl) {
        bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
      }
    }
  }
  function onBulletClick(e) {
    const bulletEl = e.target.closest(classes_to_selector_classesToSelector(swiper.params.pagination.bulletClass));
    if (!bulletEl) {
      return;
    }
    e.preventDefault();
    const index = (0,utils.h)(bulletEl) * swiper.params.slidesPerGroup;
    if (swiper.params.loop) {
      if (swiper.realIndex === index) return;
      swiper.slideToLoop(index);
    } else {
      swiper.slideTo(index);
    }
  }
  function update() {
    // Render || Update Pagination bullets/items
    const rtl = swiper.rtl;
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    let el = swiper.pagination.el;
    el = (0,utils.m)(el);
    // Current/Total
    let current;
    let previousIndex;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
    if (swiper.params.loop) {
      previousIndex = swiper.previousRealIndex || 0;
      current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
      previousIndex = swiper.previousSnapIndex;
    } else {
      previousIndex = swiper.previousIndex || 0;
      current = swiper.activeIndex || 0;
    }
    // Types
    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      const bullets = swiper.pagination.bullets;
      let firstIndex;
      let lastIndex;
      let midIndex;
      if (params.dynamicBullets) {
        bulletSize = (0,utils.f)(bullets[0], swiper.isHorizontal() ? 'width' : 'height', true);
        el.forEach(subEl => {
          subEl.style[swiper.isHorizontal() ? 'width' : 'height'] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
        });
        if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
          dynamicBulletIndex += current - (previousIndex || 0);
          if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
            dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (dynamicBulletIndex < 0) {
            dynamicBulletIndex = 0;
          }
        }
        firstIndex = Math.max(current - dynamicBulletIndex, 0);
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }
      bullets.forEach(bulletEl => {
        const classesToRemove = [...['', '-next', '-next-next', '-prev', '-prev-prev', '-main'].map(suffix => `${params.bulletActiveClass}${suffix}`)].map(s => typeof s === 'string' && s.includes(' ') ? s.split(' ') : s).flat();
        bulletEl.classList.remove(...classesToRemove);
      });
      if (el.length > 1) {
        bullets.forEach(bullet => {
          const bulletIndex = (0,utils.h)(bullet);
          if (bulletIndex === current) {
            bullet.classList.add(...params.bulletActiveClass.split(' '));
          } else if (swiper.isElement) {
            bullet.setAttribute('part', 'bullet');
          }
          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              bullet.classList.add(...`${params.bulletActiveClass}-main`.split(' '));
            }
            if (bulletIndex === firstIndex) {
              setSideBullets(bullet, 'prev');
            }
            if (bulletIndex === lastIndex) {
              setSideBullets(bullet, 'next');
            }
          }
        });
      } else {
        const bullet = bullets[current];
        if (bullet) {
          bullet.classList.add(...params.bulletActiveClass.split(' '));
        }
        if (swiper.isElement) {
          bullets.forEach((bulletEl, bulletIndex) => {
            bulletEl.setAttribute('part', bulletIndex === current ? 'bullet-active' : 'bullet');
          });
        }
        if (params.dynamicBullets) {
          const firstDisplayedBullet = bullets[firstIndex];
          const lastDisplayedBullet = bullets[lastIndex];
          for (let i = firstIndex; i <= lastIndex; i += 1) {
            if (bullets[i]) {
              bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(' '));
            }
          }
          setSideBullets(firstDisplayedBullet, 'prev');
          setSideBullets(lastDisplayedBullet, 'next');
        }
      }
      if (params.dynamicBullets) {
        const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
        const offsetProp = rtl ? 'right' : 'left';
        bullets.forEach(bullet => {
          bullet.style[swiper.isHorizontal() ? offsetProp : 'top'] = `${bulletsOffset}px`;
        });
      }
    }
    el.forEach((subEl, subElIndex) => {
      if (params.type === 'fraction') {
        subEl.querySelectorAll(classes_to_selector_classesToSelector(params.currentClass)).forEach(fractionEl => {
          fractionEl.textContent = params.formatFractionCurrent(current + 1);
        });
        subEl.querySelectorAll(classes_to_selector_classesToSelector(params.totalClass)).forEach(totalEl => {
          totalEl.textContent = params.formatFractionTotal(total);
        });
      }
      if (params.type === 'progressbar') {
        let progressbarDirection;
        if (params.progressbarOpposite) {
          progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
        } else {
          progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
        }
        const scale = (current + 1) / total;
        let scaleX = 1;
        let scaleY = 1;
        if (progressbarDirection === 'horizontal') {
          scaleX = scale;
        } else {
          scaleY = scale;
        }
        subEl.querySelectorAll(classes_to_selector_classesToSelector(params.progressbarFillClass)).forEach(progressEl => {
          progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
          progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
        });
      }
      if (params.type === 'custom' && params.renderCustom) {
        subEl.innerHTML = params.renderCustom(swiper, current + 1, total);
        if (subElIndex === 0) emit('paginationRender', subEl);
      } else {
        if (subElIndex === 0) emit('paginationRender', subEl);
        emit('paginationUpdate', subEl);
      }
      if (swiper.params.watchOverflow && swiper.enabled) {
        subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
      }
    });
  }
  function render() {
    // Render Container
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
    let el = swiper.pagination.el;
    el = (0,utils.m)(el);
    let paginationHTML = '';
    if (params.type === 'bullets') {
      let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }
      for (let i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          // prettier-ignore
          paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ''} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
      }
    }
    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
      }
    }
    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
      }
    }
    swiper.pagination.bullets = [];
    el.forEach(subEl => {
      if (params.type !== 'custom') {
        subEl.innerHTML = paginationHTML || '';
      }
      if (params.type === 'bullets') {
        swiper.pagination.bullets.push(...subEl.querySelectorAll(classes_to_selector_classesToSelector(params.bulletClass)));
      }
    });
    if (params.type !== 'custom') {
      emit('paginationRender', el[0]);
    }
  }
  function init() {
    swiper.params.pagination = create_element_if_not_defined_createElementIfNotDefined(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
      el: 'swiper-pagination'
    });
    const params = swiper.params.pagination;
    if (!params.el) return;
    let el;
    if (typeof params.el === 'string' && swiper.isElement) {
      el = swiper.el.querySelector(params.el);
    }
    if (!el && typeof params.el === 'string') {
      el = [...document.querySelectorAll(params.el)];
    }
    if (!el) {
      el = params.el;
    }
    if (!el || el.length === 0) return;
    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && Array.isArray(el) && el.length > 1) {
      el = [...swiper.el.querySelectorAll(params.el)];
      // check if it belongs to another nested Swiper
      if (el.length > 1) {
        el = el.filter(subEl => {
          if ((0,utils.a)(subEl, '.swiper')[0] !== swiper.el) return false;
          return true;
        })[0];
      }
    }
    if (Array.isArray(el) && el.length === 1) el = el[0];
    Object.assign(swiper.pagination, {
      el
    });
    el = (0,utils.m)(el);
    el.forEach(subEl => {
      if (params.type === 'bullets' && params.clickable) {
        subEl.classList.add(...(params.clickableClass || '').split(' '));
      }
      subEl.classList.add(params.modifierClass + params.type);
      subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
      if (params.type === 'bullets' && params.dynamicBullets) {
        subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
        dynamicBulletIndex = 0;
        if (params.dynamicMainBullets < 1) {
          params.dynamicMainBullets = 1;
        }
      }
      if (params.type === 'progressbar' && params.progressbarOpposite) {
        subEl.classList.add(params.progressbarOppositeClass);
      }
      if (params.clickable) {
        subEl.addEventListener('click', onBulletClick);
      }
      if (!swiper.enabled) {
        subEl.classList.add(params.lockClass);
      }
    });
  }
  function destroy() {
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    let el = swiper.pagination.el;
    if (el) {
      el = (0,utils.m)(el);
      el.forEach(subEl => {
        subEl.classList.remove(params.hiddenClass);
        subEl.classList.remove(params.modifierClass + params.type);
        subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (params.clickable) {
          subEl.classList.remove(...(params.clickableClass || '').split(' '));
          subEl.removeEventListener('click', onBulletClick);
        }
      });
    }
    if (swiper.pagination.bullets) swiper.pagination.bullets.forEach(subEl => subEl.classList.remove(...params.bulletActiveClass.split(' ')));
  }
  on('changeDirection', () => {
    if (!swiper.pagination || !swiper.pagination.el) return;
    const params = swiper.params.pagination;
    let {
      el
    } = swiper.pagination;
    el = (0,utils.m)(el);
    el.forEach(subEl => {
      subEl.classList.remove(params.horizontalClass, params.verticalClass);
      subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    });
  });
  on('init', () => {
    if (swiper.params.pagination.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      render();
      update();
    }
  });
  on('activeIndexChange', () => {
    if (typeof swiper.snapIndex === 'undefined') {
      update();
    }
  });
  on('snapIndexChange', () => {
    update();
  });
  on('snapGridLengthChange', () => {
    render();
    update();
  });
  on('destroy', () => {
    destroy();
  });
  on('enable disable', () => {
    let {
      el
    } = swiper.pagination;
    if (el) {
      el = (0,utils.m)(el);
      el.forEach(subEl => subEl.classList[swiper.enabled ? 'remove' : 'add'](swiper.params.pagination.lockClass));
    }
  });
  on('lock unlock', () => {
    update();
  });
  on('click', (_s, e) => {
    const targetEl = e.target;
    const el = (0,utils.m)(swiper.pagination.el);
    if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
      if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
      const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
      if (isHidden === true) {
        emit('paginationShow');
      } else {
        emit('paginationHide');
      }
      el.forEach(subEl => subEl.classList.toggle(swiper.params.pagination.hiddenClass));
    }
  });
  const enable = () => {
    swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
    let {
      el
    } = swiper.pagination;
    if (el) {
      el = (0,utils.m)(el);
      el.forEach(subEl => subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
    }
    init();
    render();
    update();
  };
  const disable = () => {
    swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
    let {
      el
    } = swiper.pagination;
    if (el) {
      el = (0,utils.m)(el);
      el.forEach(subEl => subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
    }
    destroy();
  };
  Object.assign(swiper.pagination, {
    enable,
    disable,
    render,
    update,
    init,
    destroy
  });
}



;// CONCATENATED MODULE: ./node_modules/swiper/modules/scrollbar.mjs





function Scrollbar(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  const document = getDocument();
  let isTouched = false;
  let timeout = null;
  let dragTimeout = null;
  let dragStartPos;
  let dragSize;
  let trackSize;
  let divider;
  extendParams({
    scrollbar: {
      el: null,
      dragSize: 'auto',
      hide: false,
      draggable: false,
      snapOnRelease: true,
      lockClass: 'swiper-scrollbar-lock',
      dragClass: 'swiper-scrollbar-drag',
      scrollbarDisabledClass: 'swiper-scrollbar-disabled',
      horizontalClass: `swiper-scrollbar-horizontal`,
      verticalClass: `swiper-scrollbar-vertical`
    }
  });
  swiper.scrollbar = {
    el: null,
    dragEl: null
  };
  function setTranslate() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    const {
      scrollbar,
      rtlTranslate: rtl
    } = swiper;
    const {
      dragEl,
      el
    } = scrollbar;
    const params = swiper.params.scrollbar;
    const progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
    let newSize = dragSize;
    let newPos = (trackSize - dragSize) * progress;
    if (rtl) {
      newPos = -newPos;
      if (newPos > 0) {
        newSize = dragSize - newPos;
        newPos = 0;
      } else if (-newPos + dragSize > trackSize) {
        newSize = trackSize + newPos;
      }
    } else if (newPos < 0) {
      newSize = dragSize + newPos;
      newPos = 0;
    } else if (newPos + dragSize > trackSize) {
      newSize = trackSize - newPos;
    }
    if (swiper.isHorizontal()) {
      dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
      dragEl.style.width = `${newSize}px`;
    } else {
      dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
      dragEl.style.height = `${newSize}px`;
    }
    if (params.hide) {
      clearTimeout(timeout);
      el.style.opacity = 1;
      timeout = setTimeout(() => {
        el.style.opacity = 0;
        el.style.transitionDuration = '400ms';
      }, 1000);
    }
  }
  function setTransition(duration) {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
  }
  function updateSize() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    const {
      scrollbar
    } = swiper;
    const {
      dragEl,
      el
    } = scrollbar;
    dragEl.style.width = '';
    dragEl.style.height = '';
    trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
    divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
    if (swiper.params.scrollbar.dragSize === 'auto') {
      dragSize = trackSize * divider;
    } else {
      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
    }
    if (swiper.isHorizontal()) {
      dragEl.style.width = `${dragSize}px`;
    } else {
      dragEl.style.height = `${dragSize}px`;
    }
    if (divider >= 1) {
      el.style.display = 'none';
    } else {
      el.style.display = '';
    }
    if (swiper.params.scrollbar.hide) {
      el.style.opacity = 0;
    }
    if (swiper.params.watchOverflow && swiper.enabled) {
      scrollbar.el.classList[swiper.isLocked ? 'add' : 'remove'](swiper.params.scrollbar.lockClass);
    }
  }
  function getPointerPosition(e) {
    return swiper.isHorizontal() ? e.clientX : e.clientY;
  }
  function setDragPosition(e) {
    const {
      scrollbar,
      rtlTranslate: rtl
    } = swiper;
    const {
      el
    } = scrollbar;
    let positionRatio;
    positionRatio = (getPointerPosition(e) - elementOffset(el)[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
    positionRatio = Math.max(Math.min(positionRatio, 1), 0);
    if (rtl) {
      positionRatio = 1 - positionRatio;
    }
    const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
    swiper.updateProgress(position);
    swiper.setTranslate(position);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  function onDragStart(e) {
    const params = swiper.params.scrollbar;
    const {
      scrollbar,
      wrapperEl
    } = swiper;
    const {
      el,
      dragEl
    } = scrollbar;
    isTouched = true;
    dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
    e.preventDefault();
    e.stopPropagation();
    wrapperEl.style.transitionDuration = '100ms';
    dragEl.style.transitionDuration = '100ms';
    setDragPosition(e);
    clearTimeout(dragTimeout);
    el.style.transitionDuration = '0ms';
    if (params.hide) {
      el.style.opacity = 1;
    }
    if (swiper.params.cssMode) {
      swiper.wrapperEl.style['scroll-snap-type'] = 'none';
    }
    emit('scrollbarDragStart', e);
  }
  function onDragMove(e) {
    const {
      scrollbar,
      wrapperEl
    } = swiper;
    const {
      el,
      dragEl
    } = scrollbar;
    if (!isTouched) return;
    if (e.preventDefault && e.cancelable) e.preventDefault();else e.returnValue = false;
    setDragPosition(e);
    wrapperEl.style.transitionDuration = '0ms';
    el.style.transitionDuration = '0ms';
    dragEl.style.transitionDuration = '0ms';
    emit('scrollbarDragMove', e);
  }
  function onDragEnd(e) {
    const params = swiper.params.scrollbar;
    const {
      scrollbar,
      wrapperEl
    } = swiper;
    const {
      el
    } = scrollbar;
    if (!isTouched) return;
    isTouched = false;
    if (swiper.params.cssMode) {
      swiper.wrapperEl.style['scroll-snap-type'] = '';
      wrapperEl.style.transitionDuration = '';
    }
    if (params.hide) {
      clearTimeout(dragTimeout);
      dragTimeout = nextTick(() => {
        el.style.opacity = 0;
        el.style.transitionDuration = '400ms';
      }, 1000);
    }
    emit('scrollbarDragEnd', e);
    if (params.snapOnRelease) {
      swiper.slideToClosest();
    }
  }
  function events(method) {
    const {
      scrollbar,
      params
    } = swiper;
    const el = scrollbar.el;
    if (!el) return;
    const target = el;
    const activeListener = params.passiveListeners ? {
      passive: false,
      capture: false
    } : false;
    const passiveListener = params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    if (!target) return;
    const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    target[eventMethod]('pointerdown', onDragStart, activeListener);
    document[eventMethod]('pointermove', onDragMove, activeListener);
    document[eventMethod]('pointerup', onDragEnd, passiveListener);
  }
  function enableDraggable() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    events('on');
  }
  function disableDraggable() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    events('off');
  }
  function init() {
    const {
      scrollbar,
      el: swiperEl
    } = swiper;
    swiper.params.scrollbar = createElementIfNotDefined(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
      el: 'swiper-scrollbar'
    });
    const params = swiper.params.scrollbar;
    if (!params.el) return;
    let el;
    if (typeof params.el === 'string' && swiper.isElement) {
      el = swiper.el.querySelector(params.el);
    }
    if (!el && typeof params.el === 'string') {
      el = document.querySelectorAll(params.el);
      if (!el.length) return;
    } else if (!el) {
      el = params.el;
    }
    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) {
      el = swiperEl.querySelector(params.el);
    }
    if (el.length > 0) el = el[0];
    el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    let dragEl;
    if (el) {
      dragEl = el.querySelector(classesToSelector(swiper.params.scrollbar.dragClass));
      if (!dragEl) {
        dragEl = createElement('div', swiper.params.scrollbar.dragClass);
        el.append(dragEl);
      }
    }
    Object.assign(scrollbar, {
      el,
      dragEl
    });
    if (params.draggable) {
      enableDraggable();
    }
    if (el) {
      el.classList[swiper.enabled ? 'remove' : 'add'](...classesToTokens(swiper.params.scrollbar.lockClass));
    }
  }
  function destroy() {
    const params = swiper.params.scrollbar;
    const el = swiper.scrollbar.el;
    if (el) {
      el.classList.remove(...classesToTokens(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass));
    }
    disableDraggable();
  }
  on('changeDirection', () => {
    if (!swiper.scrollbar || !swiper.scrollbar.el) return;
    const params = swiper.params.scrollbar;
    let {
      el
    } = swiper.scrollbar;
    el = makeElementsArray(el);
    el.forEach(subEl => {
      subEl.classList.remove(params.horizontalClass, params.verticalClass);
      subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    });
  });
  on('init', () => {
    if (swiper.params.scrollbar.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      updateSize();
      setTranslate();
    }
  });
  on('update resize observerUpdate lock unlock changeDirection', () => {
    updateSize();
  });
  on('setTranslate', () => {
    setTranslate();
  });
  on('setTransition', (_s, duration) => {
    setTransition(duration);
  });
  on('enable disable', () => {
    const {
      el
    } = swiper.scrollbar;
    if (el) {
      el.classList[swiper.enabled ? 'remove' : 'add'](...classesToTokens(swiper.params.scrollbar.lockClass));
    }
  });
  on('destroy', () => {
    destroy();
  });
  const enable = () => {
    swiper.el.classList.remove(...classesToTokens(swiper.params.scrollbar.scrollbarDisabledClass));
    if (swiper.scrollbar.el) {
      swiper.scrollbar.el.classList.remove(...classesToTokens(swiper.params.scrollbar.scrollbarDisabledClass));
    }
    init();
    updateSize();
    setTranslate();
  };
  const disable = () => {
    swiper.el.classList.add(...classesToTokens(swiper.params.scrollbar.scrollbarDisabledClass));
    if (swiper.scrollbar.el) {
      swiper.scrollbar.el.classList.add(...classesToTokens(swiper.params.scrollbar.scrollbarDisabledClass));
    }
    destroy();
  };
  Object.assign(swiper.scrollbar, {
    enable,
    disable,
    updateSize,
    setTranslate,
    init,
    destroy
  });
}



;// CONCATENATED MODULE: ./node_modules/swiper/modules/parallax.mjs


function Parallax(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    parallax: {
      enabled: false
    }
  });
  const elementsSelector = '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]';
  const setTransform = (el, progress) => {
    const {
      rtl
    } = swiper;
    const rtlFactor = rtl ? -1 : 1;
    const p = el.getAttribute('data-swiper-parallax') || '0';
    let x = el.getAttribute('data-swiper-parallax-x');
    let y = el.getAttribute('data-swiper-parallax-y');
    const scale = el.getAttribute('data-swiper-parallax-scale');
    const opacity = el.getAttribute('data-swiper-parallax-opacity');
    const rotate = el.getAttribute('data-swiper-parallax-rotate');
    if (x || y) {
      x = x || '0';
      y = y || '0';
    } else if (swiper.isHorizontal()) {
      x = p;
      y = '0';
    } else {
      y = p;
      x = '0';
    }
    if (x.indexOf('%') >= 0) {
      x = `${parseInt(x, 10) * progress * rtlFactor}%`;
    } else {
      x = `${x * progress * rtlFactor}px`;
    }
    if (y.indexOf('%') >= 0) {
      y = `${parseInt(y, 10) * progress}%`;
    } else {
      y = `${y * progress}px`;
    }
    if (typeof opacity !== 'undefined' && opacity !== null) {
      const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
      el.style.opacity = currentOpacity;
    }
    let transform = `translate3d(${x}, ${y}, 0px)`;
    if (typeof scale !== 'undefined' && scale !== null) {
      const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
      transform += ` scale(${currentScale})`;
    }
    if (rotate && typeof rotate !== 'undefined' && rotate !== null) {
      const currentRotate = rotate * progress * -1;
      transform += ` rotate(${currentRotate}deg)`;
    }
    el.style.transform = transform;
  };
  const setTranslate = () => {
    const {
      el,
      slides,
      progress,
      snapGrid,
      isElement
    } = swiper;
    const elements = elementChildren(el, elementsSelector);
    if (swiper.isElement) {
      elements.push(...elementChildren(swiper.hostEl, elementsSelector));
    }
    elements.forEach(subEl => {
      setTransform(subEl, progress);
    });
    slides.forEach((slideEl, slideIndex) => {
      let slideProgress = slideEl.progress;
      if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
        slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
      }
      slideProgress = Math.min(Math.max(slideProgress, -1), 1);
      slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach(subEl => {
        setTransform(subEl, slideProgress);
      });
    });
  };
  const setTransition = function (duration) {
    if (duration === void 0) {
      duration = swiper.params.speed;
    }
    const {
      el,
      hostEl
    } = swiper;
    const elements = [...el.querySelectorAll(elementsSelector)];
    if (swiper.isElement) {
      elements.push(...hostEl.querySelectorAll(elementsSelector));
    }
    elements.forEach(parallaxEl => {
      let parallaxDuration = parseInt(parallaxEl.getAttribute('data-swiper-parallax-duration'), 10) || duration;
      if (duration === 0) parallaxDuration = 0;
      parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
    });
  };
  on('beforeInit', () => {
    if (!swiper.params.parallax.enabled) return;
    swiper.params.watchSlidesProgress = true;
    swiper.originalParams.watchSlidesProgress = true;
  });
  on('init', () => {
    if (!swiper.params.parallax.enabled) return;
    setTranslate();
  });
  on('setTranslate', () => {
    if (!swiper.params.parallax.enabled) return;
    setTranslate();
  });
  on('setTransition', (_swiper, duration) => {
    if (!swiper.params.parallax.enabled) return;
    setTransition(duration);
  });
}



;// CONCATENATED MODULE: ./node_modules/swiper/modules/zoom.mjs



function Zoom(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  const window = getWindow();
  extendParams({
    zoom: {
      enabled: false,
      limitToOriginalSize: false,
      maxRatio: 3,
      minRatio: 1,
      toggle: true,
      containerClass: 'swiper-zoom-container',
      zoomedSlideClass: 'swiper-slide-zoomed'
    }
  });
  swiper.zoom = {
    enabled: false
  };
  let currentScale = 1;
  let isScaling = false;
  let fakeGestureTouched;
  let fakeGestureMoved;
  const evCache = [];
  const gesture = {
    originX: 0,
    originY: 0,
    slideEl: undefined,
    slideWidth: undefined,
    slideHeight: undefined,
    imageEl: undefined,
    imageWrapEl: undefined,
    maxRatio: 3
  };
  const image = {
    isTouched: undefined,
    isMoved: undefined,
    currentX: undefined,
    currentY: undefined,
    minX: undefined,
    minY: undefined,
    maxX: undefined,
    maxY: undefined,
    width: undefined,
    height: undefined,
    startX: undefined,
    startY: undefined,
    touchesStart: {},
    touchesCurrent: {}
  };
  const velocity = {
    x: undefined,
    y: undefined,
    prevPositionX: undefined,
    prevPositionY: undefined,
    prevTime: undefined
  };
  let scale = 1;
  Object.defineProperty(swiper.zoom, 'scale', {
    get() {
      return scale;
    },
    set(value) {
      if (scale !== value) {
        const imageEl = gesture.imageEl;
        const slideEl = gesture.slideEl;
        emit('zoomChange', value, imageEl, slideEl);
      }
      scale = value;
    }
  });
  function getDistanceBetweenTouches() {
    if (evCache.length < 2) return 1;
    const x1 = evCache[0].pageX;
    const y1 = evCache[0].pageY;
    const x2 = evCache[1].pageX;
    const y2 = evCache[1].pageY;
    const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
    return distance;
  }
  function getMaxRatio() {
    const params = swiper.params.zoom;
    const maxRatio = gesture.imageWrapEl.getAttribute('data-swiper-zoom') || params.maxRatio;
    if (params.limitToOriginalSize && gesture.imageEl && gesture.imageEl.naturalWidth) {
      const imageMaxRatio = gesture.imageEl.naturalWidth / gesture.imageEl.offsetWidth;
      return Math.min(imageMaxRatio, maxRatio);
    }
    return maxRatio;
  }
  function getScaleOrigin() {
    if (evCache.length < 2) return {
      x: null,
      y: null
    };
    const box = gesture.imageEl.getBoundingClientRect();
    return [(evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale, (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale];
  }
  function getSlideSelector() {
    return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
  }
  function eventWithinSlide(e) {
    const slideSelector = getSlideSelector();
    if (e.target.matches(slideSelector)) return true;
    if (swiper.slides.filter(slideEl => slideEl.contains(e.target)).length > 0) return true;
    return false;
  }
  function eventWithinZoomContainer(e) {
    const selector = `.${swiper.params.zoom.containerClass}`;
    if (e.target.matches(selector)) return true;
    if ([...swiper.hostEl.querySelectorAll(selector)].filter(containerEl => containerEl.contains(e.target)).length > 0) return true;
    return false;
  }

  // Events
  function onGestureStart(e) {
    if (e.pointerType === 'mouse') {
      evCache.splice(0, evCache.length);
    }
    if (!eventWithinSlide(e)) return;
    const params = swiper.params.zoom;
    fakeGestureTouched = false;
    fakeGestureMoved = false;
    evCache.push(e);
    if (evCache.length < 2) {
      return;
    }
    fakeGestureTouched = true;
    gesture.scaleStart = getDistanceBetweenTouches();
    if (!gesture.slideEl) {
      gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
      if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
      let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
      if (imageEl) {
        imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
      }
      gesture.imageEl = imageEl;
      if (imageEl) {
        gesture.imageWrapEl = elementParents(gesture.imageEl, `.${params.containerClass}`)[0];
      } else {
        gesture.imageWrapEl = undefined;
      }
      if (!gesture.imageWrapEl) {
        gesture.imageEl = undefined;
        return;
      }
      gesture.maxRatio = getMaxRatio();
    }
    if (gesture.imageEl) {
      const [originX, originY] = getScaleOrigin();
      gesture.originX = originX;
      gesture.originY = originY;
      gesture.imageEl.style.transitionDuration = '0ms';
    }
    isScaling = true;
  }
  function onGestureChange(e) {
    if (!eventWithinSlide(e)) return;
    const params = swiper.params.zoom;
    const zoom = swiper.zoom;
    const pointerIndex = evCache.findIndex(cachedEv => cachedEv.pointerId === e.pointerId);
    if (pointerIndex >= 0) evCache[pointerIndex] = e;
    if (evCache.length < 2) {
      return;
    }
    fakeGestureMoved = true;
    gesture.scaleMove = getDistanceBetweenTouches();
    if (!gesture.imageEl) {
      return;
    }
    zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
    if (zoom.scale > gesture.maxRatio) {
      zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
    }
    if (zoom.scale < params.minRatio) {
      zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
    }
    gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
  }
  function onGestureEnd(e) {
    if (!eventWithinSlide(e)) return;
    if (e.pointerType === 'mouse' && e.type === 'pointerout') return;
    const params = swiper.params.zoom;
    const zoom = swiper.zoom;
    const pointerIndex = evCache.findIndex(cachedEv => cachedEv.pointerId === e.pointerId);
    if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
    if (!fakeGestureTouched || !fakeGestureMoved) {
      return;
    }
    fakeGestureTouched = false;
    fakeGestureMoved = false;
    if (!gesture.imageEl) return;
    zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
    gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
    gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    currentScale = zoom.scale;
    isScaling = false;
    if (zoom.scale > 1 && gesture.slideEl) {
      gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
    } else if (zoom.scale <= 1 && gesture.slideEl) {
      gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
    }
    if (zoom.scale === 1) {
      gesture.originX = 0;
      gesture.originY = 0;
      gesture.slideEl = undefined;
    }
  }
  let allowTouchMoveTimeout;
  function allowTouchMove() {
    swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
  }
  function preventTouchMove() {
    clearTimeout(allowTouchMoveTimeout);
    swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
    allowTouchMoveTimeout = setTimeout(() => {
      allowTouchMove();
    });
  }
  function onTouchStart(e) {
    const device = swiper.device;
    if (!gesture.imageEl) return;
    if (image.isTouched) return;
    if (device.android && e.cancelable) e.preventDefault();
    image.isTouched = true;
    const event = evCache.length > 0 ? evCache[0] : e;
    image.touchesStart.x = event.pageX;
    image.touchesStart.y = event.pageY;
  }
  function onTouchMove(e) {
    if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) {
      return;
    }
    const zoom = swiper.zoom;
    if (!gesture.imageEl) {
      return;
    }
    if (!image.isTouched || !gesture.slideEl) {
      return;
    }
    if (!image.isMoved) {
      image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
      image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
      image.startX = getTranslate(gesture.imageWrapEl, 'x') || 0;
      image.startY = getTranslate(gesture.imageWrapEl, 'y') || 0;
      gesture.slideWidth = gesture.slideEl.offsetWidth;
      gesture.slideHeight = gesture.slideEl.offsetHeight;
      gesture.imageWrapEl.style.transitionDuration = '0ms';
    }
    // Define if we need image drag
    const scaledWidth = image.width * zoom.scale;
    const scaledHeight = image.height * zoom.scale;
    if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) {
      allowTouchMove();
      return;
    }
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;
    image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
    image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
    const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
    if (touchesDiff > 5) {
      swiper.allowClick = false;
    }
    if (!image.isMoved && !isScaling) {
      if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
        image.isTouched = false;
        allowTouchMove();
        return;
      }
      if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
        image.isTouched = false;
        allowTouchMove();
        return;
      }
    }
    if (e.cancelable) {
      e.preventDefault();
    }
    e.stopPropagation();
    preventTouchMove();
    image.isMoved = true;
    const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
    const {
      originX,
      originY
    } = gesture;
    image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
    image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
    if (image.currentX < image.minX) {
      image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
    }
    if (image.currentX > image.maxX) {
      image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
    }
    if (image.currentY < image.minY) {
      image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
    }
    if (image.currentY > image.maxY) {
      image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
    }

    // Velocity
    if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
    if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
    if (!velocity.prevTime) velocity.prevTime = Date.now();
    velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
    velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
    if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
    if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
    velocity.prevPositionX = image.touchesCurrent.x;
    velocity.prevPositionY = image.touchesCurrent.y;
    velocity.prevTime = Date.now();
    gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
  }
  function onTouchEnd() {
    const zoom = swiper.zoom;
    if (!gesture.imageEl) return;
    if (!image.isTouched || !image.isMoved) {
      image.isTouched = false;
      image.isMoved = false;
      return;
    }
    image.isTouched = false;
    image.isMoved = false;
    let momentumDurationX = 300;
    let momentumDurationY = 300;
    const momentumDistanceX = velocity.x * momentumDurationX;
    const newPositionX = image.currentX + momentumDistanceX;
    const momentumDistanceY = velocity.y * momentumDurationY;
    const newPositionY = image.currentY + momentumDistanceY;

    // Fix duration
    if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
    if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
    const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
    image.currentX = newPositionX;
    image.currentY = newPositionY;
    // Define if we need image drag
    const scaledWidth = image.width * zoom.scale;
    const scaledHeight = image.height * zoom.scale;
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;
    image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
    image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
    gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
    gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
  }
  function onTransitionEnd() {
    const zoom = swiper.zoom;
    if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
      if (gesture.imageEl) {
        gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
      }
      if (gesture.imageWrapEl) {
        gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
      }
      gesture.slideEl.classList.remove(`${swiper.params.zoom.zoomedSlideClass}`);
      zoom.scale = 1;
      currentScale = 1;
      gesture.slideEl = undefined;
      gesture.imageEl = undefined;
      gesture.imageWrapEl = undefined;
      gesture.originX = 0;
      gesture.originY = 0;
    }
  }
  function zoomIn(e) {
    const zoom = swiper.zoom;
    const params = swiper.params.zoom;
    if (!gesture.slideEl) {
      if (e && e.target) {
        gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
      }
      if (!gesture.slideEl) {
        if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
          gesture.slideEl = elementChildren(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
        } else {
          gesture.slideEl = swiper.slides[swiper.activeIndex];
        }
      }
      let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
      if (imageEl) {
        imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
      }
      gesture.imageEl = imageEl;
      if (imageEl) {
        gesture.imageWrapEl = elementParents(gesture.imageEl, `.${params.containerClass}`)[0];
      } else {
        gesture.imageWrapEl = undefined;
      }
    }
    if (!gesture.imageEl || !gesture.imageWrapEl) return;
    if (swiper.params.cssMode) {
      swiper.wrapperEl.style.overflow = 'hidden';
      swiper.wrapperEl.style.touchAction = 'none';
    }
    gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
    let touchX;
    let touchY;
    let offsetX;
    let offsetY;
    let diffX;
    let diffY;
    let translateX;
    let translateY;
    let imageWidth;
    let imageHeight;
    let scaledWidth;
    let scaledHeight;
    let translateMinX;
    let translateMinY;
    let translateMaxX;
    let translateMaxY;
    let slideWidth;
    let slideHeight;
    if (typeof image.touchesStart.x === 'undefined' && e) {
      touchX = e.pageX;
      touchY = e.pageY;
    } else {
      touchX = image.touchesStart.x;
      touchY = image.touchesStart.y;
    }
    const forceZoomRatio = typeof e === 'number' ? e : null;
    if (currentScale === 1 && forceZoomRatio) {
      touchX = undefined;
      touchY = undefined;
    }
    const maxRatio = getMaxRatio();
    zoom.scale = forceZoomRatio || maxRatio;
    currentScale = forceZoomRatio || maxRatio;
    if (e && !(currentScale === 1 && forceZoomRatio)) {
      slideWidth = gesture.slideEl.offsetWidth;
      slideHeight = gesture.slideEl.offsetHeight;
      offsetX = elementOffset(gesture.slideEl).left + window.scrollX;
      offsetY = elementOffset(gesture.slideEl).top + window.scrollY;
      diffX = offsetX + slideWidth / 2 - touchX;
      diffY = offsetY + slideHeight / 2 - touchY;
      imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
      imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
      scaledWidth = imageWidth * zoom.scale;
      scaledHeight = imageHeight * zoom.scale;
      translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
      translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
      translateMaxX = -translateMinX;
      translateMaxY = -translateMinY;
      translateX = diffX * zoom.scale;
      translateY = diffY * zoom.scale;
      if (translateX < translateMinX) {
        translateX = translateMinX;
      }
      if (translateX > translateMaxX) {
        translateX = translateMaxX;
      }
      if (translateY < translateMinY) {
        translateY = translateMinY;
      }
      if (translateY > translateMaxY) {
        translateY = translateMaxY;
      }
    } else {
      translateX = 0;
      translateY = 0;
    }
    if (forceZoomRatio && zoom.scale === 1) {
      gesture.originX = 0;
      gesture.originY = 0;
    }
    gesture.imageWrapEl.style.transitionDuration = '300ms';
    gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
    gesture.imageEl.style.transitionDuration = '300ms';
    gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
  }
  function zoomOut() {
    const zoom = swiper.zoom;
    const params = swiper.params.zoom;
    if (!gesture.slideEl) {
      if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
        gesture.slideEl = elementChildren(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
      } else {
        gesture.slideEl = swiper.slides[swiper.activeIndex];
      }
      let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
      if (imageEl) {
        imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
      }
      gesture.imageEl = imageEl;
      if (imageEl) {
        gesture.imageWrapEl = elementParents(gesture.imageEl, `.${params.containerClass}`)[0];
      } else {
        gesture.imageWrapEl = undefined;
      }
    }
    if (!gesture.imageEl || !gesture.imageWrapEl) return;
    if (swiper.params.cssMode) {
      swiper.wrapperEl.style.overflow = '';
      swiper.wrapperEl.style.touchAction = '';
    }
    zoom.scale = 1;
    currentScale = 1;
    gesture.imageWrapEl.style.transitionDuration = '300ms';
    gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
    gesture.imageEl.style.transitionDuration = '300ms';
    gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
    gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
    gesture.slideEl = undefined;
    gesture.originX = 0;
    gesture.originY = 0;
  }

  // Toggle Zoom
  function zoomToggle(e) {
    const zoom = swiper.zoom;
    if (zoom.scale && zoom.scale !== 1) {
      // Zoom Out
      zoomOut();
    } else {
      // Zoom In
      zoomIn(e);
    }
  }
  function getListeners() {
    const passiveListener = swiper.params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    const activeListenerWithCapture = swiper.params.passiveListeners ? {
      passive: false,
      capture: true
    } : true;
    return {
      passiveListener,
      activeListenerWithCapture
    };
  }

  // Attach/Detach Events
  function enable() {
    const zoom = swiper.zoom;
    if (zoom.enabled) return;
    zoom.enabled = true;
    const {
      passiveListener,
      activeListenerWithCapture
    } = getListeners();

    // Scale image
    swiper.wrapperEl.addEventListener('pointerdown', onGestureStart, passiveListener);
    swiper.wrapperEl.addEventListener('pointermove', onGestureChange, activeListenerWithCapture);
    ['pointerup', 'pointercancel', 'pointerout'].forEach(eventName => {
      swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
    });

    // Move image
    swiper.wrapperEl.addEventListener('pointermove', onTouchMove, activeListenerWithCapture);
  }
  function disable() {
    const zoom = swiper.zoom;
    if (!zoom.enabled) return;
    zoom.enabled = false;
    const {
      passiveListener,
      activeListenerWithCapture
    } = getListeners();

    // Scale image
    swiper.wrapperEl.removeEventListener('pointerdown', onGestureStart, passiveListener);
    swiper.wrapperEl.removeEventListener('pointermove', onGestureChange, activeListenerWithCapture);
    ['pointerup', 'pointercancel', 'pointerout'].forEach(eventName => {
      swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
    });

    // Move image
    swiper.wrapperEl.removeEventListener('pointermove', onTouchMove, activeListenerWithCapture);
  }
  on('init', () => {
    if (swiper.params.zoom.enabled) {
      enable();
    }
  });
  on('destroy', () => {
    disable();
  });
  on('touchStart', (_s, e) => {
    if (!swiper.zoom.enabled) return;
    onTouchStart(e);
  });
  on('touchEnd', (_s, e) => {
    if (!swiper.zoom.enabled) return;
    onTouchEnd();
  });
  on('doubleTap', (_s, e) => {
    if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
      zoomToggle(e);
    }
  });
  on('transitionEnd', () => {
    if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
      onTransitionEnd();
    }
  });
  on('slideChange', () => {
    if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) {
      onTransitionEnd();
    }
  });
  Object.assign(swiper.zoom, {
    enable,
    disable,
    in: zoomIn,
    out: zoomOut,
    toggle: zoomToggle
  });
}



;// CONCATENATED MODULE: ./node_modules/swiper/modules/controller.mjs


/* eslint no-bitwise: ["error", { "allow": [">>"] }] */
function Controller(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    controller: {
      control: undefined,
      inverse: false,
      by: 'slide' // or 'container'
    }
  });

  swiper.controller = {
    control: undefined
  };
  function LinearSpline(x, y) {
    const binarySearch = function search() {
      let maxIndex;
      let minIndex;
      let guess;
      return (array, val) => {
        minIndex = -1;
        maxIndex = array.length;
        while (maxIndex - minIndex > 1) {
          guess = maxIndex + minIndex >> 1;
          if (array[guess] <= val) {
            minIndex = guess;
          } else {
            maxIndex = guess;
          }
        }
        return maxIndex;
      };
    }();
    this.x = x;
    this.y = y;
    this.lastIndex = x.length - 1;
    // Given an x value (x2), return the expected y2 value:
    // (x1,y1) is the known point before given value,
    // (x3,y3) is the known point after given value.
    let i1;
    let i3;
    this.interpolate = function interpolate(x2) {
      if (!x2) return 0;

      // Get the indexes of x1 and x3 (the array indexes before and after given x2):
      i3 = binarySearch(this.x, x2);
      i1 = i3 - 1;

      // We have our indexes i1 & i3, so we can calculate already:
      // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
      return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
    };
    return this;
  }
  function getInterpolateFunction(c) {
    swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
  }
  function setTranslate(_t, byController) {
    const controlled = swiper.controller.control;
    let multiplier;
    let controlledTranslate;
    const Swiper = swiper.constructor;
    function setControlledTranslate(c) {
      if (c.destroyed) return;

      // this will create an Interpolate function based on the snapGrids
      // x is the Grid of the scrolled scroller and y will be the controlled scroller
      // it makes sense to create this only once and recall it for the interpolation
      // the function does a lot of value caching for performance
      const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
      if (swiper.params.controller.by === 'slide') {
        getInterpolateFunction(c);
        // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
        // but it did not work out
        controlledTranslate = -swiper.controller.spline.interpolate(-translate);
      }
      if (!controlledTranslate || swiper.params.controller.by === 'container') {
        multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
        if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) {
          multiplier = 1;
        }
        controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
      }
      if (swiper.params.controller.inverse) {
        controlledTranslate = c.maxTranslate() - controlledTranslate;
      }
      c.updateProgress(controlledTranslate);
      c.setTranslate(controlledTranslate, swiper);
      c.updateActiveIndex();
      c.updateSlidesClasses();
    }
    if (Array.isArray(controlled)) {
      for (let i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTranslate(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTranslate(controlled);
    }
  }
  function setTransition(duration, byController) {
    const Swiper = swiper.constructor;
    const controlled = swiper.controller.control;
    let i;
    function setControlledTransition(c) {
      if (c.destroyed) return;
      c.setTransition(duration, swiper);
      if (duration !== 0) {
        c.transitionStart();
        if (c.params.autoHeight) {
          nextTick(() => {
            c.updateAutoHeight();
          });
        }
        elementTransitionEnd(c.wrapperEl, () => {
          if (!controlled) return;
          c.transitionEnd();
        });
      }
    }
    if (Array.isArray(controlled)) {
      for (i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTransition(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTransition(controlled);
    }
  }
  function removeSpline() {
    if (!swiper.controller.control) return;
    if (swiper.controller.spline) {
      swiper.controller.spline = undefined;
      delete swiper.controller.spline;
    }
  }
  on('beforeInit', () => {
    if (typeof window !== 'undefined' && (
    // eslint-disable-line
    typeof swiper.params.controller.control === 'string' || swiper.params.controller.control instanceof HTMLElement)) {
      const controlElement = document.querySelector(swiper.params.controller.control);
      if (controlElement && controlElement.swiper) {
        swiper.controller.control = controlElement.swiper;
      } else if (controlElement) {
        const onControllerSwiper = e => {
          swiper.controller.control = e.detail[0];
          swiper.update();
          controlElement.removeEventListener('init', onControllerSwiper);
        };
        controlElement.addEventListener('init', onControllerSwiper);
      }
      return;
    }
    swiper.controller.control = swiper.params.controller.control;
  });
  on('update', () => {
    removeSpline();
  });
  on('resize', () => {
    removeSpline();
  });
  on('observerUpdate', () => {
    removeSpline();
  });
  on('setTranslate', (_s, translate, byController) => {
    if (!swiper.controller.control || swiper.controller.control.destroyed) return;
    swiper.controller.setTranslate(translate, byController);
  });
  on('setTransition', (_s, duration, byController) => {
    if (!swiper.controller.control || swiper.controller.control.destroyed) return;
    swiper.controller.setTransition(duration, byController);
  });
  Object.assign(swiper.controller, {
    setTranslate,
    setTransition
  });
}



;// CONCATENATED MODULE: ./node_modules/swiper/modules/a11y.mjs




function A11y(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    a11y: {
      enabled: true,
      notificationClass: 'swiper-notification',
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}',
      slideLabelMessage: '{{index}} / {{slidesLength}}',
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      itemRoleDescriptionMessage: null,
      slideRole: 'group',
      id: null
    }
  });
  swiper.a11y = {
    clicked: false
  };
  let liveRegion = null;
  let preventFocusHandler;
  let focusTargetSlideEl;
  let visibilityChangedTimestamp = new Date().getTime();
  function notify(message) {
    const notification = liveRegion;
    if (notification.length === 0) return;
    notification.innerHTML = '';
    notification.innerHTML = message;
  }
  function getRandomNumber(size) {
    if (size === void 0) {
      size = 16;
    }
    const randomChar = () => Math.round(16 * Math.random()).toString(16);
    return 'x'.repeat(size).replace(/x/g, randomChar);
  }
  function makeElFocusable(el) {
    el = (0,utils.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('tabIndex', '0');
    });
  }
  function makeElNotFocusable(el) {
    el = (0,utils.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('tabIndex', '-1');
    });
  }
  function addElRole(el, role) {
    el = (0,utils.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('role', role);
    });
  }
  function addElRoleDescription(el, description) {
    el = (0,utils.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-roledescription', description);
    });
  }
  function addElControls(el, controls) {
    el = (0,utils.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-controls', controls);
    });
  }
  function addElLabel(el, label) {
    el = (0,utils.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-label', label);
    });
  }
  function addElId(el, id) {
    el = (0,utils.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('id', id);
    });
  }
  function addElLive(el, live) {
    el = (0,utils.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-live', live);
    });
  }
  function disableEl(el) {
    el = (0,utils.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-disabled', true);
    });
  }
  function enableEl(el) {
    el = (0,utils.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-disabled', false);
    });
  }
  function onEnterOrSpaceKey(e) {
    if (e.keyCode !== 13 && e.keyCode !== 32) return;
    const params = swiper.params.a11y;
    const targetEl = e.target;
    if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
      if (!e.target.matches(classes_to_selector_classesToSelector(swiper.params.pagination.bulletClass))) return;
    }
    if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
      const prevEls = (0,utils.m)(swiper.navigation.prevEl);
      const nextEls = (0,utils.m)(swiper.navigation.nextEl);
      if (nextEls.includes(targetEl)) {
        if (!(swiper.isEnd && !swiper.params.loop)) {
          swiper.slideNext();
        }
        if (swiper.isEnd) {
          notify(params.lastSlideMessage);
        } else {
          notify(params.nextSlideMessage);
        }
      }
      if (prevEls.includes(targetEl)) {
        if (!(swiper.isBeginning && !swiper.params.loop)) {
          swiper.slidePrev();
        }
        if (swiper.isBeginning) {
          notify(params.firstSlideMessage);
        } else {
          notify(params.prevSlideMessage);
        }
      }
    }
    if (swiper.pagination && targetEl.matches(classes_to_selector_classesToSelector(swiper.params.pagination.bulletClass))) {
      targetEl.click();
    }
  }
  function updateNavigation() {
    if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
    const {
      nextEl,
      prevEl
    } = swiper.navigation;
    if (prevEl) {
      if (swiper.isBeginning) {
        disableEl(prevEl);
        makeElNotFocusable(prevEl);
      } else {
        enableEl(prevEl);
        makeElFocusable(prevEl);
      }
    }
    if (nextEl) {
      if (swiper.isEnd) {
        disableEl(nextEl);
        makeElNotFocusable(nextEl);
      } else {
        enableEl(nextEl);
        makeElFocusable(nextEl);
      }
    }
  }
  function hasPagination() {
    return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
  }
  function hasClickablePagination() {
    return hasPagination() && swiper.params.pagination.clickable;
  }
  function updatePagination() {
    const params = swiper.params.a11y;
    if (!hasPagination()) return;
    swiper.pagination.bullets.forEach(bulletEl => {
      if (swiper.params.pagination.clickable) {
        makeElFocusable(bulletEl);
        if (!swiper.params.pagination.renderBullet) {
          addElRole(bulletEl, 'button');
          addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0,utils.h)(bulletEl) + 1));
        }
      }
      if (bulletEl.matches(classes_to_selector_classesToSelector(swiper.params.pagination.bulletActiveClass))) {
        bulletEl.setAttribute('aria-current', 'true');
      } else {
        bulletEl.removeAttribute('aria-current');
      }
    });
  }
  const initNavEl = (el, wrapperId, message) => {
    makeElFocusable(el);
    if (el.tagName !== 'BUTTON') {
      addElRole(el, 'button');
      el.addEventListener('keydown', onEnterOrSpaceKey);
    }
    addElLabel(el, message);
    addElControls(el, wrapperId);
  };
  const handlePointerDown = e => {
    if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) {
      preventFocusHandler = true;
    }
    swiper.a11y.clicked = true;
  };
  const handlePointerUp = () => {
    preventFocusHandler = false;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!swiper.destroyed) {
          swiper.a11y.clicked = false;
        }
      });
    });
  };
  const onVisibilityChange = e => {
    visibilityChangedTimestamp = new Date().getTime();
  };
  const handleFocus = e => {
    if (swiper.a11y.clicked) return;
    if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
    const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
    if (!slideEl || !swiper.slides.includes(slideEl)) return;
    focusTargetSlideEl = slideEl;
    const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
    const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
    if (isActive || isVisible) return;
    if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
    if (swiper.isHorizontal()) {
      swiper.el.scrollLeft = 0;
    } else {
      swiper.el.scrollTop = 0;
    }
    requestAnimationFrame(() => {
      if (preventFocusHandler) return;
      swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
      preventFocusHandler = false;
    });
  };
  const initSlides = () => {
    const params = swiper.params.a11y;
    if (params.itemRoleDescriptionMessage) {
      addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
    }
    if (params.slideRole) {
      addElRole(swiper.slides, params.slideRole);
    }
    const slidesLength = swiper.slides.length;
    if (params.slideLabelMessage) {
      swiper.slides.forEach((slideEl, index) => {
        const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10) : index;
        const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
        addElLabel(slideEl, ariaLabelMessage);
      });
    }
  };
  const init = () => {
    const params = swiper.params.a11y;
    swiper.el.append(liveRegion);

    // Container
    const containerEl = swiper.el;
    if (params.containerRoleDescriptionMessage) {
      addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
    }
    if (params.containerMessage) {
      addElLabel(containerEl, params.containerMessage);
    }

    // Wrapper
    const wrapperEl = swiper.wrapperEl;
    const wrapperId = params.id || wrapperEl.getAttribute('id') || `swiper-wrapper-${getRandomNumber(16)}`;
    const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
    addElId(wrapperEl, wrapperId);
    addElLive(wrapperEl, live);

    // Slide
    initSlides();

    // Navigation
    let {
      nextEl,
      prevEl
    } = swiper.navigation ? swiper.navigation : {};
    nextEl = (0,utils.m)(nextEl);
    prevEl = (0,utils.m)(prevEl);
    if (nextEl) {
      nextEl.forEach(el => initNavEl(el, wrapperId, params.nextSlideMessage));
    }
    if (prevEl) {
      prevEl.forEach(el => initNavEl(el, wrapperId, params.prevSlideMessage));
    }

    // Pagination
    if (hasClickablePagination()) {
      const paginationEl = (0,utils.m)(swiper.pagination.el);
      paginationEl.forEach(el => {
        el.addEventListener('keydown', onEnterOrSpaceKey);
      });
    }

    // Tab focus
    const document = (0,ssr_window_esm.g)();
    document.addEventListener('visibilitychange', onVisibilityChange);
    swiper.el.addEventListener('focus', handleFocus, true);
    swiper.el.addEventListener('focus', handleFocus, true);
    swiper.el.addEventListener('pointerdown', handlePointerDown, true);
    swiper.el.addEventListener('pointerup', handlePointerUp, true);
  };
  function destroy() {
    if (liveRegion) liveRegion.remove();
    let {
      nextEl,
      prevEl
    } = swiper.navigation ? swiper.navigation : {};
    nextEl = (0,utils.m)(nextEl);
    prevEl = (0,utils.m)(prevEl);
    if (nextEl) {
      nextEl.forEach(el => el.removeEventListener('keydown', onEnterOrSpaceKey));
    }
    if (prevEl) {
      prevEl.forEach(el => el.removeEventListener('keydown', onEnterOrSpaceKey));
    }

    // Pagination
    if (hasClickablePagination()) {
      const paginationEl = (0,utils.m)(swiper.pagination.el);
      paginationEl.forEach(el => {
        el.removeEventListener('keydown', onEnterOrSpaceKey);
      });
    }
    const document = (0,ssr_window_esm.g)();
    document.removeEventListener('visibilitychange', onVisibilityChange);
    // Tab focus
    swiper.el.removeEventListener('focus', handleFocus, true);
    swiper.el.removeEventListener('pointerdown', handlePointerDown, true);
    swiper.el.removeEventListener('pointerup', handlePointerUp, true);
  }
  on('beforeInit', () => {
    liveRegion = (0,utils.c)('span', swiper.params.a11y.notificationClass);
    liveRegion.setAttribute('aria-live', 'assertive');
    liveRegion.setAttribute('aria-atomic', 'true');
  });
  on('afterInit', () => {
    if (!swiper.params.a11y.enabled) return;
    init();
  });
  on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', () => {
    if (!swiper.params.a11y.enabled) return;
    initSlides();
  });
  on('fromEdge toEdge afterInit lock unlock', () => {
    if (!swiper.params.a11y.enabled) return;
    updateNavigation();
  });
  on('paginationUpdate', () => {
    if (!swiper.params.a11y.enabled) return;
    updatePagination();
  });
  on('destroy', () => {
    if (!swiper.params.a11y.enabled) return;
    destroy();
  });
}



;// CONCATENATED MODULE: ./node_modules/swiper/modules/history.mjs


function History(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    history: {
      enabled: false,
      root: '',
      replaceState: false,
      key: 'slides',
      keepQuery: false
    }
  });
  let initialized = false;
  let paths = {};
  const slugify = text => {
    return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
  };
  const getPathValues = urlOverride => {
    const window = getWindow();
    let location;
    if (urlOverride) {
      location = new URL(urlOverride);
    } else {
      location = window.location;
    }
    const pathArray = location.pathname.slice(1).split('/').filter(part => part !== '');
    const total = pathArray.length;
    const key = pathArray[total - 2];
    const value = pathArray[total - 1];
    return {
      key,
      value
    };
  };
  const setHistory = (key, index) => {
    const window = getWindow();
    if (!initialized || !swiper.params.history.enabled) return;
    let location;
    if (swiper.params.url) {
      location = new URL(swiper.params.url);
    } else {
      location = window.location;
    }
    const slide = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${index}"]`) : swiper.slides[index];
    let value = slugify(slide.getAttribute('data-history'));
    if (swiper.params.history.root.length > 0) {
      let root = swiper.params.history.root;
      if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
      value = `${root}/${key ? `${key}/` : ''}${value}`;
    } else if (!location.pathname.includes(key)) {
      value = `${key ? `${key}/` : ''}${value}`;
    }
    if (swiper.params.history.keepQuery) {
      value += location.search;
    }
    const currentState = window.history.state;
    if (currentState && currentState.value === value) {
      return;
    }
    if (swiper.params.history.replaceState) {
      window.history.replaceState({
        value
      }, null, value);
    } else {
      window.history.pushState({
        value
      }, null, value);
    }
  };
  const scrollToSlide = (speed, value, runCallbacks) => {
    if (value) {
      for (let i = 0, length = swiper.slides.length; i < length; i += 1) {
        const slide = swiper.slides[i];
        const slideHistory = slugify(slide.getAttribute('data-history'));
        if (slideHistory === value) {
          const index = swiper.getSlideIndex(slide);
          swiper.slideTo(index, speed, runCallbacks);
        }
      }
    } else {
      swiper.slideTo(0, speed, runCallbacks);
    }
  };
  const setHistoryPopState = () => {
    paths = getPathValues(swiper.params.url);
    scrollToSlide(swiper.params.speed, paths.value, false);
  };
  const init = () => {
    const window = getWindow();
    if (!swiper.params.history) return;
    if (!window.history || !window.history.pushState) {
      swiper.params.history.enabled = false;
      swiper.params.hashNavigation.enabled = true;
      return;
    }
    initialized = true;
    paths = getPathValues(swiper.params.url);
    if (!paths.key && !paths.value) {
      if (!swiper.params.history.replaceState) {
        window.addEventListener('popstate', setHistoryPopState);
      }
      return;
    }
    scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
    if (!swiper.params.history.replaceState) {
      window.addEventListener('popstate', setHistoryPopState);
    }
  };
  const destroy = () => {
    const window = getWindow();
    if (!swiper.params.history.replaceState) {
      window.removeEventListener('popstate', setHistoryPopState);
    }
  };
  on('init', () => {
    if (swiper.params.history.enabled) {
      init();
    }
  });
  on('destroy', () => {
    if (swiper.params.history.enabled) {
      destroy();
    }
  });
  on('transitionEnd _freeModeNoMomentumRelease', () => {
    if (initialized) {
      setHistory(swiper.params.history.key, swiper.activeIndex);
    }
  });
  on('slideChange', () => {
    if (initialized && swiper.params.cssMode) {
      setHistory(swiper.params.history.key, swiper.activeIndex);
    }
  });
}



;// CONCATENATED MODULE: ./node_modules/swiper/modules/hash-navigation.mjs



function HashNavigation(_ref) {
  let {
    swiper,
    extendParams,
    emit,
    on
  } = _ref;
  let initialized = false;
  const document = getDocument();
  const window = getWindow();
  extendParams({
    hashNavigation: {
      enabled: false,
      replaceState: false,
      watchState: false,
      getSlideIndex(_s, hash) {
        if (swiper.virtual && swiper.params.virtual.enabled) {
          const slideWithHash = swiper.slides.filter(slideEl => slideEl.getAttribute('data-hash') === hash)[0];
          if (!slideWithHash) return 0;
          const index = parseInt(slideWithHash.getAttribute('data-swiper-slide-index'), 10);
          return index;
        }
        return swiper.getSlideIndex(elementChildren(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0]);
      }
    }
  });
  const onHashChange = () => {
    emit('hashChange');
    const newHash = document.location.hash.replace('#', '');
    const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
    const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') : '';
    if (newHash !== activeSlideHash) {
      const newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
      if (typeof newIndex === 'undefined' || Number.isNaN(newIndex)) return;
      swiper.slideTo(newIndex);
    }
  };
  const setHash = () => {
    if (!initialized || !swiper.params.hashNavigation.enabled) return;
    const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
    const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') || activeSlideEl.getAttribute('data-history') : '';
    if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
      window.history.replaceState(null, null, `#${activeSlideHash}` || '');
      emit('hashSet');
    } else {
      document.location.hash = activeSlideHash || '';
      emit('hashSet');
    }
  };
  const init = () => {
    if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
    initialized = true;
    const hash = document.location.hash.replace('#', '');
    if (hash) {
      const speed = 0;
      const index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
      swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
    }
    if (swiper.params.hashNavigation.watchState) {
      window.addEventListener('hashchange', onHashChange);
    }
  };
  const destroy = () => {
    if (swiper.params.hashNavigation.watchState) {
      window.removeEventListener('hashchange', onHashChange);
    }
  };
  on('init', () => {
    if (swiper.params.hashNavigation.enabled) {
      init();
    }
  });
  on('destroy', () => {
    if (swiper.params.hashNavigation.enabled) {
      destroy();
    }
  });
  on('transitionEnd _freeModeNoMomentumRelease', () => {
    if (initialized) {
      setHash();
    }
  });
  on('slideChange', () => {
    if (initialized && swiper.params.cssMode) {
      setHash();
    }
  });
}



;// CONCATENATED MODULE: ./node_modules/swiper/modules/autoplay.mjs


/* eslint no-underscore-dangle: "off" */
/* eslint no-use-before-define: "off" */
function Autoplay(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit,
    params
  } = _ref;
  swiper.autoplay = {
    running: false,
    paused: false,
    timeLeft: 0
  };
  extendParams({
    autoplay: {
      enabled: false,
      delay: 3000,
      waitForTransition: true,
      disableOnInteraction: false,
      stopOnLastSlide: false,
      reverseDirection: false,
      pauseOnMouseEnter: false
    }
  });
  let timeout;
  let raf;
  let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
  let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
  let autoplayTimeLeft;
  let autoplayStartTime = new Date().getTime();
  let wasPaused;
  let isTouched;
  let pausedByTouch;
  let touchStartTimeout;
  let slideChanged;
  let pausedByInteraction;
  let pausedByPointerEnter;
  function onTransitionEnd(e) {
    if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
    if (e.target !== swiper.wrapperEl) return;
    swiper.wrapperEl.removeEventListener('transitionend', onTransitionEnd);
    if (pausedByPointerEnter) {
      return;
    }
    resume();
  }
  const calcTimeLeft = () => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    if (swiper.autoplay.paused) {
      wasPaused = true;
    } else if (wasPaused) {
      autoplayDelayCurrent = autoplayTimeLeft;
      wasPaused = false;
    }
    const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
    swiper.autoplay.timeLeft = timeLeft;
    emit('autoplayTimeLeft', timeLeft, timeLeft / autoplayDelayTotal);
    raf = requestAnimationFrame(() => {
      calcTimeLeft();
    });
  };
  const getSlideDelay = () => {
    let activeSlideEl;
    if (swiper.virtual && swiper.params.virtual.enabled) {
      activeSlideEl = swiper.slides.filter(slideEl => slideEl.classList.contains('swiper-slide-active'))[0];
    } else {
      activeSlideEl = swiper.slides[swiper.activeIndex];
    }
    if (!activeSlideEl) return undefined;
    const currentSlideDelay = parseInt(activeSlideEl.getAttribute('data-swiper-autoplay'), 10);
    return currentSlideDelay;
  };
  const run = delayForce => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    cancelAnimationFrame(raf);
    calcTimeLeft();
    let delay = typeof delayForce === 'undefined' ? swiper.params.autoplay.delay : delayForce;
    autoplayDelayTotal = swiper.params.autoplay.delay;
    autoplayDelayCurrent = swiper.params.autoplay.delay;
    const currentSlideDelay = getSlideDelay();
    if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === 'undefined') {
      delay = currentSlideDelay;
      autoplayDelayTotal = currentSlideDelay;
      autoplayDelayCurrent = currentSlideDelay;
    }
    autoplayTimeLeft = delay;
    const speed = swiper.params.speed;
    const proceed = () => {
      if (!swiper || swiper.destroyed) return;
      if (swiper.params.autoplay.reverseDirection) {
        if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
          swiper.slidePrev(speed, true, true);
          emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(swiper.slides.length - 1, speed, true, true);
          emit('autoplay');
        }
      } else {
        if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
          swiper.slideNext(speed, true, true);
          emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(0, speed, true, true);
          emit('autoplay');
        }
      }
      if (swiper.params.cssMode) {
        autoplayStartTime = new Date().getTime();
        requestAnimationFrame(() => {
          run();
        });
      }
    };
    if (delay > 0) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        proceed();
      }, delay);
    } else {
      requestAnimationFrame(() => {
        proceed();
      });
    }

    // eslint-disable-next-line
    return delay;
  };
  const start = () => {
    autoplayStartTime = new Date().getTime();
    swiper.autoplay.running = true;
    run();
    emit('autoplayStart');
  };
  const stop = () => {
    swiper.autoplay.running = false;
    clearTimeout(timeout);
    cancelAnimationFrame(raf);
    emit('autoplayStop');
  };
  const pause = (internal, reset) => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    clearTimeout(timeout);
    if (!internal) {
      pausedByInteraction = true;
    }
    const proceed = () => {
      emit('autoplayPause');
      if (swiper.params.autoplay.waitForTransition) {
        swiper.wrapperEl.addEventListener('transitionend', onTransitionEnd);
      } else {
        resume();
      }
    };
    swiper.autoplay.paused = true;
    if (reset) {
      if (slideChanged) {
        autoplayTimeLeft = swiper.params.autoplay.delay;
      }
      slideChanged = false;
      proceed();
      return;
    }
    const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
    autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
    if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
    if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
    proceed();
  };
  const resume = () => {
    if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
    autoplayStartTime = new Date().getTime();
    if (pausedByInteraction) {
      pausedByInteraction = false;
      run(autoplayTimeLeft);
    } else {
      run();
    }
    swiper.autoplay.paused = false;
    emit('autoplayResume');
  };
  const onVisibilityChange = () => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    const document = (0,ssr_window_esm.g)();
    if (document.visibilityState === 'hidden') {
      pausedByInteraction = true;
      pause(true);
    }
    if (document.visibilityState === 'visible') {
      resume();
    }
  };
  const onPointerEnter = e => {
    if (e.pointerType !== 'mouse') return;
    pausedByInteraction = true;
    pausedByPointerEnter = true;
    if (swiper.animating || swiper.autoplay.paused) return;
    pause(true);
  };
  const onPointerLeave = e => {
    if (e.pointerType !== 'mouse') return;
    pausedByPointerEnter = false;
    if (swiper.autoplay.paused) {
      resume();
    }
  };
  const attachMouseEvents = () => {
    if (swiper.params.autoplay.pauseOnMouseEnter) {
      swiper.el.addEventListener('pointerenter', onPointerEnter);
      swiper.el.addEventListener('pointerleave', onPointerLeave);
    }
  };
  const detachMouseEvents = () => {
    swiper.el.removeEventListener('pointerenter', onPointerEnter);
    swiper.el.removeEventListener('pointerleave', onPointerLeave);
  };
  const attachDocumentEvents = () => {
    const document = (0,ssr_window_esm.g)();
    document.addEventListener('visibilitychange', onVisibilityChange);
  };
  const detachDocumentEvents = () => {
    const document = (0,ssr_window_esm.g)();
    document.removeEventListener('visibilitychange', onVisibilityChange);
  };
  on('init', () => {
    if (swiper.params.autoplay.enabled) {
      attachMouseEvents();
      attachDocumentEvents();
      start();
    }
  });
  on('destroy', () => {
    detachMouseEvents();
    detachDocumentEvents();
    if (swiper.autoplay.running) {
      stop();
    }
  });
  on('_freeModeStaticRelease', () => {
    if (pausedByTouch || pausedByInteraction) {
      resume();
    }
  });
  on('_freeModeNoMomentumRelease', () => {
    if (!swiper.params.autoplay.disableOnInteraction) {
      pause(true, true);
    } else {
      stop();
    }
  });
  on('beforeTransitionStart', (_s, speed, internal) => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    if (internal || !swiper.params.autoplay.disableOnInteraction) {
      pause(true, true);
    } else {
      stop();
    }
  });
  on('sliderFirstMove', () => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    if (swiper.params.autoplay.disableOnInteraction) {
      stop();
      return;
    }
    isTouched = true;
    pausedByTouch = false;
    pausedByInteraction = false;
    touchStartTimeout = setTimeout(() => {
      pausedByInteraction = true;
      pausedByTouch = true;
      pause(true);
    }, 200);
  });
  on('touchEnd', () => {
    if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
    clearTimeout(touchStartTimeout);
    clearTimeout(timeout);
    if (swiper.params.autoplay.disableOnInteraction) {
      pausedByTouch = false;
      isTouched = false;
      return;
    }
    if (pausedByTouch && swiper.params.cssMode) resume();
    pausedByTouch = false;
    isTouched = false;
  });
  on('slideChange', () => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    slideChanged = true;
  });
  Object.assign(swiper.autoplay, {
    start,
    stop,
    pause,
    resume
  });
}



;// CONCATENATED MODULE: ./node_modules/swiper/modules/thumbs.mjs



function Thumb(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: true,
      autoScrollOffset: 0,
      slideThumbActiveClass: 'swiper-slide-thumb-active',
      thumbsContainerClass: 'swiper-thumbs'
    }
  });
  let initialized = false;
  let swiperCreated = false;
  swiper.thumbs = {
    swiper: null
  };
  function onThumbClick() {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    const clickedIndex = thumbsSwiper.clickedIndex;
    const clickedSlide = thumbsSwiper.clickedSlide;
    if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
    if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
    let slideToIndex;
    if (thumbsSwiper.params.loop) {
      slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
    } else {
      slideToIndex = clickedIndex;
    }
    if (swiper.params.loop) {
      swiper.slideToLoop(slideToIndex);
    } else {
      swiper.slideTo(slideToIndex);
    }
  }
  function init() {
    const {
      thumbs: thumbsParams
    } = swiper.params;
    if (initialized) return false;
    initialized = true;
    const SwiperClass = swiper.constructor;
    if (thumbsParams.swiper instanceof SwiperClass) {
      swiper.thumbs.swiper = thumbsParams.swiper;
      Object.assign(swiper.thumbs.swiper.originalParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      Object.assign(swiper.thumbs.swiper.params, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      swiper.thumbs.swiper.update();
    } else if ((0,utils.l)(thumbsParams.swiper)) {
      const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
      Object.assign(thumbsSwiperParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
      swiperCreated = true;
    }
    swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
    swiper.thumbs.swiper.on('tap', onThumbClick);
    return true;
  }
  function update(initial) {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;

    // Activate thumbs
    let thumbsToActivate = 1;
    const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
    if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
      thumbsToActivate = swiper.params.slidesPerView;
    }
    if (!swiper.params.thumbs.multipleActiveThumbs) {
      thumbsToActivate = 1;
    }
    thumbsToActivate = Math.floor(thumbsToActivate);
    thumbsSwiper.slides.forEach(slideEl => slideEl.classList.remove(thumbActiveClass));
    if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) {
      for (let i = 0; i < thumbsToActivate; i += 1) {
        (0,utils.e)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach(slideEl => {
          slideEl.classList.add(thumbActiveClass);
        });
      }
    } else {
      for (let i = 0; i < thumbsToActivate; i += 1) {
        if (thumbsSwiper.slides[swiper.realIndex + i]) {
          thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
        }
      }
    }
    const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
    const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
    if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
      const currentThumbsIndex = thumbsSwiper.activeIndex;
      let newThumbsIndex;
      let direction;
      if (thumbsSwiper.params.loop) {
        const newThumbsSlide = thumbsSwiper.slides.filter(slideEl => slideEl.getAttribute('data-swiper-slide-index') === `${swiper.realIndex}`)[0];
        newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
        direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
      } else {
        newThumbsIndex = swiper.realIndex;
        direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
      }
      if (useOffset) {
        newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
      }
      if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
        if (thumbsSwiper.params.centeredSlides) {
          if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
          } else {
            newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
          }
        } else if (newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup === 1) ;
        thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
      }
    }
  }
  on('beforeInit', () => {
    const {
      thumbs
    } = swiper.params;
    if (!thumbs || !thumbs.swiper) return;
    if (typeof thumbs.swiper === 'string' || thumbs.swiper instanceof HTMLElement) {
      const document = (0,ssr_window_esm.g)();
      const getThumbsElementAndInit = () => {
        const thumbsElement = typeof thumbs.swiper === 'string' ? document.querySelector(thumbs.swiper) : thumbs.swiper;
        if (thumbsElement && thumbsElement.swiper) {
          thumbs.swiper = thumbsElement.swiper;
          init();
          update(true);
        } else if (thumbsElement) {
          const onThumbsSwiper = e => {
            thumbs.swiper = e.detail[0];
            thumbsElement.removeEventListener('init', onThumbsSwiper);
            init();
            update(true);
            thumbs.swiper.update();
            swiper.update();
          };
          thumbsElement.addEventListener('init', onThumbsSwiper);
        }
        return thumbsElement;
      };
      const watchForThumbsToAppear = () => {
        if (swiper.destroyed) return;
        const thumbsElement = getThumbsElementAndInit();
        if (!thumbsElement) {
          requestAnimationFrame(watchForThumbsToAppear);
        }
      };
      requestAnimationFrame(watchForThumbsToAppear);
    } else {
      init();
      update(true);
    }
  });
  on('slideChange update resize observerUpdate', () => {
    update();
  });
  on('setTransition', (_s, duration) => {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    thumbsSwiper.setTransition(duration);
  });
  on('beforeDestroy', () => {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    if (swiperCreated) {
      thumbsSwiper.destroy();
    }
  });
  Object.assign(swiper.thumbs, {
    init,
    update
  });
}



;// CONCATENATED MODULE: ./node_modules/swiper/modules/free-mode.mjs


function freeMode(_ref) {
  let {
    swiper,
    extendParams,
    emit,
    once
  } = _ref;
  extendParams({
    freeMode: {
      enabled: false,
      momentum: true,
      momentumRatio: 1,
      momentumBounce: true,
      momentumBounceRatio: 1,
      momentumVelocityRatio: 1,
      sticky: false,
      minimumVelocity: 0.02
    }
  });
  function onTouchStart() {
    if (swiper.params.cssMode) return;
    const translate = swiper.getTranslate();
    swiper.setTranslate(translate);
    swiper.setTransition(0);
    swiper.touchEventsData.velocities.length = 0;
    swiper.freeMode.onTouchEnd({
      currentPos: swiper.rtl ? swiper.translate : -swiper.translate
    });
  }
  function onTouchMove() {
    if (swiper.params.cssMode) return;
    const {
      touchEventsData: data,
      touches
    } = swiper;
    // Velocity
    if (data.velocities.length === 0) {
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
        time: data.touchStartTime
      });
    }
    data.velocities.push({
      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
      time: (0,utils.d)()
    });
  }
  function onTouchEnd(_ref2) {
    let {
      currentPos
    } = _ref2;
    if (swiper.params.cssMode) return;
    const {
      params,
      wrapperEl,
      rtlTranslate: rtl,
      snapGrid,
      touchEventsData: data
    } = swiper;
    // Time diff
    const touchEndTime = (0,utils.d)();
    const timeDiff = touchEndTime - data.touchStartTime;
    if (currentPos < -swiper.minTranslate()) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (currentPos > -swiper.maxTranslate()) {
      if (swiper.slides.length < snapGrid.length) {
        swiper.slideTo(snapGrid.length - 1);
      } else {
        swiper.slideTo(swiper.slides.length - 1);
      }
      return;
    }
    if (params.freeMode.momentum) {
      if (data.velocities.length > 1) {
        const lastMoveEvent = data.velocities.pop();
        const velocityEvent = data.velocities.pop();
        const distance = lastMoveEvent.position - velocityEvent.position;
        const time = lastMoveEvent.time - velocityEvent.time;
        swiper.velocity = distance / time;
        swiper.velocity /= 2;
        if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) {
          swiper.velocity = 0;
        }
        // this implies that the user stopped moving a finger then released.
        // There would be no events with distance zero, so the last event is stale.
        if (time > 150 || (0,utils.d)() - lastMoveEvent.time > 300) {
          swiper.velocity = 0;
        }
      } else {
        swiper.velocity = 0;
      }
      swiper.velocity *= params.freeMode.momentumVelocityRatio;
      data.velocities.length = 0;
      let momentumDuration = 1000 * params.freeMode.momentumRatio;
      const momentumDistance = swiper.velocity * momentumDuration;
      let newPosition = swiper.translate + momentumDistance;
      if (rtl) newPosition = -newPosition;
      let doBounce = false;
      let afterBouncePosition;
      const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
      let needsLoopFix;
      if (newPosition < swiper.maxTranslate()) {
        if (params.freeMode.momentumBounce) {
          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
            newPosition = swiper.maxTranslate() - bounceAmount;
          }
          afterBouncePosition = swiper.maxTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.maxTranslate();
        }
        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (newPosition > swiper.minTranslate()) {
        if (params.freeMode.momentumBounce) {
          if (newPosition - swiper.minTranslate() > bounceAmount) {
            newPosition = swiper.minTranslate() + bounceAmount;
          }
          afterBouncePosition = swiper.minTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.minTranslate();
        }
        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (params.freeMode.sticky) {
        let nextSlide;
        for (let j = 0; j < snapGrid.length; j += 1) {
          if (snapGrid[j] > -newPosition) {
            nextSlide = j;
            break;
          }
        }
        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
          newPosition = snapGrid[nextSlide];
        } else {
          newPosition = snapGrid[nextSlide - 1];
        }
        newPosition = -newPosition;
      }
      if (needsLoopFix) {
        once('transitionEnd', () => {
          swiper.loopFix();
        });
      }
      // Fix duration
      if (swiper.velocity !== 0) {
        if (rtl) {
          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
        } else {
          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
        }
        if (params.freeMode.sticky) {
          // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
          // event, then durations can be 20+ seconds to slide one (or zero!) slides.
          // It's easy to see this when simulating touch with mouse events. To fix this,
          // limit single-slide swipes to the default slide duration. This also has the
          // nice side effect of matching slide speed if the user stopped moving before
          // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
          // For faster swipes, also apply limits (albeit higher ones).
          const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
          const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
          if (moveDistance < currentSlideSize) {
            momentumDuration = params.speed;
          } else if (moveDistance < 2 * currentSlideSize) {
            momentumDuration = params.speed * 1.5;
          } else {
            momentumDuration = params.speed * 2.5;
          }
        }
      } else if (params.freeMode.sticky) {
        swiper.slideToClosest();
        return;
      }
      if (params.freeMode.momentumBounce && doBounce) {
        swiper.updateProgress(afterBouncePosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        swiper.animating = true;
        (0,utils.k)(wrapperEl, () => {
          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
          emit('momentumBounce');
          swiper.setTransition(params.speed);
          setTimeout(() => {
            swiper.setTranslate(afterBouncePosition);
            (0,utils.k)(wrapperEl, () => {
              if (!swiper || swiper.destroyed) return;
              swiper.transitionEnd();
            });
          }, 0);
        });
      } else if (swiper.velocity) {
        emit('_freeModeNoMomentumRelease');
        swiper.updateProgress(newPosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        if (!swiper.animating) {
          swiper.animating = true;
          (0,utils.k)(wrapperEl, () => {
            if (!swiper || swiper.destroyed) return;
            swiper.transitionEnd();
          });
        }
      } else {
        swiper.updateProgress(newPosition);
      }
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    } else if (params.freeMode.sticky) {
      swiper.slideToClosest();
      return;
    } else if (params.freeMode) {
      emit('_freeModeNoMomentumRelease');
    }
    if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
      emit('_freeModeStaticRelease');
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
  }
  Object.assign(swiper, {
    freeMode: {
      onTouchStart,
      onTouchMove,
      onTouchEnd
    }
  });
}



;// CONCATENATED MODULE: ./node_modules/swiper/shared/effect-init.mjs
function effect_init_effectInit(params) {
  const {
    effect,
    swiper,
    on,
    setTranslate,
    setTransition,
    overwriteParams,
    perspective,
    recreateShadows,
    getEffectParams
  } = params;
  on('beforeInit', () => {
    if (swiper.params.effect !== effect) return;
    swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
    if (perspective && perspective()) {
      swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
    }
    const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
    Object.assign(swiper.params, overwriteParamsResult);
    Object.assign(swiper.originalParams, overwriteParamsResult);
  });
  on('setTranslate', () => {
    if (swiper.params.effect !== effect) return;
    setTranslate();
  });
  on('setTransition', (_s, duration) => {
    if (swiper.params.effect !== effect) return;
    setTransition(duration);
  });
  on('transitionEnd', () => {
    if (swiper.params.effect !== effect) return;
    if (recreateShadows) {
      if (!getEffectParams || !getEffectParams().slideShadows) return;
      // remove shadows
      swiper.slides.forEach(slideEl => {
        slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach(shadowEl => shadowEl.remove());
      });
      // create new one
      recreateShadows();
    }
  });
  let requireUpdateOnVirtual;
  on('virtualUpdate', () => {
    if (swiper.params.effect !== effect) return;
    if (!swiper.slides.length) {
      requireUpdateOnVirtual = true;
    }
    requestAnimationFrame(() => {
      if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
        setTranslate();
        requireUpdateOnVirtual = false;
      }
    });
  });
}



;// CONCATENATED MODULE: ./node_modules/swiper/shared/effect-target.mjs


function effect_target_effectTarget(effectParams, slideEl) {
  const transformEl = (0,utils.g)(slideEl);
  if (transformEl !== slideEl) {
    transformEl.style.backfaceVisibility = 'hidden';
    transformEl.style['-webkit-backface-visibility'] = 'hidden';
  }
  return transformEl;
}



;// CONCATENATED MODULE: ./node_modules/swiper/shared/effect-virtual-transition-end.mjs


function effect_virtual_transition_end_effectVirtualTransitionEnd(_ref) {
  let {
    swiper,
    duration,
    transformElements,
    allSlides
  } = _ref;
  const {
    activeIndex
  } = swiper;
  const getSlide = el => {
    if (!el.parentElement) {
      // assume shadow root
      const slide = swiper.slides.filter(slideEl => slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode)[0];
      return slide;
    }
    return el.parentElement;
  };
  if (swiper.params.virtualTranslate && duration !== 0) {
    let eventTriggered = false;
    let transitionEndTarget;
    if (allSlides) {
      transitionEndTarget = transformElements;
    } else {
      transitionEndTarget = transformElements.filter(transformEl => {
        const el = transformEl.classList.contains('swiper-slide-transform') ? getSlide(transformEl) : transformEl;
        return swiper.getSlideIndex(el) === activeIndex;
      });
    }
    transitionEndTarget.forEach(el => {
      (0,utils.k)(el, () => {
        if (eventTriggered) return;
        if (!swiper || swiper.destroyed) return;
        eventTriggered = true;
        swiper.animating = false;
        const evt = new window.CustomEvent('transitionend', {
          bubbles: true,
          cancelable: true
        });
        swiper.wrapperEl.dispatchEvent(evt);
      });
    });
  }
}



;// CONCATENATED MODULE: ./node_modules/swiper/modules/effect-fade.mjs





function EffectFade(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    fadeEffect: {
      crossFade: false
    }
  });
  const setTranslate = () => {
    const {
      slides
    } = swiper;
    const params = swiper.params.fadeEffect;
    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = swiper.slides[i];
      const offset = slideEl.swiperSlideOffset;
      let tx = -offset;
      if (!swiper.params.virtualTranslate) tx -= swiper.translate;
      let ty = 0;
      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
      }
      const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
      const targetEl = effect_target_effectTarget(params, slideEl);
      targetEl.style.opacity = slideOpacity;
      targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
    }
  };
  const setTransition = duration => {
    const transformElements = swiper.slides.map(slideEl => (0,utils.g)(slideEl));
    transformElements.forEach(el => {
      el.style.transitionDuration = `${duration}ms`;
    });
    effect_virtual_transition_end_effectVirtualTransitionEnd({
      swiper,
      duration,
      transformElements,
      allSlides: true
    });
  };
  effect_init_effectInit({
    effect: 'fade',
    swiper,
    on,
    setTranslate,
    setTransition,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      spaceBetween: 0,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}



;// CONCATENATED MODULE: ./node_modules/swiper/modules/effect-cube.mjs



function EffectCube(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    cubeEffect: {
      slideShadows: true,
      shadow: true,
      shadowOffset: 20,
      shadowScale: 0.94
    }
  });
  const createSlideShadows = (slideEl, progress, isHorizontal) => {
    let shadowBefore = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
    let shadowAfter = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
    if (!shadowBefore) {
      shadowBefore = createElement('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}`.split(' '));
      slideEl.append(shadowBefore);
    }
    if (!shadowAfter) {
      shadowAfter = createElement('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}`.split(' '));
      slideEl.append(shadowAfter);
    }
    if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
    if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
  };
  const recreateShadows = () => {
    // create new ones
    const isHorizontal = swiper.isHorizontal();
    swiper.slides.forEach(slideEl => {
      const progress = Math.max(Math.min(slideEl.progress, 1), -1);
      createSlideShadows(slideEl, progress, isHorizontal);
    });
  };
  const setTranslate = () => {
    const {
      el,
      wrapperEl,
      slides,
      width: swiperWidth,
      height: swiperHeight,
      rtlTranslate: rtl,
      size: swiperSize,
      browser
    } = swiper;
    const params = swiper.params.cubeEffect;
    const isHorizontal = swiper.isHorizontal();
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let wrapperRotate = 0;
    let cubeShadowEl;
    if (params.shadow) {
      if (isHorizontal) {
        cubeShadowEl = swiper.wrapperEl.querySelector('.swiper-cube-shadow');
        if (!cubeShadowEl) {
          cubeShadowEl = createElement('div', 'swiper-cube-shadow');
          swiper.wrapperEl.append(cubeShadowEl);
        }
        cubeShadowEl.style.height = `${swiperWidth}px`;
      } else {
        cubeShadowEl = el.querySelector('.swiper-cube-shadow');
        if (!cubeShadowEl) {
          cubeShadowEl = createElement('div', 'swiper-cube-shadow');
          el.append(cubeShadowEl);
        }
      }
    }
    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = slides[i];
      let slideIndex = i;
      if (isVirtual) {
        slideIndex = parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10);
      }
      let slideAngle = slideIndex * 90;
      let round = Math.floor(slideAngle / 360);
      if (rtl) {
        slideAngle = -slideAngle;
        round = Math.floor(-slideAngle / 360);
      }
      const progress = Math.max(Math.min(slideEl.progress, 1), -1);
      let tx = 0;
      let ty = 0;
      let tz = 0;
      if (slideIndex % 4 === 0) {
        tx = -round * 4 * swiperSize;
        tz = 0;
      } else if ((slideIndex - 1) % 4 === 0) {
        tx = 0;
        tz = -round * 4 * swiperSize;
      } else if ((slideIndex - 2) % 4 === 0) {
        tx = swiperSize + round * 4 * swiperSize;
        tz = swiperSize;
      } else if ((slideIndex - 3) % 4 === 0) {
        tx = -swiperSize;
        tz = 3 * swiperSize + swiperSize * 4 * round;
      }
      if (rtl) {
        tx = -tx;
      }
      if (!isHorizontal) {
        ty = tx;
        tx = 0;
      }
      const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
      if (progress <= 1 && progress > -1) {
        wrapperRotate = slideIndex * 90 + progress * 90;
        if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
        if (swiper.browser && swiper.browser.need3dFix && Math.abs(wrapperRotate) / 90 % 2 === 1) {
          wrapperRotate += 0.001;
        }
      }
      slideEl.style.transform = transform;
      if (params.slideShadows) {
        createSlideShadows(slideEl, progress, isHorizontal);
      }
    }
    wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
    wrapperEl.style['-webkit-transform-origin'] = `50% 50% -${swiperSize / 2}px`;
    if (params.shadow) {
      if (isHorizontal) {
        cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${params.shadowScale})`;
      } else {
        const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
        const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
        const scale1 = params.shadowScale;
        const scale2 = params.shadowScale / multiplier;
        const offset = params.shadowOffset;
        cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-89.99deg)`;
      }
    }
    const zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
    wrapperEl.style.transform = `translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`;
    wrapperEl.style.setProperty('--swiper-cube-translate-z', `${zFactor}px`);
  };
  const setTransition = duration => {
    const {
      el,
      slides
    } = swiper;
    slides.forEach(slideEl => {
      slideEl.style.transitionDuration = `${duration}ms`;
      slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach(subEl => {
        subEl.style.transitionDuration = `${duration}ms`;
      });
    });
    if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
      const shadowEl = el.querySelector('.swiper-cube-shadow');
      if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
    }
  };
  effectInit({
    effect: 'cube',
    swiper,
    on,
    setTranslate,
    setTransition,
    recreateShadows,
    getEffectParams: () => swiper.params.cubeEffect,
    perspective: () => true,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      resistanceRatio: 0,
      spaceBetween: 0,
      centeredSlides: false,
      virtualTranslate: true
    })
  });
}



;// CONCATENATED MODULE: ./node_modules/swiper/shared/create-shadow.mjs


function create_shadow_createShadow(suffix, slideEl, side) {
  const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}${suffix ? ` swiper-slide-shadow-${suffix}` : ''}`;
  const shadowContainer = getSlideTransformEl(slideEl);
  let shadowEl = shadowContainer.querySelector(`.${shadowClass.split(' ').join('.')}`);
  if (!shadowEl) {
    shadowEl = createElement('div', shadowClass.split(' '));
    shadowContainer.append(shadowEl);
  }
  return shadowEl;
}



;// CONCATENATED MODULE: ./node_modules/swiper/modules/effect-flip.mjs






function EffectFlip(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    flipEffect: {
      slideShadows: true,
      limitRotation: true
    }
  });
  const createSlideShadows = (slideEl, progress) => {
    let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
    let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
    if (!shadowBefore) {
      shadowBefore = createShadow('flip', slideEl, swiper.isHorizontal() ? 'left' : 'top');
    }
    if (!shadowAfter) {
      shadowAfter = createShadow('flip', slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
    }
    if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
    if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
  };
  const recreateShadows = () => {
    // Set shadows
    swiper.params.flipEffect;
    swiper.slides.forEach(slideEl => {
      let progress = slideEl.progress;
      if (swiper.params.flipEffect.limitRotation) {
        progress = Math.max(Math.min(slideEl.progress, 1), -1);
      }
      createSlideShadows(slideEl, progress);
    });
  };
  const setTranslate = () => {
    const {
      slides,
      rtlTranslate: rtl
    } = swiper;
    const params = swiper.params.flipEffect;
    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = slides[i];
      let progress = slideEl.progress;
      if (swiper.params.flipEffect.limitRotation) {
        progress = Math.max(Math.min(slideEl.progress, 1), -1);
      }
      const offset = slideEl.swiperSlideOffset;
      const rotate = -180 * progress;
      let rotateY = rotate;
      let rotateX = 0;
      let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
      let ty = 0;
      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
        rotateX = -rotateY;
        rotateY = 0;
      } else if (rtl) {
        rotateY = -rotateY;
      }
      if (swiper.browser && swiper.browser.need3dFix) {
        if (Math.abs(rotateY) / 90 % 2 === 1) {
          rotateY += 0.001;
        }
        if (Math.abs(rotateX) / 90 % 2 === 1) {
          rotateX += 0.001;
        }
      }
      slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
      if (params.slideShadows) {
        createSlideShadows(slideEl, progress);
      }
      const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
      const targetEl = effectTarget(params, slideEl);
      targetEl.style.transform = transform;
    }
  };
  const setTransition = duration => {
    const transformElements = swiper.slides.map(slideEl => getSlideTransformEl(slideEl));
    transformElements.forEach(el => {
      el.style.transitionDuration = `${duration}ms`;
      el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach(shadowEl => {
        shadowEl.style.transitionDuration = `${duration}ms`;
      });
    });
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformElements
    });
  };
  effectInit({
    effect: 'flip',
    swiper,
    on,
    setTranslate,
    setTransition,
    recreateShadows,
    getEffectParams: () => swiper.params.flipEffect,
    perspective: () => true,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      spaceBetween: 0,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}



;// CONCATENATED MODULE: ./node_modules/swiper/modules/effect-coverflow.mjs





function EffectCoverflow(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      scale: 1,
      modifier: 1,
      slideShadows: true
    }
  });
  const setTranslate = () => {
    const {
      width: swiperWidth,
      height: swiperHeight,
      slides,
      slidesSizesGrid
    } = swiper;
    const params = swiper.params.coverflowEffect;
    const isHorizontal = swiper.isHorizontal();
    const transform = swiper.translate;
    const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
    const rotate = isHorizontal ? params.rotate : -params.rotate;
    const translate = params.depth;
    // Each slide offset from center
    for (let i = 0, length = slides.length; i < length; i += 1) {
      const slideEl = slides[i];
      const slideSize = slidesSizesGrid[i];
      const slideOffset = slideEl.swiperSlideOffset;
      const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
      const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
      let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
      let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
      // var rotateZ = 0
      let translateZ = -translate * Math.abs(offsetMultiplier);
      let stretch = params.stretch;
      // Allow percentage to make a relative stretch for responsive sliders
      if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) {
        stretch = parseFloat(params.stretch) / 100 * slideSize;
      }
      let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
      let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
      let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);

      // Fix for ultra small values
      if (Math.abs(translateX) < 0.001) translateX = 0;
      if (Math.abs(translateY) < 0.001) translateY = 0;
      if (Math.abs(translateZ) < 0.001) translateZ = 0;
      if (Math.abs(rotateY) < 0.001) rotateY = 0;
      if (Math.abs(rotateX) < 0.001) rotateX = 0;
      if (Math.abs(scale) < 0.001) scale = 0;
      if (swiper.browser && swiper.browser.need3dFix) {
        if (Math.abs(rotateY) / 90 % 2 === 1) {
          rotateY += 0.001;
        }
        if (Math.abs(rotateX) / 90 % 2 === 1) {
          rotateX += 0.001;
        }
      }
      const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
      const targetEl = effectTarget(params, slideEl);
      targetEl.style.transform = slideTransform;
      slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
      if (params.slideShadows) {
        // Set shadows
        let shadowBeforeEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfterEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBeforeEl) {
          shadowBeforeEl = createShadow('coverflow', slideEl, isHorizontal ? 'left' : 'top');
        }
        if (!shadowAfterEl) {
          shadowAfterEl = createShadow('coverflow', slideEl, isHorizontal ? 'right' : 'bottom');
        }
        if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
        if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
      }
    }
  };
  const setTransition = duration => {
    const transformElements = swiper.slides.map(slideEl => getSlideTransformEl(slideEl));
    transformElements.forEach(el => {
      el.style.transitionDuration = `${duration}ms`;
      el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach(shadowEl => {
        shadowEl.style.transitionDuration = `${duration}ms`;
      });
    });
  };
  effectInit({
    effect: 'coverflow',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => true,
    overwriteParams: () => ({
      watchSlidesProgress: true
    })
  });
}



;// CONCATENATED MODULE: ./node_modules/swiper/modules/effect-creative.mjs






function EffectCreative(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    creativeEffect: {
      limitProgress: 1,
      shadowPerProgress: false,
      progressMultiplier: 1,
      perspective: true,
      prev: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      },
      next: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      }
    }
  });
  const getTranslateValue = value => {
    if (typeof value === 'string') return value;
    return `${value}px`;
  };
  const setTranslate = () => {
    const {
      slides,
      wrapperEl,
      slidesSizesGrid
    } = swiper;
    const params = swiper.params.creativeEffect;
    const {
      progressMultiplier: multiplier
    } = params;
    const isCenteredSlides = swiper.params.centeredSlides;
    if (isCenteredSlides) {
      const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
      wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
    }
    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = slides[i];
      const slideProgress = slideEl.progress;
      const progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
      let originalProgress = progress;
      if (!isCenteredSlides) {
        originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
      }
      const offset = slideEl.swiperSlideOffset;
      const t = [swiper.params.cssMode ? -offset - swiper.translate : -offset, 0, 0];
      const r = [0, 0, 0];
      let custom = false;
      if (!swiper.isHorizontal()) {
        t[1] = t[0];
        t[0] = 0;
      }
      let data = {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        scale: 1,
        opacity: 1
      };
      if (progress < 0) {
        data = params.next;
        custom = true;
      } else if (progress > 0) {
        data = params.prev;
        custom = true;
      }
      // set translate
      t.forEach((value, index) => {
        t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
      });
      // set rotates
      r.forEach((value, index) => {
        let val = data.rotate[index] * Math.abs(progress * multiplier);
        if (swiper.browser && swiper.browser.need3dFix && Math.abs(val) / 90 % 2 === 1) {
          val += 0.001;
        }
        r[index] = val;
      });
      slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
      const translateString = t.join(', ');
      const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
      const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
      const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
      const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;

      // Set shadows
      if (custom && data.shadow || !custom) {
        let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
        if (!shadowEl && data.shadow) {
          shadowEl = createShadow('creative', slideEl);
        }
        if (shadowEl) {
          const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
          shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
        }
      }
      const targetEl = effectTarget(params, slideEl);
      targetEl.style.transform = transform;
      targetEl.style.opacity = opacityString;
      if (data.origin) {
        targetEl.style.transformOrigin = data.origin;
      }
    }
  };
  const setTransition = duration => {
    const transformElements = swiper.slides.map(slideEl => getSlideTransformEl(slideEl));
    transformElements.forEach(el => {
      el.style.transitionDuration = `${duration}ms`;
      el.querySelectorAll('.swiper-slide-shadow').forEach(shadowEl => {
        shadowEl.style.transitionDuration = `${duration}ms`;
      });
    });
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformElements,
      allSlides: true
    });
  };
  effectInit({
    effect: 'creative',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => swiper.params.creativeEffect.perspective,
    overwriteParams: () => ({
      watchSlidesProgress: true,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}



;// CONCATENATED MODULE: ./node_modules/swiper/modules/effect-cards.mjs






function EffectCards(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    cardsEffect: {
      slideShadows: true,
      rotate: true,
      perSlideRotate: 2,
      perSlideOffset: 8
    }
  });
  const setTranslate = () => {
    const {
      slides,
      activeIndex,
      rtlTranslate: rtl
    } = swiper;
    const params = swiper.params.cardsEffect;
    const {
      startTranslate,
      isTouched
    } = swiper.touchEventsData;
    const currentTranslate = rtl ? -swiper.translate : swiper.translate;
    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = slides[i];
      const slideProgress = slideEl.progress;
      const progress = Math.min(Math.max(slideProgress, -4), 4);
      let offset = slideEl.swiperSlideOffset;
      if (swiper.params.centeredSlides && !swiper.params.cssMode) {
        swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
      }
      if (swiper.params.centeredSlides && swiper.params.cssMode) {
        offset -= slides[0].swiperSlideOffset;
      }
      let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
      let tY = 0;
      const tZ = -100 * Math.abs(progress);
      let scale = 1;
      let rotate = -params.perSlideRotate * progress;
      let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
      const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
      const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
      const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
      if (isSwipeToNext || isSwipeToPrev) {
        const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
        rotate += -28 * progress * subProgress;
        scale += -0.5 * subProgress;
        tXAdd += 96 * subProgress;
        tY = `${-25 * subProgress * Math.abs(progress)}%`;
      }
      if (progress < 0) {
        // next
        tX = `calc(${tX}px ${rtl ? '-' : '+'} (${tXAdd * Math.abs(progress)}%))`;
      } else if (progress > 0) {
        // prev
        tX = `calc(${tX}px ${rtl ? '-' : '+'} (-${tXAdd * Math.abs(progress)}%))`;
      } else {
        tX = `${tX}px`;
      }
      if (!swiper.isHorizontal()) {
        const prevY = tY;
        tY = tX;
        tX = prevY;
      }
      const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;

      /* eslint-disable */
      const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
      /* eslint-enable */

      if (params.slideShadows) {
        // Set shadows
        let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
        if (!shadowEl) {
          shadowEl = createShadow('cards', slideEl);
        }
        if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
      }
      slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
      const targetEl = effectTarget(params, slideEl);
      targetEl.style.transform = transform;
    }
  };
  const setTransition = duration => {
    const transformElements = swiper.slides.map(slideEl => getSlideTransformEl(slideEl));
    transformElements.forEach(el => {
      el.style.transitionDuration = `${duration}ms`;
      el.querySelectorAll('.swiper-slide-shadow').forEach(shadowEl => {
        shadowEl.style.transitionDuration = `${duration}ms`;
      });
    });
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformElements
    });
  };
  effectInit({
    effect: 'cards',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => true,
    overwriteParams: () => ({
      watchSlidesProgress: true,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}



;// CONCATENATED MODULE: ./node_modules/swiper/modules/index.mjs
























/***/ }),

/***/ 13433:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ getWindow; },
/* harmony export */   "g": function() { return /* binding */ getDocument; }
/* harmony export */ });
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */
/* eslint-disable no-param-reassign */
function isObject(obj) {
  return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function extend(target, src) {
  if (target === void 0) {
    target = {};
  }
  if (src === void 0) {
    src = {};
  }
  Object.keys(src).forEach(key => {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
      extend(target[key], src[key]);
    }
  });
}
const ssrDocument = {
  body: {},
  addEventListener() {},
  removeEventListener() {},
  activeElement: {
    blur() {},
    nodeName: ''
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {}
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {},
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  }
};
function getDocument() {
  const doc = typeof document !== 'undefined' ? document : {};
  extend(doc, ssrDocument);
  return doc;
}
const ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ''
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  },
  history: {
    replaceState() {},
    pushState() {},
    go() {},
    back() {}
  },
  CustomEvent: function CustomEvent() {
    return this;
  },
  addEventListener() {},
  removeEventListener() {},
  getComputedStyle() {
    return {
      getPropertyValue() {
        return '';
      }
    };
  },
  Image() {},
  Date() {},
  screen: {},
  setTimeout() {},
  clearTimeout() {},
  matchMedia() {
    return {};
  },
  requestAnimationFrame(callback) {
    if (typeof setTimeout === 'undefined') {
      callback();
      return null;
    }
    return setTimeout(callback, 0);
  },
  cancelAnimationFrame(id) {
    if (typeof setTimeout === 'undefined') {
      return;
    }
    clearTimeout(id);
  }
};
function getWindow() {
  const win = typeof window !== 'undefined' ? window : {};
  extend(win, ssrWindow);
  return win;
}




/***/ }),

/***/ 96236:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ Swiper; },
/* harmony export */   "d": function() { return /* binding */ defaults; }
/* harmony export */ });
/* harmony import */ var _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13433);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7185);



let support;
function calcSupport() {
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  const document = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
  return {
    smoothScroll: document.documentElement && document.documentElement.style && 'scrollBehavior' in document.documentElement.style,
    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch)
  };
}
function getSupport() {
  if (!support) {
    support = calcSupport();
  }
  return support;
}

let deviceCached;
function calcDevice(_temp) {
  let {
    userAgent
  } = _temp === void 0 ? {} : _temp;
  const support = getSupport();
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  const platform = window.navigator.platform;
  const ua = userAgent || window.navigator.userAgent;
  const device = {
    ios: false,
    android: false
  };
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
  let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  const windows = platform === 'Win32';
  let macos = platform === 'MacIntel';

  // iPadOs 13 fix
  const iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];
  if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, '13_0_0'];
    macos = false;
  }

  // Android
  if (android && !windows) {
    device.os = 'android';
    device.android = true;
  }
  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  }

  // Export object
  return device;
}
function getDevice(overrides) {
  if (overrides === void 0) {
    overrides = {};
  }
  if (!deviceCached) {
    deviceCached = calcDevice(overrides);
  }
  return deviceCached;
}

let browser;
function calcBrowser() {
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  const device = getDevice();
  let needPerspectiveFix = false;
  function isSafari() {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }
  if (isSafari()) {
    const ua = String(window.navigator.userAgent);
    if (ua.includes('Version/')) {
      const [major, minor] = ua.split('Version/')[1].split(' ')[0].split('.').map(num => Number(num));
      needPerspectiveFix = major < 16 || major === 16 && minor < 2;
    }
  }
  const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent);
  const isSafariBrowser = isSafari();
  const need3dFix = isSafariBrowser || isWebView && device.ios;
  return {
    isSafari: needPerspectiveFix || isSafariBrowser,
    needPerspectiveFix,
    need3dFix,
    isWebView
  };
}
function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }
  return browser;
}

function Resize(_ref) {
  let {
    swiper,
    on,
    emit
  } = _ref;
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  let observer = null;
  let animationFrame = null;
  const resizeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('beforeResize');
    emit('resize');
  };
  const createObserver = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    observer = new ResizeObserver(entries => {
      animationFrame = window.requestAnimationFrame(() => {
        const {
          width,
          height
        } = swiper;
        let newWidth = width;
        let newHeight = height;
        entries.forEach(_ref2 => {
          let {
            contentBoxSize,
            contentRect,
            target
          } = _ref2;
          if (target && target !== swiper.el) return;
          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
        });
        if (newWidth !== width || newHeight !== height) {
          resizeHandler();
        }
      });
    });
    observer.observe(swiper.el);
  };
  const removeObserver = () => {
    if (animationFrame) {
      window.cancelAnimationFrame(animationFrame);
    }
    if (observer && observer.unobserve && swiper.el) {
      observer.unobserve(swiper.el);
      observer = null;
    }
  };
  const orientationChangeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('orientationchange');
  };
  on('init', () => {
    if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
      createObserver();
      return;
    }
    window.addEventListener('resize', resizeHandler);
    window.addEventListener('orientationchange', orientationChangeHandler);
  });
  on('destroy', () => {
    removeObserver();
    window.removeEventListener('resize', resizeHandler);
    window.removeEventListener('orientationchange', orientationChangeHandler);
  });
}

function Observer(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  const observers = [];
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  const attach = function (target, options) {
    if (options === void 0) {
      options = {};
    }
    const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
    const observer = new ObserverFunc(mutations => {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (swiper.__preventObserver__) return;
      if (mutations.length === 1) {
        emit('observerUpdate', mutations[0]);
        return;
      }
      const observerUpdate = function observerUpdate() {
        emit('observerUpdate', mutations[0]);
      };
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(observerUpdate);
      } else {
        window.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });
    observers.push(observer);
  };
  const init = () => {
    if (!swiper.params.observer) return;
    if (swiper.params.observeParents) {
      const containerParents = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.a)(swiper.hostEl);
      for (let i = 0; i < containerParents.length; i += 1) {
        attach(containerParents[i]);
      }
    }
    // Observe container
    attach(swiper.hostEl, {
      childList: swiper.params.observeSlideChildren
    });

    // Observe wrapper
    attach(swiper.wrapperEl, {
      attributes: false
    });
  };
  const destroy = () => {
    observers.forEach(observer => {
      observer.disconnect();
    });
    observers.splice(0, observers.length);
  };
  extendParams({
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  });
  on('init', init);
  on('destroy', destroy);
}

/* eslint-disable no-underscore-dangle */

var eventsEmitter = {
  on(events, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    const method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(event => {
      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
      self.eventsListeners[event][method](handler);
    });
    return self;
  },
  once(events, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    function onceHandler() {
      self.off(events, onceHandler);
      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      handler.apply(self, args);
    }
    onceHandler.__emitterProxy = handler;
    return self.on(events, onceHandler, priority);
  },
  onAny(handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    const method = priority ? 'unshift' : 'push';
    if (self.eventsAnyListeners.indexOf(handler) < 0) {
      self.eventsAnyListeners[method](handler);
    }
    return self;
  },
  offAny(handler) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsAnyListeners) return self;
    const index = self.eventsAnyListeners.indexOf(handler);
    if (index >= 0) {
      self.eventsAnyListeners.splice(index, 1);
    }
    return self;
  },
  off(events, handler) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    events.split(' ').forEach(event => {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event]) {
        self.eventsListeners[event].forEach((eventHandler, index) => {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  },
  emit() {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    let events;
    let data;
    let context;
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }
    data.unshift(context);
    const eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(event => {
      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
        self.eventsAnyListeners.forEach(eventHandler => {
          eventHandler.apply(context, [event, ...data]);
        });
      }
      if (self.eventsListeners && self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(eventHandler => {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  }
};

function updateSize() {
  const swiper = this;
  let width;
  let height;
  const el = swiper.el;
  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = el.clientWidth;
  }
  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = el.clientHeight;
  }
  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  }

  // Subtract paddings
  width = width - parseInt((0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.o)(el, 'padding-left') || 0, 10) - parseInt((0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.o)(el, 'padding-right') || 0, 10);
  height = height - parseInt((0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.o)(el, 'padding-top') || 0, 10) - parseInt((0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.o)(el, 'padding-bottom') || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  Object.assign(swiper, {
    width,
    height,
    size: swiper.isHorizontal() ? width : height
  });
}

function updateSlides() {
  const swiper = this;
  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
  }
  const params = swiper.params;
  const {
    wrapperEl,
    slidesEl,
    size: swiperSize,
    rtlTranslate: rtl,
    wrongRTL
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  const slides = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
  const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  let snapGrid = [];
  const slidesGrid = [];
  const slidesSizesGrid = [];
  let offsetBefore = params.slidesOffsetBefore;
  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }
  let offsetAfter = params.slidesOffsetAfter;
  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }
  const previousSnapGridLength = swiper.snapGrid.length;
  const previousSlidesGridLength = swiper.slidesGrid.length;
  let spaceBetween = params.spaceBetween;
  let slidePosition = -offsetBefore;
  let prevSlideSize = 0;
  let index = 0;
  if (typeof swiperSize === 'undefined') {
    return;
  }
  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  } else if (typeof spaceBetween === 'string') {
    spaceBetween = parseFloat(spaceBetween);
  }
  swiper.virtualSize = -spaceBetween;

  // reset margins
  slides.forEach(slideEl => {
    if (rtl) {
      slideEl.style.marginLeft = '';
    } else {
      slideEl.style.marginRight = '';
    }
    slideEl.style.marginBottom = '';
    slideEl.style.marginTop = '';
  });

  // reset cssMode offsets
  if (params.centeredSlides && params.cssMode) {
    (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(wrapperEl, '--swiper-centered-offset-before', '');
    (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(wrapperEl, '--swiper-centered-offset-after', '');
  }
  const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
  if (gridEnabled) {
    swiper.grid.initSlides(slides);
  } else if (swiper.grid) {
    swiper.grid.unsetSlides();
  }

  // Calc slides
  let slideSize;
  const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter(key => {
    return typeof params.breakpoints[key].slidesPerView !== 'undefined';
  }).length > 0;
  for (let i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    let slide;
    if (slides[i]) slide = slides[i];
    if (gridEnabled) {
      swiper.grid.updateSlide(i, slide, slides);
    }
    if (slides[i] && (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.o)(slide, 'display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      if (shouldResetSlideSize) {
        slides[i].style[swiper.getDirectionLabel('width')] = ``;
      }
      const slideStyles = getComputedStyle(slide);
      const currentTransform = slide.style.transform;
      const currentWebKitTransform = slide.style.webkitTransform;
      if (currentTransform) {
        slide.style.transform = 'none';
      }
      if (currentWebKitTransform) {
        slide.style.webkitTransform = 'none';
      }
      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.f)(slide, 'width', true) : (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.f)(slide, 'height', true);
      } else {
        // eslint-disable-next-line
        const width = getDirectionPropertyValue(slideStyles, 'width');
        const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
        const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
        const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
        const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
        const boxSizing = slideStyles.getPropertyValue('box-sizing');
        if (boxSizing && boxSizing === 'border-box') {
          slideSize = width + marginLeft + marginRight;
        } else {
          const {
            clientWidth,
            offsetWidth
          } = slide;
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }
      if (currentTransform) {
        slide.style.transform = currentTransform;
      }
      if (currentWebKitTransform) {
        slide.style.webkitTransform = currentWebKitTransform;
      }
      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);
      if (slides[i]) {
        slides[i].style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
      }
    }
    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }
    slidesSizesGrid.push(slideSize);
    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }
    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }
  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
  }
  if (params.setWrapperSize) {
    wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
  }
  if (gridEnabled) {
    swiper.grid.updateWrapperSize(slideSize, snapGrid);
  }

  // Remove last grid elements depending on width
  if (!params.centeredSlides) {
    const newSlidesGrid = [];
    for (let i = 0; i < snapGrid.length; i += 1) {
      let slidesGridItem = snapGrid[i];
      if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
      if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(slidesGridItem);
      }
    }
    snapGrid = newSlidesGrid;
    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }
  if (isVirtual && params.loop) {
    const size = slidesSizesGrid[0] + spaceBetween;
    if (params.slidesPerGroup > 1) {
      const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
      const groupSize = size * params.slidesPerGroup;
      for (let i = 0; i < groups; i += 1) {
        snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
      }
    }
    for (let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1) {
      if (params.slidesPerGroup === 1) {
        snapGrid.push(snapGrid[snapGrid.length - 1] + size);
      }
      slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
      swiper.virtualSize += size;
    }
  }
  if (snapGrid.length === 0) snapGrid = [0];
  if (spaceBetween !== 0) {
    const key = swiper.isHorizontal() && rtl ? 'marginLeft' : swiper.getDirectionLabel('marginRight');
    slides.filter((_, slideIndex) => {
      if (!params.cssMode || params.loop) return true;
      if (slideIndex === slides.length - 1) {
        return false;
      }
      return true;
    }).forEach(slideEl => {
      slideEl.style[key] = `${spaceBetween}px`;
    });
  }
  if (params.centeredSlides && params.centeredSlidesBounds) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach(slideSizeValue => {
      allSlidesSize += slideSizeValue + (spaceBetween || 0);
    });
    allSlidesSize -= spaceBetween;
    const maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map(snap => {
      if (snap <= 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }
  if (params.centerInsufficientSlides) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach(slideSizeValue => {
      allSlidesSize += slideSizeValue + (spaceBetween || 0);
    });
    allSlidesSize -= spaceBetween;
    if (allSlidesSize < swiperSize) {
      const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
      snapGrid.forEach((snap, snapIndex) => {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach((snap, snapIndex) => {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }
  Object.assign(swiper, {
    slides,
    snapGrid,
    slidesGrid,
    slidesSizesGrid
  });
  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
    (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
    (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
    const addToSnapGrid = -swiper.snapGrid[0];
    const addToSlidesGrid = -swiper.slidesGrid[0];
    swiper.snapGrid = swiper.snapGrid.map(v => v + addToSnapGrid);
    swiper.slidesGrid = swiper.slidesGrid.map(v => v + addToSlidesGrid);
  }
  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }
  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }
  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }
  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
  swiper.emit('slidesUpdated');
  if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
    const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
    const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
    if (slidesLength <= params.maxBackfaceHiddenSlides) {
      if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
    } else if (hasClassBackfaceClassAdded) {
      swiper.el.classList.remove(backFaceHiddenClass);
    }
  }
}

function updateAutoHeight(speed) {
  const swiper = this;
  const activeSlides = [];
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  let newHeight = 0;
  let i;
  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }
  const getSlideByIndex = index => {
    if (isVirtual) {
      return swiper.slides[swiper.getSlideIndexByData(index)];
    }
    return swiper.slides[index];
  };
  // Find slides currently in view
  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      (swiper.visibleSlides || []).forEach(slide => {
        activeSlides.push(slide);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        const index = swiper.activeIndex + i;
        if (index > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  }

  // Find new height from highest slide in view
  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      const height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  }

  // Update Height
  if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}

function updateSlidesOffset() {
  const swiper = this;
  const slides = swiper.slides;
  // eslint-disable-next-line
  const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
  for (let i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
  }
}

function updateSlidesProgress(translate) {
  if (translate === void 0) {
    translate = this && this.translate || 0;
  }
  const swiper = this;
  const params = swiper.params;
  const {
    slides,
    rtlTranslate: rtl,
    snapGrid
  } = swiper;
  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
  let offsetCenter = -translate;
  if (rtl) offsetCenter = translate;

  // Visible Slides
  slides.forEach(slideEl => {
    slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass);
  });
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];
  let spaceBetween = params.spaceBetween;
  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
  } else if (typeof spaceBetween === 'string') {
    spaceBetween = parseFloat(spaceBetween);
  }
  for (let i = 0; i < slides.length; i += 1) {
    const slide = slides[i];
    let slideOffset = slide.swiperSlideOffset;
    if (params.cssMode && params.centeredSlides) {
      slideOffset -= slides[0].swiperSlideOffset;
    }
    const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
    const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
    const slideBefore = -(offsetCenter - slideOffset);
    const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
    const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
    const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
    if (isVisible) {
      swiper.visibleSlides.push(slide);
      swiper.visibleSlidesIndexes.push(i);
      slides[i].classList.add(params.slideVisibleClass);
    }
    if (isFullyVisible) {
      slides[i].classList.add(params.slideFullyVisibleClass);
    }
    slide.progress = rtl ? -slideProgress : slideProgress;
    slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
  }
}

function updateProgress(translate) {
  const swiper = this;
  if (typeof translate === 'undefined') {
    const multiplier = swiper.rtlTranslate ? -1 : 1;
    // eslint-disable-next-line
    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }
  const params = swiper.params;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  let {
    progress,
    isBeginning,
    isEnd,
    progressLoop
  } = swiper;
  const wasBeginning = isBeginning;
  const wasEnd = isEnd;
  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
    const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
    isBeginning = isBeginningRounded || progress <= 0;
    isEnd = isEndRounded || progress >= 1;
    if (isBeginningRounded) progress = 0;
    if (isEndRounded) progress = 1;
  }
  if (params.loop) {
    const firstSlideIndex = swiper.getSlideIndexByData(0);
    const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
    const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
    const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
    const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
    const translateAbs = Math.abs(translate);
    if (translateAbs >= firstSlideTranslate) {
      progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
    } else {
      progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
    }
    if (progressLoop > 1) progressLoop -= 1;
  }
  Object.assign(swiper, {
    progress,
    progressLoop,
    isBeginning,
    isEnd
  });
  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }
  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }
  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }
  swiper.emit('progress', progress);
}

const toggleSlideClasses = (slideEl, condition, className) => {
  if (condition && !slideEl.classList.contains(className)) {
    slideEl.classList.add(className);
  } else if (!condition && slideEl.classList.contains(className)) {
    slideEl.classList.remove(className);
  }
};
function updateSlidesClasses() {
  const swiper = this;
  const {
    slides,
    params,
    slidesEl,
    activeIndex
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  const getFilteredSlide = selector => {
    return (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
  };
  let activeSlide;
  let prevSlide;
  let nextSlide;
  if (isVirtual) {
    if (params.loop) {
      let slideIndex = activeIndex - swiper.virtual.slidesBefore;
      if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
      if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
      activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
    } else {
      activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    }
  } else {
    if (gridEnabled) {
      activeSlide = slides.filter(slideEl => slideEl.column === activeIndex)[0];
      nextSlide = slides.filter(slideEl => slideEl.column === activeIndex + 1)[0];
      prevSlide = slides.filter(slideEl => slideEl.column === activeIndex - 1)[0];
    } else {
      activeSlide = slides[activeIndex];
    }
  }
  if (activeSlide) {
    if (!gridEnabled) {
      // Next Slide
      nextSlide = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.p)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
      if (params.loop && !nextSlide) {
        nextSlide = slides[0];
      }

      // Prev Slide
      prevSlide = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.q)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
      if (params.loop && !prevSlide === 0) {
        prevSlide = slides[slides.length - 1];
      }
    }
  }
  slides.forEach(slideEl => {
    toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
    toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
    toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
  });
  swiper.emitSlidesClasses();
}

const processLazyPreloader = (swiper, imageEl) => {
  if (!swiper || swiper.destroyed || !swiper.params) return;
  const slideSelector = () => swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
  const slideEl = imageEl.closest(slideSelector());
  if (slideEl) {
    let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
    if (!lazyEl && swiper.isElement) {
      if (slideEl.shadowRoot) {
        lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
      } else {
        // init later
        requestAnimationFrame(() => {
          if (slideEl.shadowRoot) {
            lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            if (lazyEl) lazyEl.remove();
          }
        });
      }
    }
    if (lazyEl) lazyEl.remove();
  }
};
const unlazy = (swiper, index) => {
  if (!swiper.slides[index]) return;
  const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
  if (imageEl) imageEl.removeAttribute('loading');
};
const preload = swiper => {
  if (!swiper || swiper.destroyed || !swiper.params) return;
  let amount = swiper.params.lazyPreloadPrevNext;
  const len = swiper.slides.length;
  if (!len || !amount || amount < 0) return;
  amount = Math.min(amount, len);
  const slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
  const activeIndex = swiper.activeIndex;
  if (swiper.params.grid && swiper.params.grid.rows > 1) {
    const activeColumn = activeIndex;
    const preloadColumns = [activeColumn - amount];
    preloadColumns.push(...Array.from({
      length: amount
    }).map((_, i) => {
      return activeColumn + slidesPerView + i;
    }));
    swiper.slides.forEach((slideEl, i) => {
      if (preloadColumns.includes(slideEl.column)) unlazy(swiper, i);
    });
    return;
  }
  const slideIndexLastInView = activeIndex + slidesPerView - 1;
  if (swiper.params.rewind || swiper.params.loop) {
    for (let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1) {
      const realIndex = (i % len + len) % len;
      if (realIndex < activeIndex || realIndex > slideIndexLastInView) unlazy(swiper, realIndex);
    }
  } else {
    for (let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1) {
      if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) {
        unlazy(swiper, i);
      }
    }
  }
};

function getActiveIndexByTranslate(swiper) {
  const {
    slidesGrid,
    params
  } = swiper;
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  let activeIndex;
  for (let i = 0; i < slidesGrid.length; i += 1) {
    if (typeof slidesGrid[i + 1] !== 'undefined') {
      if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
        activeIndex = i;
      } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
        activeIndex = i + 1;
      }
    } else if (translate >= slidesGrid[i]) {
      activeIndex = i;
    }
  }
  // Normalize slideIndex
  if (params.normalizeSlideIndex) {
    if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
  }
  return activeIndex;
}
function updateActiveIndex(newActiveIndex) {
  const swiper = this;
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  const {
    snapGrid,
    params,
    activeIndex: previousIndex,
    realIndex: previousRealIndex,
    snapIndex: previousSnapIndex
  } = swiper;
  let activeIndex = newActiveIndex;
  let snapIndex;
  const getVirtualRealIndex = aIndex => {
    let realIndex = aIndex - swiper.virtual.slidesBefore;
    if (realIndex < 0) {
      realIndex = swiper.virtual.slides.length + realIndex;
    }
    if (realIndex >= swiper.virtual.slides.length) {
      realIndex -= swiper.virtual.slides.length;
    }
    return realIndex;
  };
  if (typeof activeIndex === 'undefined') {
    activeIndex = getActiveIndexByTranslate(swiper);
  }
  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  if (activeIndex === previousIndex && !swiper.params.loop) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }
    return;
  }
  if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
    swiper.realIndex = getVirtualRealIndex(activeIndex);
    return;
  }
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;

  // Get real index
  let realIndex;
  if (swiper.virtual && params.virtual.enabled && params.loop) {
    realIndex = getVirtualRealIndex(activeIndex);
  } else if (gridEnabled) {
    const firstSlideInColumn = swiper.slides.filter(slideEl => slideEl.column === activeIndex)[0];
    let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute('data-swiper-slide-index'), 10);
    if (Number.isNaN(activeSlideIndex)) {
      activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
    }
    realIndex = Math.floor(activeSlideIndex / params.grid.rows);
  } else if (swiper.slides[activeIndex]) {
    const slideIndex = swiper.slides[activeIndex].getAttribute('data-swiper-slide-index');
    if (slideIndex) {
      realIndex = parseInt(slideIndex, 10);
    } else {
      realIndex = activeIndex;
    }
  } else {
    realIndex = activeIndex;
  }
  Object.assign(swiper, {
    previousSnapIndex,
    snapIndex,
    previousRealIndex,
    realIndex,
    previousIndex,
    activeIndex
  });
  if (swiper.initialized) {
    preload(swiper);
  }
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');
  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    if (previousRealIndex !== realIndex) {
      swiper.emit('realIndexChange');
    }
    swiper.emit('slideChange');
  }
}

function updateClickedSlide(el, path) {
  const swiper = this;
  const params = swiper.params;
  let slide = el.closest(`.${params.slideClass}, swiper-slide`);
  if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) {
    [...path.slice(path.indexOf(el) + 1, path.length)].forEach(pathEl => {
      if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) {
        slide = pathEl;
      }
    });
  }
  let slideFound = false;
  let slideIndex;
  if (slide) {
    for (let i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }
  if (slide && slideFound) {
    swiper.clickedSlide = slide;
    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }
  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}

var update = {
  updateSize,
  updateSlides,
  updateAutoHeight,
  updateSlidesOffset,
  updateSlidesProgress,
  updateProgress,
  updateSlidesClasses,
  updateActiveIndex,
  updateClickedSlide
};

function getSwiperTranslate(axis) {
  if (axis === void 0) {
    axis = this.isHorizontal() ? 'x' : 'y';
  }
  const swiper = this;
  const {
    params,
    rtlTranslate: rtl,
    translate,
    wrapperEl
  } = swiper;
  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }
  if (params.cssMode) {
    return translate;
  }
  let currentTranslate = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.j)(wrapperEl, axis);
  currentTranslate += swiper.cssOverflowAdjustment();
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}

function setTranslate(translate, byController) {
  const swiper = this;
  const {
    rtlTranslate: rtl,
    params,
    wrapperEl,
    progress
  } = swiper;
  let x = 0;
  let y = 0;
  const z = 0;
  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }
  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }
  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y;
  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    if (swiper.isHorizontal()) {
      x -= swiper.cssOverflowAdjustment();
    } else {
      y -= swiper.cssOverflowAdjustment();
    }
    wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
  }

  // Check if we need to update progress
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }
  swiper.emit('setTranslate', swiper.translate, byController);
}

function minTranslate() {
  return -this.snapGrid[0];
}

function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}

function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
  if (translate === void 0) {
    translate = 0;
  }
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (translateBounds === void 0) {
    translateBounds = true;
  }
  const swiper = this;
  const {
    params,
    wrapperEl
  } = swiper;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }
  const minTranslate = swiper.minTranslate();
  const maxTranslate = swiper.maxTranslate();
  let newTranslate;
  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate;

  // Update progress
  swiper.updateProgress(newTranslate);
  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
    } else {
      if (!swiper.support.smoothScroll) {
        (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.r)({
          swiper,
          targetPosition: -newTranslate,
          side: isH ? 'left' : 'top'
        });
        return true;
      }
      wrapperEl.scrollTo({
        [isH ? 'left' : 'top']: -newTranslate,
        behavior: 'smooth'
      });
    }
    return true;
  }
  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionEnd');
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionStart');
    }
    if (!swiper.animating) {
      swiper.animating = true;
      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;
          swiper.animating = false;
          if (runCallbacks) {
            swiper.emit('transitionEnd');
          }
        };
      }
      swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
    }
  }
  return true;
}

var translate = {
  getTranslate: getSwiperTranslate,
  setTranslate,
  minTranslate,
  maxTranslate,
  translateTo
};

function setTransition(duration, byController) {
  const swiper = this;
  if (!swiper.params.cssMode) {
    swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
    swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : '';
  }
  swiper.emit('setTransition', duration, byController);
}

function transitionEmit(_ref) {
  let {
    swiper,
    runCallbacks,
    direction,
    step
  } = _ref;
  const {
    activeIndex,
    previousIndex
  } = swiper;
  let dir = direction;
  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }
  swiper.emit(`transition${step}`);
  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit(`slideResetTransition${step}`);
      return;
    }
    swiper.emit(`slideChangeTransition${step}`);
    if (dir === 'next') {
      swiper.emit(`slideNextTransition${step}`);
    } else {
      swiper.emit(`slidePrevTransition${step}`);
    }
  }
}

function transitionStart(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    params
  } = swiper;
  if (params.cssMode) return;
  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: 'Start'
  });
}

function transitionEnd(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    params
  } = swiper;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: 'End'
  });
}

var transition = {
  setTransition,
  transitionStart,
  transitionEnd
};

function slideTo(index, speed, runCallbacks, internal, initial) {
  if (index === void 0) {
    index = 0;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (typeof index === 'string') {
    index = parseInt(index, 10);
  }
  const swiper = this;
  let slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  const {
    params,
    snapGrid,
    slidesGrid,
    previousIndex,
    activeIndex,
    rtlTranslate: rtl,
    wrapperEl,
    enabled
  } = swiper;
  if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }
  if (typeof speed === 'undefined') {
    speed = swiper.params.speed;
  }
  const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  const translate = -snapGrid[snapIndex];
  // Normalize slideIndex
  if (params.normalizeSlideIndex) {
    for (let i = 0; i < slidesGrid.length; i += 1) {
      const normalizedTranslate = -Math.floor(translate * 100);
      const normalizedGrid = Math.floor(slidesGrid[i] * 100);
      const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGrid) {
        slideIndex = i;
      }
    }
  }
  // Directions locks
  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) {
      return false;
    }
    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) {
        return false;
      }
    }
  }
  if (slideIndex !== (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  }

  // Update progress
  swiper.updateProgress(translate);
  let direction;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset';

  // Update Index
  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
    swiper.updateActiveIndex(slideIndex);
    // Update Height
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
    swiper.updateSlidesClasses();
    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }
    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }
    return false;
  }
  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    const t = rtl ? translate : -translate;
    if (speed === 0) {
      const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      if (isVirtual) {
        swiper.wrapperEl.style.scrollSnapType = 'none';
        swiper._immediateVirtual = true;
      }
      if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
        swiper._cssModeVirtualInitialSet = true;
        requestAnimationFrame(() => {
          wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
        });
      } else {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
      }
      if (isVirtual) {
        requestAnimationFrame(() => {
          swiper.wrapperEl.style.scrollSnapType = '';
          swiper._immediateVirtual = false;
        });
      }
    } else {
      if (!swiper.support.smoothScroll) {
        (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.r)({
          swiper,
          targetPosition: t,
          side: isH ? 'left' : 'top'
        });
        return true;
      }
      wrapperEl.scrollTo({
        [isH ? 'left' : 'top']: t,
        behavior: 'smooth'
      });
    }
    return true;
  }
  swiper.setTransition(speed);
  swiper.setTranslate(translate);
  swiper.updateActiveIndex(slideIndex);
  swiper.updateSlidesClasses();
  swiper.emit('beforeTransitionStart', speed, internal);
  swiper.transitionStart(runCallbacks, direction);
  if (speed === 0) {
    swiper.transitionEnd(runCallbacks, direction);
  } else if (!swiper.animating) {
    swiper.animating = true;
    if (!swiper.onSlideToWrapperTransitionEnd) {
      swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
        if (!swiper || swiper.destroyed) return;
        if (e.target !== this) return;
        swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.onSlideToWrapperTransitionEnd = null;
        delete swiper.onSlideToWrapperTransitionEnd;
        swiper.transitionEnd(runCallbacks, direction);
      };
    }
    swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
  }
  return true;
}

function slideToLoop(index, speed, runCallbacks, internal) {
  if (index === void 0) {
    index = 0;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (typeof index === 'string') {
    const indexAsNumber = parseInt(index, 10);
    index = indexAsNumber;
  }
  const swiper = this;
  if (swiper.destroyed) return;
  if (typeof speed === 'undefined') {
    speed = swiper.params.speed;
  }
  const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
  let newIndex = index;
  if (swiper.params.loop) {
    if (swiper.virtual && swiper.params.virtual.enabled) {
      // eslint-disable-next-line
      newIndex = newIndex + swiper.virtual.slidesBefore;
    } else {
      let targetSlideIndex;
      if (gridEnabled) {
        const slideIndex = newIndex * swiper.params.grid.rows;
        targetSlideIndex = swiper.slides.filter(slideEl => slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex)[0].column;
      } else {
        targetSlideIndex = swiper.getSlideIndexByData(newIndex);
      }
      const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
      const {
        centeredSlides
      } = swiper.params;
      let slidesPerView = swiper.params.slidesPerView;
      if (slidesPerView === 'auto') {
        slidesPerView = swiper.slidesPerViewDynamic();
      } else {
        slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
        if (centeredSlides && slidesPerView % 2 === 0) {
          slidesPerView = slidesPerView + 1;
        }
      }
      let needLoopFix = cols - targetSlideIndex < slidesPerView;
      if (centeredSlides) {
        needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
      }
      if (internal && centeredSlides && swiper.params.slidesPerView !== 'auto' && !gridEnabled) {
        needLoopFix = false;
      }
      if (needLoopFix) {
        const direction = centeredSlides ? targetSlideIndex < swiper.activeIndex ? 'prev' : 'next' : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? 'next' : 'prev';
        swiper.loopFix({
          direction,
          slideTo: true,
          activeSlideIndex: direction === 'next' ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
          slideRealIndex: direction === 'next' ? swiper.realIndex : undefined
        });
      }
      if (gridEnabled) {
        const slideIndex = newIndex * swiper.params.grid.rows;
        newIndex = swiper.slides.filter(slideEl => slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex)[0].column;
      } else {
        newIndex = swiper.getSlideIndexByData(newIndex);
      }
    }
  }
  requestAnimationFrame(() => {
    swiper.slideTo(newIndex, speed, runCallbacks, internal);
  });
  return swiper;
}

/* eslint no-unused-vars: "off" */
function slideNext(speed, runCallbacks, internal) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    enabled,
    params,
    animating
  } = swiper;
  if (!enabled || swiper.destroyed) return swiper;
  if (typeof speed === 'undefined') {
    speed = swiper.params.speed;
  }
  let perGroup = params.slidesPerGroup;
  if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
    perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
  }
  const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  if (params.loop) {
    if (animating && !isVirtual && params.loopPreventsSliding) return false;
    swiper.loopFix({
      direction: 'next'
    });
    // eslint-disable-next-line
    swiper._clientLeft = swiper.wrapperEl.clientLeft;
    if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
      requestAnimationFrame(() => {
        swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
      });
      return true;
    }
  }
  if (params.rewind && swiper.isEnd) {
    return swiper.slideTo(0, speed, runCallbacks, internal);
  }
  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slidePrev(speed, runCallbacks, internal) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    params,
    snapGrid,
    slidesGrid,
    rtlTranslate,
    enabled,
    animating
  } = swiper;
  if (!enabled || swiper.destroyed) return swiper;
  if (typeof speed === 'undefined') {
    speed = swiper.params.speed;
  }
  const isVirtual = swiper.virtual && params.virtual.enabled;
  if (params.loop) {
    if (animating && !isVirtual && params.loopPreventsSliding) return false;
    swiper.loopFix({
      direction: 'prev'
    });
    // eslint-disable-next-line
    swiper._clientLeft = swiper.wrapperEl.clientLeft;
  }
  const translate = rtlTranslate ? swiper.translate : -swiper.translate;
  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }
  const normalizedTranslate = normalize(translate);
  const normalizedSnapGrid = snapGrid.map(val => normalize(val));
  let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
  if (typeof prevSnap === 'undefined' && params.cssMode) {
    let prevSnapIndex;
    snapGrid.forEach((snap, snapIndex) => {
      if (normalizedTranslate >= snap) {
        // prevSnap = snap;
        prevSnapIndex = snapIndex;
      }
    });
    if (typeof prevSnapIndex !== 'undefined') {
      prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
  }
  let prevIndex = 0;
  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
      prevIndex = Math.max(prevIndex, 0);
    }
  }
  if (params.rewind && swiper.isBeginning) {
    const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
  } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
    requestAnimationFrame(() => {
      swiper.slideTo(prevIndex, speed, runCallbacks, internal);
    });
    return true;
  }
  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideReset(speed, runCallbacks, internal) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  if (swiper.destroyed) return;
  if (typeof speed === 'undefined') {
    speed = swiper.params.speed;
  }
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideToClosest(speed, runCallbacks, internal, threshold) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (threshold === void 0) {
    threshold = 0.5;
  }
  const swiper = this;
  if (swiper.destroyed) return;
  if (typeof speed === 'undefined') {
    speed = swiper.params.speed;
  }
  let index = swiper.activeIndex;
  const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  if (translate >= swiper.snapGrid[snapIndex]) {
    // The current translate is on or after the current snap index, so the choice
    // is between the current index and the one after it.
    const currentSnap = swiper.snapGrid[snapIndex];
    const nextSnap = swiper.snapGrid[snapIndex + 1];
    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    // The current translate is before the current snap index, so the choice
    // is between the current index and the one before it.
    const prevSnap = swiper.snapGrid[snapIndex - 1];
    const currentSnap = swiper.snapGrid[snapIndex];
    if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }
  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}

function slideToClickedSlide() {
  const swiper = this;
  if (swiper.destroyed) return;
  const {
    params,
    slidesEl
  } = swiper;
  const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  let slideToIndex = swiper.clickedIndex;
  let realIndex;
  const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt(swiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = swiper.getSlideIndex((0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
        (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.n)(() => {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = swiper.getSlideIndex((0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.n)(() => {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}

var slide = {
  slideTo,
  slideToLoop,
  slideNext,
  slidePrev,
  slideReset,
  slideToClosest,
  slideToClickedSlide
};

function loopCreate(slideRealIndex) {
  const swiper = this;
  const {
    params,
    slidesEl
  } = swiper;
  if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
  const initSlides = () => {
    const slides = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(slidesEl, `.${params.slideClass}, swiper-slide`);
    slides.forEach((el, index) => {
      el.setAttribute('data-swiper-slide-index', index);
    });
  };
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
  const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
  const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
  const addBlankSlides = amountOfSlides => {
    for (let i = 0; i < amountOfSlides; i += 1) {
      const slideEl = swiper.isElement ? (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)('swiper-slide', [params.slideBlankClass]) : (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)('div', [params.slideClass, params.slideBlankClass]);
      swiper.slidesEl.append(slideEl);
    }
  };
  if (shouldFillGroup) {
    if (params.loopAddBlankSlides) {
      const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
      addBlankSlides(slidesToAdd);
      swiper.recalcSlides();
      swiper.updateSlides();
    } else {
      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.t)('Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
    }
    initSlides();
  } else if (shouldFillGrid) {
    if (params.loopAddBlankSlides) {
      const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
      addBlankSlides(slidesToAdd);
      swiper.recalcSlides();
      swiper.updateSlides();
    } else {
      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.t)('Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
    }
    initSlides();
  } else {
    initSlides();
  }
  swiper.loopFix({
    slideRealIndex,
    direction: params.centeredSlides ? undefined : 'next'
  });
}

function loopFix(_temp) {
  let {
    slideRealIndex,
    slideTo = true,
    direction,
    setTranslate,
    activeSlideIndex,
    byController,
    byMousewheel
  } = _temp === void 0 ? {} : _temp;
  const swiper = this;
  if (!swiper.params.loop) return;
  swiper.emit('beforeLoopFix');
  const {
    slides,
    allowSlidePrev,
    allowSlideNext,
    slidesEl,
    params
  } = swiper;
  const {
    centeredSlides
  } = params;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  if (swiper.virtual && params.virtual.enabled) {
    if (slideTo) {
      if (!params.centeredSlides && swiper.snapIndex === 0) {
        swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
      } else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) {
        swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
      } else if (swiper.snapIndex === swiper.snapGrid.length - 1) {
        swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
      }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit('loopFix');
    return;
  }
  let slidesPerView = params.slidesPerView;
  if (slidesPerView === 'auto') {
    slidesPerView = swiper.slidesPerViewDynamic();
  } else {
    slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
    if (centeredSlides && slidesPerView % 2 === 0) {
      slidesPerView = slidesPerView + 1;
    }
  }
  const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
  let loopedSlides = slidesPerGroup;
  if (loopedSlides % slidesPerGroup !== 0) {
    loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
  }
  loopedSlides += params.loopAdditionalSlides;
  swiper.loopedSlides = loopedSlides;
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  if (slides.length < slidesPerView + loopedSlides) {
    (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.t)('Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters');
  } else if (gridEnabled && params.grid.fill === 'row') {
    (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.t)('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
  }
  const prependSlidesIndexes = [];
  const appendSlidesIndexes = [];
  let activeIndex = swiper.activeIndex;
  if (typeof activeSlideIndex === 'undefined') {
    activeSlideIndex = swiper.getSlideIndex(slides.filter(el => el.classList.contains(params.slideActiveClass))[0]);
  } else {
    activeIndex = activeSlideIndex;
  }
  const isNext = direction === 'next' || !direction;
  const isPrev = direction === 'prev' || !direction;
  let slidesPrepended = 0;
  let slidesAppended = 0;
  const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
  const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
  const activeColIndexWithShift = activeColIndex + (centeredSlides && typeof setTranslate === 'undefined' ? -slidesPerView / 2 + 0.5 : 0);
  // prepend last slides before start
  if (activeColIndexWithShift < loopedSlides) {
    slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
    for (let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1) {
      const index = i - Math.floor(i / cols) * cols;
      if (gridEnabled) {
        const colIndexToPrepend = cols - index - 1;
        for (let i = slides.length - 1; i >= 0; i -= 1) {
          if (slides[i].column === colIndexToPrepend) prependSlidesIndexes.push(i);
        }
        // slides.forEach((slide, slideIndex) => {
        //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
        // });
      } else {
        prependSlidesIndexes.push(cols - index - 1);
      }
    }
  } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
    slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
    for (let i = 0; i < slidesAppended; i += 1) {
      const index = i - Math.floor(i / cols) * cols;
      if (gridEnabled) {
        slides.forEach((slide, slideIndex) => {
          if (slide.column === index) appendSlidesIndexes.push(slideIndex);
        });
      } else {
        appendSlidesIndexes.push(index);
      }
    }
  }
  swiper.__preventObserver__ = true;
  requestAnimationFrame(() => {
    swiper.__preventObserver__ = false;
  });
  if (isPrev) {
    prependSlidesIndexes.forEach(index => {
      slides[index].swiperLoopMoveDOM = true;
      slidesEl.prepend(slides[index]);
      slides[index].swiperLoopMoveDOM = false;
    });
  }
  if (isNext) {
    appendSlidesIndexes.forEach(index => {
      slides[index].swiperLoopMoveDOM = true;
      slidesEl.append(slides[index]);
      slides[index].swiperLoopMoveDOM = false;
    });
  }
  swiper.recalcSlides();
  if (params.slidesPerView === 'auto') {
    swiper.updateSlides();
  } else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) {
    swiper.slides.forEach((slide, slideIndex) => {
      swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
  }
  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
  if (slideTo) {
    if (prependSlidesIndexes.length > 0 && isPrev) {
      if (typeof slideRealIndex === 'undefined') {
        const currentSlideTranslate = swiper.slidesGrid[activeIndex];
        const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
        const diff = newSlideTranslate - currentSlideTranslate;
        if (byMousewheel) {
          swiper.setTranslate(swiper.translate - diff);
        } else {
          swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
          if (setTranslate) {
            swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
            swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
          }
        }
      } else {
        if (setTranslate) {
          const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
          swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
          swiper.touchEventsData.currentTranslate = swiper.translate;
        }
      }
    } else if (appendSlidesIndexes.length > 0 && isNext) {
      if (typeof slideRealIndex === 'undefined') {
        const currentSlideTranslate = swiper.slidesGrid[activeIndex];
        const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
        const diff = newSlideTranslate - currentSlideTranslate;
        if (byMousewheel) {
          swiper.setTranslate(swiper.translate - diff);
        } else {
          swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
          if (setTranslate) {
            swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
            swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
          }
        }
      } else {
        const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
        swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
      }
    }
  }
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  if (swiper.controller && swiper.controller.control && !byController) {
    const loopParams = {
      slideRealIndex,
      direction,
      setTranslate,
      activeSlideIndex,
      byController: true
    };
    if (Array.isArray(swiper.controller.control)) {
      swiper.controller.control.forEach(c => {
        if (!c.destroyed && c.params.loop) c.loopFix({
          ...loopParams,
          slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
      });
    } else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) {
      swiper.controller.control.loopFix({
        ...loopParams,
        slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
      });
    }
  }
  swiper.emit('loopFix');
}

function loopDestroy() {
  const swiper = this;
  const {
    params,
    slidesEl
  } = swiper;
  if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
  swiper.recalcSlides();
  const newSlidesOrder = [];
  swiper.slides.forEach(slideEl => {
    const index = typeof slideEl.swiperSlideIndex === 'undefined' ? slideEl.getAttribute('data-swiper-slide-index') * 1 : slideEl.swiperSlideIndex;
    newSlidesOrder[index] = slideEl;
  });
  swiper.slides.forEach(slideEl => {
    slideEl.removeAttribute('data-swiper-slide-index');
  });
  newSlidesOrder.forEach(slideEl => {
    slidesEl.append(slideEl);
  });
  swiper.recalcSlides();
  swiper.slideTo(swiper.realIndex, 0);
}

var loop = {
  loopCreate,
  loopFix,
  loopDestroy
};

function setGrabCursor(moving) {
  const swiper = this;
  if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
  if (swiper.isElement) {
    swiper.__preventObserver__ = true;
  }
  el.style.cursor = 'move';
  el.style.cursor = moving ? 'grabbing' : 'grab';
  if (swiper.isElement) {
    requestAnimationFrame(() => {
      swiper.__preventObserver__ = false;
    });
  }
}

function unsetGrabCursor() {
  const swiper = this;
  if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }
  if (swiper.isElement) {
    swiper.__preventObserver__ = true;
  }
  swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
  if (swiper.isElement) {
    requestAnimationFrame(() => {
      swiper.__preventObserver__ = false;
    });
  }
}

var grabCursor = {
  setGrabCursor,
  unsetGrabCursor
};

// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function closestElement(selector, base) {
  if (base === void 0) {
    base = this;
  }
  function __closestFrom(el) {
    if (!el || el === (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)() || el === (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)()) return null;
    if (el.assignedSlot) el = el.assignedSlot;
    const found = el.closest(selector);
    if (!found && !el.getRootNode) {
      return null;
    }
    return found || __closestFrom(el.getRootNode().host);
  }
  return __closestFrom(base);
}
function preventEdgeSwipe(swiper, event, startX) {
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  const {
    params
  } = swiper;
  const edgeSwipeDetection = params.edgeSwipeDetection;
  const edgeSwipeThreshold = params.edgeSwipeThreshold;
  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === 'prevent') {
      event.preventDefault();
      return true;
    }
    return false;
  }
  return true;
}
function onTouchStart(event) {
  const swiper = this;
  const document = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  const data = swiper.touchEventsData;
  if (e.type === 'pointerdown') {
    if (data.pointerId !== null && data.pointerId !== e.pointerId) {
      return;
    }
    data.pointerId = e.pointerId;
  } else if (e.type === 'touchstart' && e.targetTouches.length === 1) {
    data.touchId = e.targetTouches[0].identifier;
  }
  if (e.type === 'touchstart') {
    // don't proceed touch event
    preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
    return;
  }
  const {
    params,
    touches,
    enabled
  } = swiper;
  if (!enabled) return;
  if (!params.simulateTouch && e.pointerType === 'mouse') return;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }
  if (!swiper.animating && params.cssMode && params.loop) {
    swiper.loopFix();
  }
  let targetEl = e.target;
  if (params.touchEventsTarget === 'wrapper') {
    if (!swiper.wrapperEl.contains(targetEl)) return;
  }
  if ('which' in e && e.which === 3) return;
  if ('button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return;

  // change target el for shadow root component
  const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
  // eslint-disable-next-line
  const eventPath = e.composedPath ? e.composedPath() : e.path;
  if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) {
    targetEl = eventPath[0];
  }
  const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
  const isTargetShadow = !!(e.target && e.target.shadowRoot);

  // use closestElement for shadow root element to get the actual closest for nested shadow root element
  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
    swiper.allowClick = true;
    return;
  }
  if (params.swipeHandler) {
    if (!targetEl.closest(params.swipeHandler)) return;
  }
  touches.currentX = e.pageX;
  touches.currentY = e.pageY;
  const startX = touches.currentX;
  const startY = touches.currentY;

  // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

  if (!preventEdgeSwipe(swiper, e, startX)) {
    return;
  }
  Object.assign(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.d)();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;
  let preventDefault = true;
  if (targetEl.matches(data.focusableElements)) {
    preventDefault = false;
    if (targetEl.nodeName === 'SELECT') {
      data.isTouched = false;
    }
  }
  if (document.activeElement && document.activeElement.matches(data.focusableElements) && document.activeElement !== targetEl) {
    document.activeElement.blur();
  }
  const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
  if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) {
    e.preventDefault();
  }
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
    swiper.freeMode.onTouchStart();
  }
  swiper.emit('touchStart', e);
}

function onTouchMove(event) {
  const document = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
  const swiper = this;
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    enabled
  } = swiper;
  if (!enabled) return;
  if (!params.simulateTouch && event.pointerType === 'mouse') return;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  if (e.type === 'pointermove') {
    if (data.touchId !== null) return; // return from pointer if we use touch
    const id = e.pointerId;
    if (id !== data.pointerId) return;
  }
  let targetTouch;
  if (e.type === 'touchmove') {
    targetTouch = [...e.changedTouches].filter(t => t.identifier === data.touchId)[0];
    if (!targetTouch || targetTouch.identifier !== data.touchId) return;
  } else {
    targetTouch = e;
  }
  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }
    return;
  }
  const pageX = targetTouch.pageX;
  const pageY = targetTouch.pageY;
  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }
  if (!swiper.allowTouchMove) {
    if (!e.target.matches(data.focusableElements)) {
      swiper.allowClick = false;
    }
    if (data.isTouched) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.d)();
    }
    return;
  }
  if (params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }
  if (document.activeElement) {
    if (e.target === document.activeElement && e.target.matches(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }
  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }
  touches.previousX = touches.currentX;
  touches.previousY = touches.currentY;
  touches.currentX = pageX;
  touches.currentY = pageY;
  const diffX = touches.currentX - touches.startX;
  const diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
  if (typeof data.isScrolling === 'undefined') {
    let touchAngle;
    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }
  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }
  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }
  if (data.isScrolling || e.type === 'touchmove' && data.preventTouchMoveFromPointerMove) {
    data.isTouched = false;
    return;
  }
  if (!data.startMoving) {
    return;
  }
  swiper.allowClick = false;
  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }
  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }
  let diff = swiper.isHorizontal() ? diffX : diffY;
  let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
  if (params.oneWayMovement) {
    diff = Math.abs(diff) * (rtl ? 1 : -1);
    touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
  }
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) {
    diff = -diff;
    touchesDiff = -touchesDiff;
  }
  const prevTouchesDirection = swiper.touchesDirection;
  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
  const isLoop = swiper.params.loop && !params.cssMode;
  const allowLoopFix = swiper.touchesDirection === 'next' && swiper.allowSlideNext || swiper.touchesDirection === 'prev' && swiper.allowSlidePrev;
  if (!data.isMoved) {
    if (isLoop && allowLoopFix) {
      swiper.loopFix({
        direction: swiper.swipeDirection
      });
    }
    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);
    if (swiper.animating) {
      const evt = new window.CustomEvent('transitionend', {
        bubbles: true,
        cancelable: true
      });
      swiper.wrapperEl.dispatchEvent(evt);
    }
    data.allowMomentumBounce = false;
    // Grab Cursor
    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }
    swiper.emit('sliderFirstMove', e);
  }
  let loopFixed;
  new Date().getTime();
  if (data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
    Object.assign(touches, {
      startX: pageX,
      startY: pageY,
      currentX: pageX,
      currentY: pageY,
      startTranslate: data.currentTranslate
    });
    data.loopSwapReset = true;
    data.startTranslate = data.currentTranslate;
    return;
  }
  swiper.emit('sliderMove', e);
  data.isMoved = true;
  data.currentTranslate = diff + data.startTranslate;
  let disableParentSwiper = true;
  let resistanceRatio = params.resistanceRatio;
  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }
  if (diff > 0) {
    if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] : swiper.minTranslate())) {
      swiper.loopFix({
        direction: 'prev',
        setTranslate: true,
        activeSlideIndex: 0
      });
    }
    if (data.currentTranslate > swiper.minTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
      }
    }
  } else if (diff < 0) {
    if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] : swiper.maxTranslate())) {
      swiper.loopFix({
        direction: 'next',
        setTranslate: true,
        activeSlideIndex: swiper.slides.length - (params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
      });
    }
    if (data.currentTranslate < swiper.maxTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
      }
    }
  }
  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  }

  // Directions locks
  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  }

  // Threshold
  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }
  if (!params.followFinger || params.cssMode) return;

  // Update active index in free mode
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode) {
    swiper.freeMode.onTouchMove();
  }
  // Update progress
  swiper.updateProgress(data.currentTranslate);
  // Update translate
  swiper.setTranslate(data.currentTranslate);
}

function onTouchEnd(event) {
  const swiper = this;
  const data = swiper.touchEventsData;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  let targetTouch;
  const isTouchEvent = e.type === 'touchend' || e.type === 'touchcancel';
  if (!isTouchEvent) {
    if (data.touchId !== null) return; // return from pointer if we use touch
    if (e.pointerId !== data.pointerId) return;
    targetTouch = e;
  } else {
    targetTouch = [...e.changedTouches].filter(t => t.identifier === data.touchId)[0];
    if (!targetTouch || targetTouch.identifier !== data.touchId) return;
  }
  if (['pointercancel', 'pointerout', 'pointerleave', 'contextmenu'].includes(e.type)) {
    const proceed = ['pointercancel', 'contextmenu'].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
    if (!proceed) {
      return;
    }
  }
  data.pointerId = null;
  data.touchId = null;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    slidesGrid,
    enabled
  } = swiper;
  if (!enabled) return;
  if (!params.simulateTouch && e.pointerType === 'mouse') return;
  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }
  data.allowTouchCallbacks = false;
  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }
    data.isMoved = false;
    data.startMoving = false;
    return;
  }

  // Return Grab Cursor
  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  }

  // Time diff
  const touchEndTime = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.d)();
  const timeDiff = touchEndTime - data.touchStartTime;

  // Tap, doubleTap, Click
  if (swiper.allowClick) {
    const pathTree = e.path || e.composedPath && e.composedPath();
    swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
    swiper.emit('tap click', e);
    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit('doubleTap doubleClick', e);
    }
  }
  data.lastClickTime = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.d)();
  (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.n)(() => {
    if (!swiper.destroyed) swiper.allowClick = true;
  });
  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }
  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  let currentPos;
  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }
  if (params.cssMode) {
    return;
  }
  if (params.freeMode && params.freeMode.enabled) {
    swiper.freeMode.onTouchEnd({
      currentPos
    });
    return;
  }

  // Find current slide
  const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
  let stopIndex = 0;
  let groupSize = swiper.slidesSizesGrid[0];
  for (let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (typeof slidesGrid[i + increment] !== 'undefined') {
      if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
        stopIndex = i;
        groupSize = slidesGrid[i + increment] - slidesGrid[i];
      }
    } else if (swipeToLast || currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }
  let rewindFirstIndex = null;
  let rewindLastIndex = null;
  if (params.rewind) {
    if (swiper.isBeginning) {
      rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    } else if (swiper.isEnd) {
      rewindFirstIndex = 0;
    }
  }
  // Find current slide size
  const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);else swiper.slideTo(stopIndex);
    }
    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) {
        swiper.slideTo(stopIndex + increment);
      } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
        swiper.slideTo(rewindLastIndex);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
      }
      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}

function onResize() {
  const swiper = this;
  const {
    params,
    el
  } = swiper;
  if (el && el.offsetWidth === 0) return;

  // Breakpoints
  if (params.breakpoints) {
    swiper.setBreakpoint();
  }

  // Save locks
  const {
    allowSlideNext,
    allowSlidePrev,
    snapGrid
  } = swiper;
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;

  // Disable locks on resize
  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();
  const isVirtualLoop = isVirtual && params.loop;
  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    if (swiper.params.loop && !isVirtual) {
      swiper.slideToLoop(swiper.realIndex, 0, false, true);
    } else {
      swiper.slideTo(swiper.activeIndex, 0, false, true);
    }
  }
  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    clearTimeout(swiper.autoplay.resizeTimeout);
    swiper.autoplay.resizeTimeout = setTimeout(() => {
      if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        swiper.autoplay.resume();
      }
    }, 500);
  }
  // Return locks after resize
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}

function onClick(e) {
  const swiper = this;
  if (!swiper.enabled) return;
  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();
    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}

function onScroll() {
  const swiper = this;
  const {
    wrapperEl,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;
  if (swiper.isHorizontal()) {
    swiper.translate = -wrapperEl.scrollLeft;
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  }
  // eslint-disable-next-line
  if (swiper.translate === 0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }
  swiper.emit('setTranslate', swiper.translate, false);
}

function onLoad(e) {
  const swiper = this;
  processLazyPreloader(swiper, e.target);
  if (swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) {
    return;
  }
  swiper.update();
}

function onDocumentTouchStart() {
  const swiper = this;
  if (swiper.documentTouchHandlerProceeded) return;
  swiper.documentTouchHandlerProceeded = true;
  if (swiper.params.touchReleaseOnEdges) {
    swiper.el.style.touchAction = 'auto';
  }
}

const events = (swiper, method) => {
  const document = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
  const {
    params,
    el,
    wrapperEl,
    device
  } = swiper;
  const capture = !!params.nested;
  const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
  const swiperMethod = method;

  // Touch Events
  document[domMethod]('touchstart', swiper.onDocumentTouchStart, {
    passive: false,
    capture
  });
  el[domMethod]('touchstart', swiper.onTouchStart, {
    passive: false
  });
  el[domMethod]('pointerdown', swiper.onTouchStart, {
    passive: false
  });
  document[domMethod]('touchmove', swiper.onTouchMove, {
    passive: false,
    capture
  });
  document[domMethod]('pointermove', swiper.onTouchMove, {
    passive: false,
    capture
  });
  document[domMethod]('touchend', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('pointerup', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('pointercancel', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('touchcancel', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('pointerout', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('pointerleave', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('contextmenu', swiper.onTouchEnd, {
    passive: true
  });

  // Prevent Links Clicks
  if (params.preventClicks || params.preventClicksPropagation) {
    el[domMethod]('click', swiper.onClick, true);
  }
  if (params.cssMode) {
    wrapperEl[domMethod]('scroll', swiper.onScroll);
  }

  // Resize handler
  if (params.updateOnWindowResize) {
    swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
  } else {
    swiper[swiperMethod]('observerUpdate', onResize, true);
  }

  // Images loader
  el[domMethod]('load', swiper.onLoad, {
    capture: true
  });
};
function attachEvents() {
  const swiper = this;
  const {
    params
  } = swiper;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);
  swiper.onDocumentTouchStart = onDocumentTouchStart.bind(swiper);
  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }
  swiper.onClick = onClick.bind(swiper);
  swiper.onLoad = onLoad.bind(swiper);
  events(swiper, 'on');
}
function detachEvents() {
  const swiper = this;
  events(swiper, 'off');
}
var events$1 = {
  attachEvents,
  detachEvents
};

const isGridEnabled = (swiper, params) => {
  return swiper.grid && params.grid && params.grid.rows > 1;
};
function setBreakpoint() {
  const swiper = this;
  const {
    realIndex,
    initialized,
    params,
    el
  } = swiper;
  const breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;

  // Get breakpoint for window width and update parameters
  const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
  const breakpointParams = breakpointOnlyParams || swiper.originalParams;
  const wasMultiRow = isGridEnabled(swiper, params);
  const isMultiRow = isGridEnabled(swiper, breakpointParams);
  const wasGrabCursor = swiper.params.grabCursor;
  const isGrabCursor = breakpointParams.grabCursor;
  const wasEnabled = params.enabled;
  if (wasMultiRow && !isMultiRow) {
    el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    el.classList.add(`${params.containerModifierClass}grid`);
    if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') {
      el.classList.add(`${params.containerModifierClass}grid-column`);
    }
    swiper.emitContainerClasses();
  }
  if (wasGrabCursor && !isGrabCursor) {
    swiper.unsetGrabCursor();
  } else if (!wasGrabCursor && isGrabCursor) {
    swiper.setGrabCursor();
  }

  // Toggle navigation, pagination, scrollbar
  ['navigation', 'pagination', 'scrollbar'].forEach(prop => {
    if (typeof breakpointParams[prop] === 'undefined') return;
    const wasModuleEnabled = params[prop] && params[prop].enabled;
    const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
    if (wasModuleEnabled && !isModuleEnabled) {
      swiper[prop].disable();
    }
    if (!wasModuleEnabled && isModuleEnabled) {
      swiper[prop].enable();
    }
  });
  const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
  const wasLoop = params.loop;
  if (directionChanged && initialized) {
    swiper.changeDirection();
  }
  (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.u)(swiper.params, breakpointParams);
  const isEnabled = swiper.params.enabled;
  const hasLoop = swiper.params.loop;
  Object.assign(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });
  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }
  swiper.currentBreakpoint = breakpoint;
  swiper.emit('_beforeBreakpoint', breakpointParams);
  if (initialized) {
    if (needsReLoop) {
      swiper.loopDestroy();
      swiper.loopCreate(realIndex);
      swiper.updateSlides();
    } else if (!wasLoop && hasLoop) {
      swiper.loopCreate(realIndex);
      swiper.updateSlides();
    } else if (wasLoop && !hasLoop) {
      swiper.loopDestroy();
    }
  }
  swiper.emit('breakpoint', breakpointParams);
}

function getBreakpoint(breakpoints, base, containerEl) {
  if (base === void 0) {
    base = 'window';
  }
  if (!breakpoints || base === 'container' && !containerEl) return undefined;
  let breakpoint = false;
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
  const points = Object.keys(breakpoints).map(point => {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      const minRatio = parseFloat(point.substr(1));
      const value = currentHeight * minRatio;
      return {
        value,
        point
      };
    }
    return {
      value: point,
      point
    };
  });
  points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));
  for (let i = 0; i < points.length; i += 1) {
    const {
      point,
      value
    } = points[i];
    if (base === 'window') {
      if (window.matchMedia(`(min-width: ${value}px)`).matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }
  return breakpoint || 'max';
}

var breakpoints = {
  setBreakpoint,
  getBreakpoint
};

function prepareClasses(entries, prefix) {
  const resultClasses = [];
  entries.forEach(item => {
    if (typeof item === 'object') {
      Object.keys(item).forEach(classNames => {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === 'string') {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}
function addClasses() {
  const swiper = this;
  const {
    classNames,
    params,
    rtl,
    el,
    device
  } = swiper;
  // prettier-ignore
  const suffixes = prepareClasses(['initialized', params.direction, {
    'free-mode': swiper.params.freeMode && params.freeMode.enabled
  }, {
    'autoheight': params.autoHeight
  }, {
    'rtl': rtl
  }, {
    'grid': params.grid && params.grid.rows > 1
  }, {
    'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
  }, {
    'android': device.android
  }, {
    'ios': device.ios
  }, {
    'css-mode': params.cssMode
  }, {
    'centered': params.cssMode && params.centeredSlides
  }, {
    'watch-progress': params.watchSlidesProgress
  }], params.containerModifierClass);
  classNames.push(...suffixes);
  el.classList.add(...classNames);
  swiper.emitContainerClasses();
}

function removeClasses() {
  const swiper = this;
  const {
    el,
    classNames
  } = swiper;
  el.classList.remove(...classNames);
  swiper.emitContainerClasses();
}

var classes = {
  addClasses,
  removeClasses
};

function checkOverflow() {
  const swiper = this;
  const {
    isLocked: wasLocked,
    params
  } = swiper;
  const {
    slidesOffsetBefore
  } = params;
  if (slidesOffsetBefore) {
    const lastSlideIndex = swiper.slides.length - 1;
    const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
    swiper.isLocked = swiper.size > lastSlideRightEdge;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }
  if (params.allowSlideNext === true) {
    swiper.allowSlideNext = !swiper.isLocked;
  }
  if (params.allowSlidePrev === true) {
    swiper.allowSlidePrev = !swiper.isLocked;
  }
  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
  }
  if (wasLocked !== swiper.isLocked) {
    swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
  }
}
var checkOverflow$1 = {
  checkOverflow
};

var defaults = {
  init: true,
  direction: 'horizontal',
  oneWayMovement: false,
  swiperElementNodeName: 'SWIPER-CONTAINER',
  touchEventsTarget: 'wrapper',
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: true,
  nested: false,
  createElements: false,
  eventsPrefix: 'swiper',
  enabled: true,
  focusableElements: 'input, select, option, textarea, button, video, label',
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: 'slide',
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

  // Breakpoints
  breakpoints: undefined,
  breakpointsBase: 'window',
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: false,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: true,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 5,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // loop
  loop: false,
  loopAddBlankSlides: true,
  loopAdditionalSlides: 0,
  loopPreventsSliding: true,
  // rewind
  rewind: false,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: 'swiper-',
  // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-blank',
  slideActiveClass: 'swiper-slide-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideFullyVisibleClass: 'swiper-slide-fully-visible',
  slideNextClass: 'swiper-slide-next',
  slidePrevClass: 'swiper-slide-prev',
  wrapperClass: 'swiper-wrapper',
  lazyPreloaderClass: 'swiper-lazy-preloader',
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
};

function moduleExtendParams(params, allModulesParams) {
  return function extendParams(obj) {
    if (obj === void 0) {
      obj = {};
    }
    const moduleParamName = Object.keys(obj)[0];
    const moduleParams = obj[moduleParamName];
    if (typeof moduleParams !== 'object' || moduleParams === null) {
      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.u)(allModulesParams, obj);
      return;
    }
    if (params[moduleParamName] === true) {
      params[moduleParamName] = {
        enabled: true
      };
    }
    if (moduleParamName === 'navigation' && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) {
      params[moduleParamName].auto = true;
    }
    if (['pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) {
      params[moduleParamName].auto = true;
    }
    if (!(moduleParamName in params && 'enabled' in moduleParams)) {
      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.u)(allModulesParams, obj);
      return;
    }
    if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
      params[moduleParamName].enabled = true;
    }
    if (!params[moduleParamName]) params[moduleParamName] = {
      enabled: false
    };
    (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.u)(allModulesParams, obj);
  };
}

/* eslint no-param-reassign: "off" */
const prototypes = {
  eventsEmitter,
  update,
  translate,
  transition,
  slide,
  loop,
  grabCursor,
  events: events$1,
  breakpoints,
  checkOverflow: checkOverflow$1,
  classes
};
const extendedDefaults = {};
class Swiper {
  constructor() {
    let el;
    let params;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
      params = args[0];
    } else {
      [el, params] = args;
    }
    if (!params) params = {};
    params = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.u)({}, params);
    if (el && !params.el) params.el = el;
    const document = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
    if (params.el && typeof params.el === 'string' && document.querySelectorAll(params.el).length > 1) {
      const swipers = [];
      document.querySelectorAll(params.el).forEach(containerEl => {
        const newParams = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.u)({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      });
      // eslint-disable-next-line no-constructor-return
      return swipers;
    }

    // Swiper Instance
    const swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];
    swiper.modules = [...swiper.__modules__];
    if (params.modules && Array.isArray(params.modules)) {
      swiper.modules.push(...params.modules);
    }
    const allModulesParams = {};
    swiper.modules.forEach(mod => {
      mod({
        params,
        swiper,
        extendParams: moduleExtendParams(params, allModulesParams),
        on: swiper.on.bind(swiper),
        once: swiper.once.bind(swiper),
        off: swiper.off.bind(swiper),
        emit: swiper.emit.bind(swiper)
      });
    });

    // Extend defaults with modules params
    const swiperParams = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.u)({}, defaults, allModulesParams);

    // Extend defaults with passed params
    swiper.params = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.u)({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.u)({}, swiper.params);
    swiper.passedParams = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.u)({}, params);

    // add event listeners
    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach(eventName => {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }
    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    }

    // Extend Swiper
    Object.assign(swiper, {
      enabled: swiper.params.enabled,
      el,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },
      isVertical() {
        return swiper.params.direction === 'vertical';
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      cssOverflowAdjustment() {
        // Returns 0 unless `translate` is > 2**23
        // Should be subtracted from css values to prevent overflow
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        startMoving: undefined,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    });
    swiper.emit('_swiper');

    // Init
    if (swiper.params.init) {
      swiper.init();
    }

    // Return app instance
    // eslint-disable-next-line no-constructor-return
    return swiper;
  }
  getDirectionLabel(property) {
    if (this.isHorizontal()) {
      return property;
    }
    // prettier-ignore
    return {
      'width': 'height',
      'margin-top': 'margin-left',
      'margin-bottom ': 'margin-right',
      'margin-left': 'margin-top',
      'margin-right': 'margin-bottom',
      'padding-left': 'padding-top',
      'padding-right': 'padding-bottom',
      'marginRight': 'marginBottom'
    }[property];
  }
  getSlideIndex(slideEl) {
    const {
      slidesEl,
      params
    } = this;
    const slides = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(slidesEl, `.${params.slideClass}, swiper-slide`);
    const firstSlideIndex = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.h)(slides[0]);
    return (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.h)(slideEl) - firstSlideIndex;
  }
  getSlideIndexByData(index) {
    return this.getSlideIndex(this.slides.filter(slideEl => slideEl.getAttribute('data-swiper-slide-index') * 1 === index)[0]);
  }
  recalcSlides() {
    const swiper = this;
    const {
      slidesEl,
      params
    } = swiper;
    swiper.slides = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(slidesEl, `.${params.slideClass}, swiper-slide`);
  }
  enable() {
    const swiper = this;
    if (swiper.enabled) return;
    swiper.enabled = true;
    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }
    swiper.emit('enable');
  }
  disable() {
    const swiper = this;
    if (!swiper.enabled) return;
    swiper.enabled = false;
    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }
    swiper.emit('disable');
  }
  setProgress(progress, speed) {
    const swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    const min = swiper.minTranslate();
    const max = swiper.maxTranslate();
    const current = (max - min) * progress + min;
    swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  emitContainerClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const cls = swiper.el.className.split(' ').filter(className => {
      return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit('_containerClasses', cls.join(' '));
  }
  getSlideClasses(slideEl) {
    const swiper = this;
    if (swiper.destroyed) return '';
    return slideEl.className.split(' ').filter(className => {
      return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
    }).join(' ');
  }
  emitSlidesClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const updates = [];
    swiper.slides.forEach(slideEl => {
      const classNames = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl,
        classNames
      });
      swiper.emit('_slideClass', slideEl, classNames);
    });
    swiper.emit('_slideClasses', updates);
  }
  slidesPerViewDynamic(view, exact) {
    if (view === void 0) {
      view = 'current';
    }
    if (exact === void 0) {
      exact = false;
    }
    const swiper = this;
    const {
      params,
      slides,
      slidesGrid,
      slidesSizesGrid,
      size: swiperSize,
      activeIndex
    } = swiper;
    let spv = 1;
    if (typeof params.slidesPerView === 'number') return params.slidesPerView;
    if (params.centeredSlides) {
      let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
      let breakLoop;
      for (let i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += Math.ceil(slides[i].swiperSlideSize);
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
      for (let i = activeIndex - 1; i >= 0; i -= 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
    } else {
      // eslint-disable-next-line
      if (view === 'current') {
        for (let i = activeIndex + 1; i < slides.length; i += 1) {
          const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
          if (slideInView) {
            spv += 1;
          }
        }
      } else {
        // previous
        for (let i = activeIndex - 1; i >= 0; i -= 1) {
          const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
          if (slideInView) {
            spv += 1;
          }
        }
      }
    }
    return spv;
  }
  update() {
    const swiper = this;
    if (!swiper || swiper.destroyed) return;
    const {
      snapGrid,
      params
    } = swiper;
    // Breakpoints
    if (params.breakpoints) {
      swiper.setBreakpoint();
    }
    [...swiper.el.querySelectorAll('[loading="lazy"]')].forEach(imageEl => {
      if (imageEl.complete) {
        processLazyPreloader(swiper, imageEl);
      }
    });
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();
    function setTranslate() {
      const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    let translated;
    if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
      setTranslate();
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
        const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
        translated = swiper.slideTo(slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }
      if (!translated) {
        setTranslate();
      }
    }
    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
    swiper.emit('update');
  }
  changeDirection(newDirection, needUpdate) {
    if (needUpdate === void 0) {
      needUpdate = true;
    }
    const swiper = this;
    const currentDirection = swiper.params.direction;
    if (!newDirection) {
      // eslint-disable-next-line
      newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
    }
    if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
      return swiper;
    }
    swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
    swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.forEach(slideEl => {
      if (newDirection === 'vertical') {
        slideEl.style.width = '';
      } else {
        slideEl.style.height = '';
      }
    });
    swiper.emit('changeDirection');
    if (needUpdate) swiper.update();
    return swiper;
  }
  changeLanguageDirection(direction) {
    const swiper = this;
    if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
    swiper.rtl = direction === 'rtl';
    swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
    if (swiper.rtl) {
      swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = 'rtl';
    } else {
      swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = 'ltr';
    }
    swiper.update();
  }
  mount(element) {
    const swiper = this;
    if (swiper.mounted) return true;

    // Find el
    let el = element || swiper.params.el;
    if (typeof el === 'string') {
      el = document.querySelector(el);
    }
    if (!el) {
      return false;
    }
    el.swiper = swiper;
    if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) {
      swiper.isElement = true;
    }
    const getWrapperSelector = () => {
      return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
    };
    const getWrapper = () => {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        const res = el.shadowRoot.querySelector(getWrapperSelector());
        // Children needs to return slot items
        return res;
      }
      return (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(el, getWrapperSelector())[0];
    };
    // Find Wrapper
    let wrapperEl = getWrapper();
    if (!wrapperEl && swiper.params.createElements) {
      wrapperEl = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)('div', swiper.params.wrapperClass);
      el.append(wrapperEl);
      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(el, `.${swiper.params.slideClass}`).forEach(slideEl => {
        wrapperEl.append(slideEl);
      });
    }
    Object.assign(swiper, {
      el,
      wrapperEl,
      slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
      hostEl: swiper.isElement ? el.parentNode.host : el,
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === 'rtl' || (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.o)(el, 'direction') === 'rtl',
      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.o)(el, 'direction') === 'rtl'),
      wrongRTL: (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.o)(wrapperEl, 'display') === '-webkit-box'
    });
    return true;
  }
  init(el) {
    const swiper = this;
    if (swiper.initialized) return swiper;
    const mounted = swiper.mount(el);
    if (mounted === false) return swiper;
    swiper.emit('beforeInit');

    // Set breakpoint
    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    }

    // Add Classes
    swiper.addClasses();

    // Update size
    swiper.updateSize();

    // Update slides
    swiper.updateSlides();
    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    }

    // Set Grab Cursor
    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }

    // Slide To Initial Slide
    if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
      swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    }

    // Create loop
    if (swiper.params.loop) {
      swiper.loopCreate();
    }

    // Attach events
    swiper.attachEvents();
    const lazyElements = [...swiper.el.querySelectorAll('[loading="lazy"]')];
    if (swiper.isElement) {
      lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
    }
    lazyElements.forEach(imageEl => {
      if (imageEl.complete) {
        processLazyPreloader(swiper, imageEl);
      } else {
        imageEl.addEventListener('load', e => {
          processLazyPreloader(swiper, e.target);
        });
      }
    });
    preload(swiper);

    // Init Flag
    swiper.initialized = true;
    preload(swiper);

    // Emit
    swiper.emit('init');
    swiper.emit('afterInit');
    return swiper;
  }
  destroy(deleteInstance, cleanStyles) {
    if (deleteInstance === void 0) {
      deleteInstance = true;
    }
    if (cleanStyles === void 0) {
      cleanStyles = true;
    }
    const swiper = this;
    const {
      params,
      el,
      wrapperEl,
      slides
    } = swiper;
    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
      return null;
    }
    swiper.emit('beforeDestroy');

    // Init Flag
    swiper.initialized = false;

    // Detach events
    swiper.detachEvents();

    // Destroy loop
    if (params.loop) {
      swiper.loopDestroy();
    }

    // Cleanup styles
    if (cleanStyles) {
      swiper.removeClasses();
      el.removeAttribute('style');
      wrapperEl.removeAttribute('style');
      if (slides && slides.length) {
        slides.forEach(slideEl => {
          slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
          slideEl.removeAttribute('style');
          slideEl.removeAttribute('data-swiper-slide-index');
        });
      }
    }
    swiper.emit('destroy');

    // Detach emitter events
    Object.keys(swiper.eventsListeners).forEach(eventName => {
      swiper.off(eventName);
    });
    if (deleteInstance !== false) {
      swiper.el.swiper = null;
      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.v)(swiper);
    }
    swiper.destroyed = true;
    return null;
  }
  static extendDefaults(newDefaults) {
    (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.u)(extendedDefaults, newDefaults);
  }
  static get extendedDefaults() {
    return extendedDefaults;
  }
  static get defaults() {
    return defaults;
  }
  static installModule(mod) {
    if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
    const modules = Swiper.prototype.__modules__;
    if (typeof mod === 'function' && modules.indexOf(mod) < 0) {
      modules.push(mod);
    }
  }
  static use(module) {
    if (Array.isArray(module)) {
      module.forEach(m => Swiper.installModule(m));
      return Swiper;
    }
    Swiper.installModule(module);
    return Swiper;
  }
}
Object.keys(prototypes).forEach(prototypeGroup => {
  Object.keys(prototypes[prototypeGroup]).forEach(protoMethod => {
    Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper.use([Resize, Observer]);




/***/ }),

/***/ 7185:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ elementParents; },
/* harmony export */   "c": function() { return /* binding */ createElement; },
/* harmony export */   "d": function() { return /* binding */ now; },
/* harmony export */   "e": function() { return /* binding */ elementChildren; },
/* harmony export */   "f": function() { return /* binding */ elementOuterSize; },
/* harmony export */   "g": function() { return /* binding */ getSlideTransformEl; },
/* harmony export */   "h": function() { return /* binding */ elementIndex; },
/* harmony export */   "j": function() { return /* binding */ getTranslate; },
/* harmony export */   "k": function() { return /* binding */ elementTransitionEnd; },
/* harmony export */   "l": function() { return /* binding */ isObject; },
/* harmony export */   "m": function() { return /* binding */ makeElementsArray; },
/* harmony export */   "n": function() { return /* binding */ nextTick; },
/* harmony export */   "o": function() { return /* binding */ elementStyle; },
/* harmony export */   "p": function() { return /* binding */ elementNextAll; },
/* harmony export */   "q": function() { return /* binding */ elementPrevAll; },
/* harmony export */   "r": function() { return /* binding */ animateCSSModeScroll; },
/* harmony export */   "s": function() { return /* binding */ setCSSProperty; },
/* harmony export */   "t": function() { return /* binding */ showWarning; },
/* harmony export */   "u": function() { return /* binding */ extend; },
/* harmony export */   "v": function() { return /* binding */ deleteProps; }
/* harmony export */ });
/* unused harmony exports b, i */
/* harmony import */ var _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13433);


function classesToTokens(classes) {
  if (classes === void 0) {
    classes = '';
  }
  return classes.trim().split(' ').filter(c => !!c.trim());
}

function deleteProps(obj) {
  const object = obj;
  Object.keys(object).forEach(key => {
    try {
      object[key] = null;
    } catch (e) {
      // no getter for object
    }
    try {
      delete object[key];
    } catch (e) {
      // something got wrong
    }
  });
}
function nextTick(callback, delay) {
  if (delay === void 0) {
    delay = 0;
  }
  return setTimeout(callback, delay);
}
function now() {
  return Date.now();
}
function getComputedStyle(el) {
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  let style;
  if (window.getComputedStyle) {
    style = window.getComputedStyle(el, null);
  }
  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }
  if (!style) {
    style = el.style;
  }
  return style;
}
function getTranslate(el, axis) {
  if (axis === void 0) {
    axis = 'x';
  }
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  let matrix;
  let curTransform;
  let transformMatrix;
  const curStyle = getComputedStyle(el);
  if (window.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;
    if (curTransform.split(',').length > 6) {
      curTransform = curTransform.split(', ').map(a => a.replace(',', '.')).join(', ');
    }
    // Some old versions of Webkit choke when 'none' is passed; pass
    // empty string instead in this case
    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
    matrix = transformMatrix.toString().split(',');
  }
  if (axis === 'x') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41;
    // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
    // Normal Browsers
    else curTransform = parseFloat(matrix[4]);
  }
  if (axis === 'y') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42;
    // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
    // Normal Browsers
    else curTransform = parseFloat(matrix[5]);
  }
  return curTransform || 0;
}
function isObject(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function isNode(node) {
  // eslint-disable-next-line
  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
    return node instanceof HTMLElement;
  }
  return node && (node.nodeType === 1 || node.nodeType === 11);
}
function extend() {
  const to = Object(arguments.length <= 0 ? undefined : arguments[0]);
  const noExtend = ['__proto__', 'constructor', 'prototype'];
  for (let i = 1; i < arguments.length; i += 1) {
    const nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
    if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
      const keysArray = Object.keys(Object(nextSource)).filter(key => noExtend.indexOf(key) < 0);
      for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        const nextKey = keysArray[nextIndex];
        const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
        if (desc !== undefined && desc.enumerable) {
          if (isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend(to[nextKey], nextSource[nextKey]);
            }
          } else if (!isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
            to[nextKey] = {};
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }
  return to;
}
function setCSSProperty(el, varName, varValue) {
  el.style.setProperty(varName, varValue);
}
function animateCSSModeScroll(_ref) {
  let {
    swiper,
    targetPosition,
    side
  } = _ref;
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  const startPosition = -swiper.translate;
  let startTime = null;
  let time;
  const duration = swiper.params.speed;
  swiper.wrapperEl.style.scrollSnapType = 'none';
  window.cancelAnimationFrame(swiper.cssModeFrameID);
  const dir = targetPosition > startPosition ? 'next' : 'prev';
  const isOutOfBound = (current, target) => {
    return dir === 'next' && current >= target || dir === 'prev' && current <= target;
  };
  const animate = () => {
    time = new Date().getTime();
    if (startTime === null) {
      startTime = time;
    }
    const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
    const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
    let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
    if (isOutOfBound(currentPosition, targetPosition)) {
      currentPosition = targetPosition;
    }
    swiper.wrapperEl.scrollTo({
      [side]: currentPosition
    });
    if (isOutOfBound(currentPosition, targetPosition)) {
      swiper.wrapperEl.style.overflow = 'hidden';
      swiper.wrapperEl.style.scrollSnapType = '';
      setTimeout(() => {
        swiper.wrapperEl.style.overflow = '';
        swiper.wrapperEl.scrollTo({
          [side]: currentPosition
        });
      });
      window.cancelAnimationFrame(swiper.cssModeFrameID);
      return;
    }
    swiper.cssModeFrameID = window.requestAnimationFrame(animate);
  };
  animate();
}
function getSlideTransformEl(slideEl) {
  return slideEl.querySelector('.swiper-slide-transform') || slideEl.shadowRoot && slideEl.shadowRoot.querySelector('.swiper-slide-transform') || slideEl;
}
function elementChildren(element, selector) {
  if (selector === void 0) {
    selector = '';
  }
  return [...element.children].filter(el => el.matches(selector));
}
function showWarning(text) {
  try {
    console.warn(text);
    return;
  } catch (err) {
    // err
  }
}
function createElement(tag, classes) {
  if (classes === void 0) {
    classes = [];
  }
  const el = document.createElement(tag);
  el.classList.add(...(Array.isArray(classes) ? classes : classesToTokens(classes)));
  return el;
}
function elementOffset(el) {
  const window = getWindow();
  const document = getDocument();
  const box = el.getBoundingClientRect();
  const body = document.body;
  const clientTop = el.clientTop || body.clientTop || 0;
  const clientLeft = el.clientLeft || body.clientLeft || 0;
  const scrollTop = el === window ? window.scrollY : el.scrollTop;
  const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
  return {
    top: box.top + scrollTop - clientTop,
    left: box.left + scrollLeft - clientLeft
  };
}
function elementPrevAll(el, selector) {
  const prevEls = [];
  while (el.previousElementSibling) {
    const prev = el.previousElementSibling; // eslint-disable-line
    if (selector) {
      if (prev.matches(selector)) prevEls.push(prev);
    } else prevEls.push(prev);
    el = prev;
  }
  return prevEls;
}
function elementNextAll(el, selector) {
  const nextEls = [];
  while (el.nextElementSibling) {
    const next = el.nextElementSibling; // eslint-disable-line
    if (selector) {
      if (next.matches(selector)) nextEls.push(next);
    } else nextEls.push(next);
    el = next;
  }
  return nextEls;
}
function elementStyle(el, prop) {
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  return window.getComputedStyle(el, null).getPropertyValue(prop);
}
function elementIndex(el) {
  let child = el;
  let i;
  if (child) {
    i = 0;
    // eslint-disable-next-line
    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }
    return i;
  }
  return undefined;
}
function elementParents(el, selector) {
  const parents = []; // eslint-disable-line
  let parent = el.parentElement; // eslint-disable-line
  while (parent) {
    if (selector) {
      if (parent.matches(selector)) parents.push(parent);
    } else {
      parents.push(parent);
    }
    parent = parent.parentElement;
  }
  return parents;
}
function elementTransitionEnd(el, callback) {
  function fireCallBack(e) {
    if (e.target !== el) return;
    callback.call(el, e);
    el.removeEventListener('transitionend', fireCallBack);
  }
  if (callback) {
    el.addEventListener('transitionend', fireCallBack);
  }
}
function elementOuterSize(el, size, includeMargins) {
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  if (includeMargins) {
    return el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] + parseFloat(window.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) + parseFloat(window.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom'));
  }
  return el.offsetWidth;
}
function makeElementsArray(el) {
  return (Array.isArray(el) ? el : [el]).filter(e => !!e);
}




/***/ }),

/***/ 48929:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tq": function() { return /* binding */ Swiper; },
  "o5": function() { return /* binding */ SwiperSlide; }
});

// UNUSED EXPORTS: useSwiper, useSwiperSlide

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(62991);
// EXTERNAL MODULE: ./node_modules/swiper/shared/swiper-core.mjs
var swiper_core = __webpack_require__(96236);
;// CONCATENATED MODULE: ./node_modules/swiper/shared/update-swiper.mjs
/* underscore in name -> watch for changes */
const paramsList = ['eventsPrefix', 'injectStyles', 'injectStylesUrls', 'modules', 'init', '_direction', 'oneWayMovement', 'swiperElementNodeName', 'touchEventsTarget', 'initialSlide', '_speed', 'cssMode', 'updateOnWindowResize', 'resizeObserver', 'nested', 'focusableElements', '_enabled', '_width', '_height', 'preventInteractionOnTransition', 'userAgent', 'url', '_edgeSwipeDetection', '_edgeSwipeThreshold', '_freeMode', '_autoHeight', 'setWrapperSize', 'virtualTranslate', '_effect', 'breakpoints', 'breakpointsBase', '_spaceBetween', '_slidesPerView', 'maxBackfaceHiddenSlides', '_grid', '_slidesPerGroup', '_slidesPerGroupSkip', '_slidesPerGroupAuto', '_centeredSlides', '_centeredSlidesBounds', '_slidesOffsetBefore', '_slidesOffsetAfter', 'normalizeSlideIndex', '_centerInsufficientSlides', '_watchOverflow', 'roundLengths', 'touchRatio', 'touchAngle', 'simulateTouch', '_shortSwipes', '_longSwipes', 'longSwipesRatio', 'longSwipesMs', '_followFinger', 'allowTouchMove', '_threshold', 'touchMoveStopPropagation', 'touchStartPreventDefault', 'touchStartForcePreventDefault', 'touchReleaseOnEdges', 'uniqueNavElements', '_resistance', '_resistanceRatio', '_watchSlidesProgress', '_grabCursor', 'preventClicks', 'preventClicksPropagation', '_slideToClickedSlide', '_loop', 'loopAdditionalSlides', 'loopAddBlankSlides', 'loopPreventsSliding', '_rewind', '_allowSlidePrev', '_allowSlideNext', '_swipeHandler', '_noSwiping', 'noSwipingClass', 'noSwipingSelector', 'passiveListeners', 'containerModifierClass', 'slideClass', 'slideActiveClass', 'slideVisibleClass', 'slideFullyVisibleClass', 'slideNextClass', 'slidePrevClass', 'slideBlankClass', 'wrapperClass', 'lazyPreloaderClass', 'lazyPreloadPrevNext', 'runCallbacksOnInit', 'observer', 'observeParents', 'observeSlideChildren',
// modules
'a11y', '_autoplay', '_controller', 'coverflowEffect', 'cubeEffect', 'fadeEffect', 'flipEffect', 'creativeEffect', 'cardsEffect', 'hashNavigation', 'history', 'keyboard', 'mousewheel', '_navigation', '_pagination', 'parallax', '_scrollbar', '_thumbs', 'virtual', 'zoom', 'control'];

function isObject(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object' && !o.__swiper__;
}
function extend(target, src) {
  const noExtend = ['__proto__', 'constructor', 'prototype'];
  Object.keys(src).filter(key => noExtend.indexOf(key) < 0).forEach(key => {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
      if (src[key].__swiper__) target[key] = src[key];else extend(target[key], src[key]);
    } else {
      target[key] = src[key];
    }
  });
}
function needsNavigation(params) {
  if (params === void 0) {
    params = {};
  }
  return params.navigation && typeof params.navigation.nextEl === 'undefined' && typeof params.navigation.prevEl === 'undefined';
}
function needsPagination(params) {
  if (params === void 0) {
    params = {};
  }
  return params.pagination && typeof params.pagination.el === 'undefined';
}
function needsScrollbar(params) {
  if (params === void 0) {
    params = {};
  }
  return params.scrollbar && typeof params.scrollbar.el === 'undefined';
}
function uniqueClasses(classNames) {
  if (classNames === void 0) {
    classNames = '';
  }
  const classes = classNames.split(' ').map(c => c.trim()).filter(c => !!c);
  const unique = [];
  classes.forEach(c => {
    if (unique.indexOf(c) < 0) unique.push(c);
  });
  return unique.join(' ');
}
function attrToProp(attrName) {
  if (attrName === void 0) {
    attrName = '';
  }
  return attrName.replace(/-[a-z]/g, l => l.toUpperCase().replace('-', ''));
}
function wrapperClass(className) {
  if (className === void 0) {
    className = '';
  }
  if (!className) return 'swiper-wrapper';
  if (!className.includes('swiper-wrapper')) return `swiper-wrapper ${className}`;
  return className;
}

function updateSwiper(_ref) {
  let {
    swiper,
    slides,
    passedParams,
    changedParams,
    nextEl,
    prevEl,
    scrollbarEl,
    paginationEl
  } = _ref;
  const updateParams = changedParams.filter(key => key !== 'children' && key !== 'direction' && key !== 'wrapperClass');
  const {
    params: currentParams,
    pagination,
    navigation,
    scrollbar,
    virtual,
    thumbs
  } = swiper;
  let needThumbsInit;
  let needControllerInit;
  let needPaginationInit;
  let needScrollbarInit;
  let needNavigationInit;
  let loopNeedDestroy;
  let loopNeedEnable;
  let loopNeedReloop;
  if (changedParams.includes('thumbs') && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper) {
    needThumbsInit = true;
  }
  if (changedParams.includes('controller') && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
    needControllerInit = true;
  }
  if (changedParams.includes('pagination') && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) {
    needPaginationInit = true;
  }
  if (changedParams.includes('scrollbar') && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) {
    needScrollbarInit = true;
  }
  if (changedParams.includes('navigation') && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) {
    needNavigationInit = true;
  }
  const destroyModule = mod => {
    if (!swiper[mod]) return;
    swiper[mod].destroy();
    if (mod === 'navigation') {
      if (swiper.isElement) {
        swiper[mod].prevEl.remove();
        swiper[mod].nextEl.remove();
      }
      currentParams[mod].prevEl = undefined;
      currentParams[mod].nextEl = undefined;
      swiper[mod].prevEl = undefined;
      swiper[mod].nextEl = undefined;
    } else {
      if (swiper.isElement) {
        swiper[mod].el.remove();
      }
      currentParams[mod].el = undefined;
      swiper[mod].el = undefined;
    }
  };
  if (changedParams.includes('loop') && swiper.isElement) {
    if (currentParams.loop && !passedParams.loop) {
      loopNeedDestroy = true;
    } else if (!currentParams.loop && passedParams.loop) {
      loopNeedEnable = true;
    } else {
      loopNeedReloop = true;
    }
  }
  updateParams.forEach(key => {
    if (isObject(currentParams[key]) && isObject(passedParams[key])) {
      Object.assign(currentParams[key], passedParams[key]);
      if ((key === 'navigation' || key === 'pagination' || key === 'scrollbar') && 'enabled' in passedParams[key] && !passedParams[key].enabled) {
        destroyModule(key);
      }
    } else {
      const newValue = passedParams[key];
      if ((newValue === true || newValue === false) && (key === 'navigation' || key === 'pagination' || key === 'scrollbar')) {
        if (newValue === false) {
          destroyModule(key);
        }
      } else {
        currentParams[key] = passedParams[key];
      }
    }
  });
  if (updateParams.includes('controller') && !needControllerInit && swiper.controller && swiper.controller.control && currentParams.controller && currentParams.controller.control) {
    swiper.controller.control = currentParams.controller.control;
  }
  if (changedParams.includes('children') && slides && virtual && currentParams.virtual.enabled) {
    virtual.slides = slides;
    virtual.update(true);
  } else if (changedParams.includes('virtual') && virtual && currentParams.virtual.enabled) {
    if (slides) virtual.slides = slides;
    virtual.update(true);
  }
  if (changedParams.includes('children') && slides && currentParams.loop) {
    loopNeedReloop = true;
  }
  if (needThumbsInit) {
    const initialized = thumbs.init();
    if (initialized) thumbs.update(true);
  }
  if (needControllerInit) {
    swiper.controller.control = currentParams.controller.control;
  }
  if (needPaginationInit) {
    if (swiper.isElement && (!paginationEl || typeof paginationEl === 'string')) {
      paginationEl = document.createElement('div');
      paginationEl.classList.add('swiper-pagination');
      paginationEl.part.add('pagination');
      swiper.el.appendChild(paginationEl);
    }
    if (paginationEl) currentParams.pagination.el = paginationEl;
    pagination.init();
    pagination.render();
    pagination.update();
  }
  if (needScrollbarInit) {
    if (swiper.isElement && (!scrollbarEl || typeof scrollbarEl === 'string')) {
      scrollbarEl = document.createElement('div');
      scrollbarEl.classList.add('swiper-scrollbar');
      scrollbarEl.part.add('scrollbar');
      swiper.el.appendChild(scrollbarEl);
    }
    if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
    scrollbar.init();
    scrollbar.updateSize();
    scrollbar.setTranslate();
  }
  if (needNavigationInit) {
    if (swiper.isElement) {
      if (!nextEl || typeof nextEl === 'string') {
        nextEl = document.createElement('div');
        nextEl.classList.add('swiper-button-next');
        nextEl.innerHTML = swiper.hostEl.constructor.nextButtonSvg;
        nextEl.part.add('button-next');
        swiper.el.appendChild(nextEl);
      }
      if (!prevEl || typeof prevEl === 'string') {
        prevEl = document.createElement('div');
        prevEl.classList.add('swiper-button-prev');
        prevEl.innerHTML = swiper.hostEl.constructor.prevButtonSvg;
        prevEl.part.add('button-prev');
        swiper.el.appendChild(prevEl);
      }
    }
    if (nextEl) currentParams.navigation.nextEl = nextEl;
    if (prevEl) currentParams.navigation.prevEl = prevEl;
    navigation.init();
    navigation.update();
  }
  if (changedParams.includes('allowSlideNext')) {
    swiper.allowSlideNext = passedParams.allowSlideNext;
  }
  if (changedParams.includes('allowSlidePrev')) {
    swiper.allowSlidePrev = passedParams.allowSlidePrev;
  }
  if (changedParams.includes('direction')) {
    swiper.changeDirection(passedParams.direction, false);
  }
  if (loopNeedDestroy || loopNeedReloop) {
    swiper.loopDestroy();
  }
  if (loopNeedEnable || loopNeedReloop) {
    swiper.loopCreate();
  }
  swiper.update();
}



;// CONCATENATED MODULE: ./node_modules/swiper/shared/update-on-virtual-data.mjs



function getParams(obj, splitEvents) {
  if (obj === void 0) {
    obj = {};
  }
  if (splitEvents === void 0) {
    splitEvents = true;
  }
  const params = {
    on: {}
  };
  const events = {};
  const passedParams = {};
  extend(params, swiper_core.d);
  params._emitClasses = true;
  params.init = false;
  const rest = {};
  const allowedParams = paramsList.map(key => key.replace(/_/, ''));
  const plainObj = Object.assign({}, obj);
  Object.keys(plainObj).forEach(key => {
    if (typeof obj[key] === 'undefined') return;
    if (allowedParams.indexOf(key) >= 0) {
      if (isObject(obj[key])) {
        params[key] = {};
        passedParams[key] = {};
        extend(params[key], obj[key]);
        extend(passedParams[key], obj[key]);
      } else {
        params[key] = obj[key];
        passedParams[key] = obj[key];
      }
    } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === 'function') {
      if (splitEvents) {
        events[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      } else {
        params.on[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      }
    } else {
      rest[key] = obj[key];
    }
  });
  ['navigation', 'pagination', 'scrollbar'].forEach(key => {
    if (params[key] === true) params[key] = {};
    if (params[key] === false) delete params[key];
  });
  return {
    params,
    passedParams,
    rest,
    events
  };
}

function mountSwiper(_ref, swiperParams) {
  let {
    el,
    nextEl,
    prevEl,
    paginationEl,
    scrollbarEl,
    swiper
  } = _ref;
  if (needsNavigation(swiperParams) && nextEl && prevEl) {
    swiper.params.navigation.nextEl = nextEl;
    swiper.originalParams.navigation.nextEl = nextEl;
    swiper.params.navigation.prevEl = prevEl;
    swiper.originalParams.navigation.prevEl = prevEl;
  }
  if (needsPagination(swiperParams) && paginationEl) {
    swiper.params.pagination.el = paginationEl;
    swiper.originalParams.pagination.el = paginationEl;
  }
  if (needsScrollbar(swiperParams) && scrollbarEl) {
    swiper.params.scrollbar.el = scrollbarEl;
    swiper.originalParams.scrollbar.el = scrollbarEl;
  }
  swiper.init(el);
}

function getChangedParams(swiperParams, oldParams, children, oldChildren, getKey) {
  const keys = [];
  if (!oldParams) return keys;
  const addKey = key => {
    if (keys.indexOf(key) < 0) keys.push(key);
  };
  if (children && oldChildren) {
    const oldChildrenKeys = oldChildren.map(getKey);
    const childrenKeys = children.map(getKey);
    if (oldChildrenKeys.join('') !== childrenKeys.join('')) addKey('children');
    if (oldChildren.length !== children.length) addKey('children');
  }
  const watchParams = paramsList.filter(key => key[0] === '_').map(key => key.replace(/_/, ''));
  watchParams.forEach(key => {
    if (key in swiperParams && key in oldParams) {
      if (isObject(swiperParams[key]) && isObject(oldParams[key])) {
        const newKeys = Object.keys(swiperParams[key]);
        const oldKeys = Object.keys(oldParams[key]);
        if (newKeys.length !== oldKeys.length) {
          addKey(key);
        } else {
          newKeys.forEach(newKey => {
            if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
              addKey(key);
            }
          });
          oldKeys.forEach(oldKey => {
            if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
          });
        }
      } else if (swiperParams[key] !== oldParams[key]) {
        addKey(key);
      }
    }
  });
  return keys;
}

const updateOnVirtualData = swiper => {
  if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();
  if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) {
    swiper.parallax.setTranslate();
  }
};



;// CONCATENATED MODULE: ./node_modules/swiper/swiper-react.mjs
/**
 * Swiper React 11.1.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2024 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: April 9, 2024
 */






function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

function isChildSwiperSlide(child) {
  return child.type && child.type.displayName && child.type.displayName.includes('SwiperSlide');
}
function processChildren(c) {
  const slides = [];
  react.Children.toArray(c).forEach(child => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.children) {
      processChildren(child.props.children).forEach(slide => slides.push(slide));
    }
  });
  return slides;
}
function getChildren(c) {
  const slides = [];
  const slots = {
    'container-start': [],
    'container-end': [],
    'wrapper-start': [],
    'wrapper-end': []
  };
  react.Children.toArray(c).forEach(child => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.slot && slots[child.props.slot]) {
      slots[child.props.slot].push(child);
    } else if (child.props && child.props.children) {
      const foundSlides = processChildren(child.props.children);
      if (foundSlides.length > 0) {
        foundSlides.forEach(slide => slides.push(slide));
      } else {
        slots['container-end'].push(child);
      }
    } else {
      slots['container-end'].push(child);
    }
  });
  return {
    slides,
    slots
  };
}

function renderVirtual(swiper, slides, virtualData) {
  if (!virtualData) return null;
  const getSlideIndex = index => {
    let slideIndex = index;
    if (index < 0) {
      slideIndex = slides.length + index;
    } else if (slideIndex >= slides.length) {
      // eslint-disable-next-line
      slideIndex = slideIndex - slides.length;
    }
    return slideIndex;
  };
  const style = swiper.isHorizontal() ? {
    [swiper.rtlTranslate ? 'right' : 'left']: `${virtualData.offset}px`
  } : {
    top: `${virtualData.offset}px`
  };
  const {
    from,
    to
  } = virtualData;
  const loopFrom = swiper.params.loop ? -slides.length : 0;
  const loopTo = swiper.params.loop ? slides.length * 2 : slides.length;
  const slidesToRender = [];
  for (let i = loopFrom; i < loopTo; i += 1) {
    if (i >= from && i <= to) {
      slidesToRender.push(slides[getSlideIndex(i)]);
    }
  }
  return slidesToRender.map((child, index) => {
    return /*#__PURE__*/react.cloneElement(child, {
      swiper,
      style,
      key: child.props.virtualIndex || child.key || `slide-${index}`
    });
  });
}

function useIsomorphicLayoutEffect(callback, deps) {
  // eslint-disable-next-line
  if (typeof window === 'undefined') return (0,react.useEffect)(callback, deps);
  return (0,react.useLayoutEffect)(callback, deps);
}

const SwiperSlideContext = /*#__PURE__*/(0,react.createContext)(null);
const useSwiperSlide = () => {
  return useContext(SwiperSlideContext);
};
const SwiperContext = /*#__PURE__*/(0,react.createContext)(null);
const useSwiper = () => {
  return useContext(SwiperContext);
};

const Swiper = /*#__PURE__*/(0,react.forwardRef)(function (_temp, externalElRef) {
  let {
    className,
    tag: Tag = 'div',
    wrapperTag: WrapperTag = 'div',
    children,
    onSwiper,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  let eventsAssigned = false;
  const [containerClasses, setContainerClasses] = (0,react.useState)('swiper');
  const [virtualData, setVirtualData] = (0,react.useState)(null);
  const [breakpointChanged, setBreakpointChanged] = (0,react.useState)(false);
  const initializedRef = (0,react.useRef)(false);
  const swiperElRef = (0,react.useRef)(null);
  const swiperRef = (0,react.useRef)(null);
  const oldPassedParamsRef = (0,react.useRef)(null);
  const oldSlides = (0,react.useRef)(null);
  const nextElRef = (0,react.useRef)(null);
  const prevElRef = (0,react.useRef)(null);
  const paginationElRef = (0,react.useRef)(null);
  const scrollbarElRef = (0,react.useRef)(null);
  const {
    params: swiperParams,
    passedParams,
    rest: restProps,
    events
  } = getParams(rest);
  const {
    slides,
    slots
  } = getChildren(children);
  const onBeforeBreakpoint = () => {
    setBreakpointChanged(!breakpointChanged);
  };
  Object.assign(swiperParams.on, {
    _containerClasses(swiper, classes) {
      setContainerClasses(classes);
    }
  });
  const initSwiper = () => {
    // init swiper
    Object.assign(swiperParams.on, events);
    eventsAssigned = true;
    const passParams = {
      ...swiperParams
    };
    delete passParams.wrapperClass;
    swiperRef.current = new swiper_core.S(passParams);
    if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
      swiperRef.current.virtual.slides = slides;
      const extendWith = {
        cache: false,
        slides,
        renderExternal: setVirtualData,
        renderExternalUpdate: false
      };
      extend(swiperRef.current.params.virtual, extendWith);
      extend(swiperRef.current.originalParams.virtual, extendWith);
    }
  };
  if (!swiperElRef.current) {
    initSwiper();
  }

  // Listen for breakpoints change
  if (swiperRef.current) {
    swiperRef.current.on('_beforeBreakpoint', onBeforeBreakpoint);
  }
  const attachEvents = () => {
    if (eventsAssigned || !events || !swiperRef.current) return;
    Object.keys(events).forEach(eventName => {
      swiperRef.current.on(eventName, events[eventName]);
    });
  };
  const detachEvents = () => {
    if (!events || !swiperRef.current) return;
    Object.keys(events).forEach(eventName => {
      swiperRef.current.off(eventName, events[eventName]);
    });
  };
  (0,react.useEffect)(() => {
    return () => {
      if (swiperRef.current) swiperRef.current.off('_beforeBreakpoint', onBeforeBreakpoint);
    };
  });

  // set initialized flag
  (0,react.useEffect)(() => {
    if (!initializedRef.current && swiperRef.current) {
      swiperRef.current.emitSlidesClasses();
      initializedRef.current = true;
    }
  });

  // mount swiper
  useIsomorphicLayoutEffect(() => {
    if (externalElRef) {
      externalElRef.current = swiperElRef.current;
    }
    if (!swiperElRef.current) return;
    if (swiperRef.current.destroyed) {
      initSwiper();
    }
    mountSwiper({
      el: swiperElRef.current,
      nextEl: nextElRef.current,
      prevEl: prevElRef.current,
      paginationEl: paginationElRef.current,
      scrollbarEl: scrollbarElRef.current,
      swiper: swiperRef.current
    }, swiperParams);
    if (onSwiper && !swiperRef.current.destroyed) onSwiper(swiperRef.current);
    // eslint-disable-next-line
    return () => {
      if (swiperRef.current && !swiperRef.current.destroyed) {
        swiperRef.current.destroy(true, false);
      }
    };
  }, []);

  // watch for params change
  useIsomorphicLayoutEffect(() => {
    attachEvents();
    const changedParams = getChangedParams(passedParams, oldPassedParamsRef.current, slides, oldSlides.current, c => c.key);
    oldPassedParamsRef.current = passedParams;
    oldSlides.current = slides;
    if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) {
      updateSwiper({
        swiper: swiperRef.current,
        slides,
        passedParams,
        changedParams,
        nextEl: nextElRef.current,
        prevEl: prevElRef.current,
        scrollbarEl: scrollbarElRef.current,
        paginationEl: paginationElRef.current
      });
    }
    return () => {
      detachEvents();
    };
  });

  // update on virtual update
  useIsomorphicLayoutEffect(() => {
    updateOnVirtualData(swiperRef.current);
  }, [virtualData]);

  // bypass swiper instance to slides
  function renderSlides() {
    if (swiperParams.virtual) {
      return renderVirtual(swiperRef.current, slides, virtualData);
    }
    return slides.map((child, index) => {
      return /*#__PURE__*/react.cloneElement(child, {
        swiper: swiperRef.current,
        swiperSlideIndex: index
      });
    });
  }
  return /*#__PURE__*/react.createElement(Tag, _extends({
    ref: swiperElRef,
    className: uniqueClasses(`${containerClasses}${className ? ` ${className}` : ''}`)
  }, restProps), /*#__PURE__*/react.createElement(SwiperContext.Provider, {
    value: swiperRef.current
  }, slots['container-start'], /*#__PURE__*/react.createElement(WrapperTag, {
    className: wrapperClass(swiperParams.wrapperClass)
  }, slots['wrapper-start'], renderSlides(), slots['wrapper-end']), needsNavigation(swiperParams) && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    ref: prevElRef,
    className: "swiper-button-prev"
  }), /*#__PURE__*/react.createElement("div", {
    ref: nextElRef,
    className: "swiper-button-next"
  })), needsScrollbar(swiperParams) && /*#__PURE__*/react.createElement("div", {
    ref: scrollbarElRef,
    className: "swiper-scrollbar"
  }), needsPagination(swiperParams) && /*#__PURE__*/react.createElement("div", {
    ref: paginationElRef,
    className: "swiper-pagination"
  }), slots['container-end']));
});
Swiper.displayName = 'Swiper';

const SwiperSlide = /*#__PURE__*/(0,react.forwardRef)(function (_temp, externalRef) {
  let {
    tag: Tag = 'div',
    children,
    className = '',
    swiper,
    zoom,
    lazy,
    virtualIndex,
    swiperSlideIndex,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  const slideElRef = (0,react.useRef)(null);
  const [slideClasses, setSlideClasses] = (0,react.useState)('swiper-slide');
  const [lazyLoaded, setLazyLoaded] = (0,react.useState)(false);
  function updateClasses(_s, el, classNames) {
    if (el === slideElRef.current) {
      setSlideClasses(classNames);
    }
  }
  useIsomorphicLayoutEffect(() => {
    if (typeof swiperSlideIndex !== 'undefined') {
      slideElRef.current.swiperSlideIndex = swiperSlideIndex;
    }
    if (externalRef) {
      externalRef.current = slideElRef.current;
    }
    if (!slideElRef.current || !swiper) {
      return;
    }
    if (swiper.destroyed) {
      if (slideClasses !== 'swiper-slide') {
        setSlideClasses('swiper-slide');
      }
      return;
    }
    swiper.on('_slideClass', updateClasses);
    // eslint-disable-next-line
    return () => {
      if (!swiper) return;
      swiper.off('_slideClass', updateClasses);
    };
  });
  useIsomorphicLayoutEffect(() => {
    if (swiper && slideElRef.current && !swiper.destroyed) {
      setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }
  }, [swiper]);
  const slideData = {
    isActive: slideClasses.indexOf('swiper-slide-active') >= 0,
    isVisible: slideClasses.indexOf('swiper-slide-visible') >= 0,
    isPrev: slideClasses.indexOf('swiper-slide-prev') >= 0,
    isNext: slideClasses.indexOf('swiper-slide-next') >= 0
  };
  const renderChildren = () => {
    return typeof children === 'function' ? children(slideData) : children;
  };
  const onLoad = () => {
    setLazyLoaded(true);
  };
  return /*#__PURE__*/react.createElement(Tag, _extends({
    ref: slideElRef,
    className: uniqueClasses(`${slideClasses}${className ? ` ${className}` : ''}`),
    "data-swiper-slide-index": virtualIndex,
    onLoad: onLoad
  }, rest), zoom && /*#__PURE__*/react.createElement(SwiperSlideContext.Provider, {
    value: slideData
  }, /*#__PURE__*/react.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof zoom === 'number' ? zoom : undefined
  }, renderChildren(), lazy && !lazyLoaded && /*#__PURE__*/react.createElement("div", {
    className: "swiper-lazy-preloader"
  }))), !zoom && /*#__PURE__*/react.createElement(SwiperSlideContext.Provider, {
    value: slideData
  }, renderChildren(), lazy && !lazyLoaded && /*#__PURE__*/react.createElement("div", {
    className: "swiper-lazy-preloader"
  })));
});
SwiperSlide.displayName = 'SwiperSlide';




/***/ }),

/***/ 78592:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _shared_swiper_core_mjs__WEBPACK_IMPORTED_MODULE_0__.S; }
/* harmony export */ });
/* harmony import */ var _shared_swiper_core_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96236);
/**
 * Swiper 11.1.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2024 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: April 9, 2024
 */




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(6840), __webpack_exec__(38355); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);